var _regeneratorRuntime = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _get = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _createClass = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

module.exports = function (e) {
  var n = {};

  function t(r) {
    if (n[r]) return n[r].exports;
    var o = n[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  return t.m = e, t.c = n, t.d = function (e, n, r) {
    t.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: r
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, n) {
    if (1 & n && (e = t(e)), 8 & n) return e;
    if (4 & n && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (t.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var o in e) {
      t.d(r, o, function (n) {
        return e[n];
      }.bind(null, o));
    }
    return r;
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, t.p = "", t(t.s = 232);
}([function (e, n) {
  e.exports = require("react");
}, function (e, n, t) {
  e.exports = t(31)();
}, function (e, n, t) {
  "use strict";

  var r = t(119),
      o = t(37),
      i = t(19),
      A = t(135),
      s = t(29),
      l = t(61),
      a = t(64),
      c = t(91),
      u = t(136),
      p = t(93),
      m = t(52),
      C = t(16),
      d = t(89),
      f = t(7),
      h = t(71),
      x = t(107),
      g = t(34),
      I = t(196),
      b = {
    Editor: u,
    EditorBlock: p,
    EditorState: f,
    CompositeDecorator: A,
    Entity: m,
    EntityInstance: d,
    BlockMapBuilder: o,
    CharacterMetadata: i,
    ContentBlock: s,
    ContentState: l,
    SelectionState: g,
    AtomicBlockUtils: r,
    KeyBindingUtil: h,
    Modifier: C,
    RichUtils: x,
    DefaultDraftBlockRenderMap: a,
    DefaultDraftInlineStyle: c,
    convertFromHTML: t(105),
    convertFromRaw: t(199),
    convertToRaw: I,
    genKey: t(25),
    getDefaultKeyBinding: t(108),
    getVisibleSelectionRect: t(204)
  };
  e.exports = b;
}, function (e, n, t) {
  e.exports = function () {
    "use strict";

    var e = Array.prototype.slice;

    function n(e, n) {
      n && (e.prototype = Object.create(n.prototype)), e.prototype.constructor = e;
    }

    function t(e) {
      return A(e) ? e : z(e);
    }

    function r(e) {
      return s(e) ? e : X(e);
    }

    function o(e) {
      return l(e) ? e : H(e);
    }

    function i(e) {
      return A(e) && !a(e) ? e : q(e);
    }

    function A(e) {
      return !(!e || !e[u]);
    }

    function s(e) {
      return !(!e || !e[p]);
    }

    function l(e) {
      return !(!e || !e[m]);
    }

    function a(e) {
      return s(e) || l(e);
    }

    function c(e) {
      return !(!e || !e[C]);
    }

    n(r, t), n(o, t), n(i, t), t.isIterable = A, t.isKeyed = s, t.isIndexed = l, t.isAssociative = a, t.isOrdered = c, t.Keyed = r, t.Indexed = o, t.Set = i;
    var u = "@@__IMMUTABLE_ITERABLE__@@",
        p = "@@__IMMUTABLE_KEYED__@@",
        m = "@@__IMMUTABLE_INDEXED__@@",
        C = "@@__IMMUTABLE_ORDERED__@@",
        d = 5,
        f = 1 << d,
        h = f - 1,
        x = {},
        g = {
      value: !1
    },
        I = {
      value: !1
    };

    function b(e) {
      return e.value = !1, e;
    }

    function y(e) {
      e && (e.value = !0);
    }

    function E() {}

    function v(e, n) {
      n = n || 0;

      for (var t = Math.max(0, e.length - n), r = new Array(t), o = 0; o < t; o++) {
        r[o] = e[o + n];
      }

      return r;
    }

    function w(e) {
      return void 0 === e.size && (e.size = e.__iterate(_)), e.size;
    }

    function B(e, n) {
      if ("number" != typeof n) {
        var t = n >>> 0;
        if ("" + t !== n || 4294967295 === t) return NaN;
        n = t;
      }

      return n < 0 ? w(e) + n : n;
    }

    function _() {
      return !0;
    }

    function D(e, n, t) {
      return (0 === e || void 0 !== t && e <= -t) && (void 0 === n || void 0 !== t && n >= t);
    }

    function S(e, n) {
      return O(e, n, 0);
    }

    function M(e, n) {
      return O(e, n, n);
    }

    function O(e, n, t) {
      return void 0 === e ? t : e < 0 ? Math.max(0, n + e) : void 0 === n ? e : Math.min(n, e);
    }

    var k = 0,
        T = 1,
        P = 2,
        K = "function" == typeof Symbol && Symbol.iterator,
        Q = "@@iterator",
        U = K || Q;

    function R(e) {
      this.next = e;
    }

    function G(e, n, t, r) {
      var o = 0 === e ? n : 1 === e ? t : [n, t];
      return r ? r.value = o : r = {
        value: o,
        done: !1
      }, r;
    }

    function Y() {
      return {
        value: void 0,
        done: !0
      };
    }

    function F(e) {
      return !!W(e);
    }

    function N(e) {
      return e && "function" == typeof e.next;
    }

    function j(e) {
      var n = W(e);
      return n && n.call(e);
    }

    function W(e) {
      var n = e && (K && e[K] || e[Q]);
      if ("function" == typeof n) return n;
    }

    function L(e) {
      return e && "number" == typeof e.length;
    }

    function z(e) {
      return null == e ? ie() : A(e) ? e.toSeq() : function (e) {
        var n = le(e) || "object" == typeof e && new ne(e);
        if (!n) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + e);
        return n;
      }(e);
    }

    function X(e) {
      return null == e ? ie().toKeyedSeq() : A(e) ? s(e) ? e.toSeq() : e.fromEntrySeq() : Ae(e);
    }

    function H(e) {
      return null == e ? ie() : A(e) ? s(e) ? e.entrySeq() : e.toIndexedSeq() : se(e);
    }

    function q(e) {
      return (null == e ? ie() : A(e) ? s(e) ? e.entrySeq() : e : se(e)).toSetSeq();
    }

    R.prototype.toString = function () {
      return "[Iterator]";
    }, R.KEYS = k, R.VALUES = T, R.ENTRIES = P, R.prototype.inspect = R.prototype.toSource = function () {
      return this.toString();
    }, R.prototype[U] = function () {
      return this;
    }, n(z, t), z.of = function () {
      return z(arguments);
    }, z.prototype.toSeq = function () {
      return this;
    }, z.prototype.toString = function () {
      return this.__toString("Seq {", "}");
    }, z.prototype.cacheResult = function () {
      return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
    }, z.prototype.__iterate = function (e, n) {
      return ae(this, e, n, !0);
    }, z.prototype.__iterator = function (e, n) {
      return ce(this, e, n, !0);
    }, n(X, z), X.prototype.toKeyedSeq = function () {
      return this;
    }, n(H, z), H.of = function () {
      return H(arguments);
    }, H.prototype.toIndexedSeq = function () {
      return this;
    }, H.prototype.toString = function () {
      return this.__toString("Seq [", "]");
    }, H.prototype.__iterate = function (e, n) {
      return ae(this, e, n, !1);
    }, H.prototype.__iterator = function (e, n) {
      return ce(this, e, n, !1);
    }, n(q, z), q.of = function () {
      return q(arguments);
    }, q.prototype.toSetSeq = function () {
      return this;
    }, z.isSeq = oe, z.Keyed = X, z.Set = q, z.Indexed = H;
    var V,
        J,
        Z,
        $ = "@@__IMMUTABLE_SEQ__@@";

    function ee(e) {
      this._array = e, this.size = e.length;
    }

    function ne(e) {
      var n = Object.keys(e);
      this._object = e, this._keys = n, this.size = n.length;
    }

    function te(e) {
      this._iterable = e, this.size = e.length || e.size;
    }

    function re(e) {
      this._iterator = e, this._iteratorCache = [];
    }

    function oe(e) {
      return !(!e || !e[$]);
    }

    function ie() {
      return V || (V = new ee([]));
    }

    function Ae(e) {
      var n = Array.isArray(e) ? new ee(e).fromEntrySeq() : N(e) ? new re(e).fromEntrySeq() : F(e) ? new te(e).fromEntrySeq() : "object" == typeof e ? new ne(e) : void 0;
      if (!n) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + e);
      return n;
    }

    function se(e) {
      var n = le(e);
      if (!n) throw new TypeError("Expected Array or iterable object of values: " + e);
      return n;
    }

    function le(e) {
      return L(e) ? new ee(e) : N(e) ? new re(e) : F(e) ? new te(e) : void 0;
    }

    function ae(e, n, t, r) {
      var o = e._cache;

      if (o) {
        for (var i = o.length - 1, A = 0; A <= i; A++) {
          var s = o[t ? i - A : A];
          if (!1 === n(s[1], r ? s[0] : A, e)) return A + 1;
        }

        return A;
      }

      return e.__iterateUncached(n, t);
    }

    function ce(e, n, t, r) {
      var o = e._cache;

      if (o) {
        var i = o.length - 1,
            A = 0;
        return new R(function () {
          var e = o[t ? i - A : A];
          return A++ > i ? {
            value: void 0,
            done: !0
          } : G(n, r ? e[0] : A - 1, e[1]);
        });
      }

      return e.__iteratorUncached(n, t);
    }

    function ue(e, n) {
      return n ? function e(n, t, r, o) {
        return Array.isArray(t) ? n.call(o, r, H(t).map(function (r, o) {
          return e(n, r, o, t);
        })) : me(t) ? n.call(o, r, X(t).map(function (r, o) {
          return e(n, r, o, t);
        })) : t;
      }(n, e, "", {
        "": e
      }) : pe(e);
    }

    function pe(e) {
      return Array.isArray(e) ? H(e).map(pe).toList() : me(e) ? X(e).map(pe).toMap() : e;
    }

    function me(e) {
      return e && (e.constructor === Object || void 0 === e.constructor);
    }

    function Ce(e, n) {
      if (e === n || e != e && n != n) return !0;
      if (!e || !n) return !1;

      if ("function" == typeof e.valueOf && "function" == typeof n.valueOf) {
        if ((e = e.valueOf()) === (n = n.valueOf()) || e != e && n != n) return !0;
        if (!e || !n) return !1;
      }

      return !("function" != typeof e.equals || "function" != typeof n.equals || !e.equals(n));
    }

    function de(e, n) {
      if (e === n) return !0;
      if (!A(n) || void 0 !== e.size && void 0 !== n.size && e.size !== n.size || void 0 !== e.__hash && void 0 !== n.__hash && e.__hash !== n.__hash || s(e) !== s(n) || l(e) !== l(n) || c(e) !== c(n)) return !1;
      if (0 === e.size && 0 === n.size) return !0;
      var t = !a(e);

      if (c(e)) {
        var r = e.entries();
        return n.every(function (e, n) {
          var o = r.next().value;
          return o && Ce(o[1], e) && (t || Ce(o[0], n));
        }) && r.next().done;
      }

      var o = !1;
      if (void 0 === e.size) if (void 0 === n.size) "function" == typeof e.cacheResult && e.cacheResult();else {
        o = !0;
        var i = e;
        e = n, n = i;
      }

      var u = !0,
          p = n.__iterate(function (n, r) {
        if (t ? !e.has(n) : o ? !Ce(n, e.get(r, x)) : !Ce(e.get(r, x), n)) return u = !1, !1;
      });

      return u && e.size === p;
    }

    function fe(e, n) {
      if (!(this instanceof fe)) return new fe(e, n);

      if (this._value = e, this.size = void 0 === n ? 1 / 0 : Math.max(0, n), 0 === this.size) {
        if (J) return J;
        J = this;
      }
    }

    function he(e, n) {
      if (!e) throw new Error(n);
    }

    function xe(e, n, t) {
      if (!(this instanceof xe)) return new xe(e, n, t);

      if (he(0 !== t, "Cannot step a Range by 0"), e = e || 0, void 0 === n && (n = 1 / 0), t = void 0 === t ? 1 : Math.abs(t), n < e && (t = -t), this._start = e, this._end = n, this._step = t, this.size = Math.max(0, Math.ceil((n - e) / t - 1) + 1), 0 === this.size) {
        if (Z) return Z;
        Z = this;
      }
    }

    function ge() {
      throw TypeError("Abstract");
    }

    function Ie() {}

    function be() {}

    function ye() {}

    z.prototype[$] = !0, n(ee, H), ee.prototype.get = function (e, n) {
      return this.has(e) ? this._array[B(this, e)] : n;
    }, ee.prototype.__iterate = function (e, n) {
      for (var t = this._array, r = t.length - 1, o = 0; o <= r; o++) {
        if (!1 === e(t[n ? r - o : o], o, this)) return o + 1;
      }

      return o;
    }, ee.prototype.__iterator = function (e, n) {
      var t = this._array,
          r = t.length - 1,
          o = 0;
      return new R(function () {
        return o > r ? {
          value: void 0,
          done: !0
        } : G(e, o, t[n ? r - o++ : o++]);
      });
    }, n(ne, X), ne.prototype.get = function (e, n) {
      return void 0 === n || this.has(e) ? this._object[e] : n;
    }, ne.prototype.has = function (e) {
      return this._object.hasOwnProperty(e);
    }, ne.prototype.__iterate = function (e, n) {
      for (var t = this._object, r = this._keys, o = r.length - 1, i = 0; i <= o; i++) {
        var A = r[n ? o - i : i];
        if (!1 === e(t[A], A, this)) return i + 1;
      }

      return i;
    }, ne.prototype.__iterator = function (e, n) {
      var t = this._object,
          r = this._keys,
          o = r.length - 1,
          i = 0;
      return new R(function () {
        var A = r[n ? o - i : i];
        return i++ > o ? {
          value: void 0,
          done: !0
        } : G(e, A, t[A]);
      });
    }, ne.prototype[C] = !0, n(te, H), te.prototype.__iterateUncached = function (e, n) {
      if (n) return this.cacheResult().__iterate(e, n);
      var t = j(this._iterable),
          r = 0;
      if (N(t)) for (var o; !(o = t.next()).done && !1 !== e(o.value, r++, this);) {
        ;
      }
      return r;
    }, te.prototype.__iteratorUncached = function (e, n) {
      if (n) return this.cacheResult().__iterator(e, n);
      var t = j(this._iterable);
      if (!N(t)) return new R(Y);
      var r = 0;
      return new R(function () {
        var n = t.next();
        return n.done ? n : G(e, r++, n.value);
      });
    }, n(re, H), re.prototype.__iterateUncached = function (e, n) {
      if (n) return this.cacheResult().__iterate(e, n);

      for (var t, r = this._iterator, o = this._iteratorCache, i = 0; i < o.length;) {
        if (!1 === e(o[i], i++, this)) return i;
      }

      for (; !(t = r.next()).done;) {
        var A = t.value;
        if (o[i] = A, !1 === e(A, i++, this)) break;
      }

      return i;
    }, re.prototype.__iteratorUncached = function (e, n) {
      if (n) return this.cacheResult().__iterator(e, n);
      var t = this._iterator,
          r = this._iteratorCache,
          o = 0;
      return new R(function () {
        if (o >= r.length) {
          var n = t.next();
          if (n.done) return n;
          r[o] = n.value;
        }

        return G(e, o, r[o++]);
      });
    }, n(fe, H), fe.prototype.toString = function () {
      return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
    }, fe.prototype.get = function (e, n) {
      return this.has(e) ? this._value : n;
    }, fe.prototype.includes = function (e) {
      return Ce(this._value, e);
    }, fe.prototype.slice = function (e, n) {
      var t = this.size;
      return D(e, n, t) ? this : new fe(this._value, M(n, t) - S(e, t));
    }, fe.prototype.reverse = function () {
      return this;
    }, fe.prototype.indexOf = function (e) {
      return Ce(this._value, e) ? 0 : -1;
    }, fe.prototype.lastIndexOf = function (e) {
      return Ce(this._value, e) ? this.size : -1;
    }, fe.prototype.__iterate = function (e, n) {
      for (var t = 0; t < this.size; t++) {
        if (!1 === e(this._value, t, this)) return t + 1;
      }

      return t;
    }, fe.prototype.__iterator = function (e, n) {
      var t = this,
          r = 0;
      return new R(function () {
        return r < t.size ? G(e, r++, t._value) : {
          value: void 0,
          done: !0
        };
      });
    }, fe.prototype.equals = function (e) {
      return e instanceof fe ? Ce(this._value, e._value) : de(e);
    }, n(xe, H), xe.prototype.toString = function () {
      return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step > 1 ? " by " + this._step : "") + " ]";
    }, xe.prototype.get = function (e, n) {
      return this.has(e) ? this._start + B(this, e) * this._step : n;
    }, xe.prototype.includes = function (e) {
      var n = (e - this._start) / this._step;
      return n >= 0 && n < this.size && n === Math.floor(n);
    }, xe.prototype.slice = function (e, n) {
      return D(e, n, this.size) ? this : (e = S(e, this.size), (n = M(n, this.size)) <= e ? new xe(0, 0) : new xe(this.get(e, this._end), this.get(n, this._end), this._step));
    }, xe.prototype.indexOf = function (e) {
      var n = e - this._start;

      if (n % this._step == 0) {
        var t = n / this._step;
        if (t >= 0 && t < this.size) return t;
      }

      return -1;
    }, xe.prototype.lastIndexOf = function (e) {
      return this.indexOf(e);
    }, xe.prototype.__iterate = function (e, n) {
      for (var t = this.size - 1, r = this._step, o = n ? this._start + t * r : this._start, i = 0; i <= t; i++) {
        if (!1 === e(o, i, this)) return i + 1;
        o += n ? -r : r;
      }

      return i;
    }, xe.prototype.__iterator = function (e, n) {
      var t = this.size - 1,
          r = this._step,
          o = n ? this._start + t * r : this._start,
          i = 0;
      return new R(function () {
        var A = o;
        return o += n ? -r : r, i > t ? {
          value: void 0,
          done: !0
        } : G(e, i++, A);
      });
    }, xe.prototype.equals = function (e) {
      return e instanceof xe ? this._start === e._start && this._end === e._end && this._step === e._step : de(this, e);
    }, n(ge, t), n(Ie, ge), n(be, ge), n(ye, ge), ge.Keyed = Ie, ge.Indexed = be, ge.Set = ye;
    var Ee = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function (e, n) {
      var t = 65535 & (e |= 0),
          r = 65535 & (n |= 0);
      return t * r + ((e >>> 16) * r + t * (n >>> 16) << 16 >>> 0) | 0;
    };

    function ve(e) {
      return e >>> 1 & 1073741824 | 3221225471 & e;
    }

    function we(e) {
      if (!1 === e || null == e) return 0;
      if ("function" == typeof e.valueOf && (!1 === (e = e.valueOf()) || null == e)) return 0;
      if (!0 === e) return 1;
      var n = typeof e;

      if ("number" === n) {
        var t = 0 | e;

        for (t !== e && (t ^= 4294967295 * e); e > 4294967295;) {
          t ^= e /= 4294967295;
        }

        return ve(t);
      }

      if ("string" === n) return e.length > Te ? function (e) {
        var n = Qe[e];
        return void 0 === n && (n = Be(e), Ke === Pe && (Ke = 0, Qe = {}), Ke++, Qe[e] = n), n;
      }(e) : Be(e);
      if ("function" == typeof e.hashCode) return e.hashCode();
      if ("object" === n) return function (e) {
        var n;
        if (Me && void 0 !== (n = _e.get(e))) return n;
        if (void 0 !== (n = e[ke])) return n;

        if (!Se) {
          if (void 0 !== (n = e.propertyIsEnumerable && e.propertyIsEnumerable[ke])) return n;
          if (void 0 !== (n = function (e) {
            if (e && e.nodeType > 0) switch (e.nodeType) {
              case 1:
                return e.uniqueID;

              case 9:
                return e.documentElement && e.documentElement.uniqueID;
            }
          }(e))) return n;
        }

        if (n = ++Oe, 1073741824 & Oe && (Oe = 0), Me) _e.set(e, n);else {
          if (void 0 !== De && !1 === De(e)) throw new Error("Non-extensible objects are not allowed as keys.");
          if (Se) Object.defineProperty(e, ke, {
            enumerable: !1,
            configurable: !1,
            writable: !1,
            value: n
          });else if (void 0 !== e.propertyIsEnumerable && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable) e.propertyIsEnumerable = function () {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
          }, e.propertyIsEnumerable[ke] = n;else {
            if (void 0 === e.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
            e[ke] = n;
          }
        }
        return n;
      }(e);
      if ("function" == typeof e.toString) return Be(e.toString());
      throw new Error("Value type " + n + " cannot be hashed.");
    }

    function Be(e) {
      for (var n = 0, t = 0; t < e.length; t++) {
        n = 31 * n + e.charCodeAt(t) | 0;
      }

      return ve(n);
    }

    var _e,
        De = Object.isExtensible,
        Se = function () {
      try {
        return Object.defineProperty({}, "@", {}), !0;
      } catch (e) {
        return !1;
      }
    }(),
        Me = "function" == typeof WeakMap;

    Me && (_e = new WeakMap());
    var Oe = 0,
        ke = "__immutablehash__";
    "function" == typeof Symbol && (ke = Symbol(ke));
    var Te = 16,
        Pe = 255,
        Ke = 0,
        Qe = {};

    function Ue(e) {
      he(e !== 1 / 0, "Cannot perform this action with an infinite size.");
    }

    function Re(e) {
      return null == e ? Ze() : Ge(e) && !c(e) ? e : Ze().withMutations(function (n) {
        var t = r(e);
        Ue(t.size), t.forEach(function (e, t) {
          return n.set(t, e);
        });
      });
    }

    function Ge(e) {
      return !(!e || !e[Fe]);
    }

    n(Re, Ie), Re.prototype.toString = function () {
      return this.__toString("Map {", "}");
    }, Re.prototype.get = function (e, n) {
      return this._root ? this._root.get(0, void 0, e, n) : n;
    }, Re.prototype.set = function (e, n) {
      return $e(this, e, n);
    }, Re.prototype.setIn = function (e, n) {
      return this.updateIn(e, x, function () {
        return n;
      });
    }, Re.prototype.remove = function (e) {
      return $e(this, e, x);
    }, Re.prototype.deleteIn = function (e) {
      return this.updateIn(e, function () {
        return x;
      });
    }, Re.prototype.update = function (e, n, t) {
      return 1 === arguments.length ? e(this) : this.updateIn([e], n, t);
    }, Re.prototype.updateIn = function (e, n, t) {
      t || (t = n, n = void 0);

      var r = function e(n, t, r, o) {
        var i = n === x,
            A = t.next();

        if (A.done) {
          var s = i ? r : n,
              l = o(s);
          return l === s ? n : l;
        }

        he(i || n && n.set, "invalid keyPath");
        var a = A.value,
            c = i ? x : n.get(a, x),
            u = e(c, t, r, o);
        return u === c ? n : u === x ? n.remove(a) : (i ? Ze() : n).set(a, u);
      }(this, ot(e), n, t);

      return r === x ? void 0 : r;
    }, Re.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : Ze();
    }, Re.prototype.merge = function () {
      return rn(this, void 0, arguments);
    }, Re.prototype.mergeWith = function (n) {
      var t = e.call(arguments, 1);
      return rn(this, n, t);
    }, Re.prototype.mergeIn = function (n) {
      var t = e.call(arguments, 1);
      return this.updateIn(n, Ze(), function (e) {
        return "function" == typeof e.merge ? e.merge.apply(e, t) : t[t.length - 1];
      });
    }, Re.prototype.mergeDeep = function () {
      return rn(this, on, arguments);
    }, Re.prototype.mergeDeepWith = function (n) {
      var t = e.call(arguments, 1);
      return rn(this, An(n), t);
    }, Re.prototype.mergeDeepIn = function (n) {
      var t = e.call(arguments, 1);
      return this.updateIn(n, Ze(), function (e) {
        return "function" == typeof e.mergeDeep ? e.mergeDeep.apply(e, t) : t[t.length - 1];
      });
    }, Re.prototype.sort = function (e) {
      return Mn(Xn(this, e));
    }, Re.prototype.sortBy = function (e, n) {
      return Mn(Xn(this, n, e));
    }, Re.prototype.withMutations = function (e) {
      var n = this.asMutable();
      return e(n), n.wasAltered() ? n.__ensureOwner(this.__ownerID) : this;
    }, Re.prototype.asMutable = function () {
      return this.__ownerID ? this : this.__ensureOwner(new E());
    }, Re.prototype.asImmutable = function () {
      return this.__ensureOwner();
    }, Re.prototype.wasAltered = function () {
      return this.__altered;
    }, Re.prototype.__iterator = function (e, n) {
      return new He(this, e, n);
    }, Re.prototype.__iterate = function (e, n) {
      var t = this,
          r = 0;
      return this._root && this._root.iterate(function (n) {
        return r++, e(n[1], n[0], t);
      }, n), r;
    }, Re.prototype.__ensureOwner = function (e) {
      return e === this.__ownerID ? this : e ? Je(this.size, this._root, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
    }, Re.isMap = Ge;
    var Ye,
        Fe = "@@__IMMUTABLE_MAP__@@",
        Ne = Re.prototype;

    function je(e, n) {
      this.ownerID = e, this.entries = n;
    }

    function We(e, n, t) {
      this.ownerID = e, this.bitmap = n, this.nodes = t;
    }

    function Le(e, n, t) {
      this.ownerID = e, this.count = n, this.nodes = t;
    }

    function ze(e, n, t) {
      this.ownerID = e, this.keyHash = n, this.entries = t;
    }

    function Xe(e, n, t) {
      this.ownerID = e, this.keyHash = n, this.entry = t;
    }

    function He(e, n, t) {
      this._type = n, this._reverse = t, this._stack = e._root && Ve(e._root);
    }

    function qe(e, n) {
      return G(e, n[0], n[1]);
    }

    function Ve(e, n) {
      return {
        node: e,
        index: 0,
        __prev: n
      };
    }

    function Je(e, n, t, r) {
      var o = Object.create(Ne);
      return o.size = e, o._root = n, o.__ownerID = t, o.__hash = r, o.__altered = !1, o;
    }

    function Ze() {
      return Ye || (Ye = Je(0));
    }

    function $e(e, n, t) {
      var r, o;

      if (e._root) {
        var i = b(g),
            A = b(I);
        if (r = en(e._root, e.__ownerID, 0, void 0, n, t, i, A), !A.value) return e;
        o = e.size + (i.value ? t === x ? -1 : 1 : 0);
      } else {
        if (t === x) return e;
        o = 1, r = new je(e.__ownerID, [[n, t]]);
      }

      return e.__ownerID ? (e.size = o, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? Je(o, r) : Ze();
    }

    function en(e, n, t, r, o, i, A, s) {
      return e ? e.update(n, t, r, o, i, A, s) : i === x ? e : (y(s), y(A), new Xe(n, r, [o, i]));
    }

    function nn(e) {
      return e.constructor === Xe || e.constructor === ze;
    }

    function tn(e, n, t, r, o) {
      if (e.keyHash === r) return new ze(n, r, [e.entry, o]);
      var i,
          A = (0 === t ? e.keyHash : e.keyHash >>> t) & h,
          s = (0 === t ? r : r >>> t) & h;
      return new We(n, 1 << A | 1 << s, A === s ? [tn(e, n, t + d, r, o)] : (i = new Xe(n, r, o), A < s ? [e, i] : [i, e]));
    }

    function rn(e, n, t) {
      for (var o = [], i = 0; i < t.length; i++) {
        var s = t[i],
            l = r(s);
        A(s) || (l = l.map(function (e) {
          return ue(e);
        })), o.push(l);
      }

      return sn(e, n, o);
    }

    function on(e, n, t) {
      return e && e.mergeDeep && A(n) ? e.mergeDeep(n) : Ce(e, n) ? e : n;
    }

    function An(e) {
      return function (n, t, r) {
        if (n && n.mergeDeepWith && A(t)) return n.mergeDeepWith(e, t);
        var o = e(n, t, r);
        return Ce(n, o) ? n : o;
      };
    }

    function sn(e, n, t) {
      return 0 === (t = t.filter(function (e) {
        return 0 !== e.size;
      })).length ? e : 0 !== e.size || e.__ownerID || 1 !== t.length ? e.withMutations(function (e) {
        for (var r = n ? function (t, r) {
          e.update(r, x, function (e) {
            return e === x ? t : n(e, t, r);
          });
        } : function (n, t) {
          e.set(t, n);
        }, o = 0; o < t.length; o++) {
          t[o].forEach(r);
        }
      }) : e.constructor(t[0]);
    }

    function ln(e) {
      return e = (e = (858993459 & (e -= e >> 1 & 1431655765)) + (e >> 2 & 858993459)) + (e >> 4) & 252645135, e += e >> 8, 127 & (e += e >> 16);
    }

    function an(e, n, t, r) {
      var o = r ? e : v(e);
      return o[n] = t, o;
    }

    Ne[Fe] = !0, Ne.delete = Ne.remove, Ne.removeIn = Ne.deleteIn, je.prototype.get = function (e, n, t, r) {
      for (var o = this.entries, i = 0, A = o.length; i < A; i++) {
        if (Ce(t, o[i][0])) return o[i][1];
      }

      return r;
    }, je.prototype.update = function (e, n, t, r, o, i, A) {
      for (var s = o === x, l = this.entries, a = 0, c = l.length; a < c && !Ce(r, l[a][0]); a++) {
        ;
      }

      var u = a < c;
      if (u ? l[a][1] === o : s) return this;

      if (y(A), (s || !u) && y(i), !s || 1 !== l.length) {
        if (!u && !s && l.length >= cn) return function (e, n, t, r) {
          e || (e = new E());

          for (var o = new Xe(e, we(t), [t, r]), i = 0; i < n.length; i++) {
            var A = n[i];
            o = o.update(e, 0, void 0, A[0], A[1]);
          }

          return o;
        }(e, l, r, o);
        var p = e && e === this.ownerID,
            m = p ? l : v(l);
        return u ? s ? a === c - 1 ? m.pop() : m[a] = m.pop() : m[a] = [r, o] : m.push([r, o]), p ? (this.entries = m, this) : new je(e, m);
      }
    }, We.prototype.get = function (e, n, t, r) {
      void 0 === n && (n = we(t));
      var o = 1 << ((0 === e ? n : n >>> e) & h),
          i = this.bitmap;
      return 0 == (i & o) ? r : this.nodes[ln(i & o - 1)].get(e + d, n, t, r);
    }, We.prototype.update = function (e, n, t, r, o, i, A) {
      void 0 === t && (t = we(r));
      var s = (0 === n ? t : t >>> n) & h,
          l = 1 << s,
          a = this.bitmap,
          c = 0 != (a & l);
      if (!c && o === x) return this;
      var u = ln(a & l - 1),
          p = this.nodes,
          m = c ? p[u] : void 0,
          C = en(m, e, n + d, t, r, o, i, A);
      if (C === m) return this;
      if (!c && C && p.length >= un) return function (e, n, t, r, o) {
        for (var i = 0, A = new Array(f), s = 0; 0 !== t; s++, t >>>= 1) {
          A[s] = 1 & t ? n[i++] : void 0;
        }

        return A[r] = o, new Le(e, i + 1, A);
      }(e, p, a, s, C);
      if (c && !C && 2 === p.length && nn(p[1 ^ u])) return p[1 ^ u];
      if (c && C && 1 === p.length && nn(C)) return C;
      var g = e && e === this.ownerID,
          I = c ? C ? a : a ^ l : a | l,
          b = c ? C ? an(p, u, C, g) : function (e, n, t) {
        var r = e.length - 1;
        if (t && n === r) return e.pop(), e;

        for (var o = new Array(r), i = 0, A = 0; A < r; A++) {
          A === n && (i = 1), o[A] = e[A + i];
        }

        return o;
      }(p, u, g) : function (e, n, t, r) {
        var o = e.length + 1;
        if (r && n + 1 === o) return e[n] = t, e;

        for (var i = new Array(o), A = 0, s = 0; s < o; s++) {
          s === n ? (i[s] = t, A = -1) : i[s] = e[s + A];
        }

        return i;
      }(p, u, C, g);
      return g ? (this.bitmap = I, this.nodes = b, this) : new We(e, I, b);
    }, Le.prototype.get = function (e, n, t, r) {
      void 0 === n && (n = we(t));
      var o = (0 === e ? n : n >>> e) & h,
          i = this.nodes[o];
      return i ? i.get(e + d, n, t, r) : r;
    }, Le.prototype.update = function (e, n, t, r, o, i, A) {
      void 0 === t && (t = we(r));
      var s = (0 === n ? t : t >>> n) & h,
          l = o === x,
          a = this.nodes,
          c = a[s];
      if (l && !c) return this;
      var u = en(c, e, n + d, t, r, o, i, A);
      if (u === c) return this;
      var p = this.count;

      if (c) {
        if (!u && --p < pn) return function (e, n, t, r) {
          for (var o = 0, i = 0, A = new Array(t), s = 0, l = 1, a = n.length; s < a; s++, l <<= 1) {
            var c = n[s];
            void 0 !== c && s !== r && (o |= l, A[i++] = c);
          }

          return new We(e, o, A);
        }(e, a, p, s);
      } else p++;

      var m = e && e === this.ownerID,
          C = an(a, s, u, m);
      return m ? (this.count = p, this.nodes = C, this) : new Le(e, p, C);
    }, ze.prototype.get = function (e, n, t, r) {
      for (var o = this.entries, i = 0, A = o.length; i < A; i++) {
        if (Ce(t, o[i][0])) return o[i][1];
      }

      return r;
    }, ze.prototype.update = function (e, n, t, r, o, i, A) {
      void 0 === t && (t = we(r));
      var s = o === x;
      if (t !== this.keyHash) return s ? this : (y(A), y(i), tn(this, e, n, t, [r, o]));

      for (var l = this.entries, a = 0, c = l.length; a < c && !Ce(r, l[a][0]); a++) {
        ;
      }

      var u = a < c;
      if (u ? l[a][1] === o : s) return this;
      if (y(A), (s || !u) && y(i), s && 2 === c) return new Xe(e, this.keyHash, l[1 ^ a]);
      var p = e && e === this.ownerID,
          m = p ? l : v(l);
      return u ? s ? a === c - 1 ? m.pop() : m[a] = m.pop() : m[a] = [r, o] : m.push([r, o]), p ? (this.entries = m, this) : new ze(e, this.keyHash, m);
    }, Xe.prototype.get = function (e, n, t, r) {
      return Ce(t, this.entry[0]) ? this.entry[1] : r;
    }, Xe.prototype.update = function (e, n, t, r, o, i, A) {
      var s = o === x,
          l = Ce(r, this.entry[0]);
      return (l ? o === this.entry[1] : s) ? this : (y(A), s ? void y(i) : l ? e && e === this.ownerID ? (this.entry[1] = o, this) : new Xe(e, this.keyHash, [r, o]) : (y(i), tn(this, e, n, we(r), [r, o])));
    }, je.prototype.iterate = ze.prototype.iterate = function (e, n) {
      for (var t = this.entries, r = 0, o = t.length - 1; r <= o; r++) {
        if (!1 === e(t[n ? o - r : r])) return !1;
      }
    }, We.prototype.iterate = Le.prototype.iterate = function (e, n) {
      for (var t = this.nodes, r = 0, o = t.length - 1; r <= o; r++) {
        var i = t[n ? o - r : r];
        if (i && !1 === i.iterate(e, n)) return !1;
      }
    }, Xe.prototype.iterate = function (e, n) {
      return e(this.entry);
    }, n(He, R), He.prototype.next = function () {
      for (var e = this._type, n = this._stack; n;) {
        var t,
            r = n.node,
            o = n.index++;

        if (r.entry) {
          if (0 === o) return qe(e, r.entry);
        } else if (r.entries) {
          if (o <= (t = r.entries.length - 1)) return qe(e, r.entries[this._reverse ? t - o : o]);
        } else if (o <= (t = r.nodes.length - 1)) {
          var i = r.nodes[this._reverse ? t - o : o];

          if (i) {
            if (i.entry) return qe(e, i.entry);
            n = this._stack = Ve(i, n);
          }

          continue;
        }

        n = this._stack = this._stack.__prev;
      }

      return {
        value: void 0,
        done: !0
      };
    };
    var cn = f / 4,
        un = f / 2,
        pn = f / 4;

    function mn(e) {
      var n = En();
      if (null == e) return n;
      if (Cn(e)) return e;
      var t = o(e),
          r = t.size;
      return 0 === r ? n : (Ue(r), r > 0 && r < f ? yn(0, r, d, null, new hn(t.toArray())) : n.withMutations(function (e) {
        e.setSize(r), t.forEach(function (n, t) {
          return e.set(t, n);
        });
      }));
    }

    function Cn(e) {
      return !(!e || !e[dn]);
    }

    n(mn, be), mn.of = function () {
      return this(arguments);
    }, mn.prototype.toString = function () {
      return this.__toString("List [", "]");
    }, mn.prototype.get = function (e, n) {
      if ((e = B(this, e)) >= 0 && e < this.size) {
        var t = Bn(this, e += this._origin);
        return t && t.array[e & h];
      }

      return n;
    }, mn.prototype.set = function (e, n) {
      return function (e, n, t) {
        if ((n = B(e, n)) != n) return e;
        if (n >= e.size || n < 0) return e.withMutations(function (e) {
          n < 0 ? _n(e, n).set(0, t) : _n(e, 0, n + 1).set(n, t);
        });
        n += e._origin;
        var r = e._tail,
            o = e._root,
            i = b(I);
        return n >= Sn(e._capacity) ? r = vn(r, e.__ownerID, 0, n, t, i) : o = vn(o, e.__ownerID, e._level, n, t, i), i.value ? e.__ownerID ? (e._root = o, e._tail = r, e.__hash = void 0, e.__altered = !0, e) : yn(e._origin, e._capacity, e._level, o, r) : e;
      }(this, e, n);
    }, mn.prototype.remove = function (e) {
      return this.has(e) ? 0 === e ? this.shift() : e === this.size - 1 ? this.pop() : this.splice(e, 1) : this;
    }, mn.prototype.insert = function (e, n) {
      return this.splice(e, 0, n);
    }, mn.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = d, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : En();
    }, mn.prototype.push = function () {
      var e = arguments,
          n = this.size;
      return this.withMutations(function (t) {
        _n(t, 0, n + e.length);

        for (var r = 0; r < e.length; r++) {
          t.set(n + r, e[r]);
        }
      });
    }, mn.prototype.pop = function () {
      return _n(this, 0, -1);
    }, mn.prototype.unshift = function () {
      var e = arguments;
      return this.withMutations(function (n) {
        _n(n, -e.length);

        for (var t = 0; t < e.length; t++) {
          n.set(t, e[t]);
        }
      });
    }, mn.prototype.shift = function () {
      return _n(this, 1);
    }, mn.prototype.merge = function () {
      return Dn(this, void 0, arguments);
    }, mn.prototype.mergeWith = function (n) {
      var t = e.call(arguments, 1);
      return Dn(this, n, t);
    }, mn.prototype.mergeDeep = function () {
      return Dn(this, on, arguments);
    }, mn.prototype.mergeDeepWith = function (n) {
      var t = e.call(arguments, 1);
      return Dn(this, An(n), t);
    }, mn.prototype.setSize = function (e) {
      return _n(this, 0, e);
    }, mn.prototype.slice = function (e, n) {
      var t = this.size;
      return D(e, n, t) ? this : _n(this, S(e, t), M(n, t));
    }, mn.prototype.__iterator = function (e, n) {
      var t = 0,
          r = bn(this, n);
      return new R(function () {
        var n = r();
        return n === In ? {
          value: void 0,
          done: !0
        } : G(e, t++, n);
      });
    }, mn.prototype.__iterate = function (e, n) {
      for (var t, r = 0, o = bn(this, n); (t = o()) !== In && !1 !== e(t, r++, this);) {
        ;
      }

      return r;
    }, mn.prototype.__ensureOwner = function (e) {
      return e === this.__ownerID ? this : e ? yn(this._origin, this._capacity, this._level, this._root, this._tail, e, this.__hash) : (this.__ownerID = e, this);
    }, mn.isList = Cn;
    var dn = "@@__IMMUTABLE_LIST__@@",
        fn = mn.prototype;

    function hn(e, n) {
      this.array = e, this.ownerID = n;
    }

    fn[dn] = !0, fn.delete = fn.remove, fn.setIn = Ne.setIn, fn.deleteIn = fn.removeIn = Ne.removeIn, fn.update = Ne.update, fn.updateIn = Ne.updateIn, fn.mergeIn = Ne.mergeIn, fn.mergeDeepIn = Ne.mergeDeepIn, fn.withMutations = Ne.withMutations, fn.asMutable = Ne.asMutable, fn.asImmutable = Ne.asImmutable, fn.wasAltered = Ne.wasAltered, hn.prototype.removeBefore = function (e, n, t) {
      if (t === n ? 1 << n : 0 === this.array.length) return this;
      var r = t >>> n & h;
      if (r >= this.array.length) return new hn([], e);
      var o,
          i = 0 === r;

      if (n > 0) {
        var A = this.array[r];
        if ((o = A && A.removeBefore(e, n - d, t)) === A && i) return this;
      }

      if (i && !o) return this;
      var s = wn(this, e);
      if (!i) for (var l = 0; l < r; l++) {
        s.array[l] = void 0;
      }
      return o && (s.array[r] = o), s;
    }, hn.prototype.removeAfter = function (e, n, t) {
      if (t === (n ? 1 << n : 0) || 0 === this.array.length) return this;
      var r,
          o = t - 1 >>> n & h;
      if (o >= this.array.length) return this;

      if (n > 0) {
        var i = this.array[o];
        if ((r = i && i.removeAfter(e, n - d, t)) === i && o === this.array.length - 1) return this;
      }

      var A = wn(this, e);
      return A.array.splice(o + 1), r && (A.array[o] = r), A;
    };
    var xn,
        gn,
        In = {};

    function bn(e, n) {
      var t = e._origin,
          r = e._capacity,
          o = Sn(r),
          i = e._tail;
      return A(e._root, e._level, 0);

      function A(e, s, l) {
        return 0 === s ? function (e, A) {
          var s = A === o ? i && i.array : e && e.array,
              l = A > t ? 0 : t - A,
              a = r - A;
          return a > f && (a = f), function () {
            if (l === a) return In;
            var e = n ? --a : l++;
            return s && s[e];
          };
        }(e, l) : function (e, o, i) {
          var s,
              l = e && e.array,
              a = i > t ? 0 : t - i >> o,
              c = 1 + (r - i >> o);
          return c > f && (c = f), function () {
            for (;;) {
              if (s) {
                var e = s();
                if (e !== In) return e;
                s = null;
              }

              if (a === c) return In;
              var t = n ? --c : a++;
              s = A(l && l[t], o - d, i + (t << o));
            }
          };
        }(e, s, l);
      }
    }

    function yn(e, n, t, r, o, i, A) {
      var s = Object.create(fn);
      return s.size = n - e, s._origin = e, s._capacity = n, s._level = t, s._root = r, s._tail = o, s.__ownerID = i, s.__hash = A, s.__altered = !1, s;
    }

    function En() {
      return xn || (xn = yn(0, 0, d));
    }

    function vn(e, n, t, r, o, i) {
      var A,
          s = r >>> t & h,
          l = e && s < e.array.length;
      if (!l && void 0 === o) return e;

      if (t > 0) {
        var a = e && e.array[s],
            c = vn(a, n, t - d, r, o, i);
        return c === a ? e : ((A = wn(e, n)).array[s] = c, A);
      }

      return l && e.array[s] === o ? e : (y(i), A = wn(e, n), void 0 === o && s === A.array.length - 1 ? A.array.pop() : A.array[s] = o, A);
    }

    function wn(e, n) {
      return n && e && n === e.ownerID ? e : new hn(e ? e.array.slice() : [], n);
    }

    function Bn(e, n) {
      if (n >= Sn(e._capacity)) return e._tail;

      if (n < 1 << e._level + d) {
        for (var t = e._root, r = e._level; t && r > 0;) {
          t = t.array[n >>> r & h], r -= d;
        }

        return t;
      }
    }

    function _n(e, n, t) {
      void 0 !== n && (n |= 0), void 0 !== t && (t |= 0);
      var r = e.__ownerID || new E(),
          o = e._origin,
          i = e._capacity,
          A = o + n,
          s = void 0 === t ? i : t < 0 ? i + t : o + t;
      if (A === o && s === i) return e;
      if (A >= s) return e.clear();

      for (var l = e._level, a = e._root, c = 0; A + c < 0;) {
        a = new hn(a && a.array.length ? [void 0, a] : [], r), c += 1 << (l += d);
      }

      c && (A += c, o += c, s += c, i += c);

      for (var u = Sn(i), p = Sn(s); p >= 1 << l + d;) {
        a = new hn(a && a.array.length ? [a] : [], r), l += d;
      }

      var m = e._tail,
          C = p < u ? Bn(e, s - 1) : p > u ? new hn([], r) : m;

      if (m && p > u && A < i && m.array.length) {
        for (var f = a = wn(a, r), x = l; x > d; x -= d) {
          var g = u >>> x & h;
          f = f.array[g] = wn(f.array[g], r);
        }

        f.array[u >>> d & h] = m;
      }

      if (s < i && (C = C && C.removeAfter(r, 0, s)), A >= p) A -= p, s -= p, l = d, a = null, C = C && C.removeBefore(r, 0, A);else if (A > o || p < u) {
        for (c = 0; a;) {
          var I = A >>> l & h;
          if (I !== p >>> l & h) break;
          I && (c += (1 << l) * I), l -= d, a = a.array[I];
        }

        a && A > o && (a = a.removeBefore(r, l, A - c)), a && p < u && (a = a.removeAfter(r, l, p - c)), c && (A -= c, s -= c);
      }
      return e.__ownerID ? (e.size = s - A, e._origin = A, e._capacity = s, e._level = l, e._root = a, e._tail = C, e.__hash = void 0, e.__altered = !0, e) : yn(A, s, l, a, C);
    }

    function Dn(e, n, t) {
      for (var r = [], i = 0, s = 0; s < t.length; s++) {
        var l = t[s],
            a = o(l);
        a.size > i && (i = a.size), A(l) || (a = a.map(function (e) {
          return ue(e);
        })), r.push(a);
      }

      return i > e.size && (e = e.setSize(i)), sn(e, n, r);
    }

    function Sn(e) {
      return e < f ? 0 : e - 1 >>> d << d;
    }

    function Mn(e) {
      return null == e ? Tn() : On(e) ? e : Tn().withMutations(function (n) {
        var t = r(e);
        Ue(t.size), t.forEach(function (e, t) {
          return n.set(t, e);
        });
      });
    }

    function On(e) {
      return Ge(e) && c(e);
    }

    function kn(e, n, t, r) {
      var o = Object.create(Mn.prototype);
      return o.size = e ? e.size : 0, o._map = e, o._list = n, o.__ownerID = t, o.__hash = r, o;
    }

    function Tn() {
      return gn || (gn = kn(Ze(), En()));
    }

    function Pn(e, n, t) {
      var r,
          o,
          i = e._map,
          A = e._list,
          s = i.get(n),
          l = void 0 !== s;

      if (t === x) {
        if (!l) return e;
        A.size >= f && A.size >= 2 * i.size ? (r = (o = A.filter(function (e, n) {
          return void 0 !== e && s !== n;
        })).toKeyedSeq().map(function (e) {
          return e[0];
        }).flip().toMap(), e.__ownerID && (r.__ownerID = o.__ownerID = e.__ownerID)) : (r = i.remove(n), o = s === A.size - 1 ? A.pop() : A.set(s, void 0));
      } else if (l) {
        if (t === A.get(s)[1]) return e;
        r = i, o = A.set(s, [n, t]);
      } else r = i.set(n, A.size), o = A.set(A.size, [n, t]);

      return e.__ownerID ? (e.size = r.size, e._map = r, e._list = o, e.__hash = void 0, e) : kn(r, o);
    }

    function Kn(e, n) {
      this._iter = e, this._useKeys = n, this.size = e.size;
    }

    function Qn(e) {
      this._iter = e, this.size = e.size;
    }

    function Un(e) {
      this._iter = e, this.size = e.size;
    }

    function Rn(e) {
      this._iter = e, this.size = e.size;
    }

    function Gn(e) {
      var n = nt(e);
      return n._iter = e, n.size = e.size, n.flip = function () {
        return e;
      }, n.reverse = function () {
        var n = e.reverse.apply(this);
        return n.flip = function () {
          return e.reverse();
        }, n;
      }, n.has = function (n) {
        return e.includes(n);
      }, n.includes = function (n) {
        return e.has(n);
      }, n.cacheResult = tt, n.__iterateUncached = function (n, t) {
        var r = this;
        return e.__iterate(function (e, t) {
          return !1 !== n(t, e, r);
        }, t);
      }, n.__iteratorUncached = function (n, t) {
        if (n === P) {
          var r = e.__iterator(n, t);

          return new R(function () {
            var e = r.next();

            if (!e.done) {
              var n = e.value[0];
              e.value[0] = e.value[1], e.value[1] = n;
            }

            return e;
          });
        }

        return e.__iterator(n === T ? k : T, t);
      }, n;
    }

    function Yn(e, n, t) {
      var r = nt(e);
      return r.size = e.size, r.has = function (n) {
        return e.has(n);
      }, r.get = function (r, o) {
        var i = e.get(r, x);
        return i === x ? o : n.call(t, i, r, e);
      }, r.__iterateUncached = function (r, o) {
        var i = this;
        return e.__iterate(function (e, o, A) {
          return !1 !== r(n.call(t, e, o, A), o, i);
        }, o);
      }, r.__iteratorUncached = function (r, o) {
        var i = e.__iterator(P, o);

        return new R(function () {
          var o = i.next();
          if (o.done) return o;
          var A = o.value,
              s = A[0];
          return G(r, s, n.call(t, A[1], s, e), o);
        });
      }, r;
    }

    function Fn(e, n) {
      var t = nt(e);
      return t._iter = e, t.size = e.size, t.reverse = function () {
        return e;
      }, e.flip && (t.flip = function () {
        var n = Gn(e);
        return n.reverse = function () {
          return e.flip();
        }, n;
      }), t.get = function (t, r) {
        return e.get(n ? t : -1 - t, r);
      }, t.has = function (t) {
        return e.has(n ? t : -1 - t);
      }, t.includes = function (n) {
        return e.includes(n);
      }, t.cacheResult = tt, t.__iterate = function (n, t) {
        var r = this;
        return e.__iterate(function (e, t) {
          return n(e, t, r);
        }, !t);
      }, t.__iterator = function (n, t) {
        return e.__iterator(n, !t);
      }, t;
    }

    function Nn(e, n, t, r) {
      var o = nt(e);
      return r && (o.has = function (r) {
        var o = e.get(r, x);
        return o !== x && !!n.call(t, o, r, e);
      }, o.get = function (r, o) {
        var i = e.get(r, x);
        return i !== x && n.call(t, i, r, e) ? i : o;
      }), o.__iterateUncached = function (o, i) {
        var A = this,
            s = 0;
        return e.__iterate(function (e, i, l) {
          if (n.call(t, e, i, l)) return s++, o(e, r ? i : s - 1, A);
        }, i), s;
      }, o.__iteratorUncached = function (o, i) {
        var A = e.__iterator(P, i),
            s = 0;

        return new R(function () {
          for (;;) {
            var i = A.next();
            if (i.done) return i;
            var l = i.value,
                a = l[0],
                c = l[1];
            if (n.call(t, c, a, e)) return G(o, r ? a : s++, c, i);
          }
        });
      }, o;
    }

    function jn(e, n, t, r) {
      var o = e.size;
      if (void 0 !== n && (n |= 0), void 0 !== t && (t |= 0), D(n, t, o)) return e;
      var i = S(n, o),
          A = M(t, o);
      if (i != i || A != A) return jn(e.toSeq().cacheResult(), n, t, r);
      var s,
          l = A - i;
      l == l && (s = l < 0 ? 0 : l);
      var a = nt(e);
      return a.size = 0 === s ? s : e.size && s || void 0, !r && oe(e) && s >= 0 && (a.get = function (n, t) {
        return (n = B(this, n)) >= 0 && n < s ? e.get(n + i, t) : t;
      }), a.__iterateUncached = function (n, t) {
        var o = this;
        if (0 === s) return 0;
        if (t) return this.cacheResult().__iterate(n, t);
        var A = 0,
            l = !0,
            a = 0;
        return e.__iterate(function (e, t) {
          if (!l || !(l = A++ < i)) return a++, !1 !== n(e, r ? t : a - 1, o) && a !== s;
        }), a;
      }, a.__iteratorUncached = function (n, t) {
        if (0 !== s && t) return this.cacheResult().__iterator(n, t);

        var o = 0 !== s && e.__iterator(n, t),
            A = 0,
            l = 0;

        return new R(function () {
          for (; A++ < i;) {
            o.next();
          }

          if (++l > s) return {
            value: void 0,
            done: !0
          };
          var e = o.next();
          return r || n === T ? e : G(n, l - 1, n === k ? void 0 : e.value[1], e);
        });
      }, a;
    }

    function Wn(e, n, t, r) {
      var o = nt(e);
      return o.__iterateUncached = function (o, i) {
        var A = this;
        if (i) return this.cacheResult().__iterate(o, i);
        var s = !0,
            l = 0;
        return e.__iterate(function (e, i, a) {
          if (!s || !(s = n.call(t, e, i, a))) return l++, o(e, r ? i : l - 1, A);
        }), l;
      }, o.__iteratorUncached = function (o, i) {
        var A = this;
        if (i) return this.cacheResult().__iterator(o, i);

        var s = e.__iterator(P, i),
            l = !0,
            a = 0;

        return new R(function () {
          var e, i, c;

          do {
            if ((e = s.next()).done) return r || o === T ? e : G(o, a++, o === k ? void 0 : e.value[1], e);
            var u = e.value;
            i = u[0], c = u[1], l && (l = n.call(t, c, i, A));
          } while (l);

          return o === P ? e : G(o, i, c, e);
        });
      }, o;
    }

    function Ln(e, n) {
      var t = s(e),
          o = [e].concat(n).map(function (e) {
        return A(e) ? t && (e = r(e)) : e = t ? Ae(e) : se(Array.isArray(e) ? e : [e]), e;
      }).filter(function (e) {
        return 0 !== e.size;
      });
      if (0 === o.length) return e;

      if (1 === o.length) {
        var i = o[0];
        if (i === e || t && s(i) || l(e) && l(i)) return i;
      }

      var a = new ee(o);
      return t ? a = a.toKeyedSeq() : l(e) || (a = a.toSetSeq()), (a = a.flatten(!0)).size = o.reduce(function (e, n) {
        if (void 0 !== e) {
          var t = n.size;
          if (void 0 !== t) return e + t;
        }
      }, 0), a;
    }

    function zn(e, n, t) {
      var r = nt(e);
      return r.__iterateUncached = function (r, o) {
        var i = 0,
            s = !1;
        return function e(l, a) {
          var c = this;

          l.__iterate(function (o, l) {
            return (!n || a < n) && A(o) ? e(o, a + 1) : !1 === r(o, t ? l : i++, c) && (s = !0), !s;
          }, o);
        }(e, 0), i;
      }, r.__iteratorUncached = function (r, o) {
        var i = e.__iterator(r, o),
            s = [],
            l = 0;

        return new R(function () {
          for (; i;) {
            var e = i.next();

            if (!1 === e.done) {
              var a = e.value;
              if (r === P && (a = a[1]), n && !(s.length < n) || !A(a)) return t ? e : G(r, l++, a, e);
              s.push(i), i = a.__iterator(r, o);
            } else i = s.pop();
          }

          return {
            value: void 0,
            done: !0
          };
        });
      }, r;
    }

    function Xn(e, n, t) {
      n || (n = rt);
      var r = s(e),
          o = 0,
          i = e.toSeq().map(function (n, r) {
        return [r, n, o++, t ? t(n, r, e) : n];
      }).toArray();
      return i.sort(function (e, t) {
        return n(e[3], t[3]) || e[2] - t[2];
      }).forEach(r ? function (e, n) {
        i[n].length = 2;
      } : function (e, n) {
        i[n] = e[1];
      }), r ? X(i) : l(e) ? H(i) : q(i);
    }

    function Hn(e, n, t) {
      if (n || (n = rt), t) {
        var r = e.toSeq().map(function (n, r) {
          return [n, t(n, r, e)];
        }).reduce(function (e, t) {
          return qn(n, e[1], t[1]) ? t : e;
        });
        return r && r[0];
      }

      return e.reduce(function (e, t) {
        return qn(n, e, t) ? t : e;
      });
    }

    function qn(e, n, t) {
      var r = e(t, n);
      return 0 === r && t !== n && (null == t || t != t) || r > 0;
    }

    function Vn(e, n, r) {
      var o = nt(e);
      return o.size = new ee(r).map(function (e) {
        return e.size;
      }).min(), o.__iterate = function (e, n) {
        for (var t, r = this.__iterator(T, n), o = 0; !(t = r.next()).done && !1 !== e(t.value, o++, this);) {
          ;
        }

        return o;
      }, o.__iteratorUncached = function (e, o) {
        var i = r.map(function (e) {
          return e = t(e), j(o ? e.reverse() : e);
        }),
            A = 0,
            s = !1;
        return new R(function () {
          var t;
          return s || (t = i.map(function (e) {
            return e.next();
          }), s = t.some(function (e) {
            return e.done;
          })), s ? {
            value: void 0,
            done: !0
          } : G(e, A++, n.apply(null, t.map(function (e) {
            return e.value;
          })));
        });
      }, o;
    }

    function Jn(e, n) {
      return oe(e) ? n : e.constructor(n);
    }

    function Zn(e) {
      if (e !== Object(e)) throw new TypeError("Expected [K, V] tuple: " + e);
    }

    function $n(e) {
      return Ue(e.size), w(e);
    }

    function et(e) {
      return s(e) ? r : l(e) ? o : i;
    }

    function nt(e) {
      return Object.create((s(e) ? X : l(e) ? H : q).prototype);
    }

    function tt() {
      return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : z.prototype.cacheResult.call(this);
    }

    function rt(e, n) {
      return e > n ? 1 : e < n ? -1 : 0;
    }

    function ot(e) {
      var n = j(e);

      if (!n) {
        if (!L(e)) throw new TypeError("Expected iterable or array-like: " + e);
        n = j(t(e));
      }

      return n;
    }

    function it(e, n) {
      var t,
          r = function r(i) {
        if (i instanceof r) return i;
        if (!(this instanceof r)) return new r(i);

        if (!t) {
          t = !0;
          var A = Object.keys(e);
          !function (e, n) {
            try {
              n.forEach(at.bind(void 0, e));
            } catch (e) {}
          }(o, A), o.size = A.length, o._name = n, o._keys = A, o._defaultValues = e;
        }

        this._map = Re(i);
      },
          o = r.prototype = Object.create(At);

      return o.constructor = r, r;
    }

    n(Mn, Re), Mn.of = function () {
      return this(arguments);
    }, Mn.prototype.toString = function () {
      return this.__toString("OrderedMap {", "}");
    }, Mn.prototype.get = function (e, n) {
      var t = this._map.get(e);

      return void 0 !== t ? this._list.get(t)[1] : n;
    }, Mn.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : Tn();
    }, Mn.prototype.set = function (e, n) {
      return Pn(this, e, n);
    }, Mn.prototype.remove = function (e) {
      return Pn(this, e, x);
    }, Mn.prototype.wasAltered = function () {
      return this._map.wasAltered() || this._list.wasAltered();
    }, Mn.prototype.__iterate = function (e, n) {
      var t = this;
      return this._list.__iterate(function (n) {
        return n && e(n[1], n[0], t);
      }, n);
    }, Mn.prototype.__iterator = function (e, n) {
      return this._list.fromEntrySeq().__iterator(e, n);
    }, Mn.prototype.__ensureOwner = function (e) {
      if (e === this.__ownerID) return this;

      var n = this._map.__ensureOwner(e),
          t = this._list.__ensureOwner(e);

      return e ? kn(n, t, e, this.__hash) : (this.__ownerID = e, this._map = n, this._list = t, this);
    }, Mn.isOrderedMap = On, Mn.prototype[C] = !0, Mn.prototype.delete = Mn.prototype.remove, n(Kn, X), Kn.prototype.get = function (e, n) {
      return this._iter.get(e, n);
    }, Kn.prototype.has = function (e) {
      return this._iter.has(e);
    }, Kn.prototype.valueSeq = function () {
      return this._iter.valueSeq();
    }, Kn.prototype.reverse = function () {
      var e = this,
          n = Fn(this, !0);
      return this._useKeys || (n.valueSeq = function () {
        return e._iter.toSeq().reverse();
      }), n;
    }, Kn.prototype.map = function (e, n) {
      var t = this,
          r = Yn(this, e, n);
      return this._useKeys || (r.valueSeq = function () {
        return t._iter.toSeq().map(e, n);
      }), r;
    }, Kn.prototype.__iterate = function (e, n) {
      var t,
          r = this;
      return this._iter.__iterate(this._useKeys ? function (n, t) {
        return e(n, t, r);
      } : (t = n ? $n(this) : 0, function (o) {
        return e(o, n ? --t : t++, r);
      }), n);
    }, Kn.prototype.__iterator = function (e, n) {
      if (this._useKeys) return this._iter.__iterator(e, n);

      var t = this._iter.__iterator(T, n),
          r = n ? $n(this) : 0;

      return new R(function () {
        var o = t.next();
        return o.done ? o : G(e, n ? --r : r++, o.value, o);
      });
    }, Kn.prototype[C] = !0, n(Qn, H), Qn.prototype.includes = function (e) {
      return this._iter.includes(e);
    }, Qn.prototype.__iterate = function (e, n) {
      var t = this,
          r = 0;
      return this._iter.__iterate(function (n) {
        return e(n, r++, t);
      }, n);
    }, Qn.prototype.__iterator = function (e, n) {
      var t = this._iter.__iterator(T, n),
          r = 0;

      return new R(function () {
        var n = t.next();
        return n.done ? n : G(e, r++, n.value, n);
      });
    }, n(Un, q), Un.prototype.has = function (e) {
      return this._iter.includes(e);
    }, Un.prototype.__iterate = function (e, n) {
      var t = this;
      return this._iter.__iterate(function (n) {
        return e(n, n, t);
      }, n);
    }, Un.prototype.__iterator = function (e, n) {
      var t = this._iter.__iterator(T, n);

      return new R(function () {
        var n = t.next();
        return n.done ? n : G(e, n.value, n.value, n);
      });
    }, n(Rn, X), Rn.prototype.entrySeq = function () {
      return this._iter.toSeq();
    }, Rn.prototype.__iterate = function (e, n) {
      var t = this;
      return this._iter.__iterate(function (n) {
        if (n) {
          Zn(n);
          var r = A(n);
          return e(r ? n.get(1) : n[1], r ? n.get(0) : n[0], t);
        }
      }, n);
    }, Rn.prototype.__iterator = function (e, n) {
      var t = this._iter.__iterator(T, n);

      return new R(function () {
        for (;;) {
          var n = t.next();
          if (n.done) return n;
          var r = n.value;

          if (r) {
            Zn(r);
            var o = A(r);
            return G(e, o ? r.get(0) : r[0], o ? r.get(1) : r[1], n);
          }
        }
      });
    }, Qn.prototype.cacheResult = Kn.prototype.cacheResult = Un.prototype.cacheResult = Rn.prototype.cacheResult = tt, n(it, Ie), it.prototype.toString = function () {
      return this.__toString(lt(this) + " {", "}");
    }, it.prototype.has = function (e) {
      return this._defaultValues.hasOwnProperty(e);
    }, it.prototype.get = function (e, n) {
      if (!this.has(e)) return n;
      var t = this._defaultValues[e];
      return this._map ? this._map.get(e, t) : t;
    }, it.prototype.clear = function () {
      if (this.__ownerID) return this._map && this._map.clear(), this;
      var e = this.constructor;
      return e._empty || (e._empty = st(this, Ze()));
    }, it.prototype.set = function (e, n) {
      if (!this.has(e)) throw new Error('Cannot set unknown key "' + e + '" on ' + lt(this));

      var t = this._map && this._map.set(e, n);

      return this.__ownerID || t === this._map ? this : st(this, t);
    }, it.prototype.remove = function (e) {
      if (!this.has(e)) return this;

      var n = this._map && this._map.remove(e);

      return this.__ownerID || n === this._map ? this : st(this, n);
    }, it.prototype.wasAltered = function () {
      return this._map.wasAltered();
    }, it.prototype.__iterator = function (e, n) {
      var t = this;
      return r(this._defaultValues).map(function (e, n) {
        return t.get(n);
      }).__iterator(e, n);
    }, it.prototype.__iterate = function (e, n) {
      var t = this;
      return r(this._defaultValues).map(function (e, n) {
        return t.get(n);
      }).__iterate(e, n);
    }, it.prototype.__ensureOwner = function (e) {
      if (e === this.__ownerID) return this;

      var n = this._map && this._map.__ensureOwner(e);

      return e ? st(this, n, e) : (this.__ownerID = e, this._map = n, this);
    };
    var At = it.prototype;

    function st(e, n, t) {
      var r = Object.create(Object.getPrototypeOf(e));
      return r._map = n, r.__ownerID = t, r;
    }

    function lt(e) {
      return e._name || e.constructor.name || "Record";
    }

    function at(e, n) {
      Object.defineProperty(e, n, {
        get: function get() {
          return this.get(n);
        },
        set: function set(e) {
          he(this.__ownerID, "Cannot set on an immutable record."), this.set(n, e);
        }
      });
    }

    function ct(e) {
      return null == e ? ht() : ut(e) && !c(e) ? e : ht().withMutations(function (n) {
        var t = i(e);
        Ue(t.size), t.forEach(function (e) {
          return n.add(e);
        });
      });
    }

    function ut(e) {
      return !(!e || !e[mt]);
    }

    At.delete = At.remove, At.deleteIn = At.removeIn = Ne.removeIn, At.merge = Ne.merge, At.mergeWith = Ne.mergeWith, At.mergeIn = Ne.mergeIn, At.mergeDeep = Ne.mergeDeep, At.mergeDeepWith = Ne.mergeDeepWith, At.mergeDeepIn = Ne.mergeDeepIn, At.setIn = Ne.setIn, At.update = Ne.update, At.updateIn = Ne.updateIn, At.withMutations = Ne.withMutations, At.asMutable = Ne.asMutable, At.asImmutable = Ne.asImmutable, n(ct, ye), ct.of = function () {
      return this(arguments);
    }, ct.fromKeys = function (e) {
      return this(r(e).keySeq());
    }, ct.prototype.toString = function () {
      return this.__toString("Set {", "}");
    }, ct.prototype.has = function (e) {
      return this._map.has(e);
    }, ct.prototype.add = function (e) {
      return dt(this, this._map.set(e, !0));
    }, ct.prototype.remove = function (e) {
      return dt(this, this._map.remove(e));
    }, ct.prototype.clear = function () {
      return dt(this, this._map.clear());
    }, ct.prototype.union = function () {
      var n = e.call(arguments, 0);
      return 0 === (n = n.filter(function (e) {
        return 0 !== e.size;
      })).length ? this : 0 !== this.size || this.__ownerID || 1 !== n.length ? this.withMutations(function (e) {
        for (var t = 0; t < n.length; t++) {
          i(n[t]).forEach(function (n) {
            return e.add(n);
          });
        }
      }) : this.constructor(n[0]);
    }, ct.prototype.intersect = function () {
      var n = e.call(arguments, 0);
      if (0 === n.length) return this;
      n = n.map(function (e) {
        return i(e);
      });
      var t = this;
      return this.withMutations(function (e) {
        t.forEach(function (t) {
          n.every(function (e) {
            return e.includes(t);
          }) || e.remove(t);
        });
      });
    }, ct.prototype.subtract = function () {
      var n = e.call(arguments, 0);
      if (0 === n.length) return this;
      n = n.map(function (e) {
        return i(e);
      });
      var t = this;
      return this.withMutations(function (e) {
        t.forEach(function (t) {
          n.some(function (e) {
            return e.includes(t);
          }) && e.remove(t);
        });
      });
    }, ct.prototype.merge = function () {
      return this.union.apply(this, arguments);
    }, ct.prototype.mergeWith = function (n) {
      var t = e.call(arguments, 1);
      return this.union.apply(this, t);
    }, ct.prototype.sort = function (e) {
      return xt(Xn(this, e));
    }, ct.prototype.sortBy = function (e, n) {
      return xt(Xn(this, n, e));
    }, ct.prototype.wasAltered = function () {
      return this._map.wasAltered();
    }, ct.prototype.__iterate = function (e, n) {
      var t = this;
      return this._map.__iterate(function (n, r) {
        return e(r, r, t);
      }, n);
    }, ct.prototype.__iterator = function (e, n) {
      return this._map.map(function (e, n) {
        return n;
      }).__iterator(e, n);
    }, ct.prototype.__ensureOwner = function (e) {
      if (e === this.__ownerID) return this;

      var n = this._map.__ensureOwner(e);

      return e ? this.__make(n, e) : (this.__ownerID = e, this._map = n, this);
    }, ct.isSet = ut;
    var pt,
        mt = "@@__IMMUTABLE_SET__@@",
        Ct = ct.prototype;

    function dt(e, n) {
      return e.__ownerID ? (e.size = n.size, e._map = n, e) : n === e._map ? e : 0 === n.size ? e.__empty() : e.__make(n);
    }

    function ft(e, n) {
      var t = Object.create(Ct);
      return t.size = e ? e.size : 0, t._map = e, t.__ownerID = n, t;
    }

    function ht() {
      return pt || (pt = ft(Ze()));
    }

    function xt(e) {
      return null == e ? Et() : gt(e) ? e : Et().withMutations(function (n) {
        var t = i(e);
        Ue(t.size), t.forEach(function (e) {
          return n.add(e);
        });
      });
    }

    function gt(e) {
      return ut(e) && c(e);
    }

    Ct[mt] = !0, Ct.delete = Ct.remove, Ct.mergeDeep = Ct.merge, Ct.mergeDeepWith = Ct.mergeWith, Ct.withMutations = Ne.withMutations, Ct.asMutable = Ne.asMutable, Ct.asImmutable = Ne.asImmutable, Ct.__empty = ht, Ct.__make = ft, n(xt, ct), xt.of = function () {
      return this(arguments);
    }, xt.fromKeys = function (e) {
      return this(r(e).keySeq());
    }, xt.prototype.toString = function () {
      return this.__toString("OrderedSet {", "}");
    }, xt.isOrderedSet = gt;
    var It,
        bt = xt.prototype;

    function yt(e, n) {
      var t = Object.create(bt);
      return t.size = e ? e.size : 0, t._map = e, t.__ownerID = n, t;
    }

    function Et() {
      return It || (It = yt(Tn()));
    }

    function vt(e) {
      return null == e ? Mt() : wt(e) ? e : Mt().unshiftAll(e);
    }

    function wt(e) {
      return !(!e || !e[_t]);
    }

    bt[C] = !0, bt.__empty = Et, bt.__make = yt, n(vt, be), vt.of = function () {
      return this(arguments);
    }, vt.prototype.toString = function () {
      return this.__toString("Stack [", "]");
    }, vt.prototype.get = function (e, n) {
      var t = this._head;

      for (e = B(this, e); t && e--;) {
        t = t.next;
      }

      return t ? t.value : n;
    }, vt.prototype.peek = function () {
      return this._head && this._head.value;
    }, vt.prototype.push = function () {
      if (0 === arguments.length) return this;

      for (var e = this.size + arguments.length, n = this._head, t = arguments.length - 1; t >= 0; t--) {
        n = {
          value: arguments[t],
          next: n
        };
      }

      return this.__ownerID ? (this.size = e, this._head = n, this.__hash = void 0, this.__altered = !0, this) : St(e, n);
    }, vt.prototype.pushAll = function (e) {
      if (0 === (e = o(e)).size) return this;
      Ue(e.size);
      var n = this.size,
          t = this._head;
      return e.reverse().forEach(function (e) {
        n++, t = {
          value: e,
          next: t
        };
      }), this.__ownerID ? (this.size = n, this._head = t, this.__hash = void 0, this.__altered = !0, this) : St(n, t);
    }, vt.prototype.pop = function () {
      return this.slice(1);
    }, vt.prototype.unshift = function () {
      return this.push.apply(this, arguments);
    }, vt.prototype.unshiftAll = function (e) {
      return this.pushAll(e);
    }, vt.prototype.shift = function () {
      return this.pop.apply(this, arguments);
    }, vt.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Mt();
    }, vt.prototype.slice = function (e, n) {
      if (D(e, n, this.size)) return this;
      var t = S(e, this.size);
      if (M(n, this.size) !== this.size) return be.prototype.slice.call(this, e, n);

      for (var r = this.size - t, o = this._head; t--;) {
        o = o.next;
      }

      return this.__ownerID ? (this.size = r, this._head = o, this.__hash = void 0, this.__altered = !0, this) : St(r, o);
    }, vt.prototype.__ensureOwner = function (e) {
      return e === this.__ownerID ? this : e ? St(this.size, this._head, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
    }, vt.prototype.__iterate = function (e, n) {
      if (n) return this.reverse().__iterate(e);

      for (var t = 0, r = this._head; r && !1 !== e(r.value, t++, this);) {
        r = r.next;
      }

      return t;
    }, vt.prototype.__iterator = function (e, n) {
      if (n) return this.reverse().__iterator(e);
      var t = 0,
          r = this._head;
      return new R(function () {
        if (r) {
          var n = r.value;
          return r = r.next, G(e, t++, n);
        }

        return {
          value: void 0,
          done: !0
        };
      });
    }, vt.isStack = wt;
    var Bt,
        _t = "@@__IMMUTABLE_STACK__@@",
        Dt = vt.prototype;

    function St(e, n, t, r) {
      var o = Object.create(Dt);
      return o.size = e, o._head = n, o.__ownerID = t, o.__hash = r, o.__altered = !1, o;
    }

    function Mt() {
      return Bt || (Bt = St(0));
    }

    function Ot(e, n) {
      var t = function t(_t2) {
        e.prototype[_t2] = n[_t2];
      };

      return Object.keys(n).forEach(t), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(n).forEach(t), e;
    }

    Dt[_t] = !0, Dt.withMutations = Ne.withMutations, Dt.asMutable = Ne.asMutable, Dt.asImmutable = Ne.asImmutable, Dt.wasAltered = Ne.wasAltered, t.Iterator = R, Ot(t, {
      toArray: function toArray() {
        Ue(this.size);
        var e = new Array(this.size || 0);
        return this.valueSeq().__iterate(function (n, t) {
          e[t] = n;
        }), e;
      },
      toIndexedSeq: function toIndexedSeq() {
        return new Qn(this);
      },
      toJS: function toJS() {
        return this.toSeq().map(function (e) {
          return e && "function" == typeof e.toJS ? e.toJS() : e;
        }).__toJS();
      },
      toJSON: function toJSON() {
        return this.toSeq().map(function (e) {
          return e && "function" == typeof e.toJSON ? e.toJSON() : e;
        }).__toJS();
      },
      toKeyedSeq: function toKeyedSeq() {
        return new Kn(this, !0);
      },
      toMap: function toMap() {
        return Re(this.toKeyedSeq());
      },
      toObject: function toObject() {
        Ue(this.size);
        var e = {};
        return this.__iterate(function (n, t) {
          e[t] = n;
        }), e;
      },
      toOrderedMap: function toOrderedMap() {
        return Mn(this.toKeyedSeq());
      },
      toOrderedSet: function toOrderedSet() {
        return xt(s(this) ? this.valueSeq() : this);
      },
      toSet: function toSet() {
        return ct(s(this) ? this.valueSeq() : this);
      },
      toSetSeq: function toSetSeq() {
        return new Un(this);
      },
      toSeq: function toSeq() {
        return l(this) ? this.toIndexedSeq() : s(this) ? this.toKeyedSeq() : this.toSetSeq();
      },
      toStack: function toStack() {
        return vt(s(this) ? this.valueSeq() : this);
      },
      toList: function toList() {
        return mn(s(this) ? this.valueSeq() : this);
      },
      toString: function toString() {
        return "[Iterable]";
      },
      __toString: function __toString(e, n) {
        return 0 === this.size ? e + n : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + n;
      },
      concat: function concat() {
        var n = e.call(arguments, 0);
        return Jn(this, Ln(this, n));
      },
      includes: function includes(e) {
        return this.some(function (n) {
          return Ce(n, e);
        });
      },
      entries: function entries() {
        return this.__iterator(P);
      },
      every: function every(e, n) {
        Ue(this.size);
        var t = !0;
        return this.__iterate(function (r, o, i) {
          if (!e.call(n, r, o, i)) return t = !1, !1;
        }), t;
      },
      filter: function filter(e, n) {
        return Jn(this, Nn(this, e, n, !0));
      },
      find: function find(e, n, t) {
        var r = this.findEntry(e, n);
        return r ? r[1] : t;
      },
      findEntry: function findEntry(e, n) {
        var t;
        return this.__iterate(function (r, o, i) {
          if (e.call(n, r, o, i)) return t = [o, r], !1;
        }), t;
      },
      findLastEntry: function findLastEntry(e, n) {
        return this.toSeq().reverse().findEntry(e, n);
      },
      forEach: function forEach(e, n) {
        return Ue(this.size), this.__iterate(n ? e.bind(n) : e);
      },
      join: function join(e) {
        Ue(this.size), e = void 0 !== e ? "" + e : ",";
        var n = "",
            t = !0;
        return this.__iterate(function (r) {
          t ? t = !1 : n += e, n += null != r ? r.toString() : "";
        }), n;
      },
      keys: function keys() {
        return this.__iterator(k);
      },
      map: function map(e, n) {
        return Jn(this, Yn(this, e, n));
      },
      reduce: function reduce(e, n, t) {
        var r, o;
        return Ue(this.size), arguments.length < 2 ? o = !0 : r = n, this.__iterate(function (n, i, A) {
          o ? (o = !1, r = n) : r = e.call(t, r, n, i, A);
        }), r;
      },
      reduceRight: function reduceRight(e, n, t) {
        var r = this.toKeyedSeq().reverse();
        return r.reduce.apply(r, arguments);
      },
      reverse: function reverse() {
        return Jn(this, Fn(this, !0));
      },
      slice: function slice(e, n) {
        return Jn(this, jn(this, e, n, !0));
      },
      some: function some(e, n) {
        return !this.every(Qt(e), n);
      },
      sort: function sort(e) {
        return Jn(this, Xn(this, e));
      },
      values: function values() {
        return this.__iterator(T);
      },
      butLast: function butLast() {
        return this.slice(0, -1);
      },
      isEmpty: function isEmpty() {
        return void 0 !== this.size ? 0 === this.size : !this.some(function () {
          return !0;
        });
      },
      count: function count(e, n) {
        return w(e ? this.toSeq().filter(e, n) : this);
      },
      countBy: function countBy(e, n) {
        return function (e, n, t) {
          var r = Re().asMutable();
          return e.__iterate(function (o, i) {
            r.update(n.call(t, o, i, e), 0, function (e) {
              return e + 1;
            });
          }), r.asImmutable();
        }(this, e, n);
      },
      equals: function equals(e) {
        return de(this, e);
      },
      entrySeq: function entrySeq() {
        var e = this;
        if (e._cache) return new ee(e._cache);
        var n = e.toSeq().map(Kt).toIndexedSeq();
        return n.fromEntrySeq = function () {
          return e.toSeq();
        }, n;
      },
      filterNot: function filterNot(e, n) {
        return this.filter(Qt(e), n);
      },
      findLast: function findLast(e, n, t) {
        return this.toKeyedSeq().reverse().find(e, n, t);
      },
      first: function first() {
        return this.find(_);
      },
      flatMap: function flatMap(e, n) {
        return Jn(this, function (e, n, t) {
          var r = et(e);
          return e.toSeq().map(function (o, i) {
            return r(n.call(t, o, i, e));
          }).flatten(!0);
        }(this, e, n));
      },
      flatten: function flatten(e) {
        return Jn(this, zn(this, e, !0));
      },
      fromEntrySeq: function fromEntrySeq() {
        return new Rn(this);
      },
      get: function get(e, n) {
        return this.find(function (n, t) {
          return Ce(t, e);
        }, void 0, n);
      },
      getIn: function getIn(e, n) {
        for (var t, r = this, o = ot(e); !(t = o.next()).done;) {
          var i = t.value;
          if ((r = r && r.get ? r.get(i, x) : x) === x) return n;
        }

        return r;
      },
      groupBy: function groupBy(e, n) {
        return function (e, n, t) {
          var r = s(e),
              o = (c(e) ? Mn() : Re()).asMutable();

          e.__iterate(function (i, A) {
            o.update(n.call(t, i, A, e), function (e) {
              return (e = e || []).push(r ? [A, i] : i), e;
            });
          });

          var i = et(e);
          return o.map(function (n) {
            return Jn(e, i(n));
          });
        }(this, e, n);
      },
      has: function has(e) {
        return this.get(e, x) !== x;
      },
      hasIn: function hasIn(e) {
        return this.getIn(e, x) !== x;
      },
      isSubset: function isSubset(e) {
        return e = "function" == typeof e.includes ? e : t(e), this.every(function (n) {
          return e.includes(n);
        });
      },
      isSuperset: function isSuperset(e) {
        return (e = "function" == typeof e.isSubset ? e : t(e)).isSubset(this);
      },
      keySeq: function keySeq() {
        return this.toSeq().map(Pt).toIndexedSeq();
      },
      last: function last() {
        return this.toSeq().reverse().first();
      },
      max: function max(e) {
        return Hn(this, e);
      },
      maxBy: function maxBy(e, n) {
        return Hn(this, n, e);
      },
      min: function min(e) {
        return Hn(this, e ? Ut(e) : Yt);
      },
      minBy: function minBy(e, n) {
        return Hn(this, n ? Ut(n) : Yt, e);
      },
      rest: function rest() {
        return this.slice(1);
      },
      skip: function skip(e) {
        return this.slice(Math.max(0, e));
      },
      skipLast: function skipLast(e) {
        return Jn(this, this.toSeq().reverse().skip(e).reverse());
      },
      skipWhile: function skipWhile(e, n) {
        return Jn(this, Wn(this, e, n, !0));
      },
      skipUntil: function skipUntil(e, n) {
        return this.skipWhile(Qt(e), n);
      },
      sortBy: function sortBy(e, n) {
        return Jn(this, Xn(this, n, e));
      },
      take: function take(e) {
        return this.slice(0, Math.max(0, e));
      },
      takeLast: function takeLast(e) {
        return Jn(this, this.toSeq().reverse().take(e).reverse());
      },
      takeWhile: function takeWhile(e, n) {
        return Jn(this, function (e, n, t) {
          var r = nt(e);
          return r.__iterateUncached = function (r, o) {
            var i = this;
            if (o) return this.cacheResult().__iterate(r, o);
            var A = 0;
            return e.__iterate(function (e, o, s) {
              return n.call(t, e, o, s) && ++A && r(e, o, i);
            }), A;
          }, r.__iteratorUncached = function (r, o) {
            var i = this;
            if (o) return this.cacheResult().__iterator(r, o);

            var A = e.__iterator(P, o),
                s = !0;

            return new R(function () {
              if (!s) return {
                value: void 0,
                done: !0
              };
              var e = A.next();
              if (e.done) return e;
              var o = e.value,
                  l = o[0],
                  a = o[1];
              return n.call(t, a, l, i) ? r === P ? e : G(r, l, a, e) : (s = !1, {
                value: void 0,
                done: !0
              });
            });
          }, r;
        }(this, e, n));
      },
      takeUntil: function takeUntil(e, n) {
        return this.takeWhile(Qt(e), n);
      },
      valueSeq: function valueSeq() {
        return this.toIndexedSeq();
      },
      hashCode: function hashCode() {
        return this.__hash || (this.__hash = function (e) {
          if (e.size === 1 / 0) return 0;
          var n = c(e),
              t = s(e),
              r = n ? 1 : 0;
          return function (e, n) {
            return n = Ee(n, 3432918353), n = Ee(n << 15 | n >>> -15, 461845907), n = Ee(n << 13 | n >>> -13, 5), n = Ee((n = (n + 3864292196 | 0) ^ e) ^ n >>> 16, 2246822507), n = ve((n = Ee(n ^ n >>> 13, 3266489909)) ^ n >>> 16);
          }(e.__iterate(t ? n ? function (e, n) {
            r = 31 * r + Ft(we(e), we(n)) | 0;
          } : function (e, n) {
            r = r + Ft(we(e), we(n)) | 0;
          } : n ? function (e) {
            r = 31 * r + we(e) | 0;
          } : function (e) {
            r = r + we(e) | 0;
          }), r);
        }(this));
      }
    });
    var kt = t.prototype;
    kt[u] = !0, kt[U] = kt.values, kt.__toJS = kt.toArray, kt.__toStringMapper = Rt, kt.inspect = kt.toSource = function () {
      return this.toString();
    }, kt.chain = kt.flatMap, kt.contains = kt.includes, function () {
      try {
        Object.defineProperty(kt, "length", {
          get: function get() {
            if (!t.noLengthWarning) {
              var e;

              try {
                throw new Error();
              } catch (n) {
                e = n.stack;
              }

              if (-1 === e.indexOf("_wrapObject")) return console && console.warn && console.warn("iterable.length has been deprecated, use iterable.size or iterable.count(). This warning will become a silent error in a future version. " + e), this.size;
            }
          }
        });
      } catch (e) {}
    }(), Ot(r, {
      flip: function flip() {
        return Jn(this, Gn(this));
      },
      findKey: function findKey(e, n) {
        var t = this.findEntry(e, n);
        return t && t[0];
      },
      findLastKey: function findLastKey(e, n) {
        return this.toSeq().reverse().findKey(e, n);
      },
      keyOf: function keyOf(e) {
        return this.findKey(function (n) {
          return Ce(n, e);
        });
      },
      lastKeyOf: function lastKeyOf(e) {
        return this.findLastKey(function (n) {
          return Ce(n, e);
        });
      },
      mapEntries: function mapEntries(e, n) {
        var t = this,
            r = 0;
        return Jn(this, this.toSeq().map(function (o, i) {
          return e.call(n, [i, o], r++, t);
        }).fromEntrySeq());
      },
      mapKeys: function mapKeys(e, n) {
        var t = this;
        return Jn(this, this.toSeq().flip().map(function (r, o) {
          return e.call(n, r, o, t);
        }).flip());
      }
    });
    var Tt = r.prototype;

    function Pt(e, n) {
      return n;
    }

    function Kt(e, n) {
      return [n, e];
    }

    function Qt(e) {
      return function () {
        return !e.apply(this, arguments);
      };
    }

    function Ut(e) {
      return function () {
        return -e.apply(this, arguments);
      };
    }

    function Rt(e) {
      return "string" == typeof e ? JSON.stringify(e) : e;
    }

    function Gt() {
      return v(arguments);
    }

    function Yt(e, n) {
      return e < n ? 1 : e > n ? -1 : 0;
    }

    function Ft(e, n) {
      return e ^ n + 2654435769 + (e << 6) + (e >> 2) | 0;
    }

    return Tt[p] = !0, Tt[U] = kt.entries, Tt.__toJS = kt.toObject, Tt.__toStringMapper = function (e, n) {
      return JSON.stringify(n) + ": " + Rt(e);
    }, Ot(o, {
      toKeyedSeq: function toKeyedSeq() {
        return new Kn(this, !1);
      },
      filter: function filter(e, n) {
        return Jn(this, Nn(this, e, n, !1));
      },
      findIndex: function findIndex(e, n) {
        var t = this.findEntry(e, n);
        return t ? t[0] : -1;
      },
      indexOf: function indexOf(e) {
        var n = this.toKeyedSeq().keyOf(e);
        return void 0 === n ? -1 : n;
      },
      lastIndexOf: function lastIndexOf(e) {
        var n = this.toKeyedSeq().reverse().keyOf(e);
        return void 0 === n ? -1 : n;
      },
      reverse: function reverse() {
        return Jn(this, Fn(this, !1));
      },
      slice: function slice(e, n) {
        return Jn(this, jn(this, e, n, !1));
      },
      splice: function splice(e, n) {
        var t = arguments.length;
        if (n = Math.max(0 | n, 0), 0 === t || 2 === t && !n) return this;
        e = S(e, e < 0 ? this.count() : this.size);
        var r = this.slice(0, e);
        return Jn(this, 1 === t ? r : r.concat(v(arguments, 2), this.slice(e + n)));
      },
      findLastIndex: function findLastIndex(e, n) {
        var t = this.toKeyedSeq().findLastKey(e, n);
        return void 0 === t ? -1 : t;
      },
      first: function first() {
        return this.get(0);
      },
      flatten: function flatten(e) {
        return Jn(this, zn(this, e, !1));
      },
      get: function get(e, n) {
        return (e = B(this, e)) < 0 || this.size === 1 / 0 || void 0 !== this.size && e > this.size ? n : this.find(function (n, t) {
          return t === e;
        }, void 0, n);
      },
      has: function has(e) {
        return (e = B(this, e)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || e < this.size : -1 !== this.indexOf(e));
      },
      interpose: function interpose(e) {
        return Jn(this, function (e, n) {
          var t = nt(e);
          return t.size = e.size && 2 * e.size - 1, t.__iterateUncached = function (t, r) {
            var o = this,
                i = 0;
            return e.__iterate(function (e, r) {
              return (!i || !1 !== t(n, i++, o)) && !1 !== t(e, i++, o);
            }, r), i;
          }, t.__iteratorUncached = function (t, r) {
            var o,
                i = e.__iterator(T, r),
                A = 0;

            return new R(function () {
              return (!o || A % 2) && (o = i.next()).done ? o : A % 2 ? G(t, A++, n) : G(t, A++, o.value, o);
            });
          }, t;
        }(this, e));
      },
      interleave: function interleave() {
        var e = [this].concat(v(arguments)),
            n = Vn(this.toSeq(), H.of, e),
            t = n.flatten(!0);
        return n.size && (t.size = n.size * e.length), Jn(this, t);
      },
      last: function last() {
        return this.get(-1);
      },
      skipWhile: function skipWhile(e, n) {
        return Jn(this, Wn(this, e, n, !1));
      },
      zip: function zip() {
        var e = [this].concat(v(arguments));
        return Jn(this, Vn(this, Gt, e));
      },
      zipWith: function zipWith(e) {
        var n = v(arguments);
        return n[0] = this, Jn(this, Vn(this, e, n));
      }
    }), o.prototype[m] = !0, o.prototype[C] = !0, Ot(i, {
      get: function get(e, n) {
        return this.has(e) ? e : n;
      },
      includes: function includes(e) {
        return this.has(e);
      },
      keySeq: function keySeq() {
        return this.valueSeq();
      }
    }), i.prototype.has = kt.includes, Ot(X, r.prototype), Ot(H, o.prototype), Ot(q, i.prototype), Ot(Ie, r.prototype), Ot(be, o.prototype), Ot(ye, i.prototype), {
      Iterable: t,
      Seq: z,
      Collection: ge,
      Map: Re,
      OrderedMap: Mn,
      List: mn,
      Stack: vt,
      Set: ct,
      OrderedSet: xt,
      Record: it,
      Range: xe,
      Repeat: fe,
      is: Ce,
      fromJS: ue
    };
  }();
}, function (e, n, t) {
  "use strict";

  var r = function r(e) {};

  e.exports = function (e, n, t, o, i, A, s, l) {
    if (r(n), !e) {
      var a;
      if (void 0 === n) a = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var c = [t, o, i, A, s, l],
            u = 0;
        (a = new Error(n.replace(/%s/g, function () {
          return c[u++];
        }))).name = "Invariant Violation";
      }
      throw a.framesToPop = 1, a;
    }
  };
}, function (e, n, t) {
  "use strict";

  t.d(n, "a", function () {
    return h;
  });
  var r = t(26),
      o = t(1),
      i = t.n(o),
      A = t(0),
      s = t.n(A);

  function l(e) {
    return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function a(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  function c(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = null != arguments[n] ? arguments[n] : {},
          r = Object.keys(t);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      }))), r.forEach(function (n) {
        a(e, n, t[n]);
      });
    }

    return e;
  }

  function u(e, n) {
    if (null == e) return {};

    var t,
        r,
        o = function (e, n) {
      if (null == e) return {};
      var t,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        t = i[r], n.indexOf(t) >= 0 || (o[t] = e[t]);
      }

      return o;
    }(e, n);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        t = i[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
      }
    }

    return o;
  }

  function p(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var n = 0, t = new Array(e.length); n < e.length; n++) {
          t[n] = e[n];
        }

        return t;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function m(e) {
    return n = e, (n -= 0) == n ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, n) {
      return n ? n.toUpperCase() : "";
    })).substr(0, 1).toLowerCase() + e.substr(1);
    var n;
  }

  var C = !1;

  try {
    C = !0;
  } catch (e) {}

  function d(e) {
    return null === e ? null : "object" === l(e) && e.prefix && e.iconName ? e : Array.isArray(e) && 2 === e.length ? {
      prefix: e[0],
      iconName: e[1]
    } : "string" == typeof e ? {
      prefix: "fas",
      iconName: e
    } : void 0;
  }

  function f(e, n) {
    return Array.isArray(n) && n.length > 0 || !Array.isArray(n) && n ? a({}, e, n) : {};
  }

  function h(e) {
    var n = e.icon,
        t = e.mask,
        o = e.symbol,
        i = e.className,
        A = e.title,
        s = d(n),
        l = f("classes", [].concat(p(function (e) {
      var n,
          t = e.spin,
          r = e.pulse,
          o = e.fixedWidth,
          i = e.inverse,
          A = e.border,
          s = e.listItem,
          l = e.flip,
          c = e.size,
          u = e.rotation,
          p = e.pull,
          m = (a(n = {
        "fa-spin": t,
        "fa-pulse": r,
        "fa-fw": o,
        "fa-inverse": i,
        "fa-border": A,
        "fa-li": s,
        "fa-flip-horizontal": "horizontal" === l || "both" === l,
        "fa-flip-vertical": "vertical" === l || "both" === l
      }, "fa-".concat(c), void 0 !== c), a(n, "fa-rotate-".concat(u), void 0 !== u), a(n, "fa-pull-".concat(p), void 0 !== p), a(n, "fa-swap-opacity", e.swapOpacity), n);
      return Object.keys(m).map(function (e) {
        return m[e] ? e : null;
      }).filter(function (e) {
        return e;
      });
    }(e)), p(i.split(" ")))),
        u = f("transform", "string" == typeof e.transform ? r.b.transform(e.transform) : e.transform),
        m = f("mask", d(t)),
        g = Object(r.a)(s, c({}, l, u, m, {
      symbol: o,
      title: A
    }));
    if (!g) return function () {
      var e;
      !C && console && "function" == typeof console.error && (e = console).error.apply(e, arguments);
    }("Could not find icon", s), null;
    var I = g.abstract,
        b = {};
    return Object.keys(e).forEach(function (n) {
      h.defaultProps.hasOwnProperty(n) || (b[n] = e[n]);
    }), x(I[0], b);
  }

  h.displayName = "FontAwesomeIcon", h.propTypes = {
    border: i.a.bool,
    className: i.a.string,
    mask: i.a.oneOfType([i.a.object, i.a.array, i.a.string]),
    fixedWidth: i.a.bool,
    inverse: i.a.bool,
    flip: i.a.oneOf(["horizontal", "vertical", "both"]),
    icon: i.a.oneOfType([i.a.object, i.a.array, i.a.string]),
    listItem: i.a.bool,
    pull: i.a.oneOf(["right", "left"]),
    pulse: i.a.bool,
    rotation: i.a.oneOf([90, 180, 270]),
    size: i.a.oneOf(["lg", "xs", "sm", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
    spin: i.a.bool,
    symbol: i.a.oneOfType([i.a.bool, i.a.string]),
    title: i.a.string,
    transform: i.a.oneOfType([i.a.string, i.a.object]),
    swapOpacity: i.a.bool
  }, h.defaultProps = {
    border: !1,
    className: "",
    mask: null,
    fixedWidth: !1,
    inverse: !1,
    flip: null,
    icon: null,
    listItem: !1,
    pull: null,
    pulse: !1,
    rotation: null,
    size: null,
    spin: !1,
    symbol: !1,
    title: "",
    transform: null,
    swapOpacity: !1
  };

  var x = function e(n, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    if ("string" == typeof t) return t;
    var o = (t.children || []).map(function (t) {
      return e(n, t);
    }),
        i = Object.keys(t.attributes || {}).reduce(function (e, n) {
      var r = t.attributes[n];

      switch (n) {
        case "class":
          e.attrs.className = r, delete t.attributes.class;
          break;

        case "style":
          e.attrs.style = r.split(";").map(function (e) {
            return e.trim();
          }).filter(function (e) {
            return e;
          }).reduce(function (e, n) {
            var t,
                r = n.indexOf(":"),
                o = m(n.slice(0, r)),
                i = n.slice(r + 1).trim();
            return o.startsWith("webkit") ? e[(t = o, t.charAt(0).toUpperCase() + t.slice(1))] = i : e[o] = i, e;
          }, {});
          break;

        default:
          0 === n.indexOf("aria-") || 0 === n.indexOf("data-") ? e.attrs[n.toLowerCase()] = r : e.attrs[m(n)] = r;
      }

      return e;
    }, {
      attrs: {}
    }),
        A = r.style,
        s = void 0 === A ? {} : A,
        l = u(r, ["style"]);
    return i.attrs.style = c({}, i.attrs.style, s), n.apply(void 0, [t.tag, c({}, i.attrs, l)].concat(p(o)));
  }.bind(null, s.a.createElement);
}, function (e, n, t) {
  "use strict";

  t.d(n, "a", function () {
    return r;
  }), t.d(n, "b", function () {
    return o;
  }), t.d(n, "c", function () {
    return i;
  }), t.d(n, "d", function () {
    return A;
  }), t.d(n, "e", function () {
    return s;
  }), t.d(n, "f", function () {
    return l;
  }), t.d(n, "g", function () {
    return a;
  }), t.d(n, "h", function () {
    return c;
  }), t.d(n, "i", function () {
    return u;
  }), t.d(n, "j", function () {
    return p;
  }), t.d(n, "k", function () {
    return m;
  }), t.d(n, "l", function () {
    return C;
  }), t.d(n, "m", function () {
    return d;
  }), t.d(n, "n", function () {
    return f;
  }), t.d(n, "o", function () {
    return h;
  }), t.d(n, "p", function () {
    return x;
  }), t.d(n, "q", function () {
    return g;
  });
  var r = {
    prefix: "fas",
    iconName: "backward",
    icon: [512, 512, [], "f04a", "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"]
  },
      o = {
    prefix: "fas",
    iconName: "cog",
    icon: [512, 512, [], "f013", "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      i = {
    prefix: "fas",
    iconName: "forward",
    icon: [512, 512, [], "f04e", "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"]
  },
      A = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [256, 512, [], "f246", "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"]
  },
      s = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [576, 512, [], "f11c", "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"]
  },
      l = {
    prefix: "fas",
    iconName: "mouse-pointer",
    icon: [320, 512, [], "f245", "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"]
  },
      a = {
    prefix: "fas",
    iconName: "pause",
    icon: [448, 512, [], "f04c", "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"]
  },
      c = {
    prefix: "fas",
    iconName: "play",
    icon: [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"]
  },
      u = {
    prefix: "fas",
    iconName: "question-circle",
    icon: [512, 512, [], "f059", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"]
  },
      p = {
    prefix: "fas",
    iconName: "save",
    icon: [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"]
  },
      m = {
    prefix: "fas",
    iconName: "share",
    icon: [512, 512, [], "f064", "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"]
  },
      C = {
    prefix: "fas",
    iconName: "tv",
    icon: [640, 512, [], "f26c", "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"]
  },
      d = {
    prefix: "fas",
    iconName: "undo",
    icon: [512, 512, [], "f0e2", "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"]
  },
      f = {
    prefix: "fas",
    iconName: "user-edit",
    icon: [640, 512, [], "f4ff", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"]
  },
      h = {
    prefix: "fas",
    iconName: "volume-mute",
    icon: [512, 512, [], "f6a9", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"]
  },
      x = {
    prefix: "fas",
    iconName: "volume-up",
    icon: [576, 512, [], "f028", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"]
  },
      g = {
    prefix: "fas",
    iconName: "window-close",
    icon: [512, 512, [], "f410", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"]
  };
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  };

  var o = t(88),
      i = t(61),
      A = t(132),
      s = t(3),
      l = t(34),
      a = s.OrderedSet,
      c = s.Record,
      u = s.Stack,
      p = c({
    allowUndo: !0,
    currentContent: null,
    decorator: null,
    directionMap: null,
    forceSelection: !1,
    inCompositionMode: !1,
    inlineStyleOverride: null,
    lastChangeType: null,
    nativelyRenderedContent: null,
    redoStack: u(),
    selection: null,
    treeMap: null,
    undoStack: u()
  }),
      m = function () {
    function e(n) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this._immutable = n;
    }

    return e.createEmpty = function (n) {
      return e.createWithContent(i.createFromText(""), n);
    }, e.createWithContent = function (n, t) {
      var r = n.getBlockMap().first().getKey();
      return e.create({
        currentContent: n,
        undoStack: u(),
        redoStack: u(),
        decorator: t || null,
        selection: l.createEmpty(r)
      });
    }, e.create = function (n) {
      var t = n.currentContent,
          o = n.decorator,
          i = r({}, n, {
        treeMap: d(t, o),
        directionMap: A.getDirectionMap(t)
      });
      return new e(new p(i));
    }, e.set = function (n, t) {
      return new e(n.getImmutable().withMutations(function (e) {
        var r = e.get("decorator"),
            i = r;
        null === t.decorator ? i = null : t.decorator && (i = t.decorator);
        var A = t.currentContent || n.getCurrentContent();

        if (i !== r) {
          var s,
              l = e.get("treeMap");
          return s = i && r ? function (e, n, t, r, i) {
            return t.merge(n.toSeq().filter(function (n) {
              return r.getDecorations(n, e) !== i.getDecorations(n, e);
            }).map(function (n) {
              return o.generate(e, n, r);
            }));
          }(A, A.getBlockMap(), l, i, r) : d(A, i), void e.merge({
            decorator: i,
            treeMap: s,
            nativelyRenderedContent: null
          });
        }

        A !== n.getCurrentContent() && e.set("treeMap", function (e, n, t, r) {
          var i = e.getCurrentContent().set("entityMap", t),
              A = i.getBlockMap();
          return e.getImmutable().get("treeMap").merge(n.toSeq().filter(function (e, n) {
            return e !== A.get(n);
          }).map(function (e) {
            return o.generate(i, e, r);
          }));
        }(n, A.getBlockMap(), A.getEntityMap(), i)), e.merge(t);
      }));
    }, e.prototype.toJS = function () {
      return this.getImmutable().toJS();
    }, e.prototype.getAllowUndo = function () {
      return this.getImmutable().get("allowUndo");
    }, e.prototype.getCurrentContent = function () {
      return this.getImmutable().get("currentContent");
    }, e.prototype.getUndoStack = function () {
      return this.getImmutable().get("undoStack");
    }, e.prototype.getRedoStack = function () {
      return this.getImmutable().get("redoStack");
    }, e.prototype.getSelection = function () {
      return this.getImmutable().get("selection");
    }, e.prototype.getDecorator = function () {
      return this.getImmutable().get("decorator");
    }, e.prototype.isInCompositionMode = function () {
      return this.getImmutable().get("inCompositionMode");
    }, e.prototype.mustForceSelection = function () {
      return this.getImmutable().get("forceSelection");
    }, e.prototype.getNativelyRenderedContent = function () {
      return this.getImmutable().get("nativelyRenderedContent");
    }, e.prototype.getLastChangeType = function () {
      return this.getImmutable().get("lastChangeType");
    }, e.prototype.getInlineStyleOverride = function () {
      return this.getImmutable().get("inlineStyleOverride");
    }, e.setInlineStyleOverride = function (n, t) {
      return e.set(n, {
        inlineStyleOverride: t
      });
    }, e.prototype.getCurrentInlineStyle = function () {
      var e = this.getInlineStyleOverride();
      if (null != e) return e;
      var n = this.getCurrentContent(),
          t = this.getSelection();
      return t.isCollapsed() ? function (e, n) {
        var t = n.getStartKey(),
            r = n.getStartOffset(),
            o = e.getBlockForKey(t);
        if (r > 0) return o.getInlineStyleAt(r - 1);
        if (o.getLength()) return o.getInlineStyleAt(0);
        return f(e, t);
      }(n, t) : function (e, n) {
        var t = n.getStartKey(),
            r = n.getStartOffset(),
            o = e.getBlockForKey(t);
        if (r < o.getLength()) return o.getInlineStyleAt(r);
        if (r > 0) return o.getInlineStyleAt(r - 1);
        return f(e, t);
      }(n, t);
    }, e.prototype.getBlockTree = function (e) {
      return this.getImmutable().getIn(["treeMap", e]);
    }, e.prototype.isSelectionAtStartOfContent = function () {
      var e = this.getCurrentContent().getBlockMap().first().getKey();
      return this.getSelection().hasEdgeWithin(e, 0, 0);
    }, e.prototype.isSelectionAtEndOfContent = function () {
      var e = this.getCurrentContent().getBlockMap().last(),
          n = e.getLength();
      return this.getSelection().hasEdgeWithin(e.getKey(), n, n);
    }, e.prototype.getDirectionMap = function () {
      return this.getImmutable().get("directionMap");
    }, e.acceptSelection = function (e, n) {
      return C(e, n, !1);
    }, e.forceSelection = function (e, n) {
      return n.getHasFocus() || (n = n.set("hasFocus", !0)), C(e, n, !0);
    }, e.moveSelectionToEnd = function (n) {
      var t = n.getCurrentContent().getLastBlock(),
          r = t.getKey(),
          o = t.getLength();
      return e.acceptSelection(n, new l({
        anchorKey: r,
        anchorOffset: o,
        focusKey: r,
        focusOffset: o,
        isBackward: !1
      }));
    }, e.moveFocusToEnd = function (n) {
      var t = e.moveSelectionToEnd(n);
      return e.forceSelection(t, t.getSelection());
    }, e.push = function (n, t, r) {
      if (n.getCurrentContent() === t) return n;
      var o = "insert-characters" !== r,
          i = A.getDirectionMap(t, n.getDirectionMap());
      if (!n.getAllowUndo()) return e.set(n, {
        currentContent: t,
        directionMap: i,
        lastChangeType: r,
        selection: t.getSelectionAfter(),
        forceSelection: o,
        inlineStyleOverride: null
      });
      var s = n.getSelection(),
          l = n.getCurrentContent(),
          a = n.getUndoStack(),
          c = t;
      s !== l.getSelectionAfter() || function (e, n) {
        var t = e.getLastChangeType();
        return n !== t || "insert-characters" !== n && "backspace-character" !== n && "delete-character" !== n;
      }(n, r) ? (a = a.push(l), c = c.set("selectionBefore", s)) : "insert-characters" !== r && "backspace-character" !== r && "delete-character" !== r || (c = c.set("selectionBefore", l.getSelectionBefore()));
      var p = n.getInlineStyleOverride();
      -1 === ["adjust-depth", "change-block-type", "split-block"].indexOf(r) && (p = null);
      var m = {
        currentContent: c,
        directionMap: i,
        undoStack: a,
        redoStack: u(),
        lastChangeType: r,
        selection: t.getSelectionAfter(),
        forceSelection: o,
        inlineStyleOverride: p
      };
      return e.set(n, m);
    }, e.undo = function (n) {
      if (!n.getAllowUndo()) return n;
      var t = n.getUndoStack(),
          r = t.peek();
      if (!r) return n;
      var o = n.getCurrentContent(),
          i = A.getDirectionMap(r, n.getDirectionMap());
      return e.set(n, {
        currentContent: r,
        directionMap: i,
        undoStack: t.shift(),
        redoStack: n.getRedoStack().push(o),
        forceSelection: !0,
        inlineStyleOverride: null,
        lastChangeType: "undo",
        nativelyRenderedContent: null,
        selection: o.getSelectionBefore()
      });
    }, e.redo = function (n) {
      if (!n.getAllowUndo()) return n;
      var t = n.getRedoStack(),
          r = t.peek();
      if (!r) return n;
      var o = n.getCurrentContent(),
          i = A.getDirectionMap(r, n.getDirectionMap());
      return e.set(n, {
        currentContent: r,
        directionMap: i,
        undoStack: n.getUndoStack().push(o),
        redoStack: t.shift(),
        forceSelection: !0,
        inlineStyleOverride: null,
        lastChangeType: "redo",
        nativelyRenderedContent: null,
        selection: r.getSelectionAfter()
      });
    }, e.prototype.getImmutable = function () {
      return this._immutable;
    }, e;
  }();

  function C(e, n, t) {
    return m.set(e, {
      selection: n,
      forceSelection: t,
      nativelyRenderedContent: null,
      inlineStyleOverride: null
    });
  }

  function d(e, n) {
    return e.getBlockMap().map(function (t) {
      return o.generate(e, t, n);
    }).toOrderedMap();
  }

  function f(e, n) {
    var t = e.getBlockMap().reverse().skipUntil(function (e, t) {
      return t === n;
    }).skip(1).skipUntil(function (e, n) {
      return e.getLength();
    }).first();
    return t ? t.getInlineStyleAt(t.getLength() - 1) : a();
  }

  e.exports = m;
}, function (e, n, t) {
  "use strict";

  t.r(n);

  var r = function r(e, n) {
    function t(e) {
      return 10 > e ? "0".concat(parseInt(e)) : parseInt(e);
    }

    var r = 25;
    void 0 !== n && (r = n);

    var o = function (e, n) {
      return +(1 / n * Math.floor(+(n * e).toPrecision(12))).toFixed(2);
    }(e, r),
        i = Math.floor(o),
        A = ((o - i) * r).toFixed(2);

    return "".concat(t(i / 60 / 60 % 60), ":").concat(t(i / 60 % 60), ":").concat(t(i % 60), ":").concat(t(A));
  },
      o = function o(e, n) {
    var t = 25;
    return void 0 !== n && (t = n), +(+function (e, n) {
      var t = e.split(":"),
          r = parseInt(t[3]);
      return r += parseInt(t[2]) * n, r += parseInt(t[1]) * (60 * n), r += parseInt(t[0]) * (60 * n * 60);
    }(e, t) / t).toFixed(2);
  },
      i = function i(e) {
    return 1 === e.length;
  },
      A = function A(e) {
    if ("string" != typeof e) return e;

    switch (e.split(":").length) {
      case 4:
        return e;

      case 2:
        return i(e.split(":")[0]) ? "00:0".concat(e, ":00") : "00:".concat(e, ":00");

      case 3:
        return "".concat(e, ":00");

      default:
        return function (e) {
          return e.includes(".");
        }(e) ? i(e.split(".")[0]) ? "00:0".concat(e.split(".")[0], ":").concat(e.split(".")[1], ":00") : "00:".concat(e.replace(".", ":"), ":00") : i(e) ? "00:00:0".concat(e, ":00") : "00:00:".concat(e, ":00");
    }
  };

  t.d(n, "timecodeToSeconds", function () {
    return s;
  }), t.d(n, "shortTimecode", function () {
    return l;
  }), t.d(n, "secondsToTimecode", function () {
    return r;
  });

  var s = function s(e) {
    if ("string" == typeof e) {
      var n = A(e);
      return o(n);
    }

    return parseFloat(e);
  },
      l = function l(e) {
    return r(e).slice(0, -3);
  };
}, function (e, n, t) {
  var r = t(78);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  "use strict";

  n.a = function (e, n) {
    var t = 0;
    return e.map(function (e) {
      var r = {
        start: e.start,
        end: e.end,
        confidence: e.confidence,
        text: e[n],
        offset: t,
        length: e[n].length,
        key: Math.random().toString(36).substring(6)
      };
      return t = t + e[n].length + 1, r;
    });
  };
}, function (e, n, t) {
  var r = t(226);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n) {
  var t;

  t = function () {
    return this;
  }();

  try {
    t = t || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (t = window);
  }

  e.exports = t;
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    var n = [];
    return n.toString = function () {
      return this.map(function (n) {
        var t = function (e, n) {
          var t = e[1] || "",
              r = e[3];
          if (!r) return t;

          if (n && "function" == typeof btoa) {
            var o = (A = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(A)))) + " */"),
                i = r.sources.map(function (e) {
              return "/*# sourceURL=" + r.sourceRoot + e + " */";
            });
            return [t].concat(i).concat([o]).join("\n");
          }

          var A;
          return [t].join("\n");
        }(n, e);

        return n[2] ? "@media " + n[2] + "{" + t + "}" : t;
      }).join("");
    }, n.i = function (e, t) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var r = {}, o = 0; o < this.length; o++) {
        var i = this[o][0];
        null != i && (r[i] = !0);
      }

      for (o = 0; o < e.length; o++) {
        var A = e[o];
        null != A[0] && r[A[0]] || (t && !A[2] ? A[2] = t : t && (A[2] = "(" + A[2] + ") and (" + t + ")"), n.push(A));
      }
    }, n;
  };
}, function (e, n, t) {
  var r,
      o,
      i = {},
      A = (r = function r() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = r.apply(this, arguments)), o;
  }),
      s = function s(e, n) {
    return n ? n.querySelector(e) : document.querySelector(e);
  },
      l = function (e) {
    var n = {};
    return function (e, t) {
      if ("function" == typeof e) return e();

      if (void 0 === n[e]) {
        var r = s.call(this, e, t);
        if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
          r = r.contentDocument.head;
        } catch (e) {
          r = null;
        }
        n[e] = r;
      }

      return n[e];
    };
  }(),
      a = null,
      c = 0,
      u = [],
      p = t(33);

  function m(e, n) {
    for (var t = 0; t < e.length; t++) {
      var r = e[t],
          o = i[r.id];

      if (o) {
        o.refs++;

        for (var A = 0; A < o.parts.length; A++) {
          o.parts[A](r.parts[A]);
        }

        for (; A < r.parts.length; A++) {
          o.parts.push(g(r.parts[A], n));
        }
      } else {
        var s = [];

        for (A = 0; A < r.parts.length; A++) {
          s.push(g(r.parts[A], n));
        }

        i[r.id] = {
          id: r.id,
          refs: 1,
          parts: s
        };
      }
    }
  }

  function C(e, n) {
    for (var t = [], r = {}, o = 0; o < e.length; o++) {
      var i = e[o],
          A = n.base ? i[0] + n.base : i[0],
          s = {
        css: i[1],
        media: i[2],
        sourceMap: i[3]
      };
      r[A] ? r[A].parts.push(s) : t.push(r[A] = {
        id: A,
        parts: [s]
      });
    }

    return t;
  }

  function d(e, n) {
    var t = l(e.insertInto);
    if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var r = u[u.length - 1];
    if ("top" === e.insertAt) r ? r.nextSibling ? t.insertBefore(n, r.nextSibling) : t.appendChild(n) : t.insertBefore(n, t.firstChild), u.push(n);else if ("bottom" === e.insertAt) t.appendChild(n);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = l(e.insertAt.before, t);
      t.insertBefore(n, o);
    }
  }

  function f(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var n = u.indexOf(e);
    n >= 0 && u.splice(n, 1);
  }

  function h(e) {
    var n = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var r = function () {
        0;
        return t.nc;
      }();

      r && (e.attrs.nonce = r);
    }

    return x(n, e.attrs), d(e, n), n;
  }

  function x(e, n) {
    Object.keys(n).forEach(function (t) {
      e.setAttribute(t, n[t]);
    });
  }

  function g(e, n) {
    var t, r, o, i;

    if (n.transform && e.css) {
      if (!(i = "function" == typeof n.transform ? n.transform(e.css) : n.transform.default(e.css))) return function () {};
      e.css = i;
    }

    if (n.singleton) {
      var A = c++;
      t = a || (a = h(n)), r = y.bind(null, t, A, !1), o = y.bind(null, t, A, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (e) {
      var n = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", x(n, e.attrs), d(e, n), n;
    }(n), r = v.bind(null, t, n), o = function o() {
      f(t), t.href && URL.revokeObjectURL(t.href);
    }) : (t = h(n), r = E.bind(null, t), o = function o() {
      f(t);
    });

    return r(e), function (n) {
      if (n) {
        if (n.css === e.css && n.media === e.media && n.sourceMap === e.sourceMap) return;
        r(e = n);
      } else o();
    };
  }

  e.exports = function (e, n) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (n = n || {}).attrs = "object" == typeof n.attrs ? n.attrs : {}, n.singleton || "boolean" == typeof n.singleton || (n.singleton = A()), n.insertInto || (n.insertInto = "head"), n.insertAt || (n.insertAt = "bottom");
    var t = C(e, n);
    return m(t, n), function (e) {
      for (var r = [], o = 0; o < t.length; o++) {
        var A = t[o];
        (s = i[A.id]).refs--, r.push(s);
      }

      e && m(C(e, n), n);

      for (o = 0; o < r.length; o++) {
        var s;

        if (0 === (s = r[o]).refs) {
          for (var l = 0; l < s.parts.length; l++) {
            s.parts[l]();
          }

          delete i[s.id];
        }
      }
    };
  };

  var I,
      b = (I = [], function (e, n) {
    return I[e] = n, I.filter(Boolean).join("\n");
  });

  function y(e, n, t, r) {
    var o = t ? "" : r.css;
    if (e.styleSheet) e.styleSheet.cssText = b(n, o);else {
      var i = document.createTextNode(o),
          A = e.childNodes;
      A[n] && e.removeChild(A[n]), A.length ? e.insertBefore(i, A[n]) : e.appendChild(i);
    }
  }

  function E(e, n) {
    var t = n.css,
        r = n.media;
    if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = t;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(t));
    }
  }

  function v(e, n, t) {
    var r = t.css,
        o = t.sourceMap,
        i = void 0 === n.convertToAbsoluteUrls && o;
    (n.convertToAbsoluteUrls || i) && (r = p(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
    var A = new Blob([r], {
      type: "text/css"
    }),
        s = e.href;
    e.href = URL.createObjectURL(A), s && URL.revokeObjectURL(s);
  }
}, function (e, n, t) {
  var r = t(230);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  "use strict";

  var r = t(19),
      o = t(121),
      i = t(27),
      A = t(3),
      s = t(122),
      l = t(124),
      a = t(51),
      c = t(127),
      u = t(128),
      p = t(4),
      m = t(129),
      C = t(85),
      d = t(130),
      f = t(131),
      h = A.OrderedSet,
      x = {
    replaceText: function replaceText(e, n, t, o, i) {
      var A = C(e, n),
          s = d(A, n),
          l = r.create({
        style: o || h(),
        entity: i || null
      });
      return u(s, s.getSelectionAfter(), t, l);
    },
    insertText: function insertText(e, n, t, r, o) {
      return n.isCollapsed() || p(!1), x.replaceText(e, n, t, r, o);
    },
    moveText: function moveText(e, n, t) {
      var r = a(e, n),
          o = x.removeRange(e, n, "backward");
      return x.replaceWithFragment(o, t, r);
    },
    replaceWithFragment: function replaceWithFragment(e, n, t) {
      var r = C(e, n),
          o = d(r, n);
      return c(o, o.getSelectionAfter(), t);
    },
    removeRange: function removeRange(e, n, t) {
      var r,
          o,
          A = void 0,
          s = void 0;
      n.getIsBackward() && (n = n.merge({
        anchorKey: n.getFocusKey(),
        anchorOffset: n.getFocusOffset(),
        focusKey: n.getAnchorKey(),
        focusOffset: n.getAnchorOffset(),
        isBackward: !1
      })), r = n.getAnchorKey(), o = n.getFocusKey(), A = e.getBlockForKey(r), s = e.getBlockForKey(o);
      var a = n.getStartOffset(),
          c = n.getEndOffset(),
          u = A.getEntityAt(a),
          p = s.getEntityAt(c - 1);

      if (r === o && u && u === p) {
        var m = l(e.getEntityMap(), A, s, n, t);
        return d(e, m);
      }

      var f = n;
      i.draft_segmented_entities_behavior && (f = l(e.getEntityMap(), A, s, n, t));
      var h = C(e, f);
      return d(h, f);
    },
    splitBlock: function splitBlock(e, n) {
      var t = C(e, n),
          r = d(t, n);
      return f(r, r.getSelectionAfter());
    },
    applyInlineStyle: function applyInlineStyle(e, n, t) {
      return o.add(e, n, t);
    },
    removeInlineStyle: function removeInlineStyle(e, n, t) {
      return o.remove(e, n, t);
    },
    setBlockType: function setBlockType(e, n, t) {
      return m(e, n, function (e) {
        return e.merge({
          type: t,
          depth: 0
        });
      });
    },
    setBlockData: function setBlockData(e, n, t) {
      return m(e, n, function (e) {
        return e.merge({
          data: t
        });
      });
    },
    mergeBlockData: function mergeBlockData(e, n, t) {
      return m(e, n, function (e) {
        return e.merge({
          data: e.getData().merge(t)
        });
      });
    },
    applyEntity: function applyEntity(e, n, t) {
      var r = C(e, n);
      return s(r, n, t);
    }
  };
  e.exports = x;
}, function (e, n, t) {
  var r;
  "undefined" != typeof self && self, r = function r() {
    return function (e) {
      var n = {};

      function t(r) {
        if (n[r]) return n[r].exports;
        var o = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
      }

      return t.m = e, t.c = n, t.d = function (e, n, r) {
        t.o(e, n) || Object.defineProperty(e, n, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, t.n = function (e) {
        var n = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return t.d(n, "a", n), n;
      }, t.o = function (e, n) {
        return Object.prototype.hasOwnProperty.call(e, n);
      }, t.p = "", t(t.s = 130);
    }([function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\index.ts", o = "f524d3c619c6fe7baf64ebe54286badd7e1d73b1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 37
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 34
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 42
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 46
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 38
            }
          },
          9: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 51
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,qCAAgC;AAChC,kCAA6B;AAC7B,0CAAqC;AACrC,8CAAyC;AACzC,sCAAiC;AACjC,mDAA8C",
          sourcesContent: ['export * from "./xml-component";\r\nexport * from "./attributes";\r\nexport * from "./default-attributes";\r\nexport * from "./imported-xml-component";\r\nexport * from "./xmlable-object";\r\nexport * from "./initializable-xml-component";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(131)), a.s[5]++, c(t(132)), a.s[6]++, c(t(53)), a.s[7]++, c(t(133)), a.s[8]++, c(t(149)), a.s[9]++, c(t(150));
    }, function (e, n, t) {
      "use strict";

      var r = t(6),
          o = t(109),
          i = t(24),
          A = t(298),
          s = t(17);

      function l(e) {
        return e;
      }

      function a(e, n) {
        for (var t = 0; t < e.length; ++t) {
          n[t] = 255 & e.charCodeAt(t);
        }

        return n;
      }

      n.newBlob = function (e, t) {
        n.checkSupport("blob");

        try {
          return new Blob([e], {
            type: t
          });
        } catch (n) {
          try {
            var r = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return r.append(e), r.getBlob(t);
          } catch (e) {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };

      var c = {
        stringifyByChunk: function stringifyByChunk(e, n, t) {
          var r = [],
              o = 0,
              i = e.length;
          if (i <= t) return String.fromCharCode.apply(null, e);

          for (; o < i;) {
            "array" === n || "nodebuffer" === n ? r.push(String.fromCharCode.apply(null, e.slice(o, Math.min(o + t, i)))) : r.push(String.fromCharCode.apply(null, e.subarray(o, Math.min(o + t, i)))), o += t;
          }

          return r.join("");
        },
        stringifyByChar: function stringifyByChar(e) {
          for (var n = "", t = 0; t < e.length; t++) {
            n += String.fromCharCode(e[t]);
          }

          return n;
        },
        applyCanBeUsed: {
          uint8array: function () {
            try {
              return r.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
            } catch (e) {
              return !1;
            }
          }(),
          nodebuffer: function () {
            try {
              return r.nodebuffer && 1 === String.fromCharCode.apply(null, i.allocBuffer(1)).length;
            } catch (e) {
              return !1;
            }
          }()
        }
      };

      function u(e) {
        var t = 65536,
            r = n.getTypeOf(e),
            o = !0;
        if ("uint8array" === r ? o = c.applyCanBeUsed.uint8array : "nodebuffer" === r && (o = c.applyCanBeUsed.nodebuffer), o) for (; t > 1;) {
          try {
            return c.stringifyByChunk(e, r, t);
          } catch (e) {
            t = Math.floor(t / 2);
          }
        }
        return c.stringifyByChar(e);
      }

      function p(e, n) {
        for (var t = 0; t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      n.applyFromCharCode = u;
      var m = {};
      m.string = {
        string: l,
        array: function array(e) {
          return a(e, new Array(e.length));
        },
        arraybuffer: function arraybuffer(e) {
          return m.string.uint8array(e).buffer;
        },
        uint8array: function uint8array(e) {
          return a(e, new Uint8Array(e.length));
        },
        nodebuffer: function nodebuffer(e) {
          return a(e, i.allocBuffer(e.length));
        }
      }, m.array = {
        string: u,
        array: l,
        arraybuffer: function arraybuffer(e) {
          return new Uint8Array(e).buffer;
        },
        uint8array: function uint8array(e) {
          return new Uint8Array(e);
        },
        nodebuffer: function nodebuffer(e) {
          return i.newBufferFrom(e);
        }
      }, m.arraybuffer = {
        string: function string(e) {
          return u(new Uint8Array(e));
        },
        array: function array(e) {
          return p(new Uint8Array(e), new Array(e.byteLength));
        },
        arraybuffer: l,
        uint8array: function uint8array(e) {
          return new Uint8Array(e);
        },
        nodebuffer: function nodebuffer(e) {
          return i.newBufferFrom(new Uint8Array(e));
        }
      }, m.uint8array = {
        string: u,
        array: function array(e) {
          return p(e, new Array(e.length));
        },
        arraybuffer: function arraybuffer(e) {
          return e.buffer;
        },
        uint8array: l,
        nodebuffer: function nodebuffer(e) {
          return i.newBufferFrom(e);
        }
      }, m.nodebuffer = {
        string: u,
        array: function array(e) {
          return p(e, new Array(e.length));
        },
        arraybuffer: function arraybuffer(e) {
          return m.nodebuffer.uint8array(e).buffer;
        },
        uint8array: function uint8array(e) {
          return p(e, new Uint8Array(e.length));
        },
        nodebuffer: l
      }, n.transformTo = function (e, t) {
        if (t || (t = ""), !e) return t;
        n.checkSupport(e);
        var r = n.getTypeOf(t);
        return m[r][e](t);
      }, n.getTypeOf = function (e) {
        return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : r.nodebuffer && i.isBuffer(e) ? "nodebuffer" : r.uint8array && e instanceof Uint8Array ? "uint8array" : r.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, n.checkSupport = function (e) {
        if (!r[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
      }, n.MAX_VALUE_16BITS = 65535, n.MAX_VALUE_32BITS = -1, n.pretty = function (e) {
        var n,
            t,
            r = "";

        for (t = 0; t < (e || "").length; t++) {
          r += "\\x" + ((n = e.charCodeAt(t)) < 16 ? "0" : "") + n.toString(16).toUpperCase();
        }

        return r;
      }, n.delay = function (e, n, t) {
        A(function () {
          e.apply(t || null, n || []);
        });
      }, n.inherits = function (e, n) {
        var t = function t() {};

        t.prototype = n.prototype, e.prototype = new t();
      }, n.extend = function () {
        var e,
            n,
            t = {};

        for (e = 0; e < arguments.length; e++) {
          for (n in arguments[e]) {
            arguments[e].hasOwnProperty(n) && void 0 === t[n] && (t[n] = arguments[e][n]);
          }
        }

        return t;
      }, n.prepareContent = function (e, t, i, A, l) {
        return s.Promise.resolve(t).then(function (e) {
          return r.blob && (e instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new s.Promise(function (n, t) {
            var r = new FileReader();
            r.onload = function (e) {
              n(e.target.result);
            }, r.onerror = function (e) {
              t(e.target.error);
            }, r.readAsArrayBuffer(e);
          }) : e;
        }).then(function (t) {
          var c,
              u = n.getTypeOf(t);
          return u ? ("arraybuffer" === u ? t = n.transformTo("uint8array", t) : "string" === u && (l ? t = o.decode(t) : i && !0 !== A && (t = a(c = t, r.uint8array ? new Uint8Array(c.length) : new Array(c.length)))), t) : s.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\index.ts", o = "ecdaec61f4d657ab4aa4907c2d7b2af3b1f28af4", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 34
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 33
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 34
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 27
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 29
            }
          },
          9: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 29
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,kCAA6B;AAC7B,iCAA4B;AAC5B,kCAA6B;AAC7B,2BAAsB;AACtB,6BAAwB;AACxB,6BAAwB",
          sourcesContent: ['export * from "./formatting";\r\nexport * from "./paragraph";\r\nexport * from "./properties";\r\nexport * from "./run";\r\nexport * from "./links";\r\nexport * from "./image";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(50)), a.s[5]++, c(t(81)), a.s[6]++, c(t(22)), a.s[7]++, c(t(4)), a.s[8]++, c(t(210)), a.s[9]++, c(t(215));
    }, function (e, n, t) {
      "use strict";

      function r(e) {
        this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
          data: [],
          end: [],
          error: []
        }, this.previous = null;
      }

      r.prototype = {
        push: function push(e) {
          this.emit("data", e);
        },
        end: function end() {
          if (this.isFinished) return !1;
          this.flush();

          try {
            this.emit("end"), this.cleanUp(), this.isFinished = !0;
          } catch (e) {
            this.emit("error", e);
          }

          return !0;
        },
        error: function error(e) {
          return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
        },
        on: function on(e, n) {
          return this._listeners[e].push(n), this;
        },
        cleanUp: function cleanUp() {
          this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
        },
        emit: function emit(e, n) {
          if (this._listeners[e]) for (var t = 0; t < this._listeners[e].length; t++) {
            this._listeners[e][t].call(this, n);
          }
        },
        pipe: function pipe(e) {
          return e.registerPrevious(this);
        },
        registerPrevious: function registerPrevious(e) {
          if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
          this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
          var n = this;
          return e.on("data", function (e) {
            n.processChunk(e);
          }), e.on("end", function () {
            n.end();
          }), e.on("error", function (e) {
            n.error(e);
          }), this;
        },
        pause: function pause() {
          return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
        },
        resume: function resume() {
          if (!this.isPaused || this.isFinished) return !1;
          this.isPaused = !1;
          var e = !1;
          return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
        },
        flush: function flush() {},
        processChunk: function processChunk(e) {
          this.push(e);
        },
        withStreamInfo: function withStreamInfo(e, n) {
          return this.extraStreamInfo[e] = n, this.mergeStreamInfo(), this;
        },
        mergeStreamInfo: function mergeStreamInfo() {
          for (var e in this.extraStreamInfo) {
            this.extraStreamInfo.hasOwnProperty(e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
          }
        },
        lock: function lock() {
          if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
          this.isLocked = !0, this.previous && this.previous.lock();
        },
        toString: function toString() {
          var e = "Worker " + this.name;
          return this.previous ? this.previous + " -> " + e : e;
        }
      }, e.exports = r;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\index.ts", o = "80e7478cd7ac0cd7e2c3559e83454f1a4acda802", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 27
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 32
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 35
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 45
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,2BAAsB;AACtB,gCAA2B;AAC3B,mCAA8B;AAC9B,6CAAwC",
          sourcesContent: ['export * from "./run";\r\nexport * from "./text-run";\r\nexport * from "./picture-run";\r\nexport * from "./sequential-identifier";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(151)), a.s[5]++, c(t(156)), a.s[6]++, c(t(158)), a.s[7]++, c(t(206));
    }, function (e, n, t) {
      "use strict";

      (function (e) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
         * @license  MIT
         */
        var r = t(135),
            o = t(136),
            i = t(55);

        function A() {
          return l.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }

        function s(e, n) {
          if (A() < n) throw new RangeError("Invalid typed array length");
          return l.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(n)).__proto__ = l.prototype : (null === e && (e = new l(n)), e.length = n), e;
        }

        function l(e, n, t) {
          if (!(l.TYPED_ARRAY_SUPPORT || this instanceof l)) return new l(e, n, t);

          if ("number" == typeof e) {
            if ("string" == typeof n) throw new Error("If encoding is specified then the first argument must be a string");
            return u(this, e);
          }

          return a(this, e, n, t);
        }

        function a(e, n, t, r) {
          if ("number" == typeof n) throw new TypeError('"value" argument must not be a number');
          return "undefined" != typeof ArrayBuffer && n instanceof ArrayBuffer ? function (e, n, t, r) {
            if (n.byteLength, t < 0 || n.byteLength < t) throw new RangeError("'offset' is out of bounds");
            if (n.byteLength < t + (r || 0)) throw new RangeError("'length' is out of bounds");
            return n = void 0 === t && void 0 === r ? new Uint8Array(n) : void 0 === r ? new Uint8Array(n, t) : new Uint8Array(n, t, r), l.TYPED_ARRAY_SUPPORT ? (e = n).__proto__ = l.prototype : e = p(e, n), e;
          }(e, n, t, r) : "string" == typeof n ? function (e, n, t) {
            if ("string" == typeof t && "" !== t || (t = "utf8"), !l.isEncoding(t)) throw new TypeError('"encoding" must be a valid string encoding');
            var r = 0 | C(n, t),
                o = (e = s(e, r)).write(n, t);
            return o !== r && (e = e.slice(0, o)), e;
          }(e, n, t) : function (e, n) {
            if (l.isBuffer(n)) {
              var t = 0 | m(n.length);
              return 0 === (e = s(e, t)).length ? e : (n.copy(e, 0, 0, t), e);
            }

            if (n) {
              if ("undefined" != typeof ArrayBuffer && n.buffer instanceof ArrayBuffer || "length" in n) return "number" != typeof n.length || (r = n.length) != r ? s(e, 0) : p(e, n);
              if ("Buffer" === n.type && i(n.data)) return p(e, n.data);
            }

            var r;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(e, n);
        }

        function c(e) {
          if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
          if (e < 0) throw new RangeError('"size" argument must not be negative');
        }

        function u(e, n) {
          if (c(n), e = s(e, n < 0 ? 0 : 0 | m(n)), !l.TYPED_ARRAY_SUPPORT) for (var t = 0; t < n; ++t) {
            e[t] = 0;
          }
          return e;
        }

        function p(e, n) {
          var t = n.length < 0 ? 0 : 0 | m(n.length);
          e = s(e, t);

          for (var r = 0; r < t; r += 1) {
            e[r] = 255 & n[r];
          }

          return e;
        }

        function m(e) {
          if (e >= A()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + A().toString(16) + " bytes");
          return 0 | e;
        }

        function C(e, n) {
          if (l.isBuffer(e)) return e.length;
          if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
          "string" != typeof e && (e = "" + e);
          var t = e.length;
          if (0 === t) return 0;

          for (var r = !1;;) {
            switch (n) {
              case "ascii":
              case "latin1":
              case "binary":
                return t;

              case "utf8":
              case "utf-8":
              case void 0:
                return Y(e).length;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * t;

              case "hex":
                return t >>> 1;

              case "base64":
                return F(e).length;

              default:
                if (r) return Y(e).length;
                n = ("" + n).toLowerCase(), r = !0;
            }
          }
        }

        function d(e, n, t) {
          var r = !1;
          if ((void 0 === n || n < 0) && (n = 0), n > this.length) return "";
          if ((void 0 === t || t > this.length) && (t = this.length), t <= 0) return "";
          if ((t >>>= 0) <= (n >>>= 0)) return "";

          for (e || (e = "utf8");;) {
            switch (e) {
              case "hex":
                return M(this, n, t);

              case "utf8":
              case "utf-8":
                return B(this, n, t);

              case "ascii":
                return D(this, n, t);

              case "latin1":
              case "binary":
                return S(this, n, t);

              case "base64":
                return w(this, n, t);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return O(this, n, t);

              default:
                if (r) throw new TypeError("Unknown encoding: " + e);
                e = (e + "").toLowerCase(), r = !0;
            }
          }
        }

        function f(e, n, t) {
          var r = e[n];
          e[n] = e[t], e[t] = r;
        }

        function h(e, n, t, r, o) {
          if (0 === e.length) return -1;

          if ("string" == typeof t ? (r = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = o ? 0 : e.length - 1), t < 0 && (t = e.length + t), t >= e.length) {
            if (o) return -1;
            t = e.length - 1;
          } else if (t < 0) {
            if (!o) return -1;
            t = 0;
          }

          if ("string" == typeof n && (n = l.from(n, r)), l.isBuffer(n)) return 0 === n.length ? -1 : x(e, n, t, r, o);
          if ("number" == typeof n) return n &= 255, l.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, n, t) : Uint8Array.prototype.lastIndexOf.call(e, n, t) : x(e, [n], t, r, o);
          throw new TypeError("val must be string, number or Buffer");
        }

        function x(e, n, t, r, o) {
          var i,
              A = 1,
              s = e.length,
              l = n.length;

          if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
            if (e.length < 2 || n.length < 2) return -1;
            A = 2, s /= 2, l /= 2, t /= 2;
          }

          function a(e, n) {
            return 1 === A ? e[n] : e.readUInt16BE(n * A);
          }

          if (o) {
            var c = -1;

            for (i = t; i < s; i++) {
              if (a(e, i) === a(n, -1 === c ? 0 : i - c)) {
                if (-1 === c && (c = i), i - c + 1 === l) return c * A;
              } else -1 !== c && (i -= i - c), c = -1;
            }
          } else for (t + l > s && (t = s - l), i = t; i >= 0; i--) {
            for (var u = !0, p = 0; p < l; p++) {
              if (a(e, i + p) !== a(n, p)) {
                u = !1;
                break;
              }
            }

            if (u) return i;
          }

          return -1;
        }

        function g(e, n, t, r) {
          t = Number(t) || 0;
          var o = e.length - t;
          r ? (r = Number(r)) > o && (r = o) : r = o;
          var i = n.length;
          if (i % 2 != 0) throw new TypeError("Invalid hex string");
          r > i / 2 && (r = i / 2);

          for (var A = 0; A < r; ++A) {
            var s = parseInt(n.substr(2 * A, 2), 16);
            if (isNaN(s)) return A;
            e[t + A] = s;
          }

          return A;
        }

        function I(e, n, t, r) {
          return N(Y(n, e.length - t), e, t, r);
        }

        function b(e, n, t, r) {
          return N(function (e) {
            for (var n = [], t = 0; t < e.length; ++t) {
              n.push(255 & e.charCodeAt(t));
            }

            return n;
          }(n), e, t, r);
        }

        function y(e, n, t, r) {
          return b(e, n, t, r);
        }

        function E(e, n, t, r) {
          return N(F(n), e, t, r);
        }

        function v(e, n, t, r) {
          return N(function (e, n) {
            for (var t, r, o, i = [], A = 0; A < e.length && !((n -= 2) < 0); ++A) {
              t = e.charCodeAt(A), r = t >> 8, o = t % 256, i.push(o), i.push(r);
            }

            return i;
          }(n, e.length - t), e, t, r);
        }

        function w(e, n, t) {
          return 0 === n && t === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(n, t));
        }

        function B(e, n, t) {
          t = Math.min(e.length, t);

          for (var r = [], o = n; o < t;) {
            var i,
                A,
                s,
                l,
                a = e[o],
                c = null,
                u = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
            if (o + u <= t) switch (u) {
              case 1:
                a < 128 && (c = a);
                break;

              case 2:
                128 == (192 & (i = e[o + 1])) && (l = (31 & a) << 6 | 63 & i) > 127 && (c = l);
                break;

              case 3:
                i = e[o + 1], A = e[o + 2], 128 == (192 & i) && 128 == (192 & A) && (l = (15 & a) << 12 | (63 & i) << 6 | 63 & A) > 2047 && (l < 55296 || l > 57343) && (c = l);
                break;

              case 4:
                i = e[o + 1], A = e[o + 2], s = e[o + 3], 128 == (192 & i) && 128 == (192 & A) && 128 == (192 & s) && (l = (15 & a) << 18 | (63 & i) << 12 | (63 & A) << 6 | 63 & s) > 65535 && l < 1114112 && (c = l);
            }
            null === c ? (c = 65533, u = 1) : c > 65535 && (c -= 65536, r.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), r.push(c), o += u;
          }

          return function (e) {
            var n = e.length;
            if (n <= _) return String.fromCharCode.apply(String, e);

            for (var t = "", r = 0; r < n;) {
              t += String.fromCharCode.apply(String, e.slice(r, r += _));
            }

            return t;
          }(r);
        }

        n.Buffer = l, n.SlowBuffer = function (e) {
          return +e != e && (e = 0), l.alloc(+e);
        }, n.INSPECT_MAX_BYTES = 50, l.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
          try {
            var e = new Uint8Array(1);
            return e.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function foo() {
                return 42;
              }
            }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
          } catch (e) {
            return !1;
          }
        }(), n.kMaxLength = A(), l.poolSize = 8192, l._augment = function (e) {
          return e.__proto__ = l.prototype, e;
        }, l.from = function (e, n, t) {
          return a(null, e, n, t);
        }, l.TYPED_ARRAY_SUPPORT && (l.prototype.__proto__ = Uint8Array.prototype, l.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && l[Symbol.species] === l && Object.defineProperty(l, Symbol.species, {
          value: null,
          configurable: !0
        })), l.alloc = function (e, n, t) {
          return function (e, n, t, r) {
            return c(n), n <= 0 ? s(e, n) : void 0 !== t ? "string" == typeof r ? s(e, n).fill(t, r) : s(e, n).fill(t) : s(e, n);
          }(null, e, n, t);
        }, l.allocUnsafe = function (e) {
          return u(null, e);
        }, l.allocUnsafeSlow = function (e) {
          return u(null, e);
        }, l.isBuffer = function (e) {
          return !(null == e || !e._isBuffer);
        }, l.compare = function (e, n) {
          if (!l.isBuffer(e) || !l.isBuffer(n)) throw new TypeError("Arguments must be Buffers");
          if (e === n) return 0;

          for (var t = e.length, r = n.length, o = 0, i = Math.min(t, r); o < i; ++o) {
            if (e[o] !== n[o]) {
              t = e[o], r = n[o];
              break;
            }
          }

          return t < r ? -1 : r < t ? 1 : 0;
        }, l.isEncoding = function (e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;

            default:
              return !1;
          }
        }, l.concat = function (e, n) {
          if (!i(e)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === e.length) return l.alloc(0);
          var t;
          if (void 0 === n) for (n = 0, t = 0; t < e.length; ++t) {
            n += e[t].length;
          }
          var r = l.allocUnsafe(n),
              o = 0;

          for (t = 0; t < e.length; ++t) {
            var A = e[t];
            if (!l.isBuffer(A)) throw new TypeError('"list" argument must be an Array of Buffers');
            A.copy(r, o), o += A.length;
          }

          return r;
        }, l.byteLength = C, l.prototype._isBuffer = !0, l.prototype.swap16 = function () {
          var e = this.length;
          if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

          for (var n = 0; n < e; n += 2) {
            f(this, n, n + 1);
          }

          return this;
        }, l.prototype.swap32 = function () {
          var e = this.length;
          if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

          for (var n = 0; n < e; n += 4) {
            f(this, n, n + 3), f(this, n + 1, n + 2);
          }

          return this;
        }, l.prototype.swap64 = function () {
          var e = this.length;
          if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

          for (var n = 0; n < e; n += 8) {
            f(this, n, n + 7), f(this, n + 1, n + 6), f(this, n + 2, n + 5), f(this, n + 3, n + 4);
          }

          return this;
        }, l.prototype.toString = function () {
          var e = 0 | this.length;
          return 0 === e ? "" : 0 === arguments.length ? B(this, 0, e) : d.apply(this, arguments);
        }, l.prototype.equals = function (e) {
          if (!l.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          return this === e || 0 === l.compare(this, e);
        }, l.prototype.inspect = function () {
          var e = "",
              t = n.INSPECT_MAX_BYTES;
          return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
        }, l.prototype.compare = function (e, n, t, r, o) {
          if (!l.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          if (void 0 === n && (n = 0), void 0 === t && (t = e ? e.length : 0), void 0 === r && (r = 0), void 0 === o && (o = this.length), n < 0 || t > e.length || r < 0 || o > this.length) throw new RangeError("out of range index");
          if (r >= o && n >= t) return 0;
          if (r >= o) return -1;
          if (n >= t) return 1;
          if (this === e) return 0;

          for (var i = (o >>>= 0) - (r >>>= 0), A = (t >>>= 0) - (n >>>= 0), s = Math.min(i, A), a = this.slice(r, o), c = e.slice(n, t), u = 0; u < s; ++u) {
            if (a[u] !== c[u]) {
              i = a[u], A = c[u];
              break;
            }
          }

          return i < A ? -1 : A < i ? 1 : 0;
        }, l.prototype.includes = function (e, n, t) {
          return -1 !== this.indexOf(e, n, t);
        }, l.prototype.indexOf = function (e, n, t) {
          return h(this, e, n, t, !0);
        }, l.prototype.lastIndexOf = function (e, n, t) {
          return h(this, e, n, t, !1);
        }, l.prototype.write = function (e, n, t, r) {
          if (void 0 === n) r = "utf8", t = this.length, n = 0;else if (void 0 === t && "string" == typeof n) r = n, t = this.length, n = 0;else {
            if (!isFinite(n)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            n |= 0, isFinite(t) ? (t |= 0, void 0 === r && (r = "utf8")) : (r = t, t = void 0);
          }
          var o = this.length - n;
          if ((void 0 === t || t > o) && (t = o), e.length > 0 && (t < 0 || n < 0) || n > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          r || (r = "utf8");

          for (var i = !1;;) {
            switch (r) {
              case "hex":
                return g(this, e, n, t);

              case "utf8":
              case "utf-8":
                return I(this, e, n, t);

              case "ascii":
                return b(this, e, n, t);

              case "latin1":
              case "binary":
                return y(this, e, n, t);

              case "base64":
                return E(this, e, n, t);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return v(this, e, n, t);

              default:
                if (i) throw new TypeError("Unknown encoding: " + r);
                r = ("" + r).toLowerCase(), i = !0;
            }
          }
        }, l.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        var _ = 4096;

        function D(e, n, t) {
          var r = "";
          t = Math.min(e.length, t);

          for (var o = n; o < t; ++o) {
            r += String.fromCharCode(127 & e[o]);
          }

          return r;
        }

        function S(e, n, t) {
          var r = "";
          t = Math.min(e.length, t);

          for (var o = n; o < t; ++o) {
            r += String.fromCharCode(e[o]);
          }

          return r;
        }

        function M(e, n, t) {
          var r,
              o = e.length;
          (!n || n < 0) && (n = 0), (!t || t < 0 || t > o) && (t = o);

          for (var i = "", A = n; A < t; ++A) {
            i += (r = e[A]) < 16 ? "0" + r.toString(16) : r.toString(16);
          }

          return i;
        }

        function O(e, n, t) {
          for (var r = e.slice(n, t), o = "", i = 0; i < r.length; i += 2) {
            o += String.fromCharCode(r[i] + 256 * r[i + 1]);
          }

          return o;
        }

        function k(e, n, t) {
          if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
          if (e + n > t) throw new RangeError("Trying to access beyond buffer length");
        }

        function T(e, n, t, r, o, i) {
          if (!l.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (n > o || n < i) throw new RangeError('"value" argument is out of bounds');
          if (t + r > e.length) throw new RangeError("Index out of range");
        }

        function P(e, n, t, r) {
          n < 0 && (n = 65535 + n + 1);

          for (var o = 0, i = Math.min(e.length - t, 2); o < i; ++o) {
            e[t + o] = (n & 255 << 8 * (r ? o : 1 - o)) >>> 8 * (r ? o : 1 - o);
          }
        }

        function K(e, n, t, r) {
          n < 0 && (n = 4294967295 + n + 1);

          for (var o = 0, i = Math.min(e.length - t, 4); o < i; ++o) {
            e[t + o] = n >>> 8 * (r ? o : 3 - o) & 255;
          }
        }

        function Q(e, n, t, r, o, i) {
          if (t + r > e.length) throw new RangeError("Index out of range");
          if (t < 0) throw new RangeError("Index out of range");
        }

        function U(e, n, t, r, i) {
          return i || Q(e, 0, t, 4), o.write(e, n, t, r, 23, 4), t + 4;
        }

        function R(e, n, t, r, i) {
          return i || Q(e, 0, t, 8), o.write(e, n, t, r, 52, 8), t + 8;
        }

        l.prototype.slice = function (e, n) {
          var t,
              r = this.length;
          if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (n = void 0 === n ? r : ~~n) < 0 ? (n += r) < 0 && (n = 0) : n > r && (n = r), n < e && (n = e), l.TYPED_ARRAY_SUPPORT) (t = this.subarray(e, n)).__proto__ = l.prototype;else {
            var o = n - e;
            t = new l(o, void 0);

            for (var i = 0; i < o; ++i) {
              t[i] = this[i + e];
            }
          }
          return t;
        }, l.prototype.readUIntLE = function (e, n, t) {
          e |= 0, n |= 0, t || k(e, n, this.length);

          for (var r = this[e], o = 1, i = 0; ++i < n && (o *= 256);) {
            r += this[e + i] * o;
          }

          return r;
        }, l.prototype.readUIntBE = function (e, n, t) {
          e |= 0, n |= 0, t || k(e, n, this.length);

          for (var r = this[e + --n], o = 1; n > 0 && (o *= 256);) {
            r += this[e + --n] * o;
          }

          return r;
        }, l.prototype.readUInt8 = function (e, n) {
          return n || k(e, 1, this.length), this[e];
        }, l.prototype.readUInt16LE = function (e, n) {
          return n || k(e, 2, this.length), this[e] | this[e + 1] << 8;
        }, l.prototype.readUInt16BE = function (e, n) {
          return n || k(e, 2, this.length), this[e] << 8 | this[e + 1];
        }, l.prototype.readUInt32LE = function (e, n) {
          return n || k(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
        }, l.prototype.readUInt32BE = function (e, n) {
          return n || k(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
        }, l.prototype.readIntLE = function (e, n, t) {
          e |= 0, n |= 0, t || k(e, n, this.length);

          for (var r = this[e], o = 1, i = 0; ++i < n && (o *= 256);) {
            r += this[e + i] * o;
          }

          return r >= (o *= 128) && (r -= Math.pow(2, 8 * n)), r;
        }, l.prototype.readIntBE = function (e, n, t) {
          e |= 0, n |= 0, t || k(e, n, this.length);

          for (var r = n, o = 1, i = this[e + --r]; r > 0 && (o *= 256);) {
            i += this[e + --r] * o;
          }

          return i >= (o *= 128) && (i -= Math.pow(2, 8 * n)), i;
        }, l.prototype.readInt8 = function (e, n) {
          return n || k(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
        }, l.prototype.readInt16LE = function (e, n) {
          n || k(e, 2, this.length);
          var t = this[e] | this[e + 1] << 8;
          return 32768 & t ? 4294901760 | t : t;
        }, l.prototype.readInt16BE = function (e, n) {
          n || k(e, 2, this.length);
          var t = this[e + 1] | this[e] << 8;
          return 32768 & t ? 4294901760 | t : t;
        }, l.prototype.readInt32LE = function (e, n) {
          return n || k(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
        }, l.prototype.readInt32BE = function (e, n) {
          return n || k(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
        }, l.prototype.readFloatLE = function (e, n) {
          return n || k(e, 4, this.length), o.read(this, e, !0, 23, 4);
        }, l.prototype.readFloatBE = function (e, n) {
          return n || k(e, 4, this.length), o.read(this, e, !1, 23, 4);
        }, l.prototype.readDoubleLE = function (e, n) {
          return n || k(e, 8, this.length), o.read(this, e, !0, 52, 8);
        }, l.prototype.readDoubleBE = function (e, n) {
          return n || k(e, 8, this.length), o.read(this, e, !1, 52, 8);
        }, l.prototype.writeUIntLE = function (e, n, t, r) {
          e = +e, n |= 0, t |= 0, r || T(this, e, n, t, Math.pow(2, 8 * t) - 1, 0);
          var o = 1,
              i = 0;

          for (this[n] = 255 & e; ++i < t && (o *= 256);) {
            this[n + i] = e / o & 255;
          }

          return n + t;
        }, l.prototype.writeUIntBE = function (e, n, t, r) {
          e = +e, n |= 0, t |= 0, r || T(this, e, n, t, Math.pow(2, 8 * t) - 1, 0);
          var o = t - 1,
              i = 1;

          for (this[n + o] = 255 & e; --o >= 0 && (i *= 256);) {
            this[n + o] = e / i & 255;
          }

          return n + t;
        }, l.prototype.writeUInt8 = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 1, 255, 0), l.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[n] = 255 & e, n + 1;
        }, l.prototype.writeUInt16LE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[n] = 255 & e, this[n + 1] = e >>> 8) : P(this, e, n, !0), n + 2;
        }, l.prototype.writeUInt16BE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 8, this[n + 1] = 255 & e) : P(this, e, n, !1), n + 2;
        }, l.prototype.writeUInt32LE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[n + 3] = e >>> 24, this[n + 2] = e >>> 16, this[n + 1] = e >>> 8, this[n] = 255 & e) : K(this, e, n, !0), n + 4;
        }, l.prototype.writeUInt32BE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 24, this[n + 1] = e >>> 16, this[n + 2] = e >>> 8, this[n + 3] = 255 & e) : K(this, e, n, !1), n + 4;
        }, l.prototype.writeIntLE = function (e, n, t, r) {
          if (e = +e, n |= 0, !r) {
            var o = Math.pow(2, 8 * t - 1);
            T(this, e, n, t, o - 1, -o);
          }

          var i = 0,
              A = 1,
              s = 0;

          for (this[n] = 255 & e; ++i < t && (A *= 256);) {
            e < 0 && 0 === s && 0 !== this[n + i - 1] && (s = 1), this[n + i] = (e / A >> 0) - s & 255;
          }

          return n + t;
        }, l.prototype.writeIntBE = function (e, n, t, r) {
          if (e = +e, n |= 0, !r) {
            var o = Math.pow(2, 8 * t - 1);
            T(this, e, n, t, o - 1, -o);
          }

          var i = t - 1,
              A = 1,
              s = 0;

          for (this[n + i] = 255 & e; --i >= 0 && (A *= 256);) {
            e < 0 && 0 === s && 0 !== this[n + i + 1] && (s = 1), this[n + i] = (e / A >> 0) - s & 255;
          }

          return n + t;
        }, l.prototype.writeInt8 = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 1, 127, -128), l.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[n] = 255 & e, n + 1;
        }, l.prototype.writeInt16LE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[n] = 255 & e, this[n + 1] = e >>> 8) : P(this, e, n, !0), n + 2;
        }, l.prototype.writeInt16BE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 8, this[n + 1] = 255 & e) : P(this, e, n, !1), n + 2;
        }, l.prototype.writeInt32LE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 4, 2147483647, -2147483648), l.TYPED_ARRAY_SUPPORT ? (this[n] = 255 & e, this[n + 1] = e >>> 8, this[n + 2] = e >>> 16, this[n + 3] = e >>> 24) : K(this, e, n, !0), n + 4;
        }, l.prototype.writeInt32BE = function (e, n, t) {
          return e = +e, n |= 0, t || T(this, e, n, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), l.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 24, this[n + 1] = e >>> 16, this[n + 2] = e >>> 8, this[n + 3] = 255 & e) : K(this, e, n, !1), n + 4;
        }, l.prototype.writeFloatLE = function (e, n, t) {
          return U(this, e, n, !0, t);
        }, l.prototype.writeFloatBE = function (e, n, t) {
          return U(this, e, n, !1, t);
        }, l.prototype.writeDoubleLE = function (e, n, t) {
          return R(this, e, n, !0, t);
        }, l.prototype.writeDoubleBE = function (e, n, t) {
          return R(this, e, n, !1, t);
        }, l.prototype.copy = function (e, n, t, r) {
          if (t || (t = 0), r || 0 === r || (r = this.length), n >= e.length && (n = e.length), n || (n = 0), r > 0 && r < t && (r = t), r === t) return 0;
          if (0 === e.length || 0 === this.length) return 0;
          if (n < 0) throw new RangeError("targetStart out of bounds");
          if (t < 0 || t >= this.length) throw new RangeError("sourceStart out of bounds");
          if (r < 0) throw new RangeError("sourceEnd out of bounds");
          r > this.length && (r = this.length), e.length - n < r - t && (r = e.length - n + t);
          var o,
              i = r - t;
          if (this === e && t < n && n < r) for (o = i - 1; o >= 0; --o) {
            e[o + n] = this[o + t];
          } else if (i < 1e3 || !l.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
            e[o + n] = this[o + t];
          } else Uint8Array.prototype.set.call(e, this.subarray(t, t + i), n);
          return i;
        }, l.prototype.fill = function (e, n, t, r) {
          if ("string" == typeof e) {
            if ("string" == typeof n ? (r = n, n = 0, t = this.length) : "string" == typeof t && (r = t, t = this.length), 1 === e.length) {
              var o = e.charCodeAt(0);
              o < 256 && (e = o);
            }

            if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
            if ("string" == typeof r && !l.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
          } else "number" == typeof e && (e &= 255);

          if (n < 0 || this.length < n || this.length < t) throw new RangeError("Out of range index");
          if (t <= n) return this;
          var i;
          if (n >>>= 0, t = void 0 === t ? this.length : t >>> 0, e || (e = 0), "number" == typeof e) for (i = n; i < t; ++i) {
            this[i] = e;
          } else {
            var A = l.isBuffer(e) ? e : Y(new l(e, r).toString()),
                s = A.length;

            for (i = 0; i < t - n; ++i) {
              this[i + n] = A[i % s];
            }
          }
          return this;
        };
        var G = /[^+\/0-9A-Za-z-_]/g;

        function Y(e, n) {
          var t;
          n = n || 1 / 0;

          for (var r = e.length, o = null, i = [], A = 0; A < r; ++A) {
            if ((t = e.charCodeAt(A)) > 55295 && t < 57344) {
              if (!o) {
                if (t > 56319) {
                  (n -= 3) > -1 && i.push(239, 191, 189);
                  continue;
                }

                if (A + 1 === r) {
                  (n -= 3) > -1 && i.push(239, 191, 189);
                  continue;
                }

                o = t;
                continue;
              }

              if (t < 56320) {
                (n -= 3) > -1 && i.push(239, 191, 189), o = t;
                continue;
              }

              t = 65536 + (o - 55296 << 10 | t - 56320);
            } else o && (n -= 3) > -1 && i.push(239, 191, 189);

            if (o = null, t < 128) {
              if ((n -= 1) < 0) break;
              i.push(t);
            } else if (t < 2048) {
              if ((n -= 2) < 0) break;
              i.push(t >> 6 | 192, 63 & t | 128);
            } else if (t < 65536) {
              if ((n -= 3) < 0) break;
              i.push(t >> 12 | 224, t >> 6 & 63 | 128, 63 & t | 128);
            } else {
              if (!(t < 1114112)) throw new Error("Invalid code point");
              if ((n -= 4) < 0) break;
              i.push(t >> 18 | 240, t >> 12 & 63 | 128, t >> 6 & 63 | 128, 63 & t | 128);
            }
          }

          return i;
        }

        function F(e) {
          return r.toByteArray(function (e) {
            if ((e = function (e) {
              return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
            }(e).replace(G, "")).length < 2) return "";

            for (; e.length % 4 != 0;) {
              e += "=";
            }

            return e;
          }(e));
        }

        function N(e, n, t, r) {
          for (var o = 0; o < r && !(o + t >= n.length || o >= e.length); ++o) {
            n[o + t] = e[o];
          }

          return o;
        }
      }).call(n, t(8));
    }, function (e, n, t) {
      "use strict";

      (function (e) {
        if (n.base64 = !0, n.array = !0, n.string = !0, n.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, n.nodebuffer = void 0 !== e, n.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) n.blob = !1;else {
          var r = new ArrayBuffer(0);

          try {
            n.blob = 0 === new Blob([r], {
              type: "application/zip"
            }).size;
          } catch (e) {
            try {
              var o = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
              o.append(r), n.blob = 0 === o.getBlob("application/zip").size;
            } catch (e) {
              n.blob = !1;
            }
          }
        }

        try {
          n.nodestream = !!t(108).Readable;
        } catch (e) {
          n.nodestream = !1;
        }
      }).call(n, t(5).Buffer);
    }, function (e, n, t) {
      "use strict";

      var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

      function o(e, n) {
        return Object.prototype.hasOwnProperty.call(e, n);
      }

      n.assign = function (e) {
        for (var n = Array.prototype.slice.call(arguments, 1); n.length;) {
          var t = n.shift();

          if (t) {
            if ("object" != typeof t) throw new TypeError(t + "must be non-object");

            for (var r in t) {
              o(t, r) && (e[r] = t[r]);
            }
          }
        }

        return e;
      }, n.shrinkBuf = function (e, n) {
        return e.length === n ? e : e.subarray ? e.subarray(0, n) : (e.length = n, e);
      };
      var i = {
        arraySet: function arraySet(e, n, t, r, o) {
          if (n.subarray && e.subarray) e.set(n.subarray(t, t + r), o);else for (var i = 0; i < r; i++) {
            e[o + i] = n[t + i];
          }
        },
        flattenChunks: function flattenChunks(e) {
          var n, t, r, o, i, A;

          for (r = 0, n = 0, t = e.length; n < t; n++) {
            r += e[n].length;
          }

          for (A = new Uint8Array(r), o = 0, n = 0, t = e.length; n < t; n++) {
            i = e[n], A.set(i, o), o += i.length;
          }

          return A;
        }
      },
          A = {
        arraySet: function arraySet(e, n, t, r, o) {
          for (var i = 0; i < r; i++) {
            e[o + i] = n[t + i];
          }
        },
        flattenChunks: function flattenChunks(e) {
          return [].concat.apply([], e);
        }
      };
      n.setTyped = function (e) {
        e ? (n.Buf8 = Uint8Array, n.Buf16 = Uint16Array, n.Buf32 = Int32Array, n.assign(n, i)) : (n.Buf8 = Array, n.Buf16 = Array, n.Buf32 = Array, n.assign(n, A));
      }, n.setTyped(r);
    }, function (e, n) {
      var t;

      t = function () {
        return this;
      }();

      try {
        t = t || Function("return this")() || (0, eval)("this");
      } catch (e) {
        "object" == typeof window && (t = window);
      }

      e.exports = t;
    }, function (e, n, t) {
      "use strict";

      var r = t(18),
          o = Object.keys || function (e) {
        var n = [];

        for (var t in e) {
          n.push(t);
        }

        return n;
      };

      e.exports = u;
      var i = t(14);
      i.inherits = t(10);
      var A = t(56),
          s = t(31);
      i.inherits(u, A);

      for (var l = o(s.prototype), a = 0; a < l.length; a++) {
        var c = l[a];
        u.prototype[c] || (u.prototype[c] = s.prototype[c]);
      }

      function u(e) {
        if (!(this instanceof u)) return new u(e);
        A.call(this, e), s.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", p);
      }

      function p() {
        this.allowHalfOpen || this._writableState.ended || r(m, this);
      }

      function m(e) {
        e.end();
      }

      Object.defineProperty(u.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(e) {
          void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
        }
      }), u.prototype._destroy = function (e, n) {
        this.push(null), this.end(), r(n, e);
      };
    }, function (e, n) {
      "function" == typeof Object.create ? e.exports = function (e, n) {
        e.super_ = n, e.prototype = Object.create(n.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        });
      } : e.exports = function (e, n) {
        e.super_ = n;

        var t = function t() {};

        t.prototype = n.prototype, e.prototype = new t(), e.prototype.constructor = e;
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\document-attributes.ts", o = "1d489b0d08fb9fe3de7ab47987f711e5fd7f303c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\document-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 31,
              column: 10
            }
          },
          4: {
            start: {
              line: 34,
              column: 0
            },
            end: {
              line: 34,
              column: 48
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/document-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\document-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AA4B5D,wBAAgC,SAAQ,sCAAoD;IAA5F;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,WAAW;YAChB,EAAE,EAAE,UAAU;YACd,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,IAAI,EAAE,YAAY;YAClB,EAAE,EAAE,UAAU;YACd,GAAG,EAAE,WAAW;YAChB,CAAC,EAAE,SAAS;YACZ,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,SAAS,EAAE,cAAc;YACzB,EAAE,EAAE,UAAU;YACd,EAAE,EAAE,UAAU;YACd,OAAO,EAAE,eAAe;YACxB,QAAQ,EAAE,gBAAgB;YAC1B,GAAG,EAAE,WAAW;YAChB,IAAI,EAAE,UAAU;SACnB,CAAC;IACN,CAAC;CAAA;AA1BD,gDA0BC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IDocumentAttributesProperties {\r\n    readonly wpc?: string;\r\n    readonly mc?: string;\r\n    readonly o?: string;\r\n    readonly r?: string;\r\n    readonly m?: string;\r\n    readonly v?: string;\r\n    readonly wp14?: string;\r\n    readonly wp?: string;\r\n    readonly w10?: string;\r\n    readonly w?: string;\r\n    readonly w14?: string;\r\n    readonly w15?: string;\r\n    readonly wpg?: string;\r\n    readonly wpi?: string;\r\n    readonly wne?: string;\r\n    readonly wps?: string;\r\n    readonly Ignorable?: string;\r\n    readonly cp?: string;\r\n    readonly dc?: string;\r\n    readonly dcterms?: string;\r\n    readonly dcmitype?: string;\r\n    readonly xsi?: string;\r\n    readonly type?: string;\r\n}\r\n\r\nexport class DocumentAttributes extends XmlAttributeComponent<IDocumentAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        wpc: "xmlns:wpc",\r\n        mc: "xmlns:mc",\r\n        o: "xmlns:o",\r\n        r: "xmlns:r",\r\n        m: "xmlns:m",\r\n        v: "xmlns:v",\r\n        wp14: "xmlns:wp14",\r\n        wp: "xmlns:wp",\r\n        w10: "xmlns:w10",\r\n        w: "xmlns:w",\r\n        w14: "xmlns:w14",\r\n        w15: "xmlns:w15",\r\n        wpg: "xmlns:wpg",\r\n        wpi: "xmlns:wpi",\r\n        wne: "xmlns:wne",\r\n        wps: "xmlns:wps",\r\n        Ignorable: "mc:Ignorable",\r\n        cp: "xmlns:cp",\r\n        dc: "xmlns:dc",\r\n        dcterms: "xmlns:dcterms",\r\n        dcmitype: "xmlns:dcmitype",\r\n        xsi: "xmlns:xsi",\r\n        type: "xsi:type",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon) {
        _inherits(u, _c$XmlAttributeCompon);

        function u() {
          var _this;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this.xmlKeys = {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type"
          };
          return _this;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.DocumentAttributes = u;
    }, function (e, n, t) {
      "use strict";

      for (var r = t(1), o = t(6), i = t(24), A = t(3), s = new Array(256), l = 0; l < 256; l++) {
        s[l] = l >= 252 ? 6 : l >= 248 ? 5 : l >= 240 ? 4 : l >= 224 ? 3 : l >= 192 ? 2 : 1;
      }

      function a() {
        A.call(this, "utf-8 decode"), this.leftOver = null;
      }

      function c() {
        A.call(this, "utf-8 encode");
      }

      s[254] = s[254] = 1, n.utf8encode = function (e) {
        return o.nodebuffer ? i.newBufferFrom(e, "utf-8") : function (e) {
          var n,
              t,
              r,
              i,
              A,
              s = e.length,
              l = 0;

          for (i = 0; i < s; i++) {
            55296 == (64512 & (t = e.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (r = e.charCodeAt(i + 1))) && (t = 65536 + (t - 55296 << 10) + (r - 56320), i++), l += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
          }

          for (n = o.uint8array ? new Uint8Array(l) : new Array(l), A = 0, i = 0; A < l; i++) {
            55296 == (64512 & (t = e.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (r = e.charCodeAt(i + 1))) && (t = 65536 + (t - 55296 << 10) + (r - 56320), i++), t < 128 ? n[A++] = t : t < 2048 ? (n[A++] = 192 | t >>> 6, n[A++] = 128 | 63 & t) : t < 65536 ? (n[A++] = 224 | t >>> 12, n[A++] = 128 | t >>> 6 & 63, n[A++] = 128 | 63 & t) : (n[A++] = 240 | t >>> 18, n[A++] = 128 | t >>> 12 & 63, n[A++] = 128 | t >>> 6 & 63, n[A++] = 128 | 63 & t);
          }

          return n;
        }(e);
      }, n.utf8decode = function (e) {
        return o.nodebuffer ? r.transformTo("nodebuffer", e).toString("utf-8") : function (e) {
          var n,
              t,
              o,
              i,
              A = e.length,
              l = new Array(2 * A);

          for (t = 0, n = 0; n < A;) {
            if ((o = e[n++]) < 128) l[t++] = o;else if ((i = s[o]) > 4) l[t++] = 65533, n += i - 1;else {
              for (o &= 2 === i ? 31 : 3 === i ? 15 : 7; i > 1 && n < A;) {
                o = o << 6 | 63 & e[n++], i--;
              }

              i > 1 ? l[t++] = 65533 : o < 65536 ? l[t++] = o : (o -= 65536, l[t++] = 55296 | o >> 10 & 1023, l[t++] = 56320 | 1023 & o);
            }
          }

          return l.length !== t && (l.subarray ? l = l.subarray(0, t) : l.length = t), r.applyFromCharCode(l);
        }(e = r.transformTo(o.uint8array ? "uint8array" : "array", e));
      }, r.inherits(a, A), a.prototype.processChunk = function (e) {
        var t = r.transformTo(o.uint8array ? "uint8array" : "array", e.data);

        if (this.leftOver && this.leftOver.length) {
          if (o.uint8array) {
            var i = t;
            (t = new Uint8Array(i.length + this.leftOver.length)).set(this.leftOver, 0), t.set(i, this.leftOver.length);
          } else t = this.leftOver.concat(t);

          this.leftOver = null;
        }

        var A = function (e, n) {
          var t;

          for ((n = n || e.length) > e.length && (n = e.length), t = n - 1; t >= 0 && 128 == (192 & e[t]);) {
            t--;
          }

          return t < 0 ? n : 0 === t ? n : t + s[e[t]] > n ? t : n;
        }(t),
            l = t;

        A !== t.length && (o.uint8array ? (l = t.subarray(0, A), this.leftOver = t.subarray(A, t.length)) : (l = t.slice(0, A), this.leftOver = t.slice(A, t.length))), this.push({
          data: n.utf8decode(l),
          meta: e.meta
        });
      }, a.prototype.flush = function () {
        this.leftOver && this.leftOver.length && (this.push({
          data: n.utf8decode(this.leftOver),
          meta: {}
        }), this.leftOver = null);
      }, n.Utf8DecodeWorker = a, r.inherits(c, A), c.prototype.processChunk = function (e) {
        this.push({
          data: n.utf8encode(e.data),
          meta: e.meta
        });
      }, n.Utf8EncodeWorker = c;
    }, function (e, n) {
      var t,
          r,
          o = e.exports = {};

      function i() {
        throw new Error("setTimeout has not been defined");
      }

      function A() {
        throw new Error("clearTimeout has not been defined");
      }

      function s(e) {
        if (t === setTimeout) return setTimeout(e, 0);
        if ((t === i || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);

        try {
          return t(e, 0);
        } catch (n) {
          try {
            return t.call(null, e, 0);
          } catch (n) {
            return t.call(this, e, 0);
          }
        }
      }

      !function () {
        try {
          t = "function" == typeof setTimeout ? setTimeout : i;
        } catch (e) {
          t = i;
        }

        try {
          r = "function" == typeof clearTimeout ? clearTimeout : A;
        } catch (e) {
          r = A;
        }
      }();
      var l,
          a = [],
          c = !1,
          u = -1;

      function p() {
        c && l && (c = !1, l.length ? a = l.concat(a) : u = -1, a.length && m());
      }

      function m() {
        if (!c) {
          var e = s(p);
          c = !0;

          for (var n = a.length; n;) {
            for (l = a, a = []; ++u < n;) {
              l && l[u].run();
            }

            u = -1, n = a.length;
          }

          l = null, c = !1, function (e) {
            if (r === clearTimeout) return clearTimeout(e);
            if ((r === A || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

            try {
              r(e);
            } catch (n) {
              try {
                return r.call(null, e);
              } catch (n) {
                return r.call(this, e);
              }
            }
          }(e);
        }
      }

      function C(e, n) {
        this.fun = e, this.array = n;
      }

      function d() {}

      o.nextTick = function (e) {
        var n = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var t = 1; t < arguments.length; t++) {
          n[t - 1] = arguments[t];
        }
        a.push(new C(e, n)), 1 !== a.length || c || s(m);
      }, C.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = d, o.addListener = d, o.once = d, o.off = d, o.removeListener = d, o.removeAllListeners = d, o.emit = d, o.prependListener = d, o.prependOnceListener = d, o.listeners = function (e) {
        return [];
      }, o.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, o.cwd = function () {
        return "/";
      }, o.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, o.umask = function () {
        return 0;
      };
    }, function (e, n, t) {
      (function (e) {
        function t(e) {
          return Object.prototype.toString.call(e);
        }

        n.isArray = function (e) {
          return Array.isArray ? Array.isArray(e) : "[object Array]" === t(e);
        }, n.isBoolean = function (e) {
          return "boolean" == typeof e;
        }, n.isNull = function (e) {
          return null === e;
        }, n.isNullOrUndefined = function (e) {
          return null == e;
        }, n.isNumber = function (e) {
          return "number" == typeof e;
        }, n.isString = function (e) {
          return "string" == typeof e;
        }, n.isSymbol = function (e) {
          return "symbol" == typeof e;
        }, n.isUndefined = function (e) {
          return void 0 === e;
        }, n.isRegExp = function (e) {
          return "[object RegExp]" === t(e);
        }, n.isObject = function (e) {
          return "object" == typeof e && null !== e;
        }, n.isDate = function (e) {
          return "[object Date]" === t(e);
        }, n.isError = function (e) {
          return "[object Error]" === t(e) || e instanceof Error;
        }, n.isFunction = function (e) {
          return "function" == typeof e;
        }, n.isPrimitive = function (e) {
          return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
        }, n.isBuffer = e.isBuffer;
      }).call(n, t(5).Buffer);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\formatting.ts", o = "c01f9e22f2c89c64381db15bedbe0002c347f3ae", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\formatting.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 18
            },
            end: {
              line: 4,
              column: 40
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 42
            }
          },
          4: {
            start: {
              line: 6,
              column: 15
            },
            end: {
              line: 6,
              column: 34
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 39
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 43
            }
          },
          7: {
            start: {
              line: 9,
              column: 18
            },
            end: {
              line: 9,
              column: 40
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 40
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 21
            }
          },
          10: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 16,
              column: 12
            }
          },
          11: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 20
            }
          },
          12: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 23
            }
          },
          13: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 25,
              column: 12
            }
          },
          14: {
            start: {
              line: 28,
              column: 0
            },
            end: {
              line: 28,
              column: 46
            }
          },
          15: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 27
            }
          },
          16: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 34,
              column: 12
            }
          },
          17: {
            start: {
              line: 37,
              column: 0
            },
            end: {
              line: 37,
              column: 44
            }
          },
          18: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 21
            }
          },
          19: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 43,
              column: 12
            }
          },
          20: {
            start: {
              line: 46,
              column: 0
            },
            end: {
              line: 46,
              column: 26
            }
          },
          21: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 23
            }
          },
          22: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 52,
              column: 12
            }
          },
          23: {
            start: {
              line: 55,
              column: 0
            },
            end: {
              line: 55,
              column: 52
            }
          },
          24: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 24
            }
          },
          25: {
            start: {
              line: 59,
              column: 8
            },
            end: {
              line: 61,
              column: 12
            }
          },
          26: {
            start: {
              line: 64,
              column: 0
            },
            end: {
              line: 64,
              column: 20
            }
          },
          27: {
            start: {
              line: 67,
              column: 8
            },
            end: {
              line: 67,
              column: 25
            }
          },
          28: {
            start: {
              line: 68,
              column: 8
            },
            end: {
              line: 70,
              column: 12
            }
          },
          29: {
            start: {
              line: 73,
              column: 0
            },
            end: {
              line: 73,
              column: 22
            }
          },
          30: {
            start: {
              line: 76,
              column: 8
            },
            end: {
              line: 76,
              column: 27
            }
          },
          31: {
            start: {
              line: 77,
              column: 8
            },
            end: {
              line: 79,
              column: 12
            }
          },
          32: {
            start: {
              line: 82,
              column: 0
            },
            end: {
              line: 82,
              column: 36
            }
          },
          33: {
            start: {
              line: 85,
              column: 8
            },
            end: {
              line: 85,
              column: 26
            }
          },
          34: {
            start: {
              line: 86,
              column: 8
            },
            end: {
              line: 88,
              column: 12
            }
          },
          35: {
            start: {
              line: 91,
              column: 0
            },
            end: {
              line: 91,
              column: 24
            }
          },
          36: {
            start: {
              line: 94,
              column: 8
            },
            end: {
              line: 94,
              column: 27
            }
          },
          37: {
            start: {
              line: 95,
              column: 8
            },
            end: {
              line: 97,
              column: 12
            }
          },
          38: {
            start: {
              line: 100,
              column: 0
            },
            end: {
              line: 100,
              column: 26
            }
          },
          39: {
            start: {
              line: 103,
              column: 8
            },
            end: {
              line: 103,
              column: 26
            }
          },
          40: {
            start: {
              line: 104,
              column: 8
            },
            end: {
              line: 106,
              column: 12
            }
          },
          41: {
            start: {
              line: 109,
              column: 0
            },
            end: {
              line: 109,
              column: 24
            }
          },
          42: {
            start: {
              line: 112,
              column: 8
            },
            end: {
              line: 112,
              column: 29
            }
          },
          43: {
            start: {
              line: 113,
              column: 8
            },
            end: {
              line: 115,
              column: 12
            }
          },
          44: {
            start: {
              line: 118,
              column: 0
            },
            end: {
              line: 118,
              column: 30
            }
          },
          45: {
            start: {
              line: 121,
              column: 8
            },
            end: {
              line: 121,
              column: 26
            }
          },
          46: {
            start: {
              line: 122,
              column: 8
            },
            end: {
              line: 124,
              column: 12
            }
          },
          47: {
            start: {
              line: 127,
              column: 0
            },
            end: {
              line: 127,
              column: 24
            }
          },
          48: {
            start: {
              line: 130,
              column: 8
            },
            end: {
              line: 130,
              column: 22
            }
          },
          49: {
            start: {
              line: 131,
              column: 8
            },
            end: {
              line: 133,
              column: 12
            }
          },
          50: {
            start: {
              line: 136,
              column: 0
            },
            end: {
              line: 136,
              column: 20
            }
          },
          51: {
            start: {
              line: 139,
              column: 8
            },
            end: {
              line: 139,
              column: 24
            }
          },
          52: {
            start: {
              line: 140,
              column: 8
            },
            end: {
              line: 142,
              column: 12
            }
          },
          53: {
            start: {
              line: 145,
              column: 0
            },
            end: {
              line: 145,
              column: 46
            }
          },
          54: {
            start: {
              line: 148,
              column: 8
            },
            end: {
              line: 148,
              column: 23
            }
          },
          55: {
            start: {
              line: 149,
              column: 8
            },
            end: {
              line: 151,
              column: 12
            }
          },
          56: {
            start: {
              line: 154,
              column: 0
            },
            end: {
              line: 154,
              column: 34
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 12
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 18
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 21
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 23
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 30
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 39,
                column: 4
              },
              end: {
                line: 39,
                column: 5
              }
            },
            loc: {
              start: {
                line: 39,
                column: 18
              },
              end: {
                line: 44,
                column: 5
              }
            },
            line: 39
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 48,
                column: 4
              },
              end: {
                line: 48,
                column: 5
              }
            },
            loc: {
              start: {
                line: 48,
                column: 18
              },
              end: {
                line: 53,
                column: 5
              }
            },
            line: 48
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 57,
                column: 4
              },
              end: {
                line: 57,
                column: 5
              }
            },
            loc: {
              start: {
                line: 57,
                column: 18
              },
              end: {
                line: 62,
                column: 5
              }
            },
            line: 57
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 66,
                column: 4
              },
              end: {
                line: 66,
                column: 5
              }
            },
            loc: {
              start: {
                line: 66,
                column: 23
              },
              end: {
                line: 71,
                column: 5
              }
            },
            line: 66
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 75,
                column: 4
              },
              end: {
                line: 75,
                column: 5
              }
            },
            loc: {
              start: {
                line: 75,
                column: 18
              },
              end: {
                line: 80,
                column: 5
              }
            },
            line: 75
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 84,
                column: 4
              },
              end: {
                line: 84,
                column: 5
              }
            },
            loc: {
              start: {
                line: 84,
                column: 18
              },
              end: {
                line: 89,
                column: 5
              }
            },
            line: 84
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 93,
                column: 4
              },
              end: {
                line: 93,
                column: 5
              }
            },
            loc: {
              start: {
                line: 93,
                column: 18
              },
              end: {
                line: 98,
                column: 5
              }
            },
            line: 93
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 102,
                column: 4
              },
              end: {
                line: 102,
                column: 5
              }
            },
            loc: {
              start: {
                line: 102,
                column: 18
              },
              end: {
                line: 107,
                column: 5
              }
            },
            line: 102
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 111,
                column: 4
              },
              end: {
                line: 111,
                column: 5
              }
            },
            loc: {
              start: {
                line: 111,
                column: 18
              },
              end: {
                line: 116,
                column: 5
              }
            },
            line: 111
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 120,
                column: 4
              },
              end: {
                line: 120,
                column: 5
              }
            },
            loc: {
              start: {
                line: 120,
                column: 18
              },
              end: {
                line: 125,
                column: 5
              }
            },
            line: 120
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 129,
                column: 4
              },
              end: {
                line: 129,
                column: 5
              }
            },
            loc: {
              start: {
                line: 129,
                column: 22
              },
              end: {
                line: 134,
                column: 5
              }
            },
            line: 129
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 138,
                column: 4
              },
              end: {
                line: 138,
                column: 5
              }
            },
            loc: {
              start: {
                line: 138,
                column: 22
              },
              end: {
                line: 143,
                column: 5
              }
            },
            line: 138
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 147,
                column: 4
              },
              end: {
                line: 147,
                column: 5
              }
            },
            loc: {
              start: {
                line: 147,
                column: 18
              },
              end: {
                line: 152,
                column: 5
              }
            },
            line: 147
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/formatting.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\formatting.ts"],
          names: [],
          mappings: ";;AAAA,wDAA+D;AAC/D,yCAAwC;AAA/B,gCAAA,SAAS,CAAA;AAClB,mCAAkD;AAAzC,6BAAA,SAAS,CAAA;AAAE,+BAAA,WAAW,CAAA;AAC/B,yCAAuC;AAA9B,+BAAA,QAAQ,CAAA;AAEjB,UAAkB,SAAQ,6BAAY;IAClC;QACI,KAAK,CAAC,KAAK,CAAC,CAAC;QACb,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,oBASC;AAED,uBAA+B,SAAQ,6BAAY;IAC/C;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,8CASC;AAED,sBAA8B,SAAQ,6BAAY;IAC9C,YAAY,KAAa;QACrB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,4CASC;AAED,aAAqB,SAAQ,6BAAY;IACrC;QACI,KAAK,CAAC,KAAK,CAAC,CAAC;QACb,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,0BASC;AAED,0BAAkC,SAAQ,6BAAY;IAClD;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,oDASC;AAED,UAAkB,SAAQ,6BAAY;IAClC;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,oBASC;AAED,WAAmB,SAAQ,6BAAY;IACnC,YAAY,KAAa;QACrB,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,sBASC;AAED,kBAA0B,SAAQ,6BAAY;IAC1C;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,oCASC;AAED,YAAoB,SAAQ,6BAAY;IACpC;QACI,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,wBASC;AAED,aAAqB,SAAQ,6BAAY;IACrC;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,0BASC;AAED,YAAoB,SAAQ,6BAAY;IACpC;QACI,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,wBASC;AAED,eAAuB,SAAQ,6BAAY;IACvC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,8BASC;AAED,YAAoB,SAAQ,6BAAY;IACpC;QACI,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,wBASC;AAED,UAAkB,SAAQ,6BAAY;IAClC,YAAY,IAAY;QACpB,KAAK,CAAC,MAAM,CAAC,CAAC;QACd,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,oBASC;AAED,uBAA+B,SAAQ,6BAAY;IAC/C,YAAY,IAAY;QACpB,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,8CASC;AAED,iBAAyB,SAAQ,6BAAY;IACzC;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,kCASC",
          sourcesContent: ['import { Attributes, XmlComponent } from "file/xml-components";\r\nexport { Underline } from "./underline";\r\nexport { SubScript, SuperScript } from "./script";\r\nexport { RunFonts } from "./run-fonts";\r\n\r\nexport class Bold extends XmlComponent {\r\n    constructor() {\r\n        super("w:b");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class BoldComplexScript extends XmlComponent {\r\n    constructor() {\r\n        super("w:bCs");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class CharacterSpacing extends XmlComponent {\r\n    constructor(value: number) {\r\n        super("w:spacing");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Italics extends XmlComponent {\r\n    constructor() {\r\n        super("w:i");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class ItalicsComplexScript extends XmlComponent {\r\n    constructor() {\r\n        super("w:iCs");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Caps extends XmlComponent {\r\n    constructor() {\r\n        super("w:caps");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Color extends XmlComponent {\r\n    constructor(color: string) {\r\n        super("w:color");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: color,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class DoubleStrike extends XmlComponent {\r\n    constructor() {\r\n        super("w:dstrike");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Emboss extends XmlComponent {\r\n    constructor() {\r\n        super("w:emboss");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Imprint extends XmlComponent {\r\n    constructor() {\r\n        super("w:imprint");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Shadow extends XmlComponent {\r\n    constructor() {\r\n        super("w:shadow");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class SmallCaps extends XmlComponent {\r\n    constructor() {\r\n        super("w:smallCaps");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Strike extends XmlComponent {\r\n    constructor() {\r\n        super("w:strike");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Size extends XmlComponent {\r\n    constructor(size: number) {\r\n        super("w:sz");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: size,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class SizeComplexScript extends XmlComponent {\r\n    constructor(size: number) {\r\n        super("w:szCs");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: size,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class RightToLeft extends XmlComponent {\r\n    constructor() {\r\n        super("w:rtl");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: true,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      var u = (a.s[2]++, t(64));
      a.s[3]++, n.Underline = u.Underline;
      var p = (a.s[4]++, t(65));
      a.s[5]++, n.SubScript = p.SubScript, a.s[6]++, n.SuperScript = p.SuperScript;
      var m = (a.s[7]++, t(37));
      a.s[8]++, n.RunFonts = m.RunFonts;

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent) {
        _inherits(C, _c$XmlComponent);

        function C() {
          var _this2;

          _classCallCheck(this, C);

          a.f[0]++, a.s[9]++, _this2 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:b")), a.s[10]++, _this2.root.push(new c.Attributes({
            val: !0
          }));
          return _this2;
        }

        return C;
      }(c.XmlComponent);

      a.s[11]++, n.Bold = C;

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent2) {
        _inherits(d, _c$XmlComponent2);

        function d() {
          var _this3;

          _classCallCheck(this, d);

          a.f[1]++, a.s[12]++, _this3 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "w:bCs")), a.s[13]++, _this3.root.push(new c.Attributes({
            val: !0
          }));
          return _this3;
        }

        return d;
      }(c.XmlComponent);

      a.s[14]++, n.BoldComplexScript = d;

      var f =
      /*#__PURE__*/
      function (_c$XmlComponent3) {
        _inherits(f, _c$XmlComponent3);

        function f(e) {
          var _this4;

          _classCallCheck(this, f);

          a.f[2]++, a.s[15]++, _this4 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "w:spacing")), a.s[16]++, _this4.root.push(new c.Attributes({
            val: e
          }));
          return _this4;
        }

        return f;
      }(c.XmlComponent);

      a.s[17]++, n.CharacterSpacing = f;

      var h =
      /*#__PURE__*/
      function (_c$XmlComponent4) {
        _inherits(h, _c$XmlComponent4);

        function h() {
          var _this5;

          _classCallCheck(this, h);

          a.f[3]++, a.s[18]++, _this5 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, "w:i")), a.s[19]++, _this5.root.push(new c.Attributes({
            val: !0
          }));
          return _this5;
        }

        return h;
      }(c.XmlComponent);

      a.s[20]++, n.Italics = h;

      var x =
      /*#__PURE__*/
      function (_c$XmlComponent5) {
        _inherits(x, _c$XmlComponent5);

        function x() {
          var _this6;

          _classCallCheck(this, x);

          a.f[4]++, a.s[21]++, _this6 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, "w:iCs")), a.s[22]++, _this6.root.push(new c.Attributes({
            val: !0
          }));
          return _this6;
        }

        return x;
      }(c.XmlComponent);

      a.s[23]++, n.ItalicsComplexScript = x;

      var g =
      /*#__PURE__*/
      function (_c$XmlComponent6) {
        _inherits(g, _c$XmlComponent6);

        function g() {
          var _this7;

          _classCallCheck(this, g);

          a.f[5]++, a.s[24]++, _this7 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, "w:caps")), a.s[25]++, _this7.root.push(new c.Attributes({
            val: !0
          }));
          return _this7;
        }

        return g;
      }(c.XmlComponent);

      a.s[26]++, n.Caps = g;

      var I =
      /*#__PURE__*/
      function (_c$XmlComponent7) {
        _inherits(I, _c$XmlComponent7);

        function I(e) {
          var _this8;

          _classCallCheck(this, I);

          a.f[6]++, a.s[27]++, _this8 = _possibleConstructorReturn(this, _getPrototypeOf(I).call(this, "w:color")), a.s[28]++, _this8.root.push(new c.Attributes({
            val: e
          }));
          return _this8;
        }

        return I;
      }(c.XmlComponent);

      a.s[29]++, n.Color = I;

      var b =
      /*#__PURE__*/
      function (_c$XmlComponent8) {
        _inherits(b, _c$XmlComponent8);

        function b() {
          var _this9;

          _classCallCheck(this, b);

          a.f[7]++, a.s[30]++, _this9 = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this, "w:dstrike")), a.s[31]++, _this9.root.push(new c.Attributes({
            val: !0
          }));
          return _this9;
        }

        return b;
      }(c.XmlComponent);

      a.s[32]++, n.DoubleStrike = b;

      var y =
      /*#__PURE__*/
      function (_c$XmlComponent9) {
        _inherits(y, _c$XmlComponent9);

        function y() {
          var _this10;

          _classCallCheck(this, y);

          a.f[8]++, a.s[33]++, _this10 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this, "w:emboss")), a.s[34]++, _this10.root.push(new c.Attributes({
            val: !0
          }));
          return _this10;
        }

        return y;
      }(c.XmlComponent);

      a.s[35]++, n.Emboss = y;

      var E =
      /*#__PURE__*/
      function (_c$XmlComponent10) {
        _inherits(E, _c$XmlComponent10);

        function E() {
          var _this11;

          _classCallCheck(this, E);

          a.f[9]++, a.s[36]++, _this11 = _possibleConstructorReturn(this, _getPrototypeOf(E).call(this, "w:imprint")), a.s[37]++, _this11.root.push(new c.Attributes({
            val: !0
          }));
          return _this11;
        }

        return E;
      }(c.XmlComponent);

      a.s[38]++, n.Imprint = E;

      var v =
      /*#__PURE__*/
      function (_c$XmlComponent11) {
        _inherits(v, _c$XmlComponent11);

        function v() {
          var _this12;

          _classCallCheck(this, v);

          a.f[10]++, a.s[39]++, _this12 = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this, "w:shadow")), a.s[40]++, _this12.root.push(new c.Attributes({
            val: !0
          }));
          return _this12;
        }

        return v;
      }(c.XmlComponent);

      a.s[41]++, n.Shadow = v;

      var w =
      /*#__PURE__*/
      function (_c$XmlComponent12) {
        _inherits(w, _c$XmlComponent12);

        function w() {
          var _this13;

          _classCallCheck(this, w);

          a.f[11]++, a.s[42]++, _this13 = _possibleConstructorReturn(this, _getPrototypeOf(w).call(this, "w:smallCaps")), a.s[43]++, _this13.root.push(new c.Attributes({
            val: !0
          }));
          return _this13;
        }

        return w;
      }(c.XmlComponent);

      a.s[44]++, n.SmallCaps = w;

      var B =
      /*#__PURE__*/
      function (_c$XmlComponent13) {
        _inherits(B, _c$XmlComponent13);

        function B() {
          var _this14;

          _classCallCheck(this, B);

          a.f[12]++, a.s[45]++, _this14 = _possibleConstructorReturn(this, _getPrototypeOf(B).call(this, "w:strike")), a.s[46]++, _this14.root.push(new c.Attributes({
            val: !0
          }));
          return _this14;
        }

        return B;
      }(c.XmlComponent);

      a.s[47]++, n.Strike = B;

      var _ =
      /*#__PURE__*/
      function (_c$XmlComponent14) {
        _inherits(_, _c$XmlComponent14);

        function _(e) {
          var _this15;

          _classCallCheck(this, _);

          a.f[13]++, a.s[48]++, _this15 = _possibleConstructorReturn(this, _getPrototypeOf(_).call(this, "w:sz")), a.s[49]++, _this15.root.push(new c.Attributes({
            val: e
          }));
          return _this15;
        }

        return _;
      }(c.XmlComponent);

      a.s[50]++, n.Size = _;

      var D =
      /*#__PURE__*/
      function (_c$XmlComponent15) {
        _inherits(D, _c$XmlComponent15);

        function D(e) {
          var _this16;

          _classCallCheck(this, D);

          a.f[14]++, a.s[51]++, _this16 = _possibleConstructorReturn(this, _getPrototypeOf(D).call(this, "w:szCs")), a.s[52]++, _this16.root.push(new c.Attributes({
            val: e
          }));
          return _this16;
        }

        return D;
      }(c.XmlComponent);

      a.s[53]++, n.SizeComplexScript = D;

      var S =
      /*#__PURE__*/
      function (_c$XmlComponent16) {
        _inherits(S, _c$XmlComponent16);

        function S() {
          var _this17;

          _classCallCheck(this, S);

          a.f[15]++, a.s[54]++, _this17 = _possibleConstructorReturn(this, _getPrototypeOf(S).call(this, "w:rtl")), a.s[55]++, _this17.root.push(new c.Attributes({
            val: !0
          }));
          return _this17;
        }

        return S;
      }(c.XmlComponent);

      a.s[56]++, n.RightToLeft = S;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\index.ts", o = "260f23cbb4698fe3eb1eea6956a7b26fc5d518cb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 29
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 28
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 29
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/media/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\media\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,6BAAwB;AACxB,4BAAuB;AACvB,6BAAwB",
          sourcesContent: ['export * from "./media";\r\nexport * from "./data";\r\nexport * from "./image";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(254)), a.s[5]++, c(t(255)), a.s[6]++, c(t(100));
    }, function (e, n, t) {
      "use strict";

      var r = null;
      r = "undefined" != typeof Promise ? Promise : t(312), e.exports = {
        Promise: r
      };
    }, function (e, n, t) {
      "use strict";

      (function (n) {
        !n.version || 0 === n.version.indexOf("v0.") || 0 === n.version.indexOf("v1.") && 0 !== n.version.indexOf("v1.8.") ? e.exports = function (e, t, r, o) {
          if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
          var i,
              A,
              s = arguments.length;

          switch (s) {
            case 0:
            case 1:
              return n.nextTick(e);

            case 2:
              return n.nextTick(function () {
                e.call(null, t);
              });

            case 3:
              return n.nextTick(function () {
                e.call(null, t, r);
              });

            case 4:
              return n.nextTick(function () {
                e.call(null, t, r, o);
              });

            default:
              for (i = new Array(s - 1), A = 0; A < i.length;) {
                i[A++] = arguments[A];
              }

              return n.nextTick(function () {
                e.apply(null, i);
              });
          }
        } : e.exports = n.nextTick;
      }).call(n, t(13));
    }, function (e, n, t) {
      var r = t(5),
          o = r.Buffer;

      function i(e, n) {
        for (var t in e) {
          n[t] = e[t];
        }
      }

      function A(e, n, t) {
        return o(e, n, t);
      }

      o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = r : (i(r, n), n.Buffer = A), i(o, A), A.from = function (e, n, t) {
        if ("number" == typeof e) throw new TypeError("Argument must not be a number");
        return o(e, n, t);
      }, A.alloc = function (e, n, t) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        var r = o(e);
        return void 0 !== n ? "string" == typeof t ? r.fill(n, t) : r.fill(n) : r.fill(0), r;
      }, A.allocUnsafe = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return o(e);
      }, A.allocUnsafeSlow = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return r.SlowBuffer(e);
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\space-type.ts", o = "3f298b7bc0a655a832eb355eec8f3589df718901", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\space-type.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 4,
              column: 0
            },
            end: {
              line: 7,
              column: 62
            }
          },
          2: {
            start: {
              line: 5,
              column: 4
            },
            end: {
              line: 5,
              column: 37
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 39
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 1
              },
              end: {
                line: 4,
                column: 2
              }
            },
            loc: {
              start: {
                line: 4,
                column: 22
              },
              end: {
                line: 7,
                column: 1
              }
            },
            line: 4
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 7,
                column: 15
              },
              end: {
                line: 7,
                column: 60
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 7,
                column: 15
              },
              end: {
                line: 7,
                column: 32
              }
            }, {
              start: {
                line: 7,
                column: 37
              },
              end: {
                line: 7,
                column: 59
              }
            }],
            line: 7
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/space-type.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\space-type.ts"],
          names: [],
          mappings: ";;AAAA,IAAY,SAGX;AAHD,WAAY,SAAS;IACjB,gCAAmB,CAAA;IACnB,kCAAqB,CAAA;AACzB,CAAC,EAHW,SAAS,GAAT,iBAAS,KAAT,iBAAS,QAGpB",
          sourcesContent: ['export enum SpaceType {\r\n    DEFAULT = "default",\r\n    PRESERVE = "preserve",\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[1]++, function (e) {
        a.f[0]++, a.s[2]++, e.DEFAULT = "default", a.s[3]++, e.PRESERVE = "preserve";
      }((a.b[0][0]++, n.SpaceType || (a.b[0][1]++, n.SpaceType = {})));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\properties.ts", o = "a40148cec938be8422d3bb6e1329c0a8a9a7a51b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 23
            }
          },
          3: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 29
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 15
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 8
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,mBAA2B,SAAQ,6BAAY;IAC3C;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;IACnB,CAAC;IAEM,IAAI,CAAC,IAAkB;QAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;IACzB,CAAC;CACJ;AARD,sCAQC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class RunProperties extends XmlComponent {\r\n    constructor() {\r\n        super("w:rPr");\r\n    }\r\n\r\n    public push(item: XmlComponent): void {\r\n        this.root.push(item);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent17) {
        _inherits(u, _c$XmlComponent17);

        function u() {
          var _this18;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this18 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:rPr"));
          return _this18;
        }

        _createClass(u, [{
          key: "push",
          value: function push(e) {
            a.f[1]++, a.s[3]++, this.root.push(e);
          }
        }]);

        return u;
      }(c.XmlComponent);

      a.s[4]++, n.RunProperties = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\properties.ts", o = "d51c89a45e6b039f870e92296881b6e205805bfe", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 17
            },
            end: {
              line: 4,
              column: 47
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 23
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 53
            }
          },
          5: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 40
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 29
            }
          },
          7: {
            start: {
              line: 17,
              column: 0
            },
            end: {
              line: 17,
              column: 50
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 19
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 10
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 15
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 13
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\properties.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,gDAA6C;AAE7C,yBAAiC,SAAQ,6BAAY;IAGjD;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,eAAe,GAAG,IAAI,eAAM,EAAE,CAAC;IACxC,CAAC;IAEM,YAAY;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,eAAe,CAAC,CAAC;IACpC,CAAC;IAEM,IAAI,CAAC,IAAkB;QAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;IACzB,CAAC;CACJ;AAfD,kDAeC",
          sourcesContent: ['// http://officeopenxml.com/WPparagraphProperties.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { Border } from "./formatting/border";\r\n\r\nexport class ParagraphProperties extends XmlComponent {\r\n    public readonly paragraphBorder: Border;\r\n\r\n    constructor() {\r\n        super("w:pPr");\r\n        this.paragraphBorder = new Border();\r\n    }\r\n\r\n    public createBorder(): void {\r\n        this.push(this.paragraphBorder);\r\n    }\r\n\r\n    public push(item: XmlComponent): void {\r\n        this.root.push(item);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(35));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent18) {
        _inherits(p, _c$XmlComponent18);

        function p() {
          var _this19;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this19 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:pPr")), a.s[4]++, _this19.paragraphBorder = new u.Border();
          return _this19;
        }

        _createClass(p, [{
          key: "createBorder",
          value: function createBorder() {
            a.f[1]++, a.s[5]++, this.push(this.paragraphBorder);
          }
        }, {
          key: "push",
          value: function push(e) {
            a.f[2]++, a.s[6]++, this.root.push(e);
          }
        }]);

        return p;
      }(c.XmlComponent);

      a.s[7]++, n.ParagraphProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\index.ts", o = "707971fb3dd0a39a8035f6dd162c918fc6c4b0fd", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 29
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 34
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,6BAAwB;AACxB,kCAA6B;AAC7B,wCAAmC",
          sourcesContent: ['export * from "./table";\r\nexport * from "./table-cell";\r\nexport * from "./table-properties";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(216)), a.s[5]++, c(t(40)), a.s[6]++, c(t(83));
    }, function (e, n, t) {
      "use strict";

      (function (n) {
        e.exports = {
          isNode: void 0 !== n,
          newBufferFrom: function newBufferFrom(e, t) {
            return new n(e, t);
          },
          allocBuffer: function allocBuffer(e) {
            return n.alloc ? n.alloc(e) : new n(e);
          },
          isBuffer: function isBuffer(e) {
            return n.isBuffer(e);
          },
          isStream: function isStream(e) {
            return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
          }
        };
      }).call(n, t(5).Buffer);
    }, function (e, n) {
      var t = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = t);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\index.ts", o = "646bd7657e15b514d3df2318d5ce889d9403cdea", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 33
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 29
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 28
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 39
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 33
            }
          },
          9: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 29
            }
          },
          10: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 31
            }
          },
          11: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 32
            }
          },
          12: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 30
            }
          },
          13: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 41
            }
          },
          14: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,iCAA4B;AAC5B,6BAAwB;AACxB,4BAAuB;AACvB,uCAAkC;AAClC,iCAA4B;AAC5B,6BAAwB;AACxB,+BAA0B;AAC1B,gCAA2B;AAC3B,8BAAyB;AACzB,yCAAoC;AACpC,sCAAiC",
          sourcesContent: ['export * from "./paragraph";\r\nexport * from "./table";\r\nexport * from "./file";\r\nexport * from "./file-properties";\r\nexport * from "./numbering";\r\nexport * from "./media";\r\nexport * from "./drawing";\r\nexport * from "./document";\r\nexport * from "./styles";\r\nexport * from "./table-of-contents";\r\nexport * from "./xml-components";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(2)), a.s[5]++, c(t(23)), a.s[6]++, c(t(227)), a.s[7]++, c(t(286)), a.s[8]++, c(t(102)), a.s[9]++, c(t(16)), a.s[10]++, c(t(67)), a.s[11]++, c(t(86)), a.s[12]++, c(t(44)), a.s[13]++, c(t(287)), a.s[14]++, c(t(0));
    }, function (e, n, t) {
      var r = t(54),
          o = t(147),
          i = t(60),
          A = t(148);
      e.exports = {
        xml2js: r,
        xml2json: o,
        js2xml: i,
        json2xml: A
      };
    }, function (e, n, t) {
      e.exports = o;
      var r = t(29).EventEmitter;

      function o() {
        r.call(this);
      }

      t(10)(o, r), o.Readable = t(30), o.Writable = t(143), o.Duplex = t(144), o.Transform = t(145), o.PassThrough = t(146), o.Stream = o, o.prototype.pipe = function (e, n) {
        var t = this;

        function o(n) {
          e.writable && !1 === e.write(n) && t.pause && t.pause();
        }

        function i() {
          t.readable && t.resume && t.resume();
        }

        t.on("data", o), e.on("drain", i), e._isStdio || n && !1 === n.end || (t.on("end", s), t.on("close", l));
        var A = !1;

        function s() {
          A || (A = !0, e.end());
        }

        function l() {
          A || (A = !0, "function" == typeof e.destroy && e.destroy());
        }

        function a(e) {
          if (c(), 0 === r.listenerCount(this, "error")) throw e;
        }

        function c() {
          t.removeListener("data", o), e.removeListener("drain", i), t.removeListener("end", s), t.removeListener("close", l), t.removeListener("error", a), e.removeListener("error", a), t.removeListener("end", c), t.removeListener("close", c), e.removeListener("close", c);
        }

        return t.on("error", a), e.on("error", a), t.on("end", c), t.on("close", c), e.on("close", c), e.emit("pipe", t), e;
      };
    }, function (e, n) {
      function t() {
        this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
      }

      function r(e) {
        return "function" == typeof e;
      }

      function o(e) {
        return "object" == typeof e && null !== e;
      }

      function i(e) {
        return void 0 === e;
      }

      e.exports = t, t.EventEmitter = t, t.prototype._events = void 0, t.prototype._maxListeners = void 0, t.defaultMaxListeners = 10, t.prototype.setMaxListeners = function (e) {
        if ("number" != typeof e || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
        return this._maxListeners = e, this;
      }, t.prototype.emit = function (e) {
        var n, t, A, s, l, a;

        if (this._events || (this._events = {}), "error" === e && (!this._events.error || o(this._events.error) && !this._events.error.length)) {
          if ((n = arguments[1]) instanceof Error) throw n;
          var c = new Error('Uncaught, unspecified "error" event. (' + n + ")");
          throw c.context = n, c;
        }

        if (i(t = this._events[e])) return !1;
        if (r(t)) switch (arguments.length) {
          case 1:
            t.call(this);
            break;

          case 2:
            t.call(this, arguments[1]);
            break;

          case 3:
            t.call(this, arguments[1], arguments[2]);
            break;

          default:
            s = Array.prototype.slice.call(arguments, 1), t.apply(this, s);
        } else if (o(t)) for (s = Array.prototype.slice.call(arguments, 1), A = (a = t.slice()).length, l = 0; l < A; l++) {
          a[l].apply(this, s);
        }
        return !0;
      }, t.prototype.addListener = function (e, n) {
        var A;
        if (!r(n)) throw TypeError("listener must be a function");
        return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, r(n.listener) ? n.listener : n), this._events[e] ? o(this._events[e]) ? this._events[e].push(n) : this._events[e] = [this._events[e], n] : this._events[e] = n, o(this._events[e]) && !this._events[e].warned && (A = i(this._maxListeners) ? t.defaultMaxListeners : this._maxListeners) && A > 0 && this._events[e].length > A && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace()), this;
      }, t.prototype.on = t.prototype.addListener, t.prototype.once = function (e, n) {
        if (!r(n)) throw TypeError("listener must be a function");
        var t = !1;

        function o() {
          this.removeListener(e, o), t || (t = !0, n.apply(this, arguments));
        }

        return o.listener = n, this.on(e, o), this;
      }, t.prototype.removeListener = function (e, n) {
        var t, i, A, s;
        if (!r(n)) throw TypeError("listener must be a function");
        if (!this._events || !this._events[e]) return this;
        if (A = (t = this._events[e]).length, i = -1, t === n || r(t.listener) && t.listener === n) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, n);else if (o(t)) {
          for (s = A; s-- > 0;) {
            if (t[s] === n || t[s].listener && t[s].listener === n) {
              i = s;
              break;
            }
          }

          if (i < 0) return this;
          1 === t.length ? (t.length = 0, delete this._events[e]) : t.splice(i, 1), this._events.removeListener && this.emit("removeListener", e, n);
        }
        return this;
      }, t.prototype.removeAllListeners = function (e) {
        var n, t;
        if (!this._events) return this;
        if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;

        if (0 === arguments.length) {
          for (n in this._events) {
            "removeListener" !== n && this.removeAllListeners(n);
          }

          return this.removeAllListeners("removeListener"), this._events = {}, this;
        }

        if (r(t = this._events[e])) this.removeListener(e, t);else if (t) for (; t.length;) {
          this.removeListener(e, t[t.length - 1]);
        }
        return delete this._events[e], this;
      }, t.prototype.listeners = function (e) {
        return this._events && this._events[e] ? r(this._events[e]) ? [this._events[e]] : this._events[e].slice() : [];
      }, t.prototype.listenerCount = function (e) {
        if (this._events) {
          var n = this._events[e];
          if (r(n)) return 1;
          if (n) return n.length;
        }

        return 0;
      }, t.listenerCount = function (e, n) {
        return e.listenerCount(n);
      };
    }, function (e, n, t) {
      (n = e.exports = t(56)).Stream = n, n.Readable = n, n.Writable = t(31), n.Duplex = t(9), n.Transform = t(59), n.PassThrough = t(142);
    }, function (e, n, t) {
      "use strict";

      (function (n, r, o) {
        var i = t(18);

        function A(e) {
          var n = this;
          this.next = null, this.entry = null, this.finish = function () {
            !function (e, n, t) {
              var r = e.entry;

              for (e.entry = null; r;) {
                var o = r.callback;
                n.pendingcb--, o(t), r = r.next;
              }

              n.corkedRequestsFree ? n.corkedRequestsFree.next = e : n.corkedRequestsFree = e;
            }(n, e);
          };
        }

        e.exports = x;
        var s,
            l = !n.browser && ["v0.10", "v0.9."].indexOf(n.version.slice(0, 5)) > -1 ? r : i;
        x.WritableState = h;
        var a = t(14);
        a.inherits = t(10);

        var c,
            u = {
          deprecate: t(141)
        },
            p = t(57),
            m = t(19).Buffer,
            C = o.Uint8Array || function () {},
            d = t(58);

        function f() {}

        function h(e, n) {
          s = s || t(9), e = e || {}, this.objectMode = !!e.objectMode, n instanceof s && (this.objectMode = this.objectMode || !!e.writableObjectMode);
          var r = e.highWaterMark,
              o = this.objectMode ? 16 : 16384;
          this.highWaterMark = r || 0 === r ? r : o, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
          var a = !1 === e.decodeStrings;
          this.decodeStrings = !a, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
            !function (e, n) {
              var t = e._writableState,
                  r = t.sync,
                  o = t.writecb;
              if (function (e) {
                e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
              }(t), n) !function (e, n, t, r, o) {
                --n.pendingcb, t ? (i(o, r), i(v, e, n), e._writableState.errorEmitted = !0, e.emit("error", r)) : (o(r), e._writableState.errorEmitted = !0, e.emit("error", r), v(e, n));
              }(e, t, r, n, o);else {
                var A = y(t);
                A || t.corked || t.bufferProcessing || !t.bufferedRequest || b(e, t), r ? l(I, e, t, A, o) : I(e, t, A, o);
              }
            }(n, e);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new A(this);
        }

        function x(e) {
          if (s = s || t(9), !(c.call(x, this) || this instanceof s)) return new x(e);
          this._writableState = new h(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), p.call(this);
        }

        function g(e, n, t, r, o, i, A) {
          n.writelen = r, n.writecb = A, n.writing = !0, n.sync = !0, t ? e._writev(o, n.onwrite) : e._write(o, i, n.onwrite), n.sync = !1;
        }

        function I(e, n, t, r) {
          t || function (e, n) {
            0 === n.length && n.needDrain && (n.needDrain = !1, e.emit("drain"));
          }(e, n), n.pendingcb--, r(), v(e, n);
        }

        function b(e, n) {
          n.bufferProcessing = !0;
          var t = n.bufferedRequest;

          if (e._writev && t && t.next) {
            var r = n.bufferedRequestCount,
                o = new Array(r),
                i = n.corkedRequestsFree;
            i.entry = t;

            for (var s = 0, l = !0; t;) {
              o[s] = t, t.isBuf || (l = !1), t = t.next, s += 1;
            }

            o.allBuffers = l, g(e, n, !0, n.length, o, "", i.finish), n.pendingcb++, n.lastBufferedRequest = null, i.next ? (n.corkedRequestsFree = i.next, i.next = null) : n.corkedRequestsFree = new A(n);
          } else {
            for (; t;) {
              var a = t.chunk,
                  c = t.encoding,
                  u = t.callback;
              if (g(e, n, !1, n.objectMode ? 1 : a.length, a, c, u), t = t.next, n.writing) break;
            }

            null === t && (n.lastBufferedRequest = null);
          }

          n.bufferedRequestCount = 0, n.bufferedRequest = t, n.bufferProcessing = !1;
        }

        function y(e) {
          return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
        }

        function E(e, n) {
          e._final(function (t) {
            n.pendingcb--, t && e.emit("error", t), n.prefinished = !0, e.emit("prefinish"), v(e, n);
          });
        }

        function v(e, n) {
          var t = y(n);
          return t && (function (e, n) {
            n.prefinished || n.finalCalled || ("function" == typeof e._final ? (n.pendingcb++, n.finalCalled = !0, i(E, e, n)) : (n.prefinished = !0, e.emit("prefinish")));
          }(e, n), 0 === n.pendingcb && (n.finished = !0, e.emit("finish"))), t;
        }

        a.inherits(x, p), h.prototype.getBuffer = function () {
          for (var e = this.bufferedRequest, n = []; e;) {
            n.push(e), e = e.next;
          }

          return n;
        }, function () {
          try {
            Object.defineProperty(h.prototype, "buffer", {
              get: u.deprecate(function () {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
          } catch (e) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (c = Function.prototype[Symbol.hasInstance], Object.defineProperty(x, Symbol.hasInstance, {
          value: function value(e) {
            return !!c.call(this, e) || e && e._writableState instanceof h;
          }
        })) : c = function c(e) {
          return e instanceof this;
        }, x.prototype.pipe = function () {
          this.emit("error", new Error("Cannot pipe, not readable"));
        }, x.prototype.write = function (e, n, t) {
          var r,
              o = this._writableState,
              A = !1,
              s = (r = e, (m.isBuffer(r) || r instanceof C) && !o.objectMode);
          return s && !m.isBuffer(e) && (e = function (e) {
            return m.from(e);
          }(e)), "function" == typeof n && (t = n, n = null), s ? n = "buffer" : n || (n = o.defaultEncoding), "function" != typeof t && (t = f), o.ended ? function (e, n) {
            var t = new Error("write after end");
            e.emit("error", t), i(n, t);
          }(this, t) : (s || function (e, n, t, r) {
            var o = !0,
                A = !1;
            return null === t ? A = new TypeError("May not write null values to stream") : "string" == typeof t || void 0 === t || n.objectMode || (A = new TypeError("Invalid non-string/buffer chunk")), A && (e.emit("error", A), i(r, A), o = !1), o;
          }(this, o, e, t)) && (o.pendingcb++, A = function (e, n, t, r, o, i) {
            if (!t) {
              var A = function (e, n, t) {
                return e.objectMode || !1 === e.decodeStrings || "string" != typeof n || (n = m.from(n, t)), n;
              }(n, r, o);

              r !== A && (t = !0, o = "buffer", r = A);
            }

            var s = n.objectMode ? 1 : r.length;
            n.length += s;
            var l = n.length < n.highWaterMark;

            if (l || (n.needDrain = !0), n.writing || n.corked) {
              var a = n.lastBufferedRequest;
              n.lastBufferedRequest = {
                chunk: r,
                encoding: o,
                isBuf: t,
                callback: i,
                next: null
              }, a ? a.next = n.lastBufferedRequest : n.bufferedRequest = n.lastBufferedRequest, n.bufferedRequestCount += 1;
            } else g(e, n, !1, s, r, o, i);

            return l;
          }(this, o, s, e, n, t)), A;
        }, x.prototype.cork = function () {
          this._writableState.corked++;
        }, x.prototype.uncork = function () {
          var e = this._writableState;
          e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || b(this, e));
        }, x.prototype.setDefaultEncoding = function (e) {
          if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
          return this._writableState.defaultEncoding = e, this;
        }, x.prototype._write = function (e, n, t) {
          t(new Error("_write() is not implemented"));
        }, x.prototype._writev = null, x.prototype.end = function (e, n, t) {
          var r = this._writableState;
          "function" == typeof e ? (t = e, e = null, n = null) : "function" == typeof n && (t = n, n = null), null != e && this.write(e, n), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || function (e, n, t) {
            n.ending = !0, v(e, n), t && (n.finished ? i(t) : e.once("finish", t)), n.ended = !0, e.writable = !1;
          }(this, r, t);
        }, Object.defineProperty(x.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._writableState && this._writableState.destroyed;
          },
          set: function set(e) {
            this._writableState && (this._writableState.destroyed = e);
          }
        }), x.prototype.destroy = d.destroy, x.prototype._undestroy = d.undestroy, x.prototype._destroy = function (e, n) {
          this.end(), n(e);
        };
      }).call(n, t(13), t(139).setImmediate, t(8));
    }, function (e, n, t) {
      "use strict";

      var r = t(19).Buffer,
          o = r.isEncoding || function (e) {
        switch ((e = "" + e) && e.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;

          default:
            return !1;
        }
      };

      function i(e) {
        var n;

        switch (this.encoding = function (e) {
          var n = function (e) {
            if (!e) return "utf8";

            for (var n;;) {
              switch (e) {
                case "utf8":
                case "utf-8":
                  return "utf8";

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return "utf16le";

                case "latin1":
                case "binary":
                  return "latin1";

                case "base64":
                case "ascii":
                case "hex":
                  return e;

                default:
                  if (n) return;
                  e = ("" + e).toLowerCase(), n = !0;
              }
            }
          }(e);

          if ("string" != typeof n && (r.isEncoding === o || !o(e))) throw new Error("Unknown encoding: " + e);
          return n || e;
        }(e), this.encoding) {
          case "utf16le":
            this.text = l, this.end = a, n = 4;
            break;

          case "utf8":
            this.fillLast = s, n = 4;
            break;

          case "base64":
            this.text = c, this.end = u, n = 3;
            break;

          default:
            return this.write = p, void (this.end = m);
        }

        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(n);
      }

      function A(e) {
        return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : -1;
      }

      function s(e) {
        var n = this.lastTotal - this.lastNeed,
            t = function (e, n, t) {
          if (128 != (192 & n[0])) return e.lastNeed = 0, "�".repeat(t);

          if (e.lastNeed > 1 && n.length > 1) {
            if (128 != (192 & n[1])) return e.lastNeed = 1, "�".repeat(t + 1);
            if (e.lastNeed > 2 && n.length > 2 && 128 != (192 & n[2])) return e.lastNeed = 2, "�".repeat(t + 2);
          }
        }(this, e, n);

        return void 0 !== t ? t : this.lastNeed <= e.length ? (e.copy(this.lastChar, n, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, n, 0, e.length), void (this.lastNeed -= e.length));
      }

      function l(e, n) {
        if ((e.length - n) % 2 == 0) {
          var t = e.toString("utf16le", n);

          if (t) {
            var r = t.charCodeAt(t.length - 1);
            if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], t.slice(0, -1);
          }

          return t;
        }

        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", n, e.length - 1);
      }

      function a(e) {
        var n = e && e.length ? this.write(e) : "";

        if (this.lastNeed) {
          var t = this.lastTotal - this.lastNeed;
          return n + this.lastChar.toString("utf16le", 0, t);
        }

        return n;
      }

      function c(e, n) {
        var t = (e.length - n) % 3;
        return 0 === t ? e.toString("base64", n) : (this.lastNeed = 3 - t, this.lastTotal = 3, 1 === t ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", n, e.length - t));
      }

      function u(e) {
        var n = e && e.length ? this.write(e) : "";
        return this.lastNeed ? n + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : n;
      }

      function p(e) {
        return e.toString(this.encoding);
      }

      function m(e) {
        return e && e.length ? this.write(e) : "";
      }

      n.StringDecoder = i, i.prototype.write = function (e) {
        if (0 === e.length) return "";
        var n, t;

        if (this.lastNeed) {
          if (void 0 === (n = this.fillLast(e))) return "";
          t = this.lastNeed, this.lastNeed = 0;
        } else t = 0;

        return t < e.length ? n ? n + this.text(e, t) : this.text(e, t) : n || "";
      }, i.prototype.end = function (e) {
        var n = e && e.length ? this.write(e) : "";
        return this.lastNeed ? n + "�".repeat(this.lastTotal - this.lastNeed) : n;
      }, i.prototype.text = function (e, n) {
        var t = function (e, n, t) {
          var r = n.length - 1;
          if (r < t) return 0;
          var o = A(n[r]);
          return o >= 0 ? (o > 0 && (e.lastNeed = o - 1), o) : --r < t ? 0 : (o = A(n[r])) >= 0 ? (o > 0 && (e.lastNeed = o - 2), o) : --r < t ? 0 : (o = A(n[r])) >= 0 ? (o > 0 && (2 === o ? o = 0 : e.lastNeed = o - 3), o) : 0;
        }(this, e, n);

        if (!this.lastNeed) return e.toString("utf8", n);
        this.lastTotal = t;
        var r = e.length - (t - this.lastNeed);
        return e.copy(this.lastChar, 0, r), e.toString("utf8", n, r);
      }, i.prototype.fillLast = function (e) {
        if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
      };
    }, function (e, n, t) {
      var r = t(34).isArray;
      e.exports = {
        copyOptions: function copyOptions(e) {
          var n,
              t = {};

          for (n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }

          return t;
        },
        ensureFlagExists: function ensureFlagExists(e, n) {
          e in n && "boolean" == typeof n[e] || (n[e] = !1);
        },
        ensureSpacesExists: function ensureSpacesExists(e) {
          "spaces" in e && ("number" == typeof e.spaces || "string" == typeof e.spaces) || (e.spaces = 0);
        },
        ensureAlwaysArrayExists: function ensureAlwaysArrayExists(e) {
          "alwaysArray" in e && ("boolean" == typeof e.alwaysArray || r(e.alwaysArray)) || (e.alwaysArray = !1);
        },
        ensureKeyExists: function ensureKeyExists(e, n) {
          e + "Key" in n && "string" == typeof n[e + "Key"] || (n[e + "Key"] = n.compact ? "_" + e : e);
        },
        checkFnExists: function checkFnExists(e, n) {
          return e + "Fn" in n;
        }
      };
    }, function (e, n) {
      e.exports = {
        isArray: function isArray(e) {
          return Array.isArray ? Array.isArray(e) : "[object Array]" === Object.prototype.toString.call(e);
        }
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\border.ts", o = "6b36b49ea658eb65555989518a1eb95ee7a59701", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\border.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 22
            },
            end: {
              line: 11,
              column: 10
            }
          },
          3: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 30
            }
          },
          4: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 20
            }
          },
          5: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 24
            }
          },
          6: {
            start: {
              line: 21,
              column: 20
            },
            end: {
              line: 21,
              column: 47
            }
          },
          7: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 53
            }
          },
          8: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 28
            }
          },
          9: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 20
            }
          },
          10: {
            start: {
              line: 27,
              column: 23
            },
            end: {
              line: 27,
              column: 53
            }
          },
          11: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 56
            }
          },
          12: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 31
            }
          },
          13: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 20
            }
          },
          14: {
            start: {
              line: 33,
              column: 21
            },
            end: {
              line: 33,
              column: 49
            }
          },
          15: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 54
            }
          },
          16: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 29
            }
          },
          17: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 20
            }
          },
          18: {
            start: {
              line: 39,
              column: 22
            },
            end: {
              line: 39,
              column: 51
            }
          },
          19: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 55
            }
          },
          20: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 30
            }
          },
          21: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 20
            }
          },
          22: {
            start: {
              line: 45,
              column: 0
            },
            end: {
              line: 45,
              column: 24
            }
          },
          23: {
            start: {
              line: 48,
              column: 8
            },
            end: {
              line: 48,
              column: 24
            }
          },
          24: {
            start: {
              line: 49,
              column: 23
            },
            end: {
              line: 49,
              column: 53
            }
          },
          25: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 57
            }
          },
          26: {
            start: {
              line: 51,
              column: 8
            },
            end: {
              line: 51,
              column: 31
            }
          },
          27: {
            start: {
              line: 54,
              column: 0
            },
            end: {
              line: 54,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 45
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 18
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 17
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 76
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 20
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 79
              },
              end: {
                line: 31,
                column: 5
              }
            },
            line: 26
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 32,
                column: 4
              },
              end: {
                line: 32,
                column: 5
              }
            },
            loc: {
              start: {
                line: 32,
                column: 77
              },
              end: {
                line: 37,
                column: 5
              }
            },
            line: 32
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 38,
                column: 4
              },
              end: {
                line: 38,
                column: 5
              }
            },
            loc: {
              start: {
                line: 38,
                column: 78
              },
              end: {
                line: 43,
                column: 5
              }
            },
            line: 38
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 47,
                column: 4
              },
              end: {
                line: 47,
                column: 5
              }
            },
            loc: {
              start: {
                line: 47,
                column: 18
              },
              end: {
                line: 52,
                column: 5
              }
            },
            line: 47
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 20,
                column: 17
              },
              end: {
                line: 20,
                column: 31
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 20,
                column: 25
              },
              end: {
                line: 20,
                column: 31
              }
            }],
            line: 20
          },
          1: {
            loc: {
              start: {
                line: 20,
                column: 33
              },
              end: {
                line: 20,
                column: 44
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 20,
                column: 41
              },
              end: {
                line: 20,
                column: 44
              }
            }],
            line: 20
          },
          2: {
            loc: {
              start: {
                line: 20,
                column: 46
              },
              end: {
                line: 20,
                column: 62
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 20,
                column: 54
              },
              end: {
                line: 20,
                column: 62
              }
            }],
            line: 20
          },
          3: {
            loc: {
              start: {
                line: 20,
                column: 64
              },
              end: {
                line: 20,
                column: 74
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 20,
                column: 71
              },
              end: {
                line: 20,
                column: 74
              }
            }],
            line: 20
          },
          4: {
            loc: {
              start: {
                line: 26,
                column: 20
              },
              end: {
                line: 26,
                column: 34
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 26,
                column: 28
              },
              end: {
                line: 26,
                column: 34
              }
            }],
            line: 26
          },
          5: {
            loc: {
              start: {
                line: 26,
                column: 36
              },
              end: {
                line: 26,
                column: 47
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 26,
                column: 44
              },
              end: {
                line: 26,
                column: 47
              }
            }],
            line: 26
          },
          6: {
            loc: {
              start: {
                line: 26,
                column: 49
              },
              end: {
                line: 26,
                column: 65
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 26,
                column: 57
              },
              end: {
                line: 26,
                column: 65
              }
            }],
            line: 26
          },
          7: {
            loc: {
              start: {
                line: 26,
                column: 67
              },
              end: {
                line: 26,
                column: 77
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 26,
                column: 74
              },
              end: {
                line: 26,
                column: 77
              }
            }],
            line: 26
          },
          8: {
            loc: {
              start: {
                line: 32,
                column: 18
              },
              end: {
                line: 32,
                column: 32
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 32,
                column: 26
              },
              end: {
                line: 32,
                column: 32
              }
            }],
            line: 32
          },
          9: {
            loc: {
              start: {
                line: 32,
                column: 34
              },
              end: {
                line: 32,
                column: 45
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 32,
                column: 42
              },
              end: {
                line: 32,
                column: 45
              }
            }],
            line: 32
          },
          10: {
            loc: {
              start: {
                line: 32,
                column: 47
              },
              end: {
                line: 32,
                column: 63
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 32,
                column: 55
              },
              end: {
                line: 32,
                column: 63
              }
            }],
            line: 32
          },
          11: {
            loc: {
              start: {
                line: 32,
                column: 65
              },
              end: {
                line: 32,
                column: 75
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 32,
                column: 72
              },
              end: {
                line: 32,
                column: 75
              }
            }],
            line: 32
          },
          12: {
            loc: {
              start: {
                line: 38,
                column: 19
              },
              end: {
                line: 38,
                column: 33
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 38,
                column: 27
              },
              end: {
                line: 38,
                column: 33
              }
            }],
            line: 38
          },
          13: {
            loc: {
              start: {
                line: 38,
                column: 35
              },
              end: {
                line: 38,
                column: 46
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 38,
                column: 43
              },
              end: {
                line: 38,
                column: 46
              }
            }],
            line: 38
          },
          14: {
            loc: {
              start: {
                line: 38,
                column: 48
              },
              end: {
                line: 38,
                column: 64
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 38,
                column: 56
              },
              end: {
                line: 38,
                column: 64
              }
            }],
            line: 38
          },
          15: {
            loc: {
              start: {
                line: 38,
                column: 66
              },
              end: {
                line: 38,
                column: 76
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 38,
                column: 73
              },
              end: {
                line: 38,
                column: 76
              }
            }],
            line: 38
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        b: {
          0: [0],
          1: [0],
          2: [0],
          3: [0],
          4: [0],
          5: [0],
          6: [0],
          7: [0],
          8: [0],
          9: [0],
          10: [0],
          11: [0],
          12: [0],
          13: [0],
          14: [0],
          15: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/border.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\border.ts"],
          names: [],
          mappings: ";;AACA,wDAA+D;AAE/D,oBAAqB,SAAQ,6BAAY;IAC9B,aAAa,CAAC,KAAa,EAAE,KAAa,EAAE,KAAa,EAAE,IAAY;QAC1E,MAAM,KAAK,GAAG,IAAI,2BAAU,CAAC;YACzB,KAAK,EAAE,KAAK;YACZ,KAAK,EAAE,KAAK;YACZ,GAAG,EAAE,KAAK;YACV,EAAE,EAAE,IAAI;SACX,CAAC,CAAC;QACH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;QAEtB,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAED,YAAoB,SAAQ,6BAAY;IACpC;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;IACpB,CAAC;IAEM,YAAY,CAAC,QAAgB,MAAM,EAAE,QAAgB,GAAG,EAAE,QAAgB,QAAQ,EAAE,OAAe,GAAG;QACzG,MAAM,GAAG,GAAG,IAAI,cAAc,CAAC,OAAO,CAAC,CAAC;QACxC,GAAG,CAAC,aAAa,CAAC,KAAK,EAAE,KAAK,EAAE,KAAK,EAAE,IAAI,CAAC,CAAC;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QAEpB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe,CAAC,QAAgB,MAAM,EAAE,QAAgB,GAAG,EAAE,QAAgB,QAAQ,EAAE,OAAe,GAAG;QAC5G,MAAM,MAAM,GAAG,IAAI,cAAc,CAAC,UAAU,CAAC,CAAC;QAC9C,MAAM,CAAC,aAAa,CAAC,KAAK,EAAE,KAAK,EAAE,KAAK,EAAE,IAAI,CAAC,CAAC;QAChD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;QAEvB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,aAAa,CAAC,QAAgB,MAAM,EAAE,QAAgB,GAAG,EAAE,QAAgB,QAAQ,EAAE,OAAe,GAAG;QAC1G,MAAM,IAAI,GAAG,IAAI,cAAc,CAAC,QAAQ,CAAC,CAAC;QAC1C,IAAI,CAAC,aAAa,CAAC,KAAK,EAAE,KAAK,EAAE,KAAK,EAAE,IAAI,CAAC,CAAC;QAC9C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;QAErB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,cAAc,CAAC,QAAgB,MAAM,EAAE,QAAgB,GAAG,EAAE,QAAgB,QAAQ,EAAE,OAAe,GAAG;QAC3G,MAAM,KAAK,GAAG,IAAI,cAAc,CAAC,SAAS,CAAC,CAAC;QAC5C,KAAK,CAAC,aAAa,CAAC,KAAK,EAAE,KAAK,EAAE,KAAK,EAAE,IAAI,CAAC,CAAC;QAC/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;QAEtB,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AApCD,wBAoCC;AAED,mBAA2B,SAAQ,6BAAY;IAC3C;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,MAAM,MAAM,GAAG,IAAI,cAAc,CAAC,UAAU,CAAC,CAAC;QAC9C,MAAM,CAAC,aAAa,CAAC,MAAM,EAAE,GAAG,EAAE,QAAQ,EAAE,GAAG,CAAC,CAAC;QACjD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;IAC3B,CAAC;CACJ;AAPD,sCAOC",
          sourcesContent: ['// http://officeopenxml.com/WPborders.php\r\nimport { Attributes, XmlComponent } from "file/xml-components";\r\n\r\nclass BorderProperty extends XmlComponent {\r\n    public setProperties(color: string, space: string, value: string, size: string): XmlComponent {\r\n        const attrs = new Attributes({\r\n            color: color,\r\n            space: space,\r\n            val: value,\r\n            sz: size,\r\n        });\r\n        this.root.push(attrs);\r\n\r\n        return this;\r\n    }\r\n}\r\n\r\nexport class Border extends XmlComponent {\r\n    constructor() {\r\n        super("w:pBdr");\r\n    }\r\n\r\n    public addTopBorder(color: string = "auto", space: string = "1", value: string = "single", size: string = "6"): XmlComponent {\r\n        const top = new BorderProperty("w:top");\r\n        top.setProperties(color, space, value, size);\r\n        this.root.push(top);\r\n\r\n        return this;\r\n    }\r\n\r\n    public addBottomBorder(color: string = "auto", space: string = "1", value: string = "single", size: string = "6"): XmlComponent {\r\n        const bottom = new BorderProperty("w:bottom");\r\n        bottom.setProperties(color, space, value, size);\r\n        this.root.push(bottom);\r\n\r\n        return this;\r\n    }\r\n\r\n    public addLeftBorder(color: string = "auto", space: string = "1", value: string = "single", size: string = "6"): XmlComponent {\r\n        const left = new BorderProperty("w:left");\r\n        left.setProperties(color, space, value, size);\r\n        this.root.push(left);\r\n\r\n        return this;\r\n    }\r\n\r\n    public addRightBorder(color: string = "auto", space: string = "1", value: string = "single", size: string = "6"): XmlComponent {\r\n        const right = new BorderProperty("w:right");\r\n        right.setProperties(color, space, value, size);\r\n        this.root.push(right);\r\n\r\n        return this;\r\n    }\r\n}\r\n\r\nexport class ThematicBreak extends XmlComponent {\r\n    constructor() {\r\n        super("w:pBdr");\r\n        const bottom = new BorderProperty("w:bottom");\r\n        bottom.setProperties("auto", "1", "single", "6");\r\n        this.root.push(bottom);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent19) {
        _inherits(u, _c$XmlComponent19);

        function u() {
          _classCallCheck(this, u);

          return _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments));
        }

        _createClass(u, [{
          key: "setProperties",
          value: function setProperties(e, n, t, r) {
            a.f[0]++;
            var o = (a.s[2]++, new c.Attributes({
              color: e,
              space: n,
              val: t,
              sz: r
            }));
            return a.s[3]++, this.root.push(o), a.s[4]++, this;
          }
        }]);

        return u;
      }(c.XmlComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent20) {
        _inherits(p, _c$XmlComponent20);

        function p() {
          var _this20;

          _classCallCheck(this, p);

          a.f[1]++, a.s[5]++, _this20 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:pBdr"));
          return _this20;
        }

        _createClass(p, [{
          key: "addTopBorder",
          value: function addTopBorder() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, "auto");
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[1][0]++, "1");
            var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (a.b[2][0]++, "single");
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (a.b[3][0]++, "6");
            a.f[2]++;
            var o = (a.s[6]++, new u("w:top"));
            return a.s[7]++, o.setProperties(e, n, t, r), a.s[8]++, this.root.push(o), a.s[9]++, this;
          }
        }, {
          key: "addBottomBorder",
          value: function addBottomBorder() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[4][0]++, "auto");
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[5][0]++, "1");
            var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (a.b[6][0]++, "single");
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (a.b[7][0]++, "6");
            a.f[3]++;
            var o = (a.s[10]++, new u("w:bottom"));
            return a.s[11]++, o.setProperties(e, n, t, r), a.s[12]++, this.root.push(o), a.s[13]++, this;
          }
        }, {
          key: "addLeftBorder",
          value: function addLeftBorder() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[8][0]++, "auto");
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[9][0]++, "1");
            var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (a.b[10][0]++, "single");
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (a.b[11][0]++, "6");
            a.f[4]++;
            var o = (a.s[14]++, new u("w:left"));
            return a.s[15]++, o.setProperties(e, n, t, r), a.s[16]++, this.root.push(o), a.s[17]++, this;
          }
        }, {
          key: "addRightBorder",
          value: function addRightBorder() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[12][0]++, "auto");
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[13][0]++, "1");
            var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (a.b[14][0]++, "single");
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (a.b[15][0]++, "6");
            a.f[5]++;
            var o = (a.s[18]++, new u("w:right"));
            return a.s[19]++, o.setProperties(e, n, t, r), a.s[20]++, this.root.push(o), a.s[21]++, this;
          }
        }]);

        return p;
      }(c.XmlComponent);

      a.s[22]++, n.Border = p;

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent21) {
        _inherits(m, _c$XmlComponent21);

        function m() {
          var _this21;

          _classCallCheck(this, m);

          a.f[6]++, a.s[23]++, _this21 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:pBdr"));
          var e = (a.s[24]++, new u("w:bottom"));
          a.s[25]++, e.setProperties("auto", "1", "single", "6"), a.s[26]++, _this21.root.push(e);
          return _this21;
        }

        return m;
      }(c.XmlComponent);

      a.s[27]++, n.ThematicBreak = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\field.ts", o = "45fc534a0e6024f9416ce1e85b3448b6e3a52f22", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\field.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 9,
              column: 52
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 42
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 38
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 48
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 28
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 67
            }
          },
          8: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 27
            }
          },
          9: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 84
            }
          },
          10: {
            start: {
              line: 22,
              column: 0
            },
            end: {
              line: 22,
              column: 22
            }
          },
          11: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 27
            }
          },
          12: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 87
            }
          },
          13: {
            start: {
              line: 29,
              column: 0
            },
            end: {
              line: 29,
              column: 28
            }
          },
          14: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 27
            }
          },
          15: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 82
            }
          },
          16: {
            start: {
              line: 36,
              column: 0
            },
            end: {
              line: 36,
              column: 18
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 31
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 18
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 23
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 17
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 24,
                column: 4
              },
              end: {
                line: 24,
                column: 5
              }
            },
            loc: {
              start: {
                line: 24,
                column: 23
              },
              end: {
                line: 27,
                column: 5
              }
            },
            line: 24
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 31,
                column: 4
              },
              end: {
                line: 31,
                column: 5
              }
            },
            loc: {
              start: {
                line: 31,
                column: 23
              },
              end: {
                line: 34,
                column: 5
              }
            },
            line: 31
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 3
              },
              end: {
                line: 9,
                column: 50
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 3
              },
              end: {
                line: 9,
                column: 21
              }
            }, {
              start: {
                line: 9,
                column: 26
              },
              end: {
                line: 9,
                column: 49
              }
            }],
            line: 9
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/field.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\field.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAE1E,IAAK,kBAIJ;AAJD,WAAK,kBAAkB;IACnB,qCAAe,CAAA;IACf,iCAAW,CAAA;IACX,2CAAqB,CAAA;AACzB,CAAC,EAJI,kBAAkB,KAAlB,kBAAkB,QAItB;AAED,kBAAmB,SAAQ,sCAAsF;IAAjH;;QACuB,YAAO,GAAG,EAAE,IAAI,EAAE,eAAe,EAAE,KAAK,EAAE,SAAS,EAAE,CAAC;IAC7E,CAAC;CAAA;AAED,WAAmB,SAAQ,6BAAY;IACnC,YAAY,KAAe;QACvB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,YAAY,CAAC,EAAE,IAAI,EAAE,kBAAkB,CAAC,KAAK,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAChF,CAAC;CACJ;AALD,sBAKC;AAED,cAAsB,SAAQ,6BAAY;IACtC,YAAY,KAAe;QACvB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,YAAY,CAAC,EAAE,IAAI,EAAE,kBAAkB,CAAC,QAAQ,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IACnF,CAAC;CACJ;AALD,4BAKC;AAED,SAAiB,SAAQ,6BAAY;IACjC,YAAY,KAAe;QACvB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,YAAY,CAAC,EAAE,IAAI,EAAE,kBAAkB,CAAC,GAAG,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAC9E,CAAC;CACJ;AALD,kBAKC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nenum FieldCharacterType {\r\n    BEGIN = "begin",\r\n    END = "end",\r\n    SEPARATE = "separate",\r\n}\r\n\r\nclass FidCharAttrs extends XmlAttributeComponent<{ readonly type: FieldCharacterType; readonly dirty?: boolean }> {\r\n    protected readonly xmlKeys = { type: "w:fldCharType", dirty: "w:dirty" };\r\n}\r\n\r\nexport class Begin extends XmlComponent {\r\n    constructor(dirty?: boolean) {\r\n        super("w:fldChar");\r\n        this.root.push(new FidCharAttrs({ type: FieldCharacterType.BEGIN, dirty }));\r\n    }\r\n}\r\n\r\nexport class Separate extends XmlComponent {\r\n    constructor(dirty?: boolean) {\r\n        super("w:fldChar");\r\n        this.root.push(new FidCharAttrs({ type: FieldCharacterType.SEPARATE, dirty }));\r\n    }\r\n}\r\n\r\nexport class End extends XmlComponent {\r\n    constructor(dirty?: boolean) {\r\n        super("w:fldChar");\r\n        this.root.push(new FidCharAttrs({ type: FieldCharacterType.END, dirty }));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      var u;
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.BEGIN = "begin", a.s[4]++, e.END = "end", a.s[5]++, e.SEPARATE = "separate";
      }((a.b[0][0]++, u || (a.b[0][1]++, u = {})));

      var p =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon2) {
        _inherits(p, _c$XmlAttributeCompon2);

        function p() {
          var _this22;

          _classCallCheck(this, p);

          a.f[1]++, a.s[6]++, _this22 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[7]++, _this22.xmlKeys = {
            type: "w:fldCharType",
            dirty: "w:dirty"
          };
          return _this22;
        }

        return p;
      }(c.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent22) {
        _inherits(m, _c$XmlComponent22);

        function m(e) {
          var _this23;

          _classCallCheck(this, m);

          a.f[2]++, a.s[8]++, _this23 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:fldChar")), a.s[9]++, _this23.root.push(new p({
            type: u.BEGIN,
            dirty: e
          }));
          return _this23;
        }

        return m;
      }(c.XmlComponent);

      a.s[10]++, n.Begin = m;

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent23) {
        _inherits(C, _c$XmlComponent23);

        function C(e) {
          var _this24;

          _classCallCheck(this, C);

          a.f[3]++, a.s[11]++, _this24 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:fldChar")), a.s[12]++, _this24.root.push(new p({
            type: u.SEPARATE,
            dirty: e
          }));
          return _this24;
        }

        return C;
      }(c.XmlComponent);

      a.s[13]++, n.Separate = C;

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent24) {
        _inherits(d, _c$XmlComponent24);

        function d(e) {
          var _this25;

          _classCallCheck(this, d);

          a.f[4]++, a.s[14]++, _this25 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "w:fldChar")), a.s[15]++, _this25.root.push(new p({
            type: u.END,
            dirty: e
          }));
          return _this25;
        }

        return d;
      }(c.XmlComponent);

      a.s[16]++, n.End = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\run-fonts.ts", o = "50f0924e5bb70a9510e2c1ce956f72b104cb02c5", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\run-fonts.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 13,
              column: 10
            }
          },
          4: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 26
            }
          },
          5: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 25,
              column: 12
            }
          },
          6: {
            start: {
              line: 28,
              column: 0
            },
            end: {
              line: 28,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 29
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 17
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/run-fonts.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\run-fonts.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAU1E,uBAAwB,SAAQ,sCAAmD;IAAnF;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,SAAS;YAChB,EAAE,EAAE,MAAM;YACV,QAAQ,EAAE,YAAY;YACtB,KAAK,EAAE,SAAS;YAChB,IAAI,EAAE,QAAQ;SACjB,CAAC;IACN,CAAC;CAAA;AAED,cAAsB,SAAQ,6BAAY;IACtC,YAAY,KAAa,EAAE,IAAa;QACpC,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,iBAAiB,CAAC;YAClB,KAAK,EAAE,KAAK;YACZ,EAAE,EAAE,KAAK;YACT,QAAQ,EAAE,KAAK;YACf,KAAK,EAAE,KAAK;YACZ,IAAI,EAAE,IAAI;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAbD,4BAaC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\ninterface IRunFontAttributesProperties {\r\n    readonly ascii: string;\r\n    readonly cs: string;\r\n    readonly eastAsia: string;\r\n    readonly hAnsi: string;\r\n    readonly hint?: string;\r\n}\r\n\r\nclass RunFontAttributes extends XmlAttributeComponent<IRunFontAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        ascii: "w:ascii",\r\n        cs: "w:cs",\r\n        eastAsia: "w:eastAsia",\r\n        hAnsi: "w:hAnsi",\r\n        hint: "w:hint",\r\n    };\r\n}\r\n\r\nexport class RunFonts extends XmlComponent {\r\n    constructor(ascii: string, hint?: string) {\r\n        super("w:rFonts");\r\n        this.root.push(\r\n            new RunFontAttributes({\r\n                ascii: ascii,\r\n                cs: ascii,\r\n                eastAsia: ascii,\r\n                hAnsi: ascii,\r\n                hint: hint,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon3) {
        _inherits(u, _c$XmlAttributeCompon3);

        function u() {
          var _this26;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this26 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this26.xmlKeys = {
            ascii: "w:ascii",
            cs: "w:cs",
            eastAsia: "w:eastAsia",
            hAnsi: "w:hAnsi",
            hint: "w:hint"
          };
          return _this26;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent25) {
        _inherits(p, _c$XmlComponent25);

        function p(e, n) {
          var _this27;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this27 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:rFonts")), a.s[5]++, _this27.root.push(new u({
            ascii: e,
            cs: e,
            eastAsia: e,
            hAnsi: e,
            hint: n
          }));
          return _this27;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.RunFonts = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\floating-position.ts", o = "c25e5b9438bd6363a3cc67873ec56ec14d966093", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\floating-position.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 4,
              column: 0
            },
            end: {
              line: 13,
              column: 125
            }
          },
          2: {
            start: {
              line: 5,
              column: 4
            },
            end: {
              line: 5,
              column: 62
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 56
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 69
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 65
            }
          },
          6: {
            start: {
              line: 9,
              column: 4
            },
            end: {
              line: 9,
              column: 56
            }
          },
          7: {
            start: {
              line: 10,
              column: 4
            },
            end: {
              line: 10,
              column: 71
            }
          },
          8: {
            start: {
              line: 11,
              column: 4
            },
            end: {
              line: 11,
              column: 52
            }
          },
          9: {
            start: {
              line: 12,
              column: 4
            },
            end: {
              line: 12,
              column: 67
            }
          },
          10: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 24,
              column: 119
            }
          },
          11: {
            start: {
              line: 16,
              column: 4
            },
            end: {
              line: 16,
              column: 67
            }
          },
          12: {
            start: {
              line: 17,
              column: 4
            },
            end: {
              line: 17,
              column: 67
            }
          },
          13: {
            start: {
              line: 18,
              column: 4
            },
            end: {
              line: 18,
              column: 50
            }
          },
          14: {
            start: {
              line: 19,
              column: 4
            },
            end: {
              line: 19,
              column: 54
            }
          },
          15: {
            start: {
              line: 20,
              column: 4
            },
            end: {
              line: 20,
              column: 69
            }
          },
          16: {
            start: {
              line: 21,
              column: 4
            },
            end: {
              line: 21,
              column: 50
            }
          },
          17: {
            start: {
              line: 22,
              column: 4
            },
            end: {
              line: 22,
              column: 60
            }
          },
          18: {
            start: {
              line: 23,
              column: 4
            },
            end: {
              line: 23,
              column: 61
            }
          },
          19: {
            start: {
              line: 26,
              column: 0
            },
            end: {
              line: 32,
              column: 104
            }
          },
          20: {
            start: {
              line: 27,
              column: 4
            },
            end: {
              line: 27,
              column: 49
            }
          },
          21: {
            start: {
              line: 28,
              column: 4
            },
            end: {
              line: 28,
              column: 49
            }
          },
          22: {
            start: {
              line: 29,
              column: 4
            },
            end: {
              line: 29,
              column: 45
            }
          },
          23: {
            start: {
              line: 30,
              column: 4
            },
            end: {
              line: 30,
              column: 51
            }
          },
          24: {
            start: {
              line: 31,
              column: 4
            },
            end: {
              line: 31,
              column: 47
            }
          },
          25: {
            start: {
              line: 34,
              column: 0
            },
            end: {
              line: 40,
              column: 98
            }
          },
          26: {
            start: {
              line: 35,
              column: 4
            },
            end: {
              line: 35,
              column: 47
            }
          },
          27: {
            start: {
              line: 36,
              column: 4
            },
            end: {
              line: 36,
              column: 47
            }
          },
          28: {
            start: {
              line: 37,
              column: 4
            },
            end: {
              line: 37,
              column: 47
            }
          },
          29: {
            start: {
              line: 38,
              column: 4
            },
            end: {
              line: 38,
              column: 49
            }
          },
          30: {
            start: {
              line: 39,
              column: 4
            },
            end: {
              line: 39,
              column: 41
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 1
              },
              end: {
                line: 4,
                column: 2
              }
            },
            loc: {
              start: {
                line: 4,
                column: 43
              },
              end: {
                line: 13,
                column: 1
              }
            },
            line: 4
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 15,
                column: 1
              },
              end: {
                line: 15,
                column: 2
              }
            },
            loc: {
              start: {
                line: 15,
                column: 41
              },
              end: {
                line: 24,
                column: 1
              }
            },
            line: 15
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 26,
                column: 1
              },
              end: {
                line: 26,
                column: 2
              }
            },
            loc: {
              start: {
                line: 26,
                column: 36
              },
              end: {
                line: 32,
                column: 1
              }
            },
            line: 26
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 34,
                column: 1
              },
              end: {
                line: 34,
                column: 2
              }
            },
            loc: {
              start: {
                line: 34,
                column: 34
              },
              end: {
                line: 40,
                column: 1
              }
            },
            line: 34
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 13,
                column: 36
              },
              end: {
                line: 13,
                column: 123
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 13,
                column: 36
              },
              end: {
                line: 13,
                column: 74
              }
            }, {
              start: {
                line: 13,
                column: 79
              },
              end: {
                line: 13,
                column: 122
              }
            }],
            line: 13
          },
          1: {
            loc: {
              start: {
                line: 24,
                column: 34
              },
              end: {
                line: 24,
                column: 117
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 24,
                column: 34
              },
              end: {
                line: 24,
                column: 70
              }
            }, {
              start: {
                line: 24,
                column: 75
              },
              end: {
                line: 24,
                column: 116
              }
            }],
            line: 24
          },
          2: {
            loc: {
              start: {
                line: 32,
                column: 29
              },
              end: {
                line: 32,
                column: 102
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 32,
                column: 29
              },
              end: {
                line: 32,
                column: 60
              }
            }, {
              start: {
                line: 32,
                column: 65
              },
              end: {
                line: 32,
                column: 101
              }
            }],
            line: 32
          },
          3: {
            loc: {
              start: {
                line: 40,
                column: 27
              },
              end: {
                line: 40,
                column: 96
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 40,
                column: 27
              },
              end: {
                line: 40,
                column: 56
              }
            }, {
              start: {
                line: 40,
                column: 61
              },
              end: {
                line: 40,
                column: 95
              }
            }],
            line: 40
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/floating/floating-position.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\floating\\floating-position.ts"],
          names: [],
          mappings: ";;AAGA,IAAY,8BASX;AATD,WAAY,8BAA8B;IACtC,yDAAuB,CAAA;IACvB,mDAAiB,CAAA;IACjB,gEAA8B,CAAA;IAC9B,4DAA0B,CAAA;IAC1B,mDAAiB,CAAA;IACjB,kEAAgC,CAAA;IAChC,+CAAa,CAAA;IACb,8DAA4B,CAAA;AAChC,CAAC,EATW,8BAA8B,GAA9B,sCAA8B,KAA9B,sCAA8B,QASzC;AAED,IAAY,4BASX;AATD,WAAY,4BAA4B;IACpC,8DAA8B,CAAA;IAC9B,8DAA8B,CAAA;IAC9B,6CAAa,CAAA;IACb,iDAAiB,CAAA;IACjB,gEAAgC,CAAA;IAChC,6CAAa,CAAA;IACb,uDAAuB,CAAA;IACvB,wDAAwB,CAAA;AAC5B,CAAC,EATW,4BAA4B,GAA5B,oCAA4B,KAA5B,oCAA4B,QASvC;AAED,IAAY,uBAMX;AAND,WAAY,uBAAuB;IAC/B,4CAAiB,CAAA;IACjB,4CAAiB,CAAA;IACjB,wCAAa,CAAA;IACb,8CAAmB,CAAA;IACnB,0CAAe,CAAA;AACnB,CAAC,EANW,uBAAuB,GAAvB,+BAAuB,KAAvB,+BAAuB,QAMlC;AAED,IAAY,qBAMX;AAND,WAAY,qBAAqB;IAC7B,0CAAiB,CAAA;IACjB,0CAAiB,CAAA;IACjB,0CAAiB,CAAA;IACjB,4CAAmB,CAAA;IACnB,oCAAW,CAAA;AACf,CAAC,EANW,qBAAqB,GAArB,6BAAqB,KAArB,6BAAqB,QAMhC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-position.php\r\nimport { ITextWrapping } from "../text-wrap";\r\n\r\nexport enum HorizontalPositionRelativeFrom {\r\n    CHARACTER = "character",\r\n    COLUMN = "column",\r\n    INSIDE_MARGIN = "insideMargin",\r\n    LEFT_MARGIN = "leftMargin",\r\n    MARGIN = "margin",\r\n    OUTSIDE_MARGIN = "outsideMargin",\r\n    PAGE = "page",\r\n    RIGHT_MARGIN = "rightMargin",\r\n}\r\n\r\nexport enum VerticalPositionRelativeFrom {\r\n    BOTTOM_MARGIN = "bottomMargin",\r\n    INSIDE_MARGIN = "insideMargin",\r\n    LINE = "line",\r\n    MARGIN = "margin",\r\n    OUTSIDE_MARGIN = "outsideMargin",\r\n    PAGE = "page",\r\n    PARAGRAPH = "paragraph",\r\n    TOP_MARGIN = "topMargin",\r\n}\r\n\r\nexport enum HorizontalPositionAlign {\r\n    CENTER = "center",\r\n    INSIDE = "inside",\r\n    LEFT = "left",\r\n    OUTSIDE = "outside",\r\n    RIGHT = "right",\r\n}\r\n\r\nexport enum VerticalPositionAlign {\r\n    BOTTOM = "bottom",\r\n    CENTER = "center",\r\n    INSIDE = "inside",\r\n    OUTSIDE = "outside",\r\n    TOP = "top",\r\n}\r\n\r\nexport interface IHorizontalPositionOptions {\r\n    readonly relative?: HorizontalPositionRelativeFrom;\r\n    readonly align?: HorizontalPositionAlign;\r\n    readonly offset?: number;\r\n}\r\n\r\nexport interface IVerticalPositionOptions {\r\n    readonly relative?: VerticalPositionRelativeFrom;\r\n    readonly align?: VerticalPositionAlign;\r\n    readonly offset?: number;\r\n}\r\n\r\nexport interface IMargins {\r\n    readonly left?: number;\r\n    readonly bottom?: number;\r\n    readonly top?: number;\r\n    readonly right?: number;\r\n}\r\n\r\nexport interface IFloating {\r\n    readonly horizontalPosition: IHorizontalPositionOptions;\r\n    readonly verticalPosition: IVerticalPositionOptions;\r\n    readonly allowOverlap?: boolean;\r\n    readonly lockAnchor?: boolean;\r\n    readonly behindDocument?: boolean;\r\n    readonly layoutInCell?: boolean;\r\n    readonly margins?: IMargins;\r\n    readonly wrap?: ITextWrapping;\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[1]++, function (e) {
        a.f[0]++, a.s[2]++, e.CHARACTER = "character", a.s[3]++, e.COLUMN = "column", a.s[4]++, e.INSIDE_MARGIN = "insideMargin", a.s[5]++, e.LEFT_MARGIN = "leftMargin", a.s[6]++, e.MARGIN = "margin", a.s[7]++, e.OUTSIDE_MARGIN = "outsideMargin", a.s[8]++, e.PAGE = "page", a.s[9]++, e.RIGHT_MARGIN = "rightMargin";
      }((a.b[0][0]++, n.HorizontalPositionRelativeFrom || (a.b[0][1]++, n.HorizontalPositionRelativeFrom = {}))), a.s[10]++, function (e) {
        a.f[1]++, a.s[11]++, e.BOTTOM_MARGIN = "bottomMargin", a.s[12]++, e.INSIDE_MARGIN = "insideMargin", a.s[13]++, e.LINE = "line", a.s[14]++, e.MARGIN = "margin", a.s[15]++, e.OUTSIDE_MARGIN = "outsideMargin", a.s[16]++, e.PAGE = "page", a.s[17]++, e.PARAGRAPH = "paragraph", a.s[18]++, e.TOP_MARGIN = "topMargin";
      }((a.b[1][0]++, n.VerticalPositionRelativeFrom || (a.b[1][1]++, n.VerticalPositionRelativeFrom = {}))), a.s[19]++, function (e) {
        a.f[2]++, a.s[20]++, e.CENTER = "center", a.s[21]++, e.INSIDE = "inside", a.s[22]++, e.LEFT = "left", a.s[23]++, e.OUTSIDE = "outside", a.s[24]++, e.RIGHT = "right";
      }((a.b[2][0]++, n.HorizontalPositionAlign || (a.b[2][1]++, n.HorizontalPositionAlign = {}))), a.s[25]++, function (e) {
        a.f[3]++, a.s[26]++, e.BOTTOM = "bottom", a.s[27]++, e.CENTER = "center", a.s[28]++, e.INSIDE = "inside", a.s[29]++, e.OUTSIDE = "outside", a.s[30]++, e.TOP = "top";
      }((a.b[3][0]++, n.VerticalPositionAlign || (a.b[3][1]++, n.VerticalPositionAlign = {})));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\index.ts", o = "c51ca7c1c92f16e087ef49890c9cac4b3b6eca68", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 37
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 33
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 35
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 34
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 43
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/text-wrap/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\text-wrap\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,qCAAgC;AAChC,iCAA4B;AAC5B,mCAA8B;AAC9B,kCAA6B;AAC7B,2CAAsC",
          sourcesContent: ['export * from "./text-wrapping";\r\nexport * from "./wrap-none";\r\nexport * from "./wrap-square";\r\nexport * from "./wrap-tight";\r\nexport * from "./wrap-top-and-bottom";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(193)), a.s[5]++, c(t(194)), a.s[6]++, c(t(195)), a.s[7]++, c(t(196)), a.s[8]++, c(t(197));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\index.ts", o = "3648db237aabb865a7b08512092fef90780be8a8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 34
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 45
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-cell/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-cell\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,kCAA6B;AAC7B,6CAAwC",
          sourcesContent: ['export * from "./table-cell";\r\nexport * from "./table-cell-components";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(218)), a.s[5]++, c(t(82));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-size\\page-size-attributes.ts", o = "e6913ae6ef71f2331937282d526a5108479d893e", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-size\\page-size-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 8,
              column: 80
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 45
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 47
            }
          },
          5: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 28
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 16,
              column: 10
            }
          },
          7: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 48
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 28
              },
              end: {
                line: 8,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 10
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 8,
                column: 21
              },
              end: {
                line: 8,
                column: 78
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 8,
                column: 21
              },
              end: {
                line: 8,
                column: 44
              }
            }, {
              start: {
                line: 8,
                column: 49
              },
              end: {
                line: 8,
                column: 77
              }
            }],
            line: 8
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-size/page-size-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-size\\page-size-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAE5D,IAAY,eAGX;AAHD,WAAY,eAAe;IACvB,wCAAqB,CAAA;IACrB,0CAAuB,CAAA;AAC3B,CAAC,EAHW,eAAe,GAAf,uBAAe,KAAf,uBAAe,QAG1B;AAQD,wBAAgC,SAAQ,sCAA0C;IAAlF;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,KAAK;YACZ,MAAM,EAAE,KAAK;YACb,WAAW,EAAE,UAAU;SAC1B,CAAC;IACN,CAAC;CAAA;AAND,gDAMC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport enum PageOrientation {\r\n    PORTRAIT = "portrait",\r\n    LANDSCAPE = "landscape",\r\n}\r\n\r\nexport interface IPageSizeAttributes {\r\n    readonly width?: number;\r\n    readonly height?: number;\r\n    readonly orientation?: PageOrientation;\r\n}\r\n\r\nexport class PageSizeAttributes extends XmlAttributeComponent<IPageSizeAttributes> {\r\n    protected readonly xmlKeys = {\r\n        width: "w:w",\r\n        height: "w:h",\r\n        orientation: "w:orient",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.PORTRAIT = "portrait", a.s[4]++, e.LANDSCAPE = "landscape";
      }((a.b[0][0]++, n.PageOrientation || (a.b[0][1]++, n.PageOrientation = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon4) {
        _inherits(u, _c$XmlAttributeCompon4);

        function u() {
          var _this28;

          _classCallCheck(this, u);

          a.f[1]++, a.s[5]++, _this28 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[6]++, _this28.xmlKeys = {
            width: "w:w",
            height: "w:h",
            orientation: "w:orient"
          };
          return _this28;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[7]++, n.PageSizeAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\index.ts", o = "ff0c89f51a3175888e4cdf7307539638c99defea", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 37
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/relationships/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\relationships\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,qCAAgC",
          sourcesContent: ['export * from "./relationships";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(256));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\level.ts", o = "7e26a207e2f85d5e476cf401739428968e713a5e", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\level.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 21
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 5,
              column: 21
            },
            end: {
              line: 5,
              column: 55
            }
          },
          4: {
            start: {
              line: 6,
              column: 19
            },
            end: {
              line: 6,
              column: 57
            }
          },
          5: {
            start: {
              line: 7,
              column: 21
            },
            end: {
              line: 7,
              column: 59
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 28
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 14,
              column: 10
            }
          },
          8: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 25
            }
          },
          9: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 22,
              column: 12
            }
          },
          10: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 26
            }
          },
          11: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 30,
              column: 12
            }
          },
          12: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 27
            }
          },
          13: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 38,
              column: 12
            }
          },
          14: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 25
            }
          },
          15: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 46,
              column: 12
            }
          },
          16: {
            start: {
              line: 50,
              column: 0
            },
            end: {
              line: 54,
              column: 68
            }
          },
          17: {
            start: {
              line: 51,
              column: 4
            },
            end: {
              line: 51,
              column: 39
            }
          },
          18: {
            start: {
              line: 52,
              column: 4
            },
            end: {
              line: 52,
              column: 35
            }
          },
          19: {
            start: {
              line: 53,
              column: 4
            },
            end: {
              line: 53,
              column: 31
            }
          },
          20: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 24
            }
          },
          21: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 60,
              column: 12
            }
          },
          22: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 65,
              column: 23
            }
          },
          23: {
            start: {
              line: 66,
              column: 8
            },
            end: {
              line: 69,
              column: 12
            }
          },
          24: {
            start: {
              line: 70,
              column: 8
            },
            end: {
              line: 72,
              column: 9
            }
          },
          25: {
            start: {
              line: 71,
              column: 12
            },
            end: {
              line: 71,
              column: 45
            }
          },
          26: {
            start: {
              line: 73,
              column: 8
            },
            end: {
              line: 75,
              column: 9
            }
          },
          27: {
            start: {
              line: 74,
              column: 12
            },
            end: {
              line: 74,
              column: 59
            }
          },
          28: {
            start: {
              line: 76,
              column: 8
            },
            end: {
              line: 78,
              column: 9
            }
          },
          29: {
            start: {
              line: 77,
              column: 12
            },
            end: {
              line: 77,
              column: 53
            }
          },
          30: {
            start: {
              line: 79,
              column: 8
            },
            end: {
              line: 81,
              column: 9
            }
          },
          31: {
            start: {
              line: 80,
              column: 12
            },
            end: {
              line: 80,
              column: 47
            }
          },
          32: {
            start: {
              line: 82,
              column: 8
            },
            end: {
              line: 82,
              column: 74
            }
          },
          33: {
            start: {
              line: 83,
              column: 8
            },
            end: {
              line: 83,
              column: 62
            }
          },
          34: {
            start: {
              line: 84,
              column: 8
            },
            end: {
              line: 84,
              column: 49
            }
          },
          35: {
            start: {
              line: 85,
              column: 8
            },
            end: {
              line: 85,
              column: 43
            }
          },
          36: {
            start: {
              line: 88,
              column: 8
            },
            end: {
              line: 88,
              column: 42
            }
          },
          37: {
            start: {
              line: 89,
              column: 8
            },
            end: {
              line: 89,
              column: 20
            }
          },
          38: {
            start: {
              line: 92,
              column: 8
            },
            end: {
              line: 92,
              column: 48
            }
          },
          39: {
            start: {
              line: 93,
              column: 8
            },
            end: {
              line: 93,
              column: 20
            }
          },
          40: {
            start: {
              line: 96,
              column: 8
            },
            end: {
              line: 96,
              column: 42
            }
          },
          41: {
            start: {
              line: 97,
              column: 8
            },
            end: {
              line: 97,
              column: 20
            }
          },
          42: {
            start: {
              line: 100,
              column: 8
            },
            end: {
              line: 100,
              column: 56
            }
          },
          43: {
            start: {
              line: 101,
              column: 8
            },
            end: {
              line: 101,
              column: 20
            }
          },
          44: {
            start: {
              line: 104,
              column: 8
            },
            end: {
              line: 104,
              column: 51
            }
          },
          45: {
            start: {
              line: 105,
              column: 8
            },
            end: {
              line: 105,
              column: 20
            }
          },
          46: {
            start: {
              line: 108,
              column: 8
            },
            end: {
              line: 108,
              column: 54
            }
          },
          47: {
            start: {
              line: 109,
              column: 8
            },
            end: {
              line: 109,
              column: 20
            }
          },
          48: {
            start: {
              line: 112,
              column: 8
            },
            end: {
              line: 112,
              column: 56
            }
          },
          49: {
            start: {
              line: 113,
              column: 8
            },
            end: {
              line: 113,
              column: 20
            }
          },
          50: {
            start: {
              line: 116,
              column: 8
            },
            end: {
              line: 116,
              column: 51
            }
          },
          51: {
            start: {
              line: 117,
              column: 8
            },
            end: {
              line: 117,
              column: 20
            }
          },
          52: {
            start: {
              line: 120,
              column: 8
            },
            end: {
              line: 120,
              column: 53
            }
          },
          53: {
            start: {
              line: 121,
              column: 8
            },
            end: {
              line: 121,
              column: 20
            }
          },
          54: {
            start: {
              line: 124,
              column: 8
            },
            end: {
              line: 124,
              column: 59
            }
          },
          55: {
            start: {
              line: 125,
              column: 8
            },
            end: {
              line: 125,
              column: 20
            }
          },
          56: {
            start: {
              line: 128,
              column: 8
            },
            end: {
              line: 128,
              column: 56
            }
          },
          57: {
            start: {
              line: 129,
              column: 8
            },
            end: {
              line: 129,
              column: 20
            }
          },
          58: {
            start: {
              line: 132,
              column: 8
            },
            end: {
              line: 132,
              column: 58
            }
          },
          59: {
            start: {
              line: 133,
              column: 8
            },
            end: {
              line: 133,
              column: 20
            }
          },
          60: {
            start: {
              line: 136,
              column: 8
            },
            end: {
              line: 136,
              column: 76
            }
          },
          61: {
            start: {
              line: 137,
              column: 8
            },
            end: {
              line: 137,
              column: 20
            }
          },
          62: {
            start: {
              line: 140,
              column: 8
            },
            end: {
              line: 140,
              column: 57
            }
          },
          63: {
            start: {
              line: 141,
              column: 8
            },
            end: {
              line: 141,
              column: 20
            }
          },
          64: {
            start: {
              line: 144,
              column: 8
            },
            end: {
              line: 144,
              column: 63
            }
          },
          65: {
            start: {
              line: 145,
              column: 8
            },
            end: {
              line: 145,
              column: 20
            }
          },
          66: {
            start: {
              line: 148,
              column: 8
            },
            end: {
              line: 148,
              column: 100
            }
          },
          67: {
            start: {
              line: 149,
              column: 8
            },
            end: {
              line: 149,
              column: 20
            }
          },
          68: {
            start: {
              line: 152,
              column: 8
            },
            end: {
              line: 152,
              column: 98
            }
          },
          69: {
            start: {
              line: 153,
              column: 8
            },
            end: {
              line: 153,
              column: 20
            }
          },
          70: {
            start: {
              line: 156,
              column: 8
            },
            end: {
              line: 156,
              column: 99
            }
          },
          71: {
            start: {
              line: 157,
              column: 8
            },
            end: {
              line: 157,
              column: 20
            }
          },
          72: {
            start: {
              line: 160,
              column: 8
            },
            end: {
              line: 160,
              column: 98
            }
          },
          73: {
            start: {
              line: 161,
              column: 8
            },
            end: {
              line: 161,
              column: 20
            }
          },
          74: {
            start: {
              line: 164,
              column: 8
            },
            end: {
              line: 164,
              column: 68
            }
          },
          75: {
            start: {
              line: 165,
              column: 8
            },
            end: {
              line: 165,
              column: 20
            }
          },
          76: {
            start: {
              line: 168,
              column: 8
            },
            end: {
              line: 168,
              column: 70
            }
          },
          77: {
            start: {
              line: 169,
              column: 8
            },
            end: {
              line: 169,
              column: 20
            }
          },
          78: {
            start: {
              line: 172,
              column: 8
            },
            end: {
              line: 172,
              column: 74
            }
          },
          79: {
            start: {
              line: 173,
              column: 8
            },
            end: {
              line: 173,
              column: 20
            }
          },
          80: {
            start: {
              line: 176,
              column: 8
            },
            end: {
              line: 176,
              column: 66
            }
          },
          81: {
            start: {
              line: 177,
              column: 8
            },
            end: {
              line: 177,
              column: 20
            }
          },
          82: {
            start: {
              line: 180,
              column: 8
            },
            end: {
              line: 180,
              column: 68
            }
          },
          83: {
            start: {
              line: 181,
              column: 8
            },
            end: {
              line: 181,
              column: 20
            }
          },
          84: {
            start: {
              line: 184,
              column: 8
            },
            end: {
              line: 184,
              column: 63
            }
          },
          85: {
            start: {
              line: 185,
              column: 8
            },
            end: {
              line: 185,
              column: 20
            }
          },
          86: {
            start: {
              line: 188,
              column: 8
            },
            end: {
              line: 188,
              column: 64
            }
          },
          87: {
            start: {
              line: 189,
              column: 8
            },
            end: {
              line: 189,
              column: 20
            }
          },
          88: {
            start: {
              line: 192,
              column: 0
            },
            end: {
              line: 192,
              column: 30
            }
          },
          89: {
            start: {
              line: 195,
              column: 8
            },
            end: {
              line: 195,
              column: 56
            }
          },
          90: {
            start: {
              line: 198,
              column: 0
            },
            end: {
              line: 198,
              column: 22
            }
          },
          91: {
            start: {
              line: 201,
              column: 0
            },
            end: {
              line: 201,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 9,
                column: 4
              },
              end: {
                line: 9,
                column: 5
              }
            },
            loc: {
              start: {
                line: 9,
                column: 18
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 9
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 18,
                column: 23
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 18
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 23
              },
              end: {
                line: 31,
                column: 5
              }
            },
            line: 26
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 34,
                column: 4
              },
              end: {
                line: 34,
                column: 5
              }
            },
            loc: {
              start: {
                line: 34,
                column: 23
              },
              end: {
                line: 39,
                column: 5
              }
            },
            line: 34
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 42,
                column: 4
              },
              end: {
                line: 42,
                column: 5
              }
            },
            loc: {
              start: {
                line: 42,
                column: 23
              },
              end: {
                line: 47,
                column: 5
              }
            },
            line: 42
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 50,
                column: 1
              },
              end: {
                line: 50,
                column: 2
              }
            },
            loc: {
              start: {
                line: 50,
                column: 24
              },
              end: {
                line: 54,
                column: 1
              }
            },
            line: 50
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 56,
                column: 4
              },
              end: {
                line: 56,
                column: 5
              }
            },
            loc: {
              start: {
                line: 56,
                column: 23
              },
              end: {
                line: 61,
                column: 5
              }
            },
            line: 56
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 64,
                column: 4
              },
              end: {
                line: 64,
                column: 5
              }
            },
            loc: {
              start: {
                line: 64,
                column: 62
              },
              end: {
                line: 86,
                column: 5
              }
            },
            line: 64
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 87,
                column: 4
              },
              end: {
                line: 87,
                column: 5
              }
            },
            loc: {
              start: {
                line: 87,
                column: 21
              },
              end: {
                line: 90,
                column: 5
              }
            },
            line: 87
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 91,
                column: 4
              },
              end: {
                line: 91,
                column: 5
              }
            },
            loc: {
              start: {
                line: 91,
                column: 35
              },
              end: {
                line: 94,
                column: 5
              }
            },
            line: 91
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 95,
                column: 4
              },
              end: {
                line: 95,
                column: 5
              }
            },
            loc: {
              start: {
                line: 95,
                column: 29
              },
              end: {
                line: 98,
                column: 5
              }
            },
            line: 95
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 99,
                column: 4
              },
              end: {
                line: 99,
                column: 5
              }
            },
            loc: {
              start: {
                line: 99,
                column: 16
              },
              end: {
                line: 102,
                column: 5
              }
            },
            line: 99
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 103,
                column: 4
              },
              end: {
                line: 103,
                column: 5
              }
            },
            loc: {
              start: {
                line: 103,
                column: 11
              },
              end: {
                line: 106,
                column: 5
              }
            },
            line: 103
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 107,
                column: 4
              },
              end: {
                line: 107,
                column: 5
              }
            },
            loc: {
              start: {
                line: 107,
                column: 14
              },
              end: {
                line: 110,
                column: 5
              }
            },
            line: 107
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 111,
                column: 4
              },
              end: {
                line: 111,
                column: 5
              }
            },
            loc: {
              start: {
                line: 111,
                column: 16
              },
              end: {
                line: 114,
                column: 5
              }
            },
            line: 111
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 115,
                column: 4
              },
              end: {
                line: 115,
                column: 5
              }
            },
            loc: {
              start: {
                line: 115,
                column: 14
              },
              end: {
                line: 118,
                column: 5
              }
            },
            line: 115
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 119,
                column: 4
              },
              end: {
                line: 119,
                column: 5
              }
            },
            loc: {
              start: {
                line: 119,
                column: 13
              },
              end: {
                line: 122,
                column: 5
              }
            },
            line: 119
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 123,
                column: 4
              },
              end: {
                line: 123,
                column: 5
              }
            },
            loc: {
              start: {
                line: 123,
                column: 19
              },
              end: {
                line: 126,
                column: 5
              }
            },
            line: 123
          },
          18: {
            name: "(anonymous_18)",
            decl: {
              start: {
                line: 127,
                column: 4
              },
              end: {
                line: 127,
                column: 5
              }
            },
            loc: {
              start: {
                line: 127,
                column: 16
              },
              end: {
                line: 130,
                column: 5
              }
            },
            line: 127
          },
          19: {
            name: "(anonymous_19)",
            decl: {
              start: {
                line: 131,
                column: 4
              },
              end: {
                line: 131,
                column: 5
              }
            },
            loc: {
              start: {
                line: 131,
                column: 18
              },
              end: {
                line: 134,
                column: 5
              }
            },
            line: 131
          },
          20: {
            name: "(anonymous_20)",
            decl: {
              start: {
                line: 135,
                column: 4
              },
              end: {
                line: 135,
                column: 5
              }
            },
            loc: {
              start: {
                line: 135,
                column: 36
              },
              end: {
                line: 138,
                column: 5
              }
            },
            line: 135
          },
          21: {
            name: "(anonymous_21)",
            decl: {
              start: {
                line: 139,
                column: 4
              },
              end: {
                line: 139,
                column: 5
              }
            },
            loc: {
              start: {
                line: 139,
                column: 17
              },
              end: {
                line: 142,
                column: 5
              }
            },
            line: 139
          },
          22: {
            name: "(anonymous_22)",
            decl: {
              start: {
                line: 143,
                column: 4
              },
              end: {
                line: 143,
                column: 5
              }
            },
            loc: {
              start: {
                line: 143,
                column: 19
              },
              end: {
                line: 146,
                column: 5
              }
            },
            line: 143
          },
          23: {
            name: "(anonymous_23)",
            decl: {
              start: {
                line: 147,
                column: 4
              },
              end: {
                line: 147,
                column: 5
              }
            },
            loc: {
              start: {
                line: 147,
                column: 13
              },
              end: {
                line: 150,
                column: 5
              }
            },
            line: 147
          },
          24: {
            name: "(anonymous_24)",
            decl: {
              start: {
                line: 151,
                column: 4
              },
              end: {
                line: 151,
                column: 5
              }
            },
            loc: {
              start: {
                line: 151,
                column: 11
              },
              end: {
                line: 154,
                column: 5
              }
            },
            line: 151
          },
          25: {
            name: "(anonymous_25)",
            decl: {
              start: {
                line: 155,
                column: 4
              },
              end: {
                line: 155,
                column: 5
              }
            },
            loc: {
              start: {
                line: 155,
                column: 12
              },
              end: {
                line: 158,
                column: 5
              }
            },
            line: 155
          },
          26: {
            name: "(anonymous_26)",
            decl: {
              start: {
                line: 159,
                column: 4
              },
              end: {
                line: 159,
                column: 5
              }
            },
            loc: {
              start: {
                line: 159,
                column: 16
              },
              end: {
                line: 162,
                column: 5
              }
            },
            line: 159
          },
          27: {
            name: "(anonymous_27)",
            decl: {
              start: {
                line: 163,
                column: 4
              },
              end: {
                line: 163,
                column: 5
              }
            },
            loc: {
              start: {
                line: 163,
                column: 20
              },
              end: {
                line: 166,
                column: 5
              }
            },
            line: 163
          },
          28: {
            name: "(anonymous_28)",
            decl: {
              start: {
                line: 167,
                column: 4
              },
              end: {
                line: 167,
                column: 5
              }
            },
            loc: {
              start: {
                line: 167,
                column: 22
              },
              end: {
                line: 170,
                column: 5
              }
            },
            line: 167
          },
          29: {
            name: "(anonymous_29)",
            decl: {
              start: {
                line: 171,
                column: 4
              },
              end: {
                line: 171,
                column: 5
              }
            },
            loc: {
              start: {
                line: 171,
                column: 26
              },
              end: {
                line: 174,
                column: 5
              }
            },
            line: 171
          },
          30: {
            name: "(anonymous_30)",
            decl: {
              start: {
                line: 175,
                column: 4
              },
              end: {
                line: 175,
                column: 5
              }
            },
            loc: {
              start: {
                line: 175,
                column: 18
              },
              end: {
                line: 178,
                column: 5
              }
            },
            line: 175
          },
          31: {
            name: "(anonymous_31)",
            decl: {
              start: {
                line: 179,
                column: 4
              },
              end: {
                line: 179,
                column: 5
              }
            },
            loc: {
              start: {
                line: 179,
                column: 20
              },
              end: {
                line: 182,
                column: 5
              }
            },
            line: 179
          },
          32: {
            name: "(anonymous_32)",
            decl: {
              start: {
                line: 183,
                column: 4
              },
              end: {
                line: 183,
                column: 5
              }
            },
            loc: {
              start: {
                line: 183,
                column: 15
              },
              end: {
                line: 186,
                column: 5
              }
            },
            line: 183
          },
          33: {
            name: "(anonymous_33)",
            decl: {
              start: {
                line: 187,
                column: 4
              },
              end: {
                line: 187,
                column: 5
              }
            },
            loc: {
              start: {
                line: 187,
                column: 16
              },
              end: {
                line: 190,
                column: 5
              }
            },
            line: 187
          },
          34: {
            name: "(anonymous_34)",
            decl: {
              start: {
                line: 194,
                column: 4
              },
              end: {
                line: 194,
                column: 5
              }
            },
            loc: {
              start: {
                line: 194,
                column: 55
              },
              end: {
                line: 196,
                column: 5
              }
            },
            line: 194
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 54,
                column: 17
              },
              end: {
                line: 54,
                column: 66
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 54,
                column: 17
              },
              end: {
                line: 54,
                column: 36
              }
            }, {
              start: {
                line: 54,
                column: 41
              },
              end: {
                line: 54,
                column: 65
              }
            }],
            line: 54
          },
          1: {
            loc: {
              start: {
                line: 70,
                column: 8
              },
              end: {
                line: 72,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 70,
                column: 8
              },
              end: {
                line: 72,
                column: 9
              }
            }, {
              start: {
                line: 70,
                column: 8
              },
              end: {
                line: 72,
                column: 9
              }
            }],
            line: 70
          },
          2: {
            loc: {
              start: {
                line: 73,
                column: 8
              },
              end: {
                line: 75,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 73,
                column: 8
              },
              end: {
                line: 75,
                column: 9
              }
            }, {
              start: {
                line: 73,
                column: 8
              },
              end: {
                line: 75,
                column: 9
              }
            }],
            line: 73
          },
          3: {
            loc: {
              start: {
                line: 76,
                column: 8
              },
              end: {
                line: 78,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 76,
                column: 8
              },
              end: {
                line: 78,
                column: 9
              }
            }, {
              start: {
                line: 76,
                column: 8
              },
              end: {
                line: 78,
                column: 9
              }
            }],
            line: 76
          },
          4: {
            loc: {
              start: {
                line: 79,
                column: 8
              },
              end: {
                line: 81,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 79,
                column: 8
              },
              end: {
                line: 81,
                column: 9
              }
            }, {
              start: {
                line: 79,
                column: 8
              },
              end: {
                line: 81,
                column: 9
              }
            }],
            line: 79
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0,
          64: 0,
          65: 0,
          66: 0,
          67: 0,
          68: 0,
          69: 0,
          70: 0,
          71: 0,
          72: 0,
          73: 0,
          74: 0,
          75: 0,
          76: 0,
          77: 0,
          78: 0,
          79: 0,
          80: 0,
          81: 0,
          82: 0,
          83: 0,
          84: 0,
          85: 0,
          86: 0,
          87: 0,
          88: 0,
          89: 0,
          90: 0,
          91: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/numbering/level.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\numbering\\level.ts"],
          names: [],
          mappings: ";;AAAA,wDAAsF;AACtF,wDAWiC;AACjC,wDAA8D;AAC9D,0DAA0D;AAC1D,4DAA4D;AAO5D,qBAAsB,SAAQ,sCAAiD;IAA/E;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,QAAQ;YACd,SAAS,EAAE,eAAe;SAC7B,CAAC;IACN,CAAC;CAAA;AAED,WAAY,SAAQ,6BAAY;IAC5B,YAAY,KAAa;QACrB,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,kBAAmB,SAAQ,6BAAY;IACnC,YAAY,KAAa;QACrB,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,eAAgB,SAAQ,6BAAY;IAChC,YAAY,KAAa;QACrB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,aAAc,SAAQ,6BAAY;IAC9B,YAAY,KAAa;QACrB,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,IAAY,WAIX;AAJD,WAAY,WAAW;IACnB,kCAAmB,CAAA;IACnB,8BAAe,CAAA;IACf,0BAAW,CAAA;AACf,CAAC,EAJW,WAAW,GAAX,mBAAW,KAAX,mBAAW,QAItB;AAED,YAAa,SAAQ,6BAAY;IAC7B,YAAY,KAAkB;QAC1B,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,eAAuB,SAAQ,6BAAY;IAIvC,YAAY,KAAa,EAAE,KAAc,EAAE,YAAqB,EAAE,SAAkB,EAAE,KAAc;QAChG,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,eAAe,CAAC;YAChB,IAAI,EAAE,KAAK;YACX,SAAS,EAAE,CAAC;SACf,CAAC,CACL,CAAC;QAEF,IAAI,KAAK,KAAK,SAAS,EAAE;YACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC;SACpC;QACD,IAAI,YAAY,KAAK,SAAS,EAAE;YAC5B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,YAAY,CAAC,YAAY,CAAC,CAAC,CAAC;SAClD;QACD,IAAI,SAAS,KAAK,SAAS,EAAE;YACzB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,SAAS,CAAC,SAAS,CAAC,CAAC,CAAC;SAC5C;QACD,IAAI,KAAK,KAAK,SAAS,EAAE;YACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC;SACtC;QAED,IAAI,CAAC,mBAAmB,GAAG,IAAI,gCAAmB,EAAE,CAAC;QACrD,IAAI,CAAC,aAAa,GAAG,IAAI,0BAAa,EAAE,CAAC;QAEzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,mBAAmB,CAAC,CAAC;QACzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;IACvC,CAAC;IAEM,SAAS,CAAC,KAAkB;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,MAAM,CAAC,KAAK,CAAC,CAAC,CAAC;QAClC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,oBAAoB,CAAC,QAAsB;QAC9C,IAAI,CAAC,mBAAmB,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QACxC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,cAAc,CAAC,QAAsB;QACxC,IAAI,CAAC,aAAa,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QAClC,OAAO,IAAI,CAAC;IAChB,CAAC;IAIM,IAAI,CAAC,KAAa;QACrB,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC;QAChD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI;QACP,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,IAAI,EAAE,CAAC,CAAC;QAC3C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,OAAO;QACV,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,OAAO,EAAE,CAAC,CAAC;QAC9C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,SAAS,EAAE,CAAC,CAAC;QAChD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,OAAO;QACV,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,IAAI,EAAE,CAAC,CAAC;QAC3C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM;QACT,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,MAAM,EAAE,CAAC,CAAC;QAC7C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,YAAY;QACf,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,YAAY,EAAE,CAAC,CAAC;QACnD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,SAAS,EAAE,CAAC,CAAC;QAChD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW;QACd,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,WAAW,EAAE,CAAC,CAAC;QAClD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS,CAAC,aAAsB,EAAE,KAAc;QACnD,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,SAAS,CAAC,aAAa,EAAE,KAAK,CAAC,CAAC,CAAC;QACpE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK,CAAC,KAAa;QACtB,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC;QACjD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI,CAAC,QAAgB;QACxB,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,QAAQ,CAAC,QAAQ,CAAC,CAAC,CAAC;QACvD,OAAO,IAAI,CAAC;IAChB,CAAC;IAIM,MAAM;QACT,IAAI,CAAC,oBAAoB,CAAC,IAAI,sBAAS,CAAC,6BAAgB,CAAC,MAAM,CAAC,CAAC,CAAC;QAClE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI;QACP,IAAI,CAAC,oBAAoB,CAAC,IAAI,sBAAS,CAAC,6BAAgB,CAAC,IAAI,CAAC,CAAC,CAAC;QAChE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK;QACR,IAAI,CAAC,oBAAoB,CAAC,IAAI,sBAAS,CAAC,6BAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;QACjE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,oBAAoB,CAAC,IAAI,sBAAS,CAAC,6BAAgB,CAAC,IAAI,CAAC,CAAC,CAAC;QAChE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,aAAa;QAChB,IAAI,CAAC,oBAAoB,CAAC,IAAI,0BAAa,EAAE,CAAC,CAAC;QAC/C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe;QAClB,IAAI,CAAC,oBAAoB,CAAC,IAAI,4BAAe,EAAE,CAAC,CAAC;QACjD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW,CAAC,QAAgB;QAC/B,IAAI,CAAC,oBAAoB,CAAC,IAAI,wBAAW,CAAC,QAAQ,CAAC,CAAC,CAAC;QACrD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM,CAAC,KAAa;QACvB,IAAI,CAAC,oBAAoB,CAAC,IAAI,mBAAM,CAAC,KAAK,CAAC,CAAC,CAAC;QAC7C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,OAAO,CAAC,MAA0B;QACrC,IAAI,CAAC,oBAAoB,CAAC,IAAI,oBAAO,CAAC,MAAM,CAAC,CAAC,CAAC;QAC/C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,oBAAoB,CAAC,IAAI,qBAAQ,EAAE,CAAC,CAAC;QAC1C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,oBAAoB,CAAC,IAAI,sBAAS,EAAE,CAAC,CAAC;QAC3C,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAtKD,8BAsKC;AAED,WAAmB,SAAQ,SAAS;IAGhC,YAAY,KAAa,EAAE,YAAoB,EAAE,SAAiB,EAAE,KAAa;QAC7E,KAAK,CAAC,KAAK,EAAE,CAAC,EAAE,YAAY,EAAE,SAAS,EAAE,KAAK,CAAC,CAAC;IACpD,CAAC;CACJ;AAND,sBAMC;AAED,sBAA8B,SAAQ,SAAS;CAAG;AAAlD,4CAAkD",
          sourcesContent: ['import { Attributes, XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport {\r\n    Alignment,\r\n    AlignmentOptions,\r\n    Indent,\r\n    ISpacingProperties,\r\n    KeepLines,\r\n    KeepNext,\r\n    LeftTabStop,\r\n    MaxRightTabStop,\r\n    Spacing,\r\n    ThematicBreak,\r\n} from "../paragraph/formatting";\r\nimport { ParagraphProperties } from "../paragraph/properties";\r\nimport * as formatting from "../paragraph/run/formatting";\r\nimport { RunProperties } from "../paragraph/run/properties";\r\n\r\ninterface ILevelAttributesProperties {\r\n    readonly ilvl?: number;\r\n    readonly tentative?: number;\r\n}\r\n\r\nclass LevelAttributes extends XmlAttributeComponent<ILevelAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        ilvl: "w:ilvl",\r\n        tentative: "w15:tentative",\r\n    };\r\n}\r\n\r\nclass Start extends XmlComponent {\r\n    constructor(value: number) {\r\n        super("w:start");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nclass NumberFormat extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:numFmt");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nclass LevelText extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:lvlText");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nclass LevelJc extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:lvlJc");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport enum LevelSuffix {\r\n    NOTHING = "nothing",\r\n    SPACE = "space",\r\n    TAB = "tab",\r\n}\r\n\r\nclass Suffix extends XmlComponent {\r\n    constructor(value: LevelSuffix) {\r\n        super("w:suff");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class LevelBase extends XmlComponent {\r\n    private readonly paragraphProperties: ParagraphProperties;\r\n    private readonly runProperties: RunProperties;\r\n\r\n    constructor(level: number, start?: number, numberFormat?: string, levelText?: string, lvlJc?: string) {\r\n        super("w:lvl");\r\n        this.root.push(\r\n            new LevelAttributes({\r\n                ilvl: level,\r\n                tentative: 1,\r\n            }),\r\n        );\r\n\r\n        if (start !== undefined) {\r\n            this.root.push(new Start(start));\r\n        }\r\n        if (numberFormat !== undefined) {\r\n            this.root.push(new NumberFormat(numberFormat));\r\n        }\r\n        if (levelText !== undefined) {\r\n            this.root.push(new LevelText(levelText));\r\n        }\r\n        if (lvlJc !== undefined) {\r\n            this.root.push(new LevelJc(lvlJc));\r\n        }\r\n\r\n        this.paragraphProperties = new ParagraphProperties();\r\n        this.runProperties = new RunProperties();\r\n\r\n        this.root.push(this.paragraphProperties);\r\n        this.root.push(this.runProperties);\r\n    }\r\n\r\n    public setSuffix(value: LevelSuffix): LevelBase {\r\n        this.root.push(new Suffix(value));\r\n        return this;\r\n    }\r\n\r\n    public addParagraphProperty(property: XmlComponent): Level {\r\n        this.paragraphProperties.push(property);\r\n        return this;\r\n    }\r\n\r\n    public addRunProperty(property: XmlComponent): Level {\r\n        this.runProperties.push(property);\r\n        return this;\r\n    }\r\n\r\n    // ----------  Run formatting ---------------------- //\r\n\r\n    public size(twips: number): Level {\r\n        this.addRunProperty(new formatting.Size(twips));\r\n        return this;\r\n    }\r\n\r\n    public bold(): Level {\r\n        this.addRunProperty(new formatting.Bold());\r\n        return this;\r\n    }\r\n\r\n    public italics(): Level {\r\n        this.addRunProperty(new formatting.Italics());\r\n        return this;\r\n    }\r\n\r\n    public smallCaps(): Level {\r\n        this.addRunProperty(new formatting.SmallCaps());\r\n        return this;\r\n    }\r\n\r\n    public allCaps(): Level {\r\n        this.addRunProperty(new formatting.Caps());\r\n        return this;\r\n    }\r\n\r\n    public strike(): Level {\r\n        this.addRunProperty(new formatting.Strike());\r\n        return this;\r\n    }\r\n\r\n    public doubleStrike(): Level {\r\n        this.addRunProperty(new formatting.DoubleStrike());\r\n        return this;\r\n    }\r\n\r\n    public subScript(): Level {\r\n        this.addRunProperty(new formatting.SubScript());\r\n        return this;\r\n    }\r\n\r\n    public superScript(): Level {\r\n        this.addRunProperty(new formatting.SuperScript());\r\n        return this;\r\n    }\r\n\r\n    public underline(underlineType?: string, color?: string): Level {\r\n        this.addRunProperty(new formatting.Underline(underlineType, color));\r\n        return this;\r\n    }\r\n\r\n    public color(color: string): Level {\r\n        this.addRunProperty(new formatting.Color(color));\r\n        return this;\r\n    }\r\n\r\n    public font(fontName: string): Level {\r\n        this.addRunProperty(new formatting.RunFonts(fontName));\r\n        return this;\r\n    }\r\n\r\n    // --------------------- Paragraph formatting ------------------------ //\r\n\r\n    public center(): Level {\r\n        this.addParagraphProperty(new Alignment(AlignmentOptions.CENTER));\r\n        return this;\r\n    }\r\n\r\n    public left(): Level {\r\n        this.addParagraphProperty(new Alignment(AlignmentOptions.LEFT));\r\n        return this;\r\n    }\r\n\r\n    public right(): Level {\r\n        this.addParagraphProperty(new Alignment(AlignmentOptions.RIGHT));\r\n        return this;\r\n    }\r\n\r\n    public justified(): Level {\r\n        this.addParagraphProperty(new Alignment(AlignmentOptions.BOTH));\r\n        return this;\r\n    }\r\n\r\n    public thematicBreak(): Level {\r\n        this.addParagraphProperty(new ThematicBreak());\r\n        return this;\r\n    }\r\n\r\n    public maxRightTabStop(): Level {\r\n        this.addParagraphProperty(new MaxRightTabStop());\r\n        return this;\r\n    }\r\n\r\n    public leftTabStop(position: number): Level {\r\n        this.addParagraphProperty(new LeftTabStop(position));\r\n        return this;\r\n    }\r\n\r\n    public indent(attrs: object): Level {\r\n        this.addParagraphProperty(new Indent(attrs));\r\n        return this;\r\n    }\r\n\r\n    public spacing(params: ISpacingProperties): Level {\r\n        this.addParagraphProperty(new Spacing(params));\r\n        return this;\r\n    }\r\n\r\n    public keepNext(): Level {\r\n        this.addParagraphProperty(new KeepNext());\r\n        return this;\r\n    }\r\n\r\n    public keepLines(): Level {\r\n        this.addParagraphProperty(new KeepLines());\r\n        return this;\r\n    }\r\n}\r\n\r\nexport class Level extends LevelBase {\r\n    // This is the level that sits under abstractNum. We make a\r\n    // handful of properties required\r\n    constructor(level: number, numberFormat: string, levelText: string, lvlJc: string) {\r\n        super(level, 1, numberFormat, levelText, lvlJc);\r\n    }\r\n}\r\n\r\nexport class LevelForOverride extends LevelBase {}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(50)),
          p = (a.s[3]++, t(22)),
          m = (a.s[4]++, t(15)),
          C = (a.s[5]++, t(21));

      var d =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon5) {
        _inherits(d, _c$XmlAttributeCompon5);

        function d() {
          var _this29;

          _classCallCheck(this, d);

          a.f[0]++, a.s[6]++, _this29 = _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments)), a.s[7]++, _this29.xmlKeys = {
            ilvl: "w:ilvl",
            tentative: "w15:tentative"
          };
          return _this29;
        }

        return d;
      }(c.XmlAttributeComponent);

      var f =
      /*#__PURE__*/
      function (_c$XmlComponent26) {
        _inherits(f, _c$XmlComponent26);

        function f(e) {
          var _this30;

          _classCallCheck(this, f);

          a.f[1]++, a.s[8]++, _this30 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "w:start")), a.s[9]++, _this30.root.push(new c.Attributes({
            val: e
          }));
          return _this30;
        }

        return f;
      }(c.XmlComponent);

      var h =
      /*#__PURE__*/
      function (_c$XmlComponent27) {
        _inherits(h, _c$XmlComponent27);

        function h(e) {
          var _this31;

          _classCallCheck(this, h);

          a.f[2]++, a.s[10]++, _this31 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, "w:numFmt")), a.s[11]++, _this31.root.push(new c.Attributes({
            val: e
          }));
          return _this31;
        }

        return h;
      }(c.XmlComponent);

      var x =
      /*#__PURE__*/
      function (_c$XmlComponent28) {
        _inherits(x, _c$XmlComponent28);

        function x(e) {
          var _this32;

          _classCallCheck(this, x);

          a.f[3]++, a.s[12]++, _this32 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, "w:lvlText")), a.s[13]++, _this32.root.push(new c.Attributes({
            val: e
          }));
          return _this32;
        }

        return x;
      }(c.XmlComponent);

      var g =
      /*#__PURE__*/
      function (_c$XmlComponent29) {
        _inherits(g, _c$XmlComponent29);

        function g(e) {
          var _this33;

          _classCallCheck(this, g);

          a.f[4]++, a.s[14]++, _this33 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, "w:lvlJc")), a.s[15]++, _this33.root.push(new c.Attributes({
            val: e
          }));
          return _this33;
        }

        return g;
      }(c.XmlComponent);

      a.s[16]++, function (e) {
        a.f[5]++, a.s[17]++, e.NOTHING = "nothing", a.s[18]++, e.SPACE = "space", a.s[19]++, e.TAB = "tab";
      }((a.b[0][0]++, n.LevelSuffix || (a.b[0][1]++, n.LevelSuffix = {})));

      var I =
      /*#__PURE__*/
      function (_c$XmlComponent30) {
        _inherits(I, _c$XmlComponent30);

        function I(e) {
          var _this34;

          _classCallCheck(this, I);

          a.f[6]++, a.s[20]++, _this34 = _possibleConstructorReturn(this, _getPrototypeOf(I).call(this, "w:suff")), a.s[21]++, _this34.root.push(new c.Attributes({
            val: e
          }));
          return _this34;
        }

        return I;
      }(c.XmlComponent);

      var b =
      /*#__PURE__*/
      function (_c$XmlComponent31) {
        _inherits(b, _c$XmlComponent31);

        function b(e, n, t, r, o) {
          var _this35;

          _classCallCheck(this, b);

          a.f[7]++, a.s[22]++, _this35 = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this, "w:lvl")), a.s[23]++, _this35.root.push(new d({
            ilvl: e,
            tentative: 1
          })), a.s[24]++, void 0 !== n ? (a.b[1][0]++, a.s[25]++, _this35.root.push(new f(n))) : a.b[1][1]++, a.s[26]++, void 0 !== t ? (a.b[2][0]++, a.s[27]++, _this35.root.push(new h(t))) : a.b[2][1]++, a.s[28]++, void 0 !== r ? (a.b[3][0]++, a.s[29]++, _this35.root.push(new x(r))) : a.b[3][1]++, a.s[30]++, void 0 !== o ? (a.b[4][0]++, a.s[31]++, _this35.root.push(new g(o))) : a.b[4][1]++, a.s[32]++, _this35.paragraphProperties = new p.ParagraphProperties(), a.s[33]++, _this35.runProperties = new C.RunProperties(), a.s[34]++, _this35.root.push(_this35.paragraphProperties), a.s[35]++, _this35.root.push(_this35.runProperties);
          return _this35;
        }

        _createClass(b, [{
          key: "setSuffix",
          value: function setSuffix(e) {
            return a.f[8]++, a.s[36]++, this.root.push(new I(e)), a.s[37]++, this;
          }
        }, {
          key: "addParagraphProperty",
          value: function addParagraphProperty(e) {
            return a.f[9]++, a.s[38]++, this.paragraphProperties.push(e), a.s[39]++, this;
          }
        }, {
          key: "addRunProperty",
          value: function addRunProperty(e) {
            return a.f[10]++, a.s[40]++, this.runProperties.push(e), a.s[41]++, this;
          }
        }, {
          key: "size",
          value: function size(e) {
            return a.f[11]++, a.s[42]++, this.addRunProperty(new m.Size(e)), a.s[43]++, this;
          }
        }, {
          key: "bold",
          value: function bold() {
            return a.f[12]++, a.s[44]++, this.addRunProperty(new m.Bold()), a.s[45]++, this;
          }
        }, {
          key: "italics",
          value: function italics() {
            return a.f[13]++, a.s[46]++, this.addRunProperty(new m.Italics()), a.s[47]++, this;
          }
        }, {
          key: "smallCaps",
          value: function smallCaps() {
            return a.f[14]++, a.s[48]++, this.addRunProperty(new m.SmallCaps()), a.s[49]++, this;
          }
        }, {
          key: "allCaps",
          value: function allCaps() {
            return a.f[15]++, a.s[50]++, this.addRunProperty(new m.Caps()), a.s[51]++, this;
          }
        }, {
          key: "strike",
          value: function strike() {
            return a.f[16]++, a.s[52]++, this.addRunProperty(new m.Strike()), a.s[53]++, this;
          }
        }, {
          key: "doubleStrike",
          value: function doubleStrike() {
            return a.f[17]++, a.s[54]++, this.addRunProperty(new m.DoubleStrike()), a.s[55]++, this;
          }
        }, {
          key: "subScript",
          value: function subScript() {
            return a.f[18]++, a.s[56]++, this.addRunProperty(new m.SubScript()), a.s[57]++, this;
          }
        }, {
          key: "superScript",
          value: function superScript() {
            return a.f[19]++, a.s[58]++, this.addRunProperty(new m.SuperScript()), a.s[59]++, this;
          }
        }, {
          key: "underline",
          value: function underline(e, n) {
            return a.f[20]++, a.s[60]++, this.addRunProperty(new m.Underline(e, n)), a.s[61]++, this;
          }
        }, {
          key: "color",
          value: function color(e) {
            return a.f[21]++, a.s[62]++, this.addRunProperty(new m.Color(e)), a.s[63]++, this;
          }
        }, {
          key: "font",
          value: function font(e) {
            return a.f[22]++, a.s[64]++, this.addRunProperty(new m.RunFonts(e)), a.s[65]++, this;
          }
        }, {
          key: "center",
          value: function center() {
            return a.f[23]++, a.s[66]++, this.addParagraphProperty(new u.Alignment(u.AlignmentOptions.CENTER)), a.s[67]++, this;
          }
        }, {
          key: "left",
          value: function left() {
            return a.f[24]++, a.s[68]++, this.addParagraphProperty(new u.Alignment(u.AlignmentOptions.LEFT)), a.s[69]++, this;
          }
        }, {
          key: "right",
          value: function right() {
            return a.f[25]++, a.s[70]++, this.addParagraphProperty(new u.Alignment(u.AlignmentOptions.RIGHT)), a.s[71]++, this;
          }
        }, {
          key: "justified",
          value: function justified() {
            return a.f[26]++, a.s[72]++, this.addParagraphProperty(new u.Alignment(u.AlignmentOptions.BOTH)), a.s[73]++, this;
          }
        }, {
          key: "thematicBreak",
          value: function thematicBreak() {
            return a.f[27]++, a.s[74]++, this.addParagraphProperty(new u.ThematicBreak()), a.s[75]++, this;
          }
        }, {
          key: "maxRightTabStop",
          value: function maxRightTabStop() {
            return a.f[28]++, a.s[76]++, this.addParagraphProperty(new u.MaxRightTabStop()), a.s[77]++, this;
          }
        }, {
          key: "leftTabStop",
          value: function leftTabStop(e) {
            return a.f[29]++, a.s[78]++, this.addParagraphProperty(new u.LeftTabStop(e)), a.s[79]++, this;
          }
        }, {
          key: "indent",
          value: function indent(e) {
            return a.f[30]++, a.s[80]++, this.addParagraphProperty(new u.Indent(e)), a.s[81]++, this;
          }
        }, {
          key: "spacing",
          value: function spacing(e) {
            return a.f[31]++, a.s[82]++, this.addParagraphProperty(new u.Spacing(e)), a.s[83]++, this;
          }
        }, {
          key: "keepNext",
          value: function keepNext() {
            return a.f[32]++, a.s[84]++, this.addParagraphProperty(new u.KeepNext()), a.s[85]++, this;
          }
        }, {
          key: "keepLines",
          value: function keepLines() {
            return a.f[33]++, a.s[86]++, this.addParagraphProperty(new u.KeepLines()), a.s[87]++, this;
          }
        }]);

        return b;
      }(c.XmlComponent);

      a.s[88]++, n.LevelBase = b, a.s[90]++, n.Level =
      /*#__PURE__*/
      function (_b) {
        _inherits(_class, _b);

        function _class(e, n, t, r) {
          var _this36;

          _classCallCheck(this, _class);

          a.f[34]++, a.s[89]++, _this36 = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, e, 1, n, t, r));
          return _this36;
        }

        return _class;
      }(b), a.s[91]++, n.LevelForOverride =
      /*#__PURE__*/
      function (_b2) {
        _inherits(_class2, _b2);

        function _class2() {
          _classCallCheck(this, _class2);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
        }

        return _class2;
      }(b);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\index.ts", o = "2efa8d371d8483b887b2bb3f1e68feebc19bd243", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,8BAAyB",
          sourcesContent: ['export * from "./styles";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(278));
    }, function (e, n) {
      e.exports = function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      };
    }, function (e, n, t) {
      e.exports = !t(112)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, n, t) {
      "use strict";

      var r = t(17),
          o = t(116),
          i = t(117),
          A = t(118);

      function s(e, n, t, r, o) {
        this.compressedSize = e, this.uncompressedSize = n, this.crc32 = t, this.compression = r, this.compressedContent = o;
      }

      i = t(117), s.prototype = {
        getContentWorker: function getContentWorker() {
          var e = new o(r.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new i("data_length")),
              n = this;
          return e.on("end", function () {
            if (this.streamInfo.data_length !== n.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
          }), e;
        },
        getCompressedWorker: function getCompressedWorker() {
          return new o(r.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
        }
      }, s.createWorkerFrom = function (e, n, t) {
        return e.pipe(new A()).pipe(new i("uncompressedSize")).pipe(n.compressWorker(t)).pipe(new i("compressedSize")).withStreamInfo("compression", n);
      }, e.exports = s;
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = function () {
        for (var e, n = [], t = 0; t < 256; t++) {
          e = t;

          for (var r = 0; r < 8; r++) {
            e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
          }

          n[t] = e;
        }

        return n;
      }();

      e.exports = function (e, n) {
        return void 0 !== e && e.length ? "string" !== r.getTypeOf(e) ? function (e, n, t, r) {
          var i = o,
              A = r + t;
          e ^= -1;

          for (var s = r; s < A; s++) {
            e = e >>> 8 ^ i[255 & (e ^ n[s])];
          }

          return -1 ^ e;
        }(0 | n, e, e.length, 0) : function (e, n, t, r) {
          var i = o,
              A = r + t;
          e ^= -1;

          for (var s = r; s < A; s++) {
            e = e >>> 8 ^ i[255 & (e ^ n.charCodeAt(s))];
          }

          return -1 ^ e;
        }(0 | n, e, e.length, 0) : 0;
      };
    }, function (e, n, t) {
      "use strict";

      e.exports = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\index.ts", o = "405b8a4e33ec2835423c3aa626141d295241d74f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 33
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 30
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 30
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 28
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 34
            }
          },
          9: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 31
            }
          },
          10: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 29
            }
          },
          11: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 32
            }
          },
          12: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,iCAA4B;AAC5B,8BAAyB;AACzB,8BAAyB;AACzB,4BAAuB;AACvB,kCAA6B;AAC7B,+BAA0B;AAC1B,6BAAwB;AACxB,gCAA2B;AAC3B,sCAAiC",
          sourcesContent: ['export * from "./alignment";\r\nexport * from "./border";\r\nexport * from "./indent";\r\nexport * from "./keep";\r\nexport * from "./page-break";\r\nexport * from "./spacing";\r\nexport * from "./style";\r\nexport * from "./tab-stop";\r\nexport * from "./unordered-list";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(51)), a.s[5]++, c(t(35)), a.s[6]++, c(t(61)), a.s[7]++, c(t(62)), a.s[8]++, c(t(63)), a.s[9]++, c(t(77)), a.s[10]++, c(t(78)), a.s[11]++, c(t(79)), a.s[12]++, c(t(80));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\alignment.ts", o = "75421bb8ef1c1513b29b279d0c8c26bed0602079", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\alignment.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 13,
              column: 83
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 40
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 36
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 42
            }
          },
          6: {
            start: {
              line: 9,
              column: 4
            },
            end: {
              line: 9,
              column: 38
            }
          },
          7: {
            start: {
              line: 10,
              column: 4
            },
            end: {
              line: 10,
              column: 50
            }
          },
          8: {
            start: {
              line: 11,
              column: 4
            },
            end: {
              line: 11,
              column: 38
            }
          },
          9: {
            start: {
              line: 12,
              column: 4
            },
            end: {
              line: 12,
              column: 40
            }
          },
          10: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 28
            }
          },
          11: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 40
            }
          },
          12: {
            start: {
              line: 20,
              column: 0
            },
            end: {
              line: 20,
              column: 50
            }
          },
          13: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 22
            }
          },
          14: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 63
            }
          },
          15: {
            start: {
              line: 27,
              column: 0
            },
            end: {
              line: 27,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 29
              },
              end: {
                line: 13,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 15,
                column: 4
              },
              end: {
                line: 15,
                column: 5
              }
            },
            loc: {
              start: {
                line: 15,
                column: 18
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 15
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 22,
                column: 4
              },
              end: {
                line: 22,
                column: 5
              }
            },
            loc: {
              start: {
                line: 22,
                column: 22
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 22
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 13,
                column: 22
              },
              end: {
                line: 13,
                column: 81
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 13,
                column: 22
              },
              end: {
                line: 13,
                column: 46
              }
            }, {
              start: {
                line: 13,
                column: 51
              },
              end: {
                line: 13,
                column: 80
              }
            }],
            line: 13
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/alignment.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\alignment.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAE1E,IAAY,gBAQX;AARD,WAAY,gBAAgB;IACxB,mCAAe,CAAA;IACf,+BAAW,CAAA;IACX,qCAAiB,CAAA;IACjB,iCAAa,CAAA;IACb,6CAAyB,CAAA;IACzB,iCAAa,CAAA;IACb,mCAAe,CAAA;AACnB,CAAC,EARW,gBAAgB,GAAhB,wBAAgB,KAAhB,wBAAgB,QAQ3B;AAED,yBAAiC,SAAQ,sCAAyD;IAAlG;;QACuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC;IAClD,CAAC;CAAA;AAFD,kDAEC;AAED,eAAuB,SAAQ,6BAAY;IACvC,YAAY,IAAsB;QAC9B,KAAK,CAAC,MAAM,CAAC,CAAC;QACd,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,EAAE,GAAG,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC;IAC3D,CAAC;CACJ;AALD,8BAKC",
          sourcesContent: ['// http://officeopenxml.com/WPalignment.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport enum AlignmentOptions {\r\n    START = "start",\r\n    END = "end",\r\n    CENTER = "center",\r\n    BOTH = "both",\r\n    DISTRIBUTE = "distribute",\r\n    LEFT = "left",\r\n    RIGHT = "right",\r\n}\r\n\r\nexport class AlignmentAttributes extends XmlAttributeComponent<{ readonly val: AlignmentOptions }> {\r\n    protected readonly xmlKeys = { val: "w:val" };\r\n}\r\n\r\nexport class Alignment extends XmlComponent {\r\n    constructor(type: AlignmentOptions) {\r\n        super("w:jc");\r\n        this.root.push(new AlignmentAttributes({ val: type }));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.START = "start", a.s[4]++, e.END = "end", a.s[5]++, e.CENTER = "center", a.s[6]++, e.BOTH = "both", a.s[7]++, e.DISTRIBUTE = "distribute", a.s[8]++, e.LEFT = "left", a.s[9]++, e.RIGHT = "right";
      }((a.b[0][0]++, n.AlignmentOptions || (a.b[0][1]++, n.AlignmentOptions = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon6) {
        _inherits(u, _c$XmlAttributeCompon6);

        function u() {
          var _this37;

          _classCallCheck(this, u);

          a.f[1]++, a.s[10]++, _this37 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[11]++, _this37.xmlKeys = {
            val: "w:val"
          };
          return _this37;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[12]++, n.AlignmentAttributes = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent32) {
        _inherits(p, _c$XmlComponent32);

        function p(e) {
          var _this38;

          _classCallCheck(this, p);

          a.f[2]++, a.s[13]++, _this38 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:jc")), a.s[14]++, _this38.root.push(new u({
            val: e
          }));
          return _this38;
        }

        return p;
      }(c.XmlComponent);

      a.s[15]++, n.Alignment = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\base.ts", o = "6228f22817531301ba3bdd7968684c44465029ce", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\base.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 5,
              column: 8
            },
            end: {
              line: 5,
              column: 29
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 31
            }
          },
          3: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 28
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 4
              },
              end: {
                line: 4,
                column: 5
              }
            },
            loc: {
              start: {
                line: 4,
                column: 25
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 4
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 20
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 8
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/base.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\base.ts"],
          names: [],
          mappings: ";;AAEA;IAKI,YAAY,OAAe;QAFjB,YAAO,GAAY,KAAK,CAAC;QAG/B,IAAI,CAAC,OAAO,GAAG,OAAO,CAAC;IAC3B,CAAC;IAID,IAAW,SAAS;QAChB,OAAO,IAAI,CAAC,OAAO,CAAC;IACxB,CAAC;CACJ;AAdD,4CAcC",
          sourcesContent: ['import { IXmlableObject } from "./xmlable-object";\r\n\r\nexport abstract class BaseXmlComponent {\r\n    protected readonly rootKey: string;\r\n    // tslint:disable-next-line:readonly-keyword\r\n    protected deleted: boolean = false;\r\n\r\n    constructor(rootKey: string) {\r\n        this.rootKey = rootKey;\r\n    }\r\n\r\n    public abstract prepForXml(): IXmlableObject | undefined;\r\n\r\n    public get IsDeleted(): boolean {\r\n        return this.deleted;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, n.BaseXmlComponent =
      /*#__PURE__*/
      function () {
        function _class3(e) {
          _classCallCheck(this, _class3);

          a.f[0]++, a.s[1]++, this.deleted = !1, a.s[2]++, this.rootKey = e;
        }

        _createClass(_class3, [{
          key: "IsDeleted",
          get: function get() {
            return a.f[1]++, a.s[3]++, this.deleted;
          }
        }]);

        return _class3;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\default-attributes.ts", o = "5b2936a47a9b006474a41ad8b2aa2f3e455a22a1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\default-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 15
            },
            end: {
              line: 3,
              column: 32
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 23
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 31
            }
          },
          4: {
            start: {
              line: 10,
              column: 22
            },
            end: {
              line: 10,
              column: 24
            }
          },
          5: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 17,
              column: 11
            }
          },
          6: {
            start: {
              line: 12,
              column: 26
            },
            end: {
              line: 12,
              column: 40
            }
          },
          7: {
            start: {
              line: 13,
              column: 12
            },
            end: {
              line: 16,
              column: 13
            }
          },
          8: {
            start: {
              line: 14,
              column: 31
            },
            end: {
              line: 14,
              column: 48
            }
          },
          9: {
            start: {
              line: 15,
              column: 16
            },
            end: {
              line: 15,
              column: 38
            }
          },
          10: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 32
            }
          },
          11: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 31
            }
          },
          12: {
            start: {
              line: 24,
              column: 0
            },
            end: {
              line: 24,
              column: 54
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 28
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 9,
                column: 4
              },
              end: {
                line: 9,
                column: 5
              }
            },
            loc: {
              start: {
                line: 9,
                column: 17
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 9
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 11,
                column: 39
              },
              end: {
                line: 11,
                column: 40
              }
            },
            loc: {
              start: {
                line: 11,
                column: 48
              },
              end: {
                line: 17,
                column: 9
              }
            },
            line: 11
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 20
              },
              end: {
                line: 22,
                column: 5
              }
            },
            line: 20
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 13,
                column: 12
              },
              end: {
                line: 16,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 13,
                column: 12
              },
              end: {
                line: 16,
                column: 13
              }
            }, {
              start: {
                line: 13,
                column: 12
              },
              end: {
                line: 16,
                column: 13
              }
            }],
            line: 13
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/default-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\default-attributes.ts"],
          names: [],
          mappings: ";;AAAA,iCAA0C;AAK1C,2BAA+C,SAAQ,uBAAgB;IAKnE,YAAY,UAAa;QACrB,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,GAAG,UAAU,CAAC;IAC3B,CAAC;IAEM,UAAU;QACb,MAAM,KAAK,GAAG,EAAE,CAAC;QACjB,MAAM,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,OAAO,CAAC,CAAC,GAAG,EAAE,EAAE;YACnC,MAAM,KAAK,GAAG,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;YAC7B,IAAI,KAAK,KAAK,SAAS,EAAE;gBACrB,MAAM,MAAM,GAAG,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC;gBACjC,KAAK,CAAC,MAAM,CAAC,GAAG,KAAK,CAAC;aACzB;QACL,CAAC,CAAC,CAAC;QACH,OAAO,EAAE,KAAK,EAAE,KAAK,EAAE,CAAC;IAC5B,CAAC;IAEM,GAAG,CAAC,UAAa;QACpB,IAAI,CAAC,IAAI,GAAG,UAAU,CAAC;IAC3B,CAAC;CACJ;AAzBD,sDAyBC",
          sourcesContent: ['import { BaseXmlComponent } from "./base";\r\nimport { IXmlableObject } from "./xmlable-object";\r\n\r\nexport type AttributeMap<T> = { [P in keyof T]: string };\r\n\r\nexport abstract class XmlAttributeComponent<T> extends BaseXmlComponent {\r\n    // tslint:disable-next-line:readonly-keyword\r\n    protected root: T;\r\n    protected readonly xmlKeys: AttributeMap<T>;\r\n\r\n    constructor(properties: T) {\r\n        super("_attr");\r\n        this.root = properties;\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject {\r\n        const attrs = {};\r\n        Object.keys(this.root).forEach((key) => {\r\n            const value = this.root[key];\r\n            if (value !== undefined) {\r\n                const newKey = this.xmlKeys[key];\r\n                attrs[newKey] = value;\r\n            }\r\n        });\r\n        return { _attr: attrs };\r\n    }\r\n\r\n    public set(properties: T): void {\r\n        this.root = properties;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(52));

      var u =
      /*#__PURE__*/
      function (_c$BaseXmlComponent) {
        _inherits(u, _c$BaseXmlComponent);

        function u(e) {
          var _this39;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this39 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "_attr")), a.s[3]++, _this39.root = e;
          return _this39;
        }

        _createClass(u, [{
          key: "prepForXml",
          value: function prepForXml() {
            var _this40 = this;

            a.f[1]++;
            var e = (a.s[4]++, {});
            return a.s[5]++, Object.keys(this.root).forEach(function (n) {
              a.f[2]++;
              var t = (a.s[6]++, _this40.root[n]);

              if (a.s[7]++, void 0 !== t) {
                a.b[0][0]++;

                var _r2 = (a.s[8]++, _this40.xmlKeys[n]);

                a.s[9]++, e[_r2] = t;
              } else a.b[0][1]++;
            }), a.s[10]++, {
              _attr: e
            };
          }
        }, {
          key: "set",
          value: function set(e) {
            a.f[3]++, a.s[11]++, this.root = e;
          }
        }]);

        return u;
      }(c.BaseXmlComponent);

      a.s[12]++, n.XmlAttributeComponent = u;
    }, function (e, n, t) {
      var r,
          o,
          i = t(134),
          A = t(33),
          s = t(34).isArray;

      function l(e) {
        var n = Number(e);
        if (!isNaN(n)) return n;
        var t = e.toLowerCase();
        return "true" === t || "false" !== t && e;
      }

      function a(e, n) {
        var t;

        if (r.compact) {
          if (!o[r[e + "Key"]] && (s(r.alwaysArray) ? -1 !== r.alwaysArray.indexOf(r[e + "Key"]) : r.alwaysArray) && (o[r[e + "Key"]] = []), o[r[e + "Key"]] && !s(o[r[e + "Key"]]) && (o[r[e + "Key"]] = [o[r[e + "Key"]]]), e + "Fn" in r && "string" == typeof n && (n = r[e + "Fn"](n, o)), "instruction" === e && ("instructionFn" in r || "instructionNameFn" in r)) for (t in n) {
            if (n.hasOwnProperty(t)) if ("instructionFn" in r) n[t] = r.instructionFn(n[t], t, o);else {
              var i = n[t];
              delete n[t], n[r.instructionNameFn(t, i, o)] = i;
            }
          }
          s(o[r[e + "Key"]]) ? o[r[e + "Key"]].push(n) : o[r[e + "Key"]] = n;
        } else {
          o[r.elementsKey] || (o[r.elementsKey] = []);
          var A = {};

          if (A[r.typeKey] = e, "instruction" === e) {
            for (t in n) {
              if (n.hasOwnProperty(t)) break;
            }

            A[r.nameKey] = "instructionNameFn" in r ? r.instructionNameFn(t, n, o) : t, r.instructionHasAttributes ? (A[r.attributesKey] = n[t][r.attributesKey], "instructionFn" in r && (A[r.attributesKey] = r.instructionFn(A[r.attributesKey], t, o))) : ("instructionFn" in r && (n[t] = r.instructionFn(n[t], t, o)), A[r.instructionKey] = n[t]);
          } else e + "Fn" in r && (n = r[e + "Fn"](n, o)), A[r[e + "Key"]] = n;

          r.addParent && (A[r.parentKey] = o), o[r.elementsKey].push(A);
        }
      }

      function c(e) {
        var n;
        if ("attributesFn" in r && e && (e = r.attributesFn(e, o)), (r.trim || "attributeValueFn" in r || "attributeNameFn" in r || r.nativeTypeAttributes) && e) for (n in e) {
          if (e.hasOwnProperty(n) && (r.trim && (e[n] = e[n].trim()), r.nativeTypeAttributes && (e[n] = l(e[n])), "attributeValueFn" in r && (e[n] = r.attributeValueFn(e[n], n, o)), "attributeNameFn" in r)) {
            var t = e[n];
            delete e[n], e[r.attributeNameFn(n, e[n], o)] = t;
          }
        }
        return e;
      }

      function u(e) {
        var n = {};

        if (e.body && ("xml" === e.name.toLowerCase() || r.instructionHasAttributes)) {
          for (var t, i = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g; null !== (t = i.exec(e.body));) {
            n[t[1]] = t[2] || t[3] || t[4];
          }

          n = c(n);
        }

        if ("xml" === e.name.toLowerCase()) {
          if (r.ignoreDeclaration) return;
          o[r.declarationKey] = {}, Object.keys(n).length && (o[r.declarationKey][r.attributesKey] = n), r.addParent && (o[r.declarationKey][r.parentKey] = o);
        } else {
          if (r.ignoreInstruction) return;
          r.trim && (e.body = e.body.trim());
          var A = {};
          r.instructionHasAttributes && Object.keys(n).length ? (A[e.name] = {}, A[e.name][r.attributesKey] = n) : A[e.name] = e.body, a("instruction", A);
        }
      }

      function p(e, n) {
        var t;

        if ("object" == typeof e && (n = e.attributes, e = e.name), n = c(n), "elementNameFn" in r && (e = r.elementNameFn(e, o)), r.compact) {
          var i;
          if (t = {}, !r.ignoreAttributes && n && Object.keys(n).length) for (i in t[r.attributesKey] = {}, n) {
            n.hasOwnProperty(i) && (t[r.attributesKey][i] = n[i]);
          }
          e in o || (s(r.alwaysArray) ? -1 === r.alwaysArray.indexOf(e) : !r.alwaysArray) || (o[e] = []), o[e] && !s(o[e]) && (o[e] = [o[e]]), s(o[e]) ? o[e].push(t) : o[e] = t;
        } else o[r.elementsKey] || (o[r.elementsKey] = []), (t = {})[r.typeKey] = "element", t[r.nameKey] = e, !r.ignoreAttributes && n && Object.keys(n).length && (t[r.attributesKey] = n), r.alwaysChildren && (t[r.elementsKey] = []), o[r.elementsKey].push(t);

        t[r.parentKey] = o, o = t;
      }

      function m(e) {
        r.ignoreText || (e.trim() || r.captureSpacesBetweenElements) && (r.trim && (e = e.trim()), r.nativeType && (e = l(e)), r.sanitize && (e = e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")), a("text", e));
      }

      function C(e) {
        r.ignoreComment || (r.trim && (e = e.trim()), a("comment", e));
      }

      function d(e) {
        var n = o[r.parentKey];
        r.addParent || delete o[r.parentKey], o = n;
      }

      function f(e) {
        r.ignoreCdata || (r.trim && (e = e.trim()), a("cdata", e));
      }

      function h(e) {
        r.ignoreDoctype || (e = e.replace(/^ /, ""), r.trim && (e = e.trim()), a("doctype", e));
      }

      function x(e) {
        e.note = e;
      }

      e.exports = function (e, n) {
        var t = i.parser(!0, {}),
            s = {};

        if (o = s, r = function (e) {
          return r = A.copyOptions(e), A.ensureFlagExists("ignoreDeclaration", r), A.ensureFlagExists("ignoreInstruction", r), A.ensureFlagExists("ignoreAttributes", r), A.ensureFlagExists("ignoreText", r), A.ensureFlagExists("ignoreComment", r), A.ensureFlagExists("ignoreCdata", r), A.ensureFlagExists("ignoreDoctype", r), A.ensureFlagExists("compact", r), A.ensureFlagExists("alwaysChildren", r), A.ensureFlagExists("addParent", r), A.ensureFlagExists("trim", r), A.ensureFlagExists("nativeType", r), A.ensureFlagExists("nativeTypeAttributes", r), A.ensureFlagExists("sanitize", r), A.ensureFlagExists("instructionHasAttributes", r), A.ensureFlagExists("captureSpacesBetweenElements", r), A.ensureAlwaysArrayExists(r), A.ensureKeyExists("declaration", r), A.ensureKeyExists("instruction", r), A.ensureKeyExists("attributes", r), A.ensureKeyExists("text", r), A.ensureKeyExists("comment", r), A.ensureKeyExists("cdata", r), A.ensureKeyExists("doctype", r), A.ensureKeyExists("type", r), A.ensureKeyExists("name", r), A.ensureKeyExists("elements", r), A.ensureKeyExists("parent", r), A.checkFnExists("doctype", r), A.checkFnExists("instruction", r), A.checkFnExists("cdata", r), A.checkFnExists("comment", r), A.checkFnExists("text", r), A.checkFnExists("instructionName", r), A.checkFnExists("elementName", r), A.checkFnExists("attributeName", r), A.checkFnExists("attributeValue", r), A.checkFnExists("attributes", r), r;
        }(n), t.opt = {
          strictEntities: !0
        }, t.onopentag = p, t.ontext = m, t.oncomment = C, t.onclosetag = d, t.onerror = x, t.oncdata = f, t.ondoctype = h, t.onprocessinginstruction = u, t.write(e).close(), s[r.elementsKey]) {
          var l = s[r.elementsKey];
          delete s[r.elementsKey], s[r.elementsKey] = l, delete s.text;
        }

        return s;
      };
    }, function (e, n) {
      var t = {}.toString;

      e.exports = Array.isArray || function (e) {
        return "[object Array]" == t.call(e);
      };
    }, function (e, n, t) {
      "use strict";

      (function (n, r) {
        var o = t(18);
        e.exports = g;
        var i,
            A = t(55);
        g.ReadableState = x, t(29).EventEmitter;

        var s = function s(e, n) {
          return e.listeners(n).length;
        },
            l = t(57),
            a = t(19).Buffer,
            c = n.Uint8Array || function () {},
            u = t(14);

        u.inherits = t(10);
        var p = t(137),
            m = void 0;
        m = p && p.debuglog ? p.debuglog("stream") : function () {};
        var C,
            d = t(138),
            f = t(58);
        u.inherits(g, l);
        var h = ["error", "close", "destroy", "pause", "resume"];

        function x(e, n) {
          i = i || t(9), e = e || {}, this.objectMode = !!e.objectMode, n instanceof i && (this.objectMode = this.objectMode || !!e.readableObjectMode);
          var r = e.highWaterMark,
              o = this.objectMode ? 16 : 16384;
          this.highWaterMark = r || 0 === r ? r : o, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (C || (C = t(32).StringDecoder), this.decoder = new C(e.encoding), this.encoding = e.encoding);
        }

        function g(e) {
          if (i = i || t(9), !(this instanceof g)) return new g(e);
          this._readableState = new x(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), l.call(this);
        }

        function I(e, n, t, r, o) {
          var i,
              A = e._readableState;
          return null === n ? (A.reading = !1, function (e, n) {
            if (!n.ended) {
              if (n.decoder) {
                var t = n.decoder.end();
                t && t.length && (n.buffer.push(t), n.length += n.objectMode ? 1 : t.length);
              }

              n.ended = !0, v(e);
            }
          }(e, A)) : (o || (i = function (e, n) {
            var t, r;
            return r = n, a.isBuffer(r) || r instanceof c || "string" == typeof n || void 0 === n || e.objectMode || (t = new TypeError("Invalid non-string/buffer chunk")), t;
          }(A, n)), i ? e.emit("error", i) : A.objectMode || n && n.length > 0 ? ("string" == typeof n || A.objectMode || Object.getPrototypeOf(n) === a.prototype || (n = function (e) {
            return a.from(e);
          }(n)), r ? A.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : b(e, A, n, !0) : A.ended ? e.emit("error", new Error("stream.push() after EOF")) : (A.reading = !1, A.decoder && !t ? (n = A.decoder.write(n), A.objectMode || 0 !== n.length ? b(e, A, n, !1) : B(e, A)) : b(e, A, n, !1))) : r || (A.reading = !1)), function (e) {
            return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
          }(A);
        }

        function b(e, n, t, r) {
          n.flowing && 0 === n.length && !n.sync ? (e.emit("data", t), e.read(0)) : (n.length += n.objectMode ? 1 : t.length, r ? n.buffer.unshift(t) : n.buffer.push(t), n.needReadable && v(e)), B(e, n);
        }

        Object.defineProperty(g.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._readableState && this._readableState.destroyed;
          },
          set: function set(e) {
            this._readableState && (this._readableState.destroyed = e);
          }
        }), g.prototype.destroy = f.destroy, g.prototype._undestroy = f.undestroy, g.prototype._destroy = function (e, n) {
          this.push(null), n(e);
        }, g.prototype.push = function (e, n) {
          var t,
              r = this._readableState;
          return r.objectMode ? t = !0 : "string" == typeof e && ((n = n || r.defaultEncoding) !== r.encoding && (e = a.from(e, n), n = ""), t = !0), I(this, e, n, !1, t);
        }, g.prototype.unshift = function (e) {
          return I(this, e, null, !0, !1);
        }, g.prototype.isPaused = function () {
          return !1 === this._readableState.flowing;
        }, g.prototype.setEncoding = function (e) {
          return C || (C = t(32).StringDecoder), this._readableState.decoder = new C(e), this._readableState.encoding = e, this;
        };
        var y = 8388608;

        function E(e, n) {
          return e <= 0 || 0 === n.length && n.ended ? 0 : n.objectMode ? 1 : e != e ? n.flowing && n.length ? n.buffer.head.data.length : n.length : (e > n.highWaterMark && (n.highWaterMark = function (e) {
            return e >= y ? e = y : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
          }(e)), e <= n.length ? e : n.ended ? n.length : (n.needReadable = !0, 0));
        }

        function v(e) {
          var n = e._readableState;
          n.needReadable = !1, n.emittedReadable || (m("emitReadable", n.flowing), n.emittedReadable = !0, n.sync ? o(w, e) : w(e));
        }

        function w(e) {
          m("emit readable"), e.emit("readable"), M(e);
        }

        function B(e, n) {
          n.readingMore || (n.readingMore = !0, o(_, e, n));
        }

        function _(e, n) {
          for (var t = n.length; !n.reading && !n.flowing && !n.ended && n.length < n.highWaterMark && (m("maybeReadMore read 0"), e.read(0), t !== n.length);) {
            t = n.length;
          }

          n.readingMore = !1;
        }

        function D(e) {
          m("readable nexttick read 0"), e.read(0);
        }

        function S(e, n) {
          n.reading || (m("resume read 0"), e.read(0)), n.resumeScheduled = !1, n.awaitDrain = 0, e.emit("resume"), M(e), n.flowing && !n.reading && e.read(0);
        }

        function M(e) {
          var n = e._readableState;

          for (m("flow", n.flowing); n.flowing && null !== e.read();) {
            ;
          }
        }

        function O(e, n) {
          return 0 === n.length ? null : (n.objectMode ? t = n.buffer.shift() : !e || e >= n.length ? (t = n.decoder ? n.buffer.join("") : 1 === n.buffer.length ? n.buffer.head.data : n.buffer.concat(n.length), n.buffer.clear()) : t = function (e, n, t) {
            var r;
            return e < n.head.data.length ? (r = n.head.data.slice(0, e), n.head.data = n.head.data.slice(e)) : r = e === n.head.data.length ? n.shift() : t ? function (e, n) {
              var t = n.head,
                  r = 1,
                  o = t.data;

              for (e -= o.length; t = t.next;) {
                var i = t.data,
                    A = e > i.length ? i.length : e;

                if (A === i.length ? o += i : o += i.slice(0, e), 0 == (e -= A)) {
                  A === i.length ? (++r, t.next ? n.head = t.next : n.head = n.tail = null) : (n.head = t, t.data = i.slice(A));
                  break;
                }

                ++r;
              }

              return n.length -= r, o;
            }(e, n) : function (e, n) {
              var t = a.allocUnsafe(e),
                  r = n.head,
                  o = 1;

              for (r.data.copy(t), e -= r.data.length; r = r.next;) {
                var i = r.data,
                    A = e > i.length ? i.length : e;

                if (i.copy(t, t.length - e, 0, A), 0 == (e -= A)) {
                  A === i.length ? (++o, r.next ? n.head = r.next : n.head = n.tail = null) : (n.head = r, r.data = i.slice(A));
                  break;
                }

                ++o;
              }

              return n.length -= o, t;
            }(e, n), r;
          }(e, n.buffer, n.decoder), t);
          var t;
        }

        function k(e) {
          var n = e._readableState;
          if (n.length > 0) throw new Error('"endReadable()" called on non-empty stream');
          n.endEmitted || (n.ended = !0, o(T, n, e));
        }

        function T(e, n) {
          e.endEmitted || 0 !== e.length || (e.endEmitted = !0, n.readable = !1, n.emit("end"));
        }

        function P(e, n) {
          for (var t = 0, r = e.length; t < r; t++) {
            if (e[t] === n) return t;
          }

          return -1;
        }

        g.prototype.read = function (e) {
          m("read", e), e = parseInt(e, 10);
          var n = this._readableState,
              t = e;
          if (0 !== e && (n.emittedReadable = !1), 0 === e && n.needReadable && (n.length >= n.highWaterMark || n.ended)) return m("read: emitReadable", n.length, n.ended), 0 === n.length && n.ended ? k(this) : v(this), null;
          if (0 === (e = E(e, n)) && n.ended) return 0 === n.length && k(this), null;
          var r,
              o = n.needReadable;
          return m("need readable", o), (0 === n.length || n.length - e < n.highWaterMark) && m("length less than watermark", o = !0), n.ended || n.reading ? m("reading or ended", o = !1) : o && (m("do read"), n.reading = !0, n.sync = !0, 0 === n.length && (n.needReadable = !0), this._read(n.highWaterMark), n.sync = !1, n.reading || (e = E(t, n))), null === (r = e > 0 ? O(e, n) : null) ? (n.needReadable = !0, e = 0) : n.length -= e, 0 === n.length && (n.ended || (n.needReadable = !0), t !== e && n.ended && k(this)), null !== r && this.emit("data", r), r;
        }, g.prototype._read = function (e) {
          this.emit("error", new Error("_read() is not implemented"));
        }, g.prototype.pipe = function (e, n) {
          var t = this,
              i = this._readableState;

          switch (i.pipesCount) {
            case 0:
              i.pipes = e;
              break;

            case 1:
              i.pipes = [i.pipes, e];
              break;

            default:
              i.pipes.push(e);
          }

          i.pipesCount += 1, m("pipe count=%d opts=%j", i.pipesCount, n);
          var l = n && !1 === n.end || e === r.stdout || e === r.stderr ? g : c;

          function a(n, r) {
            m("onunpipe"), n === t && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, m("cleanup"), e.removeListener("close", h), e.removeListener("finish", x), e.removeListener("drain", u), e.removeListener("error", f), e.removeListener("unpipe", a), t.removeListener("end", c), t.removeListener("end", g), t.removeListener("data", d), p = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
          }

          function c() {
            m("onend"), e.end();
          }

          i.endEmitted ? o(l) : t.once("end", l), e.on("unpipe", a);

          var u = function (e) {
            return function () {
              var n = e._readableState;
              m("pipeOnDrain", n.awaitDrain), n.awaitDrain && n.awaitDrain--, 0 === n.awaitDrain && s(e, "data") && (n.flowing = !0, M(e));
            };
          }(t);

          e.on("drain", u);
          var p = !1,
              C = !1;

          function d(n) {
            m("ondata"), C = !1, !1 !== e.write(n) || C || ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== P(i.pipes, e)) && !p && (m("false write response, pause", t._readableState.awaitDrain), t._readableState.awaitDrain++, C = !0), t.pause());
          }

          function f(n) {
            m("onerror", n), g(), e.removeListener("error", f), 0 === s(e, "error") && e.emit("error", n);
          }

          function h() {
            e.removeListener("finish", x), g();
          }

          function x() {
            m("onfinish"), e.removeListener("close", h), g();
          }

          function g() {
            m("unpipe"), t.unpipe(e);
          }

          return t.on("data", d), function (e, n, t) {
            if ("function" == typeof e.prependListener) return e.prependListener(n, t);
            e._events && e._events[n] ? A(e._events[n]) ? e._events[n].unshift(t) : e._events[n] = [t, e._events[n]] : e.on(n, t);
          }(e, "error", f), e.once("close", h), e.once("finish", x), e.emit("pipe", t), i.flowing || (m("pipe resume"), t.resume()), e;
        }, g.prototype.unpipe = function (e) {
          var n = this._readableState,
              t = {
            hasUnpiped: !1
          };
          if (0 === n.pipesCount) return this;
          if (1 === n.pipesCount) return e && e !== n.pipes ? this : (e || (e = n.pipes), n.pipes = null, n.pipesCount = 0, n.flowing = !1, e && e.emit("unpipe", this, t), this);

          if (!e) {
            var r = n.pipes,
                o = n.pipesCount;
            n.pipes = null, n.pipesCount = 0, n.flowing = !1;

            for (var i = 0; i < o; i++) {
              r[i].emit("unpipe", this, t);
            }

            return this;
          }

          var A = P(n.pipes, e);
          return -1 === A ? this : (n.pipes.splice(A, 1), n.pipesCount -= 1, 1 === n.pipesCount && (n.pipes = n.pipes[0]), e.emit("unpipe", this, t), this);
        }, g.prototype.on = function (e, n) {
          var t = l.prototype.on.call(this, e, n);
          if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
            var r = this._readableState;
            r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && v(this) : o(D, this));
          }
          return t;
        }, g.prototype.addListener = g.prototype.on, g.prototype.resume = function () {
          var e = this._readableState;
          return e.flowing || (m("resume"), e.flowing = !0, function (e, n) {
            n.resumeScheduled || (n.resumeScheduled = !0, o(S, e, n));
          }(this, e)), this;
        }, g.prototype.pause = function () {
          return m("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (m("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
        }, g.prototype.wrap = function (e) {
          var n = this._readableState,
              t = !1,
              r = this;

          for (var o in e.on("end", function () {
            if (m("wrapped end"), n.decoder && !n.ended) {
              var e = n.decoder.end();
              e && e.length && r.push(e);
            }

            r.push(null);
          }), e.on("data", function (o) {
            m("wrapped data"), n.decoder && (o = n.decoder.write(o)), n.objectMode && null == o || (n.objectMode || o && o.length) && (r.push(o) || (t = !0, e.pause()));
          }), e) {
            void 0 === this[o] && "function" == typeof e[o] && (this[o] = function (n) {
              return function () {
                return e[n].apply(e, arguments);
              };
            }(o));
          }

          for (var i = 0; i < h.length; i++) {
            e.on(h[i], r.emit.bind(r, h[i]));
          }

          return r._read = function (n) {
            m("wrapped _read", n), t && (t = !1, e.resume());
          }, r;
        }, g._fromList = O;
      }).call(n, t(8), t(13));
    }, function (e, n, t) {
      e.exports = t(29).EventEmitter;
    }, function (e, n, t) {
      "use strict";

      var r = t(18);

      function o(e, n) {
        e.emit("error", n);
      }

      e.exports = {
        destroy: function destroy(e, n) {
          var t = this,
              i = this._readableState && this._readableState.destroyed,
              A = this._writableState && this._writableState.destroyed;
          i || A ? n ? n(e) : !e || this._writableState && this._writableState.errorEmitted || r(o, this, e) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
            !n && e ? (r(o, t, e), t._writableState && (t._writableState.errorEmitted = !0)) : n && n(e);
          }));
        },
        undestroy: function undestroy() {
          this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
        }
      };
    }, function (e, n, t) {
      "use strict";

      e.exports = A;
      var r = t(9),
          o = t(14);

      function i(e) {
        this.afterTransform = function (n, t) {
          return function (e, n, t) {
            var r = e._transformState;
            r.transforming = !1;
            var o = r.writecb;
            if (!o) return e.emit("error", new Error("write callback called multiple times"));
            r.writechunk = null, r.writecb = null, null != t && e.push(t), o(n);
            var i = e._readableState;
            i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && e._read(i.highWaterMark);
          }(e, n, t);
        }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
      }

      function A(e) {
        if (!(this instanceof A)) return new A(e);
        r.call(this, e), this._transformState = new i(this);
        var n = this;
        this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.once("prefinish", function () {
          "function" == typeof this._flush ? this._flush(function (e, t) {
            s(n, e, t);
          }) : s(n);
        });
      }

      function s(e, n, t) {
        if (n) return e.emit("error", n);
        null != t && e.push(t);
        var r = e._writableState,
            o = e._transformState;
        if (r.length) throw new Error("Calling transform done when ws.length != 0");
        if (o.transforming) throw new Error("Calling transform done when still transforming");
        return e.push(null);
      }

      o.inherits = t(10), o.inherits(A, r), A.prototype.push = function (e, n) {
        return this._transformState.needTransform = !1, r.prototype.push.call(this, e, n);
      }, A.prototype._transform = function (e, n, t) {
        throw new Error("_transform() is not implemented");
      }, A.prototype._write = function (e, n, t) {
        var r = this._transformState;

        if (r.writecb = t, r.writechunk = e, r.writeencoding = n, !r.transforming) {
          var o = this._readableState;
          (r.needTransform || o.needReadable || o.length < o.highWaterMark) && this._read(o.highWaterMark);
        }
      }, A.prototype._read = function (e) {
        var n = this._transformState;
        null !== n.writechunk && n.writecb && !n.transforming ? (n.transforming = !0, this._transform(n.writechunk, n.writeencoding, n.afterTransform)) : n.needTransform = !0;
      }, A.prototype._destroy = function (e, n) {
        var t = this;

        r.prototype._destroy.call(this, e, function (e) {
          n(e), t.emit("close");
        });
      };
    }, function (e, n, t) {
      var r,
          o,
          i = t(33),
          A = t(34).isArray;

      function s(e, n, t) {
        return (!t && e.spaces ? "\n" : "") + Array(n + 1).join(e.spaces);
      }

      function l(e, n, t) {
        if (n.ignoreAttributes) return "";
        "attributesFn" in n && (e = n.attributesFn(e, o, r));
        var i,
            A,
            l,
            a,
            c = [];

        for (i in e) {
          e.hasOwnProperty(i) && null !== e[i] && void 0 !== e[i] && (a = n.noQuotesForNativeAttributes && "string" != typeof e[i] ? "" : '"', A = (A = "" + e[i]).replace(/"/g, "&quot;"), l = "attributeNameFn" in n ? n.attributeNameFn(i, A, o, r) : i, c.push(n.spaces && n.indentAttributes ? s(n, t + 1, !1) : " "), c.push(l + "=" + a + ("attributeValueFn" in n ? n.attributeValueFn(A, i, o, r) : A) + a));
        }

        return e && Object.keys(e).length && n.spaces && n.indentAttributes && c.push(s(n, t, !1)), c.join("");
      }

      function a(e, n, t) {
        return r = e, o = "xml", n.ignoreDeclaration ? "" : "<?xml" + l(e[n.attributesKey], n, t) + "?>";
      }

      function c(e, n, t) {
        if (n.ignoreInstruction) return "";
        var i;

        for (i in e) {
          if (e.hasOwnProperty(i)) break;
        }

        var A = "instructionNameFn" in n ? n.instructionNameFn(i, e[i], o, r) : i;
        if ("object" == typeof e[i]) return r = e, o = A, "<?" + A + l(e[i][n.attributesKey], n, t) + "?>";
        var s = e[i] ? e[i] : "";
        return "instructionFn" in n && (s = n.instructionFn(s, i, o, r)), "<?" + A + (s ? " " + s : "") + "?>";
      }

      function u(e, n) {
        return n.ignoreComment ? "" : "\x3c!--" + ("commentFn" in n ? n.commentFn(e, o, r) : e) + "--\x3e";
      }

      function p(e, n) {
        return n.ignoreCdata ? "" : "<![CDATA[" + ("cdataFn" in n ? n.cdataFn(e, o, r) : e) + "]]>";
      }

      function m(e, n) {
        return n.ignoreDoctype ? "" : "<!DOCTYPE " + ("doctypeFn" in n ? n.doctypeFn(e, o, r) : e) + ">";
      }

      function C(e, n) {
        return n.ignoreText ? "" : (e = (e = (e = "" + e).replace(/&amp;/g, "&")).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), "textFn" in n ? n.textFn(e, o, r) : e);
      }

      function d(e, n, t, i) {
        return e.reduce(function (e, A) {
          var a = s(n, t, i && !e);

          switch (A.type) {
            case "element":
              return e + a + function (e, n, t) {
                r = e, o = e.name;
                var i = [],
                    A = "elementNameFn" in n ? n.elementNameFn(e.name, e) : e.name;
                i.push("<" + A), e[n.attributesKey] && i.push(l(e[n.attributesKey], n, t));
                var s = e[n.elementsKey] && e[n.elementsKey].length || e[n.attributesKey] && "preserve" === e[n.attributesKey]["xml:space"];
                return s || (s = "fullTagEmptyElementFn" in n ? n.fullTagEmptyElementFn(e.name, e) : n.fullTagEmptyElement), s ? (i.push(">"), e[n.elementsKey] && e[n.elementsKey].length && (i.push(d(e[n.elementsKey], n, t + 1)), r = e, o = e.name), i.push(n.spaces && function (e, n) {
                  var t;
                  if (e.elements && e.elements.length) for (t = 0; t < e.elements.length; ++t) {
                    switch (e.elements[t][n.typeKey]) {
                      case "text":
                        if (n.indentText) return !0;
                        break;

                      case "cdata":
                        if (n.indentCdata) return !0;
                        break;

                      case "instruction":
                        if (n.indentInstruction) return !0;
                        break;

                      case "doctype":
                      case "comment":
                      case "element":
                      default:
                        return !0;
                    }
                  }
                  return !1;
                }(e, n) ? "\n" + Array(t + 1).join(n.spaces) : ""), i.push("</" + A + ">")) : i.push("/>"), i.join("");
              }(A, n, t);

            case "comment":
              return e + a + u(A[n.commentKey], n);

            case "doctype":
              return e + a + m(A[n.doctypeKey], n);

            case "cdata":
              return e + (n.indentCdata ? a : "") + p(A[n.cdataKey], n);

            case "text":
              return e + (n.indentText ? a : "") + C(A[n.textKey], n);

            case "instruction":
              var f = {};
              return f[A[n.nameKey]] = A[n.attributesKey] ? A : A[n.instructionKey], e + (n.indentInstruction ? a : "") + c(f, n, t);
          }
        }, "");
      }

      function f(e, n, t) {
        var r;

        for (r in e) {
          if (e.hasOwnProperty(r)) switch (r) {
            case n.parentKey:
            case n.attributesKey:
              break;

            case n.textKey:
              if (n.indentText || t) return !0;
              break;

            case n.cdataKey:
              if (n.indentCdata || t) return !0;
              break;

            case n.instructionKey:
              if (n.indentInstruction || t) return !0;
              break;

            case n.doctypeKey:
            case n.commentKey:
            default:
              return !0;
          }
        }

        return !1;
      }

      function h(e, n, t, i, A) {
        r = e, o = n;
        var a = "elementNameFn" in t ? t.elementNameFn(n, e) : n;
        if (null == e) return "fullTagEmptyElementFn" in t && t.fullTagEmptyElementFn(n, e) || t.fullTagEmptyElement ? "<" + a + "></" + a + ">" : "<" + a + "/>";
        var c = [];

        if (n) {
          if (c.push("<" + a), "object" != typeof e) return c.push(">" + C(e, t) + "</" + a + ">"), c.join("");
          e[t.attributesKey] && c.push(l(e[t.attributesKey], t, i));
          var u = f(e, t, !0) || e[t.attributesKey] && "preserve" === e[t.attributesKey]["xml:space"];
          if (u || (u = "fullTagEmptyElementFn" in t ? t.fullTagEmptyElementFn(n, e) : t.fullTagEmptyElement), !u) return c.push("/>"), c.join("");
          c.push(">");
        }

        return c.push(x(e, t, i + 1, !1)), r = e, o = n, n && c.push((A ? s(t, i, !1) : "") + "</" + a + ">"), c.join("");
      }

      function x(e, n, t, r) {
        var o,
            i,
            l,
            d = [];

        for (i in e) {
          if (e.hasOwnProperty(i)) for (l = A(e[i]) ? e[i] : [e[i]], o = 0; o < l.length; ++o) {
            switch (i) {
              case n.declarationKey:
                d.push(a(l[o], n, t));
                break;

              case n.instructionKey:
                d.push((n.indentInstruction ? s(n, t, r) : "") + c(l[o], n, t));
                break;

              case n.attributesKey:
              case n.parentKey:
                break;

              case n.textKey:
                d.push((n.indentText ? s(n, t, r) : "") + C(l[o], n));
                break;

              case n.cdataKey:
                d.push((n.indentCdata ? s(n, t, r) : "") + p(l[o], n));
                break;

              case n.doctypeKey:
                d.push(s(n, t, r) + m(l[o], n));
                break;

              case n.commentKey:
                d.push(s(n, t, r) + u(l[o], n));
                break;

              default:
                d.push(s(n, t, r) + h(l[o], i, n, t, f(l[o], n)));
            }

            r = r && !d.length;
          }
        }

        return d.join("");
      }

      e.exports = function (e, n) {
        n = function (e) {
          var n = i.copyOptions(e);
          return i.ensureFlagExists("ignoreDeclaration", n), i.ensureFlagExists("ignoreInstruction", n), i.ensureFlagExists("ignoreAttributes", n), i.ensureFlagExists("ignoreText", n), i.ensureFlagExists("ignoreComment", n), i.ensureFlagExists("ignoreCdata", n), i.ensureFlagExists("ignoreDoctype", n), i.ensureFlagExists("compact", n), i.ensureFlagExists("indentText", n), i.ensureFlagExists("indentCdata", n), i.ensureFlagExists("indentAttributes", n), i.ensureFlagExists("indentInstruction", n), i.ensureFlagExists("fullTagEmptyElement", n), i.ensureFlagExists("noQuotesForNativeAttributes", n), i.ensureSpacesExists(n), "number" == typeof n.spaces && (n.spaces = Array(n.spaces + 1).join(" ")), i.ensureKeyExists("declaration", n), i.ensureKeyExists("instruction", n), i.ensureKeyExists("attributes", n), i.ensureKeyExists("text", n), i.ensureKeyExists("comment", n), i.ensureKeyExists("cdata", n), i.ensureKeyExists("doctype", n), i.ensureKeyExists("type", n), i.ensureKeyExists("name", n), i.ensureKeyExists("elements", n), i.checkFnExists("doctype", n), i.checkFnExists("instruction", n), i.checkFnExists("cdata", n), i.checkFnExists("comment", n), i.checkFnExists("text", n), i.checkFnExists("instructionName", n), i.checkFnExists("elementName", n), i.checkFnExists("attributeName", n), i.checkFnExists("attributeValue", n), i.checkFnExists("attributes", n), i.checkFnExists("fullTagEmptyElement", n), n;
        }(n);

        var t = [];
        return r = e, o = "_root_", n.compact ? t.push(x(e, n, 0, !0)) : (e[n.declarationKey] && t.push(a(e[n.declarationKey], n, 0)), e[n.elementsKey] && e[n.elementsKey].length && t.push(d(e[n.elementsKey], n, 0, !t.length))), t.join("");
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\indent.ts", o = "e3d78619bc77b1907f9ca2269968613c7ba761e8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\indent.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 13,
              column: 10
            }
          },
          4: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 23
            }
          },
          5: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 52
            }
          },
          6: {
            start: {
              line: 22,
              column: 0
            },
            end: {
              line: 22,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 23
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 17
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/indent.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\indent.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAU1E,sBAAuB,SAAQ,sCAAkD;IAAjF;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,QAAQ;YACd,OAAO,EAAE,WAAW;YACpB,SAAS,EAAE,aAAa;YACxB,KAAK,EAAE,SAAS;YAChB,GAAG,EAAE,OAAO;SACf,CAAC;IACN,CAAC;CAAA;AAED,YAAoB,SAAQ,6BAAY;IACpC,YAAY,KAAkC;QAC1C,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gBAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;IAChD,CAAC;CACJ;AALD,wBAKC",
          sourcesContent: ['// http://officeopenxml.com/WPindentation.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport interface IIndentAttributesProperties {\r\n    readonly left?: number;\r\n    readonly hanging?: number;\r\n    readonly firstLine?: number;\r\n    readonly start?: number;\r\n    readonly end?: number;\r\n}\r\n\r\nclass IndentAttributes extends XmlAttributeComponent<IIndentAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        left: "w:left",\r\n        hanging: "w:hanging",\r\n        firstLine: "w:firstLine",\r\n        start: "w:start",\r\n        end: "w:end",\r\n    };\r\n}\r\n\r\nexport class Indent extends XmlComponent {\r\n    constructor(attrs: IIndentAttributesProperties) {\r\n        super("w:ind");\r\n        this.root.push(new IndentAttributes(attrs));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon7) {
        _inherits(u, _c$XmlAttributeCompon7);

        function u() {
          var _this41;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this41 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this41.xmlKeys = {
            left: "w:left",
            hanging: "w:hanging",
            firstLine: "w:firstLine",
            start: "w:start",
            end: "w:end"
          };
          return _this41;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent33) {
        _inherits(p, _c$XmlComponent33);

        function p(e) {
          var _this42;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this42 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:ind")), a.s[5]++, _this42.root.push(new u(e));
          return _this42;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.Indent = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\keep.ts", o = "14da45cbb1db4d4704614eea3346889bb35dd244", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\keep.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 29
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 30
            }
          },
          4: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 28
            }
          },
          5: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/keep.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\keep.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,eAAuB,SAAQ,6BAAY;IACvC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;IACzB,CAAC;CACJ;AAJD,8BAIC;AAED,cAAsB,SAAQ,6BAAY;IACtC;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;IACxB,CAAC;CACJ;AAJD,4BAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class KeepLines extends XmlComponent {\r\n    constructor() {\r\n        super("w:keepLines");\r\n    }\r\n}\r\n\r\nexport class KeepNext extends XmlComponent {\r\n    constructor() {\r\n        super("w:keepNext");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent34) {
        _inherits(u, _c$XmlComponent34);

        function u() {
          var _this43;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this43 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:keepLines"));
          return _this43;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.KeepLines = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent35) {
        _inherits(p, _c$XmlComponent35);

        function p() {
          var _this44;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this44 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:keepNext"));
          return _this44;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.KeepNext = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\page-break.ts", o = "df92209c28bbb8b3036614cb7b8965e7e5ff9897", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\page-break.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 14
            },
            end: {
              line: 4,
              column: 31
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 22
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 12
            }
          },
          5: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 16
            }
          },
          6: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 36
            }
          },
          7: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 30
            }
          },
          8: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 35
            }
          },
          9: {
            start: {
              line: 25,
              column: 0
            },
            end: {
              line: 25,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 14
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 18
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 21
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/page-break.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\page-break.ts"],
          names: [],
          mappings: ";;AACA,wDAA+D;AAC/D,gCAA6B;AAE7B,WAAY,SAAQ,6BAAY;IAC5B;QACI,KAAK,CAAC,MAAM,CAAC,CAAC;QACd,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,IAAI,EAAE,MAAM;SACf,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,eAAuB,SAAQ,SAAG;IAC9B;QACI,KAAK,EAAE,CAAC;QACR,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,KAAK,EAAE,CAAC,CAAC;IAChC,CAAC;CACJ;AALD,8BAKC;AAKD,qBAA6B,SAAQ,6BAAY;IAC7C;QACI,KAAK,CAAC,mBAAmB,CAAC,CAAC;IAC/B,CAAC;CACJ;AAJD,0CAIC",
          sourcesContent: ['// http://officeopenxml.com/WPtextSpecialContent-break.php\r\nimport { Attributes, XmlComponent } from "file/xml-components";\r\nimport { Run } from "../run";\r\n\r\nclass Break extends XmlComponent {\r\n    constructor() {\r\n        super("w:br");\r\n        this.root.push(\r\n            new Attributes({\r\n                type: "page",\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class PageBreak extends Run {\r\n    constructor() {\r\n        super();\r\n        this.root.push(new Break());\r\n    }\r\n}\r\n\r\n/**\r\n * Add page break before the paragraph if there is no one added before.\r\n */\r\nexport class PageBreakBefore extends XmlComponent {\r\n    constructor() {\r\n        super("w:pageBreakBefore");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(4));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent36) {
        _inherits(p, _c$XmlComponent36);

        function p() {
          var _this45;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this45 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:br")), a.s[4]++, _this45.root.push(new c.Attributes({
            type: "page"
          }));
          return _this45;
        }

        return p;
      }(c.XmlComponent);

      var m =
      /*#__PURE__*/
      function (_u$Run) {
        _inherits(m, _u$Run);

        function m() {
          var _this46;

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this46 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this)), a.s[6]++, _this46.root.push(new p());
          return _this46;
        }

        return m;
      }(u.Run);

      a.s[7]++, n.PageBreak = m;

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent37) {
        _inherits(C, _c$XmlComponent37);

        function C() {
          var _this47;

          _classCallCheck(this, C);

          a.f[2]++, a.s[8]++, _this47 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:pageBreakBefore"));
          return _this47;
        }

        return C;
      }(c.XmlComponent);

      a.s[9]++, n.PageBreakBefore = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\underline.ts", o = "4ebe83c137500a9321aaf7cf1d308c8292732118", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\underline.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 21
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 12
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 38
            }
          },
          5: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 36
            }
          },
          6: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 30
            }
          },
          7: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 22
            }
          },
          8: {
            start: {
              line: 25,
              column: 0
            },
            end: {
              line: 25,
              column: 38
            }
          },
          9: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 33
            }
          },
          10: {
            start: {
              line: 31,
              column: 0
            },
            end: {
              line: 31,
              column: 60
            }
          },
          11: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 30
            }
          },
          12: {
            start: {
              line: 37,
              column: 0
            },
            end: {
              line: 37,
              column: 54
            }
          },
          13: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 26
            }
          },
          14: {
            start: {
              line: 43,
              column: 0
            },
            end: {
              line: 43,
              column: 46
            }
          },
          15: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 46,
              column: 31
            }
          },
          16: {
            start: {
              line: 49,
              column: 0
            },
            end: {
              line: 49,
              column: 56
            }
          },
          17: {
            start: {
              line: 52,
              column: 8
            },
            end: {
              line: 52,
              column: 25
            }
          },
          18: {
            start: {
              line: 55,
              column: 0
            },
            end: {
              line: 55,
              column: 44
            }
          },
          19: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 28
            }
          },
          20: {
            start: {
              line: 61,
              column: 0
            },
            end: {
              line: 61,
              column: 50
            }
          },
          21: {
            start: {
              line: 64,
              column: 8
            },
            end: {
              line: 64,
              column: 24
            }
          },
          22: {
            start: {
              line: 67,
              column: 0
            },
            end: {
              line: 67,
              column: 42
            }
          },
          23: {
            start: {
              line: 70,
              column: 8
            },
            end: {
              line: 70,
              column: 29
            }
          },
          24: {
            start: {
              line: 73,
              column: 0
            },
            end: {
              line: 73,
              column: 52
            }
          },
          25: {
            start: {
              line: 76,
              column: 8
            },
            end: {
              line: 76,
              column: 24
            }
          },
          26: {
            start: {
              line: 79,
              column: 0
            },
            end: {
              line: 79,
              column: 42
            }
          },
          27: {
            start: {
              line: 82,
              column: 8
            },
            end: {
              line: 82,
              column: 24
            }
          },
          28: {
            start: {
              line: 85,
              column: 0
            },
            end: {
              line: 85,
              column: 42
            }
          },
          29: {
            start: {
              line: 88,
              column: 8
            },
            end: {
              line: 88,
              column: 23
            }
          },
          30: {
            start: {
              line: 91,
              column: 0
            },
            end: {
              line: 91,
              column: 40
            }
          },
          31: {
            start: {
              line: 94,
              column: 8
            },
            end: {
              line: 94,
              column: 22
            }
          },
          32: {
            start: {
              line: 97,
              column: 0
            },
            end: {
              line: 97,
              column: 38
            }
          },
          33: {
            start: {
              line: 100,
              column: 8
            },
            end: {
              line: 100,
              column: 28
            }
          },
          34: {
            start: {
              line: 103,
              column: 0
            },
            end: {
              line: 103,
              column: 50
            }
          },
          35: {
            start: {
              line: 106,
              column: 8
            },
            end: {
              line: 106,
              column: 27
            }
          },
          36: {
            start: {
              line: 109,
              column: 0
            },
            end: {
              line: 109,
              column: 48
            }
          },
          37: {
            start: {
              line: 112,
              column: 8
            },
            end: {
              line: 112,
              column: 23
            }
          },
          38: {
            start: {
              line: 115,
              column: 0
            },
            end: {
              line: 115,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 38
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 15,
                column: 4
              },
              end: {
                line: 15,
                column: 5
              }
            },
            loc: {
              start: {
                line: 15,
                column: 49
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 15
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 18
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 21
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 18
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 27
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 33,
                column: 4
              },
              end: {
                line: 33,
                column: 5
              }
            },
            loc: {
              start: {
                line: 33,
                column: 18
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 33
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 39,
                column: 4
              },
              end: {
                line: 39,
                column: 5
              }
            },
            loc: {
              start: {
                line: 39,
                column: 18
              },
              end: {
                line: 41,
                column: 5
              }
            },
            line: 39
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 45,
                column: 4
              },
              end: {
                line: 45,
                column: 5
              }
            },
            loc: {
              start: {
                line: 45,
                column: 18
              },
              end: {
                line: 47,
                column: 5
              }
            },
            line: 45
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 51,
                column: 4
              },
              end: {
                line: 51,
                column: 5
              }
            },
            loc: {
              start: {
                line: 51,
                column: 18
              },
              end: {
                line: 53,
                column: 5
              }
            },
            line: 51
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 57,
                column: 4
              },
              end: {
                line: 57,
                column: 5
              }
            },
            loc: {
              start: {
                line: 57,
                column: 18
              },
              end: {
                line: 59,
                column: 5
              }
            },
            line: 57
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 63,
                column: 4
              },
              end: {
                line: 63,
                column: 5
              }
            },
            loc: {
              start: {
                line: 63,
                column: 18
              },
              end: {
                line: 65,
                column: 5
              }
            },
            line: 63
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 69,
                column: 4
              },
              end: {
                line: 69,
                column: 5
              }
            },
            loc: {
              start: {
                line: 69,
                column: 18
              },
              end: {
                line: 71,
                column: 5
              }
            },
            line: 69
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 75,
                column: 4
              },
              end: {
                line: 75,
                column: 5
              }
            },
            loc: {
              start: {
                line: 75,
                column: 18
              },
              end: {
                line: 77,
                column: 5
              }
            },
            line: 75
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 81,
                column: 4
              },
              end: {
                line: 81,
                column: 5
              }
            },
            loc: {
              start: {
                line: 81,
                column: 18
              },
              end: {
                line: 83,
                column: 5
              }
            },
            line: 81
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 87,
                column: 4
              },
              end: {
                line: 87,
                column: 5
              }
            },
            loc: {
              start: {
                line: 87,
                column: 18
              },
              end: {
                line: 89,
                column: 5
              }
            },
            line: 87
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 93,
                column: 4
              },
              end: {
                line: 93,
                column: 5
              }
            },
            loc: {
              start: {
                line: 93,
                column: 18
              },
              end: {
                line: 95,
                column: 5
              }
            },
            line: 93
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 99,
                column: 4
              },
              end: {
                line: 99,
                column: 5
              }
            },
            loc: {
              start: {
                line: 99,
                column: 18
              },
              end: {
                line: 101,
                column: 5
              }
            },
            line: 99
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 105,
                column: 4
              },
              end: {
                line: 105,
                column: 5
              }
            },
            loc: {
              start: {
                line: 105,
                column: 18
              },
              end: {
                line: 107,
                column: 5
              }
            },
            line: 105
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 111,
                column: 4
              },
              end: {
                line: 111,
                column: 5
              }
            },
            loc: {
              start: {
                line: 111,
                column: 18
              },
              end: {
                line: 113,
                column: 5
              }
            },
            line: 111
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 15,
                column: 16
              },
              end: {
                line: 15,
                column: 40
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 15,
                column: 32
              },
              end: {
                line: 15,
                column: 40
              }
            }],
            line: 15
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0
        },
        b: {
          0: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/underline.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\underline.ts"],
          names: [],
          mappings: ";;AAAA,wDAA+D;AAE/D,mBAAoC,SAAQ,6BAAY;IACpD,YAAY,aAAqB,EAAE,KAAc;QAC7C,KAAK,CAAC,KAAK,CAAC,CAAC;QACb,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,aAAa;YAClB,KAAK,EAAE,KAAK;SACf,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,sCAUC;AAED,eAAuB,SAAQ,aAAa;IACxC,YAAY,gBAAwB,QAAQ,EAAE,KAAc;QACxD,KAAK,CAAC,aAAa,EAAE,KAAK,CAAC,CAAC;IAChC,CAAC;CACJ;AAJD,8BAIC;AAED,mBAA2B,SAAQ,aAAa;IAC5C;QACI,KAAK,CAAC,MAAM,CAAC,CAAC;IAClB,CAAC;CACJ;AAJD,sCAIC;AAED,8BAAsC,SAAQ,aAAa;IACvD;QACI,KAAK,CAAC,iBAAiB,CAAC,CAAC;IAC7B,CAAC;CACJ;AAJD,4DAIC;AAED,2BAAmC,SAAQ,aAAa;IACpD;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;IAC1B,CAAC;CACJ;AAJD,sDAIC;AAED,uBAA+B,SAAQ,aAAa;IAChD;QACI,KAAK,CAAC,UAAU,CAAC,CAAC;IACtB,CAAC;CACJ;AAJD,8CAIC;AAED,4BAAoC,SAAQ,aAAa;IACrD;QACI,KAAK,CAAC,eAAe,CAAC,CAAC;IAC3B,CAAC;CACJ;AAJD,wDAIC;AAED,sBAA8B,SAAQ,aAAa;IAC/C;QACI,KAAK,CAAC,SAAS,CAAC,CAAC;IACrB,CAAC;CACJ;AAJD,4CAIC;AAED,yBAAiC,SAAQ,aAAa;IAClD;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;IACxB,CAAC;CACJ;AAJD,kDAIC;AAED,qBAA6B,SAAQ,aAAa;IAC9C;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;IACpB,CAAC;CACJ;AAJD,0CAIC;AAED,0BAAkC,SAAQ,aAAa;IACnD;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;IACzB,CAAC;CACJ;AAJD,oDAIC;AAED,qBAA6B,SAAQ,aAAa;IAC9C;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;IACpB,CAAC;CACJ;AAJD,0CAIC;AAED,qBAA6B,SAAQ,aAAa;IAC9C;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;IACpB,CAAC;CACJ;AAJD,0CAIC;AAED,oBAA4B,SAAQ,aAAa;IAC7C;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;IACnB,CAAC;CACJ;AAJD,wCAIC;AAED,mBAA2B,SAAQ,aAAa;IAC5C;QACI,KAAK,CAAC,MAAM,CAAC,CAAC;IAClB,CAAC;CACJ;AAJD,sCAIC;AAED,yBAAiC,SAAQ,aAAa;IAClD;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;IACxB,CAAC;CACJ;AAJD,kDAIC;AAED,wBAAgC,SAAQ,aAAa;IACjD;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;IACvB,CAAC;CACJ;AAJD,gDAIC;AAED,oBAA4B,SAAQ,aAAa;IAC7C;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;IACnB,CAAC;CACJ;AAJD,wCAIC",
          sourcesContent: ['import { Attributes, XmlComponent } from "file/xml-components";\r\n\r\nexport abstract class BaseUnderline extends XmlComponent {\r\n    constructor(underlineType: string, color?: string) {\r\n        super("w:u");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: underlineType,\r\n                color: color,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class Underline extends BaseUnderline {\r\n    constructor(underlineType: string = "single", color?: string) {\r\n        super(underlineType, color);\r\n    }\r\n}\r\n\r\nexport class DashUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dash");\r\n    }\r\n}\r\n\r\nexport class DashDotDotHeavyUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dashDotDotHeavy");\r\n    }\r\n}\r\n\r\nexport class DashDotHeavyUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dashDotHeavy");\r\n    }\r\n}\r\n\r\nexport class DashLongUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dashLong");\r\n    }\r\n}\r\n\r\nexport class DashLongHeavyUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dashLongHeavy");\r\n    }\r\n}\r\n\r\nexport class DotDashUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dotDash");\r\n    }\r\n}\r\n\r\nexport class DotDotDashUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dotDotDash");\r\n    }\r\n}\r\n\r\nexport class DottedUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dotted");\r\n    }\r\n}\r\n\r\nexport class DottedHeavyUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("dottedHeavy");\r\n    }\r\n}\r\n\r\nexport class DoubleUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("double");\r\n    }\r\n}\r\n\r\nexport class SingleUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("single");\r\n    }\r\n}\r\n\r\nexport class ThickUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("thick");\r\n    }\r\n}\r\n\r\nexport class WaveUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("wave");\r\n    }\r\n}\r\n\r\nexport class WavyDoubleUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("wavyDouble");\r\n    }\r\n}\r\n\r\nexport class WavyHeavyUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("wavyHeavy");\r\n    }\r\n}\r\n\r\nexport class WordsUnderline extends BaseUnderline {\r\n    constructor() {\r\n        super("words");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent38) {
        _inherits(u, _c$XmlComponent38);

        function u(e, n) {
          var _this48;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this48 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:u")), a.s[3]++, _this48.root.push(new c.Attributes({
            val: e,
            color: n
          }));
          return _this48;
        }

        return u;
      }(c.XmlComponent);

      a.s[4]++, n.BaseUnderline = u, a.s[6]++, n.Underline =
      /*#__PURE__*/
      function (_u) {
        _inherits(_class4, _u);

        function _class4() {
          var _this49;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, "single");
          var n = arguments.length > 1 ? arguments[1] : undefined;

          _classCallCheck(this, _class4);

          a.f[1]++, a.s[5]++, _this49 = _possibleConstructorReturn(this, _getPrototypeOf(_class4).call(this, e, n));
          return _this49;
        }

        return _class4;
      }(u), a.s[8]++, n.DashUnderline =
      /*#__PURE__*/
      function (_u2) {
        _inherits(_class5, _u2);

        function _class5() {
          var _this50;

          _classCallCheck(this, _class5);

          a.f[2]++, a.s[7]++, _this50 = _possibleConstructorReturn(this, _getPrototypeOf(_class5).call(this, "dash"));
          return _this50;
        }

        return _class5;
      }(u), a.s[10]++, n.DashDotDotHeavyUnderline =
      /*#__PURE__*/
      function (_u3) {
        _inherits(_class6, _u3);

        function _class6() {
          var _this51;

          _classCallCheck(this, _class6);

          a.f[3]++, a.s[9]++, _this51 = _possibleConstructorReturn(this, _getPrototypeOf(_class6).call(this, "dashDotDotHeavy"));
          return _this51;
        }

        return _class6;
      }(u), a.s[12]++, n.DashDotHeavyUnderline =
      /*#__PURE__*/
      function (_u4) {
        _inherits(_class7, _u4);

        function _class7() {
          var _this52;

          _classCallCheck(this, _class7);

          a.f[4]++, a.s[11]++, _this52 = _possibleConstructorReturn(this, _getPrototypeOf(_class7).call(this, "dashDotHeavy"));
          return _this52;
        }

        return _class7;
      }(u), a.s[14]++, n.DashLongUnderline =
      /*#__PURE__*/
      function (_u5) {
        _inherits(_class8, _u5);

        function _class8() {
          var _this53;

          _classCallCheck(this, _class8);

          a.f[5]++, a.s[13]++, _this53 = _possibleConstructorReturn(this, _getPrototypeOf(_class8).call(this, "dashLong"));
          return _this53;
        }

        return _class8;
      }(u), a.s[16]++, n.DashLongHeavyUnderline =
      /*#__PURE__*/
      function (_u6) {
        _inherits(_class9, _u6);

        function _class9() {
          var _this54;

          _classCallCheck(this, _class9);

          a.f[6]++, a.s[15]++, _this54 = _possibleConstructorReturn(this, _getPrototypeOf(_class9).call(this, "dashLongHeavy"));
          return _this54;
        }

        return _class9;
      }(u), a.s[18]++, n.DotDashUnderline =
      /*#__PURE__*/
      function (_u7) {
        _inherits(_class10, _u7);

        function _class10() {
          var _this55;

          _classCallCheck(this, _class10);

          a.f[7]++, a.s[17]++, _this55 = _possibleConstructorReturn(this, _getPrototypeOf(_class10).call(this, "dotDash"));
          return _this55;
        }

        return _class10;
      }(u), a.s[20]++, n.DotDotDashUnderline =
      /*#__PURE__*/
      function (_u8) {
        _inherits(_class11, _u8);

        function _class11() {
          var _this56;

          _classCallCheck(this, _class11);

          a.f[8]++, a.s[19]++, _this56 = _possibleConstructorReturn(this, _getPrototypeOf(_class11).call(this, "dotDotDash"));
          return _this56;
        }

        return _class11;
      }(u), a.s[22]++, n.DottedUnderline =
      /*#__PURE__*/
      function (_u9) {
        _inherits(_class12, _u9);

        function _class12() {
          var _this57;

          _classCallCheck(this, _class12);

          a.f[9]++, a.s[21]++, _this57 = _possibleConstructorReturn(this, _getPrototypeOf(_class12).call(this, "dotted"));
          return _this57;
        }

        return _class12;
      }(u), a.s[24]++, n.DottedHeavyUnderline =
      /*#__PURE__*/
      function (_u10) {
        _inherits(_class13, _u10);

        function _class13() {
          var _this58;

          _classCallCheck(this, _class13);

          a.f[10]++, a.s[23]++, _this58 = _possibleConstructorReturn(this, _getPrototypeOf(_class13).call(this, "dottedHeavy"));
          return _this58;
        }

        return _class13;
      }(u), a.s[26]++, n.DoubleUnderline =
      /*#__PURE__*/
      function (_u11) {
        _inherits(_class14, _u11);

        function _class14() {
          var _this59;

          _classCallCheck(this, _class14);

          a.f[11]++, a.s[25]++, _this59 = _possibleConstructorReturn(this, _getPrototypeOf(_class14).call(this, "double"));
          return _this59;
        }

        return _class14;
      }(u), a.s[28]++, n.SingleUnderline =
      /*#__PURE__*/
      function (_u12) {
        _inherits(_class15, _u12);

        function _class15() {
          var _this60;

          _classCallCheck(this, _class15);

          a.f[12]++, a.s[27]++, _this60 = _possibleConstructorReturn(this, _getPrototypeOf(_class15).call(this, "single"));
          return _this60;
        }

        return _class15;
      }(u), a.s[30]++, n.ThickUnderline =
      /*#__PURE__*/
      function (_u13) {
        _inherits(_class16, _u13);

        function _class16() {
          var _this61;

          _classCallCheck(this, _class16);

          a.f[13]++, a.s[29]++, _this61 = _possibleConstructorReturn(this, _getPrototypeOf(_class16).call(this, "thick"));
          return _this61;
        }

        return _class16;
      }(u), a.s[32]++, n.WaveUnderline =
      /*#__PURE__*/
      function (_u14) {
        _inherits(_class17, _u14);

        function _class17() {
          var _this62;

          _classCallCheck(this, _class17);

          a.f[14]++, a.s[31]++, _this62 = _possibleConstructorReturn(this, _getPrototypeOf(_class17).call(this, "wave"));
          return _this62;
        }

        return _class17;
      }(u), a.s[34]++, n.WavyDoubleUnderline =
      /*#__PURE__*/
      function (_u15) {
        _inherits(_class18, _u15);

        function _class18() {
          var _this63;

          _classCallCheck(this, _class18);

          a.f[15]++, a.s[33]++, _this63 = _possibleConstructorReturn(this, _getPrototypeOf(_class18).call(this, "wavyDouble"));
          return _this63;
        }

        return _class18;
      }(u), a.s[36]++, n.WavyHeavyUnderline =
      /*#__PURE__*/
      function (_u16) {
        _inherits(_class19, _u16);

        function _class19() {
          var _this64;

          _classCallCheck(this, _class19);

          a.f[16]++, a.s[35]++, _this64 = _possibleConstructorReturn(this, _getPrototypeOf(_class19).call(this, "wavyHeavy"));
          return _this64;
        }

        return _class19;
      }(u), a.s[38]++, n.WordsUnderline =
      /*#__PURE__*/
      function (_u17) {
        _inherits(_class20, _u17);

        function _class20() {
          var _this65;

          _classCallCheck(this, _class20);

          a.f[17]++, a.s[37]++, _this65 = _possibleConstructorReturn(this, _getPrototypeOf(_class20).call(this, "words"));
          return _this65;
        }

        return _class20;
      }(u);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\script.ts", o = "dfb298a4ab4d3bcdb9f2a8ee69d21f5e4688cbeb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\script.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 29
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 12
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 38
            }
          },
          5: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 29
            }
          },
          6: {
            start: {
              line: 18,
              column: 0
            },
            end: {
              line: 18,
              column: 34
            }
          },
          7: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 27
            }
          },
          8: {
            start: {
              line: 24,
              column: 0
            },
            end: {
              line: 24,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 22
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 18
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 14
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 18
              },
              end: {
                line: 22,
                column: 5
              }
            },
            line: 20
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/script.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\script.ts"],
          names: [],
          mappings: ";;AAAA,wDAA+D;AAE/D,mBAAoC,SAAQ,6BAAY;IACpD,YAAY,IAAY;QACpB,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,IAAI;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,sCASC;AAED,iBAAyB,SAAQ,aAAa;IAC1C;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;IACzB,CAAC;CACJ;AAJD,kCAIC;AAED,eAAuB,SAAQ,aAAa;IACxC;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;IACvB,CAAC;CACJ;AAJD,8BAIC",
          sourcesContent: ['import { Attributes, XmlComponent } from "file/xml-components";\r\n\r\nexport abstract class VerticalAlign extends XmlComponent {\r\n    constructor(type: string) {\r\n        super("w:vertAlign");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: type,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class SuperScript extends VerticalAlign {\r\n    constructor() {\r\n        super("superscript");\r\n    }\r\n}\r\n\r\nexport class SubScript extends VerticalAlign {\r\n    constructor() {\r\n        super("subscript");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent39) {
        _inherits(u, _c$XmlComponent39);

        function u(e) {
          var _this66;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this66 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:vertAlign")), a.s[3]++, _this66.root.push(new c.Attributes({
            val: e
          }));
          return _this66;
        }

        return u;
      }(c.XmlComponent);

      a.s[4]++, n.VerticalAlign = u, a.s[6]++, n.SuperScript =
      /*#__PURE__*/
      function (_u18) {
        _inherits(_class21, _u18);

        function _class21() {
          var _this67;

          _classCallCheck(this, _class21);

          a.f[1]++, a.s[5]++, _this67 = _possibleConstructorReturn(this, _getPrototypeOf(_class21).call(this, "superscript"));
          return _this67;
        }

        return _class21;
      }(u), a.s[8]++, n.SubScript =
      /*#__PURE__*/
      function (_u19) {
        _inherits(_class22, _u19);

        function _class22() {
          var _this68;

          _classCallCheck(this, _class22);

          a.f[2]++, a.s[7]++, _this68 = _possibleConstructorReturn(this, _getPrototypeOf(_class22).call(this, "subscript"));
          return _this68;
        }

        return _class22;
      }(u);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\style.ts", o = "5be36e45155690c4f2f5e473b92d301d8d61f046", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\style.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 40
            }
          },
          4: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 26
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 62
            }
          },
          6: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 25
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/style.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\style.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAE1E,qBAAsB,SAAQ,sCAA+C;IAA7E;;QACuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC;IAClD,CAAC;CAAA;AAED,WAAmB,SAAQ,6BAAY;IACnC,YAAY,OAAe;QACvB,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,eAAe,CAAC,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC,CAAC,CAAC;IAC1D,CAAC;CACJ;AALD,sBAKC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nclass StyleAttributes extends XmlAttributeComponent<{ readonly val: string }> {\r\n    protected readonly xmlKeys = { val: "w:val" };\r\n}\r\n\r\nexport class Style extends XmlComponent {\r\n    constructor(styleId: string) {\r\n        super("w:rStyle");\r\n        this.root.push(new StyleAttributes({ val: styleId }));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon8) {
        _inherits(u, _c$XmlAttributeCompon8);

        function u() {
          var _this69;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this69 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this69.xmlKeys = {
            val: "w:val"
          };
          return _this69;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent40) {
        _inherits(p, _c$XmlComponent40);

        function p(e) {
          var _this70;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this70 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:rStyle")), a.s[5]++, _this70.root.push(new u({
            val: e
          }));
          return _this70;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.Style = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\index.ts", o = "76663e16df0929671adce5647d337678266d0cf1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 31
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 33
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,+BAA0B;AAC1B,iCAA4B;AAC5B,gCAA2B",
          sourcesContent: ['export * from "./drawing";\r\nexport * from "./text-wrap";\r\nexport * from "./floating";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(159)), a.s[5]++, c(t(39)), a.s[6]++, c(t(68));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\index.ts", o = "4370796d6c194be6aea45f08703d7b6cd7f7aa33", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 41
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 34
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 43
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 41
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/floating/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\floating\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,yCAAoC;AACpC,kCAA6B;AAC7B,2CAAsC;AACtC,yCAAoC",
          sourcesContent: ['export * from "./floating-position";\r\nexport * from "./simple-pos";\r\nexport * from "./horizontal-position";\r\nexport * from "./vertical-position";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(38)), a.s[5]++, c(t(162)), a.s[6]++, c(t(163)), a.s[7]++, c(t(164));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\align.ts", o = "3b110c7f33e3fc2e9c310d792380dcb1741b821c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\align.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 26
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 30
            }
          },
          4: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 23
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/floating/align.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\floating\\align.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AAGnD,WAAmB,SAAQ,6BAAY;IACnC,YAAY,KAAsD;QAC9D,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,sBAKC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-position.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { HorizontalPositionAlign, VerticalPositionAlign } from "./floating-position";\r\n\r\nexport class Align extends XmlComponent {\r\n    constructor(value: HorizontalPositionAlign | VerticalPositionAlign) {\r\n        super("wp:align");\r\n        this.root.push(value);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent41) {
        _inherits(u, _c$XmlComponent41);

        function u(e) {
          var _this71;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this71 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "wp:align")), a.s[3]++, _this71.root.push(e);
          return _this71;
        }

        return u;
      }(c.XmlComponent);

      a.s[4]++, n.Align = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\position-offset.ts", o = "136b68e4f553bdc686e9473ef94cb7c91393c75d", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\position-offset.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 30
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 47
            }
          },
          4: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 29
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/floating/position-offset.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\floating\\position-offset.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AAEnD,oBAA4B,SAAQ,6BAAY;IAC5C,YAAY,WAAmB;QAC3B,KAAK,CAAC,cAAc,CAAC,CAAC;QACtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,WAAW,CAAC,QAAQ,EAAE,CAAC,CAAC;IAC3C,CAAC;CACJ;AALD,wCAKC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-position.php\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nexport class PositionOffset extends XmlComponent {\r\n    constructor(offsetValue: number) {\r\n        super("wp:posOffset");\r\n        this.root.push(offsetValue.toString());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent42) {
        _inherits(u, _c$XmlComponent42);

        function u(e) {
          var _this72;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this72 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "wp:posOffset")), a.s[3]++, _this72.root.push(e.toString());
          return _this72;
        }

        return u;
      }(c.XmlComponent);

      a.s[4]++, n.PositionOffset = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\index.ts", o = "5d1a572ccef6baa37588e90cad4d004ad8d47998", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 31
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,+BAA0B",
          sourcesContent: ['export * from "./graphic";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(165));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\doc-properties\\doc-properties.ts", o = "4a8bbae745e4461dcfb5ba2d3d3102e9b32018ca", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\doc-properties\\doc-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 36
            },
            end: {
              line: 4,
              column: 74
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 26
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 12,
              column: 12
            }
          },
          5: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/doc-properties/doc-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\doc-properties\\doc-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,2EAAsE;AAEtE,mBAA2B,SAAQ,6BAAY;IAC3C;QACI,KAAK,CAAC,UAAU,CAAC,CAAC;QAElB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,mDAAuB,CAAC;YACxB,EAAE,EAAE,CAAC;YACL,IAAI,EAAE,EAAE;YACR,KAAK,EAAE,EAAE;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAZD,sCAYC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { DocPropertiesAttributes } from "./doc-properties-attributes";\r\n\r\nexport class DocProperties extends XmlComponent {\r\n    constructor() {\r\n        super("wp:docPr");\r\n\r\n        this.root.push(\r\n            new DocPropertiesAttributes({\r\n                id: 0,\r\n                name: "",\r\n                descr: "",\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(198));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent43) {
        _inherits(p, _c$XmlComponent43);

        function p() {
          var _this73;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this73 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "wp:docPr")), a.s[4]++, _this73.root.push(new u.DocPropertiesAttributes({
            id: 0,
            name: "",
            descr: ""
          }));
          return _this73;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.DocProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\effect-extent\\effect-extent.ts", o = "4a54db4f5ccb929fe170b909643a36e89cce265c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\effect-extent\\effect-extent.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 35
            },
            end: {
              line: 4,
              column: 72
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 33
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 13,
              column: 12
            }
          },
          5: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/effect-extent/effect-extent.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\effect-extent\\effect-extent.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,yEAAoE;AAEpE,kBAA0B,SAAQ,6BAAY;IAC1C;QACI,KAAK,CAAC,iBAAiB,CAAC,CAAC;QAEzB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,iDAAsB,CAAC;YACvB,CAAC,EAAE,CAAC;YACJ,CAAC,EAAE,CAAC;YACJ,CAAC,EAAE,CAAC;YACJ,CAAC,EAAE,CAAC;SACP,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAbD,oCAaC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { EffectExtentAttributes } from "./effect-extent-attributes";\r\n\r\nexport class EffectExtent extends XmlComponent {\r\n    constructor() {\r\n        super("wp:effectExtent");\r\n\r\n        this.root.push(\r\n            new EffectExtentAttributes({\r\n                b: 0,\r\n                l: 0,\r\n                r: 0,\r\n                t: 0,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(199));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent44) {
        _inherits(p, _c$XmlComponent44);

        function p() {
          var _this74;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this74 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "wp:effectExtent")), a.s[4]++, _this74.root.push(new u.EffectExtentAttributes({
            b: 0,
            l: 0,
            r: 0,
            t: 0
          }));
          return _this74;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.EffectExtent = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\extent\\extent.ts", o = "acde2373d2aefebbf1086071a7702bc4bb1c4f71", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\extent\\extent.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 28
            },
            end: {
              line: 4,
              column: 58
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 27
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 11
            }
          },
          5: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 40
            }
          },
          6: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 18,
              column: 11
            }
          },
          7: {
            start: {
              line: 21,
              column: 0
            },
            end: {
              line: 21,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 22
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 16
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 14
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/extent/extent.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\extent\\extent.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,2DAAuD;AAEvD,YAAoB,SAAQ,6BAAY;IAGpC,YAAY,CAAS,EAAE,CAAS;QAC5B,KAAK,CAAC,WAAW,CAAC,CAAC;QAEnB,IAAI,CAAC,UAAU,GAAG,IAAI,oCAAgB,CAAC;YACnC,EAAE,EAAE,CAAC;YACL,EAAE,EAAE,CAAC;SACR,CAAC,CAAC;QAEH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAEM,KAAK,CAAC,CAAS,EAAE,CAAS;QAC7B,IAAI,CAAC,UAAU,CAAC,GAAG,CAAC;YAChB,EAAE,EAAE,CAAC;YACL,EAAE,EAAE,CAAC;SACR,CAAC,CAAC;IACP,CAAC;CACJ;AApBD,wBAoBC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nimport { ExtentAttributes } from "./extent-attributes";\r\n\r\nexport class Extent extends XmlComponent {\r\n    private readonly attributes: ExtentAttributes;\r\n\r\n    constructor(x: number, y: number) {\r\n        super("wp:extent");\r\n\r\n        this.attributes = new ExtentAttributes({\r\n            cx: x,\r\n            cy: y,\r\n        });\r\n\r\n        this.root.push(this.attributes);\r\n    }\r\n\r\n    public setXY(x: number, y: number): void {\r\n        this.attributes.set({\r\n            cx: x,\r\n            cy: y,\r\n        });\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(200));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent45) {
        _inherits(p, _c$XmlComponent45);

        function p(e, n) {
          var _this75;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this75 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "wp:extent")), a.s[4]++, _this75.attributes = new u.ExtentAttributes({
            cx: e,
            cy: n
          }), a.s[5]++, _this75.root.push(_this75.attributes);
          return _this75;
        }

        _createClass(p, [{
          key: "setXY",
          value: function setXY(e, n) {
            a.f[1]++, a.s[6]++, this.attributes.set({
              cx: e,
              cy: n
            });
          }
        }]);

        return p;
      }(c.XmlComponent);

      a.s[7]++, n.Extent = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\graphic-frame\\graphic-frame-properties.ts", o = "8076ccac5d39f31d67227dc1cd7e5598183e4a21", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\graphic-frame\\graphic-frame-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 30
            },
            end: {
              line: 4,
              column: 82
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 38
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 70
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 56
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/graphic-frame/graphic-frame-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\graphic-frame\\graphic-frame-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,mFAA8E;AAE9E,4BAAoC,SAAQ,6BAAY;IACpD;QACI,KAAK,CAAC,sBAAsB,CAAC,CAAC;QAE9B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uCAAiB,EAAE,CAAC,CAAC;IAC5C,CAAC;CACJ;AAND,wDAMC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { GraphicFrameLocks } from "./graphic-frame-locks/graphic-frame-locks";\r\n\r\nexport class GraphicFrameProperties extends XmlComponent {\r\n    constructor() {\r\n        super("wp:cNvGraphicFramePr");\r\n\r\n        this.root.push(new GraphicFrameLocks());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(201));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent46) {
        _inherits(p, _c$XmlComponent46);

        function p() {
          var _this76;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this76 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "wp:cNvGraphicFramePr")), a.s[4]++, _this76.root.push(new u.GraphicFrameLocks());
          return _this76;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.GraphicFrameProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\anchor\\anchor-attributes.ts", o = "7764acce23795a61d6bb9b850ad1dd2dd24ac595", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\anchor\\anchor-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 18,
              column: 10
            }
          },
          4: {
            start: {
              line: 21,
              column: 0
            },
            end: {
              line: 21,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/anchor/anchor-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\anchor\\anchor-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAY5D,sBAA8B,SAAQ,sCAAwC;IAA9E;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,YAAY,EAAE,cAAc;YAC5B,SAAS,EAAE,WAAW;YACtB,YAAY,EAAE,cAAc;YAC5B,MAAM,EAAE,QAAQ;YAChB,cAAc,EAAE,gBAAgB;YAChC,SAAS,EAAE,WAAW;SACzB,CAAC;IACN,CAAC;CAAA;AAbD,4CAaC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\nimport { IDistance } from "../drawing";\r\n\r\nexport interface IAnchorAttributes extends IDistance {\r\n    readonly allowOverlap?: "0" | "1";\r\n    readonly behindDoc?: "0" | "1";\r\n    readonly layoutInCell?: "0" | "1";\r\n    readonly locked?: "0" | "1";\r\n    readonly relativeHeight?: number;\r\n    readonly simplePos?: "0" | "1";\r\n}\r\n\r\nexport class AnchorAttributes extends XmlAttributeComponent<IAnchorAttributes> {\r\n    protected readonly xmlKeys = {\r\n        distT: "distT",\r\n        distB: "distB",\r\n        distL: "distL",\r\n        distR: "distR",\r\n        allowOverlap: "allowOverlap",\r\n        behindDoc: "behindDoc",\r\n        layoutInCell: "layoutInCell",\r\n        locked: "locked",\r\n        relativeHeight: "relativeHeight",\r\n        simplePos: "simplePos",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon9) {
        _inherits(u, _c$XmlAttributeCompon9);

        function u() {
          var _this77;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this77 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this77.xmlKeys = {
            distT: "distT",
            distB: "distB",
            distL: "distL",
            distR: "distR",
            allowOverlap: "allowOverlap",
            behindDoc: "behindDoc",
            layoutInCell: "layoutInCell",
            locked: "locked",
            relativeHeight: "relativeHeight",
            simplePos: "simplePos"
          };
          return _this77;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.AnchorAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\spacing.ts", o = "ec9c26ae8273d06ab6d0850bf63e83b4942ee643", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\spacing.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 12,
              column: 10
            }
          },
          4: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 27
            }
          },
          5: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 52
            }
          },
          6: {
            start: {
              line: 21,
              column: 0
            },
            end: {
              line: 21,
              column: 26
            }
          },
          7: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 37
            }
          },
          8: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 27,
              column: 12
            }
          },
          9: {
            start: {
              line: 30,
              column: 0
            },
            end: {
              line: 30,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 22
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 16
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 23,
                column: 4
              },
              end: {
                line: 23,
                column: 5
              }
            },
            loc: {
              start: {
                line: 23,
                column: 23
              },
              end: {
                line: 28,
                column: 5
              }
            },
            line: 23
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 26,
                column: 17
              },
              end: {
                line: 26,
                column: 40
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 26,
                column: 35
              },
              end: {
                line: 26,
                column: 36
              }
            }, {
              start: {
                line: 26,
                column: 39
              },
              end: {
                line: 26,
                column: 40
              }
            }],
            line: 26
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/spacing.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\spacing.ts"],
          names: [],
          mappings: ";;AACA,wDAAsF;AAStF,uBAAwB,SAAQ,sCAAyC;IAAzE;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,SAAS;YAChB,MAAM,EAAE,UAAU;YAClB,IAAI,EAAE,QAAQ;YACd,QAAQ,EAAE,YAAY;SACzB,CAAC;IACN,CAAC;CAAA;AAED,aAAqB,SAAQ,6BAAY;IACrC,YAAY,IAAwB;QAChC,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAiB,CAAC,IAAI,CAAC,CAAC,CAAC;IAChD,CAAC;CACJ;AALD,0BAKC;AAED,uBAA+B,SAAQ,6BAAY;IAC/C,YAAY,KAAc;QACtB,KAAK,CAAC,qBAAqB,CAAC,CAAC;QAC7B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK,KAAK,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC;SAC/B,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,8CASC",
          sourcesContent: ['// http://officeopenxml.com/WPspacing.php\r\nimport { Attributes, XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport interface ISpacingProperties {\r\n    readonly after?: number;\r\n    readonly before?: number;\r\n    readonly line?: number;\r\n    readonly lineRule?: string;\r\n}\r\n\r\nclass SpacingAttributes extends XmlAttributeComponent<ISpacingProperties> {\r\n    protected readonly xmlKeys = {\r\n        after: "w:after",\r\n        before: "w:before",\r\n        line: "w:line",\r\n        lineRule: "w:lineRule",\r\n    };\r\n}\r\n\r\nexport class Spacing extends XmlComponent {\r\n    constructor(opts: ISpacingProperties) {\r\n        super("w:spacing");\r\n        this.root.push(new SpacingAttributes(opts));\r\n    }\r\n}\r\n\r\nexport class ContextualSpacing extends XmlComponent {\r\n    constructor(value: boolean) {\r\n        super("w:contextualSpacing");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value === false ? 0 : 1,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon10) {
        _inherits(u, _c$XmlAttributeCompon10);

        function u() {
          var _this78;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this78 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this78.xmlKeys = {
            after: "w:after",
            before: "w:before",
            line: "w:line",
            lineRule: "w:lineRule"
          };
          return _this78;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent47) {
        _inherits(p, _c$XmlComponent47);

        function p(e) {
          var _this79;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this79 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:spacing")), a.s[5]++, _this79.root.push(new u(e));
          return _this79;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.Spacing = p;

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent48) {
        _inherits(m, _c$XmlComponent48);

        function m(e) {
          var _this80;

          _classCallCheck(this, m);

          a.f[2]++, a.s[7]++, _this80 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:contextualSpacing")), a.s[8]++, _this80.root.push(new c.Attributes({
            val: !1 === e ? (a.b[0][0]++, 0) : (a.b[0][1]++, 1)
          }));
          return _this80;
        }

        return m;
      }(c.XmlComponent);

      a.s[9]++, n.ContextualSpacing = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\style.ts", o = "83c0ff2db6c0976ee22c8488bc73874b8b0f2830", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\style.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 26
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 31
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 12
            }
          },
          5: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 25
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/style.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\style.ts"],
          names: [],
          mappings: ";;AAAA,wDAA+D;AAE/D,WAAmB,SAAQ,6BAAY;IAGnC,YAAY,OAAe;QACvB,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,OAAO,GAAG,OAAO,CAAC;QACvB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,OAAO;SACf,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAZD,sBAYC",
          sourcesContent: ['import { Attributes, XmlComponent } from "file/xml-components";\r\n\r\nexport class Style extends XmlComponent {\r\n    public readonly styleId: string;\r\n\r\n    constructor(styleId: string) {\r\n        super("w:pStyle");\r\n        this.styleId = styleId;\r\n        this.root.push(\r\n            new Attributes({\r\n                val: styleId,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent49) {
        _inherits(u, _c$XmlComponent49);

        function u(e) {
          var _this81;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this81 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:pStyle")), a.s[3]++, _this81.styleId = e, a.s[4]++, _this81.root.push(new c.Attributes({
            val: e
          }));
          return _this81;
        }

        return u;
      }(c.XmlComponent);

      a.s[5]++, n.Style = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\tab-stop.ts", o = "ddd30e25054e3c7609fd031c1019647e1ac8420e", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\tab-stop.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 24
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 26
            }
          },
          5: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 22,
              column: 59
            }
          },
          6: {
            start: {
              line: 13,
              column: 4
            },
            end: {
              line: 13,
              column: 30
            }
          },
          7: {
            start: {
              line: 14,
              column: 4
            },
            end: {
              line: 14,
              column: 32
            }
          },
          8: {
            start: {
              line: 15,
              column: 4
            },
            end: {
              line: 15,
              column: 34
            }
          },
          9: {
            start: {
              line: 16,
              column: 4
            },
            end: {
              line: 16,
              column: 28
            }
          },
          10: {
            start: {
              line: 17,
              column: 4
            },
            end: {
              line: 17,
              column: 32
            }
          },
          11: {
            start: {
              line: 18,
              column: 4
            },
            end: {
              line: 18,
              column: 36
            }
          },
          12: {
            start: {
              line: 19,
              column: 4
            },
            end: {
              line: 19,
              column: 28
            }
          },
          13: {
            start: {
              line: 20,
              column: 4
            },
            end: {
              line: 20,
              column: 28
            }
          },
          14: {
            start: {
              line: 21,
              column: 4
            },
            end: {
              line: 21,
              column: 32
            }
          },
          15: {
            start: {
              line: 24,
              column: 0
            },
            end: {
              line: 30,
              column: 65
            }
          },
          16: {
            start: {
              line: 25,
              column: 4
            },
            end: {
              line: 25,
              column: 30
            }
          },
          17: {
            start: {
              line: 26,
              column: 4
            },
            end: {
              line: 26,
              column: 36
            }
          },
          18: {
            start: {
              line: 27,
              column: 4
            },
            end: {
              line: 27,
              column: 43
            }
          },
          19: {
            start: {
              line: 28,
              column: 4
            },
            end: {
              line: 28,
              column: 32
            }
          },
          20: {
            start: {
              line: 29,
              column: 4
            },
            end: {
              line: 29,
              column: 44
            }
          },
          21: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 28
            }
          },
          22: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 74
            }
          },
          23: {
            start: {
              line: 37,
              column: 0
            },
            end: {
              line: 37,
              column: 38
            }
          },
          24: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 23
            }
          },
          25: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 45,
              column: 12
            }
          },
          26: {
            start: {
              line: 48,
              column: 0
            },
            end: {
              line: 48,
              column: 34
            }
          },
          27: {
            start: {
              line: 51,
              column: 8
            },
            end: {
              line: 51,
              column: 61
            }
          },
          28: {
            start: {
              line: 54,
              column: 0
            },
            end: {
              line: 54,
              column: 42
            }
          },
          29: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 64
            }
          },
          30: {
            start: {
              line: 60,
              column: 0
            },
            end: {
              line: 60,
              column: 34
            }
          },
          31: {
            start: {
              line: 63,
              column: 8
            },
            end: {
              line: 63,
              column: 65
            }
          },
          32: {
            start: {
              line: 66,
              column: 0
            },
            end: {
              line: 66,
              column: 36
            }
          },
          33: {
            start: {
              line: 69,
              column: 8
            },
            end: {
              line: 69,
              column: 66
            }
          },
          34: {
            start: {
              line: 72,
              column: 0
            },
            end: {
              line: 72,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 21
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 1
              },
              end: {
                line: 12,
                column: 2
              }
            },
            loc: {
              start: {
                line: 12,
                column: 21
              },
              end: {
                line: 22,
                column: 1
              }
            },
            line: 12
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 24,
                column: 1
              },
              end: {
                line: 24,
                column: 2
              }
            },
            loc: {
              start: {
                line: 24,
                column: 23
              },
              end: {
                line: 30,
                column: 1
              }
            },
            line: 24
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 32,
                column: 4
              },
              end: {
                line: 32,
                column: 5
              }
            },
            loc: {
              start: {
                line: 32,
                column: 18
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 32
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 39,
                column: 4
              },
              end: {
                line: 39,
                column: 5
              }
            },
            loc: {
              start: {
                line: 39,
                column: 41
              },
              end: {
                line: 46,
                column: 5
              }
            },
            line: 39
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 50,
                column: 4
              },
              end: {
                line: 50,
                column: 5
              }
            },
            loc: {
              start: {
                line: 50,
                column: 24
              },
              end: {
                line: 52,
                column: 5
              }
            },
            line: 50
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 56,
                column: 4
              },
              end: {
                line: 56,
                column: 5
              }
            },
            loc: {
              start: {
                line: 56,
                column: 34
              },
              end: {
                line: 58,
                column: 5
              }
            },
            line: 56
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 62,
                column: 4
              },
              end: {
                line: 62,
                column: 5
              }
            },
            loc: {
              start: {
                line: 62,
                column: 34
              },
              end: {
                line: 64,
                column: 5
              }
            },
            line: 62
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 68,
                column: 4
              },
              end: {
                line: 68,
                column: 5
              }
            },
            loc: {
              start: {
                line: 68,
                column: 34
              },
              end: {
                line: 70,
                column: 5
              }
            },
            line: 68
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 22,
                column: 14
              },
              end: {
                line: 22,
                column: 57
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 22,
                column: 14
              },
              end: {
                line: 22,
                column: 30
              }
            }, {
              start: {
                line: 22,
                column: 35
              },
              end: {
                line: 22,
                column: 56
              }
            }],
            line: 22
          },
          1: {
            loc: {
              start: {
                line: 30,
                column: 16
              },
              end: {
                line: 30,
                column: 63
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 30,
                column: 16
              },
              end: {
                line: 30,
                column: 34
              }
            }, {
              start: {
                line: 30,
                column: 39
              },
              end: {
                line: 30,
                column: 62
              }
            }],
            line: 30
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/tab-stop.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\tab-stop.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAE1E,aAAqB,SAAQ,6BAAY;IACrC,YAAY,GAAgB;QACxB,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;IACxB,CAAC;CACJ;AALD,0BAKC;AAED,IAAY,QAUX;AAVD,WAAY,QAAQ;IAChB,yBAAa,CAAA;IACb,2BAAe,CAAA;IACf,6BAAiB,CAAA;IACjB,uBAAW,CAAA;IACX,2BAAe,CAAA;IACf,+BAAmB,CAAA;IACnB,uBAAW,CAAA;IACX,uBAAW,CAAA;IACX,2BAAe,CAAA;AACnB,CAAC,EAVW,QAAQ,GAAR,gBAAQ,KAAR,gBAAQ,QAUnB;AAED,IAAY,UAMX;AAND,WAAY,UAAU;IAClB,yBAAW,CAAA;IACX,+BAAiB,CAAA;IACjB,sCAAwB,CAAA;IACxB,2BAAa,CAAA;IACb,uCAAyB,CAAA;AAC7B,CAAC,EANW,UAAU,GAAV,kBAAU,KAAV,kBAAU,QAMrB;AAED,mBAA2B,SAAQ,sCAIjC;IAJF;;QAKuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,GAAG,EAAE,OAAO,EAAE,MAAM,EAAE,UAAU,EAAE,CAAC;IACpF,CAAC;CAAA;AAND,sCAMC;AAED,iBAAyB,SAAQ,6BAAY;IACzC,YAAY,KAAe,EAAE,QAAyB,EAAE,MAAmB;QACvE,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,aAAa,CAAC;YACd,GAAG,EAAE,KAAK;YACV,GAAG,EAAE,QAAQ;YACb,MAAM;SACT,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,kCAWC;AAED,qBAA6B,SAAQ,OAAO;IACxC,YAAY,MAAmB;QAC3B,KAAK,CAAC,IAAI,WAAW,CAAC,QAAQ,CAAC,KAAK,EAAE,IAAI,EAAE,MAAM,CAAC,CAAC,CAAC;IACzD,CAAC;CACJ;AAJD,0CAIC;AAED,iBAAyB,SAAQ,OAAO;IACpC,YAAY,QAAgB,EAAE,MAAmB;QAC7C,KAAK,CAAC,IAAI,WAAW,CAAC,QAAQ,CAAC,IAAI,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,CAAC;IAC5D,CAAC;CACJ;AAJD,kCAIC;AAED,kBAA0B,SAAQ,OAAO;IACrC,YAAY,QAAgB,EAAE,MAAmB;QAC7C,KAAK,CAAC,IAAI,WAAW,CAAC,QAAQ,CAAC,KAAK,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,CAAC;IAC7D,CAAC;CACJ;AAJD,oCAIC;AAED,mBAA2B,SAAQ,OAAO;IACtC,YAAY,QAAgB,EAAE,MAAmB;QAC7C,KAAK,CAAC,IAAI,WAAW,CAAC,QAAQ,CAAC,MAAM,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,CAAC;IAC9D,CAAC;CACJ;AAJD,sCAIC",
          sourcesContent: ['// http://officeopenxml.com/WPtab.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport class TabStop extends XmlComponent {\r\n    constructor(tab: TabStopItem) {\r\n        super("w:tabs");\r\n        this.root.push(tab);\r\n    }\r\n}\r\n\r\nexport enum TabValue {\r\n    LEFT = "left",\r\n    RIGHT = "right",\r\n    CENTER = "center",\r\n    BAR = "bar",\r\n    CLEAR = "clear",\r\n    DECIMAL = "decimal",\r\n    END = "end",\r\n    NUM = "num",\r\n    START = "start",\r\n}\r\n\r\nexport enum LeaderType {\r\n    DOT = "dot",\r\n    HYPHEN = "hyphen",\r\n    MIDDLE_DOT = "middleDot",\r\n    NONE = "none",\r\n    UNDERSCORE = "underscore",\r\n}\r\n\r\nexport class TabAttributes extends XmlAttributeComponent<{\r\n    readonly val: TabValue;\r\n    readonly pos: string | number;\r\n    readonly leader?: LeaderType;\r\n}> {\r\n    protected readonly xmlKeys = { val: "w:val", pos: "w:pos", leader: "w:leader" };\r\n}\r\n\r\nexport class TabStopItem extends XmlComponent {\r\n    constructor(value: TabValue, position: string | number, leader?: LeaderType) {\r\n        super("w:tab");\r\n        this.root.push(\r\n            new TabAttributes({\r\n                val: value,\r\n                pos: position,\r\n                leader,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class MaxRightTabStop extends TabStop {\r\n    constructor(leader?: LeaderType) {\r\n        super(new TabStopItem(TabValue.RIGHT, 9026, leader));\r\n    }\r\n}\r\n\r\nexport class LeftTabStop extends TabStop {\r\n    constructor(position: number, leader?: LeaderType) {\r\n        super(new TabStopItem(TabValue.LEFT, position, leader));\r\n    }\r\n}\r\n\r\nexport class RightTabStop extends TabStop {\r\n    constructor(position: number, leader?: LeaderType) {\r\n        super(new TabStopItem(TabValue.RIGHT, position, leader));\r\n    }\r\n}\r\n\r\nexport class CenterTabStop extends TabStop {\r\n    constructor(position: number, leader?: LeaderType) {\r\n        super(new TabStopItem(TabValue.CENTER, position, leader));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent50) {
        _inherits(u, _c$XmlComponent50);

        function u(e) {
          var _this82;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this82 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:tabs")), a.s[3]++, _this82.root.push(e);
          return _this82;
        }

        return u;
      }(c.XmlComponent);

      var p;
      a.s[4]++, n.TabStop = u, a.s[5]++, function (e) {
        a.f[1]++, a.s[6]++, e.LEFT = "left", a.s[7]++, e.RIGHT = "right", a.s[8]++, e.CENTER = "center", a.s[9]++, e.BAR = "bar", a.s[10]++, e.CLEAR = "clear", a.s[11]++, e.DECIMAL = "decimal", a.s[12]++, e.END = "end", a.s[13]++, e.NUM = "num", a.s[14]++, e.START = "start";
      }((a.b[0][0]++, p = n.TabValue || (a.b[0][1]++, n.TabValue = {}))), a.s[15]++, function (e) {
        a.f[2]++, a.s[16]++, e.DOT = "dot", a.s[17]++, e.HYPHEN = "hyphen", a.s[18]++, e.MIDDLE_DOT = "middleDot", a.s[19]++, e.NONE = "none", a.s[20]++, e.UNDERSCORE = "underscore";
      }((a.b[1][0]++, n.LeaderType || (a.b[1][1]++, n.LeaderType = {})));

      var m =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon11) {
        _inherits(m, _c$XmlAttributeCompon11);

        function m() {
          var _this83;

          _classCallCheck(this, m);

          a.f[3]++, a.s[21]++, _this83 = _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments)), a.s[22]++, _this83.xmlKeys = {
            val: "w:val",
            pos: "w:pos",
            leader: "w:leader"
          };
          return _this83;
        }

        return m;
      }(c.XmlAttributeComponent);

      a.s[23]++, n.TabAttributes = m;

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent51) {
        _inherits(C, _c$XmlComponent51);

        function C(e, n, t) {
          var _this84;

          _classCallCheck(this, C);

          a.f[4]++, a.s[24]++, _this84 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:tab")), a.s[25]++, _this84.root.push(new m({
            val: e,
            pos: n,
            leader: t
          }));
          return _this84;
        }

        return C;
      }(c.XmlComponent);

      a.s[26]++, n.TabStopItem = C, a.s[28]++, n.MaxRightTabStop =
      /*#__PURE__*/
      function (_u20) {
        _inherits(_class23, _u20);

        function _class23(e) {
          var _this85;

          _classCallCheck(this, _class23);

          a.f[5]++, a.s[27]++, _this85 = _possibleConstructorReturn(this, _getPrototypeOf(_class23).call(this, new C(p.RIGHT, 9026, e)));
          return _this85;
        }

        return _class23;
      }(u), a.s[30]++, n.LeftTabStop =
      /*#__PURE__*/
      function (_u21) {
        _inherits(_class24, _u21);

        function _class24(e, n) {
          var _this86;

          _classCallCheck(this, _class24);

          a.f[6]++, a.s[29]++, _this86 = _possibleConstructorReturn(this, _getPrototypeOf(_class24).call(this, new C(p.LEFT, e, n)));
          return _this86;
        }

        return _class24;
      }(u), a.s[32]++, n.RightTabStop =
      /*#__PURE__*/
      function (_u22) {
        _inherits(_class25, _u22);

        function _class25(e, n) {
          var _this87;

          _classCallCheck(this, _class25);

          a.f[7]++, a.s[31]++, _this87 = _possibleConstructorReturn(this, _getPrototypeOf(_class25).call(this, new C(p.RIGHT, e, n)));
          return _this87;
        }

        return _class25;
      }(u), a.s[34]++, n.CenterTabStop =
      /*#__PURE__*/
      function (_u23) {
        _inherits(_class26, _u23);

        function _class26(e, n) {
          var _this88;

          _classCallCheck(this, _class26);

          a.f[8]++, a.s[33]++, _this88 = _possibleConstructorReturn(this, _getPrototypeOf(_class26).call(this, new C(p.CENTER, e, n)));
          return _this88;
        }

        return _class26;
      }(u);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\unordered-list.ts", o = "a20e2483348e5f59cbe752a7957a04946e6a62eb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\unordered-list.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 25
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 53
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 47
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 44
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 24
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 17,
              column: 12
            }
          },
          8: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 25
            }
          },
          9: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 25,
              column: 12
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 39
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 23
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 13
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 20
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 21
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/unordered-list.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\unordered-list.ts"],
          names: [],
          mappings: ";;AAAA,wDAA+D;AAE/D,sBAA8B,SAAQ,6BAAY;IAC9C,YAAY,QAAgB,EAAE,WAAmB;QAC7C,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,WAAW,CAAC,WAAW,CAAC,CAAC,CAAC;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,QAAQ,CAAC,QAAQ,CAAC,CAAC,CAAC;IAC3C,CAAC;CACJ;AAND,4CAMC;AAED,iBAAkB,SAAQ,6BAAY;IAClC,YAAY,KAAa;QACrB,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,cAAe,SAAQ,6BAAY;IAC/B,YAAY,EAAU;QAClB,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,EAAE;SACV,CAAC,CACL,CAAC;IACN,CAAC;CACJ",
          sourcesContent: ['import { Attributes, XmlComponent } from "file/xml-components";\r\n\r\nexport class NumberProperties extends XmlComponent {\r\n    constructor(numberId: number, indentLevel: number) {\r\n        super("w:numPr");\r\n        this.root.push(new IndentLevel(indentLevel));\r\n        this.root.push(new NumberId(numberId));\r\n    }\r\n}\r\n\r\nclass IndentLevel extends XmlComponent {\r\n    constructor(level: number) {\r\n        super("w:ilvl");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: level,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nclass NumberId extends XmlComponent {\r\n    constructor(id: number) {\r\n        super("w:numId");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: id,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent52) {
        _inherits(u, _c$XmlComponent52);

        function u(e, n) {
          var _this89;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this89 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:numPr")), a.s[3]++, _this89.root.push(new p(n)), a.s[4]++, _this89.root.push(new m(e));
          return _this89;
        }

        return u;
      }(c.XmlComponent);

      a.s[5]++, n.NumberProperties = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent53) {
        _inherits(p, _c$XmlComponent53);

        function p(e) {
          var _this90;

          _classCallCheck(this, p);

          a.f[1]++, a.s[6]++, _this90 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:ilvl")), a.s[7]++, _this90.root.push(new c.Attributes({
            val: e
          }));
          return _this90;
        }

        return p;
      }(c.XmlComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent54) {
        _inherits(m, _c$XmlComponent54);

        function m(e) {
          var _this91;

          _classCallCheck(this, m);

          a.f[2]++, a.s[8]++, _this91 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:numId")), a.s[9]++, _this91.root.push(new c.Attributes({
            val: e
          }));
          return _this91;
        }

        return m;
      }(c.XmlComponent);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\paragraph.ts", o = "74c6b222f4c8021cc43c8b14b9db8ce05eee6800", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\paragraph.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 24
            },
            end: {
              line: 3,
              column: 76
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 5,
              column: 20
            },
            end: {
              line: 5,
              column: 53
            }
          },
          4: {
            start: {
              line: 6,
              column: 24
            },
            end: {
              line: 6,
              column: 61
            }
          },
          5: {
            start: {
              line: 7,
              column: 17
            },
            end: {
              line: 7,
              column: 47
            }
          },
          6: {
            start: {
              line: 8,
              column: 17
            },
            end: {
              line: 8,
              column: 47
            }
          },
          7: {
            start: {
              line: 9,
              column: 15
            },
            end: {
              line: 9,
              column: 43
            }
          },
          8: {
            start: {
              line: 10,
              column: 21
            },
            end: {
              line: 10,
              column: 55
            }
          },
          9: {
            start: {
              line: 11,
              column: 18
            },
            end: {
              line: 11,
              column: 49
            }
          },
          10: {
            start: {
              line: 12,
              column: 16
            },
            end: {
              line: 12,
              column: 45
            }
          },
          11: {
            start: {
              line: 13,
              column: 19
            },
            end: {
              line: 13,
              column: 51
            }
          },
          12: {
            start: {
              line: 14,
              column: 25
            },
            end: {
              line: 14,
              column: 63
            }
          },
          13: {
            start: {
              line: 15,
              column: 21
            },
            end: {
              line: 15,
              column: 44
            }
          },
          14: {
            start: {
              line: 16,
              column: 14
            },
            end: {
              line: 16,
              column: 30
            }
          },
          15: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 21
            }
          },
          16: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 65
            }
          },
          17: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 40
            }
          },
          18: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 24,
              column: 9
            }
          },
          19: {
            start: {
              line: 23,
              column: 12
            },
            end: {
              line: 23,
              column: 52
            }
          },
          20: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 31
            }
          },
          21: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 47
            }
          },
          22: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 39
            }
          },
          23: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 20
            }
          },
          24: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 28
            }
          },
          25: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 38,
              column: 20
            }
          },
          26: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 34
            }
          },
          27: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 20
            }
          },
          28: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 39
            }
          },
          29: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 46,
              column: 38
            }
          },
          30: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 37
            }
          },
          31: {
            start: {
              line: 48,
              column: 8
            },
            end: {
              line: 48,
              column: 20
            }
          },
          32: {
            start: {
              line: 51,
              column: 20
            },
            end: {
              line: 51,
              column: 43
            }
          },
          33: {
            start: {
              line: 52,
              column: 8
            },
            end: {
              line: 52,
              column: 25
            }
          },
          34: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 19
            }
          },
          35: {
            start: {
              line: 56,
              column: 20
            },
            end: {
              line: 56,
              column: 29
            }
          },
          36: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 25
            }
          },
          37: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 19
            }
          },
          38: {
            start: {
              line: 61,
              column: 8
            },
            end: {
              line: 61,
              column: 60
            }
          },
          39: {
            start: {
              line: 62,
              column: 8
            },
            end: {
              line: 62,
              column: 20
            }
          },
          40: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 65,
              column: 60
            }
          },
          41: {
            start: {
              line: 66,
              column: 8
            },
            end: {
              line: 66,
              column: 20
            }
          },
          42: {
            start: {
              line: 69,
              column: 8
            },
            end: {
              line: 69,
              column: 60
            }
          },
          43: {
            start: {
              line: 70,
              column: 8
            },
            end: {
              line: 70,
              column: 20
            }
          },
          44: {
            start: {
              line: 73,
              column: 8
            },
            end: {
              line: 73,
              column: 60
            }
          },
          45: {
            start: {
              line: 74,
              column: 8
            },
            end: {
              line: 74,
              column: 20
            }
          },
          46: {
            start: {
              line: 77,
              column: 8
            },
            end: {
              line: 77,
              column: 60
            }
          },
          47: {
            start: {
              line: 78,
              column: 8
            },
            end: {
              line: 78,
              column: 20
            }
          },
          48: {
            start: {
              line: 81,
              column: 8
            },
            end: {
              line: 81,
              column: 60
            }
          },
          49: {
            start: {
              line: 82,
              column: 8
            },
            end: {
              line: 82,
              column: 20
            }
          },
          50: {
            start: {
              line: 85,
              column: 8
            },
            end: {
              line: 85,
              column: 57
            }
          },
          51: {
            start: {
              line: 86,
              column: 8
            },
            end: {
              line: 86,
              column: 20
            }
          },
          52: {
            start: {
              line: 89,
              column: 8
            },
            end: {
              line: 89,
              column: 93
            }
          },
          53: {
            start: {
              line: 90,
              column: 8
            },
            end: {
              line: 90,
              column: 20
            }
          },
          54: {
            start: {
              line: 93,
              column: 8
            },
            end: {
              line: 93,
              column: 91
            }
          },
          55: {
            start: {
              line: 94,
              column: 8
            },
            end: {
              line: 94,
              column: 20
            }
          },
          56: {
            start: {
              line: 97,
              column: 8
            },
            end: {
              line: 97,
              column: 92
            }
          },
          57: {
            start: {
              line: 98,
              column: 8
            },
            end: {
              line: 98,
              column: 20
            }
          },
          58: {
            start: {
              line: 101,
              column: 8
            },
            end: {
              line: 101,
              column: 92
            }
          },
          59: {
            start: {
              line: 102,
              column: 8
            },
            end: {
              line: 102,
              column: 20
            }
          },
          60: {
            start: {
              line: 105,
              column: 8
            },
            end: {
              line: 105,
              column: 90
            }
          },
          61: {
            start: {
              line: 106,
              column: 8
            },
            end: {
              line: 106,
              column: 20
            }
          },
          62: {
            start: {
              line: 109,
              column: 8
            },
            end: {
              line: 109,
              column: 97
            }
          },
          63: {
            start: {
              line: 110,
              column: 8
            },
            end: {
              line: 110,
              column: 20
            }
          },
          64: {
            start: {
              line: 113,
              column: 8
            },
            end: {
              line: 113,
              column: 91
            }
          },
          65: {
            start: {
              line: 114,
              column: 8
            },
            end: {
              line: 114,
              column: 20
            }
          },
          66: {
            start: {
              line: 117,
              column: 8
            },
            end: {
              line: 117,
              column: 59
            }
          },
          67: {
            start: {
              line: 118,
              column: 8
            },
            end: {
              line: 118,
              column: 20
            }
          },
          68: {
            start: {
              line: 121,
              column: 8
            },
            end: {
              line: 121,
              column: 53
            }
          },
          69: {
            start: {
              line: 122,
              column: 8
            },
            end: {
              line: 122,
              column: 20
            }
          },
          70: {
            start: {
              line: 125,
              column: 8
            },
            end: {
              line: 125,
              column: 65
            }
          },
          71: {
            start: {
              line: 126,
              column: 8
            },
            end: {
              line: 126,
              column: 20
            }
          },
          72: {
            start: {
              line: 129,
              column: 8
            },
            end: {
              line: 129,
              column: 69
            }
          },
          73: {
            start: {
              line: 130,
              column: 8
            },
            end: {
              line: 130,
              column: 20
            }
          },
          74: {
            start: {
              line: 133,
              column: 8
            },
            end: {
              line: 133,
              column: 75
            }
          },
          75: {
            start: {
              line: 134,
              column: 8
            },
            end: {
              line: 134,
              column: 20
            }
          },
          76: {
            start: {
              line: 137,
              column: 8
            },
            end: {
              line: 137,
              column: 76
            }
          },
          77: {
            start: {
              line: 138,
              column: 8
            },
            end: {
              line: 138,
              column: 20
            }
          },
          78: {
            start: {
              line: 141,
              column: 8
            },
            end: {
              line: 141,
              column: 77
            }
          },
          79: {
            start: {
              line: 142,
              column: 8
            },
            end: {
              line: 142,
              column: 20
            }
          },
          80: {
            start: {
              line: 145,
              column: 8
            },
            end: {
              line: 145,
              column: 65
            }
          },
          81: {
            start: {
              line: 146,
              column: 8
            },
            end: {
              line: 146,
              column: 84
            }
          },
          82: {
            start: {
              line: 147,
              column: 8
            },
            end: {
              line: 147,
              column: 20
            }
          },
          83: {
            start: {
              line: 150,
              column: 8
            },
            end: {
              line: 150,
              column: 65
            }
          },
          84: {
            start: {
              line: 151,
              column: 8
            },
            end: {
              line: 151,
              column: 95
            }
          },
          85: {
            start: {
              line: 152,
              column: 8
            },
            end: {
              line: 152,
              column: 20
            }
          },
          86: {
            start: {
              line: 155,
              column: 8
            },
            end: {
              line: 155,
              column: 91
            }
          },
          87: {
            start: {
              line: 156,
              column: 8
            },
            end: {
              line: 156,
              column: 20
            }
          },
          88: {
            start: {
              line: 159,
              column: 8
            },
            end: {
              line: 159,
              column: 57
            }
          },
          89: {
            start: {
              line: 160,
              column: 8
            },
            end: {
              line: 160,
              column: 20
            }
          },
          90: {
            start: {
              line: 163,
              column: 8
            },
            end: {
              line: 163,
              column: 57
            }
          },
          91: {
            start: {
              line: 164,
              column: 8
            },
            end: {
              line: 164,
              column: 20
            }
          },
          92: {
            start: {
              line: 167,
              column: 8
            },
            end: {
              line: 167,
              column: 60
            }
          },
          93: {
            start: {
              line: 168,
              column: 8
            },
            end: {
              line: 168,
              column: 20
            }
          },
          94: {
            start: {
              line: 171,
              column: 8
            },
            end: {
              line: 171,
              column: 69
            }
          },
          95: {
            start: {
              line: 172,
              column: 8
            },
            end: {
              line: 172,
              column: 20
            }
          },
          96: {
            start: {
              line: 175,
              column: 8
            },
            end: {
              line: 175,
              column: 52
            }
          },
          97: {
            start: {
              line: 176,
              column: 8
            },
            end: {
              line: 176,
              column: 20
            }
          },
          98: {
            start: {
              line: 179,
              column: 8
            },
            end: {
              line: 179,
              column: 53
            }
          },
          99: {
            start: {
              line: 180,
              column: 8
            },
            end: {
              line: 180,
              column: 20
            }
          },
          100: {
            start: {
              line: 183,
              column: 8
            },
            end: {
              line: 183,
              column: 69
            }
          },
          101: {
            start: {
              line: 184,
              column: 8
            },
            end: {
              line: 184,
              column: 20
            }
          },
          102: {
            start: {
              line: 187,
              column: 8
            },
            end: {
              line: 187,
              column: 36
            }
          },
          103: {
            start: {
              line: 188,
              column: 8
            },
            end: {
              line: 188,
              column: 20
            }
          },
          104: {
            start: {
              line: 191,
              column: 8
            },
            end: {
              line: 191,
              column: 66
            }
          },
          105: {
            start: {
              line: 192,
              column: 8
            },
            end: {
              line: 192,
              column: 20
            }
          },
          106: {
            start: {
              line: 195,
              column: 8
            },
            end: {
              line: 195,
              column: 36
            }
          },
          107: {
            start: {
              line: 196,
              column: 8
            },
            end: {
              line: 196,
              column: 20
            }
          },
          108: {
            start: {
              line: 199,
              column: 8
            },
            end: {
              line: 199,
              column: 67
            }
          },
          109: {
            start: {
              line: 200,
              column: 8
            },
            end: {
              line: 200,
              column: 20
            }
          },
          110: {
            start: {
              line: 203,
              column: 0
            },
            end: {
              line: 203,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 18,
                column: 22
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 18
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 30
              },
              end: {
                line: 28,
                column: 5
              }
            },
            line: 26
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 29,
                column: 4
              },
              end: {
                line: 29,
                column: 5
              }
            },
            loc: {
              start: {
                line: 29,
                column: 18
              },
              end: {
                line: 31,
                column: 5
              }
            },
            line: 29
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 32,
                column: 4
              },
              end: {
                line: 32,
                column: 5
              }
            },
            loc: {
              start: {
                line: 32,
                column: 19
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 32
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 36,
                column: 4
              },
              end: {
                line: 36,
                column: 5
              }
            },
            loc: {
              start: {
                line: 36,
                column: 16
              },
              end: {
                line: 39,
                column: 5
              }
            },
            line: 36
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 40,
                column: 4
              },
              end: {
                line: 40,
                column: 5
              }
            },
            loc: {
              start: {
                line: 40,
                column: 28
              },
              end: {
                line: 43,
                column: 5
              }
            },
            line: 40
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 44,
                column: 4
              },
              end: {
                line: 44,
                column: 5
              }
            },
            loc: {
              start: {
                line: 44,
                column: 26
              },
              end: {
                line: 49,
                column: 5
              }
            },
            line: 44
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 50,
                column: 4
              },
              end: {
                line: 50,
                column: 5
              }
            },
            loc: {
              start: {
                line: 50,
                column: 24
              },
              end: {
                line: 54,
                column: 5
              }
            },
            line: 50
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 55,
                column: 4
              },
              end: {
                line: 55,
                column: 5
              }
            },
            loc: {
              start: {
                line: 55,
                column: 20
              },
              end: {
                line: 59,
                column: 5
              }
            },
            line: 55
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 60,
                column: 4
              },
              end: {
                line: 60,
                column: 5
              }
            },
            loc: {
              start: {
                line: 60,
                column: 15
              },
              end: {
                line: 63,
                column: 5
              }
            },
            line: 60
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 64,
                column: 4
              },
              end: {
                line: 64,
                column: 5
              }
            },
            loc: {
              start: {
                line: 64,
                column: 15
              },
              end: {
                line: 67,
                column: 5
              }
            },
            line: 64
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 68,
                column: 4
              },
              end: {
                line: 68,
                column: 5
              }
            },
            loc: {
              start: {
                line: 68,
                column: 15
              },
              end: {
                line: 71,
                column: 5
              }
            },
            line: 68
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 72,
                column: 4
              },
              end: {
                line: 72,
                column: 5
              }
            },
            loc: {
              start: {
                line: 72,
                column: 15
              },
              end: {
                line: 75,
                column: 5
              }
            },
            line: 72
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 76,
                column: 4
              },
              end: {
                line: 76,
                column: 5
              }
            },
            loc: {
              start: {
                line: 76,
                column: 15
              },
              end: {
                line: 79,
                column: 5
              }
            },
            line: 76
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 80,
                column: 4
              },
              end: {
                line: 80,
                column: 5
              }
            },
            loc: {
              start: {
                line: 80,
                column: 15
              },
              end: {
                line: 83,
                column: 5
              }
            },
            line: 80
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 84,
                column: 4
              },
              end: {
                line: 84,
                column: 5
              }
            },
            loc: {
              start: {
                line: 84,
                column: 12
              },
              end: {
                line: 87,
                column: 5
              }
            },
            line: 84
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 88,
                column: 4
              },
              end: {
                line: 88,
                column: 5
              }
            },
            loc: {
              start: {
                line: 88,
                column: 13
              },
              end: {
                line: 91,
                column: 5
              }
            },
            line: 88
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 92,
                column: 4
              },
              end: {
                line: 92,
                column: 5
              }
            },
            loc: {
              start: {
                line: 92,
                column: 11
              },
              end: {
                line: 95,
                column: 5
              }
            },
            line: 92
          },
          18: {
            name: "(anonymous_18)",
            decl: {
              start: {
                line: 96,
                column: 4
              },
              end: {
                line: 96,
                column: 5
              }
            },
            loc: {
              start: {
                line: 96,
                column: 12
              },
              end: {
                line: 99,
                column: 5
              }
            },
            line: 96
          },
          19: {
            name: "(anonymous_19)",
            decl: {
              start: {
                line: 100,
                column: 4
              },
              end: {
                line: 100,
                column: 5
              }
            },
            loc: {
              start: {
                line: 100,
                column: 12
              },
              end: {
                line: 103,
                column: 5
              }
            },
            line: 100
          },
          20: {
            name: "(anonymous_20)",
            decl: {
              start: {
                line: 104,
                column: 4
              },
              end: {
                line: 104,
                column: 5
              }
            },
            loc: {
              start: {
                line: 104,
                column: 10
              },
              end: {
                line: 107,
                column: 5
              }
            },
            line: 104
          },
          21: {
            name: "(anonymous_21)",
            decl: {
              start: {
                line: 108,
                column: 4
              },
              end: {
                line: 108,
                column: 5
              }
            },
            loc: {
              start: {
                line: 108,
                column: 17
              },
              end: {
                line: 111,
                column: 5
              }
            },
            line: 108
          },
          22: {
            name: "(anonymous_22)",
            decl: {
              start: {
                line: 112,
                column: 4
              },
              end: {
                line: 112,
                column: 5
              }
            },
            loc: {
              start: {
                line: 112,
                column: 16
              },
              end: {
                line: 115,
                column: 5
              }
            },
            line: 112
          },
          23: {
            name: "(anonymous_23)",
            decl: {
              start: {
                line: 116,
                column: 4
              },
              end: {
                line: 116,
                column: 5
              }
            },
            loc: {
              start: {
                line: 116,
                column: 20
              },
              end: {
                line: 119,
                column: 5
              }
            },
            line: 116
          },
          24: {
            name: "(anonymous_24)",
            decl: {
              start: {
                line: 120,
                column: 4
              },
              end: {
                line: 120,
                column: 5
              }
            },
            loc: {
              start: {
                line: 120,
                column: 16
              },
              end: {
                line: 123,
                column: 5
              }
            },
            line: 120
          },
          25: {
            name: "(anonymous_25)",
            decl: {
              start: {
                line: 124,
                column: 4
              },
              end: {
                line: 124,
                column: 5
              }
            },
            loc: {
              start: {
                line: 124,
                column: 22
              },
              end: {
                line: 127,
                column: 5
              }
            },
            line: 124
          },
          26: {
            name: "(anonymous_26)",
            decl: {
              start: {
                line: 128,
                column: 4
              },
              end: {
                line: 128,
                column: 5
              }
            },
            loc: {
              start: {
                line: 128,
                column: 28
              },
              end: {
                line: 131,
                column: 5
              }
            },
            line: 128
          },
          27: {
            name: "(anonymous_27)",
            decl: {
              start: {
                line: 132,
                column: 4
              },
              end: {
                line: 132,
                column: 5
              }
            },
            loc: {
              start: {
                line: 132,
                column: 34
              },
              end: {
                line: 135,
                column: 5
              }
            },
            line: 132
          },
          28: {
            name: "(anonymous_28)",
            decl: {
              start: {
                line: 136,
                column: 4
              },
              end: {
                line: 136,
                column: 5
              }
            },
            loc: {
              start: {
                line: 136,
                column: 35
              },
              end: {
                line: 139,
                column: 5
              }
            },
            line: 136
          },
          29: {
            name: "(anonymous_29)",
            decl: {
              start: {
                line: 140,
                column: 4
              },
              end: {
                line: 140,
                column: 5
              }
            },
            loc: {
              start: {
                line: 140,
                column: 36
              },
              end: {
                line: 143,
                column: 5
              }
            },
            line: 140
          },
          30: {
            name: "(anonymous_30)",
            decl: {
              start: {
                line: 144,
                column: 4
              },
              end: {
                line: 144,
                column: 5
              }
            },
            loc: {
              start: {
                line: 144,
                column: 28
              },
              end: {
                line: 148,
                column: 5
              }
            },
            line: 144
          },
          31: {
            name: "(anonymous_31)",
            decl: {
              start: {
                line: 149,
                column: 4
              },
              end: {
                line: 149,
                column: 5
              }
            },
            loc: {
              start: {
                line: 149,
                column: 41
              },
              end: {
                line: 153,
                column: 5
              }
            },
            line: 149
          },
          32: {
            name: "(anonymous_32)",
            decl: {
              start: {
                line: 154,
                column: 4
              },
              end: {
                line: 154,
                column: 5
              }
            },
            loc: {
              start: {
                line: 154,
                column: 46
              },
              end: {
                line: 157,
                column: 5
              }
            },
            line: 154
          },
          33: {
            name: "(anonymous_33)",
            decl: {
              start: {
                line: 158,
                column: 4
              },
              end: {
                line: 158,
                column: 5
              }
            },
            loc: {
              start: {
                line: 158,
                column: 19
              },
              end: {
                line: 161,
                column: 5
              }
            },
            line: 158
          },
          34: {
            name: "(anonymous_34)",
            decl: {
              start: {
                line: 162,
                column: 4
              },
              end: {
                line: 162,
                column: 5
              }
            },
            loc: {
              start: {
                line: 162,
                column: 18
              },
              end: {
                line: 165,
                column: 5
              }
            },
            line: 162
          },
          35: {
            name: "(anonymous_35)",
            decl: {
              start: {
                line: 166,
                column: 4
              },
              end: {
                line: 166,
                column: 5
              }
            },
            loc: {
              start: {
                line: 166,
                column: 20
              },
              end: {
                line: 169,
                column: 5
              }
            },
            line: 166
          },
          36: {
            name: "(anonymous_36)",
            decl: {
              start: {
                line: 170,
                column: 4
              },
              end: {
                line: 170,
                column: 5
              }
            },
            loc: {
              start: {
                line: 170,
                column: 29
              },
              end: {
                line: 173,
                column: 5
              }
            },
            line: 170
          },
          37: {
            name: "(anonymous_37)",
            decl: {
              start: {
                line: 174,
                column: 4
              },
              end: {
                line: 174,
                column: 5
              }
            },
            loc: {
              start: {
                line: 174,
                column: 15
              },
              end: {
                line: 177,
                column: 5
              }
            },
            line: 174
          },
          38: {
            name: "(anonymous_38)",
            decl: {
              start: {
                line: 178,
                column: 4
              },
              end: {
                line: 178,
                column: 5
              }
            },
            loc: {
              start: {
                line: 178,
                column: 16
              },
              end: {
                line: 181,
                column: 5
              }
            },
            line: 178
          },
          39: {
            name: "(anonymous_39)",
            decl: {
              start: {
                line: 182,
                column: 4
              },
              end: {
                line: 182,
                column: 5
              }
            },
            loc: {
              start: {
                line: 182,
                column: 26
              },
              end: {
                line: 185,
                column: 5
              }
            },
            line: 182
          },
          40: {
            name: "(anonymous_40)",
            decl: {
              start: {
                line: 186,
                column: 4
              },
              end: {
                line: 186,
                column: 5
              }
            },
            loc: {
              start: {
                line: 186,
                column: 23
              },
              end: {
                line: 189,
                column: 5
              }
            },
            line: 186
          },
          41: {
            name: "(anonymous_41)",
            decl: {
              start: {
                line: 190,
                column: 4
              },
              end: {
                line: 190,
                column: 5
              }
            },
            loc: {
              start: {
                line: 190,
                column: 20
              },
              end: {
                line: 193,
                column: 5
              }
            },
            line: 190
          },
          42: {
            name: "(anonymous_42)",
            decl: {
              start: {
                line: 194,
                column: 4
              },
              end: {
                line: 194,
                column: 5
              }
            },
            loc: {
              start: {
                line: 194,
                column: 20
              },
              end: {
                line: 197,
                column: 5
              }
            },
            line: 194
          },
          43: {
            name: "(anonymous_43)",
            decl: {
              start: {
                line: 198,
                column: 4
              },
              end: {
                line: 198,
                column: 5
              }
            },
            loc: {
              start: {
                line: 198,
                column: 40
              },
              end: {
                line: 201,
                column: 5
              }
            },
            line: 198
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            }, {
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            }],
            line: 22
          },
          1: {
            loc: {
              start: {
                line: 144,
                column: 11
              },
              end: {
                line: 144,
                column: 26
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 144,
                column: 25
              },
              end: {
                line: 144,
                column: 26
              }
            }],
            line: 144
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0,
          64: 0,
          65: 0,
          66: 0,
          67: 0,
          68: 0,
          69: 0,
          70: 0,
          71: 0,
          72: 0,
          73: 0,
          74: 0,
          75: 0,
          76: 0,
          77: 0,
          78: 0,
          79: 0,
          80: 0,
          81: 0,
          82: 0,
          83: 0,
          84: 0,
          85: 0,
          86: 0,
          87: 0,
          88: 0,
          89: 0,
          90: 0,
          91: 0,
          92: 0,
          93: 0,
          94: 0,
          95: 0,
          96: 0,
          97: 0,
          98: 0,
          99: 0,
          100: 0,
          101: 0,
          102: 0,
          103: 0,
          104: 0,
          105: 0,
          106: 0,
          107: 0,
          108: 0,
          109: 0,
          110: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0
        },
        b: {
          0: [0, 0],
          1: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/paragraph.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\paragraph.ts"],
          names: [],
          mappings: ";;AACA,6EAAiF;AAGjF,wDAAmD;AAEnD,sDAAqE;AACrE,8DAA2D;AAC3D,gDAA4D;AAC5D,gDAA0E;AAC1E,4CAAwD;AACxD,wDAAqE;AACrE,kDAAsF;AACtF,8CAA2C;AAC3C,oDAA8G;AAC9G,gEAA+D;AAE/D,6CAAmD;AACnD,+BAAuE;AAEvE,eAAuB,SAAQ,6BAAY;IAGvC,YAAY,IAAa;QACrB,KAAK,CAAC,KAAK,CAAC,CAAC;QACb,IAAI,CAAC,UAAU,GAAG,IAAI,gCAAmB,EAAE,CAAC;QAC5C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;QAChC,IAAI,IAAI,KAAK,SAAS,EAAE;YACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAO,CAAC,IAAI,CAAC,CAAC,CAAC;SACrC;IACL,CAAC;IAED,IAAW,mBAAmB;QAC1B,OAAO,IAAI,CAAC,UAAU,CAAC;IAC3B,CAAC;IAED,IAAW,OAAO;QACd,OAAO,IAAI,CAAC,UAAU,CAAC,eAAe,CAAC;IAC3C,CAAC;IAEM,YAAY;QACf,IAAI,CAAC,UAAU,CAAC,YAAY,EAAE,CAAC;QAC/B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM,CAAC,GAAQ;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QACpB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;QAC1B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW,CAAC,QAAkB;QAEjC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC;QAC9B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,GAAG,CAAC,CAAC;QAC7B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,aAAa,CAAC,IAAY;QAC7B,MAAM,GAAG,GAAG,IAAI,aAAO,CAAC,IAAI,CAAC,CAAC;QAC9B,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,CAAC;QACjB,OAAO,GAAG,CAAC;IACf,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,MAAM,GAAG,GAAG,KAAK,CAAC,GAAG,CAAC;QACtB,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,CAAC;QAEjB,OAAO,GAAG,CAAC;IACf,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,UAAU,CAAC,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,UAAU,CAAC,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,UAAU,CAAC,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,UAAU,CAAC,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,UAAU,CAAC,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,UAAU,CAAC,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK;QACR,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,OAAO,CAAC,CAAC,CAAC;QACzC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM;QACT,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,MAAM,CAAC,CAAC,CAAC;QAC7D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI;QACP,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,IAAI,CAAC,CAAC,CAAC;QAC3D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK;QACR,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;QAC5D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK;QACR,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;QAC5D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,GAAG;QACN,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,GAAG,CAAC,CAAC,CAAC;QAC1D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,UAAU;QACb,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,UAAU,CAAC,CAAC,CAAC;QACjE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,IAAI,CAAC,CAAC,CAAC;QAC3D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,aAAa;QAChB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,sBAAa,EAAE,CAAC,CAAC;QAC1C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,sBAAS,EAAE,CAAC,CAAC;QAChC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe;QAClB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,4BAAe,EAAE,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe,CAAC,MAAmB;QACtC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,0BAAe,CAAC,MAAM,CAAC,CAAC,CAAC;QAClD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW,CAAC,QAAgB,EAAE,MAAmB;QACpD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,sBAAW,CAAC,QAAQ,EAAE,MAAM,CAAC,CAAC,CAAC;QACxD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,YAAY,CAAC,QAAgB,EAAE,MAAmB;QACrD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,uBAAY,CAAC,QAAQ,EAAE,MAAM,CAAC,CAAC,CAAC;QACzD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,aAAa,CAAC,QAAgB,EAAE,MAAmB;QACtD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,wBAAa,CAAC,QAAQ,EAAE,MAAM,CAAC,CAAC,CAAC;QAC1D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM,CAAC,cAAsB,CAAC;QACjC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,eAAe,CAAC,CAAC,CAAC;QACjD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iCAAgB,CAAC,CAAC,EAAE,WAAW,CAAC,CAAC,CAAC;QAC3D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,YAAY,CAAC,SAAc,EAAE,WAAmB;QACnD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,eAAe,CAAC,CAAC,CAAC;QACjD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iCAAgB,CAAC,SAAS,CAAC,EAAE,EAAE,WAAW,CAAC,CAAC,CAAC;QACtE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,kBAAkB,CAAC,QAAgB,EAAE,WAAmB;QAC3D,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iCAAgB,CAAC,QAAQ,EAAE,WAAW,CAAC,CAAC,CAAC;QAClE,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK,CAAC,OAAe;QACxB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,OAAO,CAAC,CAAC,CAAC;QACzC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM,CAAC,KAAkC;QAC5C,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,eAAM,CAAC,KAAK,CAAC,CAAC,CAAC;QACxC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,OAAO,CAAC,MAA0B;QACrC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,MAAM,CAAC,CAAC,CAAC;QAC1C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,iBAAiB,CAAC,KAAc;QACnC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,2BAAiB,CAAC,KAAK,CAAC,CAAC,CAAC;QACnD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ;QACX,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,eAAQ,EAAE,CAAC,CAAC;QACrC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,gBAAS,EAAE,CAAC,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,iBAAiB,CAAC,EAAU;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oCAAoB,CAAC,EAAE,CAAC,CAAC,CAAC;QAC7C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,aAAa,CAAC,GAAQ;QACzB,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,EAAE,CAAC,EAAE,GAAG,CAAC,CAAC;QAC5B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,aAAa;QAChB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,6BAAa,EAAE,CAAC,CAAC;QAC1C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,UAAU,CAAC,GAAQ;QACtB,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,EAAE,CAAC,EAAE,GAAG,CAAC,CAAC;QAC5B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,uBAAuB,CAAC,UAAkB;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,0BAAoB,CAAC,UAAU,CAAC,CAAC,CAAC;QACrD,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAxOD,8BAwOC",
          sourcesContent: ['// http://officeopenxml.com/WPparagraph.php\r\nimport { FootnoteReferenceRun } from "file/footnotes/footnote/run/reference-run";\r\nimport { Image } from "file/media";\r\nimport { Num } from "file/numbering/num";\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nimport { Alignment, AlignmentOptions } from "./formatting/alignment";\r\nimport { Bidirectional } from "./formatting/bidirectional";\r\nimport { Border, ThematicBreak } from "./formatting/border";\r\nimport { IIndentAttributesProperties, Indent } from "./formatting/indent";\r\nimport { KeepLines, KeepNext } from "./formatting/keep";\r\nimport { PageBreak, PageBreakBefore } from "./formatting/page-break";\r\nimport { ContextualSpacing, ISpacingProperties, Spacing } from "./formatting/spacing";\r\nimport { Style } from "./formatting/style";\r\nimport { CenterTabStop, LeaderType, LeftTabStop, MaxRightTabStop, RightTabStop } from "./formatting/tab-stop";\r\nimport { NumberProperties } from "./formatting/unordered-list";\r\nimport { Bookmark, Hyperlink } from "./links";\r\nimport { ParagraphProperties } from "./properties";\r\nimport { PictureRun, Run, SequentialIdentifier, TextRun } from "./run";\r\n\r\nexport class Paragraph extends XmlComponent {\r\n    private readonly properties: ParagraphProperties;\r\n\r\n    constructor(text?: string) {\r\n        super("w:p");\r\n        this.properties = new ParagraphProperties();\r\n        this.root.push(this.properties);\r\n        if (text !== undefined) {\r\n            this.root.push(new TextRun(text));\r\n        }\r\n    }\r\n\r\n    public get paragraphProperties(): ParagraphProperties {\r\n        return this.properties;\r\n    }\r\n\r\n    public get Borders(): Border {\r\n        return this.properties.paragraphBorder;\r\n    }\r\n\r\n    public createBorder(): Paragraph {\r\n        this.properties.createBorder();\r\n        return this;\r\n    }\r\n\r\n    public addRun(run: Run): Paragraph {\r\n        this.root.push(run);\r\n        return this;\r\n    }\r\n\r\n    public addHyperLink(hyperlink: Hyperlink): Paragraph {\r\n        this.root.push(hyperlink);\r\n        return this;\r\n    }\r\n\r\n    public addBookmark(bookmark: Bookmark): Paragraph {\r\n        // Bookmarks by spec have three components, a start, text, and end\r\n        this.root.push(bookmark.start);\r\n        this.root.push(bookmark.text);\r\n        this.root.push(bookmark.end);\r\n        return this;\r\n    }\r\n\r\n    public createTextRun(text: string): TextRun {\r\n        const run = new TextRun(text);\r\n        this.addRun(run);\r\n        return run;\r\n    }\r\n\r\n    public addImage(image: Image): PictureRun {\r\n        const run = image.Run;\r\n        this.addRun(run);\r\n\r\n        return run;\r\n    }\r\n\r\n    public heading1(): Paragraph {\r\n        this.properties.push(new Style("Heading1"));\r\n        return this;\r\n    }\r\n\r\n    public heading2(): Paragraph {\r\n        this.properties.push(new Style("Heading2"));\r\n        return this;\r\n    }\r\n\r\n    public heading3(): Paragraph {\r\n        this.properties.push(new Style("Heading3"));\r\n        return this;\r\n    }\r\n\r\n    public heading4(): Paragraph {\r\n        this.properties.push(new Style("Heading4"));\r\n        return this;\r\n    }\r\n\r\n    public heading5(): Paragraph {\r\n        this.properties.push(new Style("Heading5"));\r\n        return this;\r\n    }\r\n\r\n    public heading6(): Paragraph {\r\n        this.properties.push(new Style("Heading6"));\r\n        return this;\r\n    }\r\n\r\n    public title(): Paragraph {\r\n        this.properties.push(new Style("Title"));\r\n        return this;\r\n    }\r\n\r\n    public center(): Paragraph {\r\n        this.properties.push(new Alignment(AlignmentOptions.CENTER));\r\n        return this;\r\n    }\r\n\r\n    public left(): Paragraph {\r\n        this.properties.push(new Alignment(AlignmentOptions.LEFT));\r\n        return this;\r\n    }\r\n\r\n    public right(): Paragraph {\r\n        this.properties.push(new Alignment(AlignmentOptions.RIGHT));\r\n        return this;\r\n    }\r\n\r\n    public start(): Paragraph {\r\n        this.properties.push(new Alignment(AlignmentOptions.START));\r\n        return this;\r\n    }\r\n\r\n    public end(): Paragraph {\r\n        this.properties.push(new Alignment(AlignmentOptions.END));\r\n        return this;\r\n    }\r\n\r\n    public distribute(): Paragraph {\r\n        this.properties.push(new Alignment(AlignmentOptions.DISTRIBUTE));\r\n        return this;\r\n    }\r\n\r\n    public justified(): Paragraph {\r\n        this.properties.push(new Alignment(AlignmentOptions.BOTH));\r\n        return this;\r\n    }\r\n\r\n    public thematicBreak(): Paragraph {\r\n        this.properties.push(new ThematicBreak());\r\n        return this;\r\n    }\r\n\r\n    public pageBreak(): Paragraph {\r\n        this.root.push(new PageBreak());\r\n        return this;\r\n    }\r\n\r\n    public pageBreakBefore(): Paragraph {\r\n        this.properties.push(new PageBreakBefore());\r\n        return this;\r\n    }\r\n\r\n    public maxRightTabStop(leader?: LeaderType): Paragraph {\r\n        this.properties.push(new MaxRightTabStop(leader));\r\n        return this;\r\n    }\r\n\r\n    public leftTabStop(position: number, leader?: LeaderType): Paragraph {\r\n        this.properties.push(new LeftTabStop(position, leader));\r\n        return this;\r\n    }\r\n\r\n    public rightTabStop(position: number, leader?: LeaderType): Paragraph {\r\n        this.properties.push(new RightTabStop(position, leader));\r\n        return this;\r\n    }\r\n\r\n    public centerTabStop(position: number, leader?: LeaderType): Paragraph {\r\n        this.properties.push(new CenterTabStop(position, leader));\r\n        return this;\r\n    }\r\n\r\n    public bullet(indentLevel: number = 0): Paragraph {\r\n        this.properties.push(new Style("ListParagraph"));\r\n        this.properties.push(new NumberProperties(1, indentLevel));\r\n        return this;\r\n    }\r\n\r\n    public setNumbering(numbering: Num, indentLevel: number): Paragraph {\r\n        this.properties.push(new Style("ListParagraph"));\r\n        this.properties.push(new NumberProperties(numbering.id, indentLevel));\r\n        return this;\r\n    }\r\n\r\n    public setCustomNumbering(numberId: number, indentLevel: number): Paragraph {\r\n        this.properties.push(new NumberProperties(numberId, indentLevel));\r\n        return this;\r\n    }\r\n\r\n    public style(styleId: string): Paragraph {\r\n        this.properties.push(new Style(styleId));\r\n        return this;\r\n    }\r\n\r\n    public indent(attrs: IIndentAttributesProperties): Paragraph {\r\n        this.properties.push(new Indent(attrs));\r\n        return this;\r\n    }\r\n\r\n    public spacing(params: ISpacingProperties): Paragraph {\r\n        this.properties.push(new Spacing(params));\r\n        return this;\r\n    }\r\n\r\n    public contextualSpacing(value: boolean): Paragraph {\r\n        this.properties.push(new ContextualSpacing(value));\r\n        return this;\r\n    }\r\n\r\n    public keepNext(): Paragraph {\r\n        this.properties.push(new KeepNext());\r\n        return this;\r\n    }\r\n\r\n    public keepLines(): Paragraph {\r\n        this.properties.push(new KeepLines());\r\n        return this;\r\n    }\r\n\r\n    public referenceFootnote(id: number): Paragraph {\r\n        this.root.push(new FootnoteReferenceRun(id));\r\n        return this;\r\n    }\r\n\r\n    public addRunToFront(run: Run): Paragraph {\r\n        this.root.splice(1, 0, run);\r\n        return this;\r\n    }\r\n\r\n    public bidirectional(): Paragraph {\r\n        this.properties.push(new Bidirectional());\r\n        return this;\r\n    }\r\n\r\n    public addTabStop(run: Run): Paragraph {\r\n        this.root.splice(1, 0, run);\r\n        return this;\r\n    }\r\n\r\n    public addSequentialIdentifier(identifier: string): Paragraph {\r\n        this.root.push(new SequentialIdentifier(identifier));\r\n        return this;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(208)),
          u = (a.s[2]++, t(0)),
          p = (a.s[3]++, t(51)),
          m = (a.s[4]++, t(209)),
          C = (a.s[5]++, t(35)),
          d = (a.s[6]++, t(61)),
          f = (a.s[7]++, t(62)),
          h = (a.s[8]++, t(63)),
          x = (a.s[9]++, t(77)),
          g = (a.s[10]++, t(78)),
          I = (a.s[11]++, t(79)),
          b = (a.s[12]++, t(80)),
          y = (a.s[13]++, t(22)),
          E = (a.s[14]++, t(4));

      var v =
      /*#__PURE__*/
      function (_u$XmlComponent) {
        _inherits(v, _u$XmlComponent);

        function v(e) {
          var _this92;

          _classCallCheck(this, v);

          a.f[0]++, a.s[15]++, _this92 = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this, "w:p")), a.s[16]++, _this92.properties = new y.ParagraphProperties(), a.s[17]++, _this92.root.push(_this92.properties), a.s[18]++, void 0 !== e ? (a.b[0][0]++, a.s[19]++, _this92.root.push(new E.TextRun(e))) : a.b[0][1]++;
          return _this92;
        }

        _createClass(v, [{
          key: "createBorder",
          value: function createBorder() {
            return a.f[3]++, a.s[22]++, this.properties.createBorder(), a.s[23]++, this;
          }
        }, {
          key: "addRun",
          value: function addRun(e) {
            return a.f[4]++, a.s[24]++, this.root.push(e), a.s[25]++, this;
          }
        }, {
          key: "addHyperLink",
          value: function addHyperLink(e) {
            return a.f[5]++, a.s[26]++, this.root.push(e), a.s[27]++, this;
          }
        }, {
          key: "addBookmark",
          value: function addBookmark(e) {
            return a.f[6]++, a.s[28]++, this.root.push(e.start), a.s[29]++, this.root.push(e.text), a.s[30]++, this.root.push(e.end), a.s[31]++, this;
          }
        }, {
          key: "createTextRun",
          value: function createTextRun(e) {
            a.f[7]++;
            var n = (a.s[32]++, new E.TextRun(e));
            return a.s[33]++, this.addRun(n), a.s[34]++, n;
          }
        }, {
          key: "addImage",
          value: function addImage(e) {
            a.f[8]++;
            var n = (a.s[35]++, e.Run);
            return a.s[36]++, this.addRun(n), a.s[37]++, n;
          }
        }, {
          key: "heading1",
          value: function heading1() {
            return a.f[9]++, a.s[38]++, this.properties.push(new g.Style("Heading1")), a.s[39]++, this;
          }
        }, {
          key: "heading2",
          value: function heading2() {
            return a.f[10]++, a.s[40]++, this.properties.push(new g.Style("Heading2")), a.s[41]++, this;
          }
        }, {
          key: "heading3",
          value: function heading3() {
            return a.f[11]++, a.s[42]++, this.properties.push(new g.Style("Heading3")), a.s[43]++, this;
          }
        }, {
          key: "heading4",
          value: function heading4() {
            return a.f[12]++, a.s[44]++, this.properties.push(new g.Style("Heading4")), a.s[45]++, this;
          }
        }, {
          key: "heading5",
          value: function heading5() {
            return a.f[13]++, a.s[46]++, this.properties.push(new g.Style("Heading5")), a.s[47]++, this;
          }
        }, {
          key: "heading6",
          value: function heading6() {
            return a.f[14]++, a.s[48]++, this.properties.push(new g.Style("Heading6")), a.s[49]++, this;
          }
        }, {
          key: "title",
          value: function title() {
            return a.f[15]++, a.s[50]++, this.properties.push(new g.Style("Title")), a.s[51]++, this;
          }
        }, {
          key: "center",
          value: function center() {
            return a.f[16]++, a.s[52]++, this.properties.push(new p.Alignment(p.AlignmentOptions.CENTER)), a.s[53]++, this;
          }
        }, {
          key: "left",
          value: function left() {
            return a.f[17]++, a.s[54]++, this.properties.push(new p.Alignment(p.AlignmentOptions.LEFT)), a.s[55]++, this;
          }
        }, {
          key: "right",
          value: function right() {
            return a.f[18]++, a.s[56]++, this.properties.push(new p.Alignment(p.AlignmentOptions.RIGHT)), a.s[57]++, this;
          }
        }, {
          key: "start",
          value: function start() {
            return a.f[19]++, a.s[58]++, this.properties.push(new p.Alignment(p.AlignmentOptions.START)), a.s[59]++, this;
          }
        }, {
          key: "end",
          value: function end() {
            return a.f[20]++, a.s[60]++, this.properties.push(new p.Alignment(p.AlignmentOptions.END)), a.s[61]++, this;
          }
        }, {
          key: "distribute",
          value: function distribute() {
            return a.f[21]++, a.s[62]++, this.properties.push(new p.Alignment(p.AlignmentOptions.DISTRIBUTE)), a.s[63]++, this;
          }
        }, {
          key: "justified",
          value: function justified() {
            return a.f[22]++, a.s[64]++, this.properties.push(new p.Alignment(p.AlignmentOptions.BOTH)), a.s[65]++, this;
          }
        }, {
          key: "thematicBreak",
          value: function thematicBreak() {
            return a.f[23]++, a.s[66]++, this.properties.push(new C.ThematicBreak()), a.s[67]++, this;
          }
        }, {
          key: "pageBreak",
          value: function pageBreak() {
            return a.f[24]++, a.s[68]++, this.root.push(new h.PageBreak()), a.s[69]++, this;
          }
        }, {
          key: "pageBreakBefore",
          value: function pageBreakBefore() {
            return a.f[25]++, a.s[70]++, this.properties.push(new h.PageBreakBefore()), a.s[71]++, this;
          }
        }, {
          key: "maxRightTabStop",
          value: function maxRightTabStop(e) {
            return a.f[26]++, a.s[72]++, this.properties.push(new I.MaxRightTabStop(e)), a.s[73]++, this;
          }
        }, {
          key: "leftTabStop",
          value: function leftTabStop(e, n) {
            return a.f[27]++, a.s[74]++, this.properties.push(new I.LeftTabStop(e, n)), a.s[75]++, this;
          }
        }, {
          key: "rightTabStop",
          value: function rightTabStop(e, n) {
            return a.f[28]++, a.s[76]++, this.properties.push(new I.RightTabStop(e, n)), a.s[77]++, this;
          }
        }, {
          key: "centerTabStop",
          value: function centerTabStop(e, n) {
            return a.f[29]++, a.s[78]++, this.properties.push(new I.CenterTabStop(e, n)), a.s[79]++, this;
          }
        }, {
          key: "bullet",
          value: function bullet() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[1][0]++, 0);
            return a.f[30]++, a.s[80]++, this.properties.push(new g.Style("ListParagraph")), a.s[81]++, this.properties.push(new b.NumberProperties(1, e)), a.s[82]++, this;
          }
        }, {
          key: "setNumbering",
          value: function setNumbering(e, n) {
            return a.f[31]++, a.s[83]++, this.properties.push(new g.Style("ListParagraph")), a.s[84]++, this.properties.push(new b.NumberProperties(e.id, n)), a.s[85]++, this;
          }
        }, {
          key: "setCustomNumbering",
          value: function setCustomNumbering(e, n) {
            return a.f[32]++, a.s[86]++, this.properties.push(new b.NumberProperties(e, n)), a.s[87]++, this;
          }
        }, {
          key: "style",
          value: function style(e) {
            return a.f[33]++, a.s[88]++, this.properties.push(new g.Style(e)), a.s[89]++, this;
          }
        }, {
          key: "indent",
          value: function indent(e) {
            return a.f[34]++, a.s[90]++, this.properties.push(new d.Indent(e)), a.s[91]++, this;
          }
        }, {
          key: "spacing",
          value: function spacing(e) {
            return a.f[35]++, a.s[92]++, this.properties.push(new x.Spacing(e)), a.s[93]++, this;
          }
        }, {
          key: "contextualSpacing",
          value: function contextualSpacing(e) {
            return a.f[36]++, a.s[94]++, this.properties.push(new x.ContextualSpacing(e)), a.s[95]++, this;
          }
        }, {
          key: "keepNext",
          value: function keepNext() {
            return a.f[37]++, a.s[96]++, this.properties.push(new f.KeepNext()), a.s[97]++, this;
          }
        }, {
          key: "keepLines",
          value: function keepLines() {
            return a.f[38]++, a.s[98]++, this.properties.push(new f.KeepLines()), a.s[99]++, this;
          }
        }, {
          key: "referenceFootnote",
          value: function referenceFootnote(e) {
            return a.f[39]++, a.s[100]++, this.root.push(new c.FootnoteReferenceRun(e)), a.s[101]++, this;
          }
        }, {
          key: "addRunToFront",
          value: function addRunToFront(e) {
            return a.f[40]++, a.s[102]++, this.root.splice(1, 0, e), a.s[103]++, this;
          }
        }, {
          key: "bidirectional",
          value: function bidirectional() {
            return a.f[41]++, a.s[104]++, this.properties.push(new m.Bidirectional()), a.s[105]++, this;
          }
        }, {
          key: "addTabStop",
          value: function addTabStop(e) {
            return a.f[42]++, a.s[106]++, this.root.splice(1, 0, e), a.s[107]++, this;
          }
        }, {
          key: "addSequentialIdentifier",
          value: function addSequentialIdentifier(e) {
            return a.f[43]++, a.s[108]++, this.root.push(new E.SequentialIdentifier(e)), a.s[109]++, this;
          }
        }, {
          key: "paragraphProperties",
          get: function get() {
            return a.f[1]++, a.s[20]++, this.properties;
          }
        }, {
          key: "Borders",
          get: function get() {
            return a.f[2]++, a.s[21]++, this.properties.paragraphBorder;
          }
        }]);

        return v;
      }(u.XmlComponent);

      a.s[110]++, n.Paragraph = v;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\table-cell-components.ts", o = "15246bd88ec12e1e440e4e7fd7e33cbb62019a43", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\table-cell-components.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 74
            }
          },
          4: {
            start: {
              line: 12,
              column: 22
            },
            end: {
              line: 16,
              column: 10
            }
          },
          5: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 30
            }
          },
          6: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 20
            }
          },
          7: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 29
            }
          },
          8: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 28,
              column: 9
            }
          },
          9: {
            start: {
              line: 27,
              column: 12
            },
            end: {
              line: 27,
              column: 38
            }
          },
          10: {
            start: {
              line: 31,
              column: 20
            },
            end: {
              line: 31,
              column: 52
            }
          },
          11: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 46
            }
          },
          12: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 28
            }
          },
          13: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 20
            }
          },
          14: {
            start: {
              line: 37,
              column: 22
            },
            end: {
              line: 37,
              column: 56
            }
          },
          15: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 38,
              column: 48
            }
          },
          16: {
            start: {
              line: 39,
              column: 8
            },
            end: {
              line: 39,
              column: 30
            }
          },
          17: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 20
            }
          },
          18: {
            start: {
              line: 43,
              column: 23
            },
            end: {
              line: 43,
              column: 58
            }
          },
          19: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 44,
              column: 49
            }
          },
          20: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 31
            }
          },
          21: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 46,
              column: 20
            }
          },
          22: {
            start: {
              line: 49,
              column: 20
            },
            end: {
              line: 49,
              column: 52
            }
          },
          23: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 46
            }
          },
          24: {
            start: {
              line: 51,
              column: 8
            },
            end: {
              line: 51,
              column: 28
            }
          },
          25: {
            start: {
              line: 52,
              column: 8
            },
            end: {
              line: 52,
              column: 20
            }
          },
          26: {
            start: {
              line: 55,
              column: 0
            },
            end: {
              line: 55,
              column: 44
            }
          },
          27: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 28
            }
          },
          28: {
            start: {
              line: 59,
              column: 8
            },
            end: {
              line: 59,
              column: 40
            }
          },
          29: {
            start: {
              line: 64,
              column: 8
            },
            end: {
              line: 64,
              column: 28
            }
          },
          30: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 67,
              column: 12
            }
          },
          31: {
            start: {
              line: 70,
              column: 0
            },
            end: {
              line: 70,
              column: 28
            }
          },
          32: {
            start: {
              line: 72,
              column: 0
            },
            end: {
              line: 75,
              column: 65
            }
          },
          33: {
            start: {
              line: 73,
              column: 4
            },
            end: {
              line: 73,
              column: 40
            }
          },
          34: {
            start: {
              line: 74,
              column: 4
            },
            end: {
              line: 74,
              column: 38
            }
          },
          35: {
            start: {
              line: 78,
              column: 8
            },
            end: {
              line: 78,
              column: 28
            }
          },
          36: {
            start: {
              line: 79,
              column: 8
            },
            end: {
              line: 79,
              column: 40
            }
          },
          37: {
            start: {
              line: 84,
              column: 8
            },
            end: {
              line: 84,
              column: 26
            }
          },
          38: {
            start: {
              line: 85,
              column: 8
            },
            end: {
              line: 87,
              column: 12
            }
          },
          39: {
            start: {
              line: 90,
              column: 0
            },
            end: {
              line: 90,
              column: 24
            }
          },
          40: {
            start: {
              line: 92,
              column: 0
            },
            end: {
              line: 96,
              column: 74
            }
          },
          41: {
            start: {
              line: 93,
              column: 4
            },
            end: {
              line: 93,
              column: 39
            }
          },
          42: {
            start: {
              line: 94,
              column: 4
            },
            end: {
              line: 94,
              column: 39
            }
          },
          43: {
            start: {
              line: 95,
              column: 4
            },
            end: {
              line: 95,
              column: 33
            }
          },
          44: {
            start: {
              line: 99,
              column: 8
            },
            end: {
              line: 99,
              column: 28
            }
          },
          45: {
            start: {
              line: 100,
              column: 8
            },
            end: {
              line: 100,
              column: 40
            }
          },
          46: {
            start: {
              line: 105,
              column: 8
            },
            end: {
              line: 105,
              column: 26
            }
          },
          47: {
            start: {
              line: 106,
              column: 8
            },
            end: {
              line: 108,
              column: 12
            }
          },
          48: {
            start: {
              line: 111,
              column: 0
            },
            end: {
              line: 111,
              column: 24
            }
          },
          49: {
            start: {
              line: 113,
              column: 0
            },
            end: {
              line: 118,
              column: 62
            }
          },
          50: {
            start: {
              line: 114,
              column: 4
            },
            end: {
              line: 114,
              column: 31
            }
          },
          51: {
            start: {
              line: 115,
              column: 4
            },
            end: {
              line: 115,
              column: 29
            }
          },
          52: {
            start: {
              line: 116,
              column: 4
            },
            end: {
              line: 116,
              column: 29
            }
          },
          53: {
            start: {
              line: 117,
              column: 4
            },
            end: {
              line: 117,
              column: 36
            }
          },
          54: {
            start: {
              line: 121,
              column: 8
            },
            end: {
              line: 121,
              column: 28
            }
          },
          55: {
            start: {
              line: 122,
              column: 8
            },
            end: {
              line: 122,
              column: 56
            }
          },
          56: {
            start: {
              line: 127,
              column: 8
            },
            end: {
              line: 127,
              column: 23
            }
          },
          57: {
            start: {
              line: 128,
              column: 8
            },
            end: {
              line: 131,
              column: 12
            }
          },
          58: {
            start: {
              line: 134,
              column: 0
            },
            end: {
              line: 134,
              column: 40
            }
          },
          59: {
            start: {
              line: 137,
              column: 8
            },
            end: {
              line: 137,
              column: 28
            }
          },
          60: {
            start: {
              line: 138,
              column: 8
            },
            end: {
              line: 142,
              column: 10
            }
          },
          61: {
            start: {
              line: 147,
              column: 8
            },
            end: {
              line: 147,
              column: 23
            }
          },
          62: {
            start: {
              line: 148,
              column: 8
            },
            end: {
              line: 148,
              column: 62
            }
          },
          63: {
            start: {
              line: 151,
              column: 0
            },
            end: {
              line: 151,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 38
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 22,
                column: 4
              },
              end: {
                line: 22,
                column: 5
              }
            },
            loc: {
              start: {
                line: 22,
                column: 18
              },
              end: {
                line: 24,
                column: 5
              }
            },
            line: 22
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 25,
                column: 4
              },
              end: {
                line: 25,
                column: 5
              }
            },
            loc: {
              start: {
                line: 25,
                column: 17
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 25
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 37
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 30
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 36,
                column: 4
              },
              end: {
                line: 36,
                column: 5
              }
            },
            loc: {
              start: {
                line: 36,
                column: 39
              },
              end: {
                line: 41,
                column: 5
              }
            },
            line: 36
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 42,
                column: 4
              },
              end: {
                line: 42,
                column: 5
              }
            },
            loc: {
              start: {
                line: 42,
                column: 40
              },
              end: {
                line: 47,
                column: 5
              }
            },
            line: 42
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 48,
                column: 4
              },
              end: {
                line: 48,
                column: 5
              }
            },
            loc: {
              start: {
                line: 48,
                column: 37
              },
              end: {
                line: 53,
                column: 5
              }
            },
            line: 48
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 57,
                column: 4
              },
              end: {
                line: 57,
                column: 5
              }
            },
            loc: {
              start: {
                line: 57,
                column: 18
              },
              end: {
                line: 60,
                column: 5
              }
            },
            line: 57
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 63,
                column: 4
              },
              end: {
                line: 63,
                column: 5
              }
            },
            loc: {
              start: {
                line: 63,
                column: 23
              },
              end: {
                line: 68,
                column: 5
              }
            },
            line: 63
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 72,
                column: 1
              },
              end: {
                line: 72,
                column: 2
              }
            },
            loc: {
              start: {
                line: 72,
                column: 23
              },
              end: {
                line: 75,
                column: 1
              }
            },
            line: 72
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 77,
                column: 4
              },
              end: {
                line: 77,
                column: 5
              }
            },
            loc: {
              start: {
                line: 77,
                column: 18
              },
              end: {
                line: 80,
                column: 5
              }
            },
            line: 77
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 83,
                column: 4
              },
              end: {
                line: 83,
                column: 5
              }
            },
            loc: {
              start: {
                line: 83,
                column: 23
              },
              end: {
                line: 88,
                column: 5
              }
            },
            line: 83
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 92,
                column: 1
              },
              end: {
                line: 92,
                column: 2
              }
            },
            loc: {
              start: {
                line: 92,
                column: 26
              },
              end: {
                line: 96,
                column: 1
              }
            },
            line: 92
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 98,
                column: 4
              },
              end: {
                line: 98,
                column: 5
              }
            },
            loc: {
              start: {
                line: 98,
                column: 18
              },
              end: {
                line: 101,
                column: 5
              }
            },
            line: 98
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 104,
                column: 4
              },
              end: {
                line: 104,
                column: 5
              }
            },
            loc: {
              start: {
                line: 104,
                column: 23
              },
              end: {
                line: 109,
                column: 5
              }
            },
            line: 104
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 113,
                column: 1
              },
              end: {
                line: 113,
                column: 2
              }
            },
            loc: {
              start: {
                line: 113,
                column: 22
              },
              end: {
                line: 118,
                column: 1
              }
            },
            line: 113
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 120,
                column: 4
              },
              end: {
                line: 120,
                column: 5
              }
            },
            loc: {
              start: {
                line: 120,
                column: 18
              },
              end: {
                line: 123,
                column: 5
              }
            },
            line: 120
          },
          18: {
            name: "(anonymous_18)",
            decl: {
              start: {
                line: 126,
                column: 4
              },
              end: {
                line: 126,
                column: 5
              }
            },
            loc: {
              start: {
                line: 126,
                column: 29
              },
              end: {
                line: 132,
                column: 5
              }
            },
            line: 126
          },
          19: {
            name: "(anonymous_19)",
            decl: {
              start: {
                line: 136,
                column: 4
              },
              end: {
                line: 136,
                column: 5
              }
            },
            loc: {
              start: {
                line: 136,
                column: 18
              },
              end: {
                line: 143,
                column: 5
              }
            },
            line: 136
          },
          20: {
            name: "(anonymous_20)",
            decl: {
              start: {
                line: 146,
                column: 4
              },
              end: {
                line: 146,
                column: 5
              }
            },
            loc: {
              start: {
                line: 146,
                column: 23
              },
              end: {
                line: 149,
                column: 5
              }
            },
            line: 146
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 26,
                column: 8
              },
              end: {
                line: 28,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 26,
                column: 8
              },
              end: {
                line: 28,
                column: 9
              }
            }, {
              start: {
                line: 26,
                column: 8
              },
              end: {
                line: 28,
                column: 9
              }
            }],
            line: 26
          },
          1: {
            loc: {
              start: {
                line: 75,
                column: 16
              },
              end: {
                line: 75,
                column: 63
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 75,
                column: 16
              },
              end: {
                line: 75,
                column: 34
              }
            }, {
              start: {
                line: 75,
                column: 39
              },
              end: {
                line: 75,
                column: 62
              }
            }],
            line: 75
          },
          2: {
            loc: {
              start: {
                line: 96,
                column: 19
              },
              end: {
                line: 96,
                column: 72
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 96,
                column: 19
              },
              end: {
                line: 96,
                column: 40
              }
            }, {
              start: {
                line: 96,
                column: 45
              },
              end: {
                line: 96,
                column: 71
              }
            }],
            line: 96
          },
          3: {
            loc: {
              start: {
                line: 118,
                column: 15
              },
              end: {
                line: 118,
                column: 60
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 118,
                column: 15
              },
              end: {
                line: 118,
                column: 32
              }
            }, {
              start: {
                line: 118,
                column: 37
              },
              end: {
                line: 118,
                column: 59
              }
            }],
            line: 118
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-cell/table-cell-components.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-cell\\table-cell-components.ts"],
          names: [],
          mappings: ";;AACA,wDAA0F;AAQ1F,0BAA2B,SAAQ,sCAAkC;IAArE;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,OAAO,EAAE,IAAI,EAAE,MAAM,EAAE,KAAK,EAAE,SAAS,EAAE,CAAC;IACpF,CAAC;CAAA;AAED,yBAA0B,SAAQ,6BAAY;IACnC,aAAa,CAAC,KAAkB,EAAE,IAAY,EAAE,KAAa;QAChE,MAAM,KAAK,GAAG,IAAI,oBAAoB,CAAC;YACnC,KAAK,EAAE,KAAK;YACZ,IAAI,EAAE,IAAI;YACV,KAAK,EAAE,KAAK;SACf,CAAC,CAAC;QACH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;QAEtB,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAED,sBAA8B,SAAQ,6BAAY;IAC9C;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;IACzB,CAAC;IAEM,UAAU;QACb,IAAI,IAAI,CAAC,IAAI,CAAC,MAAM,GAAG,CAAC,EAAE;YACtB,OAAO,KAAK,CAAC,UAAU,EAAE,CAAC;SAC7B;IACL,CAAC;IAEM,YAAY,CAAC,KAAkB,EAAE,IAAY,EAAE,KAAa;QAC/D,MAAM,GAAG,GAAG,IAAI,mBAAmB,CAAC,OAAO,CAAC,CAAC;QAC7C,GAAG,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,EAAE,KAAK,CAAC,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QAEpB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,cAAc,CAAC,KAAkB,EAAE,IAAY,EAAE,KAAa;QACjE,MAAM,KAAK,GAAG,IAAI,mBAAmB,CAAC,SAAS,CAAC,CAAC;QACjD,KAAK,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,EAAE,KAAK,CAAC,CAAC;QACxC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;QAEtB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe,CAAC,KAAkB,EAAE,IAAY,EAAE,KAAa;QAClE,MAAM,MAAM,GAAG,IAAI,mBAAmB,CAAC,UAAU,CAAC,CAAC;QACnD,MAAM,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,EAAE,KAAK,CAAC,CAAC;QACzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;QAEvB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,YAAY,CAAC,KAAkB,EAAE,IAAY,EAAE,KAAa;QAC/D,MAAM,GAAG,GAAG,IAAI,mBAAmB,CAAC,OAAO,CAAC,CAAC;QAC7C,GAAG,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,EAAE,KAAK,CAAC,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QAEpB,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AA1CD,4CA0CC;AAKD,wBAAyB,SAAQ,sCAA+C;IAAhF;;QACuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC;IAClD,CAAC;CAAA;AAKD,cAAsB,SAAQ,6BAAY;IACtC,YAAY,KAAa;QACrB,KAAK,CAAC,YAAY,CAAC,CAAC;QAEpB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kBAAkB,CAAC;YACnB,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,4BAUC;AAKD,IAAY,UASX;AATD,WAAY,UAAU;IAIlB,mCAAqB,CAAA;IAIrB,iCAAmB,CAAA;AACvB,CAAC,EATW,UAAU,GAAV,kBAAU,KAAV,kBAAU,QASrB;AAED,sBAAuB,SAAQ,sCAAmD;IAAlF;;QACuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC;IAClD,CAAC;CAAA;AAKD,YAAoB,SAAQ,6BAAY;IACpC,YAAY,KAAiB;QACzB,KAAK,CAAC,UAAU,CAAC,CAAC;QAElB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,gBAAgB,CAAC;YACjB,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,wBAUC;AAED,IAAY,aAIX;AAJD,WAAY,aAAa;IACrB,kCAAiB,CAAA;IACjB,kCAAiB,CAAA;IACjB,4BAAW,CAAA;AACf,CAAC,EAJW,aAAa,GAAb,qBAAa,KAAb,qBAAa,QAIxB;AAED,sBAAuB,SAAQ,sCAAsD;IAArF;;QACuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC;IAClD,CAAC;CAAA;AAKD,YAAoB,SAAQ,6BAAY;IACpC,YAAY,KAAoB;QAC5B,KAAK,CAAC,UAAU,CAAC,CAAC;QAElB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,gBAAgB,CAAC;YACjB,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,wBAUC;AAED,IAAY,SASX;AATD,WAAY,SAAS;IAEjB,0BAAa,CAAA;IAEb,wBAAW,CAAA;IAEX,wBAAW,CAAA;IAEX,+BAAkB,CAAA;AACtB,CAAC,EATW,SAAS,GAAT,iBAAS,KAAT,iBAAS,QASpB;AAED,8BAA+B,SAAQ,sCAAoF;IAA3H;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,KAAK,EAAE,IAAI,EAAE,QAAQ,EAAE,CAAC;IAClE,CAAC;CAAA;AAKD,oBAA4B,SAAQ,6BAAY;IAC5C,YAAY,KAAsB,EAAE,IAAe;QAC/C,KAAK,CAAC,OAAO,CAAC,CAAC;QAEf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wBAAwB,CAAC;YACzB,KAAK,EAAE,KAAK;YACZ,IAAI,EAAE,IAAI;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,wCAWC;AAQD,gCAAiC,SAAQ,sCAA4D;IAArG;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,QAAQ;YACd,KAAK,EAAE,SAAS;YAChB,GAAG,EAAE,OAAO;SACf,CAAC;IACN,CAAC;CAAA;AAKD,sBAA8B,SAAQ,6BAAY;IAC9C,YAAY,KAA4C;QACpD,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,0BAA0B,CAAC,KAAK,CAAC,CAAC,CAAC;IAC1D,CAAC;CACJ;AALD,4CAKC",
          sourcesContent: ['import { BorderStyle } from "file/styles";\r\nimport { IXmlableObject, XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\ninterface ICellBorder {\r\n    readonly style: BorderStyle;\r\n    readonly size: number;\r\n    readonly color: string;\r\n}\r\n\r\nclass CellBorderAttributes extends XmlAttributeComponent<ICellBorder> {\r\n    protected readonly xmlKeys = { style: "w:val", size: "w:sz", color: "w:color" };\r\n}\r\n\r\nclass BaseTableCellBorder extends XmlComponent {\r\n    public setProperties(style: BorderStyle, size: number, color: string): BaseTableCellBorder {\r\n        const attrs = new CellBorderAttributes({\r\n            style: style,\r\n            size: size,\r\n            color: color,\r\n        });\r\n        this.root.push(attrs);\r\n\r\n        return this;\r\n    }\r\n}\r\n\r\nexport class TableCellBorders extends XmlComponent {\r\n    constructor() {\r\n        super("w:tcBorders");\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        if (this.root.length > 0) {\r\n            return super.prepForXml();\r\n        }\r\n    }\r\n\r\n    public addTopBorder(style: BorderStyle, size: number, color: string): TableCellBorders {\r\n        const top = new BaseTableCellBorder("w:top");\r\n        top.setProperties(style, size, color);\r\n        this.root.push(top);\r\n\r\n        return this;\r\n    }\r\n\r\n    public addStartBorder(style: BorderStyle, size: number, color: string): TableCellBorders {\r\n        const start = new BaseTableCellBorder("w:start");\r\n        start.setProperties(style, size, color);\r\n        this.root.push(start);\r\n\r\n        return this;\r\n    }\r\n\r\n    public addBottomBorder(style: BorderStyle, size: number, color: string): TableCellBorders {\r\n        const bottom = new BaseTableCellBorder("w:bottom");\r\n        bottom.setProperties(style, size, color);\r\n        this.root.push(bottom);\r\n\r\n        return this;\r\n    }\r\n\r\n    public addEndBorder(style: BorderStyle, size: number, color: string): TableCellBorders {\r\n        const end = new BaseTableCellBorder("w:end");\r\n        end.setProperties(style, size, color);\r\n        this.root.push(end);\r\n\r\n        return this;\r\n    }\r\n}\r\n\r\n/**\r\n * Attributes fot the GridSpan element.\r\n */\r\nclass GridSpanAttributes extends XmlAttributeComponent<{ readonly val: number }> {\r\n    protected readonly xmlKeys = { val: "w:val" };\r\n}\r\n\r\n/**\r\n * GridSpan element. Should be used in a table cell. Pass the number of columns that this cell need to span.\r\n */\r\nexport class GridSpan extends XmlComponent {\r\n    constructor(value: number) {\r\n        super("w:gridSpan");\r\n\r\n        this.root.push(\r\n            new GridSpanAttributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\n/**\r\n * Vertical merge types.\r\n */\r\nexport enum VMergeType {\r\n    /**\r\n     * Cell that is merged with upper one.\r\n     */\r\n    CONTINUE = "continue",\r\n    /**\r\n     * Cell that is starting the vertical merge.\r\n     */\r\n    RESTART = "restart",\r\n}\r\n\r\nclass VMergeAttributes extends XmlAttributeComponent<{ readonly val: VMergeType }> {\r\n    protected readonly xmlKeys = { val: "w:val" };\r\n}\r\n\r\n/**\r\n * Vertical merge element. Should be used in a table cell.\r\n */\r\nexport class VMerge extends XmlComponent {\r\n    constructor(value: VMergeType) {\r\n        super("w:vMerge");\r\n\r\n        this.root.push(\r\n            new VMergeAttributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport enum VerticalAlign {\r\n    BOTTOM = "bottom",\r\n    CENTER = "center",\r\n    TOP = "top",\r\n}\r\n\r\nclass VAlignAttributes extends XmlAttributeComponent<{ readonly val: VerticalAlign }> {\r\n    protected readonly xmlKeys = { val: "w:val" };\r\n}\r\n\r\n/**\r\n * Vertical align element.\r\n */\r\nexport class VAlign extends XmlComponent {\r\n    constructor(value: VerticalAlign) {\r\n        super("w:vAlign");\r\n\r\n        this.root.push(\r\n            new VAlignAttributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport enum WidthType {\r\n    /** Auto. */\r\n    AUTO = "auto",\r\n    /** Value is in twentieths of a point */\r\n    DXA = "dxa",\r\n    /** No (empty) value. */\r\n    NIL = "nil",\r\n    /** Value is in percentage. */\r\n    PERCENTAGE = "pct",\r\n}\r\n\r\nclass TableCellWidthAttributes extends XmlAttributeComponent<{ readonly type: WidthType; readonly width: string | number }> {\r\n    protected readonly xmlKeys = { width: "w:w", type: "w:type" };\r\n}\r\n\r\n/**\r\n * Table cell width element.\r\n */\r\nexport class TableCellWidth extends XmlComponent {\r\n    constructor(value: string | number, type: WidthType) {\r\n        super("w:tcW");\r\n\r\n        this.root.push(\r\n            new TableCellWidthAttributes({\r\n                width: value,\r\n                type: type,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport interface ITableCellShadingAttributesProperties {\r\n    readonly fill?: string;\r\n    readonly color?: string;\r\n    readonly val?: string;\r\n}\r\n\r\nclass TableCellShadingAttributes extends XmlAttributeComponent<ITableCellShadingAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        fill: "w:fill",\r\n        color: "w:color",\r\n        val: "w:val",\r\n    };\r\n}\r\n\r\n/**\r\n * Table cell shading element.\r\n */\r\nexport class TableCellShading extends XmlComponent {\r\n    constructor(attrs: ITableCellShadingAttributesProperties) {\r\n        super("w:shd");\r\n        this.root.push(new TableCellShadingAttributes(attrs));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon12) {
        _inherits(u, _c$XmlAttributeCompon12);

        function u() {
          var _this93;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this93 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this93.xmlKeys = {
            style: "w:val",
            size: "w:sz",
            color: "w:color"
          };
          return _this93;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent55) {
        _inherits(p, _c$XmlComponent55);

        function p() {
          _classCallCheck(this, p);

          return _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments));
        }

        _createClass(p, [{
          key: "setProperties",
          value: function setProperties(e, n, t) {
            a.f[1]++;
            var r = (a.s[4]++, new u({
              style: e,
              size: n,
              color: t
            }));
            return a.s[5]++, this.root.push(r), a.s[6]++, this;
          }
        }]);

        return p;
      }(c.XmlComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent56) {
        _inherits(m, _c$XmlComponent56);

        function m() {
          var _this94;

          _classCallCheck(this, m);

          a.f[2]++, a.s[7]++, _this94 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:tcBorders"));
          return _this94;
        }

        _createClass(m, [{
          key: "prepForXml",
          value: function prepForXml() {
            if (a.f[3]++, a.s[8]++, this.root.length > 0) return a.b[0][0]++, a.s[9]++, _get(_getPrototypeOf(m.prototype), "prepForXml", this).call(this);
            a.b[0][1]++;
          }
        }, {
          key: "addTopBorder",
          value: function addTopBorder(e, n, t) {
            a.f[4]++;
            var r = (a.s[10]++, new p("w:top"));
            return a.s[11]++, r.setProperties(e, n, t), a.s[12]++, this.root.push(r), a.s[13]++, this;
          }
        }, {
          key: "addStartBorder",
          value: function addStartBorder(e, n, t) {
            a.f[5]++;
            var r = (a.s[14]++, new p("w:start"));
            return a.s[15]++, r.setProperties(e, n, t), a.s[16]++, this.root.push(r), a.s[17]++, this;
          }
        }, {
          key: "addBottomBorder",
          value: function addBottomBorder(e, n, t) {
            a.f[6]++;
            var r = (a.s[18]++, new p("w:bottom"));
            return a.s[19]++, r.setProperties(e, n, t), a.s[20]++, this.root.push(r), a.s[21]++, this;
          }
        }, {
          key: "addEndBorder",
          value: function addEndBorder(e, n, t) {
            a.f[7]++;
            var r = (a.s[22]++, new p("w:end"));
            return a.s[23]++, r.setProperties(e, n, t), a.s[24]++, this.root.push(r), a.s[25]++, this;
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[26]++, n.TableCellBorders = m;

      var C =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon13) {
        _inherits(C, _c$XmlAttributeCompon13);

        function C() {
          var _this95;

          _classCallCheck(this, C);

          a.f[8]++, a.s[27]++, _this95 = _possibleConstructorReturn(this, _getPrototypeOf(C).apply(this, arguments)), a.s[28]++, _this95.xmlKeys = {
            val: "w:val"
          };
          return _this95;
        }

        return C;
      }(c.XmlAttributeComponent);

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent57) {
        _inherits(d, _c$XmlComponent57);

        function d(e) {
          var _this96;

          _classCallCheck(this, d);

          a.f[9]++, a.s[29]++, _this96 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "w:gridSpan")), a.s[30]++, _this96.root.push(new C({
            val: e
          }));
          return _this96;
        }

        return d;
      }(c.XmlComponent);

      a.s[31]++, n.GridSpan = d, a.s[32]++, function (e) {
        a.f[10]++, a.s[33]++, e.CONTINUE = "continue", a.s[34]++, e.RESTART = "restart";
      }((a.b[1][0]++, n.VMergeType || (a.b[1][1]++, n.VMergeType = {})));

      var f =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon14) {
        _inherits(f, _c$XmlAttributeCompon14);

        function f() {
          var _this97;

          _classCallCheck(this, f);

          a.f[11]++, a.s[35]++, _this97 = _possibleConstructorReturn(this, _getPrototypeOf(f).apply(this, arguments)), a.s[36]++, _this97.xmlKeys = {
            val: "w:val"
          };
          return _this97;
        }

        return f;
      }(c.XmlAttributeComponent);

      var h =
      /*#__PURE__*/
      function (_c$XmlComponent58) {
        _inherits(h, _c$XmlComponent58);

        function h(e) {
          var _this98;

          _classCallCheck(this, h);

          a.f[12]++, a.s[37]++, _this98 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, "w:vMerge")), a.s[38]++, _this98.root.push(new f({
            val: e
          }));
          return _this98;
        }

        return h;
      }(c.XmlComponent);

      a.s[39]++, n.VMerge = h, a.s[40]++, function (e) {
        a.f[13]++, a.s[41]++, e.BOTTOM = "bottom", a.s[42]++, e.CENTER = "center", a.s[43]++, e.TOP = "top";
      }((a.b[2][0]++, n.VerticalAlign || (a.b[2][1]++, n.VerticalAlign = {})));

      var x =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon15) {
        _inherits(x, _c$XmlAttributeCompon15);

        function x() {
          var _this99;

          _classCallCheck(this, x);

          a.f[14]++, a.s[44]++, _this99 = _possibleConstructorReturn(this, _getPrototypeOf(x).apply(this, arguments)), a.s[45]++, _this99.xmlKeys = {
            val: "w:val"
          };
          return _this99;
        }

        return x;
      }(c.XmlAttributeComponent);

      var g =
      /*#__PURE__*/
      function (_c$XmlComponent59) {
        _inherits(g, _c$XmlComponent59);

        function g(e) {
          var _this100;

          _classCallCheck(this, g);

          a.f[15]++, a.s[46]++, _this100 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, "w:vAlign")), a.s[47]++, _this100.root.push(new x({
            val: e
          }));
          return _this100;
        }

        return g;
      }(c.XmlComponent);

      a.s[48]++, n.VAlign = g, a.s[49]++, function (e) {
        a.f[16]++, a.s[50]++, e.AUTO = "auto", a.s[51]++, e.DXA = "dxa", a.s[52]++, e.NIL = "nil", a.s[53]++, e.PERCENTAGE = "pct";
      }((a.b[3][0]++, n.WidthType || (a.b[3][1]++, n.WidthType = {})));

      var I =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon16) {
        _inherits(I, _c$XmlAttributeCompon16);

        function I() {
          var _this101;

          _classCallCheck(this, I);

          a.f[17]++, a.s[54]++, _this101 = _possibleConstructorReturn(this, _getPrototypeOf(I).apply(this, arguments)), a.s[55]++, _this101.xmlKeys = {
            width: "w:w",
            type: "w:type"
          };
          return _this101;
        }

        return I;
      }(c.XmlAttributeComponent);

      var b =
      /*#__PURE__*/
      function (_c$XmlComponent60) {
        _inherits(b, _c$XmlComponent60);

        function b(e, n) {
          var _this102;

          _classCallCheck(this, b);

          a.f[18]++, a.s[56]++, _this102 = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this, "w:tcW")), a.s[57]++, _this102.root.push(new I({
            width: e,
            type: n
          }));
          return _this102;
        }

        return b;
      }(c.XmlComponent);

      a.s[58]++, n.TableCellWidth = b;

      var y =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon17) {
        _inherits(y, _c$XmlAttributeCompon17);

        function y() {
          var _this103;

          _classCallCheck(this, y);

          a.f[19]++, a.s[59]++, _this103 = _possibleConstructorReturn(this, _getPrototypeOf(y).apply(this, arguments)), a.s[60]++, _this103.xmlKeys = {
            fill: "w:fill",
            color: "w:color",
            val: "w:val"
          };
          return _this103;
        }

        return y;
      }(c.XmlAttributeComponent);

      var E =
      /*#__PURE__*/
      function (_c$XmlComponent61) {
        _inherits(E, _c$XmlComponent61);

        function E(e) {
          var _this104;

          _classCallCheck(this, E);

          a.f[20]++, a.s[61]++, _this104 = _possibleConstructorReturn(this, _getPrototypeOf(E).call(this, "w:shd")), a.s[62]++, _this104.root.push(new y(e));
          return _this104;
        }

        return E;
      }(c.XmlComponent);

      a.s[63]++, n.TableCellShading = E;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\index.ts", o = "826536ef15c0bf28faf7e36262b7be11adc78be3", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 40
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-properties/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-properties\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,wCAAmC;AACnC,8CAAyC",
          sourcesContent: ['export * from "./table-properties";\r\nexport * from "./table-float-properties";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(220)), a.s[5]++, c(t(84));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-float-properties.ts", o = "1b17c9987550aa56fa178d4b52d07d71737fcddb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-float-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 9,
              column: 80
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 41
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 37
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 37
            }
          },
          6: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 17,
              column: 113
            }
          },
          7: {
            start: {
              line: 12,
              column: 4
            },
            end: {
              line: 12,
              column: 52
            }
          },
          8: {
            start: {
              line: 13,
              column: 4
            },
            end: {
              line: 13,
              column: 52
            }
          },
          9: {
            start: {
              line: 14,
              column: 4
            },
            end: {
              line: 14,
              column: 48
            }
          },
          10: {
            start: {
              line: 15,
              column: 4
            },
            end: {
              line: 15,
              column: 54
            }
          },
          11: {
            start: {
              line: 16,
              column: 4
            },
            end: {
              line: 16,
              column: 50
            }
          },
          12: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 26,
              column: 107
            }
          },
          13: {
            start: {
              line: 20,
              column: 4
            },
            end: {
              line: 20,
              column: 50
            }
          },
          14: {
            start: {
              line: 21,
              column: 4
            },
            end: {
              line: 21,
              column: 50
            }
          },
          15: {
            start: {
              line: 22,
              column: 4
            },
            end: {
              line: 22,
              column: 50
            }
          },
          16: {
            start: {
              line: 23,
              column: 4
            },
            end: {
              line: 23,
              column: 52
            }
          },
          17: {
            start: {
              line: 24,
              column: 4
            },
            end: {
              line: 24,
              column: 50
            }
          },
          18: {
            start: {
              line: 25,
              column: 4
            },
            end: {
              line: 25,
              column: 44
            }
          },
          19: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 28
            }
          },
          20: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 41,
              column: 10
            }
          },
          21: {
            start: {
              line: 44,
              column: 0
            },
            end: {
              line: 44,
              column: 66
            }
          },
          22: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 26
            }
          },
          23: {
            start: {
              line: 48,
              column: 8
            },
            end: {
              line: 48,
              column: 65
            }
          },
          24: {
            start: {
              line: 51,
              column: 0
            },
            end: {
              line: 51,
              column: 52
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 28
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 1
              },
              end: {
                line: 11,
                column: 2
              }
            },
            loc: {
              start: {
                line: 11,
                column: 39
              },
              end: {
                line: 17,
                column: 1
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 19,
                column: 1
              },
              end: {
                line: 19,
                column: 2
              }
            },
            loc: {
              start: {
                line: 19,
                column: 37
              },
              end: {
                line: 26,
                column: 1
              }
            },
            line: 19
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 28,
                column: 4
              },
              end: {
                line: 28,
                column: 5
              }
            },
            loc: {
              start: {
                line: 28,
                column: 18
              },
              end: {
                line: 42,
                column: 5
              }
            },
            line: 28
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 46,
                column: 4
              },
              end: {
                line: 46,
                column: 5
              }
            },
            loc: {
              start: {
                line: 46,
                column: 25
              },
              end: {
                line: 49,
                column: 5
              }
            },
            line: 46
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 21
              },
              end: {
                line: 9,
                column: 78
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 21
              },
              end: {
                line: 9,
                column: 44
              }
            }, {
              start: {
                line: 9,
                column: 49
              },
              end: {
                line: 9,
                column: 77
              }
            }],
            line: 9
          },
          1: {
            loc: {
              start: {
                line: 17,
                column: 32
              },
              end: {
                line: 17,
                column: 111
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 17,
                column: 32
              },
              end: {
                line: 17,
                column: 66
              }
            }, {
              start: {
                line: 17,
                column: 71
              },
              end: {
                line: 17,
                column: 110
              }
            }],
            line: 17
          },
          2: {
            loc: {
              start: {
                line: 26,
                column: 30
              },
              end: {
                line: 26,
                column: 105
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 26,
                column: 30
              },
              end: {
                line: 26,
                column: 62
              }
            }, {
              start: {
                line: 26,
                column: 67
              },
              end: {
                line: 26,
                column: 104
              }
            }],
            line: 26
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-properties/table-float-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-properties\\table-float-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAE1E,IAAY,eAIX;AAJD,WAAY,eAAe;IACvB,oCAAiB,CAAA;IACjB,gCAAa,CAAA;IACb,gCAAa,CAAA;AACjB,CAAC,EAJW,eAAe,GAAf,uBAAe,KAAf,uBAAe,QAI1B;AAED,IAAY,0BAMX;AAND,WAAY,0BAA0B;IAClC,+CAAiB,CAAA;IACjB,+CAAiB,CAAA;IACjB,2CAAa,CAAA;IACb,iDAAmB,CAAA;IACnB,6CAAe,CAAA;AACnB,CAAC,EANW,0BAA0B,GAA1B,kCAA0B,KAA1B,kCAA0B,QAMrC;AAED,IAAY,wBAOX;AAPD,WAAY,wBAAwB;IAChC,6CAAiB,CAAA;IACjB,6CAAiB,CAAA;IACjB,6CAAiB,CAAA;IACjB,+CAAmB,CAAA;IACnB,6CAAiB,CAAA;IACjB,uCAAW,CAAA;AACf,CAAC,EAPW,wBAAwB,GAAxB,gCAAwB,KAAxB,gCAAwB,QAOnC;AA0FD,iCAAyC,SAAQ,sCAAyC;IAA1F;;QACuB,YAAO,GAAG;YACzB,gBAAgB,EAAE,cAAc;YAChC,cAAc,EAAE,cAAc;YAC9B,0BAA0B,EAAE,SAAS;YACrC,0BAA0B,EAAE,aAAa;YACzC,wBAAwB,EAAE,SAAS;YACnC,wBAAwB,EAAE,aAAa;YACvC,cAAc,EAAE,kBAAkB;YAClC,WAAW,EAAE,eAAe;YAC5B,YAAY,EAAE,gBAAgB;YAC9B,aAAa,EAAE,iBAAiB;SACnC,CAAC;IACN,CAAC;CAAA;AAbD,kEAaC;AAED,0BAAkC,SAAQ,6BAAY;IAClD,YAAY,OAA2B;QACnC,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2BAA2B,CAAC,OAAO,CAAC,CAAC,CAAC;IAC7D,CAAC;CACJ;AALD,oDAKC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport enum TableAnchorType {\r\n    MARGIN = "margin",\r\n    PAGE = "page",\r\n    TEXT = "text",\r\n}\r\n\r\nexport enum RelativeHorizontalPosition {\r\n    CENTER = "center",\r\n    INSIDE = "inside",\r\n    LEFT = "left",\r\n    OUTSIDE = "outside",\r\n    RIGHT = "right",\r\n}\r\n\r\nexport enum RelativeVerticalPosition {\r\n    CENTER = "center",\r\n    INSIDE = "inside",\r\n    BOTTOM = "bottom",\r\n    OUTSIDE = "outside",\r\n    INLINE = "inline",\r\n    TOP = "top",\r\n}\r\n\r\nexport interface ITableFloatOptions {\r\n    /**\r\n     * Specifies the horizontal anchor or the base object from which the horizontal positioning in the\r\n     * tblpX or tblpXSpec attribute should be determined.\r\n     * margin - relative to the vertical edge of the text margin before any text runs (left edge for left-to-right paragraphs)\r\n     * page - relative to the vertical edge of the page before any text runs (left edge for left-to-right paragraphs)\r\n     * text - relative to the vertical edge of the text margin for the column in which the anchor paragraph is located\r\n     * If omitted, the value is assumed to be page.\r\n     */\r\n    readonly horizontalAnchor?: TableAnchorType;\r\n\r\n    /**\r\n     * Specifies an absolute horizontal position for the table, relative to the horizontalAnchor.\r\n     * The value is in twentieths of a point. Note that the value can be negative, in which case the\r\n     * table is positioned before the anchor object in the direction of horizontal text flow.\r\n     * If relativeHorizontalPosition is also specified, then the absoluteHorizontalPosition attribute is ignored.\r\n     * If the attribute is omitted, the value is assumed to be zero.\r\n     */\r\n    readonly absoluteHorizontalPosition?: number;\r\n\r\n    /**\r\n     * Specifies a relative horizontal position for the table, relative to the horizontalAnchor attribute.\r\n     * This will supersede the absoluteHorizontalPosition attribute.\r\n     * Possible values are:\r\n     * center - the table should be horizontally centered with respect to the anchor\r\n     * inside - the table should be inside of the anchor\r\n     * left - the table should be left aligned with respect to the anchor\r\n     * outside - the table should be outside of the anchor\r\n     * right - the table should be right aligned with respect to the anchor\r\n     */\r\n    readonly relativeHorizontalPosition?: RelativeHorizontalPosition;\r\n\r\n    /**\r\n     * Specifies the vertical anchor or the base object from which the vertical positioning\r\n     * in the absoluteVerticalPosition attribute should be determined. Possible values are:\r\n     * margin - relative to the horizontal edge of the text margin before any text runs (top edge for top-to-bottom paragraphs)\r\n     * page - relative to the horizontal edge of the page before any text runs (top edge for top-to-bottom paragraphs)\r\n     * text - relative to the horizontal edge of the text margin for the column in which the anchor paragraph is located\r\n     * If omitted, the value is assumed to be page.\r\n     */\r\n    readonly verticalAnchor?: TableAnchorType;\r\n\r\n    /**\r\n     * Specifies an absolute vertical position for the table, relative to the verticalAnchor anchor.\r\n     * The value is in twentieths of a point. Note that the value can be negative, in which case the table is\r\n     * positioned before the anchor object in the direction of vertical text flow.\r\n     * If relativeVerticalPosition is also specified, then the absoluteVerticalPosition attribute is ignored.\r\n     * If the attribute is omitted, the value is assumed to be zero.\r\n     */\r\n    readonly absoluteVerticalPosition?: number;\r\n\r\n    /**\r\n     * Specifies a relative vertical position for the table, relative to the verticalAnchor attribute.\r\n     * This will supersede the absoluteVerticalPosition attribute. Possible values are:\r\n     * center - the table should be vertically centered with respect to the anchor\r\n     * inside - the table should be vertically aligned to the edge of the anchor and inside the anchor\r\n     * bottom - the table should be vertically aligned to the bottom edge of the anchor\r\n     * outside - the table should be vertically aligned to the edge of the anchor and outside the anchor\r\n     * inline - the table should be vertically aligned in line with the surrounding text (so as to not allow any text wrapping around it)\r\n     * top - the table should be vertically aligned to the top edge of the anchor\r\n     */\r\n    readonly relativeVerticalPosition?: RelativeVerticalPosition;\r\n\r\n    /**\r\n     * Specifies the minimun distance to be maintained between the table and the top of text in the paragraph\r\n     * below the table. The value is in twentieths of a point. If omitted, the value is assumed to be zero.\r\n     */\r\n    readonly bottomFromText?: number;\r\n\r\n    /**\r\n     * Specifies the minimun distance to be maintained between the table and the bottom edge of text in the paragraph\r\n     * above the table. The value is in twentieths of a point. If omitted, the value is assumed to be zero.\r\n     */\r\n    readonly topFromText?: number;\r\n\r\n    /**\r\n     * Specifies the minimun distance to be maintained between the table and the edge of text in the paragraph\r\n     * to the left of the table. The value is in twentieths of a point. If omitted, the value is assumed to be zero.\r\n     */\r\n    readonly leftFromText?: number;\r\n\r\n    /**\r\n     * Specifies the minimun distance to be maintained between the table and the edge of text in the paragraph\r\n     * to the right of the table. The value is in twentieths of a point. If omitted, the value is assumed to be zero.\r\n     */\r\n    readonly rightFromText?: number;\r\n}\r\n\r\nexport class TableFloatOptionsAttributes extends XmlAttributeComponent<ITableFloatOptions> {\r\n    protected readonly xmlKeys = {\r\n        horizontalAnchor: "w:horzAnchor",\r\n        verticalAnchor: "w:vertAnchor",\r\n        absoluteHorizontalPosition: "w:tblpX",\r\n        relativeHorizontalPosition: "w:tblpXSpec",\r\n        absoluteVerticalPosition: "w:tblpY",\r\n        relativeVerticalPosition: "w:tblpYSpec",\r\n        bottomFromText: "w:bottomFromText",\r\n        topFromText: "w:topFromText",\r\n        leftFromText: "w:leftFromText",\r\n        rightFromText: "w:rightFromText",\r\n    };\r\n}\r\n\r\nexport class TableFloatProperties extends XmlComponent {\r\n    constructor(options: ITableFloatOptions) {\r\n        super("w:tblpPr");\r\n        this.root.push(new TableFloatOptionsAttributes(options));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.MARGIN = "margin", a.s[4]++, e.PAGE = "page", a.s[5]++, e.TEXT = "text";
      }((a.b[0][0]++, n.TableAnchorType || (a.b[0][1]++, n.TableAnchorType = {}))), a.s[6]++, function (e) {
        a.f[1]++, a.s[7]++, e.CENTER = "center", a.s[8]++, e.INSIDE = "inside", a.s[9]++, e.LEFT = "left", a.s[10]++, e.OUTSIDE = "outside", a.s[11]++, e.RIGHT = "right";
      }((a.b[1][0]++, n.RelativeHorizontalPosition || (a.b[1][1]++, n.RelativeHorizontalPosition = {}))), a.s[12]++, function (e) {
        a.f[2]++, a.s[13]++, e.CENTER = "center", a.s[14]++, e.INSIDE = "inside", a.s[15]++, e.BOTTOM = "bottom", a.s[16]++, e.OUTSIDE = "outside", a.s[17]++, e.INLINE = "inline", a.s[18]++, e.TOP = "top";
      }((a.b[2][0]++, n.RelativeVerticalPosition || (a.b[2][1]++, n.RelativeVerticalPosition = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon18) {
        _inherits(u, _c$XmlAttributeCompon18);

        function u() {
          var _this105;

          _classCallCheck(this, u);

          a.f[3]++, a.s[19]++, _this105 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[20]++, _this105.xmlKeys = {
            horizontalAnchor: "w:horzAnchor",
            verticalAnchor: "w:vertAnchor",
            absoluteHorizontalPosition: "w:tblpX",
            relativeHorizontalPosition: "w:tblpXSpec",
            absoluteVerticalPosition: "w:tblpY",
            relativeVerticalPosition: "w:tblpYSpec",
            bottomFromText: "w:bottomFromText",
            topFromText: "w:topFromText",
            leftFromText: "w:leftFromText",
            rightFromText: "w:rightFromText"
          };
          return _this105;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[21]++, n.TableFloatOptionsAttributes = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent62) {
        _inherits(p, _c$XmlComponent62);

        function p(e) {
          var _this106;

          _classCallCheck(this, p);

          a.f[4]++, a.s[22]++, _this106 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:tblpPr")), a.s[23]++, _this106.root.push(new u(e));
          return _this106;
        }

        return p;
      }(c.XmlComponent);

      a.s[24]++, n.TableFloatProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-row\\table-row-properties.ts", o = "590a0d724da52f417ec3320f5ffaa2ae859d5297", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-row\\table-row-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 24
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 48
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-row/table-row-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-row\\table-row-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,wBAAgC,SAAQ,6BAAY;IAChD;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;IACpB,CAAC;CACJ;AAJD,gDAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class TableRowProperties extends XmlComponent {\r\n    constructor() {\r\n        super("w:trPr");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent63) {
        _inherits(u, _c$XmlComponent63);

        function u() {
          var _this107;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this107 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:trPr"));
          return _this107;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.TableRowProperties = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\index.ts", o = "8775db1df304d9e8956457ced878c80209ff3618", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 32
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 43
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,gCAA2B;AAC3B,2CAAsC;AACtC,4BAAuB",
          sourcesContent: ['export * from "./document";\r\nexport * from "./document-attributes";\r\nexport * from "./body";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(239)), a.s[5]++, c(t(11)), a.s[6]++, c(t(87));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\index.ts", o = "fd83b91e32f92703e92fe5c8f7dce3bcd11e8356", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 28
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,4BAAuB;AACvB,0CAAqC",
          sourcesContent: ['export * from "./body";\r\nexport * from "./section-properties";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(240)), a.s[5]++, c(t(98));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\section-properties.ts", o = "9850dc9292d9a432b2e7abd58c59fc35cbe1a70a", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\section-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 18
            },
            end: {
              line: 4,
              column: 46
            }
          },
          3: {
            start: {
              line: 5,
              column: 19
            },
            end: {
              line: 5,
              column: 49
            }
          },
          4: {
            start: {
              line: 6,
              column: 27
            },
            end: {
              line: 6,
              column: 56
            }
          },
          5: {
            start: {
              line: 7,
              column: 27
            },
            end: {
              line: 7,
              column: 73
            }
          },
          6: {
            start: {
              line: 8,
              column: 27
            },
            end: {
              line: 8,
              column: 56
            }
          },
          7: {
            start: {
              line: 9,
              column: 27
            },
            end: {
              line: 9,
              column: 73
            }
          },
          8: {
            start: {
              line: 10,
              column: 22
            },
            end: {
              line: 10,
              column: 46
            }
          },
          9: {
            start: {
              line: 11,
              column: 22
            },
            end: {
              line: 11,
              column: 58
            }
          },
          10: {
            start: {
              line: 12,
              column: 22
            },
            end: {
              line: 12,
              column: 46
            }
          },
          11: {
            start: {
              line: 13,
              column: 20
            },
            end: {
              line: 13,
              column: 52
            }
          },
          12: {
            start: {
              line: 14,
              column: 31
            },
            end: {
              line: 14,
              column: 74
            }
          },
          13: {
            start: {
              line: 15,
              column: 21
            },
            end: {
              line: 15,
              column: 55
            }
          },
          14: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 26
            }
          },
          15: {
            start: {
              line: 19,
              column: 450
            },
            end: {
              line: 19,
              column: 457
            }
          },
          16: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 31
            }
          },
          17: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 77
            }
          },
          18: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 111
            }
          },
          19: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 53
            }
          },
          20: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 63
            }
          },
          21: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 33
            }
          },
          22: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 33
            }
          },
          23: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 96
            }
          },
          24: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 36,
              column: 9
            }
          },
          25: {
            start: {
              line: 29,
              column: 12
            },
            end: {
              line: 35,
              column: 16
            }
          },
          26: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 39,
              column: 9
            }
          },
          27: {
            start: {
              line: 38,
              column: 12
            },
            end: {
              line: 38,
              column: 57
            }
          },
          28: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 61,
              column: 9
            }
          },
          29: {
            start: {
              line: 43,
              column: 12
            },
            end: {
              line: 48,
              column: 13
            }
          },
          30: {
            start: {
              line: 44,
              column: 16
            },
            end: {
              line: 47,
              column: 20
            }
          },
          31: {
            start: {
              line: 49,
              column: 12
            },
            end: {
              line: 54,
              column: 13
            }
          },
          32: {
            start: {
              line: 50,
              column: 16
            },
            end: {
              line: 53,
              column: 20
            }
          },
          33: {
            start: {
              line: 55,
              column: 12
            },
            end: {
              line: 60,
              column: 13
            }
          },
          34: {
            start: {
              line: 56,
              column: 16
            },
            end: {
              line: 59,
              column: 20
            }
          },
          35: {
            start: {
              line: 64,
              column: 8
            },
            end: {
              line: 83,
              column: 9
            }
          },
          36: {
            start: {
              line: 65,
              column: 12
            },
            end: {
              line: 70,
              column: 13
            }
          },
          37: {
            start: {
              line: 66,
              column: 16
            },
            end: {
              line: 69,
              column: 20
            }
          },
          38: {
            start: {
              line: 71,
              column: 12
            },
            end: {
              line: 76,
              column: 13
            }
          },
          39: {
            start: {
              line: 72,
              column: 16
            },
            end: {
              line: 75,
              column: 20
            }
          },
          40: {
            start: {
              line: 77,
              column: 12
            },
            end: {
              line: 82,
              column: 13
            }
          },
          41: {
            start: {
              line: 78,
              column: 16
            },
            end: {
              line: 81,
              column: 20
            }
          },
          42: {
            start: {
              line: 86,
              column: 8
            },
            end: {
              line: 86,
              column: 28
            }
          },
          43: {
            start: {
              line: 89,
              column: 0
            },
            end: {
              line: 89,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 30
              },
              end: {
                line: 40,
                column: 5
              }
            },
            line: 17
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 41,
                column: 4
              },
              end: {
                line: 41,
                column: 5
              }
            },
            loc: {
              start: {
                line: 41,
                column: 24
              },
              end: {
                line: 62,
                column: 5
              }
            },
            line: 41
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 63,
                column: 4
              },
              end: {
                line: 63,
                column: 5
              }
            },
            loc: {
              start: {
                line: 63,
                column: 24
              },
              end: {
                line: 84,
                column: 5
              }
            },
            line: 63
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 85,
                column: 4
              },
              end: {
                line: 85,
                column: 5
              }
            },
            loc: {
              start: {
                line: 85,
                column: 18
              },
              end: {
                line: 87,
                column: 5
              }
            },
            line: 85
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 17,
                column: 16
              },
              end: {
                line: 17,
                column: 28
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 17,
                column: 26
              },
              end: {
                line: 17,
                column: 28
              }
            }],
            line: 17
          },
          1: {
            loc: {
              start: {
                line: 19,
                column: 16
              },
              end: {
                line: 19,
                column: 29
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 24
              },
              end: {
                line: 19,
                column: 29
              }
            }],
            line: 19
          },
          2: {
            loc: {
              start: {
                line: 19,
                column: 31
              },
              end: {
                line: 19,
                column: 45
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 40
              },
              end: {
                line: 19,
                column: 45
              }
            }],
            line: 19
          },
          3: {
            loc: {
              start: {
                line: 19,
                column: 47
              },
              end: {
                line: 19,
                column: 57
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 53
              },
              end: {
                line: 19,
                column: 57
              }
            }],
            line: 19
          },
          4: {
            loc: {
              start: {
                line: 19,
                column: 59
              },
              end: {
                line: 19,
                column: 71
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 67
              },
              end: {
                line: 19,
                column: 71
              }
            }],
            line: 19
          },
          5: {
            loc: {
              start: {
                line: 19,
                column: 73
              },
              end: {
                line: 19,
                column: 86
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 82
              },
              end: {
                line: 19,
                column: 86
              }
            }],
            line: 19
          },
          6: {
            loc: {
              start: {
                line: 19,
                column: 88
              },
              end: {
                line: 19,
                column: 99
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 95
              },
              end: {
                line: 19,
                column: 99
              }
            }],
            line: 19
          },
          7: {
            loc: {
              start: {
                line: 19,
                column: 101
              },
              end: {
                line: 19,
                column: 113
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 110
              },
              end: {
                line: 19,
                column: 113
              }
            }],
            line: 19
          },
          8: {
            loc: {
              start: {
                line: 19,
                column: 115
              },
              end: {
                line: 19,
                column: 127
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 124
              },
              end: {
                line: 19,
                column: 127
              }
            }],
            line: 19
          },
          9: {
            loc: {
              start: {
                line: 19,
                column: 129
              },
              end: {
                line: 19,
                column: 139
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 138
              },
              end: {
                line: 19,
                column: 139
              }
            }],
            line: 19
          },
          10: {
            loc: {
              start: {
                line: 19,
                column: 141
              },
              end: {
                line: 19,
                column: 155
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 150
              },
              end: {
                line: 19,
                column: 155
              }
            }],
            line: 19
          },
          11: {
            loc: {
              start: {
                line: 19,
                column: 157
              },
              end: {
                line: 19,
                column: 168
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 165
              },
              end: {
                line: 19,
                column: 168
              }
            }],
            line: 19
          },
          12: {
            loc: {
              start: {
                line: 19,
                column: 170
              },
              end: {
                line: 19,
                column: 185
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 182
              },
              end: {
                line: 19,
                column: 185
              }
            }],
            line: 19
          },
          13: {
            loc: {
              start: {
                line: 19,
                column: 187
              },
              end: {
                line: 19,
                column: 248
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 201
              },
              end: {
                line: 19,
                column: 248
              }
            }],
            line: 19
          },
          14: {
            loc: {
              start: {
                line: 19,
                column: 268
              },
              end: {
                line: 19,
                column: 329
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 291
              },
              end: {
                line: 19,
                column: 329
              }
            }],
            line: 19
          },
          15: {
            loc: {
              start: {
                line: 19,
                column: 427
              },
              end: {
                line: 19,
                column: 444
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 439
              },
              end: {
                line: 19,
                column: 444
              }
            }],
            line: 19
          },
          16: {
            loc: {
              start: {
                line: 28,
                column: 8
              },
              end: {
                line: 36,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 28,
                column: 8
              },
              end: {
                line: 36,
                column: 9
              }
            }, {
              start: {
                line: 28,
                column: 8
              },
              end: {
                line: 36,
                column: 9
              }
            }],
            line: 28
          },
          17: {
            loc: {
              start: {
                line: 28,
                column: 12
              },
              end: {
                line: 28,
                column: 97
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 28,
                column: 12
              },
              end: {
                line: 28,
                column: 23
              }
            }, {
              start: {
                line: 28,
                column: 27
              },
              end: {
                line: 28,
                column: 40
              }
            }, {
              start: {
                line: 28,
                column: 44
              },
              end: {
                line: 28,
                column: 59
              }
            }, {
              start: {
                line: 28,
                column: 63
              },
              end: {
                line: 28,
                column: 79
              }
            }, {
              start: {
                line: 28,
                column: 83
              },
              end: {
                line: 28,
                column: 97
              }
            }],
            line: 28
          },
          18: {
            loc: {
              start: {
                line: 37,
                column: 8
              },
              end: {
                line: 39,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 37,
                column: 8
              },
              end: {
                line: 39,
                column: 9
              }
            }, {
              start: {
                line: 37,
                column: 8
              },
              end: {
                line: 39,
                column: 9
              }
            }],
            line: 37
          },
          19: {
            loc: {
              start: {
                line: 42,
                column: 8
              },
              end: {
                line: 61,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 42,
                column: 8
              },
              end: {
                line: 61,
                column: 9
              }
            }, {
              start: {
                line: 42,
                column: 8
              },
              end: {
                line: 61,
                column: 9
              }
            }],
            line: 42
          },
          20: {
            loc: {
              start: {
                line: 43,
                column: 12
              },
              end: {
                line: 48,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 43,
                column: 12
              },
              end: {
                line: 48,
                column: 13
              }
            }, {
              start: {
                line: 43,
                column: 12
              },
              end: {
                line: 48,
                column: 13
              }
            }],
            line: 43
          },
          21: {
            loc: {
              start: {
                line: 49,
                column: 12
              },
              end: {
                line: 54,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 49,
                column: 12
              },
              end: {
                line: 54,
                column: 13
              }
            }, {
              start: {
                line: 49,
                column: 12
              },
              end: {
                line: 54,
                column: 13
              }
            }],
            line: 49
          },
          22: {
            loc: {
              start: {
                line: 55,
                column: 12
              },
              end: {
                line: 60,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 55,
                column: 12
              },
              end: {
                line: 60,
                column: 13
              }
            }, {
              start: {
                line: 55,
                column: 12
              },
              end: {
                line: 60,
                column: 13
              }
            }],
            line: 55
          },
          23: {
            loc: {
              start: {
                line: 64,
                column: 8
              },
              end: {
                line: 83,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 64,
                column: 8
              },
              end: {
                line: 83,
                column: 9
              }
            }, {
              start: {
                line: 64,
                column: 8
              },
              end: {
                line: 83,
                column: 9
              }
            }],
            line: 64
          },
          24: {
            loc: {
              start: {
                line: 65,
                column: 12
              },
              end: {
                line: 70,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 65,
                column: 12
              },
              end: {
                line: 70,
                column: 13
              }
            }, {
              start: {
                line: 65,
                column: 12
              },
              end: {
                line: 70,
                column: 13
              }
            }],
            line: 65
          },
          25: {
            loc: {
              start: {
                line: 71,
                column: 12
              },
              end: {
                line: 76,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 71,
                column: 12
              },
              end: {
                line: 76,
                column: 13
              }
            }, {
              start: {
                line: 71,
                column: 12
              },
              end: {
                line: 76,
                column: 13
              }
            }],
            line: 71
          },
          26: {
            loc: {
              start: {
                line: 77,
                column: 12
              },
              end: {
                line: 82,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 77,
                column: 12
              },
              end: {
                line: 82,
                column: 13
              }
            }, {
              start: {
                line: 77,
                column: 12
              },
              end: {
                line: 82,
                column: 13
              }
            }],
            line: 77
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {
          0: [0],
          1: [0],
          2: [0],
          3: [0],
          4: [0],
          5: [0],
          6: [0],
          7: [0],
          8: [0],
          9: [0],
          10: [0],
          11: [0],
          12: [0],
          13: [0],
          14: [0],
          15: [0],
          16: [0, 0],
          17: [0, 0, 0, 0, 0],
          18: [0, 0],
          19: [0, 0],
          20: [0, 0],
          21: [0, 0],
          22: [0, 0],
          23: [0, 0],
          24: [0, 0],
          25: [0, 0],
          26: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/section-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\section-properties.ts"],
          names: [],
          mappings: ";;AAGA,wDAAmD;AAEnD,+CAA4C;AAE5C,kDAAmD;AAEnD,yDAAyD;AACzD,0EAAsE;AACtE,yDAAyD;AACzD,0EAAsE;AACtE,+CAAiE;AACjE,2DAAuD;AAEvD,+CAA4F;AAC5F,qDAAiD;AACjD,2EAAwF;AACxF,wDAAoD;AA8BpD,uBAA+B,SAAQ,6BAAY;IAG/C,YAAY,UAAoC,EAAE;QAC9C,KAAK,CAAC,UAAU,CAAC,CAAC;QAElB,MAAM,EACF,KAAK,GAAG,KAAK,EACb,MAAM,GAAG,KAAK,EACd,GAAG,GAAG,IAAI,EACV,KAAK,GAAG,IAAI,EACZ,MAAM,GAAG,IAAI,EACb,IAAI,GAAG,IAAI,EACX,MAAM,GAAG,GAAG,EACZ,MAAM,GAAG,GAAG,EACZ,MAAM,GAAG,CAAC,EACV,MAAM,GAAG,KAAK,EACd,KAAK,GAAG,GAAG,EACX,SAAS,GAAG,GAAG,EACf,WAAW,GAAG,sCAAe,CAAC,QAAQ,EACtC,OAAO,EACP,OAAO,EACP,oBAAoB,GAAG,8BAAgB,CAAC,OAAO,EAC/C,eAAe,EACf,WAAW,EACX,aAAa,EACb,eAAe,EACf,gBAAgB,EAChB,cAAc,EACd,SAAS,GAAG,KAAK,GACpB,GAAG,OAAO,CAAC;QAEZ,IAAI,CAAC,OAAO,GAAG,OAAO,CAAC;QACvB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAQ,CAAC,KAAK,EAAE,MAAM,EAAE,WAAW,CAAC,CAAC,CAAC;QACzD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,wBAAU,CAAC,GAAG,EAAE,KAAK,EAAE,MAAM,EAAE,IAAI,EAAE,MAAM,EAAE,MAAM,EAAE,MAAM,EAAE,MAAM,CAAC,CAAC,CAAC;QACzF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,KAAK,CAAC,CAAC,CAAC;QACnC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAY,CAAC,SAAS,CAAC,CAAC,CAAC;QAE5C,IAAI,CAAC,UAAU,CAAC,OAAO,CAAC,CAAC;QACzB,IAAI,CAAC,UAAU,CAAC,OAAO,CAAC,CAAC;QAEzB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,4BAAc,CAAC,eAAe,EAAE,oBAAoB,CAAC,CAAC,CAAC;QAE1E,IAAI,WAAW,IAAI,aAAa,IAAI,eAAe,IAAI,gBAAgB,IAAI,cAAc,EAAE;YACvF,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,yBAAW,CAAC;gBACZ,WAAW,EAAE,WAAW;gBACxB,aAAa,EAAE,aAAa;gBAC5B,eAAe,EAAE,eAAe;gBAChC,gBAAgB,EAAE,gBAAgB;gBAClC,cAAc,EAAE,cAAc;aACjC,CAAC,CACL,CAAC;SACL;QAED,IAAI,SAAS,EAAE;YACX,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,sBAAS,EAAE,CAAC,CAAC;SACnC;IACL,CAAC;IAEO,UAAU,CAAC,OAA2C;QAC1D,IAAI,OAAO,EAAE;YACT,IAAI,OAAO,CAAC,OAAO,EAAE;gBACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kCAAe,CAAC;oBAChB,UAAU,EAAE,sCAAmB,CAAC,OAAO;oBACvC,QAAQ,EAAE,OAAO,CAAC,OAAO,CAAC,MAAM,CAAC,WAAW;iBAC/C,CAAC,CACL,CAAC;aACL;YAED,IAAI,OAAO,CAAC,KAAK,EAAE;gBACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kCAAe,CAAC;oBAChB,UAAU,EAAE,sCAAmB,CAAC,KAAK;oBACrC,QAAQ,EAAE,OAAO,CAAC,KAAK,CAAC,MAAM,CAAC,WAAW;iBAC7C,CAAC,CACL,CAAC;aACL;YAED,IAAI,OAAO,CAAC,IAAI,EAAE;gBACd,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kCAAe,CAAC;oBAChB,UAAU,EAAE,sCAAmB,CAAC,IAAI;oBACpC,QAAQ,EAAE,OAAO,CAAC,IAAI,CAAC,MAAM,CAAC,WAAW;iBAC5C,CAAC,CACL,CAAC;aACL;SACJ;IACL,CAAC;IAEO,UAAU,CAAC,OAA2C;QAC1D,IAAI,OAAO,EAAE;YACT,IAAI,OAAO,CAAC,OAAO,EAAE;gBACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kCAAe,CAAC;oBAChB,UAAU,EAAE,sCAAmB,CAAC,OAAO;oBACvC,QAAQ,EAAE,OAAO,CAAC,OAAO,CAAC,MAAM,CAAC,WAAW;iBAC/C,CAAC,CACL,CAAC;aACL;YAED,IAAI,OAAO,CAAC,KAAK,EAAE;gBACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kCAAe,CAAC;oBAChB,UAAU,EAAE,sCAAmB,CAAC,KAAK;oBACrC,QAAQ,EAAE,OAAO,CAAC,KAAK,CAAC,MAAM,CAAC,WAAW;iBAC7C,CAAC,CACL,CAAC;aACL;YAED,IAAI,OAAO,CAAC,IAAI,EAAE;gBACd,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kCAAe,CAAC;oBAChB,UAAU,EAAE,sCAAmB,CAAC,IAAI;oBACpC,QAAQ,EAAE,OAAO,CAAC,IAAI,CAAC,MAAM,CAAC,WAAW;iBAC5C,CAAC,CACL,CAAC;aACL;SACJ;IACL,CAAC;IAED,IAAW,OAAO;QACd,OAAO,IAAI,CAAC,OAAO,CAAC;IACxB,CAAC;CACJ;AA7HD,8CA6HC",
          sourcesContent: ['// http://officeopenxml.com/WPsection.php\r\nimport { FooterWrapper } from "file/footer-wrapper";\r\nimport { HeaderWrapper } from "file/header-wrapper";\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nimport { Columns } from "./columns/columns";\r\nimport { IColumnsAttributes } from "./columns/columns-attributes";\r\nimport { DocumentGrid } from "./doc-grid/doc-grid";\r\nimport { IDocGridAttributesProperties } from "./doc-grid/doc-grid-attributes";\r\nimport { FooterReferenceType } from "./footer-reference";\r\nimport { FooterReference } from "./footer-reference/footer-reference";\r\nimport { HeaderReferenceType } from "./header-reference";\r\nimport { HeaderReference } from "./header-reference/header-reference";\r\nimport { IPageBordersOptions, PageBorders } from "./page-border";\r\nimport { PageMargin } from "./page-margin/page-margin";\r\nimport { IPageMarginAttributes } from "./page-margin/page-margin-attributes";\r\nimport { IPageNumberTypeAttributes, PageNumberFormat, PageNumberType } from "./page-number";\r\nimport { PageSize } from "./page-size/page-size";\r\nimport { IPageSizeAttributes, PageOrientation } from "./page-size/page-size-attributes";\r\nimport { TitlePage } from "./title-page/title-page";\r\n\r\nexport interface IHeaderFooterGroup<T> {\r\n    readonly default?: T;\r\n    readonly first?: T;\r\n    readonly even?: T;\r\n}\r\n\r\ninterface IHeadersOptions {\r\n    readonly headers?: IHeaderFooterGroup<HeaderWrapper>;\r\n}\r\n\r\ninterface IFootersOptions {\r\n    readonly footers?: IHeaderFooterGroup<FooterWrapper>;\r\n}\r\n\r\ninterface ITitlePageOptions {\r\n    readonly titlePage?: boolean;\r\n}\r\n\r\nexport type SectionPropertiesOptions = IPageSizeAttributes &\r\n    IPageMarginAttributes &\r\n    IColumnsAttributes &\r\n    IDocGridAttributesProperties &\r\n    IHeadersOptions &\r\n    IFootersOptions &\r\n    IPageNumberTypeAttributes &\r\n    IPageBordersOptions &\r\n    ITitlePageOptions;\r\n\r\nexport class SectionProperties extends XmlComponent {\r\n    private readonly options: SectionPropertiesOptions;\r\n\r\n    constructor(options: SectionPropertiesOptions = {}) {\r\n        super("w:sectPr");\r\n\r\n        const {\r\n            width = 11906,\r\n            height = 16838,\r\n            top = 1440,\r\n            right = 1440,\r\n            bottom = 1440,\r\n            left = 1440,\r\n            header = 708,\r\n            footer = 708,\r\n            gutter = 0,\r\n            mirror = false,\r\n            space = 708,\r\n            linePitch = 360,\r\n            orientation = PageOrientation.PORTRAIT,\r\n            headers,\r\n            footers,\r\n            pageNumberFormatType = PageNumberFormat.DECIMAL,\r\n            pageNumberStart,\r\n            pageBorders,\r\n            pageBorderTop,\r\n            pageBorderRight,\r\n            pageBorderBottom,\r\n            pageBorderLeft,\r\n            titlePage = false,\r\n        } = options;\r\n\r\n        this.options = options;\r\n        this.root.push(new PageSize(width, height, orientation));\r\n        this.root.push(new PageMargin(top, right, bottom, left, header, footer, gutter, mirror));\r\n        this.root.push(new Columns(space));\r\n        this.root.push(new DocumentGrid(linePitch));\r\n\r\n        this.addHeaders(headers);\r\n        this.addFooters(footers);\r\n\r\n        this.root.push(new PageNumberType(pageNumberStart, pageNumberFormatType));\r\n\r\n        if (pageBorders || pageBorderTop || pageBorderRight || pageBorderBottom || pageBorderLeft) {\r\n            this.root.push(\r\n                new PageBorders({\r\n                    pageBorders: pageBorders,\r\n                    pageBorderTop: pageBorderTop,\r\n                    pageBorderRight: pageBorderRight,\r\n                    pageBorderBottom: pageBorderBottom,\r\n                    pageBorderLeft: pageBorderLeft,\r\n                }),\r\n            );\r\n        }\r\n\r\n        if (titlePage) {\r\n            this.root.push(new TitlePage());\r\n        }\r\n    }\r\n\r\n    private addHeaders(headers?: IHeaderFooterGroup<HeaderWrapper>): void {\r\n        if (headers) {\r\n            if (headers.default) {\r\n                this.root.push(\r\n                    new HeaderReference({\r\n                        headerType: HeaderReferenceType.DEFAULT,\r\n                        headerId: headers.default.Header.ReferenceId,\r\n                    }),\r\n                );\r\n            }\r\n\r\n            if (headers.first) {\r\n                this.root.push(\r\n                    new HeaderReference({\r\n                        headerType: HeaderReferenceType.FIRST,\r\n                        headerId: headers.first.Header.ReferenceId,\r\n                    }),\r\n                );\r\n            }\r\n\r\n            if (headers.even) {\r\n                this.root.push(\r\n                    new HeaderReference({\r\n                        headerType: HeaderReferenceType.EVEN,\r\n                        headerId: headers.even.Header.ReferenceId,\r\n                    }),\r\n                );\r\n            }\r\n        }\r\n    }\r\n\r\n    private addFooters(footers?: IHeaderFooterGroup<FooterWrapper>): void {\r\n        if (footers) {\r\n            if (footers.default) {\r\n                this.root.push(\r\n                    new FooterReference({\r\n                        footerType: FooterReferenceType.DEFAULT,\r\n                        footerId: footers.default.Footer.ReferenceId,\r\n                    }),\r\n                );\r\n            }\r\n\r\n            if (footers.first) {\r\n                this.root.push(\r\n                    new FooterReference({\r\n                        footerType: FooterReferenceType.FIRST,\r\n                        footerId: footers.first.Footer.ReferenceId,\r\n                    }),\r\n                );\r\n            }\r\n\r\n            if (footers.even) {\r\n                this.root.push(\r\n                    new FooterReference({\r\n                        footerType: FooterReferenceType.EVEN,\r\n                        footerId: footers.even.Footer.ReferenceId,\r\n                    }),\r\n                );\r\n            }\r\n        }\r\n    }\r\n\r\n    public get Options(): SectionPropertiesOptions {\r\n        return this.options;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(241)),
          p = (a.s[3]++, t(243)),
          m = (a.s[4]++, t(89)),
          C = (a.s[5]++, t(90)),
          d = (a.s[6]++, t(92)),
          f = (a.s[7]++, t(93)),
          h = (a.s[8]++, t(95)),
          x = (a.s[9]++, t(246)),
          g = (a.s[10]++, t(96)),
          I = (a.s[11]++, t(97)),
          b = (a.s[12]++, t(41)),
          y = (a.s[13]++, t(249));

      var E =
      /*#__PURE__*/
      function (_c$XmlComponent64) {
        _inherits(E, _c$XmlComponent64);

        function E() {
          var _this108;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, {});

          _classCallCheck(this, E);

          a.f[0]++, a.s[14]++, _this108 = _possibleConstructorReturn(this, _getPrototypeOf(E).call(this, "w:sectPr"));

          var _ref = (a.s[15]++, e),
              _ref$width = _ref.width,
              n = _ref$width === void 0 ? (a.b[1][0]++, 11906) : _ref$width,
              _ref$height = _ref.height,
              t = _ref$height === void 0 ? (a.b[2][0]++, 16838) : _ref$height,
              _ref$top = _ref.top,
              r = _ref$top === void 0 ? (a.b[3][0]++, 1440) : _ref$top,
              _ref$right = _ref.right,
              o = _ref$right === void 0 ? (a.b[4][0]++, 1440) : _ref$right,
              _ref$bottom = _ref.bottom,
              i = _ref$bottom === void 0 ? (a.b[5][0]++, 1440) : _ref$bottom,
              _ref$left = _ref.left,
              A = _ref$left === void 0 ? (a.b[6][0]++, 1440) : _ref$left,
              _ref$header = _ref.header,
              s = _ref$header === void 0 ? (a.b[7][0]++, 708) : _ref$header,
              _ref$footer = _ref.footer,
              l = _ref$footer === void 0 ? (a.b[8][0]++, 708) : _ref$footer,
              _ref$gutter = _ref.gutter,
              c = _ref$gutter === void 0 ? (a.b[9][0]++, 0) : _ref$gutter,
              _ref$mirror = _ref.mirror,
              m = _ref$mirror === void 0 ? (a.b[10][0]++, !1) : _ref$mirror,
              _ref$space = _ref.space,
              C = _ref$space === void 0 ? (a.b[11][0]++, 708) : _ref$space,
              _ref$linePitch = _ref.linePitch,
              d = _ref$linePitch === void 0 ? (a.b[12][0]++, 360) : _ref$linePitch,
              _ref$orientation = _ref.orientation,
              f = _ref$orientation === void 0 ? (a.b[13][0]++, b.PageOrientation.PORTRAIT) : _ref$orientation,
              _E = _ref.headers,
              v = _ref.footers,
              _ref$pageNumberFormat = _ref.pageNumberFormatType,
              w = _ref$pageNumberFormat === void 0 ? (a.b[14][0]++, g.PageNumberFormat.DECIMAL) : _ref$pageNumberFormat,
              B = _ref.pageNumberStart,
              _ = _ref.pageBorders,
              D = _ref.pageBorderTop,
              S = _ref.pageBorderRight,
              M = _ref.pageBorderBottom,
              O = _ref.pageBorderLeft,
              _ref$titlePage = _ref.titlePage,
              k = _ref$titlePage === void 0 ? (a.b[15][0]++, !1) : _ref$titlePage;

          a.s[16]++, _this108.options = e, a.s[17]++, _this108.root.push(new I.PageSize(n, t, f)), a.s[18]++, _this108.root.push(new x.PageMargin(r, o, i, A, s, l, c, m)), a.s[19]++, _this108.root.push(new u.Columns(C)), a.s[20]++, _this108.root.push(new p.DocumentGrid(d)), a.s[21]++, _this108.addHeaders(_E), a.s[22]++, _this108.addFooters(v), a.s[23]++, _this108.root.push(new g.PageNumberType(B, w)), a.s[24]++, a.b[17][0]++, _ || (a.b[17][1]++, D) || (a.b[17][2]++, S) || (a.b[17][3]++, M) || (a.b[17][4]++, O) ? (a.b[16][0]++, a.s[25]++, _this108.root.push(new h.PageBorders({
            pageBorders: _,
            pageBorderTop: D,
            pageBorderRight: S,
            pageBorderBottom: M,
            pageBorderLeft: O
          }))) : a.b[16][1]++, a.s[26]++, k ? (a.b[18][0]++, a.s[27]++, _this108.root.push(new y.TitlePage())) : a.b[18][1]++;
          return _this108;
        }

        _createClass(E, [{
          key: "addHeaders",
          value: function addHeaders(e) {
            a.f[1]++, a.s[28]++, e ? (a.b[19][0]++, a.s[29]++, e.default ? (a.b[20][0]++, a.s[30]++, this.root.push(new f.HeaderReference({
              headerType: d.HeaderReferenceType.DEFAULT,
              headerId: e.default.Header.ReferenceId
            }))) : a.b[20][1]++, a.s[31]++, e.first ? (a.b[21][0]++, a.s[32]++, this.root.push(new f.HeaderReference({
              headerType: d.HeaderReferenceType.FIRST,
              headerId: e.first.Header.ReferenceId
            }))) : a.b[21][1]++, a.s[33]++, e.even ? (a.b[22][0]++, a.s[34]++, this.root.push(new f.HeaderReference({
              headerType: d.HeaderReferenceType.EVEN,
              headerId: e.even.Header.ReferenceId
            }))) : a.b[22][1]++) : a.b[19][1]++;
          }
        }, {
          key: "addFooters",
          value: function addFooters(e) {
            a.f[2]++, a.s[35]++, e ? (a.b[23][0]++, a.s[36]++, e.default ? (a.b[24][0]++, a.s[37]++, this.root.push(new C.FooterReference({
              footerType: m.FooterReferenceType.DEFAULT,
              footerId: e.default.Footer.ReferenceId
            }))) : a.b[24][1]++, a.s[38]++, e.first ? (a.b[25][0]++, a.s[39]++, this.root.push(new C.FooterReference({
              footerType: m.FooterReferenceType.FIRST,
              footerId: e.first.Footer.ReferenceId
            }))) : a.b[25][1]++, a.s[40]++, e.even ? (a.b[26][0]++, a.s[41]++, this.root.push(new C.FooterReference({
              footerType: m.FooterReferenceType.EVEN,
              footerId: e.even.Footer.ReferenceId
            }))) : a.b[26][1]++) : a.b[23][1]++;
          }
        }, {
          key: "Options",
          get: function get() {
            return a.f[3]++, a.s[42]++, this.options;
          }
        }]);

        return E;
      }(c.XmlComponent);

      a.s[43]++, n.SectionProperties = E;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\footer-reference\\index.ts", o = "720ba9a18c8e285b1d101b51f5a3dc2be784d52c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\footer-reference\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 40
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 51
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/footer-reference/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\footer-reference\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,wCAAmC;AACnC,mDAA8C",
          sourcesContent: ['export * from "./footer-reference";\r\nexport * from "./footer-reference-attributes";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(90)), a.s[5]++, c(t(91));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\footer-reference\\footer-reference.ts", o = "85068f6cac9506497b8ee712f1899a8c268fdebe", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\footer-reference\\footer-reference.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 38
            },
            end: {
              line: 4,
              column: 78
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 35
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 25
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 18
              },
              end: {
                line: 9,
                column: 97
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 18
              },
              end: {
                line: 9,
                column: 36
              }
            }, {
              start: {
                line: 9,
                column: 40
              },
              end: {
                line: 9,
                column: 97
              }
            }],
            line: 9
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/footer-reference/footer-reference.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\footer-reference\\footer-reference.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,+EAA+F;AAO/F,qBAA6B,SAAQ,6BAAY;IAC7C,YAAY,OAAuB;QAC/B,KAAK,CAAC,mBAAmB,CAAC,CAAC;QAE3B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,uDAAyB,CAAC;YAC1B,IAAI,EAAE,OAAO,CAAC,UAAU,IAAI,iDAAmB,CAAC,OAAO;YACvD,EAAE,EAAE,MAAM,OAAO,CAAC,QAAQ,EAAE;SAC/B,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,0CAWC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { FooterReferenceAttributes, FooterReferenceType } from "./footer-reference-attributes";\r\n\r\nexport interface IFooterOptions {\r\n    readonly footerType?: FooterReferenceType;\r\n    readonly footerId?: number;\r\n}\r\n\r\nexport class FooterReference extends XmlComponent {\r\n    constructor(options: IFooterOptions) {\r\n        super("w:footerReference");\r\n\r\n        this.root.push(\r\n            new FooterReferenceAttributes({\r\n                type: options.footerType || FooterReferenceType.DEFAULT,\r\n                id: `rId${options.footerId}`,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(91));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent65) {
        _inherits(p, _c$XmlComponent65);

        function p(e) {
          var _this109;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this109 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:footerReference")), a.s[4]++, _this109.root.push(new u.FooterReferenceAttributes({
            type: (a.b[0][0]++, e.footerType || (a.b[0][1]++, u.FooterReferenceType.DEFAULT)),
            id: "rId".concat(e.footerId)
          }));
          return _this109;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.FooterReference = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\footer-reference\\footer-reference-attributes.ts", o = "bcc818dd900d04aa0a5a717bd9251473dd5b70ab", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\footer-reference\\footer-reference-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 9,
              column: 92
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 47
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 43
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 41
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 28
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 16,
              column: 10
            }
          },
          8: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 62
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 32
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 25
              },
              end: {
                line: 9,
                column: 90
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 25
              },
              end: {
                line: 9,
                column: 52
              }
            }, {
              start: {
                line: 9,
                column: 57
              },
              end: {
                line: 9,
                column: 89
              }
            }],
            line: 9
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/footer-reference/footer-reference-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\footer-reference\\footer-reference-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAE5D,IAAY,mBAIX;AAJD,WAAY,mBAAmB;IAC3B,0CAAmB,CAAA;IACnB,sCAAe,CAAA;IACf,oCAAa,CAAA;AACjB,CAAC,EAJW,mBAAmB,GAAnB,2BAAmB,KAAnB,2BAAmB,QAI9B;AAOD,+BAAuC,SAAQ,sCAAiD;IAAhG;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,QAAQ;YACd,EAAE,EAAE,MAAM;SACb,CAAC;IACN,CAAC;CAAA;AALD,8DAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport enum FooterReferenceType {\r\n    DEFAULT = "default",\r\n    FIRST = "first",\r\n    EVEN = "even",\r\n}\r\n\r\nexport interface IFooterReferenceAttributes {\r\n    readonly type: string;\r\n    readonly id: string;\r\n}\r\n\r\nexport class FooterReferenceAttributes extends XmlAttributeComponent<IFooterReferenceAttributes> {\r\n    protected readonly xmlKeys = {\r\n        type: "w:type",\r\n        id: "r:id",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.DEFAULT = "default", a.s[4]++, e.FIRST = "first", a.s[5]++, e.EVEN = "even";
      }((a.b[0][0]++, n.FooterReferenceType || (a.b[0][1]++, n.FooterReferenceType = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon19) {
        _inherits(u, _c$XmlAttributeCompon19);

        function u() {
          var _this110;

          _classCallCheck(this, u);

          a.f[1]++, a.s[6]++, _this110 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[7]++, _this110.xmlKeys = {
            type: "w:type",
            id: "r:id"
          };
          return _this110;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[8]++, n.FooterReferenceAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\header-reference\\index.ts", o = "4f384e1611bbd0cc96e0e5499c540a450903fb38", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\header-reference\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 40
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 51
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/header-reference/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\header-reference\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,wCAAmC;AACnC,mDAA8C",
          sourcesContent: ['export * from "./header-reference";\r\nexport * from "./header-reference-attributes";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(93)), a.s[5]++, c(t(94));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\header-reference\\header-reference.ts", o = "b0b023fe8bfe56ab2bce10496bcbea80add71f7a", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\header-reference\\header-reference.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 38
            },
            end: {
              line: 4,
              column: 78
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 35
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 25
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 18
              },
              end: {
                line: 9,
                column: 97
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 18
              },
              end: {
                line: 9,
                column: 36
              }
            }, {
              start: {
                line: 9,
                column: 40
              },
              end: {
                line: 9,
                column: 97
              }
            }],
            line: 9
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/header-reference/header-reference.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\header-reference\\header-reference.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,+EAA+F;AAO/F,qBAA6B,SAAQ,6BAAY;IAC7C,YAAY,OAAuB;QAC/B,KAAK,CAAC,mBAAmB,CAAC,CAAC;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,uDAAyB,CAAC;YAC1B,IAAI,EAAE,OAAO,CAAC,UAAU,IAAI,iDAAmB,CAAC,OAAO;YACvD,EAAE,EAAE,MAAM,OAAO,CAAC,QAAQ,EAAE;SAC/B,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,0CAUC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { HeaderReferenceAttributes, HeaderReferenceType } from "./header-reference-attributes";\r\n\r\nexport interface IHeaderOptions {\r\n    readonly headerType?: HeaderReferenceType;\r\n    readonly headerId?: number;\r\n}\r\n\r\nexport class HeaderReference extends XmlComponent {\r\n    constructor(options: IHeaderOptions) {\r\n        super("w:headerReference");\r\n        this.root.push(\r\n            new HeaderReferenceAttributes({\r\n                type: options.headerType || HeaderReferenceType.DEFAULT,\r\n                id: `rId${options.headerId}`,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(94));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent66) {
        _inherits(p, _c$XmlComponent66);

        function p(e) {
          var _this111;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this111 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:headerReference")), a.s[4]++, _this111.root.push(new u.HeaderReferenceAttributes({
            type: (a.b[0][0]++, e.headerType || (a.b[0][1]++, u.HeaderReferenceType.DEFAULT)),
            id: "rId".concat(e.headerId)
          }));
          return _this111;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.HeaderReference = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\header-reference\\header-reference-attributes.ts", o = "3c89e17e4d90dab42898ba0a371e5af934867768", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\header-reference\\header-reference-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 9,
              column: 92
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 47
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 43
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 41
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 28
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 16,
              column: 10
            }
          },
          8: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 62
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 32
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 25
              },
              end: {
                line: 9,
                column: 90
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 25
              },
              end: {
                line: 9,
                column: 52
              }
            }, {
              start: {
                line: 9,
                column: 57
              },
              end: {
                line: 9,
                column: 89
              }
            }],
            line: 9
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/header-reference/header-reference-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\header-reference\\header-reference-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAE5D,IAAY,mBAIX;AAJD,WAAY,mBAAmB;IAC3B,0CAAmB,CAAA;IACnB,sCAAe,CAAA;IACf,oCAAa,CAAA;AACjB,CAAC,EAJW,mBAAmB,GAAnB,2BAAmB,KAAnB,2BAAmB,QAI9B;AAOD,+BAAuC,SAAQ,sCAAiD;IAAhG;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,QAAQ;YACd,EAAE,EAAE,MAAM;SACb,CAAC;IACN,CAAC;CAAA;AALD,8DAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport enum HeaderReferenceType {\r\n    DEFAULT = "default",\r\n    FIRST = "first",\r\n    EVEN = "even",\r\n}\r\n\r\nexport interface IHeaderReferenceAttributes {\r\n    readonly type: string;\r\n    readonly id: string;\r\n}\r\n\r\nexport class HeaderReferenceAttributes extends XmlAttributeComponent<IHeaderReferenceAttributes> {\r\n    protected readonly xmlKeys = {\r\n        type: "w:type",\r\n        id: "r:id",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.DEFAULT = "default", a.s[4]++, e.FIRST = "first", a.s[5]++, e.EVEN = "even";
      }((a.b[0][0]++, n.HeaderReferenceType || (a.b[0][1]++, n.HeaderReferenceType = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon20) {
        _inherits(u, _c$XmlAttributeCompon20);

        function u() {
          var _this112;

          _classCallCheck(this, u);

          a.f[1]++, a.s[6]++, _this112 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[7]++, _this112.xmlKeys = {
            type: "w:type",
            id: "r:id"
          };
          return _this112;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[8]++, n.HeaderReferenceAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-border\\index.ts", o = "1b9202ae3409336b9a38858f3b9a98d1de16e233", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-border\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-border/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-border\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,oCAA+B",
          sourcesContent: ['export * from "./page-borders";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(245));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-number\\index.ts", o = "9c4eab2eedb9cd6ffa71ef8116abe07bf51ccce9", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-number\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 35
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-number/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-number\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,mCAA8B",
          sourcesContent: ['export * from "./page-number";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(248));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-size\\page-size.ts", o = "a23161623fc8934ab9ca9631b82708a346b42fe2", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-size\\page-size.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 31
            },
            end: {
              line: 4,
              column: 64
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 24
            }
          },
          4: {
            start: {
              line: 8,
              column: 21
            },
            end: {
              line: 8,
              column: 85
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 13,
              column: 12
            }
          },
          6: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 44
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 10,
                column: 19
              },
              end: {
                line: 10,
                column: 40
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 10,
                column: 26
              },
              end: {
                line: 10,
                column: 32
              }
            }, {
              start: {
                line: 10,
                column: 35
              },
              end: {
                line: 10,
                column: 40
              }
            }],
            line: 10
          },
          1: {
            loc: {
              start: {
                line: 11,
                column: 20
              },
              end: {
                line: 11,
                column: 41
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 11,
                column: 27
              },
              end: {
                line: 11,
                column: 32
              }
            }, {
              start: {
                line: 11,
                column: 35
              },
              end: {
                line: 11,
                column: 41
              }
            }],
            line: 11
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-size/page-size.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-size\\page-size.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,iEAA6E;AAE7E,cAAsB,SAAQ,6BAAY;IACtC,YAAY,KAAa,EAAE,MAAc,EAAE,WAA4B;QACnE,KAAK,CAAC,QAAQ,CAAC,CAAC;QAEhB,MAAM,IAAI,GAAG,WAAW,KAAK,sCAAe,CAAC,SAAS,CAAC;QAEvD,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,yCAAkB,CAAC;YACnB,KAAK,EAAE,IAAI,CAAC,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,KAAK;YAC5B,MAAM,EAAE,IAAI,CAAC,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,MAAM;YAC7B,WAAW,EAAE,WAAW;SAC3B,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAdD,4BAcC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { PageOrientation, PageSizeAttributes } from "./page-size-attributes";\r\n\r\nexport class PageSize extends XmlComponent {\r\n    constructor(width: number, height: number, orientation: PageOrientation) {\r\n        super("w:pgSz");\r\n\r\n        const flip = orientation === PageOrientation.LANDSCAPE;\r\n\r\n        this.root.push(\r\n            new PageSizeAttributes({\r\n                width: flip ? height : width,\r\n                height: flip ? width : height,\r\n                orientation: orientation,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(41));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent67) {
        _inherits(p, _c$XmlComponent67);

        function p(e, n, t) {
          var _this113;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this113 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:pgSz"));
          var r = (a.s[4]++, t === u.PageOrientation.LANDSCAPE);
          a.s[5]++, _this113.root.push(new u.PageSizeAttributes({
            width: r ? (a.b[0][0]++, n) : (a.b[0][1]++, e),
            height: r ? (a.b[1][0]++, e) : (a.b[1][1]++, n),
            orientation: t
          }));
          return _this113;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.PageSize = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\index.ts", o = "38790ab735c259ccda363533f4331a6c75ceff41", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 42
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 40
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 40
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 33
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 35
            }
          },
          9: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 35
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,0CAAqC;AACrC,wCAAmC;AACnC,wCAAmC;AACnC,iCAA4B;AAC5B,mCAA8B;AAC9B,mCAA8B",
          sourcesContent: ['export * from "./section-properties";\r\nexport * from "./footer-reference";\r\nexport * from "./header-reference";\r\nexport * from "./page-size";\r\nexport * from "./page-number";\r\nexport * from "./page-border";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(88)), a.s[5]++, c(t(89)), a.s[6]++, c(t(92)), a.s[7]++, c(t(251)), a.s[8]++, c(t(96)), a.s[9]++, c(t(95));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footer-wrapper.ts", o = "63382383dd14ee5ed0010f0762d764ad5edabc97", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footer-wrapper.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 17
            },
            end: {
              line: 3,
              column: 43
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 5,
              column: 20
            },
            end: {
              line: 5,
              column: 42
            }
          },
          4: {
            start: {
              line: 6,
              column: 24
            },
            end: {
              line: 6,
              column: 50
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 27
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 68
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 65
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 44
            }
          },
          9: {
            start: {
              line: 17,
              column: 21
            },
            end: {
              line: 17,
              column: 52
            }
          },
          10: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 32
            }
          },
          11: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 20
            }
          },
          12: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 36
            }
          },
          13: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 51
            }
          },
          14: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 50
            }
          },
          15: {
            start: {
              line: 31,
              column: 26
            },
            end: {
              line: 31,
              column: 74
            }
          },
          16: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 177
            }
          },
          17: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 25
            }
          },
          18: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 154
            }
          },
          19: {
            start: {
              line: 39,
              column: 26
            },
            end: {
              line: 39,
              column: 111
            }
          },
          20: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 84
            }
          },
          21: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 50
            }
          },
          22: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 44,
              column: 20
            }
          },
          23: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 27
            }
          },
          24: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 34
            }
          },
          25: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 26
            }
          },
          26: {
            start: {
              line: 56,
              column: 0
            },
            end: {
              line: 56,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 49
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 28
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 13
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 26
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 16
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 20
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 21
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 24,
                column: 4
              },
              end: {
                line: 24,
                column: 5
              }
            },
            loc: {
              start: {
                line: 24,
                column: 28
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 24
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 34
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 27
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 54
              },
              end: {
                line: 34,
                column: 5
              }
            },
            line: 30
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 35,
                column: 4
              },
              end: {
                line: 35,
                column: 5
              }
            },
            loc: {
              start: {
                line: 35,
                column: 56
              },
              end: {
                line: 37,
                column: 5
              }
            },
            line: 35
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 38,
                column: 4
              },
              end: {
                line: 38,
                column: 5
              }
            },
            loc: {
              start: {
                line: 38,
                column: 38
              },
              end: {
                line: 41,
                column: 5
              }
            },
            line: 38
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 42,
                column: 4
              },
              end: {
                line: 42,
                column: 5
              }
            },
            loc: {
              start: {
                line: 42,
                column: 20
              },
              end: {
                line: 45,
                column: 5
              }
            },
            line: 42
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 46,
                column: 4
              },
              end: {
                line: 46,
                column: 5
              }
            },
            loc: {
              start: {
                line: 46,
                column: 17
              },
              end: {
                line: 48,
                column: 5
              }
            },
            line: 46
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 49,
                column: 4
              },
              end: {
                line: 49,
                column: 5
              }
            },
            loc: {
              start: {
                line: 49,
                column: 24
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 49
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 52,
                column: 4
              },
              end: {
                line: 52,
                column: 5
              }
            },
            loc: {
              start: {
                line: 52,
                column: 16
              },
              end: {
                line: 54,
                column: 5
              }
            },
            line: 52
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footer-wrapper.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footer-wrapper.ts"],
          names: [],
          mappings: ";;AAGA,4CAAyC;AACzC,mCAAmD;AACnD,2CAAwD;AACxD,mDAAgD;AAQhD;IAII,YAA6B,KAAY,EAAE,WAAmB,EAAE,WAA0B;QAA7D,UAAK,GAAL,KAAK,CAAO;QACrC,IAAI,CAAC,MAAM,GAAG,IAAI,eAAM,CAAC,WAAW,EAAE,WAAW,CAAC,CAAC;QACnD,IAAI,CAAC,aAAa,GAAG,IAAI,6BAAa,EAAE,CAAC;IAC7C,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,IAAI,CAAC,MAAM,CAAC,YAAY,CAAC,SAAS,CAAC,CAAC;IACxC,CAAC;IAEM,eAAe,CAAC,IAAa;QAChC,MAAM,IAAI,GAAG,IAAI,qBAAS,CAAC,IAAI,CAAC,CAAC;QACjC,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,CAAC;QACxB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,MAAM,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;IAChC,CAAC;IAEM,WAAW,CAAC,IAAY,EAAE,IAAY;QACzC,OAAO,IAAI,CAAC,MAAM,CAAC,WAAW,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;IAC/C,CAAC;IAEM,eAAe,CAAC,YAA0B;QAC7C,IAAI,CAAC,MAAM,CAAC,eAAe,CAAC,YAAY,CAAC,CAAC;IAC9C,CAAC;IAEM,oBAAoB,CAAC,KAAa,EAAE,KAAa,EAAE,KAAc,EAAE,MAAe;QACrF,MAAM,SAAS,GAAG,IAAI,CAAC,KAAK,CAAC,QAAQ,CAAC,KAAK,EAAE,KAAK,EAAE,KAAK,EAAE,MAAM,CAAC,CAAC;QACnE,IAAI,CAAC,aAAa,CAAC,kBAAkB,CACjC,SAAS,CAAC,WAAW,EACrB,2EAA2E,EAC3E,SAAS,SAAS,CAAC,QAAQ,EAAE,CAChC,CAAC;QACF,OAAO,SAAS,CAAC;IACrB,CAAC;IAEM,wBAAwB,CAAC,MAAc,EAAE,KAAa,EAAE,UAAmC;QAC9F,IAAI,CAAC,aAAa,CAAC,kBAAkB,CACjC,KAAK,EACL,+EAA+E,EAC/E,MAAM,EACN,UAAU,CACb,CAAC;IACN,CAAC;IAEM,WAAW,CAAC,KAAiD,EAAE,KAAc,EAAE,MAAe;QAGjG,MAAM,SAAS,GAAG,IAAI,CAAC,oBAAoB,CAAC,KAAY,EAAE,IAAI,CAAC,aAAa,CAAC,iBAAiB,EAAE,KAAK,EAAE,MAAM,CAAC,CAAC;QAC/G,IAAI,CAAC,QAAQ,CAAC,IAAI,aAAK,CAAC,IAAI,0BAAc,CAAC,SAAS,CAAC,CAAC,CAAC,CAAC;IAC5D,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,MAAM,CAAC,YAAY,CAAC,KAAK,CAAC,SAAS,CAAC,CAAC;QAC1C,OAAO,IAAI,CAAC;IAChB,CAAC;IAED,IAAW,MAAM;QACb,OAAO,IAAI,CAAC,MAAM,CAAC;IACvB,CAAC;IAED,IAAW,aAAa;QACpB,OAAO,IAAI,CAAC,aAAa,CAAC;IAC9B,CAAC;IAED,IAAW,KAAK;QACZ,OAAO,IAAI,CAAC,KAAK,CAAC;IACtB,CAAC;CACJ;AAzED,sCAyEC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nimport { FooterReferenceType } from "./document";\r\nimport { Footer } from "./footer/footer";\r\nimport { Image, IMediaData, Media } from "./media";\r\nimport { ImageParagraph, Paragraph } from "./paragraph";\r\nimport { Relationships } from "./relationships";\r\nimport { Table } from "./table";\r\n\r\nexport interface IDocumentFooter {\r\n    readonly footer: FooterWrapper;\r\n    readonly type: FooterReferenceType;\r\n}\r\n\r\nexport class FooterWrapper {\r\n    private readonly footer: Footer;\r\n    private readonly relationships: Relationships;\r\n\r\n    constructor(private readonly media: Media, referenceId: number, initContent?: XmlComponent) {\r\n        this.footer = new Footer(referenceId, initContent);\r\n        this.relationships = new Relationships();\r\n    }\r\n\r\n    public addParagraph(paragraph: Paragraph): void {\r\n        this.footer.addParagraph(paragraph);\r\n    }\r\n\r\n    public createParagraph(text?: string): Paragraph {\r\n        const para = new Paragraph(text);\r\n        this.addParagraph(para);\r\n        return para;\r\n    }\r\n\r\n    public addTable(table: Table): void {\r\n        this.footer.addTable(table);\r\n    }\r\n\r\n    public createTable(rows: number, cols: number): Table {\r\n        return this.footer.createTable(rows, cols);\r\n    }\r\n\r\n    public addChildElement(childElement: XmlComponent): void {\r\n        this.footer.addChildElement(childElement);\r\n    }\r\n\r\n    public addImageRelationship(image: Buffer, refId: number, width?: number, height?: number): IMediaData {\r\n        const mediaData = this.media.addMedia(image, refId, width, height);\r\n        this.relationships.createRelationship(\r\n            mediaData.referenceId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",\r\n            `media/${mediaData.fileName}`,\r\n        );\r\n        return mediaData;\r\n    }\r\n\r\n    public addHyperlinkRelationship(target: string, refId: number, targetMode?: "External" | undefined): void {\r\n        this.relationships.createRelationship(\r\n            refId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",\r\n            target,\r\n            targetMode,\r\n        );\r\n    }\r\n\r\n    public createImage(image: Buffer | string | Uint8Array | ArrayBuffer, width?: number, height?: number): void {\r\n        // TODO\r\n        // tslint:disable-next-line:no-any\r\n        const mediaData = this.addImageRelationship(image as any, this.relationships.RelationshipCount, width, height);\r\n        this.addImage(new Image(new ImageParagraph(mediaData)));\r\n    }\r\n\r\n    public addImage(image: Image): FooterWrapper {\r\n        this.footer.addParagraph(image.Paragraph);\r\n        return this;\r\n    }\r\n\r\n    public get Footer(): Footer {\r\n        return this.footer;\r\n    }\r\n\r\n    public get Relationships(): Relationships {\r\n        return this.relationships;\r\n    }\r\n\r\n    public get Media(): Media {\r\n        return this.media;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(252)),
          u = (a.s[2]++, t(16)),
          p = (a.s[3]++, t(2)),
          m = (a.s[4]++, t(42));
      a.s[26]++, n.FooterWrapper =
      /*#__PURE__*/
      function () {
        function _class27(e, n, t) {
          _classCallCheck(this, _class27);

          a.f[0]++, a.s[5]++, this.media = e, a.s[6]++, this.footer = new c.Footer(n, t), a.s[7]++, this.relationships = new m.Relationships();
        }

        _createClass(_class27, [{
          key: "addParagraph",
          value: function addParagraph(e) {
            a.f[1]++, a.s[8]++, this.footer.addParagraph(e);
          }
        }, {
          key: "createParagraph",
          value: function createParagraph(e) {
            a.f[2]++;
            var n = (a.s[9]++, new p.Paragraph(e));
            return a.s[10]++, this.addParagraph(n), a.s[11]++, n;
          }
        }, {
          key: "addTable",
          value: function addTable(e) {
            a.f[3]++, a.s[12]++, this.footer.addTable(e);
          }
        }, {
          key: "createTable",
          value: function createTable(e, n) {
            return a.f[4]++, a.s[13]++, this.footer.createTable(e, n);
          }
        }, {
          key: "addChildElement",
          value: function addChildElement(e) {
            a.f[5]++, a.s[14]++, this.footer.addChildElement(e);
          }
        }, {
          key: "addImageRelationship",
          value: function addImageRelationship(e, n, t, r) {
            a.f[6]++;
            var o = (a.s[15]++, this.media.addMedia(e, n, t, r));
            return a.s[16]++, this.relationships.createRelationship(o.referenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", "media/".concat(o.fileName)), a.s[17]++, o;
          }
        }, {
          key: "addHyperlinkRelationship",
          value: function addHyperlinkRelationship(e, n, t) {
            a.f[7]++, a.s[18]++, this.relationships.createRelationship(n, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", e, t);
          }
        }, {
          key: "createImage",
          value: function createImage(e, n, t) {
            a.f[8]++;
            var r = (a.s[19]++, this.addImageRelationship(e, this.relationships.RelationshipCount, n, t));
            a.s[20]++, this.addImage(new u.Image(new p.ImageParagraph(r)));
          }
        }, {
          key: "addImage",
          value: function addImage(e) {
            return a.f[9]++, a.s[21]++, this.footer.addParagraph(e.Paragraph), a.s[22]++, this;
          }
        }, {
          key: "Footer",
          get: function get() {
            return a.f[10]++, a.s[23]++, this.footer;
          }
        }, {
          key: "Relationships",
          get: function get() {
            return a.f[11]++, a.s[24]++, this.relationships;
          }
        }, {
          key: "Media",
          get: function get() {
            return a.f[12]++, a.s[25]++, this.media;
          }
        }]);

        return _class27;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\image.ts", o = "89f6a26142cb6d66c934099180788bd2ad2cd279", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\image.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 5,
              column: 8
            },
            end: {
              line: 5,
              column: 35
            }
          },
          2: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 30
            }
          },
          3: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 34
            }
          },
          4: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 51
            }
          },
          5: {
            start: {
              line: 17,
              column: 0
            },
            end: {
              line: 17,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 4
              },
              end: {
                line: 4,
                column: 5
              }
            },
            loc: {
              start: {
                line: 4,
                column: 27
              },
              end: {
                line: 6,
                column: 5
              }
            },
            line: 4
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 20
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 7
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 14
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 10
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 28
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 13
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/media/image.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\media\\image.ts"],
          names: [],
          mappings: ";;AAEA;IACI,YAA6B,SAAyB;QAAzB,cAAS,GAAT,SAAS,CAAgB;IAAG,CAAC;IAE1D,IAAW,SAAS;QAChB,OAAO,IAAI,CAAC,SAAS,CAAC;IAC1B,CAAC;IAED,IAAW,GAAG;QACV,OAAO,IAAI,CAAC,SAAS,CAAC,GAAG,CAAC;IAC9B,CAAC;IAEM,KAAK,CAAC,OAAe,EAAE,OAAgB;QAC1C,IAAI,CAAC,SAAS,CAAC,GAAG,CAAC,KAAK,CAAC,OAAO,EAAE,OAAO,CAAC,CAAC;IAC/C,CAAC;CACJ;AAdD,sBAcC",
          sourcesContent: ['import { ImageParagraph, PictureRun } from "../paragraph";\r\n\r\nexport class Image {\r\n    constructor(private readonly paragraph: ImageParagraph) {}\r\n\r\n    public get Paragraph(): ImageParagraph {\r\n        return this.paragraph;\r\n    }\r\n\r\n    public get Run(): PictureRun {\r\n        return this.paragraph.Run;\r\n    }\r\n\r\n    public scale(factorX: number, factorY?: number): void {\r\n        this.paragraph.Run.scale(factorX, factorY);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[5]++, n.Image =
      /*#__PURE__*/
      function () {
        function _class28(e) {
          _classCallCheck(this, _class28);

          a.f[0]++, a.s[1]++, this.paragraph = e;
        }

        _createClass(_class28, [{
          key: "scale",
          value: function scale(e, n) {
            a.f[3]++, a.s[4]++, this.paragraph.Run.scale(e, n);
          }
        }, {
          key: "Paragraph",
          get: function get() {
            return a.f[1]++, a.s[2]++, this.paragraph;
          }
        }, {
          key: "Run",
          get: function get() {
            return a.f[2]++, a.s[3]++, this.paragraph.Run;
          }
        }]);

        return _class28;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\header-wrapper.ts", o = "5a41314f42d8e87a9d688f30917c0a64fb9ac9af", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\header-wrapper.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 17
            },
            end: {
              line: 3,
              column: 43
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 5,
              column: 20
            },
            end: {
              line: 5,
              column: 42
            }
          },
          4: {
            start: {
              line: 6,
              column: 24
            },
            end: {
              line: 6,
              column: 50
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 27
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 68
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 65
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 44
            }
          },
          9: {
            start: {
              line: 17,
              column: 21
            },
            end: {
              line: 17,
              column: 52
            }
          },
          10: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 32
            }
          },
          11: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 20
            }
          },
          12: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 36
            }
          },
          13: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 51
            }
          },
          14: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 50
            }
          },
          15: {
            start: {
              line: 31,
              column: 26
            },
            end: {
              line: 31,
              column: 74
            }
          },
          16: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 177
            }
          },
          17: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 25
            }
          },
          18: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 154
            }
          },
          19: {
            start: {
              line: 39,
              column: 26
            },
            end: {
              line: 39,
              column: 111
            }
          },
          20: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 84
            }
          },
          21: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 50
            }
          },
          22: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 44,
              column: 20
            }
          },
          23: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 27
            }
          },
          24: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 34
            }
          },
          25: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 26
            }
          },
          26: {
            start: {
              line: 56,
              column: 0
            },
            end: {
              line: 56,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 49
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 28
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 13
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 26
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 16
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 20
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 21
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 24,
                column: 4
              },
              end: {
                line: 24,
                column: 5
              }
            },
            loc: {
              start: {
                line: 24,
                column: 28
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 24
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 34
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 27
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 54
              },
              end: {
                line: 34,
                column: 5
              }
            },
            line: 30
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 35,
                column: 4
              },
              end: {
                line: 35,
                column: 5
              }
            },
            loc: {
              start: {
                line: 35,
                column: 56
              },
              end: {
                line: 37,
                column: 5
              }
            },
            line: 35
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 38,
                column: 4
              },
              end: {
                line: 38,
                column: 5
              }
            },
            loc: {
              start: {
                line: 38,
                column: 38
              },
              end: {
                line: 41,
                column: 5
              }
            },
            line: 38
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 42,
                column: 4
              },
              end: {
                line: 42,
                column: 5
              }
            },
            loc: {
              start: {
                line: 42,
                column: 20
              },
              end: {
                line: 45,
                column: 5
              }
            },
            line: 42
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 46,
                column: 4
              },
              end: {
                line: 46,
                column: 5
              }
            },
            loc: {
              start: {
                line: 46,
                column: 17
              },
              end: {
                line: 48,
                column: 5
              }
            },
            line: 46
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 49,
                column: 4
              },
              end: {
                line: 49,
                column: 5
              }
            },
            loc: {
              start: {
                line: 49,
                column: 24
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 49
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 52,
                column: 4
              },
              end: {
                line: 52,
                column: 5
              }
            },
            loc: {
              start: {
                line: 52,
                column: 16
              },
              end: {
                line: 54,
                column: 5
              }
            },
            line: 52
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/header-wrapper.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\header-wrapper.ts"],
          names: [],
          mappings: ";;AAGA,4CAAyC;AACzC,mCAAmD;AACnD,2CAAwD;AACxD,mDAAgD;AAQhD;IAII,YAA6B,KAAY,EAAE,WAAmB,EAAE,WAA0B;QAA7D,UAAK,GAAL,KAAK,CAAO;QACrC,IAAI,CAAC,MAAM,GAAG,IAAI,eAAM,CAAC,WAAW,EAAE,WAAW,CAAC,CAAC;QACnD,IAAI,CAAC,aAAa,GAAG,IAAI,6BAAa,EAAE,CAAC;IAC7C,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,IAAI,CAAC,MAAM,CAAC,YAAY,CAAC,SAAS,CAAC,CAAC;IACxC,CAAC;IAEM,eAAe,CAAC,IAAa;QAChC,MAAM,IAAI,GAAG,IAAI,qBAAS,CAAC,IAAI,CAAC,CAAC;QACjC,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,CAAC;QACxB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,MAAM,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;IAChC,CAAC;IAEM,WAAW,CAAC,IAAY,EAAE,IAAY;QACzC,OAAO,IAAI,CAAC,MAAM,CAAC,WAAW,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;IAC/C,CAAC;IAEM,eAAe,CAAC,YAAmC;QACtD,IAAI,CAAC,MAAM,CAAC,eAAe,CAAC,YAAY,CAAC,CAAC;IAC9C,CAAC;IAEM,oBAAoB,CAAC,KAAa,EAAE,KAAa,EAAE,KAAc,EAAE,MAAe;QACrF,MAAM,SAAS,GAAG,IAAI,CAAC,KAAK,CAAC,QAAQ,CAAC,KAAK,EAAE,KAAK,EAAE,KAAK,EAAE,MAAM,CAAC,CAAC;QACnE,IAAI,CAAC,aAAa,CAAC,kBAAkB,CACjC,SAAS,CAAC,WAAW,EACrB,2EAA2E,EAC3E,SAAS,SAAS,CAAC,QAAQ,EAAE,CAChC,CAAC;QACF,OAAO,SAAS,CAAC;IACrB,CAAC;IAEM,wBAAwB,CAAC,MAAc,EAAE,KAAa,EAAE,UAAmC;QAC9F,IAAI,CAAC,aAAa,CAAC,kBAAkB,CACjC,KAAK,EACL,+EAA+E,EAC/E,MAAM,EACN,UAAU,CACb,CAAC;IACN,CAAC;IAEM,WAAW,CAAC,KAAiD,EAAE,KAAc,EAAE,MAAe;QAGjG,MAAM,SAAS,GAAG,IAAI,CAAC,oBAAoB,CAAC,KAAY,EAAE,IAAI,CAAC,aAAa,CAAC,iBAAiB,EAAE,KAAK,EAAE,MAAM,CAAC,CAAC;QAC/G,IAAI,CAAC,QAAQ,CAAC,IAAI,aAAK,CAAC,IAAI,0BAAc,CAAC,SAAS,CAAC,CAAC,CAAC,CAAC;IAC5D,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,MAAM,CAAC,YAAY,CAAC,KAAK,CAAC,SAAS,CAAC,CAAC;QAC1C,OAAO,IAAI,CAAC;IAChB,CAAC;IAED,IAAW,MAAM;QACb,OAAO,IAAI,CAAC,MAAM,CAAC;IACvB,CAAC;IAED,IAAW,aAAa;QACpB,OAAO,IAAI,CAAC,aAAa,CAAC;IAC9B,CAAC;IAED,IAAW,KAAK;QACZ,OAAO,IAAI,CAAC,KAAK,CAAC;IACtB,CAAC;CACJ;AAzED,sCAyEC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nimport { HeaderReferenceType } from "./document";\r\nimport { Header } from "./header/header";\r\nimport { Image, IMediaData, Media } from "./media";\r\nimport { ImageParagraph, Paragraph } from "./paragraph";\r\nimport { Relationships } from "./relationships";\r\nimport { Table } from "./table";\r\n\r\nexport interface IDocumentHeader {\r\n    readonly header: HeaderWrapper;\r\n    readonly type: HeaderReferenceType;\r\n}\r\n\r\nexport class HeaderWrapper {\r\n    private readonly header: Header;\r\n    private readonly relationships: Relationships;\r\n\r\n    constructor(private readonly media: Media, referenceId: number, initContent?: XmlComponent) {\r\n        this.header = new Header(referenceId, initContent);\r\n        this.relationships = new Relationships();\r\n    }\r\n\r\n    public addParagraph(paragraph: Paragraph): void {\r\n        this.header.addParagraph(paragraph);\r\n    }\r\n\r\n    public createParagraph(text?: string): Paragraph {\r\n        const para = new Paragraph(text);\r\n        this.addParagraph(para);\r\n        return para;\r\n    }\r\n\r\n    public addTable(table: Table): void {\r\n        this.header.addTable(table);\r\n    }\r\n\r\n    public createTable(rows: number, cols: number): Table {\r\n        return this.header.createTable(rows, cols);\r\n    }\r\n\r\n    public addChildElement(childElement: XmlComponent | string): void {\r\n        this.header.addChildElement(childElement);\r\n    }\r\n\r\n    public addImageRelationship(image: Buffer, refId: number, width?: number, height?: number): IMediaData {\r\n        const mediaData = this.media.addMedia(image, refId, width, height);\r\n        this.relationships.createRelationship(\r\n            mediaData.referenceId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",\r\n            `media/${mediaData.fileName}`,\r\n        );\r\n        return mediaData;\r\n    }\r\n\r\n    public addHyperlinkRelationship(target: string, refId: number, targetMode?: "External" | undefined): void {\r\n        this.relationships.createRelationship(\r\n            refId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",\r\n            target,\r\n            targetMode,\r\n        );\r\n    }\r\n\r\n    public createImage(image: Buffer | string | Uint8Array | ArrayBuffer, width?: number, height?: number): void {\r\n        // TODO\r\n        // tslint:disable-next-line:no-any\r\n        const mediaData = this.addImageRelationship(image as any, this.relationships.RelationshipCount, width, height);\r\n        this.addImage(new Image(new ImageParagraph(mediaData)));\r\n    }\r\n\r\n    public addImage(image: Image): HeaderWrapper {\r\n        this.header.addParagraph(image.Paragraph);\r\n        return this;\r\n    }\r\n\r\n    public get Header(): Header {\r\n        return this.header;\r\n    }\r\n\r\n    public get Relationships(): Relationships {\r\n        return this.relationships;\r\n    }\r\n\r\n    public get Media(): Media {\r\n        return this.media;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(271)),
          u = (a.s[2]++, t(16)),
          p = (a.s[3]++, t(2)),
          m = (a.s[4]++, t(42));
      a.s[26]++, n.HeaderWrapper =
      /*#__PURE__*/
      function () {
        function _class29(e, n, t) {
          _classCallCheck(this, _class29);

          a.f[0]++, a.s[5]++, this.media = e, a.s[6]++, this.header = new c.Header(n, t), a.s[7]++, this.relationships = new m.Relationships();
        }

        _createClass(_class29, [{
          key: "addParagraph",
          value: function addParagraph(e) {
            a.f[1]++, a.s[8]++, this.header.addParagraph(e);
          }
        }, {
          key: "createParagraph",
          value: function createParagraph(e) {
            a.f[2]++;
            var n = (a.s[9]++, new p.Paragraph(e));
            return a.s[10]++, this.addParagraph(n), a.s[11]++, n;
          }
        }, {
          key: "addTable",
          value: function addTable(e) {
            a.f[3]++, a.s[12]++, this.header.addTable(e);
          }
        }, {
          key: "createTable",
          value: function createTable(e, n) {
            return a.f[4]++, a.s[13]++, this.header.createTable(e, n);
          }
        }, {
          key: "addChildElement",
          value: function addChildElement(e) {
            a.f[5]++, a.s[14]++, this.header.addChildElement(e);
          }
        }, {
          key: "addImageRelationship",
          value: function addImageRelationship(e, n, t, r) {
            a.f[6]++;
            var o = (a.s[15]++, this.media.addMedia(e, n, t, r));
            return a.s[16]++, this.relationships.createRelationship(o.referenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", "media/".concat(o.fileName)), a.s[17]++, o;
          }
        }, {
          key: "addHyperlinkRelationship",
          value: function addHyperlinkRelationship(e, n, t) {
            a.f[7]++, a.s[18]++, this.relationships.createRelationship(n, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", e, t);
          }
        }, {
          key: "createImage",
          value: function createImage(e, n, t) {
            a.f[8]++;
            var r = (a.s[19]++, this.addImageRelationship(e, this.relationships.RelationshipCount, n, t));
            a.s[20]++, this.addImage(new u.Image(new p.ImageParagraph(r)));
          }
        }, {
          key: "addImage",
          value: function addImage(e) {
            return a.f[9]++, a.s[21]++, this.header.addParagraph(e.Paragraph), a.s[22]++, this;
          }
        }, {
          key: "Header",
          get: function get() {
            return a.f[10]++, a.s[23]++, this.header;
          }
        }, {
          key: "Relationships",
          get: function get() {
            return a.f[11]++, a.s[24]++, this.relationships;
          }
        }, {
          key: "Media",
          get: function get() {
            return a.f[12]++, a.s[25]++, this.media;
          }
        }]);

        return _class29;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\index.ts", o = "9810895a1dae685c1d1004f894427d3600756db4", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 33
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 42
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 29
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/numbering/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\numbering\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,iCAA4B;AAC5B,0CAAqC;AACrC,6BAAwB",
          sourcesContent: ['export * from "./numbering";\r\nexport * from "./abstract-numbering";\r\nexport * from "./level";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(273)), a.s[5]++, c(t(103)), a.s[6]++, c(t(43));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\abstract-numbering.ts", o = "4baa71aa4a01b8d25509d6e6f04dc4f961545efd", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\abstract-numbering.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 5,
              column: 27
            },
            end: {
              line: 5,
              column: 56
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 28
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 12,
              column: 10
            }
          },
          6: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 31
            }
          },
          7: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 21,
              column: 12
            }
          },
          8: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 82
            }
          },
          9: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 21
            }
          },
          10: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 30
            }
          },
          11: {
            start: {
              line: 29,
              column: 22
            },
            end: {
              line: 29,
              column: 65
            }
          },
          12: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 29
            }
          },
          13: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 21
            }
          },
          14: {
            start: {
              line: 34,
              column: 0
            },
            end: {
              line: 34,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 20
              },
              end: {
                line: 24,
                column: 5
              }
            },
            line: 16
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 25,
                column: 4
              },
              end: {
                line: 25,
                column: 5
              }
            },
            loc: {
              start: {
                line: 25,
                column: 20
              },
              end: {
                line: 27,
                column: 5
              }
            },
            line: 25
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 28,
                column: 4
              },
              end: {
                line: 28,
                column: 5
              }
            },
            loc: {
              start: {
                line: 28,
                column: 52
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 28
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 28,
                column: 35
              },
              end: {
                line: 28,
                column: 50
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 28,
                column: 43
              },
              end: {
                line: 28,
                column: 50
              }
            }],
            line: 28
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {
          0: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/numbering/abstract-numbering.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\numbering\\abstract-numbering.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAC1E,mCAAgC;AAChC,yDAAoD;AAOpD,iCAAkC,SAAQ,sCAA6D;IAAvG;;QACuB,YAAO,GAAG;YACzB,aAAa,EAAE,iBAAiB;YAChC,0BAA0B,EAAE,gCAAgC;SAC/D,CAAC;IACN,CAAC;CAAA;AAED,uBAA+B,SAAQ,6BAAY;IAG/C,YAAY,EAAU;QAClB,KAAK,CAAC,eAAe,CAAC,CAAC;QACvB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAA2B,CAAC;YAC5B,aAAa,EAAE,EAAE;YACjB,0BAA0B,EAAE,CAAC;SAChC,CAAC,CACL,CAAC;QACF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iCAAc,CAAC,kBAAkB,CAAC,CAAC,CAAC;QACvD,IAAI,CAAC,EAAE,GAAG,EAAE,CAAC;IACjB,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;IAEM,WAAW,CAAC,GAAW,EAAE,MAAc,EAAE,IAAY,EAAE,QAAgB,OAAO;QACjF,MAAM,KAAK,GAAG,IAAI,aAAK,CAAC,GAAG,EAAE,MAAM,EAAE,IAAI,EAAE,KAAK,CAAC,CAAC;QAClD,IAAI,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;QACrB,OAAO,KAAK,CAAC;IACjB,CAAC;CACJ;AAxBD,8CAwBC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport { Level } from "./level";\r\nimport { MultiLevelType } from "./multi-level-type";\r\n\r\ninterface IAbstractNumberingAttributesProperties {\r\n    readonly abstractNumId?: number;\r\n    readonly restartNumberingAfterBreak?: number;\r\n}\r\n\r\nclass AbstractNumberingAttributes extends XmlAttributeComponent<IAbstractNumberingAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        abstractNumId: "w:abstractNumId",\r\n        restartNumberingAfterBreak: "w15:restartNumberingAfterBreak",\r\n    };\r\n}\r\n\r\nexport class AbstractNumbering extends XmlComponent {\r\n    public readonly id: number;\r\n\r\n    constructor(id: number) {\r\n        super("w:abstractNum");\r\n        this.root.push(\r\n            new AbstractNumberingAttributes({\r\n                abstractNumId: id,\r\n                restartNumberingAfterBreak: 0,\r\n            }),\r\n        );\r\n        this.root.push(new MultiLevelType("hybridMultilevel"));\r\n        this.id = id;\r\n    }\r\n\r\n    public addLevel(level: Level): void {\r\n        this.root.push(level);\r\n    }\r\n\r\n    public createLevel(num: number, format: string, text: string, align: string = "start"): Level {\r\n        const level = new Level(num, format, text, align);\r\n        this.addLevel(level);\r\n        return level;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(43)),
          p = (a.s[3]++, t(274));

      var m =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon21) {
        _inherits(m, _c$XmlAttributeCompon21);

        function m() {
          var _this114;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this114 = _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments)), a.s[5]++, _this114.xmlKeys = {
            abstractNumId: "w:abstractNumId",
            restartNumberingAfterBreak: "w15:restartNumberingAfterBreak"
          };
          return _this114;
        }

        return m;
      }(c.XmlAttributeComponent);

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent68) {
        _inherits(C, _c$XmlComponent68);

        function C(e) {
          var _this115;

          _classCallCheck(this, C);

          a.f[1]++, a.s[6]++, _this115 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:abstractNum")), a.s[7]++, _this115.root.push(new m({
            abstractNumId: e,
            restartNumberingAfterBreak: 0
          })), a.s[8]++, _this115.root.push(new p.MultiLevelType("hybridMultilevel")), a.s[9]++, _this115.id = e;
          return _this115;
        }

        _createClass(C, [{
          key: "addLevel",
          value: function addLevel(e) {
            a.f[2]++, a.s[10]++, this.root.push(e);
          }
        }, {
          key: "createLevel",
          value: function createLevel(e, n, t) {
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (a.b[0][0]++, "start");
            a.f[3]++;
            var o = (a.s[11]++, new u.Level(e, n, t, r));
            return a.s[12]++, this.addLevel(o), a.s[13]++, o;
          }
        }]);

        return C;
      }(c.XmlComponent);

      a.s[14]++, n.AbstractNumbering = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\settings\\update-fields.ts", o = "128a46f131095864613d5ded4c3d9f6f2bb066ec", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\settings\\update-fields.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 56
            }
          },
          5: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 32
            }
          },
          6: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 18,
              column: 12
            }
          },
          7: {
            start: {
              line: 21,
              column: 0
            },
            end: {
              line: 21,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 32
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 14
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 14,
                column: 16
              },
              end: {
                line: 14,
                column: 30
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 14,
                column: 26
              },
              end: {
                line: 14,
                column: 30
              }
            }],
            line: 14
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/settings/update-fields.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\settings\\update-fields.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAI1E,4BAAoC,SAAQ,sCAAwD;IAApG;;QACuB,YAAO,GAAG;YACzB,OAAO,EAAE,OAAO;SACnB,CAAC;IACN,CAAC;CAAA;AAJD,wDAIC;AACD,kBAA0B,SAAQ,6BAAY;IAC1C,YAAY,UAAmB,IAAI;QAC/B,KAAK,CAAC,gBAAgB,CAAC,CAAC;QACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,sBAAsB,CAAC;YACvB,OAAO;SACV,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,oCASC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nexport interface IUpdateFieldsAttributesProperties {\r\n    readonly enabled: boolean;\r\n}\r\nexport class UpdateFieldsAttributes extends XmlAttributeComponent<IUpdateFieldsAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        enabled: "w:val",\r\n    };\r\n}\r\nexport class UpdateFields extends XmlComponent {\r\n    constructor(enabled: boolean = true) {\r\n        super("w:updateFields");\r\n        this.root.push(\r\n            new UpdateFieldsAttributes({\r\n                enabled,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon22) {
        _inherits(u, _c$XmlAttributeCompon22);

        function u() {
          var _this116;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this116 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this116.xmlKeys = {
            enabled: "w:val"
          };
          return _this116;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.UpdateFieldsAttributes = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent69) {
        _inherits(p, _c$XmlComponent69);

        function p() {
          var _this117;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, !0);

          _classCallCheck(this, p);

          a.f[1]++, a.s[5]++, _this117 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:updateFields")), a.s[6]++, _this117.root.push(new u({
            enabled: e
          }));
          return _this117;
        }

        return p;
      }(c.XmlComponent);

      a.s[7]++, n.UpdateFields = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\external-styles-factory.ts", o = "d894a6b68d86735730e57cbb4868d64386859c78", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\external-styles-factory.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 17
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 5,
              column: 11
            },
            end: {
              line: 5,
              column: 24
            }
          },
          4: {
            start: {
              line: 8,
              column: 23
            },
            end: {
              line: 8,
              column: 67
            }
          },
          5: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 14,
              column: 9
            }
          },
          6: {
            start: {
              line: 11,
              column: 12
            },
            end: {
              line: 13,
              column: 13
            }
          },
          7: {
            start: {
              line: 12,
              column: 16
            },
            end: {
              line: 12,
              column: 42
            }
          },
          8: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 17,
              column: 9
            }
          },
          9: {
            start: {
              line: 16,
              column: 12
            },
            end: {
              line: 16,
              column: 59
            }
          },
          10: {
            start: {
              line: 18,
              column: 30
            },
            end: {
              line: 18,
              column: 124
            }
          },
          11: {
            start: {
              line: 19,
              column: 31
            },
            end: {
              line: 19,
              column: 62
            }
          },
          12: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 22,
              column: 9
            }
          },
          13: {
            start: {
              line: 21,
              column: 12
            },
            end: {
              line: 21,
              column: 81
            }
          },
          14: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 29
            }
          },
          15: {
            start: {
              line: 26,
              column: 0
            },
            end: {
              line: 26,
              column: 54
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 25
              },
              end: {
                line: 24,
                column: 5
              }
            },
            line: 7
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 10,
                column: 29
              },
              end: {
                line: 10,
                column: 50
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 10,
                column: 29
              },
              end: {
                line: 10,
                column: 44
              }
            }, {
              start: {
                line: 10,
                column: 48
              },
              end: {
                line: 10,
                column: 50
              }
            }],
            line: 10
          },
          1: {
            loc: {
              start: {
                line: 11,
                column: 12
              },
              end: {
                line: 13,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 11,
                column: 12
              },
              end: {
                line: 13,
                column: 13
              }
            }, {
              start: {
                line: 11,
                column: 12
              },
              end: {
                line: 13,
                column: 13
              }
            }],
            line: 11
          },
          2: {
            loc: {
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            }, {
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            }],
            line: 15
          },
          3: {
            loc: {
              start: {
                line: 19,
                column: 31
              },
              end: {
                line: 19,
                column: 62
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 19,
                column: 31
              },
              end: {
                line: 19,
                column: 56
              }
            }, {
              start: {
                line: 19,
                column: 60
              },
              end: {
                line: 19,
                column: 62
              }
            }],
            line: 19
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/external-styles-factory.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\external-styles-factory.ts"],
          names: [],
          mappings: ";;AAAA,wDAAiH;AACjH,mCAAuD;AACvD,yBAA4B;AAE5B;IAuBW,WAAW,CAAC,OAAe;QAC9B,MAAM,MAAM,GAAG,eAAM,CAAC,OAAO,EAAE,EAAE,OAAO,EAAE,KAAK,EAAE,CAAe,CAAC;QAEjE,IAAI,gBAAwC,CAAC;QAC7C,KAAK,MAAM,MAAM,IAAI,MAAM,CAAC,QAAQ,IAAI,EAAE,EAAE;YACxC,IAAI,MAAM,CAAC,IAAI,KAAK,UAAU,EAAE;gBAC5B,gBAAgB,GAAG,MAAM,CAAC;aAC7B;SACJ;QACD,IAAI,gBAAgB,KAAK,SAAS,EAAE;YAChC,MAAM,IAAI,KAAK,CAAC,6BAA6B,CAAC,CAAC;SAClD;QAED,MAAM,aAAa,GAAG,IAAI,SAAM,CAAC,IAAI,8CAA6B,CAAC,gBAAgB,CAAC,UAAU,CAAC,CAAC,CAAC;QACjG,MAAM,cAAc,GAAG,gBAAgB,CAAC,QAAQ,IAAI,EAAE,CAAC;QACvD,KAAK,MAAM,QAAQ,IAAI,cAAc,EAAE;YACnC,aAAa,CAAC,IAAI,CAAC,sCAAqB,CAAC,QAAQ,CAAyB,CAAC,CAAC;SAC/E;QACD,OAAO,aAAa,CAAC;IACzB,CAAC;CACJ;AA3CD,sDA2CC",
          sourcesContent: ['import { convertToXmlComponent, ImportedRootElementAttributes, ImportedXmlComponent } from "file/xml-components";\r\nimport { Element as XMLElement, xml2js } from "xml-js";\r\nimport { Styles } from "./";\r\n\r\nexport class ExternalStylesFactory {\r\n    /**\r\n     * Creates new Style based on the given styles.\r\n     * Parses the styles and convert them to XmlComponent.\r\n     * Example content from styles.xml:\r\n     * <?xml version="1.0">\r\n     * <w:styles xmlns:mc="some schema" ...>\r\n     *\r\n     *   <w:style w:type="paragraph" w:styleId="Heading1">\r\n     *           <w:name w:val="heading 1"/>\r\n     *           .....\r\n     *   </w:style>\r\n     *\r\n     *   <w:style w:type="paragraph" w:styleId="Heading2">\r\n     *           <w:name w:val="heading 2"/>\r\n     *           .....\r\n     *   </w:style>\r\n     *\r\n     *   <w:docDefaults>Or any other element will be parsed to</w:docDefaults>\r\n     *\r\n     * </w:styles>\r\n     * @param externalStyles context from styles.xml\r\n     */\r\n    public newInstance(xmlData: string): Styles {\r\n        const xmlObj = xml2js(xmlData, { compact: false }) as XMLElement;\r\n\r\n        let stylesXmlElement: XMLElement | undefined;\r\n        for (const xmlElm of xmlObj.elements || []) {\r\n            if (xmlElm.name === "w:styles") {\r\n                stylesXmlElement = xmlElm;\r\n            }\r\n        }\r\n        if (stylesXmlElement === undefined) {\r\n            throw new Error("can not find styles element");\r\n        }\r\n\r\n        const importedStyle = new Styles(new ImportedRootElementAttributes(stylesXmlElement.attributes));\r\n        const stylesElements = stylesXmlElement.elements || [];\r\n        for (const childElm of stylesElements) {\r\n            importedStyle.push(convertToXmlComponent(childElm) as ImportedXmlComponent);\r\n        }\r\n        return importedStyle;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(27)),
          p = (a.s[3]++, t(44));
      a.s[15]++, n.ExternalStylesFactory =
      /*#__PURE__*/
      function () {
        function _class30() {
          _classCallCheck(this, _class30);
        }

        _createClass(_class30, [{
          key: "newInstance",
          value: function newInstance(e) {
            a.f[0]++;
            var n = (a.s[4]++, u.xml2js(e, {
              compact: !1
            }));
            var t;
            a.s[5]++;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = (a.b[0][0]++, n.elements || (a.b[0][1]++, []))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _e2 = _step.value;
                a.s[6]++, "w:styles" === _e2.name ? (a.b[1][0]++, a.s[7]++, t = _e2) : a.b[1][1]++;
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (a.s[8]++, void 0 === t) throw a.b[2][0]++, a.s[9]++, new Error("can not find styles element");
            a.b[2][1]++;
            var r = (a.s[10]++, new p.Styles(new c.ImportedRootElementAttributes(t.attributes))),
                o = (a.s[11]++, a.b[3][0]++, t.elements || (a.b[3][1]++, []));
            a.s[12]++;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = o[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _e3 = _step2.value;
                a.s[13]++, r.push(c.convertToXmlComponent(_e3));
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            return a.s[14]++, r;
          }
        }]);

        return _class30;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\style\\index.ts", o = "9fd8e92f6c70903d6b72bcc879c6cacc0ab7fdfa", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\style\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 45
            }
          },
          2: {
            start: {
              line: 4,
              column: 19
            },
            end: {
              line: 4,
              column: 59
            }
          },
          3: {
            start: {
              line: 5,
              column: 21
            },
            end: {
              line: 5,
              column: 61
            }
          },
          4: {
            start: {
              line: 6,
              column: 25
            },
            end: {
              line: 6,
              column: 55
            }
          },
          5: {
            start: {
              line: 7,
              column: 21
            },
            end: {
              line: 7,
              column: 44
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 28
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 16,
              column: 10
            }
          },
          8: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 25
            }
          },
          9: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 56
            }
          },
          10: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 25,
              column: 9
            }
          },
          11: {
            start: {
              line: 24,
              column: 12
            },
            end: {
              line: 24,
              column: 56
            }
          },
          12: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 37
            }
          },
          13: {
            start: {
              line: 31,
              column: 0
            },
            end: {
              line: 31,
              column: 22
            }
          },
          14: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 61
            }
          },
          15: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 73
            }
          },
          16: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 62
            }
          },
          17: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 49
            }
          },
          18: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 38,
              column: 43
            }
          },
          19: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 48
            }
          },
          20: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 20
            }
          },
          21: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 42
            }
          },
          22: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 46,
              column: 20
            }
          },
          23: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 59
            }
          },
          24: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 20
            }
          },
          25: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 55
            }
          },
          26: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 54,
              column: 20
            }
          },
          27: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 54
            }
          },
          28: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 20
            }
          },
          29: {
            start: {
              line: 61,
              column: 8
            },
            end: {
              line: 61,
              column: 119
            }
          },
          30: {
            start: {
              line: 64,
              column: 8
            },
            end: {
              line: 64,
              column: 58
            }
          },
          31: {
            start: {
              line: 67,
              column: 8
            },
            end: {
              line: 67,
              column: 61
            }
          },
          32: {
            start: {
              line: 70,
              column: 8
            },
            end: {
              line: 70,
              column: 63
            }
          },
          33: {
            start: {
              line: 73,
              column: 8
            },
            end: {
              line: 73,
              column: 58
            }
          },
          34: {
            start: {
              line: 76,
              column: 8
            },
            end: {
              line: 76,
              column: 60
            }
          },
          35: {
            start: {
              line: 79,
              column: 8
            },
            end: {
              line: 79,
              column: 66
            }
          },
          36: {
            start: {
              line: 82,
              column: 8
            },
            end: {
              line: 82,
              column: 63
            }
          },
          37: {
            start: {
              line: 85,
              column: 8
            },
            end: {
              line: 85,
              column: 65
            }
          },
          38: {
            start: {
              line: 88,
              column: 8
            },
            end: {
              line: 88,
              column: 83
            }
          },
          39: {
            start: {
              line: 91,
              column: 8
            },
            end: {
              line: 91,
              column: 64
            }
          },
          40: {
            start: {
              line: 94,
              column: 8
            },
            end: {
              line: 94,
              column: 70
            }
          },
          41: {
            start: {
              line: 97,
              column: 8
            },
            end: {
              line: 97,
              column: 75
            }
          },
          42: {
            start: {
              line: 100,
              column: 8
            },
            end: {
              line: 100,
              column: 105
            }
          },
          43: {
            start: {
              line: 103,
              column: 8
            },
            end: {
              line: 103,
              column: 103
            }
          },
          44: {
            start: {
              line: 106,
              column: 8
            },
            end: {
              line: 106,
              column: 104
            }
          },
          45: {
            start: {
              line: 109,
              column: 8
            },
            end: {
              line: 109,
              column: 103
            }
          },
          46: {
            start: {
              line: 112,
              column: 8
            },
            end: {
              line: 112,
              column: 74
            }
          },
          47: {
            start: {
              line: 115,
              column: 8
            },
            end: {
              line: 115,
              column: 76
            }
          },
          48: {
            start: {
              line: 118,
              column: 8
            },
            end: {
              line: 118,
              column: 80
            }
          },
          49: {
            start: {
              line: 121,
              column: 8
            },
            end: {
              line: 121,
              column: 72
            }
          },
          50: {
            start: {
              line: 124,
              column: 8
            },
            end: {
              line: 124,
              column: 74
            }
          },
          51: {
            start: {
              line: 127,
              column: 8
            },
            end: {
              line: 127,
              column: 69
            }
          },
          52: {
            start: {
              line: 130,
              column: 8
            },
            end: {
              line: 130,
              column: 70
            }
          },
          53: {
            start: {
              line: 133,
              column: 0
            },
            end: {
              line: 133,
              column: 40
            }
          },
          54: {
            start: {
              line: 136,
              column: 8
            },
            end: {
              line: 136,
              column: 29
            }
          },
          55: {
            start: {
              line: 137,
              column: 8
            },
            end: {
              line: 137,
              column: 31
            }
          },
          56: {
            start: {
              line: 138,
              column: 8
            },
            end: {
              line: 138,
              column: 28
            }
          },
          57: {
            start: {
              line: 139,
              column: 8
            },
            end: {
              line: 139,
              column: 27
            }
          },
          58: {
            start: {
              line: 142,
              column: 0
            },
            end: {
              line: 142,
              column: 36
            }
          },
          59: {
            start: {
              line: 145,
              column: 8
            },
            end: {
              line: 145,
              column: 32
            }
          },
          60: {
            start: {
              line: 148,
              column: 0
            },
            end: {
              line: 148,
              column: 32
            }
          },
          61: {
            start: {
              line: 151,
              column: 8
            },
            end: {
              line: 151,
              column: 39
            }
          },
          62: {
            start: {
              line: 154,
              column: 0
            },
            end: {
              line: 154,
              column: 38
            }
          },
          63: {
            start: {
              line: 157,
              column: 8
            },
            end: {
              line: 157,
              column: 39
            }
          },
          64: {
            start: {
              line: 160,
              column: 0
            },
            end: {
              line: 160,
              column: 38
            }
          },
          65: {
            start: {
              line: 163,
              column: 8
            },
            end: {
              line: 163,
              column: 39
            }
          },
          66: {
            start: {
              line: 166,
              column: 0
            },
            end: {
              line: 166,
              column: 38
            }
          },
          67: {
            start: {
              line: 169,
              column: 8
            },
            end: {
              line: 169,
              column: 39
            }
          },
          68: {
            start: {
              line: 172,
              column: 0
            },
            end: {
              line: 172,
              column: 38
            }
          },
          69: {
            start: {
              line: 175,
              column: 8
            },
            end: {
              line: 175,
              column: 39
            }
          },
          70: {
            start: {
              line: 178,
              column: 0
            },
            end: {
              line: 178,
              column: 38
            }
          },
          71: {
            start: {
              line: 181,
              column: 8
            },
            end: {
              line: 181,
              column: 39
            }
          },
          72: {
            start: {
              line: 184,
              column: 0
            },
            end: {
              line: 184,
              column: 38
            }
          },
          73: {
            start: {
              line: 187,
              column: 8
            },
            end: {
              line: 187,
              column: 31
            }
          },
          74: {
            start: {
              line: 188,
              column: 8
            },
            end: {
              line: 188,
              column: 64
            }
          },
          75: {
            start: {
              line: 189,
              column: 8
            },
            end: {
              line: 189,
              column: 59
            }
          },
          76: {
            start: {
              line: 190,
              column: 8
            },
            end: {
              line: 190,
              column: 55
            }
          },
          77: {
            start: {
              line: 193,
              column: 0
            },
            end: {
              line: 193,
              column: 38
            }
          },
          78: {
            start: {
              line: 196,
              column: 8
            },
            end: {
              line: 196,
              column: 61
            }
          },
          79: {
            start: {
              line: 197,
              column: 8
            },
            end: {
              line: 197,
              column: 62
            }
          },
          80: {
            start: {
              line: 198,
              column: 8
            },
            end: {
              line: 198,
              column: 43
            }
          },
          81: {
            start: {
              line: 199,
              column: 8
            },
            end: {
              line: 199,
              column: 58
            }
          },
          82: {
            start: {
              line: 200,
              column: 8
            },
            end: {
              line: 200,
              column: 58
            }
          },
          83: {
            start: {
              line: 203,
              column: 8
            },
            end: {
              line: 203,
              column: 59
            }
          },
          84: {
            start: {
              line: 204,
              column: 8
            },
            end: {
              line: 204,
              column: 20
            }
          },
          85: {
            start: {
              line: 207,
              column: 8
            },
            end: {
              line: 207,
              column: 42
            }
          },
          86: {
            start: {
              line: 208,
              column: 8
            },
            end: {
              line: 208,
              column: 20
            }
          },
          87: {
            start: {
              line: 211,
              column: 8
            },
            end: {
              line: 211,
              column: 64
            }
          },
          88: {
            start: {
              line: 214,
              column: 8
            },
            end: {
              line: 214,
              column: 83
            }
          },
          89: {
            start: {
              line: 217,
              column: 8
            },
            end: {
              line: 217,
              column: 119
            }
          },
          90: {
            start: {
              line: 220,
              column: 0
            },
            end: {
              line: 220,
              column: 40
            }
          },
          91: {
            start: {
              line: 223,
              column: 8
            },
            end: {
              line: 223,
              column: 40
            }
          },
          92: {
            start: {
              line: 224,
              column: 8
            },
            end: {
              line: 226,
              column: 33
            }
          },
          93: {
            start: {
              line: 229,
              column: 0
            },
            end: {
              line: 229,
              column: 40
            }
          },
          94: {
            start: {
              line: 232,
              column: 8
            },
            end: {
              line: 232,
              column: 67
            }
          },
          95: {
            start: {
              line: 233,
              column: 8
            },
            end: {
              line: 233,
              column: 68
            }
          },
          96: {
            start: {
              line: 234,
              column: 8
            },
            end: {
              line: 234,
              column: 73
            }
          },
          97: {
            start: {
              line: 235,
              column: 8
            },
            end: {
              line: 235,
              column: 58
            }
          },
          98: {
            start: {
              line: 236,
              column: 8
            },
            end: {
              line: 236,
              column: 54
            }
          },
          99: {
            start: {
              line: 237,
              column: 8
            },
            end: {
              line: 237,
              column: 58
            }
          },
          100: {
            start: {
              line: 238,
              column: 8
            },
            end: {
              line: 238,
              column: 62
            }
          },
          101: {
            start: {
              line: 239,
              column: 8
            },
            end: {
              line: 239,
              column: 73
            }
          },
          102: {
            start: {
              line: 240,
              column: 8
            },
            end: {
              line: 240,
              column: 43
            }
          },
          103: {
            start: {
              line: 243,
              column: 0
            },
            end: {
              line: 243,
              column: 56
            }
          },
          104: {
            start: {
              line: 246,
              column: 8
            },
            end: {
              line: 246,
              column: 30
            }
          },
          105: {
            start: {
              line: 247,
              column: 8
            },
            end: {
              line: 247,
              column: 63
            }
          },
          106: {
            start: {
              line: 248,
              column: 8
            },
            end: {
              line: 248,
              column: 59
            }
          },
          107: {
            start: {
              line: 249,
              column: 8
            },
            end: {
              line: 249,
              column: 66
            }
          },
          108: {
            start: {
              line: 250,
              column: 8
            },
            end: {
              line: 250,
              column: 58
            }
          },
          109: {
            start: {
              line: 251,
              column: 8
            },
            end: {
              line: 251,
              column: 54
            }
          },
          110: {
            start: {
              line: 252,
              column: 8
            },
            end: {
              line: 252,
              column: 58
            }
          },
          111: {
            start: {
              line: 253,
              column: 8
            },
            end: {
              line: 257,
              column: 11
            }
          },
          112: {
            start: {
              line: 258,
              column: 8
            },
            end: {
              line: 258,
              column: 22
            }
          },
          113: {
            start: {
              line: 261,
              column: 0
            },
            end: {
              line: 261,
              column: 36
            }
          },
          114: {
            start: {
              line: 264,
              column: 8
            },
            end: {
              line: 264,
              column: 56
            }
          },
          115: {
            start: {
              line: 265,
              column: 8
            },
            end: {
              line: 265,
              column: 45
            }
          },
          116: {
            start: {
              line: 266,
              column: 8
            },
            end: {
              line: 266,
              column: 62
            }
          },
          117: {
            start: {
              line: 267,
              column: 8
            },
            end: {
              line: 267,
              column: 58
            }
          },
          118: {
            start: {
              line: 268,
              column: 8
            },
            end: {
              line: 268,
              column: 54
            }
          },
          119: {
            start: {
              line: 269,
              column: 8
            },
            end: {
              line: 269,
              column: 22
            }
          },
          120: {
            start: {
              line: 272,
              column: 0
            },
            end: {
              line: 272,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 9,
                column: 4
              },
              end: {
                line: 9,
                column: 5
              }
            },
            loc: {
              start: {
                line: 9,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 9
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 34
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 20
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 23
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 27
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 33,
                column: 4
              },
              end: {
                line: 33,
                column: 5
              }
            },
            loc: {
              start: {
                line: 33,
                column: 31
              },
              end: {
                line: 39,
                column: 5
              }
            },
            line: 33
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 40,
                column: 4
              },
              end: {
                line: 40,
                column: 5
              }
            },
            loc: {
              start: {
                line: 40,
                column: 35
              },
              end: {
                line: 43,
                column: 5
              }
            },
            line: 40
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 44,
                column: 4
              },
              end: {
                line: 44,
                column: 5
              }
            },
            loc: {
              start: {
                line: 44,
                column: 29
              },
              end: {
                line: 47,
                column: 5
              }
            },
            line: 44
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 48,
                column: 4
              },
              end: {
                line: 48,
                column: 5
              }
            },
            loc: {
              start: {
                line: 48,
                column: 22
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 48
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 52,
                column: 4
              },
              end: {
                line: 52,
                column: 5
              }
            },
            loc: {
              start: {
                line: 52,
                column: 18
              },
              end: {
                line: 55,
                column: 5
              }
            },
            line: 52
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 56,
                column: 4
              },
              end: {
                line: 56,
                column: 5
              }
            },
            loc: {
              start: {
                line: 56,
                column: 17
              },
              end: {
                line: 59,
                column: 5
              }
            },
            line: 56
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 60,
                column: 4
              },
              end: {
                line: 60,
                column: 5
              }
            },
            loc: {
              start: {
                line: 60,
                column: 16
              },
              end: {
                line: 62,
                column: 5
              }
            },
            line: 60
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 63,
                column: 4
              },
              end: {
                line: 63,
                column: 5
              }
            },
            loc: {
              start: {
                line: 63,
                column: 11
              },
              end: {
                line: 65,
                column: 5
              }
            },
            line: 63
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 66,
                column: 4
              },
              end: {
                line: 66,
                column: 5
              }
            },
            loc: {
              start: {
                line: 66,
                column: 14
              },
              end: {
                line: 68,
                column: 5
              }
            },
            line: 66
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 69,
                column: 4
              },
              end: {
                line: 69,
                column: 5
              }
            },
            loc: {
              start: {
                line: 69,
                column: 16
              },
              end: {
                line: 71,
                column: 5
              }
            },
            line: 69
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 72,
                column: 4
              },
              end: {
                line: 72,
                column: 5
              }
            },
            loc: {
              start: {
                line: 72,
                column: 14
              },
              end: {
                line: 74,
                column: 5
              }
            },
            line: 72
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 75,
                column: 4
              },
              end: {
                line: 75,
                column: 5
              }
            },
            loc: {
              start: {
                line: 75,
                column: 13
              },
              end: {
                line: 77,
                column: 5
              }
            },
            line: 75
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 78,
                column: 4
              },
              end: {
                line: 78,
                column: 5
              }
            },
            loc: {
              start: {
                line: 78,
                column: 19
              },
              end: {
                line: 80,
                column: 5
              }
            },
            line: 78
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 81,
                column: 4
              },
              end: {
                line: 81,
                column: 5
              }
            },
            loc: {
              start: {
                line: 81,
                column: 16
              },
              end: {
                line: 83,
                column: 5
              }
            },
            line: 81
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 84,
                column: 4
              },
              end: {
                line: 84,
                column: 5
              }
            },
            loc: {
              start: {
                line: 84,
                column: 18
              },
              end: {
                line: 86,
                column: 5
              }
            },
            line: 84
          },
          18: {
            name: "(anonymous_18)",
            decl: {
              start: {
                line: 87,
                column: 4
              },
              end: {
                line: 87,
                column: 5
              }
            },
            loc: {
              start: {
                line: 87,
                column: 36
              },
              end: {
                line: 89,
                column: 5
              }
            },
            line: 87
          },
          19: {
            name: "(anonymous_19)",
            decl: {
              start: {
                line: 90,
                column: 4
              },
              end: {
                line: 90,
                column: 5
              }
            },
            loc: {
              start: {
                line: 90,
                column: 17
              },
              end: {
                line: 92,
                column: 5
              }
            },
            line: 90
          },
          20: {
            name: "(anonymous_20)",
            decl: {
              start: {
                line: 93,
                column: 4
              },
              end: {
                line: 93,
                column: 5
              }
            },
            loc: {
              start: {
                line: 93,
                column: 19
              },
              end: {
                line: 95,
                column: 5
              }
            },
            line: 93
          },
          21: {
            name: "(anonymous_21)",
            decl: {
              start: {
                line: 96,
                column: 4
              },
              end: {
                line: 96,
                column: 5
              }
            },
            loc: {
              start: {
                line: 96,
                column: 28
              },
              end: {
                line: 98,
                column: 5
              }
            },
            line: 96
          },
          22: {
            name: "(anonymous_22)",
            decl: {
              start: {
                line: 99,
                column: 4
              },
              end: {
                line: 99,
                column: 5
              }
            },
            loc: {
              start: {
                line: 99,
                column: 13
              },
              end: {
                line: 101,
                column: 5
              }
            },
            line: 99
          },
          23: {
            name: "(anonymous_23)",
            decl: {
              start: {
                line: 102,
                column: 4
              },
              end: {
                line: 102,
                column: 5
              }
            },
            loc: {
              start: {
                line: 102,
                column: 11
              },
              end: {
                line: 104,
                column: 5
              }
            },
            line: 102
          },
          24: {
            name: "(anonymous_24)",
            decl: {
              start: {
                line: 105,
                column: 4
              },
              end: {
                line: 105,
                column: 5
              }
            },
            loc: {
              start: {
                line: 105,
                column: 12
              },
              end: {
                line: 107,
                column: 5
              }
            },
            line: 105
          },
          25: {
            name: "(anonymous_25)",
            decl: {
              start: {
                line: 108,
                column: 4
              },
              end: {
                line: 108,
                column: 5
              }
            },
            loc: {
              start: {
                line: 108,
                column: 16
              },
              end: {
                line: 110,
                column: 5
              }
            },
            line: 108
          },
          26: {
            name: "(anonymous_26)",
            decl: {
              start: {
                line: 111,
                column: 4
              },
              end: {
                line: 111,
                column: 5
              }
            },
            loc: {
              start: {
                line: 111,
                column: 20
              },
              end: {
                line: 113,
                column: 5
              }
            },
            line: 111
          },
          27: {
            name: "(anonymous_27)",
            decl: {
              start: {
                line: 114,
                column: 4
              },
              end: {
                line: 114,
                column: 5
              }
            },
            loc: {
              start: {
                line: 114,
                column: 22
              },
              end: {
                line: 116,
                column: 5
              }
            },
            line: 114
          },
          28: {
            name: "(anonymous_28)",
            decl: {
              start: {
                line: 117,
                column: 4
              },
              end: {
                line: 117,
                column: 5
              }
            },
            loc: {
              start: {
                line: 117,
                column: 26
              },
              end: {
                line: 119,
                column: 5
              }
            },
            line: 117
          },
          29: {
            name: "(anonymous_29)",
            decl: {
              start: {
                line: 120,
                column: 4
              },
              end: {
                line: 120,
                column: 5
              }
            },
            loc: {
              start: {
                line: 120,
                column: 18
              },
              end: {
                line: 122,
                column: 5
              }
            },
            line: 120
          },
          30: {
            name: "(anonymous_30)",
            decl: {
              start: {
                line: 123,
                column: 4
              },
              end: {
                line: 123,
                column: 5
              }
            },
            loc: {
              start: {
                line: 123,
                column: 20
              },
              end: {
                line: 125,
                column: 5
              }
            },
            line: 123
          },
          31: {
            name: "(anonymous_31)",
            decl: {
              start: {
                line: 126,
                column: 4
              },
              end: {
                line: 126,
                column: 5
              }
            },
            loc: {
              start: {
                line: 126,
                column: 15
              },
              end: {
                line: 128,
                column: 5
              }
            },
            line: 126
          },
          32: {
            name: "(anonymous_32)",
            decl: {
              start: {
                line: 129,
                column: 4
              },
              end: {
                line: 129,
                column: 5
              }
            },
            loc: {
              start: {
                line: 129,
                column: 16
              },
              end: {
                line: 131,
                column: 5
              }
            },
            line: 129
          },
          33: {
            name: "(anonymous_33)",
            decl: {
              start: {
                line: 135,
                column: 4
              },
              end: {
                line: 135,
                column: 5
              }
            },
            loc: {
              start: {
                line: 135,
                column: 31
              },
              end: {
                line: 140,
                column: 5
              }
            },
            line: 135
          },
          34: {
            name: "(anonymous_34)",
            decl: {
              start: {
                line: 144,
                column: 4
              },
              end: {
                line: 144,
                column: 5
              }
            },
            loc: {
              start: {
                line: 144,
                column: 18
              },
              end: {
                line: 146,
                column: 5
              }
            },
            line: 144
          },
          35: {
            name: "(anonymous_35)",
            decl: {
              start: {
                line: 150,
                column: 4
              },
              end: {
                line: 150,
                column: 5
              }
            },
            loc: {
              start: {
                line: 150,
                column: 18
              },
              end: {
                line: 152,
                column: 5
              }
            },
            line: 150
          },
          36: {
            name: "(anonymous_36)",
            decl: {
              start: {
                line: 156,
                column: 4
              },
              end: {
                line: 156,
                column: 5
              }
            },
            loc: {
              start: {
                line: 156,
                column: 18
              },
              end: {
                line: 158,
                column: 5
              }
            },
            line: 156
          },
          37: {
            name: "(anonymous_37)",
            decl: {
              start: {
                line: 162,
                column: 4
              },
              end: {
                line: 162,
                column: 5
              }
            },
            loc: {
              start: {
                line: 162,
                column: 18
              },
              end: {
                line: 164,
                column: 5
              }
            },
            line: 162
          },
          38: {
            name: "(anonymous_38)",
            decl: {
              start: {
                line: 168,
                column: 4
              },
              end: {
                line: 168,
                column: 5
              }
            },
            loc: {
              start: {
                line: 168,
                column: 18
              },
              end: {
                line: 170,
                column: 5
              }
            },
            line: 168
          },
          39: {
            name: "(anonymous_39)",
            decl: {
              start: {
                line: 174,
                column: 4
              },
              end: {
                line: 174,
                column: 5
              }
            },
            loc: {
              start: {
                line: 174,
                column: 18
              },
              end: {
                line: 176,
                column: 5
              }
            },
            line: 174
          },
          40: {
            name: "(anonymous_40)",
            decl: {
              start: {
                line: 180,
                column: 4
              },
              end: {
                line: 180,
                column: 5
              }
            },
            loc: {
              start: {
                line: 180,
                column: 18
              },
              end: {
                line: 182,
                column: 5
              }
            },
            line: 180
          },
          41: {
            name: "(anonymous_41)",
            decl: {
              start: {
                line: 186,
                column: 4
              },
              end: {
                line: 186,
                column: 5
              }
            },
            loc: {
              start: {
                line: 186,
                column: 18
              },
              end: {
                line: 191,
                column: 5
              }
            },
            line: 186
          },
          42: {
            name: "(anonymous_42)",
            decl: {
              start: {
                line: 195,
                column: 4
              },
              end: {
                line: 195,
                column: 5
              }
            },
            loc: {
              start: {
                line: 195,
                column: 31
              },
              end: {
                line: 201,
                column: 5
              }
            },
            line: 195
          },
          43: {
            name: "(anonymous_43)",
            decl: {
              start: {
                line: 202,
                column: 4
              },
              end: {
                line: 202,
                column: 5
              }
            },
            loc: {
              start: {
                line: 202,
                column: 22
              },
              end: {
                line: 205,
                column: 5
              }
            },
            line: 202
          },
          44: {
            name: "(anonymous_44)",
            decl: {
              start: {
                line: 206,
                column: 4
              },
              end: {
                line: 206,
                column: 5
              }
            },
            loc: {
              start: {
                line: 206,
                column: 29
              },
              end: {
                line: 209,
                column: 5
              }
            },
            line: 206
          },
          45: {
            name: "(anonymous_45)",
            decl: {
              start: {
                line: 210,
                column: 4
              },
              end: {
                line: 210,
                column: 5
              }
            },
            loc: {
              start: {
                line: 210,
                column: 17
              },
              end: {
                line: 212,
                column: 5
              }
            },
            line: 210
          },
          46: {
            name: "(anonymous_46)",
            decl: {
              start: {
                line: 213,
                column: 4
              },
              end: {
                line: 213,
                column: 5
              }
            },
            loc: {
              start: {
                line: 213,
                column: 36
              },
              end: {
                line: 215,
                column: 5
              }
            },
            line: 213
          },
          47: {
            name: "(anonymous_47)",
            decl: {
              start: {
                line: 216,
                column: 4
              },
              end: {
                line: 216,
                column: 5
              }
            },
            loc: {
              start: {
                line: 216,
                column: 16
              },
              end: {
                line: 218,
                column: 5
              }
            },
            line: 216
          },
          48: {
            name: "(anonymous_48)",
            decl: {
              start: {
                line: 222,
                column: 4
              },
              end: {
                line: 222,
                column: 5
              }
            },
            loc: {
              start: {
                line: 222,
                column: 18
              },
              end: {
                line: 227,
                column: 5
              }
            },
            line: 222
          },
          49: {
            name: "(anonymous_49)",
            decl: {
              start: {
                line: 231,
                column: 4
              },
              end: {
                line: 231,
                column: 5
              }
            },
            loc: {
              start: {
                line: 231,
                column: 18
              },
              end: {
                line: 241,
                column: 5
              }
            },
            line: 231
          },
          50: {
            name: "(anonymous_50)",
            decl: {
              start: {
                line: 245,
                column: 4
              },
              end: {
                line: 245,
                column: 5
              }
            },
            loc: {
              start: {
                line: 245,
                column: 18
              },
              end: {
                line: 259,
                column: 5
              }
            },
            line: 245
          },
          51: {
            name: "(anonymous_51)",
            decl: {
              start: {
                line: 263,
                column: 4
              },
              end: {
                line: 263,
                column: 5
              }
            },
            loc: {
              start: {
                line: 263,
                column: 18
              },
              end: {
                line: 270,
                column: 5
              }
            },
            line: 263
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 23,
                column: 8
              },
              end: {
                line: 25,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 23,
                column: 8
              },
              end: {
                line: 25,
                column: 9
              }
            }, {
              start: {
                line: 23,
                column: 8
              },
              end: {
                line: 25,
                column: 9
              }
            }],
            line: 23
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0,
          64: 0,
          65: 0,
          66: 0,
          67: 0,
          68: 0,
          69: 0,
          70: 0,
          71: 0,
          72: 0,
          73: 0,
          74: 0,
          75: 0,
          76: 0,
          77: 0,
          78: 0,
          79: 0,
          80: 0,
          81: 0,
          82: 0,
          83: 0,
          84: 0,
          85: 0,
          86: 0,
          87: 0,
          88: 0,
          89: 0,
          90: 0,
          91: 0,
          92: 0,
          93: 0,
          94: 0,
          95: 0,
          96: 0,
          97: 0,
          98: 0,
          99: 0,
          100: 0,
          101: 0,
          102: 0,
          103: 0,
          104: 0,
          105: 0,
          106: 0,
          107: 0,
          108: 0,
          109: 0,
          110: 0,
          111: 0,
          112: 0,
          113: 0,
          114: 0,
          115: 0,
          116: 0,
          117: 0,
          118: 0,
          119: 0,
          120: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/style/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\style\\index.ts"],
          names: [],
          mappings: ";;AAAA,8CAYwB;AACxB,4DAA4D;AAC5D,8DAA8D;AAC9D,wDAA0E;AAE1E,6CAA8G;AAS9G,qBAAsB,SAAQ,sCAAuC;IAArE;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,QAAQ;YACd,OAAO,EAAE,WAAW;YACpB,OAAO,EAAE,WAAW;YACpB,WAAW,EAAE,eAAe;SAC/B,CAAC;IACN,CAAC;CAAA;AAED,WAAmB,SAAQ,6BAAY;IACnC,YAAY,UAA4B,EAAE,IAAa;QACnD,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,eAAe,CAAC,UAAU,CAAC,CAAC,CAAC;QAChD,IAAI,IAAI,EAAE;YACN,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,IAAI,CAAC,CAAC,CAAC;SAClC;IACL,CAAC;IAEM,IAAI,CAAC,YAA0B;QAClC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,YAAY,CAAC,CAAC;IACjC,CAAC;CACJ;AAZD,sBAYC;AAED,oBAA4B,SAAQ,KAAK;IAIrC,YAAY,OAAe,EAAE,IAAa;QACtC,KAAK,CAAC,EAAE,IAAI,EAAE,WAAW,EAAE,OAAO,EAAE,OAAO,EAAE,EAAE,IAAI,CAAC,CAAC;QACrD,IAAI,CAAC,mBAAmB,GAAG,IAAI,+BAAmB,EAAE,CAAC;QACrD,IAAI,CAAC,aAAa,GAAG,IAAI,0BAAa,EAAE,CAAC;QACzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,mBAAmB,CAAC,CAAC;QACzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;IACvC,CAAC;IAEM,oBAAoB,CAAC,QAAsB;QAC9C,IAAI,CAAC,mBAAmB,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QACxC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,cAAc,CAAC,QAAsB;QACxC,IAAI,CAAC,aAAa,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QAClC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,OAAO,CAAC,QAAgB;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,CAAC,QAAQ,CAAC,CAAC,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW;QACd,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,wBAAW,EAAE,CAAC,CAAC;QAClC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI,CAAC,MAAc;QACtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,MAAM,CAAC,CAAC,CAAC;QACjC,OAAO,IAAI,CAAC;IAChB,CAAC;IAIM,IAAI,CAAC,KAAa;QACrB,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAC,CAAC;IACnH,CAAC;IAEM,IAAI;QACP,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,IAAI,EAAE,CAAC,CAAC;IACtD,CAAC;IAEM,OAAO;QACV,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,OAAO,EAAE,CAAC,CAAC;IACzD,CAAC;IAEM,SAAS;QACZ,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,SAAS,EAAE,CAAC,CAAC;IAC3D,CAAC;IAEM,OAAO;QACV,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,IAAI,EAAE,CAAC,CAAC;IACtD,CAAC;IAEM,MAAM;QACT,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,MAAM,EAAE,CAAC,CAAC;IACxD,CAAC;IAEM,YAAY;QACf,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,YAAY,EAAE,CAAC,CAAC;IAC9D,CAAC;IAEM,SAAS;QACZ,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,SAAS,EAAE,CAAC,CAAC;IAC3D,CAAC;IAEM,WAAW;QACd,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,WAAW,EAAE,CAAC,CAAC;IAC7D,CAAC;IAEM,SAAS,CAAC,aAAsB,EAAE,KAAc;QACnD,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,SAAS,CAAC,aAAa,EAAE,KAAK,CAAC,CAAC,CAAC;IAC/E,CAAC;IAEM,KAAK,CAAC,KAAa;QACtB,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC;IAC5D,CAAC;IAEM,IAAI,CAAC,QAAgB;QACxB,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,QAAQ,CAAC,QAAQ,CAAC,CAAC,CAAC;IAClE,CAAC;IAEM,gBAAgB,CAAC,KAAa;QACjC,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,gBAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;IACvE,CAAC;IAIM,MAAM;QACT,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,MAAM,CAAC,CAAC,CAAC;IAC7E,CAAC;IAEM,IAAI;QACP,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,IAAI,CAAC,CAAC,CAAC;IAC3E,CAAC;IAEM,KAAK;QACR,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;IAC5E,CAAC;IAEM,SAAS;QACZ,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,qBAAS,CAAC,4BAAgB,CAAC,IAAI,CAAC,CAAC,CAAC;IAC3E,CAAC;IAEM,aAAa;QAChB,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,yBAAa,EAAE,CAAC,CAAC;IAC1D,CAAC;IAEM,eAAe;QAClB,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,2BAAe,EAAE,CAAC,CAAC;IAC5D,CAAC;IAEM,WAAW,CAAC,QAAgB;QAC/B,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,uBAAW,CAAC,QAAQ,CAAC,CAAC,CAAC;IAChE,CAAC;IAEM,MAAM,CAAC,KAAa;QACvB,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,KAAK,CAAC,CAAC,CAAC;IACxD,CAAC;IAEM,OAAO,CAAC,MAA0B;QACrC,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,mBAAO,CAAC,MAAM,CAAC,CAAC,CAAC;IAC1D,CAAC;IAEM,QAAQ;QACX,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,oBAAQ,EAAE,CAAC,CAAC;IACrD,CAAC;IAEM,SAAS;QACZ,OAAO,IAAI,CAAC,oBAAoB,CAAC,IAAI,qBAAS,EAAE,CAAC,CAAC;IACtD,CAAC;CACJ;AAxID,wCAwIC;AAED,kBAA0B,SAAQ,cAAc;IAC5C,YAAY,OAAe,EAAE,IAAY;QACrC,KAAK,CAAC,OAAO,EAAE,IAAI,CAAC,CAAC;QACrB,IAAI,CAAC,OAAO,CAAC,QAAQ,CAAC,CAAC;QACvB,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QACpB,IAAI,CAAC,WAAW,EAAE,CAAC;IACvB,CAAC;CACJ;AAPD,oCAOC;AAED,gBAAwB,SAAQ,YAAY;IACxC;QACI,KAAK,CAAC,OAAO,EAAE,OAAO,CAAC,CAAC;IAC5B,CAAC;CACJ;AAJD,gCAIC;AAED,mBAA2B,SAAQ,YAAY;IAC3C;QACI,KAAK,CAAC,UAAU,EAAE,WAAW,CAAC,CAAC;IACnC,CAAC;CACJ;AAJD,sCAIC;AAED,mBAA2B,SAAQ,YAAY;IAC3C;QACI,KAAK,CAAC,UAAU,EAAE,WAAW,CAAC,CAAC;IACnC,CAAC;CACJ;AAJD,sCAIC;AAED,mBAA2B,SAAQ,YAAY;IAC3C;QACI,KAAK,CAAC,UAAU,EAAE,WAAW,CAAC,CAAC;IACnC,CAAC;CACJ;AAJD,sCAIC;AAED,mBAA2B,SAAQ,YAAY;IAC3C;QACI,KAAK,CAAC,UAAU,EAAE,WAAW,CAAC,CAAC;IACnC,CAAC;CACJ;AAJD,sCAIC;AAED,mBAA2B,SAAQ,YAAY;IAC3C;QACI,KAAK,CAAC,UAAU,EAAE,WAAW,CAAC,CAAC;IACnC,CAAC;CACJ;AAJD,sCAIC;AAED,mBAA2B,SAAQ,YAAY;IAC3C;QACI,KAAK,CAAC,UAAU,EAAE,WAAW,CAAC,CAAC;IACnC,CAAC;CACJ;AAJD,sCAIC;AAED,mBAA2B,SAAQ,cAAc;IAC7C;QACI,KAAK,CAAC,eAAe,CAAC,CAAC;QACvB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,gBAAgB,CAAC,CAAC,CAAC;QAC3C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,CAAC,QAAQ,CAAC,CAAC,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,wBAAW,EAAE,CAAC,CAAC;IACtC,CAAC;CACJ;AAPD,sCAOC;AAED,oBAA4B,SAAQ,KAAK;IAGrC,YAAY,OAAe,EAAE,IAAa;QACtC,KAAK,CAAC,EAAE,IAAI,EAAE,WAAW,EAAE,OAAO,EAAE,OAAO,EAAE,EAAE,IAAI,CAAC,CAAC;QACrD,IAAI,CAAC,aAAa,GAAG,IAAI,0BAAa,EAAE,CAAC;QACzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QACnC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAU,CAAC,IAAI,CAAC,CAAC,CAAC;QACrC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2BAAc,EAAE,CAAC,CAAC;IACzC,CAAC;IAEM,OAAO,CAAC,QAAgB;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,CAAC,QAAQ,CAAC,CAAC,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,cAAc,CAAC,QAAsB;QACxC,IAAI,CAAC,aAAa,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QAClC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK,CAAC,KAAa;QACtB,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC;IAC5D,CAAC;IAEM,SAAS,CAAC,aAAsB,EAAE,KAAc;QACnD,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,SAAS,CAAC,aAAa,EAAE,KAAK,CAAC,CAAC,CAAC;IAC/E,CAAC;IAEM,IAAI,CAAC,KAAa;QACrB,OAAO,IAAI,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,cAAc,CAAC,IAAI,UAAU,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAC,CAAC;IACnH,CAAC;CACJ;AAhCD,wCAgCC;AAED,oBAA4B,SAAQ,cAAc;IAC9C;QACI,KAAK,CAAC,WAAW,EAAE,WAAW,CAAC,CAAC;QAChC,IAAI,CAAC,OAAO,CAAC,sBAAsB,CAAC;aAC/B,KAAK,CAAC,QAAQ,CAAC;aACf,SAAS,CAAC,QAAQ,CAAC,CAAC;IAC7B,CAAC;CACJ;AAPD,wCAOC;AAED,4BAAoC,SAAQ,KAAK;IAG7C;QACI,KAAK,CAAC,EAAE,IAAI,EAAE,WAAW,EAAE,OAAO,EAAE,mBAAmB,EAAE,CAAC,CAAC;QAC3D,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,oBAAoB,CAAC,CAAC,CAAC;QAC/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,CAAC,sBAAsB,CAAC,CAAC,CAAC;QACpD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAU,CAAC,IAAI,CAAC,CAAC,CAAC;QACrC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAU,EAAE,CAAC,CAAC;QACjC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2BAAc,EAAE,CAAC,CAAC;QAErC,IAAI,CAAC,aAAa,GAAG,IAAI,0BAAa,EAAE,CAAC;QACzC,IAAI,CAAC,aAAa,CAAC,eAAe,CAAC,IAAI,UAAU,CAAC,WAAW,EAAE,CAAC,CAAC;QACjE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;IACvC,CAAC;CACJ;AAfD,wDAeC;AAED,kBAA0B,SAAQ,cAAc;IAC5C;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;QACtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,eAAe,CAAC,CAAC,CAAC;QAC1C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,CAAC,QAAQ,CAAC,CAAC,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,kBAAkB,CAAC,CAAC,CAAC;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAU,CAAC,IAAI,CAAC,CAAC,CAAC;QACrC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAU,EAAE,CAAC,CAAC;QACjC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2BAAc,EAAE,CAAC,CAAC;QACrC,IAAI,CAAC,OAAO,CAAC;YACT,KAAK,EAAE,CAAC;YACR,IAAI,EAAE,GAAG;YACT,QAAQ,EAAE,MAAM;SACnB,CAAC,CAAC;QACH,IAAI,CAAC,IAAI,CAAC,EAAE,CAAC,CAAC;IAClB,CAAC;CACJ;AAhBD,oCAgBC;AAED,sBAA8B,SAAQ,cAAc;IAChD;QACI,KAAK,CAAC,kBAAkB,EAAE,oBAAoB,CAAC,CAAC;QAChD,IAAI,CAAC,OAAO,CAAC,sBAAsB,CAAC,CAAC;QACrC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,cAAc,CAAC,CAAC,CAAC;QACzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAU,CAAC,IAAI,CAAC,CAAC,CAAC;QACrC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAU,EAAE,CAAC,CAAC;QACjC,IAAI,CAAC,IAAI,CAAC,EAAE,CAAC,CAAC;IAClB,CAAC;CACJ;AATD,4CASC",
          sourcesContent: ['import {\r\n    Alignment,\r\n    AlignmentOptions,\r\n    Indent,\r\n    ISpacingProperties,\r\n    KeepLines,\r\n    KeepNext,\r\n    LeftTabStop,\r\n    MaxRightTabStop,\r\n    ParagraphProperties,\r\n    Spacing,\r\n    ThematicBreak,\r\n} from "file/paragraph";\r\nimport * as formatting from "file/paragraph/run/formatting";\r\nimport { RunProperties } from "file/paragraph/run/properties";\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nimport { BasedOn, Link, Name, Next, QuickFormat, SemiHidden, UiPriority, UnhideWhenUsed } from "./components";\r\n\r\nexport interface IStyleAttributes {\r\n    readonly type?: string;\r\n    readonly styleId?: string;\r\n    readonly default?: boolean;\r\n    readonly customStyle?: string;\r\n}\r\n\r\nclass StyleAttributes extends XmlAttributeComponent<IStyleAttributes> {\r\n    protected readonly xmlKeys = {\r\n        type: "w:type",\r\n        styleId: "w:styleId",\r\n        default: "w:default",\r\n        customStyle: "w:customStyle",\r\n    };\r\n}\r\n\r\nexport class Style extends XmlComponent {\r\n    constructor(attributes: IStyleAttributes, name?: string) {\r\n        super("w:style");\r\n        this.root.push(new StyleAttributes(attributes));\r\n        if (name) {\r\n            this.root.push(new Name(name));\r\n        }\r\n    }\r\n\r\n    public push(styleSegment: XmlComponent): void {\r\n        this.root.push(styleSegment);\r\n    }\r\n}\r\n\r\nexport class ParagraphStyle extends Style {\r\n    private readonly paragraphProperties: ParagraphProperties;\r\n    private readonly runProperties: RunProperties;\r\n\r\n    constructor(styleId: string, name?: string) {\r\n        super({ type: "paragraph", styleId: styleId }, name);\r\n        this.paragraphProperties = new ParagraphProperties();\r\n        this.runProperties = new RunProperties();\r\n        this.root.push(this.paragraphProperties);\r\n        this.root.push(this.runProperties);\r\n    }\r\n\r\n    public addParagraphProperty(property: XmlComponent): ParagraphStyle {\r\n        this.paragraphProperties.push(property);\r\n        return this;\r\n    }\r\n\r\n    public addRunProperty(property: XmlComponent): ParagraphStyle {\r\n        this.runProperties.push(property);\r\n        return this;\r\n    }\r\n\r\n    public basedOn(parentId: string): ParagraphStyle {\r\n        this.root.push(new BasedOn(parentId));\r\n        return this;\r\n    }\r\n\r\n    public quickFormat(): ParagraphStyle {\r\n        this.root.push(new QuickFormat());\r\n        return this;\r\n    }\r\n\r\n    public next(nextId: string): ParagraphStyle {\r\n        this.root.push(new Next(nextId));\r\n        return this;\r\n    }\r\n\r\n    // ----------  Run formatting ---------------------- //\r\n\r\n    public size(twips: number): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.Size(twips)).addRunProperty(new formatting.SizeComplexScript(twips));\r\n    }\r\n\r\n    public bold(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.Bold());\r\n    }\r\n\r\n    public italics(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.Italics());\r\n    }\r\n\r\n    public smallCaps(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.SmallCaps());\r\n    }\r\n\r\n    public allCaps(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.Caps());\r\n    }\r\n\r\n    public strike(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.Strike());\r\n    }\r\n\r\n    public doubleStrike(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.DoubleStrike());\r\n    }\r\n\r\n    public subScript(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.SubScript());\r\n    }\r\n\r\n    public superScript(): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.SuperScript());\r\n    }\r\n\r\n    public underline(underlineType?: string, color?: string): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.Underline(underlineType, color));\r\n    }\r\n\r\n    public color(color: string): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.Color(color));\r\n    }\r\n\r\n    public font(fontName: string): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.RunFonts(fontName));\r\n    }\r\n\r\n    public characterSpacing(value: number): ParagraphStyle {\r\n        return this.addRunProperty(new formatting.CharacterSpacing(value));\r\n    }\r\n\r\n    // --------------------- Paragraph formatting ------------------------ //\r\n\r\n    public center(): ParagraphStyle {\r\n        return this.addParagraphProperty(new Alignment(AlignmentOptions.CENTER));\r\n    }\r\n\r\n    public left(): ParagraphStyle {\r\n        return this.addParagraphProperty(new Alignment(AlignmentOptions.LEFT));\r\n    }\r\n\r\n    public right(): ParagraphStyle {\r\n        return this.addParagraphProperty(new Alignment(AlignmentOptions.RIGHT));\r\n    }\r\n\r\n    public justified(): ParagraphStyle {\r\n        return this.addParagraphProperty(new Alignment(AlignmentOptions.BOTH));\r\n    }\r\n\r\n    public thematicBreak(): ParagraphStyle {\r\n        return this.addParagraphProperty(new ThematicBreak());\r\n    }\r\n\r\n    public maxRightTabStop(): ParagraphStyle {\r\n        return this.addParagraphProperty(new MaxRightTabStop());\r\n    }\r\n\r\n    public leftTabStop(position: number): ParagraphStyle {\r\n        return this.addParagraphProperty(new LeftTabStop(position));\r\n    }\r\n\r\n    public indent(attrs: object): ParagraphStyle {\r\n        return this.addParagraphProperty(new Indent(attrs));\r\n    }\r\n\r\n    public spacing(params: ISpacingProperties): ParagraphStyle {\r\n        return this.addParagraphProperty(new Spacing(params));\r\n    }\r\n\r\n    public keepNext(): ParagraphStyle {\r\n        return this.addParagraphProperty(new KeepNext());\r\n    }\r\n\r\n    public keepLines(): ParagraphStyle {\r\n        return this.addParagraphProperty(new KeepLines());\r\n    }\r\n}\r\n\r\nexport class HeadingStyle extends ParagraphStyle {\r\n    constructor(styleId: string, name: string) {\r\n        super(styleId, name);\r\n        this.basedOn("Normal");\r\n        this.next("Normal");\r\n        this.quickFormat();\r\n    }\r\n}\r\n\r\nexport class TitleStyle extends HeadingStyle {\r\n    constructor() {\r\n        super("Title", "Title");\r\n    }\r\n}\r\n\r\nexport class Heading1Style extends HeadingStyle {\r\n    constructor() {\r\n        super("Heading1", "Heading 1");\r\n    }\r\n}\r\n\r\nexport class Heading2Style extends HeadingStyle {\r\n    constructor() {\r\n        super("Heading2", "Heading 2");\r\n    }\r\n}\r\n\r\nexport class Heading3Style extends HeadingStyle {\r\n    constructor() {\r\n        super("Heading3", "Heading 3");\r\n    }\r\n}\r\n\r\nexport class Heading4Style extends HeadingStyle {\r\n    constructor() {\r\n        super("Heading4", "Heading 4");\r\n    }\r\n}\r\n\r\nexport class Heading5Style extends HeadingStyle {\r\n    constructor() {\r\n        super("Heading5", "Heading 5");\r\n    }\r\n}\r\n\r\nexport class Heading6Style extends HeadingStyle {\r\n    constructor() {\r\n        super("Heading6", "Heading 6");\r\n    }\r\n}\r\n\r\nexport class ListParagraph extends ParagraphStyle {\r\n    constructor() {\r\n        super("ListParagraph");\r\n        this.root.push(new Name("List Paragraph"));\r\n        this.root.push(new BasedOn("Normal"));\r\n        this.root.push(new QuickFormat());\r\n    }\r\n}\r\n\r\nexport class CharacterStyle extends Style {\r\n    private readonly runProperties: RunProperties;\r\n\r\n    constructor(styleId: string, name?: string) {\r\n        super({ type: "character", styleId: styleId }, name);\r\n        this.runProperties = new RunProperties();\r\n        this.root.push(this.runProperties);\r\n        this.root.push(new UiPriority("99"));\r\n        this.root.push(new UnhideWhenUsed());\r\n    }\r\n\r\n    public basedOn(parentId: string): CharacterStyle {\r\n        this.root.push(new BasedOn(parentId));\r\n        return this;\r\n    }\r\n\r\n    public addRunProperty(property: XmlComponent): CharacterStyle {\r\n        this.runProperties.push(property);\r\n        return this;\r\n    }\r\n\r\n    public color(color: string): CharacterStyle {\r\n        return this.addRunProperty(new formatting.Color(color));\r\n    }\r\n\r\n    public underline(underlineType?: string, color?: string): CharacterStyle {\r\n        return this.addRunProperty(new formatting.Underline(underlineType, color));\r\n    }\r\n\r\n    public size(twips: number): CharacterStyle {\r\n        return this.addRunProperty(new formatting.Size(twips)).addRunProperty(new formatting.SizeComplexScript(twips));\r\n    }\r\n}\r\n\r\nexport class HyperlinkStyle extends CharacterStyle {\r\n    constructor() {\r\n        super("Hyperlink", "Hyperlink");\r\n        this.basedOn("DefaultParagraphFont")\r\n            .color("0563C1")\r\n            .underline("single");\r\n    }\r\n}\r\n\r\nexport class FootnoteReferenceStyle extends Style {\r\n    private readonly runProperties: RunProperties;\r\n\r\n    constructor() {\r\n        super({ type: "character", styleId: "FootnoteReference" });\r\n        this.root.push(new Name("footnote reference"));\r\n        this.root.push(new BasedOn("DefaultParagraphFont"));\r\n        this.root.push(new UiPriority("99"));\r\n        this.root.push(new SemiHidden());\r\n        this.root.push(new UnhideWhenUsed());\r\n\r\n        this.runProperties = new RunProperties();\r\n        this.runProperties.addChildElement(new formatting.SuperScript());\r\n        this.root.push(this.runProperties);\r\n    }\r\n}\r\n\r\nexport class FootnoteText extends ParagraphStyle {\r\n    constructor() {\r\n        super("FootnoteText");\r\n        this.root.push(new Name("footnote text"));\r\n        this.root.push(new BasedOn("Normal"));\r\n        this.root.push(new Link("FootnoteTextChar"));\r\n        this.root.push(new UiPriority("99"));\r\n        this.root.push(new SemiHidden());\r\n        this.root.push(new UnhideWhenUsed());\r\n        this.spacing({\r\n            after: 0,\r\n            line: 240,\r\n            lineRule: "auto",\r\n        });\r\n        this.size(20);\r\n    }\r\n}\r\n\r\nexport class FootnoteTextChar extends CharacterStyle {\r\n    constructor() {\r\n        super("FootnoteTextChar", "Footnote Text Char");\r\n        this.basedOn("DefaultParagraphFont");\r\n        this.root.push(new Link("FootnoteText"));\r\n        this.root.push(new UiPriority("99"));\r\n        this.root.push(new SemiHidden());\r\n        this.size(20);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(15)),
          p = (a.s[3]++, t(21)),
          m = (a.s[4]++, t(0)),
          C = (a.s[5]++, t(282));

      var d =
      /*#__PURE__*/
      function (_m$XmlAttributeCompon) {
        _inherits(d, _m$XmlAttributeCompon);

        function d() {
          var _this118;

          _classCallCheck(this, d);

          a.f[0]++, a.s[6]++, _this118 = _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments)), a.s[7]++, _this118.xmlKeys = {
            type: "w:type",
            styleId: "w:styleId",
            default: "w:default",
            customStyle: "w:customStyle"
          };
          return _this118;
        }

        return d;
      }(m.XmlAttributeComponent);

      var f =
      /*#__PURE__*/
      function (_m$XmlComponent) {
        _inherits(f, _m$XmlComponent);

        function f(e, n) {
          var _this119;

          _classCallCheck(this, f);

          a.f[1]++, a.s[8]++, _this119 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "w:style")), a.s[9]++, _this119.root.push(new d(e)), a.s[10]++, n ? (a.b[0][0]++, a.s[11]++, _this119.root.push(new C.Name(n))) : a.b[0][1]++;
          return _this119;
        }

        _createClass(f, [{
          key: "push",
          value: function push(e) {
            a.f[2]++, a.s[12]++, this.root.push(e);
          }
        }]);

        return f;
      }(m.XmlComponent);

      a.s[13]++, n.Style = f;

      var h =
      /*#__PURE__*/
      function (_f) {
        _inherits(h, _f);

        function h(e, n) {
          var _this120;

          _classCallCheck(this, h);

          a.f[3]++, a.s[14]++, _this120 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, {
            type: "paragraph",
            styleId: e
          }, n)), a.s[15]++, _this120.paragraphProperties = new c.ParagraphProperties(), a.s[16]++, _this120.runProperties = new p.RunProperties(), a.s[17]++, _this120.root.push(_this120.paragraphProperties), a.s[18]++, _this120.root.push(_this120.runProperties);
          return _this120;
        }

        _createClass(h, [{
          key: "addParagraphProperty",
          value: function addParagraphProperty(e) {
            return a.f[4]++, a.s[19]++, this.paragraphProperties.push(e), a.s[20]++, this;
          }
        }, {
          key: "addRunProperty",
          value: function addRunProperty(e) {
            return a.f[5]++, a.s[21]++, this.runProperties.push(e), a.s[22]++, this;
          }
        }, {
          key: "basedOn",
          value: function basedOn(e) {
            return a.f[6]++, a.s[23]++, this.root.push(new C.BasedOn(e)), a.s[24]++, this;
          }
        }, {
          key: "quickFormat",
          value: function quickFormat() {
            return a.f[7]++, a.s[25]++, this.root.push(new C.QuickFormat()), a.s[26]++, this;
          }
        }, {
          key: "next",
          value: function next(e) {
            return a.f[8]++, a.s[27]++, this.root.push(new C.Next(e)), a.s[28]++, this;
          }
        }, {
          key: "size",
          value: function size(e) {
            return a.f[9]++, a.s[29]++, this.addRunProperty(new u.Size(e)).addRunProperty(new u.SizeComplexScript(e));
          }
        }, {
          key: "bold",
          value: function bold() {
            return a.f[10]++, a.s[30]++, this.addRunProperty(new u.Bold());
          }
        }, {
          key: "italics",
          value: function italics() {
            return a.f[11]++, a.s[31]++, this.addRunProperty(new u.Italics());
          }
        }, {
          key: "smallCaps",
          value: function smallCaps() {
            return a.f[12]++, a.s[32]++, this.addRunProperty(new u.SmallCaps());
          }
        }, {
          key: "allCaps",
          value: function allCaps() {
            return a.f[13]++, a.s[33]++, this.addRunProperty(new u.Caps());
          }
        }, {
          key: "strike",
          value: function strike() {
            return a.f[14]++, a.s[34]++, this.addRunProperty(new u.Strike());
          }
        }, {
          key: "doubleStrike",
          value: function doubleStrike() {
            return a.f[15]++, a.s[35]++, this.addRunProperty(new u.DoubleStrike());
          }
        }, {
          key: "subScript",
          value: function subScript() {
            return a.f[16]++, a.s[36]++, this.addRunProperty(new u.SubScript());
          }
        }, {
          key: "superScript",
          value: function superScript() {
            return a.f[17]++, a.s[37]++, this.addRunProperty(new u.SuperScript());
          }
        }, {
          key: "underline",
          value: function underline(e, n) {
            return a.f[18]++, a.s[38]++, this.addRunProperty(new u.Underline(e, n));
          }
        }, {
          key: "color",
          value: function color(e) {
            return a.f[19]++, a.s[39]++, this.addRunProperty(new u.Color(e));
          }
        }, {
          key: "font",
          value: function font(e) {
            return a.f[20]++, a.s[40]++, this.addRunProperty(new u.RunFonts(e));
          }
        }, {
          key: "characterSpacing",
          value: function characterSpacing(e) {
            return a.f[21]++, a.s[41]++, this.addRunProperty(new u.CharacterSpacing(e));
          }
        }, {
          key: "center",
          value: function center() {
            return a.f[22]++, a.s[42]++, this.addParagraphProperty(new c.Alignment(c.AlignmentOptions.CENTER));
          }
        }, {
          key: "left",
          value: function left() {
            return a.f[23]++, a.s[43]++, this.addParagraphProperty(new c.Alignment(c.AlignmentOptions.LEFT));
          }
        }, {
          key: "right",
          value: function right() {
            return a.f[24]++, a.s[44]++, this.addParagraphProperty(new c.Alignment(c.AlignmentOptions.RIGHT));
          }
        }, {
          key: "justified",
          value: function justified() {
            return a.f[25]++, a.s[45]++, this.addParagraphProperty(new c.Alignment(c.AlignmentOptions.BOTH));
          }
        }, {
          key: "thematicBreak",
          value: function thematicBreak() {
            return a.f[26]++, a.s[46]++, this.addParagraphProperty(new c.ThematicBreak());
          }
        }, {
          key: "maxRightTabStop",
          value: function maxRightTabStop() {
            return a.f[27]++, a.s[47]++, this.addParagraphProperty(new c.MaxRightTabStop());
          }
        }, {
          key: "leftTabStop",
          value: function leftTabStop(e) {
            return a.f[28]++, a.s[48]++, this.addParagraphProperty(new c.LeftTabStop(e));
          }
        }, {
          key: "indent",
          value: function indent(e) {
            return a.f[29]++, a.s[49]++, this.addParagraphProperty(new c.Indent(e));
          }
        }, {
          key: "spacing",
          value: function spacing(e) {
            return a.f[30]++, a.s[50]++, this.addParagraphProperty(new c.Spacing(e));
          }
        }, {
          key: "keepNext",
          value: function keepNext() {
            return a.f[31]++, a.s[51]++, this.addParagraphProperty(new c.KeepNext());
          }
        }, {
          key: "keepLines",
          value: function keepLines() {
            return a.f[32]++, a.s[52]++, this.addParagraphProperty(new c.KeepLines());
          }
        }]);

        return h;
      }(f);

      a.s[53]++, n.ParagraphStyle = h;

      var x =
      /*#__PURE__*/
      function (_h) {
        _inherits(x, _h);

        function x(e, n) {
          var _this121;

          _classCallCheck(this, x);

          a.f[33]++, a.s[54]++, _this121 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, e, n)), a.s[55]++, _this121.basedOn("Normal"), a.s[56]++, _this121.next("Normal"), a.s[57]++, _this121.quickFormat();
          return _this121;
        }

        return x;
      }(h);

      a.s[58]++, n.HeadingStyle = x, a.s[60]++, n.TitleStyle =
      /*#__PURE__*/
      function (_x) {
        _inherits(_class31, _x);

        function _class31() {
          var _this122;

          _classCallCheck(this, _class31);

          a.f[34]++, a.s[59]++, _this122 = _possibleConstructorReturn(this, _getPrototypeOf(_class31).call(this, "Title", "Title"));
          return _this122;
        }

        return _class31;
      }(x), a.s[62]++, n.Heading1Style =
      /*#__PURE__*/
      function (_x2) {
        _inherits(_class32, _x2);

        function _class32() {
          var _this123;

          _classCallCheck(this, _class32);

          a.f[35]++, a.s[61]++, _this123 = _possibleConstructorReturn(this, _getPrototypeOf(_class32).call(this, "Heading1", "Heading 1"));
          return _this123;
        }

        return _class32;
      }(x), a.s[64]++, n.Heading2Style =
      /*#__PURE__*/
      function (_x3) {
        _inherits(_class33, _x3);

        function _class33() {
          var _this124;

          _classCallCheck(this, _class33);

          a.f[36]++, a.s[63]++, _this124 = _possibleConstructorReturn(this, _getPrototypeOf(_class33).call(this, "Heading2", "Heading 2"));
          return _this124;
        }

        return _class33;
      }(x), a.s[66]++, n.Heading3Style =
      /*#__PURE__*/
      function (_x4) {
        _inherits(_class34, _x4);

        function _class34() {
          var _this125;

          _classCallCheck(this, _class34);

          a.f[37]++, a.s[65]++, _this125 = _possibleConstructorReturn(this, _getPrototypeOf(_class34).call(this, "Heading3", "Heading 3"));
          return _this125;
        }

        return _class34;
      }(x), a.s[68]++, n.Heading4Style =
      /*#__PURE__*/
      function (_x5) {
        _inherits(_class35, _x5);

        function _class35() {
          var _this126;

          _classCallCheck(this, _class35);

          a.f[38]++, a.s[67]++, _this126 = _possibleConstructorReturn(this, _getPrototypeOf(_class35).call(this, "Heading4", "Heading 4"));
          return _this126;
        }

        return _class35;
      }(x), a.s[70]++, n.Heading5Style =
      /*#__PURE__*/
      function (_x6) {
        _inherits(_class36, _x6);

        function _class36() {
          var _this127;

          _classCallCheck(this, _class36);

          a.f[39]++, a.s[69]++, _this127 = _possibleConstructorReturn(this, _getPrototypeOf(_class36).call(this, "Heading5", "Heading 5"));
          return _this127;
        }

        return _class36;
      }(x), a.s[72]++, n.Heading6Style =
      /*#__PURE__*/
      function (_x7) {
        _inherits(_class37, _x7);

        function _class37() {
          var _this128;

          _classCallCheck(this, _class37);

          a.f[40]++, a.s[71]++, _this128 = _possibleConstructorReturn(this, _getPrototypeOf(_class37).call(this, "Heading6", "Heading 6"));
          return _this128;
        }

        return _class37;
      }(x), a.s[77]++, n.ListParagraph =
      /*#__PURE__*/
      function (_h2) {
        _inherits(_class38, _h2);

        function _class38() {
          var _this129;

          _classCallCheck(this, _class38);

          a.f[41]++, a.s[73]++, _this129 = _possibleConstructorReturn(this, _getPrototypeOf(_class38).call(this, "ListParagraph")), a.s[74]++, _this129.root.push(new C.Name("List Paragraph")), a.s[75]++, _this129.root.push(new C.BasedOn("Normal")), a.s[76]++, _this129.root.push(new C.QuickFormat());
          return _this129;
        }

        return _class38;
      }(h);

      var g =
      /*#__PURE__*/
      function (_f2) {
        _inherits(g, _f2);

        function g(e, n) {
          var _this130;

          _classCallCheck(this, g);

          a.f[42]++, a.s[78]++, _this130 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, {
            type: "character",
            styleId: e
          }, n)), a.s[79]++, _this130.runProperties = new p.RunProperties(), a.s[80]++, _this130.root.push(_this130.runProperties), a.s[81]++, _this130.root.push(new C.UiPriority("99")), a.s[82]++, _this130.root.push(new C.UnhideWhenUsed());
          return _this130;
        }

        _createClass(g, [{
          key: "basedOn",
          value: function basedOn(e) {
            return a.f[43]++, a.s[83]++, this.root.push(new C.BasedOn(e)), a.s[84]++, this;
          }
        }, {
          key: "addRunProperty",
          value: function addRunProperty(e) {
            return a.f[44]++, a.s[85]++, this.runProperties.push(e), a.s[86]++, this;
          }
        }, {
          key: "color",
          value: function color(e) {
            return a.f[45]++, a.s[87]++, this.addRunProperty(new u.Color(e));
          }
        }, {
          key: "underline",
          value: function underline(e, n) {
            return a.f[46]++, a.s[88]++, this.addRunProperty(new u.Underline(e, n));
          }
        }, {
          key: "size",
          value: function size(e) {
            return a.f[47]++, a.s[89]++, this.addRunProperty(new u.Size(e)).addRunProperty(new u.SizeComplexScript(e));
          }
        }]);

        return g;
      }(f);

      a.s[90]++, n.CharacterStyle = g, a.s[93]++, n.HyperlinkStyle =
      /*#__PURE__*/
      function (_g) {
        _inherits(_class39, _g);

        function _class39() {
          var _this131;

          _classCallCheck(this, _class39);

          a.f[48]++, a.s[91]++, _this131 = _possibleConstructorReturn(this, _getPrototypeOf(_class39).call(this, "Hyperlink", "Hyperlink")), a.s[92]++, _this131.basedOn("DefaultParagraphFont").color("0563C1").underline("single");
          return _this131;
        }

        return _class39;
      }(g), a.s[103]++, n.FootnoteReferenceStyle =
      /*#__PURE__*/
      function (_f3) {
        _inherits(_class40, _f3);

        function _class40() {
          var _this132;

          _classCallCheck(this, _class40);

          a.f[49]++, a.s[94]++, _this132 = _possibleConstructorReturn(this, _getPrototypeOf(_class40).call(this, {
            type: "character",
            styleId: "FootnoteReference"
          })), a.s[95]++, _this132.root.push(new C.Name("footnote reference")), a.s[96]++, _this132.root.push(new C.BasedOn("DefaultParagraphFont")), a.s[97]++, _this132.root.push(new C.UiPriority("99")), a.s[98]++, _this132.root.push(new C.SemiHidden()), a.s[99]++, _this132.root.push(new C.UnhideWhenUsed()), a.s[100]++, _this132.runProperties = new p.RunProperties(), a.s[101]++, _this132.runProperties.addChildElement(new u.SuperScript()), a.s[102]++, _this132.root.push(_this132.runProperties);
          return _this132;
        }

        return _class40;
      }(f), a.s[113]++, n.FootnoteText =
      /*#__PURE__*/
      function (_h3) {
        _inherits(_class41, _h3);

        function _class41() {
          var _this133;

          _classCallCheck(this, _class41);

          a.f[50]++, a.s[104]++, _this133 = _possibleConstructorReturn(this, _getPrototypeOf(_class41).call(this, "FootnoteText")), a.s[105]++, _this133.root.push(new C.Name("footnote text")), a.s[106]++, _this133.root.push(new C.BasedOn("Normal")), a.s[107]++, _this133.root.push(new C.Link("FootnoteTextChar")), a.s[108]++, _this133.root.push(new C.UiPriority("99")), a.s[109]++, _this133.root.push(new C.SemiHidden()), a.s[110]++, _this133.root.push(new C.UnhideWhenUsed()), a.s[111]++, _this133.spacing({
            after: 0,
            line: 240,
            lineRule: "auto"
          }), a.s[112]++, _this133.size(20);
          return _this133;
        }

        return _class41;
      }(h), a.s[120]++, n.FootnoteTextChar =
      /*#__PURE__*/
      function (_g2) {
        _inherits(_class42, _g2);

        function _class42() {
          var _this134;

          _classCallCheck(this, _class42);

          a.f[51]++, a.s[114]++, _this134 = _possibleConstructorReturn(this, _getPrototypeOf(_class42).call(this, "FootnoteTextChar", "Footnote Text Char")), a.s[115]++, _this134.basedOn("DefaultParagraphFont"), a.s[116]++, _this134.root.push(new C.Link("FootnoteText")), a.s[117]++, _this134.root.push(new C.UiPriority("99")), a.s[118]++, _this134.root.push(new C.SemiHidden()), a.s[119]++, _this134.size(20);
          return _this134;
        }

        return _class42;
      }(g);
    }, function (e, n, t) {
      "use strict";

      function r() {
        if (!(this instanceof r)) return new r();
        if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = {}, this.comment = null, this.root = "", this.clone = function () {
          var e = new r();

          for (var n in this) {
            "function" != typeof this[n] && (e[n] = this[n]);
          }

          return e;
        };
      }

      r.prototype = t(297), r.prototype.loadAsync = t(330), r.support = t(6), r.defaults = t(115), r.version = "3.1.5", r.loadAsync = function (e, n) {
        return new r().loadAsync(e, n);
      }, r.external = t(17), e.exports = r;
    }, function (e, n, t) {
      e.exports = t(28);
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = t(6),
          i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      n.encode = function (e) {
        for (var n, t, o, A, s, l, a, c = [], u = 0, p = e.length, m = p, C = "string" !== r.getTypeOf(e); u < e.length;) {
          m = p - u, C ? (n = e[u++], t = u < p ? e[u++] : 0, o = u < p ? e[u++] : 0) : (n = e.charCodeAt(u++), t = u < p ? e.charCodeAt(u++) : 0, o = u < p ? e.charCodeAt(u++) : 0), A = n >> 2, s = (3 & n) << 4 | t >> 4, l = m > 1 ? (15 & t) << 2 | o >> 6 : 64, a = m > 2 ? 63 & o : 64, c.push(i.charAt(A) + i.charAt(s) + i.charAt(l) + i.charAt(a));
        }

        return c.join("");
      }, n.decode = function (e) {
        var n,
            t,
            r,
            A,
            s,
            l,
            a = 0,
            c = 0;
        if ("data:" === e.substr(0, "data:".length)) throw new Error("Invalid base64 input, it looks like a data url.");
        var u,
            p = 3 * (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "")).length / 4;
        if (e.charAt(e.length - 1) === i.charAt(64) && p--, e.charAt(e.length - 2) === i.charAt(64) && p--, p % 1 != 0) throw new Error("Invalid base64 input, bad content length.");

        for (u = o.uint8array ? new Uint8Array(0 | p) : new Array(0 | p); a < e.length;) {
          n = i.indexOf(e.charAt(a++)) << 2 | (A = i.indexOf(e.charAt(a++))) >> 4, t = (15 & A) << 4 | (s = i.indexOf(e.charAt(a++))) >> 2, r = (3 & s) << 6 | (l = i.indexOf(e.charAt(a++))), u[c++] = n, 64 !== s && (u[c++] = t), 64 !== l && (u[c++] = r);
        }

        return u;
      };
    }, function (e, n) {
      var t = e.exports = {
        version: "2.3.0"
      };
      "number" == typeof __e && (__e = t);
    }, function (e, n, t) {
      var r = t(301);

      e.exports = function (e, n, t) {
        if (r(e), void 0 === n) return e;

        switch (t) {
          case 1:
            return function (t) {
              return e.call(n, t);
            };

          case 2:
            return function (t, r) {
              return e.call(n, t, r);
            };

          case 3:
            return function (t, r, o) {
              return e.call(n, t, r, o);
            };
        }

        return function () {
          return e.apply(n, arguments);
        };
      };
    }, function (e, n) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (e) {
          return !0;
        }
      };
    }, function (e, n, t) {
      var r = t(45),
          o = t(25).document,
          i = r(o) && r(o.createElement);

      e.exports = function (e) {
        return i ? o.createElement(e) : {};
      };
    }, function (e, n, t) {
      "use strict";

      (function (n) {
        var r = t(1),
            o = t(314),
            i = t(3),
            A = t(109),
            s = t(6),
            l = t(17),
            a = null;
        if (s.nodestream) try {
          a = t(315);
        } catch (e) {}

        function c(e, t) {
          return new l.Promise(function (o, i) {
            var s = [],
                l = e._internalType,
                a = e._outputType,
                c = e._mimeType;
            e.on("data", function (e, n) {
              s.push(e), t && t(n);
            }).on("error", function (e) {
              s = [], i(e);
            }).on("end", function () {
              try {
                var e = function (e, n, t) {
                  switch (e) {
                    case "blob":
                      return r.newBlob(r.transformTo("arraybuffer", n), t);

                    case "base64":
                      return A.encode(n);

                    default:
                      return r.transformTo(e, n);
                  }
                }(a, function (e, t) {
                  var r,
                      o = 0,
                      i = null,
                      A = 0;

                  for (r = 0; r < t.length; r++) {
                    A += t[r].length;
                  }

                  switch (e) {
                    case "string":
                      return t.join("");

                    case "array":
                      return Array.prototype.concat.apply([], t);

                    case "uint8array":
                      for (i = new Uint8Array(A), r = 0; r < t.length; r++) {
                        i.set(t[r], o), o += t[r].length;
                      }

                      return i;

                    case "nodebuffer":
                      return n.concat(t);

                    default:
                      throw new Error("concat : unsupported type '" + e + "'");
                  }
                }(l, s), c);

                o(e);
              } catch (e) {
                i(e);
              }

              s = [];
            }).resume();
          });
        }

        function u(e, n, t) {
          var A = n;

          switch (n) {
            case "blob":
            case "arraybuffer":
              A = "uint8array";
              break;

            case "base64":
              A = "string";
          }

          try {
            this._internalType = A, this._outputType = n, this._mimeType = t, r.checkSupport(A), this._worker = e.pipe(new o(A)), e.lock();
          } catch (e) {
            this._worker = new i("error"), this._worker.error(e);
          }
        }

        u.prototype = {
          accumulate: function accumulate(e) {
            return c(this, e);
          },
          on: function on(e, n) {
            var t = this;
            return "data" === e ? this._worker.on(e, function (e) {
              n.call(t, e.data, e.meta);
            }) : this._worker.on(e, function () {
              r.delay(n, arguments, t);
            }), this;
          },
          resume: function resume() {
            return r.delay(this._worker.resume, [], this._worker), this;
          },
          pause: function pause() {
            return this._worker.pause(), this;
          },
          toNodejsStream: function toNodejsStream(e) {
            if (r.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
            return new a(this, {
              objectMode: "nodebuffer" !== this._outputType
            }, e);
          }
        }, e.exports = u;
      }).call(n, t(5).Buffer);
    }, function (e, n, t) {
      "use strict";

      n.base64 = !1, n.binary = !1, n.dir = !1, n.createFolders = !0, n.date = null, n.compression = null, n.compressionOptions = null, n.comment = null, n.unixPermissions = null, n.dosPermissions = null;
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = t(3);

      function i(e) {
        o.call(this, "DataWorker");
        var n = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function (e) {
          n.dataIsReady = !0, n.data = e, n.max = e && e.length || 0, n.type = r.getTypeOf(e), n.isPaused || n._tickAndRepeat();
        }, function (e) {
          n.error(e);
        });
      }

      r.inherits(i, o), i.prototype.cleanUp = function () {
        o.prototype.cleanUp.call(this), this.data = null;
      }, i.prototype.resume = function () {
        return !!o.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, r.delay(this._tickAndRepeat, [], this)), !0);
      }, i.prototype._tickAndRepeat = function () {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (r.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, i.prototype._tick = function () {
        if (this.isPaused || this.isFinished) return !1;
        var e = null,
            n = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max) return this.end();

        switch (this.type) {
          case "string":
            e = this.data.substring(this.index, n);
            break;

          case "uint8array":
            e = this.data.subarray(this.index, n);
            break;

          case "array":
          case "nodebuffer":
            e = this.data.slice(this.index, n);
        }

        return this.index = n, this.push({
          data: e,
          meta: {
            percent: this.max ? this.index / this.max * 100 : 0
          }
        });
      }, e.exports = i;
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = t(3);

      function i(e) {
        o.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
      }

      r.inherits(i, o), i.prototype.processChunk = function (e) {
        if (e) {
          var n = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = n + e.data.length;
        }

        o.prototype.processChunk.call(this, e);
      }, e.exports = i;
    }, function (e, n, t) {
      "use strict";

      var r = t(3),
          o = t(48);

      function i() {
        r.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }

      t(1).inherits(i, r), i.prototype.processChunk = function (e) {
        this.streamInfo.crc32 = o(e.data, this.streamInfo.crc32 || 0), this.push(e);
      }, e.exports = i;
    }, function (e, n, t) {
      "use strict";

      var r = t(3);
      n.STORE = {
        magic: "\0\0",
        compressWorker: function compressWorker(e) {
          return new r("STORE compression");
        },
        uncompressWorker: function uncompressWorker() {
          return new r("STORE decompression");
        }
      }, n.DEFLATE = t(318);
    }, function (e, n, t) {
      "use strict";

      e.exports = function (e, n, t, r) {
        for (var o = 65535 & e | 0, i = e >>> 16 & 65535 | 0, A = 0; 0 !== t;) {
          t -= A = t > 2e3 ? 2e3 : t;

          do {
            i = i + (o = o + n[r++] | 0) | 0;
          } while (--A);

          o %= 65521, i %= 65521;
        }

        return o | i << 16 | 0;
      };
    }, function (e, n, t) {
      "use strict";

      var r = function () {
        for (var e, n = [], t = 0; t < 256; t++) {
          e = t;

          for (var r = 0; r < 8; r++) {
            e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
          }

          n[t] = e;
        }

        return n;
      }();

      e.exports = function (e, n, t, o) {
        var i = r,
            A = o + t;
        e ^= -1;

        for (var s = o; s < A; s++) {
          e = e >>> 8 ^ i[255 & (e ^ n[s])];
        }

        return -1 ^ e;
      };
    }, function (e, n, t) {
      "use strict";

      var r = t(7),
          o = !0,
          i = !0;

      try {
        String.fromCharCode.apply(null, [0]);
      } catch (e) {
        o = !1;
      }

      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (e) {
        i = !1;
      }

      for (var A = new r.Buf8(256), s = 0; s < 256; s++) {
        A[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
      }

      function l(e, n) {
        if (n < 65537 && (e.subarray && i || !e.subarray && o)) return String.fromCharCode.apply(null, r.shrinkBuf(e, n));

        for (var t = "", A = 0; A < n; A++) {
          t += String.fromCharCode(e[A]);
        }

        return t;
      }

      A[254] = A[254] = 1, n.string2buf = function (e) {
        var n,
            t,
            o,
            i,
            A,
            s = e.length,
            l = 0;

        for (i = 0; i < s; i++) {
          55296 == (64512 & (t = e.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (o = e.charCodeAt(i + 1))) && (t = 65536 + (t - 55296 << 10) + (o - 56320), i++), l += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
        }

        for (n = new r.Buf8(l), A = 0, i = 0; A < l; i++) {
          55296 == (64512 & (t = e.charCodeAt(i))) && i + 1 < s && 56320 == (64512 & (o = e.charCodeAt(i + 1))) && (t = 65536 + (t - 55296 << 10) + (o - 56320), i++), t < 128 ? n[A++] = t : t < 2048 ? (n[A++] = 192 | t >>> 6, n[A++] = 128 | 63 & t) : t < 65536 ? (n[A++] = 224 | t >>> 12, n[A++] = 128 | t >>> 6 & 63, n[A++] = 128 | 63 & t) : (n[A++] = 240 | t >>> 18, n[A++] = 128 | t >>> 12 & 63, n[A++] = 128 | t >>> 6 & 63, n[A++] = 128 | 63 & t);
        }

        return n;
      }, n.buf2binstring = function (e) {
        return l(e, e.length);
      }, n.binstring2buf = function (e) {
        for (var n = new r.Buf8(e.length), t = 0, o = n.length; t < o; t++) {
          n[t] = e.charCodeAt(t);
        }

        return n;
      }, n.buf2string = function (e, n) {
        var t,
            r,
            o,
            i,
            s = n || e.length,
            a = new Array(2 * s);

        for (r = 0, t = 0; t < s;) {
          if ((o = e[t++]) < 128) a[r++] = o;else if ((i = A[o]) > 4) a[r++] = 65533, t += i - 1;else {
            for (o &= 2 === i ? 31 : 3 === i ? 15 : 7; i > 1 && t < s;) {
              o = o << 6 | 63 & e[t++], i--;
            }

            i > 1 ? a[r++] = 65533 : o < 65536 ? a[r++] = o : (o -= 65536, a[r++] = 55296 | o >> 10 & 1023, a[r++] = 56320 | 1023 & o);
          }
        }

        return l(a, r);
      }, n.utf8border = function (e, n) {
        var t;

        for ((n = n || e.length) > e.length && (n = e.length), t = n - 1; t >= 0 && 128 == (192 & e[t]);) {
          t--;
        }

        return t < 0 ? n : 0 === t ? n : t + A[e[t]] > n ? t : n;
      };
    }, function (e, n, t) {
      "use strict";

      e.exports = function () {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, function (e, n, t) {
      "use strict";

      e.exports = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
      };
    }, function (e, n, t) {
      "use strict";

      n.LOCAL_FILE_HEADER = "PK", n.CENTRAL_FILE_HEADER = "PK", n.CENTRAL_DIRECTORY_END = "PK", n.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", n.ZIP64_CENTRAL_DIRECTORY_END = "PK", n.DATA_DESCRIPTOR = "PK\b";
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = t(6),
          i = t(127),
          A = t(332),
          s = t(333),
          l = t(129);

      e.exports = function (e) {
        var n = r.getTypeOf(e);
        return r.checkSupport(n), "string" !== n || o.uint8array ? "nodebuffer" === n ? new s(e) : o.uint8array ? new l(r.transformTo("uint8array", e)) : new i(r.transformTo("array", e)) : new A(e);
      };
    }, function (e, n, t) {
      "use strict";

      var r = t(128);

      function o(e) {
        r.call(this, e);

        for (var n = 0; n < this.data.length; n++) {
          e[n] = 255 & e[n];
        }
      }

      t(1).inherits(o, r), o.prototype.byteAt = function (e) {
        return this.data[this.zero + e];
      }, o.prototype.lastIndexOfSignature = function (e) {
        for (var n = e.charCodeAt(0), t = e.charCodeAt(1), r = e.charCodeAt(2), o = e.charCodeAt(3), i = this.length - 4; i >= 0; --i) {
          if (this.data[i] === n && this.data[i + 1] === t && this.data[i + 2] === r && this.data[i + 3] === o) return i - this.zero;
        }

        return -1;
      }, o.prototype.readAndCheckSignature = function (e) {
        var n = e.charCodeAt(0),
            t = e.charCodeAt(1),
            r = e.charCodeAt(2),
            o = e.charCodeAt(3),
            i = this.readData(4);
        return n === i[0] && t === i[1] && r === i[2] && o === i[3];
      }, o.prototype.readData = function (e) {
        if (this.checkOffset(e), 0 === e) return [];
        var n = this.data.slice(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, n;
      }, e.exports = o;
    }, function (e, n, t) {
      "use strict";

      var r = t(1);

      function o(e) {
        this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
      }

      o.prototype = {
        checkOffset: function checkOffset(e) {
          this.checkIndex(this.index + e);
        },
        checkIndex: function checkIndex(e) {
          if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
        },
        setIndex: function setIndex(e) {
          this.checkIndex(e), this.index = e;
        },
        skip: function skip(e) {
          this.setIndex(this.index + e);
        },
        byteAt: function byteAt(e) {},
        readInt: function readInt(e) {
          var n,
              t = 0;

          for (this.checkOffset(e), n = this.index + e - 1; n >= this.index; n--) {
            t = (t << 8) + this.byteAt(n);
          }

          return this.index += e, t;
        },
        readString: function readString(e) {
          return r.transformTo("string", this.readData(e));
        },
        readData: function readData(e) {},
        lastIndexOfSignature: function lastIndexOfSignature(e) {},
        readAndCheckSignature: function readAndCheckSignature(e) {},
        readDate: function readDate() {
          var e = this.readInt(4);
          return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
        }
      }, e.exports = o;
    }, function (e, n, t) {
      "use strict";

      var r = t(127);

      function o(e) {
        r.call(this, e);
      }

      t(1).inherits(o, r), o.prototype.readData = function (e) {
        if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
        var n = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, n;
      }, e.exports = o;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\index.ts", o = "cc535db5c251802b3613f5bfd097b2d096309d77", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 13
            },
            end: {
              line: 6,
              column: 30
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 31
            }
          },
          6: {
            start: {
              line: 8,
              column: 0
            },
            end: {
              line: 8,
              column: 28
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 30
            }
          },
          8: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 35
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\index.ts"],
          names: [],
          mappings: ";;;;;AAEA,+BAA0C;AAAjC,0BAAA,IAAI,CAAY;AACzB,4BAAuB;AACvB,8BAAyB;AACzB,mCAA8B",
          sourcesContent: ['// Internally, the wrapper is a \'File\', but export to the end user as a \'Document\'\r\n// Use of \'File\' also works\r\nexport { File as Document } from "./file";\r\nexport * from "./file";\r\nexport * from "./export";\r\nexport * from "./import-dotx";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var u = (a.s[4]++, t(26));
      a.s[5]++, n.Document = u.File, a.s[6]++, c(t(26)), a.s[7]++, c(t(294)), a.s[8]++, c(t(338));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\xml-component.ts", o = "d4c6f2424ee4e43036025ebd033014e9fbc1f1f1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\xml-component.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 15
            },
            end: {
              line: 3,
              column: 32
            }
          },
          2: {
            start: {
              line: 4,
              column: 0
            },
            end: {
              line: 4,
              column: 51
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 23
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 32
            }
          },
          5: {
            start: {
              line: 11,
              column: 25
            },
            end: {
              line: 24,
              column: 49
            }
          },
          6: {
            start: {
              line: 13,
              column: 12
            },
            end: {
              line: 15,
              column: 13
            }
          },
          7: {
            start: {
              line: 14,
              column: 16
            },
            end: {
              line: 14,
              column: 36
            }
          },
          8: {
            start: {
              line: 16,
              column: 12
            },
            end: {
              line: 16,
              column: 24
            }
          },
          9: {
            start: {
              line: 19,
              column: 12
            },
            end: {
              line: 21,
              column: 13
            }
          },
          10: {
            start: {
              line: 20,
              column: 16
            },
            end: {
              line: 20,
              column: 41
            }
          },
          11: {
            start: {
              line: 22,
              column: 12
            },
            end: {
              line: 22,
              column: 24
            }
          },
          12: {
            start: {
              line: 24,
              column: 30
            },
            end: {
              line: 24,
              column: 48
            }
          },
          13: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 27,
              column: 10
            }
          },
          14: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 30
            }
          },
          15: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 20
            }
          },
          16: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 28
            }
          },
          17: {
            start: {
              line: 37,
              column: 0
            },
            end: {
              line: 37,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 25
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 17
              },
              end: {
                line: 28,
                column: 5
              }
            },
            line: 10
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 12,
                column: 20
              },
              end: {
                line: 12,
                column: 21
              }
            },
            loc: {
              start: {
                line: 12,
                column: 27
              },
              end: {
                line: 17,
                column: 9
              }
            },
            line: 12
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 18,
                column: 17
              },
              end: {
                line: 18,
                column: 18
              }
            },
            loc: {
              start: {
                line: 18,
                column: 27
              },
              end: {
                line: 23,
                column: 9
              }
            },
            line: 18
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 24,
                column: 20
              },
              end: {
                line: 24,
                column: 21
              }
            },
            loc: {
              start: {
                line: 24,
                column: 30
              },
              end: {
                line: 24,
                column: 48
              }
            },
            line: 24
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 29,
                column: 4
              },
              end: {
                line: 29,
                column: 5
              }
            },
            loc: {
              start: {
                line: 29,
                column: 27
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 29
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 33,
                column: 4
              },
              end: {
                line: 33,
                column: 5
              }
            },
            loc: {
              start: {
                line: 33,
                column: 13
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 33
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 13,
                column: 12
              },
              end: {
                line: 15,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 13,
                column: 12
              },
              end: {
                line: 15,
                column: 13
              }
            }, {
              start: {
                line: 13,
                column: 12
              },
              end: {
                line: 15,
                column: 13
              }
            }],
            line: 13
          },
          1: {
            loc: {
              start: {
                line: 19,
                column: 12
              },
              end: {
                line: 21,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 19,
                column: 12
              },
              end: {
                line: 21,
                column: 13
              }
            }, {
              start: {
                line: 19,
                column: 12
              },
              end: {
                line: 21,
                column: 13
              }
            }],
            line: 19
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/xml-component.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\xml-component.ts"],
          names: [],
          mappings: ";;AAAA,iCAA0C;AAEjC,2BAFA,uBAAgB,CAEA;AAEzB,kBAAmC,SAAQ,uBAAgB;IAIvD,YAAY,OAAe;QACvB,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,GAAG,IAAI,KAAK,EAA6B,CAAC;IACvD,CAAC;IAEM,UAAU;QACb,MAAM,QAAQ,GAAG,IAAI,CAAC,IAAI;aACrB,MAAM,CAAC,CAAC,CAAC,EAAE,EAAE;YACV,IAAI,CAAC,YAAY,uBAAgB,EAAE;gBAC/B,OAAO,CAAC,CAAC,CAAC,SAAS,CAAC;aACvB;YACD,OAAO,IAAI,CAAC;QAChB,CAAC,CAAC;aACD,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE;YACV,IAAI,IAAI,YAAY,uBAAgB,EAAE;gBAClC,OAAO,IAAI,CAAC,UAAU,EAAE,CAAC;aAC5B;YACD,OAAO,IAAI,CAAC;QAChB,CAAC,CAAC;aACD,MAAM,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,KAAK,SAAS,CAAC,CAAC;QAC1C,OAAO;YACH,CAAC,IAAI,CAAC,OAAO,CAAC,EAAE,QAAQ;SAC3B,CAAC;IACN,CAAC;IAEM,eAAe,CAAC,KAA4B;QAC/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;QAEtB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM;QACT,IAAI,CAAC,OAAO,GAAG,IAAI,CAAC;IACxB,CAAC;CACJ;AAtCD,oCAsCC",
          sourcesContent: ['import { BaseXmlComponent } from "./base";\r\nimport { IXmlableObject } from "./xmlable-object";\r\nexport { BaseXmlComponent };\r\n\r\nexport abstract class XmlComponent extends BaseXmlComponent {\r\n    // tslint:disable-next-line:readonly-keyword\r\n    protected root: Array<BaseXmlComponent | string>;\r\n\r\n    constructor(rootKey: string) {\r\n        super(rootKey);\r\n        this.root = new Array<BaseXmlComponent | string>();\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        const children = this.root\r\n            .filter((c) => {\r\n                if (c instanceof BaseXmlComponent) {\r\n                    return !c.IsDeleted;\r\n                }\r\n                return true;\r\n            })\r\n            .map((comp) => {\r\n                if (comp instanceof BaseXmlComponent) {\r\n                    return comp.prepForXml();\r\n                }\r\n                return comp;\r\n            })\r\n            .filter((comp) => comp !== undefined); // Exclude undefined\r\n        return {\r\n            [this.rootKey]: children,\r\n        };\r\n    }\r\n\r\n    public addChildElement(child: XmlComponent | string): XmlComponent {\r\n        this.root.push(child);\r\n\r\n        return this;\r\n    }\r\n\r\n    public delete(): void {\r\n        this.deleted = true;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(52));
      a.s[2]++, n.BaseXmlComponent = c.BaseXmlComponent;

      var u =
      /*#__PURE__*/
      function (_c$BaseXmlComponent2) {
        _inherits(u, _c$BaseXmlComponent2);

        function u(e) {
          var _this135;

          _classCallCheck(this, u);

          a.f[0]++, a.s[3]++, _this135 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, e)), a.s[4]++, _this135.root = new Array();
          return _this135;
        }

        _createClass(u, [{
          key: "prepForXml",
          value: function prepForXml() {
            a.f[1]++;
            var e = (a.s[5]++, this.root.filter(function (e) {
              return a.f[2]++, a.s[6]++, e instanceof c.BaseXmlComponent ? (a.b[0][0]++, a.s[7]++, !e.IsDeleted) : (a.b[0][1]++, a.s[8]++, !0);
            }).map(function (e) {
              return a.f[3]++, a.s[9]++, e instanceof c.BaseXmlComponent ? (a.b[1][0]++, a.s[10]++, e.prepForXml()) : (a.b[1][1]++, a.s[11]++, e);
            }).filter(function (e) {
              return a.f[4]++, a.s[12]++, void 0 !== e;
            }));
            return a.s[13]++, _defineProperty({}, this.rootKey, e);
          }
        }, {
          key: "addChildElement",
          value: function addChildElement(e) {
            return a.f[5]++, a.s[14]++, this.root.push(e), a.s[15]++, this;
          }
        }, {
          key: "delete",
          value: function _delete() {
            a.f[6]++, a.s[16]++, this.deleted = !0;
          }
        }]);

        return u;
      }(c.BaseXmlComponent);

      a.s[17]++, n.XmlComponent = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\attributes.ts", o = "e618c6040445c93e5cc17ae08f306b210cd20977", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 29
            },
            end: {
              line: 3,
              column: 60
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 27,
              column: 10
            }
          },
          4: {
            start: {
              line: 30,
              column: 0
            },
            end: {
              line: 30,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 28,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\attributes.ts"],
          names: [],
          mappings: ";;AAAA,6DAA6D;AAwB7D,gBAAwB,SAAQ,0CAA4C;IAA5E;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,OAAO;YACZ,KAAK,EAAE,SAAS;YAChB,KAAK,EAAE,SAAS;YAChB,EAAE,EAAE,MAAM;YACV,IAAI,EAAE,QAAQ;YACd,KAAK,EAAE,SAAS;YAChB,OAAO,EAAE,WAAW;YACpB,QAAQ,EAAE,YAAY;YACtB,CAAC,EAAE,KAAK;YACR,CAAC,EAAE,KAAK;YACR,GAAG,EAAE,OAAO;YACZ,KAAK,EAAE,SAAS;YAChB,MAAM,EAAE,UAAU;YAClB,IAAI,EAAE,QAAQ;YACd,MAAM,EAAE,UAAU;YAClB,MAAM,EAAE,UAAU;YAClB,MAAM,EAAE,UAAU;YAClB,SAAS,EAAE,aAAa;YACxB,GAAG,EAAE,OAAO;SACf,CAAC;IACN,CAAC;CAAA;AAtBD,gCAsBC",
          sourcesContent: ['import { XmlAttributeComponent } from "./default-attributes";\r\n\r\nexport interface IAttributesProperties {\r\n    readonly val?: string | number | boolean;\r\n    readonly color?: string;\r\n    readonly space?: string;\r\n    readonly sz?: string;\r\n    readonly type?: string;\r\n    readonly rsidR?: string;\r\n    readonly rsidRPr?: string;\r\n    readonly rsidSect?: string;\r\n    readonly w?: string;\r\n    readonly h?: string;\r\n    readonly top?: string;\r\n    readonly right?: string;\r\n    readonly bottom?: string;\r\n    readonly left?: string;\r\n    readonly header?: string;\r\n    readonly footer?: string;\r\n    readonly gutter?: string;\r\n    readonly linePitch?: string;\r\n    readonly pos?: string | number; // Little strange. Perhaps it is normal. Need to clarify in the spec.\r\n}\r\n\r\nexport class Attributes extends XmlAttributeComponent<IAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        val: "w:val",\r\n        color: "w:color",\r\n        space: "w:space",\r\n        sz: "w:sz",\r\n        type: "w:type",\r\n        rsidR: "w:rsidR",\r\n        rsidRPr: "w:rsidRPr",\r\n        rsidSect: "w:rsidSect",\r\n        w: "w:w",\r\n        h: "w:h",\r\n        top: "w:top",\r\n        right: "w:right",\r\n        bottom: "w:bottom",\r\n        left: "w:left",\r\n        header: "w:header",\r\n        footer: "w:footer",\r\n        gutter: "w:gutter",\r\n        linePitch: "w:linePitch",\r\n        pos: "w:pos",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(53));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon23) {
        _inherits(u, _c$XmlAttributeCompon23);

        function u() {
          var _this136;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this136 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this136.xmlKeys = {
            val: "w:val",
            color: "w:color",
            space: "w:space",
            sz: "w:sz",
            type: "w:type",
            rsidR: "w:rsidR",
            rsidRPr: "w:rsidRPr",
            rsidSect: "w:rsidSect",
            w: "w:w",
            h: "w:h",
            top: "w:top",
            right: "w:right",
            bottom: "w:bottom",
            left: "w:left",
            header: "w:header",
            footer: "w:footer",
            gutter: "w:gutter",
            linePitch: "w:linePitch",
            pos: "w:pos"
          };
          return _this136;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.Attributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\imported-xml-component.ts", o = "723eb8c861d9d7cc1b0bb44febde9859ee05f015", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\imported-xml-component.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 17
            },
            end: {
              line: 3,
              column: 34
            }
          },
          2: {
            start: {
              line: 4,
              column: 11
            },
            end: {
              line: 4,
              column: 23
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 22,
              column: 5
            }
          },
          4: {
            start: {
              line: 9,
              column: 33
            },
            end: {
              line: 9,
              column: 91
            }
          },
          5: {
            start: {
              line: 10,
              column: 33
            },
            end: {
              line: 10,
              column: 55
            }
          },
          6: {
            start: {
              line: 11,
              column: 12
            },
            end: {
              line: 16,
              column: 13
            }
          },
          7: {
            start: {
              line: 12,
              column: 30
            },
            end: {
              line: 12,
              column: 61
            }
          },
          8: {
            start: {
              line: 13,
              column: 16
            },
            end: {
              line: 15,
              column: 17
            }
          },
          9: {
            start: {
              line: 14,
              column: 20
            },
            end: {
              line: 14,
              column: 45
            }
          },
          10: {
            start: {
              line: 17,
              column: 12
            },
            end: {
              line: 17,
              column: 32
            }
          },
          11: {
            start: {
              line: 19,
              column: 12
            },
            end: {
              line: 19,
              column: 32
            }
          },
          12: {
            start: {
              line: 21,
              column: 12
            },
            end: {
              line: 21,
              column: 29
            }
          },
          13: {
            start: {
              line: 24,
              column: 0
            },
            end: {
              line: 24,
              column: 54
            }
          },
          14: {
            start: {
              line: 27,
              column: 23
            },
            end: {
              line: 27,
              column: 75
            }
          },
          15: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 45
            }
          },
          16: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 23
            }
          },
          17: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 34,
              column: 9
            }
          },
          18: {
            start: {
              line: 33,
              column: 12
            },
            end: {
              line: 33,
              column: 31
            }
          },
          19: {
            start: {
              line: 37,
              column: 23
            },
            end: {
              line: 37,
              column: 41
            }
          },
          20: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 40,
              column: 9
            }
          },
          21: {
            start: {
              line: 39,
              column: 12
            },
            end: {
              line: 39,
              column: 29
            }
          },
          22: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 46,
              column: 9
            }
          },
          23: {
            start: {
              line: 42,
              column: 12
            },
            end: {
              line: 44,
              column: 13
            }
          },
          24: {
            start: {
              line: 43,
              column: 16
            },
            end: {
              line: 43,
              column: 62
            }
          },
          25: {
            start: {
              line: 45,
              column: 12
            },
            end: {
              line: 45,
              column: 64
            }
          },
          26: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 22
            }
          },
          27: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 37
            }
          },
          28: {
            start: {
              line: 53,
              column: 0
            },
            end: {
              line: 53,
              column: 52
            }
          },
          29: {
            start: {
              line: 56,
              column: 8
            },
            end: {
              line: 56,
              column: 18
            }
          },
          30: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 27
            }
          },
          31: {
            start: {
              line: 60,
              column: 8
            },
            end: {
              line: 62,
              column: 10
            }
          },
          32: {
            start: {
              line: 65,
              column: 0
            },
            end: {
              line: 65,
              column: 70
            }
          }
        },
        fnMap: {
          0: {
            name: "convertToXmlComponent",
            decl: {
              start: {
                line: 5,
                column: 9
              },
              end: {
                line: 5,
                column: 30
              }
            },
            loc: {
              start: {
                line: 5,
                column: 40
              },
              end: {
                line: 23,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 42
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 26
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 32
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 30
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 36,
                column: 4
              },
              end: {
                line: 36,
                column: 5
              }
            },
            loc: {
              start: {
                line: 36,
                column: 17
              },
              end: {
                line: 48,
                column: 5
              }
            },
            line: 36
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 49,
                column: 4
              },
              end: {
                line: 49,
                column: 5
              }
            },
            loc: {
              start: {
                line: 49,
                column: 23
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 49
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 55,
                column: 4
              },
              end: {
                line: 55,
                column: 5
              }
            },
            loc: {
              start: {
                line: 55,
                column: 23
              },
              end: {
                line: 58,
                column: 5
              }
            },
            line: 55
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 59,
                column: 4
              },
              end: {
                line: 59,
                column: 5
              }
            },
            loc: {
              start: {
                line: 59,
                column: 17
              },
              end: {
                line: 63,
                column: 5
              }
            },
            line: 59
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 22,
                column: 5
              }
            },
            type: "switch",
            locations: [{
              start: {
                line: 7,
                column: 8
              },
              end: {
                line: 7,
                column: 23
              }
            }, {
              start: {
                line: 8,
                column: 8
              },
              end: {
                line: 17,
                column: 32
              }
            }, {
              start: {
                line: 18,
                column: 8
              },
              end: {
                line: 19,
                column: 32
              }
            }, {
              start: {
                line: 20,
                column: 8
              },
              end: {
                line: 21,
                column: 29
              }
            }],
            line: 6
          },
          1: {
            loc: {
              start: {
                line: 10,
                column: 33
              },
              end: {
                line: 10,
                column: 55
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 10,
                column: 33
              },
              end: {
                line: 10,
                column: 49
              }
            }, {
              start: {
                line: 10,
                column: 53
              },
              end: {
                line: 10,
                column: 55
              }
            }],
            line: 10
          },
          2: {
            loc: {
              start: {
                line: 13,
                column: 16
              },
              end: {
                line: 15,
                column: 17
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 13,
                column: 16
              },
              end: {
                line: 15,
                column: 17
              }
            }, {
              start: {
                line: 13,
                column: 16
              },
              end: {
                line: 15,
                column: 17
              }
            }],
            line: 13
          },
          3: {
            loc: {
              start: {
                line: 32,
                column: 8
              },
              end: {
                line: 34,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 32,
                column: 8
              },
              end: {
                line: 34,
                column: 9
              }
            }, {
              start: {
                line: 32,
                column: 8
              },
              end: {
                line: 34,
                column: 9
              }
            }],
            line: 32
          },
          4: {
            loc: {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }, {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }],
            line: 38
          },
          5: {
            loc: {
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 46,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 46,
                column: 9
              }
            }, {
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 46,
                column: 9
              }
            }],
            line: 41
          },
          6: {
            loc: {
              start: {
                line: 42,
                column: 12
              },
              end: {
                line: 44,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 42,
                column: 12
              },
              end: {
                line: 44,
                column: 13
              }
            }, {
              start: {
                line: 42,
                column: 12
              },
              end: {
                line: 44,
                column: 13
              }
            }],
            line: 42
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        b: {
          0: [0, 0, 0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0],
          6: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/imported-xml-component.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\imported-xml-component.ts"],
          names: [],
          mappings: ";;AACA,mCAAuD;AACvD,wBAAiD;AAOjD,+BAAsC,OAAmB;IACrD,QAAQ,OAAO,CAAC,IAAI,EAAE;QAClB,KAAK,SAAS,CAAC;QACf,KAAK,SAAS;YACV,MAAM,YAAY,GAAG,IAAI,oBAAoB,CAAC,OAAO,CAAC,IAAc,EAAE,OAAO,CAAC,UAAU,CAAC,CAAC;YAC1F,MAAM,YAAY,GAAG,OAAO,CAAC,QAAQ,IAAI,EAAE,CAAC;YAC5C,KAAK,MAAM,QAAQ,IAAI,YAAY,EAAE;gBACjC,MAAM,KAAK,GAAG,qBAAqB,CAAC,QAAQ,CAAC,CAAC;gBAC9C,IAAI,KAAK,KAAK,SAAS,EAAE;oBACrB,YAAY,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;iBAC5B;aACJ;YACD,OAAO,YAAY,CAAC;QACxB,KAAK,MAAM;YACP,OAAO,OAAO,CAAC,IAAc,CAAC;QAClC;YACI,OAAO,SAAS,CAAC;KACxB;AACL,CAAC;AAlBD,sDAkBC;AAKD,0BAAkC,SAAQ,eAAY;IAM3C,MAAM,CAAC,aAAa,CAAC,eAAuB;QAC/C,MAAM,MAAM,GAAG,eAAM,CAAC,eAAe,EAAE,EAAE,OAAO,EAAE,KAAK,EAAE,CAAe,CAAC;QACzE,OAAO,qBAAqB,CAAC,MAAM,CAAyB,CAAC;IACjE,CAAC;IAWD,YAAY,OAAe,EAAE,KAAW;QACpC,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,KAAK,EAAE;YACP,IAAI,CAAC,KAAK,GAAG,KAAK,CAAC;SACtB;IACL,CAAC;IA4BM,UAAU;QACb,MAAM,MAAM,GAAG,KAAK,CAAC,UAAU,EAAE,CAAC;QAClC,IAAI,CAAC,MAAM,EAAE;YACT,OAAO,SAAS,CAAC;SACpB;QAED,IAAI,CAAC,CAAC,IAAI,CAAC,KAAK,EAAE;YACd,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,MAAM,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC,EAAE;gBACtC,MAAM,CAAC,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,MAAM,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC,CAAC;aACjD;YACD,MAAM,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC,OAAO,CAAC,EAAE,KAAK,EAAE,IAAI,CAAC,KAAK,EAAE,CAAC,CAAC;SACvD;QACD,OAAO,MAAM,CAAC;IAClB,CAAC;IAEM,IAAI,CAAC,YAAmC;QAC3C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,YAAY,CAAC,CAAC;IACjC,CAAC;CACJ;AAvED,oDAuEC;AAKD,mCAA2C,SAAQ,eAAY;IAE3D,YAA6B,KAAU;QACnC,KAAK,CAAC,EAAE,CAAC,CAAC;QADe,UAAK,GAAL,KAAK,CAAK;IAEvC,CAAC;IAEM,UAAU;QACb,OAAO;YACH,KAAK,EAAE,IAAI,CAAC,KAAK;SACpB,CAAC;IACN,CAAC;CACJ;AAXD,sEAWC",
          sourcesContent: ['// tslint:disable:no-any\r\nimport { Element as XmlElement, xml2js } from "xml-js";\r\nimport { IXmlableObject, XmlComponent } from ".";\r\n\r\n/**\r\n * Converts the given xml element (in json format) into XmlComponent.\r\n * @param element the xml element in json presentation\r\n */\r\n\r\nexport function convertToXmlComponent(element: XmlElement): ImportedXmlComponent | string | undefined {\r\n    switch (element.type) {\r\n        case undefined:\r\n        case "element":\r\n            const xmlComponent = new ImportedXmlComponent(element.name as string, element.attributes);\r\n            const childElments = element.elements || [];\r\n            for (const childElm of childElments) {\r\n                const child = convertToXmlComponent(childElm);\r\n                if (child !== undefined) {\r\n                    xmlComponent.push(child);\r\n                }\r\n            }\r\n            return xmlComponent;\r\n        case "text":\r\n            return element.text as string;\r\n        default:\r\n            return undefined;\r\n    }\r\n}\r\n\r\n/**\r\n * Represents imported xml component from xml file.\r\n */\r\nexport class ImportedXmlComponent extends XmlComponent {\r\n    /**\r\n     * Converts the xml string to a XmlComponent tree.\r\n     *\r\n     * @param importedContent xml content of the imported component\r\n     */\r\n    public static fromXmlString(importedContent: string): ImportedXmlComponent {\r\n        const xmlObj = xml2js(importedContent, { compact: false }) as XmlElement;\r\n        return convertToXmlComponent(xmlObj) as ImportedXmlComponent;\r\n    }\r\n    /**\r\n     * Converts the xml string to a XmlComponent tree.\r\n     *\r\n     * @param importedContent xml content of the imported component\r\n     */\r\n\r\n    // tslint:disable-next-line:variable-name\r\n    private readonly _attr: any;\r\n\r\n    // tslint:disable-next-line:variable-name\r\n    constructor(rootKey: string, _attr?: any) {\r\n        super(rootKey);\r\n        if (_attr) {\r\n            this._attr = _attr;\r\n        }\r\n    }\r\n\r\n    /**\r\n     * Transforms the object so it can be converted to xml. Example:\r\n     * <w:someKey someAttr="1" otherAttr="11">\r\n     *    <w:child childAttr="2">\r\n     *    </w:child>\r\n     * </w:someKey>\r\n     * {\r\n     *   \'w:someKey\': [\r\n     *      {\r\n     *          _attr: {\r\n     *              someAttr: "1",\r\n     *              otherAttr: "11"\r\n     *          }\r\n     *      },\r\n     *      {\r\n     *          \'w:child\': [\r\n     *              {\r\n     *                  _attr: {\r\n     *                      childAttr: "2"\r\n     *                  }\r\n     *              }\r\n     *           ]\r\n     *      }\r\n     *    ]\r\n     * }\r\n     */\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        const result = super.prepForXml();\r\n        if (!result) {\r\n            return undefined;\r\n        }\r\n\r\n        if (!!this._attr) {\r\n            if (!Array.isArray(result[this.rootKey])) {\r\n                result[this.rootKey] = [result[this.rootKey]];\r\n            }\r\n            result[this.rootKey].unshift({ _attr: this._attr });\r\n        }\r\n        return result;\r\n    }\r\n\r\n    public push(xmlComponent: XmlComponent | string): void {\r\n        this.root.push(xmlComponent);\r\n    }\r\n}\r\n\r\n/**\r\n * Used for the attributes of root element that is being imported.\r\n */\r\nexport class ImportedRootElementAttributes extends XmlComponent {\r\n    // tslint:disable-next-line:variable-name\r\n    constructor(private readonly _attr: any) {\r\n        super("");\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject {\r\n        return {\r\n            _attr: this._attr,\r\n        };\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(27)),
          u = (a.s[2]++, t(0));

      function p(e) {
        switch (a.f[0]++, a.s[3]++, e.type) {
          case void 0:
            a.b[0][0]++;

          case "element":
            a.b[0][1]++;

            var _n2 = (a.s[4]++, new m(e.name, e.attributes)),
                _t3 = (a.s[5]++, a.b[1][0]++, e.elements || (a.b[1][1]++, []));

            a.s[6]++;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = _t3[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _e4 = _step3.value;

                var _t4 = (a.s[7]++, p(_e4));

                a.s[8]++, void 0 !== _t4 ? (a.b[2][0]++, a.s[9]++, _n2.push(_t4)) : a.b[2][1]++;
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            return a.s[10]++, _n2;

          case "text":
            return a.b[0][2]++, a.s[11]++, e.text;

          default:
            return a.b[0][3]++, void a.s[12]++;
        }
      }

      a.s[13]++, n.convertToXmlComponent = p;

      var m =
      /*#__PURE__*/
      function (_u$XmlComponent2) {
        _inherits(m, _u$XmlComponent2);

        _createClass(m, null, [{
          key: "fromXmlString",
          value: function fromXmlString(e) {
            a.f[1]++;
            var n = (a.s[14]++, c.xml2js(e, {
              compact: !1
            }));
            return a.s[15]++, p(n);
          }
        }]);

        function m(e, n) {
          var _this137;

          _classCallCheck(this, m);

          a.f[2]++, a.s[16]++, _this137 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, e)), a.s[17]++, n ? (a.b[3][0]++, a.s[18]++, _this137._attr = n) : a.b[3][1]++;
          return _this137;
        }

        _createClass(m, [{
          key: "prepForXml",
          value: function prepForXml() {
            a.f[3]++;
            var e = (a.s[19]++, _get(_getPrototypeOf(m.prototype), "prepForXml", this).call(this));
            return a.s[20]++, e ? (a.b[4][1]++, a.s[22]++, this._attr ? (a.b[5][0]++, a.s[23]++, Array.isArray(e[this.rootKey]) ? a.b[6][1]++ : (a.b[6][0]++, a.s[24]++, e[this.rootKey] = [e[this.rootKey]]), a.s[25]++, e[this.rootKey].unshift({
              _attr: this._attr
            })) : a.b[5][1]++, a.s[26]++, e) : (a.b[4][0]++, void a.s[21]++);
          }
        }, {
          key: "push",
          value: function push(e) {
            a.f[4]++, a.s[27]++, this.root.push(e);
          }
        }]);

        return m;
      }(u.XmlComponent);

      a.s[28]++, n.ImportedXmlComponent = m;

      var C =
      /*#__PURE__*/
      function (_u$XmlComponent3) {
        _inherits(C, _u$XmlComponent3);

        function C(e) {
          var _this138;

          _classCallCheck(this, C);

          a.f[5]++, a.s[29]++, _this138 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "")), a.s[30]++, _this138._attr = e;
          return _this138;
        }

        _createClass(C, [{
          key: "prepForXml",
          value: function prepForXml() {
            return a.f[6]++, a.s[31]++, {
              _attr: this._attr
            };
          }
        }]);

        return C;
      }(u.XmlComponent);

      a.s[32]++, n.ImportedRootElementAttributes = C;
    }, function (e, n, t) {
      (function (e) {
        !function (n) {
          n.parser = function (e, n) {
            return new i(e, n);
          }, n.SAXParser = i, n.SAXStream = s, n.createStream = function (e, n) {
            return new s(e, n);
          }, n.MAX_BUFFER_LENGTH = 65536;
          var r,
              o = ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"];

          function i(e, t) {
            if (!(this instanceof i)) return new i(e, t);
            !function (e) {
              for (var n = 0, t = o.length; n < t; n++) {
                e[o[n]] = "";
              }
            }(this), this.q = this.c = "", this.bufferCheckPosition = n.MAX_BUFFER_LENGTH, this.opt = t || {}, this.opt.lowercase = this.opt.lowercase || this.opt.lowercasetags, this.looseCase = this.opt.lowercase ? "toLowerCase" : "toUpperCase", this.tags = [], this.closed = this.closedRoot = this.sawRoot = !1, this.tag = this.error = null, this.strict = !!e, this.noscript = !(!e && !this.opt.noscript), this.state = w.BEGIN, this.strictEntities = this.opt.strictEntities, this.ENTITIES = this.strictEntities ? Object.create(n.XML_ENTITIES) : Object.create(n.ENTITIES), this.attribList = [], this.opt.xmlns && (this.ns = Object.create(p)), this.trackPosition = !1 !== this.opt.position, this.trackPosition && (this.position = this.line = this.column = 0), _(this, "onready");
          }

          n.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function (e) {
            function n() {}

            return n.prototype = e, new n();
          }), Object.keys || (Object.keys = function (e) {
            var n = [];

            for (var t in e) {
              e.hasOwnProperty(t) && n.push(t);
            }

            return n;
          }), i.prototype = {
            end: function end() {
              k(this);
            },
            write: function write(e) {
              if (this.error) throw this.error;
              if (this.closed) return O(this, "Cannot write after close. Assign an onready handler.");
              if (null === e) return k(this);
              "object" == typeof e && (e = e.toString());

              for (var t = 0, r = ""; r = F(e, t++), this.c = r, r;) {
                switch (this.trackPosition && (this.position++, "\n" === r ? (this.line++, this.column = 0) : this.column++), this.state) {
                  case w.BEGIN:
                    if (this.state = w.BEGIN_WHITESPACE, "\uFEFF" === r) continue;
                    Y(this, r);
                    continue;

                  case w.BEGIN_WHITESPACE:
                    Y(this, r);
                    continue;

                  case w.TEXT:
                    if (this.sawRoot && !this.closedRoot) {
                      for (var i = t - 1; r && "<" !== r && "&" !== r;) {
                        (r = F(e, t++)) && this.trackPosition && (this.position++, "\n" === r ? (this.line++, this.column = 0) : this.column++);
                      }

                      this.textNode += e.substring(i, t - 1);
                    }

                    "<" !== r || this.sawRoot && this.closedRoot && !this.strict ? (h(r) || this.sawRoot && !this.closedRoot || T(this, "Text data outside of root node."), "&" === r ? this.state = w.TEXT_ENTITY : this.textNode += r) : (this.state = w.OPEN_WAKA, this.startTagPosition = this.position);
                    continue;

                  case w.SCRIPT:
                    "<" === r ? this.state = w.SCRIPT_ENDING : this.script += r;
                    continue;

                  case w.SCRIPT_ENDING:
                    "/" === r ? this.state = w.CLOSE_TAG : (this.script += "<" + r, this.state = w.SCRIPT);
                    continue;

                  case w.OPEN_WAKA:
                    if ("!" === r) this.state = w.SGML_DECL, this.sgmlDecl = "";else if (h(r)) ;else if (I(m, r)) this.state = w.OPEN_TAG, this.tagName = r;else if ("/" === r) this.state = w.CLOSE_TAG, this.tagName = "";else if ("?" === r) this.state = w.PROC_INST, this.procInstName = this.procInstBody = "";else {
                      if (T(this, "Unencoded <"), this.startTagPosition + 1 < this.position) {
                        var A = this.position - this.startTagPosition;
                        r = new Array(A).join(" ") + r;
                      }

                      this.textNode += "<" + r, this.state = w.TEXT;
                    }
                    continue;

                  case w.SGML_DECL:
                    (this.sgmlDecl + r).toUpperCase() === l ? (D(this, "onopencdata"), this.state = w.CDATA, this.sgmlDecl = "", this.cdata = "") : this.sgmlDecl + r === "--" ? (this.state = w.COMMENT, this.comment = "", this.sgmlDecl = "") : (this.sgmlDecl + r).toUpperCase() === a ? (this.state = w.DOCTYPE, (this.doctype || this.sawRoot) && T(this, "Inappropriately located doctype declaration"), this.doctype = "", this.sgmlDecl = "") : ">" === r ? (D(this, "onsgmldeclaration", this.sgmlDecl), this.sgmlDecl = "", this.state = w.TEXT) : x(r) ? (this.state = w.SGML_DECL_QUOTED, this.sgmlDecl += r) : this.sgmlDecl += r;
                    continue;

                  case w.SGML_DECL_QUOTED:
                    r === this.q && (this.state = w.SGML_DECL, this.q = ""), this.sgmlDecl += r;
                    continue;

                  case w.DOCTYPE:
                    ">" === r ? (this.state = w.TEXT, D(this, "ondoctype", this.doctype), this.doctype = !0) : (this.doctype += r, "[" === r ? this.state = w.DOCTYPE_DTD : x(r) && (this.state = w.DOCTYPE_QUOTED, this.q = r));
                    continue;

                  case w.DOCTYPE_QUOTED:
                    this.doctype += r, r === this.q && (this.q = "", this.state = w.DOCTYPE);
                    continue;

                  case w.DOCTYPE_DTD:
                    this.doctype += r, "]" === r ? this.state = w.DOCTYPE : x(r) && (this.state = w.DOCTYPE_DTD_QUOTED, this.q = r);
                    continue;

                  case w.DOCTYPE_DTD_QUOTED:
                    this.doctype += r, r === this.q && (this.state = w.DOCTYPE_DTD, this.q = "");
                    continue;

                  case w.COMMENT:
                    "-" === r ? this.state = w.COMMENT_ENDING : this.comment += r;
                    continue;

                  case w.COMMENT_ENDING:
                    "-" === r ? (this.state = w.COMMENT_ENDED, this.comment = M(this.opt, this.comment), this.comment && D(this, "oncomment", this.comment), this.comment = "") : (this.comment += "-" + r, this.state = w.COMMENT);
                    continue;

                  case w.COMMENT_ENDED:
                    ">" !== r ? (T(this, "Malformed comment"), this.comment += "--" + r, this.state = w.COMMENT) : this.state = w.TEXT;
                    continue;

                  case w.CDATA:
                    "]" === r ? this.state = w.CDATA_ENDING : this.cdata += r;
                    continue;

                  case w.CDATA_ENDING:
                    "]" === r ? this.state = w.CDATA_ENDING_2 : (this.cdata += "]" + r, this.state = w.CDATA);
                    continue;

                  case w.CDATA_ENDING_2:
                    ">" === r ? (this.cdata && D(this, "oncdata", this.cdata), D(this, "onclosecdata"), this.cdata = "", this.state = w.TEXT) : "]" === r ? this.cdata += "]" : (this.cdata += "]]" + r, this.state = w.CDATA);
                    continue;

                  case w.PROC_INST:
                    "?" === r ? this.state = w.PROC_INST_ENDING : h(r) ? this.state = w.PROC_INST_BODY : this.procInstName += r;
                    continue;

                  case w.PROC_INST_BODY:
                    if (!this.procInstBody && h(r)) continue;
                    "?" === r ? this.state = w.PROC_INST_ENDING : this.procInstBody += r;
                    continue;

                  case w.PROC_INST_ENDING:
                    ">" === r ? (D(this, "onprocessinginstruction", {
                      name: this.procInstName,
                      body: this.procInstBody
                    }), this.procInstName = this.procInstBody = "", this.state = w.TEXT) : (this.procInstBody += "?" + r, this.state = w.PROC_INST_BODY);
                    continue;

                  case w.OPEN_TAG:
                    I(C, r) ? this.tagName += r : (P(this), ">" === r ? U(this) : "/" === r ? this.state = w.OPEN_TAG_SLASH : (h(r) || T(this, "Invalid character in tag name"), this.state = w.ATTRIB));
                    continue;

                  case w.OPEN_TAG_SLASH:
                    ">" === r ? (U(this, !0), R(this)) : (T(this, "Forward-slash in opening tag not followed by >"), this.state = w.ATTRIB);
                    continue;

                  case w.ATTRIB:
                    if (h(r)) continue;
                    ">" === r ? U(this) : "/" === r ? this.state = w.OPEN_TAG_SLASH : I(m, r) ? (this.attribName = r, this.attribValue = "", this.state = w.ATTRIB_NAME) : T(this, "Invalid attribute name");
                    continue;

                  case w.ATTRIB_NAME:
                    "=" === r ? this.state = w.ATTRIB_VALUE : ">" === r ? (T(this, "Attribute without value"), this.attribValue = this.attribName, Q(this), U(this)) : h(r) ? this.state = w.ATTRIB_NAME_SAW_WHITE : I(C, r) ? this.attribName += r : T(this, "Invalid attribute name");
                    continue;

                  case w.ATTRIB_NAME_SAW_WHITE:
                    if ("=" === r) this.state = w.ATTRIB_VALUE;else {
                      if (h(r)) continue;
                      T(this, "Attribute without value"), this.tag.attributes[this.attribName] = "", this.attribValue = "", D(this, "onattribute", {
                        name: this.attribName,
                        value: ""
                      }), this.attribName = "", ">" === r ? U(this) : I(m, r) ? (this.attribName = r, this.state = w.ATTRIB_NAME) : (T(this, "Invalid attribute name"), this.state = w.ATTRIB);
                    }
                    continue;

                  case w.ATTRIB_VALUE:
                    if (h(r)) continue;
                    x(r) ? (this.q = r, this.state = w.ATTRIB_VALUE_QUOTED) : (T(this, "Unquoted attribute value"), this.state = w.ATTRIB_VALUE_UNQUOTED, this.attribValue = r);
                    continue;

                  case w.ATTRIB_VALUE_QUOTED:
                    if (r !== this.q) {
                      "&" === r ? this.state = w.ATTRIB_VALUE_ENTITY_Q : this.attribValue += r;
                      continue;
                    }

                    Q(this), this.q = "", this.state = w.ATTRIB_VALUE_CLOSED;
                    continue;

                  case w.ATTRIB_VALUE_CLOSED:
                    h(r) ? this.state = w.ATTRIB : ">" === r ? U(this) : "/" === r ? this.state = w.OPEN_TAG_SLASH : I(m, r) ? (T(this, "No whitespace between attributes"), this.attribName = r, this.attribValue = "", this.state = w.ATTRIB_NAME) : T(this, "Invalid attribute name");
                    continue;

                  case w.ATTRIB_VALUE_UNQUOTED:
                    if (!g(r)) {
                      "&" === r ? this.state = w.ATTRIB_VALUE_ENTITY_U : this.attribValue += r;
                      continue;
                    }

                    Q(this), ">" === r ? U(this) : this.state = w.ATTRIB;
                    continue;

                  case w.CLOSE_TAG:
                    if (this.tagName) ">" === r ? R(this) : I(C, r) ? this.tagName += r : this.script ? (this.script += "</" + this.tagName, this.tagName = "", this.state = w.SCRIPT) : (h(r) || T(this, "Invalid tagname in closing tag"), this.state = w.CLOSE_TAG_SAW_WHITE);else {
                      if (h(r)) continue;
                      b(m, r) ? this.script ? (this.script += "</" + r, this.state = w.SCRIPT) : T(this, "Invalid tagname in closing tag.") : this.tagName = r;
                    }
                    continue;

                  case w.CLOSE_TAG_SAW_WHITE:
                    if (h(r)) continue;
                    ">" === r ? R(this) : T(this, "Invalid characters in closing tag");
                    continue;

                  case w.TEXT_ENTITY:
                  case w.ATTRIB_VALUE_ENTITY_Q:
                  case w.ATTRIB_VALUE_ENTITY_U:
                    var s, c;

                    switch (this.state) {
                      case w.TEXT_ENTITY:
                        s = w.TEXT, c = "textNode";
                        break;

                      case w.ATTRIB_VALUE_ENTITY_Q:
                        s = w.ATTRIB_VALUE_QUOTED, c = "attribValue";
                        break;

                      case w.ATTRIB_VALUE_ENTITY_U:
                        s = w.ATTRIB_VALUE_UNQUOTED, c = "attribValue";
                    }

                    ";" === r ? (this[c] += G(this), this.entity = "", this.state = s) : I(this.entity.length ? f : d, r) ? this.entity += r : (T(this, "Invalid character in entity name"), this[c] += "&" + this.entity + r, this.entity = "", this.state = s);
                    continue;

                  default:
                    throw new Error(this, "Unknown state: " + this.state);
                }
              }

              return this.position >= this.bufferCheckPosition && function (e) {
                for (var t = Math.max(n.MAX_BUFFER_LENGTH, 10), r = 0, i = 0, A = o.length; i < A; i++) {
                  var s = e[o[i]].length;
                  if (s > t) switch (o[i]) {
                    case "textNode":
                      S(e);
                      break;

                    case "cdata":
                      D(e, "oncdata", e.cdata), e.cdata = "";
                      break;

                    case "script":
                      D(e, "onscript", e.script), e.script = "";
                      break;

                    default:
                      O(e, "Max buffer length exceeded: " + o[i]);
                  }
                  r = Math.max(r, s);
                }

                var l = n.MAX_BUFFER_LENGTH - r;
                e.bufferCheckPosition = l + e.position;
              }(this), this;
            }
            /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
            ,
            resume: function resume() {
              return this.error = null, this;
            },
            close: function close() {
              return this.write(null);
            },
            flush: function flush() {
              var e;
              S(e = this), "" !== e.cdata && (D(e, "oncdata", e.cdata), e.cdata = ""), "" !== e.script && (D(e, "onscript", e.script), e.script = "");
            }
          };

          try {
            r = t(28).Stream;
          } catch (e) {
            r = function r() {};
          }

          var A = n.EVENTS.filter(function (e) {
            return "error" !== e && "end" !== e;
          });

          function s(e, n) {
            if (!(this instanceof s)) return new s(e, n);
            r.apply(this), this._parser = new i(e, n), this.writable = !0, this.readable = !0;
            var t = this;
            this._parser.onend = function () {
              t.emit("end");
            }, this._parser.onerror = function (e) {
              t.emit("error", e), t._parser.error = null;
            }, this._decoder = null, A.forEach(function (e) {
              Object.defineProperty(t, "on" + e, {
                get: function get() {
                  return t._parser["on" + e];
                },
                set: function set(n) {
                  if (!n) return t.removeAllListeners(e), t._parser["on" + e] = n, n;
                  t.on(e, n);
                },
                enumerable: !0,
                configurable: !1
              });
            });
          }

          s.prototype = Object.create(r.prototype, {
            constructor: {
              value: s
            }
          }), s.prototype.write = function (n) {
            if ("function" == typeof e && "function" == typeof e.isBuffer && e.isBuffer(n)) {
              if (!this._decoder) {
                var r = t(32).StringDecoder;
                this._decoder = new r("utf8");
              }

              n = this._decoder.write(n);
            }

            return this._parser.write(n.toString()), this.emit("data", n), !0;
          }, s.prototype.end = function (e) {
            return e && e.length && this.write(e), this._parser.end(), !0;
          }, s.prototype.on = function (e, n) {
            var t = this;
            return t._parser["on" + e] || -1 === A.indexOf(e) || (t._parser["on" + e] = function () {
              var n = 1 === arguments.length ? [arguments[0]] : Array.apply(null, arguments);
              n.splice(0, 0, e), t.emit.apply(t, n);
            }), r.prototype.on.call(t, e, n);
          };
          var l = "[CDATA[",
              a = "DOCTYPE",
              c = "http://www.w3.org/XML/1998/namespace",
              u = "http://www.w3.org/2000/xmlns/",
              p = {
            xml: c,
            xmlns: u
          },
              m = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
              C = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/,
              d = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
              f = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;

          function h(e) {
            return " " === e || "\n" === e || "\r" === e || "\t" === e;
          }

          function x(e) {
            return '"' === e || "'" === e;
          }

          function g(e) {
            return ">" === e || h(e);
          }

          function I(e, n) {
            return e.test(n);
          }

          function b(e, n) {
            return !I(e, n);
          }

          var y,
              E,
              v,
              w = 0;

          for (var B in n.STATE = {
            BEGIN: w++,
            BEGIN_WHITESPACE: w++,
            TEXT: w++,
            TEXT_ENTITY: w++,
            OPEN_WAKA: w++,
            SGML_DECL: w++,
            SGML_DECL_QUOTED: w++,
            DOCTYPE: w++,
            DOCTYPE_QUOTED: w++,
            DOCTYPE_DTD: w++,
            DOCTYPE_DTD_QUOTED: w++,
            COMMENT_STARTING: w++,
            COMMENT: w++,
            COMMENT_ENDING: w++,
            COMMENT_ENDED: w++,
            CDATA: w++,
            CDATA_ENDING: w++,
            CDATA_ENDING_2: w++,
            PROC_INST: w++,
            PROC_INST_BODY: w++,
            PROC_INST_ENDING: w++,
            OPEN_TAG: w++,
            OPEN_TAG_SLASH: w++,
            ATTRIB: w++,
            ATTRIB_NAME: w++,
            ATTRIB_NAME_SAW_WHITE: w++,
            ATTRIB_VALUE: w++,
            ATTRIB_VALUE_QUOTED: w++,
            ATTRIB_VALUE_CLOSED: w++,
            ATTRIB_VALUE_UNQUOTED: w++,
            ATTRIB_VALUE_ENTITY_Q: w++,
            ATTRIB_VALUE_ENTITY_U: w++,
            CLOSE_TAG: w++,
            CLOSE_TAG_SAW_WHITE: w++,
            SCRIPT: w++,
            SCRIPT_ENDING: w++
          }, n.XML_ENTITIES = {
            amp: "&",
            gt: ">",
            lt: "<",
            quot: '"',
            apos: "'"
          }, n.ENTITIES = {
            amp: "&",
            gt: ">",
            lt: "<",
            quot: '"',
            apos: "'",
            AElig: 198,
            Aacute: 193,
            Acirc: 194,
            Agrave: 192,
            Aring: 197,
            Atilde: 195,
            Auml: 196,
            Ccedil: 199,
            ETH: 208,
            Eacute: 201,
            Ecirc: 202,
            Egrave: 200,
            Euml: 203,
            Iacute: 205,
            Icirc: 206,
            Igrave: 204,
            Iuml: 207,
            Ntilde: 209,
            Oacute: 211,
            Ocirc: 212,
            Ograve: 210,
            Oslash: 216,
            Otilde: 213,
            Ouml: 214,
            THORN: 222,
            Uacute: 218,
            Ucirc: 219,
            Ugrave: 217,
            Uuml: 220,
            Yacute: 221,
            aacute: 225,
            acirc: 226,
            aelig: 230,
            agrave: 224,
            aring: 229,
            atilde: 227,
            auml: 228,
            ccedil: 231,
            eacute: 233,
            ecirc: 234,
            egrave: 232,
            eth: 240,
            euml: 235,
            iacute: 237,
            icirc: 238,
            igrave: 236,
            iuml: 239,
            ntilde: 241,
            oacute: 243,
            ocirc: 244,
            ograve: 242,
            oslash: 248,
            otilde: 245,
            ouml: 246,
            szlig: 223,
            thorn: 254,
            uacute: 250,
            ucirc: 251,
            ugrave: 249,
            uuml: 252,
            yacute: 253,
            yuml: 255,
            copy: 169,
            reg: 174,
            nbsp: 160,
            iexcl: 161,
            cent: 162,
            pound: 163,
            curren: 164,
            yen: 165,
            brvbar: 166,
            sect: 167,
            uml: 168,
            ordf: 170,
            laquo: 171,
            not: 172,
            shy: 173,
            macr: 175,
            deg: 176,
            plusmn: 177,
            sup1: 185,
            sup2: 178,
            sup3: 179,
            acute: 180,
            micro: 181,
            para: 182,
            middot: 183,
            cedil: 184,
            ordm: 186,
            raquo: 187,
            frac14: 188,
            frac12: 189,
            frac34: 190,
            iquest: 191,
            times: 215,
            divide: 247,
            OElig: 338,
            oelig: 339,
            Scaron: 352,
            scaron: 353,
            Yuml: 376,
            fnof: 402,
            circ: 710,
            tilde: 732,
            Alpha: 913,
            Beta: 914,
            Gamma: 915,
            Delta: 916,
            Epsilon: 917,
            Zeta: 918,
            Eta: 919,
            Theta: 920,
            Iota: 921,
            Kappa: 922,
            Lambda: 923,
            Mu: 924,
            Nu: 925,
            Xi: 926,
            Omicron: 927,
            Pi: 928,
            Rho: 929,
            Sigma: 931,
            Tau: 932,
            Upsilon: 933,
            Phi: 934,
            Chi: 935,
            Psi: 936,
            Omega: 937,
            alpha: 945,
            beta: 946,
            gamma: 947,
            delta: 948,
            epsilon: 949,
            zeta: 950,
            eta: 951,
            theta: 952,
            iota: 953,
            kappa: 954,
            lambda: 955,
            mu: 956,
            nu: 957,
            xi: 958,
            omicron: 959,
            pi: 960,
            rho: 961,
            sigmaf: 962,
            sigma: 963,
            tau: 964,
            upsilon: 965,
            phi: 966,
            chi: 967,
            psi: 968,
            omega: 969,
            thetasym: 977,
            upsih: 978,
            piv: 982,
            ensp: 8194,
            emsp: 8195,
            thinsp: 8201,
            zwnj: 8204,
            zwj: 8205,
            lrm: 8206,
            rlm: 8207,
            ndash: 8211,
            mdash: 8212,
            lsquo: 8216,
            rsquo: 8217,
            sbquo: 8218,
            ldquo: 8220,
            rdquo: 8221,
            bdquo: 8222,
            dagger: 8224,
            Dagger: 8225,
            bull: 8226,
            hellip: 8230,
            permil: 8240,
            prime: 8242,
            Prime: 8243,
            lsaquo: 8249,
            rsaquo: 8250,
            oline: 8254,
            frasl: 8260,
            euro: 8364,
            image: 8465,
            weierp: 8472,
            real: 8476,
            trade: 8482,
            alefsym: 8501,
            larr: 8592,
            uarr: 8593,
            rarr: 8594,
            darr: 8595,
            harr: 8596,
            crarr: 8629,
            lArr: 8656,
            uArr: 8657,
            rArr: 8658,
            dArr: 8659,
            hArr: 8660,
            forall: 8704,
            part: 8706,
            exist: 8707,
            empty: 8709,
            nabla: 8711,
            isin: 8712,
            notin: 8713,
            ni: 8715,
            prod: 8719,
            sum: 8721,
            minus: 8722,
            lowast: 8727,
            radic: 8730,
            prop: 8733,
            infin: 8734,
            ang: 8736,
            and: 8743,
            or: 8744,
            cap: 8745,
            cup: 8746,
            int: 8747,
            there4: 8756,
            sim: 8764,
            cong: 8773,
            asymp: 8776,
            ne: 8800,
            equiv: 8801,
            le: 8804,
            ge: 8805,
            sub: 8834,
            sup: 8835,
            nsub: 8836,
            sube: 8838,
            supe: 8839,
            oplus: 8853,
            otimes: 8855,
            perp: 8869,
            sdot: 8901,
            lceil: 8968,
            rceil: 8969,
            lfloor: 8970,
            rfloor: 8971,
            lang: 9001,
            rang: 9002,
            loz: 9674,
            spades: 9824,
            clubs: 9827,
            hearts: 9829,
            diams: 9830
          }, Object.keys(n.ENTITIES).forEach(function (e) {
            var t = n.ENTITIES[e],
                r = "number" == typeof t ? String.fromCharCode(t) : t;
            n.ENTITIES[e] = r;
          }), n.STATE) {
            n.STATE[n.STATE[B]] = B;
          }

          function _(e, n, t) {
            e[n] && e[n](t);
          }

          function D(e, n, t) {
            e.textNode && S(e), _(e, n, t);
          }

          function S(e) {
            e.textNode = M(e.opt, e.textNode), e.textNode && _(e, "ontext", e.textNode), e.textNode = "";
          }

          function M(e, n) {
            return e.trim && (n = n.trim()), e.normalize && (n = n.replace(/\s+/g, " ")), n;
          }

          function O(e, n) {
            return S(e), e.trackPosition && (n += "\nLine: " + e.line + "\nColumn: " + e.column + "\nChar: " + e.c), n = new Error(n), e.error = n, _(e, "onerror", n), e;
          }

          function k(e) {
            return e.sawRoot && !e.closedRoot && T(e, "Unclosed root tag"), e.state !== w.BEGIN && e.state !== w.BEGIN_WHITESPACE && e.state !== w.TEXT && O(e, "Unexpected end"), S(e), e.c = "", e.closed = !0, _(e, "onend"), i.call(e, e.strict, e.opt), e;
          }

          function T(e, n) {
            if ("object" != typeof e || !(e instanceof i)) throw new Error("bad call to strictFail");
            e.strict && O(e, n);
          }

          function P(e) {
            e.strict || (e.tagName = e.tagName[e.looseCase]());
            var n = e.tags[e.tags.length - 1] || e,
                t = e.tag = {
              name: e.tagName,
              attributes: {}
            };
            e.opt.xmlns && (t.ns = n.ns), e.attribList.length = 0, D(e, "onopentagstart", t);
          }

          function K(e, n) {
            var t = e.indexOf(":") < 0 ? ["", e] : e.split(":"),
                r = t[0],
                o = t[1];
            return n && "xmlns" === e && (r = "xmlns", o = ""), {
              prefix: r,
              local: o
            };
          }

          function Q(e) {
            if (e.strict || (e.attribName = e.attribName[e.looseCase]()), -1 !== e.attribList.indexOf(e.attribName) || e.tag.attributes.hasOwnProperty(e.attribName)) e.attribName = e.attribValue = "";else {
              if (e.opt.xmlns) {
                var n = K(e.attribName, !0),
                    t = n.prefix,
                    r = n.local;
                if ("xmlns" === t) if ("xml" === r && e.attribValue !== c) T(e, "xml: prefix must be bound to " + c + "\nActual: " + e.attribValue);else if ("xmlns" === r && e.attribValue !== u) T(e, "xmlns: prefix must be bound to " + u + "\nActual: " + e.attribValue);else {
                  var o = e.tag,
                      i = e.tags[e.tags.length - 1] || e;
                  o.ns === i.ns && (o.ns = Object.create(i.ns)), o.ns[r] = e.attribValue;
                }
                e.attribList.push([e.attribName, e.attribValue]);
              } else e.tag.attributes[e.attribName] = e.attribValue, D(e, "onattribute", {
                name: e.attribName,
                value: e.attribValue
              });

              e.attribName = e.attribValue = "";
            }
          }

          function U(e, n) {
            if (e.opt.xmlns) {
              var t = e.tag,
                  r = K(e.tagName);
              t.prefix = r.prefix, t.local = r.local, t.uri = t.ns[r.prefix] || "", t.prefix && !t.uri && (T(e, "Unbound namespace prefix: " + JSON.stringify(e.tagName)), t.uri = r.prefix);
              var o = e.tags[e.tags.length - 1] || e;
              t.ns && o.ns !== t.ns && Object.keys(t.ns).forEach(function (n) {
                D(e, "onopennamespace", {
                  prefix: n,
                  uri: t.ns[n]
                });
              });

              for (var i = 0, A = e.attribList.length; i < A; i++) {
                var s = e.attribList[i],
                    l = s[0],
                    a = s[1],
                    c = K(l, !0),
                    u = c.prefix,
                    p = c.local,
                    m = "" === u ? "" : t.ns[u] || "",
                    C = {
                  name: l,
                  value: a,
                  prefix: u,
                  local: p,
                  uri: m
                };
                u && "xmlns" !== u && !m && (T(e, "Unbound namespace prefix: " + JSON.stringify(u)), C.uri = u), e.tag.attributes[l] = C, D(e, "onattribute", C);
              }

              e.attribList.length = 0;
            }

            e.tag.isSelfClosing = !!n, e.sawRoot = !0, e.tags.push(e.tag), D(e, "onopentag", e.tag), n || (e.noscript || "script" !== e.tagName.toLowerCase() ? e.state = w.TEXT : e.state = w.SCRIPT, e.tag = null, e.tagName = ""), e.attribName = e.attribValue = "", e.attribList.length = 0;
          }

          function R(e) {
            if (!e.tagName) return T(e, "Weird empty close tag."), e.textNode += "</>", void (e.state = w.TEXT);

            if (e.script) {
              if ("script" !== e.tagName) return e.script += "</" + e.tagName + ">", e.tagName = "", void (e.state = w.SCRIPT);
              D(e, "onscript", e.script), e.script = "";
            }

            var n = e.tags.length,
                t = e.tagName;
            e.strict || (t = t[e.looseCase]());

            for (var r = t; n-- && e.tags[n].name !== r;) {
              T(e, "Unexpected close tag");
            }

            if (n < 0) return T(e, "Unmatched closing tag: " + e.tagName), e.textNode += "</" + e.tagName + ">", void (e.state = w.TEXT);
            e.tagName = t;

            for (var o = e.tags.length; o-- > n;) {
              var i = e.tag = e.tags.pop();
              e.tagName = e.tag.name, D(e, "onclosetag", e.tagName);
              var A = {};

              for (var s in i.ns) {
                A[s] = i.ns[s];
              }

              var l = e.tags[e.tags.length - 1] || e;
              e.opt.xmlns && i.ns !== l.ns && Object.keys(i.ns).forEach(function (n) {
                var t = i.ns[n];
                D(e, "onclosenamespace", {
                  prefix: n,
                  uri: t
                });
              });
            }

            0 === n && (e.closedRoot = !0), e.tagName = e.attribValue = e.attribName = "", e.attribList.length = 0, e.state = w.TEXT;
          }

          function G(e) {
            var n,
                t = e.entity,
                r = t.toLowerCase(),
                o = "";
            return e.ENTITIES[t] ? e.ENTITIES[t] : e.ENTITIES[r] ? e.ENTITIES[r] : ("#" === (t = r).charAt(0) && ("x" === t.charAt(1) ? (t = t.slice(2), o = (n = parseInt(t, 16)).toString(16)) : (t = t.slice(1), o = (n = parseInt(t, 10)).toString(10))), t = t.replace(/^0+/, ""), isNaN(n) || o.toLowerCase() !== t ? (T(e, "Invalid character entity"), "&" + e.entity + ";") : String.fromCodePoint(n));
          }

          function Y(e, n) {
            "<" === n ? (e.state = w.OPEN_WAKA, e.startTagPosition = e.position) : h(n) || (T(e, "Non-whitespace before first tag."), e.textNode = n, e.state = w.TEXT);
          }

          function F(e, n) {
            var t = "";
            return n < e.length && (t = e.charAt(n)), t;
          }

          w = n.STATE, String.fromCodePoint || (y = String.fromCharCode, E = Math.floor, v = function v() {
            var e,
                n,
                t = 16384,
                r = [],
                o = -1,
                i = arguments.length;
            if (!i) return "";

            for (var A = ""; ++o < i;) {
              var s = Number(arguments[o]);
              if (!isFinite(s) || s < 0 || s > 1114111 || E(s) !== s) throw RangeError("Invalid code point: " + s);
              s <= 65535 ? r.push(s) : (e = 55296 + ((s -= 65536) >> 10), n = s % 1024 + 56320, r.push(e, n)), (o + 1 === i || r.length > t) && (A += y.apply(null, r), r.length = 0);
            }

            return A;
          }, Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
            value: v,
            configurable: !0,
            writable: !0
          }) : String.fromCodePoint = v);
        }(n);
      }).call(n, t(5).Buffer);
    }, function (e, n, t) {
      "use strict";

      n.byteLength = function (e) {
        var n = a(e),
            t = n[0],
            r = n[1];
        return 3 * (t + r) / 4 - r;
      }, n.toByteArray = function (e) {
        for (var n, t = a(e), r = t[0], A = t[1], s = new i(function (e, n, t) {
          return 3 * (n + t) / 4 - t;
        }(0, r, A)), l = 0, c = A > 0 ? r - 4 : r, u = 0; u < c; u += 4) {
          n = o[e.charCodeAt(u)] << 18 | o[e.charCodeAt(u + 1)] << 12 | o[e.charCodeAt(u + 2)] << 6 | o[e.charCodeAt(u + 3)], s[l++] = n >> 16 & 255, s[l++] = n >> 8 & 255, s[l++] = 255 & n;
        }

        return 2 === A && (n = o[e.charCodeAt(u)] << 2 | o[e.charCodeAt(u + 1)] >> 4, s[l++] = 255 & n), 1 === A && (n = o[e.charCodeAt(u)] << 10 | o[e.charCodeAt(u + 1)] << 4 | o[e.charCodeAt(u + 2)] >> 2, s[l++] = n >> 8 & 255, s[l++] = 255 & n), s;
      }, n.fromByteArray = function (e) {
        for (var n, t = e.length, o = t % 3, i = [], A = 0, s = t - o; A < s; A += 16383) {
          i.push(c(e, A, A + 16383 > s ? s : A + 16383));
        }

        return 1 === o ? (n = e[t - 1], i.push(r[n >> 2] + r[n << 4 & 63] + "==")) : 2 === o && (n = (e[t - 2] << 8) + e[t - 1], i.push(r[n >> 10] + r[n >> 4 & 63] + r[n << 2 & 63] + "=")), i.join("");
      };

      for (var r = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, l = A.length; s < l; ++s) {
        r[s] = A[s], o[A.charCodeAt(s)] = s;
      }

      function a(e) {
        var n = e.length;
        if (n % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var t = e.indexOf("=");
        return -1 === t && (t = n), [t, t === n ? 0 : 4 - t % 4];
      }

      function c(e, n, t) {
        for (var o, i, A = [], s = n; s < t; s += 3) {
          o = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), A.push(r[(i = o) >> 18 & 63] + r[i >> 12 & 63] + r[i >> 6 & 63] + r[63 & i]);
        }

        return A.join("");
      }

      o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
    }, function (e, n) {
      n.read = function (e, n, t, r, o) {
        var i,
            A,
            s = 8 * o - r - 1,
            l = (1 << s) - 1,
            a = l >> 1,
            c = -7,
            u = t ? o - 1 : 0,
            p = t ? -1 : 1,
            m = e[n + u];

        for (u += p, i = m & (1 << -c) - 1, m >>= -c, c += s; c > 0; i = 256 * i + e[n + u], u += p, c -= 8) {
          ;
        }

        for (A = i & (1 << -c) - 1, i >>= -c, c += r; c > 0; A = 256 * A + e[n + u], u += p, c -= 8) {
          ;
        }

        if (0 === i) i = 1 - a;else {
          if (i === l) return A ? NaN : 1 / 0 * (m ? -1 : 1);
          A += Math.pow(2, r), i -= a;
        }
        return (m ? -1 : 1) * A * Math.pow(2, i - r);
      }, n.write = function (e, n, t, r, o, i) {
        var A,
            s,
            l,
            a = 8 * i - o - 1,
            c = (1 << a) - 1,
            u = c >> 1,
            p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            m = r ? 0 : i - 1,
            C = r ? 1 : -1,
            d = n < 0 || 0 === n && 1 / n < 0 ? 1 : 0;

        for (n = Math.abs(n), isNaN(n) || n === 1 / 0 ? (s = isNaN(n) ? 1 : 0, A = c) : (A = Math.floor(Math.log(n) / Math.LN2), n * (l = Math.pow(2, -A)) < 1 && (A--, l *= 2), (n += A + u >= 1 ? p / l : p * Math.pow(2, 1 - u)) * l >= 2 && (A++, l /= 2), A + u >= c ? (s = 0, A = c) : A + u >= 1 ? (s = (n * l - 1) * Math.pow(2, o), A += u) : (s = n * Math.pow(2, u - 1) * Math.pow(2, o), A = 0)); o >= 8; e[t + m] = 255 & s, m += C, s /= 256, o -= 8) {
          ;
        }

        for (A = A << o | s, a += o; a > 0; e[t + m] = 255 & A, m += C, A /= 256, a -= 8) {
          ;
        }

        e[t + m - C] |= 128 * d;
      };
    }, function (e, n) {}, function (e, n, t) {
      "use strict";

      var r = t(19).Buffer;

      e.exports = function () {
        function e() {
          !function (e, n) {
            if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.head = null, this.tail = null, this.length = 0;
        }

        return e.prototype.push = function (e) {
          var n = {
            data: e,
            next: null
          };
          this.length > 0 ? this.tail.next = n : this.head = n, this.tail = n, ++this.length;
        }, e.prototype.unshift = function (e) {
          var n = {
            data: e,
            next: this.head
          };
          0 === this.length && (this.tail = n), this.head = n, ++this.length;
        }, e.prototype.shift = function () {
          if (0 !== this.length) {
            var e = this.head.data;
            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
          }
        }, e.prototype.clear = function () {
          this.head = this.tail = null, this.length = 0;
        }, e.prototype.join = function (e) {
          if (0 === this.length) return "";

          for (var n = this.head, t = "" + n.data; n = n.next;) {
            t += e + n.data;
          }

          return t;
        }, e.prototype.concat = function (e) {
          if (0 === this.length) return r.alloc(0);
          if (1 === this.length) return this.head.data;

          for (var n, t, o, i = r.allocUnsafe(e >>> 0), A = this.head, s = 0; A;) {
            n = A.data, t = i, o = s, n.copy(t, o), s += A.data.length, A = A.next;
          }

          return i;
        }, e;
      }();
    }, function (e, n, t) {
      (function (e) {
        var r = void 0 !== e && e || "undefined" != typeof self && self || window,
            o = Function.prototype.apply;

        function i(e, n) {
          this._id = e, this._clearFn = n;
        }

        n.setTimeout = function () {
          return new i(o.call(setTimeout, r, arguments), clearTimeout);
        }, n.setInterval = function () {
          return new i(o.call(setInterval, r, arguments), clearInterval);
        }, n.clearTimeout = n.clearInterval = function (e) {
          e && e.close();
        }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
          this._clearFn.call(r, this._id);
        }, n.enroll = function (e, n) {
          clearTimeout(e._idleTimeoutId), e._idleTimeout = n;
        }, n.unenroll = function (e) {
          clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
        }, n._unrefActive = n.active = function (e) {
          clearTimeout(e._idleTimeoutId);
          var n = e._idleTimeout;
          n >= 0 && (e._idleTimeoutId = setTimeout(function () {
            e._onTimeout && e._onTimeout();
          }, n));
        }, t(140), n.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, n.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
      }).call(n, t(8));
    }, function (e, n, t) {
      (function (e, n) {
        !function (e, t) {
          "use strict";

          if (!e.setImmediate) {
            var r,
                o,
                i,
                A,
                s,
                l = 1,
                a = {},
                c = !1,
                u = e.document,
                p = Object.getPrototypeOf && Object.getPrototypeOf(e);
            p = p && p.setTimeout ? p : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
              n.nextTick(function () {
                C(e);
              });
            } : function () {
              if (e.postMessage && !e.importScripts) {
                var n = !0,
                    t = e.onmessage;
                return e.onmessage = function () {
                  n = !1;
                }, e.postMessage("", "*"), e.onmessage = t, n;
              }
            }() ? (A = "setImmediate$" + Math.random() + "$", s = function s(n) {
              n.source === e && "string" == typeof n.data && 0 === n.data.indexOf(A) && C(+n.data.slice(A.length));
            }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), r = function r(n) {
              e.postMessage(A + n, "*");
            }) : e.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (e) {
              C(e.data);
            }, r = function r(e) {
              i.port2.postMessage(e);
            }) : u && "onreadystatechange" in u.createElement("script") ? (o = u.documentElement, r = function r(e) {
              var n = u.createElement("script");
              n.onreadystatechange = function () {
                C(e), n.onreadystatechange = null, o.removeChild(n), n = null;
              }, o.appendChild(n);
            }) : r = function r(e) {
              setTimeout(C, 0, e);
            }, p.setImmediate = function (e) {
              "function" != typeof e && (e = new Function("" + e));

              for (var n = new Array(arguments.length - 1), t = 0; t < n.length; t++) {
                n[t] = arguments[t + 1];
              }

              var o = {
                callback: e,
                args: n
              };
              return a[l] = o, r(l), l++;
            }, p.clearImmediate = m;
          }

          function m(e) {
            delete a[e];
          }

          function C(e) {
            if (c) setTimeout(C, 0, e);else {
              var n = a[e];

              if (n) {
                c = !0;

                try {
                  !function (e) {
                    var n = e.callback,
                        r = e.args;

                    switch (r.length) {
                      case 0:
                        n();
                        break;

                      case 1:
                        n(r[0]);
                        break;

                      case 2:
                        n(r[0], r[1]);
                        break;

                      case 3:
                        n(r[0], r[1], r[2]);
                        break;

                      default:
                        n.apply(t, r);
                    }
                  }(n);
                } finally {
                  m(e), c = !1;
                }
              }
            }
          }
        }("undefined" == typeof self ? void 0 === e ? this : e : self);
      }).call(n, t(8), t(13));
    }, function (e, n, t) {
      (function (n) {
        function t(e) {
          try {
            if (!n.localStorage) return !1;
          } catch (e) {
            return !1;
          }

          var t = n.localStorage[e];
          return null != t && "true" === String(t).toLowerCase();
        }

        e.exports = function (e, n) {
          if (t("noDeprecation")) return e;
          var r = !1;
          return function () {
            if (!r) {
              if (t("throwDeprecation")) throw new Error(n);
              t("traceDeprecation") ? console.trace(n) : console.warn(n), r = !0;
            }

            return e.apply(this, arguments);
          };
        };
      }).call(n, t(8));
    }, function (e, n, t) {
      "use strict";

      e.exports = i;
      var r = t(59),
          o = t(14);

      function i(e) {
        if (!(this instanceof i)) return new i(e);
        r.call(this, e);
      }

      o.inherits = t(10), o.inherits(i, r), i.prototype._transform = function (e, n, t) {
        t(null, e);
      };
    }, function (e, n, t) {
      e.exports = t(31);
    }, function (e, n, t) {
      e.exports = t(9);
    }, function (e, n, t) {
      e.exports = t(30).Transform;
    }, function (e, n, t) {
      e.exports = t(30).PassThrough;
    }, function (e, n, t) {
      var r = t(33),
          o = t(54);

      e.exports = function (e, n) {
        var t, i, A;
        return t = function (e) {
          var n = r.copyOptions(e);
          return r.ensureSpacesExists(n), n;
        }(n), i = o(e, t), A = "compact" in t && t.compact ? "_parent" : "parent", ("addParent" in t && t.addParent ? JSON.stringify(i, function (e, n) {
          return e === A ? "_" : n;
        }, t.spaces) : JSON.stringify(i, null, t.spaces)).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
      };
    }, function (e, n, t) {
      (function (n) {
        var r = t(60);

        e.exports = function (e, t) {
          e instanceof n && (e = e.toString());
          var o = null;
          if ("string" == typeof e) try {
            o = JSON.parse(e);
          } catch (e) {
            throw new Error("The JSON structure is invalid");
          } else o = e;
          return r(o, t);
        };
      }).call(n, t(5).Buffer);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\xmlable-object.ts", o = "cd618d97fdffb7deaae8fbfedcda28d005ee16f2", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\xmlable-object.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 0
            },
            end: {
              line: 3,
              column: 25
            }
          }
        },
        fnMap: {},
        branchMap: {},
        s: {
          0: 0,
          1: 0
        },
        f: {},
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/xmlable-object.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\xmlable-object.ts"],
          names: [],
          mappings: ";;AAWa,QAAA,WAAW,GAAG,EAAE,CAAC",
          sourcesContent: ['export interface IXmlAttribute {\r\n    readonly [key: string]: string | number | boolean;\r\n}\r\nexport interface IXmlableObject extends Object {\r\n    readonly _attr?: IXmlAttribute;\r\n}\r\n\r\n// Needed because of: https://github.com/s-panferov/awesome-typescript-loader/issues/432\r\n/**\r\n * @ignore\r\n */\r\nexport const WORKAROUND3 = "";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[1]++, n.WORKAROUND3 = "";
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\initializable-xml-component.ts", o = "d240240ee65d738fc7ea34518e51ddf59b04bcd1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\xml-components\\initializable-xml-component.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 23
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 9
            }
          },
          4: {
            start: {
              line: 8,
              column: 12
            },
            end: {
              line: 8,
              column: 43
            }
          },
          5: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 62
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 40
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 7,
                column: 8
              },
              end: {
                line: 9,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 7,
                column: 8
              },
              end: {
                line: 9,
                column: 9
              }
            }, {
              start: {
                line: 7,
                column: 8
              },
              end: {
                line: 9,
                column: 9
              }
            }],
            line: 7
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/xml-components/initializable-xml-component.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\xml-components\\initializable-xml-component.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,+BAAgD,SAAQ,6BAAY;IAChE,YAAY,OAAe,EAAE,aAAyC;QAClE,KAAK,CAAC,OAAO,CAAC,CAAC;QAEf,IAAI,aAAa,EAAE;YACf,IAAI,CAAC,IAAI,GAAG,aAAa,CAAC,IAAI,CAAC;SAClC;IACL,CAAC;CACJ;AARD,8DAQC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport abstract class InitializableXmlComponent extends XmlComponent {\r\n    constructor(rootKey: string, initComponent?: InitializableXmlComponent) {\r\n        super(rootKey);\r\n\r\n        if (initComponent) {\r\n            this.root = initComponent.root;\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent70) {
        _inherits(u, _c$XmlComponent70);

        function u(e, n) {
          var _this139;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this139 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, e)), a.s[3]++, n ? (a.b[0][0]++, a.s[4]++, _this139.root = n.root) : a.b[0][1]++;
          return _this139;
        }

        return u;
      }(c.XmlComponent);

      a.s[5]++, n.InitializableXmlComponent = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\run.ts", o = "5d2b63468ad981514ed1bcd38ae752bf2dd5ffe7", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\run.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 16
            },
            end: {
              line: 3,
              column: 34
            }
          },
          2: {
            start: {
              line: 4,
              column: 15
            },
            end: {
              line: 4,
              column: 32
            }
          },
          3: {
            start: {
              line: 5,
              column: 16
            },
            end: {
              line: 5,
              column: 34
            }
          },
          4: {
            start: {
              line: 6,
              column: 21
            },
            end: {
              line: 6,
              column: 44
            }
          },
          5: {
            start: {
              line: 7,
              column: 22
            },
            end: {
              line: 7,
              column: 46
            }
          },
          6: {
            start: {
              line: 8,
              column: 21
            },
            end: {
              line: 8,
              column: 44
            }
          },
          7: {
            start: {
              line: 9,
              column: 20
            },
            end: {
              line: 9,
              column: 42
            }
          },
          8: {
            start: {
              line: 10,
              column: 17
            },
            end: {
              line: 10,
              column: 36
            }
          },
          9: {
            start: {
              line: 11,
              column: 16
            },
            end: {
              line: 11,
              column: 34
            }
          },
          10: {
            start: {
              line: 12,
              column: 14
            },
            end: {
              line: 12,
              column: 30
            }
          },
          11: {
            start: {
              line: 13,
              column: 20
            },
            end: {
              line: 13,
              column: 42
            }
          },
          12: {
            start: {
              line: 14,
              column: 25
            },
            end: {
              line: 14,
              column: 55
            }
          },
          13: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 21
            }
          },
          14: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 59
            }
          },
          15: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 40
            }
          },
          16: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 54
            }
          },
          17: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 67
            }
          },
          18: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 20
            }
          },
          19: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 57
            }
          },
          20: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 70
            }
          },
          21: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 20
            }
          },
          22: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 78
            }
          },
          23: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 20
            }
          },
          24: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 60
            }
          },
          25: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 20
            }
          },
          26: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 58
            }
          },
          27: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 71
            }
          },
          28: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 20
            }
          },
          29: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 61
            }
          },
          30: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 46,
              column: 20
            }
          },
          31: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 52
            }
          },
          32: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 20
            }
          },
          33: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 48
            }
          },
          34: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 54,
              column: 20
            }
          },
          35: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 44
            }
          },
          36: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 49
            }
          },
          37: {
            start: {
              line: 59,
              column: 8
            },
            end: {
              line: 59,
              column: 47
            }
          },
          38: {
            start: {
              line: 60,
              column: 8
            },
            end: {
              line: 60,
              column: 42
            }
          },
          39: {
            start: {
              line: 61,
              column: 8
            },
            end: {
              line: 61,
              column: 20
            }
          },
          40: {
            start: {
              line: 64,
              column: 8
            },
            end: {
              line: 64,
              column: 44
            }
          },
          41: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 65,
              column: 58
            }
          },
          42: {
            start: {
              line: 66,
              column: 8
            },
            end: {
              line: 66,
              column: 47
            }
          },
          43: {
            start: {
              line: 67,
              column: 8
            },
            end: {
              line: 67,
              column: 42
            }
          },
          44: {
            start: {
              line: 68,
              column: 8
            },
            end: {
              line: 68,
              column: 20
            }
          },
          45: {
            start: {
              line: 71,
              column: 8
            },
            end: {
              line: 71,
              column: 53
            }
          },
          46: {
            start: {
              line: 72,
              column: 8
            },
            end: {
              line: 72,
              column: 20
            }
          },
          47: {
            start: {
              line: 75,
              column: 8
            },
            end: {
              line: 75,
              column: 48
            }
          },
          48: {
            start: {
              line: 76,
              column: 8
            },
            end: {
              line: 76,
              column: 20
            }
          },
          49: {
            start: {
              line: 79,
              column: 8
            },
            end: {
              line: 79,
              column: 56
            }
          },
          50: {
            start: {
              line: 80,
              column: 8
            },
            end: {
              line: 80,
              column: 20
            }
          },
          51: {
            start: {
              line: 83,
              column: 8
            },
            end: {
              line: 83,
              column: 62
            }
          },
          52: {
            start: {
              line: 84,
              column: 8
            },
            end: {
              line: 84,
              column: 20
            }
          },
          53: {
            start: {
              line: 87,
              column: 8
            },
            end: {
              line: 87,
              column: 55
            }
          },
          54: {
            start: {
              line: 88,
              column: 8
            },
            end: {
              line: 88,
              column: 20
            }
          },
          55: {
            start: {
              line: 91,
              column: 8
            },
            end: {
              line: 91,
              column: 57
            }
          },
          56: {
            start: {
              line: 92,
              column: 8
            },
            end: {
              line: 92,
              column: 20
            }
          },
          57: {
            start: {
              line: 95,
              column: 8
            },
            end: {
              line: 95,
              column: 71
            }
          },
          58: {
            start: {
              line: 96,
              column: 8
            },
            end: {
              line: 96,
              column: 20
            }
          },
          59: {
            start: {
              line: 99,
              column: 8
            },
            end: {
              line: 99,
              column: 57
            }
          },
          60: {
            start: {
              line: 100,
              column: 8
            },
            end: {
              line: 100,
              column: 20
            }
          },
          61: {
            start: {
              line: 103,
              column: 0
            },
            end: {
              line: 103,
              column: 18
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 18
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 16
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 11
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 21
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 13
              },
              end: {
                line: 30,
                column: 5
              }
            },
            line: 26
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 31,
                column: 4
              },
              end: {
                line: 31,
                column: 5
              }
            },
            loc: {
              start: {
                line: 31,
                column: 36
              },
              end: {
                line: 34,
                column: 5
              }
            },
            line: 31
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 35,
                column: 4
              },
              end: {
                line: 35,
                column: 5
              }
            },
            loc: {
              start: {
                line: 35,
                column: 17
              },
              end: {
                line: 38,
                column: 5
              }
            },
            line: 35
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 39,
                column: 4
              },
              end: {
                line: 39,
                column: 5
              }
            },
            loc: {
              start: {
                line: 39,
                column: 15
              },
              end: {
                line: 43,
                column: 5
              }
            },
            line: 39
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 44,
                column: 4
              },
              end: {
                line: 44,
                column: 5
              }
            },
            loc: {
              start: {
                line: 44,
                column: 18
              },
              end: {
                line: 47,
                column: 5
              }
            },
            line: 44
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 48,
                column: 4
              },
              end: {
                line: 48,
                column: 5
              }
            },
            loc: {
              start: {
                line: 48,
                column: 12
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 48
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 52,
                column: 4
              },
              end: {
                line: 52,
                column: 5
              }
            },
            loc: {
              start: {
                line: 52,
                column: 10
              },
              end: {
                line: 55,
                column: 5
              }
            },
            line: 52
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 56,
                column: 4
              },
              end: {
                line: 56,
                column: 5
              }
            },
            loc: {
              start: {
                line: 56,
                column: 17
              },
              end: {
                line: 62,
                column: 5
              }
            },
            line: 56
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 63,
                column: 4
              },
              end: {
                line: 63,
                column: 5
              }
            },
            loc: {
              start: {
                line: 63,
                column: 25
              },
              end: {
                line: 69,
                column: 5
              }
            },
            line: 63
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 70,
                column: 4
              },
              end: {
                line: 70,
                column: 5
              }
            },
            loc: {
              start: {
                line: 70,
                column: 16
              },
              end: {
                line: 73,
                column: 5
              }
            },
            line: 70
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 74,
                column: 4
              },
              end: {
                line: 74,
                column: 5
              }
            },
            loc: {
              start: {
                line: 74,
                column: 14
              },
              end: {
                line: 77,
                column: 5
              }
            },
            line: 74
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 78,
                column: 4
              },
              end: {
                line: 78,
                column: 5
              }
            },
            loc: {
              start: {
                line: 78,
                column: 13
              },
              end: {
                line: 81,
                column: 5
              }
            },
            line: 78
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 82,
                column: 4
              },
              end: {
                line: 82,
                column: 5
              }
            },
            loc: {
              start: {
                line: 82,
                column: 19
              },
              end: {
                line: 85,
                column: 5
              }
            },
            line: 82
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 86,
                column: 4
              },
              end: {
                line: 86,
                column: 5
              }
            },
            loc: {
              start: {
                line: 86,
                column: 16
              },
              end: {
                line: 89,
                column: 5
              }
            },
            line: 86
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 90,
                column: 4
              },
              end: {
                line: 90,
                column: 5
              }
            },
            loc: {
              start: {
                line: 90,
                column: 18
              },
              end: {
                line: 93,
                column: 5
              }
            },
            line: 90
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 94,
                column: 4
              },
              end: {
                line: 94,
                column: 5
              }
            },
            loc: {
              start: {
                line: 94,
                column: 25
              },
              end: {
                line: 97,
                column: 5
              }
            },
            line: 94
          },
          18: {
            name: "(anonymous_18)",
            decl: {
              start: {
                line: 98,
                column: 4
              },
              end: {
                line: 98,
                column: 5
              }
            },
            loc: {
              start: {
                line: 98,
                column: 19
              },
              end: {
                line: 101,
                column: 5
              }
            },
            line: 98
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 0,
          61: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/run.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\run.ts"],
          names: [],
          mappings: ";;AACA,mCAAgC;AAChC,iCAAyC;AACzC,mCAA+C;AAC/C,6CAWsB;AACtB,+CAAoD;AACpD,6CAA6C;AAC7C,2CAAuC;AACvC,qCAAkD;AAClD,mCAAgC;AAChC,+BAA4B;AAC5B,2CAAwC;AAExC,wDAAmD;AAEnD,SAAiB,SAAQ,6BAAY;IAGjC;QACI,KAAK,CAAC,KAAK,CAAC,CAAC;QACb,IAAI,CAAC,UAAU,GAAG,IAAI,0BAAa,EAAE,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAEM,IAAI;QACP,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iBAAI,EAAE,CAAC,CAAC;QACjC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,8BAAiB,EAAE,CAAC,CAAC;QAC9C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM;QACT,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,oBAAO,EAAE,CAAC,CAAC;QACpC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iCAAoB,EAAE,CAAC,CAAC;QACjD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS,CAAC,aAAsB,EAAE,KAAc;QACnD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,aAAa,EAAE,KAAK,CAAC,CAAC,CAAC;QAC1D,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK,CAAC,KAAa;QACtB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,kBAAK,CAAC,KAAK,CAAC,CAAC,CAAC;QACvC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI,CAAC,IAAY;QACpB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,IAAI,CAAC,CAAC,CAAC;QACrC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,8BAAiB,CAAC,IAAI,CAAC,CAAC,CAAC;QAClD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW;QACd,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,wBAAW,EAAE,CAAC,CAAC;QACxC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK;QACR,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,EAAE,CAAC,EAAE,IAAI,aAAK,EAAE,CAAC,CAAC;QACpC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,GAAG;QACN,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,EAAE,CAAC,EAAE,IAAI,SAAG,EAAE,CAAC,CAAC;QAClC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,UAAU;QACb,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAK,EAAE,CAAC,CAAC;QAC5B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,kBAAI,EAAE,CAAC,CAAC;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gBAAQ,EAAE,CAAC,CAAC;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,WAAG,EAAE,CAAC,CAAC;QAC1B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,kBAAkB;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAK,EAAE,CAAC,CAAC;QAC5B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2BAAa,EAAE,CAAC,CAAC;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gBAAQ,EAAE,CAAC,CAAC;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,WAAG,EAAE,CAAC,CAAC;QAC1B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,gBAAS,EAAE,CAAC,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,OAAO;QACV,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,WAAI,EAAE,CAAC,CAAC;QACjC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,MAAM;QACT,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,mBAAM,EAAE,CAAC,CAAC;QACnC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,YAAY;QACf,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,yBAAY,EAAE,CAAC,CAAC;QACzC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,kBAAS,EAAE,CAAC,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW;QACd,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,oBAAW,EAAE,CAAC,CAAC;QACxC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI,CAAC,QAAgB,EAAE,IAAyB;QACnD,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,oBAAQ,CAAC,QAAQ,EAAE,IAAI,CAAC,CAAC,CAAC;QACnD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK,CAAC,OAAe;QACxB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,OAAO,CAAC,CAAC,CAAC;QACzC,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AA3GD,kBA2GC",
          sourcesContent: ['// http://officeopenxml.com/WPtext.php\r\nimport { Break } from "./break";\r\nimport { Caps, SmallCaps } from "./caps";\r\nimport { Begin, End, Separate } from "./field";\r\nimport {\r\n    Bold,\r\n    BoldComplexScript,\r\n    Color,\r\n    DoubleStrike,\r\n    Italics,\r\n    ItalicsComplexScript,\r\n    RightToLeft,\r\n    Size,\r\n    SizeComplexScript,\r\n    Strike,\r\n} from "./formatting";\r\nimport { NumberOfPages, Page } from "./page-number";\r\nimport { RunProperties } from "./properties";\r\nimport { RunFonts } from "./run-fonts";\r\nimport { SubScript, SuperScript } from "./script";\r\nimport { Style } from "./style";\r\nimport { Tab } from "./tab";\r\nimport { Underline } from "./underline";\r\n\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nexport class Run extends XmlComponent {\r\n    protected readonly properties: RunProperties;\r\n\r\n    constructor() {\r\n        super("w:r");\r\n        this.properties = new RunProperties();\r\n        this.root.push(this.properties);\r\n    }\r\n\r\n    public bold(): Run {\r\n        this.properties.push(new Bold());\r\n        this.properties.push(new BoldComplexScript());\r\n        return this;\r\n    }\r\n\r\n    public italic(): Run {\r\n        this.properties.push(new Italics());\r\n        this.properties.push(new ItalicsComplexScript());\r\n        return this;\r\n    }\r\n\r\n    public underline(underlineType?: string, color?: string): Run {\r\n        this.properties.push(new Underline(underlineType, color));\r\n        return this;\r\n    }\r\n\r\n    public color(color: string): Run {\r\n        this.properties.push(new Color(color));\r\n        return this;\r\n    }\r\n\r\n    public size(size: number): Run {\r\n        this.properties.push(new Size(size));\r\n        this.properties.push(new SizeComplexScript(size));\r\n        return this;\r\n    }\r\n\r\n    public rightToLeft(): Run {\r\n        this.properties.push(new RightToLeft());\r\n        return this;\r\n    }\r\n\r\n    public break(): Run {\r\n        this.root.splice(1, 0, new Break());\r\n        return this;\r\n    }\r\n\r\n    public tab(): Run {\r\n        this.root.splice(1, 0, new Tab());\r\n        return this;\r\n    }\r\n\r\n    public pageNumber(): Run {\r\n        this.root.push(new Begin());\r\n        this.root.push(new Page());\r\n        this.root.push(new Separate());\r\n        this.root.push(new End());\r\n        return this;\r\n    }\r\n\r\n    public numberOfTotalPages(): Run {\r\n        this.root.push(new Begin());\r\n        this.root.push(new NumberOfPages());\r\n        this.root.push(new Separate());\r\n        this.root.push(new End());\r\n        return this;\r\n    }\r\n\r\n    public smallCaps(): Run {\r\n        this.properties.push(new SmallCaps());\r\n        return this;\r\n    }\r\n\r\n    public allCaps(): Run {\r\n        this.properties.push(new Caps());\r\n        return this;\r\n    }\r\n\r\n    public strike(): Run {\r\n        this.properties.push(new Strike());\r\n        return this;\r\n    }\r\n\r\n    public doubleStrike(): Run {\r\n        this.properties.push(new DoubleStrike());\r\n        return this;\r\n    }\r\n\r\n    public subScript(): Run {\r\n        this.properties.push(new SubScript());\r\n        return this;\r\n    }\r\n\r\n    public superScript(): Run {\r\n        this.properties.push(new SuperScript());\r\n        return this;\r\n    }\r\n\r\n    public font(fontName: string, hint?: string | undefined): Run {\r\n        this.properties.push(new RunFonts(fontName, hint));\r\n        return this;\r\n    }\r\n\r\n    public style(styleId: string): Run {\r\n        this.properties.push(new Style(styleId));\r\n        return this;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(152)),
          u = (a.s[2]++, t(153)),
          p = (a.s[3]++, t(36)),
          m = (a.s[4]++, t(15)),
          C = (a.s[5]++, t(154)),
          d = (a.s[6]++, t(21)),
          f = (a.s[7]++, t(37)),
          h = (a.s[8]++, t(65)),
          x = (a.s[9]++, t(66)),
          g = (a.s[10]++, t(155)),
          I = (a.s[11]++, t(64)),
          b = (a.s[12]++, t(0));

      var y =
      /*#__PURE__*/
      function (_b$XmlComponent) {
        _inherits(y, _b$XmlComponent);

        function y() {
          var _this140;

          _classCallCheck(this, y);

          a.f[0]++, a.s[13]++, _this140 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this, "w:r")), a.s[14]++, _this140.properties = new d.RunProperties(), a.s[15]++, _this140.root.push(_this140.properties);
          return _this140;
        }

        _createClass(y, [{
          key: "bold",
          value: function bold() {
            return a.f[1]++, a.s[16]++, this.properties.push(new m.Bold()), a.s[17]++, this.properties.push(new m.BoldComplexScript()), a.s[18]++, this;
          }
        }, {
          key: "italic",
          value: function italic() {
            return a.f[2]++, a.s[19]++, this.properties.push(new m.Italics()), a.s[20]++, this.properties.push(new m.ItalicsComplexScript()), a.s[21]++, this;
          }
        }, {
          key: "underline",
          value: function underline(e, n) {
            return a.f[3]++, a.s[22]++, this.properties.push(new I.Underline(e, n)), a.s[23]++, this;
          }
        }, {
          key: "color",
          value: function color(e) {
            return a.f[4]++, a.s[24]++, this.properties.push(new m.Color(e)), a.s[25]++, this;
          }
        }, {
          key: "size",
          value: function size(e) {
            return a.f[5]++, a.s[26]++, this.properties.push(new m.Size(e)), a.s[27]++, this.properties.push(new m.SizeComplexScript(e)), a.s[28]++, this;
          }
        }, {
          key: "rightToLeft",
          value: function rightToLeft() {
            return a.f[6]++, a.s[29]++, this.properties.push(new m.RightToLeft()), a.s[30]++, this;
          }
        }, {
          key: "break",
          value: function _break() {
            return a.f[7]++, a.s[31]++, this.root.splice(1, 0, new c.Break()), a.s[32]++, this;
          }
        }, {
          key: "tab",
          value: function tab() {
            return a.f[8]++, a.s[33]++, this.root.splice(1, 0, new g.Tab()), a.s[34]++, this;
          }
        }, {
          key: "pageNumber",
          value: function pageNumber() {
            return a.f[9]++, a.s[35]++, this.root.push(new p.Begin()), a.s[36]++, this.root.push(new C.Page()), a.s[37]++, this.root.push(new p.Separate()), a.s[38]++, this.root.push(new p.End()), a.s[39]++, this;
          }
        }, {
          key: "numberOfTotalPages",
          value: function numberOfTotalPages() {
            return a.f[10]++, a.s[40]++, this.root.push(new p.Begin()), a.s[41]++, this.root.push(new C.NumberOfPages()), a.s[42]++, this.root.push(new p.Separate()), a.s[43]++, this.root.push(new p.End()), a.s[44]++, this;
          }
        }, {
          key: "smallCaps",
          value: function smallCaps() {
            return a.f[11]++, a.s[45]++, this.properties.push(new u.SmallCaps()), a.s[46]++, this;
          }
        }, {
          key: "allCaps",
          value: function allCaps() {
            return a.f[12]++, a.s[47]++, this.properties.push(new u.Caps()), a.s[48]++, this;
          }
        }, {
          key: "strike",
          value: function strike() {
            return a.f[13]++, a.s[49]++, this.properties.push(new m.Strike()), a.s[50]++, this;
          }
        }, {
          key: "doubleStrike",
          value: function doubleStrike() {
            return a.f[14]++, a.s[51]++, this.properties.push(new m.DoubleStrike()), a.s[52]++, this;
          }
        }, {
          key: "subScript",
          value: function subScript() {
            return a.f[15]++, a.s[53]++, this.properties.push(new h.SubScript()), a.s[54]++, this;
          }
        }, {
          key: "superScript",
          value: function superScript() {
            return a.f[16]++, a.s[55]++, this.properties.push(new h.SuperScript()), a.s[56]++, this;
          }
        }, {
          key: "font",
          value: function font(e, n) {
            return a.f[17]++, a.s[57]++, this.properties.push(new f.RunFonts(e, n)), a.s[58]++, this;
          }
        }, {
          key: "style",
          value: function style(e) {
            return a.f[18]++, a.s[59]++, this.properties.push(new x.Style(e)), a.s[60]++, this;
          }
        }]);

        return y;
      }(b.XmlComponent);

      a.s[61]++, n.Run = y;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\break.ts", o = "7f4bbb06b841a6f6f94bc6224a32e031bfd4e8ae", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\break.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 22
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/break.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\break.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AAEnD,WAAmB,SAAQ,6BAAY;IACnC;QACI,KAAK,CAAC,MAAM,CAAC,CAAC;IAClB,CAAC;CACJ;AAJD,sBAIC",
          sourcesContent: ['// http://officeopenxml.com/WPtextSpecialContent-break.php\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nexport class Break extends XmlComponent {\r\n    constructor() {\r\n        super("w:br");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent71) {
        _inherits(u, _c$XmlComponent71);

        function u() {
          var _this141;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this141 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:br"));
          return _this141;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.Break = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\caps.ts", o = "1470241437b120f4da3a221e115e09182323a4ae", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\caps.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 29
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 30
            }
          },
          4: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 24
            }
          },
          5: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 20
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/caps.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\caps.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,eAAuB,SAAQ,6BAAY;IACvC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;IACzB,CAAC;CACJ;AAJD,8BAIC;AAED,UAAkB,SAAQ,6BAAY;IAClC;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;IACpB,CAAC;CACJ;AAJD,oBAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class SmallCaps extends XmlComponent {\r\n    constructor() {\r\n        super("w:smallCaps");\r\n    }\r\n}\r\n\r\nexport class Caps extends XmlComponent {\r\n    constructor() {\r\n        super("w:caps");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent72) {
        _inherits(u, _c$XmlComponent72);

        function u() {
          var _this142;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this142 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:smallCaps"));
          return _this142;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.SmallCaps = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent73) {
        _inherits(p, _c$XmlComponent73);

        function p() {
          var _this143;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this143 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:caps"));
          return _this143;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Caps = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\page-number.ts", o = "6badd8bc722923552b99fdfbd799a2c89ed5f026", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\page-number.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 47
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 46
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 29
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 87
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 31
            }
          },
          8: {
            start: {
              line: 18,
              column: 0
            },
            end: {
              line: 18,
              column: 20
            }
          },
          9: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 29
            }
          },
          10: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 87
            }
          },
          11: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 35
            }
          },
          12: {
            start: {
              line: 26,
              column: 0
            },
            end: {
              line: 26,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 18
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 12
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 18
              },
              end: {
                line: 24,
                column: 5
              }
            },
            line: 20
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/page-number.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\page-number.ts"],
          names: [],
          mappings: ";;AAAA,gDAA4C;AAC5C,wDAA0E;AAE1E,oBAAqB,SAAQ,sCAAoD;IAAjF;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,WAAW,EAAE,CAAC;IACxD,CAAC;CAAA;AAED,UAAkB,SAAQ,6BAAY;IAClC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,cAAc,CAAC,EAAE,KAAK,EAAE,sBAAS,CAAC,QAAQ,EAAE,CAAC,CAAC,CAAC;QAClE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;IAC3B,CAAC;CACJ;AAND,oBAMC;AAED,mBAA2B,SAAQ,6BAAY;IAC3C;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,cAAc,CAAC,EAAE,KAAK,EAAE,sBAAS,CAAC,QAAQ,EAAE,CAAC,CAAC,CAAC;QAClE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IAC/B,CAAC;CACJ;AAND,sCAMC",
          sourcesContent: ['import { SpaceType } from "file/space-type";\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nclass TextAttributes extends XmlAttributeComponent<{ readonly space: SpaceType }> {\r\n    protected readonly xmlKeys = { space: "xml:space" };\r\n}\r\n\r\nexport class Page extends XmlComponent {\r\n    constructor() {\r\n        super("w:instrText");\r\n        this.root.push(new TextAttributes({ space: SpaceType.PRESERVE }));\r\n        this.root.push("PAGE");\r\n    }\r\n}\r\n\r\nexport class NumberOfPages extends XmlComponent {\r\n    constructor() {\r\n        super("w:instrText");\r\n        this.root.push(new TextAttributes({ space: SpaceType.PRESERVE }));\r\n        this.root.push("NUMPAGES");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(20)),
          u = (a.s[2]++, t(0));

      var p =
      /*#__PURE__*/
      function (_u$XmlAttributeCompon) {
        _inherits(p, _u$XmlAttributeCompon);

        function p() {
          var _this144;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this144 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this144.xmlKeys = {
            space: "xml:space"
          };
          return _this144;
        }

        return p;
      }(u.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_u$XmlComponent4) {
        _inherits(m, _u$XmlComponent4);

        function m() {
          var _this145;

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this145 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:instrText")), a.s[6]++, _this145.root.push(new p({
            space: c.SpaceType.PRESERVE
          })), a.s[7]++, _this145.root.push("PAGE");
          return _this145;
        }

        return m;
      }(u.XmlComponent);

      a.s[8]++, n.Page = m;

      var C =
      /*#__PURE__*/
      function (_u$XmlComponent5) {
        _inherits(C, _u$XmlComponent5);

        function C() {
          var _this146;

          _classCallCheck(this, C);

          a.f[2]++, a.s[9]++, _this146 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:instrText")), a.s[10]++, _this146.root.push(new p({
            space: c.SpaceType.PRESERVE
          })), a.s[11]++, _this146.root.push("NUMPAGES");
          return _this146;
        }

        return C;
      }(u.XmlComponent);

      a.s[12]++, n.NumberOfPages = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\tab.ts", o = "5e2732840f66a5883b72022335eba6627bfd9855", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\tab.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 23
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 18
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/tab.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\tab.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,SAAiB,SAAQ,6BAAY;IACjC;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;IACnB,CAAC;CACJ;AAJD,kBAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class Tab extends XmlComponent {\r\n    constructor() {\r\n        super("w:tab");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent74) {
        _inherits(u, _c$XmlComponent74);

        function u() {
          var _this147;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this147 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:tab"));
          return _this147;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.Tab = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\text-run.ts", o = "ba45ae4378fdd0af35c650c82da1387581c6b595", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\text-run.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 14
            },
            end: {
              line: 3,
              column: 31
            }
          },
          2: {
            start: {
              line: 4,
              column: 15
            },
            end: {
              line: 4,
              column: 47
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 16
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 46
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 22
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/text-run.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\text-run.ts"],
          names: [],
          mappings: ";;AAAA,gCAA6B;AAC7B,gDAA6C;AAE7C,aAAqB,SAAQ,SAAG;IAC5B,YAAY,IAAY;QACpB,KAAK,EAAE,CAAC;QACR,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,WAAI,CAAC,IAAI,CAAC,CAAC,CAAC;IACnC,CAAC;CACJ;AALD,0BAKC",
          sourcesContent: ['import { Run } from "../run";\r\nimport { Text } from "./run-components/text";\r\n\r\nexport class TextRun extends Run {\r\n    constructor(text: string) {\r\n        super();\r\n        this.root.push(new Text(text));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(4)),
          u = (a.s[2]++, t(157));

      var p =
      /*#__PURE__*/
      function (_c$Run) {
        _inherits(p, _c$Run);

        function p(e) {
          var _this148;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this148 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), a.s[4]++, _this148.root.push(new u.Text(e));
          return _this148;
        }

        return p;
      }(c.Run);

      a.s[5]++, n.TextRun = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\run-components\\text.ts", o = "ea695a8de8f5b68304901436e51057fb4555aa02", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\run-components\\text.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 47
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 46
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 21
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 87
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 17,
              column: 9
            }
          },
          8: {
            start: {
              line: 16,
              column: 12
            },
            end: {
              line: 16,
              column: 33
            }
          },
          9: {
            start: {
              line: 20,
              column: 0
            },
            end: {
              line: 20,
              column: 20
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 22
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 12
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            }, {
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            }],
            line: 15
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/run-components/text.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\run-components\\text.ts"],
          names: [],
          mappings: ";;AAAA,gDAA4C;AAC5C,wDAA0E;AAE1E,oBAAqB,SAAQ,sCAAoD;IAAjF;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,WAAW,EAAE,CAAC;IACxD,CAAC;CAAA;AAED,UAAkB,SAAQ,6BAAY;IAClC,YAAY,IAAY;QACpB,KAAK,CAAC,KAAK,CAAC,CAAC;QACb,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,cAAc,CAAC,EAAE,KAAK,EAAE,sBAAS,CAAC,QAAQ,EAAE,CAAC,CAAC,CAAC;QAClE,IAAI,IAAI,EAAE;YACN,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;SACxB;IACL,CAAC;CACJ;AARD,oBAQC",
          sourcesContent: ['import { SpaceType } from "file/space-type";\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nclass TextAttributes extends XmlAttributeComponent<{ readonly space: SpaceType }> {\r\n    protected readonly xmlKeys = { space: "xml:space" };\r\n}\r\n\r\nexport class Text extends XmlComponent {\r\n    constructor(text: string) {\r\n        super("w:t");\r\n        this.root.push(new TextAttributes({ space: SpaceType.PRESERVE }));\r\n        if (text) {\r\n            this.root.push(text);\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(20)),
          u = (a.s[2]++, t(0));

      var p =
      /*#__PURE__*/
      function (_u$XmlAttributeCompon2) {
        _inherits(p, _u$XmlAttributeCompon2);

        function p() {
          var _this149;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this149 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this149.xmlKeys = {
            space: "xml:space"
          };
          return _this149;
        }

        return p;
      }(u.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_u$XmlComponent6) {
        _inherits(m, _u$XmlComponent6);

        function m(e) {
          var _this150;

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this150 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:t")), a.s[6]++, _this150.root.push(new p({
            space: c.SpaceType.PRESERVE
          })), a.s[7]++, e ? (a.b[0][0]++, a.s[8]++, _this150.root.push(e)) : a.b[0][1]++;
          return _this150;
        }

        return m;
      }(u.XmlComponent);

      a.s[9]++, n.Text = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\picture-run.ts", o = "98a8798a6e0c45a4f368cbb8a72d70b4a78910fd", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\picture-run.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 18
            },
            end: {
              line: 3,
              column: 42
            }
          },
          2: {
            start: {
              line: 4,
              column: 14
            },
            end: {
              line: 4,
              column: 31
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 16
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 9
            }
          },
          5: {
            start: {
              line: 9,
              column: 12
            },
            end: {
              line: 9,
              column: 61
            }
          },
          6: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 72
            }
          },
          7: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 37
            }
          },
          8: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 45
            }
          },
          9: {
            start: {
              line: 18,
              column: 0
            },
            end: {
              line: 18,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 43
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 42
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 14
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 8,
                column: 8
              },
              end: {
                line: 10,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 8,
                column: 8
              },
              end: {
                line: 10,
                column: 9
              }
            }, {
              start: {
                line: 8,
                column: 8
              },
              end: {
                line: 10,
                column: 9
              }
            }],
            line: 8
          },
          1: {
            loc: {
              start: {
                line: 14,
                column: 10
              },
              end: {
                line: 14,
                column: 21
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 14,
                column: 20
              },
              end: {
                line: 14,
                column: 21
              }
            }],
            line: 14
          },
          2: {
            loc: {
              start: {
                line: 14,
                column: 23
              },
              end: {
                line: 14,
                column: 40
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 14,
                column: 33
              },
              end: {
                line: 14,
                column: 40
              }
            }],
            line: 14
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0],
          1: [0],
          2: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/picture-run.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\picture-run.ts"],
          names: [],
          mappings: ";;AAAA,2CAAwC;AAGxC,gCAA6B;AAE7B,gBAAwB,SAAQ,SAAG;IAG/B,YAAY,SAAqB,EAAE,cAAgC;QAC/D,KAAK,EAAE,CAAC;QAER,IAAI,SAAS,KAAK,SAAS,EAAE;YACzB,MAAM,IAAI,KAAK,CAAC,+BAA+B,CAAC,CAAC;SACpD;QAED,IAAI,CAAC,OAAO,GAAG,IAAI,iBAAO,CAAC,SAAS,EAAE,cAAc,CAAC,CAAC;QAEtD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;IACjC,CAAC;IAEM,KAAK,CAAC,UAAkB,CAAC,EAAE,UAAkB,OAAO;QACvD,IAAI,CAAC,OAAO,CAAC,KAAK,CAAC,OAAO,EAAE,OAAO,CAAC,CAAC;IACzC,CAAC;CACJ;AAlBD,gCAkBC",
          sourcesContent: ['import { Drawing } from "../../drawing";\r\nimport { IDrawingOptions } from "../../drawing/drawing";\r\nimport { IMediaData } from "../../media/data";\r\nimport { Run } from "../run";\r\n\r\nexport class PictureRun extends Run {\r\n    private readonly drawing: Drawing;\r\n\r\n    constructor(imageData: IMediaData, drawingOptions?: IDrawingOptions) {\r\n        super();\r\n\r\n        if (imageData === undefined) {\r\n            throw new Error("imageData cannot be undefined");\r\n        }\r\n\r\n        this.drawing = new Drawing(imageData, drawingOptions);\r\n\r\n        this.root.push(this.drawing);\r\n    }\r\n\r\n    public scale(factorX: number = 1, factorY: number = factorX): void {\r\n        this.drawing.scale(factorX, factorY);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(67)),
          u = (a.s[2]++, t(4));

      var p =
      /*#__PURE__*/
      function (_u$Run2) {
        _inherits(p, _u$Run2);

        function p(e, n) {
          var _this151;

          _classCallCheck(this, p);

          if (a.f[0]++, a.s[3]++, _this151 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), a.s[4]++, void 0 === e) throw a.b[0][0]++, a.s[5]++, new Error("imageData cannot be undefined");
          a.b[0][1]++, a.s[6]++, _this151.drawing = new c.Drawing(e, n), a.s[7]++, _this151.root.push(_this151.drawing);
          return _possibleConstructorReturn(_this151);
        }

        _createClass(p, [{
          key: "scale",
          value: function scale() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[1][0]++, 1);
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[2][0]++, e);
            a.f[1]++, a.s[8]++, this.drawing.scale(e, n);
          }
        }]);

        return p;
      }(u.Run);

      a.s[9]++, n.PictureRun = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\drawing.ts", o = "e577b7e135edd33c942385162acaef62ea407552", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\drawing.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 17
            },
            end: {
              line: 4,
              column: 36
            }
          },
          3: {
            start: {
              line: 5,
              column: 17
            },
            end: {
              line: 5,
              column: 36
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 27
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 11,
              column: 9
            }
          },
          6: {
            start: {
              line: 10,
              column: 12
            },
            end: {
              line: 10,
              column: 61
            }
          },
          7: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 18,
              column: 9
            }
          },
          8: {
            start: {
              line: 13,
              column: 12
            },
            end: {
              line: 13,
              column: 91
            }
          },
          9: {
            start: {
              line: 14,
              column: 12
            },
            end: {
              line: 14,
              column: 40
            }
          },
          10: {
            start: {
              line: 17,
              column: 12
            },
            end: {
              line: 17,
              column: 109
            }
          },
          11: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 44
            }
          },
          12: {
            start: {
              line: 24,
              column: 0
            },
            end: {
              line: 24,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 48
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 28
              },
              end: {
                line: 22,
                column: 5
              }
            },
            line: 20
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 7,
                column: 27
              },
              end: {
                line: 7,
                column: 46
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 7,
                column: 44
              },
              end: {
                line: 7,
                column: 46
              }
            }],
            line: 7
          },
          1: {
            loc: {
              start: {
                line: 9,
                column: 8
              },
              end: {
                line: 11,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 9,
                column: 8
              },
              end: {
                line: 11,
                column: 9
              }
            }, {
              start: {
                line: 9,
                column: 8
              },
              end: {
                line: 11,
                column: 9
              }
            }],
            line: 9
          },
          2: {
            loc: {
              start: {
                line: 12,
                column: 8
              },
              end: {
                line: 18,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 12,
                column: 8
              },
              end: {
                line: 18,
                column: 9
              }
            }, {
              start: {
                line: 12,
                column: 8
              },
              end: {
                line: 18,
                column: 9
              }
            }],
            line: 12
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0],
          1: [0, 0],
          2: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/drawing.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\drawing.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,qCAAkC;AAElC,qCAAkC;AAalC,aAAqB,SAAQ,6BAAY;IAGrC,YAAY,SAAqB,EAAE,iBAAkC,EAAE;QACnE,KAAK,CAAC,WAAW,CAAC,CAAC;QAEnB,IAAI,SAAS,KAAK,SAAS,EAAE;YACzB,MAAM,IAAI,KAAK,CAAC,+BAA+B,CAAC,CAAC;SACpD;QAED,IAAI,CAAC,cAAc,CAAC,QAAQ,EAAE;YAC1B,IAAI,CAAC,MAAM,GAAG,IAAI,eAAM,CAAC,SAAS,CAAC,WAAW,EAAE,SAAS,CAAC,UAAU,CAAC,CAAC;YACtE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;SAC/B;aAAM;YACH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,eAAM,CAAC,SAAS,CAAC,WAAW,EAAE,SAAS,CAAC,UAAU,EAAE,cAAc,CAAC,CAAC,CAAC;SAC3F;IACL,CAAC;IAEM,KAAK,CAAC,OAAe,EAAE,OAAe;QACzC,IAAI,CAAC,MAAM,CAAC,KAAK,CAAC,OAAO,EAAE,OAAO,CAAC,CAAC;IACxC,CAAC;CACJ;AArBD,0BAqBC",
          sourcesContent: ['import { IMediaData } from "file/media";\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { Anchor } from "./anchor";\r\nimport { IFloating } from "./floating";\r\nimport { Inline } from "./inline";\r\n\r\nexport interface IDistance {\r\n    readonly distT?: number;\r\n    readonly distB?: number;\r\n    readonly distL?: number;\r\n    readonly distR?: number;\r\n}\r\n\r\nexport interface IDrawingOptions {\r\n    readonly floating?: IFloating;\r\n}\r\n\r\nexport class Drawing extends XmlComponent {\r\n    private readonly inline: Inline;\r\n\r\n    constructor(imageData: IMediaData, drawingOptions: IDrawingOptions = {}) {\r\n        super("w:drawing");\r\n\r\n        if (imageData === undefined) {\r\n            throw new Error("imageData cannot be undefined");\r\n        }\r\n\r\n        if (!drawingOptions.floating) {\r\n            this.inline = new Inline(imageData.referenceId, imageData.dimensions);\r\n            this.root.push(this.inline);\r\n        } else {\r\n            this.root.push(new Anchor(imageData.referenceId, imageData.dimensions, drawingOptions));\r\n        }\r\n    }\r\n\r\n    public scale(factorX: number, factorY: number): void {\r\n        this.inline.scale(factorX, factorY);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(160)),
          p = (a.s[3]++, t(203));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent75) {
        _inherits(m, _c$XmlComponent75);

        function m(e) {
          var _this152;

          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[0][0]++, {});

          _classCallCheck(this, m);

          if (a.f[0]++, a.s[4]++, _this152 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:drawing")), a.s[5]++, void 0 === e) throw a.b[1][0]++, a.s[6]++, new Error("imageData cannot be undefined");
          a.b[1][1]++, a.s[7]++, n.floating ? (a.b[2][1]++, a.s[10]++, _this152.root.push(new u.Anchor(e.referenceId, e.dimensions, n))) : (a.b[2][0]++, a.s[8]++, _this152.inline = new p.Inline(e.referenceId, e.dimensions), a.s[9]++, _this152.root.push(_this152.inline));
          return _possibleConstructorReturn(_this152);
        }

        _createClass(m, [{
          key: "scale",
          value: function scale(e, n) {
            a.f[1]++, a.s[11]++, this.inline.scale(e, n);
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[12]++, n.Drawing = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\anchor\\index.ts", o = "d3449d61b99648a39e7d3a2b1a24cf7d30d6577a", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\anchor\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 30
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 41
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/anchor/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\anchor\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,8BAAyB;AACzB,yCAAoC",
          sourcesContent: ['export * from "./anchor";\r\nexport * from "./anchor-attributes";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(161)), a.s[5]++, c(t(76));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\anchor\\anchor.ts", o = "cfefcf0d1191a6b63ae9fc8300f644bec36f5108", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\anchor\\anchor.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 19
            },
            end: {
              line: 4,
              column: 41
            }
          },
          3: {
            start: {
              line: 5,
              column: 18
            },
            end: {
              line: 5,
              column: 46
            }
          },
          4: {
            start: {
              line: 6,
              column: 20
            },
            end: {
              line: 6,
              column: 43
            }
          },
          5: {
            start: {
              line: 7,
              column: 25
            },
            end: {
              line: 7,
              column: 70
            }
          },
          6: {
            start: {
              line: 8,
              column: 24
            },
            end: {
              line: 8,
              column: 67
            }
          },
          7: {
            start: {
              line: 9,
              column: 17
            },
            end: {
              line: 9,
              column: 46
            }
          },
          8: {
            start: {
              line: 10,
              column: 35
            },
            end: {
              line: 10,
              column: 89
            }
          },
          9: {
            start: {
              line: 11,
              column: 28
            },
            end: {
              line: 11,
              column: 58
            }
          },
          10: {
            start: {
              line: 12,
              column: 23
            },
            end: {
              line: 19,
              column: 1
            }
          },
          11: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 27
            }
          },
          12: {
            start: {
              line: 23,
              column: 25
            },
            end: {
              line: 28,
              column: 57
            }
          },
          13: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 40,
              column: 12
            }
          },
          14: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 51
            }
          },
          15: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 87
            }
          },
          16: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 83
            }
          },
          17: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 44,
              column: 82
            }
          },
          18: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 59
            }
          },
          19: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 64,
              column: 9
            }
          },
          20: {
            start: {
              line: 47,
              column: 12
            },
            end: {
              line: 60,
              column: 13
            }
          },
          21: {
            start: {
              line: 49,
              column: 20
            },
            end: {
              line: 49,
              column: 126
            }
          },
          22: {
            start: {
              line: 50,
              column: 20
            },
            end: {
              line: 50,
              column: 26
            }
          },
          23: {
            start: {
              line: 52,
              column: 20
            },
            end: {
              line: 52,
              column: 95
            }
          },
          24: {
            start: {
              line: 53,
              column: 20
            },
            end: {
              line: 53,
              column: 26
            }
          },
          25: {
            start: {
              line: 55,
              column: 20
            },
            end: {
              line: 55,
              column: 102
            }
          },
          26: {
            start: {
              line: 56,
              column: 20
            },
            end: {
              line: 56,
              column: 26
            }
          },
          27: {
            start: {
              line: 59,
              column: 20
            },
            end: {
              line: 59,
              column: 63
            }
          },
          28: {
            start: {
              line: 63,
              column: 12
            },
            end: {
              line: 63,
              column: 55
            }
          },
          29: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 65,
              column: 61
            }
          },
          30: {
            start: {
              line: 66,
              column: 8
            },
            end: {
              line: 66,
              column: 80
            }
          },
          31: {
            start: {
              line: 67,
              column: 8
            },
            end: {
              line: 67,
              column: 97
            }
          },
          32: {
            start: {
              line: 70,
              column: 0
            },
            end: {
              line: 70,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 57
              },
              end: {
                line: 68,
                column: 5
              }
            },
            line: 21
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 30,
                column: 19
              },
              end: {
                line: 30,
                column: 44
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 30,
                column: 19
              },
              end: {
                line: 30,
                column: 39
              }
            }, {
              start: {
                line: 30,
                column: 43
              },
              end: {
                line: 30,
                column: 44
              }
            }],
            line: 30
          },
          1: {
            loc: {
              start: {
                line: 31,
                column: 19
              },
              end: {
                line: 31,
                column: 47
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 31,
                column: 19
              },
              end: {
                line: 31,
                column: 42
              }
            }, {
              start: {
                line: 31,
                column: 46
              },
              end: {
                line: 31,
                column: 47
              }
            }],
            line: 31
          },
          2: {
            loc: {
              start: {
                line: 32,
                column: 19
              },
              end: {
                line: 32,
                column: 45
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 32,
                column: 19
              },
              end: {
                line: 32,
                column: 40
              }
            }, {
              start: {
                line: 32,
                column: 44
              },
              end: {
                line: 32,
                column: 45
              }
            }],
            line: 32
          },
          3: {
            loc: {
              start: {
                line: 33,
                column: 19
              },
              end: {
                line: 33,
                column: 46
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 33,
                column: 19
              },
              end: {
                line: 33,
                column: 41
              }
            }, {
              start: {
                line: 33,
                column: 45
              },
              end: {
                line: 33,
                column: 46
              }
            }],
            line: 33
          },
          4: {
            loc: {
              start: {
                line: 35,
                column: 26
              },
              end: {
                line: 35,
                column: 68
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 35,
                column: 59
              },
              end: {
                line: 35,
                column: 62
              }
            }, {
              start: {
                line: 35,
                column: 65
              },
              end: {
                line: 35,
                column: 68
              }
            }],
            line: 35
          },
          5: {
            loc: {
              start: {
                line: 36,
                column: 23
              },
              end: {
                line: 36,
                column: 67
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 36,
                column: 58
              },
              end: {
                line: 36,
                column: 61
              }
            }, {
              start: {
                line: 36,
                column: 64
              },
              end: {
                line: 36,
                column: 67
              }
            }],
            line: 36
          },
          6: {
            loc: {
              start: {
                line: 37,
                column: 20
              },
              end: {
                line: 37,
                column: 60
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 37,
                column: 51
              },
              end: {
                line: 37,
                column: 54
              }
            }, {
              start: {
                line: 37,
                column: 57
              },
              end: {
                line: 37,
                column: 60
              }
            }],
            line: 37
          },
          7: {
            loc: {
              start: {
                line: 38,
                column: 26
              },
              end: {
                line: 38,
                column: 68
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 38,
                column: 59
              },
              end: {
                line: 38,
                column: 62
              }
            }, {
              start: {
                line: 38,
                column: 65
              },
              end: {
                line: 38,
                column: 68
              }
            }],
            line: 38
          },
          8: {
            loc: {
              start: {
                line: 46,
                column: 8
              },
              end: {
                line: 64,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 46,
                column: 8
              },
              end: {
                line: 64,
                column: 9
              }
            }, {
              start: {
                line: 46,
                column: 8
              },
              end: {
                line: 64,
                column: 9
              }
            }],
            line: 46
          },
          9: {
            loc: {
              start: {
                line: 46,
                column: 12
              },
              end: {
                line: 46,
                column: 95
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 46,
                column: 12
              },
              end: {
                line: 46,
                column: 49
              }
            }, {
              start: {
                line: 46,
                column: 53
              },
              end: {
                line: 46,
                column: 95
              }
            }],
            line: 46
          },
          10: {
            loc: {
              start: {
                line: 47,
                column: 12
              },
              end: {
                line: 60,
                column: 13
              }
            },
            type: "switch",
            locations: [{
              start: {
                line: 48,
                column: 16
              },
              end: {
                line: 50,
                column: 26
              }
            }, {
              start: {
                line: 51,
                column: 16
              },
              end: {
                line: 53,
                column: 26
              }
            }, {
              start: {
                line: 54,
                column: 16
              },
              end: {
                line: 56,
                column: 26
              }
            }, {
              start: {
                line: 57,
                column: 16
              },
              end: {
                line: 57,
                column: 55
              }
            }, {
              start: {
                line: 58,
                column: 16
              },
              end: {
                line: 59,
                column: 63
              }
            }],
            line: 47
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0],
          6: [0, 0],
          7: [0, 0],
          8: [0, 0],
          9: [0, 0],
          10: [0, 0, 0, 0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/anchor/anchor.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\anchor\\anchor.ts"],
          names: [],
          mappings: ";;AAEA,wDAAmD;AAEnD,0CAAyF;AACzF,+CAA4C;AAC5C,4CAAmG;AACnG,uEAAmE;AACnE,oEAAgE;AAChE,+CAA4C;AAC5C,0FAAqF;AACrF,2DAAuD;AAEvD,MAAM,cAAc,GAAc;IAC9B,YAAY,EAAE,IAAI;IAClB,cAAc,EAAE,KAAK;IACrB,UAAU,EAAE,KAAK;IACjB,YAAY,EAAE,IAAI;IAClB,gBAAgB,EAAE,EAAE;IACpB,kBAAkB,EAAE,EAAE;CACzB,CAAC;AAEF,YAAoB,SAAQ,6BAAY;IACpC,YAAY,WAAmB,EAAE,UAAgC,EAAE,cAA+B;QAC9F,KAAK,CAAC,WAAW,CAAC,CAAC;QAEnB,MAAM,QAAQ,mBACV,OAAO,EAAE;gBACL,GAAG,EAAE,CAAC;gBACN,MAAM,EAAE,CAAC;gBACT,IAAI,EAAE,CAAC;gBACP,KAAK,EAAE,CAAC;aACX,IACE,cAAc,EACd,cAAc,CAAC,QAAQ,CAC7B,CAAC;QAEF,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,oCAAgB,CAAC;YACjB,KAAK,EAAE,QAAQ,CAAC,OAAO,CAAC,GAAG,IAAI,CAAC;YAChC,KAAK,EAAE,QAAQ,CAAC,OAAO,CAAC,MAAM,IAAI,CAAC;YACnC,KAAK,EAAE,QAAQ,CAAC,OAAO,CAAC,IAAI,IAAI,CAAC;YACjC,KAAK,EAAE,QAAQ,CAAC,OAAO,CAAC,KAAK,IAAI,CAAC;YAClC,SAAS,EAAE,GAAG;YACd,YAAY,EAAE,QAAQ,CAAC,YAAY,KAAK,IAAI,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,GAAG;YACxD,SAAS,EAAE,QAAQ,CAAC,cAAc,KAAK,IAAI,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,GAAG;YACvD,MAAM,EAAE,QAAQ,CAAC,UAAU,KAAK,IAAI,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,GAAG;YAChD,YAAY,EAAE,QAAQ,CAAC,YAAY,KAAK,IAAI,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,GAAG;YACxD,cAAc,EAAE,UAAU,CAAC,IAAI,CAAC,CAAC;SACpC,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAS,EAAE,CAAC,CAAC;QAChC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,6BAAkB,CAAC,QAAQ,CAAC,kBAAkB,CAAC,CAAC,CAAC;QACpE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2BAAgB,CAAC,QAAQ,CAAC,gBAAgB,CAAC,CAAC,CAAC;QAChE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,eAAM,CAAC,UAAU,CAAC,IAAI,CAAC,CAAC,EAAE,UAAU,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC;QACjE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,4BAAY,EAAE,CAAC,CAAC;QAEnC,IAAI,cAAc,CAAC,QAAQ,KAAK,SAAS,IAAI,cAAc,CAAC,QAAQ,CAAC,IAAI,KAAK,SAAS,EAAE;YACrF,QAAQ,cAAc,CAAC,QAAQ,CAAC,IAAI,CAAC,IAAI,EAAE;gBACvC,KAAK,4BAAgB,CAAC,MAAM;oBACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,sBAAU,CAAC,cAAc,CAAC,QAAQ,CAAC,IAAI,EAAE,cAAc,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAC,CAAC;oBAC9F,MAAM;gBACV,KAAK,4BAAgB,CAAC,KAAK;oBACvB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,qBAAS,CAAC,cAAc,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAC,CAAC;oBAC/D,MAAM;gBACV,KAAK,4BAAgB,CAAC,cAAc;oBAChC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,4BAAgB,CAAC,cAAc,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAC,CAAC;oBACtE,MAAM;gBACV,KAAK,4BAAgB,CAAC,IAAI,CAAC;gBAC3B;oBACI,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAQ,EAAE,CAAC,CAAC;aACtC;SACJ;aAAM;YACH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAQ,EAAE,CAAC,CAAC;SAClC;QAED,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,8BAAa,EAAE,CAAC,CAAC;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iDAAsB,EAAE,CAAC,CAAC;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,WAAW,EAAE,UAAU,CAAC,IAAI,CAAC,CAAC,EAAE,UAAU,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC;IACnF,CAAC;CACJ;AA3DD,wBA2DC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating.php\r\nimport { IMediaDataDimensions } from "file/media";\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { IDrawingOptions } from "../drawing";\r\nimport { HorizontalPosition, IFloating, SimplePos, VerticalPosition } from "../floating";\r\nimport { Graphic } from "../inline/graphic";\r\nimport { TextWrappingType, WrapNone, WrapSquare, WrapTight, WrapTopAndBottom } from "../text-wrap";\r\nimport { DocProperties } from "./../doc-properties/doc-properties";\r\nimport { EffectExtent } from "./../effect-extent/effect-extent";\r\nimport { Extent } from "./../extent/extent";\r\nimport { GraphicFrameProperties } from "./../graphic-frame/graphic-frame-properties";\r\nimport { AnchorAttributes } from "./anchor-attributes";\r\n\r\nconst defaultOptions: IFloating = {\r\n    allowOverlap: true,\r\n    behindDocument: false,\r\n    lockAnchor: false,\r\n    layoutInCell: true,\r\n    verticalPosition: {},\r\n    horizontalPosition: {},\r\n};\r\n\r\nexport class Anchor extends XmlComponent {\r\n    constructor(referenceId: number, dimensions: IMediaDataDimensions, drawingOptions: IDrawingOptions) {\r\n        super("wp:anchor");\r\n\r\n        const floating = {\r\n            margins: {\r\n                top: 0,\r\n                bottom: 0,\r\n                left: 0,\r\n                right: 0,\r\n            },\r\n            ...defaultOptions,\r\n            ...drawingOptions.floating,\r\n        };\r\n\r\n        this.root.push(\r\n            new AnchorAttributes({\r\n                distT: floating.margins.top || 0,\r\n                distB: floating.margins.bottom || 0,\r\n                distL: floating.margins.left || 0,\r\n                distR: floating.margins.right || 0,\r\n                simplePos: "0", // note: word doesn\'t fully support - so we use 0\r\n                allowOverlap: floating.allowOverlap === true ? "1" : "0",\r\n                behindDoc: floating.behindDocument === true ? "1" : "0",\r\n                locked: floating.lockAnchor === true ? "1" : "0",\r\n                layoutInCell: floating.layoutInCell === true ? "1" : "0",\r\n                relativeHeight: dimensions.emus.y,\r\n            }),\r\n        );\r\n\r\n        this.root.push(new SimplePos());\r\n        this.root.push(new HorizontalPosition(floating.horizontalPosition));\r\n        this.root.push(new VerticalPosition(floating.verticalPosition));\r\n        this.root.push(new Extent(dimensions.emus.x, dimensions.emus.y));\r\n        this.root.push(new EffectExtent());\r\n\r\n        if (drawingOptions.floating !== undefined && drawingOptions.floating.wrap !== undefined) {\r\n            switch (drawingOptions.floating.wrap.type) {\r\n                case TextWrappingType.SQUARE:\r\n                    this.root.push(new WrapSquare(drawingOptions.floating.wrap, drawingOptions.floating.margins));\r\n                    break;\r\n                case TextWrappingType.TIGHT:\r\n                    this.root.push(new WrapTight(drawingOptions.floating.margins));\r\n                    break;\r\n                case TextWrappingType.TOP_AND_BOTTOM:\r\n                    this.root.push(new WrapTopAndBottom(drawingOptions.floating.margins));\r\n                    break;\r\n                case TextWrappingType.NONE:\r\n                default:\r\n                    this.root.push(new WrapNone());\r\n            }\r\n        } else {\r\n            this.root.push(new WrapNone());\r\n        }\r\n\r\n        this.root.push(new DocProperties());\r\n        this.root.push(new GraphicFrameProperties());\r\n        this.root.push(new Graphic(referenceId, dimensions.emus.x, dimensions.emus.y));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(68)),
          p = (a.s[3]++, t(71)),
          m = (a.s[4]++, t(39)),
          C = (a.s[5]++, t(72)),
          d = (a.s[6]++, t(73)),
          f = (a.s[7]++, t(74)),
          h = (a.s[8]++, t(75)),
          x = (a.s[9]++, t(76)),
          g = (a.s[10]++, {
        allowOverlap: !0,
        behindDocument: !1,
        lockAnchor: !1,
        layoutInCell: !0,
        verticalPosition: {},
        horizontalPosition: {}
      });

      var I =
      /*#__PURE__*/
      function (_c$XmlComponent76) {
        _inherits(I, _c$XmlComponent76);

        function I(e, n, t) {
          var _this153;

          _classCallCheck(this, I);

          a.f[0]++, a.s[11]++, _this153 = _possibleConstructorReturn(this, _getPrototypeOf(I).call(this, "wp:anchor"));
          var r = (a.s[12]++, Object.assign({
            margins: {
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            }
          }, g, t.floating));
          if (a.s[13]++, _this153.root.push(new x.AnchorAttributes({
            distT: (a.b[0][0]++, r.margins.top || (a.b[0][1]++, 0)),
            distB: (a.b[1][0]++, r.margins.bottom || (a.b[1][1]++, 0)),
            distL: (a.b[2][0]++, r.margins.left || (a.b[2][1]++, 0)),
            distR: (a.b[3][0]++, r.margins.right || (a.b[3][1]++, 0)),
            simplePos: "0",
            allowOverlap: !0 === r.allowOverlap ? (a.b[4][0]++, "1") : (a.b[4][1]++, "0"),
            behindDoc: !0 === r.behindDocument ? (a.b[5][0]++, "1") : (a.b[5][1]++, "0"),
            locked: !0 === r.lockAnchor ? (a.b[6][0]++, "1") : (a.b[6][1]++, "0"),
            layoutInCell: !0 === r.layoutInCell ? (a.b[7][0]++, "1") : (a.b[7][1]++, "0"),
            relativeHeight: n.emus.y
          })), a.s[14]++, _this153.root.push(new u.SimplePos()), a.s[15]++, _this153.root.push(new u.HorizontalPosition(r.horizontalPosition)), a.s[16]++, _this153.root.push(new u.VerticalPosition(r.verticalPosition)), a.s[17]++, _this153.root.push(new f.Extent(n.emus.x, n.emus.y)), a.s[18]++, _this153.root.push(new d.EffectExtent()), a.s[19]++, a.b[9][0]++, void 0 !== t.floating && (a.b[9][1]++, void 0 !== t.floating.wrap)) switch (a.b[8][0]++, a.s[20]++, t.floating.wrap.type) {
            case m.TextWrappingType.SQUARE:
              a.b[10][0]++, a.s[21]++, _this153.root.push(new m.WrapSquare(t.floating.wrap, t.floating.margins)), a.s[22]++;
              break;

            case m.TextWrappingType.TIGHT:
              a.b[10][1]++, a.s[23]++, _this153.root.push(new m.WrapTight(t.floating.margins)), a.s[24]++;
              break;

            case m.TextWrappingType.TOP_AND_BOTTOM:
              a.b[10][2]++, a.s[25]++, _this153.root.push(new m.WrapTopAndBottom(t.floating.margins)), a.s[26]++;
              break;

            case m.TextWrappingType.NONE:
              a.b[10][3]++;

            default:
              a.b[10][4]++, a.s[27]++, _this153.root.push(new m.WrapNone());
          } else a.b[8][1]++, a.s[28]++, _this153.root.push(new m.WrapNone());
          a.s[29]++, _this153.root.push(new C.DocProperties()), a.s[30]++, _this153.root.push(new h.GraphicFrameProperties()), a.s[31]++, _this153.root.push(new p.Graphic(e, n.emus.x, n.emus.y));
          return _this153;
        }

        return I;
      }(c.XmlComponent);

      a.s[32]++, n.Anchor = I;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\simple-pos.ts", o = "d0d41d38b4a0675f6c82b48524af05f2e8fc9c27", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\simple-pos.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 30
            }
          },
          5: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 19,
              column: 12
            }
          },
          6: {
            start: {
              line: 22,
              column: 0
            },
            end: {
              line: 22,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 18
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 14
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/floating/simple-pos.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\floating\\simple-pos.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAO1E,yBAA0B,SAAQ,sCAA2C;IAA7E;;QACuB,YAAO,GAAG;YACzB,CAAC,EAAE,GAAG;YACN,CAAC,EAAE,GAAG;SACT,CAAC;IACN,CAAC;CAAA;AAED,eAAuB,SAAQ,6BAAY;IACvC;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;QAGtB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,mBAAmB,CAAC;YACpB,CAAC,EAAE,CAAC;YACJ,CAAC,EAAE,CAAC;SACP,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAZD,8BAYC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-position.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\ninterface ISimplePosAttributes {\r\n    readonly x: number;\r\n    readonly y: number;\r\n}\r\n\r\nclass SimplePosAttributes extends XmlAttributeComponent<ISimplePosAttributes> {\r\n    protected readonly xmlKeys = {\r\n        x: "x",\r\n        y: "y",\r\n    };\r\n}\r\n\r\nexport class SimplePos extends XmlComponent {\r\n    constructor() {\r\n        super("wp:simplePos");\r\n\r\n        // NOTE: It\'s not fully supported in Microsoft Word, but this element is needed anyway\r\n        this.root.push(\r\n            new SimplePosAttributes({\r\n                x: 0,\r\n                y: 0,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon24) {
        _inherits(u, _c$XmlAttributeCompon24);

        function u() {
          var _this154;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this154 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this154.xmlKeys = {
            x: "x",
            y: "y"
          };
          return _this154;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent77) {
        _inherits(p, _c$XmlComponent77);

        function p() {
          var _this155;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this155 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "wp:simplePos")), a.s[5]++, _this155.root.push(new u({
            x: 0,
            y: 0
          }));
          return _this155;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.SimplePos = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\horizontal-position.ts", o = "d257fe4d7f9673da8880abd5108ec2a737eff991", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\horizontal-position.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 5,
              column: 28
            },
            end: {
              line: 5,
              column: 58
            }
          },
          4: {
            start: {
              line: 6,
              column: 26
            },
            end: {
              line: 6,
              column: 54
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 28
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 12,
              column: 10
            }
          },
          7: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 30
            }
          },
          8: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 20,
              column: 12
            }
          },
          9: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 29,
              column: 9
            }
          },
          10: {
            start: {
              line: 22,
              column: 12
            },
            end: {
              line: 22,
              column: 72
            }
          },
          11: {
            start: {
              line: 24,
              column: 13
            },
            end: {
              line: 29,
              column: 9
            }
          },
          12: {
            start: {
              line: 25,
              column: 12
            },
            end: {
              line: 25,
              column: 92
            }
          },
          13: {
            start: {
              line: 28,
              column: 12
            },
            end: {
              line: 28,
              column: 106
            }
          },
          14: {
            start: {
              line: 32,
              column: 0
            },
            end: {
              line: 32,
              column: 48
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 36
              },
              end: {
                line: 30,
                column: 5
              }
            },
            line: 16
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 19,
                column: 26
              },
              end: {
                line: 19,
                column: 112
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 19,
                column: 26
              },
              end: {
                line: 19,
                column: 53
              }
            }, {
              start: {
                line: 19,
                column: 57
              },
              end: {
                line: 19,
                column: 112
              }
            }],
            line: 19
          },
          1: {
            loc: {
              start: {
                line: 21,
                column: 8
              },
              end: {
                line: 29,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 21,
                column: 8
              },
              end: {
                line: 29,
                column: 9
              }
            }, {
              start: {
                line: 21,
                column: 8
              },
              end: {
                line: 29,
                column: 9
              }
            }],
            line: 21
          },
          2: {
            loc: {
              start: {
                line: 24,
                column: 13
              },
              end: {
                line: 29,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 24,
                column: 13
              },
              end: {
                line: 29,
                column: 9
              }
            }, {
              start: {
                line: 24,
                column: 13
              },
              end: {
                line: 29,
                column: 9
              }
            }],
            line: 24
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/floating/horizontal-position.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\floating\\horizontal-position.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAC1E,mCAAgC;AAChC,2DAAiG;AACjG,uDAAmD;AAMnD,kCAAmC,SAAQ,sCAAoD;IAA/F;;QACuB,YAAO,GAAG;YACzB,YAAY,EAAE,cAAc;SAC/B,CAAC;IACN,CAAC;CAAA;AAED,wBAAgC,SAAQ,6BAAY;IAChD,YAAY,kBAA8C;QACtD,KAAK,CAAC,cAAc,CAAC,CAAC;QAEtB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,4BAA4B,CAAC;YAC7B,YAAY,EAAE,kBAAkB,CAAC,QAAQ,IAAI,kDAA8B,CAAC,IAAI;SACnF,CAAC,CACL,CAAC;QAEF,IAAI,kBAAkB,CAAC,KAAK,EAAE;YAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,kBAAkB,CAAC,KAAK,CAAC,CAAC,CAAC;SACvD;aAAM,IAAI,kBAAkB,CAAC,MAAM,KAAK,SAAS,EAAE;YAChD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gCAAc,CAAC,kBAAkB,CAAC,MAAM,CAAC,CAAC,CAAC;SACjE;aAAM;YACH,MAAM,IAAI,KAAK,CAAC,4EAA4E,CAAC,CAAC;SACjG;IACL,CAAC;CACJ;AAlBD,gDAkBC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-position.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport { Align } from "./align";\r\nimport { HorizontalPositionRelativeFrom, IHorizontalPositionOptions } from "./floating-position";\r\nimport { PositionOffset } from "./position-offset";\r\n\r\ninterface IHorizontalPositionAttributes {\r\n    readonly relativeFrom: HorizontalPositionRelativeFrom;\r\n}\r\n\r\nclass HorizontalPositionAttributes extends XmlAttributeComponent<IHorizontalPositionAttributes> {\r\n    protected readonly xmlKeys = {\r\n        relativeFrom: "relativeFrom",\r\n    };\r\n}\r\n\r\nexport class HorizontalPosition extends XmlComponent {\r\n    constructor(horizontalPosition: IHorizontalPositionOptions) {\r\n        super("wp:positionH");\r\n\r\n        this.root.push(\r\n            new HorizontalPositionAttributes({\r\n                relativeFrom: horizontalPosition.relative || HorizontalPositionRelativeFrom.PAGE,\r\n            }),\r\n        );\r\n\r\n        if (horizontalPosition.align) {\r\n            this.root.push(new Align(horizontalPosition.align));\r\n        } else if (horizontalPosition.offset !== undefined) {\r\n            this.root.push(new PositionOffset(horizontalPosition.offset));\r\n        } else {\r\n            throw new Error("There is no configuration provided for floating position (Align or offset)");\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(69)),
          p = (a.s[3]++, t(38)),
          m = (a.s[4]++, t(70));

      var C =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon25) {
        _inherits(C, _c$XmlAttributeCompon25);

        function C() {
          var _this156;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this156 = _possibleConstructorReturn(this, _getPrototypeOf(C).apply(this, arguments)), a.s[6]++, _this156.xmlKeys = {
            relativeFrom: "relativeFrom"
          };
          return _this156;
        }

        return C;
      }(c.XmlAttributeComponent);

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent78) {
        _inherits(d, _c$XmlComponent78);

        function d(e) {
          var _this157;

          _classCallCheck(this, d);

          if (a.f[1]++, a.s[7]++, _this157 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "wp:positionH")), a.s[8]++, _this157.root.push(new C({
            relativeFrom: (a.b[0][0]++, e.relative || (a.b[0][1]++, p.HorizontalPositionRelativeFrom.PAGE))
          })), a.s[9]++, e.align) a.b[1][0]++, a.s[10]++, _this157.root.push(new u.Align(e.align));else {
            if (a.b[1][1]++, a.s[11]++, void 0 === e.offset) throw a.b[2][1]++, a.s[13]++, new Error("There is no configuration provided for floating position (Align or offset)");
            a.b[2][0]++, a.s[12]++, _this157.root.push(new m.PositionOffset(e.offset));
          }
          return _possibleConstructorReturn(_this157);
        }

        return d;
      }(c.XmlComponent);

      a.s[14]++, n.HorizontalPosition = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\vertical-position.ts", o = "80a798df08096cebe7ed1f22541909177f512c4f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\floating\\vertical-position.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 5,
              column: 28
            },
            end: {
              line: 5,
              column: 58
            }
          },
          4: {
            start: {
              line: 6,
              column: 26
            },
            end: {
              line: 6,
              column: 54
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 28
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 12,
              column: 10
            }
          },
          7: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 30
            }
          },
          8: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 20,
              column: 12
            }
          },
          9: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 29,
              column: 9
            }
          },
          10: {
            start: {
              line: 22,
              column: 12
            },
            end: {
              line: 22,
              column: 70
            }
          },
          11: {
            start: {
              line: 24,
              column: 13
            },
            end: {
              line: 29,
              column: 9
            }
          },
          12: {
            start: {
              line: 25,
              column: 12
            },
            end: {
              line: 25,
              column: 90
            }
          },
          13: {
            start: {
              line: 28,
              column: 12
            },
            end: {
              line: 28,
              column: 106
            }
          },
          14: {
            start: {
              line: 32,
              column: 0
            },
            end: {
              line: 32,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 34
              },
              end: {
                line: 30,
                column: 5
              }
            },
            line: 16
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 19,
                column: 26
              },
              end: {
                line: 19,
                column: 108
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 19,
                column: 26
              },
              end: {
                line: 19,
                column: 51
              }
            }, {
              start: {
                line: 19,
                column: 55
              },
              end: {
                line: 19,
                column: 108
              }
            }],
            line: 19
          },
          1: {
            loc: {
              start: {
                line: 21,
                column: 8
              },
              end: {
                line: 29,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 21,
                column: 8
              },
              end: {
                line: 29,
                column: 9
              }
            }, {
              start: {
                line: 21,
                column: 8
              },
              end: {
                line: 29,
                column: 9
              }
            }],
            line: 21
          },
          2: {
            loc: {
              start: {
                line: 24,
                column: 13
              },
              end: {
                line: 29,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 24,
                column: 13
              },
              end: {
                line: 29,
                column: 9
              }
            }, {
              start: {
                line: 24,
                column: 13
              },
              end: {
                line: 29,
                column: 9
              }
            }],
            line: 24
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/floating/vertical-position.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\floating\\vertical-position.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAC1E,mCAAgC;AAChC,2DAA6F;AAC7F,uDAAmD;AAMnD,gCAAiC,SAAQ,sCAAkD;IAA3F;;QACuB,YAAO,GAAG;YACzB,YAAY,EAAE,cAAc;SAC/B,CAAC;IACN,CAAC;CAAA;AAED,sBAA8B,SAAQ,6BAAY;IAC9C,YAAY,gBAA0C;QAClD,KAAK,CAAC,cAAc,CAAC,CAAC;QAEtB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,0BAA0B,CAAC;YAC3B,YAAY,EAAE,gBAAgB,CAAC,QAAQ,IAAI,gDAA4B,CAAC,IAAI;SAC/E,CAAC,CACL,CAAC;QAEF,IAAI,gBAAgB,CAAC,KAAK,EAAE;YACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,gBAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;SACrD;aAAM,IAAI,gBAAgB,CAAC,MAAM,KAAK,SAAS,EAAE;YAC9C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gCAAc,CAAC,gBAAgB,CAAC,MAAM,CAAC,CAAC,CAAC;SAC/D;aAAM;YACH,MAAM,IAAI,KAAK,CAAC,4EAA4E,CAAC,CAAC;SACjG;IACL,CAAC;CACJ;AAlBD,4CAkBC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-position.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport { Align } from "./align";\r\nimport { IVerticalPositionOptions, VerticalPositionRelativeFrom } from "./floating-position";\r\nimport { PositionOffset } from "./position-offset";\r\n\r\ninterface IVerticalPositionAttributes {\r\n    readonly relativeFrom: VerticalPositionRelativeFrom;\r\n}\r\n\r\nclass VerticalPositionAttributes extends XmlAttributeComponent<IVerticalPositionAttributes> {\r\n    protected readonly xmlKeys = {\r\n        relativeFrom: "relativeFrom",\r\n    };\r\n}\r\n\r\nexport class VerticalPosition extends XmlComponent {\r\n    constructor(verticalPosition: IVerticalPositionOptions) {\r\n        super("wp:positionV");\r\n\r\n        this.root.push(\r\n            new VerticalPositionAttributes({\r\n                relativeFrom: verticalPosition.relative || VerticalPositionRelativeFrom.PAGE,\r\n            }),\r\n        );\r\n\r\n        if (verticalPosition.align) {\r\n            this.root.push(new Align(verticalPosition.align));\r\n        } else if (verticalPosition.offset !== undefined) {\r\n            this.root.push(new PositionOffset(verticalPosition.offset));\r\n        } else {\r\n            throw new Error("There is no configuration provided for floating position (Align or offset)");\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(69)),
          p = (a.s[3]++, t(38)),
          m = (a.s[4]++, t(70));

      var C =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon26) {
        _inherits(C, _c$XmlAttributeCompon26);

        function C() {
          var _this158;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this158 = _possibleConstructorReturn(this, _getPrototypeOf(C).apply(this, arguments)), a.s[6]++, _this158.xmlKeys = {
            relativeFrom: "relativeFrom"
          };
          return _this158;
        }

        return C;
      }(c.XmlAttributeComponent);

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent79) {
        _inherits(d, _c$XmlComponent79);

        function d(e) {
          var _this159;

          _classCallCheck(this, d);

          if (a.f[1]++, a.s[7]++, _this159 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "wp:positionV")), a.s[8]++, _this159.root.push(new C({
            relativeFrom: (a.b[0][0]++, e.relative || (a.b[0][1]++, p.VerticalPositionRelativeFrom.PAGE))
          })), a.s[9]++, e.align) a.b[1][0]++, a.s[10]++, _this159.root.push(new u.Align(e.align));else {
            if (a.b[1][1]++, a.s[11]++, void 0 === e.offset) throw a.b[2][1]++, a.s[13]++, new Error("There is no configuration provided for floating position (Align or offset)");
            a.b[2][0]++, a.s[12]++, _this159.root.push(new m.PositionOffset(e.offset));
          }
          return _possibleConstructorReturn(_this159);
        }

        return d;
      }(c.XmlComponent);

      a.s[14]++, n.VerticalPosition = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic.ts", o = "acfe71c78d453fe9b5546f63ea0958093473cce4", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 23
            },
            end: {
              line: 4,
              column: 48
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          5: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 27
            }
          },
          6: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 18,
              column: 12
            }
          },
          7: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 70
            }
          },
          8: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 34
            }
          },
          9: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 30
            }
          },
          10: {
            start: {
              line: 26,
              column: 0
            },
            end: {
              line: 26,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 35
              },
              end: {
                line: 21,
                column: 5
              }
            },
            line: 14
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 22,
                column: 4
              },
              end: {
                line: 22,
                column: 5
              }
            },
            loc: {
              start: {
                line: 22,
                column: 16
              },
              end: {
                line: 24,
                column: 5
              }
            },
            line: 22
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAC1E,iDAA6C;AAM7C,uBAAwB,SAAQ,sCAAyC;IAAzE;;QACuB,YAAO,GAAG;YACzB,CAAC,EAAE,SAAS;SACf,CAAC;IACN,CAAC;CAAA;AAED,aAAqB,SAAQ,6BAAY;IAGrC,YAAY,WAAmB,EAAE,CAAS,EAAE,CAAS;QACjD,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,iBAAiB,CAAC;YAClB,CAAC,EAAE,uDAAuD;SAC7D,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,IAAI,GAAG,IAAI,0BAAW,CAAC,WAAW,EAAE,CAAC,EAAE,CAAC,CAAC,CAAC;QAE/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;IAC9B,CAAC;IAEM,KAAK,CAAC,CAAS,EAAE,CAAS;QAC7B,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;IAC1B,CAAC;CACJ;AAnBD,0BAmBC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport { GraphicData } from "./graphic-data";\r\n\r\ninterface IGraphicProperties {\r\n    readonly a: string;\r\n}\r\n\r\nclass GraphicAttributes extends XmlAttributeComponent<IGraphicProperties> {\r\n    protected readonly xmlKeys = {\r\n        a: "xmlns:a",\r\n    };\r\n}\r\n\r\nexport class Graphic extends XmlComponent {\r\n    private readonly data: GraphicData;\r\n\r\n    constructor(referenceId: number, x: number, y: number) {\r\n        super("a:graphic");\r\n        this.root.push(\r\n            new GraphicAttributes({\r\n                a: "http://schemas.openxmlformats.org/drawingml/2006/main",\r\n            }),\r\n        );\r\n\r\n        this.data = new GraphicData(referenceId, x, y);\r\n\r\n        this.root.push(this.data);\r\n    }\r\n\r\n    public setXY(x: number, y: number): void {\r\n        this.data.setXY(x, y);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(166));

      var p =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon27) {
        _inherits(p, _c$XmlAttributeCompon27);

        function p() {
          var _this160;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this160 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this160.xmlKeys = {
            a: "xmlns:a"
          };
          return _this160;
        }

        return p;
      }(c.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent80) {
        _inherits(m, _c$XmlComponent80);

        function m(e, n, t) {
          var _this161;

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this161 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "a:graphic")), a.s[6]++, _this161.root.push(new p({
            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
          })), a.s[7]++, _this161.data = new u.GraphicData(e, n, t), a.s[8]++, _this161.root.push(_this161.data);
          return _this161;
        }

        _createClass(m, [{
          key: "setXY",
          value: function setXY(e, n) {
            a.f[2]++, a.s[9]++, this.data.setXY(e, n);
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[10]++, n.Graphic = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\index.ts", o = "9d927910ce5f0df11a12b32d178d90517de6effb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,oCAA+B",
          sourcesContent: ['export * from "./graphic-data";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(167));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\graphic-data.ts", o = "ba3bf7b76678510c322d384dcba45f881c9bb59c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\graphic-data.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 33
            },
            end: {
              line: 4,
              column: 68
            }
          },
          3: {
            start: {
              line: 5,
              column: 14
            },
            end: {
              line: 5,
              column: 30
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 31
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 52
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 33
            }
          },
          8: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 29
            }
          },
          9: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 34
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 35
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 15,
                column: 4
              },
              end: {
                line: 15,
                column: 5
              }
            },
            loc: {
              start: {
                line: 15,
                column: 16
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 15
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/graphic-data.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\graphic-data.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,qEAAiE;AACjE,+BAA4B;AAE5B,iBAAyB,SAAQ,6BAAY;IAGzC,YAAY,WAAmB,EAAE,CAAS,EAAE,CAAS;QACjD,KAAK,CAAC,eAAe,CAAC,CAAC;QAEvB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,8CAAqB,CAAC;YACtB,GAAG,EAAE,0DAA0D;SAClE,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,GAAG,GAAG,IAAI,SAAG,CAAC,WAAW,EAAE,CAAC,EAAE,CAAC,CAAC,CAAC;QAEtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;IAC7B,CAAC;IAEM,KAAK,CAAC,CAAS,EAAE,CAAS;QAC7B,IAAI,CAAC,GAAG,CAAC,KAAK,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;IACzB,CAAC;CACJ;AApBD,kCAoBC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { GraphicDataAttributes } from "./graphic-data-attribute";\r\nimport { Pic } from "./pic";\r\n\r\nexport class GraphicData extends XmlComponent {\r\n    private readonly pic: Pic;\r\n\r\n    constructor(referenceId: number, x: number, y: number) {\r\n        super("a:graphicData");\r\n\r\n        this.root.push(\r\n            new GraphicDataAttributes({\r\n                uri: "http://schemas.openxmlformats.org/drawingml/2006/picture",\r\n            }),\r\n        );\r\n\r\n        this.pic = new Pic(referenceId, x, y);\r\n\r\n        this.root.push(this.pic);\r\n    }\r\n\r\n    public setXY(x: number, y: number): void {\r\n        this.pic.setXY(x, y);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(168)),
          p = (a.s[3]++, t(169));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent81) {
        _inherits(m, _c$XmlComponent81);

        function m(e, n, t) {
          var _this162;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this162 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "a:graphicData")), a.s[5]++, _this162.root.push(new u.GraphicDataAttributes({
            uri: "http://schemas.openxmlformats.org/drawingml/2006/picture"
          })), a.s[6]++, _this162.pic = new p.Pic(e, n, t), a.s[7]++, _this162.root.push(_this162.pic);
          return _this162;
        }

        _createClass(m, [{
          key: "setXY",
          value: function setXY(e, n) {
            a.f[1]++, a.s[8]++, this.pic.setXY(e, n);
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[9]++, n.GraphicData = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\graphic-data-attribute.ts", o = "3eeb6d10c87c8ba00651fdf96918975a515cf133", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\graphic-data-attribute.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 54
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/graphic-data-attribute.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\graphic-data-attribute.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,2BAAmC,SAAQ,sCAA6C;IAAxF;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,KAAK;SACb,CAAC;IACN,CAAC;CAAA;AAJD,sDAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IGraphicDataAttributes {\r\n    readonly uri?: string;\r\n}\r\n\r\nexport class GraphicDataAttributes extends XmlAttributeComponent<IGraphicDataAttributes> {\r\n    protected readonly xmlKeys = {\r\n        uri: "uri",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon28) {
        _inherits(u, _c$XmlAttributeCompon28);

        function u() {
          var _this163;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this163 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this163.xmlKeys = {
            uri: "uri"
          };
          return _this163;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.GraphicDataAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\index.ts", o = "8c27e9a0b5a7b7d01483c2ac64a47b07f576c510", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 27
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,2BAAsB",
          sourcesContent: ['export * from "./pic";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(170));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\pic.ts", o = "f9c391c16781dcc3a9f96f53d28226fc91b1ec7f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\pic.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 20
            },
            end: {
              line: 4,
              column: 47
            }
          },
          3: {
            start: {
              line: 5,
              column: 36
            },
            end: {
              line: 5,
              column: 100
            }
          },
          4: {
            start: {
              line: 6,
              column: 25
            },
            end: {
              line: 6,
              column: 52
            }
          },
          5: {
            start: {
              line: 7,
              column: 27
            },
            end: {
              line: 7,
              column: 73
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 25
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 13,
              column: 12
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 76
            }
          },
          9: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 81
            }
          },
          10: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 62
            }
          },
          11: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 69
            }
          },
          12: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 41
            }
          },
          13: {
            start: {
              line: 23,
              column: 0
            },
            end: {
              line: 23,
              column: 18
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 9,
                column: 4
              },
              end: {
                line: 9,
                column: 5
              }
            },
            loc: {
              start: {
                line: 9,
                column: 35
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 9
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 19,
                column: 4
              },
              end: {
                line: 19,
                column: 5
              }
            },
            loc: {
              start: {
                line: 19,
                column: 16
              },
              end: {
                line: 21,
                column: 5
              }
            },
            line: 19
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/pic.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\pic.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,gDAA4C;AAC5C,qGAA+F;AAC/F,qDAAiD;AACjD,0EAAsE;AAEtE,SAAiB,SAAQ,6BAAY;IAGjC,YAAY,WAAmB,EAAE,CAAS,EAAE,CAAS;QACjD,KAAK,CAAC,SAAS,CAAC,CAAC;QAEjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,8BAAa,CAAC;YACd,KAAK,EAAE,0DAA0D;SACpE,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,eAAe,GAAG,IAAI,kCAAe,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;QAEjD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,kDAAsB,EAAE,CAAC,CAAC;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAQ,CAAC,WAAW,CAAC,CAAC,CAAC;QAC1C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,kCAAe,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC,CAAC;IAC9C,CAAC;IAEM,KAAK,CAAC,CAAS,EAAE,CAAS;QAC7B,IAAI,CAAC,eAAe,CAAC,KAAK,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;IACrC,CAAC;CACJ;AAtBD,kBAsBC",
          sourcesContent: ['// http://officeopenxml.com/drwPic.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { BlipFill } from "./blip/blip-fill";\r\nimport { NonVisualPicProperties } from "./non-visual-pic-properties/non-visual-pic-properties";\r\nimport { PicAttributes } from "./pic-attributes";\r\nimport { ShapeProperties } from "./shape-properties/shape-properties";\r\n\r\nexport class Pic extends XmlComponent {\r\n    private readonly shapeProperties: ShapeProperties;\r\n\r\n    constructor(referenceId: number, x: number, y: number) {\r\n        super("pic:pic");\r\n\r\n        this.root.push(\r\n            new PicAttributes({\r\n                xmlns: "http://schemas.openxmlformats.org/drawingml/2006/picture",\r\n            }),\r\n        );\r\n\r\n        this.shapeProperties = new ShapeProperties(x, y);\r\n\r\n        this.root.push(new NonVisualPicProperties());\r\n        this.root.push(new BlipFill(referenceId));\r\n        this.root.push(new ShapeProperties(x, y));\r\n    }\r\n\r\n    public setXY(x: number, y: number): void {\r\n        this.shapeProperties.setXY(x, y);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(171)),
          p = (a.s[3]++, t(175)),
          m = (a.s[4]++, t(181)),
          C = (a.s[5]++, t(182));

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent82) {
        _inherits(d, _c$XmlComponent82);

        function d(e, n, t) {
          var _this164;

          _classCallCheck(this, d);

          a.f[0]++, a.s[6]++, _this164 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "pic:pic")), a.s[7]++, _this164.root.push(new m.PicAttributes({
            xmlns: "http://schemas.openxmlformats.org/drawingml/2006/picture"
          })), a.s[8]++, _this164.shapeProperties = new C.ShapeProperties(n, t), a.s[9]++, _this164.root.push(new p.NonVisualPicProperties()), a.s[10]++, _this164.root.push(new u.BlipFill(e)), a.s[11]++, _this164.root.push(new C.ShapeProperties(n, t));
          return _this164;
        }

        _createClass(d, [{
          key: "setXY",
          value: function setXY(e, n) {
            a.f[1]++, a.s[12]++, this.shapeProperties.setXY(e, n);
          }
        }]);

        return d;
      }(c.XmlComponent);

      a.s[13]++, n.Pic = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\blip-fill.ts", o = "6d25ccdff8b4a0a83cfe04acb8a0e10340758a6e", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\blip-fill.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 15
            },
            end: {
              line: 4,
              column: 32
            }
          },
          3: {
            start: {
              line: 5,
              column: 27
            },
            end: {
              line: 5,
              column: 56
            }
          },
          4: {
            start: {
              line: 6,
              column: 18
            },
            end: {
              line: 6,
              column: 38
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 30
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 53
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 65
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 48
            }
          },
          9: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 29
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 8
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/blip/blip-fill.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\blip-fill.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,iCAA8B;AAC9B,yDAAqD;AACrD,uCAAoC;AAEpC,cAAsB,SAAQ,6BAAY;IACtC,YAAY,WAAmB;QAC3B,KAAK,CAAC,cAAc,CAAC,CAAC;QACtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,WAAI,CAAC,WAAW,CAAC,CAAC,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,kCAAe,EAAE,CAAC,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,EAAE,CAAC,CAAC;IAClC,CAAC;CACJ;AAPD,4BAOC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { Blip } from "./blip";\r\nimport { SourceRectangle } from "./source-rectangle";\r\nimport { Stretch } from "./stretch";\r\n\r\nexport class BlipFill extends XmlComponent {\r\n    constructor(referenceId: number) {\r\n        super("pic:blipFill");\r\n        this.root.push(new Blip(referenceId));\r\n        this.root.push(new SourceRectangle());\r\n        this.root.push(new Stretch());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(172)),
          p = (a.s[3]++, t(173)),
          m = (a.s[4]++, t(174));

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent83) {
        _inherits(C, _c$XmlComponent83);

        function C(e) {
          var _this165;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this165 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "pic:blipFill")), a.s[6]++, _this165.root.push(new u.Blip(e)), a.s[7]++, _this165.root.push(new p.SourceRectangle()), a.s[8]++, _this165.root.push(new m.Stretch());
          return _this165;
        }

        return C;
      }(c.XmlComponent);

      a.s[9]++, n.BlipFill = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\blip.ts", o = "ed8ece1be44df009b7cd8f206752b45f4fd59cda", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\blip.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 24
            }
          },
          5: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 19,
              column: 12
            }
          },
          6: {
            start: {
              line: 22,
              column: 0
            },
            end: {
              line: 22,
              column: 20
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 29
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 14
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/blip/blip.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\blip.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAO1E,oBAAqB,SAAQ,sCAAsC;IAAnE;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,SAAS;YAChB,MAAM,EAAE,QAAQ;SACnB,CAAC;IACN,CAAC;CAAA;AAED,UAAkB,SAAQ,6BAAY;IAClC,YAAY,WAAmB;QAC3B,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,cAAc,CAAC;YACf,KAAK,EAAE,MAAM,WAAW,EAAE;YAC1B,MAAM,EAAE,MAAM;SACjB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,oBAUC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\ninterface IBlipProperties {\r\n    readonly embed: string;\r\n    readonly cstate: string;\r\n}\r\n\r\nclass BlipAttributes extends XmlAttributeComponent<IBlipProperties> {\r\n    protected readonly xmlKeys = {\r\n        embed: "r:embed",\r\n        cstate: "cstate",\r\n    };\r\n}\r\n\r\nexport class Blip extends XmlComponent {\r\n    constructor(referenceId: number) {\r\n        super("a:blip");\r\n        this.root.push(\r\n            new BlipAttributes({\r\n                embed: `rId${referenceId}`,\r\n                cstate: "none",\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon29) {
        _inherits(u, _c$XmlAttributeCompon29);

        function u() {
          var _this166;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this166 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this166.xmlKeys = {
            embed: "r:embed",
            cstate: "cstate"
          };
          return _this166;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent84) {
        _inherits(p, _c$XmlComponent84);

        function p(e) {
          var _this167;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this167 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "a:blip")), a.s[5]++, _this167.root.push(new u({
            embed: "rId".concat(e),
            cstate: "none"
          }));
          return _this167;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.Blip = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\source-rectangle.ts", o = "c151ff580ad1065429d30117efe7aff9ea717f94", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\source-rectangle.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 27
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/blip/source-rectangle.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\source-rectangle.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,qBAA6B,SAAQ,6BAAY;IAC7C;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;IACvB,CAAC;CACJ;AAJD,0CAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class SourceRectangle extends XmlComponent {\r\n    constructor() {\r\n        super("a:srcRect");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent85) {
        _inherits(u, _c$XmlComponent85);

        function u() {
          var _this168;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this168 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "a:srcRect"));
          return _this168;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.SourceRectangle = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\stretch.ts", o = "79639b0dba67354fdffddf3e0046f5e287982d37", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\stretch.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 27
            }
          },
          4: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 44
            }
          },
          5: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 10
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/blip/stretch.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\blip\\stretch.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,mBAAoB,SAAQ,6BAAY;IACpC;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;IACxB,CAAC;CACJ;AAED,aAAqB,SAAQ,6BAAY;IACrC;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAa,EAAE,CAAC,CAAC;IACxC,CAAC;CACJ;AALD,0BAKC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nclass FillRectangle extends XmlComponent {\r\n    constructor() {\r\n        super("a:fillRect");\r\n    }\r\n}\r\n\r\nexport class Stretch extends XmlComponent {\r\n    constructor() {\r\n        super("a:stretch");\r\n        this.root.push(new FillRectangle());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent86) {
        _inherits(u, _c$XmlComponent86);

        function u() {
          var _this169;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this169 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "a:fillRect"));
          return _this169;
        }

        return u;
      }(c.XmlComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent87) {
        _inherits(p, _c$XmlComponent87);

        function p() {
          var _this170;

          _classCallCheck(this, p);

          a.f[1]++, a.s[3]++, _this170 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "a:stretch")), a.s[4]++, _this170.root.push(new u());
          return _this170;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Stretch = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-pic-properties.ts", o = "6a4d187c8fe2aea899d646aa0838245866a77b8d", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-pic-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 42
            },
            end: {
              line: 4,
              column: 118
            }
          },
          3: {
            start: {
              line: 5,
              column: 32
            },
            end: {
              line: 5,
              column: 88
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 29
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 74
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 89
            }
          },
          7: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 56
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 7
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/non-visual-pic-properties/non-visual-pic-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-pic-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,uHAA6G;AAC7G,yFAAoF;AAEpF,4BAAoC,SAAQ,6BAAY;IACpD;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;QAErB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2CAAmB,EAAE,CAAC,CAAC;QAC1C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,0DAAwB,EAAE,CAAC,CAAC;IACnD,CAAC;CACJ;AAPD,wDAOC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { ChildNonVisualProperties } from "./child-non-visual-pic-properties/child-non-visual-pic-properties";\r\nimport { NonVisualProperties } from "./non-visual-properties/non-visual-properties";\r\n\r\nexport class NonVisualPicProperties extends XmlComponent {\r\n    constructor() {\r\n        super("pic:nvPicPr");\r\n\r\n        this.root.push(new NonVisualProperties());\r\n        this.root.push(new ChildNonVisualProperties());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(176)),
          p = (a.s[3]++, t(179));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent88) {
        _inherits(m, _c$XmlComponent88);

        function m() {
          var _this171;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this171 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "pic:nvPicPr")), a.s[5]++, _this171.root.push(new p.NonVisualProperties()), a.s[6]++, _this171.root.push(new u.ChildNonVisualProperties());
          return _this171;
        }

        return m;
      }(c.XmlComponent);

      a.s[7]++, n.NonVisualPicProperties = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\child-non-visual-pic-properties.ts", o = "283c058e787b31ef4ecfee3845252791e461bb49", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\child-non-visual-pic-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 20
            },
            end: {
              line: 4,
              column: 52
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 30
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 51
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 60
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/non-visual-pic-properties/child-non-visual-pic-properties/child-non-visual-pic-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\child-non-visual-pic-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,qDAAiD;AAEjD,8BAAsC,SAAQ,6BAAY;IACtD;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;QAEtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAQ,EAAE,CAAC,CAAC;IACnC,CAAC;CACJ;AAND,4DAMC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { PicLocks } from "./pic-locks/pic-locks";\r\n\r\nexport class ChildNonVisualProperties extends XmlComponent {\r\n    constructor() {\r\n        super("pic:cNvPicPr");\r\n\r\n        this.root.push(new PicLocks());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(177));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent89) {
        _inherits(p, _c$XmlComponent89);

        function p() {
          var _this172;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this172 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "pic:cNvPicPr")), a.s[4]++, _this172.root.push(new u.PicLocks());
          return _this172;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.ChildNonVisualProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\pic-locks\\pic-locks.ts", o = "1e4dc48cbf5599a1586f1c5e986a93b28e45f198", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\pic-locks\\pic-locks.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 31
            },
            end: {
              line: 4,
              column: 64
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/non-visual-pic-properties/child-non-visual-pic-properties/pic-locks/pic-locks.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\pic-locks\\pic-locks.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,iEAA4D;AAE5D,cAAsB,SAAQ,6BAAY;IACtC;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;QACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,yCAAkB,CAAC;YACnB,cAAc,EAAE,CAAC;YACjB,kBAAkB,EAAE,CAAC;SACxB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,4BAUC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { PicLocksAttributes } from "./pic-locks-attributes";\r\n\r\nexport class PicLocks extends XmlComponent {\r\n    constructor() {\r\n        super("a:picLocks");\r\n        this.root.push(\r\n            new PicLocksAttributes({\r\n                noChangeAspect: 1,\r\n                noChangeArrowheads: 1,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(178));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent90) {
        _inherits(p, _c$XmlComponent90);

        function p() {
          var _this173;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this173 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "a:picLocks")), a.s[4]++, _this173.root.push(new u.PicLocksAttributes({
            noChangeAspect: 1,
            noChangeArrowheads: 1
          }));
          return _this173;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.PicLocks = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\pic-locks\\pic-locks-attributes.ts", o = "4de483eeb877ee457be8ef0e083096cf5cc6152b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\pic-locks\\pic-locks-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 48
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/non-visual-pic-properties/child-non-visual-pic-properties/pic-locks/pic-locks-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\child-non-visual-pic-properties\\pic-locks\\pic-locks-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,wBAAgC,SAAQ,sCAA0C;IAAlF;;QACuB,YAAO,GAAG;YACzB,cAAc,EAAE,gBAAgB;YAChC,kBAAkB,EAAE,oBAAoB;SAC3C,CAAC;IACN,CAAC;CAAA;AALD,gDAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IPicLocksAttributes {\r\n    readonly noChangeAspect?: number;\r\n    readonly noChangeArrowheads?: number;\r\n}\r\n\r\nexport class PicLocksAttributes extends XmlAttributeComponent<IPicLocksAttributes> {\r\n    protected readonly xmlKeys = {\r\n        noChangeAspect: "noChangeAspect",\r\n        noChangeArrowheads: "noChangeArrowheads",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon30) {
        _inherits(u, _c$XmlAttributeCompon30);

        function u() {
          var _this174;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this174 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this174.xmlKeys = {
            noChangeAspect: "noChangeAspect",
            noChangeArrowheads: "noChangeArrowheads"
          };
          return _this174;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.PicLocksAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-properties\\non-visual-properties.ts", o = "0cce91803f11c0f6453b99256a7300c13ae15839", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-properties\\non-visual-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 43
            },
            end: {
              line: 4,
              column: 88
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 27
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 12,
              column: 12
            }
          },
          5: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 50
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/non-visual-pic-properties/non-visual-properties/non-visual-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-properties\\non-visual-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,yFAAmF;AAEnF,yBAAiC,SAAQ,6BAAY;IACjD;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;QAEnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,gEAA6B,CAAC;YAC9B,EAAE,EAAE,CAAC;YACL,IAAI,EAAE,EAAE;YACR,KAAK,EAAE,EAAE;SACZ,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAZD,kDAYC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { NonVisualPropertiesAttributes } from "./non-visual-properties-attributes";\r\n\r\nexport class NonVisualProperties extends XmlComponent {\r\n    constructor() {\r\n        super("pic:cNvPr");\r\n\r\n        this.root.push(\r\n            new NonVisualPropertiesAttributes({\r\n                id: 0,\r\n                name: "",\r\n                descr: "",\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(180));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent91) {
        _inherits(p, _c$XmlComponent91);

        function p() {
          var _this175;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this175 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "pic:cNvPr")), a.s[4]++, _this175.root.push(new u.NonVisualPropertiesAttributes({
            id: 0,
            name: "",
            descr: ""
          }));
          return _this175;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.NonVisualProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-properties\\non-visual-properties-attributes.ts", o = "4cd2182f5a3acecb61da709cbf494b3adeebcc40", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-properties\\non-visual-properties-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 11,
              column: 10
            }
          },
          4: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 70
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/non-visual-pic-properties/non-visual-properties/non-visual-properties-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\non-visual-pic-properties\\non-visual-properties\\non-visual-properties-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAQ5D,mCAA2C,SAAQ,sCAAqD;IAAxG;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,IAAI;YACR,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,MAAM;SAChB,CAAC;IACN,CAAC;CAAA;AAND,sEAMC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface INonVisualPropertiesAttributes {\r\n    readonly id?: number;\r\n    readonly name?: string;\r\n    readonly descr?: string;\r\n}\r\n\r\nexport class NonVisualPropertiesAttributes extends XmlAttributeComponent<INonVisualPropertiesAttributes> {\r\n    protected readonly xmlKeys = {\r\n        id: "id",\r\n        name: "name",\r\n        descr: "desc",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon31) {
        _inherits(u, _c$XmlAttributeCompon31);

        function u() {
          var _this176;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this176 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this176.xmlKeys = {
            id: "id",
            name: "name",
            descr: "desc"
          };
          return _this176;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.NonVisualPropertiesAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\pic-attributes.ts", o = "90ba45dd98133e9d9f710d8baaf614a58b717994", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\pic-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/pic-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\pic-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,mBAA2B,SAAQ,sCAAqC;IAAxE;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,WAAW;SACrB,CAAC;IACN,CAAC;CAAA;AAJD,sCAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IPicAttributes {\r\n    readonly xmlns?: string;\r\n}\r\n\r\nexport class PicAttributes extends XmlAttributeComponent<IPicAttributes> {\r\n    protected readonly xmlKeys = {\r\n        xmlns: "xmlns:pic",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon32) {
        _inherits(u, _c$XmlAttributeCompon32);

        function u() {
          var _this177;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this177 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this177.xmlKeys = {
            xmlns: "xmlns:pic"
          };
          return _this177;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.PicAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\shape-properties.ts", o = "ef23e17fdb3fac473351e848a95e5733f25d8d0a", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\shape-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 15
            },
            end: {
              line: 4,
              column: 32
            }
          },
          3: {
            start: {
              line: 5,
              column: 26
            },
            end: {
              line: 5,
              column: 70
            }
          },
          4: {
            start: {
              line: 6,
              column: 38
            },
            end: {
              line: 6,
              column: 78
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 26
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 12,
              column: 12
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 42
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 34
            }
          },
          9: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 63
            }
          },
          10: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 30
            }
          },
          11: {
            start: {
              line: 21,
              column: 0
            },
            end: {
              line: 21,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 22
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 16
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 17
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/shape-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\shape-properties.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,iCAA8B;AAG9B,uEAAmE;AACnE,+EAA0E;AAE1E,qBAA6B,SAAQ,6BAAY;IAG7C,YAAY,CAAS,EAAE,CAAS;QAC5B,KAAK,CAAC,UAAU,CAAC,CAAC;QAElB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,uDAAyB,CAAC;YAC1B,MAAM,EAAE,MAAM;SACjB,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,IAAI,GAAG,IAAI,WAAI,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;QAE3B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;QAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gCAAc,EAAE,CAAC,CAAC;IAGzC,CAAC;IAEM,KAAK,CAAC,CAAS,EAAE,CAAS;QAC7B,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;IAC1B,CAAC;CACJ;AAvBD,0CAuBC",
          sourcesContent: ['// http://officeopenxml.com/drwSp-SpPr.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { Form } from "./form";\r\n// import { NoFill } from "./no-fill";\r\n// import { Outline } from "./outline/outline";\r\nimport { PresetGeometry } from "./preset-geometry/preset-geometry";\r\nimport { ShapePropertiesAttributes } from "./shape-properties-attributes";\r\n\r\nexport class ShapeProperties extends XmlComponent {\r\n    private readonly form: Form;\r\n\r\n    constructor(x: number, y: number) {\r\n        super("pic:spPr");\r\n\r\n        this.root.push(\r\n            new ShapePropertiesAttributes({\r\n                bwMode: "auto",\r\n            }),\r\n        );\r\n\r\n        this.form = new Form(x, y);\r\n\r\n        this.root.push(this.form);\r\n        this.root.push(new PresetGeometry());\r\n        // this.root.push(new NoFill());\r\n        // this.root.push(new Outline());\r\n    }\r\n\r\n    public setXY(x: number, y: number): void {\r\n        this.form.setXY(x, y);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(183)),
          p = (a.s[3]++, t(189)),
          m = (a.s[4]++, t(192));

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent92) {
        _inherits(C, _c$XmlComponent92);

        function C(e, n) {
          var _this178;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this178 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "pic:spPr")), a.s[6]++, _this178.root.push(new m.ShapePropertiesAttributes({
            bwMode: "auto"
          })), a.s[7]++, _this178.form = new u.Form(e, n), a.s[8]++, _this178.root.push(_this178.form), a.s[9]++, _this178.root.push(new p.PresetGeometry());
          return _this178;
        }

        _createClass(C, [{
          key: "setXY",
          value: function setXY(e, n) {
            a.f[1]++, a.s[10]++, this.form.setXY(e, n);
          }
        }]);

        return C;
      }(c.XmlComponent);

      a.s[11]++, n.ShapeProperties = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\index.ts", o = "e39dc9d1201f315525d8fa68537c7766bbcb8a74", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/form/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,4BAAuB",
          sourcesContent: ['export * from "./form";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(184));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\form.ts", o = "7cd37b4e34df5c9d749a1f8e00a3c2b65535b9fd", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\form.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 18
            },
            end: {
              line: 4,
              column: 46
            }
          },
          3: {
            start: {
              line: 5,
              column: 14
            },
            end: {
              line: 5,
              column: 37
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 24
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 51
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 37
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 43
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 33
            }
          },
          9: {
            start: {
              line: 17,
              column: 0
            },
            end: {
              line: 17,
              column: 20
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 22
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 16
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 13
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/form/form.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\form.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,+CAA4C;AAC5C,sCAAsC;AAEtC,UAAkB,SAAQ,6BAAY;IAGlC,YAAY,CAAS,EAAE,CAAS;QAC5B,KAAK,CAAC,QAAQ,CAAC,CAAC;QAEhB,IAAI,CAAC,OAAO,GAAG,IAAI,iBAAO,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;QAEjC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;QAC7B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,YAAM,EAAE,CAAC,CAAC;IACjC,CAAC;IAEM,KAAK,CAAC,CAAS,EAAE,CAAS;QAC7B,IAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;IAC7B,CAAC;CACJ;AAfD,oBAeC",
          sourcesContent: ['// http://officeopenxml.com/drwSp-size.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { Extents } from "./extents/extents";\r\nimport { Offset } from "./offset/off";\r\n\r\nexport class Form extends XmlComponent {\r\n    private readonly extents: Extents;\r\n\r\n    constructor(x: number, y: number) {\r\n        super("a:xfrm");\r\n\r\n        this.extents = new Extents(x, y);\r\n\r\n        this.root.push(this.extents);\r\n        this.root.push(new Offset());\r\n    }\r\n\r\n    public setXY(x: number, y: number): void {\r\n        this.extents.setXY(x, y);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(185)),
          p = (a.s[3]++, t(187));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent93) {
        _inherits(m, _c$XmlComponent93);

        function m(e, n) {
          var _this179;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this179 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "a:xfrm")), a.s[5]++, _this179.extents = new u.Extents(e, n), a.s[6]++, _this179.root.push(_this179.extents), a.s[7]++, _this179.root.push(new p.Offset());
          return _this179;
        }

        _createClass(m, [{
          key: "setXY",
          value: function setXY(e, n) {
            a.f[1]++, a.s[8]++, this.extents.setXY(e, n);
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[9]++, n.Form = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\extents\\extents.ts", o = "db6291f29d20ff1195e42407c4b911792fa882f8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\extents\\extents.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 29
            },
            end: {
              line: 4,
              column: 60
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 23
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 11
            }
          },
          5: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 40
            }
          },
          6: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 18,
              column: 11
            }
          },
          7: {
            start: {
              line: 21,
              column: 0
            },
            end: {
              line: 21,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 22
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 16
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 14
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/form/extents/extents.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\extents\\extents.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,6DAAyD;AAEzD,aAAqB,SAAQ,6BAAY;IAGrC,YAAY,CAAS,EAAE,CAAS;QAC5B,KAAK,CAAC,OAAO,CAAC,CAAC;QAEf,IAAI,CAAC,UAAU,GAAG,IAAI,sCAAiB,CAAC;YACpC,EAAE,EAAE,CAAC;YACL,EAAE,EAAE,CAAC;SACR,CAAC,CAAC;QAEH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAEM,KAAK,CAAC,CAAS,EAAE,CAAS;QAC7B,IAAI,CAAC,UAAU,CAAC,GAAG,CAAC;YAChB,EAAE,EAAE,CAAC;YACL,EAAE,EAAE,CAAC;SACR,CAAC,CAAC;IACP,CAAC;CACJ;AApBD,0BAoBC",
          sourcesContent: ['// http://officeopenxml.com/drwSp-size.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { ExtentsAttributes } from "./extents-attributes";\r\n\r\nexport class Extents extends XmlComponent {\r\n    private readonly attributes: ExtentsAttributes;\r\n\r\n    constructor(x: number, y: number) {\r\n        super("a:ext");\r\n\r\n        this.attributes = new ExtentsAttributes({\r\n            cx: x,\r\n            cy: y,\r\n        });\r\n\r\n        this.root.push(this.attributes);\r\n    }\r\n\r\n    public setXY(x: number, y: number): void {\r\n        this.attributes.set({\r\n            cx: x,\r\n            cy: y,\r\n        });\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(186));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent94) {
        _inherits(p, _c$XmlComponent94);

        function p(e, n) {
          var _this180;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this180 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "a:ext")), a.s[4]++, _this180.attributes = new u.ExtentsAttributes({
            cx: e,
            cy: n
          }), a.s[5]++, _this180.root.push(_this180.attributes);
          return _this180;
        }

        _createClass(p, [{
          key: "setXY",
          value: function setXY(e, n) {
            a.f[1]++, a.s[6]++, this.attributes.set({
              cx: e,
              cy: n
            });
          }
        }]);

        return p;
      }(c.XmlComponent);

      a.s[7]++, n.Extents = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\extents\\extents-attributes.ts", o = "acd2810d287b6e5c46de1bc7f8768b19da53820a", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\extents\\extents-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/form/extents/extents-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\extents\\extents-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,uBAA+B,SAAQ,sCAAyC;IAAhF;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,IAAI;YACR,EAAE,EAAE,IAAI;SACX,CAAC;IACN,CAAC;CAAA;AALD,8CAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IExtentsAttributes {\r\n    readonly cx?: number;\r\n    readonly cy?: number;\r\n}\r\n\r\nexport class ExtentsAttributes extends XmlAttributeComponent<IExtentsAttributes> {\r\n    protected readonly xmlKeys = {\r\n        cx: "cx",\r\n        cy: "cy",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon33) {
        _inherits(u, _c$XmlAttributeCompon33);

        function u() {
          var _this181;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this181 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this181.xmlKeys = {
            cx: "cx",
            cy: "cy"
          };
          return _this181;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.ExtentsAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\offset\\off.ts", o = "ec7a583e233d6062bc21ad20399aa3d684f470a1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\offset\\off.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 52
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 23
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/form/offset/off.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\offset\\off.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,qDAAoD;AAEpD,YAAoB,SAAQ,6BAAY;IACpC;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;QAEf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,iCAAgB,CAAC;YACjB,CAAC,EAAE,CAAC;YACJ,CAAC,EAAE,CAAC;SACP,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,wBAWC",
          sourcesContent: ['// http://officeopenxml.com/drwSp-size.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { OffsetAttributes } from "./off-attributes";\r\n\r\nexport class Offset extends XmlComponent {\r\n    constructor() {\r\n        super("a:off");\r\n\r\n        this.root.push(\r\n            new OffsetAttributes({\r\n                x: 0,\r\n                y: 0,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(188));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent95) {
        _inherits(p, _c$XmlComponent95);

        function p() {
          var _this182;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this182 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "a:off")), a.s[4]++, _this182.root.push(new u.OffsetAttributes({
            x: 0,
            y: 0
          }));
          return _this182;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Offset = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\offset\\off-attributes.ts", o = "8750633db24c42ba2cd77fdeea0566c8a0b05ad8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\offset\\off-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/form/offset/off-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\form\\offset\\off-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,sBAA8B,SAAQ,sCAAwC;IAA9E;;QACuB,YAAO,GAAG;YACzB,CAAC,EAAE,GAAG;YACN,CAAC,EAAE,GAAG;SACT,CAAC;IACN,CAAC;CAAA;AALD,4CAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IOffsetAttributes {\r\n    readonly x?: number;\r\n    readonly y?: number;\r\n}\r\n\r\nexport class OffsetAttributes extends XmlAttributeComponent<IOffsetAttributes> {\r\n    protected readonly xmlKeys = {\r\n        x: "x",\r\n        y: "y",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon34) {
        _inherits(u, _c$XmlAttributeCompon34);

        function u() {
          var _this183;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this183 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this183.xmlKeys = {
            x: "x",
            y: "y"
          };
          return _this183;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.OffsetAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\preset-geometry.ts", o = "8b8a164beaa4f75c71f2d4e5f517b6708c4e6e4c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\preset-geometry.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 28
            },
            end: {
              line: 4,
              column: 76
            }
          },
          3: {
            start: {
              line: 5,
              column: 37
            },
            end: {
              line: 5,
              column: 76
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 28
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 67
            }
          },
          7: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 7
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/preset-geometry/preset-geometry.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\preset-geometry.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,6EAAyE;AACzE,6EAAwE;AAExE,oBAA4B,SAAQ,6BAAY;IAC5C;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;QAEpB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,qDAAwB,CAAC;YACzB,IAAI,EAAE,MAAM;SACf,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oCAAgB,EAAE,CAAC,CAAC;IAC3C,CAAC;CACJ;AAZD,wCAYC",
          sourcesContent: ['// http://officeopenxml.com/drwSp-prstGeom.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { AdjustmentValues } from "./adjustment-values/adjustment-values";\r\nimport { PresetGeometryAttributes } from "./preset-geometry-attributes";\r\n\r\nexport class PresetGeometry extends XmlComponent {\r\n    constructor() {\r\n        super("a:prstGeom");\r\n\r\n        this.root.push(\r\n            new PresetGeometryAttributes({\r\n                prst: "rect",\r\n            }),\r\n        );\r\n\r\n        this.root.push(new AdjustmentValues());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(190)),
          p = (a.s[3]++, t(191));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent96) {
        _inherits(m, _c$XmlComponent96);

        function m() {
          var _this184;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this184 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "a:prstGeom")), a.s[5]++, _this184.root.push(new p.PresetGeometryAttributes({
            prst: "rect"
          })), a.s[6]++, _this184.root.push(new u.AdjustmentValues());
          return _this184;
        }

        return m;
      }(c.XmlComponent);

      a.s[7]++, n.PresetGeometry = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\adjustment-values\\adjustment-values.ts", o = "fc18b4af2f225f93a26ac6b7dab4c075584ccade", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\adjustment-values\\adjustment-values.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 25
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/preset-geometry/adjustment-values/adjustment-values.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\adjustment-values\\adjustment-values.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AAEnD,sBAA8B,SAAQ,6BAAY;IAC9C;QACI,KAAK,CAAC,SAAS,CAAC,CAAC;IACrB,CAAC;CACJ;AAJD,4CAIC",
          sourcesContent: ['// http://officeopenxml.com/drwSp-prstGeom.php\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nexport class AdjustmentValues extends XmlComponent {\r\n    constructor() {\r\n        super("a:avLst");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent97) {
        _inherits(u, _c$XmlComponent97);

        function u() {
          var _this185;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this185 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "a:avLst"));
          return _this185;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.AdjustmentValues = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\preset-geometry-attributes.ts", o = "b606e065616ed6aa8ea2b2dc92244a0ba69220b9", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\preset-geometry-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 60
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/preset-geometry/preset-geometry-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\preset-geometry\\preset-geometry-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,8BAAsC,SAAQ,sCAAgD;IAA9F;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,MAAM;SACf,CAAC;IACN,CAAC;CAAA;AAJD,4DAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IPresetGeometryAttributes {\r\n    readonly prst?: string;\r\n}\r\n\r\nexport class PresetGeometryAttributes extends XmlAttributeComponent<IPresetGeometryAttributes> {\r\n    protected readonly xmlKeys = {\r\n        prst: "prst",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon35) {
        _inherits(u, _c$XmlAttributeCompon35);

        function u() {
          var _this186;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this186 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this186.xmlKeys = {
            prst: "prst"
          };
          return _this186;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.PresetGeometryAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\shape-properties-attributes.ts", o = "0455d3b4c32344a8f3f2010c7a81c287a9bb2425", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\shape-properties-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 62
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/graphic/graphic-data/pic/shape-properties/shape-properties-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\graphic\\graphic-data\\pic\\shape-properties\\shape-properties-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,+BAAuC,SAAQ,sCAAiD;IAAhG;;QACuB,YAAO,GAAG;YACzB,MAAM,EAAE,QAAQ;SACnB,CAAC;IACN,CAAC;CAAA;AAJD,8DAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IShapePropertiesAttributes {\r\n    readonly bwMode?: string;\r\n}\r\n\r\nexport class ShapePropertiesAttributes extends XmlAttributeComponent<IShapePropertiesAttributes> {\r\n    protected readonly xmlKeys = {\r\n        bwMode: "bwMode",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon36) {
        _inherits(u, _c$XmlAttributeCompon36);

        function u() {
          var _this187;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this187 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this187.xmlKeys = {
            bwMode: "bwMode"
          };
          return _this187;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.ShapePropertiesAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\text-wrapping.ts", o = "bb3617fd77b9a33e2037322abacb2a38f1c2963c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\text-wrapping.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 4,
              column: 0
            },
            end: {
              line: 9,
              column: 83
            }
          },
          2: {
            start: {
              line: 5,
              column: 4
            },
            end: {
              line: 5,
              column: 60
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 64
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 62
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 80
            }
          },
          6: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 16,
              column: 83
            }
          },
          7: {
            start: {
              line: 12,
              column: 4
            },
            end: {
              line: 12,
              column: 49
            }
          },
          8: {
            start: {
              line: 13,
              column: 4
            },
            end: {
              line: 13,
              column: 38
            }
          },
          9: {
            start: {
              line: 14,
              column: 4
            },
            end: {
              line: 14,
              column: 40
            }
          },
          10: {
            start: {
              line: 15,
              column: 4
            },
            end: {
              line: 15,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 1
              },
              end: {
                line: 4,
                column: 2
              }
            },
            loc: {
              start: {
                line: 4,
                column: 29
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 4
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 1
              },
              end: {
                line: 11,
                column: 2
              }
            },
            loc: {
              start: {
                line: 11,
                column: 29
              },
              end: {
                line: 16,
                column: 1
              }
            },
            line: 11
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 22
              },
              end: {
                line: 9,
                column: 81
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 22
              },
              end: {
                line: 9,
                column: 46
              }
            }, {
              start: {
                line: 9,
                column: 51
              },
              end: {
                line: 9,
                column: 80
              }
            }],
            line: 9
          },
          1: {
            loc: {
              start: {
                line: 16,
                column: 22
              },
              end: {
                line: 16,
                column: 81
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 16,
                column: 22
              },
              end: {
                line: 16,
                column: 46
              }
            }, {
              start: {
                line: 16,
                column: 51
              },
              end: {
                line: 16,
                column: 80
              }
            }],
            line: 16
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/text-wrap/text-wrapping.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\text-wrap\\text-wrapping.ts"],
          names: [],
          mappings: ";;AAGA,IAAY,gBAKX;AALD,WAAY,gBAAgB;IACxB,uDAAI,CAAA;IACJ,2DAAM,CAAA;IACN,yDAAK,CAAA;IACL,2EAAc,CAAA;AAClB,CAAC,EALW,gBAAgB,GAAhB,wBAAgB,KAAhB,wBAAgB,QAK3B;AAED,IAAY,gBAKX;AALD,WAAY,gBAAgB;IACxB,4CAAwB,CAAA;IACxB,iCAAa,CAAA;IACb,mCAAe,CAAA;IACf,uCAAmB,CAAA;AACvB,CAAC,EALW,gBAAgB,GAAhB,wBAAgB,KAAhB,wBAAgB,QAK3B",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-textWrap.php\r\nimport { IDistance } from "../drawing";\r\n\r\nexport enum TextWrappingType {\r\n    NONE,\r\n    SQUARE,\r\n    TIGHT,\r\n    TOP_AND_BOTTOM,\r\n}\r\n\r\nexport enum TextWrappingSide {\r\n    BOTH_SIDES = "bothSides",\r\n    LEFT = "left",\r\n    RIGHT = "right",\r\n    LARGEST = "largest",\r\n}\r\n\r\nexport interface ITextWrapping {\r\n    readonly type: TextWrappingType;\r\n    readonly side?: TextWrappingSide;\r\n    readonly margins?: IDistance;\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[1]++, function (e) {
        a.f[0]++, a.s[2]++, e[e.NONE = 0] = "NONE", a.s[3]++, e[e.SQUARE = 1] = "SQUARE", a.s[4]++, e[e.TIGHT = 2] = "TIGHT", a.s[5]++, e[e.TOP_AND_BOTTOM = 3] = "TOP_AND_BOTTOM";
      }((a.b[0][0]++, n.TextWrappingType || (a.b[0][1]++, n.TextWrappingType = {}))), a.s[6]++, function (e) {
        a.f[1]++, a.s[7]++, e.BOTH_SIDES = "bothSides", a.s[8]++, e.LEFT = "left", a.s[9]++, e.RIGHT = "right", a.s[10]++, e.LARGEST = "largest";
      }((a.b[1][0]++, n.TextWrappingSide || (a.b[1][1]++, n.TextWrappingSide = {})));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-none.ts", o = "0dda0a6f826126f98c7d19d187bbef417854c12b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-none.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 29
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/text-wrap/wrap-none.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\text-wrap\\wrap-none.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AAEnD,cAAsB,SAAQ,6BAAY;IACtC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;IACzB,CAAC;CACJ;AAJD,4BAIC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-textWrap.php\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nexport class WrapNone extends XmlComponent {\r\n    constructor() {\r\n        super("wp:wrapNone");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent98) {
        _inherits(u, _c$XmlComponent98);

        function u() {
          var _this188;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this188 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "wp:wrapNone"));
          return _this188;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.WrapNone = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-square.ts", o = "058d1452dc98dfdfd297c78a523db343cdbb5f7f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-square.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 11
            },
            end: {
              line: 4,
              column: 23
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 14,
              column: 10
            }
          },
          5: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 31
            }
          },
          6: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 31,
              column: 12
            }
          },
          7: {
            start: {
              line: 34,
              column: 0
            },
            end: {
              line: 34,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 23,
                column: 7
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 23
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 18,
                column: 30
              },
              end: {
                line: 23,
                column: 5
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 18,
                column: 40
              },
              end: {
                line: 23,
                column: 5
              }
            }],
            line: 18
          },
          1: {
            loc: {
              start: {
                line: 26,
                column: 22
              },
              end: {
                line: 26,
                column: 73
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 26,
                column: 22
              },
              end: {
                line: 26,
                column: 39
              }
            }, {
              start: {
                line: 26,
                column: 43
              },
              end: {
                line: 26,
                column: 73
              }
            }],
            line: 26
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/text-wrap/wrap-square.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\text-wrap\\wrap-square.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAC1E,wBAAoD;AAYpD,0BAA2B,SAAQ,sCAA4C;IAA/E;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,QAAQ,EAAE,UAAU;SACvB,CAAC;IACN,CAAC;CAAA;AAED,gBAAwB,SAAQ,6BAAY;IACxC,YACI,YAA2B,EAC3B,UAAoB;QAChB,GAAG,EAAE,CAAC;QACN,MAAM,EAAE,CAAC;QACT,IAAI,EAAE,CAAC;QACP,KAAK,EAAE,CAAC;KACX;QAED,KAAK,CAAC,eAAe,CAAC,CAAC;QAEvB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,oBAAoB,CAAC;YACrB,QAAQ,EAAE,YAAY,CAAC,IAAI,IAAI,mBAAgB,CAAC,UAAU;YAC1D,KAAK,EAAE,OAAO,CAAC,GAAG;YAClB,KAAK,EAAE,OAAO,CAAC,MAAM;YACrB,KAAK,EAAE,OAAO,CAAC,IAAI;YACnB,KAAK,EAAE,OAAO,CAAC,KAAK;SACvB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAtBD,gCAsBC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-textWrap.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport { ITextWrapping, TextWrappingSide } from ".";\r\nimport { IDistance } from "../drawing";\r\nimport { IMargins } from "../floating";\r\n\r\ninterface IWrapSquareAttributes extends IDistance {\r\n    readonly wrapText?: TextWrappingSide;\r\n    readonly distT?: number;\r\n    readonly distB?: number;\r\n    readonly distL?: number;\r\n    readonly distR?: number;\r\n}\r\n\r\nclass WrapSquareAttributes extends XmlAttributeComponent<IWrapSquareAttributes> {\r\n    protected readonly xmlKeys = {\r\n        distT: "distT",\r\n        distB: "distB",\r\n        distL: "distL",\r\n        distR: "distR",\r\n        wrapText: "wrapText",\r\n    };\r\n}\r\n\r\nexport class WrapSquare extends XmlComponent {\r\n    constructor(\r\n        textWrapping: ITextWrapping,\r\n        margins: IMargins = {\r\n            top: 0,\r\n            bottom: 0,\r\n            left: 0,\r\n            right: 0,\r\n        },\r\n    ) {\r\n        super("wp:wrapSquare");\r\n\r\n        this.root.push(\r\n            new WrapSquareAttributes({\r\n                wrapText: textWrapping.side || TextWrappingSide.BOTH_SIDES,\r\n                distT: margins.top,\r\n                distB: margins.bottom,\r\n                distL: margins.left,\r\n                distR: margins.right,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(39));

      var p =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon37) {
        _inherits(p, _c$XmlAttributeCompon37);

        function p() {
          var _this189;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this189 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this189.xmlKeys = {
            distT: "distT",
            distB: "distB",
            distL: "distL",
            distR: "distR",
            wrapText: "wrapText"
          };
          return _this189;
        }

        return p;
      }(c.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent99) {
        _inherits(m, _c$XmlComponent99);

        function m(e) {
          var _this190;

          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[0][0]++, {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          });

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this190 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "wp:wrapSquare")), a.s[6]++, _this190.root.push(new p({
            wrapText: (a.b[1][0]++, e.side || (a.b[1][1]++, u.TextWrappingSide.BOTH_SIDES)),
            distT: n.top,
            distB: n.bottom,
            distL: n.left,
            distR: n.right
          }));
          return _this190;
        }

        return m;
      }(c.XmlComponent);

      a.s[7]++, n.WrapSquare = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-tight.ts", o = "cb1652d1e444a9059008ab85b93384edeb038dba", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-tight.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 30
            }
          },
          5: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 22,
              column: 12
            }
          },
          6: {
            start: {
              line: 25,
              column: 0
            },
            end: {
              line: 25,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 7
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 17
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 14,
                column: 16
              },
              end: {
                line: 17,
                column: 5
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 14,
                column: 26
              },
              end: {
                line: 17,
                column: 5
              }
            }],
            line: 14
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/text-wrap/wrap-tight.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\text-wrap\\wrap-tight.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAS1E,yBAA0B,SAAQ,sCAA2C;IAA7E;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;SACjB,CAAC;IACN,CAAC;CAAA;AAED,eAAuB,SAAQ,6BAAY;IACvC,YACI,UAAoB;QAChB,GAAG,EAAE,CAAC;QACN,MAAM,EAAE,CAAC;KACZ;QAED,KAAK,CAAC,cAAc,CAAC,CAAC;QAEtB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,mBAAmB,CAAC;YACpB,KAAK,EAAE,OAAO,CAAC,GAAG;YAClB,KAAK,EAAE,OAAO,CAAC,MAAM;SACxB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAhBD,8BAgBC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-textWrap.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nimport { IMargins } from "../floating";\r\n\r\ninterface IWrapTightAttributes {\r\n    readonly distT?: number;\r\n    readonly distB?: number;\r\n}\r\n\r\nclass WrapTightAttributes extends XmlAttributeComponent<IWrapTightAttributes> {\r\n    protected readonly xmlKeys = {\r\n        distT: "distT",\r\n        distB: "distB",\r\n    };\r\n}\r\n\r\nexport class WrapTight extends XmlComponent {\r\n    constructor(\r\n        margins: IMargins = {\r\n            top: 0,\r\n            bottom: 0,\r\n        },\r\n    ) {\r\n        super("wp:wrapTight");\r\n\r\n        this.root.push(\r\n            new WrapTightAttributes({\r\n                distT: margins.top,\r\n                distB: margins.bottom,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon38) {
        _inherits(u, _c$XmlAttributeCompon38);

        function u() {
          var _this191;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this191 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this191.xmlKeys = {
            distT: "distT",
            distB: "distB"
          };
          return _this191;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent100) {
        _inherits(p, _c$XmlComponent100);

        function p() {
          var _this192;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, {
            top: 0,
            bottom: 0
          });

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this192 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "wp:wrapTight")), a.s[5]++, _this192.root.push(new u({
            distT: e.top,
            distB: e.bottom
          }));
          return _this192;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.WrapTight = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-top-and-bottom.ts", o = "77edaf94288dd6644a05bb026353fee4632a3a21", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\text-wrap\\wrap-top-and-bottom.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 37
            }
          },
          5: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 22,
              column: 12
            }
          },
          6: {
            start: {
              line: 25,
              column: 0
            },
            end: {
              line: 25,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 7
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 17
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 14,
                column: 16
              },
              end: {
                line: 17,
                column: 5
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 14,
                column: 26
              },
              end: {
                line: 17,
                column: 5
              }
            }],
            line: 14
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {
          0: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/text-wrap/wrap-top-and-bottom.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\text-wrap\\wrap-top-and-bottom.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAS1E,gCAAiC,SAAQ,sCAAkD;IAA3F;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;SACjB,CAAC;IACN,CAAC;CAAA;AAED,sBAA8B,SAAQ,6BAAY;IAC9C,YACI,UAAoB;QAChB,GAAG,EAAE,CAAC;QACN,MAAM,EAAE,CAAC;KACZ;QAED,KAAK,CAAC,qBAAqB,CAAC,CAAC;QAE7B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,0BAA0B,CAAC;YAC3B,KAAK,EAAE,OAAO,CAAC,GAAG;YAClB,KAAK,EAAE,OAAO,CAAC,MAAM;SACxB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAhBD,4CAgBC",
          sourcesContent: ['// http://officeopenxml.com/drwPicFloating-textWrap.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nimport { IMargins } from "../floating";\r\n\r\ninterface IWrapTopAndBottomAttributes {\r\n    readonly distT?: number;\r\n    readonly distB?: number;\r\n}\r\n\r\nclass WrapTopAndBottomAttributes extends XmlAttributeComponent<IWrapTopAndBottomAttributes> {\r\n    protected readonly xmlKeys = {\r\n        distT: "distT",\r\n        distB: "distB",\r\n    };\r\n}\r\n\r\nexport class WrapTopAndBottom extends XmlComponent {\r\n    constructor(\r\n        margins: IMargins = {\r\n            top: 0,\r\n            bottom: 0,\r\n        },\r\n    ) {\r\n        super("wp:wrapTopAndBottom");\r\n\r\n        this.root.push(\r\n            new WrapTopAndBottomAttributes({\r\n                distT: margins.top,\r\n                distB: margins.bottom,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon39) {
        _inherits(u, _c$XmlAttributeCompon39);

        function u() {
          var _this193;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this193 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this193.xmlKeys = {
            distT: "distT",
            distB: "distB"
          };
          return _this193;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent101) {
        _inherits(p, _c$XmlComponent101);

        function p() {
          var _this194;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, {
            top: 0,
            bottom: 0
          });

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this194 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "wp:wrapTopAndBottom")), a.s[5]++, _this194.root.push(new u({
            distT: e.top,
            distB: e.bottom
          }));
          return _this194;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.WrapTopAndBottom = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\doc-properties\\doc-properties-attributes.ts", o = "819ab6d74afe81a512f3763b1d2424c2684b6fbc", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\doc-properties\\doc-properties-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 11,
              column: 10
            }
          },
          4: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 58
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/doc-properties/doc-properties-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\doc-properties\\doc-properties-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAQ5D,6BAAqC,SAAQ,sCAA+C;IAA5F;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,IAAI;YACR,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,OAAO;SACjB,CAAC;IACN,CAAC;CAAA;AAND,0DAMC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IDocPropertiesAttributes {\r\n    readonly id?: number;\r\n    readonly name?: string;\r\n    readonly descr?: string;\r\n}\r\n\r\nexport class DocPropertiesAttributes extends XmlAttributeComponent<IDocPropertiesAttributes> {\r\n    protected readonly xmlKeys = {\r\n        id: "id",\r\n        name: "name",\r\n        descr: "descr",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon40) {
        _inherits(u, _c$XmlAttributeCompon40);

        function u() {
          var _this195;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this195 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this195.xmlKeys = {
            id: "id",
            name: "name",
            descr: "descr"
          };
          return _this195;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.DocPropertiesAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\effect-extent\\effect-extent-attributes.ts", o = "8336d861fec746d851be6dfd3a5a8afa1731caa8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\effect-extent\\effect-extent-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 12,
              column: 10
            }
          },
          4: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 56
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/effect-extent/effect-extent-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\effect-extent\\effect-extent-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAS5D,4BAAoC,SAAQ,sCAA8C;IAA1F;;QACuB,YAAO,GAAG;YACzB,CAAC,EAAE,GAAG;YACN,CAAC,EAAE,GAAG;YACN,CAAC,EAAE,GAAG;YACN,CAAC,EAAE,GAAG;SACT,CAAC;IACN,CAAC;CAAA;AAPD,wDAOC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IEffectExtentAttributes {\r\n    readonly b?: number;\r\n    readonly l?: number;\r\n    readonly r?: number;\r\n    readonly t?: number;\r\n}\r\n\r\nexport class EffectExtentAttributes extends XmlAttributeComponent<IEffectExtentAttributes> {\r\n    protected readonly xmlKeys = {\r\n        b: "b",\r\n        l: "l",\r\n        r: "r",\r\n        t: "t",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon41) {
        _inherits(u, _c$XmlAttributeCompon41);

        function u() {
          var _this196;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this196 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this196.xmlKeys = {
            b: "b",
            l: "l",
            r: "r",
            t: "t"
          };
          return _this196;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.EffectExtentAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\extent\\extent-attributes.ts", o = "b936d4b64544d74e7b6885b85e4d46b3b65be678", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\extent\\extent-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/extent/extent-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\extent\\extent-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,sBAA8B,SAAQ,sCAAwC;IAA9E;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,IAAI;YACR,EAAE,EAAE,IAAI;SACX,CAAC;IACN,CAAC;CAAA;AALD,4CAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IExtentAttributes {\r\n    readonly cx?: number;\r\n    readonly cy?: number;\r\n}\r\n\r\nexport class ExtentAttributes extends XmlAttributeComponent<IExtentAttributes> {\r\n    protected readonly xmlKeys = {\r\n        cx: "cx",\r\n        cy: "cy",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon42) {
        _inherits(u, _c$XmlAttributeCompon42);

        function u() {
          var _this197;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this197 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this197.xmlKeys = {
            cx: "cx",
            cy: "cy"
          };
          return _this197;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.ExtentAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\graphic-frame\\graphic-frame-locks\\graphic-frame-locks.ts", o = "f0c8637e49c352ec9424f29d5d3b21239c303d7b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\graphic-frame\\graphic-frame-locks\\graphic-frame-locks.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 40
            },
            end: {
              line: 4,
              column: 82
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 37
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/graphic-frame/graphic-frame-locks/graphic-frame-locks.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\graphic-frame\\graphic-frame-locks\\graphic-frame-locks.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,mFAA6E;AAE7E,uBAA+B,SAAQ,6BAAY;IAC/C;QACI,KAAK,CAAC,qBAAqB,CAAC,CAAC;QAE7B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,0DAA0B,CAAC;YAC3B,KAAK,EAAE,uDAAuD;YAC9D,cAAc,EAAE,CAAC;SACpB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,8CAWC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { GraphicFrameLockAttributes } from "./graphic-frame-lock-attributes";\r\n\r\nexport class GraphicFrameLocks extends XmlComponent {\r\n    constructor() {\r\n        super("a:graphicFrameLocks");\r\n\r\n        this.root.push(\r\n            new GraphicFrameLockAttributes({\r\n                xmlns: "http://schemas.openxmlformats.org/drawingml/2006/main",\r\n                noChangeAspect: 1,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(202));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent102) {
        _inherits(p, _c$XmlComponent102);

        function p() {
          var _this198;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this198 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "a:graphicFrameLocks")), a.s[4]++, _this198.root.push(new u.GraphicFrameLockAttributes({
            xmlns: "http://schemas.openxmlformats.org/drawingml/2006/main",
            noChangeAspect: 1
          }));
          return _this198;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.GraphicFrameLocks = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\graphic-frame\\graphic-frame-locks\\graphic-frame-lock-attributes.ts", o = "17e3128233b1f1f91ac1f15f8e5064c5c8bb65db", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\graphic-frame\\graphic-frame-locks\\graphic-frame-lock-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 64
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/graphic-frame/graphic-frame-locks/graphic-frame-lock-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\graphic-frame\\graphic-frame-locks\\graphic-frame-lock-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,gCAAwC,SAAQ,sCAAkD;IAAlG;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,SAAS;YAChB,cAAc,EAAE,gBAAgB;SACnC,CAAC;IACN,CAAC;CAAA;AALD,gEAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IGraphicFrameLockAttributes {\r\n    readonly xmlns?: string;\r\n    readonly noChangeAspect?: number;\r\n}\r\n\r\nexport class GraphicFrameLockAttributes extends XmlAttributeComponent<IGraphicFrameLockAttributes> {\r\n    protected readonly xmlKeys = {\r\n        xmlns: "xmlns:a",\r\n        noChangeAspect: "noChangeAspect",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon43) {
        _inherits(u, _c$XmlAttributeCompon43);

        function u() {
          var _this199;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this199 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this199.xmlKeys = {
            xmlns: "xmlns:a",
            noChangeAspect: "noChangeAspect"
          };
          return _this199;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.GraphicFrameLockAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\index.ts", o = "c01e9f34324bbeff10639e49cbf5fa7c74f7561a", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,8BAAyB",
          sourcesContent: ['export * from "./inline";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(204));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\inline.ts", o = "05a45d5abd5131201e8e7f29914fa33540c5d471", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\inline.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 70
            }
          },
          3: {
            start: {
              line: 5,
              column: 24
            },
            end: {
              line: 5,
              column: 67
            }
          },
          4: {
            start: {
              line: 6,
              column: 17
            },
            end: {
              line: 6,
              column: 46
            }
          },
          5: {
            start: {
              line: 7,
              column: 35
            },
            end: {
              line: 7,
              column: 89
            }
          },
          6: {
            start: {
              line: 8,
              column: 18
            },
            end: {
              line: 8,
              column: 48
            }
          },
          7: {
            start: {
              line: 9,
              column: 28
            },
            end: {
              line: 9,
              column: 58
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 27
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 37
            }
          },
          10: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 19,
              column: 12
            }
          },
          11: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 80
            }
          },
          12: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 96
            }
          },
          13: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 36
            }
          },
          14: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 59
            }
          },
          15: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 61
            }
          },
          16: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 80
            }
          },
          17: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 37
            }
          },
          18: {
            start: {
              line: 29,
              column: 21
            },
            end: {
              line: 29,
              column: 65
            }
          },
          19: {
            start: {
              line: 30,
              column: 21
            },
            end: {
              line: 30,
              column: 65
            }
          },
          20: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 38
            }
          },
          21: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 39
            }
          },
          22: {
            start: {
              line: 35,
              column: 0
            },
            end: {
              line: 35,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 41
              },
              end: {
                line: 27,
                column: 5
              }
            },
            line: 11
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 28,
                column: 4
              },
              end: {
                line: 28,
                column: 5
              }
            },
            loc: {
              start: {
                line: 28,
                column: 28
              },
              end: {
                line: 33,
                column: 5
              }
            },
            line: 28
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/inline.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\inline.ts"],
          names: [],
          mappings: ";;AAEA,wDAAmD;AACnD,uEAAmE;AACnE,oEAAgE;AAChE,+CAA4C;AAC5C,0FAAqF;AACrF,iDAA8C;AAC9C,2DAAuD;AAEvD,YAAoB,SAAQ,6BAAY;IAIpC,YAAY,WAAmB,EAAmB,UAAgC;QAC9E,KAAK,CAAC,WAAW,CAAC,CAAC;QAD2B,eAAU,GAAV,UAAU,CAAsB;QAG9E,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,oCAAgB,CAAC;YACjB,KAAK,EAAE,CAAC;YACR,KAAK,EAAE,CAAC;YACR,KAAK,EAAE,CAAC;YACR,KAAK,EAAE,CAAC;SACX,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,MAAM,GAAG,IAAI,eAAM,CAAC,UAAU,CAAC,IAAI,CAAC,CAAC,EAAE,UAAU,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC;QAC/D,IAAI,CAAC,OAAO,GAAG,IAAI,iBAAO,CAAC,WAAW,EAAE,UAAU,CAAC,IAAI,CAAC,CAAC,EAAE,UAAU,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC;QAE9E,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;QAC5B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,4BAAY,EAAE,CAAC,CAAC;QACnC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,8BAAa,EAAE,CAAC,CAAC;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iDAAsB,EAAE,CAAC,CAAC;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;IACjC,CAAC;IAEM,KAAK,CAAC,OAAe,EAAE,OAAe;QACzC,MAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,CAAC,GAAG,OAAO,CAAC,CAAC;QAC1D,MAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,CAAC,GAAG,OAAO,CAAC,CAAC;QAE1D,IAAI,CAAC,MAAM,CAAC,KAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;QAC9B,IAAI,CAAC,OAAO,CAAC,KAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;IACnC,CAAC;CACJ;AAjCD,wBAiCC",
          sourcesContent: ['// http://officeopenxml.com/drwPicInline.php\r\nimport { IMediaDataDimensions } from "file/media";\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { DocProperties } from "./../doc-properties/doc-properties";\r\nimport { EffectExtent } from "./../effect-extent/effect-extent";\r\nimport { Extent } from "./../extent/extent";\r\nimport { GraphicFrameProperties } from "./../graphic-frame/graphic-frame-properties";\r\nimport { Graphic } from "./../inline/graphic";\r\nimport { InlineAttributes } from "./inline-attributes";\r\n\r\nexport class Inline extends XmlComponent {\r\n    private readonly extent: Extent;\r\n    private readonly graphic: Graphic;\r\n\r\n    constructor(referenceId: number, private readonly dimensions: IMediaDataDimensions) {\r\n        super("wp:inline");\r\n\r\n        this.root.push(\r\n            new InlineAttributes({\r\n                distT: 0,\r\n                distB: 0,\r\n                distL: 0,\r\n                distR: 0,\r\n            }),\r\n        );\r\n\r\n        this.extent = new Extent(dimensions.emus.x, dimensions.emus.y);\r\n        this.graphic = new Graphic(referenceId, dimensions.emus.x, dimensions.emus.y);\r\n\r\n        this.root.push(this.extent);\r\n        this.root.push(new EffectExtent());\r\n        this.root.push(new DocProperties());\r\n        this.root.push(new GraphicFrameProperties());\r\n        this.root.push(this.graphic);\r\n    }\r\n\r\n    public scale(factorX: number, factorY: number): void {\r\n        const newX = Math.round(this.dimensions.emus.x * factorX);\r\n        const newY = Math.round(this.dimensions.emus.y * factorY);\r\n\r\n        this.extent.setXY(newX, newY);\r\n        this.graphic.setXY(newX, newY);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(72)),
          p = (a.s[3]++, t(73)),
          m = (a.s[4]++, t(74)),
          C = (a.s[5]++, t(75)),
          d = (a.s[6]++, t(71)),
          f = (a.s[7]++, t(205));

      var h =
      /*#__PURE__*/
      function (_c$XmlComponent103) {
        _inherits(h, _c$XmlComponent103);

        function h(e, n) {
          var _this200;

          _classCallCheck(this, h);

          a.f[0]++, a.s[8]++, _this200 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, "wp:inline")), a.s[9]++, _this200.dimensions = n, a.s[10]++, _this200.root.push(new f.InlineAttributes({
            distT: 0,
            distB: 0,
            distL: 0,
            distR: 0
          })), a.s[11]++, _this200.extent = new m.Extent(n.emus.x, n.emus.y), a.s[12]++, _this200.graphic = new d.Graphic(e, n.emus.x, n.emus.y), a.s[13]++, _this200.root.push(_this200.extent), a.s[14]++, _this200.root.push(new p.EffectExtent()), a.s[15]++, _this200.root.push(new u.DocProperties()), a.s[16]++, _this200.root.push(new C.GraphicFrameProperties()), a.s[17]++, _this200.root.push(_this200.graphic);
          return _this200;
        }

        _createClass(h, [{
          key: "scale",
          value: function scale(e, n) {
            a.f[1]++;
            var t = (a.s[18]++, Math.round(this.dimensions.emus.x * e)),
                r = (a.s[19]++, Math.round(this.dimensions.emus.y * n));
            a.s[20]++, this.extent.setXY(t, r), a.s[21]++, this.graphic.setXY(t, r);
          }
        }]);

        return h;
      }(c.XmlComponent);

      a.s[22]++, n.Inline = h;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\inline-attributes.ts", o = "5c8ff4d256cf76c10c6021b702f95ae5e8d32b72", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\drawing\\inline\\inline-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 12,
              column: 10
            }
          },
          4: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/drawing/inline/inline-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\drawing\\inline\\inline-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAW5D,sBAA8B,SAAQ,sCAAwC;IAA9E;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;YACd,KAAK,EAAE,OAAO;SACjB,CAAC;IACN,CAAC;CAAA;AAPD,4CAOC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\nimport { IDistance } from "../drawing";\r\n\r\n// distT, distB etc have no effect on inline images, only floating\r\nexport interface IInlineAttributes extends IDistance {\r\n    readonly distT?: number;\r\n    readonly distB?: number;\r\n    readonly distL?: number;\r\n    readonly distR?: number;\r\n}\r\n\r\nexport class InlineAttributes extends XmlAttributeComponent<IInlineAttributes> {\r\n    protected readonly xmlKeys = {\r\n        distT: "distT",\r\n        distB: "distB",\r\n        distL: "distL",\r\n        distR: "distR",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon44) {
        _inherits(u, _c$XmlAttributeCompon44);

        function u() {
          var _this201;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this201 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this201.xmlKeys = {
            distT: "distT",
            distB: "distB",
            distL: "distL",
            distR: "distR"
          };
          return _this201;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.InlineAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\sequential-identifier.ts", o = "458a15f176641a53cd7933d9210452015b0d0564", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\sequential-identifier.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 14
            },
            end: {
              line: 3,
              column: 43
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 51
            }
          },
          3: {
            start: {
              line: 5,
              column: 44
            },
            end: {
              line: 5,
              column: 90
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 16
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 48
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 108
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 47
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 42
            }
          },
          9: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 52
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 28
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 7
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/sequential-identifier.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\sequential-identifier.ts"],
          names: [],
          mappings: ";;AAAA,4CAAyC;AACzC,oDAAgE;AAChE,2FAAsF;AAEtF,0BAAkC,SAAQ,SAAG;IACzC,YAAY,UAAkB;QAC1B,KAAK,EAAE,CAAC;QACR,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,IAAI,CAAC,CAAC,CAAC;QAChC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mEAA+B,CAAC,UAAU,CAAC,CAAC,CAAC;QAChE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gBAAQ,EAAE,CAAC,CAAC;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,WAAG,EAAE,CAAC,CAAC;IAC9B,CAAC;CACJ;AARD,oDAQC",
          sourcesContent: ['import { Run } from "file/paragraph/run";\r\nimport { Begin, End, Separate } from "file/paragraph/run/field";\r\nimport { SequentialIdentifierInstruction } from "./sequential-identifier-instruction";\r\n\r\nexport class SequentialIdentifier extends Run {\r\n    constructor(identifier: string) {\r\n        super();\r\n        this.root.push(new Begin(true));\r\n        this.root.push(new SequentialIdentifierInstruction(identifier));\r\n        this.root.push(new Separate());\r\n        this.root.push(new End());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(4)),
          u = (a.s[2]++, t(36)),
          p = (a.s[3]++, t(207));

      var m =
      /*#__PURE__*/
      function (_c$Run2) {
        _inherits(m, _c$Run2);

        function m(e) {
          var _this202;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this202 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this)), a.s[5]++, _this202.root.push(new u.Begin(!0)), a.s[6]++, _this202.root.push(new p.SequentialIdentifierInstruction(e)), a.s[7]++, _this202.root.push(new u.Separate()), a.s[8]++, _this202.root.push(new u.End());
          return _this202;
        }

        return m;
      }(c.Run);

      a.s[9]++, n.SequentialIdentifier = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\sequential-identifier-instruction.ts", o = "7f18cbb9240da5c35cf97ec8b4e1aa717c0dfef6", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\run\\sequential-identifier-instruction.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 47
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 46
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 29
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 87
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 44
            }
          },
          8: {
            start: {
              line: 18,
              column: 0
            },
            end: {
              line: 18,
              column: 74
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 28
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 12
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/run/sequential-identifier-instruction.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\run\\sequential-identifier-instruction.ts"],
          names: [],
          mappings: ";;AACA,gDAA4C;AAC5C,wDAA0E;AAE1E,oBAAqB,SAAQ,sCAAoD;IAAjF;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,WAAW,EAAE,CAAC;IACxD,CAAC;CAAA;AAED,qCAA6C,SAAQ,6BAAY;IAC7D,YAAY,UAAkB;QAC1B,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,cAAc,CAAC,EAAE,KAAK,EAAE,sBAAS,CAAC,QAAQ,EAAE,CAAC,CAAC,CAAC;QAClE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,UAAU,EAAE,CAAC,CAAC;IACxC,CAAC;CACJ;AAND,0EAMC",
          sourcesContent: ['// http://officeopenxml.com/WPfieldInstructions.php\r\nimport { SpaceType } from "file/space-type";\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nclass TextAttributes extends XmlAttributeComponent<{ readonly space: SpaceType }> {\r\n    protected readonly xmlKeys = { space: "xml:space" };\r\n}\r\n\r\nexport class SequentialIdentifierInstruction extends XmlComponent {\r\n    constructor(identifier: string) {\r\n        super("w:instrText");\r\n        this.root.push(new TextAttributes({ space: SpaceType.PRESERVE }));\r\n        this.root.push(`SEQ ${identifier}`);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(20)),
          u = (a.s[2]++, t(0));

      var p =
      /*#__PURE__*/
      function (_u$XmlAttributeCompon3) {
        _inherits(p, _u$XmlAttributeCompon3);

        function p() {
          var _this203;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this203 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this203.xmlKeys = {
            space: "xml:space"
          };
          return _this203;
        }

        return p;
      }(u.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_u$XmlComponent7) {
        _inherits(m, _u$XmlComponent7);

        function m(e) {
          var _this204;

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this204 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:instrText")), a.s[6]++, _this204.root.push(new p({
            space: c.SpaceType.PRESERVE
          })), a.s[7]++, _this204.root.push("SEQ ".concat(e));
          return _this204;
        }

        return m;
      }(u.XmlComponent);

      a.s[8]++, n.SequentialIdentifierInstruction = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\reference-run.ts", o = "23fa798f91de4691b3535f5042625de8f335e04b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\reference-run.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 14
            },
            end: {
              line: 3,
              column: 43
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 51
            }
          },
          3: {
            start: {
              line: 5,
              column: 25
            },
            end: {
              line: 5,
              column: 55
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 28
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 11,
              column: 10
            }
          },
          6: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 72
            }
          },
          7: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 37
            }
          },
          8: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 20,
              column: 12
            }
          },
          9: {
            start: {
              line: 23,
              column: 0
            },
            end: {
              line: 23,
              column: 46
            }
          },
          10: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 16
            }
          },
          11: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 69
            }
          },
          12: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 50
            }
          },
          13: {
            start: {
              line: 31,
              column: 0
            },
            end: {
              line: 31,
              column: 52
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 20
              },
              end: {
                line: 21,
                column: 5
              }
            },
            line: 16
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 25,
                column: 4
              },
              end: {
                line: 25,
                column: 5
              }
            },
            loc: {
              start: {
                line: 25,
                column: 20
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 25
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/run/reference-run.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\run\\reference-run.ts"],
          names: [],
          mappings: ";;AAAA,4CAAyC;AACzC,oDAAiD;AACjD,wDAA0E;AAM1E,oCAA4C,SAAQ,sCAAgE;IAApH;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,MAAM;SACb,CAAC;IACN,CAAC;CAAA;AAJD,wEAIC;AAED,uBAA+B,SAAQ,6BAAY;IAC/C,YAAY,EAAU;QAClB,KAAK,CAAC,qBAAqB,CAAC,CAAC;QAE7B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,8BAA8B,CAAC;YAC/B,EAAE,EAAE,EAAE;SACT,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,8CAUC;AAED,0BAAkC,SAAQ,SAAG;IACzC,YAAY,EAAU;QAClB,KAAK,EAAE,CAAC;QAER,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,mBAAmB,CAAC,CAAC,CAAC;QAErD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAiB,CAAC,EAAE,CAAC,CAAC,CAAC;IAC9C,CAAC;CACJ;AARD,oDAQC",
          sourcesContent: ['import { Run } from "file/paragraph/run";\r\nimport { Style } from "file/paragraph/run/style";\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport interface IFootNoteReferenceRunAttributesProperties {\r\n    readonly id: number;\r\n}\r\n\r\nexport class FootNoteReferenceRunAttributes extends XmlAttributeComponent<IFootNoteReferenceRunAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        id: "w:id",\r\n    };\r\n}\r\n\r\nexport class FootnoteReference extends XmlComponent {\r\n    constructor(id: number) {\r\n        super("w:footnoteReference");\r\n\r\n        this.root.push(\r\n            new FootNoteReferenceRunAttributes({\r\n                id: id,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class FootnoteReferenceRun extends Run {\r\n    constructor(id: number) {\r\n        super();\r\n\r\n        this.properties.push(new Style("FootnoteReference"));\r\n\r\n        this.root.push(new FootnoteReference(id));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(4)),
          u = (a.s[2]++, t(66)),
          p = (a.s[3]++, t(0));

      var m =
      /*#__PURE__*/
      function (_p$XmlAttributeCompon) {
        _inherits(m, _p$XmlAttributeCompon);

        function m() {
          var _this205;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this205 = _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments)), a.s[5]++, _this205.xmlKeys = {
            id: "w:id"
          };
          return _this205;
        }

        return m;
      }(p.XmlAttributeComponent);

      a.s[6]++, n.FootNoteReferenceRunAttributes = m;

      var C =
      /*#__PURE__*/
      function (_p$XmlComponent) {
        _inherits(C, _p$XmlComponent);

        function C(e) {
          var _this206;

          _classCallCheck(this, C);

          a.f[1]++, a.s[7]++, _this206 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:footnoteReference")), a.s[8]++, _this206.root.push(new m({
            id: e
          }));
          return _this206;
        }

        return C;
      }(p.XmlComponent);

      a.s[9]++, n.FootnoteReference = C;

      var d =
      /*#__PURE__*/
      function (_c$Run3) {
        _inherits(d, _c$Run3);

        function d(e) {
          var _this207;

          _classCallCheck(this, d);

          a.f[2]++, a.s[10]++, _this207 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this)), a.s[11]++, _this207.properties.push(new u.Style("FootnoteReference")), a.s[12]++, _this207.root.push(new C(e));
          return _this207;
        }

        return d;
      }(c.Run);

      a.s[13]++, n.FootnoteReferenceRun = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\bidirectional.ts", o = "53892a8a9d8459477861eca4c0528bfaea22cb07", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\formatting\\bidirectional.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 24
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/formatting/bidirectional.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\formatting\\bidirectional.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,mBAA2B,SAAQ,6BAAY;IAC3C;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;IACpB,CAAC;CACJ;AAJD,sCAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class Bidirectional extends XmlComponent {\r\n    constructor() {\r\n        super("w:bidi");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent104) {
        _inherits(u, _c$XmlComponent104);

        function u() {
          var _this208;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this208 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:bidi"));
          return _this208;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.Bidirectional = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\index.ts", o = "523db665e1284bc5ecbcc5962d166ab0fcbc3679", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 33
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/links/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\links\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,iCAA4B;AAC5B,gCAA2B",
          sourcesContent: ['export * from "./hyperlink";\r\nexport * from "./bookmark";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(211)), a.s[5]++, c(t(213));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\hyperlink.ts", o = "f5429a4f114d737498f7b976725d727e0ea998be", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\hyperlink.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 14
            },
            end: {
              line: 4,
              column: 31
            }
          },
          3: {
            start: {
              line: 5,
              column: 31
            },
            end: {
              line: 5,
              column: 64
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 29
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 45
            }
          },
          6: {
            start: {
              line: 10,
              column: 22
            },
            end: {
              line: 14,
              column: 9
            }
          },
          7: {
            start: {
              line: 15,
              column: 27
            },
            end: {
              line: 15,
              column: 80
            }
          },
          8: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 35
            }
          },
          9: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 67
            }
          },
          10: {
            start: {
              line: 20,
              column: 0
            },
            end: {
              line: 20,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 50
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 7
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 12,
                column: 20
              },
              end: {
                line: 12,
                column: 47
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 12,
                column: 29
              },
              end: {
                line: 12,
                column: 35
              }
            }, {
              start: {
                line: 12,
                column: 38
              },
              end: {
                line: 12,
                column: 47
              }
            }],
            line: 12
          },
          1: {
            loc: {
              start: {
                line: 13,
                column: 16
              },
              end: {
                line: 13,
                column: 57
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 13,
                column: 26
              },
              end: {
                line: 13,
                column: 45
              }
            }, {
              start: {
                line: 13,
                column: 48
              },
              end: {
                line: 13,
                column: 57
              }
            }],
            line: 13
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/links/hyperlink.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\links\\hyperlink.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,gCAAiC;AACjC,iEAA6F;AAE7F,eAAuB,SAAQ,6BAAY;IAGvC,YAAY,IAAY,EAAE,kBAA0B,EAAE,MAAe;QACjE,KAAK,CAAC,aAAa,CAAC,CAAC;QAErB,IAAI,CAAC,MAAM,GAAG,kBAAkB,GAAG,CAAC,CAAC;QAErC,MAAM,KAAK,GAAmC;YAC1C,OAAO,EAAE,CAAC;YACV,MAAM,EAAE,MAAM,CAAC,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,SAAS;YACnC,EAAE,EAAE,CAAC,MAAM,CAAC,CAAC,CAAC,MAAM,IAAI,CAAC,MAAM,EAAE,CAAC,CAAC,CAAC,SAAS;SAChD,CAAC;QAEF,MAAM,UAAU,GAAG,IAAI,0CAAmB,CAAC,KAAK,CAAC,CAAC;QAClD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAO,CAAC,IAAI,CAAC,CAAC,KAAK,CAAC,WAAW,CAAC,CAAC,CAAC;IACzD,CAAC;CACJ;AAlBD,8BAkBC",
          sourcesContent: ['// http://officeopenxml.com/WPhyperlink.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { TextRun } from "../run";\r\nimport { HyperlinkAttributes, IHyperlinkAttributesProperties } from "./hyperlink-attributes";\r\n\r\nexport class Hyperlink extends XmlComponent {\r\n    public readonly linkId: number;\r\n\r\n    constructor(text: string, relationshipsCount: number, anchor?: string) {\r\n        super("w:hyperlink");\r\n\r\n        this.linkId = relationshipsCount + 1;\r\n\r\n        const props: IHyperlinkAttributesProperties = {\r\n            history: 1,\r\n            anchor: anchor ? anchor : undefined,\r\n            id: !anchor ? `rId${this.linkId}` : undefined,\r\n        };\r\n\r\n        const attributes = new HyperlinkAttributes(props);\r\n        this.root.push(attributes);\r\n        this.root.push(new TextRun(text).style("Hyperlink"));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(4)),
          p = (a.s[3]++, t(212));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent105) {
        _inherits(m, _c$XmlComponent105);

        function m(e, n, t) {
          var _this209;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this209 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:hyperlink")), a.s[5]++, _this209.linkId = n + 1;
          var r = (a.s[6]++, {
            history: 1,
            anchor: t ? (a.b[0][0]++, t) : void a.b[0][1]++,
            id: t ? void a.b[1][1]++ : (a.b[1][0]++, "rId".concat(_this209.linkId))
          }),
              o = (a.s[7]++, new p.HyperlinkAttributes(r));
          a.s[8]++, _this209.root.push(o), a.s[9]++, _this209.root.push(new u.TextRun(e).style("Hyperlink"));
          return _this209;
        }

        return m;
      }(c.XmlComponent);

      a.s[10]++, n.Hyperlink = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\hyperlink-attributes.ts", o = "a261a9e8f5a0eff771c9399f0fdc45472c63e861", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\hyperlink-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 11,
              column: 10
            }
          },
          4: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 50
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/links/hyperlink-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\links\\hyperlink-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAQ5D,yBAAiC,SAAQ,sCAAqD;IAA9F;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,MAAM;YACV,OAAO,EAAE,WAAW;YACpB,MAAM,EAAE,UAAU;SACrB,CAAC;IACN,CAAC;CAAA;AAND,kDAMC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IHyperlinkAttributesProperties {\r\n    readonly id?: string;\r\n    readonly anchor?: string;\r\n    readonly history: number;\r\n}\r\n\r\nexport class HyperlinkAttributes extends XmlAttributeComponent<IHyperlinkAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        id: "r:id",\r\n        history: "w:history",\r\n        anchor: "w:anchor",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon45) {
        _inherits(u, _c$XmlAttributeCompon45);

        function u() {
          var _this210;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this210 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this210.xmlKeys = {
            id: "r:id",
            history: "w:history",
            anchor: "w:anchor"
          };
          return _this210;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.HyperlinkAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\bookmark.ts", o = "f43ab34490afe31cec77b1a2e41dcf8c1e48c6b6", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\bookmark.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 14
            },
            end: {
              line: 4,
              column: 31
            }
          },
          3: {
            start: {
              line: 5,
              column: 30
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 45
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 58
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 44
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 48
            }
          },
          8: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 28
            }
          },
          9: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 33
            }
          },
          10: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 41
            }
          },
          11: {
            start: {
              line: 19,
              column: 19
            },
            end: {
              line: 19,
              column: 35
            }
          },
          12: {
            start: {
              line: 20,
              column: 27
            },
            end: {
              line: 23,
              column: 10
            }
          },
          13: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 35
            }
          },
          14: {
            start: {
              line: 27,
              column: 0
            },
            end: {
              line: 27,
              column: 38
            }
          },
          15: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 31
            }
          },
          16: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 41
            }
          },
          17: {
            start: {
              line: 32,
              column: 19
            },
            end: {
              line: 32,
              column: 35
            }
          },
          18: {
            start: {
              line: 33,
              column: 27
            },
            end: {
              line: 35,
              column: 10
            }
          },
          19: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 35
            }
          },
          20: {
            start: {
              line: 39,
              column: 0
            },
            end: {
              line: 39,
              column: 34
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 48
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 42
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 16
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 29,
                column: 4
              },
              end: {
                line: 29,
                column: 5
              }
            },
            loc: {
              start: {
                line: 29,
                column: 36
              },
              end: {
                line: 37,
                column: 5
              }
            },
            line: 29
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/links/bookmark.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\links\\bookmark.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,gCAAiC;AACjC,+DAAuF;AAEvF;IAMI,YAAY,IAAY,EAAE,IAAY,EAAE,kBAA0B;QAC9D,IAAI,CAAC,MAAM,GAAG,kBAAkB,GAAG,CAAC,CAAC;QAErC,IAAI,CAAC,KAAK,GAAG,IAAI,aAAa,CAAC,IAAI,EAAE,IAAI,CAAC,MAAM,CAAC,CAAC;QAClD,IAAI,CAAC,IAAI,GAAG,IAAI,aAAO,CAAC,IAAI,CAAC,CAAC;QAC9B,IAAI,CAAC,GAAG,GAAG,IAAI,WAAW,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;IAC5C,CAAC;CACJ;AAbD,4BAaC;AAED,mBAA2B,SAAQ,6BAAY;IAG3C,YAAY,IAAY,EAAE,kBAA0B;QAChD,KAAK,CAAC,iBAAiB,CAAC,CAAC;QAEzB,IAAI,CAAC,MAAM,GAAG,kBAAkB,CAAC;QACjC,MAAM,EAAE,GAAG,GAAG,IAAI,CAAC,MAAM,EAAE,CAAC;QAC5B,MAAM,UAAU,GAAG,IAAI,6CAAuB,CAAC;YAC3C,IAAI;YACJ,EAAE;SACL,CAAC,CAAC;QACH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IAC/B,CAAC;CACJ;AAdD,sCAcC;AAED,iBAAyB,SAAQ,6BAAY;IAGzC,YAAY,kBAA0B;QAClC,KAAK,CAAC,eAAe,CAAC,CAAC;QAEvB,IAAI,CAAC,MAAM,GAAG,kBAAkB,CAAC;QACjC,MAAM,EAAE,GAAG,GAAG,IAAI,CAAC,MAAM,EAAE,CAAC;QAC5B,MAAM,UAAU,GAAG,IAAI,2CAAqB,CAAC;YACzC,EAAE;SACL,CAAC,CAAC;QACH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IAC/B,CAAC;CACJ;AAbD,kCAaC",
          sourcesContent: ['// http://officeopenxml.com/WPbookmark.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { TextRun } from "../run";\r\nimport { BookmarkEndAttributes, BookmarkStartAttributes } from "./bookmark-attributes";\r\n\r\nexport class Bookmark {\r\n    public readonly linkId: number;\r\n    public readonly start: BookmarkStart;\r\n    public readonly text: TextRun;\r\n    public readonly end: BookmarkEnd;\r\n\r\n    constructor(name: string, text: string, relationshipsCount: number) {\r\n        this.linkId = relationshipsCount + 1;\r\n\r\n        this.start = new BookmarkStart(name, this.linkId);\r\n        this.text = new TextRun(text);\r\n        this.end = new BookmarkEnd(this.linkId);\r\n    }\r\n}\r\n\r\nexport class BookmarkStart extends XmlComponent {\r\n    public readonly linkId: number;\r\n\r\n    constructor(name: string, relationshipsCount: number) {\r\n        super("w:bookmarkStart");\r\n\r\n        this.linkId = relationshipsCount;\r\n        const id = `${this.linkId}`;\r\n        const attributes = new BookmarkStartAttributes({\r\n            name,\r\n            id,\r\n        });\r\n        this.root.push(attributes);\r\n    }\r\n}\r\n\r\nexport class BookmarkEnd extends XmlComponent {\r\n    public readonly linkId: number;\r\n\r\n    constructor(relationshipsCount: number) {\r\n        super("w:bookmarkEnd");\r\n\r\n        this.linkId = relationshipsCount;\r\n        const id = `${this.linkId}`;\r\n        const attributes = new BookmarkEndAttributes({\r\n            id,\r\n        });\r\n        this.root.push(attributes);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(4)),
          p = (a.s[3]++, t(214));
      a.s[8]++, n.Bookmark =
      /*#__PURE__*/
      function () {
        function _class43(e, n, t) {
          _classCallCheck(this, _class43);

          a.f[0]++, a.s[4]++, this.linkId = t + 1, a.s[5]++, this.start = new m(e, this.linkId), a.s[6]++, this.text = new u.TextRun(n), a.s[7]++, this.end = new C(this.linkId);
        }

        return _class43;
      }();

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent106) {
        _inherits(m, _c$XmlComponent106);

        function m(e, n) {
          var _this211;

          _classCallCheck(this, m);

          a.f[1]++, a.s[9]++, _this211 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:bookmarkStart")), a.s[10]++, _this211.linkId = n;
          var t = (a.s[11]++, "".concat(_this211.linkId)),
              r = (a.s[12]++, new p.BookmarkStartAttributes({
            name: e,
            id: t
          }));
          a.s[13]++, _this211.root.push(r);
          return _this211;
        }

        return m;
      }(c.XmlComponent);

      a.s[14]++, n.BookmarkStart = m;

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent107) {
        _inherits(C, _c$XmlComponent107);

        function C(e) {
          var _this212;

          _classCallCheck(this, C);

          a.f[2]++, a.s[15]++, _this212 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:bookmarkEnd")), a.s[16]++, _this212.linkId = e;
          var n = (a.s[17]++, "".concat(_this212.linkId)),
              t = (a.s[18]++, new p.BookmarkEndAttributes({
            id: n
          }));
          a.s[19]++, _this212.root.push(t);
          return _this212;
        }

        return C;
      }(c.XmlComponent);

      a.s[20]++, n.BookmarkEnd = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\bookmark-attributes.ts", o = "e03b4bb5d9d3656a468dc49f164c20c8675aedec", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\links\\bookmark-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 58
            }
          },
          5: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 28
            }
          },
          6: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 19,
              column: 10
            }
          },
          7: {
            start: {
              line: 22,
              column: 0
            },
            end: {
              line: 22,
              column: 54
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 15,
                column: 4
              },
              end: {
                line: 15,
                column: 5
              }
            },
            loc: {
              start: {
                line: 15,
                column: 18
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 15
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/links/bookmark-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\links\\bookmark-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,6BAAqC,SAAQ,sCAAyD;IAAtG;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,MAAM;YACV,IAAI,EAAE,QAAQ;SACjB,CAAC;IACN,CAAC;CAAA;AALD,0DAKC;AAMD,2BAAmC,SAAQ,sCAAuD;IAAlG;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,MAAM;SACb,CAAC;IACN,CAAC;CAAA;AAJD,sDAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IBookmarkStartAttributesProperties {\r\n    readonly id: string;\r\n    readonly name: string;\r\n}\r\n\r\nexport class BookmarkStartAttributes extends XmlAttributeComponent<IBookmarkStartAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        id: "w:id",\r\n        name: "w:name",\r\n    };\r\n}\r\n\r\nexport interface IBookmarkEndAttributesProperties {\r\n    readonly id: string;\r\n}\r\n\r\nexport class BookmarkEndAttributes extends XmlAttributeComponent<IBookmarkEndAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        id: "w:id",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon46) {
        _inherits(u, _c$XmlAttributeCompon46);

        function u() {
          var _this213;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this213 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this213.xmlKeys = {
            id: "w:id",
            name: "w:name"
          };
          return _this213;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.BookmarkStartAttributes = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon47) {
        _inherits(p, _c$XmlAttributeCompon47);

        function p() {
          var _this214;

          _classCallCheck(this, p);

          a.f[1]++, a.s[5]++, _this214 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[6]++, _this214.xmlKeys = {
            id: "w:id"
          };
          return _this214;
        }

        return p;
      }(c.XmlAttributeComponent);

      a.s[7]++, n.BookmarkEndAttributes = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\image.ts", o = "4a7e7bb612385c1bd46bb1b3393b56d3ebc3366b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\paragraph\\image.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 42
            }
          },
          2: {
            start: {
              line: 4,
              column: 14
            },
            end: {
              line: 4,
              column: 30
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 16
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 74
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 40
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 48
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 31
            }
          },
          8: {
            start: {
              line: 18,
              column: 0
            },
            end: {
              line: 18,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 43
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 28
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 14
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 14
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/paragraph/image.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\paragraph\\image.ts"],
          names: [],
          mappings: ";;AAEA,2CAAwC;AACxC,+BAAmC;AAEnC,oBAA4B,SAAQ,qBAAS;IAGzC,YAAY,SAAqB,EAAE,cAAgC;QAC/D,KAAK,EAAE,CAAC;QACR,IAAI,CAAC,UAAU,GAAG,IAAI,gBAAU,CAAC,SAAS,EAAE,cAAc,CAAC,CAAC;QAC5D,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAEM,KAAK,CAAC,OAAe,EAAE,OAAgB;QAC1C,IAAI,CAAC,UAAU,CAAC,KAAK,CAAC,OAAO,EAAE,OAAO,CAAC,CAAC;IAC5C,CAAC;IAED,IAAW,GAAG;QACV,OAAO,IAAI,CAAC,UAAU,CAAC;IAC3B,CAAC;CACJ;AAhBD,wCAgBC",
          sourcesContent: ['import { IDrawingOptions } from "../drawing";\r\nimport { IMediaData } from "../media";\r\nimport { Paragraph } from "./paragraph";\r\nimport { PictureRun } from "./run";\r\n\r\nexport class ImageParagraph extends Paragraph {\r\n    private readonly pictureRun: PictureRun;\r\n\r\n    constructor(imageData: IMediaData, drawingOptions?: IDrawingOptions) {\r\n        super();\r\n        this.pictureRun = new PictureRun(imageData, drawingOptions);\r\n        this.root.push(this.pictureRun);\r\n    }\r\n\r\n    public scale(factorX: number, factorY?: number): void {\r\n        this.pictureRun.scale(factorX, factorY);\r\n    }\r\n\r\n    public get Run(): PictureRun {\r\n        return this.pictureRun;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(81)),
          u = (a.s[2]++, t(4));

      var p =
      /*#__PURE__*/
      function (_c$Paragraph) {
        _inherits(p, _c$Paragraph);

        function p(e, n) {
          var _this215;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this215 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), a.s[4]++, _this215.pictureRun = new u.PictureRun(e, n), a.s[5]++, _this215.root.push(_this215.pictureRun);
          return _this215;
        }

        _createClass(p, [{
          key: "scale",
          value: function scale(e, n) {
            a.f[1]++, a.s[6]++, this.pictureRun.scale(e, n);
          }
        }, {
          key: "Run",
          get: function get() {
            return a.f[2]++, a.s[7]++, this.pictureRun;
          }
        }]);

        return p;
      }(c.Paragraph);

      a.s[8]++, n.ImageParagraph = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table.ts", o = "57f5228f6271574e0a12d8bd6e70b39bb40b3bfd", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 15
            },
            end: {
              line: 4,
              column: 32
            }
          },
          3: {
            start: {
              line: 5,
              column: 21
            },
            end: {
              line: 5,
              column: 44
            }
          },
          4: {
            start: {
              line: 6,
              column: 27
            },
            end: {
              line: 6,
              column: 56
            }
          },
          5: {
            start: {
              line: 7,
              column: 20
            },
            end: {
              line: 7,
              column: 42
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 23
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 67
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 40
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 36
            }
          },
          10: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 23,
              column: 9
            }
          },
          11: {
            start: {
              line: 15,
              column: 12
            },
            end: {
              line: 15,
              column: 55
            }
          },
          12: {
            start: {
              line: 18,
              column: 29
            },
            end: {
              line: 18,
              column: 31
            }
          },
          13: {
            start: {
              line: 19,
              column: 12
            },
            end: {
              line: 21,
              column: 13
            }
          },
          14: {
            start: {
              line: 20,
              column: 16
            },
            end: {
              line: 20,
              column: 35
            }
          },
          15: {
            start: {
              line: 22,
              column: 12
            },
            end: {
              line: 22,
              column: 55
            }
          },
          16: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 34
            }
          },
          17: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 23
            }
          },
          18: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 34,
              column: 9
            }
          },
          19: {
            start: {
              line: 27,
              column: 26
            },
            end: {
              line: 27,
              column: 28
            }
          },
          20: {
            start: {
              line: 28,
              column: 12
            },
            end: {
              line: 30,
              column: 13
            }
          },
          21: {
            start: {
              line: 29,
              column: 16
            },
            end: {
              line: 29,
              column: 57
            }
          },
          22: {
            start: {
              line: 31,
              column: 24
            },
            end: {
              line: 31,
              column: 55
            }
          },
          23: {
            start: {
              line: 32,
              column: 12
            },
            end: {
              line: 32,
              column: 32
            }
          },
          24: {
            start: {
              line: 33,
              column: 12
            },
            end: {
              line: 33,
              column: 32
            }
          },
          25: {
            start: {
              line: 37,
              column: 20
            },
            end: {
              line: 37,
              column: 33
            }
          },
          26: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 40,
              column: 9
            }
          },
          27: {
            start: {
              line: 39,
              column: 12
            },
            end: {
              line: 39,
              column: 79
            }
          },
          28: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 19
            }
          },
          29: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 44,
              column: 45
            }
          },
          30: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 46
            }
          },
          31: {
            start: {
              line: 48,
              column: 8
            },
            end: {
              line: 48,
              column: 20
            }
          },
          32: {
            start: {
              line: 51,
              column: 8
            },
            end: {
              line: 51,
              column: 46
            }
          },
          33: {
            start: {
              line: 52,
              column: 8
            },
            end: {
              line: 52,
              column: 20
            }
          },
          34: {
            start: {
              line: 55,
              column: 8
            },
            end: {
              line: 55,
              column: 67
            }
          },
          35: {
            start: {
              line: 56,
              column: 8
            },
            end: {
              line: 56,
              column: 20
            }
          },
          36: {
            start: {
              line: 59,
              column: 8
            },
            end: {
              line: 59,
              column: 31
            }
          },
          37: {
            start: {
              line: 62,
              column: 0
            },
            end: {
              line: 62,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 9,
                column: 4
              },
              end: {
                line: 9,
                column: 5
              }
            },
            loc: {
              start: {
                line: 9,
                column: 38
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 9
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 36,
                column: 4
              },
              end: {
                line: 36,
                column: 5
              }
            },
            loc: {
              start: {
                line: 36,
                column: 15
              },
              end: {
                line: 42,
                column: 5
              }
            },
            line: 36
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 43,
                column: 4
              },
              end: {
                line: 43,
                column: 5
              }
            },
            loc: {
              start: {
                line: 43,
                column: 22
              },
              end: {
                line: 45,
                column: 5
              }
            },
            line: 43
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 46,
                column: 4
              },
              end: {
                line: 46,
                column: 5
              }
            },
            loc: {
              start: {
                line: 46,
                column: 26
              },
              end: {
                line: 49,
                column: 5
              }
            },
            line: 46
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 50,
                column: 4
              },
              end: {
                line: 50,
                column: 5
              }
            },
            loc: {
              start: {
                line: 50,
                column: 26
              },
              end: {
                line: 53,
                column: 5
              }
            },
            line: 50
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 54,
                column: 4
              },
              end: {
                line: 54,
                column: 5
              }
            },
            loc: {
              start: {
                line: 54,
                column: 29
              },
              end: {
                line: 57,
                column: 5
              }
            },
            line: 54
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 58,
                column: 4
              },
              end: {
                line: 58,
                column: 5
              }
            },
            loc: {
              start: {
                line: 58,
                column: 21
              },
              end: {
                line: 60,
                column: 5
              }
            },
            line: 58
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 14,
                column: 8
              },
              end: {
                line: 23,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 14,
                column: 8
              },
              end: {
                line: 23,
                column: 9
              }
            }, {
              start: {
                line: 14,
                column: 8
              },
              end: {
                line: 23,
                column: 9
              }
            }],
            line: 14
          },
          1: {
            loc: {
              start: {
                line: 14,
                column: 12
              },
              end: {
                line: 14,
                column: 43
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 14,
                column: 12
              },
              end: {
                line: 14,
                column: 20
              }
            }, {
              start: {
                line: 14,
                column: 24
              },
              end: {
                line: 14,
                column: 43
              }
            }],
            line: 14
          },
          2: {
            loc: {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }, {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }],
            line: 38
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AAEnD,iCAAmC;AACnC,6CAAoD;AACpD,yDAAyE;AACzE,2CAAuC;AAEvC,WAAmB,SAAQ,6BAAY;IAKnC,YAAY,IAAY,EAAE,IAAY,EAAE,QAAmB;QACvD,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,UAAU,GAAG,IAAI,kCAAe,EAAE,CAAC;QACxC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;QAChC,IAAI,CAAC,UAAU,CAAC,SAAS,EAAE,CAAC;QAE5B,IAAI,QAAQ,IAAI,QAAQ,CAAC,MAAM,GAAG,CAAC,EAAE;YACjC,IAAI,CAAC,IAAI,GAAG,IAAI,gBAAS,CAAC,QAAQ,CAAC,CAAC;SACvC;aAAM;YACH,MAAM,QAAQ,GAAa,EAAE,CAAC;YAC9B,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,IAAI,EAAE,CAAC,EAAE,EAAE;gBAW3B,QAAQ,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;aACtB;YACD,IAAI,CAAC,IAAI,GAAG,IAAI,gBAAS,CAAC,QAAQ,CAAC,CAAC;SACvC;QAED,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;QAE1B,IAAI,CAAC,IAAI,GAAG,EAAE,CAAC;QACf,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,IAAI,EAAE,CAAC,EAAE,EAAE;YAC3B,MAAM,KAAK,GAAgB,EAAE,CAAC;YAC9B,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,IAAI,EAAE,CAAC,EAAE,EAAE;gBAC3B,KAAK,CAAC,IAAI,CAAC,IAAI,sBAAS,EAAE,CAAC,CAAC;aAC/B;YACD,MAAM,GAAG,GAAG,IAAI,oBAAQ,CAAC,KAAK,CAAC,CAAC;YAChC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;YACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;SACvB;IACL,CAAC;IAEM,MAAM,CAAC,EAAU;QACpB,MAAM,GAAG,GAAG,IAAI,CAAC,IAAI,CAAC,EAAE,CAAC,CAAC;QAE1B,IAAI,CAAC,GAAG,EAAE;YACN,MAAM,KAAK,CAAC,qDAAqD,CAAC,CAAC;SACtE;QAED,OAAO,GAAG,CAAC;IACf,CAAC;IAEM,OAAO,CAAC,GAAW,EAAE,GAAW;QACnC,OAAO,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC;IACzC,CAAC;IAEM,QAAQ,CAAC,IAAe,EAAE,KAAsB;QACnD,IAAI,CAAC,UAAU,CAAC,QAAQ,CAAC,IAAI,EAAE,KAAK,CAAC,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,mBAAmB;QACtB,IAAI,CAAC,UAAU,CAAC,mBAAmB,EAAE,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,KAAK,CAAC,iBAAqC;QAC9C,IAAI,CAAC,UAAU,CAAC,uBAAuB,CAAC,iBAAiB,CAAC,CAAC;QAC3D,OAAO,IAAI,CAAC;IAChB,CAAC;IAED,IAAW,UAAU;QACjB,OAAO,IAAI,CAAC,UAAU,CAAC;IAC3B,CAAC;CACJ;AA7ED,sBA6EC",
          sourcesContent: ['// http://officeopenxml.com/WPtableGrid.php\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nimport { TableGrid } from "./grid";\r\nimport { TableCell, WidthType } from "./table-cell";\r\nimport { ITableFloatOptions, TableProperties } from "./table-properties";\r\nimport { TableRow } from "./table-row";\r\n\r\nexport class Table extends XmlComponent {\r\n    private readonly properties: TableProperties;\r\n    private readonly rows: TableRow[];\r\n    private readonly grid: TableGrid;\r\n\r\n    constructor(rows: number, cols: number, colSizes?: number[]) {\r\n        super("w:tbl");\r\n        this.properties = new TableProperties();\r\n        this.root.push(this.properties);\r\n        this.properties.setBorder();\r\n\r\n        if (colSizes && colSizes.length > 0) {\r\n            this.grid = new TableGrid(colSizes);\r\n        } else {\r\n            const gridCols: number[] = [];\r\n            for (let i = 0; i < cols; i++) {\r\n                /*\r\n                  0-width columns don\'t get rendered correctly, so we need\r\n                  to give them some value. A reasonable default would be\r\n                  ~6in / numCols, but if we do that it becomes very hard\r\n                  to resize the table using setWidth, unless the layout\r\n                  algorithm is set to \'fixed\'. Instead, the approach here\r\n                  means even in \'auto\' layout, setting a width on the\r\n                  table will make it look reasonable, as the layout\r\n                  algorithm will expand columns to fit its content\r\n                 */\r\n                gridCols.push(100);\r\n            }\r\n            this.grid = new TableGrid(gridCols);\r\n        }\r\n\r\n        this.root.push(this.grid);\r\n\r\n        this.rows = [];\r\n        for (let i = 0; i < rows; i++) {\r\n            const cells: TableCell[] = [];\r\n            for (let j = 0; j < cols; j++) {\r\n                cells.push(new TableCell());\r\n            }\r\n            const row = new TableRow(cells);\r\n            this.rows.push(row);\r\n            this.root.push(row);\r\n        }\r\n    }\r\n\r\n    public getRow(ix: number): TableRow {\r\n        const row = this.rows[ix];\r\n\r\n        if (!row) {\r\n            throw Error("Index out of bounds when trying to get row on table");\r\n        }\r\n\r\n        return row;\r\n    }\r\n\r\n    public getCell(row: number, col: number): TableCell {\r\n        return this.getRow(row).getCell(col);\r\n    }\r\n\r\n    public setWidth(type: WidthType, width: number | string): Table {\r\n        this.properties.setWidth(type, width);\r\n        return this;\r\n    }\r\n\r\n    public setFixedWidthLayout(): Table {\r\n        this.properties.setFixedWidthLayout();\r\n        return this;\r\n    }\r\n\r\n    public float(tableFloatOptions: ITableFloatOptions): Table {\r\n        this.properties.setTableFloatProperties(tableFloatOptions);\r\n        return this;\r\n    }\r\n\r\n    public get Properties(): TableProperties {\r\n        return this.properties;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(217)),
          p = (a.s[3]++, t(40)),
          m = (a.s[4]++, t(83)),
          C = (a.s[5]++, t(225));

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent108) {
        _inherits(d, _c$XmlComponent108);

        function d(e, n, t) {
          var _this216;

          _classCallCheck(this, d);

          if (a.f[0]++, a.s[6]++, _this216 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "w:tbl")), a.s[7]++, _this216.properties = new m.TableProperties(), a.s[8]++, _this216.root.push(_this216.properties), a.s[9]++, _this216.properties.setBorder(), a.s[10]++, a.b[1][0]++, t && (a.b[1][1]++, t.length > 0)) a.b[0][0]++, a.s[11]++, _this216.grid = new u.TableGrid(t);else {
            a.b[0][1]++;

            var _e5 = (a.s[12]++, []);

            a.s[13]++;

            for (var _t5 = 0; _t5 < n; _t5++) {
              a.s[14]++, _e5.push(100);
            }

            a.s[15]++, _this216.grid = new u.TableGrid(_e5);
          }
          a.s[16]++, _this216.root.push(_this216.grid), a.s[17]++, _this216.rows = [], a.s[18]++;

          for (var _t6 = 0; _t6 < e; _t6++) {
            var _e6 = (a.s[19]++, []);

            a.s[20]++;

            for (var _t8 = 0; _t8 < n; _t8++) {
              a.s[21]++, _e6.push(new p.TableCell());
            }

            var _t7 = (a.s[22]++, new C.TableRow(_e6));

            a.s[23]++, _this216.rows.push(_t7), a.s[24]++, _this216.root.push(_t7);
          }

          return _possibleConstructorReturn(_this216);
        }

        _createClass(d, [{
          key: "getRow",
          value: function getRow(e) {
            a.f[1]++;
            var n = (a.s[25]++, this.rows[e]);
            if (a.s[26]++, !n) throw a.b[2][0]++, a.s[27]++, Error("Index out of bounds when trying to get row on table");
            return a.b[2][1]++, a.s[28]++, n;
          }
        }, {
          key: "getCell",
          value: function getCell(e, n) {
            return a.f[2]++, a.s[29]++, this.getRow(e).getCell(n);
          }
        }, {
          key: "setWidth",
          value: function setWidth(e, n) {
            return a.f[3]++, a.s[30]++, this.properties.setWidth(e, n), a.s[31]++, this;
          }
        }, {
          key: "setFixedWidthLayout",
          value: function setFixedWidthLayout() {
            return a.f[4]++, a.s[32]++, this.properties.setFixedWidthLayout(), a.s[33]++, this;
          }
        }, {
          key: "float",
          value: function float(e) {
            return a.f[5]++, a.s[34]++, this.properties.setTableFloatProperties(e), a.s[35]++, this;
          }
        }, {
          key: "Properties",
          get: function get() {
            return a.f[6]++, a.s[36]++, this.properties;
          }
        }]);

        return d;
      }(c.XmlComponent);

      a.s[37]++, n.Table = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\grid.ts", o = "dc9b8537c22108718b1689d66f679e056d6685f8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\grid.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 27
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 64
            }
          },
          4: {
            start: {
              line: 7,
              column: 30
            },
            end: {
              line: 7,
              column: 62
            }
          },
          5: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 30
            }
          },
          6: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 28
            }
          },
          7: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 36
            }
          },
          8: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 27
            }
          },
          9: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 22,
              column: 9
            }
          },
          10: {
            start: {
              line: 21,
              column: 12
            },
            end: {
              line: 21,
              column: 64
            }
          },
          11: {
            start: {
              line: 25,
              column: 0
            },
            end: {
              line: 25,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 22
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 7,
                column: 21
              },
              end: {
                line: 7,
                column: 22
              }
            },
            loc: {
              start: {
                line: 7,
                column: 30
              },
              end: {
                line: 7,
                column: 62
              }
            },
            line: 7
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 18
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 12
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 18,
                column: 23
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 18
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 20,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 20,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            }, {
              start: {
                line: 20,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            }],
            line: 20
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/grid.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\grid.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAE1E,eAAuB,SAAQ,6BAAY;IACvC,YAAY,IAAc;QACtB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,OAAO,CAAC,CAAC,GAAG,EAAE,EAAE,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,OAAO,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC;IAC5D,CAAC;CACJ;AALD,8BAKC;AAED,uBAAwB,SAAQ,sCAA6C;IAA7E;;QACuB,YAAO,GAAG,EAAE,CAAC,EAAE,KAAK,EAAE,CAAC;IAC9C,CAAC;CAAA;AAED,aAAqB,SAAQ,6BAAY;IACrC,YAAY,KAAc;QACtB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,KAAK,KAAK,SAAS,EAAE;YACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAiB,CAAC,EAAE,CAAC,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;SACvD;IACL,CAAC;CACJ;AAPD,0BAOC",
          sourcesContent: ['// http://officeopenxml.com/WPtableGrid.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport class TableGrid extends XmlComponent {\r\n    constructor(cols: number[]) {\r\n        super("w:tblGrid");\r\n        cols.forEach((col) => this.root.push(new GridCol(col)));\r\n    }\r\n}\r\n\r\nclass GridColAttributes extends XmlAttributeComponent<{ readonly w: number }> {\r\n    protected readonly xmlKeys = { w: "w:w" };\r\n}\r\n\r\nexport class GridCol extends XmlComponent {\r\n    constructor(width?: number) {\r\n        super("w:gridCol");\r\n        if (width !== undefined) {\r\n            this.root.push(new GridColAttributes({ w: width }));\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent109) {
        _inherits(u, _c$XmlComponent109);

        function u(e) {
          var _this217;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this217 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:tblGrid")), a.s[3]++, e.forEach(function (e) {
            return a.f[1]++, a.s[4]++, _this217.root.push(new m(e));
          });
          return _this217;
        }

        return u;
      }(c.XmlComponent);

      a.s[5]++, n.TableGrid = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon48) {
        _inherits(p, _c$XmlAttributeCompon48);

        function p() {
          var _this218;

          _classCallCheck(this, p);

          a.f[2]++, a.s[6]++, _this218 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[7]++, _this218.xmlKeys = {
            w: "w:w"
          };
          return _this218;
        }

        return p;
      }(c.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent110) {
        _inherits(m, _c$XmlComponent110);

        function m(e) {
          var _this219;

          _classCallCheck(this, m);

          a.f[3]++, a.s[8]++, _this219 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:gridCol")), a.s[9]++, void 0 !== e ? (a.b[0][0]++, a.s[10]++, _this219.root.push(new p({
            w: e
          }))) : a.b[0][1]++;
          return _this219;
        }

        return m;
      }(c.XmlComponent);

      a.s[11]++, n.GridCol = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\table-cell.ts", o = "2bde0beee1eb487332f4884150f612946c84367b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\table-cell.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 45
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 5,
              column: 32
            },
            end: {
              line: 5,
              column: 66
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 22
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 76
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 40
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 32
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 20
            }
          },
          9: {
            start: {
              line: 17,
              column: 23
            },
            end: {
              line: 17,
              column: 41
            }
          },
          10: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 20,
              column: 9
            }
          },
          11: {
            start: {
              line: 19,
              column: 12
            },
            end: {
              line: 19,
              column: 29
            }
          },
          12: {
            start: {
              line: 21,
              column: 24
            },
            end: {
              line: 21,
              column: 38
            }
          },
          13: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 24,
              column: 9
            }
          },
          14: {
            start: {
              line: 23,
              column: 12
            },
            end: {
              line: 23,
              column: 67
            }
          },
          15: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 22
            }
          },
          16: {
            start: {
              line: 28,
              column: 21
            },
            end: {
              line: 28,
              column: 52
            }
          },
          17: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 30
            }
          },
          18: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 20
            }
          },
          19: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 31
            }
          },
          20: {
            start: {
              line: 36,
              column: 0
            },
            end: {
              line: 36,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 24
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 12
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 17
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 16
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 26
              },
              end: {
                line: 31,
                column: 5
              }
            },
            line: 27
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 32,
                column: 4
              },
              end: {
                line: 32,
                column: 5
              }
            },
            loc: {
              start: {
                line: 32,
                column: 25
              },
              end: {
                line: 34,
                column: 5
              }
            },
            line: 32
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 18,
                column: 8
              },
              end: {
                line: 20,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 18,
                column: 8
              },
              end: {
                line: 20,
                column: 9
              }
            }, {
              start: {
                line: 18,
                column: 8
              },
              end: {
                line: 20,
                column: 9
              }
            }],
            line: 18
          },
          1: {
            loc: {
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            }, {
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            }],
            line: 22
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-cell/table-cell.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-cell\\table-cell.ts"],
          names: [],
          mappings: ";;AACA,8CAA2C;AAC3C,wDAAmE;AAGnE,mEAA8D;AAE9D,eAAuB,SAAQ,6BAAY;IAGvC;QACI,KAAK,CAAC,MAAM,CAAC,CAAC;QACd,IAAI,CAAC,UAAU,GAAG,IAAI,2CAAmB,EAAE,CAAC;QAC5C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAEM,UAAU,CAAC,OAA0B;QACxC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;QACxB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,UAAU;QAEb,MAAM,MAAM,GAAG,KAAK,CAAC,UAAU,EAAE,CAAC;QAClC,IAAI,CAAC,MAAM,EAAE;YACT,OAAO,SAAS,CAAC;SACpB;QAED,MAAM,OAAO,GAAG,MAAM,CAAC,MAAM,CAAC,CAAC;QAC/B,IAAI,CAAC,OAAO,CAAC,OAAO,CAAC,MAAM,GAAG,CAAC,CAAC,CAAC,KAAK,CAAC,EAAE;YACrC,OAAO,CAAC,IAAI,CAAC,IAAI,qBAAS,EAAE,CAAC,UAAU,EAAE,CAAC,CAAC;SAC9C;QACD,OAAO,MAAM,CAAC;IAClB,CAAC;IAEM,eAAe,CAAC,IAAa;QAChC,MAAM,IAAI,GAAG,IAAI,qBAAS,CAAC,IAAI,CAAC,CAAC;QACjC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,CAAC;QACtB,OAAO,IAAI,CAAC;IAChB,CAAC;IAED,IAAW,cAAc;QACrB,OAAO,IAAI,CAAC,UAAU,CAAC;IAC3B,CAAC;CACJ;AArCD,8BAqCC",
          sourcesContent: ['// http://officeopenxml.com/WPtableGrid.php\r\nimport { Paragraph } from "file/paragraph";\r\nimport { IXmlableObject, XmlComponent } from "file/xml-components";\r\n\r\nimport { Table } from "../table";\r\nimport { TableCellProperties } from "./table-cell-properties";\r\n\r\nexport class TableCell extends XmlComponent {\r\n    private readonly properties: TableCellProperties;\r\n\r\n    constructor() {\r\n        super("w:tc");\r\n        this.properties = new TableCellProperties();\r\n        this.root.push(this.properties);\r\n    }\r\n\r\n    public addContent(content: Paragraph | Table): TableCell {\r\n        this.root.push(content);\r\n        return this;\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        // Cells must end with a paragraph\r\n        const retval = super.prepForXml();\r\n        if (!retval) {\r\n            return undefined;\r\n        }\r\n\r\n        const content = retval["w:tc"];\r\n        if (!content[content.length - 1]["w:p"]) {\r\n            content.push(new Paragraph().prepForXml());\r\n        }\r\n        return retval;\r\n    }\r\n\r\n    public createParagraph(text?: string): Paragraph {\r\n        const para = new Paragraph(text);\r\n        this.addContent(para);\r\n        return para;\r\n    }\r\n\r\n    public get CellProperties(): TableCellProperties {\r\n        return this.properties;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(0)),
          p = (a.s[3]++, t(219));

      var m =
      /*#__PURE__*/
      function (_u$XmlComponent8) {
        _inherits(m, _u$XmlComponent8);

        function m() {
          var _this220;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this220 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:tc")), a.s[5]++, _this220.properties = new p.TableCellProperties(), a.s[6]++, _this220.root.push(_this220.properties);
          return _this220;
        }

        _createClass(m, [{
          key: "addContent",
          value: function addContent(e) {
            return a.f[1]++, a.s[7]++, this.root.push(e), a.s[8]++, this;
          }
        }, {
          key: "prepForXml",
          value: function prepForXml() {
            a.f[2]++;
            var e = (a.s[9]++, _get(_getPrototypeOf(m.prototype), "prepForXml", this).call(this));
            if (a.s[10]++, !e) return a.b[0][0]++, void a.s[11]++;
            a.b[0][1]++;
            var n = (a.s[12]++, e["w:tc"]);
            return a.s[13]++, n[n.length - 1]["w:p"] ? a.b[1][1]++ : (a.b[1][0]++, a.s[14]++, n.push(new c.Paragraph().prepForXml())), a.s[15]++, e;
          }
        }, {
          key: "createParagraph",
          value: function createParagraph(e) {
            a.f[3]++;
            var n = (a.s[16]++, new c.Paragraph(e));
            return a.s[17]++, this.addContent(n), a.s[18]++, n;
          }
        }, {
          key: "CellProperties",
          get: function get() {
            return a.f[4]++, a.s[19]++, this.properties;
          }
        }]);

        return m;
      }(u.XmlComponent);

      a.s[20]++, n.TableCell = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\table-cell-properties.ts", o = "6313028209e64a3e6cc328348c0ace5344c788a5", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-cell\\table-cell-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 32
            },
            end: {
              line: 4,
              column: 66
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 24
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 73
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 40
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 31
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 71
            }
          },
          8: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 20
            }
          },
          9: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 65
            }
          },
          10: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 20
            }
          },
          11: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 65
            }
          },
          12: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 20
            }
          },
          13: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 80
            }
          },
          14: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 20
            }
          },
          15: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 76
            }
          },
          16: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 20
            }
          },
          17: {
            start: {
              line: 35,
              column: 0
            },
            end: {
              line: 35,
              column: 50
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 26
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 14
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 18,
                column: 27
              },
              end: {
                line: 21,
                column: 5
              }
            },
            line: 18
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 22,
                column: 4
              },
              end: {
                line: 22,
                column: 5
              }
            },
            loc: {
              start: {
                line: 22,
                column: 27
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 22
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 26
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 26
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 22
              },
              end: {
                line: 33,
                column: 5
              }
            },
            line: 30
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-cell/table-cell-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-cell\\table-cell-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,mEAWiC;AAEjC,yBAAiC,SAAQ,6BAAY;IAGjD;QACI,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,UAAU,GAAG,IAAI,wCAAgB,EAAE,CAAC;QACzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAED,IAAW,OAAO;QACd,OAAO,IAAI,CAAC,UAAU,CAAC;IAC3B,CAAC;IAEM,WAAW,CAAC,QAAgB;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gCAAQ,CAAC,QAAQ,CAAC,CAAC,CAAC;QAEvC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,gBAAgB,CAAC,IAAgB;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,8BAAM,CAAC,IAAI,CAAC,CAAC,CAAC;QAEjC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,gBAAgB,CAAC,IAAmB;QACvC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,8BAAM,CAAC,IAAI,CAAC,CAAC,CAAC;QAEjC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ,CAAC,KAAsB,EAAE,IAAe;QACnD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,sCAAc,CAAC,KAAK,EAAE,IAAI,CAAC,CAAC,CAAC;QAEhD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,UAAU,CAAC,KAA4C;QAC1D,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,wCAAgB,CAAC,KAAK,CAAC,CAAC,CAAC;QAE5C,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AA1CD,kDA0CC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nimport {\r\n    GridSpan,\r\n    ITableCellShadingAttributesProperties,\r\n    TableCellBorders,\r\n    TableCellShading,\r\n    TableCellWidth,\r\n    VAlign,\r\n    VerticalAlign,\r\n    VMerge,\r\n    VMergeType,\r\n    WidthType,\r\n} from "./table-cell-components";\r\n\r\nexport class TableCellProperties extends XmlComponent {\r\n    private readonly cellBorder: TableCellBorders;\r\n\r\n    constructor() {\r\n        super("w:tcPr");\r\n        this.cellBorder = new TableCellBorders();\r\n        this.root.push(this.cellBorder);\r\n    }\r\n\r\n    public get Borders(): TableCellBorders {\r\n        return this.cellBorder;\r\n    }\r\n\r\n    public addGridSpan(cellSpan: number): TableCellProperties {\r\n        this.root.push(new GridSpan(cellSpan));\r\n\r\n        return this;\r\n    }\r\n\r\n    public addVerticalMerge(type: VMergeType): TableCellProperties {\r\n        this.root.push(new VMerge(type));\r\n\r\n        return this;\r\n    }\r\n\r\n    public setVerticalAlign(type: VerticalAlign): TableCellProperties {\r\n        this.root.push(new VAlign(type));\r\n\r\n        return this;\r\n    }\r\n\r\n    public setWidth(width: string | number, type: WidthType): TableCellProperties {\r\n        this.root.push(new TableCellWidth(width, type));\r\n\r\n        return this;\r\n    }\r\n\r\n    public setShading(attrs: ITableCellShadingAttributesProperties): TableCellProperties {\r\n        this.root.push(new TableCellShading(attrs));\r\n\r\n        return this;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(82));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent111) {
        _inherits(p, _c$XmlComponent111);

        function p() {
          var _this221;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this221 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:tcPr")), a.s[4]++, _this221.cellBorder = new u.TableCellBorders(), a.s[5]++, _this221.root.push(_this221.cellBorder);
          return _this221;
        }

        _createClass(p, [{
          key: "addGridSpan",
          value: function addGridSpan(e) {
            return a.f[2]++, a.s[7]++, this.root.push(new u.GridSpan(e)), a.s[8]++, this;
          }
        }, {
          key: "addVerticalMerge",
          value: function addVerticalMerge(e) {
            return a.f[3]++, a.s[9]++, this.root.push(new u.VMerge(e)), a.s[10]++, this;
          }
        }, {
          key: "setVerticalAlign",
          value: function setVerticalAlign(e) {
            return a.f[4]++, a.s[11]++, this.root.push(new u.VAlign(e)), a.s[12]++, this;
          }
        }, {
          key: "setWidth",
          value: function setWidth(e, n) {
            return a.f[5]++, a.s[13]++, this.root.push(new u.TableCellWidth(e, n)), a.s[14]++, this;
          }
        }, {
          key: "setShading",
          value: function setShading(e) {
            return a.f[6]++, a.s[15]++, this.root.push(new u.TableCellShading(e)), a.s[16]++, this;
          }
        }, {
          key: "Borders",
          get: function get() {
            return a.f[1]++, a.s[6]++, this.cellBorder;
          }
        }]);

        return p;
      }(c.XmlComponent);

      a.s[17]++, n.TableCellProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-properties.ts", o = "01f64cb096f6d562e9820855054a3b0851359fae", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 24
            },
            end: {
              line: 4,
              column: 50
            }
          },
          3: {
            start: {
              line: 5,
              column: 28
            },
            end: {
              line: 5,
              column: 58
            }
          },
          4: {
            start: {
              line: 6,
              column: 33
            },
            end: {
              line: 6,
              column: 68
            }
          },
          5: {
            start: {
              line: 7,
              column: 23
            },
            end: {
              line: 7,
              column: 48
            }
          },
          6: {
            start: {
              line: 8,
              column: 22
            },
            end: {
              line: 8,
              column: 46
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 25
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 68
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 40
            }
          },
          10: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 71
            }
          },
          11: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 20
            }
          },
          12: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 93
            }
          },
          13: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 20
            }
          },
          14: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 59
            }
          },
          15: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 20
            }
          },
          16: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 31
            }
          },
          17: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 93
            }
          },
          18: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 20
            }
          },
          19: {
            start: {
              line: 35,
              column: 0
            },
            end: {
              line: 35,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 18
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 10
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 15,
                column: 4
              },
              end: {
                line: 15,
                column: 5
              }
            },
            loc: {
              start: {
                line: 15,
                column: 22
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 15
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 19,
                column: 4
              },
              end: {
                line: 19,
                column: 5
              }
            },
            loc: {
              start: {
                line: 19,
                column: 26
              },
              end: {
                line: 22,
                column: 5
              }
            },
            line: 19
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 23,
                column: 4
              },
              end: {
                line: 23,
                column: 5
              }
            },
            loc: {
              start: {
                line: 23,
                column: 16
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 23
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 21
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 27
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 47
              },
              end: {
                line: 33,
                column: 5
              }
            },
            line: 30
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-properties/table-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-properties\\table-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAGnD,mDAA+C;AAC/C,2DAAsD;AACtD,qEAAoF;AACpF,iDAA8D;AAC9D,+CAAoD;AAEpD,qBAA6B,SAAQ,6BAAY;IAG7C;QACI,KAAK,CAAC,SAAS,CAAC,CAAC;QAEjB,IAAI,CAAC,UAAU,GAAG,IAAI,mCAAe,EAAE,CAAC;QACxC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAEM,QAAQ,CAAC,IAAe,EAAE,CAAkB;QAC/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iCAAmB,CAAC,IAAI,EAAE,CAAC,CAAC,CAAC,CAAC;QACjD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,mBAAmB;QACtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,0BAAW,CAAC,8BAAe,CAAC,KAAK,CAAC,CAAC,CAAC;QACvD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,SAAS;QACZ,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,4BAAY,EAAE,CAAC,CAAC;QACnC,OAAO,IAAI,CAAC;IAChB,CAAC;IAED,IAAW,UAAU;QACjB,OAAO,IAAI,CAAC,UAAU,CAAC;IAC3B,CAAC;IAEM,uBAAuB,CAAC,iBAAqC;QAChE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,6CAAoB,CAAC,iBAAiB,CAAC,CAAC,CAAC;QAC5D,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAjCD,0CAiCC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nimport { WidthType } from "../table-cell";\r\nimport { TableBorders } from "./table-borders";\r\nimport { TableCellMargin } from "./table-cell-margin";\r\nimport { ITableFloatOptions, TableFloatProperties } from "./table-float-properties";\r\nimport { TableLayout, TableLayoutType } from "./table-layout";\r\nimport { PreferredTableWidth } from "./table-width";\r\n\r\nexport class TableProperties extends XmlComponent {\r\n    private readonly cellMargin: TableCellMargin;\r\n\r\n    constructor() {\r\n        super("w:tblPr");\r\n\r\n        this.cellMargin = new TableCellMargin();\r\n        this.root.push(this.cellMargin);\r\n    }\r\n\r\n    public setWidth(type: WidthType, w: number | string): TableProperties {\r\n        this.root.push(new PreferredTableWidth(type, w));\r\n        return this;\r\n    }\r\n\r\n    public setFixedWidthLayout(): TableProperties {\r\n        this.root.push(new TableLayout(TableLayoutType.FIXED));\r\n        return this;\r\n    }\r\n\r\n    public setBorder(): TableProperties {\r\n        this.root.push(new TableBorders());\r\n        return this;\r\n    }\r\n\r\n    public get CellMargin(): TableCellMargin {\r\n        return this.cellMargin;\r\n    }\r\n\r\n    public setTableFloatProperties(tableFloatOptions: ITableFloatOptions): TableProperties {\r\n        this.root.push(new TableFloatProperties(tableFloatOptions));\r\n        return this;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(221)),
          p = (a.s[3]++, t(222)),
          m = (a.s[4]++, t(84)),
          C = (a.s[5]++, t(223)),
          d = (a.s[6]++, t(224));

      var f =
      /*#__PURE__*/
      function (_c$XmlComponent112) {
        _inherits(f, _c$XmlComponent112);

        function f() {
          var _this222;

          _classCallCheck(this, f);

          a.f[0]++, a.s[7]++, _this222 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "w:tblPr")), a.s[8]++, _this222.cellMargin = new p.TableCellMargin(), a.s[9]++, _this222.root.push(_this222.cellMargin);
          return _this222;
        }

        _createClass(f, [{
          key: "setWidth",
          value: function setWidth(e, n) {
            return a.f[1]++, a.s[10]++, this.root.push(new d.PreferredTableWidth(e, n)), a.s[11]++, this;
          }
        }, {
          key: "setFixedWidthLayout",
          value: function setFixedWidthLayout() {
            return a.f[2]++, a.s[12]++, this.root.push(new C.TableLayout(C.TableLayoutType.FIXED)), a.s[13]++, this;
          }
        }, {
          key: "setBorder",
          value: function setBorder() {
            return a.f[3]++, a.s[14]++, this.root.push(new u.TableBorders()), a.s[15]++, this;
          }
        }, {
          key: "setTableFloatProperties",
          value: function setTableFloatProperties(e) {
            return a.f[5]++, a.s[17]++, this.root.push(new m.TableFloatProperties(e)), a.s[18]++, this;
          }
        }, {
          key: "CellMargin",
          get: function get() {
            return a.f[4]++, a.s[16]++, this.cellMargin;
          }
        }]);

        return f;
      }(c.XmlComponent);

      a.s[19]++, n.TableProperties = f;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-borders.ts", o = "1854b5b90904ef748941a81a671a89294cf78a3a", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-borders.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 30
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 81
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 82
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 84
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 83
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 85
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 85
            }
          },
          9: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 36
            }
          },
          10: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 27
            }
          },
          11: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 24,
              column: 12
            }
          },
          12: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 28
            }
          },
          13: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 35,
              column: 10
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 56
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 17
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 28,
                column: 4
              },
              end: {
                line: 28,
                column: 5
              }
            },
            loc: {
              start: {
                line: 28,
                column: 18
              },
              end: {
                line: 36,
                column: 5
              }
            },
            line: 28
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-properties/table-borders.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-properties\\table-borders.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAE1E,kBAA0B,SAAQ,6BAAY;IAC1C;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;QACtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,OAAO,EAAE,QAAQ,EAAE,CAAC,EAAE,CAAC,EAAE,MAAM,CAAC,CAAC,CAAC;QACzE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,QAAQ,EAAE,QAAQ,EAAE,CAAC,EAAE,CAAC,EAAE,MAAM,CAAC,CAAC,CAAC;QAC1E,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,UAAU,EAAE,QAAQ,EAAE,CAAC,EAAE,CAAC,EAAE,MAAM,CAAC,CAAC,CAAC;QAC5E,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,SAAS,EAAE,QAAQ,EAAE,CAAC,EAAE,CAAC,EAAE,MAAM,CAAC,CAAC,CAAC;QAC3E,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,WAAW,EAAE,QAAQ,EAAE,CAAC,EAAE,CAAC,EAAE,MAAM,CAAC,CAAC,CAAC;QAC7E,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,WAAW,EAAE,QAAQ,EAAE,CAAC,EAAE,CAAC,EAAE,MAAM,CAAC,CAAC,CAAC;IACjF,CAAC;CACJ;AAVD,oCAUC;AAED,yBAA0B,SAAQ,6BAAY;IAC1C,YAAY,WAAmB,EAAE,KAAa,EAAE,IAAY,EAAE,KAAa,EAAE,KAAa;QACtF,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,sBAAsB,CAAC;YACvB,KAAK;YACL,IAAI;YACJ,KAAK;YACL,KAAK;SACR,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,4BAA6B,SAAQ,sCAKnC;IALF;;QAMuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,SAAS;YAChB,KAAK,EAAE,SAAS;SACnB,CAAC;IACN,CAAC;CAAA",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport class TableBorders extends XmlComponent {\r\n    constructor() {\r\n        super("w:tblBorders");\r\n        this.root.push(new TableBordersElement("w:top", "single", 4, 0, "auto"));\r\n        this.root.push(new TableBordersElement("w:left", "single", 4, 0, "auto"));\r\n        this.root.push(new TableBordersElement("w:bottom", "single", 4, 0, "auto"));\r\n        this.root.push(new TableBordersElement("w:right", "single", 4, 0, "auto"));\r\n        this.root.push(new TableBordersElement("w:insideH", "single", 4, 0, "auto"));\r\n        this.root.push(new TableBordersElement("w:insideV", "single", 4, 0, "auto"));\r\n    }\r\n}\r\n\r\nclass TableBordersElement extends XmlComponent {\r\n    constructor(elementName: string, value: string, size: number, space: number, color: string) {\r\n        super(elementName);\r\n        this.root.push(\r\n            new TableBordersAttributes({\r\n                value,\r\n                size,\r\n                space,\r\n                color,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nclass TableBordersAttributes extends XmlAttributeComponent<{\r\n    readonly value: string;\r\n    readonly size: number;\r\n    readonly space: number;\r\n    readonly color: string;\r\n}> {\r\n    protected readonly xmlKeys = {\r\n        value: "w:val",\r\n        size: "w:sz",\r\n        space: "w:space",\r\n        color: "w:color",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent113) {
        _inherits(u, _c$XmlComponent113);

        function u() {
          var _this223;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this223 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:tblBorders")), a.s[3]++, _this223.root.push(new p("w:top", "single", 4, 0, "auto")), a.s[4]++, _this223.root.push(new p("w:left", "single", 4, 0, "auto")), a.s[5]++, _this223.root.push(new p("w:bottom", "single", 4, 0, "auto")), a.s[6]++, _this223.root.push(new p("w:right", "single", 4, 0, "auto")), a.s[7]++, _this223.root.push(new p("w:insideH", "single", 4, 0, "auto")), a.s[8]++, _this223.root.push(new p("w:insideV", "single", 4, 0, "auto"));
          return _this223;
        }

        return u;
      }(c.XmlComponent);

      a.s[9]++, n.TableBorders = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent114) {
        _inherits(p, _c$XmlComponent114);

        function p(e, n, t, r, o) {
          var _this224;

          _classCallCheck(this, p);

          a.f[1]++, a.s[10]++, _this224 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, e)), a.s[11]++, _this224.root.push(new m({
            value: n,
            size: t,
            space: r,
            color: o
          }));
          return _this224;
        }

        return p;
      }(c.XmlComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon49) {
        _inherits(m, _c$XmlAttributeCompon49);

        function m() {
          var _this225;

          _classCallCheck(this, m);

          a.f[2]++, a.s[12]++, _this225 = _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments)), a.s[13]++, _this225.xmlKeys = {
            value: "w:val",
            size: "w:sz",
            space: "w:space",
            color: "w:color"
          };
          return _this225;
        }

        return m;
      }(c.XmlAttributeComponent);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-cell-margin.ts", o = "b245e710c338461e80390299f01c6bf2cd911d68", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-cell-margin.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 21
            },
            end: {
              line: 4,
              column: 45
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 54
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 16,
              column: 12
            }
          },
          6: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 30
            }
          },
          7: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 26,
              column: 9
            }
          },
          8: {
            start: {
              line: 25,
              column: 12
            },
            end: {
              line: 25,
              column: 38
            }
          },
          9: {
            start: {
              line: 29,
              column: 20
            },
            end: {
              line: 29,
              column: 52
            }
          },
          10: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 39
            }
          },
          11: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 28
            }
          },
          12: {
            start: {
              line: 34,
              column: 21
            },
            end: {
              line: 34,
              column: 54
            }
          },
          13: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 40
            }
          },
          14: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 29
            }
          },
          15: {
            start: {
              line: 39,
              column: 23
            },
            end: {
              line: 39,
              column: 58
            }
          },
          16: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 42
            }
          },
          17: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 31
            }
          },
          18: {
            start: {
              line: 44,
              column: 22
            },
            end: {
              line: 44,
              column: 56
            }
          },
          19: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 41
            }
          },
          20: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 46,
              column: 30
            }
          },
          21: {
            start: {
              line: 49,
              column: 0
            },
            end: {
              line: 49,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 60
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 12
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 18
              },
              end: {
                line: 22,
                column: 5
              }
            },
            line: 20
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 23,
                column: 4
              },
              end: {
                line: 23,
                column: 5
              }
            },
            loc: {
              start: {
                line: 23,
                column: 17
              },
              end: {
                line: 27,
                column: 5
              }
            },
            line: 23
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 28,
                column: 4
              },
              end: {
                line: 28,
                column: 5
              }
            },
            loc: {
              start: {
                line: 28,
                column: 59
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 28
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 33,
                column: 4
              },
              end: {
                line: 33,
                column: 5
              }
            },
            loc: {
              start: {
                line: 33,
                column: 60
              },
              end: {
                line: 37,
                column: 5
              }
            },
            line: 33
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 38,
                column: 4
              },
              end: {
                line: 38,
                column: 5
              }
            },
            loc: {
              start: {
                line: 38,
                column: 62
              },
              end: {
                line: 42,
                column: 5
              }
            },
            line: 38
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 43,
                column: 4
              },
              end: {
                line: 43,
                column: 5
              }
            },
            loc: {
              start: {
                line: 43,
                column: 61
              },
              end: {
                line: 47,
                column: 5
              }
            },
            line: 43
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 12,
                column: 25
              },
              end: {
                line: 12,
                column: 58
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 12,
                column: 32
              },
              end: {
                line: 12,
                column: 58
              }
            }],
            line: 12
          },
          1: {
            loc: {
              start: {
                line: 24,
                column: 8
              },
              end: {
                line: 26,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 24,
                column: 8
              },
              end: {
                line: 26,
                column: 9
              }
            }, {
              start: {
                line: 24,
                column: 8
              },
              end: {
                line: 26,
                column: 9
              }
            }],
            line: 24
          },
          2: {
            loc: {
              start: {
                line: 28,
                column: 24
              },
              end: {
                line: 28,
                column: 57
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 28,
                column: 31
              },
              end: {
                line: 28,
                column: 57
              }
            }],
            line: 28
          },
          3: {
            loc: {
              start: {
                line: 33,
                column: 25
              },
              end: {
                line: 33,
                column: 58
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 33,
                column: 32
              },
              end: {
                line: 33,
                column: 58
              }
            }],
            line: 33
          },
          4: {
            loc: {
              start: {
                line: 38,
                column: 27
              },
              end: {
                line: 38,
                column: 60
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 38,
                column: 34
              },
              end: {
                line: 38,
                column: 60
              }
            }],
            line: 38
          },
          5: {
            loc: {
              start: {
                line: 43,
                column: 26
              },
              end: {
                line: 43,
                column: 59
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 43,
                column: 33
              },
              end: {
                line: 43,
                column: 59
              }
            }],
            line: 43
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        b: {
          0: [0],
          1: [0, 0],
          2: [0],
          3: [0],
          4: [0],
          5: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-properties/table-cell-margin.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-properties\\table-cell-margin.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0F;AAE1F,8CAA0C;AAE1C,+BAAgC,SAAQ,sCAA2E;IAAnH;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,KAAK,EAAE,IAAI,EAAE,MAAM,EAAE,CAAC;IAChE,CAAC;CAAA;AAED,yBAA0B,SAAQ,6BAAY;IACnC,aAAa,CAAC,KAAa,EAAE,OAAkB,sBAAS,CAAC,GAAG;QAC/D,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,yBAAyB,CAAC;YAC1B,IAAI,EAAE,IAAI;YACV,KAAK,EAAE,KAAK;SACf,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAED,qBAA6B,SAAQ,6BAAY;IAC7C;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;IAC1B,CAAC;IAEM,UAAU;QACb,IAAI,IAAI,CAAC,IAAI,CAAC,MAAM,GAAG,CAAC,EAAE;YACtB,OAAO,KAAK,CAAC,UAAU,EAAE,CAAC;SAC7B;IACL,CAAC;IAEM,YAAY,CAAC,KAAa,EAAE,OAAkB,sBAAS,CAAC,GAAG;QAC9D,MAAM,GAAG,GAAG,IAAI,mBAAmB,CAAC,OAAO,CAAC,CAAC;QAE7C,GAAG,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,CAAC,CAAC;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;IACxB,CAAC;IAEM,aAAa,CAAC,KAAa,EAAE,OAAkB,sBAAS,CAAC,GAAG;QAC/D,MAAM,IAAI,GAAG,IAAI,mBAAmB,CAAC,QAAQ,CAAC,CAAC;QAE/C,IAAI,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,CAAC,CAAC;QAChC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;IACzB,CAAC;IAEM,eAAe,CAAC,KAAa,EAAE,OAAkB,sBAAS,CAAC,GAAG;QACjE,MAAM,MAAM,GAAG,IAAI,mBAAmB,CAAC,UAAU,CAAC,CAAC;QAEnD,MAAM,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,CAAC,CAAC;QAClC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;IAC3B,CAAC;IAEM,cAAc,CAAC,KAAa,EAAE,OAAkB,sBAAS,CAAC,GAAG;QAChE,MAAM,KAAK,GAAG,IAAI,mBAAmB,CAAC,SAAS,CAAC,CAAC;QAEjD,KAAK,CAAC,aAAa,CAAC,KAAK,EAAE,IAAI,CAAC,CAAC;QACjC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AAtCD,0CAsCC",
          sourcesContent: ['import { IXmlableObject, XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nimport { WidthType } from "../table-cell";\r\n\r\nclass TableCellMarginAttributes extends XmlAttributeComponent<{ readonly type: WidthType; readonly value: number }> {\r\n    protected readonly xmlKeys = { value: "w:w", type: "w:sz" };\r\n}\r\n\r\nclass BaseTableCellMargin extends XmlComponent {\r\n    public setProperties(value: number, type: WidthType = WidthType.DXA): void {\r\n        this.root.push(\r\n            new TableCellMarginAttributes({\r\n                type: type,\r\n                value: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\nexport class TableCellMargin extends XmlComponent {\r\n    constructor() {\r\n        super("w:tblCellMar");\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        if (this.root.length > 0) {\r\n            return super.prepForXml();\r\n        }\r\n    }\r\n\r\n    public addTopMargin(value: number, type: WidthType = WidthType.DXA): void {\r\n        const top = new BaseTableCellMargin("w:top");\r\n\r\n        top.setProperties(value, type);\r\n        this.root.push(top);\r\n    }\r\n\r\n    public addLeftMargin(value: number, type: WidthType = WidthType.DXA): void {\r\n        const left = new BaseTableCellMargin("w:left");\r\n\r\n        left.setProperties(value, type);\r\n        this.root.push(left);\r\n    }\r\n\r\n    public addBottomMargin(value: number, type: WidthType = WidthType.DXA): void {\r\n        const bottom = new BaseTableCellMargin("w:bottom");\r\n\r\n        bottom.setProperties(value, type);\r\n        this.root.push(bottom);\r\n    }\r\n\r\n    public addRightMargin(value: number, type: WidthType = WidthType.DXA): void {\r\n        const right = new BaseTableCellMargin("w:right");\r\n\r\n        right.setProperties(value, type);\r\n        this.root.push(right);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(40));

      var p =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon50) {
        _inherits(p, _c$XmlAttributeCompon50);

        function p() {
          var _this226;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this226 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this226.xmlKeys = {
            value: "w:w",
            type: "w:sz"
          };
          return _this226;
        }

        return p;
      }(c.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent115) {
        _inherits(m, _c$XmlComponent115);

        function m() {
          _classCallCheck(this, m);

          return _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments));
        }

        _createClass(m, [{
          key: "setProperties",
          value: function setProperties(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[0][0]++, u.WidthType.DXA);
            a.f[1]++, a.s[5]++, this.root.push(new p({
              type: n,
              value: e
            }));
          }
        }]);

        return m;
      }(c.XmlComponent);

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent116) {
        _inherits(C, _c$XmlComponent116);

        function C() {
          var _this227;

          _classCallCheck(this, C);

          a.f[2]++, a.s[6]++, _this227 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:tblCellMar"));
          return _this227;
        }

        _createClass(C, [{
          key: "prepForXml",
          value: function prepForXml() {
            if (a.f[3]++, a.s[7]++, this.root.length > 0) return a.b[1][0]++, a.s[8]++, _get(_getPrototypeOf(C.prototype), "prepForXml", this).call(this);
            a.b[1][1]++;
          }
        }, {
          key: "addTopMargin",
          value: function addTopMargin(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[2][0]++, u.WidthType.DXA);
            a.f[4]++;
            var t = (a.s[9]++, new m("w:top"));
            a.s[10]++, t.setProperties(e, n), a.s[11]++, this.root.push(t);
          }
        }, {
          key: "addLeftMargin",
          value: function addLeftMargin(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[3][0]++, u.WidthType.DXA);
            a.f[5]++;
            var t = (a.s[12]++, new m("w:left"));
            a.s[13]++, t.setProperties(e, n), a.s[14]++, this.root.push(t);
          }
        }, {
          key: "addBottomMargin",
          value: function addBottomMargin(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[4][0]++, u.WidthType.DXA);
            a.f[6]++;
            var t = (a.s[15]++, new m("w:bottom"));
            a.s[16]++, t.setProperties(e, n), a.s[17]++, this.root.push(t);
          }
        }, {
          key: "addRightMargin",
          value: function addRightMargin(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[5][0]++, u.WidthType.DXA);
            a.f[7]++;
            var t = (a.s[18]++, new m("w:right"));
            a.s[19]++, t.setProperties(e, n), a.s[20]++, this.root.push(t);
          }
        }]);

        return C;
      }(c.XmlComponent);

      a.s[21]++, n.TableCellMargin = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-layout.ts", o = "140bdaa912231445af54d0734f24c4140d445c42", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-layout.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 8,
              column: 80
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 43
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 39
            }
          },
          5: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 28
            }
          },
          6: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 42
            }
          },
          7: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 29
            }
          },
          8: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 60
            }
          },
          9: {
            start: {
              line: 21,
              column: 0
            },
            end: {
              line: 21,
              column: 34
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 28
              },
              end: {
                line: 8,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 10
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 22
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 16
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 8,
                column: 21
              },
              end: {
                line: 8,
                column: 78
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 8,
                column: 21
              },
              end: {
                line: 8,
                column: 44
              }
            }, {
              start: {
                line: 8,
                column: 49
              },
              end: {
                line: 8,
                column: 77
              }
            }],
            line: 8
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-properties/table-layout.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-properties\\table-layout.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAE1E,IAAY,eAGX;AAHD,WAAY,eAAe;IACvB,sCAAmB,CAAA;IACnB,kCAAe,CAAA;AACnB,CAAC,EAHW,eAAe,GAAf,uBAAe,KAAf,uBAAe,QAG1B;AAED,2BAA4B,SAAQ,sCAAyD;IAA7F;;QACuB,YAAO,GAAG,EAAE,IAAI,EAAE,QAAQ,EAAE,CAAC;IACpD,CAAC;CAAA;AAED,iBAAyB,SAAQ,6BAAY;IACzC,YAAY,IAAqB;QAC7B,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,qBAAqB,CAAC,EAAE,IAAI,EAAE,CAAC,CAAC,CAAC;IACxD,CAAC;CACJ;AALD,kCAKC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport enum TableLayoutType {\r\n    AUTOFIT = "autofit",\r\n    FIXED = "fixed",\r\n}\r\n\r\nclass TableLayoutAttributes extends XmlAttributeComponent<{ readonly type: TableLayoutType }> {\r\n    protected readonly xmlKeys = { type: "w:type" };\r\n}\r\n\r\nexport class TableLayout extends XmlComponent {\r\n    constructor(type: TableLayoutType) {\r\n        super("w:tblLayout");\r\n        this.root.push(new TableLayoutAttributes({ type }));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.AUTOFIT = "autofit", a.s[4]++, e.FIXED = "fixed";
      }((a.b[0][0]++, n.TableLayoutType || (a.b[0][1]++, n.TableLayoutType = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon51) {
        _inherits(u, _c$XmlAttributeCompon51);

        function u() {
          var _this228;

          _classCallCheck(this, u);

          a.f[1]++, a.s[5]++, _this228 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[6]++, _this228.xmlKeys = {
            type: "w:type"
          };
          return _this228;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent117) {
        _inherits(p, _c$XmlComponent117);

        function p(e) {
          var _this229;

          _classCallCheck(this, p);

          a.f[2]++, a.s[7]++, _this229 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:tblLayout")), a.s[8]++, _this229.root.push(new u({
            type: e
          }));
          return _this229;
        }

        return p;
      }(c.XmlComponent);

      a.s[9]++, n.TableLayout = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-width.ts", o = "8d1170584e055e7eeff269f9007dc0e04433ae2c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-properties\\table-width.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 52
            }
          },
          4: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 24
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 62
            }
          },
          6: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 50
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 25
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-properties/table-width.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-properties\\table-width.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAS1E,0BAA2B,SAAQ,sCAAkC;IAArE;;QACuB,YAAO,GAAG,EAAE,IAAI,EAAE,QAAQ,EAAE,CAAC,EAAE,KAAK,EAAE,CAAC;IAC9D,CAAC;CAAA;AAED,yBAAiC,SAAQ,6BAAY;IACjD,YAAY,IAAe,EAAE,CAAkB;QAC3C,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAoB,CAAC,EAAE,IAAI,EAAE,CAAC,EAAE,CAAC,CAAC,CAAC;IAC1D,CAAC;CACJ;AALD,kDAKC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nimport { WidthType } from "../table-cell";\r\n\r\ninterface ITableWidth {\r\n    readonly type: WidthType;\r\n    readonly w: number | string;\r\n}\r\n\r\nclass TableWidthAttributes extends XmlAttributeComponent<ITableWidth> {\r\n    protected readonly xmlKeys = { type: "w:type", w: "w:w" };\r\n}\r\n\r\nexport class PreferredTableWidth extends XmlComponent {\r\n    constructor(type: WidthType, w: number | string) {\r\n        super("w:tblW");\r\n        this.root.push(new TableWidthAttributes({ type, w }));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon52) {
        _inherits(u, _c$XmlAttributeCompon52);

        function u() {
          var _this230;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this230 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this230.xmlKeys = {
            type: "w:type",
            w: "w:w"
          };
          return _this230;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent118) {
        _inherits(p, _c$XmlComponent118);

        function p(e, n) {
          var _this231;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this231 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:tblW")), a.s[5]++, _this231.root.push(new u({
            type: e,
            w: n
          }));
          return _this231;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.PreferredTableWidth = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-row\\index.ts", o = "eadef8bdd7e65f71bb1ade6f72400b399b8e70a1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-row\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 33
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-row/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-row\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,iCAA4B;AAC5B,4CAAuC",
          sourcesContent: ['export * from "./table-row";\r\nexport * from "./table-row-properties";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(226)), a.s[5]++, c(t(85));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-row\\table-row.ts", o = "6770915f88235a2a6801b8e2891cdc4d4bed8fc8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table\\table-row\\table-row.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 31
            },
            end: {
              line: 4,
              column: 64
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 22
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 27
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 74
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 40
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 48
            }
          },
          8: {
            start: {
              line: 11,
              column: 29
            },
            end: {
              line: 11,
              column: 46
            }
          },
          9: {
            start: {
              line: 14,
              column: 21
            },
            end: {
              line: 14,
              column: 35
            }
          },
          10: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 17,
              column: 9
            }
          },
          11: {
            start: {
              line: 16,
              column: 12
            },
            end: {
              line: 16,
              column: 78
            }
          },
          12: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 20
            }
          },
          13: {
            start: {
              line: 21,
              column: 27
            },
            end: {
              line: 21,
              column: 44
            }
          },
          14: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 56
            }
          },
          15: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 51
            }
          },
          16: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 50
            }
          },
          17: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 26
            }
          },
          18: {
            start: {
              line: 28,
              column: 25
            },
            end: {
              line: 28,
              column: 50
            }
          },
          19: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 54
            }
          },
          20: {
            start: {
              line: 32,
              column: 0
            },
            end: {
              line: 32,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 23
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 22
              },
              end: {
                line: 11,
                column: 23
              }
            },
            loc: {
              start: {
                line: 11,
                column: 29
              },
              end: {
                line: 11,
                column: 46
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 16
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 13
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 33
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 20
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 37
              },
              end: {
                line: 30,
                column: 5
              }
            },
            line: 27
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            }, {
              start: {
                line: 15,
                column: 8
              },
              end: {
                line: 17,
                column: 9
              }
            }],
            line: 15
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table/table-row/table-row.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table\\table-row\\table-row.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAGnD,iEAA4D;AAE5D,cAAsB,SAAQ,6BAAY;IAGtC,YAA6B,KAAkB;QAC3C,KAAK,CAAC,MAAM,CAAC,CAAC;QADW,UAAK,GAAL,KAAK,CAAa;QAE3C,IAAI,CAAC,UAAU,GAAG,IAAI,yCAAkB,EAAE,CAAC;QAC3C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;QAChC,KAAK,CAAC,OAAO,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC;IAC5C,CAAC;IAEM,OAAO,CAAC,EAAU;QACrB,MAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,EAAE,CAAC,CAAC;QAE5B,IAAI,CAAC,IAAI,EAAE;YACP,MAAM,KAAK,CAAC,oDAAoD,CAAC,CAAC;SACrE;QAED,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW,CAAC,KAAa,EAAE,QAAgB;QAC9C,MAAM,UAAU,GAAG,IAAI,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC;QACrC,UAAU,CAAC,cAAc,CAAC,WAAW,CAAC,QAAQ,CAAC,CAAC;QAChD,IAAI,CAAC,KAAK,CAAC,MAAM,CAAC,KAAK,GAAG,CAAC,EAAE,QAAQ,GAAG,CAAC,CAAC,CAAC;QAC3C,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,KAAK,GAAG,CAAC,EAAE,QAAQ,GAAG,CAAC,CAAC,CAAC;QAE1C,OAAO,UAAU,CAAC;IACtB,CAAC;IAEM,UAAU,CAAC,UAAkB,EAAE,QAAgB;QAClD,MAAM,QAAQ,GAAG,QAAQ,GAAG,UAAU,GAAG,CAAC,CAAC;QAE3C,OAAO,IAAI,CAAC,WAAW,CAAC,UAAU,EAAE,QAAQ,CAAC,CAAC;IAClD,CAAC;CACJ;AAlCD,4BAkCC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nimport { TableCell } from "../table-cell";\r\nimport { TableRowProperties } from "./table-row-properties";\r\n\r\nexport class TableRow extends XmlComponent {\r\n    private readonly properties: TableRowProperties;\r\n\r\n    constructor(private readonly cells: TableCell[]) {\r\n        super("w:tr");\r\n        this.properties = new TableRowProperties();\r\n        this.root.push(this.properties);\r\n        cells.forEach((c) => this.root.push(c));\r\n    }\r\n\r\n    public getCell(ix: number): TableCell {\r\n        const cell = this.cells[ix];\r\n\r\n        if (!cell) {\r\n            throw Error("Index out of bounds when trying to get cell on row");\r\n        }\r\n\r\n        return cell;\r\n    }\r\n\r\n    public addGridSpan(index: number, cellSpan: number): TableCell {\r\n        const remainCell = this.cells[index];\r\n        remainCell.CellProperties.addGridSpan(cellSpan);\r\n        this.cells.splice(index + 1, cellSpan - 1);\r\n        this.root.splice(index + 2, cellSpan - 1);\r\n\r\n        return remainCell;\r\n    }\r\n\r\n    public mergeCells(startIndex: number, endIndex: number): TableCell {\r\n        const cellSpan = endIndex - startIndex + 1;\r\n\r\n        return this.addGridSpan(startIndex, cellSpan);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(85));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent119) {
        _inherits(p, _c$XmlComponent119);

        function p(e) {
          var _this232;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this232 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:tr")), a.s[4]++, _this232.cells = e, a.s[5]++, _this232.properties = new u.TableRowProperties(), a.s[6]++, _this232.root.push(_this232.properties), a.s[7]++, e.forEach(function (e) {
            return a.f[1]++, a.s[8]++, _this232.root.push(e);
          });
          return _this232;
        }

        _createClass(p, [{
          key: "getCell",
          value: function getCell(e) {
            a.f[2]++;
            var n = (a.s[9]++, this.cells[e]);
            if (a.s[10]++, !n) throw a.b[0][0]++, a.s[11]++, Error("Index out of bounds when trying to get cell on row");
            return a.b[0][1]++, a.s[12]++, n;
          }
        }, {
          key: "addGridSpan",
          value: function addGridSpan(e, n) {
            a.f[3]++;
            var t = (a.s[13]++, this.cells[e]);
            return a.s[14]++, t.CellProperties.addGridSpan(n), a.s[15]++, this.cells.splice(e + 1, n - 1), a.s[16]++, this.root.splice(e + 2, n - 1), a.s[17]++, t;
          }
        }, {
          key: "mergeCells",
          value: function mergeCells(e, n) {
            a.f[4]++;
            var t = (a.s[18]++, n - e + 1);
            return a.s[19]++, this.addGridSpan(e, t);
          }
        }]);

        return p;
      }(c.XmlComponent);

      a.s[20]++, n.TableRow = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\file.ts", o = "0914fef2126de05ee7fed5cf8fd760af8a197e47", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\file.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 67
            }
          },
          2: {
            start: {
              line: 4,
              column: 24
            },
            end: {
              line: 4,
              column: 64
            }
          },
          3: {
            start: {
              line: 5,
              column: 26
            },
            end: {
              line: 5,
              column: 54
            }
          },
          4: {
            start: {
              line: 6,
              column: 19
            },
            end: {
              line: 6,
              column: 40
            }
          },
          5: {
            start: {
              line: 7,
              column: 29
            },
            end: {
              line: 7,
              column: 74
            }
          },
          6: {
            start: {
              line: 8,
              column: 25
            },
            end: {
              line: 8,
              column: 52
            }
          },
          7: {
            start: {
              line: 9,
              column: 20
            },
            end: {
              line: 9,
              column: 42
            }
          },
          8: {
            start: {
              line: 10,
              column: 25
            },
            end: {
              line: 10,
              column: 52
            }
          },
          9: {
            start: {
              line: 11,
              column: 16
            },
            end: {
              line: 11,
              column: 34
            }
          },
          10: {
            start: {
              line: 12,
              column: 20
            },
            end: {
              line: 12,
              column: 42
            }
          },
          11: {
            start: {
              line: 13,
              column: 20
            },
            end: {
              line: 13,
              column: 42
            }
          },
          12: {
            start: {
              line: 14,
              column: 24
            },
            end: {
              line: 14,
              column: 50
            }
          },
          13: {
            start: {
              line: 15,
              column: 19
            },
            end: {
              line: 15,
              column: 40
            }
          },
          14: {
            start: {
              line: 16,
              column: 34
            },
            end: {
              line: 16,
              column: 77
            }
          },
          15: {
            start: {
              line: 17,
              column: 18
            },
            end: {
              line: 17,
              column: 45
            }
          },
          16: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 39
            }
          },
          17: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 26
            }
          },
          18: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 26
            }
          },
          19: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 76
            }
          },
          20: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 53
            }
          },
          21: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 68
            }
          },
          22: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 41
            }
          },
          23: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 69
            }
          },
          24: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 66
            }
          },
          25: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 53
            }
          },
          26: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 63
            }
          },
          27: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 37,
              column: 9
            }
          },
          28: {
            start: {
              line: 36,
              column: 12
            },
            end: {
              line: 36,
              column: 91
            }
          },
          29: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 40,
              column: 9
            }
          },
          30: {
            start: {
              line: 39,
              column: 12
            },
            end: {
              line: 39,
              column: 73
            }
          },
          31: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 51,
              column: 9
            }
          },
          32: {
            start: {
              line: 42,
              column: 12
            },
            end: {
              line: 42,
              column: 57
            }
          },
          33: {
            start: {
              line: 44,
              column: 13
            },
            end: {
              line: 51,
              column: 9
            }
          },
          34: {
            start: {
              line: 45,
              column: 34
            },
            end: {
              line: 45,
              column: 87
            }
          },
          35: {
            start: {
              line: 46,
              column: 12
            },
            end: {
              line: 46,
              column: 76
            }
          },
          36: {
            start: {
              line: 49,
              column: 34
            },
            end: {
              line: 49,
              column: 70
            }
          },
          37: {
            start: {
              line: 50,
              column: 12
            },
            end: {
              line: 50,
              column: 54
            }
          },
          38: {
            start: {
              line: 52,
              column: 8
            },
            end: {
              line: 52,
              column: 39
            }
          },
          39: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 60,
              column: 9
            }
          },
          40: {
            start: {
              line: 54,
              column: 12
            },
            end: {
              line: 56,
              column: 13
            }
          },
          41: {
            start: {
              line: 55,
              column: 16
            },
            end: {
              line: 55,
              column: 85
            }
          },
          42: {
            start: {
              line: 59,
              column: 12
            },
            end: {
              line: 59,
              column: 32
            }
          },
          43: {
            start: {
              line: 61,
              column: 8
            },
            end: {
              line: 68,
              column: 9
            }
          },
          44: {
            start: {
              line: 62,
              column: 12
            },
            end: {
              line: 64,
              column: 13
            }
          },
          45: {
            start: {
              line: 63,
              column: 16
            },
            end: {
              line: 63,
              column: 85
            }
          },
          46: {
            start: {
              line: 67,
              column: 12
            },
            end: {
              line: 67,
              column: 32
            }
          },
          47: {
            start: {
              line: 69,
              column: 44
            },
            end: {
              line: 69,
              column: 243
            }
          },
          48: {
            start: {
              line: 70,
              column: 8
            },
            end: {
              line: 70,
              column: 77
            }
          },
          49: {
            start: {
              line: 71,
              column: 8
            },
            end: {
              line: 71,
              column: 50
            }
          },
          50: {
            start: {
              line: 74,
              column: 8
            },
            end: {
              line: 74,
              column: 46
            }
          },
          51: {
            start: {
              line: 77,
              column: 8
            },
            end: {
              line: 77,
              column: 46
            }
          },
          52: {
            start: {
              line: 78,
              column: 8
            },
            end: {
              line: 78,
              column: 20
            }
          },
          53: {
            start: {
              line: 81,
              column: 8
            },
            end: {
              line: 81,
              column: 51
            }
          },
          54: {
            start: {
              line: 84,
              column: 8
            },
            end: {
              line: 84,
              column: 45
            }
          },
          55: {
            start: {
              line: 87,
              column: 8
            },
            end: {
              line: 87,
              column: 53
            }
          },
          56: {
            start: {
              line: 90,
              column: 8
            },
            end: {
              line: 90,
              column: 52
            }
          },
          57: {
            start: {
              line: 91,
              column: 8
            },
            end: {
              line: 91,
              column: 20
            }
          },
          58: {
            start: {
              line: 94,
              column: 22
            },
            end: {
              line: 94,
              column: 89
            }
          },
          59: {
            start: {
              line: 95,
              column: 8
            },
            end: {
              line: 95,
              column: 52
            }
          },
          60: {
            start: {
              line: 96,
              column: 8
            },
            end: {
              line: 96,
              column: 21
            }
          },
          61: {
            start: {
              line: 99,
              column: 24
            },
            end: {
              line: 99,
              column: 56
            }
          },
          62: {
            start: {
              line: 100,
              column: 26
            },
            end: {
              line: 100,
              column: 101
            }
          },
          63: {
            start: {
              line: 101,
              column: 8
            },
            end: {
              line: 101,
              column: 166
            }
          },
          64: {
            start: {
              line: 102,
              column: 8
            },
            end: {
              line: 102,
              column: 25
            }
          },
          65: {
            start: {
              line: 105,
              column: 24
            },
            end: {
              line: 105,
              column: 58
            }
          },
          66: {
            start: {
              line: 106,
              column: 26
            },
            end: {
              line: 106,
              column: 109
            }
          },
          67: {
            start: {
              line: 107,
              column: 8
            },
            end: {
              line: 107,
              column: 25
            }
          },
          68: {
            start: {
              line: 110,
              column: 24
            },
            end: {
              line: 110,
              column: 56
            }
          },
          69: {
            start: {
              line: 111,
              column: 25
            },
            end: {
              line: 111,
              column: 105
            }
          },
          70: {
            start: {
              line: 112,
              column: 8
            },
            end: {
              line: 112,
              column: 24
            }
          },
          71: {
            start: {
              line: 115,
              column: 8
            },
            end: {
              line: 115,
              column: 64
            }
          },
          72: {
            start: {
              line: 118,
              column: 8
            },
            end: {
              line: 118,
              column: 49
            }
          },
          73: {
            start: {
              line: 121,
              column: 23
            },
            end: {
              line: 121,
              column: 99
            }
          },
          74: {
            start: {
              line: 122,
              column: 8
            },
            end: {
              line: 122,
              column: 41
            }
          },
          75: {
            start: {
              line: 123,
              column: 8
            },
            end: {
              line: 123,
              column: 22
            }
          },
          76: {
            start: {
              line: 126,
              column: 23
            },
            end: {
              line: 126,
              column: 99
            }
          },
          77: {
            start: {
              line: 127,
              column: 8
            },
            end: {
              line: 127,
              column: 41
            }
          },
          78: {
            start: {
              line: 128,
              column: 8
            },
            end: {
              line: 128,
              column: 22
            }
          },
          79: {
            start: {
              line: 131,
              column: 30
            },
            end: {
              line: 131,
              column: 49
            }
          },
          80: {
            start: {
              line: 132,
              column: 8
            },
            end: {
              line: 135,
              column: 12
            }
          },
          81: {
            start: {
              line: 136,
              column: 8
            },
            end: {
              line: 136,
              column: 29
            }
          },
          82: {
            start: {
              line: 139,
              column: 30
            },
            end: {
              line: 139,
              column: 49
            }
          },
          83: {
            start: {
              line: 140,
              column: 8
            },
            end: {
              line: 143,
              column: 12
            }
          },
          84: {
            start: {
              line: 144,
              column: 8
            },
            end: {
              line: 144,
              column: 29
            }
          },
          85: {
            start: {
              line: 147,
              column: 30
            },
            end: {
              line: 147,
              column: 49
            }
          },
          86: {
            start: {
              line: 148,
              column: 8
            },
            end: {
              line: 151,
              column: 12
            }
          },
          87: {
            start: {
              line: 152,
              column: 8
            },
            end: {
              line: 152,
              column: 29
            }
          },
          88: {
            start: {
              line: 155,
              column: 30
            },
            end: {
              line: 155,
              column: 49
            }
          },
          89: {
            start: {
              line: 156,
              column: 8
            },
            end: {
              line: 159,
              column: 12
            }
          },
          90: {
            start: {
              line: 160,
              column: 8
            },
            end: {
              line: 160,
              column: 29
            }
          },
          91: {
            start: {
              line: 163,
              column: 22
            },
            end: {
              line: 163,
              column: 105
            }
          },
          92: {
            start: {
              line: 163,
              column: 49
            },
            end: {
              line: 163,
              column: 60
            }
          },
          93: {
            start: {
              line: 163,
              column: 74
            },
            end: {
              line: 163,
              column: 104
            }
          },
          94: {
            start: {
              line: 164,
              column: 8
            },
            end: {
              line: 166,
              column: 9
            }
          },
          95: {
            start: {
              line: 165,
              column: 12
            },
            end: {
              line: 165,
              column: 25
            }
          },
          96: {
            start: {
              line: 167,
              column: 8
            },
            end: {
              line: 167,
              column: 79
            }
          },
          97: {
            start: {
              line: 170,
              column: 22
            },
            end: {
              line: 170,
              column: 105
            }
          },
          98: {
            start: {
              line: 170,
              column: 49
            },
            end: {
              line: 170,
              column: 60
            }
          },
          99: {
            start: {
              line: 170,
              column: 74
            },
            end: {
              line: 170,
              column: 104
            }
          },
          100: {
            start: {
              line: 171,
              column: 8
            },
            end: {
              line: 173,
              column: 9
            }
          },
          101: {
            start: {
              line: 172,
              column: 12
            },
            end: {
              line: 172,
              column: 25
            }
          },
          102: {
            start: {
              line: 174,
              column: 8
            },
            end: {
              line: 174,
              column: 79
            }
          },
          103: {
            start: {
              line: 177,
              column: 8
            },
            end: {
              line: 179,
              column: 9
            }
          },
          104: {
            start: {
              line: 178,
              column: 12
            },
            end: {
              line: 178,
              column: 44
            }
          },
          105: {
            start: {
              line: 182,
              column: 8
            },
            end: {
              line: 182,
              column: 44
            }
          },
          106: {
            start: {
              line: 183,
              column: 8
            },
            end: {
              line: 183,
              column: 190
            }
          },
          107: {
            start: {
              line: 184,
              column: 8
            },
            end: {
              line: 184,
              column: 57
            }
          },
          108: {
            start: {
              line: 187,
              column: 8
            },
            end: {
              line: 187,
              column: 44
            }
          },
          109: {
            start: {
              line: 188,
              column: 8
            },
            end: {
              line: 188,
              column: 190
            }
          },
          110: {
            start: {
              line: 189,
              column: 8
            },
            end: {
              line: 189,
              column: 57
            }
          },
          111: {
            start: {
              line: 192,
              column: 8
            },
            end: {
              line: 192,
              column: 160
            }
          },
          112: {
            start: {
              line: 193,
              column: 8
            },
            end: {
              line: 193,
              column: 163
            }
          },
          113: {
            start: {
              line: 194,
              column: 8
            },
            end: {
              line: 194,
              column: 164
            }
          },
          114: {
            start: {
              line: 195,
              column: 8
            },
            end: {
              line: 195,
              column: 171
            }
          },
          115: {
            start: {
              line: 196,
              column: 8
            },
            end: {
              line: 196,
              column: 177
            }
          },
          116: {
            start: {
              line: 197,
              column: 8
            },
            end: {
              line: 197,
              column: 177
            }
          },
          117: {
            start: {
              line: 200,
              column: 23
            },
            end: {
              line: 200,
              column: 28
            }
          },
          118: {
            start: {
              line: 201,
              column: 8
            },
            end: {
              line: 216,
              column: 9
            }
          },
          119: {
            start: {
              line: 202,
              column: 12
            },
            end: {
              line: 215,
              column: 13
            }
          },
          120: {
            start: {
              line: 204,
              column: 20
            },
            end: {
              line: 204,
              column: 87
            }
          },
          121: {
            start: {
              line: 205,
              column: 20
            },
            end: {
              line: 205,
              column: 26
            }
          },
          122: {
            start: {
              line: 207,
              column: 20
            },
            end: {
              line: 207,
              column: 85
            }
          },
          123: {
            start: {
              line: 208,
              column: 20
            },
            end: {
              line: 208,
              column: 26
            }
          },
          124: {
            start: {
              line: 210,
              column: 20
            },
            end: {
              line: 210,
              column: 84
            }
          },
          125: {
            start: {
              line: 211,
              column: 20
            },
            end: {
              line: 211,
              column: 26
            }
          },
          126: {
            start: {
              line: 213,
              column: 20
            },
            end: {
              line: 213,
              column: 87
            }
          },
          127: {
            start: {
              line: 214,
              column: 20
            },
            end: {
              line: 214,
              column: 26
            }
          },
          128: {
            start: {
              line: 217,
              column: 8
            },
            end: {
              line: 217,
              column: 24
            }
          },
          129: {
            start: {
              line: 220,
              column: 23
            },
            end: {
              line: 220,
              column: 28
            }
          },
          130: {
            start: {
              line: 221,
              column: 8
            },
            end: {
              line: 236,
              column: 9
            }
          },
          131: {
            start: {
              line: 222,
              column: 12
            },
            end: {
              line: 235,
              column: 13
            }
          },
          132: {
            start: {
              line: 224,
              column: 20
            },
            end: {
              line: 224,
              column: 87
            }
          },
          133: {
            start: {
              line: 225,
              column: 20
            },
            end: {
              line: 225,
              column: 26
            }
          },
          134: {
            start: {
              line: 227,
              column: 20
            },
            end: {
              line: 227,
              column: 85
            }
          },
          135: {
            start: {
              line: 228,
              column: 20
            },
            end: {
              line: 228,
              column: 26
            }
          },
          136: {
            start: {
              line: 230,
              column: 20
            },
            end: {
              line: 230,
              column: 84
            }
          },
          137: {
            start: {
              line: 231,
              column: 20
            },
            end: {
              line: 231,
              column: 26
            }
          },
          138: {
            start: {
              line: 233,
              column: 20
            },
            end: {
              line: 233,
              column: 87
            }
          },
          139: {
            start: {
              line: 234,
              column: 20
            },
            end: {
              line: 234,
              column: 26
            }
          },
          140: {
            start: {
              line: 237,
              column: 8
            },
            end: {
              line: 237,
              column: 24
            }
          },
          141: {
            start: {
              line: 240,
              column: 8
            },
            end: {
              line: 240,
              column: 29
            }
          },
          142: {
            start: {
              line: 243,
              column: 8
            },
            end: {
              line: 243,
              column: 27
            }
          },
          143: {
            start: {
              line: 246,
              column: 8
            },
            end: {
              line: 246,
              column: 29
            }
          },
          144: {
            start: {
              line: 249,
              column: 8
            },
            end: {
              line: 249,
              column: 35
            }
          },
          145: {
            start: {
              line: 252,
              column: 8
            },
            end: {
              line: 252,
              column: 30
            }
          },
          146: {
            start: {
              line: 255,
              column: 8
            },
            end: {
              line: 255,
              column: 26
            }
          },
          147: {
            start: {
              line: 258,
              column: 8
            },
            end: {
              line: 258,
              column: 37
            }
          },
          148: {
            start: {
              line: 261,
              column: 8
            },
            end: {
              line: 261,
              column: 38
            }
          },
          149: {
            start: {
              line: 264,
              column: 8
            },
            end: {
              line: 264,
              column: 38
            }
          },
          150: {
            start: {
              line: 267,
              column: 8
            },
            end: {
              line: 267,
              column: 55
            }
          },
          151: {
            start: {
              line: 267,
              column: 42
            },
            end: {
              line: 267,
              column: 53
            }
          },
          152: {
            start: {
              line: 270,
              column: 8
            },
            end: {
              line: 270,
              column: 38
            }
          },
          153: {
            start: {
              line: 273,
              column: 8
            },
            end: {
              line: 273,
              column: 55
            }
          },
          154: {
            start: {
              line: 273,
              column: 42
            },
            end: {
              line: 273,
              column: 53
            }
          },
          155: {
            start: {
              line: 276,
              column: 8
            },
            end: {
              line: 276,
              column: 33
            }
          },
          156: {
            start: {
              line: 279,
              column: 8
            },
            end: {
              line: 279,
              column: 34
            }
          },
          157: {
            start: {
              line: 282,
              column: 8
            },
            end: {
              line: 282,
              column: 30
            }
          },
          158: {
            start: {
              line: 285,
              column: 8
            },
            end: {
              line: 285,
              column: 29
            }
          },
          159: {
            start: {
              line: 288,
              column: 0
            },
            end: {
              line: 288,
              column: 20
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 19,
                column: 4
              },
              end: {
                line: 19,
                column: 5
              }
            },
            loc: {
              start: {
                line: 23,
                column: 59
              },
              end: {
                line: 72,
                column: 5
              }
            },
            line: 23
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 73,
                column: 4
              },
              end: {
                line: 73,
                column: 5
              }
            },
            loc: {
              start: {
                line: 73,
                column: 28
              },
              end: {
                line: 75,
                column: 5
              }
            },
            line: 73
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 76,
                column: 4
              },
              end: {
                line: 76,
                column: 5
              }
            },
            loc: {
              start: {
                line: 76,
                column: 28
              },
              end: {
                line: 79,
                column: 5
              }
            },
            line: 76
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 80,
                column: 4
              },
              end: {
                line: 80,
                column: 5
              }
            },
            loc: {
              start: {
                line: 80,
                column: 26
              },
              end: {
                line: 82,
                column: 5
              }
            },
            line: 80
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 83,
                column: 4
              },
              end: {
                line: 83,
                column: 5
              }
            },
            loc: {
              start: {
                line: 83,
                column: 20
              },
              end: {
                line: 85,
                column: 5
              }
            },
            line: 83
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 86,
                column: 4
              },
              end: {
                line: 86,
                column: 5
              }
            },
            loc: {
              start: {
                line: 86,
                column: 28
              },
              end: {
                line: 88,
                column: 5
              }
            },
            line: 86
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 89,
                column: 4
              },
              end: {
                line: 89,
                column: 5
              }
            },
            loc: {
              start: {
                line: 89,
                column: 20
              },
              end: {
                line: 92,
                column: 5
              }
            },
            line: 89
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 93,
                column: 4
              },
              end: {
                line: 93,
                column: 5
              }
            },
            loc: {
              start: {
                line: 93,
                column: 55
              },
              end: {
                line: 97,
                column: 5
              }
            },
            line: 93
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 98,
                column: 4
              },
              end: {
                line: 98,
                column: 5
              }
            },
            loc: {
              start: {
                line: 98,
                column: 32
              },
              end: {
                line: 103,
                column: 5
              }
            },
            line: 98
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 104,
                column: 4
              },
              end: {
                line: 104,
                column: 5
              }
            },
            loc: {
              start: {
                line: 104,
                column: 42
              },
              end: {
                line: 108,
                column: 5
              }
            },
            line: 104
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 109,
                column: 4
              },
              end: {
                line: 109,
                column: 5
              }
            },
            loc: {
              start: {
                line: 109,
                column: 31
              },
              end: {
                line: 113,
                column: 5
              }
            },
            line: 109
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 114,
                column: 4
              },
              end: {
                line: 114,
                column: 5
              }
            },
            loc: {
              start: {
                line: 114,
                column: 41
              },
              end: {
                line: 116,
                column: 5
              }
            },
            line: 114
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 117,
                column: 4
              },
              end: {
                line: 117,
                column: 5
              }
            },
            loc: {
              start: {
                line: 117,
                column: 30
              },
              end: {
                line: 119,
                column: 5
              }
            },
            line: 117
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 120,
                column: 4
              },
              end: {
                line: 120,
                column: 5
              }
            },
            loc: {
              start: {
                line: 120,
                column: 19
              },
              end: {
                line: 124,
                column: 5
              }
            },
            line: 120
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 125,
                column: 4
              },
              end: {
                line: 125,
                column: 5
              }
            },
            loc: {
              start: {
                line: 125,
                column: 19
              },
              end: {
                line: 129,
                column: 5
              }
            },
            line: 125
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 130,
                column: 4
              },
              end: {
                line: 130,
                column: 5
              }
            },
            loc: {
              start: {
                line: 130,
                column: 28
              },
              end: {
                line: 137,
                column: 5
              }
            },
            line: 130
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 138,
                column: 4
              },
              end: {
                line: 138,
                column: 5
              }
            },
            loc: {
              start: {
                line: 138,
                column: 27
              },
              end: {
                line: 145,
                column: 5
              }
            },
            line: 138
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 146,
                column: 4
              },
              end: {
                line: 146,
                column: 5
              }
            },
            loc: {
              start: {
                line: 146,
                column: 28
              },
              end: {
                line: 153,
                column: 5
              }
            },
            line: 146
          },
          18: {
            name: "(anonymous_18)",
            decl: {
              start: {
                line: 154,
                column: 4
              },
              end: {
                line: 154,
                column: 5
              }
            },
            loc: {
              start: {
                line: 154,
                column: 27
              },
              end: {
                line: 161,
                column: 5
              }
            },
            line: 154
          },
          19: {
            name: "(anonymous_19)",
            decl: {
              start: {
                line: 162,
                column: 4
              },
              end: {
                line: 162,
                column: 5
              }
            },
            loc: {
              start: {
                line: 162,
                column: 38
              },
              end: {
                line: 168,
                column: 5
              }
            },
            line: 162
          },
          20: {
            name: "(anonymous_20)",
            decl: {
              start: {
                line: 163,
                column: 39
              },
              end: {
                line: 163,
                column: 40
              }
            },
            loc: {
              start: {
                line: 163,
                column: 49
              },
              end: {
                line: 163,
                column: 60
              }
            },
            line: 163
          },
          21: {
            name: "(anonymous_21)",
            decl: {
              start: {
                line: 163,
                column: 67
              },
              end: {
                line: 163,
                column: 68
              }
            },
            loc: {
              start: {
                line: 163,
                column: 74
              },
              end: {
                line: 163,
                column: 104
              }
            },
            line: 163
          },
          22: {
            name: "(anonymous_22)",
            decl: {
              start: {
                line: 169,
                column: 4
              },
              end: {
                line: 169,
                column: 5
              }
            },
            loc: {
              start: {
                line: 169,
                column: 38
              },
              end: {
                line: 175,
                column: 5
              }
            },
            line: 169
          },
          23: {
            name: "(anonymous_23)",
            decl: {
              start: {
                line: 170,
                column: 39
              },
              end: {
                line: 170,
                column: 40
              }
            },
            loc: {
              start: {
                line: 170,
                column: 49
              },
              end: {
                line: 170,
                column: 60
              }
            },
            line: 170
          },
          24: {
            name: "(anonymous_24)",
            decl: {
              start: {
                line: 170,
                column: 67
              },
              end: {
                line: 170,
                column: 68
              }
            },
            loc: {
              start: {
                line: 170,
                column: 74
              },
              end: {
                line: 170,
                column: 104
              }
            },
            line: 170
          },
          25: {
            name: "(anonymous_25)",
            decl: {
              start: {
                line: 176,
                column: 4
              },
              end: {
                line: 176,
                column: 5
              }
            },
            loc: {
              start: {
                line: 176,
                column: 25
              },
              end: {
                line: 180,
                column: 5
              }
            },
            line: 176
          },
          26: {
            name: "(anonymous_26)",
            decl: {
              start: {
                line: 181,
                column: 4
              },
              end: {
                line: 181,
                column: 5
              }
            },
            loc: {
              start: {
                line: 181,
                column: 89
              },
              end: {
                line: 185,
                column: 5
              }
            },
            line: 181
          },
          27: {
            name: "(anonymous_27)",
            decl: {
              start: {
                line: 186,
                column: 4
              },
              end: {
                line: 186,
                column: 5
              }
            },
            loc: {
              start: {
                line: 186,
                column: 89
              },
              end: {
                line: 190,
                column: 5
              }
            },
            line: 186
          },
          28: {
            name: "(anonymous_28)",
            decl: {
              start: {
                line: 191,
                column: 4
              },
              end: {
                line: 191,
                column: 5
              }
            },
            loc: {
              start: {
                line: 191,
                column: 30
              },
              end: {
                line: 198,
                column: 5
              }
            },
            line: 191
          },
          29: {
            name: "(anonymous_29)",
            decl: {
              start: {
                line: 199,
                column: 4
              },
              end: {
                line: 199,
                column: 5
              }
            },
            loc: {
              start: {
                line: 199,
                column: 38
              },
              end: {
                line: 218,
                column: 5
              }
            },
            line: 199
          },
          30: {
            name: "(anonymous_30)",
            decl: {
              start: {
                line: 219,
                column: 4
              },
              end: {
                line: 219,
                column: 5
              }
            },
            loc: {
              start: {
                line: 219,
                column: 38
              },
              end: {
                line: 238,
                column: 5
              }
            },
            line: 219
          },
          31: {
            name: "(anonymous_31)",
            decl: {
              start: {
                line: 239,
                column: 4
              },
              end: {
                line: 239,
                column: 5
              }
            },
            loc: {
              start: {
                line: 239,
                column: 19
              },
              end: {
                line: 241,
                column: 5
              }
            },
            line: 239
          },
          32: {
            name: "(anonymous_32)",
            decl: {
              start: {
                line: 242,
                column: 4
              },
              end: {
                line: 242,
                column: 5
              }
            },
            loc: {
              start: {
                line: 242,
                column: 17
              },
              end: {
                line: 244,
                column: 5
              }
            },
            line: 242
          },
          33: {
            name: "(anonymous_33)",
            decl: {
              start: {
                line: 245,
                column: 4
              },
              end: {
                line: 245,
                column: 5
              }
            },
            loc: {
              start: {
                line: 245,
                column: 23
              },
              end: {
                line: 247,
                column: 5
              }
            },
            line: 245
          },
          34: {
            name: "(anonymous_34)",
            decl: {
              start: {
                line: 248,
                column: 4
              },
              end: {
                line: 248,
                column: 5
              }
            },
            loc: {
              start: {
                line: 248,
                column: 25
              },
              end: {
                line: 250,
                column: 5
              }
            },
            line: 248
          },
          35: {
            name: "(anonymous_35)",
            decl: {
              start: {
                line: 251,
                column: 4
              },
              end: {
                line: 251,
                column: 5
              }
            },
            loc: {
              start: {
                line: 251,
                column: 20
              },
              end: {
                line: 253,
                column: 5
              }
            },
            line: 251
          },
          36: {
            name: "(anonymous_36)",
            decl: {
              start: {
                line: 254,
                column: 4
              },
              end: {
                line: 254,
                column: 5
              }
            },
            loc: {
              start: {
                line: 254,
                column: 16
              },
              end: {
                line: 256,
                column: 5
              }
            },
            line: 254
          },
          37: {
            name: "(anonymous_37)",
            decl: {
              start: {
                line: 257,
                column: 4
              },
              end: {
                line: 257,
                column: 5
              }
            },
            loc: {
              start: {
                line: 257,
                column: 32
              },
              end: {
                line: 259,
                column: 5
              }
            },
            line: 257
          },
          38: {
            name: "(anonymous_38)",
            decl: {
              start: {
                line: 260,
                column: 4
              },
              end: {
                line: 260,
                column: 5
              }
            },
            loc: {
              start: {
                line: 260,
                column: 28
              },
              end: {
                line: 262,
                column: 5
              }
            },
            line: 260
          },
          39: {
            name: "(anonymous_39)",
            decl: {
              start: {
                line: 263,
                column: 4
              },
              end: {
                line: 263,
                column: 5
              }
            },
            loc: {
              start: {
                line: 263,
                column: 17
              },
              end: {
                line: 265,
                column: 5
              }
            },
            line: 263
          },
          40: {
            name: "(anonymous_40)",
            decl: {
              start: {
                line: 266,
                column: 4
              },
              end: {
                line: 266,
                column: 5
              }
            },
            loc: {
              start: {
                line: 266,
                column: 18
              },
              end: {
                line: 268,
                column: 5
              }
            },
            line: 266
          },
          41: {
            name: "(anonymous_41)",
            decl: {
              start: {
                line: 267,
                column: 32
              },
              end: {
                line: 267,
                column: 33
              }
            },
            loc: {
              start: {
                line: 267,
                column: 42
              },
              end: {
                line: 267,
                column: 53
              }
            },
            line: 267
          },
          42: {
            name: "(anonymous_42)",
            decl: {
              start: {
                line: 269,
                column: 4
              },
              end: {
                line: 269,
                column: 5
              }
            },
            loc: {
              start: {
                line: 269,
                column: 17
              },
              end: {
                line: 271,
                column: 5
              }
            },
            line: 269
          },
          43: {
            name: "(anonymous_43)",
            decl: {
              start: {
                line: 272,
                column: 4
              },
              end: {
                line: 272,
                column: 5
              }
            },
            loc: {
              start: {
                line: 272,
                column: 18
              },
              end: {
                line: 274,
                column: 5
              }
            },
            line: 272
          },
          44: {
            name: "(anonymous_44)",
            decl: {
              start: {
                line: 273,
                column: 32
              },
              end: {
                line: 273,
                column: 33
              }
            },
            loc: {
              start: {
                line: 273,
                column: 42
              },
              end: {
                line: 273,
                column: 53
              }
            },
            line: 273
          },
          45: {
            name: "(anonymous_45)",
            decl: {
              start: {
                line: 275,
                column: 4
              },
              end: {
                line: 275,
                column: 5
              }
            },
            loc: {
              start: {
                line: 275,
                column: 23
              },
              end: {
                line: 277,
                column: 5
              }
            },
            line: 275
          },
          46: {
            name: "(anonymous_46)",
            decl: {
              start: {
                line: 278,
                column: 4
              },
              end: {
                line: 278,
                column: 5
              }
            },
            loc: {
              start: {
                line: 278,
                column: 24
              },
              end: {
                line: 280,
                column: 5
              }
            },
            line: 278
          },
          47: {
            name: "(anonymous_47)",
            decl: {
              start: {
                line: 281,
                column: 4
              },
              end: {
                line: 281,
                column: 5
              }
            },
            loc: {
              start: {
                line: 281,
                column: 20
              },
              end: {
                line: 283,
                column: 5
              }
            },
            line: 281
          },
          48: {
            name: "(anonymous_48)",
            decl: {
              start: {
                line: 284,
                column: 4
              },
              end: {
                line: 284,
                column: 5
              }
            },
            loc: {
              start: {
                line: 284,
                column: 19
              },
              end: {
                line: 286,
                column: 5
              }
            },
            line: 284
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 19,
                column: 16
              },
              end: {
                line: 23,
                column: 5
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 19,
                column: 26
              },
              end: {
                line: 23,
                column: 5
              }
            }],
            line: 19
          },
          1: {
            loc: {
              start: {
                line: 23,
                column: 7
              },
              end: {
                line: 23,
                column: 36
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 23,
                column: 34
              },
              end: {
                line: 23,
                column: 36
              }
            }],
            line: 23
          },
          2: {
            loc: {
              start: {
                line: 23,
                column: 38
              },
              end: {
                line: 23,
                column: 57
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 23,
                column: 55
              },
              end: {
                line: 23,
                column: 57
              }
            }],
            line: 23
          },
          3: {
            loc: {
              start: {
                line: 35,
                column: 8
              },
              end: {
                line: 37,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 35,
                column: 8
              },
              end: {
                line: 37,
                column: 9
              }
            }, {
              start: {
                line: 35,
                column: 8
              },
              end: {
                line: 37,
                column: 9
              }
            }],
            line: 35
          },
          4: {
            loc: {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }, {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }],
            line: 38
          },
          5: {
            loc: {
              start: {
                line: 38,
                column: 12
              },
              end: {
                line: 38,
                column: 61
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 38,
                column: 12
              },
              end: {
                line: 38,
                column: 35
              }
            }, {
              start: {
                line: 38,
                column: 39
              },
              end: {
                line: 38,
                column: 61
              }
            }],
            line: 38
          },
          6: {
            loc: {
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 51,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 51,
                column: 9
              }
            }, {
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 51,
                column: 9
              }
            }],
            line: 41
          },
          7: {
            loc: {
              start: {
                line: 44,
                column: 13
              },
              end: {
                line: 51,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 44,
                column: 13
              },
              end: {
                line: 51,
                column: 9
              }
            }, {
              start: {
                line: 44,
                column: 13
              },
              end: {
                line: 51,
                column: 9
              }
            }],
            line: 44
          },
          8: {
            loc: {
              start: {
                line: 53,
                column: 8
              },
              end: {
                line: 60,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 53,
                column: 8
              },
              end: {
                line: 60,
                column: 9
              }
            }, {
              start: {
                line: 53,
                column: 8
              },
              end: {
                line: 60,
                column: 9
              }
            }],
            line: 53
          },
          9: {
            loc: {
              start: {
                line: 53,
                column: 12
              },
              end: {
                line: 53,
                column: 70
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 53,
                column: 12
              },
              end: {
                line: 53,
                column: 35
              }
            }, {
              start: {
                line: 53,
                column: 39
              },
              end: {
                line: 53,
                column: 70
              }
            }],
            line: 53
          },
          10: {
            loc: {
              start: {
                line: 61,
                column: 8
              },
              end: {
                line: 68,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 61,
                column: 8
              },
              end: {
                line: 68,
                column: 9
              }
            }, {
              start: {
                line: 61,
                column: 8
              },
              end: {
                line: 68,
                column: 9
              }
            }],
            line: 61
          },
          11: {
            loc: {
              start: {
                line: 61,
                column: 12
              },
              end: {
                line: 61,
                column: 70
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 61,
                column: 12
              },
              end: {
                line: 61,
                column: 35
              }
            }, {
              start: {
                line: 61,
                column: 39
              },
              end: {
                line: 61,
                column: 70
              }
            }],
            line: 61
          },
          12: {
            loc: {
              start: {
                line: 99,
                column: 24
              },
              end: {
                line: 99,
                column: 56
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 99,
                column: 45
              },
              end: {
                line: 99,
                column: 49
              }
            }, {
              start: {
                line: 99,
                column: 52
              },
              end: {
                line: 99,
                column: 56
              }
            }],
            line: 99
          },
          13: {
            loc: {
              start: {
                line: 105,
                column: 24
              },
              end: {
                line: 105,
                column: 58
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 105,
                column: 45
              },
              end: {
                line: 105,
                column: 51
              }
            }, {
              start: {
                line: 105,
                column: 54
              },
              end: {
                line: 105,
                column: 58
              }
            }],
            line: 105
          },
          14: {
            loc: {
              start: {
                line: 110,
                column: 24
              },
              end: {
                line: 110,
                column: 56
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 110,
                column: 45
              },
              end: {
                line: 110,
                column: 49
              }
            }, {
              start: {
                line: 110,
                column: 52
              },
              end: {
                line: 110,
                column: 56
              }
            }],
            line: 110
          },
          15: {
            loc: {
              start: {
                line: 164,
                column: 8
              },
              end: {
                line: 166,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 164,
                column: 8
              },
              end: {
                line: 166,
                column: 9
              }
            }, {
              start: {
                line: 164,
                column: 8
              },
              end: {
                line: 166,
                column: 9
              }
            }],
            line: 164
          },
          16: {
            loc: {
              start: {
                line: 171,
                column: 8
              },
              end: {
                line: 173,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 171,
                column: 8
              },
              end: {
                line: 173,
                column: 9
              }
            }, {
              start: {
                line: 171,
                column: 8
              },
              end: {
                line: 173,
                column: 9
              }
            }],
            line: 171
          },
          17: {
            loc: {
              start: {
                line: 177,
                column: 8
              },
              end: {
                line: 179,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 177,
                column: 8
              },
              end: {
                line: 179,
                column: 9
              }
            }, {
              start: {
                line: 177,
                column: 8
              },
              end: {
                line: 179,
                column: 9
              }
            }],
            line: 177
          },
          18: {
            loc: {
              start: {
                line: 181,
                column: 32
              },
              end: {
                line: 181,
                column: 87
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 181,
                column: 39
              },
              end: {
                line: 181,
                column: 87
              }
            }],
            line: 181
          },
          19: {
            loc: {
              start: {
                line: 186,
                column: 32
              },
              end: {
                line: 186,
                column: 87
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 186,
                column: 39
              },
              end: {
                line: 186,
                column: 87
              }
            }],
            line: 186
          },
          20: {
            loc: {
              start: {
                line: 199,
                column: 26
              },
              end: {
                line: 199,
                column: 36
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 199,
                column: 34
              },
              end: {
                line: 199,
                column: 36
              }
            }],
            line: 199
          },
          21: {
            loc: {
              start: {
                line: 202,
                column: 12
              },
              end: {
                line: 215,
                column: 13
              }
            },
            type: "switch",
            locations: [{
              start: {
                line: 203,
                column: 16
              },
              end: {
                line: 205,
                column: 26
              }
            }, {
              start: {
                line: 206,
                column: 16
              },
              end: {
                line: 208,
                column: 26
              }
            }, {
              start: {
                line: 209,
                column: 16
              },
              end: {
                line: 211,
                column: 26
              }
            }, {
              start: {
                line: 212,
                column: 16
              },
              end: {
                line: 214,
                column: 26
              }
            }],
            line: 202
          },
          22: {
            loc: {
              start: {
                line: 219,
                column: 26
              },
              end: {
                line: 219,
                column: 36
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 219,
                column: 34
              },
              end: {
                line: 219,
                column: 36
              }
            }],
            line: 219
          },
          23: {
            loc: {
              start: {
                line: 222,
                column: 12
              },
              end: {
                line: 235,
                column: 13
              }
            },
            type: "switch",
            locations: [{
              start: {
                line: 223,
                column: 16
              },
              end: {
                line: 225,
                column: 26
              }
            }, {
              start: {
                line: 226,
                column: 16
              },
              end: {
                line: 228,
                column: 26
              }
            }, {
              start: {
                line: 229,
                column: 16
              },
              end: {
                line: 231,
                column: 26
              }
            }, {
              start: {
                line: 232,
                column: 16
              },
              end: {
                line: 234,
                column: 26
              }
            }],
            line: 222
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0,
          64: 0,
          65: 0,
          66: 0,
          67: 0,
          68: 0,
          69: 0,
          70: 0,
          71: 0,
          72: 0,
          73: 0,
          74: 0,
          75: 0,
          76: 0,
          77: 0,
          78: 0,
          79: 0,
          80: 0,
          81: 0,
          82: 0,
          83: 0,
          84: 0,
          85: 0,
          86: 0,
          87: 0,
          88: 0,
          89: 0,
          90: 0,
          91: 0,
          92: 0,
          93: 0,
          94: 0,
          95: 0,
          96: 0,
          97: 0,
          98: 0,
          99: 0,
          100: 0,
          101: 0,
          102: 0,
          103: 0,
          104: 0,
          105: 0,
          106: 0,
          107: 0,
          108: 0,
          109: 0,
          110: 0,
          111: 0,
          112: 0,
          113: 0,
          114: 0,
          115: 0,
          116: 0,
          117: 0,
          118: 0,
          119: 0,
          120: 0,
          121: 0,
          122: 0,
          123: 0,
          124: 0,
          125: 0,
          126: 0,
          127: 0,
          128: 0,
          129: 0,
          130: 0,
          131: 0,
          132: 0,
          133: 0,
          134: 0,
          135: 0,
          136: 0,
          137: 0,
          138: 0,
          139: 0,
          140: 0,
          141: 0,
          142: 0,
          143: 0,
          144: 0,
          145: 0,
          146: 0,
          147: 0,
          148: 0,
          149: 0,
          150: 0,
          151: 0,
          152: 0,
          153: 0,
          154: 0,
          155: 0,
          156: 0,
          157: 0,
          158: 0,
          159: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0
        },
        b: {
          0: [0],
          1: [0],
          2: [0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0],
          6: [0, 0],
          7: [0, 0],
          8: [0, 0],
          9: [0, 0],
          10: [0, 0],
          11: [0, 0],
          12: [0, 0],
          13: [0, 0],
          14: [0, 0],
          15: [0, 0],
          16: [0, 0],
          17: [0, 0],
          18: [0],
          19: [0],
          20: [0],
          21: [0, 0, 0, 0],
          22: [0],
          23: [0, 0, 0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/file.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\file.ts"],
          names: [],
          mappings: ";;AAAA,oEAAgE;AAChE,iEAA6D;AAC7D,uDAAuE;AACvE,yCAAsC;AACtC,2EAO4C;AAG5C,qDAAkE;AAClE,2CAAwC;AACxC,qDAAkE;AAClE,mCAAuC;AACvC,2CAAwC;AACxC,2CAA6D;AAC7D,mDAAgD;AAChD,yCAAsC;AAEtC,8EAAyE;AACzE,8CAAwD;AAIxD;IAmBI,YACI,UAA8B;QAC1B,OAAO,EAAE,UAAU;QACnB,QAAQ,EAAE,GAAG;QACb,cAAc,EAAE,UAAU;KAC7B,EACD,2BAAqD,EAAE,EACvD,iBAAkC,EAAE;QAxBhC,0BAAqB,GAAW,CAAC,CAAC;QAGzB,YAAO,GAAsB,EAAE,CAAC;QAChC,YAAO,GAAsB,EAAE,CAAC;QAsB7C,IAAI,CAAC,cAAc,GAAG,IAAI,gCAAc,CAAC,OAAO,CAAC,CAAC;QAClD,IAAI,CAAC,SAAS,GAAG,IAAI,qBAAS,EAAE,CAAC;QACjC,IAAI,CAAC,gBAAgB,GAAG,IAAI,6BAAa,EAAE,CAAC;QAC5C,IAAI,CAAC,KAAK,GAAG,IAAI,aAAK,EAAE,CAAC;QACzB,IAAI,CAAC,iBAAiB,GAAG,IAAI,6BAAa,EAAE,CAAC;QAC7C,IAAI,CAAC,aAAa,GAAG,IAAI,8BAAa,EAAE,CAAC;QACzC,IAAI,CAAC,SAAS,GAAG,IAAI,qBAAS,EAAE,CAAC;QACjC,IAAI,CAAC,YAAY,GAAG,IAAI,4BAAY,EAAE,CAAC;QAEvC,IAAI,cAAc,CAAC,QAAQ,EAAE;YACzB,IAAI,CAAC,qBAAqB,GAAG,cAAc,CAAC,QAAQ,CAAC,qBAAqB,GAAG,CAAC,CAAC;SAClF;QAGD,IAAI,cAAc,CAAC,QAAQ,IAAI,OAAO,CAAC,cAAc,EAAE;YACnD,MAAM,KAAK,CAAC,+CAA+C,CAAC,CAAC;SAChE;QACD,IAAI,cAAc,CAAC,QAAQ,EAAE;YACzB,IAAI,CAAC,MAAM,GAAG,cAAc,CAAC,QAAQ,CAAC,MAAM,CAAC;SAChD;aAAM,IAAI,OAAO,CAAC,cAAc,EAAE;YAC/B,MAAM,aAAa,GAAG,IAAI,+CAAqB,EAAE,CAAC;YAClD,IAAI,CAAC,MAAM,GAAG,aAAa,CAAC,WAAW,CAAC,OAAO,CAAC,cAAc,CAAC,CAAC;SACnE;aAAM;YACH,MAAM,aAAa,GAAG,IAAI,8BAAoB,EAAE,CAAC;YACjD,IAAI,CAAC,MAAM,GAAG,aAAa,CAAC,WAAW,EAAE,CAAC;SAC7C;QAED,IAAI,CAAC,uBAAuB,EAAE,CAAC;QAE/B,IAAI,cAAc,CAAC,QAAQ,IAAI,cAAc,CAAC,QAAQ,CAAC,OAAO,EAAE;YAC5D,KAAK,MAAM,cAAc,IAAI,cAAc,CAAC,QAAQ,CAAC,OAAO,EAAE;gBAC1D,IAAI,CAAC,mBAAmB,CAAC,cAAc,CAAC,MAAM,EAAE,cAAc,CAAC,IAAI,CAAC,CAAC;aACxE;SACJ;aAAM;YACH,IAAI,CAAC,YAAY,EAAE,CAAC;SACvB;QAED,IAAI,cAAc,CAAC,QAAQ,IAAI,cAAc,CAAC,QAAQ,CAAC,OAAO,EAAE;YAC5D,KAAK,MAAM,cAAc,IAAI,cAAc,CAAC,QAAQ,CAAC,OAAO,EAAE;gBAC1D,IAAI,CAAC,mBAAmB,CAAC,cAAc,CAAC,MAAM,EAAE,cAAc,CAAC,IAAI,CAAC,CAAC;aACxE;SACJ;aAAM;YACH,IAAI,CAAC,YAAY,EAAE,CAAC;SACvB;QAED,MAAM,2BAA2B,qBAC1B,wBAAwB,IAC3B,OAAO,EAAE,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,OAAO,EAAE,wBAAwB,CAAC,OAAO,CAAC,EAC1E,OAAO,EAAE,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,OAAO,EAAE,wBAAwB,CAAC,OAAO,CAAC,GAC7E,CAAC;QAEF,IAAI,CAAC,QAAQ,GAAG,IAAI,mBAAQ,CAAC,2BAA2B,CAAC,CAAC;QAC1D,IAAI,CAAC,QAAQ,GAAG,IAAI,mBAAQ,EAAE,CAAC;IACnC,CAAC;IAEM,kBAAkB,CAAC,GAAoB;QAC1C,IAAI,CAAC,QAAQ,CAAC,kBAAkB,CAAC,GAAG,CAAC,CAAC;IAC1C,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,IAAI,CAAC,QAAQ,CAAC,YAAY,CAAC,SAAS,CAAC,CAAC;QACtC,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe,CAAC,IAAa;QAChC,OAAO,IAAI,CAAC,QAAQ,CAAC,eAAe,CAAC,IAAI,CAAC,CAAC;IAC/C,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,OAAO,IAAI,CAAC,QAAQ,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;IACzC,CAAC;IAEM,WAAW,CAAC,IAAY,EAAE,IAAY;QACzC,OAAO,IAAI,CAAC,QAAQ,CAAC,WAAW,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;IACjD,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,QAAQ,CAAC,YAAY,CAAC,KAAK,CAAC,SAAS,CAAC,CAAC;QAC5C,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,WAAW,CACd,MAAkD,EAClD,KAAc,EACd,MAAe,EACf,cAAgC;QAEhC,MAAM,KAAK,GAAG,aAAK,CAAC,QAAQ,CAAC,IAAI,EAAE,MAAM,EAAE,KAAK,EAAE,MAAM,EAAE,cAAc,CAAC,CAAC;QAC1E,IAAI,CAAC,QAAQ,CAAC,YAAY,CAAC,KAAK,CAAC,SAAS,CAAC,CAAC;QAE5C,OAAO,KAAK,CAAC;IACjB,CAAC;IAEM,eAAe,CAAC,IAAY,EAAE,IAAa;QAC9C,MAAM,OAAO,GAAG,IAAI,KAAK,SAAS,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,IAAI,CAAC;QACjD,MAAM,SAAS,GAAG,IAAI,qBAAS,CAAC,OAAO,EAAE,IAAI,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,CAAC;QAClF,IAAI,CAAC,gBAAgB,CAAC,kBAAkB,CACpC,SAAS,CAAC,MAAM,EAChB,+EAA+E,EAC/E,IAAI,EACJ,UAAU,CACb,CAAC;QACF,OAAO,SAAS,CAAC;IACrB,CAAC;IAEM,uBAAuB,CAAC,MAAc,EAAE,IAAa;QACxD,MAAM,OAAO,GAAG,IAAI,KAAK,SAAS,CAAC,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,IAAI,CAAC;QACnD,MAAM,SAAS,GAAG,IAAI,qBAAS,CAAC,OAAO,EAAE,IAAI,CAAC,gBAAgB,CAAC,iBAAiB,EAAE,MAAM,CAAC,CAAC;QAG1F,OAAO,SAAS,CAAC;IACrB,CAAC;IAEM,cAAc,CAAC,IAAY,EAAE,IAAa;QAC7C,MAAM,OAAO,GAAG,IAAI,KAAK,SAAS,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,IAAI,CAAC;QACjD,MAAM,QAAQ,GAAG,IAAI,oBAAQ,CAAC,IAAI,EAAE,OAAO,EAAE,IAAI,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,CAAC;QACtF,OAAO,QAAQ,CAAC;IACpB,CAAC;IAEM,UAAU,CAAC,wBAAkD;QAChE,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,UAAU,CAAC,wBAAwB,CAAC,CAAC;IAC5D,CAAC;IAEM,cAAc,CAAC,SAAoB;QACtC,IAAI,CAAC,SAAS,CAAC,cAAc,CAAC,SAAS,CAAC,CAAC;IAC7C,CAAC;IAEM,YAAY;QACf,MAAM,MAAM,GAAG,IAAI,8BAAa,CAAC,IAAI,CAAC,KAAK,EAAE,IAAI,CAAC,qBAAqB,EAAE,CAAC,CAAC;QAC3E,IAAI,CAAC,mBAAmB,CAAC,MAAM,CAAC,CAAC;QACjC,OAAO,MAAM,CAAC;IAClB,CAAC;IAEM,YAAY;QACf,MAAM,MAAM,GAAG,IAAI,8BAAa,CAAC,IAAI,CAAC,KAAK,EAAE,IAAI,CAAC,qBAAqB,EAAE,CAAC,CAAC;QAC3E,IAAI,CAAC,mBAAmB,CAAC,MAAM,CAAC,CAAC;QACjC,OAAO,MAAM,CAAC;IAClB,CAAC;IAEM,qBAAqB;QACxB,MAAM,aAAa,GAAG,IAAI,CAAC,YAAY,EAAE,CAAC;QAE1C,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,cAAc,CAAC,eAAe,CAC7C,IAAI,oCAAe,CAAC;YAChB,UAAU,EAAE,wCAAmB,CAAC,KAAK;YACrC,QAAQ,EAAE,aAAa,CAAC,MAAM,CAAC,WAAW;SAC7C,CAAC,CACL,CAAC;QAEF,OAAO,aAAa,CAAC;IACzB,CAAC;IAEM,oBAAoB;QACvB,MAAM,aAAa,GAAG,IAAI,CAAC,YAAY,EAAE,CAAC;QAE1C,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,cAAc,CAAC,eAAe,CAC7C,IAAI,oCAAe,CAAC;YAChB,UAAU,EAAE,wCAAmB,CAAC,IAAI;YACpC,QAAQ,EAAE,aAAa,CAAC,MAAM,CAAC,WAAW;SAC7C,CAAC,CACL,CAAC;QAEF,OAAO,aAAa,CAAC;IACzB,CAAC;IAEM,qBAAqB;QACxB,MAAM,aAAa,GAAG,IAAI,CAAC,YAAY,EAAE,CAAC;QAE1C,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,cAAc,CAAC,eAAe,CAC7C,IAAI,oCAAe,CAAC;YAChB,UAAU,EAAE,wCAAmB,CAAC,KAAK;YACrC,QAAQ,EAAE,aAAa,CAAC,MAAM,CAAC,WAAW;SAC7C,CAAC,CACL,CAAC;QAEF,OAAO,aAAa,CAAC;IACzB,CAAC;IAEM,oBAAoB;QACvB,MAAM,aAAa,GAAG,IAAI,CAAC,YAAY,EAAE,CAAC;QAE1C,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,cAAc,CAAC,eAAe,CAC7C,IAAI,oCAAe,CAAC;YAChB,UAAU,EAAE,wCAAmB,CAAC,IAAI;YACpC,QAAQ,EAAE,aAAa,CAAC,MAAM,CAAC,WAAW;SAC7C,CAAC,CACL,CAAC;QAEF,OAAO,aAAa,CAAC;IACzB,CAAC;IAEM,0BAA0B,CAAC,KAAa;QAC3C,MAAM,KAAK,GAAG,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC,CAAC,MAAM,CAAC,WAAW,KAAK,KAAK,CAAC,CAAC;QAClG,IAAI,KAAK,EAAE;YACP,OAAO,KAAK,CAAC;SAChB;QACD,MAAM,IAAI,KAAK,CAAC,8CAA8C,KAAK,EAAE,CAAC,CAAC;IAC3E,CAAC;IAEM,0BAA0B,CAAC,KAAa;QAC3C,MAAM,KAAK,GAAG,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC,CAAC,MAAM,CAAC,WAAW,KAAK,KAAK,CAAC,CAAC;QAClG,IAAI,KAAK,EAAE;YACP,OAAO,KAAK,CAAC;SAChB;QACD,MAAM,IAAI,KAAK,CAAC,8CAA8C,KAAK,EAAE,CAAC,CAAC;IAC3E,CAAC;IAEM,kBAAkB;QACrB,IAAI,IAAI,CAAC,QAAQ,CAAC,mBAAmB,EAAE,CAAC,MAAM,EAAE;YAC5C,IAAI,CAAC,QAAQ,CAAC,eAAe,EAAE,CAAC;SACnC;IACL,CAAC;IAEO,mBAAmB,CAAC,MAAqB,EAAE,OAA4B,wCAAmB,CAAC,OAAO;QACtG,IAAI,CAAC,OAAO,CAAC,IAAI,CAAC,EAAE,MAAM,EAAE,IAAI,EAAE,CAAC,CAAC;QACpC,IAAI,CAAC,gBAAgB,CAAC,kBAAkB,CACpC,MAAM,CAAC,MAAM,CAAC,WAAW,EACzB,4EAA4E,EAC5E,SAAS,IAAI,CAAC,OAAO,CAAC,MAAM,MAAM,CACrC,CAAC;QACF,IAAI,CAAC,YAAY,CAAC,SAAS,CAAC,IAAI,CAAC,OAAO,CAAC,MAAM,CAAC,CAAC;IACrD,CAAC;IAEO,mBAAmB,CAAC,MAAqB,EAAE,OAA4B,wCAAmB,CAAC,OAAO;QACtG,IAAI,CAAC,OAAO,CAAC,IAAI,CAAC,EAAE,MAAM,EAAE,IAAI,EAAE,CAAC,CAAC;QACpC,IAAI,CAAC,gBAAgB,CAAC,kBAAkB,CACpC,MAAM,CAAC,MAAM,CAAC,WAAW,EACzB,4EAA4E,EAC5E,SAAS,IAAI,CAAC,OAAO,CAAC,MAAM,MAAM,CACrC,CAAC;QACF,IAAI,CAAC,YAAY,CAAC,SAAS,CAAC,IAAI,CAAC,OAAO,CAAC,MAAM,CAAC,CAAC;IACrD,CAAC;IAEO,uBAAuB;QAC3B,IAAI,CAAC,iBAAiB,CAAC,kBAAkB,CACrC,CAAC,EACD,oFAAoF,EACpF,mBAAmB,CACtB,CAAC;QACF,IAAI,CAAC,iBAAiB,CAAC,kBAAkB,CACrC,CAAC,EACD,uFAAuF,EACvF,mBAAmB,CACtB,CAAC;QACF,IAAI,CAAC,iBAAiB,CAAC,kBAAkB,CACrC,CAAC,EACD,yFAAyF,EACzF,kBAAkB,CACrB,CAAC;QAEF,IAAI,CAAC,gBAAgB,CAAC,kBAAkB,CACpC,IAAI,CAAC,qBAAqB,EAAE,EAC5B,4EAA4E,EAC5E,YAAY,CACf,CAAC;QACF,IAAI,CAAC,gBAAgB,CAAC,kBAAkB,CACpC,IAAI,CAAC,qBAAqB,EAAE,EAC5B,+EAA+E,EAC/E,eAAe,CAClB,CAAC;QACF,IAAI,CAAC,gBAAgB,CAAC,kBAAkB,CACpC,IAAI,CAAC,qBAAqB,EAAE,EAC5B,+EAA+E,EAC/E,eAAe,CAClB,CAAC;IACN,CAAC;IAEO,YAAY,CAAC,OAA0B,EAAE,QAA2C,EAAE;QAC1F,IAAI,QAAQ,GAAG,KAAK,CAAC;QAErB,KAAK,MAAM,MAAM,IAAI,OAAO,EAAE;YAC1B,QAAQ,MAAM,CAAC,IAAI,EAAE;gBACjB,KAAK,wCAAmB,CAAC,OAAO;oBAC5B,QAAQ,qBACD,QAAQ,IACX,OAAO,EAAE,MAAM,CAAC,MAAM,GACzB,CAAC;oBACF,MAAM;gBACV,KAAK,wCAAmB,CAAC,KAAK;oBAC1B,QAAQ,qBACD,QAAQ,IACX,KAAK,EAAE,MAAM,CAAC,MAAM,GACvB,CAAC;oBACF,MAAM;gBACV,KAAK,wCAAmB,CAAC,IAAI;oBACzB,QAAQ,qBACD,QAAQ,IACX,IAAI,EAAE,MAAM,CAAC,MAAM,GACtB,CAAC;oBACF,MAAM;gBACV;oBACI,QAAQ,qBACD,QAAQ,IACX,OAAO,EAAE,MAAM,CAAC,MAAM,GACzB,CAAC;oBACF,MAAM;aACb;SACJ;QAED,OAAO,QAAQ,CAAC;IACpB,CAAC;IAEO,YAAY,CAAC,OAA0B,EAAE,QAA2C,EAAE;QAC1F,IAAI,QAAQ,GAAG,KAAK,CAAC;QAErB,KAAK,MAAM,MAAM,IAAI,OAAO,EAAE;YAC1B,QAAQ,MAAM,CAAC,IAAI,EAAE;gBACjB,KAAK,wCAAmB,CAAC,OAAO;oBAC5B,QAAQ,qBACD,QAAQ,IACX,OAAO,EAAE,MAAM,CAAC,MAAM,GACzB,CAAC;oBACF,MAAM;gBACV,KAAK,wCAAmB,CAAC,KAAK;oBAC1B,QAAQ,qBACD,QAAQ,IACX,KAAK,EAAE,MAAM,CAAC,MAAM,GACvB,CAAC;oBACF,MAAM;gBACV,KAAK,wCAAmB,CAAC,IAAI;oBACzB,QAAQ,qBACD,QAAQ,IACX,IAAI,EAAE,MAAM,CAAC,MAAM,GACtB,CAAC;oBACF,MAAM;gBACV;oBACI,QAAQ,qBACD,QAAQ,IACX,OAAO,EAAE,MAAM,CAAC,MAAM,GACzB,CAAC;oBACF,MAAM;aACb;SACJ;QAED,OAAO,QAAQ,CAAC;IACpB,CAAC;IAED,IAAW,QAAQ;QACf,OAAO,IAAI,CAAC,QAAQ,CAAC;IACzB,CAAC;IAED,IAAW,MAAM;QACb,OAAO,IAAI,CAAC,MAAM,CAAC;IACvB,CAAC;IAED,IAAW,MAAM,CAAC,MAAc;QAC5B,IAAI,CAAC,MAAM,GAAG,MAAM,CAAC;IACzB,CAAC;IAED,IAAW,cAAc;QACrB,OAAO,IAAI,CAAC,cAAc,CAAC;IAC/B,CAAC;IAED,IAAW,SAAS;QAChB,OAAO,IAAI,CAAC,SAAS,CAAC;IAC1B,CAAC;IAED,IAAW,KAAK;QACZ,OAAO,IAAI,CAAC,KAAK,CAAC;IACtB,CAAC;IAED,IAAW,qBAAqB;QAC5B,OAAO,IAAI,CAAC,gBAAgB,CAAC;IACjC,CAAC;IAED,IAAW,iBAAiB;QACxB,OAAO,IAAI,CAAC,iBAAiB,CAAC;IAClC,CAAC;IAED,IAAW,MAAM;QACb,OAAO,IAAI,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,MAAM,CAAC;IAClC,CAAC;IAED,IAAW,OAAO;QACd,OAAO,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;IACnD,CAAC;IAED,IAAW,MAAM;QACb,OAAO,IAAI,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,MAAM,CAAC;IAClC,CAAC;IAED,IAAW,OAAO;QACd,OAAO,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;IACnD,CAAC;IAED,IAAW,YAAY;QACnB,OAAO,IAAI,CAAC,YAAY,CAAC;IAC7B,CAAC;IAED,IAAW,aAAa;QACpB,OAAO,IAAI,CAAC,aAAa,CAAC;IAC9B,CAAC;IAED,IAAW,SAAS;QAChB,OAAO,IAAI,CAAC,SAAS,CAAC;IAC1B,CAAC;IAED,IAAW,QAAQ;QACf,OAAO,IAAI,CAAC,QAAQ,CAAC;IACzB,CAAC;CACJ;AA5aD,oBA4aC",
          sourcesContent: ['import { AppProperties } from "./app-properties/app-properties";\r\nimport { ContentTypes } from "./content-types/content-types";\r\nimport { CoreProperties, IPropertiesOptions } from "./core-properties";\r\nimport { Document } from "./document";\r\nimport {\r\n    FooterReference,\r\n    FooterReferenceType,\r\n    HeaderReference,\r\n    HeaderReferenceType,\r\n    IHeaderFooterGroup,\r\n    SectionPropertiesOptions,\r\n} from "./document/body/section-properties";\r\nimport { IDrawingOptions } from "./drawing";\r\nimport { IFileProperties } from "./file-properties";\r\nimport { FooterWrapper, IDocumentFooter } from "./footer-wrapper";\r\nimport { FootNotes } from "./footnotes";\r\nimport { HeaderWrapper, IDocumentHeader } from "./header-wrapper";\r\nimport { Image, Media } from "./media";\r\nimport { Numbering } from "./numbering";\r\nimport { Bookmark, Hyperlink, Paragraph } from "./paragraph";\r\nimport { Relationships } from "./relationships";\r\nimport { Settings } from "./settings";\r\nimport { Styles } from "./styles";\r\nimport { ExternalStylesFactory } from "./styles/external-styles-factory";\r\nimport { DefaultStylesFactory } from "./styles/factory";\r\nimport { Table } from "./table";\r\nimport { TableOfContents } from "./table-of-contents";\r\n\r\nexport class File {\r\n    // tslint:disable-next-line:readonly-keyword\r\n    private currentRelationshipId: number = 1;\r\n\r\n    private readonly document: Document;\r\n    private readonly headers: IDocumentHeader[] = [];\r\n    private readonly footers: IDocumentFooter[] = [];\r\n    private readonly docRelationships: Relationships;\r\n    private readonly coreProperties: CoreProperties;\r\n    private readonly numbering: Numbering;\r\n    private readonly media: Media;\r\n    private readonly fileRelationships: Relationships;\r\n    private readonly footNotes: FootNotes;\r\n    private readonly settings: Settings;\r\n    private readonly contentTypes: ContentTypes;\r\n    private readonly appProperties: AppProperties;\r\n    // tslint:disable-next-line:readonly-keyword\r\n    private styles: Styles;\r\n\r\n    constructor(\r\n        options: IPropertiesOptions = {\r\n            creator: "Un-named",\r\n            revision: "1",\r\n            lastModifiedBy: "Un-named",\r\n        },\r\n        sectionPropertiesOptions: SectionPropertiesOptions = {},\r\n        fileProperties: IFileProperties = {},\r\n    ) {\r\n        this.coreProperties = new CoreProperties(options);\r\n        this.numbering = new Numbering();\r\n        this.docRelationships = new Relationships();\r\n        this.media = new Media();\r\n        this.fileRelationships = new Relationships();\r\n        this.appProperties = new AppProperties();\r\n        this.footNotes = new FootNotes();\r\n        this.contentTypes = new ContentTypes();\r\n\r\n        if (fileProperties.template) {\r\n            this.currentRelationshipId = fileProperties.template.currentRelationshipId + 1;\r\n        }\r\n\r\n        // set up styles\r\n        if (fileProperties.template && options.externalStyles) {\r\n            throw Error("can not use both template and external styles");\r\n        }\r\n        if (fileProperties.template) {\r\n            this.styles = fileProperties.template.styles;\r\n        } else if (options.externalStyles) {\r\n            const stylesFactory = new ExternalStylesFactory();\r\n            this.styles = stylesFactory.newInstance(options.externalStyles);\r\n        } else {\r\n            const stylesFactory = new DefaultStylesFactory();\r\n            this.styles = stylesFactory.newInstance();\r\n        }\r\n\r\n        this.addDefaultRelationships();\r\n\r\n        if (fileProperties.template && fileProperties.template.headers) {\r\n            for (const templateHeader of fileProperties.template.headers) {\r\n                this.addHeaderToDocument(templateHeader.header, templateHeader.type);\r\n            }\r\n        } else {\r\n            this.createHeader();\r\n        }\r\n\r\n        if (fileProperties.template && fileProperties.template.footers) {\r\n            for (const templateFooter of fileProperties.template.footers) {\r\n                this.addFooterToDocument(templateFooter.footer, templateFooter.type);\r\n            }\r\n        } else {\r\n            this.createFooter();\r\n        }\r\n\r\n        const newSectionPropertiesOptions = {\r\n            ...sectionPropertiesOptions,\r\n            headers: this.groupHeaders(this.headers, sectionPropertiesOptions.headers),\r\n            footers: this.groupFooters(this.footers, sectionPropertiesOptions.footers),\r\n        };\r\n\r\n        this.document = new Document(newSectionPropertiesOptions);\r\n        this.settings = new Settings();\r\n    }\r\n\r\n    public addTableOfContents(toc: TableOfContents): void {\r\n        this.document.addTableOfContents(toc);\r\n    }\r\n\r\n    public addParagraph(paragraph: Paragraph): File {\r\n        this.document.addParagraph(paragraph);\r\n        return this;\r\n    }\r\n\r\n    public createParagraph(text?: string): Paragraph {\r\n        return this.document.createParagraph(text);\r\n    }\r\n\r\n    public addTable(table: Table): void {\r\n        return this.document.addTable(table);\r\n    }\r\n\r\n    public createTable(rows: number, cols: number): Table {\r\n        return this.document.createTable(rows, cols);\r\n    }\r\n\r\n    public addImage(image: Image): File {\r\n        this.document.addParagraph(image.Paragraph);\r\n        return this;\r\n    }\r\n\r\n    public createImage(\r\n        buffer: Buffer | string | Uint8Array | ArrayBuffer,\r\n        width?: number,\r\n        height?: number,\r\n        drawingOptions?: IDrawingOptions,\r\n    ): Image {\r\n        const image = Media.addImage(this, buffer, width, height, drawingOptions);\r\n        this.document.addParagraph(image.Paragraph);\r\n\r\n        return image;\r\n    }\r\n\r\n    public createHyperlink(link: string, text?: string): Hyperlink {\r\n        const newText = text === undefined ? link : text;\r\n        const hyperlink = new Hyperlink(newText, this.docRelationships.RelationshipCount);\r\n        this.docRelationships.createRelationship(\r\n            hyperlink.linkId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",\r\n            link,\r\n            "External",\r\n        );\r\n        return hyperlink;\r\n    }\r\n\r\n    public createInternalHyperLink(anchor: string, text?: string): Hyperlink {\r\n        const newText = text === undefined ? anchor : text;\r\n        const hyperlink = new Hyperlink(newText, this.docRelationships.RelationshipCount, anchor);\r\n        // NOTE: unlike File#createHyperlink(), since the link is to an internal bookmark\r\n        // we don\'t need to create a new relationship.\r\n        return hyperlink;\r\n    }\r\n\r\n    public createBookmark(name: string, text?: string): Bookmark {\r\n        const newText = text === undefined ? name : text;\r\n        const bookmark = new Bookmark(name, newText, this.docRelationships.RelationshipCount);\r\n        return bookmark;\r\n    }\r\n\r\n    public addSection(sectionPropertiesOptions: SectionPropertiesOptions): void {\r\n        this.document.Body.addSection(sectionPropertiesOptions);\r\n    }\r\n\r\n    public createFootnote(paragraph: Paragraph): void {\r\n        this.footNotes.createFootNote(paragraph);\r\n    }\r\n\r\n    public createHeader(): HeaderWrapper {\r\n        const header = new HeaderWrapper(this.media, this.currentRelationshipId++);\r\n        this.addHeaderToDocument(header);\r\n        return header;\r\n    }\r\n\r\n    public createFooter(): FooterWrapper {\r\n        const footer = new FooterWrapper(this.media, this.currentRelationshipId++);\r\n        this.addFooterToDocument(footer);\r\n        return footer;\r\n    }\r\n\r\n    public createFirstPageHeader(): HeaderWrapper {\r\n        const headerWrapper = this.createHeader();\r\n\r\n        this.document.Body.DefaultSection.addChildElement(\r\n            new HeaderReference({\r\n                headerType: HeaderReferenceType.FIRST,\r\n                headerId: headerWrapper.Header.ReferenceId,\r\n            }),\r\n        );\r\n\r\n        return headerWrapper;\r\n    }\r\n\r\n    public createEvenPageHeader(): HeaderWrapper {\r\n        const headerWrapper = this.createHeader();\r\n\r\n        this.document.Body.DefaultSection.addChildElement(\r\n            new HeaderReference({\r\n                headerType: HeaderReferenceType.EVEN,\r\n                headerId: headerWrapper.Header.ReferenceId,\r\n            }),\r\n        );\r\n\r\n        return headerWrapper;\r\n    }\r\n\r\n    public createFirstPageFooter(): FooterWrapper {\r\n        const footerWrapper = this.createFooter();\r\n\r\n        this.document.Body.DefaultSection.addChildElement(\r\n            new FooterReference({\r\n                footerType: FooterReferenceType.FIRST,\r\n                footerId: footerWrapper.Footer.ReferenceId,\r\n            }),\r\n        );\r\n\r\n        return footerWrapper;\r\n    }\r\n\r\n    public createEvenPageFooter(): FooterWrapper {\r\n        const footerWrapper = this.createFooter();\r\n\r\n        this.document.Body.DefaultSection.addChildElement(\r\n            new FooterReference({\r\n                footerType: FooterReferenceType.EVEN,\r\n                footerId: footerWrapper.Footer.ReferenceId,\r\n            }),\r\n        );\r\n\r\n        return footerWrapper;\r\n    }\r\n\r\n    public getFooterByReferenceNumber(refId: number): FooterWrapper {\r\n        const entry = this.footers.map((item) => item.footer).find((h) => h.Footer.ReferenceId === refId);\r\n        if (entry) {\r\n            return entry;\r\n        }\r\n        throw new Error(`There is no footer with given reference id ${refId}`);\r\n    }\r\n\r\n    public getHeaderByReferenceNumber(refId: number): HeaderWrapper {\r\n        const entry = this.headers.map((item) => item.header).find((h) => h.Header.ReferenceId === refId);\r\n        if (entry) {\r\n            return entry;\r\n        }\r\n        throw new Error(`There is no header with given reference id ${refId}`);\r\n    }\r\n\r\n    public verifyUpdateFields(): void {\r\n        if (this.document.getTablesOfContents().length) {\r\n            this.settings.addUpdateFields();\r\n        }\r\n    }\r\n\r\n    private addHeaderToDocument(header: HeaderWrapper, type: HeaderReferenceType = HeaderReferenceType.DEFAULT): void {\r\n        this.headers.push({ header, type });\r\n        this.docRelationships.createRelationship(\r\n            header.Header.ReferenceId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header",\r\n            `header${this.headers.length}.xml`,\r\n        );\r\n        this.contentTypes.addHeader(this.headers.length);\r\n    }\r\n\r\n    private addFooterToDocument(footer: FooterWrapper, type: FooterReferenceType = FooterReferenceType.DEFAULT): void {\r\n        this.footers.push({ footer, type });\r\n        this.docRelationships.createRelationship(\r\n            footer.Footer.ReferenceId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer",\r\n            `footer${this.footers.length}.xml`,\r\n        );\r\n        this.contentTypes.addFooter(this.footers.length);\r\n    }\r\n\r\n    private addDefaultRelationships(): void {\r\n        this.fileRelationships.createRelationship(\r\n            1,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",\r\n            "word/document.xml",\r\n        );\r\n        this.fileRelationships.createRelationship(\r\n            2,\r\n            "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",\r\n            "docProps/core.xml",\r\n        );\r\n        this.fileRelationships.createRelationship(\r\n            3,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",\r\n            "docProps/app.xml",\r\n        );\r\n\r\n        this.docRelationships.createRelationship(\r\n            this.currentRelationshipId++,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",\r\n            "styles.xml",\r\n        );\r\n        this.docRelationships.createRelationship(\r\n            this.currentRelationshipId++,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering",\r\n            "numbering.xml",\r\n        );\r\n        this.docRelationships.createRelationship(\r\n            this.currentRelationshipId++,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes",\r\n            "footnotes.xml",\r\n        );\r\n    }\r\n\r\n    private groupHeaders(headers: IDocumentHeader[], group: IHeaderFooterGroup<HeaderWrapper> = {}): IHeaderFooterGroup<HeaderWrapper> {\r\n        let newGroup = group;\r\n\r\n        for (const header of headers) {\r\n            switch (header.type) {\r\n                case HeaderReferenceType.DEFAULT:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        default: header.header,\r\n                    };\r\n                    break;\r\n                case HeaderReferenceType.FIRST:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        first: header.header,\r\n                    };\r\n                    break;\r\n                case HeaderReferenceType.EVEN:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        even: header.header,\r\n                    };\r\n                    break;\r\n                default:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        default: header.header,\r\n                    };\r\n                    break;\r\n            }\r\n        }\r\n\r\n        return newGroup;\r\n    }\r\n\r\n    private groupFooters(footers: IDocumentFooter[], group: IHeaderFooterGroup<FooterWrapper> = {}): IHeaderFooterGroup<FooterWrapper> {\r\n        let newGroup = group;\r\n\r\n        for (const footer of footers) {\r\n            switch (footer.type) {\r\n                case FooterReferenceType.DEFAULT:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        default: footer.footer,\r\n                    };\r\n                    break;\r\n                case FooterReferenceType.FIRST:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        first: footer.footer,\r\n                    };\r\n                    break;\r\n                case FooterReferenceType.EVEN:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        even: footer.footer,\r\n                    };\r\n                    break;\r\n                default:\r\n                    newGroup = {\r\n                        ...newGroup,\r\n                        default: footer.footer,\r\n                    };\r\n                    break;\r\n            }\r\n        }\r\n\r\n        return newGroup;\r\n    }\r\n\r\n    public get Document(): Document {\r\n        return this.document;\r\n    }\r\n\r\n    public get Styles(): Styles {\r\n        return this.styles;\r\n    }\r\n\r\n    public set Styles(styles: Styles) {\r\n        this.styles = styles;\r\n    }\r\n\r\n    public get CoreProperties(): CoreProperties {\r\n        return this.coreProperties;\r\n    }\r\n\r\n    public get Numbering(): Numbering {\r\n        return this.numbering;\r\n    }\r\n\r\n    public get Media(): Media {\r\n        return this.media;\r\n    }\r\n\r\n    public get DocumentRelationships(): Relationships {\r\n        return this.docRelationships;\r\n    }\r\n\r\n    public get FileRelationships(): Relationships {\r\n        return this.fileRelationships;\r\n    }\r\n\r\n    public get Header(): HeaderWrapper {\r\n        return this.headers[0].header;\r\n    }\r\n\r\n    public get Headers(): HeaderWrapper[] {\r\n        return this.headers.map((item) => item.header);\r\n    }\r\n\r\n    public get Footer(): FooterWrapper {\r\n        return this.footers[0].footer;\r\n    }\r\n\r\n    public get Footers(): FooterWrapper[] {\r\n        return this.footers.map((item) => item.footer);\r\n    }\r\n\r\n    public get ContentTypes(): ContentTypes {\r\n        return this.contentTypes;\r\n    }\r\n\r\n    public get AppProperties(): AppProperties {\r\n        return this.appProperties;\r\n    }\r\n\r\n    public get FootNotes(): FootNotes {\r\n        return this.footNotes;\r\n    }\r\n\r\n    public get Settings(): Settings {\r\n        return this.settings;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(228)),
          u = (a.s[2]++, t(230)),
          p = (a.s[3]++, t(236)),
          m = (a.s[4]++, t(86)),
          C = (a.s[5]++, t(98)),
          d = (a.s[6]++, t(99)),
          f = (a.s[7]++, t(260)),
          h = (a.s[8]++, t(101)),
          x = (a.s[9]++, t(16)),
          g = (a.s[10]++, t(102)),
          I = (a.s[11]++, t(2)),
          b = (a.s[12]++, t(42)),
          y = (a.s[13]++, t(276)),
          E = (a.s[14]++, t(105)),
          v = (a.s[15]++, t(285));
      a.s[159]++, n.File =
      /*#__PURE__*/
      function () {
        function _class44() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, {
            creator: "Un-named",
            revision: "1",
            lastModifiedBy: "Un-named"
          });
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[1][0]++, {});
          var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (a.b[2][0]++, {});

          _classCallCheck(this, _class44);

          if (a.f[0]++, a.s[16]++, this.currentRelationshipId = 1, a.s[17]++, this.headers = [], a.s[18]++, this.footers = [], a.s[19]++, this.coreProperties = new p.CoreProperties(e), a.s[20]++, this.numbering = new g.Numbering(), a.s[21]++, this.docRelationships = new b.Relationships(), a.s[22]++, this.media = new x.Media(), a.s[23]++, this.fileRelationships = new b.Relationships(), a.s[24]++, this.appProperties = new c.AppProperties(), a.s[25]++, this.footNotes = new f.FootNotes(), a.s[26]++, this.contentTypes = new u.ContentTypes(), a.s[27]++, t.template ? (a.b[3][0]++, a.s[28]++, this.currentRelationshipId = t.template.currentRelationshipId + 1) : a.b[3][1]++, a.s[29]++, a.b[5][0]++, t.template && (a.b[5][1]++, e.externalStyles)) throw a.b[4][0]++, a.s[30]++, Error("can not use both template and external styles");
          if (a.b[4][1]++, a.s[31]++, t.template) a.b[6][0]++, a.s[32]++, this.styles = t.template.styles;else if (a.b[6][1]++, a.s[33]++, e.externalStyles) {
            a.b[7][0]++;

            var _n3 = (a.s[34]++, new E.ExternalStylesFactory());

            a.s[35]++, this.styles = _n3.newInstance(e.externalStyles);
          } else {
            a.b[7][1]++;

            var _e7 = (a.s[36]++, new v.DefaultStylesFactory());

            a.s[37]++, this.styles = _e7.newInstance();
          }

          if (a.s[38]++, this.addDefaultRelationships(), a.s[39]++, a.b[9][0]++, t.template && (a.b[9][1]++, t.template.headers)) {
            a.b[8][0]++, a.s[40]++;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = t.template.headers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _e8 = _step4.value;
                a.s[41]++, this.addHeaderToDocument(_e8.header, _e8.type);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          } else a.b[8][1]++, a.s[42]++, this.createHeader();

          if (a.s[43]++, a.b[11][0]++, t.template && (a.b[11][1]++, t.template.footers)) {
            a.b[10][0]++, a.s[44]++;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = t.template.footers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _e9 = _step5.value;
                a.s[45]++, this.addFooterToDocument(_e9.footer, _e9.type);
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          } else a.b[10][1]++, a.s[46]++, this.createFooter();

          var r = (a.s[47]++, Object.assign({}, n, {
            headers: this.groupHeaders(this.headers, n.headers),
            footers: this.groupFooters(this.footers, n.footers)
          }));
          a.s[48]++, this.document = new m.Document(r), a.s[49]++, this.settings = new y.Settings();
        }

        _createClass(_class44, [{
          key: "addTableOfContents",
          value: function addTableOfContents(e) {
            a.f[1]++, a.s[50]++, this.document.addTableOfContents(e);
          }
        }, {
          key: "addParagraph",
          value: function addParagraph(e) {
            return a.f[2]++, a.s[51]++, this.document.addParagraph(e), a.s[52]++, this;
          }
        }, {
          key: "createParagraph",
          value: function createParagraph(e) {
            return a.f[3]++, a.s[53]++, this.document.createParagraph(e);
          }
        }, {
          key: "addTable",
          value: function addTable(e) {
            return a.f[4]++, a.s[54]++, this.document.addTable(e);
          }
        }, {
          key: "createTable",
          value: function createTable(e, n) {
            return a.f[5]++, a.s[55]++, this.document.createTable(e, n);
          }
        }, {
          key: "addImage",
          value: function addImage(e) {
            return a.f[6]++, a.s[56]++, this.document.addParagraph(e.Paragraph), a.s[57]++, this;
          }
        }, {
          key: "createImage",
          value: function createImage(e, n, t, r) {
            a.f[7]++;
            var o = (a.s[58]++, x.Media.addImage(this, e, n, t, r));
            return a.s[59]++, this.document.addParagraph(o.Paragraph), a.s[60]++, o;
          }
        }, {
          key: "createHyperlink",
          value: function createHyperlink(e, n) {
            a.f[8]++;
            var t = (a.s[61]++, void 0 === n ? (a.b[12][0]++, e) : (a.b[12][1]++, n)),
                r = (a.s[62]++, new I.Hyperlink(t, this.docRelationships.RelationshipCount));
            return a.s[63]++, this.docRelationships.createRelationship(r.linkId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", e, "External"), a.s[64]++, r;
          }
        }, {
          key: "createInternalHyperLink",
          value: function createInternalHyperLink(e, n) {
            a.f[9]++;
            var t = (a.s[65]++, void 0 === n ? (a.b[13][0]++, e) : (a.b[13][1]++, n)),
                r = (a.s[66]++, new I.Hyperlink(t, this.docRelationships.RelationshipCount, e));
            return a.s[67]++, r;
          }
        }, {
          key: "createBookmark",
          value: function createBookmark(e, n) {
            a.f[10]++;
            var t = (a.s[68]++, void 0 === n ? (a.b[14][0]++, e) : (a.b[14][1]++, n)),
                r = (a.s[69]++, new I.Bookmark(e, t, this.docRelationships.RelationshipCount));
            return a.s[70]++, r;
          }
        }, {
          key: "addSection",
          value: function addSection(e) {
            a.f[11]++, a.s[71]++, this.document.Body.addSection(e);
          }
        }, {
          key: "createFootnote",
          value: function createFootnote(e) {
            a.f[12]++, a.s[72]++, this.footNotes.createFootNote(e);
          }
        }, {
          key: "createHeader",
          value: function createHeader() {
            a.f[13]++;
            var e = (a.s[73]++, new h.HeaderWrapper(this.media, this.currentRelationshipId++));
            return a.s[74]++, this.addHeaderToDocument(e), a.s[75]++, e;
          }
        }, {
          key: "createFooter",
          value: function createFooter() {
            a.f[14]++;
            var e = (a.s[76]++, new d.FooterWrapper(this.media, this.currentRelationshipId++));
            return a.s[77]++, this.addFooterToDocument(e), a.s[78]++, e;
          }
        }, {
          key: "createFirstPageHeader",
          value: function createFirstPageHeader() {
            a.f[15]++;
            var e = (a.s[79]++, this.createHeader());
            return a.s[80]++, this.document.Body.DefaultSection.addChildElement(new C.HeaderReference({
              headerType: C.HeaderReferenceType.FIRST,
              headerId: e.Header.ReferenceId
            })), a.s[81]++, e;
          }
        }, {
          key: "createEvenPageHeader",
          value: function createEvenPageHeader() {
            a.f[16]++;
            var e = (a.s[82]++, this.createHeader());
            return a.s[83]++, this.document.Body.DefaultSection.addChildElement(new C.HeaderReference({
              headerType: C.HeaderReferenceType.EVEN,
              headerId: e.Header.ReferenceId
            })), a.s[84]++, e;
          }
        }, {
          key: "createFirstPageFooter",
          value: function createFirstPageFooter() {
            a.f[17]++;
            var e = (a.s[85]++, this.createFooter());
            return a.s[86]++, this.document.Body.DefaultSection.addChildElement(new C.FooterReference({
              footerType: C.FooterReferenceType.FIRST,
              footerId: e.Footer.ReferenceId
            })), a.s[87]++, e;
          }
        }, {
          key: "createEvenPageFooter",
          value: function createEvenPageFooter() {
            a.f[18]++;
            var e = (a.s[88]++, this.createFooter());
            return a.s[89]++, this.document.Body.DefaultSection.addChildElement(new C.FooterReference({
              footerType: C.FooterReferenceType.EVEN,
              footerId: e.Footer.ReferenceId
            })), a.s[90]++, e;
          }
        }, {
          key: "getFooterByReferenceNumber",
          value: function getFooterByReferenceNumber(e) {
            a.f[19]++;
            var n = (a.s[91]++, this.footers.map(function (e) {
              return a.f[20]++, a.s[92]++, e.footer;
            }).find(function (n) {
              return a.f[21]++, a.s[93]++, n.Footer.ReferenceId === e;
            }));
            if (a.s[94]++, n) return a.b[15][0]++, a.s[95]++, n;
            throw a.b[15][1]++, a.s[96]++, new Error("There is no footer with given reference id ".concat(e));
          }
        }, {
          key: "getHeaderByReferenceNumber",
          value: function getHeaderByReferenceNumber(e) {
            a.f[22]++;
            var n = (a.s[97]++, this.headers.map(function (e) {
              return a.f[23]++, a.s[98]++, e.header;
            }).find(function (n) {
              return a.f[24]++, a.s[99]++, n.Header.ReferenceId === e;
            }));
            if (a.s[100]++, n) return a.b[16][0]++, a.s[101]++, n;
            throw a.b[16][1]++, a.s[102]++, new Error("There is no header with given reference id ".concat(e));
          }
        }, {
          key: "verifyUpdateFields",
          value: function verifyUpdateFields() {
            a.f[25]++, a.s[103]++, this.document.getTablesOfContents().length ? (a.b[17][0]++, a.s[104]++, this.settings.addUpdateFields()) : a.b[17][1]++;
          }
        }, {
          key: "addHeaderToDocument",
          value: function addHeaderToDocument(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[18][0]++, C.HeaderReferenceType.DEFAULT);
            a.f[26]++, a.s[105]++, this.headers.push({
              header: e,
              type: n
            }), a.s[106]++, this.docRelationships.createRelationship(e.Header.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header", "header".concat(this.headers.length, ".xml")), a.s[107]++, this.contentTypes.addHeader(this.headers.length);
          }
        }, {
          key: "addFooterToDocument",
          value: function addFooterToDocument(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[19][0]++, C.FooterReferenceType.DEFAULT);
            a.f[27]++, a.s[108]++, this.footers.push({
              footer: e,
              type: n
            }), a.s[109]++, this.docRelationships.createRelationship(e.Footer.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer", "footer".concat(this.footers.length, ".xml")), a.s[110]++, this.contentTypes.addFooter(this.footers.length);
          }
        }, {
          key: "addDefaultRelationships",
          value: function addDefaultRelationships() {
            a.f[28]++, a.s[111]++, this.fileRelationships.createRelationship(1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument", "word/document.xml"), a.s[112]++, this.fileRelationships.createRelationship(2, "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties", "docProps/core.xml"), a.s[113]++, this.fileRelationships.createRelationship(3, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties", "docProps/app.xml"), a.s[114]++, this.docRelationships.createRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles", "styles.xml"), a.s[115]++, this.docRelationships.createRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering", "numbering.xml"), a.s[116]++, this.docRelationships.createRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes", "footnotes.xml");
          }
        }, {
          key: "groupHeaders",
          value: function groupHeaders(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[20][0]++, {});
            a.f[29]++;
            var t = (a.s[117]++, n);
            a.s[118]++;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = e[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _n4 = _step6.value;

                switch (a.s[119]++, _n4.type) {
                  case C.HeaderReferenceType.DEFAULT:
                    a.b[21][0]++, a.s[120]++, t = Object.assign({}, t, {
                      default: _n4.header
                    }), a.s[121]++;
                    break;

                  case C.HeaderReferenceType.FIRST:
                    a.b[21][1]++, a.s[122]++, t = Object.assign({}, t, {
                      first: _n4.header
                    }), a.s[123]++;
                    break;

                  case C.HeaderReferenceType.EVEN:
                    a.b[21][2]++, a.s[124]++, t = Object.assign({}, t, {
                      even: _n4.header
                    }), a.s[125]++;
                    break;

                  default:
                    a.b[21][3]++, a.s[126]++, t = Object.assign({}, t, {
                      default: _n4.header
                    }), a.s[127]++;
                }
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }

            return a.s[128]++, t;
          }
        }, {
          key: "groupFooters",
          value: function groupFooters(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a.b[22][0]++, {});
            a.f[30]++;
            var t = (a.s[129]++, n);
            a.s[130]++;
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = e[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var _n5 = _step7.value;

                switch (a.s[131]++, _n5.type) {
                  case C.FooterReferenceType.DEFAULT:
                    a.b[23][0]++, a.s[132]++, t = Object.assign({}, t, {
                      default: _n5.footer
                    }), a.s[133]++;
                    break;

                  case C.FooterReferenceType.FIRST:
                    a.b[23][1]++, a.s[134]++, t = Object.assign({}, t, {
                      first: _n5.footer
                    }), a.s[135]++;
                    break;

                  case C.FooterReferenceType.EVEN:
                    a.b[23][2]++, a.s[136]++, t = Object.assign({}, t, {
                      even: _n5.footer
                    }), a.s[137]++;
                    break;

                  default:
                    a.b[23][3]++, a.s[138]++, t = Object.assign({}, t, {
                      default: _n5.footer
                    }), a.s[139]++;
                }
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }

            return a.s[140]++, t;
          }
        }, {
          key: "Document",
          get: function get() {
            return a.f[31]++, a.s[141]++, this.document;
          }
        }, {
          key: "Styles",
          get: function get() {
            return a.f[32]++, a.s[142]++, this.styles;
          },
          set: function set(e) {
            a.f[33]++, a.s[143]++, this.styles = e;
          }
        }, {
          key: "CoreProperties",
          get: function get() {
            return a.f[34]++, a.s[144]++, this.coreProperties;
          }
        }, {
          key: "Numbering",
          get: function get() {
            return a.f[35]++, a.s[145]++, this.numbering;
          }
        }, {
          key: "Media",
          get: function get() {
            return a.f[36]++, a.s[146]++, this.media;
          }
        }, {
          key: "DocumentRelationships",
          get: function get() {
            return a.f[37]++, a.s[147]++, this.docRelationships;
          }
        }, {
          key: "FileRelationships",
          get: function get() {
            return a.f[38]++, a.s[148]++, this.fileRelationships;
          }
        }, {
          key: "Header",
          get: function get() {
            return a.f[39]++, a.s[149]++, this.headers[0].header;
          }
        }, {
          key: "Headers",
          get: function get() {
            return a.f[40]++, a.s[150]++, this.headers.map(function (e) {
              return a.f[41]++, a.s[151]++, e.header;
            });
          }
        }, {
          key: "Footer",
          get: function get() {
            return a.f[42]++, a.s[152]++, this.footers[0].footer;
          }
        }, {
          key: "Footers",
          get: function get() {
            return a.f[43]++, a.s[153]++, this.footers.map(function (e) {
              return a.f[44]++, a.s[154]++, e.footer;
            });
          }
        }, {
          key: "ContentTypes",
          get: function get() {
            return a.f[45]++, a.s[155]++, this.contentTypes;
          }
        }, {
          key: "AppProperties",
          get: function get() {
            return a.f[46]++, a.s[156]++, this.appProperties;
          }
        }, {
          key: "FootNotes",
          get: function get() {
            return a.f[47]++, a.s[157]++, this.footNotes;
          }
        }, {
          key: "Settings",
          get: function get() {
            return a.f[48]++, a.s[158]++, this.settings;
          }
        }]);

        return _class44;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\app-properties\\app-properties.ts", o = "b653b6efa1002a531089a159d143220d76f570db", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\app-properties\\app-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 36
            },
            end: {
              line: 4,
              column: 74
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/app-properties/app-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\app-properties\\app-properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,2EAAsE;AAEtE,mBAA2B,SAAQ,6BAAY;IAC3C;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;QAEpB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,mDAAuB,CAAC;YACxB,KAAK,EAAE,2EAA2E;YAClF,EAAE,EAAE,sEAAsE;SAC7E,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,sCAWC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { AppPropertiesAttributes } from "./app-properties-attributes";\r\n\r\nexport class AppProperties extends XmlComponent {\r\n    constructor() {\r\n        super("Properties");\r\n\r\n        this.root.push(\r\n            new AppPropertiesAttributes({\r\n                xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",\r\n                vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(229));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent120) {
        _inherits(p, _c$XmlComponent120);

        function p() {
          var _this233;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this233 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "Properties")), a.s[4]++, _this233.root.push(new u.AppPropertiesAttributes({
            xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
            vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
          }));
          return _this233;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.AppProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\app-properties\\app-properties-attributes.ts", o = "9eb4993dfb8a01d948a2da8e1bf1b3ce8a0170c8", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\app-properties\\app-properties-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 58
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/app-properties/app-properties-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\app-properties\\app-properties-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,6BAAqC,SAAQ,sCAA+C;IAA5F;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,EAAE,EAAE,UAAU;SACjB,CAAC;IACN,CAAC;CAAA;AALD,0DAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IAppPropertiesAttributes {\r\n    readonly xmlns: string;\r\n    readonly vt: string;\r\n}\r\n\r\nexport class AppPropertiesAttributes extends XmlAttributeComponent<IAppPropertiesAttributes> {\r\n    protected readonly xmlKeys = {\r\n        xmlns: "xmlns",\r\n        vt: "xmlns:vt",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon53) {
        _inherits(u, _c$XmlAttributeCompon53);

        function u() {
          var _this234;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this234 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this234.xmlKeys = {
            xmlns: "xmlns",
            vt: "xmlns:vt"
          };
          return _this234;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.AppPropertiesAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\content-types.ts", o = "ff60b826fe89020749a948d3598d6b6ef884a756", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\content-types.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 35
            },
            end: {
              line: 4,
              column: 72
            }
          },
          3: {
            start: {
              line: 5,
              column: 18
            },
            end: {
              line: 5,
              column: 46
            }
          },
          4: {
            start: {
              line: 6,
              column: 19
            },
            end: {
              line: 6,
              column: 49
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 23
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 12,
              column: 12
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 66
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 68
            }
          },
          9: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 67
            }
          },
          10: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 66
            }
          },
          11: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 66
            }
          },
          12: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 114
            }
          },
          13: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 72
            }
          },
          14: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 154
            }
          },
          15: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 145
            }
          },
          16: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 132
            }
          },
          17: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 142
            }
          },
          18: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 151
            }
          },
          19: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 151
            }
          },
          20: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 153
            }
          },
          21: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 153
            }
          },
          22: {
            start: {
              line: 34,
              column: 0
            },
            end: {
              line: 34,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 18
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 21
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 27
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 21
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 30
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/content-types/content-types.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\content-types\\content-types.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,yEAAmE;AACnE,+CAA4C;AAC5C,kDAA+C;AAE/C,kBAA0B,SAAQ,6BAAY;IAC1C;QACI,KAAK,CAAC,OAAO,CAAC,CAAC;QAEf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,gDAAqB,CAAC;YACtB,KAAK,EAAE,8DAA8D;SACxE,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,WAAW,EAAE,KAAK,CAAC,CAAC,CAAC;QAChD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,YAAY,EAAE,MAAM,CAAC,CAAC,CAAC;QAClD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,YAAY,EAAE,KAAK,CAAC,CAAC,CAAC;QACjD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,WAAW,EAAE,KAAK,CAAC,CAAC,CAAC;QAChD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,WAAW,EAAE,KAAK,CAAC,CAAC,CAAC;QAChD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,0DAA0D,EAAE,MAAM,CAAC,CAAC,CAAC;QAChG,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,iBAAO,CAAC,iBAAiB,EAAE,KAAK,CAAC,CAAC,CAAC;QAEtD,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,mBAAQ,CAAC,kFAAkF,EAAE,oBAAoB,CAAC,CACzH,CAAC;QAEF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAQ,CAAC,2EAA2E,EAAE,kBAAkB,CAAC,CAAC,CAAC;QAC9H,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAQ,CAAC,4DAA4D,EAAE,oBAAoB,CAAC,CAAC,CAAC;QACjH,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAQ,CAAC,uEAAuE,EAAE,mBAAmB,CAAC,CAAC,CAAC;QAC3H,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAQ,CAAC,8EAA8E,EAAE,qBAAqB,CAAC,CAAC,CAAC;QACpI,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAQ,CAAC,8EAA8E,EAAE,qBAAqB,CAAC,CAAC,CAAC;IACxI,CAAC;IAEM,SAAS,CAAC,KAAa;QAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,mBAAQ,CAAC,2EAA2E,EAAE,eAAe,KAAK,MAAM,CAAC,CACxH,CAAC;IACN,CAAC;IAEM,SAAS,CAAC,KAAa;QAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,mBAAQ,CAAC,2EAA2E,EAAE,eAAe,KAAK,MAAM,CAAC,CACxH,CAAC;IACN,CAAC;CACJ;AAxCD,oCAwCC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { ContentTypeAttributes } from "./content-types-attributes";\r\nimport { Default } from "./default/default";\r\nimport { Override } from "./override/override";\r\n\r\nexport class ContentTypes extends XmlComponent {\r\n    constructor() {\r\n        super("Types");\r\n\r\n        this.root.push(\r\n            new ContentTypeAttributes({\r\n                xmlns: "http://schemas.openxmlformats.org/package/2006/content-types",\r\n            }),\r\n        );\r\n\r\n        this.root.push(new Default("image/png", "png"));\r\n        this.root.push(new Default("image/jpeg", "jpeg"));\r\n        this.root.push(new Default("image/jpeg", "jpg"));\r\n        this.root.push(new Default("image/bmp", "bmp"));\r\n        this.root.push(new Default("image/gif", "gif"));\r\n        this.root.push(new Default("application/vnd.openxmlformats-package.relationships+xml", "rels"));\r\n        this.root.push(new Default("application/xml", "xml"));\r\n\r\n        this.root.push(\r\n            new Override("application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml", "/word/document.xml"),\r\n        );\r\n\r\n        this.root.push(new Override("application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml", "/word/styles.xml"));\r\n        this.root.push(new Override("application/vnd.openxmlformats-package.core-properties+xml", "/docProps/core.xml"));\r\n        this.root.push(new Override("application/vnd.openxmlformats-officedocument.extended-properties+xml", "/docProps/app.xml"));\r\n        this.root.push(new Override("application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml", "/word/numbering.xml"));\r\n        this.root.push(new Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml", "/word/footnotes.xml"));\r\n    }\r\n\r\n    public addFooter(index: number): void {\r\n        this.root.push(\r\n            new Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml", `/word/footer${index}.xml`),\r\n        );\r\n    }\r\n\r\n    public addHeader(index: number): void {\r\n        this.root.push(\r\n            new Override("application/vnd.openxmlformats-officedocument.wordprocessingml.header+xml", `/word/header${index}.xml`),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(231)),
          p = (a.s[3]++, t(232)),
          m = (a.s[4]++, t(234));

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent121) {
        _inherits(C, _c$XmlComponent121);

        function C() {
          var _this235;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this235 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "Types")), a.s[6]++, _this235.root.push(new u.ContentTypeAttributes({
            xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
          })), a.s[7]++, _this235.root.push(new p.Default("image/png", "png")), a.s[8]++, _this235.root.push(new p.Default("image/jpeg", "jpeg")), a.s[9]++, _this235.root.push(new p.Default("image/jpeg", "jpg")), a.s[10]++, _this235.root.push(new p.Default("image/bmp", "bmp")), a.s[11]++, _this235.root.push(new p.Default("image/gif", "gif")), a.s[12]++, _this235.root.push(new p.Default("application/vnd.openxmlformats-package.relationships+xml", "rels")), a.s[13]++, _this235.root.push(new p.Default("application/xml", "xml")), a.s[14]++, _this235.root.push(new m.Override("application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml", "/word/document.xml")), a.s[15]++, _this235.root.push(new m.Override("application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml", "/word/styles.xml")), a.s[16]++, _this235.root.push(new m.Override("application/vnd.openxmlformats-package.core-properties+xml", "/docProps/core.xml")), a.s[17]++, _this235.root.push(new m.Override("application/vnd.openxmlformats-officedocument.extended-properties+xml", "/docProps/app.xml")), a.s[18]++, _this235.root.push(new m.Override("application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml", "/word/numbering.xml")), a.s[19]++, _this235.root.push(new m.Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml", "/word/footnotes.xml"));
          return _this235;
        }

        _createClass(C, [{
          key: "addFooter",
          value: function addFooter(e) {
            a.f[1]++, a.s[20]++, this.root.push(new m.Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml", "/word/footer".concat(e, ".xml")));
          }
        }, {
          key: "addHeader",
          value: function addHeader(e) {
            a.f[2]++, a.s[21]++, this.root.push(new m.Override("application/vnd.openxmlformats-officedocument.wordprocessingml.header+xml", "/word/header".concat(e, ".xml")));
          }
        }]);

        return C;
      }(c.XmlComponent);

      a.s[22]++, n.ContentTypes = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\content-types-attributes.ts", o = "f513dcfa78a4e8bbe53d8d3c6fbf4caf22eb4516", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\content-types-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 54
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/content-types/content-types-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\content-types\\content-types-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,2BAAmC,SAAQ,sCAA6C;IAAxF;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;SACjB,CAAC;IACN,CAAC;CAAA;AAJD,sDAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IContentTypeAttributes {\r\n    readonly xmlns?: string;\r\n}\r\n\r\nexport class ContentTypeAttributes extends XmlAttributeComponent<IContentTypeAttributes> {\r\n    protected readonly xmlKeys = {\r\n        xmlns: "xmlns",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon54) {
        _inherits(u, _c$XmlAttributeCompon54);

        function u() {
          var _this236;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this236 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this236.xmlKeys = {
            xmlns: "xmlns"
          };
          return _this236;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.ContentTypeAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\default\\default.ts", o = "9172d34a896b47ccd28e2167f26d1bf47aa93a23", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\default\\default.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 29
            },
            end: {
              line: 4,
              column: 60
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 25
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 40
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/content-types/default/default.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\content-types\\default\\default.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,6DAAyD;AAEzD,aAAqB,SAAQ,6BAAY;IACrC,YAAY,WAAmB,EAAE,SAAkB;QAC/C,KAAK,CAAC,SAAS,CAAC,CAAC;QAEjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,sCAAiB,CAAC;YAClB,WAAW,EAAE,WAAW;YACxB,SAAS,EAAE,SAAS;SACvB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,0BAWC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { DefaultAttributes } from "./default-attributes";\r\n\r\nexport class Default extends XmlComponent {\r\n    constructor(contentType: string, extension?: string) {\r\n        super("Default");\r\n\r\n        this.root.push(\r\n            new DefaultAttributes({\r\n                contentType: contentType,\r\n                extension: extension,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(233));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent122) {
        _inherits(p, _c$XmlComponent122);

        function p(e, n) {
          var _this237;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this237 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "Default")), a.s[4]++, _this237.root.push(new u.DefaultAttributes({
            contentType: e,
            extension: n
          }));
          return _this237;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Default = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\default\\default-attributes.ts", o = "a4b2926779ccff70bcccb6b9baa1cb1b42b20014", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\default\\default-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/content-types/default/default-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\content-types\\default\\default-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,uBAA+B,SAAQ,sCAAyC;IAAhF;;QACuB,YAAO,GAAG;YACzB,WAAW,EAAE,aAAa;YAC1B,SAAS,EAAE,WAAW;SACzB,CAAC;IACN,CAAC;CAAA;AALD,8CAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IDefaultAttributes {\r\n    readonly contentType: string;\r\n    readonly extension?: string;\r\n}\r\n\r\nexport class DefaultAttributes extends XmlAttributeComponent<IDefaultAttributes> {\r\n    protected readonly xmlKeys = {\r\n        contentType: "ContentType",\r\n        extension: "Extension",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon55) {
        _inherits(u, _c$XmlAttributeCompon55);

        function u() {
          var _this238;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this238 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this238.xmlKeys = {
            contentType: "ContentType",
            extension: "Extension"
          };
          return _this238;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.DefaultAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\override\\override.ts", o = "4f1ef2d16ded92816859a2b01f57e6e8fd720385", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\override\\override.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 30
            },
            end: {
              line: 4,
              column: 62
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 26
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 39
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/content-types/override/override.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\content-types\\override\\override.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,+DAA2D;AAE3D,cAAsB,SAAQ,6BAAY;IACtC,YAAY,WAAmB,EAAE,QAAiB;QAC9C,KAAK,CAAC,UAAU,CAAC,CAAC;QAElB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wCAAkB,CAAC;YACnB,WAAW,EAAE,WAAW;YACxB,QAAQ,EAAE,QAAQ;SACrB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAXD,4BAWC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { OverrideAttributes } from "./override-attributes";\r\n\r\nexport class Override extends XmlComponent {\r\n    constructor(contentType: string, partName?: string) {\r\n        super("Override");\r\n\r\n        this.root.push(\r\n            new OverrideAttributes({\r\n                contentType: contentType,\r\n                partName: partName,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(235));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent123) {
        _inherits(p, _c$XmlComponent123);

        function p(e, n) {
          var _this239;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this239 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "Override")), a.s[4]++, _this239.root.push(new u.OverrideAttributes({
            contentType: e,
            partName: n
          }));
          return _this239;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Override = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\override\\override-attributes.ts", o = "5c78ee69d86a32dab2a6cf69d46840771955858c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\content-types\\override\\override-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 48
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/content-types/override/override-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\content-types\\override\\override-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,wBAAgC,SAAQ,sCAA0C;IAAlF;;QACuB,YAAO,GAAG;YACzB,WAAW,EAAE,aAAa;YAC1B,QAAQ,EAAE,UAAU;SACvB,CAAC;IACN,CAAC;CAAA;AALD,gDAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IOverrideAttributes {\r\n    readonly contentType: string;\r\n    readonly partName?: string;\r\n}\r\n\r\nexport class OverrideAttributes extends XmlAttributeComponent<IOverrideAttributes> {\r\n    protected readonly xmlKeys = {\r\n        contentType: "ContentType",\r\n        partName: "PartName",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon56) {
        _inherits(u, _c$XmlAttributeCompon56);

        function u() {
          var _this240;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this240 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this240.xmlKeys = {
            contentType: "ContentType",
            partName: "PartName"
          };
          return _this240;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.OverrideAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\core-properties\\index.ts", o = "63058e7505a85955ce96320692dbb9fabbb67375", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\core-properties\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 34
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/core-properties/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\core-properties\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,kCAA6B",
          sourcesContent: ['export * from "./properties";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(237));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\core-properties\\properties.ts", o = "1db756cdb683476196503f297a12fb64d1e0db2b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\core-properties\\properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 30
            },
            end: {
              line: 4,
              column: 72
            }
          },
          3: {
            start: {
              line: 5,
              column: 21
            },
            end: {
              line: 5,
              column: 44
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 35
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 15,
              column: 12
            }
          },
          6: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 18,
              column: 9
            }
          },
          7: {
            start: {
              line: 17,
              column: 12
            },
            end: {
              line: 17,
              column: 66
            }
          },
          8: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 21,
              column: 9
            }
          },
          9: {
            start: {
              line: 20,
              column: 12
            },
            end: {
              line: 20,
              column: 70
            }
          },
          10: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 24,
              column: 9
            }
          },
          11: {
            start: {
              line: 23,
              column: 12
            },
            end: {
              line: 23,
              column: 70
            }
          },
          12: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 27,
              column: 9
            }
          },
          13: {
            start: {
              line: 26,
              column: 12
            },
            end: {
              line: 26,
              column: 72
            }
          },
          14: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 30,
              column: 9
            }
          },
          15: {
            start: {
              line: 29,
              column: 12
            },
            end: {
              line: 29,
              column: 78
            }
          },
          16: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 33,
              column: 9
            }
          },
          17: {
            start: {
              line: 32,
              column: 12
            },
            end: {
              line: 32,
              column: 84
            }
          },
          18: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 36,
              column: 9
            }
          },
          19: {
            start: {
              line: 35,
              column: 12
            },
            end: {
              line: 35,
              column: 72
            }
          },
          20: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 51
            }
          },
          21: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 38,
              column: 52
            }
          },
          22: {
            start: {
              line: 41,
              column: 0
            },
            end: {
              line: 41,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 25
              },
              end: {
                line: 39,
                column: 5
              }
            },
            line: 7
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 16,
                column: 8
              },
              end: {
                line: 18,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 16,
                column: 8
              },
              end: {
                line: 18,
                column: 9
              }
            }, {
              start: {
                line: 16,
                column: 8
              },
              end: {
                line: 18,
                column: 9
              }
            }],
            line: 16
          },
          1: {
            loc: {
              start: {
                line: 19,
                column: 8
              },
              end: {
                line: 21,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 19,
                column: 8
              },
              end: {
                line: 21,
                column: 9
              }
            }, {
              start: {
                line: 19,
                column: 8
              },
              end: {
                line: 21,
                column: 9
              }
            }],
            line: 19
          },
          2: {
            loc: {
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            }, {
              start: {
                line: 22,
                column: 8
              },
              end: {
                line: 24,
                column: 9
              }
            }],
            line: 22
          },
          3: {
            loc: {
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            }, {
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            }],
            line: 25
          },
          4: {
            loc: {
              start: {
                line: 28,
                column: 8
              },
              end: {
                line: 30,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 28,
                column: 8
              },
              end: {
                line: 30,
                column: 9
              }
            }, {
              start: {
                line: 28,
                column: 8
              },
              end: {
                line: 30,
                column: 9
              }
            }],
            line: 28
          },
          5: {
            loc: {
              start: {
                line: 31,
                column: 8
              },
              end: {
                line: 33,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 31,
                column: 8
              },
              end: {
                line: 33,
                column: 9
              }
            }, {
              start: {
                line: 31,
                column: 8
              },
              end: {
                line: 33,
                column: 9
              }
            }],
            line: 31
          },
          6: {
            loc: {
              start: {
                line: 34,
                column: 8
              },
              end: {
                line: 36,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 34,
                column: 8
              },
              end: {
                line: 36,
                column: 9
              }
            }, {
              start: {
                line: 34,
                column: 8
              },
              end: {
                line: 36,
                column: 9
              }
            }],
            line: 34
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0],
          6: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/core-properties/properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\core-properties\\properties.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,yEAAqE;AACrE,6CAA2H;AAa3H,oBAA4B,SAAQ,6BAAY;IAC5C,YAAY,OAA2B;QACnC,KAAK,CAAC,mBAAmB,CAAC,CAAC;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wCAAkB,CAAC;YACnB,EAAE,EAAE,yEAAyE;YAC7E,EAAE,EAAE,kCAAkC;YACtC,OAAO,EAAE,2BAA2B;YACpC,QAAQ,EAAE,8BAA8B;YACxC,GAAG,EAAE,2CAA2C;SACnD,CAAC,CACL,CAAC;QACF,IAAI,OAAO,CAAC,KAAK,EAAE;YACf,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,kBAAK,CAAC,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC;SAC5C;QACD,IAAI,OAAO,CAAC,OAAO,EAAE;YACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,CAAC,OAAO,CAAC,OAAO,CAAC,CAAC,CAAC;SAChD;QACD,IAAI,OAAO,CAAC,OAAO,EAAE;YACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,CAAC,OAAO,CAAC,OAAO,CAAC,CAAC,CAAC;SAChD;QACD,IAAI,OAAO,CAAC,QAAQ,EAAE;YAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,qBAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,CAAC,CAAC;SAClD;QACD,IAAI,OAAO,CAAC,WAAW,EAAE;YACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,wBAAW,CAAC,OAAO,CAAC,WAAW,CAAC,CAAC,CAAC;SACxD;QACD,IAAI,OAAO,CAAC,cAAc,EAAE;YACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,2BAAc,CAAC,OAAO,CAAC,cAAc,CAAC,CAAC,CAAC;SAC9D;QACD,IAAI,OAAO,CAAC,QAAQ,EAAE;YAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,qBAAQ,CAAC,OAAO,CAAC,QAAQ,CAAC,CAAC,CAAC;SAClD;QACD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,oBAAO,EAAE,CAAC,CAAC;QAC9B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,qBAAQ,EAAE,CAAC,CAAC;IACnC,CAAC;CACJ;AApCD,wCAoCC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { DocumentAttributes } from "../document/document-attributes";\r\nimport { Created, Creator, Description, Keywords, LastModifiedBy, Modified, Revision, Subject, Title } from "./components";\r\n\r\nexport interface IPropertiesOptions {\r\n    readonly title?: string;\r\n    readonly subject?: string;\r\n    readonly creator?: string;\r\n    readonly keywords?: string;\r\n    readonly description?: string;\r\n    readonly lastModifiedBy?: string;\r\n    readonly revision?: string;\r\n    readonly externalStyles?: string;\r\n}\r\n\r\nexport class CoreProperties extends XmlComponent {\r\n    constructor(options: IPropertiesOptions) {\r\n        super("cp:coreProperties");\r\n        this.root.push(\r\n            new DocumentAttributes({\r\n                cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",\r\n                dc: "http://purl.org/dc/elements/1.1/",\r\n                dcterms: "http://purl.org/dc/terms/",\r\n                dcmitype: "http://purl.org/dc/dcmitype/",\r\n                xsi: "http://www.w3.org/2001/XMLSchema-instance",\r\n            }),\r\n        );\r\n        if (options.title) {\r\n            this.root.push(new Title(options.title));\r\n        }\r\n        if (options.subject) {\r\n            this.root.push(new Subject(options.subject));\r\n        }\r\n        if (options.creator) {\r\n            this.root.push(new Creator(options.creator));\r\n        }\r\n        if (options.keywords) {\r\n            this.root.push(new Keywords(options.keywords));\r\n        }\r\n        if (options.description) {\r\n            this.root.push(new Description(options.description));\r\n        }\r\n        if (options.lastModifiedBy) {\r\n            this.root.push(new LastModifiedBy(options.lastModifiedBy));\r\n        }\r\n        if (options.revision) {\r\n            this.root.push(new Revision(options.revision));\r\n        }\r\n        this.root.push(new Created());\r\n        this.root.push(new Modified());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(11)),
          p = (a.s[3]++, t(238));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent124) {
        _inherits(m, _c$XmlComponent124);

        function m(e) {
          var _this241;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this241 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "cp:coreProperties")), a.s[5]++, _this241.root.push(new u.DocumentAttributes({
            cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
            dc: "http://purl.org/dc/elements/1.1/",
            dcterms: "http://purl.org/dc/terms/",
            dcmitype: "http://purl.org/dc/dcmitype/",
            xsi: "http://www.w3.org/2001/XMLSchema-instance"
          })), a.s[6]++, e.title ? (a.b[0][0]++, a.s[7]++, _this241.root.push(new p.Title(e.title))) : a.b[0][1]++, a.s[8]++, e.subject ? (a.b[1][0]++, a.s[9]++, _this241.root.push(new p.Subject(e.subject))) : a.b[1][1]++, a.s[10]++, e.creator ? (a.b[2][0]++, a.s[11]++, _this241.root.push(new p.Creator(e.creator))) : a.b[2][1]++, a.s[12]++, e.keywords ? (a.b[3][0]++, a.s[13]++, _this241.root.push(new p.Keywords(e.keywords))) : a.b[3][1]++, a.s[14]++, e.description ? (a.b[4][0]++, a.s[15]++, _this241.root.push(new p.Description(e.description))) : a.b[4][1]++, a.s[16]++, e.lastModifiedBy ? (a.b[5][0]++, a.s[17]++, _this241.root.push(new p.LastModifiedBy(e.lastModifiedBy))) : a.b[5][1]++, a.s[18]++, e.revision ? (a.b[6][0]++, a.s[19]++, _this241.root.push(new p.Revision(e.revision))) : a.b[6][1]++, a.s[20]++, _this241.root.push(new p.Created()), a.s[21]++, _this241.root.push(new p.Modified());
          return _this241;
        }

        return m;
      }(c.XmlComponent);

      a.s[22]++, n.CoreProperties = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\core-properties\\components.ts", o = "bd1a96a174d460781a687a219c71119554eb548e", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\core-properties\\components.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 30
            },
            end: {
              line: 4,
              column: 72
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 26
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 30
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 22
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 28
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 30
            }
          },
          8: {
            start: {
              line: 18,
              column: 0
            },
            end: {
              line: 18,
              column: 26
            }
          },
          9: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 28
            }
          },
          10: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 30
            }
          },
          11: {
            start: {
              line: 25,
              column: 0
            },
            end: {
              line: 25,
              column: 26
            }
          },
          12: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 29
            }
          },
          13: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 30
            }
          },
          14: {
            start: {
              line: 32,
              column: 0
            },
            end: {
              line: 32,
              column: 28
            }
          },
          15: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 32
            }
          },
          16: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 30
            }
          },
          17: {
            start: {
              line: 39,
              column: 0
            },
            end: {
              line: 39,
              column: 34
            }
          },
          18: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 35
            }
          },
          19: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 30
            }
          },
          20: {
            start: {
              line: 46,
              column: 0
            },
            end: {
              line: 46,
              column: 40
            }
          },
          21: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 29
            }
          },
          22: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 30
            }
          },
          23: {
            start: {
              line: 53,
              column: 0
            },
            end: {
              line: 53,
              column: 28
            }
          },
          24: {
            start: {
              line: 56,
              column: 21
            },
            end: {
              line: 56,
              column: 31
            }
          },
          25: {
            start: {
              line: 57,
              column: 21
            },
            end: {
              line: 57,
              column: 39
            }
          },
          26: {
            start: {
              line: 58,
              column: 22
            },
            end: {
              line: 58,
              column: 61
            }
          },
          27: {
            start: {
              line: 59,
              column: 20
            },
            end: {
              line: 59,
              column: 52
            }
          },
          28: {
            start: {
              line: 60,
              column: 22
            },
            end: {
              line: 60,
              column: 55
            }
          },
          29: {
            start: {
              line: 61,
              column: 24
            },
            end: {
              line: 61,
              column: 59
            }
          },
          30: {
            start: {
              line: 62,
              column: 24
            },
            end: {
              line: 62,
              column: 59
            }
          },
          31: {
            start: {
              line: 63,
              column: 8
            },
            end: {
              line: 63,
              column: 98
            }
          },
          32: {
            start: {
              line: 66,
              column: 0
            },
            end: {
              line: 66,
              column: 38
            }
          },
          33: {
            start: {
              line: 69,
              column: 8
            },
            end: {
              line: 69,
              column: 33
            }
          },
          34: {
            start: {
              line: 70,
              column: 8
            },
            end: {
              line: 72,
              column: 12
            }
          },
          35: {
            start: {
              line: 73,
              column: 8
            },
            end: {
              line: 73,
              column: 46
            }
          },
          36: {
            start: {
              line: 76,
              column: 0
            },
            end: {
              line: 76,
              column: 26
            }
          },
          37: {
            start: {
              line: 79,
              column: 8
            },
            end: {
              line: 79,
              column: 34
            }
          },
          38: {
            start: {
              line: 80,
              column: 8
            },
            end: {
              line: 82,
              column: 12
            }
          },
          39: {
            start: {
              line: 83,
              column: 8
            },
            end: {
              line: 83,
              column: 46
            }
          },
          40: {
            start: {
              line: 86,
              column: 0
            },
            end: {
              line: 86,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 23
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 23
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 13
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 23
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 20
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 27,
                column: 4
              },
              end: {
                line: 27,
                column: 5
              }
            },
            loc: {
              start: {
                line: 27,
                column: 23
              },
              end: {
                line: 30,
                column: 5
              }
            },
            line: 27
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 34,
                column: 4
              },
              end: {
                line: 34,
                column: 5
              }
            },
            loc: {
              start: {
                line: 34,
                column: 23
              },
              end: {
                line: 37,
                column: 5
              }
            },
            line: 34
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 41,
                column: 4
              },
              end: {
                line: 41,
                column: 5
              }
            },
            loc: {
              start: {
                line: 41,
                column: 23
              },
              end: {
                line: 44,
                column: 5
              }
            },
            line: 41
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 48,
                column: 4
              },
              end: {
                line: 48,
                column: 5
              }
            },
            loc: {
              start: {
                line: 48,
                column: 23
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 48
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 55,
                column: 4
              },
              end: {
                line: 55,
                column: 5
              }
            },
            loc: {
              start: {
                line: 55,
                column: 21
              },
              end: {
                line: 64,
                column: 5
              }
            },
            line: 55
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 68,
                column: 4
              },
              end: {
                line: 68,
                column: 5
              }
            },
            loc: {
              start: {
                line: 68,
                column: 18
              },
              end: {
                line: 74,
                column: 5
              }
            },
            line: 68
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 78,
                column: 4
              },
              end: {
                line: 78,
                column: 5
              }
            },
            loc: {
              start: {
                line: 78,
                column: 18
              },
              end: {
                line: 84,
                column: 5
              }
            },
            line: 78
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/core-properties/components.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\core-properties\\components.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,yEAAqE;AAErE,WAAmB,SAAQ,6BAAY;IACnC,YAAY,KAAa;QACrB,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,sBAKC;AAED,aAAqB,SAAQ,6BAAY;IACrC,YAAY,KAAa;QACrB,KAAK,CAAC,YAAY,CAAC,CAAC;QACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,0BAKC;AAED,aAAqB,SAAQ,6BAAY;IACrC,YAAY,KAAa;QACrB,KAAK,CAAC,YAAY,CAAC,CAAC;QACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,0BAKC;AAED,cAAsB,SAAQ,6BAAY;IACtC,YAAY,KAAa;QACrB,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,4BAKC;AAED,iBAAyB,SAAQ,6BAAY;IACzC,YAAY,KAAa;QACrB,KAAK,CAAC,gBAAgB,CAAC,CAAC;QACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,kCAKC;AAED,oBAA4B,SAAQ,6BAAY;IAC5C,YAAY,KAAa;QACrB,KAAK,CAAC,mBAAmB,CAAC,CAAC;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,wCAKC;AAED,cAAsB,SAAQ,6BAAY;IACtC,YAAY,KAAa;QACrB,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;CACJ;AALD,4BAKC;AAED,mBAAoC,SAAQ,6BAAY;IAC1C,cAAc;QACpB,MAAM,IAAI,GAAG,IAAI,IAAI,EAAE,CAAC;QACxB,MAAM,IAAI,GAAG,IAAI,CAAC,WAAW,EAAE,CAAC;QAChC,MAAM,KAAK,GAAG,CAAC,GAAG,GAAG,CAAC,IAAI,CAAC,QAAQ,EAAE,GAAG,CAAC,CAAC,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC;QACtD,MAAM,GAAG,GAAG,CAAC,GAAG,GAAG,IAAI,CAAC,OAAO,EAAE,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC;QAC7C,MAAM,KAAK,GAAG,CAAC,GAAG,GAAG,IAAI,CAAC,QAAQ,EAAE,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC;QAChD,MAAM,OAAO,GAAG,CAAC,GAAG,GAAG,IAAI,CAAC,UAAU,EAAE,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC;QACpD,MAAM,OAAO,GAAG,CAAC,GAAG,GAAG,IAAI,CAAC,UAAU,EAAE,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC;QAEpD,OAAO,IAAI,GAAG,GAAG,GAAG,KAAK,GAAG,GAAG,GAAG,GAAG,GAAG,GAAG,GAAG,KAAK,GAAG,GAAG,GAAG,OAAO,GAAG,GAAG,GAAG,OAAO,GAAG,GAAG,CAAC;IAC9F,CAAC;CACJ;AAZD,sCAYC;AAED,aAAqB,SAAQ,aAAa;IACtC;QACI,KAAK,CAAC,iBAAiB,CAAC,CAAC;QACzB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wCAAkB,CAAC;YACnB,IAAI,EAAE,gBAAgB;SACzB,CAAC,CACL,CAAC;QACF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,cAAc,EAAE,CAAC,CAAC;IAC1C,CAAC;CACJ;AAVD,0BAUC;AAED,cAAsB,SAAQ,aAAa;IACvC;QACI,KAAK,CAAC,kBAAkB,CAAC,CAAC;QAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wCAAkB,CAAC;YACnB,IAAI,EAAE,gBAAgB;SACzB,CAAC,CACL,CAAC;QACF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,cAAc,EAAE,CAAC,CAAC;IAC1C,CAAC;CACJ;AAVD,4BAUC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { DocumentAttributes } from "../document/document-attributes";\r\n\r\nexport class Title extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("dc:title");\r\n        this.root.push(value);\r\n    }\r\n}\r\n\r\nexport class Subject extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("dc:subject");\r\n        this.root.push(value);\r\n    }\r\n}\r\n\r\nexport class Creator extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("dc:creator");\r\n        this.root.push(value);\r\n    }\r\n}\r\n\r\nexport class Keywords extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("cp:keywords");\r\n        this.root.push(value);\r\n    }\r\n}\r\n\r\nexport class Description extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("dc:description");\r\n        this.root.push(value);\r\n    }\r\n}\r\n\r\nexport class LastModifiedBy extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("cp:lastModifiedBy");\r\n        this.root.push(value);\r\n    }\r\n}\r\n\r\nexport class Revision extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("cp:revision");\r\n        this.root.push(value);\r\n    }\r\n}\r\n\r\nexport abstract class DateComponent extends XmlComponent {\r\n    protected getCurrentDate(): string {\r\n        const date = new Date();\r\n        const year = date.getFullYear();\r\n        const month = ("0" + (date.getMonth() + 1)).slice(-2);\r\n        const day = ("0" + date.getDate()).slice(-2);\r\n        const hours = ("0" + date.getHours()).slice(-2);\r\n        const minutes = ("0" + date.getMinutes()).slice(-2);\r\n        const seconds = ("0" + date.getSeconds()).slice(-2);\r\n\r\n        return year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + "Z";\r\n    }\r\n}\r\n\r\nexport class Created extends DateComponent {\r\n    constructor() {\r\n        super("dcterms:created");\r\n        this.root.push(\r\n            new DocumentAttributes({\r\n                type: "dcterms:W3CDTF",\r\n            }),\r\n        );\r\n        this.root.push(this.getCurrentDate());\r\n    }\r\n}\r\n\r\nexport class Modified extends DateComponent {\r\n    constructor() {\r\n        super("dcterms:modified");\r\n        this.root.push(\r\n            new DocumentAttributes({\r\n                type: "dcterms:W3CDTF",\r\n            }),\r\n        );\r\n        this.root.push(this.getCurrentDate());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(11));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent125) {
        _inherits(p, _c$XmlComponent125);

        function p(e) {
          var _this242;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this242 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "dc:title")), a.s[4]++, _this242.root.push(e);
          return _this242;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Title = p;

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent126) {
        _inherits(m, _c$XmlComponent126);

        function m(e) {
          var _this243;

          _classCallCheck(this, m);

          a.f[1]++, a.s[6]++, _this243 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "dc:subject")), a.s[7]++, _this243.root.push(e);
          return _this243;
        }

        return m;
      }(c.XmlComponent);

      a.s[8]++, n.Subject = m;

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent127) {
        _inherits(C, _c$XmlComponent127);

        function C(e) {
          var _this244;

          _classCallCheck(this, C);

          a.f[2]++, a.s[9]++, _this244 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "dc:creator")), a.s[10]++, _this244.root.push(e);
          return _this244;
        }

        return C;
      }(c.XmlComponent);

      a.s[11]++, n.Creator = C;

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent128) {
        _inherits(d, _c$XmlComponent128);

        function d(e) {
          var _this245;

          _classCallCheck(this, d);

          a.f[3]++, a.s[12]++, _this245 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "cp:keywords")), a.s[13]++, _this245.root.push(e);
          return _this245;
        }

        return d;
      }(c.XmlComponent);

      a.s[14]++, n.Keywords = d;

      var f =
      /*#__PURE__*/
      function (_c$XmlComponent129) {
        _inherits(f, _c$XmlComponent129);

        function f(e) {
          var _this246;

          _classCallCheck(this, f);

          a.f[4]++, a.s[15]++, _this246 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "dc:description")), a.s[16]++, _this246.root.push(e);
          return _this246;
        }

        return f;
      }(c.XmlComponent);

      a.s[17]++, n.Description = f;

      var h =
      /*#__PURE__*/
      function (_c$XmlComponent130) {
        _inherits(h, _c$XmlComponent130);

        function h(e) {
          var _this247;

          _classCallCheck(this, h);

          a.f[5]++, a.s[18]++, _this247 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, "cp:lastModifiedBy")), a.s[19]++, _this247.root.push(e);
          return _this247;
        }

        return h;
      }(c.XmlComponent);

      a.s[20]++, n.LastModifiedBy = h;

      var x =
      /*#__PURE__*/
      function (_c$XmlComponent131) {
        _inherits(x, _c$XmlComponent131);

        function x(e) {
          var _this248;

          _classCallCheck(this, x);

          a.f[6]++, a.s[21]++, _this248 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, "cp:revision")), a.s[22]++, _this248.root.push(e);
          return _this248;
        }

        return x;
      }(c.XmlComponent);

      a.s[23]++, n.Revision = x;

      var g =
      /*#__PURE__*/
      function (_c$XmlComponent132) {
        _inherits(g, _c$XmlComponent132);

        function g() {
          _classCallCheck(this, g);

          return _possibleConstructorReturn(this, _getPrototypeOf(g).apply(this, arguments));
        }

        _createClass(g, [{
          key: "getCurrentDate",
          value: function getCurrentDate() {
            a.f[7]++;
            var e = (a.s[24]++, new Date()),
                n = (a.s[25]++, e.getFullYear()),
                t = (a.s[26]++, ("0" + (e.getMonth() + 1)).slice(-2)),
                r = (a.s[27]++, ("0" + e.getDate()).slice(-2)),
                o = (a.s[28]++, ("0" + e.getHours()).slice(-2)),
                i = (a.s[29]++, ("0" + e.getMinutes()).slice(-2)),
                A = (a.s[30]++, ("0" + e.getSeconds()).slice(-2));
            return a.s[31]++, n + "-" + t + "-" + r + "T" + o + ":" + i + ":" + A + "Z";
          }
        }]);

        return g;
      }(c.XmlComponent);

      a.s[32]++, n.DateComponent = g, a.s[36]++, n.Created =
      /*#__PURE__*/
      function (_g3) {
        _inherits(_class45, _g3);

        function _class45() {
          var _this249;

          _classCallCheck(this, _class45);

          a.f[8]++, a.s[33]++, _this249 = _possibleConstructorReturn(this, _getPrototypeOf(_class45).call(this, "dcterms:created")), a.s[34]++, _this249.root.push(new u.DocumentAttributes({
            type: "dcterms:W3CDTF"
          })), a.s[35]++, _this249.root.push(_this249.getCurrentDate());
          return _this249;
        }

        return _class45;
      }(g), a.s[40]++, n.Modified =
      /*#__PURE__*/
      function (_g4) {
        _inherits(_class46, _g4);

        function _class46() {
          var _this250;

          _classCallCheck(this, _class46);

          a.f[9]++, a.s[37]++, _this250 = _possibleConstructorReturn(this, _getPrototypeOf(_class46).call(this, "dcterms:modified")), a.s[38]++, _this250.root.push(new u.DocumentAttributes({
            type: "dcterms:W3CDTF"
          })), a.s[39]++, _this250.root.push(_this250.getCurrentDate());
          return _this250;
        }

        return _class46;
      }(g);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\document.ts", o = "7c0b241610e64d180a4693bdb3cfb5958c253b03", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\document.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 20
            },
            end: {
              line: 4,
              column: 43
            }
          },
          3: {
            start: {
              line: 5,
              column: 16
            },
            end: {
              line: 5,
              column: 35
            }
          },
          4: {
            start: {
              line: 6,
              column: 15
            },
            end: {
              line: 6,
              column: 32
            }
          },
          5: {
            start: {
              line: 7,
              column: 30
            },
            end: {
              line: 7,
              column: 62
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 28
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 29,
              column: 12
            }
          },
          8: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 62
            }
          },
          9: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 34
            }
          },
          10: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 34
            }
          },
          11: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 20
            }
          },
          12: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 38,
              column: 28
            }
          },
          13: {
            start: {
              line: 39,
              column: 8
            },
            end: {
              line: 39,
              column: 20
            }
          },
          14: {
            start: {
              line: 42,
              column: 21
            },
            end: {
              line: 42,
              column: 52
            }
          },
          15: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 32
            }
          },
          16: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 44,
              column: 20
            }
          },
          17: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 30
            }
          },
          18: {
            start: {
              line: 50,
              column: 22
            },
            end: {
              line: 50,
              column: 51
            }
          },
          19: {
            start: {
              line: 51,
              column: 8
            },
            end: {
              line: 51,
              column: 29
            }
          },
          20: {
            start: {
              line: 52,
              column: 8
            },
            end: {
              line: 52,
              column: 21
            }
          },
          21: {
            start: {
              line: 55,
              column: 8
            },
            end: {
              line: 55,
              column: 25
            }
          },
          22: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 47
            }
          },
          23: {
            start: {
              line: 61,
              column: 8
            },
            end: {
              line: 61,
              column: 41
            }
          },
          24: {
            start: {
              line: 64,
              column: 0
            },
            end: {
              line: 64,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 9,
                column: 4
              },
              end: {
                line: 9,
                column: 5
              }
            },
            loc: {
              start: {
                line: 9,
                column: 42
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 9
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 33,
                column: 4
              },
              end: {
                line: 33,
                column: 5
              }
            },
            loc: {
              start: {
                line: 33,
                column: 28
              },
              end: {
                line: 36,
                column: 5
              }
            },
            line: 33
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 37,
                column: 4
              },
              end: {
                line: 37,
                column: 5
              }
            },
            loc: {
              start: {
                line: 37,
                column: 28
              },
              end: {
                line: 40,
                column: 5
              }
            },
            line: 37
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 41,
                column: 4
              },
              end: {
                line: 41,
                column: 5
              }
            },
            loc: {
              start: {
                line: 41,
                column: 26
              },
              end: {
                line: 45,
                column: 5
              }
            },
            line: 41
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 46,
                column: 4
              },
              end: {
                line: 46,
                column: 5
              }
            },
            loc: {
              start: {
                line: 46,
                column: 20
              },
              end: {
                line: 48,
                column: 5
              }
            },
            line: 46
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 49,
                column: 4
              },
              end: {
                line: 49,
                column: 5
              }
            },
            loc: {
              start: {
                line: 49,
                column: 28
              },
              end: {
                line: 53,
                column: 5
              }
            },
            line: 49
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 54,
                column: 4
              },
              end: {
                line: 54,
                column: 5
              }
            },
            loc: {
              start: {
                line: 54,
                column: 15
              },
              end: {
                line: 56,
                column: 5
              }
            },
            line: 54
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 57,
                column: 4
              },
              end: {
                line: 57,
                column: 5
              }
            },
            loc: {
              start: {
                line: 57,
                column: 26
              },
              end: {
                line: 59,
                column: 5
              }
            },
            line: 57
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 60,
                column: 4
              },
              end: {
                line: 60,
                column: 5
              }
            },
            loc: {
              start: {
                line: 60,
                column: 20
              },
              end: {
                line: 62,
                column: 5
              }
            },
            line: 60
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/document.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\document.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,4CAAyC;AACzC,oCAAiC;AAEjC,iCAA8B;AAE9B,+DAA2D;AAE3D,cAAsB,SAAQ,6BAAY;IAGtC,YAAY,wBAAmD;QAC3D,KAAK,CAAC,YAAY,CAAC,CAAC;QACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wCAAkB,CAAC;YACnB,GAAG,EAAE,oEAAoE;YACzE,EAAE,EAAE,6DAA6D;YACjE,CAAC,EAAE,yCAAyC;YAC5C,CAAC,EAAE,qEAAqE;YACxE,CAAC,EAAE,4DAA4D;YAC/D,CAAC,EAAE,+BAA+B;YAClC,IAAI,EAAE,qEAAqE;YAC3E,EAAE,EAAE,wEAAwE;YAC5E,GAAG,EAAE,uCAAuC;YAC5C,CAAC,EAAE,8DAA8D;YACjE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,GAAG,EAAE,iEAAiE;YACtE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,SAAS,EAAE,cAAc;SAC5B,CAAC,CACL,CAAC;QACF,IAAI,CAAC,IAAI,GAAG,IAAI,WAAI,CAAC,wBAAwB,CAAC,CAAC;QAC/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;IAC9B,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;QAC1B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,kBAAkB,CAAC,GAAoB;QAC1C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QACpB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe,CAAC,IAAa;QAChC,MAAM,IAAI,GAAG,IAAI,qBAAS,CAAC,IAAI,CAAC,CAAC;QACjC,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,CAAC;QACxB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;IAEM,WAAW,CAAC,IAAY,EAAE,IAAY;QACzC,MAAM,KAAK,GAAG,IAAI,aAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;QACpC,IAAI,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;QACrB,OAAO,KAAK,CAAC;IACjB,CAAC;IAED,IAAW,IAAI;QACX,OAAO,IAAI,CAAC,IAAI,CAAC;IACrB,CAAC;IAEM,mBAAmB;QACtB,OAAO,IAAI,CAAC,IAAI,CAAC,mBAAmB,EAAE,CAAC;IAC3C,CAAC;IAEM,aAAa;QAChB,OAAO,IAAI,CAAC,IAAI,CAAC,aAAa,EAAE,CAAC;IACrC,CAAC;CACJ;AAnED,4BAmEC",
          sourcesContent: ['// http://officeopenxml.com/WPdocument.php\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { Paragraph } from "../paragraph";\r\nimport { Table } from "../table";\r\nimport { TableOfContents } from "../table-of-contents";\r\nimport { Body } from "./body";\r\nimport { SectionPropertiesOptions } from "./body/section-properties";\r\nimport { DocumentAttributes } from "./document-attributes";\r\n\r\nexport class Document extends XmlComponent {\r\n    private readonly body: Body;\r\n\r\n    constructor(sectionPropertiesOptions?: SectionPropertiesOptions) {\r\n        super("w:document");\r\n        this.root.push(\r\n            new DocumentAttributes({\r\n                wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",\r\n                mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",\r\n                o: "urn:schemas-microsoft-com:office:office",\r\n                r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",\r\n                m: "http://schemas.openxmlformats.org/officeDocument/2006/math",\r\n                v: "urn:schemas-microsoft-com:vml",\r\n                wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",\r\n                wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",\r\n                w10: "urn:schemas-microsoft-com:office:word",\r\n                w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",\r\n                w14: "http://schemas.microsoft.com/office/word/2010/wordml",\r\n                w15: "http://schemas.microsoft.com/office/word/2012/wordml",\r\n                wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",\r\n                wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",\r\n                wne: "http://schemas.microsoft.com/office/word/2006/wordml",\r\n                wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",\r\n                Ignorable: "w14 w15 wp14",\r\n            }),\r\n        );\r\n        this.body = new Body(sectionPropertiesOptions);\r\n        this.root.push(this.body);\r\n    }\r\n\r\n    public addParagraph(paragraph: Paragraph): Document {\r\n        this.body.push(paragraph);\r\n        return this;\r\n    }\r\n\r\n    public addTableOfContents(toc: TableOfContents): Document {\r\n        this.body.push(toc);\r\n        return this;\r\n    }\r\n\r\n    public createParagraph(text?: string): Paragraph {\r\n        const para = new Paragraph(text);\r\n        this.addParagraph(para);\r\n        return para;\r\n    }\r\n\r\n    public addTable(table: Table): void {\r\n        this.body.push(table);\r\n    }\r\n\r\n    public createTable(rows: number, cols: number): Table {\r\n        const table = new Table(rows, cols);\r\n        this.addTable(table);\r\n        return table;\r\n    }\r\n\r\n    public get Body(): Body {\r\n        return this.body;\r\n    }\r\n\r\n    public getTablesOfContents(): TableOfContents[] {\r\n        return this.body.getTablesOfContents();\r\n    }\r\n\r\n    public getParagraphs(): Paragraph[] {\r\n        return this.body.getParagraphs();\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(2)),
          p = (a.s[3]++, t(23)),
          m = (a.s[4]++, t(87)),
          C = (a.s[5]++, t(11));

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent133) {
        _inherits(d, _c$XmlComponent133);

        function d(e) {
          var _this251;

          _classCallCheck(this, d);

          a.f[0]++, a.s[6]++, _this251 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "w:document")), a.s[7]++, _this251.root.push(new C.DocumentAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
          })), a.s[8]++, _this251.body = new m.Body(e), a.s[9]++, _this251.root.push(_this251.body);
          return _this251;
        }

        _createClass(d, [{
          key: "addParagraph",
          value: function addParagraph(e) {
            return a.f[1]++, a.s[10]++, this.body.push(e), a.s[11]++, this;
          }
        }, {
          key: "addTableOfContents",
          value: function addTableOfContents(e) {
            return a.f[2]++, a.s[12]++, this.body.push(e), a.s[13]++, this;
          }
        }, {
          key: "createParagraph",
          value: function createParagraph(e) {
            a.f[3]++;
            var n = (a.s[14]++, new u.Paragraph(e));
            return a.s[15]++, this.addParagraph(n), a.s[16]++, n;
          }
        }, {
          key: "addTable",
          value: function addTable(e) {
            a.f[4]++, a.s[17]++, this.body.push(e);
          }
        }, {
          key: "createTable",
          value: function createTable(e, n) {
            a.f[5]++;
            var t = (a.s[18]++, new p.Table(e, n));
            return a.s[19]++, this.addTable(t), a.s[20]++, t;
          }
        }, {
          key: "getTablesOfContents",
          value: function getTablesOfContents() {
            return a.f[7]++, a.s[22]++, this.body.getTablesOfContents();
          }
        }, {
          key: "getParagraphs",
          value: function getParagraphs() {
            return a.f[8]++, a.s[23]++, this.body.getParagraphs();
          }
        }, {
          key: "Body",
          get: function get() {
            return a.f[6]++, a.s[21]++, this.body;
          }
        }]);

        return d;
      }(c.XmlComponent);

      a.s[24]++, n.Document = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\body.ts", o = "21133e72a543d9c9cc2059288851f521e2762d36", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\body.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 12
            },
            end: {
              line: 4,
              column: 28
            }
          },
          3: {
            start: {
              line: 5,
              column: 29
            },
            end: {
              line: 5,
              column: 79
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 24
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 27
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 99
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 48
            }
          },
          8: {
            start: {
              line: 14,
              column: 31
            },
            end: {
              line: 14,
              column: 50
            }
          },
          9: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 68
            }
          },
          10: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 22,
              column: 9
            }
          },
          11: {
            start: {
              line: 17,
              column: 12
            },
            end: {
              line: 17,
              column: 40
            }
          },
          12: {
            start: {
              line: 20,
              column: 27
            },
            end: {
              line: 20,
              column: 82
            }
          },
          13: {
            start: {
              line: 21,
              column: 12
            },
            end: {
              line: 21,
              column: 83
            }
          },
          14: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 27,
              column: 9
            }
          },
          15: {
            start: {
              line: 26,
              column: 12
            },
            end: {
              line: 26,
              column: 45
            }
          },
          16: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 34
            }
          },
          17: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 34
            }
          },
          18: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 35
            }
          },
          19: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 81
            }
          },
          20: {
            start: {
              line: 37,
              column: 43
            },
            end: {
              line: 37,
              column: 79
            }
          },
          21: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 75
            }
          },
          22: {
            start: {
              line: 40,
              column: 43
            },
            end: {
              line: 40,
              column: 73
            }
          },
          23: {
            start: {
              line: 43,
              column: 26
            },
            end: {
              line: 43,
              column: 45
            }
          },
          24: {
            start: {
              line: 44,
              column: 27
            },
            end: {
              line: 44,
              column: 56
            }
          },
          25: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 44
            }
          },
          26: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 46,
              column: 46
            }
          },
          27: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 25
            }
          },
          28: {
            start: {
              line: 50,
              column: 0
            },
            end: {
              line: 50,
              column: 20
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 42
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 24
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 13
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 24,
                column: 4
              },
              end: {
                line: 24,
                column: 5
              }
            },
            loc: {
              start: {
                line: 24,
                column: 17
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 24
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 20
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 30
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 33,
                column: 4
              },
              end: {
                line: 33,
                column: 5
              }
            },
            loc: {
              start: {
                line: 33,
                column: 25
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 33
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 36,
                column: 4
              },
              end: {
                line: 36,
                column: 5
              }
            },
            loc: {
              start: {
                line: 36,
                column: 26
              },
              end: {
                line: 38,
                column: 5
              }
            },
            line: 36
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 37,
                column: 32
              },
              end: {
                line: 37,
                column: 33
              }
            },
            loc: {
              start: {
                line: 37,
                column: 43
              },
              end: {
                line: 37,
                column: 79
              }
            },
            line: 37
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 39,
                column: 4
              },
              end: {
                line: 39,
                column: 5
              }
            },
            loc: {
              start: {
                line: 39,
                column: 20
              },
              end: {
                line: 41,
                column: 5
              }
            },
            line: 39
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 40,
                column: 32
              },
              end: {
                line: 40,
                column: 33
              }
            },
            loc: {
              start: {
                line: 40,
                column: 43
              },
              end: {
                line: 40,
                column: 73
              }
            },
            line: 40
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 42,
                column: 4
              },
              end: {
                line: 42,
                column: 5
              }
            },
            loc: {
              start: {
                line: 42,
                column: 36
              },
              end: {
                line: 48,
                column: 5
              }
            },
            line: 42
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 16,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 16,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            }, {
              start: {
                line: 16,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            }],
            line: 16
          },
          1: {
            loc: {
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            }, {
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            }],
            line: 25
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/body.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\body.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmE;AACnE,6BAAwE;AACxE,gFAAsG;AAEtG,UAAkB,SAAQ,6BAAY;IAKlC,YAAY,wBAAmD;QAC3D,KAAK,CAAC,QAAQ,CAAC,CAAC;QAHH,aAAQ,GAAwB,EAAE,CAAC;QAKhD,IAAI,CAAC,cAAc,GAAG,IAAI,sCAAiB,CAAC,wBAAwB,CAAC,CAAC;QACtE,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,IAAI,CAAC,cAAc,CAAC,CAAC;IAC5C,CAAC;IAUM,UAAU,CAAC,OAAqD;QACnE,MAAM,cAAc,GAAG,IAAI,CAAC,QAAQ,CAAC,GAAG,EAAuB,CAAC;QAChE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,sBAAsB,CAAC,cAAc,CAAC,CAAC,CAAC;QAC5D,IAAI,OAAO,YAAY,sCAAiB,EAAE;YACtC,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;SAC/B;aAAM;YACH,MAAM,MAAM,qBACL,IAAI,CAAC,cAAc,CAAC,OAAO,EAC3B,OAAO,CACb,CAAC;YACF,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,IAAI,sCAAiB,CAAC,MAAM,CAAC,CAAC,CAAC;SACrD;IACL,CAAC;IACM,UAAU;QACb,IAAI,IAAI,CAAC,QAAQ,CAAC,MAAM,KAAK,CAAC,EAAE;YAC5B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,CAAC;SACpC;QAED,OAAO,KAAK,CAAC,UAAU,EAAE,CAAC;IAC9B,CAAC;IAEM,IAAI,CAAC,SAAuB;QAC/B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;IAC9B,CAAC;IAED,IAAW,cAAc;QACrB,OAAO,IAAI,CAAC,cAAc,CAAC;IAC/B,CAAC;IAEM,mBAAmB;QACtB,OAAO,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,KAAK,EAAE,EAAE,CAAC,KAAK,YAAY,mBAAe,CAAsB,CAAC;IAC9F,CAAC;IAEM,aAAa;QAChB,OAAO,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,KAAK,EAAE,EAAE,CAAC,KAAK,YAAY,aAAS,CAAgB,CAAC;IAClF,CAAC;IAEO,sBAAsB,CAAC,OAA0B;QACrD,MAAM,SAAS,GAAG,IAAI,aAAS,EAAE,CAAC;QAClC,MAAM,UAAU,GAAG,IAAI,uBAAmB,EAAE,CAAC;QAC7C,UAAU,CAAC,eAAe,CAAC,OAAO,CAAC,CAAC;QACpC,SAAS,CAAC,eAAe,CAAC,UAAU,CAAC,CAAC;QACtC,OAAO,SAAS,CAAC;IACrB,CAAC;CACJ;AAhED,oBAgEC",
          sourcesContent: ['import { IXmlableObject, XmlComponent } from "file/xml-components";\r\nimport { Paragraph, ParagraphProperties, TableOfContents } from "../..";\r\nimport { SectionProperties, SectionPropertiesOptions } from "./section-properties/section-properties";\r\n\r\nexport class Body extends XmlComponent {\r\n    private readonly defaultSection: SectionProperties;\r\n\r\n    private readonly sections: SectionProperties[] = [];\r\n\r\n    constructor(sectionPropertiesOptions?: SectionPropertiesOptions) {\r\n        super("w:body");\r\n\r\n        this.defaultSection = new SectionProperties(sectionPropertiesOptions);\r\n        this.sections.push(this.defaultSection);\r\n    }\r\n\r\n    /**\r\n     * Adds new section properties.\r\n     * Note: Previous section is created in paragraph after the current element, and then new section will be added.\r\n     * The spec says:\r\n     *  - section element should be in the last paragraph of the section\r\n     *  - last section should be direct child of body\r\n     * @param section new section\r\n     */\r\n    public addSection(section: SectionPropertiesOptions | SectionProperties): void {\r\n        const currentSection = this.sections.pop() as SectionProperties;\r\n        this.root.push(this.createSectionParagraph(currentSection));\r\n        if (section instanceof SectionProperties) {\r\n            this.sections.push(section);\r\n        } else {\r\n            const params = {\r\n                ...this.defaultSection.Options,\r\n                ...section,\r\n            };\r\n            this.sections.push(new SectionProperties(params));\r\n        }\r\n    }\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        if (this.sections.length === 1) {\r\n            this.root.push(this.sections[0]);\r\n        }\r\n\r\n        return super.prepForXml();\r\n    }\r\n\r\n    public push(component: XmlComponent): void {\r\n        this.root.push(component);\r\n    }\r\n\r\n    public get DefaultSection(): SectionProperties {\r\n        return this.defaultSection;\r\n    }\r\n\r\n    public getTablesOfContents(): TableOfContents[] {\r\n        return this.root.filter((child) => child instanceof TableOfContents) as TableOfContents[];\r\n    }\r\n\r\n    public getParagraphs(): Paragraph[] {\r\n        return this.root.filter((child) => child instanceof Paragraph) as Paragraph[];\r\n    }\r\n\r\n    private createSectionParagraph(section: SectionProperties): Paragraph {\r\n        const paragraph = new Paragraph();\r\n        const properties = new ParagraphProperties();\r\n        properties.addChildElement(section);\r\n        paragraph.addChildElement(properties);\r\n        return paragraph;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(26)),
          p = (a.s[3]++, t(88));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent134) {
        _inherits(m, _c$XmlComponent134);

        function m(e) {
          var _this252;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this252 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:body")), a.s[5]++, _this252.sections = [], a.s[6]++, _this252.defaultSection = new p.SectionProperties(e), a.s[7]++, _this252.sections.push(_this252.defaultSection);
          return _this252;
        }

        _createClass(m, [{
          key: "addSection",
          value: function addSection(e) {
            a.f[1]++;
            var n = (a.s[8]++, this.sections.pop());
            if (a.s[9]++, this.root.push(this.createSectionParagraph(n)), a.s[10]++, e instanceof p.SectionProperties) a.b[0][0]++, a.s[11]++, this.sections.push(e);else {
              a.b[0][1]++;

              var _n6 = (a.s[12]++, Object.assign({}, this.defaultSection.Options, e));

              a.s[13]++, this.sections.push(new p.SectionProperties(_n6));
            }
          }
        }, {
          key: "prepForXml",
          value: function prepForXml() {
            return a.f[2]++, a.s[14]++, 1 === this.sections.length ? (a.b[1][0]++, a.s[15]++, this.root.push(this.sections[0])) : a.b[1][1]++, a.s[16]++, _get(_getPrototypeOf(m.prototype), "prepForXml", this).call(this);
          }
        }, {
          key: "push",
          value: function push(e) {
            a.f[3]++, a.s[17]++, this.root.push(e);
          }
        }, {
          key: "getTablesOfContents",
          value: function getTablesOfContents() {
            return a.f[5]++, a.s[19]++, this.root.filter(function (e) {
              return a.f[6]++, a.s[20]++, e instanceof u.TableOfContents;
            });
          }
        }, {
          key: "getParagraphs",
          value: function getParagraphs() {
            return a.f[7]++, a.s[21]++, this.root.filter(function (e) {
              return a.f[8]++, a.s[22]++, e instanceof u.Paragraph;
            });
          }
        }, {
          key: "createSectionParagraph",
          value: function createSectionParagraph(e) {
            a.f[9]++;
            var n = (a.s[23]++, new u.Paragraph()),
                t = (a.s[24]++, new u.ParagraphProperties());
            return a.s[25]++, t.addChildElement(e), a.s[26]++, n.addChildElement(t), a.s[27]++, n;
          }
        }, {
          key: "DefaultSection",
          get: function get() {
            return a.f[4]++, a.s[18]++, this.defaultSection;
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[28]++, n.Body = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\columns\\columns.ts", o = "cda8eb6e92b7c80813db038a71f0ac0b71ddf830", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\columns\\columns.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 29
            },
            end: {
              line: 4,
              column: 60
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 24
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 12
            }
          },
          5: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 26
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 23
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/columns/columns.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\columns\\columns.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,6DAAyD;AAEzD,aAAqB,SAAQ,6BAAY;IACrC,YAAY,KAAa;QACrB,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,sCAAiB,CAAC;YAClB,KAAK,EAAE,KAAK;SACf,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,0BASC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { ColumnsAttributes } from "./columns-attributes";\r\n\r\nexport class Columns extends XmlComponent {\r\n    constructor(space: number) {\r\n        super("w:cols");\r\n        this.root.push(\r\n            new ColumnsAttributes({\r\n                space: space,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(242));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent135) {
        _inherits(p, _c$XmlComponent135);

        function p(e) {
          var _this253;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this253 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:cols")), a.s[4]++, _this253.root.push(new u.ColumnsAttributes({
            space: e
          }));
          return _this253;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Columns = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\columns\\columns-attributes.ts", o = "f78cad090bb34960bd1f40914eeb74ef06dcabb3", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\columns\\columns-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/columns/columns-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\columns\\columns-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,uBAA+B,SAAQ,sCAAyC;IAAhF;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,SAAS;SACnB,CAAC;IACN,CAAC;CAAA;AAJD,8CAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IColumnsAttributes {\r\n    readonly space?: number;\r\n}\r\n\r\nexport class ColumnsAttributes extends XmlAttributeComponent<IColumnsAttributes> {\r\n    protected readonly xmlKeys = {\r\n        space: "w:space",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon57) {
        _inherits(u, _c$XmlAttributeCompon57);

        function u() {
          var _this254;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this254 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this254.xmlKeys = {
            space: "w:space"
          };
          return _this254;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.ColumnsAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\doc-grid\\doc-grid.ts", o = "6e9b63c2a581c02e3fd80b13323e569b06fb7b20", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\doc-grid\\doc-grid.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 30
            },
            end: {
              line: 4,
              column: 62
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 27
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 12
            }
          },
          5: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 27
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/doc-grid/doc-grid.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\doc-grid\\doc-grid.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,+DAA0D;AAE1D,kBAA0B,SAAQ,6BAAY;IAC1C,YAAY,SAAiB;QACzB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,uCAAiB,CAAC;YAClB,SAAS,EAAE,SAAS;SACvB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,oCASC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { DocGridAttributes } from "./doc-grid-attributes";\r\n\r\nexport class DocumentGrid extends XmlComponent {\r\n    constructor(linePitch: number) {\r\n        super("w:docGrid");\r\n        this.root.push(\r\n            new DocGridAttributes({\r\n                linePitch: linePitch,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(244));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent136) {
        _inherits(p, _c$XmlComponent136);

        function p(e) {
          var _this255;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this255 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:docGrid")), a.s[4]++, _this255.root.push(new u.DocGridAttributes({
            linePitch: e
          }));
          return _this255;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.DocumentGrid = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\doc-grid\\doc-grid-attributes.ts", o = "14077ecc54cba67cbddbe69a02ea12e18ab68118", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\doc-grid\\doc-grid-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 46
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/doc-grid/doc-grid-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\doc-grid\\doc-grid-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,uBAA+B,SAAQ,sCAAmD;IAA1F;;QACuB,YAAO,GAAG;YACzB,SAAS,EAAE,aAAa;SAC3B,CAAC;IACN,CAAC;CAAA;AAJD,8CAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IDocGridAttributesProperties {\r\n    readonly linePitch?: number;\r\n}\r\n\r\nexport class DocGridAttributes extends XmlAttributeComponent<IDocGridAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        linePitch: "w:linePitch",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon58) {
        _inherits(u, _c$XmlAttributeCompon58);

        function u() {
          var _this256;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this256 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this256.xmlKeys = {
            linePitch: "w:linePitch"
          };
          return _this256;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.DocGridAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-border\\page-borders.ts", o = "0dc869c17010747ea59e80226a6ff42c75a440af", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-border\\page-borders.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 9,
              column: 86
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 48
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 50
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 57
            }
          },
          6: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 14,
              column: 95
            }
          },
          7: {
            start: {
              line: 12,
              column: 4
            },
            end: {
              line: 12,
              column: 42
            }
          },
          8: {
            start: {
              line: 13,
              column: 4
            },
            end: {
              line: 13,
              column: 42
            }
          },
          9: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 19,
              column: 83
            }
          },
          10: {
            start: {
              line: 17,
              column: 4
            },
            end: {
              line: 17,
              column: 38
            }
          },
          11: {
            start: {
              line: 18,
              column: 4
            },
            end: {
              line: 18,
              column: 40
            }
          },
          12: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 28
            }
          },
          13: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 28,
              column: 10
            }
          },
          14: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 19
            }
          },
          15: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 57
            }
          },
          16: {
            start: {
              line: 39,
              column: 8
            },
            end: {
              line: 39,
              column: 28
            }
          },
          17: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 44,
              column: 10
            }
          },
          18: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 29
            }
          },
          19: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 52,
              column: 9
            }
          },
          20: {
            start: {
              line: 51,
              column: 12
            },
            end: {
              line: 51,
              column: 19
            }
          },
          21: {
            start: {
              line: 53,
              column: 36
            },
            end: {
              line: 53,
              column: 38
            }
          },
          22: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 60,
              column: 9
            }
          },
          23: {
            start: {
              line: 55,
              column: 12
            },
            end: {
              line: 59,
              column: 14
            }
          },
          24: {
            start: {
              line: 61,
              column: 8
            },
            end: {
              line: 61,
              column: 73
            }
          },
          25: {
            start: {
              line: 62,
              column: 8
            },
            end: {
              line: 64,
              column: 9
            }
          },
          26: {
            start: {
              line: 63,
              column: 12
            },
            end: {
              line: 63,
              column: 75
            }
          },
          27: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 67,
              column: 9
            }
          },
          28: {
            start: {
              line: 66,
              column: 12
            },
            end: {
              line: 66,
              column: 79
            }
          },
          29: {
            start: {
              line: 68,
              column: 8
            },
            end: {
              line: 70,
              column: 9
            }
          },
          30: {
            start: {
              line: 69,
              column: 12
            },
            end: {
              line: 69,
              column: 81
            }
          },
          31: {
            start: {
              line: 71,
              column: 8
            },
            end: {
              line: 73,
              column: 9
            }
          },
          32: {
            start: {
              line: 72,
              column: 12
            },
            end: {
              line: 72,
              column: 77
            }
          },
          33: {
            start: {
              line: 76,
              column: 8
            },
            end: {
              line: 78,
              column: 9
            }
          },
          34: {
            start: {
              line: 77,
              column: 12
            },
            end: {
              line: 77,
              column: 38
            }
          },
          35: {
            start: {
              line: 81,
              column: 0
            },
            end: {
              line: 81,
              column: 34
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 30
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 1
              },
              end: {
                line: 11,
                column: 2
              }
            },
            loc: {
              start: {
                line: 11,
                column: 33
              },
              end: {
                line: 14,
                column: 1
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 16,
                column: 1
              },
              end: {
                line: 16,
                column: 2
              }
            },
            loc: {
              start: {
                line: 16,
                column: 29
              },
              end: {
                line: 19,
                column: 1
              }
            },
            line: 16
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 18
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 21
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 32,
                column: 4
              },
              end: {
                line: 32,
                column: 5
              }
            },
            loc: {
              start: {
                line: 32,
                column: 30
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 32
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 38,
                column: 4
              },
              end: {
                line: 38,
                column: 5
              }
            },
            loc: {
              start: {
                line: 38,
                column: 18
              },
              end: {
                line: 45,
                column: 5
              }
            },
            line: 38
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 48,
                column: 4
              },
              end: {
                line: 48,
                column: 5
              }
            },
            loc: {
              start: {
                line: 48,
                column: 25
              },
              end: {
                line: 74,
                column: 5
              }
            },
            line: 48
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 75,
                column: 4
              },
              end: {
                line: 75,
                column: 5
              }
            },
            loc: {
              start: {
                line: 75,
                column: 17
              },
              end: {
                line: 79,
                column: 5
              }
            },
            line: 75
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 9,
                column: 23
              },
              end: {
                line: 9,
                column: 84
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 9,
                column: 23
              },
              end: {
                line: 9,
                column: 48
              }
            }, {
              start: {
                line: 9,
                column: 53
              },
              end: {
                line: 9,
                column: 83
              }
            }],
            line: 9
          },
          1: {
            loc: {
              start: {
                line: 14,
                column: 26
              },
              end: {
                line: 14,
                column: 93
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 14,
                column: 26
              },
              end: {
                line: 14,
                column: 54
              }
            }, {
              start: {
                line: 14,
                column: 59
              },
              end: {
                line: 14,
                column: 92
              }
            }],
            line: 14
          },
          2: {
            loc: {
              start: {
                line: 19,
                column: 22
              },
              end: {
                line: 19,
                column: 81
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 19,
                column: 22
              },
              end: {
                line: 19,
                column: 46
              }
            }, {
              start: {
                line: 19,
                column: 51
              },
              end: {
                line: 19,
                column: 80
              }
            }],
            line: 19
          },
          3: {
            loc: {
              start: {
                line: 50,
                column: 8
              },
              end: {
                line: 52,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 50,
                column: 8
              },
              end: {
                line: 52,
                column: 9
              }
            }, {
              start: {
                line: 50,
                column: 8
              },
              end: {
                line: 52,
                column: 9
              }
            }],
            line: 50
          },
          4: {
            loc: {
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 60,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 60,
                column: 9
              }
            }, {
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 60,
                column: 9
              }
            }],
            line: 54
          },
          5: {
            loc: {
              start: {
                line: 62,
                column: 8
              },
              end: {
                line: 64,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 62,
                column: 8
              },
              end: {
                line: 64,
                column: 9
              }
            }, {
              start: {
                line: 62,
                column: 8
              },
              end: {
                line: 64,
                column: 9
              }
            }],
            line: 62
          },
          6: {
            loc: {
              start: {
                line: 65,
                column: 8
              },
              end: {
                line: 67,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 65,
                column: 8
              },
              end: {
                line: 67,
                column: 9
              }
            }, {
              start: {
                line: 65,
                column: 8
              },
              end: {
                line: 67,
                column: 9
              }
            }],
            line: 65
          },
          7: {
            loc: {
              start: {
                line: 68,
                column: 8
              },
              end: {
                line: 70,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 68,
                column: 8
              },
              end: {
                line: 70,
                column: 9
              }
            }, {
              start: {
                line: 68,
                column: 8
              },
              end: {
                line: 70,
                column: 9
              }
            }],
            line: 68
          },
          8: {
            loc: {
              start: {
                line: 71,
                column: 8
              },
              end: {
                line: 73,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 71,
                column: 8
              },
              end: {
                line: 73,
                column: 9
              }
            }, {
              start: {
                line: 71,
                column: 8
              },
              end: {
                line: 73,
                column: 9
              }
            }],
            line: 71
          },
          9: {
            loc: {
              start: {
                line: 76,
                column: 8
              },
              end: {
                line: 78,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 76,
                column: 8
              },
              end: {
                line: 78,
                column: 9
              }
            }, {
              start: {
                line: 76,
                column: 8
              },
              end: {
                line: 78,
                column: 9
              }
            }],
            line: 76
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0],
          6: [0, 0],
          7: [0, 0],
          8: [0, 0],
          9: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-border/page-borders.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-border\\page-borders.ts"],
          names: [],
          mappings: ";;AAEA,wDAA0F;AAE1F,IAAY,iBAIX;AAJD,WAAY,iBAAiB;IACzB,2CAAsB,CAAA;IACtB,6CAAwB,CAAA;IACxB,oDAA+B,CAAA;AACnC,CAAC,EAJW,iBAAiB,GAAjB,yBAAiB,KAAjB,yBAAiB,QAI5B;AAED,IAAY,oBAGX;AAHD,WAAY,oBAAoB;IAC5B,qCAAa,CAAA;IACb,qCAAa,CAAA;AACjB,CAAC,EAHW,oBAAoB,GAApB,4BAAoB,KAApB,4BAAoB,QAG/B;AAED,IAAY,gBAGX;AAHD,WAAY,gBAAgB;IACxB,iCAAa,CAAA;IACb,mCAAe,CAAA;AACnB,CAAC,EAHW,gBAAgB,GAAhB,wBAAgB,KAAhB,wBAAgB,QAG3B;AAuBD,yBAA0B,SAAQ,sCAA+C;IAAjF;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;YACd,IAAI,EAAE,QAAQ;YACd,KAAK,EAAE,SAAS;YAChB,KAAK,EAAE,SAAS;SACnB,CAAC;IACN,CAAC;CAAA;AAED,gBAAiB,SAAQ,6BAAY;IACjC,YAAY,GAAW,EAAE,OAAiC;QACtD,KAAK,CAAC,GAAG,CAAC,CAAC;QAEX,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,OAAO,CAAC,CAAC,CAAC;IACrD,CAAC;CACJ;AAED,2BAA4B,SAAQ,sCAA4C;IAAhF;;QACuB,YAAO,GAAG;YACzB,OAAO,EAAE,WAAW;YACpB,UAAU,EAAE,cAAc;YAC1B,MAAM,EAAE,UAAU;SACrB,CAAC;IACN,CAAC;CAAA;AAED,iBAAyB,SAAQ,6BAAY;IACzC,YAAY,OAA6B;QACrC,KAAK,CAAC,aAAa,CAAC,CAAC;QAErB,IAAI,CAAC,OAAO,EAAE;YACV,OAAO;SACV;QAED,IAAI,qBAAqB,GAAG,EAAE,CAAC;QAE/B,IAAI,OAAO,CAAC,WAAW,EAAE;YACrB,qBAAqB,GAAG;gBACpB,OAAO,EAAE,OAAO,CAAC,WAAW,CAAC,OAAO;gBACpC,UAAU,EAAE,OAAO,CAAC,WAAW,CAAC,UAAU;gBAC1C,MAAM,EAAE,OAAO,CAAC,WAAW,CAAC,MAAM;aACrC,CAAC;SACL;QAED,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,qBAAqB,CAAC,qBAAqB,CAAC,CAAC,CAAC;QAEjE,IAAI,OAAO,CAAC,aAAa,EAAE;YACvB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,UAAU,CAAC,OAAO,EAAE,OAAO,CAAC,aAAa,CAAC,CAAC,CAAC;SAClE;QACD,IAAI,OAAO,CAAC,eAAe,EAAE;YACzB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,UAAU,CAAC,SAAS,EAAE,OAAO,CAAC,eAAe,CAAC,CAAC,CAAC;SACtE;QACD,IAAI,OAAO,CAAC,gBAAgB,EAAE;YAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,UAAU,CAAC,UAAU,EAAE,OAAO,CAAC,gBAAgB,CAAC,CAAC,CAAC;SACxE;QACD,IAAI,OAAO,CAAC,cAAc,EAAE;YACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,UAAU,CAAC,QAAQ,EAAE,OAAO,CAAC,cAAc,CAAC,CAAC,CAAC;SACpE;IACL,CAAC;IAEM,UAAU;QACb,IAAI,IAAI,CAAC,IAAI,CAAC,MAAM,GAAG,CAAC,EAAE;YACtB,OAAO,KAAK,CAAC,UAAU,EAAE,CAAC;SAC7B;IACL,CAAC;CACJ;AAvCD,kCAuCC",
          sourcesContent: ['// http://officeopenxml.com/WPsectionBorders.php\r\nimport { BorderStyle } from "file/styles";\r\nimport { IXmlableObject, XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport enum PageBorderDisplay {\r\n    ALL_PAGES = "allPages",\r\n    FIRST_PAGE = "firstPage",\r\n    NOT_FIRST_PAGE = "notFirstPage",\r\n}\r\n\r\nexport enum PageBorderOffsetFrom {\r\n    PAGE = "page",\r\n    TEXT = "text",\r\n}\r\n\r\nexport enum PageBorderZOrder {\r\n    BACK = "back",\r\n    FRONT = "front",\r\n}\r\n\r\nexport interface IPageBorderAttributes {\r\n    readonly display?: PageBorderDisplay;\r\n    readonly offsetFrom?: PageBorderOffsetFrom;\r\n    readonly zOrder?: PageBorderZOrder;\r\n}\r\n\r\nexport interface IPageBorderConfiguration {\r\n    readonly style?: BorderStyle;\r\n    readonly size?: number;\r\n    readonly color?: string;\r\n    readonly space?: number;\r\n}\r\n\r\nexport interface IPageBordersOptions {\r\n    readonly pageBorders?: IPageBorderAttributes;\r\n    readonly pageBorderTop?: IPageBorderConfiguration;\r\n    readonly pageBorderRight?: IPageBorderConfiguration;\r\n    readonly pageBorderBottom?: IPageBorderConfiguration;\r\n    readonly pageBorderLeft?: IPageBorderConfiguration;\r\n}\r\n\r\nclass PageBordeAttributes extends XmlAttributeComponent<IPageBorderConfiguration> {\r\n    protected readonly xmlKeys = {\r\n        style: "w:val",\r\n        size: "w:size",\r\n        color: "w:color",\r\n        space: "w:space",\r\n    };\r\n}\r\n\r\nclass PageBorder extends XmlComponent {\r\n    constructor(key: string, options: IPageBorderConfiguration) {\r\n        super(key);\r\n\r\n        this.root.push(new PageBordeAttributes(options));\r\n    }\r\n}\r\n\r\nclass PageBordersAttributes extends XmlAttributeComponent<IPageBorderAttributes> {\r\n    protected readonly xmlKeys = {\r\n        display: "w:display",\r\n        offsetFrom: "w:offsetFrom",\r\n        zOrder: "w:zOrder",\r\n    };\r\n}\r\n\r\nexport class PageBorders extends XmlComponent {\r\n    constructor(options?: IPageBordersOptions) {\r\n        super("w:pgBorders");\r\n\r\n        if (!options) {\r\n            return;\r\n        }\r\n\r\n        let pageBordersAttributes = {};\r\n\r\n        if (options.pageBorders) {\r\n            pageBordersAttributes = {\r\n                display: options.pageBorders.display,\r\n                offsetFrom: options.pageBorders.offsetFrom,\r\n                zOrder: options.pageBorders.zOrder,\r\n            };\r\n        }\r\n\r\n        this.root.push(new PageBordersAttributes(pageBordersAttributes));\r\n\r\n        if (options.pageBorderTop) {\r\n            this.root.push(new PageBorder("w:top", options.pageBorderTop));\r\n        }\r\n        if (options.pageBorderRight) {\r\n            this.root.push(new PageBorder("w:right", options.pageBorderRight));\r\n        }\r\n        if (options.pageBorderBottom) {\r\n            this.root.push(new PageBorder("w:bottom", options.pageBorderBottom));\r\n        }\r\n        if (options.pageBorderLeft) {\r\n            this.root.push(new PageBorder("w:left", options.pageBorderLeft));\r\n        }\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        if (this.root.length > 0) {\r\n            return super.prepForXml();\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.ALL_PAGES = "allPages", a.s[4]++, e.FIRST_PAGE = "firstPage", a.s[5]++, e.NOT_FIRST_PAGE = "notFirstPage";
      }((a.b[0][0]++, n.PageBorderDisplay || (a.b[0][1]++, n.PageBorderDisplay = {}))), a.s[6]++, function (e) {
        a.f[1]++, a.s[7]++, e.PAGE = "page", a.s[8]++, e.TEXT = "text";
      }((a.b[1][0]++, n.PageBorderOffsetFrom || (a.b[1][1]++, n.PageBorderOffsetFrom = {}))), a.s[9]++, function (e) {
        a.f[2]++, a.s[10]++, e.BACK = "back", a.s[11]++, e.FRONT = "front";
      }((a.b[2][0]++, n.PageBorderZOrder || (a.b[2][1]++, n.PageBorderZOrder = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon59) {
        _inherits(u, _c$XmlAttributeCompon59);

        function u() {
          var _this257;

          _classCallCheck(this, u);

          a.f[3]++, a.s[12]++, _this257 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[13]++, _this257.xmlKeys = {
            style: "w:val",
            size: "w:size",
            color: "w:color",
            space: "w:space"
          };
          return _this257;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent137) {
        _inherits(p, _c$XmlComponent137);

        function p(e, n) {
          var _this258;

          _classCallCheck(this, p);

          a.f[4]++, a.s[14]++, _this258 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, e)), a.s[15]++, _this258.root.push(new u(n));
          return _this258;
        }

        return p;
      }(c.XmlComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon60) {
        _inherits(m, _c$XmlAttributeCompon60);

        function m() {
          var _this259;

          _classCallCheck(this, m);

          a.f[5]++, a.s[16]++, _this259 = _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments)), a.s[17]++, _this259.xmlKeys = {
            display: "w:display",
            offsetFrom: "w:offsetFrom",
            zOrder: "w:zOrder"
          };
          return _this259;
        }

        return m;
      }(c.XmlAttributeComponent);

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent138) {
        _inherits(C, _c$XmlComponent138);

        function C(e) {
          var _this260;

          _classCallCheck(this, C);

          if (a.f[6]++, a.s[18]++, _this260 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:pgBorders")), a.s[19]++, !e) return _possibleConstructorReturn(_this260, (a.b[3][0]++, void a.s[20]++));
          a.b[3][1]++;
          var n = (a.s[21]++, {});
          a.s[22]++, e.pageBorders ? (a.b[4][0]++, a.s[23]++, n = {
            display: e.pageBorders.display,
            offsetFrom: e.pageBorders.offsetFrom,
            zOrder: e.pageBorders.zOrder
          }) : a.b[4][1]++, a.s[24]++, _this260.root.push(new m(n)), a.s[25]++, e.pageBorderTop ? (a.b[5][0]++, a.s[26]++, _this260.root.push(new p("w:top", e.pageBorderTop))) : a.b[5][1]++, a.s[27]++, e.pageBorderRight ? (a.b[6][0]++, a.s[28]++, _this260.root.push(new p("w:right", e.pageBorderRight))) : a.b[6][1]++, a.s[29]++, e.pageBorderBottom ? (a.b[7][0]++, a.s[30]++, _this260.root.push(new p("w:bottom", e.pageBorderBottom))) : a.b[7][1]++, a.s[31]++, e.pageBorderLeft ? (a.b[8][0]++, a.s[32]++, _this260.root.push(new p("w:left", e.pageBorderLeft))) : a.b[8][1]++;
          return _possibleConstructorReturn(_this260);
        }

        _createClass(C, [{
          key: "prepForXml",
          value: function prepForXml() {
            if (a.f[7]++, a.s[33]++, this.root.length > 0) return a.b[9][0]++, a.s[34]++, _get(_getPrototypeOf(C.prototype), "prepForXml", this).call(this);
            a.b[9][1]++;
          }
        }]);

        return C;
      }(c.XmlComponent);

      a.s[35]++, n.PageBorders = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-margin\\page-margin.ts", o = "035539df697575e0101106aa4c5686194eae9acb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-margin\\page-margin.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 33
            },
            end: {
              line: 4,
              column: 68
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 25
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 17,
              column: 12
            }
          },
          5: {
            start: {
              line: 20,
              column: 0
            },
            end: {
              line: 20,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 74
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-margin/page-margin.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-margin\\page-margin.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,qEAAgE;AAEhE,gBAAwB,SAAQ,6BAAY;IACxC,YAAY,GAAW,EAAE,KAAa,EAAE,MAAc,EAAE,IAAY,EAAE,MAAc,EAAE,MAAc,EAAE,MAAc,EAAE,MAAe;QACjI,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,6CAAoB,CAAC;YACrB,GAAG,EAAE,GAAG;YACR,KAAK,EAAE,KAAK;YACZ,MAAM,EAAE,MAAM;YACd,IAAI,EAAE,IAAI;YACV,MAAM,EAAE,MAAM;YACd,MAAM,EAAE,MAAM;YACd,MAAM,EAAE,MAAM;YACd,MAAM,EAAE,MAAM;SACjB,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAhBD,gCAgBC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { PageMarginAttributes } from "./page-margin-attributes";\r\n\r\nexport class PageMargin extends XmlComponent {\r\n    constructor(top: number, right: number, bottom: number, left: number, header: number, footer: number, gutter: number, mirror: boolean) {\r\n        super("w:pgMar");\r\n        this.root.push(\r\n            new PageMarginAttributes({\r\n                top: top,\r\n                right: right,\r\n                bottom: bottom,\r\n                left: left,\r\n                header: header,\r\n                footer: footer,\r\n                gutter: gutter,\r\n                mirror: mirror,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(247));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent139) {
        _inherits(p, _c$XmlComponent139);

        function p(e, n, t, r, o, i, A, s) {
          var _this261;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this261 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:pgMar")), a.s[4]++, _this261.root.push(new u.PageMarginAttributes({
            top: e,
            right: n,
            bottom: t,
            left: r,
            header: o,
            footer: i,
            gutter: A,
            mirror: s
          }));
          return _this261;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.PageMargin = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-margin\\page-margin-attributes.ts", o = "cae497b072e76223174ef68afaa3d1612dbcec0e", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-margin\\page-margin-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 16,
              column: 10
            }
          },
          4: {
            start: {
              line: 19,
              column: 0
            },
            end: {
              line: 19,
              column: 52
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-margin/page-margin-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-margin\\page-margin-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAa5D,0BAAkC,SAAQ,sCAA4C;IAAtF;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,OAAO;YACZ,KAAK,EAAE,SAAS;YAChB,MAAM,EAAE,UAAU;YAClB,IAAI,EAAE,QAAQ;YACd,MAAM,EAAE,UAAU;YAClB,MAAM,EAAE,UAAU;YAClB,MAAM,EAAE,UAAU;YAClB,MAAM,EAAE,iBAAiB;SAC5B,CAAC;IACN,CAAC;CAAA;AAXD,oDAWC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IPageMarginAttributes {\r\n    readonly top?: number;\r\n    readonly right?: number;\r\n    readonly bottom?: number;\r\n    readonly left?: number;\r\n    readonly header?: number;\r\n    readonly footer?: number;\r\n    readonly gutter?: number;\r\n    readonly mirror?: boolean;\r\n}\r\n\r\nexport class PageMarginAttributes extends XmlAttributeComponent<IPageMarginAttributes> {\r\n    protected readonly xmlKeys = {\r\n        top: "w:top",\r\n        right: "w:right",\r\n        bottom: "w:bottom",\r\n        left: "w:left",\r\n        header: "w:header",\r\n        footer: "w:footer",\r\n        gutter: "w:gutter",\r\n        mirror: "w:mirrorMargins",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon61) {
        _inherits(u, _c$XmlAttributeCompon61);

        function u() {
          var _this262;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this262 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this262.xmlKeys = {
            top: "w:top",
            right: "w:right",
            bottom: "w:bottom",
            left: "w:left",
            header: "w:header",
            footer: "w:footer",
            gutter: "w:gutter",
            mirror: "w:mirrorMargins"
          };
          return _this262;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.PageMarginAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-number\\page-number.ts", o = "b4344c6933fbe5296bac9e3be0f3a512689bb0b2", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-number\\page-number.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 18,
              column: 83
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 55
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 44
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 74
            }
          },
          6: {
            start: {
              line: 9,
              column: 4
            },
            end: {
              line: 9,
              column: 79
            }
          },
          7: {
            start: {
              line: 10,
              column: 4
            },
            end: {
              line: 10,
              column: 72
            }
          },
          8: {
            start: {
              line: 11,
              column: 4
            },
            end: {
              line: 11,
              column: 53
            }
          },
          9: {
            start: {
              line: 12,
              column: 4
            },
            end: {
              line: 12,
              column: 53
            }
          },
          10: {
            start: {
              line: 13,
              column: 4
            },
            end: {
              line: 13,
              column: 51
            }
          },
          11: {
            start: {
              line: 14,
              column: 4
            },
            end: {
              line: 14,
              column: 38
            }
          },
          12: {
            start: {
              line: 15,
              column: 4
            },
            end: {
              line: 15,
              column: 53
            }
          },
          13: {
            start: {
              line: 16,
              column: 4
            },
            end: {
              line: 16,
              column: 53
            }
          },
          14: {
            start: {
              line: 17,
              column: 4
            },
            end: {
              line: 17,
              column: 51
            }
          },
          15: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 28
            }
          },
          16: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 25,
              column: 10
            }
          },
          17: {
            start: {
              line: 28,
              column: 0
            },
            end: {
              line: 28,
              column: 60
            }
          },
          18: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 29
            }
          },
          19: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 35,
              column: 12
            }
          },
          20: {
            start: {
              line: 38,
              column: 0
            },
            end: {
              line: 38,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 1
              },
              end: {
                line: 5,
                column: 2
              }
            },
            loc: {
              start: {
                line: 5,
                column: 29
              },
              end: {
                line: 18,
                column: 1
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 18
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 20
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 37
              },
              end: {
                line: 36,
                column: 5
              }
            },
            line: 30
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 18,
                column: 22
              },
              end: {
                line: 18,
                column: 81
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 18,
                column: 22
              },
              end: {
                line: 18,
                column: 46
              }
            }, {
              start: {
                line: 18,
                column: 51
              },
              end: {
                line: 18,
                column: 80
              }
            }],
            line: 18
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-number/page-number.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-number\\page-number.ts"],
          names: [],
          mappings: ";;AACA,wDAA0E;AAE1E,IAAY,gBAaX;AAbD,WAAY,gBAAgB;IACxB,kDAA8B,CAAA;IAC9B,uCAAmB,CAAA;IACnB,qEAAiD,CAAA;IACjD,0EAAsD,CAAA;IACtD,mEAA+C,CAAA;IAC/C,gDAA4B,CAAA;IAC5B,gDAA4B,CAAA;IAC5B,8CAA0B,CAAA;IAC1B,iCAAa,CAAA;IACb,gDAA4B,CAAA;IAC5B,gDAA4B,CAAA;IAC5B,8CAA0B,CAAA;AAC9B,CAAC,EAbW,gBAAgB,GAAhB,wBAAgB,KAAhB,wBAAgB,QAa3B;AAOD,8BAAsC,SAAQ,sCAAgD;IAA9F;;QACuB,YAAO,GAAG;YACzB,eAAe,EAAE,SAAS;YAC1B,oBAAoB,EAAE,OAAO;SAChC,CAAC;IACN,CAAC;CAAA;AALD,4DAKC;AAED,oBAA4B,SAAQ,6BAAY;IAC5C,YAAY,KAAc,EAAE,YAA+B;QACvD,KAAK,CAAC,aAAa,CAAC,CAAC;QACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wBAAwB,CAAC;YACzB,eAAe,EAAE,KAAK;YACtB,oBAAoB,EAAE,YAAY;SACrC,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAVD,wCAUC",
          sourcesContent: ['// http://officeopenxml.com/WPSectionPgNumType.php\r\nimport { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nexport enum PageNumberFormat {\r\n    CARDINAL_TEXT = "cardinalText",\r\n    DECIMAL = "decimal",\r\n    DECIMAL_ENCLOSED_CIRCLE = "decimalEnclosedCircle",\r\n    DECIMAL_ENCLOSED_FULL_STOP = "decimalEnclosedFullstop",\r\n    DECIMAL_ENCLOSED_PAREN = "decimalEnclosedParen",\r\n    DECIMAL_ZERO = "decimalZero",\r\n    LOWER_LETTER = "lowerLetter",\r\n    LOWER_ROMAN = "lowerRoman",\r\n    NONE = "none",\r\n    ORDINAL_TEXT = "ordinalText",\r\n    UPPER_LETTER = "upperLetter",\r\n    UPPER_ROMAN = "upperRoman",\r\n}\r\n\r\nexport interface IPageNumberTypeAttributes {\r\n    readonly pageNumberStart?: number;\r\n    readonly pageNumberFormatType?: PageNumberFormat;\r\n}\r\n\r\nexport class PageNumberTypeAttributes extends XmlAttributeComponent<IPageNumberTypeAttributes> {\r\n    protected readonly xmlKeys = {\r\n        pageNumberStart: "w:start",\r\n        pageNumberFormatType: "w:fmt",\r\n    };\r\n}\r\n\r\nexport class PageNumberType extends XmlComponent {\r\n    constructor(start?: number, numberFormat?: PageNumberFormat) {\r\n        super("w:pgNumType");\r\n        this.root.push(\r\n            new PageNumberTypeAttributes({\r\n                pageNumberStart: start,\r\n                pageNumberFormatType: numberFormat,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));
      a.s[2]++, function (e) {
        a.f[0]++, a.s[3]++, e.CARDINAL_TEXT = "cardinalText", a.s[4]++, e.DECIMAL = "decimal", a.s[5]++, e.DECIMAL_ENCLOSED_CIRCLE = "decimalEnclosedCircle", a.s[6]++, e.DECIMAL_ENCLOSED_FULL_STOP = "decimalEnclosedFullstop", a.s[7]++, e.DECIMAL_ENCLOSED_PAREN = "decimalEnclosedParen", a.s[8]++, e.DECIMAL_ZERO = "decimalZero", a.s[9]++, e.LOWER_LETTER = "lowerLetter", a.s[10]++, e.LOWER_ROMAN = "lowerRoman", a.s[11]++, e.NONE = "none", a.s[12]++, e.ORDINAL_TEXT = "ordinalText", a.s[13]++, e.UPPER_LETTER = "upperLetter", a.s[14]++, e.UPPER_ROMAN = "upperRoman";
      }((a.b[0][0]++, n.PageNumberFormat || (a.b[0][1]++, n.PageNumberFormat = {})));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon62) {
        _inherits(u, _c$XmlAttributeCompon62);

        function u() {
          var _this263;

          _classCallCheck(this, u);

          a.f[1]++, a.s[15]++, _this263 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[16]++, _this263.xmlKeys = {
            pageNumberStart: "w:start",
            pageNumberFormatType: "w:fmt"
          };
          return _this263;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[17]++, n.PageNumberTypeAttributes = u;

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent140) {
        _inherits(p, _c$XmlComponent140);

        function p(e, n) {
          var _this264;

          _classCallCheck(this, p);

          a.f[2]++, a.s[18]++, _this264 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:pgNumType")), a.s[19]++, _this264.root.push(new u({
            pageNumberStart: e,
            pageNumberFormatType: n
          }));
          return _this264;
        }

        return p;
      }(c.XmlComponent);

      a.s[20]++, n.PageNumberType = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\title-page\\title-page.ts", o = "5da0b954744899988467aa27c6906c2b6aa54fdf", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\title-page\\title-page.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 32
            },
            end: {
              line: 4,
              column: 66
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 27
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 12
            }
          },
          5: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/title-page/title-page.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\title-page\\title-page.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,mEAA8D;AAE9D,eAAuB,SAAQ,6BAAY;IACvC;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2CAAmB,CAAC;YACpB,KAAK,EAAE,GAAG;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,8BASC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { TitlePageAttributes } from "./title-page-attributes";\r\n\r\nexport class TitlePage extends XmlComponent {\r\n    constructor() {\r\n        super("w:titlePg");\r\n        this.root.push(\r\n            new TitlePageAttributes({\r\n                value: "1",\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(250));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent141) {
        _inherits(p, _c$XmlComponent141);

        function p() {
          var _this265;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this265 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:titlePg")), a.s[4]++, _this265.root.push(new u.TitlePageAttributes({
            value: "1"
          }));
          return _this265;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.TitlePage = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\title-page\\title-page-attributes.ts", o = "711e32a425efbe2f5bdb1f2343d329b47d8976dc", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\title-page\\title-page-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 50
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/title-page/title-page-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\title-page\\title-page-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,yBAAiC,SAAQ,sCAAiD;IAA1F;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;SACjB,CAAC;IACN,CAAC;CAAA;AAJD,kDAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IHeaderReferenceAttributes {\r\n    readonly value: string;\r\n}\r\n\r\nexport class TitlePageAttributes extends XmlAttributeComponent<IHeaderReferenceAttributes> {\r\n    protected readonly xmlKeys = {\r\n        value: "w:val",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon63) {
        _inherits(u, _c$XmlAttributeCompon63);

        function u() {
          var _this266;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this266 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this266.xmlKeys = {
            value: "w:val"
          };
          return _this266;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.TitlePageAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-size\\index.ts", o = "901988fc7fd57788d5b6633b134a9cd91660db5d", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\document\\body\\section-properties\\page-size\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 33
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/document/body/section-properties/page-size/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\document\\body\\section-properties\\page-size\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,iCAA4B;AAC5B,4CAAuC",
          sourcesContent: ['export * from "./page-size";\r\nexport * from "./page-size-attributes";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(97)), a.s[5]++, c(t(41));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footer\\footer.ts", o = "38a3dba4eba9de171c8c40904c21509b64562be2", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footer\\footer.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 20
            },
            end: {
              line: 4,
              column: 43
            }
          },
          3: {
            start: {
              line: 5,
              column: 16
            },
            end: {
              line: 5,
              column: 35
            }
          },
          4: {
            start: {
              line: 6,
              column: 28
            },
            end: {
              line: 6,
              column: 58
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 36
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 37
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 28,
              column: 12
            }
          },
          8: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 26
            }
          },
          9: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 34
            }
          },
          10: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 20
            }
          },
          11: {
            start: {
              line: 38,
              column: 21
            },
            end: {
              line: 38,
              column: 52
            }
          },
          12: {
            start: {
              line: 39,
              column: 8
            },
            end: {
              line: 39,
              column: 32
            }
          },
          13: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 20
            }
          },
          14: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 30
            }
          },
          15: {
            start: {
              line: 46,
              column: 22
            },
            end: {
              line: 46,
              column: 51
            }
          },
          16: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 29
            }
          },
          17: {
            start: {
              line: 48,
              column: 8
            },
            end: {
              line: 48,
              column: 21
            }
          },
          18: {
            start: {
              line: 51,
              column: 0
            },
            end: {
              line: 51,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 46
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 22
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 30
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 33,
                column: 4
              },
              end: {
                line: 33,
                column: 5
              }
            },
            loc: {
              start: {
                line: 33,
                column: 28
              },
              end: {
                line: 36,
                column: 5
              }
            },
            line: 33
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 37,
                column: 4
              },
              end: {
                line: 37,
                column: 5
              }
            },
            loc: {
              start: {
                line: 37,
                column: 26
              },
              end: {
                line: 41,
                column: 5
              }
            },
            line: 37
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 42,
                column: 4
              },
              end: {
                line: 42,
                column: 5
              }
            },
            loc: {
              start: {
                line: 42,
                column: 20
              },
              end: {
                line: 44,
                column: 5
              }
            },
            line: 42
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 45,
                column: 4
              },
              end: {
                line: 45,
                column: 5
              }
            },
            loc: {
              start: {
                line: 45,
                column: 28
              },
              end: {
                line: 49,
                column: 5
              }
            },
            line: 45
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footer/footer.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footer\\footer.ts"],
          names: [],
          mappings: ";;AACA,wDAA8E;AAC9E,4CAAyC;AACzC,oCAAiC;AACjC,2DAAuD;AAEvD,YAAoB,SAAQ,0CAAyB;IAGjD,YAAY,eAAuB,EAAE,WAA0B;QAC3D,KAAK,CAAC,OAAO,EAAE,WAAW,CAAC,CAAC;QAC5B,IAAI,CAAC,KAAK,GAAG,eAAe,CAAC;QAC7B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,oCAAgB,CAAC;YACjB,GAAG,EAAE,oEAAoE;YACzE,EAAE,EAAE,6DAA6D;YACjE,CAAC,EAAE,yCAAyC;YAC5C,CAAC,EAAE,qEAAqE;YACxE,CAAC,EAAE,4DAA4D;YAC/D,CAAC,EAAE,+BAA+B;YAClC,IAAI,EAAE,qEAAqE;YAC3E,EAAE,EAAE,wEAAwE;YAC5E,GAAG,EAAE,uCAAuC;YAC5C,CAAC,EAAE,8DAA8D;YACjE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,GAAG,EAAE,iEAAiE;YACtE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;SAC3E,CAAC,CACL,CAAC;IACN,CAAC;IAED,IAAW,WAAW;QAClB,OAAO,IAAI,CAAC,KAAK,CAAC;IACtB,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;QAE1B,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,eAAe,CAAC,IAAa;QAChC,MAAM,IAAI,GAAG,IAAI,qBAAS,CAAC,IAAI,CAAC,CAAC;QACjC,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,CAAC;QACxB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;IAEM,WAAW,CAAC,IAAY,EAAE,IAAY;QACzC,MAAM,KAAK,GAAG,IAAI,aAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;QACpC,IAAI,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;QACrB,OAAO,KAAK,CAAC;IACjB,CAAC;CACJ;AArDD,wBAqDC",
          sourcesContent: ['// http://officeopenxml.com/WPfooters.php\r\nimport { InitializableXmlComponent, XmlComponent } from "file/xml-components";\r\nimport { Paragraph } from "../paragraph";\r\nimport { Table } from "../table";\r\nimport { FooterAttributes } from "./footer-attributes";\r\n\r\nexport class Footer extends InitializableXmlComponent {\r\n    private readonly refId: number;\r\n\r\n    constructor(referenceNumber: number, initContent?: XmlComponent) {\r\n        super("w:ftr", initContent);\r\n        this.refId = referenceNumber;\r\n        this.root.push(\r\n            new FooterAttributes({\r\n                wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",\r\n                mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",\r\n                o: "urn:schemas-microsoft-com:office:office",\r\n                r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",\r\n                m: "http://schemas.openxmlformats.org/officeDocument/2006/math",\r\n                v: "urn:schemas-microsoft-com:vml",\r\n                wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",\r\n                wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",\r\n                w10: "urn:schemas-microsoft-com:office:word",\r\n                w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",\r\n                w14: "http://schemas.microsoft.com/office/word/2010/wordml",\r\n                w15: "http://schemas.microsoft.com/office/word/2012/wordml",\r\n                wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",\r\n                wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",\r\n                wne: "http://schemas.microsoft.com/office/word/2006/wordml",\r\n                wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",\r\n            }),\r\n        );\r\n    }\r\n\r\n    public get ReferenceId(): number {\r\n        return this.refId;\r\n    }\r\n\r\n    public addParagraph(paragraph: Paragraph): Footer {\r\n        this.root.push(paragraph);\r\n\r\n        return this;\r\n    }\r\n\r\n    public createParagraph(text?: string): Paragraph {\r\n        const para = new Paragraph(text);\r\n        this.addParagraph(para);\r\n        return para;\r\n    }\r\n\r\n    public addTable(table: Table): void {\r\n        this.root.push(table);\r\n    }\r\n\r\n    public createTable(rows: number, cols: number): Table {\r\n        const table = new Table(rows, cols);\r\n        this.addTable(table);\r\n        return table;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(2)),
          p = (a.s[3]++, t(23)),
          m = (a.s[4]++, t(253));

      var C =
      /*#__PURE__*/
      function (_c$InitializableXmlCo) {
        _inherits(C, _c$InitializableXmlCo);

        function C(e, n) {
          var _this267;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this267 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:ftr", n)), a.s[6]++, _this267.refId = e, a.s[7]++, _this267.root.push(new m.FooterAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
          }));
          return _this267;
        }

        _createClass(C, [{
          key: "addParagraph",
          value: function addParagraph(e) {
            return a.f[2]++, a.s[9]++, this.root.push(e), a.s[10]++, this;
          }
        }, {
          key: "createParagraph",
          value: function createParagraph(e) {
            a.f[3]++;
            var n = (a.s[11]++, new u.Paragraph(e));
            return a.s[12]++, this.addParagraph(n), a.s[13]++, n;
          }
        }, {
          key: "addTable",
          value: function addTable(e) {
            a.f[4]++, a.s[14]++, this.root.push(e);
          }
        }, {
          key: "createTable",
          value: function createTable(e, n) {
            a.f[5]++;
            var t = (a.s[15]++, new p.Table(e, n));
            return a.s[16]++, this.addTable(t), a.s[17]++, t;
          }
        }, {
          key: "ReferenceId",
          get: function get() {
            return a.f[1]++, a.s[8]++, this.refId;
          }
        }]);

        return C;
      }(c.InitializableXmlComponent);

      a.s[18]++, n.Footer = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footer\\footer-attributes.ts", o = "2e5c1d6971c3ac7f94c1adb89d038a7f6a9a6352", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footer\\footer-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 30,
              column: 10
            }
          },
          4: {
            start: {
              line: 33,
              column: 0
            },
            end: {
              line: 33,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 31,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footer/footer-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footer\\footer-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AA2B5D,sBAA8B,SAAQ,sCAAkD;IAAxF;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,WAAW;YAChB,EAAE,EAAE,UAAU;YACd,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,IAAI,EAAE,YAAY;YAClB,EAAE,EAAE,UAAU;YACd,GAAG,EAAE,WAAW;YAChB,CAAC,EAAE,SAAS;YACZ,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,EAAE,EAAE,UAAU;YACd,EAAE,EAAE,UAAU;YACd,OAAO,EAAE,eAAe;YACxB,QAAQ,EAAE,gBAAgB;YAC1B,GAAG,EAAE,WAAW;YAChB,IAAI,EAAE,UAAU;SACnB,CAAC;IACN,CAAC;CAAA;AAzBD,4CAyBC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IFooterAttributesProperties {\r\n    readonly wpc?: string;\r\n    readonly mc?: string;\r\n    readonly o?: string;\r\n    readonly r?: string;\r\n    readonly m?: string;\r\n    readonly v?: string;\r\n    readonly wp14?: string;\r\n    readonly wp?: string;\r\n    readonly w10?: string;\r\n    readonly w?: string;\r\n    readonly w14?: string;\r\n    readonly w15?: string;\r\n    readonly wpg?: string;\r\n    readonly wpi?: string;\r\n    readonly wne?: string;\r\n    readonly wps?: string;\r\n    readonly cp?: string;\r\n    readonly dc?: string;\r\n    readonly dcterms?: string;\r\n    readonly dcmitype?: string;\r\n    readonly xsi?: string;\r\n    readonly type?: string;\r\n}\r\n\r\nexport class FooterAttributes extends XmlAttributeComponent<IFooterAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        wpc: "xmlns:wpc",\r\n        mc: "xmlns:mc",\r\n        o: "xmlns:o",\r\n        r: "xmlns:r",\r\n        m: "xmlns:m",\r\n        v: "xmlns:v",\r\n        wp14: "xmlns:wp14",\r\n        wp: "xmlns:wp",\r\n        w10: "xmlns:w10",\r\n        w: "xmlns:w",\r\n        w14: "xmlns:w14",\r\n        w15: "xmlns:w15",\r\n        wpg: "xmlns:wpg",\r\n        wpi: "xmlns:wpi",\r\n        wne: "xmlns:wne",\r\n        wps: "xmlns:wps",\r\n        cp: "xmlns:cp",\r\n        dc: "xmlns:dc",\r\n        dcterms: "xmlns:dcterms",\r\n        dcmitype: "xmlns:dcmitype",\r\n        xsi: "xmlns:xsi",\r\n        type: "xsi:type",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon64) {
        _inherits(u, _c$XmlAttributeCompon64);

        function u() {
          var _this268;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this268 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this268.xmlKeys = {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type"
          };
          return _this268;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.FooterAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\media.ts", o = "f353f2aaec355a59013c67c8f46826a5ba73ccd1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\media.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 43
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 7,
              column: 28
            },
            end: {
              line: 7,
              column: 32
            }
          },
          4: {
            start: {
              line: 8,
              column: 26
            },
            end: {
              line: 8,
              column: 105
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 185
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 92
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 18,
              column: 35
            }
          },
          8: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 29
            }
          },
          9: {
            start: {
              line: 24,
              column: 21
            },
            end: {
              line: 24,
              column: 38
            }
          },
          10: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 27,
              column: 9
            }
          },
          11: {
            start: {
              line: 26,
              column: 12
            },
            end: {
              line: 26,
              column: 69
            }
          },
          12: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 20
            }
          },
          13: {
            start: {
              line: 31,
              column: 20
            },
            end: {
              line: 31,
              column: 47
            }
          },
          14: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 35,
              column: 19
            }
          },
          15: {
            start: {
              line: 38,
              column: 24
            },
            end: {
              line: 38,
              column: 91
            }
          },
          16: {
            start: {
              line: 39,
              column: 26
            },
            end: {
              line: 54,
              column: 9
            }
          },
          17: {
            start: {
              line: 55,
              column: 8
            },
            end: {
              line: 55,
              column: 37
            }
          },
          18: {
            start: {
              line: 56,
              column: 8
            },
            end: {
              line: 56,
              column: 25
            }
          },
          19: {
            start: {
              line: 59,
              column: 22
            },
            end: {
              line: 59,
              column: 33
            }
          },
          20: {
            start: {
              line: 60,
              column: 8
            },
            end: {
              line: 62,
              column: 11
            }
          },
          21: {
            start: {
              line: 61,
              column: 12
            },
            end: {
              line: 61,
              column: 29
            }
          },
          22: {
            start: {
              line: 63,
              column: 8
            },
            end: {
              line: 63,
              column: 21
            }
          },
          23: {
            start: {
              line: 66,
              column: 30
            },
            end: {
              line: 66,
              column: 40
            }
          },
          24: {
            start: {
              line: 67,
              column: 28
            },
            end: {
              line: 67,
              column: 81
            }
          },
          25: {
            start: {
              line: 68,
              column: 8
            },
            end: {
              line: 76,
              column: 9
            }
          },
          26: {
            start: {
              line: 69,
              column: 12
            },
            end: {
              line: 71,
              column: 46
            }
          },
          27: {
            start: {
              line: 71,
              column: 28
            },
            end: {
              line: 71,
              column: 43
            }
          },
          28: {
            start: {
              line: 74,
              column: 22
            },
            end: {
              line: 74,
              column: 44
            }
          },
          29: {
            start: {
              line: 75,
              column: 12
            },
            end: {
              line: 75,
              column: 51
            }
          },
          30: {
            start: {
              line: 79,
              column: 0
            },
            end: {
              line: 79,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 65
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 24
              },
              end: {
                line: 19,
                column: 5
              }
            },
            line: 12
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 18
              },
              end: {
                line: 22,
                column: 5
              }
            },
            line: 20
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 23,
                column: 4
              },
              end: {
                line: 23,
                column: 5
              }
            },
            loc: {
              start: {
                line: 23,
                column: 18
              },
              end: {
                line: 29,
                column: 5
              }
            },
            line: 23
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 30,
                column: 4
              },
              end: {
                line: 30,
                column: 5
              }
            },
            loc: {
              start: {
                line: 30,
                column: 61
              },
              end: {
                line: 36,
                column: 5
              }
            },
            line: 30
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 37,
                column: 4
              },
              end: {
                line: 37,
                column: 5
              }
            },
            loc: {
              start: {
                line: 37,
                column: 69
              },
              end: {
                line: 57,
                column: 5
              }
            },
            line: 37
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 58,
                column: 4
              },
              end: {
                line: 58,
                column: 5
              }
            },
            loc: {
              start: {
                line: 58,
                column: 16
              },
              end: {
                line: 64,
                column: 5
              }
            },
            line: 58
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 60,
                column: 25
              },
              end: {
                line: 60,
                column: 26
              }
            },
            loc: {
              start: {
                line: 60,
                column: 35
              },
              end: {
                line: 62,
                column: 9
              }
            },
            line: 60
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 65,
                column: 4
              },
              end: {
                line: 65,
                column: 5
              }
            },
            loc: {
              start: {
                line: 65,
                column: 36
              },
              end: {
                line: 77,
                column: 5
              }
            },
            line: 65
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 71,
                column: 21
              },
              end: {
                line: 71,
                column: 22
              }
            },
            loc: {
              start: {
                line: 71,
                column: 28
              },
              end: {
                line: 71,
                column: 43
              }
            },
            line: 71
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            }, {
              start: {
                line: 25,
                column: 8
              },
              end: {
                line: 27,
                column: 9
              }
            }],
            line: 25
          },
          1: {
            loc: {
              start: {
                line: 30,
                column: 34
              },
              end: {
                line: 30,
                column: 45
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 30,
                column: 42
              },
              end: {
                line: 30,
                column: 45
              }
            }],
            line: 30
          },
          2: {
            loc: {
              start: {
                line: 30,
                column: 47
              },
              end: {
                line: 30,
                column: 59
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 30,
                column: 56
              },
              end: {
                line: 30,
                column: 59
              }
            }],
            line: 30
          },
          3: {
            loc: {
              start: {
                line: 38,
                column: 24
              },
              end: {
                line: 38,
                column: 91
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 38,
                column: 51
              },
              end: {
                line: 38,
                column: 84
              }
            }, {
              start: {
                line: 38,
                column: 87
              },
              end: {
                line: 38,
                column: 91
              }
            }],
            line: 38
          },
          4: {
            loc: {
              start: {
                line: 68,
                column: 8
              },
              end: {
                line: 76,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 68,
                column: 8
              },
              end: {
                line: 76,
                column: 9
              }
            }, {
              start: {
                line: 68,
                column: 8
              },
              end: {
                line: 76,
                column: 9
              }
            }],
            line: 68
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        b: {
          0: [0, 0],
          1: [0],
          2: [0],
          3: [0, 0],
          4: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/media/media.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\media\\media.ts"],
          names: [],
          mappings: ";;AAEA,4CAA8C;AAE9C,mCAAgC;AAOhC;IACW,MAAM,CAAC,QAAQ,CAClB,IAAU,EACV,MAAkD,EAClD,KAAc,EACd,MAAe,EACf,cAAgC;QAGhC,MAAM,WAAW,GAAI,IAA0B,CAAC;QAChD,MAAM,SAAS,GAAG,IAAI,CAAC,KAAK,CAAC,QAAQ,CAAC,MAAM,EAAE,WAAW,CAAC,qBAAqB,EAAE,EAAE,KAAK,EAAE,MAAM,CAAC,CAAC;QAClG,IAAI,CAAC,qBAAqB,CAAC,kBAAkB,CACzC,SAAS,CAAC,WAAW,EACrB,2EAA2E,EAC3E,SAAS,SAAS,CAAC,QAAQ,EAAE,CAChC,CAAC;QAEF,OAAO,IAAI,aAAK,CAAC,IAAI,0BAAc,CAAC,SAAS,EAAE,cAAc,CAAC,CAAC,CAAC;IACpE,CAAC;IAEO,MAAM,CAAC,UAAU;QAErB,OAAO,CACH,IAAI,CAAC,MAAM,EAAE;aACR,QAAQ,CAAC,EAAE,CAAC;aACZ,SAAS,CAAC,CAAC,EAAE,EAAE,CAAC;YACrB,IAAI,CAAC,MAAM,EAAE;iBACR,QAAQ,CAAC,EAAE,CAAC;iBACZ,SAAS,CAAC,CAAC,EAAE,EAAE,CAAC,CACxB,CAAC;IACN,CAAC;IAID;QACI,IAAI,CAAC,GAAG,GAAG,IAAI,GAAG,EAAsB,CAAC;IAC7C,CAAC;IAEM,QAAQ,CAAC,GAAW;QACvB,MAAM,IAAI,GAAG,IAAI,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,CAAC;QAE/B,IAAI,IAAI,KAAK,SAAS,EAAE;YACpB,MAAM,IAAI,KAAK,CAAC,kCAAkC,GAAG,EAAE,CAAC,CAAC;SAC5D;QAED,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ,CACX,MAAkD,EAClD,WAAmB,EACnB,QAAgB,GAAG,EACnB,SAAiB,GAAG;QAEpB,MAAM,GAAG,GAAG,GAAG,KAAK,CAAC,UAAU,EAAE,MAAM,CAAC;QAExC,OAAO,IAAI,CAAC,WAAW,CACnB,GAAG,EACH,WAAW,EACX;YACI,KAAK,EAAE,KAAK;YACZ,MAAM,EAAE,MAAM;SACjB,EACD,MAAM,CACT,CAAC;IACN,CAAC;IAEO,WAAW,CACf,GAAW,EACX,kBAA0B,EAC1B,UAA+D,EAC/D,IAAgD,EAChD,QAAiB;QAEjB,MAAM,OAAO,GAAG,OAAO,IAAI,KAAK,QAAQ,CAAC,CAAC,CAAC,IAAI,CAAC,sBAAsB,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC;QAEpF,MAAM,SAAS,GAAe;YAC1B,WAAW,EAAE,kBAAkB;YAC/B,MAAM,EAAE,OAAO;YACf,IAAI,EAAE,QAAQ;YACd,QAAQ,EAAE,GAAG;YACb,UAAU,EAAE;gBACR,MAAM,EAAE;oBACJ,CAAC,EAAE,IAAI,CAAC,KAAK,CAAC,UAAU,CAAC,KAAK,CAAC;oBAC/B,CAAC,EAAE,IAAI,CAAC,KAAK,CAAC,UAAU,CAAC,MAAM,CAAC;iBACnC;gBACD,IAAI,EAAE;oBACF,CAAC,EAAE,IAAI,CAAC,KAAK,CAAC,UAAU,CAAC,KAAK,GAAG,IAAI,CAAC;oBACtC,CAAC,EAAE,IAAI,CAAC,KAAK,CAAC,UAAU,CAAC,MAAM,GAAG,IAAI,CAAC;iBAC1C;aACJ;SACJ,CAAC;QAEF,IAAI,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,EAAE,SAAS,CAAC,CAAC;QAE7B,OAAO,SAAS,CAAC;IACrB,CAAC;IAED,IAAW,KAAK;QACZ,MAAM,KAAK,GAAG,IAAI,KAAK,EAAc,CAAC;QAEtC,IAAI,CAAC,GAAG,CAAC,OAAO,CAAC,CAAC,IAAI,EAAE,EAAE;YACtB,KAAK,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;QACrB,CAAC,CAAC,CAAC;QAEH,OAAO,KAAK,CAAC;IACjB,CAAC;IAEO,sBAAsB,CAAC,OAAe;QAG1C,MAAM,aAAa,GAAG,UAAU,CAAC;QAEjC,MAAM,WAAW,GAAG,OAAO,CAAC,OAAO,CAAC,aAAa,CAAC,GAAG,aAAa,CAAC,MAAM,CAAC;QAE1E,IAAI,OAAO,IAAI,KAAK,UAAU,EAAE;YAC5B,OAAO,IAAI,UAAU,CACjB,IAAI,CAAC,OAAO,CAAC,SAAS,CAAC,WAAW,CAAC,CAAC;iBAC/B,KAAK,CAAC,EAAE,CAAC;iBACT,GAAG,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,CACnC,CAAC;SACL;aAAM;YACH,MAAM,CAAC,GAAG,OAAO,CAAC,KAAK,GAAG,KAAK,CAAC,CAAC;YACjC,OAAO,IAAI,CAAC,CAAC,MAAM,CAAC,OAAO,EAAE,QAAQ,CAAC,CAAC;SAC1C;IACL,CAAC;CACJ;AA9HD,sBA8HC",
          sourcesContent: ['import { IDrawingOptions } from "../drawing";\r\nimport { File } from "../file";\r\nimport { ImageParagraph } from "../paragraph";\r\nimport { IMediaData } from "./data";\r\nimport { Image } from "./image";\r\n\r\ninterface IHackedFile {\r\n    // tslint:disable-next-line:readonly-keyword\r\n    currentRelationshipId: number;\r\n}\r\n\r\nexport class Media {\r\n    public static addImage(\r\n        file: File,\r\n        buffer: Buffer | string | Uint8Array | ArrayBuffer,\r\n        width?: number,\r\n        height?: number,\r\n        drawingOptions?: IDrawingOptions,\r\n    ): Image {\r\n        // Workaround to expose id without exposing to API\r\n        const exposedFile = (file as {}) as IHackedFile;\r\n        const mediaData = file.Media.addMedia(buffer, exposedFile.currentRelationshipId++, width, height);\r\n        file.DocumentRelationships.createRelationship(\r\n            mediaData.referenceId,\r\n            "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",\r\n            `media/${mediaData.fileName}`,\r\n        );\r\n\r\n        return new Image(new ImageParagraph(mediaData, drawingOptions));\r\n    }\r\n\r\n    private static generateId(): string {\r\n        // https://gist.github.com/6174/6062387\r\n        return (\r\n            Math.random()\r\n                .toString(36)\r\n                .substring(2, 15) +\r\n            Math.random()\r\n                .toString(36)\r\n                .substring(2, 15)\r\n        );\r\n    }\r\n\r\n    private readonly map: Map<string, IMediaData>;\r\n\r\n    constructor() {\r\n        this.map = new Map<string, IMediaData>();\r\n    }\r\n\r\n    public getMedia(key: string): IMediaData {\r\n        const data = this.map.get(key);\r\n\r\n        if (data === undefined) {\r\n            throw new Error(`Cannot find image with the key ${key}`);\r\n        }\r\n\r\n        return data;\r\n    }\r\n\r\n    public addMedia(\r\n        buffer: Buffer | string | Uint8Array | ArrayBuffer,\r\n        referenceId: number,\r\n        width: number = 100,\r\n        height: number = 100,\r\n    ): IMediaData {\r\n        const key = `${Media.generateId()}.png`;\r\n\r\n        return this.createMedia(\r\n            key,\r\n            referenceId,\r\n            {\r\n                width: width,\r\n                height: height,\r\n            },\r\n            buffer,\r\n        );\r\n    }\r\n\r\n    private createMedia(\r\n        key: string,\r\n        relationshipsCount: number,\r\n        dimensions: { readonly width: number; readonly height: number },\r\n        data: Buffer | string | Uint8Array | ArrayBuffer,\r\n        filePath?: string,\r\n    ): IMediaData {\r\n        const newData = typeof data === "string" ? this.convertDataURIToBinary(data) : data;\r\n\r\n        const imageData: IMediaData = {\r\n            referenceId: relationshipsCount,\r\n            stream: newData,\r\n            path: filePath,\r\n            fileName: key,\r\n            dimensions: {\r\n                pixels: {\r\n                    x: Math.round(dimensions.width),\r\n                    y: Math.round(dimensions.height),\r\n                },\r\n                emus: {\r\n                    x: Math.round(dimensions.width * 9525),\r\n                    y: Math.round(dimensions.height * 9525),\r\n                },\r\n            },\r\n        };\r\n\r\n        this.map.set(key, imageData);\r\n\r\n        return imageData;\r\n    }\r\n\r\n    public get Array(): IMediaData[] {\r\n        const array = new Array<IMediaData>();\r\n\r\n        this.map.forEach((data) => {\r\n            array.push(data);\r\n        });\r\n\r\n        return array;\r\n    }\r\n\r\n    private convertDataURIToBinary(dataURI: string): Uint8Array {\r\n        // https://gist.github.com/borismus/1032746\r\n        // https://github.com/mafintosh/base64-to-uint8array\r\n        const BASE64_MARKER = ";base64,";\r\n\r\n        const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;\r\n\r\n        if (typeof atob === "function") {\r\n            return new Uint8Array(\r\n                atob(dataURI.substring(base64Index))\r\n                    .split("")\r\n                    .map((c) => c.charCodeAt(0)),\r\n            );\r\n        } else {\r\n            const b = require("buf" + "fer");\r\n            return new b.Buffer(dataURI, "base64");\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(100));

      var p =
      /*#__PURE__*/
      function () {
        _createClass(p, null, [{
          key: "addImage",
          value: function addImage(e, n, t, r, o) {
            a.f[0]++;
            var i = (a.s[3]++, e),
                A = (a.s[4]++, e.Media.addMedia(n, i.currentRelationshipId++, t, r));
            return a.s[5]++, e.DocumentRelationships.createRelationship(A.referenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", "media/".concat(A.fileName)), a.s[6]++, new u.Image(new c.ImageParagraph(A, o));
          }
        }, {
          key: "generateId",
          value: function generateId() {
            return a.f[1]++, a.s[7]++, Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
          }
        }]);

        function p() {
          _classCallCheck(this, p);

          a.f[2]++, a.s[8]++, this.map = new Map();
        }

        _createClass(p, [{
          key: "getMedia",
          value: function getMedia(e) {
            a.f[3]++;
            var n = (a.s[9]++, this.map.get(e));
            if (a.s[10]++, void 0 === n) throw a.b[0][0]++, a.s[11]++, new Error("Cannot find image with the key ".concat(e));
            return a.b[0][1]++, a.s[12]++, n;
          }
        }, {
          key: "addMedia",
          value: function addMedia(e, n) {
            var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (a.b[1][0]++, 100);
            var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (a.b[2][0]++, 100);
            a.f[4]++;
            var o = (a.s[13]++, "".concat(p.generateId(), ".png"));
            return a.s[14]++, this.createMedia(o, n, {
              width: t,
              height: r
            }, e);
          }
        }, {
          key: "createMedia",
          value: function createMedia(e, n, t, r, o) {
            a.f[5]++;
            var i = (a.s[15]++, "string" == typeof r ? (a.b[3][0]++, this.convertDataURIToBinary(r)) : (a.b[3][1]++, r)),
                A = (a.s[16]++, {
              referenceId: n,
              stream: i,
              path: o,
              fileName: e,
              dimensions: {
                pixels: {
                  x: Math.round(t.width),
                  y: Math.round(t.height)
                },
                emus: {
                  x: Math.round(9525 * t.width),
                  y: Math.round(9525 * t.height)
                }
              }
            });
            return a.s[17]++, this.map.set(e, A), a.s[18]++, A;
          }
        }, {
          key: "convertDataURIToBinary",
          value: function convertDataURIToBinary(e) {
            a.f[8]++;
            var n = (a.s[23]++, ";base64,"),
                r = (a.s[24]++, e.indexOf(n) + n.length);
            if (a.s[25]++, "function" == typeof atob) return a.b[4][0]++, a.s[26]++, new Uint8Array(atob(e.substring(r)).split("").map(function (e) {
              return a.f[9]++, a.s[27]++, e.charCodeAt(0);
            }));
            {
              a.b[4][1]++;

              var _n7 = (a.s[28]++, t(5));

              return a.s[29]++, new _n7.Buffer(e, "base64");
            }
          }
        }, {
          key: "Array",
          get: function get() {
            a.f[6]++;
            var e = (a.s[19]++, new Array());
            return a.s[20]++, this.map.forEach(function (n) {
              a.f[7]++, a.s[21]++, e.push(n);
            }), a.s[22]++, e;
          }
        }]);

        return p;
      }();

      a.s[30]++, n.Media = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\data.ts", o = "0858daa720031e71547851c32c7fb3583ee7edac", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\media\\data.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 0
            },
            end: {
              line: 3,
              column: 25
            }
          }
        },
        fnMap: {},
        branchMap: {},
        s: {
          0: 0,
          1: 0
        },
        f: {},
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/media/data.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\media\\data.ts"],
          names: [],
          mappings: ";;AAuBa,QAAA,WAAW,GAAG,EAAE,CAAC",
          sourcesContent: ['export interface IMediaDataDimensions {\r\n    readonly pixels: {\r\n        readonly x: number;\r\n        readonly y: number;\r\n    };\r\n    readonly emus: {\r\n        readonly x: number;\r\n        readonly y: number;\r\n    };\r\n}\r\n\r\nexport interface IMediaData {\r\n    readonly referenceId: number;\r\n    readonly stream: Buffer | Uint8Array | ArrayBuffer;\r\n    readonly path?: string;\r\n    readonly fileName: string;\r\n    readonly dimensions: IMediaDataDimensions;\r\n}\r\n\r\n// Needed because of: https://github.com/s-panferov/awesome-typescript-loader/issues/432\r\n/**\r\n * @ignore\r\n */\r\nexport const WORKAROUND2 = "";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[1]++, n.WORKAROUND2 = "";
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\relationships.ts", o = "4f1263b190bb7e99ebe88c18d6f3046444733acb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\relationships.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 21
            },
            end: {
              line: 4,
              column: 44
            }
          },
          3: {
            start: {
              line: 5,
              column: 23
            },
            end: {
              line: 5,
              column: 61
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 31
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 11,
              column: 12
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 37
            }
          },
          7: {
            start: {
              line: 17,
              column: 29
            },
            end: {
              line: 17,
              column: 98
            }
          },
          8: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 43
            }
          },
          9: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 28
            }
          },
          10: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 22,
              column: 36
            }
          },
          11: {
            start: {
              line: 25,
              column: 0
            },
            end: {
              line: 25,
              column: 38
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 34
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 13
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 53
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 16
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 28
              },
              end: {
                line: 23,
                column: 5
              }
            },
            line: 21
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/relationships/relationships.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\relationships\\relationships.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,6CAAuD;AACvD,8DAA6F;AAE7F,mBAA2B,SAAQ,6BAAY;IAC3C;QACI,KAAK,CAAC,eAAe,CAAC,CAAC;QACvB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,oCAAuB,CAAC;YACxB,KAAK,EAAE,8DAA8D;SACxE,CAAC,CACL,CAAC;IACN,CAAC;IAEM,eAAe,CAAC,YAA0B;QAC7C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,YAAY,CAAC,CAAC;IACjC,CAAC;IAEM,kBAAkB,CAAC,EAAU,EAAE,IAAsB,EAAE,MAAc,EAAE,UAA2B;QACrG,MAAM,YAAY,GAAG,IAAI,2BAAY,CAAC,MAAM,EAAE,EAAE,EAAE,IAAI,EAAE,MAAM,EAAE,UAAU,CAAC,CAAC;QAC5E,IAAI,CAAC,eAAe,CAAC,YAAY,CAAC,CAAC;QAEnC,OAAO,YAAY,CAAC;IACxB,CAAC;IAED,IAAW,iBAAiB;QACxB,OAAO,IAAI,CAAC,IAAI,CAAC,MAAM,GAAG,CAAC,CAAC;IAChC,CAAC;CACJ;AAxBD,sCAwBC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { RelationshipsAttributes } from "./attributes";\r\nimport { Relationship, RelationshipType, TargetModeType } from "./relationship/relationship";\r\n\r\nexport class Relationships extends XmlComponent {\r\n    constructor() {\r\n        super("Relationships");\r\n        this.root.push(\r\n            new RelationshipsAttributes({\r\n                xmlns: "http://schemas.openxmlformats.org/package/2006/relationships",\r\n            }),\r\n        );\r\n    }\r\n\r\n    public addRelationship(relationship: Relationship): void {\r\n        this.root.push(relationship);\r\n    }\r\n\r\n    public createRelationship(id: number, type: RelationshipType, target: string, targetMode?: TargetModeType): Relationship {\r\n        const relationship = new Relationship(`rId${id}`, type, target, targetMode);\r\n        this.addRelationship(relationship);\r\n\r\n        return relationship;\r\n    }\r\n\r\n    public get RelationshipCount(): number {\r\n        return this.root.length - 1;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(257)),
          p = (a.s[3]++, t(258));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent142) {
        _inherits(m, _c$XmlComponent142);

        function m() {
          var _this269;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this269 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "Relationships")), a.s[5]++, _this269.root.push(new u.RelationshipsAttributes({
            xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
          }));
          return _this269;
        }

        _createClass(m, [{
          key: "addRelationship",
          value: function addRelationship(e) {
            a.f[1]++, a.s[6]++, this.root.push(e);
          }
        }, {
          key: "createRelationship",
          value: function createRelationship(e, n, t, r) {
            a.f[2]++;
            var o = (a.s[7]++, new p.Relationship("rId".concat(e), n, t, r));
            return a.s[8]++, this.addRelationship(o), a.s[9]++, o;
          }
        }, {
          key: "RelationshipCount",
          get: function get() {
            return a.f[3]++, a.s[10]++, this.root.length - 1;
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[11]++, n.Relationships = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\attributes.ts", o = "2fb64d2857457b664537d1cf2d85275c8aa207cf", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 10
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 58
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/relationships/attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\relationships\\attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAM5D,6BAAqC,SAAQ,sCAAyD;IAAtG;;QACuB,YAAO,GAAG;YACzB,KAAK,EAAE,OAAO;SACjB,CAAC;IACN,CAAC;CAAA;AAJD,0DAIC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IRelationshipsAttributesProperties {\r\n    readonly xmlns: string;\r\n}\r\n\r\nexport class RelationshipsAttributes extends XmlAttributeComponent<IRelationshipsAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        xmlns: "xmlns",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon65) {
        _inherits(u, _c$XmlAttributeCompon65);

        function u() {
          var _this270;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this270 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this270.xmlKeys = {
            xmlns: "xmlns"
          };
          return _this270;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.RelationshipsAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\relationship\\relationship.ts", o = "f47f25193998b37f67974200d667af8a1bb3facb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\relationship\\relationship.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 34
            },
            end: {
              line: 4,
              column: 70
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 30
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 13,
              column: 12
            }
          },
          5: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 46
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/relationships/relationship/relationship.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\relationships\\relationship\\relationship.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,uEAAmE;AAoBnE,kBAA0B,SAAQ,6BAAY;IAC1C,YAAY,EAAU,EAAE,IAAsB,EAAE,MAAc,EAAE,UAA2B;QACvF,KAAK,CAAC,cAAc,CAAC,CAAC;QAEtB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,gDAAsB,CAAC;YACvB,EAAE;YACF,IAAI;YACJ,MAAM;YACN,UAAU;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAbD,oCAaC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { RelationshipAttributes } from "./relationship-attributes";\r\n\r\nexport type RelationshipType =\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument"\r\n    | "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink"\r\n    | "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes";\r\n\r\nexport type TargetModeType = "External";\r\n\r\nexport class Relationship extends XmlComponent {\r\n    constructor(id: string, type: RelationshipType, target: string, targetMode?: TargetModeType) {\r\n        super("Relationship");\r\n\r\n        this.root.push(\r\n            new RelationshipAttributes({\r\n                id,\r\n                type,\r\n                target,\r\n                targetMode,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(259));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent143) {
        _inherits(p, _c$XmlComponent143);

        function p(e, n, t, r) {
          var _this271;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this271 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "Relationship")), a.s[4]++, _this271.root.push(new u.RelationshipAttributes({
            id: e,
            type: n,
            target: t,
            targetMode: r
          }));
          return _this271;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.Relationship = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\relationship\\relationship-attributes.ts", o = "efb5ba905bf4c2af6529b033f6f5bae01466241e", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\relationships\\relationship\\relationship-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 12,
              column: 10
            }
          },
          4: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 56
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/relationships/relationship/relationship-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\relationships\\relationship\\relationship-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAS5D,4BAAoC,SAAQ,sCAAwD;IAApG;;QACuB,YAAO,GAAG;YACzB,EAAE,EAAE,IAAI;YACR,IAAI,EAAE,MAAM;YACZ,MAAM,EAAE,QAAQ;YAChB,UAAU,EAAE,YAAY;SAC3B,CAAC;IACN,CAAC;CAAA;AAPD,wDAOC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IRelationshipAttributesProperties {\r\n    readonly id: string;\r\n    readonly type: string;\r\n    readonly target: string;\r\n    readonly targetMode?: string;\r\n}\r\n\r\nexport class RelationshipAttributes extends XmlAttributeComponent<IRelationshipAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        id: "Id",\r\n        type: "Type",\r\n        target: "Target",\r\n        targetMode: "TargetMode",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon66) {
        _inherits(u, _c$XmlAttributeCompon66);

        function u() {
          var _this272;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this272 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this272.xmlKeys = {
            id: "Id",
            type: "Type",
            target: "Target",
            targetMode: "TargetMode"
          };
          return _this272;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.RelationshipAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\index.ts", o = "a211efef6e390da946d0065aa3ccfc7f18f0d1d5", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 33
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,iCAA4B",
          sourcesContent: ['export * from "./footnotes";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(261));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnotes.ts", o = "5d5cfe92cae42a469e2adc7b7150892c937c7a79", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnotes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 20
            },
            end: {
              line: 4,
              column: 43
            }
          },
          3: {
            start: {
              line: 5,
              column: 19
            },
            end: {
              line: 5,
              column: 49
            }
          },
          4: {
            start: {
              line: 6,
              column: 37
            },
            end: {
              line: 6,
              column: 89
            }
          },
          5: {
            start: {
              line: 7,
              column: 24
            },
            end: {
              line: 7,
              column: 63
            }
          },
          6: {
            start: {
              line: 8,
              column: 31
            },
            end: {
              line: 8,
              column: 64
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 29
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 27
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 31,
              column: 12
            }
          },
          10: {
            start: {
              line: 32,
              column: 22
            },
            end: {
              line: 32,
              column: 84
            }
          },
          11: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 39,
              column: 57
            }
          },
          12: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 30
            }
          },
          13: {
            start: {
              line: 41,
              column: 24
            },
            end: {
              line: 41,
              column: 98
            }
          },
          14: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 48,
              column: 82
            }
          },
          15: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 32
            }
          },
          16: {
            start: {
              line: 52,
              column: 25
            },
            end: {
              line: 52,
              column: 64
            }
          },
          17: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 41
            }
          },
          18: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 54,
              column: 33
            }
          },
          19: {
            start: {
              line: 55,
              column: 8
            },
            end: {
              line: 55,
              column: 25
            }
          },
          20: {
            start: {
              line: 58,
              column: 0
            },
            end: {
              line: 58,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 10,
                column: 4
              },
              end: {
                line: 10,
                column: 5
              }
            },
            loc: {
              start: {
                line: 10,
                column: 18
              },
              end: {
                line: 50,
                column: 5
              }
            },
            line: 10
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 51,
                column: 4
              },
              end: {
                line: 51,
                column: 5
              }
            },
            loc: {
              start: {
                line: 51,
                column: 30
              },
              end: {
                line: 56,
                column: 5
              }
            },
            line: 51
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnotes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnotes.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,4CAAyC;AACzC,kDAA6D;AAC7D,0FAAqF;AACrF,gEAA4D;AAC5D,iEAA6D;AAE7D,eAAuB,SAAQ,6BAAY;IAIvC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;QAErB,IAAI,CAAC,SAAS,GAAG,CAAC,CAAC;QAEnB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,0CAAmB,CAAC;YACpB,GAAG,EAAE,oEAAoE;YACzE,EAAE,EAAE,6DAA6D;YACjE,CAAC,EAAE,yCAAyC;YAC5C,CAAC,EAAE,qEAAqE;YACxE,CAAC,EAAE,4DAA4D;YAC/D,CAAC,EAAE,+BAA+B;YAClC,IAAI,EAAE,qEAAqE;YAC3E,EAAE,EAAE,wEAAwE;YAC5E,GAAG,EAAE,uCAAuC;YAC5C,CAAC,EAAE,8DAA8D;YACjE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,GAAG,EAAE,iEAAiE;YACtE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,SAAS,EAAE,cAAc;SAC5B,CAAC,CACL,CAAC;QAEF,MAAM,KAAK,GAAG,IAAI,mBAAQ,CAAC,CAAC,CAAC,EAAE,uBAAY,CAAC,SAAS,CAAC,CAAC;QACvD,KAAK,CAAC,YAAY,CACd,IAAI,qBAAS,EAAE;aACV,OAAO,CAAC;YACL,KAAK,EAAE,CAAC;YACR,IAAI,EAAE,GAAG;YACT,QAAQ,EAAE,MAAM;SACnB,CAAC;aACD,MAAM,CAAC,IAAI,4BAAY,EAAE,CAAC,CAClC,CAAC;QACF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;QAEtB,MAAM,OAAO,GAAG,IAAI,mBAAQ,CAAC,CAAC,EAAE,uBAAY,CAAC,sBAAsB,CAAC,CAAC;QACrE,OAAO,CAAC,YAAY,CAChB,IAAI,qBAAS,EAAE;aACV,OAAO,CAAC;YACL,KAAK,EAAE,CAAC;YACR,IAAI,EAAE,GAAG;YACT,QAAQ,EAAE,MAAM;SACnB,CAAC;aACD,MAAM,CAAC,IAAI,qDAAwB,EAAE,CAAC,CAC9C,CAAC;QACF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;IAC5B,CAAC;IAEM,cAAc,CAAC,SAAoB;QACtC,MAAM,QAAQ,GAAG,IAAI,mBAAQ,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;QAC9C,QAAQ,CAAC,YAAY,CAAC,SAAS,CAAC,CAAC;QACjC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QAEzB,IAAI,CAAC,SAAS,EAAE,CAAC;IACrB,CAAC;CACJ;AA/DD,8BA+DC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { Paragraph } from "../paragraph";\r\nimport { Footnote, FootnoteType } from "./footnote/footnote";\r\nimport { ContinuationSeperatorRun } from "./footnote/run/continuation-seperator-run";\r\nimport { SeperatorRun } from "./footnote/run/seperator-run";\r\nimport { FootnotesAttributes } from "./footnotes-attributes";\r\n\r\nexport class FootNotes extends XmlComponent {\r\n    // tslint:disable-next-line:readonly-keyword\r\n    private currentId: number;\r\n\r\n    constructor() {\r\n        super("w:footnotes");\r\n\r\n        this.currentId = 1;\r\n\r\n        this.root.push(\r\n            new FootnotesAttributes({\r\n                wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",\r\n                mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",\r\n                o: "urn:schemas-microsoft-com:office:office",\r\n                r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",\r\n                m: "http://schemas.openxmlformats.org/officeDocument/2006/math",\r\n                v: "urn:schemas-microsoft-com:vml",\r\n                wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",\r\n                wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",\r\n                w10: "urn:schemas-microsoft-com:office:word",\r\n                w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",\r\n                w14: "http://schemas.microsoft.com/office/word/2010/wordml",\r\n                w15: "http://schemas.microsoft.com/office/word/2012/wordml",\r\n                wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",\r\n                wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",\r\n                wne: "http://schemas.microsoft.com/office/word/2006/wordml",\r\n                wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",\r\n                Ignorable: "w14 w15 wp14",\r\n            }),\r\n        );\r\n\r\n        const begin = new Footnote(-1, FootnoteType.SEPERATOR);\r\n        begin.addParagraph(\r\n            new Paragraph()\r\n                .spacing({\r\n                    after: 0,\r\n                    line: 240,\r\n                    lineRule: "auto",\r\n                })\r\n                .addRun(new SeperatorRun()),\r\n        );\r\n        this.root.push(begin);\r\n\r\n        const spacing = new Footnote(0, FootnoteType.CONTINUATION_SEPERATOR);\r\n        spacing.addParagraph(\r\n            new Paragraph()\r\n                .spacing({\r\n                    after: 0,\r\n                    line: 240,\r\n                    lineRule: "auto",\r\n                })\r\n                .addRun(new ContinuationSeperatorRun()),\r\n        );\r\n        this.root.push(spacing);\r\n    }\r\n\r\n    public createFootNote(paragraph: Paragraph): void {\r\n        const footnote = new Footnote(this.currentId);\r\n        footnote.addParagraph(paragraph);\r\n        this.root.push(footnote);\r\n\r\n        this.currentId++;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(2)),
          p = (a.s[3]++, t(262)),
          m = (a.s[4]++, t(266)),
          C = (a.s[5]++, t(268)),
          d = (a.s[6]++, t(270));

      var f =
      /*#__PURE__*/
      function (_c$XmlComponent144) {
        _inherits(f, _c$XmlComponent144);

        function f() {
          var _this273;

          _classCallCheck(this, f);

          a.f[0]++, a.s[7]++, _this273 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "w:footnotes")), a.s[8]++, _this273.currentId = 1, a.s[9]++, _this273.root.push(new d.FootnotesAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
          }));
          var e = (a.s[10]++, new p.Footnote(-1, p.FootnoteType.SEPERATOR));
          a.s[11]++, e.addParagraph(new u.Paragraph().spacing({
            after: 0,
            line: 240,
            lineRule: "auto"
          }).addRun(new C.SeperatorRun())), a.s[12]++, _this273.root.push(e);
          var n = (a.s[13]++, new p.Footnote(0, p.FootnoteType.CONTINUATION_SEPERATOR));
          a.s[14]++, n.addParagraph(new u.Paragraph().spacing({
            after: 0,
            line: 240,
            lineRule: "auto"
          }).addRun(new m.ContinuationSeperatorRun())), a.s[15]++, _this273.root.push(n);
          return _this273;
        }

        _createClass(f, [{
          key: "createFootNote",
          value: function createFootNote(e) {
            a.f[1]++;
            var n = (a.s[16]++, new p.Footnote(this.currentId));
            a.s[17]++, n.addParagraph(e), a.s[18]++, this.root.push(n), a.s[19]++, this.currentId++;
          }
        }]);

        return f;
      }(c.XmlComponent);

      a.s[20]++, n.FootNotes = f;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\footnote.ts", o = "e2e13ba6eef8582ae720ca330aca6790aa5cd051", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\footnote.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 30
            },
            end: {
              line: 4,
              column: 62
            }
          },
          3: {
            start: {
              line: 5,
              column: 27
            },
            end: {
              line: 5,
              column: 60
            }
          },
          4: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 10,
              column: 71
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 44
            }
          },
          6: {
            start: {
              line: 9,
              column: 4
            },
            end: {
              line: 9,
              column: 69
            }
          },
          7: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 28
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 17,
              column: 12
            }
          },
          9: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 73
            }
          },
          10: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 34
            }
          },
          11: {
            start: {
              line: 24,
              column: 0
            },
            end: {
              line: 24,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 1
              },
              end: {
                line: 7,
                column: 2
              }
            },
            loc: {
              start: {
                line: 7,
                column: 25
              },
              end: {
                line: 10,
                column: 1
              }
            },
            line: 7
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 26
              },
              end: {
                line: 18,
                column: 5
              }
            },
            line: 12
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 19,
                column: 4
              },
              end: {
                line: 19,
                column: 5
              }
            },
            loc: {
              start: {
                line: 19,
                column: 28
              },
              end: {
                line: 22,
                column: 5
              }
            },
            line: 19
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 10,
                column: 18
              },
              end: {
                line: 10,
                column: 69
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 10,
                column: 18
              },
              end: {
                line: 10,
                column: 38
              }
            }, {
              start: {
                line: 10,
                column: 43
              },
              end: {
                line: 10,
                column: 68
              }
            }],
            line: 10
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/footnote.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\footnote.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AAEnD,+DAA2D;AAC3D,6DAAwD;AAExD,IAAY,YAGX;AAHD,WAAY,YAAY;IACpB,uCAAuB,CAAA;IACvB,gEAAgD,CAAA;AACpD,CAAC,EAHW,YAAY,GAAZ,oBAAY,KAAZ,oBAAY,QAGvB;AAED,cAAsB,SAAQ,6BAAY;IACtC,YAAY,EAAU,EAAE,IAAmB;QACvC,KAAK,CAAC,YAAY,CAAC,CAAC;QACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wCAAkB,CAAC;YACnB,IAAI,EAAE,IAAI;YACV,EAAE,EAAE,EAAE;SACT,CAAC,CACL,CAAC;IACN,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,SAAS,CAAC,aAAa,CAAC,IAAI,iCAAc,EAAE,CAAC,CAAC;QAC9C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;IAC9B,CAAC;CACJ;AAfD,4BAeC",
          sourcesContent: ['import { Paragraph } from "file/paragraph";\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nimport { FootnoteAttributes } from "./footnote-attributes";\r\nimport { FootnoteRefRun } from "./run/footnote-ref-run";\r\n\r\nexport enum FootnoteType {\r\n    SEPERATOR = "separator",\r\n    CONTINUATION_SEPERATOR = "continuationSeparator",\r\n}\r\n\r\nexport class Footnote extends XmlComponent {\r\n    constructor(id: number, type?: FootnoteType) {\r\n        super("w:footnote");\r\n        this.root.push(\r\n            new FootnoteAttributes({\r\n                type: type,\r\n                id: id,\r\n            }),\r\n        );\r\n    }\r\n\r\n    public addParagraph(paragraph: Paragraph): void {\r\n        paragraph.addRunToFront(new FootnoteRefRun());\r\n        this.root.push(paragraph);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(263)),
          p = (a.s[3]++, t(264));
      a.s[4]++, function (e) {
        a.f[0]++, a.s[5]++, e.SEPERATOR = "separator", a.s[6]++, e.CONTINUATION_SEPERATOR = "continuationSeparator";
      }((a.b[0][0]++, n.FootnoteType || (a.b[0][1]++, n.FootnoteType = {})));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent145) {
        _inherits(m, _c$XmlComponent145);

        function m(e, n) {
          var _this274;

          _classCallCheck(this, m);

          a.f[1]++, a.s[7]++, _this274 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:footnote")), a.s[8]++, _this274.root.push(new u.FootnoteAttributes({
            type: n,
            id: e
          }));
          return _this274;
        }

        _createClass(m, [{
          key: "addParagraph",
          value: function addParagraph(e) {
            a.f[2]++, a.s[9]++, e.addRunToFront(new p.FootnoteRefRun()), a.s[10]++, this.root.push(e);
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[11]++, n.Footnote = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\footnote-attributes.ts", o = "fcb4b717e35c24e98ca661190ff4f8371ed03f63", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\footnote-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 10,
              column: 10
            }
          },
          4: {
            start: {
              line: 13,
              column: 0
            },
            end: {
              line: 13,
              column: 48
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/footnote-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\footnote-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAO5D,wBAAgC,SAAQ,sCAAoD;IAA5F;;QACuB,YAAO,GAAG;YACzB,IAAI,EAAE,QAAQ;YACd,EAAE,EAAE,MAAM;SACb,CAAC;IACN,CAAC;CAAA;AALD,gDAKC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IFootnoteAttributesProperties {\r\n    readonly type?: string;\r\n    readonly id: number;\r\n}\r\n\r\nexport class FootnoteAttributes extends XmlAttributeComponent<IFootnoteAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        type: "w:type",\r\n        id: "w:id",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon67) {
        _inherits(u, _c$XmlAttributeCompon67);

        function u() {
          var _this275;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this275 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this275.xmlKeys = {
            type: "w:type",
            id: "w:id"
          };
          return _this275;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.FootnoteAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\footnote-ref-run.ts", o = "3d6bd706ae717f9a672beb0b668300eec4d46dea", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\footnote-ref-run.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 45
            }
          },
          2: {
            start: {
              line: 4,
              column: 23
            },
            end: {
              line: 4,
              column: 48
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 16
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 40
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 57
            }
          },
          6: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/run/footnote-ref-run.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\run\\footnote-ref-run.ts"],
          names: [],
          mappings: ";;AAAA,8CAAqC;AACrC,iDAA6C;AAE7C,oBAA4B,SAAQ,eAAG;IACnC;QACI,KAAK,EAAE,CAAC;QAER,IAAI,CAAC,KAAK,CAAC,mBAAmB,CAAC,CAAC;QAChC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,0BAAW,EAAE,CAAC,CAAC;IACtC,CAAC;CACJ;AAPD,wCAOC",
          sourcesContent: ['import { Run } from "file/paragraph";\r\nimport { FootnoteRef } from "./footnote-ref";\r\n\r\nexport class FootnoteRefRun extends Run {\r\n    constructor() {\r\n        super();\r\n\r\n        this.style("FootnoteReference");\r\n        this.root.push(new FootnoteRef());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(265));

      var p =
      /*#__PURE__*/
      function (_c$Run4) {
        _inherits(p, _c$Run4);

        function p() {
          var _this276;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this276 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), a.s[4]++, _this276.style("FootnoteReference"), a.s[5]++, _this276.root.push(new u.FootnoteRef());
          return _this276;
        }

        return p;
      }(c.Run);

      a.s[6]++, n.FootnoteRefRun = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\footnote-ref.ts", o = "58489bccdb455dbd4424af14a8f3901f9a21d2f0", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\footnote-ref.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 31
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 34
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/run/footnote-ref.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\run\\footnote-ref.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,iBAAyB,SAAQ,6BAAY;IACzC;QACI,KAAK,CAAC,eAAe,CAAC,CAAC;IAC3B,CAAC;CACJ;AAJD,kCAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class FootnoteRef extends XmlComponent {\r\n    constructor() {\r\n        super("w:footnoteRef");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent146) {
        _inherits(u, _c$XmlComponent146);

        function u() {
          var _this277;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this277 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:footnoteRef"));
          return _this277;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.FootnoteRef = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\continuation-seperator-run.ts", o = "773e498bae66764b69a7ac545bcc506136d5fb16", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\continuation-seperator-run.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 45
            }
          },
          2: {
            start: {
              line: 4,
              column: 33
            },
            end: {
              line: 4,
              column: 68
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 16
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 77
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 60
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/run/continuation-seperator-run.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\run\\continuation-seperator-run.ts"],
          names: [],
          mappings: ";;AAAA,8CAAqC;AACrC,qEAAiE;AAEjE,8BAAsC,SAAQ,eAAG;IAC7C;QACI,KAAK,EAAE,CAAC;QAER,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,8CAAqB,EAAE,CAAC,CAAC;IAChD,CAAC;CACJ;AAND,4DAMC",
          sourcesContent: ['import { Run } from "file/paragraph";\r\nimport { ContinuationSeperator } from "./continuation-seperator";\r\n\r\nexport class ContinuationSeperatorRun extends Run {\r\n    constructor() {\r\n        super();\r\n\r\n        this.root.push(new ContinuationSeperator());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(267));

      var p =
      /*#__PURE__*/
      function (_c$Run5) {
        _inherits(p, _c$Run5);

        function p() {
          var _this278;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this278 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), a.s[4]++, _this278.root.push(new u.ContinuationSeperator());
          return _this278;
        }

        return p;
      }(c.Run);

      a.s[5]++, n.ContinuationSeperatorRun = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\continuation-seperator.ts", o = "237c9b42c707ef73ea1b0388c4bc109bd94b6b9f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\continuation-seperator.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 41
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 54
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/run/continuation-seperator.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\run\\continuation-seperator.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,2BAAmC,SAAQ,6BAAY;IACnD;QACI,KAAK,CAAC,yBAAyB,CAAC,CAAC;IACrC,CAAC;CACJ;AAJD,sDAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class ContinuationSeperator extends XmlComponent {\r\n    constructor() {\r\n        super("w:continuationSeparator");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent147) {
        _inherits(u, _c$XmlComponent147);

        function u() {
          var _this279;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this279 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:continuationSeparator"));
          return _this279;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.ContinuationSeperator = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\seperator-run.ts", o = "46281b2af557ab3f6638da4afc4505de4bd383c6", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\seperator-run.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 45
            }
          },
          2: {
            start: {
              line: 4,
              column: 20
            },
            end: {
              line: 4,
              column: 42
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 16
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 52
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/run/seperator-run.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\run\\seperator-run.ts"],
          names: [],
          mappings: ";;AAAA,8CAAqC;AACrC,2CAAwC;AAExC,kBAA0B,SAAQ,eAAG;IACjC;QACI,KAAK,EAAE,CAAC;QAER,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,qBAAS,EAAE,CAAC,CAAC;IACpC,CAAC;CACJ;AAND,oCAMC",
          sourcesContent: ['import { Run } from "file/paragraph";\r\nimport { Seperator } from "./seperator";\r\n\r\nexport class SeperatorRun extends Run {\r\n    constructor() {\r\n        super();\r\n\r\n        this.root.push(new Seperator());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(269));

      var p =
      /*#__PURE__*/
      function (_c$Run6) {
        _inherits(p, _c$Run6);

        function p() {
          var _this280;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this280 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), a.s[4]++, _this280.root.push(new u.Seperator());
          return _this280;
        }

        return p;
      }(c.Run);

      a.s[5]++, n.SeperatorRun = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\seperator.ts", o = "77de176909d62d2ee9984eb6150ba620b0e6ad97", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnote\\run\\seperator.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 29
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnote/run/seperator.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnote\\run\\seperator.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,eAAuB,SAAQ,6BAAY;IACvC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;IACzB,CAAC;CACJ;AAJD,8BAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class Seperator extends XmlComponent {\r\n    constructor() {\r\n        super("w:separator");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent148) {
        _inherits(u, _c$XmlComponent148);

        function u() {
          var _this281;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this281 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:separator"));
          return _this281;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.Seperator = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnotes-attributes.ts", o = "b7af38f38670b323175b86b21bf64a9f286e8405", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\footnotes\\footnotes-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 25,
              column: 10
            }
          },
          4: {
            start: {
              line: 28,
              column: 0
            },
            end: {
              line: 28,
              column: 50
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 26,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/footnotes/footnotes-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\footnotes\\footnotes-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAsB5D,yBAAiC,SAAQ,sCAAqD;IAA9F;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,WAAW;YAChB,EAAE,EAAE,UAAU;YACd,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,IAAI,EAAE,YAAY;YAClB,EAAE,EAAE,UAAU;YACd,GAAG,EAAE,WAAW;YAChB,CAAC,EAAE,SAAS;YACZ,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,SAAS,EAAE,cAAc;SAC5B,CAAC;IACN,CAAC;CAAA;AApBD,kDAoBC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IFootnotesAttributesProperties {\r\n    readonly wpc?: string;\r\n    readonly mc?: string;\r\n    readonly o?: string;\r\n    readonly r?: string;\r\n    readonly m?: string;\r\n    readonly v?: string;\r\n    readonly wp14?: string;\r\n    readonly wp?: string;\r\n    readonly w10?: string;\r\n    readonly w?: string;\r\n    readonly w14?: string;\r\n    readonly w15?: string;\r\n    readonly wpg?: string;\r\n    readonly wpi?: string;\r\n    readonly wne?: string;\r\n    readonly wps?: string;\r\n    readonly Ignorable?: string;\r\n}\r\n\r\nexport class FootnotesAttributes extends XmlAttributeComponent<IFootnotesAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        wpc: "xmlns:wpc",\r\n        mc: "xmlns:mc",\r\n        o: "xmlns:o",\r\n        r: "xmlns:r",\r\n        m: "xmlns:m",\r\n        v: "xmlns:v",\r\n        wp14: "xmlns:wp14",\r\n        wp: "xmlns:wp",\r\n        w10: "xmlns:w10",\r\n        w: "xmlns:w",\r\n        w14: "xmlns:w14",\r\n        w15: "xmlns:w15",\r\n        wpg: "xmlns:wpg",\r\n        wpi: "xmlns:wpi",\r\n        wne: "xmlns:wne",\r\n        wps: "xmlns:wps",\r\n        Ignorable: "mc:Ignorable",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon68) {
        _inherits(u, _c$XmlAttributeCompon68);

        function u() {
          var _this282;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this282 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this282.xmlKeys = {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable"
          };
          return _this282;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.FootnotesAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\header\\header.ts", o = "b24632fee8b97e13037a851413d45265ca1e9b1c", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\header\\header.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 20
            },
            end: {
              line: 4,
              column: 43
            }
          },
          3: {
            start: {
              line: 5,
              column: 16
            },
            end: {
              line: 5,
              column: 35
            }
          },
          4: {
            start: {
              line: 6,
              column: 28
            },
            end: {
              line: 6,
              column: 58
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 36
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 37
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 39,
              column: 12
            }
          },
          8: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 26
            }
          },
          9: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 34
            }
          },
          10: {
            start: {
              line: 48,
              column: 21
            },
            end: {
              line: 48,
              column: 52
            }
          },
          11: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 32
            }
          },
          12: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 20
            }
          },
          13: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 30
            }
          },
          14: {
            start: {
              line: 56,
              column: 22
            },
            end: {
              line: 56,
              column: 51
            }
          },
          15: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 29
            }
          },
          16: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 21
            }
          },
          17: {
            start: {
              line: 61,
              column: 0
            },
            end: {
              line: 61,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 46
              },
              end: {
                line: 40,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 41,
                column: 4
              },
              end: {
                line: 41,
                column: 5
              }
            },
            loc: {
              start: {
                line: 41,
                column: 22
              },
              end: {
                line: 43,
                column: 5
              }
            },
            line: 41
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 44,
                column: 4
              },
              end: {
                line: 44,
                column: 5
              }
            },
            loc: {
              start: {
                line: 44,
                column: 28
              },
              end: {
                line: 46,
                column: 5
              }
            },
            line: 44
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 47,
                column: 4
              },
              end: {
                line: 47,
                column: 5
              }
            },
            loc: {
              start: {
                line: 47,
                column: 26
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 47
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 52,
                column: 4
              },
              end: {
                line: 52,
                column: 5
              }
            },
            loc: {
              start: {
                line: 52,
                column: 20
              },
              end: {
                line: 54,
                column: 5
              }
            },
            line: 52
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 55,
                column: 4
              },
              end: {
                line: 55,
                column: 5
              }
            },
            loc: {
              start: {
                line: 55,
                column: 28
              },
              end: {
                line: 59,
                column: 5
              }
            },
            line: 55
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/header/header.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\header\\header.ts"],
          names: [],
          mappings: ";;AACA,wDAA8E;AAC9E,4CAAyC;AACzC,oCAAiC;AACjC,2DAAuD;AAEvD,YAAoB,SAAQ,0CAAyB;IAGjD,YAAY,eAAuB,EAAE,WAA0B;QAC3D,KAAK,CAAC,OAAO,EAAE,WAAW,CAAC,CAAC;QAE5B,IAAI,CAAC,KAAK,GAAG,eAAe,CAAC;QAE7B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,oCAAgB,CAAC;YACjB,GAAG,EAAE,oEAAoE;YACzE,EAAE,EAAE,6DAA6D;YACjE,CAAC,EAAE,yCAAyC;YAC5C,CAAC,EAAE,qEAAqE;YACxE,CAAC,EAAE,4DAA4D;YAC/D,CAAC,EAAE,+BAA+B;YAClC,IAAI,EAAE,qEAAqE;YAC3E,EAAE,EAAE,wEAAwE;YAC5E,GAAG,EAAE,uCAAuC;YAC5C,CAAC,EAAE,8DAA8D;YACjE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,GAAG,EAAE,iEAAiE;YACtE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,EAAE,EAAE,0DAA0D;YAC9D,GAAG,EAAE,8DAA8D;YACnE,GAAG,EAAE,gEAAgE;YACrE,GAAG,EAAE,8DAA8D;YACnE,GAAG,EAAE,+DAA+D;YACpE,GAAG,EAAE,+DAA+D;YACpE,GAAG,EAAE,+DAA+D;YACpE,GAAG,EAAE,+DAA+D;YACpE,GAAG,EAAE,+DAA+D;YACpE,MAAM,EAAE,0DAA0D;YAClE,KAAK,EAAE,4DAA4D;SACtE,CAAC,CACL,CAAC;IACN,CAAC;IAED,IAAW,WAAW;QAClB,OAAO,IAAI,CAAC,KAAK,CAAC;IACtB,CAAC;IAEM,YAAY,CAAC,SAAoB;QACpC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;IAC9B,CAAC;IAEM,eAAe,CAAC,IAAa;QAChC,MAAM,IAAI,GAAG,IAAI,qBAAS,CAAC,IAAI,CAAC,CAAC;QACjC,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,CAAC;QACxB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,QAAQ,CAAC,KAAY;QACxB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;IAC1B,CAAC;IAEM,WAAW,CAAC,IAAY,EAAE,IAAY;QACzC,MAAM,KAAK,GAAG,IAAI,aAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAC;QACpC,IAAI,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAC;QACrB,OAAO,KAAK,CAAC;IACjB,CAAC;CACJ;AAhED,wBAgEC",
          sourcesContent: ['// http://officeopenxml.com/WPheaders.php\r\nimport { InitializableXmlComponent, XmlComponent } from "file/xml-components";\r\nimport { Paragraph } from "../paragraph";\r\nimport { Table } from "../table";\r\nimport { HeaderAttributes } from "./header-attributes";\r\n\r\nexport class Header extends InitializableXmlComponent {\r\n    private readonly refId: number;\r\n\r\n    constructor(referenceNumber: number, initContent?: XmlComponent) {\r\n        super("w:hdr", initContent);\r\n\r\n        this.refId = referenceNumber;\r\n\r\n        this.root.push(\r\n            new HeaderAttributes({\r\n                wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",\r\n                mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",\r\n                o: "urn:schemas-microsoft-com:office:office",\r\n                r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",\r\n                m: "http://schemas.openxmlformats.org/officeDocument/2006/math",\r\n                v: "urn:schemas-microsoft-com:vml",\r\n                wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",\r\n                wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",\r\n                w10: "urn:schemas-microsoft-com:office:word",\r\n                w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",\r\n                w14: "http://schemas.microsoft.com/office/word/2010/wordml",\r\n                w15: "http://schemas.microsoft.com/office/word/2012/wordml",\r\n                wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",\r\n                wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",\r\n                wne: "http://schemas.microsoft.com/office/word/2006/wordml",\r\n                wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",\r\n                cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",\r\n                cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",\r\n                cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",\r\n                cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",\r\n                cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",\r\n                cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",\r\n                cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",\r\n                cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",\r\n                cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",\r\n                w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",\r\n                w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex",\r\n            }),\r\n        );\r\n    }\r\n\r\n    public get ReferenceId(): number {\r\n        return this.refId;\r\n    }\r\n\r\n    public addParagraph(paragraph: Paragraph): void {\r\n        this.root.push(paragraph);\r\n    }\r\n\r\n    public createParagraph(text?: string): Paragraph {\r\n        const para = new Paragraph(text);\r\n        this.addParagraph(para);\r\n        return para;\r\n    }\r\n\r\n    public addTable(table: Table): void {\r\n        this.root.push(table);\r\n    }\r\n\r\n    public createTable(rows: number, cols: number): Table {\r\n        const table = new Table(rows, cols);\r\n        this.addTable(table);\r\n        return table;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(2)),
          p = (a.s[3]++, t(23)),
          m = (a.s[4]++, t(272));

      var C =
      /*#__PURE__*/
      function (_c$InitializableXmlCo2) {
        _inherits(C, _c$InitializableXmlCo2);

        function C(e, n) {
          var _this283;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this283 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:hdr", n)), a.s[6]++, _this283.refId = e, a.s[7]++, _this283.root.push(new m.HeaderAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",
            cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
            cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
            cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
            cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
            cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
            cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
            cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
            cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
            w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",
            w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
          }));
          return _this283;
        }

        _createClass(C, [{
          key: "addParagraph",
          value: function addParagraph(e) {
            a.f[2]++, a.s[9]++, this.root.push(e);
          }
        }, {
          key: "createParagraph",
          value: function createParagraph(e) {
            a.f[3]++;
            var n = (a.s[10]++, new u.Paragraph(e));
            return a.s[11]++, this.addParagraph(n), a.s[12]++, n;
          }
        }, {
          key: "addTable",
          value: function addTable(e) {
            a.f[4]++, a.s[13]++, this.root.push(e);
          }
        }, {
          key: "createTable",
          value: function createTable(e, n) {
            a.f[5]++;
            var t = (a.s[14]++, new p.Table(e, n));
            return a.s[15]++, this.addTable(t), a.s[16]++, t;
          }
        }, {
          key: "ReferenceId",
          get: function get() {
            return a.f[1]++, a.s[8]++, this.refId;
          }
        }]);

        return C;
      }(c.InitializableXmlComponent);

      a.s[17]++, n.Header = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\header\\header-attributes.ts", o = "37cd381865e8798b92cc71d91210d279d22ab8c1", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\header\\header-attributes.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 41,
              column: 10
            }
          },
          4: {
            start: {
              line: 44,
              column: 0
            },
            end: {
              line: 44,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 42,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/header/header-attributes.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\header\\header-attributes.ts"],
          names: [],
          mappings: ";;AAAA,wDAA4D;AAsC5D,sBAA8B,SAAQ,sCAAkD;IAAxF;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,WAAW;YAChB,EAAE,EAAE,UAAU;YACd,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,IAAI,EAAE,YAAY;YAClB,EAAE,EAAE,UAAU;YACd,GAAG,EAAE,WAAW;YAChB,CAAC,EAAE,SAAS;YACZ,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,EAAE,EAAE,UAAU;YACd,EAAE,EAAE,UAAU;YACd,OAAO,EAAE,eAAe;YACxB,QAAQ,EAAE,gBAAgB;YAC1B,GAAG,EAAE,WAAW;YAChB,IAAI,EAAE,UAAU;YAChB,EAAE,EAAE,UAAU;YACd,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,MAAM,EAAE,cAAc;YACtB,KAAK,EAAE,aAAa;SACvB,CAAC;IACN,CAAC;CAAA;AApCD,4CAoCC",
          sourcesContent: ['import { XmlAttributeComponent } from "file/xml-components";\r\n\r\nexport interface IHeaderAttributesProperties {\r\n    readonly wpc?: string;\r\n    readonly mc?: string;\r\n    readonly o?: string;\r\n    readonly r?: string;\r\n    readonly m?: string;\r\n    readonly v?: string;\r\n    readonly wp14?: string;\r\n    readonly wp?: string;\r\n    readonly w10?: string;\r\n    readonly w?: string;\r\n    readonly w14?: string;\r\n    readonly w15?: string;\r\n    readonly wpg?: string;\r\n    readonly wpi?: string;\r\n    readonly wne?: string;\r\n    readonly wps?: string;\r\n    readonly cp?: string;\r\n    readonly dc?: string;\r\n    readonly dcterms?: string;\r\n    readonly dcmitype?: string;\r\n    readonly xsi?: string;\r\n    readonly type?: string;\r\n    readonly cx?: string;\r\n    readonly cx1?: string;\r\n    readonly cx2?: string;\r\n    readonly cx3?: string;\r\n    readonly cx4?: string;\r\n    readonly cx5?: string;\r\n    readonly cx6?: string;\r\n    readonly cx7?: string;\r\n    readonly cx8?: string;\r\n    readonly w16cid: string;\r\n    readonly w16se: string;\r\n}\r\n\r\nexport class HeaderAttributes extends XmlAttributeComponent<IHeaderAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        wpc: "xmlns:wpc",\r\n        mc: "xmlns:mc",\r\n        o: "xmlns:o",\r\n        r: "xmlns:r",\r\n        m: "xmlns:m",\r\n        v: "xmlns:v",\r\n        wp14: "xmlns:wp14",\r\n        wp: "xmlns:wp",\r\n        w10: "xmlns:w10",\r\n        w: "xmlns:w",\r\n        w14: "xmlns:w14",\r\n        w15: "xmlns:w15",\r\n        wpg: "xmlns:wpg",\r\n        wpi: "xmlns:wpi",\r\n        wne: "xmlns:wne",\r\n        wps: "xmlns:wps",\r\n        cp: "xmlns:cp",\r\n        dc: "xmlns:dc",\r\n        dcterms: "xmlns:dcterms",\r\n        dcmitype: "xmlns:dcmitype",\r\n        xsi: "xmlns:xsi",\r\n        type: "xsi:type",\r\n        cx: "xmlns:cx",\r\n        cx1: "xmlns:cx1",\r\n        cx2: "xmlns:cx2",\r\n        cx3: "xmlns:cx3",\r\n        cx4: "xmlns:cx4",\r\n        cx5: "xmlns:cx5",\r\n        cx6: "xmlns:cx6",\r\n        cx7: "xmlns:cx7",\r\n        cx8: "xmlns:cx8",\r\n        w16cid: "xmlns:w16cid",\r\n        w16se: "xmlns:w16se",\r\n    };\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon69) {
        _inherits(u, _c$XmlAttributeCompon69);

        function u() {
          var _this284;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this284 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this284.xmlKeys = {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type",
            cx: "xmlns:cx",
            cx1: "xmlns:cx1",
            cx2: "xmlns:cx2",
            cx3: "xmlns:cx3",
            cx4: "xmlns:cx4",
            cx5: "xmlns:cx5",
            cx6: "xmlns:cx6",
            cx7: "xmlns:cx7",
            cx8: "xmlns:cx8",
            w16cid: "xmlns:w16cid",
            w16se: "xmlns:w16se"
          };
          return _this284;
        }

        return u;
      }(c.XmlAttributeComponent);

      a.s[4]++, n.HeaderAttributes = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\numbering.ts", o = "b98d51a85c97319e6113624e2496f2761015dc82", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\numbering.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 45
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 5,
              column: 30
            },
            end: {
              line: 5,
              column: 72
            }
          },
          4: {
            start: {
              line: 6,
              column: 29
            },
            end: {
              line: 6,
              column: 60
            }
          },
          5: {
            start: {
              line: 7,
              column: 14
            },
            end: {
              line: 7,
              column: 30
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 29
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 36
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 36
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 31,
              column: 12
            }
          },
          10: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 24
            }
          },
          11: {
            start: {
              line: 33,
              column: 34
            },
            end: {
              line: 33,
              column: 64
            }
          },
          12: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 143
            }
          },
          13: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 144
            }
          },
          14: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 144
            }
          },
          15: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 144
            }
          },
          16: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 38,
              column: 144
            }
          },
          17: {
            start: {
              line: 39,
              column: 8
            },
            end: {
              line: 39,
              column: 144
            }
          },
          18: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 144
            }
          },
          19: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 144
            }
          },
          20: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 144
            }
          },
          21: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 56
            }
          },
          22: {
            start: {
              line: 46,
              column: 20
            },
            end: {
              line: 46,
              column: 77
            }
          },
          23: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 41
            }
          },
          24: {
            start: {
              line: 48,
              column: 8
            },
            end: {
              line: 48,
              column: 19
            }
          },
          25: {
            start: {
              line: 51,
              column: 20
            },
            end: {
              line: 51,
              column: 70
            }
          },
          26: {
            start: {
              line: 52,
              column: 8
            },
            end: {
              line: 52,
              column: 41
            }
          },
          27: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 19
            }
          },
          28: {
            start: {
              line: 56,
              column: 8
            },
            end: {
              line: 56,
              column: 65
            }
          },
          29: {
            start: {
              line: 56,
              column: 46
            },
            end: {
              line: 56,
              column: 63
            }
          },
          30: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 57,
              column: 65
            }
          },
          31: {
            start: {
              line: 57,
              column: 46
            },
            end: {
              line: 57,
              column: 63
            }
          },
          32: {
            start: {
              line: 58,
              column: 8
            },
            end: {
              line: 58,
              column: 34
            }
          },
          33: {
            start: {
              line: 61,
              column: 0
            },
            end: {
              line: 61,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 9,
                column: 4
              },
              end: {
                line: 9,
                column: 5
              }
            },
            loc: {
              start: {
                line: 9,
                column: 18
              },
              end: {
                line: 44,
                column: 5
              }
            },
            line: 9
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 45,
                column: 4
              },
              end: {
                line: 45,
                column: 5
              }
            },
            loc: {
              start: {
                line: 45,
                column: 30
              },
              end: {
                line: 49,
                column: 5
              }
            },
            line: 45
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 50,
                column: 4
              },
              end: {
                line: 50,
                column: 5
              }
            },
            loc: {
              start: {
                line: 50,
                column: 47
              },
              end: {
                line: 54,
                column: 5
              }
            },
            line: 50
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 55,
                column: 4
              },
              end: {
                line: 55,
                column: 5
              }
            },
            loc: {
              start: {
                line: 55,
                column: 17
              },
              end: {
                line: 59,
                column: 5
              }
            },
            line: 55
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 56,
                column: 39
              },
              end: {
                line: 56,
                column: 40
              }
            },
            loc: {
              start: {
                line: 56,
                column: 46
              },
              end: {
                line: 56,
                column: 63
              }
            },
            line: 56
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 57,
                column: 39
              },
              end: {
                line: 57,
                column: 40
              }
            },
            loc: {
              start: {
                line: 57,
                column: 46
              },
              end: {
                line: 57,
                column: 63
              }
            },
            line: 57
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/numbering/numbering.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\numbering\\numbering.ts"],
          names: [],
          mappings: ";;AAAA,8CAAwC;AACxC,wDAAmE;AACnE,yEAAqE;AACrE,6DAAyD;AACzD,+BAA4B;AAE5B,eAAuB,SAAQ,6BAAY;IAOvC;QACI,KAAK,CAAC,aAAa,CAAC,CAAC;QAJR,sBAAiB,GAAmB,EAAE,CAAC;QACvC,sBAAiB,GAAmB,EAAE,CAAC;QAIpD,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,wCAAkB,CAAC;YACnB,GAAG,EAAE,oEAAoE;YACzE,EAAE,EAAE,6DAA6D;YACjE,CAAC,EAAE,yCAAyC;YAC5C,CAAC,EAAE,qEAAqE;YACxE,CAAC,EAAE,4DAA4D;YAC/D,CAAC,EAAE,+BAA+B;YAClC,IAAI,EAAE,qEAAqE;YAC3E,EAAE,EAAE,wEAAwE;YAC5E,GAAG,EAAE,uCAAuC;YAC5C,CAAC,EAAE,8DAA8D;YACjE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,GAAG,EAAE,iEAAiE;YACtE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,SAAS,EAAE,cAAc;SAC5B,CAAC,CACL,CAAC;QAEF,IAAI,CAAC,MAAM,GAAG,CAAC,CAAC;QAEhB,MAAM,iBAAiB,GAAG,IAAI,CAAC,uBAAuB,EAAE,CAAC;QAEzD,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,GAAG,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE3H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,iBAAiB,CAAC,WAAW,CAAC,CAAC,EAAE,QAAQ,EAAE,QAAQ,EAAE,MAAM,CAAC,CAAC,oBAAoB,CAAC,IAAI,kBAAM,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,CAAC,CAAC,CAAC;QAE5H,IAAI,CAAC,uBAAuB,CAAC,iBAAiB,CAAC,CAAC;IACpD,CAAC;IAEM,uBAAuB;QAC1B,MAAM,GAAG,GAAG,IAAI,sCAAiB,CAAC,IAAI,CAAC,MAAM,EAAE,CAAC,CAAC;QACjD,IAAI,CAAC,iBAAiB,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QACjC,OAAO,GAAG,CAAC;IACf,CAAC;IAEM,uBAAuB,CAAC,iBAAoC;QAC/D,MAAM,GAAG,GAAG,IAAI,SAAG,CAAC,IAAI,CAAC,MAAM,EAAE,EAAE,iBAAiB,CAAC,EAAE,CAAC,CAAC;QACzD,IAAI,CAAC,iBAAiB,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QACjC,OAAO,GAAG,CAAC;IACf,CAAC;IAEM,UAAU;QACb,IAAI,CAAC,iBAAiB,CAAC,OAAO,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC;QACzD,IAAI,CAAC,iBAAiB,CAAC,OAAO,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC;QACzD,OAAO,KAAK,CAAC,UAAU,EAAE,CAAC;IAC9B,CAAC;CACJ;AAzED,8BAyEC",
          sourcesContent: ["import { Indent } from \"file/paragraph\";\r\nimport { IXmlableObject, XmlComponent } from \"file/xml-components\";\r\nimport { DocumentAttributes } from \"../document/document-attributes\";\r\nimport { AbstractNumbering } from \"./abstract-numbering\";\r\nimport { Num } from \"./num\";\r\n\r\nexport class Numbering extends XmlComponent {\r\n    // tslint:disable-next-line:readonly-keyword\r\n    private nextId: number;\r\n\r\n    private readonly abstractNumbering: XmlComponent[] = [];\r\n    private readonly concreteNumbering: XmlComponent[] = [];\r\n\r\n    constructor() {\r\n        super(\"w:numbering\");\r\n        this.root.push(\r\n            new DocumentAttributes({\r\n                wpc: \"http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas\",\r\n                mc: \"http://schemas.openxmlformats.org/markup-compatibility/2006\",\r\n                o: \"urn:schemas-microsoft-com:office:office\",\r\n                r: \"http://schemas.openxmlformats.org/officeDocument/2006/relationships\",\r\n                m: \"http://schemas.openxmlformats.org/officeDocument/2006/math\",\r\n                v: \"urn:schemas-microsoft-com:vml\",\r\n                wp14: \"http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing\",\r\n                wp: \"http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing\",\r\n                w10: \"urn:schemas-microsoft-com:office:word\",\r\n                w: \"http://schemas.openxmlformats.org/wordprocessingml/2006/main\",\r\n                w14: \"http://schemas.microsoft.com/office/word/2010/wordml\",\r\n                w15: \"http://schemas.microsoft.com/office/word/2012/wordml\",\r\n                wpg: \"http://schemas.microsoft.com/office/word/2010/wordprocessingGroup\",\r\n                wpi: \"http://schemas.microsoft.com/office/word/2010/wordprocessingInk\",\r\n                wne: \"http://schemas.microsoft.com/office/word/2006/wordml\",\r\n                wps: \"http://schemas.microsoft.com/office/word/2010/wordprocessingShape\",\r\n                Ignorable: \"w14 w15 wp14\",\r\n            }),\r\n        );\r\n\r\n        this.nextId = 0;\r\n\r\n        const abstractNumbering = this.createAbstractNumbering();\r\n\r\n        abstractNumbering.createLevel(0, \"bullet\", \"\\u25CF\", \"left\").addParagraphProperty(new Indent({ left: 720, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(1, \"bullet\", \"\\u25CB\", \"left\").addParagraphProperty(new Indent({ left: 1440, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(2, \"bullet\", \"\\u25A0\", \"left\").addParagraphProperty(new Indent({ left: 2160, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(3, \"bullet\", \"\\u25CF\", \"left\").addParagraphProperty(new Indent({ left: 2880, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(4, \"bullet\", \"\\u25CB\", \"left\").addParagraphProperty(new Indent({ left: 3600, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(5, \"bullet\", \"\\u25A0\", \"left\").addParagraphProperty(new Indent({ left: 4320, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(6, \"bullet\", \"\\u25CF\", \"left\").addParagraphProperty(new Indent({ left: 5040, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(7, \"bullet\", \"\\u25CB\", \"left\").addParagraphProperty(new Indent({ left: 5760, hanging: 360 }));\r\n\r\n        abstractNumbering.createLevel(8, \"bullet\", \"\\u25A0\", \"left\").addParagraphProperty(new Indent({ left: 6480, hanging: 360 }));\r\n\r\n        this.createConcreteNumbering(abstractNumbering);\r\n    }\r\n\r\n    public createAbstractNumbering(): AbstractNumbering {\r\n        const num = new AbstractNumbering(this.nextId++);\r\n        this.abstractNumbering.push(num);\r\n        return num;\r\n    }\r\n\r\n    public createConcreteNumbering(abstractNumbering: AbstractNumbering): Num {\r\n        const num = new Num(this.nextId++, abstractNumbering.id);\r\n        this.concreteNumbering.push(num);\r\n        return num;\r\n    }\r\n\r\n    public prepForXml(): IXmlableObject | undefined {\r\n        this.abstractNumbering.forEach((x) => this.root.push(x));\r\n        this.concreteNumbering.forEach((x) => this.root.push(x));\r\n        return super.prepForXml();\r\n    }\r\n}\r\n"]
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(0)),
          p = (a.s[3]++, t(11)),
          m = (a.s[4]++, t(103)),
          C = (a.s[5]++, t(275));

      var d =
      /*#__PURE__*/
      function (_u$XmlComponent9) {
        _inherits(d, _u$XmlComponent9);

        function d() {
          var _this285;

          _classCallCheck(this, d);

          a.f[0]++, a.s[6]++, _this285 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "w:numbering")), a.s[7]++, _this285.abstractNumbering = [], a.s[8]++, _this285.concreteNumbering = [], a.s[9]++, _this285.root.push(new p.DocumentAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
          })), a.s[10]++, _this285.nextId = 0;
          var e = (a.s[11]++, _this285.createAbstractNumbering());
          a.s[12]++, e.createLevel(0, "bullet", "●", "left").addParagraphProperty(new c.Indent({
            left: 720,
            hanging: 360
          })), a.s[13]++, e.createLevel(1, "bullet", "○", "left").addParagraphProperty(new c.Indent({
            left: 1440,
            hanging: 360
          })), a.s[14]++, e.createLevel(2, "bullet", "■", "left").addParagraphProperty(new c.Indent({
            left: 2160,
            hanging: 360
          })), a.s[15]++, e.createLevel(3, "bullet", "●", "left").addParagraphProperty(new c.Indent({
            left: 2880,
            hanging: 360
          })), a.s[16]++, e.createLevel(4, "bullet", "○", "left").addParagraphProperty(new c.Indent({
            left: 3600,
            hanging: 360
          })), a.s[17]++, e.createLevel(5, "bullet", "■", "left").addParagraphProperty(new c.Indent({
            left: 4320,
            hanging: 360
          })), a.s[18]++, e.createLevel(6, "bullet", "●", "left").addParagraphProperty(new c.Indent({
            left: 5040,
            hanging: 360
          })), a.s[19]++, e.createLevel(7, "bullet", "○", "left").addParagraphProperty(new c.Indent({
            left: 5760,
            hanging: 360
          })), a.s[20]++, e.createLevel(8, "bullet", "■", "left").addParagraphProperty(new c.Indent({
            left: 6480,
            hanging: 360
          })), a.s[21]++, _this285.createConcreteNumbering(e);
          return _this285;
        }

        _createClass(d, [{
          key: "createAbstractNumbering",
          value: function createAbstractNumbering() {
            a.f[1]++;
            var e = (a.s[22]++, new m.AbstractNumbering(this.nextId++));
            return a.s[23]++, this.abstractNumbering.push(e), a.s[24]++, e;
          }
        }, {
          key: "createConcreteNumbering",
          value: function createConcreteNumbering(e) {
            a.f[2]++;
            var n = (a.s[25]++, new C.Num(this.nextId++, e.id));
            return a.s[26]++, this.concreteNumbering.push(n), a.s[27]++, n;
          }
        }, {
          key: "prepForXml",
          value: function prepForXml() {
            var _this286 = this;

            return a.f[3]++, a.s[28]++, this.abstractNumbering.forEach(function (e) {
              return a.f[4]++, a.s[29]++, _this286.root.push(e);
            }), a.s[30]++, this.concreteNumbering.forEach(function (e) {
              return a.f[5]++, a.s[31]++, _this286.root.push(e);
            }), a.s[32]++, _get(_getPrototypeOf(d.prototype), "prepForXml", this).call(this);
          }
        }]);

        return d;
      }(u.XmlComponent);

      a.s[33]++, n.Numbering = d;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\multi-level-type.ts", o = "00f6814fc1799efb02a6b58db09bf21c77672bfe", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\multi-level-type.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 34
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 9,
              column: 12
            }
          },
          4: {
            start: {
              line: 12,
              column: 0
            },
            end: {
              line: 12,
              column: 40
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 23
              },
              end: {
                line: 10,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/numbering/multi-level-type.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\numbering\\multi-level-type.ts"],
          names: [],
          mappings: ";;AAAA,wDAA+D;AAE/D,oBAA4B,SAAQ,6BAAY;IAC5C,YAAY,KAAa;QACrB,KAAK,CAAC,kBAAkB,CAAC,CAAC;QAC1B,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AATD,wCASC",
          sourcesContent: ['import { Attributes, XmlComponent } from "file/xml-components";\r\n\r\nexport class MultiLevelType extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:multiLevelType");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent149) {
        _inherits(u, _c$XmlComponent149);

        function u(e) {
          var _this287;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this287 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:multiLevelType")), a.s[3]++, _this287.root.push(new c.Attributes({
            val: e
          }));
          return _this287;
        }

        return u;
      }(c.XmlComponent);

      a.s[4]++, n.MultiLevelType = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\num.ts", o = "9b59c7a398e0270b5d137f83631ecce763741612", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\numbering\\num.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 33
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 10,
              column: 12
            }
          },
          5: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 28
            }
          },
          6: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 44
            }
          },
          7: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 23
            }
          },
          8: {
            start: {
              line: 22,
              column: 8
            },
            end: {
              line: 24,
              column: 12
            }
          },
          9: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 57
            }
          },
          10: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 24
            }
          },
          11: {
            start: {
              line: 29,
              column: 21
            },
            end: {
              line: 29,
              column: 50
            }
          },
          12: {
            start: {
              line: 30,
              column: 8
            },
            end: {
              line: 30,
              column: 29
            }
          },
          13: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 20
            }
          },
          14: {
            start: {
              line: 34,
              column: 0
            },
            end: {
              line: 34,
              column: 18
            }
          },
          15: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 28
            }
          },
          16: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 38,
              column: 42
            }
          },
          17: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 31
            }
          },
          18: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 44,
              column: 33
            }
          },
          19: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 72
            }
          },
          20: {
            start: {
              line: 46,
              column: 8
            },
            end: {
              line: 48,
              column: 9
            }
          },
          21: {
            start: {
              line: 47,
              column: 12
            },
            end: {
              line: 47,
              column: 53
            }
          },
          22: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 63
            }
          },
          23: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 50,
              column: 33
            }
          },
          24: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 24
            }
          },
          25: {
            start: {
              line: 56,
              column: 0
            },
            end: {
              line: 56,
              column: 38
            }
          },
          26: {
            start: {
              line: 59,
              column: 8
            },
            end: {
              line: 59,
              column: 28
            }
          },
          27: {
            start: {
              line: 60,
              column: 8
            },
            end: {
              line: 60,
              column: 40
            }
          },
          28: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 65,
              column: 33
            }
          },
          29: {
            start: {
              line: 66,
              column: 8
            },
            end: {
              line: 66,
              column: 68
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 23
              },
              end: {
                line: 11,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 14,
                column: 4
              },
              end: {
                line: 14,
                column: 5
              }
            },
            loc: {
              start: {
                line: 14,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 14
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 20,
                column: 4
              },
              end: {
                line: 20,
                column: 5
              }
            },
            loc: {
              start: {
                line: 20,
                column: 38
              },
              end: {
                line: 27,
                column: 5
              }
            },
            line: 20
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 28,
                column: 4
              },
              end: {
                line: 28,
                column: 5
              }
            },
            loc: {
              start: {
                line: 28,
                column: 30
              },
              end: {
                line: 32,
                column: 5
              }
            },
            line: 28
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 36,
                column: 4
              },
              end: {
                line: 36,
                column: 5
              }
            },
            loc: {
              start: {
                line: 36,
                column: 18
              },
              end: {
                line: 39,
                column: 5
              }
            },
            line: 36
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 42,
                column: 4
              },
              end: {
                line: 42,
                column: 5
              }
            },
            loc: {
              start: {
                line: 42,
                column: 33
              },
              end: {
                line: 51,
                column: 5
              }
            },
            line: 42
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 52,
                column: 4
              },
              end: {
                line: 52,
                column: 5
              }
            },
            loc: {
              start: {
                line: 52,
                column: 16
              },
              end: {
                line: 54,
                column: 5
              }
            },
            line: 52
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 58,
                column: 4
              },
              end: {
                line: 58,
                column: 5
              }
            },
            loc: {
              start: {
                line: 58,
                column: 18
              },
              end: {
                line: 61,
                column: 5
              }
            },
            line: 58
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 64,
                column: 4
              },
              end: {
                line: 64,
                column: 5
              }
            },
            loc: {
              start: {
                line: 64,
                column: 23
              },
              end: {
                line: 67,
                column: 5
              }
            },
            line: 64
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 46,
                column: 8
              },
              end: {
                line: 48,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 46,
                column: 8
              },
              end: {
                line: 48,
                column: 9
              }
            }, {
              start: {
                line: 46,
                column: 8
              },
              end: {
                line: 48,
                column: 9
              }
            }],
            line: 46
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/numbering/num.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\numbering\\num.ts"],
          names: [],
          mappings: ";;AAAA,wDAAsF;AACtF,mCAA2C;AAE3C,mBAAoB,SAAQ,6BAAY;IACpC,YAAY,KAAa;QACrB,KAAK,CAAC,iBAAiB,CAAC,CAAC;QACzB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,2BAAU,CAAC;YACX,GAAG,EAAE,KAAK;SACb,CAAC,CACL,CAAC;IACN,CAAC;CACJ;AAMD,mBAAoB,SAAQ,sCAA+C;IAA3E;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,SAAS,EAAE,CAAC;IACtD,CAAC;CAAA;AAED,SAAiB,SAAQ,6BAAY;IAGjC,YAAY,KAAa,EAAE,aAAqB;QAC5C,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,aAAa,CAAC;YACd,KAAK,EAAE,KAAK;SACf,CAAC,CACL,CAAC;QACF,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAa,CAAC,aAAa,CAAC,CAAC,CAAC;QACjD,IAAI,CAAC,EAAE,GAAG,KAAK,CAAC;IACpB,CAAC;IAEM,aAAa,CAAC,GAAW,EAAE,KAAc;QAC5C,MAAM,IAAI,GAAG,IAAI,aAAa,CAAC,GAAG,EAAE,KAAK,CAAC,CAAC;QAC3C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;QACrB,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAnBD,kBAmBC;AAED,6BAA8B,SAAQ,sCAAgD;IAAtF;;QACuB,YAAO,GAAG,EAAE,IAAI,EAAE,QAAQ,EAAE,CAAC;IACpD,CAAC;CAAA;AAED,mBAA2B,SAAQ,6BAAY;IAG3C,YAA6B,QAAgB,EAAE,KAAc;QACzD,KAAK,CAAC,eAAe,CAAC,CAAC;QADE,aAAQ,GAAR,QAAQ,CAAQ;QAEzC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAuB,CAAC,EAAE,IAAI,EAAE,QAAQ,EAAE,CAAC,CAAC,CAAC;QAChE,IAAI,KAAK,KAAK,SAAS,EAAE;YACrB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAa,CAAC,KAAK,CAAC,CAAC,CAAC;SAC5C;QAED,IAAI,CAAC,GAAG,GAAG,IAAI,wBAAgB,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QAC/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;IAC7B,CAAC;IAED,IAAW,KAAK;QACZ,OAAO,IAAI,CAAC,GAAG,CAAC;IACpB,CAAC;CACJ;AAjBD,sCAiBC;AAED,6BAA8B,SAAQ,sCAA+C;IAArF;;QACuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC;IAClD,CAAC;CAAA;AAED,mBAAoB,SAAQ,6BAAY;IACpC,YAAY,KAAa;QACrB,KAAK,CAAC,iBAAiB,CAAC,CAAC;QACzB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,uBAAuB,CAAC,EAAE,GAAG,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAChE,CAAC;CACJ",
          sourcesContent: ['import { Attributes, XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport { LevelForOverride } from "./level";\r\n\r\nclass AbstractNumId extends XmlComponent {\r\n    constructor(value: number) {\r\n        super("w:abstractNumId");\r\n        this.root.push(\r\n            new Attributes({\r\n                val: value,\r\n            }),\r\n        );\r\n    }\r\n}\r\n\r\ninterface INumAttributesProperties {\r\n    readonly numId: number;\r\n}\r\n\r\nclass NumAttributes extends XmlAttributeComponent<INumAttributesProperties> {\r\n    protected readonly xmlKeys = { numId: "w:numId" };\r\n}\r\n\r\nexport class Num extends XmlComponent {\r\n    public readonly id: number;\r\n\r\n    constructor(numId: number, abstractNumId: number) {\r\n        super("w:num");\r\n        this.root.push(\r\n            new NumAttributes({\r\n                numId: numId,\r\n            }),\r\n        );\r\n        this.root.push(new AbstractNumId(abstractNumId));\r\n        this.id = numId;\r\n    }\r\n\r\n    public overrideLevel(num: number, start?: number): LevelOverride {\r\n        const olvl = new LevelOverride(num, start);\r\n        this.root.push(olvl);\r\n        return olvl;\r\n    }\r\n}\r\n\r\nclass LevelOverrideAttributes extends XmlAttributeComponent<{ readonly ilvl: number }> {\r\n    protected readonly xmlKeys = { ilvl: "w:ilvl" };\r\n}\r\n\r\nexport class LevelOverride extends XmlComponent {\r\n    private readonly lvl: LevelForOverride;\r\n\r\n    constructor(private readonly levelNum: number, start?: number) {\r\n        super("w:lvlOverride");\r\n        this.root.push(new LevelOverrideAttributes({ ilvl: levelNum }));\r\n        if (start !== undefined) {\r\n            this.root.push(new StartOverride(start));\r\n        }\r\n\r\n        this.lvl = new LevelForOverride(this.levelNum);\r\n        this.root.push(this.lvl);\r\n    }\r\n\r\n    public get Level(): LevelForOverride {\r\n        return this.lvl;\r\n    }\r\n}\r\n\r\nclass StartOverrideAttributes extends XmlAttributeComponent<{ readonly val: number }> {\r\n    protected readonly xmlKeys = { val: "w:val" };\r\n}\r\n\r\nclass StartOverride extends XmlComponent {\r\n    constructor(start: number) {\r\n        super("w:startOverride");\r\n        this.root.push(new StartOverrideAttributes({ val: start }));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(43));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent150) {
        _inherits(p, _c$XmlComponent150);

        function p(e) {
          var _this288;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this288 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:abstractNumId")), a.s[4]++, _this288.root.push(new c.Attributes({
            val: e
          }));
          return _this288;
        }

        return p;
      }(c.XmlComponent);

      var m =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon70) {
        _inherits(m, _c$XmlAttributeCompon70);

        function m() {
          var _this289;

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this289 = _possibleConstructorReturn(this, _getPrototypeOf(m).apply(this, arguments)), a.s[6]++, _this289.xmlKeys = {
            numId: "w:numId"
          };
          return _this289;
        }

        return m;
      }(c.XmlAttributeComponent);

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent151) {
        _inherits(C, _c$XmlComponent151);

        function C(e, n) {
          var _this290;

          _classCallCheck(this, C);

          a.f[2]++, a.s[7]++, _this290 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:num")), a.s[8]++, _this290.root.push(new m({
            numId: e
          })), a.s[9]++, _this290.root.push(new p(n)), a.s[10]++, _this290.id = e;
          return _this290;
        }

        _createClass(C, [{
          key: "overrideLevel",
          value: function overrideLevel(e, n) {
            a.f[3]++;
            var t = (a.s[11]++, new f(e, n));
            return a.s[12]++, this.root.push(t), a.s[13]++, t;
          }
        }]);

        return C;
      }(c.XmlComponent);

      a.s[14]++, n.Num = C;

      var d =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon71) {
        _inherits(d, _c$XmlAttributeCompon71);

        function d() {
          var _this291;

          _classCallCheck(this, d);

          a.f[4]++, a.s[15]++, _this291 = _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments)), a.s[16]++, _this291.xmlKeys = {
            ilvl: "w:ilvl"
          };
          return _this291;
        }

        return d;
      }(c.XmlAttributeComponent);

      var f =
      /*#__PURE__*/
      function (_c$XmlComponent152) {
        _inherits(f, _c$XmlComponent152);

        function f(e, n) {
          var _this292;

          _classCallCheck(this, f);

          a.f[5]++, a.s[17]++, _this292 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "w:lvlOverride")), a.s[18]++, _this292.levelNum = e, a.s[19]++, _this292.root.push(new d({
            ilvl: e
          })), a.s[20]++, void 0 !== n ? (a.b[0][0]++, a.s[21]++, _this292.root.push(new x(n))) : a.b[0][1]++, a.s[22]++, _this292.lvl = new u.LevelForOverride(_this292.levelNum), a.s[23]++, _this292.root.push(_this292.lvl);
          return _this292;
        }

        _createClass(f, [{
          key: "Level",
          get: function get() {
            return a.f[6]++, a.s[24]++, this.lvl;
          }
        }]);

        return f;
      }(c.XmlComponent);

      a.s[25]++, n.LevelOverride = f;

      var h =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon72) {
        _inherits(h, _c$XmlAttributeCompon72);

        function h() {
          var _this293;

          _classCallCheck(this, h);

          a.f[7]++, a.s[26]++, _this293 = _possibleConstructorReturn(this, _getPrototypeOf(h).apply(this, arguments)), a.s[27]++, _this293.xmlKeys = {
            val: "w:val"
          };
          return _this293;
        }

        return h;
      }(c.XmlAttributeComponent);

      var x =
      /*#__PURE__*/
      function (_c$XmlComponent153) {
        _inherits(x, _c$XmlComponent153);

        function x(e) {
          var _this294;

          _classCallCheck(this, x);

          a.f[8]++, a.s[28]++, _this294 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, "w:startOverride")), a.s[29]++, _this294.root.push(new h({
            val: e
          }));
          return _this294;
        }

        return x;
      }(c.XmlComponent);
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\settings\\index.ts", o = "578df85243ae25d0a898f7b2929891dc66415a68", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\settings\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 32
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 37
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/settings/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\settings\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,gCAA2B;AAC3B,qCAAgC",
          sourcesContent: ['export * from "./settings";\r\nexport * from "./update-fields";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(277)), a.s[5]++, c(t(104));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\settings\\settings.ts", o = "9c698ecff4b85f48c57ae228cffe9b3cd6973e24", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\settings\\settings.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 24
            },
            end: {
              line: 4,
              column: 50
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 26,
              column: 10
            }
          },
          5: {
            start: {
              line: 29,
              column: 0
            },
            end: {
              line: 29,
              column: 48
            }
          },
          6: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 28
            }
          },
          7: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 51,
              column: 12
            }
          },
          8: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 56,
              column: 9
            }
          },
          9: {
            start: {
              line: 54,
              column: 39
            },
            end: {
              line: 54,
              column: 84
            }
          },
          10: {
            start: {
              line: 55,
              column: 12
            },
            end: {
              line: 55,
              column: 69
            }
          },
          11: {
            start: {
              line: 59,
              column: 0
            },
            end: {
              line: 59,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 27,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 31,
                column: 4
              },
              end: {
                line: 31,
                column: 5
              }
            },
            loc: {
              start: {
                line: 31,
                column: 18
              },
              end: {
                line: 52,
                column: 5
              }
            },
            line: 31
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 53,
                column: 4
              },
              end: {
                line: 53,
                column: 5
              }
            },
            loc: {
              start: {
                line: 53,
                column: 22
              },
              end: {
                line: 57,
                column: 5
              }
            },
            line: 53
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 54,
                column: 28
              },
              end: {
                line: 54,
                column: 29
              }
            },
            loc: {
              start: {
                line: 54,
                column: 39
              },
              end: {
                line: 54,
                column: 84
              }
            },
            line: 54
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 56,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 56,
                column: 9
              }
            }, {
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 56,
                column: 9
              }
            }],
            line: 54
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/settings/settings.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\settings\\settings.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAC1E,mDAA+C;AAoB/C,wBAAgC,SAAQ,sCAAoD;IAA5F;;QACuB,YAAO,GAAG;YACzB,GAAG,EAAE,WAAW;YAChB,EAAE,EAAE,UAAU;YACd,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,CAAC,EAAE,SAAS;YACZ,IAAI,EAAE,YAAY;YAClB,EAAE,EAAE,UAAU;YACd,GAAG,EAAE,WAAW;YAChB,CAAC,EAAE,SAAS;YACZ,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,GAAG,EAAE,WAAW;YAChB,SAAS,EAAE,cAAc;SAC5B,CAAC;IACN,CAAC;CAAA;AApBD,gDAoBC;AACD,cAAsB,SAAQ,6BAAY;IACtC;QACI,KAAK,CAAC,YAAY,CAAC,CAAC;QACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CACV,IAAI,kBAAkB,CAAC;YACnB,GAAG,EAAE,oEAAoE;YACzE,EAAE,EAAE,6DAA6D;YACjE,CAAC,EAAE,yCAAyC;YAC5C,CAAC,EAAE,qEAAqE;YACxE,CAAC,EAAE,4DAA4D;YAC/D,CAAC,EAAE,+BAA+B;YAClC,IAAI,EAAE,qEAAqE;YAC3E,EAAE,EAAE,wEAAwE;YAC5E,GAAG,EAAE,uCAAuC;YAC5C,CAAC,EAAE,8DAA8D;YACjE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,GAAG,EAAE,iEAAiE;YACtE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,mEAAmE;YACxE,SAAS,EAAE,cAAc;SAC5B,CAAC,CACL,CAAC;IACN,CAAC;IACM,eAAe;QAClB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,KAAK,EAAE,EAAE,CAAC,KAAK,YAAY,4BAAY,CAAC,EAAE;YAC3D,IAAI,CAAC,eAAe,CAAC,IAAI,4BAAY,EAAE,CAAC,CAAC;SAC5C;IACL,CAAC;CACJ;AA9BD,4BA8BC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\nimport { UpdateFields } from "./update-fields";\r\nexport interface ISettingsAttributesProperties {\r\n    readonly wpc?: string;\r\n    readonly mc?: string;\r\n    readonly o?: string;\r\n    readonly r?: string;\r\n    readonly m?: string;\r\n    readonly v?: string;\r\n    readonly wp14?: string;\r\n    readonly wp?: string;\r\n    readonly w10?: string;\r\n    readonly w?: string;\r\n    readonly w14?: string;\r\n    readonly w15?: string;\r\n    readonly wpg?: string;\r\n    readonly wpi?: string;\r\n    readonly wne?: string;\r\n    readonly wps?: string;\r\n    readonly Ignorable?: string;\r\n}\r\nexport class SettingsAttributes extends XmlAttributeComponent<ISettingsAttributesProperties> {\r\n    protected readonly xmlKeys = {\r\n        wpc: "xmlns:wpc",\r\n        mc: "xmlns:mc",\r\n        o: "xmlns:o",\r\n        r: "xmlns:r",\r\n        m: "xmlns:m",\r\n        v: "xmlns:v",\r\n        wp14: "xmlns:wp14",\r\n        wp: "xmlns:wp",\r\n        w10: "xmlns:w10",\r\n        w: "xmlns:w",\r\n        w14: "xmlns:w14",\r\n        w15: "xmlns:w15",\r\n        wpg: "xmlns:wpg",\r\n        wpi: "xmlns:wpi",\r\n        wne: "xmlns:wne",\r\n        wps: "xmlns:wps",\r\n        Ignorable: "mc:Ignorable",\r\n    };\r\n}\r\nexport class Settings extends XmlComponent {\r\n    constructor() {\r\n        super("w:settings");\r\n        this.root.push(\r\n            new SettingsAttributes({\r\n                wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",\r\n                mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",\r\n                o: "urn:schemas-microsoft-com:office:office",\r\n                r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",\r\n                m: "http://schemas.openxmlformats.org/officeDocument/2006/math",\r\n                v: "urn:schemas-microsoft-com:vml",\r\n                wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",\r\n                wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",\r\n                w10: "urn:schemas-microsoft-com:office:word",\r\n                w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",\r\n                w14: "http://schemas.microsoft.com/office/word/2010/wordml",\r\n                w15: "http://schemas.microsoft.com/office/word/2012/wordml",\r\n                wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",\r\n                wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",\r\n                wne: "http://schemas.microsoft.com/office/word/2006/wordml",\r\n                wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",\r\n                Ignorable: "w14 w15 wp14",\r\n            }),\r\n        );\r\n    }\r\n    public addUpdateFields(): void {\r\n        if (!this.root.find((child) => child instanceof UpdateFields)) {\r\n            this.addChildElement(new UpdateFields());\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(104));

      var p =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon73) {
        _inherits(p, _c$XmlAttributeCompon73);

        function p() {
          var _this295;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this295 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this295.xmlKeys = {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable"
          };
          return _this295;
        }

        return p;
      }(c.XmlAttributeComponent);

      a.s[5]++, n.SettingsAttributes = p;

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent154) {
        _inherits(m, _c$XmlComponent154);

        function m() {
          var _this296;

          _classCallCheck(this, m);

          a.f[1]++, a.s[6]++, _this296 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:settings")), a.s[7]++, _this296.root.push(new p({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
          }));
          return _this296;
        }

        _createClass(m, [{
          key: "addUpdateFields",
          value: function addUpdateFields() {
            a.f[2]++, a.s[8]++, this.root.find(function (e) {
              return a.f[3]++, a.s[9]++, e instanceof u.UpdateFields;
            }) ? a.b[0][1]++ : (a.b[0][0]++, a.s[10]++, this.addChildElement(new u.UpdateFields()));
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[11]++, n.Settings = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\styles.ts", o = "b185cc9e64be9c422c3da2f8b5c5c9ac638bb8b0", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\styles.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 25
            },
            end: {
              line: 6,
              column: 55
            }
          },
          5: {
            start: {
              line: 7,
              column: 19
            },
            end: {
              line: 7,
              column: 40
            }
          },
          6: {
            start: {
              line: 8,
              column: 16
            },
            end: {
              line: 8,
              column: 34
            }
          },
          7: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 30
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 26
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 15,
              column: 9
            }
          },
          10: {
            start: {
              line: 14,
              column: 12
            },
            end: {
              line: 14,
              column: 42
            }
          },
          11: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 30
            }
          },
          12: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 20
            }
          },
          13: {
            start: {
              line: 22,
              column: 25
            },
            end: {
              line: 22,
              column: 58
            }
          },
          14: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 28
            }
          },
          15: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 24
            }
          },
          16: {
            start: {
              line: 27,
              column: 21
            },
            end: {
              line: 27,
              column: 62
            }
          },
          17: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 24
            }
          },
          18: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 20
            }
          },
          19: {
            start: {
              line: 32,
              column: 0
            },
            end: {
              line: 32,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 31
              },
              end: {
                line: 16,
                column: 5
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 17,
                column: 4
              },
              end: {
                line: 17,
                column: 5
              }
            },
            loc: {
              start: {
                line: 17,
                column: 16
              },
              end: {
                line: 20,
                column: 5
              }
            },
            line: 17
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 21,
                column: 4
              },
              end: {
                line: 21,
                column: 5
              }
            },
            loc: {
              start: {
                line: 21,
                column: 29
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 21
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 40
              },
              end: {
                line: 30,
                column: 5
              }
            },
            line: 26
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          },
          1: {
            loc: {
              start: {
                line: 13,
                column: 8
              },
              end: {
                line: 15,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 13,
                column: 8
              },
              end: {
                line: 15,
                column: 9
              }
            }, {
              start: {
                line: 13,
                column: 8
              },
              end: {
                line: 15,
                column: 9
              }
            }],
            line: 13
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        b: {
          0: [0, 0],
          1: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/styles.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\styles.ts"],
          names: [],
          mappings: ";;;;;AAAA,wDAAqE;AACrE,yCAA8C;AAC9C,mCAAyC;AACzC,8BAAyB;AAEzB,YAAoB,SAAQ,6BAAY;IACpC,YAAY,aAAgC;QACxC,KAAK,CAAC,UAAU,CAAC,CAAC;QAClB,IAAI,aAAa,EAAE;YACf,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;SACjC;IACL,CAAC;IAEM,IAAI,CAAC,KAAmB;QAC3B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC;QACtB,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,sBAAsB;QACzB,MAAM,QAAQ,GAAG,IAAI,2BAAgB,EAAE,CAAC;QACxC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;QACpB,OAAO,QAAQ,CAAC;IACpB,CAAC;IAEM,oBAAoB,CAAC,OAAe,EAAE,IAAa;QACtD,MAAM,IAAI,GAAG,IAAI,sBAAc,CAAC,OAAO,EAAE,IAAI,CAAC,CAAC;QAC/C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC;QAChB,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAxBD,wBAwBC",
          sourcesContent: ['import { BaseXmlComponent, XmlComponent } from "file/xml-components";\r\nimport { DocumentDefaults } from "./defaults";\r\nimport { ParagraphStyle } from "./style";\r\nexport * from "./border";\r\n\r\nexport class Styles extends XmlComponent {\r\n    constructor(initialStyles?: BaseXmlComponent) {\r\n        super("w:styles");\r\n        if (initialStyles) {\r\n            this.root.push(initialStyles);\r\n        }\r\n    }\r\n\r\n    public push(style: XmlComponent): Styles {\r\n        this.root.push(style);\r\n        return this;\r\n    }\r\n\r\n    public createDocumentDefaults(): DocumentDefaults {\r\n        const defaults = new DocumentDefaults();\r\n        this.push(defaults);\r\n        return defaults;\r\n    }\r\n\r\n    public createParagraphStyle(styleId: string, name?: string): ParagraphStyle {\r\n        const para = new ParagraphStyle(styleId, name);\r\n        this.push(para);\r\n        return para;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[4]++, t(0)),
          u = (a.s[5]++, t(279)),
          p = (a.s[6]++, t(106));
      a.s[7]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(283));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent155) {
        _inherits(m, _c$XmlComponent155);

        function m(e) {
          var _this297;

          _classCallCheck(this, m);

          a.f[1]++, a.s[8]++, _this297 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:styles")), a.s[9]++, e ? (a.b[1][0]++, a.s[10]++, _this297.root.push(e)) : a.b[1][1]++;
          return _this297;
        }

        _createClass(m, [{
          key: "push",
          value: function push(e) {
            return a.f[2]++, a.s[11]++, this.root.push(e), a.s[12]++, this;
          }
        }, {
          key: "createDocumentDefaults",
          value: function createDocumentDefaults() {
            a.f[3]++;
            var e = (a.s[13]++, new u.DocumentDefaults());
            return a.s[14]++, this.push(e), a.s[15]++, e;
          }
        }, {
          key: "createParagraphStyle",
          value: function createParagraphStyle(e, n) {
            a.f[4]++;
            var t = (a.s[16]++, new p.ParagraphStyle(e, n));
            return a.s[17]++, this.push(t), a.s[18]++, t;
          }
        }]);

        return m;
      }(c.XmlComponent);

      a.s[19]++, n.Styles = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\defaults\\index.ts", o = "6ce2288a1bc51fcb8285b4f4c122ebd69582948b", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\defaults\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 31
            },
            end: {
              line: 4,
              column: 64
            }
          },
          3: {
            start: {
              line: 5,
              column: 25
            },
            end: {
              line: 5,
              column: 52
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 31
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 82
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 100
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 51
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 57
            }
          },
          9: {
            start: {
              line: 15,
              column: 0
            },
            end: {
              line: 15,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 7,
                column: 4
              },
              end: {
                line: 7,
                column: 5
              }
            },
            loc: {
              start: {
                line: 7,
                column: 18
              },
              end: {
                line: 13,
                column: 5
              }
            },
            line: 7
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/defaults/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\defaults\\index.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AACnD,iEAAqE;AACrE,qDAAyD;AAEzD,sBAA8B,SAAQ,6BAAY;IAI9C;QACI,KAAK,CAAC,eAAe,CAAC,CAAC;QACvB,IAAI,CAAC,qBAAqB,GAAG,IAAI,sCAAqB,EAAE,CAAC;QACzD,IAAI,CAAC,2BAA2B,GAAG,IAAI,kDAA2B,EAAE,CAAC;QACrE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,qBAAqB,CAAC,CAAC;QAC3C,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,2BAA2B,CAAC,CAAC;IACrD,CAAC;CACJ;AAXD,4CAWC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\nimport { ParagraphPropertiesDefaults } from "./paragraph-properties";\r\nimport { RunPropertiesDefaults } from "./run-properties";\r\n\r\nexport class DocumentDefaults extends XmlComponent {\r\n    private readonly runPropertiesDefaults: RunPropertiesDefaults;\r\n    private readonly paragraphPropertiesDefaults: ParagraphPropertiesDefaults;\r\n\r\n    constructor() {\r\n        super("w:docDefaults");\r\n        this.runPropertiesDefaults = new RunPropertiesDefaults();\r\n        this.paragraphPropertiesDefaults = new ParagraphPropertiesDefaults();\r\n        this.root.push(this.runPropertiesDefaults);\r\n        this.root.push(this.paragraphPropertiesDefaults);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(280)),
          p = (a.s[3]++, t(281));

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent156) {
        _inherits(m, _c$XmlComponent156);

        function m() {
          var _this298;

          _classCallCheck(this, m);

          a.f[0]++, a.s[4]++, _this298 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:docDefaults")), a.s[5]++, _this298.runPropertiesDefaults = new p.RunPropertiesDefaults(), a.s[6]++, _this298.paragraphPropertiesDefaults = new u.ParagraphPropertiesDefaults(), a.s[7]++, _this298.root.push(_this298.runPropertiesDefaults), a.s[8]++, _this298.root.push(_this298.paragraphPropertiesDefaults);
          return _this298;
        }

        return m;
      }(c.XmlComponent);

      a.s[9]++, n.DocumentDefaults = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\defaults\\paragraph-properties.ts", o = "acac36bde787d328a1fc6e375a7ad89423a05b81", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\defaults\\paragraph-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 57
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 30
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 63
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 66
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/defaults/paragraph-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\defaults\\paragraph-properties.ts"],
          names: [],
          mappings: ";;AAAA,0DAAgE;AAChE,wDAAmD;AAEnD,iCAAyC,SAAQ,6BAAY;IACzD;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;QACtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gCAAmB,EAAE,CAAC,CAAC;IAC9C,CAAC;CACJ;AALD,kEAKC",
          sourcesContent: ['import { ParagraphProperties } from "file/paragraph/properties";\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nexport class ParagraphPropertiesDefaults extends XmlComponent {\r\n    constructor() {\r\n        super("w:pPrDefault");\r\n        this.root.push(new ParagraphProperties());\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(22)),
          u = (a.s[2]++, t(0));

      var p =
      /*#__PURE__*/
      function (_u$XmlComponent10) {
        _inherits(p, _u$XmlComponent10);

        function p() {
          var _this299;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this299 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:pPrDefault")), a.s[4]++, _this299.root.push(new c.ParagraphProperties());
          return _this299;
        }

        return p;
      }(u.XmlComponent);

      a.s[5]++, n.ParagraphPropertiesDefaults = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\defaults\\run-properties.ts", o = "f7668d56bb27fe7c0f0a95d27df40ce2b26087b0", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\defaults\\run-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 61
            }
          },
          2: {
            start: {
              line: 4,
              column: 21
            },
            end: {
              line: 4,
              column: 61
            }
          },
          3: {
            start: {
              line: 5,
              column: 20
            },
            end: {
              line: 5,
              column: 59
            }
          },
          4: {
            start: {
              line: 6,
              column: 25
            },
            end: {
              line: 6,
              column: 55
            }
          },
          5: {
            start: {
              line: 9,
              column: 8
            },
            end: {
              line: 9,
              column: 30
            }
          },
          6: {
            start: {
              line: 10,
              column: 8
            },
            end: {
              line: 10,
              column: 59
            }
          },
          7: {
            start: {
              line: 11,
              column: 8
            },
            end: {
              line: 11,
              column: 40
            }
          },
          8: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 58
            }
          },
          9: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 71
            }
          },
          10: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 20
            }
          },
          11: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 65
            }
          },
          12: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 20
            }
          },
          13: {
            start: {
              line: 23,
              column: 0
            },
            end: {
              line: 23,
              column: 54
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 8
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 15
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 13
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 18,
                column: 19
              },
              end: {
                line: 21,
                column: 5
              }
            },
            line: 18
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/defaults/run-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\defaults\\run-properties.ts"],
          names: [],
          mappings: ";;AAAA,8DAAwE;AACxE,8DAA8D;AAC9D,4DAAwD;AACxD,wDAAmD;AAEnD,2BAAmC,SAAQ,6BAAY;IAGnD;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;QACtB,IAAI,CAAC,UAAU,GAAG,IAAI,0BAAa,EAAE,CAAC;QACtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;IACpC,CAAC;IAEM,IAAI,CAAC,IAAY;QACpB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,iBAAI,CAAC,IAAI,CAAC,CAAC,CAAC;QACrC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,8BAAiB,CAAC,IAAI,CAAC,CAAC,CAAC;QAClD,OAAO,IAAI,CAAC;IAChB,CAAC;IAEM,IAAI,CAAC,QAAgB;QACxB,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,IAAI,oBAAQ,CAAC,QAAQ,CAAC,CAAC,CAAC;QAC7C,OAAO,IAAI,CAAC;IAChB,CAAC;CACJ;AAnBD,sDAmBC",
          sourcesContent: ['import { Size, SizeComplexScript } from "file/paragraph/run/formatting";\r\nimport { RunProperties } from "file/paragraph/run/properties";\r\nimport { RunFonts } from "file/paragraph/run/run-fonts";\r\nimport { XmlComponent } from "file/xml-components";\r\n\r\nexport class RunPropertiesDefaults extends XmlComponent {\r\n    private readonly properties: RunProperties;\r\n\r\n    constructor() {\r\n        super("w:rPrDefault");\r\n        this.properties = new RunProperties();\r\n        this.root.push(this.properties);\r\n    }\r\n\r\n    public size(size: number): RunPropertiesDefaults {\r\n        this.properties.push(new Size(size));\r\n        this.properties.push(new SizeComplexScript(size));\r\n        return this;\r\n    }\r\n\r\n    public font(fontName: string): RunPropertiesDefaults {\r\n        this.properties.push(new RunFonts(fontName));\r\n        return this;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(15)),
          u = (a.s[2]++, t(21)),
          p = (a.s[3]++, t(37)),
          m = (a.s[4]++, t(0));

      var C =
      /*#__PURE__*/
      function (_m$XmlComponent2) {
        _inherits(C, _m$XmlComponent2);

        function C() {
          var _this300;

          _classCallCheck(this, C);

          a.f[0]++, a.s[5]++, _this300 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:rPrDefault")), a.s[6]++, _this300.properties = new u.RunProperties(), a.s[7]++, _this300.root.push(_this300.properties);
          return _this300;
        }

        _createClass(C, [{
          key: "size",
          value: function size(e) {
            return a.f[1]++, a.s[8]++, this.properties.push(new c.Size(e)), a.s[9]++, this.properties.push(new c.SizeComplexScript(e)), a.s[10]++, this;
          }
        }, {
          key: "font",
          value: function font(e) {
            return a.f[2]++, a.s[11]++, this.properties.push(new p.RunFonts(e)), a.s[12]++, this;
          }
        }]);

        return C;
      }(m.XmlComponent);

      a.s[13]++, n.RunPropertiesDefaults = C;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\style\\components.ts", o = "862933318d2dc957e7bec765794e385f628f2254", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\style\\components.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 40
            }
          },
          4: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 24
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 64
            }
          },
          6: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 20
            }
          },
          7: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 27
            }
          },
          8: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 64
            }
          },
          9: {
            start: {
              line: 23,
              column: 0
            },
            end: {
              line: 23,
              column: 26
            }
          },
          10: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 24
            }
          },
          11: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 64
            }
          },
          12: {
            start: {
              line: 30,
              column: 0
            },
            end: {
              line: 30,
              column: 20
            }
          },
          13: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 24
            }
          },
          14: {
            start: {
              line: 34,
              column: 8
            },
            end: {
              line: 34,
              column: 64
            }
          },
          15: {
            start: {
              line: 37,
              column: 0
            },
            end: {
              line: 37,
              column: 20
            }
          },
          16: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 30
            }
          },
          17: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 41,
              column: 64
            }
          },
          18: {
            start: {
              line: 44,
              column: 0
            },
            end: {
              line: 44,
              column: 32
            }
          },
          19: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 34
            }
          },
          20: {
            start: {
              line: 50,
              column: 0
            },
            end: {
              line: 50,
              column: 40
            }
          },
          21: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 27
            }
          },
          22: {
            start: {
              line: 56,
              column: 0
            },
            end: {
              line: 56,
              column: 34
            }
          },
          23: {
            start: {
              line: 59,
              column: 0
            },
            end: {
              line: 59,
              column: 42
            }
          },
          24: {
            start: {
              line: 62,
              column: 0
            },
            end: {
              line: 62,
              column: 20
            }
          },
          25: {
            start: {
              line: 65,
              column: 8
            },
            end: {
              line: 65,
              column: 30
            }
          },
          26: {
            start: {
              line: 68,
              column: 0
            },
            end: {
              line: 68,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 23
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 11
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 18,
                column: 23
              },
              end: {
                line: 21,
                column: 5
              }
            },
            line: 18
          },
          3: {
            name: "(anonymous_3)",
            decl: {
              start: {
                line: 25,
                column: 4
              },
              end: {
                line: 25,
                column: 5
              }
            },
            loc: {
              start: {
                line: 25,
                column: 23
              },
              end: {
                line: 28,
                column: 5
              }
            },
            line: 25
          },
          4: {
            name: "(anonymous_4)",
            decl: {
              start: {
                line: 32,
                column: 4
              },
              end: {
                line: 32,
                column: 5
              }
            },
            loc: {
              start: {
                line: 32,
                column: 23
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 32
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 39,
                column: 4
              },
              end: {
                line: 39,
                column: 5
              }
            },
            loc: {
              start: {
                line: 39,
                column: 23
              },
              end: {
                line: 42,
                column: 5
              }
            },
            line: 39
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 46,
                column: 4
              },
              end: {
                line: 46,
                column: 5
              }
            },
            loc: {
              start: {
                line: 46,
                column: 18
              },
              end: {
                line: 48,
                column: 5
              }
            },
            line: 46
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 52,
                column: 4
              },
              end: {
                line: 52,
                column: 5
              }
            },
            loc: {
              start: {
                line: 52,
                column: 18
              },
              end: {
                line: 54,
                column: 5
              }
            },
            line: 52
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 64,
                column: 4
              },
              end: {
                line: 64,
                column: 5
              }
            },
            loc: {
              start: {
                line: 64,
                column: 18
              },
              end: {
                line: 66,
                column: 5
              }
            },
            line: 64
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/style/components.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\style\\components.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAM1E,yBAA0B,SAAQ,sCAA2C;IAA7E;;QACuB,YAAO,GAAG,EAAE,GAAG,EAAE,OAAO,EAAE,CAAC;IAClD,CAAC;CAAA;AAED,UAAkB,SAAQ,6BAAY;IAClC,YAAY,KAAa;QACrB,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,EAAE,GAAG,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAC5D,CAAC;CACJ;AALD,oBAKC;AAED,aAAqB,SAAQ,6BAAY;IACrC,YAAY,KAAa;QACrB,KAAK,CAAC,WAAW,CAAC,CAAC;QACnB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,EAAE,GAAG,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAC5D,CAAC;CACJ;AALD,0BAKC;AAED,UAAkB,SAAQ,6BAAY;IAClC,YAAY,KAAa;QACrB,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,EAAE,GAAG,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAC5D,CAAC;CACJ;AALD,oBAKC;AAED,UAAkB,SAAQ,6BAAY;IAClC,YAAY,KAAa;QACrB,KAAK,CAAC,QAAQ,CAAC,CAAC;QAChB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,EAAE,GAAG,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAC5D,CAAC;CACJ;AALD,oBAKC;AAED,gBAAwB,SAAQ,6BAAY;IACxC,YAAY,KAAa;QACrB,KAAK,CAAC,cAAc,CAAC,CAAC;QAEtB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,mBAAmB,CAAC,EAAE,GAAG,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IAC5D,CAAC;CACJ;AAND,gCAMC;AAED,oBAA4B,SAAQ,6BAAY;IAC5C;QACI,KAAK,CAAC,kBAAkB,CAAC,CAAC;IAC9B,CAAC;CACJ;AAJD,wCAIC;AAED,iBAAyB,SAAQ,6BAAY;IACzC;QACI,KAAK,CAAC,WAAW,CAAC,CAAC;IACvB,CAAC;CACJ;AAJD,kCAIC;AAED,qBAA6B,SAAQ,6BAAY;CAAG;AAApD,0CAAoD;AAEpD,UAAkB,SAAQ,6BAAY;CAAG;AAAzC,oBAAyC;AAEzC,gBAAwB,SAAQ,6BAAY;IACxC;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;IAC1B,CAAC;CACJ;AAJD,gCAIC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\ninterface IComponentAttributes {\r\n    readonly val: string;\r\n}\r\n\r\nclass ComponentAttributes extends XmlAttributeComponent<IComponentAttributes> {\r\n    protected readonly xmlKeys = { val: "w:val" };\r\n}\r\n\r\nexport class Name extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:name");\r\n        this.root.push(new ComponentAttributes({ val: value }));\r\n    }\r\n}\r\n\r\nexport class BasedOn extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:basedOn");\r\n        this.root.push(new ComponentAttributes({ val: value }));\r\n    }\r\n}\r\n\r\nexport class Next extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:next");\r\n        this.root.push(new ComponentAttributes({ val: value }));\r\n    }\r\n}\r\n\r\nexport class Link extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:link");\r\n        this.root.push(new ComponentAttributes({ val: value }));\r\n    }\r\n}\r\n\r\nexport class UiPriority extends XmlComponent {\r\n    constructor(value: string) {\r\n        super("w:uiPriority");\r\n        // TODO: this value should be a ST_DecimalNumber\r\n        this.root.push(new ComponentAttributes({ val: value }));\r\n    }\r\n}\r\n\r\nexport class UnhideWhenUsed extends XmlComponent {\r\n    constructor() {\r\n        super("w:unhideWhenUsed");\r\n    }\r\n}\r\n\r\nexport class QuickFormat extends XmlComponent {\r\n    constructor() {\r\n        super("w:qFormat");\r\n    }\r\n}\r\n\r\nexport class TableProperties extends XmlComponent {}\r\n\r\nexport class RsId extends XmlComponent {}\r\n\r\nexport class SemiHidden extends XmlComponent {\r\n    constructor() {\r\n        super("w:semiHidden");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon74) {
        _inherits(u, _c$XmlAttributeCompon74);

        function u() {
          var _this301;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this301 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this301.xmlKeys = {
            val: "w:val"
          };
          return _this301;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent157) {
        _inherits(p, _c$XmlComponent157);

        function p(e) {
          var _this302;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this302 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:name")), a.s[5]++, _this302.root.push(new u({
            val: e
          }));
          return _this302;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.Name = p;

      var m =
      /*#__PURE__*/
      function (_c$XmlComponent158) {
        _inherits(m, _c$XmlComponent158);

        function m(e) {
          var _this303;

          _classCallCheck(this, m);

          a.f[2]++, a.s[7]++, _this303 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:basedOn")), a.s[8]++, _this303.root.push(new u({
            val: e
          }));
          return _this303;
        }

        return m;
      }(c.XmlComponent);

      a.s[9]++, n.BasedOn = m;

      var C =
      /*#__PURE__*/
      function (_c$XmlComponent159) {
        _inherits(C, _c$XmlComponent159);

        function C(e) {
          var _this304;

          _classCallCheck(this, C);

          a.f[3]++, a.s[10]++, _this304 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, "w:next")), a.s[11]++, _this304.root.push(new u({
            val: e
          }));
          return _this304;
        }

        return C;
      }(c.XmlComponent);

      a.s[12]++, n.Next = C;

      var d =
      /*#__PURE__*/
      function (_c$XmlComponent160) {
        _inherits(d, _c$XmlComponent160);

        function d(e) {
          var _this305;

          _classCallCheck(this, d);

          a.f[4]++, a.s[13]++, _this305 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, "w:link")), a.s[14]++, _this305.root.push(new u({
            val: e
          }));
          return _this305;
        }

        return d;
      }(c.XmlComponent);

      a.s[15]++, n.Link = d;

      var f =
      /*#__PURE__*/
      function (_c$XmlComponent161) {
        _inherits(f, _c$XmlComponent161);

        function f(e) {
          var _this306;

          _classCallCheck(this, f);

          a.f[5]++, a.s[16]++, _this306 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, "w:uiPriority")), a.s[17]++, _this306.root.push(new u({
            val: e
          }));
          return _this306;
        }

        return f;
      }(c.XmlComponent);

      a.s[18]++, n.UiPriority = f;

      var h =
      /*#__PURE__*/
      function (_c$XmlComponent162) {
        _inherits(h, _c$XmlComponent162);

        function h() {
          var _this307;

          _classCallCheck(this, h);

          a.f[6]++, a.s[19]++, _this307 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, "w:unhideWhenUsed"));
          return _this307;
        }

        return h;
      }(c.XmlComponent);

      a.s[20]++, n.UnhideWhenUsed = h;

      var x =
      /*#__PURE__*/
      function (_c$XmlComponent163) {
        _inherits(x, _c$XmlComponent163);

        function x() {
          var _this308;

          _classCallCheck(this, x);

          a.f[7]++, a.s[21]++, _this308 = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, "w:qFormat"));
          return _this308;
        }

        return x;
      }(c.XmlComponent);

      a.s[22]++, n.QuickFormat = x;

      var g =
      /*#__PURE__*/
      function (_c$XmlComponent164) {
        _inherits(g, _c$XmlComponent164);

        function g() {
          _classCallCheck(this, g);

          return _possibleConstructorReturn(this, _getPrototypeOf(g).apply(this, arguments));
        }

        return g;
      }(c.XmlComponent);

      a.s[23]++, n.TableProperties = g;

      var I =
      /*#__PURE__*/
      function (_c$XmlComponent165) {
        _inherits(I, _c$XmlComponent165);

        function I() {
          _classCallCheck(this, I);

          return _possibleConstructorReturn(this, _getPrototypeOf(I).apply(this, arguments));
        }

        return I;
      }(c.XmlComponent);

      a.s[24]++, n.RsId = I;

      var b =
      /*#__PURE__*/
      function (_c$XmlComponent166) {
        _inherits(b, _c$XmlComponent166);

        function b() {
          var _this309;

          _classCallCheck(this, b);

          a.f[8]++, a.s[25]++, _this309 = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this, "w:semiHidden"));
          return _this309;
        }

        return b;
      }(c.XmlComponent);

      a.s[26]++, n.SemiHidden = b;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\border\\index.ts", o = "d0e0c298375aa730a1517b130f81bc156553365f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\border\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 36
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/border/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\border\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,oCAA+B",
          sourcesContent: ['export * from "./border-style";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(284));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\border\\border-style.ts", o = "ef51ba00920fe8023454af3a4d02cc91e1a0e527", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\border\\border-style.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 4,
              column: 0
            },
            end: {
              line: 32,
              column: 68
            }
          },
          2: {
            start: {
              line: 5,
              column: 4
            },
            end: {
              line: 5,
              column: 37
            }
          },
          3: {
            start: {
              line: 6,
              column: 4
            },
            end: {
              line: 6,
              column: 55
            }
          },
          4: {
            start: {
              line: 7,
              column: 4
            },
            end: {
              line: 7,
              column: 37
            }
          },
          5: {
            start: {
              line: 8,
              column: 4
            },
            end: {
              line: 8,
              column: 51
            }
          },
          6: {
            start: {
              line: 9,
              column: 4
            },
            end: {
              line: 9,
              column: 40
            }
          },
          7: {
            start: {
              line: 10,
              column: 4
            },
            end: {
              line: 10,
              column: 47
            }
          },
          8: {
            start: {
              line: 11,
              column: 4
            },
            end: {
              line: 11,
              column: 37
            }
          },
          9: {
            start: {
              line: 12,
              column: 4
            },
            end: {
              line: 12,
              column: 37
            }
          },
          10: {
            start: {
              line: 13,
              column: 4
            },
            end: {
              line: 13,
              column: 46
            }
          },
          11: {
            start: {
              line: 14,
              column: 4
            },
            end: {
              line: 14,
              column: 35
            }
          },
          12: {
            start: {
              line: 15,
              column: 4
            },
            end: {
              line: 15,
              column: 31
            }
          },
          13: {
            start: {
              line: 16,
              column: 4
            },
            end: {
              line: 16,
              column: 33
            }
          },
          14: {
            start: {
              line: 17,
              column: 4
            },
            end: {
              line: 17,
              column: 37
            }
          },
          15: {
            start: {
              line: 18,
              column: 4
            },
            end: {
              line: 18,
              column: 35
            }
          },
          16: {
            start: {
              line: 19,
              column: 4
            },
            end: {
              line: 19,
              column: 62
            }
          },
          17: {
            start: {
              line: 20,
              column: 4
            },
            end: {
              line: 20,
              column: 64
            }
          },
          18: {
            start: {
              line: 21,
              column: 4
            },
            end: {
              line: 21,
              column: 62
            }
          },
          19: {
            start: {
              line: 22,
              column: 4
            },
            end: {
              line: 22,
              column: 62
            }
          },
          20: {
            start: {
              line: 23,
              column: 4
            },
            end: {
              line: 23,
              column: 64
            }
          },
          21: {
            start: {
              line: 24,
              column: 4
            },
            end: {
              line: 24,
              column: 62
            }
          },
          22: {
            start: {
              line: 25,
              column: 4
            },
            end: {
              line: 25,
              column: 71
            }
          },
          23: {
            start: {
              line: 26,
              column: 4
            },
            end: {
              line: 26,
              column: 73
            }
          },
          24: {
            start: {
              line: 27,
              column: 4
            },
            end: {
              line: 27,
              column: 71
            }
          },
          25: {
            start: {
              line: 28,
              column: 4
            },
            end: {
              line: 28,
              column: 51
            }
          },
          26: {
            start: {
              line: 29,
              column: 4
            },
            end: {
              line: 29,
              column: 53
            }
          },
          27: {
            start: {
              line: 30,
              column: 4
            },
            end: {
              line: 30,
              column: 37
            }
          },
          28: {
            start: {
              line: 31,
              column: 4
            },
            end: {
              line: 31,
              column: 33
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 1
              },
              end: {
                line: 4,
                column: 2
              }
            },
            loc: {
              start: {
                line: 4,
                column: 24
              },
              end: {
                line: 32,
                column: 1
              }
            },
            line: 4
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 32,
                column: 17
              },
              end: {
                line: 32,
                column: 66
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 32,
                column: 17
              },
              end: {
                line: 32,
                column: 36
              }
            }, {
              start: {
                line: 32,
                column: 41
              },
              end: {
                line: 32,
                column: 65
              }
            }],
            line: 32
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/border/border-style.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\border\\border-style.ts"],
          names: [],
          mappings: ";;AAAA,IAAY,WA4BX;AA5BD,WAAY,WAAW;IACnB,gCAAiB,CAAA;IACjB,kDAAmC,CAAA;IACnC,gCAAiB,CAAA;IACjB,8CAA+B,CAAA;IAC/B,mCAAoB,CAAA;IACpB,0CAA2B,CAAA;IAC3B,gCAAiB,CAAA;IACjB,gCAAiB,CAAA;IACjB,yCAA0B,CAAA;IAC1B,8BAAe,CAAA;IACf,0BAAW,CAAA;IACX,4BAAa,CAAA;IACb,gCAAiB,CAAA;IACjB,8BAAe,CAAA;IACf,yDAA0C,CAAA;IAC1C,2DAA4C,CAAA;IAC5C,yDAA0C,CAAA;IAC1C,yDAA0C,CAAA;IAC1C,2DAA4C,CAAA;IAC5C,yDAA0C,CAAA;IAC1C,kEAAmD,CAAA;IACnD,oEAAqD,CAAA;IACrD,kEAAmD,CAAA;IACnD,8CAA+B,CAAA;IAC/B,gDAAiC,CAAA;IACjC,gCAAiB,CAAA;IACjB,4BAAa,CAAA;AACjB,CAAC,EA5BW,WAAW,GAAX,mBAAW,KAAX,mBAAW,QA4BtB",
          sourcesContent: ['export enum BorderStyle {\r\n    SINGLE = "single",\r\n    DASH_DOT_STROKED = "dashDotStroked",\r\n    DASHED = "dashed",\r\n    DASH_SMALL_GAP = "dashSmallGap",\r\n    DOT_DASH = "dotDash",\r\n    DOT_DOT_DASH = "dotDotDash",\r\n    DOTTED = "dotted",\r\n    DOUBLE = "double",\r\n    DOUBLE_WAVE = "doubleWave",\r\n    INSET = "inset",\r\n    NIL = "nil",\r\n    NONE = "none",\r\n    OUTSET = "outset",\r\n    THICK = "thick",\r\n    THICK_THIN_LARGE_GAP = "thickThinLargeGap",\r\n    THICK_THIN_MEDIUM_GAP = "thickThinMediumGap",\r\n    THICK_THIN_SMALL_GAP = "thickThinSmallGap",\r\n    THIN_THICK_LARGE_GAP = "thinThickLargeGap",\r\n    THIN_THICK_MEDIUM_GAP = "thinThickMediumGap",\r\n    THIN_THICK_SMALL_GAP = "thinThickSmallGap",\r\n    THIN_THICK_THIN_LARGE_GAP = "thinThickThinLargeGap",\r\n    THIN_THICK_THIN_MEDIUM_GAP = "thinThickThinMediumGap",\r\n    THIN_THICK_THIN_SMALL_GAP = "thinThickThinSmallGap",\r\n    THREE_D_EMBOSS = "threeDEmboss",\r\n    THREE_D_ENGRAVE = "threeDEngrave",\r\n    TRIPLE = "triple",\r\n    WAVE = "wave",\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[1]++, function (e) {
        a.f[0]++, a.s[2]++, e.SINGLE = "single", a.s[3]++, e.DASH_DOT_STROKED = "dashDotStroked", a.s[4]++, e.DASHED = "dashed", a.s[5]++, e.DASH_SMALL_GAP = "dashSmallGap", a.s[6]++, e.DOT_DASH = "dotDash", a.s[7]++, e.DOT_DOT_DASH = "dotDotDash", a.s[8]++, e.DOTTED = "dotted", a.s[9]++, e.DOUBLE = "double", a.s[10]++, e.DOUBLE_WAVE = "doubleWave", a.s[11]++, e.INSET = "inset", a.s[12]++, e.NIL = "nil", a.s[13]++, e.NONE = "none", a.s[14]++, e.OUTSET = "outset", a.s[15]++, e.THICK = "thick", a.s[16]++, e.THICK_THIN_LARGE_GAP = "thickThinLargeGap", a.s[17]++, e.THICK_THIN_MEDIUM_GAP = "thickThinMediumGap", a.s[18]++, e.THICK_THIN_SMALL_GAP = "thickThinSmallGap", a.s[19]++, e.THIN_THICK_LARGE_GAP = "thinThickLargeGap", a.s[20]++, e.THIN_THICK_MEDIUM_GAP = "thinThickMediumGap", a.s[21]++, e.THIN_THICK_SMALL_GAP = "thinThickSmallGap", a.s[22]++, e.THIN_THICK_THIN_LARGE_GAP = "thinThickThinLargeGap", a.s[23]++, e.THIN_THICK_THIN_MEDIUM_GAP = "thinThickThinMediumGap", a.s[24]++, e.THIN_THICK_THIN_SMALL_GAP = "thinThickThinSmallGap", a.s[25]++, e.THREE_D_EMBOSS = "threeDEmboss", a.s[26]++, e.THREE_D_ENGRAVE = "threeDEngrave", a.s[27]++, e.TRIPLE = "triple", a.s[28]++, e.WAVE = "wave";
      }((a.b[0][0]++, n.BorderStyle || (a.b[0][1]++, n.BorderStyle = {})));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\factory.ts", o = "ed77105567ccf7d2038eb5284befb2d8227ef656", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\styles\\factory.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 30
            },
            end: {
              line: 3,
              column: 72
            }
          },
          2: {
            start: {
              line: 4,
              column: 21
            },
            end: {
              line: 4,
              column: 59
            }
          },
          3: {
            start: {
              line: 5,
              column: 11
            },
            end: {
              line: 5,
              column: 24
            }
          },
          4: {
            start: {
              line: 6,
              column: 16
            },
            end: {
              line: 6,
              column: 34
            }
          },
          5: {
            start: {
              line: 9,
              column: 35
            },
            end: {
              line: 16,
              column: 10
            }
          },
          6: {
            start: {
              line: 17,
              column: 23
            },
            end: {
              line: 17,
              column: 56
            }
          },
          7: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 40
            }
          },
          8: {
            start: {
              line: 19,
              column: 27
            },
            end: {
              line: 19,
              column: 51
            }
          },
          9: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 61
            }
          },
          10: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 32
            }
          },
          11: {
            start: {
              line: 22,
              column: 30
            },
            end: {
              line: 22,
              column: 57
            }
          },
          12: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 23,
              column: 71
            }
          },
          13: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 64
            }
          },
          14: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 35
            }
          },
          15: {
            start: {
              line: 26,
              column: 30
            },
            end: {
              line: 26,
              column: 57
            }
          },
          16: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 71
            }
          },
          17: {
            start: {
              line: 28,
              column: 8
            },
            end: {
              line: 28,
              column: 64
            }
          },
          18: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 29,
              column: 35
            }
          },
          19: {
            start: {
              line: 30,
              column: 30
            },
            end: {
              line: 30,
              column: 57
            }
          },
          20: {
            start: {
              line: 31,
              column: 8
            },
            end: {
              line: 31,
              column: 71
            }
          },
          21: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 32,
              column: 64
            }
          },
          22: {
            start: {
              line: 33,
              column: 8
            },
            end: {
              line: 33,
              column: 35
            }
          },
          23: {
            start: {
              line: 34,
              column: 30
            },
            end: {
              line: 34,
              column: 57
            }
          },
          24: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 35,
              column: 71
            }
          },
          25: {
            start: {
              line: 36,
              column: 8
            },
            end: {
              line: 36,
              column: 65
            }
          },
          26: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 37,
              column: 35
            }
          },
          27: {
            start: {
              line: 38,
              column: 30
            },
            end: {
              line: 38,
              column: 57
            }
          },
          28: {
            start: {
              line: 39,
              column: 8
            },
            end: {
              line: 39,
              column: 71
            }
          },
          29: {
            start: {
              line: 40,
              column: 8
            },
            end: {
              line: 40,
              column: 35
            }
          },
          30: {
            start: {
              line: 41,
              column: 30
            },
            end: {
              line: 41,
              column: 57
            }
          },
          31: {
            start: {
              line: 42,
              column: 8
            },
            end: {
              line: 42,
              column: 71
            }
          },
          32: {
            start: {
              line: 43,
              column: 8
            },
            end: {
              line: 43,
              column: 35
            }
          },
          33: {
            start: {
              line: 44,
              column: 30
            },
            end: {
              line: 44,
              column: 57
            }
          },
          34: {
            start: {
              line: 45,
              column: 8
            },
            end: {
              line: 45,
              column: 35
            }
          },
          35: {
            start: {
              line: 46,
              column: 31
            },
            end: {
              line: 46,
              column: 59
            }
          },
          36: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 47,
              column: 36
            }
          },
          37: {
            start: {
              line: 48,
              column: 39
            },
            end: {
              line: 48,
              column: 75
            }
          },
          38: {
            start: {
              line: 49,
              column: 8
            },
            end: {
              line: 49,
              column: 44
            }
          },
          39: {
            start: {
              line: 50,
              column: 34
            },
            end: {
              line: 50,
              column: 60
            }
          },
          40: {
            start: {
              line: 51,
              column: 8
            },
            end: {
              line: 51,
              column: 39
            }
          },
          41: {
            start: {
              line: 52,
              column: 38
            },
            end: {
              line: 52,
              column: 68
            }
          },
          42: {
            start: {
              line: 53,
              column: 8
            },
            end: {
              line: 53,
              column: 43
            }
          },
          43: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 54,
              column: 22
            }
          },
          44: {
            start: {
              line: 57,
              column: 0
            },
            end: {
              line: 57,
              column: 52
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 8,
                column: 4
              },
              end: {
                line: 8,
                column: 5
              }
            },
            loc: {
              start: {
                line: 8,
                column: 18
              },
              end: {
                line: 55,
                column: 5
              }
            },
            line: 8
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/styles/factory.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\styles\\factory.ts"],
          names: [],
          mappings: ";;AAAA,yEAAqE;AACrE,4DAAmE;AACnE,yBAA4B;AAE5B,mCAaiB;AAEjB;IACW,WAAW;QACd,MAAM,kBAAkB,GAAG,IAAI,wCAAkB,CAAC;YAC9C,EAAE,EAAE,6DAA6D;YACjE,CAAC,EAAE,qEAAqE;YACxE,CAAC,EAAE,8DAA8D;YACjE,GAAG,EAAE,sDAAsD;YAC3D,GAAG,EAAE,sDAAsD;YAC3D,SAAS,EAAE,SAAS;SACvB,CAAC,CAAC;QACH,MAAM,MAAM,GAAG,IAAI,SAAM,CAAC,kBAAkB,CAAC,CAAC;QAC9C,MAAM,CAAC,sBAAsB,EAAE,CAAC;QAEhC,MAAM,UAAU,GAAG,IAAI,kBAAU,EAAE,CAAC;QACpC,UAAU,CAAC,cAAc,CAAC,IAAI,iBAAI,CAAC,EAAE,CAAC,CAAC,CAAC;QACxC,MAAM,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC;QAExB,MAAM,aAAa,GAAG,IAAI,qBAAa,EAAE,CAAC;QAC1C,aAAa,CAAC,cAAc,CAAC,IAAI,kBAAK,CAAC,QAAQ,CAAC,CAAC,CAAC;QAClD,aAAa,CAAC,cAAc,CAAC,IAAI,iBAAI,CAAC,EAAE,CAAC,CAAC,CAAC;QAC3C,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QAE3B,MAAM,aAAa,GAAG,IAAI,qBAAa,EAAE,CAAC;QAC1C,aAAa,CAAC,cAAc,CAAC,IAAI,kBAAK,CAAC,QAAQ,CAAC,CAAC,CAAC;QAClD,aAAa,CAAC,cAAc,CAAC,IAAI,iBAAI,CAAC,EAAE,CAAC,CAAC,CAAC;QAC3C,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QAE3B,MAAM,aAAa,GAAG,IAAI,qBAAa,EAAE,CAAC;QAC1C,aAAa,CAAC,cAAc,CAAC,IAAI,kBAAK,CAAC,QAAQ,CAAC,CAAC,CAAC;QAClD,aAAa,CAAC,cAAc,CAAC,IAAI,iBAAI,CAAC,EAAE,CAAC,CAAC,CAAC;QAC3C,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QAE3B,MAAM,aAAa,GAAG,IAAI,qBAAa,EAAE,CAAC;QAC1C,aAAa,CAAC,cAAc,CAAC,IAAI,kBAAK,CAAC,QAAQ,CAAC,CAAC,CAAC;QAClD,aAAa,CAAC,cAAc,CAAC,IAAI,oBAAO,EAAE,CAAC,CAAC;QAC5C,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QAE3B,MAAM,aAAa,GAAG,IAAI,qBAAa,EAAE,CAAC;QAC1C,aAAa,CAAC,cAAc,CAAC,IAAI,kBAAK,CAAC,QAAQ,CAAC,CAAC,CAAC;QAClD,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QAE3B,MAAM,aAAa,GAAG,IAAI,qBAAa,EAAE,CAAC;QAC1C,aAAa,CAAC,cAAc,CAAC,IAAI,kBAAK,CAAC,QAAQ,CAAC,CAAC,CAAC;QAClD,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QAE3B,MAAM,aAAa,GAAG,IAAI,qBAAa,EAAE,CAAC;QAE1C,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;QAE3B,MAAM,cAAc,GAAG,IAAI,sBAAc,EAAE,CAAC;QAC5C,MAAM,CAAC,IAAI,CAAC,cAAc,CAAC,CAAC;QAE5B,MAAM,sBAAsB,GAAG,IAAI,8BAAsB,EAAE,CAAC;QAC5D,MAAM,CAAC,IAAI,CAAC,sBAAsB,CAAC,CAAC;QAEpC,MAAM,iBAAiB,GAAG,IAAI,oBAAY,EAAE,CAAC;QAC7C,MAAM,CAAC,IAAI,CAAC,iBAAiB,CAAC,CAAC;QAE/B,MAAM,qBAAqB,GAAG,IAAI,wBAAgB,EAAE,CAAC;QACrD,MAAM,CAAC,IAAI,CAAC,qBAAqB,CAAC,CAAC;QAEnC,OAAO,MAAM,CAAC;IAClB,CAAC;CACJ;AA/DD,oDA+DC",
          sourcesContent: ['import { DocumentAttributes } from "../document/document-attributes";\r\nimport { Color, Italics, Size } from "../paragraph/run/formatting";\r\nimport { Styles } from "./";\r\n\r\nimport {\r\n    FootnoteReferenceStyle,\r\n    FootnoteText,\r\n    FootnoteTextChar,\r\n    Heading1Style,\r\n    Heading2Style,\r\n    Heading3Style,\r\n    Heading4Style,\r\n    Heading5Style,\r\n    Heading6Style,\r\n    HyperlinkStyle,\r\n    ListParagraph,\r\n    TitleStyle,\r\n} from "./style";\r\n\r\nexport class DefaultStylesFactory {\r\n    public newInstance(): Styles {\r\n        const documentAttributes = new DocumentAttributes({\r\n            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",\r\n            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",\r\n            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",\r\n            w14: "http://schemas.microsoft.com/office/word/2010/wordml",\r\n            w15: "http://schemas.microsoft.com/office/word/2012/wordml",\r\n            Ignorable: "w14 w15",\r\n        });\r\n        const styles = new Styles(documentAttributes);\r\n        styles.createDocumentDefaults();\r\n\r\n        const titleStyle = new TitleStyle();\r\n        titleStyle.addRunProperty(new Size(56));\r\n        styles.push(titleStyle);\r\n\r\n        const heading1Style = new Heading1Style();\r\n        heading1Style.addRunProperty(new Color("2E74B5"));\r\n        heading1Style.addRunProperty(new Size(32));\r\n        styles.push(heading1Style);\r\n\r\n        const heading2Style = new Heading2Style();\r\n        heading2Style.addRunProperty(new Color("2E74B5"));\r\n        heading2Style.addRunProperty(new Size(26));\r\n        styles.push(heading2Style);\r\n\r\n        const heading3Style = new Heading3Style();\r\n        heading3Style.addRunProperty(new Color("1F4D78"));\r\n        heading3Style.addRunProperty(new Size(24));\r\n        styles.push(heading3Style);\r\n\r\n        const heading4Style = new Heading4Style();\r\n        heading4Style.addRunProperty(new Color("2E74B5"));\r\n        heading4Style.addRunProperty(new Italics());\r\n        styles.push(heading4Style);\r\n\r\n        const heading5Style = new Heading5Style();\r\n        heading5Style.addRunProperty(new Color("2E74B5"));\r\n        styles.push(heading5Style);\r\n\r\n        const heading6Style = new Heading6Style();\r\n        heading6Style.addRunProperty(new Color("1F4D78"));\r\n        styles.push(heading6Style);\r\n\r\n        const listParagraph = new ListParagraph();\r\n        // listParagraph.addParagraphProperty();\r\n        styles.push(listParagraph);\r\n\r\n        const hyperLinkStyle = new HyperlinkStyle();\r\n        styles.push(hyperLinkStyle);\r\n\r\n        const footnoteReferenceStyle = new FootnoteReferenceStyle();\r\n        styles.push(footnoteReferenceStyle);\r\n\r\n        const footnoteTextStyle = new FootnoteText();\r\n        styles.push(footnoteTextStyle);\r\n\r\n        const footnoteTextCharStyle = new FootnoteTextChar();\r\n        styles.push(footnoteTextCharStyle);\r\n\r\n        return styles;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(11)),
          u = (a.s[2]++, t(15)),
          p = (a.s[3]++, t(44)),
          m = (a.s[4]++, t(106));
      a.s[44]++, n.DefaultStylesFactory =
      /*#__PURE__*/
      function () {
        function _class47() {
          _classCallCheck(this, _class47);
        }

        _createClass(_class47, [{
          key: "newInstance",
          value: function newInstance() {
            a.f[0]++;
            var e = (a.s[5]++, new c.DocumentAttributes({
              mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
              r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
              w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
              w14: "http://schemas.microsoft.com/office/word/2010/wordml",
              w15: "http://schemas.microsoft.com/office/word/2012/wordml",
              Ignorable: "w14 w15"
            })),
                n = (a.s[6]++, new p.Styles(e));
            a.s[7]++, n.createDocumentDefaults();
            var t = (a.s[8]++, new m.TitleStyle());
            a.s[9]++, t.addRunProperty(new u.Size(56)), a.s[10]++, n.push(t);
            var r = (a.s[11]++, new m.Heading1Style());
            a.s[12]++, r.addRunProperty(new u.Color("2E74B5")), a.s[13]++, r.addRunProperty(new u.Size(32)), a.s[14]++, n.push(r);
            var o = (a.s[15]++, new m.Heading2Style());
            a.s[16]++, o.addRunProperty(new u.Color("2E74B5")), a.s[17]++, o.addRunProperty(new u.Size(26)), a.s[18]++, n.push(o);
            var i = (a.s[19]++, new m.Heading3Style());
            a.s[20]++, i.addRunProperty(new u.Color("1F4D78")), a.s[21]++, i.addRunProperty(new u.Size(24)), a.s[22]++, n.push(i);
            var A = (a.s[23]++, new m.Heading4Style());
            a.s[24]++, A.addRunProperty(new u.Color("2E74B5")), a.s[25]++, A.addRunProperty(new u.Italics()), a.s[26]++, n.push(A);
            var s = (a.s[27]++, new m.Heading5Style());
            a.s[28]++, s.addRunProperty(new u.Color("2E74B5")), a.s[29]++, n.push(s);
            var l = (a.s[30]++, new m.Heading6Style());
            a.s[31]++, l.addRunProperty(new u.Color("1F4D78")), a.s[32]++, n.push(l);
            var C = (a.s[33]++, new m.ListParagraph());
            a.s[34]++, n.push(C);
            var d = (a.s[35]++, new m.HyperlinkStyle());
            a.s[36]++, n.push(d);
            var f = (a.s[37]++, new m.FootnoteReferenceStyle());
            a.s[38]++, n.push(f);
            var h = (a.s[39]++, new m.FootnoteText());
            a.s[40]++, n.push(h);
            var x = (a.s[41]++, new m.FootnoteTextChar());
            return a.s[42]++, n.push(x), a.s[43]++, n;
          }
        }]);

        return _class47;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\file-properties.ts", o = "749e672378e6857305674ff1c3594436b716d68d", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\file-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 0
            },
            end: {
              line: 3,
              column: 24
            }
          }
        },
        fnMap: {},
        branchMap: {},
        s: {
          0: 0,
          1: 0
        },
        f: {},
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/file-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\file-properties.ts"],
          names: [],
          mappings: ";;AAUa,QAAA,UAAU,GAAG,EAAE,CAAC",
          sourcesContent: ['import { IDocumentTemplate } from "../import-dotx";\r\n\r\nexport interface IFileProperties {\r\n    readonly template?: IDocumentTemplate;\r\n}\r\n\r\n// Needed because of: https://github.com/s-panferov/awesome-typescript-loader/issues/432\r\n/**\r\n * @ignore\r\n */\r\nexport const WORKAROUND = "";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[1]++, n.WORKAROUND = "";
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\index.ts", o = "f829b8d02b12af5815f0b2dc6dbdb6b6f74b1faa", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 41
            }
          },
          5: {
            start: {
              line: 7,
              column: 0
            },
            end: {
              line: 7,
              column: 52
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table-of-contents/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table-of-contents\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,yCAAoC;AACpC,oDAA+C",
          sourcesContent: ['export * from "./table-of-contents";\r\nexport * from "./table-of-contents-properties";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));

      function c(e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }

      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, c(t(288)), a.s[5]++, c(t(293));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\table-of-contents.ts", o = "38acfef9a4eeec87c5821dc4fd562fe28db16350", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\table-of-contents.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 20
            },
            end: {
              line: 3,
              column: 45
            }
          },
          2: {
            start: {
              line: 4,
              column: 14
            },
            end: {
              line: 4,
              column: 43
            }
          },
          3: {
            start: {
              line: 5,
              column: 16
            },
            end: {
              line: 5,
              column: 51
            }
          },
          4: {
            start: {
              line: 6,
              column: 25
            },
            end: {
              line: 6,
              column: 55
            }
          },
          5: {
            start: {
              line: 7,
              column: 28
            },
            end: {
              line: 7,
              column: 58
            }
          },
          6: {
            start: {
              line: 8,
              column: 22
            },
            end: {
              line: 8,
              column: 46
            }
          },
          7: {
            start: {
              line: 9,
              column: 25
            },
            end: {
              line: 9,
              column: 52
            }
          },
          8: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 23
            }
          },
          9: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 84
            }
          },
          10: {
            start: {
              line: 14,
              column: 24
            },
            end: {
              line: 14,
              column: 72
            }
          },
          11: {
            start: {
              line: 15,
              column: 31
            },
            end: {
              line: 15,
              column: 58
            }
          },
          12: {
            start: {
              line: 16,
              column: 25
            },
            end: {
              line: 16,
              column: 40
            }
          },
          13: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 17,
              column: 58
            }
          },
          14: {
            start: {
              line: 18,
              column: 8
            },
            end: {
              line: 18,
              column: 87
            }
          },
          15: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 19,
              column: 57
            }
          },
          16: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 20,
              column: 40
            }
          },
          17: {
            start: {
              line: 21,
              column: 8
            },
            end: {
              line: 21,
              column: 48
            }
          },
          18: {
            start: {
              line: 22,
              column: 29
            },
            end: {
              line: 22,
              column: 56
            }
          },
          19: {
            start: {
              line: 23,
              column: 23
            },
            end: {
              line: 23,
              column: 38
            }
          },
          20: {
            start: {
              line: 24,
              column: 8
            },
            end: {
              line: 24,
              column: 50
            }
          },
          21: {
            start: {
              line: 25,
              column: 8
            },
            end: {
              line: 25,
              column: 36
            }
          },
          22: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 46
            }
          },
          23: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 27,
              column: 32
            }
          },
          24: {
            start: {
              line: 30,
              column: 0
            },
            end: {
              line: 30,
              column: 42
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 57
              },
              end: {
                line: 28,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 11,
                column: 16
              },
              end: {
                line: 11,
                column: 43
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 11,
                column: 24
              },
              end: {
                line: 11,
                column: 43
              }
            }],
            line: 11
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table-of-contents/table-of-contents.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table-of-contents\\table-of-contents.ts"],
          names: [],
          mappings: ";;AAEA,8CAA2C;AAC3C,4CAAyC;AACzC,oDAAgE;AAChE,wDAAmD;AACnD,2DAAuD;AACvD,+CAA6D;AAC7D,qDAAmE;AAGnE,qBAA6B,SAAQ,6BAAY;IAC7C,YAAY,QAAgB,mBAAmB,EAAE,UAAoC;QACjF,KAAK,CAAC,OAAO,CAAC,CAAC;QACf,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,gDAA+B,CAAC,KAAK,CAAC,CAAC,CAAC;QAE3D,MAAM,OAAO,GAAG,IAAI,0CAA4B,EAAE,CAAC;QAEnD,MAAM,cAAc,GAAG,IAAI,qBAAS,EAAE,CAAC;QACvC,MAAM,QAAQ,GAAG,IAAI,SAAG,EAAE,CAAC;QAC3B,QAAQ,CAAC,eAAe,CAAC,IAAI,aAAK,CAAC,IAAI,CAAC,CAAC,CAAC;QAC1C,QAAQ,CAAC,eAAe,CAAC,IAAI,oCAAgB,CAAC,UAAU,CAAC,CAAC,CAAC;QAC3D,QAAQ,CAAC,eAAe,CAAC,IAAI,gBAAQ,EAAE,CAAC,CAAC;QACzC,cAAc,CAAC,MAAM,CAAC,QAAQ,CAAC,CAAC;QAChC,OAAO,CAAC,eAAe,CAAC,cAAc,CAAC,CAAC;QAExC,MAAM,YAAY,GAAG,IAAI,qBAAS,EAAE,CAAC;QACrC,MAAM,MAAM,GAAG,IAAI,SAAG,EAAE,CAAC;QACzB,MAAM,CAAC,eAAe,CAAC,IAAI,WAAG,EAAE,CAAC,CAAC;QAClC,YAAY,CAAC,MAAM,CAAC,MAAM,CAAC,CAAC;QAC5B,OAAO,CAAC,eAAe,CAAC,YAAY,CAAC,CAAC;QAEtC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC;IAC5B,CAAC;CACJ;AAvBD,0CAuBC",
          sourcesContent: ['// http://officeopenxml.com/WPtableOfContents.php\r\n// http://www.datypic.com/sc/ooxml/e-w_sdt-1.html\r\nimport { Paragraph } from "file/paragraph";\r\nimport { Run } from "file/paragraph/run";\r\nimport { Begin, End, Separate } from "file/paragraph/run/field";\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { FieldInstruction } from "./field-instruction";\r\nimport { StructuredDocumentTagContent } from "./sdt-content";\r\nimport { StructuredDocumentTagProperties } from "./sdt-properties";\r\nimport { ITableOfContentsOptions } from "./table-of-contents-properties";\r\n\r\nexport class TableOfContents extends XmlComponent {\r\n    constructor(alias: string = "Table of Contents", properties?: ITableOfContentsOptions) {\r\n        super("w:sdt");\r\n        this.root.push(new StructuredDocumentTagProperties(alias));\r\n\r\n        const content = new StructuredDocumentTagContent();\r\n\r\n        const beginParagraph = new Paragraph();\r\n        const beginRun = new Run();\r\n        beginRun.addChildElement(new Begin(true));\r\n        beginRun.addChildElement(new FieldInstruction(properties));\r\n        beginRun.addChildElement(new Separate());\r\n        beginParagraph.addRun(beginRun);\r\n        content.addChildElement(beginParagraph);\r\n\r\n        const endParagraph = new Paragraph();\r\n        const endRun = new Run();\r\n        endRun.addChildElement(new End());\r\n        endParagraph.addRun(endRun);\r\n        content.addChildElement(endParagraph);\r\n\r\n        this.root.push(content);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(2)),
          u = (a.s[2]++, t(4)),
          p = (a.s[3]++, t(36)),
          m = (a.s[4]++, t(0)),
          C = (a.s[5]++, t(289)),
          d = (a.s[6]++, t(290)),
          f = (a.s[7]++, t(291));

      var h =
      /*#__PURE__*/
      function (_m$XmlComponent3) {
        _inherits(h, _m$XmlComponent3);

        function h() {
          var _this310;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, "Table of Contents");
          var n = arguments.length > 1 ? arguments[1] : undefined;

          _classCallCheck(this, h);

          a.f[0]++, a.s[8]++, _this310 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, "w:sdt")), a.s[9]++, _this310.root.push(new f.StructuredDocumentTagProperties(e));
          var t = (a.s[10]++, new d.StructuredDocumentTagContent()),
              r = (a.s[11]++, new c.Paragraph()),
              o = (a.s[12]++, new u.Run());
          a.s[13]++, o.addChildElement(new p.Begin(!0)), a.s[14]++, o.addChildElement(new C.FieldInstruction(n)), a.s[15]++, o.addChildElement(new p.Separate()), a.s[16]++, r.addRun(o), a.s[17]++, t.addChildElement(r);
          var i = (a.s[18]++, new c.Paragraph()),
              A = (a.s[19]++, new u.Run());
          a.s[20]++, A.addChildElement(new p.End()), a.s[21]++, i.addRun(A), a.s[22]++, t.addChildElement(i), a.s[23]++, _this310.root.push(t);
          return _this310;
        }

        return h;
      }(m.XmlComponent);

      a.s[24]++, n.TableOfContents = h;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\field-instruction.ts", o = "da94773b3914e72f35bc74455d72218faae7756f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\field-instruction.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 47
            }
          },
          2: {
            start: {
              line: 4,
              column: 25
            },
            end: {
              line: 4,
              column: 55
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 28
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 46
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 29
            }
          },
          6: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 37
            }
          },
          7: {
            start: {
              line: 15,
              column: 8
            },
            end: {
              line: 15,
              column: 87
            }
          },
          8: {
            start: {
              line: 16,
              column: 26
            },
            end: {
              line: 16,
              column: 31
            }
          },
          9: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 19,
              column: 9
            }
          },
          10: {
            start: {
              line: 18,
              column: 12
            },
            end: {
              line: 18,
              column: 81
            }
          },
          11: {
            start: {
              line: 20,
              column: 8
            },
            end: {
              line: 22,
              column: 9
            }
          },
          12: {
            start: {
              line: 21,
              column: 12
            },
            end: {
              line: 21,
              column: 88
            }
          },
          13: {
            start: {
              line: 23,
              column: 8
            },
            end: {
              line: 25,
              column: 9
            }
          },
          14: {
            start: {
              line: 24,
              column: 12
            },
            end: {
              line: 24,
              column: 97
            }
          },
          15: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 28,
              column: 9
            }
          },
          16: {
            start: {
              line: 27,
              column: 12
            },
            end: {
              line: 27,
              column: 100
            }
          },
          17: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 31,
              column: 9
            }
          },
          18: {
            start: {
              line: 30,
              column: 12
            },
            end: {
              line: 30,
              column: 86
            }
          },
          19: {
            start: {
              line: 32,
              column: 8
            },
            end: {
              line: 34,
              column: 9
            }
          },
          20: {
            start: {
              line: 33,
              column: 12
            },
            end: {
              line: 33,
              column: 47
            }
          },
          21: {
            start: {
              line: 35,
              column: 8
            },
            end: {
              line: 37,
              column: 9
            }
          },
          22: {
            start: {
              line: 36,
              column: 12
            },
            end: {
              line: 36,
              column: 86
            }
          },
          23: {
            start: {
              line: 38,
              column: 8
            },
            end: {
              line: 40,
              column: 9
            }
          },
          24: {
            start: {
              line: 39,
              column: 12
            },
            end: {
              line: 39,
              column: 96
            }
          },
          25: {
            start: {
              line: 41,
              column: 8
            },
            end: {
              line: 43,
              column: 9
            }
          },
          26: {
            start: {
              line: 42,
              column: 12
            },
            end: {
              line: 42,
              column: 86
            }
          },
          27: {
            start: {
              line: 44,
              column: 8
            },
            end: {
              line: 46,
              column: 9
            }
          },
          28: {
            start: {
              line: 45,
              column: 12
            },
            end: {
              line: 45,
              column: 96
            }
          },
          29: {
            start: {
              line: 47,
              column: 8
            },
            end: {
              line: 49,
              column: 9
            }
          },
          30: {
            start: {
              line: 48,
              column: 12
            },
            end: {
              line: 48,
              column: 96
            }
          },
          31: {
            start: {
              line: 50,
              column: 8
            },
            end: {
              line: 53,
              column: 9
            }
          },
          32: {
            start: {
              line: 51,
              column: 27
            },
            end: {
              line: 51,
              column: 112
            }
          },
          33: {
            start: {
              line: 51,
              column: 72
            },
            end: {
              line: 51,
              column: 101
            }
          },
          34: {
            start: {
              line: 52,
              column: 12
            },
            end: {
              line: 52,
              column: 59
            }
          },
          35: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 56,
              column: 9
            }
          },
          36: {
            start: {
              line: 55,
              column: 12
            },
            end: {
              line: 55,
              column: 47
            }
          },
          37: {
            start: {
              line: 57,
              column: 8
            },
            end: {
              line: 59,
              column: 9
            }
          },
          38: {
            start: {
              line: 58,
              column: 12
            },
            end: {
              line: 58,
              column: 47
            }
          },
          39: {
            start: {
              line: 60,
              column: 8
            },
            end: {
              line: 62,
              column: 9
            }
          },
          40: {
            start: {
              line: 61,
              column: 12
            },
            end: {
              line: 61,
              column: 47
            }
          },
          41: {
            start: {
              line: 63,
              column: 8
            },
            end: {
              line: 65,
              column: 9
            }
          },
          42: {
            start: {
              line: 64,
              column: 12
            },
            end: {
              line: 64,
              column: 47
            }
          },
          43: {
            start: {
              line: 66,
              column: 8
            },
            end: {
              line: 66,
              column: 36
            }
          },
          44: {
            start: {
              line: 69,
              column: 0
            },
            end: {
              line: 69,
              column: 44
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 18
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 12,
                column: 4
              },
              end: {
                line: 12,
                column: 5
              }
            },
            loc: {
              start: {
                line: 12,
                column: 33
              },
              end: {
                line: 67,
                column: 5
              }
            },
            line: 12
          },
          2: {
            name: "(anonymous_2)",
            decl: {
              start: {
                line: 51,
                column: 64
              },
              end: {
                line: 51,
                column: 65
              }
            },
            loc: {
              start: {
                line: 51,
                column: 72
              },
              end: {
                line: 51,
                column: 101
              }
            },
            line: 51
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 12,
                column: 16
              },
              end: {
                line: 12,
                column: 31
              }
            },
            type: "default-arg",
            locations: [{
              start: {
                line: 12,
                column: 29
              },
              end: {
                line: 12,
                column: 31
              }
            }],
            line: 12
          },
          1: {
            loc: {
              start: {
                line: 17,
                column: 8
              },
              end: {
                line: 19,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 17,
                column: 8
              },
              end: {
                line: 19,
                column: 9
              }
            }, {
              start: {
                line: 17,
                column: 8
              },
              end: {
                line: 19,
                column: 9
              }
            }],
            line: 17
          },
          2: {
            loc: {
              start: {
                line: 20,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 20,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            }, {
              start: {
                line: 20,
                column: 8
              },
              end: {
                line: 22,
                column: 9
              }
            }],
            line: 20
          },
          3: {
            loc: {
              start: {
                line: 23,
                column: 8
              },
              end: {
                line: 25,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 23,
                column: 8
              },
              end: {
                line: 25,
                column: 9
              }
            }, {
              start: {
                line: 23,
                column: 8
              },
              end: {
                line: 25,
                column: 9
              }
            }],
            line: 23
          },
          4: {
            loc: {
              start: {
                line: 26,
                column: 8
              },
              end: {
                line: 28,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 26,
                column: 8
              },
              end: {
                line: 28,
                column: 9
              }
            }, {
              start: {
                line: 26,
                column: 8
              },
              end: {
                line: 28,
                column: 9
              }
            }],
            line: 26
          },
          5: {
            loc: {
              start: {
                line: 29,
                column: 8
              },
              end: {
                line: 31,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 29,
                column: 8
              },
              end: {
                line: 31,
                column: 9
              }
            }, {
              start: {
                line: 29,
                column: 8
              },
              end: {
                line: 31,
                column: 9
              }
            }],
            line: 29
          },
          6: {
            loc: {
              start: {
                line: 32,
                column: 8
              },
              end: {
                line: 34,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 32,
                column: 8
              },
              end: {
                line: 34,
                column: 9
              }
            }, {
              start: {
                line: 32,
                column: 8
              },
              end: {
                line: 34,
                column: 9
              }
            }],
            line: 32
          },
          7: {
            loc: {
              start: {
                line: 35,
                column: 8
              },
              end: {
                line: 37,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 35,
                column: 8
              },
              end: {
                line: 37,
                column: 9
              }
            }, {
              start: {
                line: 35,
                column: 8
              },
              end: {
                line: 37,
                column: 9
              }
            }],
            line: 35
          },
          8: {
            loc: {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }, {
              start: {
                line: 38,
                column: 8
              },
              end: {
                line: 40,
                column: 9
              }
            }],
            line: 38
          },
          9: {
            loc: {
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 43,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 43,
                column: 9
              }
            }, {
              start: {
                line: 41,
                column: 8
              },
              end: {
                line: 43,
                column: 9
              }
            }],
            line: 41
          },
          10: {
            loc: {
              start: {
                line: 44,
                column: 8
              },
              end: {
                line: 46,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 44,
                column: 8
              },
              end: {
                line: 46,
                column: 9
              }
            }, {
              start: {
                line: 44,
                column: 8
              },
              end: {
                line: 46,
                column: 9
              }
            }],
            line: 44
          },
          11: {
            loc: {
              start: {
                line: 47,
                column: 8
              },
              end: {
                line: 49,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 47,
                column: 8
              },
              end: {
                line: 49,
                column: 9
              }
            }, {
              start: {
                line: 47,
                column: 8
              },
              end: {
                line: 49,
                column: 9
              }
            }],
            line: 47
          },
          12: {
            loc: {
              start: {
                line: 50,
                column: 8
              },
              end: {
                line: 53,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 50,
                column: 8
              },
              end: {
                line: 53,
                column: 9
              }
            }, {
              start: {
                line: 50,
                column: 8
              },
              end: {
                line: 53,
                column: 9
              }
            }],
            line: 50
          },
          13: {
            loc: {
              start: {
                line: 50,
                column: 12
              },
              end: {
                line: 50,
                column: 87
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 50,
                column: 12
              },
              end: {
                line: 50,
                column: 44
              }
            }, {
              start: {
                line: 50,
                column: 48
              },
              end: {
                line: 50,
                column: 87
              }
            }],
            line: 50
          },
          14: {
            loc: {
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 56,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 56,
                column: 9
              }
            }, {
              start: {
                line: 54,
                column: 8
              },
              end: {
                line: 56,
                column: 9
              }
            }],
            line: 54
          },
          15: {
            loc: {
              start: {
                line: 57,
                column: 8
              },
              end: {
                line: 59,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 57,
                column: 8
              },
              end: {
                line: 59,
                column: 9
              }
            }, {
              start: {
                line: 57,
                column: 8
              },
              end: {
                line: 59,
                column: 9
              }
            }],
            line: 57
          },
          16: {
            loc: {
              start: {
                line: 60,
                column: 8
              },
              end: {
                line: 62,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 60,
                column: 8
              },
              end: {
                line: 62,
                column: 9
              }
            }, {
              start: {
                line: 60,
                column: 8
              },
              end: {
                line: 62,
                column: 9
              }
            }],
            line: 60
          },
          17: {
            loc: {
              start: {
                line: 63,
                column: 8
              },
              end: {
                line: 65,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 63,
                column: 8
              },
              end: {
                line: 65,
                column: 9
              }
            }, {
              start: {
                line: 63,
                column: 8
              },
              end: {
                line: 65,
                column: 9
              }
            }],
            line: 63
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0
        },
        b: {
          0: [0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0],
          6: [0, 0],
          7: [0, 0],
          8: [0, 0],
          9: [0, 0],
          10: [0, 0],
          11: [0, 0],
          12: [0, 0],
          13: [0, 0],
          14: [0, 0],
          15: [0, 0],
          16: [0, 0],
          17: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table-of-contents/field-instruction.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table-of-contents\\field-instruction.ts"],
          names: [],
          mappings: ";;AACA,gDAA4C;AAC5C,wDAA0E;AAG1E,oBAAqB,SAAQ,sCAAoD;IAAjF;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,WAAW,EAAE,CAAC;IACxD,CAAC;CAAA;AAED,sBAA8B,SAAQ,6BAAY;IAG9C,YAAY,aAAsC,EAAE;QAChD,KAAK,CAAC,aAAa,CAAC,CAAC;QAErB,IAAI,CAAC,UAAU,GAAG,UAAU,CAAC;QAE7B,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,cAAc,CAAC,EAAE,KAAK,EAAE,sBAAS,CAAC,QAAQ,EAAE,CAAC,CAAC,CAAC;QAClE,IAAI,WAAW,GAAG,KAAK,CAAC;QAExB,IAAI,IAAI,CAAC,UAAU,CAAC,YAAY,EAAE;YAC9B,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,YAAY,GAAG,CAAC;SACxE;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,mBAAmB,EAAE;YACrC,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,mBAAmB,GAAG,CAAC;SAC/E;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,4BAA4B,EAAE;YAC9C,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,4BAA4B,GAAG,CAAC;SACxF;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,+BAA+B,EAAE;YACjD,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,+BAA+B,GAAG,CAAC;SAC3F;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,iBAAiB,EAAE;YACnC,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,iBAAiB,GAAG,CAAC;SAC7E;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,SAAS,EAAE;YAC3B,WAAW,GAAG,GAAG,WAAW,MAAM,CAAC;SACtC;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,iBAAiB,EAAE;YACnC,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,iBAAiB,GAAG,CAAC;SAC7E;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,2BAA2B,EAAE;YAC7C,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,2BAA2B,GAAG,CAAC;SACvF;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,iBAAiB,EAAE;YACnC,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,iBAAiB,GAAG,CAAC;SAC7E;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,2BAA2B,EAAE;YAC7C,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,2BAA2B,GAAG,CAAC;SACvF;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,2BAA2B,EAAE;YAC7C,WAAW,GAAG,GAAG,WAAW,SAAS,IAAI,CAAC,UAAU,CAAC,2BAA2B,GAAG,CAAC;SACvF;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,gBAAgB,IAAI,IAAI,CAAC,UAAU,CAAC,gBAAgB,CAAC,MAAM,EAAE;YAC7E,MAAM,MAAM,GAAG,IAAI,CAAC,UAAU,CAAC,gBAAgB,CAAC,GAAG,CAAC,CAAC,EAAE,EAAE,EAAE,CAAC,GAAG,EAAE,CAAC,SAAS,IAAI,EAAE,CAAC,KAAK,EAAE,CAAC,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;YACrG,WAAW,GAAG,GAAG,WAAW,SAAS,MAAM,GAAG,CAAC;SAClD;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,+BAA+B,EAAE;YACjD,WAAW,GAAG,GAAG,WAAW,MAAM,CAAC;SACtC;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,oBAAoB,EAAE;YACtC,WAAW,GAAG,GAAG,WAAW,MAAM,CAAC;SACtC;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,wBAAwB,EAAE;YAC1C,WAAW,GAAG,GAAG,WAAW,MAAM,CAAC;SACtC;QACD,IAAI,IAAI,CAAC,UAAU,CAAC,8BAA8B,EAAE;YAChD,WAAW,GAAG,GAAG,WAAW,MAAM,CAAC;SACtC;QACD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,WAAW,CAAC,CAAC;IAChC,CAAC;CACJ;AA9DD,4CA8DC",
          sourcesContent: ["// http://officeopenxml.com/WPfieldInstructions.php\r\nimport { SpaceType } from \"file/space-type\";\r\nimport { XmlAttributeComponent, XmlComponent } from \"file/xml-components\";\r\nimport { ITableOfContentsOptions } from \"./table-of-contents-properties\";\r\n\r\nclass TextAttributes extends XmlAttributeComponent<{ readonly space: SpaceType }> {\r\n    protected readonly xmlKeys = { space: \"xml:space\" };\r\n}\r\n\r\nexport class FieldInstruction extends XmlComponent {\r\n    private readonly properties: ITableOfContentsOptions;\r\n\r\n    constructor(properties: ITableOfContentsOptions = {}) {\r\n        super(\"w:instrText\");\r\n\r\n        this.properties = properties;\r\n\r\n        this.root.push(new TextAttributes({ space: SpaceType.PRESERVE }));\r\n        let instruction = \"TOC\";\r\n\r\n        if (this.properties.captionLabel) {\r\n            instruction = `${instruction} \\\\a \"${this.properties.captionLabel}\"`;\r\n        }\r\n        if (this.properties.entriesFromBookmark) {\r\n            instruction = `${instruction} \\\\b \"${this.properties.entriesFromBookmark}\"`;\r\n        }\r\n        if (this.properties.captionLabelIncludingNumbers) {\r\n            instruction = `${instruction} \\\\c \"${this.properties.captionLabelIncludingNumbers}\"`;\r\n        }\r\n        if (this.properties.sequenceAndPageNumbersSeparator) {\r\n            instruction = `${instruction} \\\\d \"${this.properties.sequenceAndPageNumbersSeparator}\"`;\r\n        }\r\n        if (this.properties.tcFieldIdentifier) {\r\n            instruction = `${instruction} \\\\f \"${this.properties.tcFieldIdentifier}\"`;\r\n        }\r\n        if (this.properties.hyperlink) {\r\n            instruction = `${instruction} \\\\h`;\r\n        }\r\n        if (this.properties.tcFieldLevelRange) {\r\n            instruction = `${instruction} \\\\l \"${this.properties.tcFieldLevelRange}\"`;\r\n        }\r\n        if (this.properties.pageNumbersEntryLevelsRange) {\r\n            instruction = `${instruction} \\\\n \"${this.properties.pageNumbersEntryLevelsRange}\"`;\r\n        }\r\n        if (this.properties.headingStyleRange) {\r\n            instruction = `${instruction} \\\\o \"${this.properties.headingStyleRange}\"`;\r\n        }\r\n        if (this.properties.entryAndPageNumberSeparator) {\r\n            instruction = `${instruction} \\\\p \"${this.properties.entryAndPageNumberSeparator}\"`;\r\n        }\r\n        if (this.properties.seqFieldIdentifierForPrefix) {\r\n            instruction = `${instruction} \\\\s \"${this.properties.seqFieldIdentifierForPrefix}\"`;\r\n        }\r\n        if (this.properties.stylesWithLevels && this.properties.stylesWithLevels.length) {\r\n            const styles = this.properties.stylesWithLevels.map((sl) => `${sl.styleName};${sl.level}`).join(\";\");\r\n            instruction = `${instruction} \\\\t \"${styles}\"`;\r\n        }\r\n        if (this.properties.useAppliedParagraphOutlineLevel) {\r\n            instruction = `${instruction} \\\\u`;\r\n        }\r\n        if (this.properties.preserveTabInEntries) {\r\n            instruction = `${instruction} \\\\w`;\r\n        }\r\n        if (this.properties.preserveNewLineInEntries) {\r\n            instruction = `${instruction} \\\\x`;\r\n        }\r\n        if (this.properties.hideTabAndPageNumbersInWebView) {\r\n            instruction = `${instruction} \\\\z`;\r\n        }\r\n        this.root.push(instruction);\r\n    }\r\n}\r\n"]
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(20)),
          u = (a.s[2]++, t(0));

      var p =
      /*#__PURE__*/
      function (_u$XmlAttributeCompon4) {
        _inherits(p, _u$XmlAttributeCompon4);

        function p() {
          var _this311;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this311 = _possibleConstructorReturn(this, _getPrototypeOf(p).apply(this, arguments)), a.s[4]++, _this311.xmlKeys = {
            space: "xml:space"
          };
          return _this311;
        }

        return p;
      }(u.XmlAttributeComponent);

      var m =
      /*#__PURE__*/
      function (_u$XmlComponent11) {
        _inherits(m, _u$XmlComponent11);

        function m() {
          var _this312;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (a.b[0][0]++, {});

          _classCallCheck(this, m);

          a.f[1]++, a.s[5]++, _this312 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, "w:instrText")), a.s[6]++, _this312.properties = e, a.s[7]++, _this312.root.push(new p({
            space: c.SpaceType.PRESERVE
          }));
          var n = (a.s[8]++, "TOC");

          if (a.s[9]++, _this312.properties.captionLabel ? (a.b[1][0]++, a.s[10]++, n = "".concat(n, " \\a \"").concat(_this312.properties.captionLabel, "\"")) : a.b[1][1]++, a.s[11]++, _this312.properties.entriesFromBookmark ? (a.b[2][0]++, a.s[12]++, n = "".concat(n, " \\b \"").concat(_this312.properties.entriesFromBookmark, "\"")) : a.b[2][1]++, a.s[13]++, _this312.properties.captionLabelIncludingNumbers ? (a.b[3][0]++, a.s[14]++, n = "".concat(n, " \\c \"").concat(_this312.properties.captionLabelIncludingNumbers, "\"")) : a.b[3][1]++, a.s[15]++, _this312.properties.sequenceAndPageNumbersSeparator ? (a.b[4][0]++, a.s[16]++, n = "".concat(n, " \\d \"").concat(_this312.properties.sequenceAndPageNumbersSeparator, "\"")) : a.b[4][1]++, a.s[17]++, _this312.properties.tcFieldIdentifier ? (a.b[5][0]++, a.s[18]++, n = "".concat(n, " \\f \"").concat(_this312.properties.tcFieldIdentifier, "\"")) : a.b[5][1]++, a.s[19]++, _this312.properties.hyperlink ? (a.b[6][0]++, a.s[20]++, n = "".concat(n, " \\h")) : a.b[6][1]++, a.s[21]++, _this312.properties.tcFieldLevelRange ? (a.b[7][0]++, a.s[22]++, n = "".concat(n, " \\l \"").concat(_this312.properties.tcFieldLevelRange, "\"")) : a.b[7][1]++, a.s[23]++, _this312.properties.pageNumbersEntryLevelsRange ? (a.b[8][0]++, a.s[24]++, n = "".concat(n, " \\n \"").concat(_this312.properties.pageNumbersEntryLevelsRange, "\"")) : a.b[8][1]++, a.s[25]++, _this312.properties.headingStyleRange ? (a.b[9][0]++, a.s[26]++, n = "".concat(n, " \\o \"").concat(_this312.properties.headingStyleRange, "\"")) : a.b[9][1]++, a.s[27]++, _this312.properties.entryAndPageNumberSeparator ? (a.b[10][0]++, a.s[28]++, n = "".concat(n, " \\p \"").concat(_this312.properties.entryAndPageNumberSeparator, "\"")) : a.b[10][1]++, a.s[29]++, _this312.properties.seqFieldIdentifierForPrefix ? (a.b[11][0]++, a.s[30]++, n = "".concat(n, " \\s \"").concat(_this312.properties.seqFieldIdentifierForPrefix, "\"")) : a.b[11][1]++, a.s[31]++, a.b[13][0]++, _this312.properties.stylesWithLevels && (a.b[13][1]++, _this312.properties.stylesWithLevels.length)) {
            a.b[12][0]++;

            var _e10 = (a.s[32]++, _this312.properties.stylesWithLevels.map(function (e) {
              return a.f[2]++, a.s[33]++, "".concat(e.styleName, ";").concat(e.level);
            }).join(";"));

            a.s[34]++, n = "".concat(n, " \\t \"").concat(_e10, "\"");
          } else a.b[12][1]++;

          a.s[35]++, _this312.properties.useAppliedParagraphOutlineLevel ? (a.b[14][0]++, a.s[36]++, n = "".concat(n, " \\u")) : a.b[14][1]++, a.s[37]++, _this312.properties.preserveTabInEntries ? (a.b[15][0]++, a.s[38]++, n = "".concat(n, " \\w")) : a.b[15][1]++, a.s[39]++, _this312.properties.preserveNewLineInEntries ? (a.b[16][0]++, a.s[40]++, n = "".concat(n, " \\x")) : a.b[16][1]++, a.s[41]++, _this312.properties.hideTabAndPageNumbersInWebView ? (a.b[17][0]++, a.s[42]++, n = "".concat(n, " \\z")) : a.b[17][1]++, a.s[43]++, _this312.root.push(n);
          return _this312;
        }

        return m;
      }(u.XmlComponent);

      a.s[44]++, n.FieldInstruction = m;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\sdt-content.ts", o = "01b575a29bdd764286a117d59e80aa7984c4c6bb", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\sdt-content.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 30
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 68
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 5
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table-of-contents/sdt-content.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table-of-contents\\sdt-content.ts"],
          names: [],
          mappings: ";;AAAA,wDAAmD;AAEnD,kCAA0C,SAAQ,6BAAY;IAC1D;QACI,KAAK,CAAC,cAAc,CAAC,CAAC;IAC1B,CAAC;CACJ;AAJD,oEAIC",
          sourcesContent: ['import { XmlComponent } from "file/xml-components";\r\n\r\nexport class StructuredDocumentTagContent extends XmlComponent {\r\n    constructor() {\r\n        super("w:sdtContent");\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlComponent167) {
        _inherits(u, _c$XmlComponent167);

        function u() {
          var _this313;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this313 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, "w:sdtContent"));
          return _this313;
        }

        return u;
      }(c.XmlComponent);

      a.s[3]++, n.StructuredDocumentTagContent = u;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\sdt-properties.ts", o = "dee8b16948d524cb5cacb881e29e528d69828d48", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\sdt-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 4,
              column: 16
            },
            end: {
              line: 4,
              column: 34
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 25
            }
          },
          4: {
            start: {
              line: 8,
              column: 8
            },
            end: {
              line: 8,
              column: 49
            }
          },
          5: {
            start: {
              line: 11,
              column: 0
            },
            end: {
              line: 11,
              column: 74
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 6,
                column: 4
              },
              end: {
                line: 6,
                column: 5
              }
            },
            loc: {
              start: {
                line: 6,
                column: 23
              },
              end: {
                line: 9,
                column: 5
              }
            },
            line: 6
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table-of-contents/sdt-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table-of-contents\\sdt-properties.ts"],
          names: [],
          mappings: ";;AACA,wDAAmD;AACnD,mCAAgC;AAEhC,qCAA6C,SAAQ,6BAAY;IAC7D,YAAY,KAAa;QACrB,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,aAAK,CAAC,KAAK,CAAC,CAAC,CAAC;IACrC,CAAC;CACJ;AALD,0EAKC",
          sourcesContent: ['// http://www.datypic.com/sc/ooxml/e-w_sdtPr-1.html\r\nimport { XmlComponent } from "file/xml-components";\r\nimport { Alias } from "./alias";\r\n\r\nexport class StructuredDocumentTagProperties extends XmlComponent {\r\n    constructor(alias: string) {\r\n        super("w:sdtPr");\r\n        this.root.push(new Alias(alias));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0)),
          u = (a.s[2]++, t(292));

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent168) {
        _inherits(p, _c$XmlComponent168);

        function p(e) {
          var _this314;

          _classCallCheck(this, p);

          a.f[0]++, a.s[3]++, _this314 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:sdtPr")), a.s[4]++, _this314.root.push(new u.Alias(e));
          return _this314;
        }

        return p;
      }(c.XmlComponent);

      a.s[5]++, n.StructuredDocumentTagProperties = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\alias.ts", o = "00ac6a2dcbbac7e19b2b7fe51f0033575c385295", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\alias.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 3,
              column: 25
            },
            end: {
              line: 3,
              column: 55
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 28
            }
          },
          3: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 42
            }
          },
          4: {
            start: {
              line: 12,
              column: 8
            },
            end: {
              line: 12,
              column: 25
            }
          },
          5: {
            start: {
              line: 13,
              column: 8
            },
            end: {
              line: 13,
              column: 55
            }
          },
          6: {
            start: {
              line: 16,
              column: 0
            },
            end: {
              line: 16,
              column: 22
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 5,
                column: 4
              },
              end: {
                line: 5,
                column: 5
              }
            },
            loc: {
              start: {
                line: 5,
                column: 18
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 5
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 11,
                column: 4
              },
              end: {
                line: 11,
                column: 5
              }
            },
            loc: {
              start: {
                line: 11,
                column: 23
              },
              end: {
                line: 14,
                column: 5
              }
            },
            line: 11
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0
        },
        f: {
          0: 0,
          1: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table-of-contents/alias.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table-of-contents\\alias.ts"],
          names: [],
          mappings: ";;AAAA,wDAA0E;AAE1E,qBAAsB,SAAQ,sCAAiD;IAA/E;;QACuB,YAAO,GAAG,EAAE,KAAK,EAAE,OAAO,EAAE,CAAC;IACpD,CAAC;CAAA;AAED,WAAmB,SAAQ,6BAAY;IACnC,YAAY,KAAa;QACrB,KAAK,CAAC,SAAS,CAAC,CAAC;QACjB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,eAAe,CAAC,EAAE,KAAK,EAAE,CAAC,CAAC,CAAC;IACnD,CAAC;CACJ;AALD,sBAKC",
          sourcesContent: ['import { XmlAttributeComponent, XmlComponent } from "file/xml-components";\r\n\r\nclass AliasAttributes extends XmlAttributeComponent<{ readonly alias: string }> {\r\n    protected readonly xmlKeys = { alias: "w:val" };\r\n}\r\n\r\nexport class Alias extends XmlComponent {\r\n    constructor(alias: string) {\r\n        super("w:alias");\r\n        this.root.push(new AliasAttributes({ alias }));\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var c = (a.s[1]++, t(0));

      var u =
      /*#__PURE__*/
      function (_c$XmlAttributeCompon75) {
        _inherits(u, _c$XmlAttributeCompon75);

        function u() {
          var _this315;

          _classCallCheck(this, u);

          a.f[0]++, a.s[2]++, _this315 = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), a.s[3]++, _this315.xmlKeys = {
            alias: "w:val"
          };
          return _this315;
        }

        return u;
      }(c.XmlAttributeComponent);

      var p =
      /*#__PURE__*/
      function (_c$XmlComponent169) {
        _inherits(p, _c$XmlComponent169);

        function p(e) {
          var _this316;

          _classCallCheck(this, p);

          a.f[1]++, a.s[4]++, _this316 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, "w:alias")), a.s[5]++, _this316.root.push(new u({
            alias: e
          }));
          return _this316;
        }

        return p;
      }(c.XmlComponent);

      a.s[6]++, n.Alias = p;
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\table-of-contents-properties.ts", o = "5188c2ad91568118bb53e77978b34238531e4baa", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\file\\table-of-contents\\table-of-contents-properties.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 5,
              column: 8
            },
            end: {
              line: 5,
              column: 35
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 6,
              column: 27
            }
          },
          3: {
            start: {
              line: 9,
              column: 0
            },
            end: {
              line: 9,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 4
              },
              end: {
                line: 4,
                column: 5
              }
            },
            loc: {
              start: {
                line: 4,
                column: 34
              },
              end: {
                line: 7,
                column: 5
              }
            },
            line: 4
          }
        },
        branchMap: {},
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0
        },
        f: {
          0: 0
        },
        b: {},
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/file/table-of-contents/table-of-contents-properties.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\file\\table-of-contents\\table-of-contents-properties.ts"],
          names: [],
          mappings: ";;AAAA;IAII,YAAY,SAAiB,EAAE,KAAa;QACxC,IAAI,CAAC,SAAS,GAAG,SAAS,CAAC;QAC3B,IAAI,CAAC,KAAK,GAAG,KAAK,CAAC;IACvB,CAAC;CACJ;AARD,gCAQC",
          sourcesContent: ["export class StyleLevel {\r\n    public readonly styleName: string;\r\n    public readonly level: number;\r\n\r\n    constructor(styleName: string, level: number) {\r\n        this.styleName = styleName;\r\n        this.level = level;\r\n    }\r\n}\r\n\r\n/**\r\n * Options according to this docs:\r\n * https://www.ecma-international.org/publications/standards/Ecma-376.htm\r\n * Part 1 - Page 1251\r\n *\r\n * Short Guide:\r\n * http://officeopenxml.com/WPtableOfContents.php\r\n */\r\nexport interface ITableOfContentsOptions {\r\n    /**\r\n     * \\a option - Includes captioned items, but omits caption labels and numbers.\r\n     * The identifier designated by text in this switch's field-argument corresponds to the caption label.\r\n     * Use captionLabelIncludingNumbers (\\c) to build a table of captions with labels and numbers.\r\n     */\r\n    readonly captionLabel?: string;\r\n\r\n    /**\r\n     * \\b option - Includes entries only from the portion of the document marked by\r\n     * the bookmark named by text in this switch's field-argument.\r\n     */\r\n    readonly entriesFromBookmark?: string;\r\n\r\n    /**\r\n     * \\c option -  Includes figures, tables, charts, and other items that are numbered\r\n     * by a SEQ field (\xA717.16.5.56). The sequence identifier designated by text in this switch's\r\n     * field-argument, which corresponds to the caption label, shall match the identifier in the\r\n     * corresponding SEQ field.\r\n     */\r\n    readonly captionLabelIncludingNumbers?: string;\r\n\r\n    /**\r\n     * \\d option - When used with \\s, the text in this switch's field-argument defines\r\n     * the separator between sequence and page numbers. The default separator is a hyphen (-).\r\n     */\r\n    readonly sequenceAndPageNumbersSeparator?: string;\r\n\r\n    /**\r\n     * \\f option - Includes only those TC fields whose identifier exactly matches the\r\n     * text in this switch's field-argument (which is typically a letter).\r\n     */\r\n    readonly tcFieldIdentifier?: string;\r\n\r\n    /**\r\n     * \\h option - Makes the table of contents entries hyperlinks.\r\n     */\r\n    readonly hyperlink?: boolean;\r\n\r\n    /**\r\n     * \\l option - Includes TC fields that assign entries to one of the levels specified\r\n     * by text in this switch's field-argument as a range having the form startLevel-endLevel,\r\n     * where startLevel and endLevel are integers, and startLevel has a value equal-to or less-than endLevel.\r\n     * TC fields that assign entries to lower levels are skipped.\r\n     */\r\n    readonly tcFieldLevelRange?: string;\r\n\r\n    /**\r\n     * \\n option - Without field-argument, omits page numbers from the table of contents.\r\n     * Page numbers are omitted from all levels unless a range of entry levels is specified by\r\n     * text in this switch's field-argument. A range is specified as for \\l.\r\n     */\r\n    readonly pageNumbersEntryLevelsRange?: string;\r\n\r\n    /**\r\n     * \\o option -  Uses paragraphs formatted with all or the specified range of builtin\r\n     * heading styles. Headings in a style range are specified by text in this switch's\r\n     * field-argument using the notation specified as for \\l, where each integer corresponds\r\n     * to the style with a style ID of HeadingX (e.g. 1 corresponds to Heading1).\r\n     * If no heading range is specified, all heading levels used in the document are listed.\r\n     */\r\n    readonly headingStyleRange?: string;\r\n\r\n    /**\r\n     * \\p option - Text in this switch's field-argument specifies a sequence of characters\r\n     * that separate an entry and its page number. The default is a tab with leader dots.\r\n     */\r\n    readonly entryAndPageNumberSeparator?: string;\r\n\r\n    /**\r\n     * \\s option - For entries numbered with a SEQ field (\xA717.16.5.56), adds a prefix to the page number.\r\n     * The prefix depends on the type of entry. text in this switch's field-argument shall match the\r\n     * identifier in the SEQ field.\r\n     */\r\n    readonly seqFieldIdentifierForPrefix?: string;\r\n\r\n    /**\r\n     * \\t field-argument Uses paragraphs formatted with styles other than the built-in heading styles.\r\n     * Text in this switch's field-argument specifies those styles as a set of comma-separated doublets,\r\n     * with each doublet being a comma-separated set of style name and table of content level.\r\n     * \\t can be combined with \\o.\r\n     */\r\n    readonly stylesWithLevels?: StyleLevel[];\r\n\r\n    /**\r\n     * \\u Uses the applied paragraph outline level.\r\n     */\r\n    readonly useAppliedParagraphOutlineLevel?: boolean;\r\n\r\n    /**\r\n     * \\w Preserves tab entries within table entries.\r\n     */\r\n    readonly preserveTabInEntries?: boolean;\r\n\r\n    /**\r\n     * \\x Preserves newline characters within table entries.\r\n     */\r\n    readonly preserveNewLineInEntries?: boolean;\r\n\r\n    /**\r\n     * \\z Hides tab leader and page numbers in web page view (\xA717.18.102).\r\n     */\r\n    readonly hideTabAndPageNumbersInWebView?: boolean;\r\n}\r\n"]
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[3]++, n.StyleLevel =
      /*#__PURE__*/
      function () {
        function _class48(e, n) {
          _classCallCheck(this, _class48);

          a.f[0]++, a.s[1]++, this.styleName = e, a.s[2]++, this.level = n;
        }

        return _class48;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\index.ts", o = "76e39025d06d085d40d85b042f38b9485f91f94f", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 37
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/export/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\export\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,qCAAgC",
          sourcesContent: ['export * from "./packer/packer";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(295));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\packer\\packer.ts", o = "459fcc6fac936f9f3af16cbbfd89c891b740e617", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\packer\\packer.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 16
            },
            end: {
              line: 9,
              column: 1
            }
          },
          1: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 8,
              column: 7
            }
          },
          2: {
            start: {
              line: 4,
              column: 36
            },
            end: {
              line: 4,
              column: 97
            }
          },
          3: {
            start: {
              line: 4,
              column: 42
            },
            end: {
              line: 4,
              column: 70
            }
          },
          4: {
            start: {
              line: 4,
              column: 85
            },
            end: {
              line: 4,
              column: 95
            }
          },
          5: {
            start: {
              line: 5,
              column: 35
            },
            end: {
              line: 5,
              column: 100
            }
          },
          6: {
            start: {
              line: 5,
              column: 41
            },
            end: {
              line: 5,
              column: 73
            }
          },
          7: {
            start: {
              line: 5,
              column: 88
            },
            end: {
              line: 5,
              column: 98
            }
          },
          8: {
            start: {
              line: 6,
              column: 32
            },
            end: {
              line: 6,
              column: 149
            }
          },
          9: {
            start: {
              line: 6,
              column: 97
            },
            end: {
              line: 6,
              column: 119
            }
          },
          10: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 78
            }
          },
          11: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 62
            }
          },
          12: {
            start: {
              line: 11,
              column: 24
            },
            end: {
              line: 11,
              column: 50
            }
          },
          13: {
            start: {
              line: 14,
              column: 8
            },
            end: {
              line: 14,
              column: 55
            }
          },
          14: {
            start: {
              line: 17,
              column: 8
            },
            end: {
              line: 24,
              column: 11
            }
          },
          15: {
            start: {
              line: 18,
              column: 24
            },
            end: {
              line: 18,
              column: 57
            }
          },
          16: {
            start: {
              line: 19,
              column: 29
            },
            end: {
              line: 22,
              column: 14
            }
          },
          17: {
            start: {
              line: 23,
              column: 12
            },
            end: {
              line: 23,
              column: 27
            }
          },
          18: {
            start: {
              line: 27,
              column: 8
            },
            end: {
              line: 34,
              column: 11
            }
          },
          19: {
            start: {
              line: 28,
              column: 24
            },
            end: {
              line: 28,
              column: 57
            }
          },
          20: {
            start: {
              line: 29,
              column: 29
            },
            end: {
              line: 32,
              column: 14
            }
          },
          21: {
            start: {
              line: 33,
              column: 12
            },
            end: {
              line: 33,
              column: 27
            }
          },
          22: {
            start: {
              line: 37,
              column: 8
            },
            end: {
              line: 44,
              column: 11
            }
          },
          23: {
            start: {
              line: 38,
              column: 24
            },
            end: {
              line: 38,
              column: 57
            }
          },
          24: {
            start: {
              line: 39,
              column: 29
            },
            end: {
              line: 42,
              column: 14
            }
          },
          25: {
            start: {
              line: 43,
              column: 12
            },
            end: {
              line: 43,
              column: 27
            }
          },
          26: {
            start: {
              line: 47,
              column: 0
            },
            end: {
              line: 47,
              column: 24
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 2,
                column: 44
              },
              end: {
                line: 2,
                column: 45
              }
            },
            loc: {
              start: {
                line: 2,
                column: 89
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 2
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 3,
                column: 36
              },
              end: {
                line: 3,
                column: 37
              }
            },
            loc: {
              start: {
                line: 3,
                column: 63
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 3
          },
          2: {
            name: "fulfilled",
            decl: {
              start: {
                line: 4,
                column: 17
              },
              end: {
                line: 4,
                column: 26
              }
            },
            loc: {
              start: {
                line: 4,
                column: 34
              },
              end: {
                line: 4,
                column: 99
              }
            },
            line: 4
          },
          3: {
            name: "rejected",
            decl: {
              start: {
                line: 5,
                column: 17
              },
              end: {
                line: 5,
                column: 25
              }
            },
            loc: {
              start: {
                line: 5,
                column: 33
              },
              end: {
                line: 5,
                column: 102
              }
            },
            line: 5
          },
          4: {
            name: "step",
            decl: {
              start: {
                line: 6,
                column: 17
              },
              end: {
                line: 6,
                column: 21
              }
            },
            loc: {
              start: {
                line: 6,
                column: 30
              },
              end: {
                line: 6,
                column: 151
              }
            },
            line: 6
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 6,
                column: 76
              },
              end: {
                line: 6,
                column: 77
              }
            },
            loc: {
              start: {
                line: 6,
                column: 95
              },
              end: {
                line: 6,
                column: 121
              }
            },
            line: 6
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 13,
                column: 4
              },
              end: {
                line: 13,
                column: 5
              }
            },
            loc: {
              start: {
                line: 13,
                column: 18
              },
              end: {
                line: 15,
                column: 5
              }
            },
            line: 13
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 16,
                column: 4
              },
              end: {
                line: 16,
                column: 5
              }
            },
            loc: {
              start: {
                line: 16,
                column: 19
              },
              end: {
                line: 25,
                column: 5
              }
            },
            line: 16
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 17,
                column: 47
              },
              end: {
                line: 17,
                column: 48
              }
            },
            loc: {
              start: {
                line: 17,
                column: 60
              },
              end: {
                line: 24,
                column: 9
              }
            },
            line: 17
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 26,
                column: 4
              },
              end: {
                line: 26,
                column: 5
              }
            },
            loc: {
              start: {
                line: 26,
                column: 25
              },
              end: {
                line: 35,
                column: 5
              }
            },
            line: 26
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 27,
                column: 47
              },
              end: {
                line: 27,
                column: 48
              }
            },
            loc: {
              start: {
                line: 27,
                column: 60
              },
              end: {
                line: 34,
                column: 9
              }
            },
            line: 27
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 36,
                column: 4
              },
              end: {
                line: 36,
                column: 5
              }
            },
            loc: {
              start: {
                line: 36,
                column: 17
              },
              end: {
                line: 45,
                column: 5
              }
            },
            line: 36
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 37,
                column: 47
              },
              end: {
                line: 37,
                column: 48
              }
            },
            loc: {
              start: {
                line: 37,
                column: 60
              },
              end: {
                line: 44,
                column: 9
              }
            },
            line: 37
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 2,
                column: 16
              },
              end: {
                line: 9,
                column: 1
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 2,
                column: 17
              },
              end: {
                line: 2,
                column: 21
              }
            }, {
              start: {
                line: 2,
                column: 25
              },
              end: {
                line: 2,
                column: 39
              }
            }, {
              start: {
                line: 2,
                column: 44
              },
              end: {
                line: 9,
                column: 1
              }
            }],
            line: 2
          },
          1: {
            loc: {
              start: {
                line: 3,
                column: 16
              },
              end: {
                line: 3,
                column: 34
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 3,
                column: 16
              },
              end: {
                line: 3,
                column: 17
              }
            }, {
              start: {
                line: 3,
                column: 22
              },
              end: {
                line: 3,
                column: 33
              }
            }],
            line: 3
          },
          2: {
            loc: {
              start: {
                line: 6,
                column: 32
              },
              end: {
                line: 6,
                column: 148
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 6,
                column: 46
              },
              end: {
                line: 6,
                column: 67
              }
            }, {
              start: {
                line: 6,
                column: 70
              },
              end: {
                line: 6,
                column: 148
              }
            }],
            line: 6
          },
          3: {
            loc: {
              start: {
                line: 7,
                column: 51
              },
              end: {
                line: 7,
                column: 67
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 7,
                column: 51
              },
              end: {
                line: 7,
                column: 61
              }
            }, {
              start: {
                line: 7,
                column: 65
              },
              end: {
                line: 7,
                column: 67
              }
            }],
            line: 7
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0
        },
        b: {
          0: [0, 0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/export/packer/packer.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\export\\packer\\packer.ts"],
          names: [],
          mappings: ";;;;;;;;;;AACA,mDAA2C;AAE3C;IAGI;QACI,IAAI,CAAC,QAAQ,GAAG,IAAI,wBAAQ,EAAE,CAAC;IACnC,CAAC;IAEY,QAAQ,CAAC,IAAU;;YAC5B,MAAM,GAAG,GAAG,MAAM,IAAI,CAAC,QAAQ,CAAC,OAAO,CAAC,IAAI,CAAC,CAAC;YAC9C,MAAM,OAAO,GAAG,CAAC,MAAM,GAAG,CAAC,aAAa,CAAC;gBACrC,IAAI,EAAE,YAAY;gBAClB,QAAQ,EAAE,yEAAyE;aACtF,CAAC,CAAW,CAAC;YAEd,OAAO,OAAO,CAAC;QACnB,CAAC;KAAA;IAEY,cAAc,CAAC,IAAU;;YAClC,MAAM,GAAG,GAAG,MAAM,IAAI,CAAC,QAAQ,CAAC,OAAO,CAAC,IAAI,CAAC,CAAC;YAC9C,MAAM,OAAO,GAAG,CAAC,MAAM,GAAG,CAAC,aAAa,CAAC;gBACrC,IAAI,EAAE,QAAQ;gBACd,QAAQ,EAAE,yEAAyE;aACtF,CAAC,CAAW,CAAC;YAEd,OAAO,OAAO,CAAC;QACnB,CAAC;KAAA;IAEY,MAAM,CAAC,IAAU;;YAC1B,MAAM,GAAG,GAAG,MAAM,IAAI,CAAC,QAAQ,CAAC,OAAO,CAAC,IAAI,CAAC,CAAC;YAC9C,MAAM,OAAO,GAAG,CAAC,MAAM,GAAG,CAAC,aAAa,CAAC;gBACrC,IAAI,EAAE,MAAM;gBACZ,QAAQ,EAAE,yEAAyE;aACtF,CAAC,CAAS,CAAC;YAEZ,OAAO,OAAO,CAAC;QACnB,CAAC;KAAA;CACJ;AApCD,wBAoCC",
          sourcesContent: ['import { File } from "file";\r\nimport { Compiler } from "./next-compiler";\r\n\r\nexport class Packer {\r\n    private readonly compiler: Compiler;\r\n\r\n    constructor() {\r\n        this.compiler = new Compiler();\r\n    }\r\n\r\n    public async toBuffer(file: File): Promise<Buffer> {\r\n        const zip = await this.compiler.compile(file);\r\n        const zipData = (await zip.generateAsync({\r\n            type: "nodebuffer",\r\n            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",\r\n        })) as Buffer;\r\n\r\n        return zipData;\r\n    }\r\n\r\n    public async toBase64String(file: File): Promise<string> {\r\n        const zip = await this.compiler.compile(file);\r\n        const zipData = (await zip.generateAsync({\r\n            type: "base64",\r\n            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",\r\n        })) as string;\r\n\r\n        return zipData;\r\n    }\r\n\r\n    public async toBlob(file: File): Promise<Blob> {\r\n        const zip = await this.compiler.compile(file);\r\n        const zipData = (await zip.generateAsync({\r\n            type: "blob",\r\n            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",\r\n        })) as Blob;\r\n\r\n        return zipData;\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s)),
          c = (a.s[0]++, a.b[0][0]++, this && (a.b[0][1]++, this.__awaiter) || (a.b[0][2]++, function (e, n, t, r) {
        return a.f[0]++, a.s[1]++, new (a.b[1][0]++, t || (a.b[1][1]++, t = Promise))(function (o, i) {
          function A(e) {
            a.f[2]++, a.s[2]++;

            try {
              a.s[3]++, l(r.next(e));
            } catch (e) {
              a.s[4]++, i(e);
            }
          }

          function s(e) {
            a.f[3]++, a.s[5]++;

            try {
              a.s[6]++, l(r.throw(e));
            } catch (e) {
              a.s[7]++, i(e);
            }
          }

          function l(e) {
            a.f[4]++, a.s[8]++, e.done ? (a.b[2][0]++, o(e.value)) : (a.b[2][1]++, new t(function (n) {
              a.f[5]++, a.s[9]++, n(e.value);
            }).then(A, s));
          }

          a.f[1]++, a.s[10]++, l((r = r.apply(e, (a.b[3][0]++, n || (a.b[3][1]++, [])))).next());
        });
      }));
      a.s[11]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var u = (a.s[12]++, t(296));
      a.s[26]++, n.Packer =
      /*#__PURE__*/
      function () {
        function _class49() {
          _classCallCheck(this, _class49);

          a.f[6]++, a.s[13]++, this.compiler = new u.Compiler();
        }

        _createClass(_class49, [{
          key: "toBuffer",
          value: function toBuffer(e) {
            return a.f[7]++, a.s[14]++, c(this, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var n, t;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      a.f[8]++;
                      a.s[15]++;
                      _context.next = 4;
                      return this.compiler.compile(e);

                    case 4:
                      n = _context.sent;
                      a.s[16]++;
                      _context.next = 8;
                      return n.generateAsync({
                        type: "nodebuffer",
                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      });

                    case 8:
                      t = _context.sent;
                      return _context.abrupt("return", (a.s[17]++, t));

                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));
          }
        }, {
          key: "toBase64String",
          value: function toBase64String(e) {
            return a.f[9]++, a.s[18]++, c(this, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2() {
              var n, t;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      a.f[10]++;
                      a.s[19]++;
                      _context2.next = 4;
                      return this.compiler.compile(e);

                    case 4:
                      n = _context2.sent;
                      a.s[20]++;
                      _context2.next = 8;
                      return n.generateAsync({
                        type: "base64",
                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      });

                    case 8:
                      t = _context2.sent;
                      return _context2.abrupt("return", (a.s[21]++, t));

                    case 10:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
          }
        }, {
          key: "toBlob",
          value: function toBlob(e) {
            return a.f[11]++, a.s[22]++, c(this, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee3() {
              var n, t;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      a.f[12]++;
                      a.s[23]++;
                      _context3.next = 4;
                      return this.compiler.compile(e);

                    case 4:
                      n = _context3.sent;
                      a.s[24]++;
                      _context3.next = 8;
                      return n.generateAsync({
                        type: "blob",
                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      });

                    case 8:
                      t = _context3.sent;
                      return _context3.abrupt("return", (a.s[25]++, t));

                    case 10:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));
          }
        }]);

        return _class49;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\packer\\next-compiler.ts", o = "390d1baa4b078f6c96175e727e9430bc1bc68399", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\packer\\next-compiler.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 16
            },
            end: {
              line: 9,
              column: 1
            }
          },
          1: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 8,
              column: 7
            }
          },
          2: {
            start: {
              line: 4,
              column: 36
            },
            end: {
              line: 4,
              column: 97
            }
          },
          3: {
            start: {
              line: 4,
              column: 42
            },
            end: {
              line: 4,
              column: 70
            }
          },
          4: {
            start: {
              line: 4,
              column: 85
            },
            end: {
              line: 4,
              column: 95
            }
          },
          5: {
            start: {
              line: 5,
              column: 35
            },
            end: {
              line: 5,
              column: 100
            }
          },
          6: {
            start: {
              line: 5,
              column: 41
            },
            end: {
              line: 5,
              column: 73
            }
          },
          7: {
            start: {
              line: 5,
              column: 88
            },
            end: {
              line: 5,
              column: 98
            }
          },
          8: {
            start: {
              line: 6,
              column: 32
            },
            end: {
              line: 6,
              column: 149
            }
          },
          9: {
            start: {
              line: 6,
              column: 97
            },
            end: {
              line: 6,
              column: 119
            }
          },
          10: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 78
            }
          },
          11: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 62
            }
          },
          12: {
            start: {
              line: 11,
              column: 14
            },
            end: {
              line: 11,
              column: 30
            }
          },
          13: {
            start: {
              line: 12,
              column: 12
            },
            end: {
              line: 12,
              column: 26
            }
          },
          14: {
            start: {
              line: 13,
              column: 20
            },
            end: {
              line: 13,
              column: 43
            }
          },
          15: {
            start: {
              line: 16,
              column: 8
            },
            end: {
              line: 16,
              column: 53
            }
          },
          16: {
            start: {
              line: 19,
              column: 8
            },
            end: {
              line: 51,
              column: 11
            }
          },
          17: {
            start: {
              line: 20,
              column: 24
            },
            end: {
              line: 20,
              column: 35
            }
          },
          18: {
            start: {
              line: 21,
              column: 40
            },
            end: {
              line: 21,
              column: 61
            }
          },
          19: {
            start: {
              line: 22,
              column: 12
            },
            end: {
              line: 35,
              column: 13
            }
          },
          20: {
            start: {
              line: 23,
              column: 16
            },
            end: {
              line: 25,
              column: 17
            }
          },
          21: {
            start: {
              line: 24,
              column: 20
            },
            end: {
              line: 24,
              column: 29
            }
          },
          22: {
            start: {
              line: 26,
              column: 28
            },
            end: {
              line: 26,
              column: 52
            }
          },
          23: {
            start: {
              line: 27,
              column: 16
            },
            end: {
              line: 34,
              column: 17
            }
          },
          24: {
            start: {
              line: 28,
              column: 20
            },
            end: {
              line: 30,
              column: 21
            }
          },
          25: {
            start: {
              line: 29,
              column: 24
            },
            end: {
              line: 29,
              column: 61
            }
          },
          26: {
            start: {
              line: 33,
              column: 20
            },
            end: {
              line: 33,
              column: 49
            }
          },
          27: {
            start: {
              line: 36,
              column: 12
            },
            end: {
              line: 39,
              column: 13
            }
          },
          28: {
            start: {
              line: 37,
              column: 34
            },
            end: {
              line: 37,
              column: 45
            }
          },
          29: {
            start: {
              line: 38,
              column: 16
            },
            end: {
              line: 38,
              column: 67
            }
          },
          30: {
            start: {
              line: 40,
              column: 12
            },
            end: {
              line: 44,
              column: 13
            }
          },
          31: {
            start: {
              line: 41,
              column: 16
            },
            end: {
              line: 43,
              column: 17
            }
          },
          32: {
            start: {
              line: 42,
              column: 20
            },
            end: {
              line: 42,
              column: 73
            }
          },
          33: {
            start: {
              line: 45,
              column: 12
            },
            end: {
              line: 49,
              column: 13
            }
          },
          34: {
            start: {
              line: 46,
              column: 16
            },
            end: {
              line: 48,
              column: 17
            }
          },
          35: {
            start: {
              line: 47,
              column: 20
            },
            end: {
              line: 47,
              column: 73
            }
          },
          36: {
            start: {
              line: 50,
              column: 12
            },
            end: {
              line: 50,
              column: 23
            }
          },
          37: {
            start: {
              line: 54,
              column: 8
            },
            end: {
              line: 54,
              column: 34
            }
          },
          38: {
            start: {
              line: 55,
              column: 8
            },
            end: {
              line: 117,
              column: 10
            }
          },
          39: {
            start: {
              line: 85,
              column: 65
            },
            end: {
              line: 88,
              column: 13
            }
          },
          40: {
            start: {
              line: 89,
              column: 65
            },
            end: {
              line: 92,
              column: 13
            }
          },
          41: {
            start: {
              line: 93,
              column: 77
            },
            end: {
              line: 96,
              column: 13
            }
          },
          42: {
            start: {
              line: 97,
              column: 77
            },
            end: {
              line: 100,
              column: 13
            }
          },
          43: {
            start: {
              line: 120,
              column: 0
            },
            end: {
              line: 120,
              column: 28
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 2,
                column: 44
              },
              end: {
                line: 2,
                column: 45
              }
            },
            loc: {
              start: {
                line: 2,
                column: 89
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 2
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 3,
                column: 36
              },
              end: {
                line: 3,
                column: 37
              }
            },
            loc: {
              start: {
                line: 3,
                column: 63
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 3
          },
          2: {
            name: "fulfilled",
            decl: {
              start: {
                line: 4,
                column: 17
              },
              end: {
                line: 4,
                column: 26
              }
            },
            loc: {
              start: {
                line: 4,
                column: 34
              },
              end: {
                line: 4,
                column: 99
              }
            },
            line: 4
          },
          3: {
            name: "rejected",
            decl: {
              start: {
                line: 5,
                column: 17
              },
              end: {
                line: 5,
                column: 25
              }
            },
            loc: {
              start: {
                line: 5,
                column: 33
              },
              end: {
                line: 5,
                column: 102
              }
            },
            line: 5
          },
          4: {
            name: "step",
            decl: {
              start: {
                line: 6,
                column: 17
              },
              end: {
                line: 6,
                column: 21
              }
            },
            loc: {
              start: {
                line: 6,
                column: 30
              },
              end: {
                line: 6,
                column: 151
              }
            },
            line: 6
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 6,
                column: 76
              },
              end: {
                line: 6,
                column: 77
              }
            },
            loc: {
              start: {
                line: 6,
                column: 95
              },
              end: {
                line: 6,
                column: 121
              }
            },
            line: 6
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 15,
                column: 4
              },
              end: {
                line: 15,
                column: 5
              }
            },
            loc: {
              start: {
                line: 15,
                column: 18
              },
              end: {
                line: 17,
                column: 5
              }
            },
            line: 15
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 18,
                column: 4
              },
              end: {
                line: 18,
                column: 5
              }
            },
            loc: {
              start: {
                line: 18,
                column: 18
              },
              end: {
                line: 52,
                column: 5
              }
            },
            line: 18
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 19,
                column: 47
              },
              end: {
                line: 19,
                column: 48
              }
            },
            loc: {
              start: {
                line: 19,
                column: 60
              },
              end: {
                line: 51,
                column: 9
              }
            },
            line: 19
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 53,
                column: 4
              },
              end: {
                line: 53,
                column: 5
              }
            },
            loc: {
              start: {
                line: 53,
                column: 21
              },
              end: {
                line: 118,
                column: 5
              }
            },
            line: 53
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 85,
                column: 38
              },
              end: {
                line: 85,
                column: 39
              }
            },
            loc: {
              start: {
                line: 85,
                column: 65
              },
              end: {
                line: 88,
                column: 13
              }
            },
            line: 85
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 89,
                column: 38
              },
              end: {
                line: 89,
                column: 39
              }
            },
            loc: {
              start: {
                line: 89,
                column: 65
              },
              end: {
                line: 92,
                column: 13
              }
            },
            line: 89
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 93,
                column: 50
              },
              end: {
                line: 93,
                column: 51
              }
            },
            loc: {
              start: {
                line: 93,
                column: 77
              },
              end: {
                line: 96,
                column: 13
              }
            },
            line: 93
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 97,
                column: 50
              },
              end: {
                line: 97,
                column: 51
              }
            },
            loc: {
              start: {
                line: 97,
                column: 77
              },
              end: {
                line: 100,
                column: 13
              }
            },
            line: 97
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 2,
                column: 16
              },
              end: {
                line: 9,
                column: 1
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 2,
                column: 17
              },
              end: {
                line: 2,
                column: 21
              }
            }, {
              start: {
                line: 2,
                column: 25
              },
              end: {
                line: 2,
                column: 39
              }
            }, {
              start: {
                line: 2,
                column: 44
              },
              end: {
                line: 9,
                column: 1
              }
            }],
            line: 2
          },
          1: {
            loc: {
              start: {
                line: 3,
                column: 16
              },
              end: {
                line: 3,
                column: 34
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 3,
                column: 16
              },
              end: {
                line: 3,
                column: 17
              }
            }, {
              start: {
                line: 3,
                column: 22
              },
              end: {
                line: 3,
                column: 33
              }
            }],
            line: 3
          },
          2: {
            loc: {
              start: {
                line: 6,
                column: 32
              },
              end: {
                line: 6,
                column: 148
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 6,
                column: 46
              },
              end: {
                line: 6,
                column: 67
              }
            }, {
              start: {
                line: 6,
                column: 70
              },
              end: {
                line: 6,
                column: 148
              }
            }],
            line: 6
          },
          3: {
            loc: {
              start: {
                line: 7,
                column: 51
              },
              end: {
                line: 7,
                column: 67
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 7,
                column: 51
              },
              end: {
                line: 7,
                column: 61
              }
            }, {
              start: {
                line: 7,
                column: 65
              },
              end: {
                line: 7,
                column: 67
              }
            }],
            line: 7
          },
          4: {
            loc: {
              start: {
                line: 23,
                column: 16
              },
              end: {
                line: 25,
                column: 17
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 23,
                column: 16
              },
              end: {
                line: 25,
                column: 17
              }
            }, {
              start: {
                line: 23,
                column: 16
              },
              end: {
                line: 25,
                column: 17
              }
            }],
            line: 23
          },
          5: {
            loc: {
              start: {
                line: 27,
                column: 16
              },
              end: {
                line: 34,
                column: 17
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 27,
                column: 16
              },
              end: {
                line: 34,
                column: 17
              }
            }, {
              start: {
                line: 27,
                column: 16
              },
              end: {
                line: 34,
                column: 17
              }
            }],
            line: 27
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0
        },
        b: {
          0: [0, 0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/export/packer/next-compiler.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\export\\packer\\next-compiler.ts"],
          names: [],
          mappings: ";;;;;;;;;;AAAA,+BAA+B;AAC/B,2BAA2B;AAG3B,4CAAyC;AAwBzC;IAGI;QACI,IAAI,CAAC,SAAS,GAAG,IAAI,qBAAS,EAAE,CAAC;IACrC,CAAC;IAEY,OAAO,CAAC,IAAU;;YAC3B,MAAM,GAAG,GAAG,IAAI,KAAK,EAAE,CAAC;YAExB,MAAM,mBAAmB,GAAG,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,CAAC;YAElD,KAAK,MAAM,GAAG,IAAI,mBAAmB,EAAE;gBACnC,IAAI,CAAC,mBAAmB,CAAC,GAAG,CAAC,EAAE;oBAC3B,SAAS;iBACZ;gBAED,MAAM,GAAG,GAAG,mBAAmB,CAAC,GAAG,CAAoC,CAAC;gBAExE,IAAI,KAAK,CAAC,OAAO,CAAC,GAAG,CAAC,EAAE;oBACpB,KAAK,MAAM,OAAO,IAAI,GAAG,EAAE;wBACvB,GAAG,CAAC,IAAI,CAAC,OAAO,CAAC,IAAI,EAAE,OAAO,CAAC,IAAI,CAAC,CAAC;qBACxC;iBACJ;qBAAM;oBACH,GAAG,CAAC,IAAI,CAAC,GAAG,CAAC,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,CAAC;iBAChC;aACJ;YAED,KAAK,MAAM,IAAI,IAAI,IAAI,CAAC,KAAK,CAAC,KAAK,EAAE;gBACjC,MAAM,SAAS,GAAG,IAAI,CAAC,MAAM,CAAC;gBAC9B,GAAG,CAAC,IAAI,CAAC,cAAc,IAAI,CAAC,QAAQ,EAAE,EAAE,SAAS,CAAC,CAAC;aACtD;YAED,KAAK,MAAM,MAAM,IAAI,IAAI,CAAC,OAAO,EAAE;gBAC/B,KAAK,MAAM,IAAI,IAAI,MAAM,CAAC,KAAK,CAAC,KAAK,EAAE;oBACnC,GAAG,CAAC,IAAI,CAAC,cAAc,IAAI,CAAC,QAAQ,EAAE,EAAE,IAAI,CAAC,MAAM,CAAC,CAAC;iBACxD;aACJ;YAED,KAAK,MAAM,MAAM,IAAI,IAAI,CAAC,OAAO,EAAE;gBAC/B,KAAK,MAAM,IAAI,IAAI,MAAM,CAAC,KAAK,CAAC,KAAK,EAAE;oBACnC,GAAG,CAAC,IAAI,CAAC,cAAc,IAAI,CAAC,QAAQ,EAAE,EAAE,IAAI,CAAC,MAAM,CAAC,CAAC;iBACxD;aACJ;YAED,OAAO,GAAG,CAAC;QACf,CAAC;KAAA;IAEO,UAAU,CAAC,IAAU;QACzB,IAAI,CAAC,kBAAkB,EAAE,CAAC;QAC1B,OAAO;YACH,QAAQ,EAAE;gBACN,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,QAAQ,CAAC,EAAE,IAAI,CAAC;gBACrD,IAAI,EAAE,mBAAmB;aAC5B;YACD,MAAM,EAAE;gBACJ,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC;gBAC7C,IAAI,EAAE,iBAAiB;aAC1B;YACD,UAAU,EAAE;gBACR,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,cAAc,CAAC,EAAE;oBAClD,WAAW,EAAE;wBACT,UAAU,EAAE,KAAK;wBACjB,QAAQ,EAAE,OAAO;qBACpB;iBACJ,CAAC;gBACF,IAAI,EAAE,mBAAmB;aAC5B;YACD,SAAS,EAAE;gBACP,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;gBAChD,IAAI,EAAE,oBAAoB;aAC7B;YACD,aAAa,EAAE;gBACX,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,qBAAqB,CAAC,CAAC;gBAC5D,IAAI,EAAE,8BAA8B;aACvC;YACD,iBAAiB,EAAE;gBACf,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,iBAAiB,CAAC,CAAC;gBACxD,IAAI,EAAE,aAAa;aACtB;YACD,OAAO,EAAE,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,aAAa,EAAE,KAAK,EAAE,EAAE,CAAC,CAAC;gBACjD,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,aAAa,CAAC,MAAM,CAAC,CAAC;gBACtD,IAAI,EAAE,cAAc,KAAK,GAAG,CAAC,MAAM;aACtC,CAAC,CAAC;YACH,OAAO,EAAE,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,aAAa,EAAE,KAAK,EAAE,EAAE,CAAC,CAAC;gBACjD,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,aAAa,CAAC,MAAM,CAAC,CAAC;gBACtD,IAAI,EAAE,cAAc,KAAK,GAAG,CAAC,MAAM;aACtC,CAAC,CAAC;YACH,mBAAmB,EAAE,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,aAAa,EAAE,KAAK,EAAE,EAAE,CAAC,CAAC;gBAC7D,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,aAAa,CAAC,aAAa,CAAC,CAAC;gBAC7D,IAAI,EAAE,oBAAoB,KAAK,GAAG,CAAC,WAAW;aACjD,CAAC,CAAC;YACH,mBAAmB,EAAE,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,CAAC,aAAa,EAAE,KAAK,EAAE,EAAE,CAAC,CAAC;gBAC7D,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,aAAa,CAAC,aAAa,CAAC,CAAC;gBAC7D,IAAI,EAAE,oBAAoB,KAAK,GAAG,CAAC,WAAW;aACjD,CAAC,CAAC;YACH,YAAY,EAAE;gBACV,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,YAAY,CAAC,CAAC;gBACnD,IAAI,EAAE,qBAAqB;aAC9B;YACD,aAAa,EAAE;gBACX,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,aAAa,CAAC,CAAC;gBACpD,IAAI,EAAE,kBAAkB;aAC3B;YACD,SAAS,EAAE;gBACP,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC;gBAChD,IAAI,EAAE,oBAAoB;aAC7B;YACD,QAAQ,EAAE;gBACN,IAAI,EAAE,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,MAAM,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;gBAC/C,IAAI,EAAE,mBAAmB;aAC5B;SACJ,CAAC;IACN,CAAC;CAUJ;AA3HD,4BA2HC",
          sourcesContent: ['import * as JSZip from "jszip";\r\nimport * as xml from "xml";\r\n\r\nimport { File } from "file";\r\nimport { Formatter } from "../formatter";\r\n\r\ninterface IXmlifyedFile {\r\n    readonly data: string;\r\n    readonly path: string;\r\n}\r\n\r\ninterface IXmlifyedFileMapping {\r\n    readonly Document: IXmlifyedFile;\r\n    readonly Styles: IXmlifyedFile;\r\n    readonly Properties: IXmlifyedFile;\r\n    readonly Numbering: IXmlifyedFile;\r\n    readonly Relationships: IXmlifyedFile;\r\n    readonly FileRelationships: IXmlifyedFile;\r\n    readonly Headers: IXmlifyedFile[];\r\n    readonly Footers: IXmlifyedFile[];\r\n    readonly HeaderRelationships: IXmlifyedFile[];\r\n    readonly FooterRelationships: IXmlifyedFile[];\r\n    readonly ContentTypes: IXmlifyedFile;\r\n    readonly AppProperties: IXmlifyedFile;\r\n    readonly FootNotes: IXmlifyedFile;\r\n    readonly Settings: IXmlifyedFile;\r\n}\r\n\r\nexport class Compiler {\r\n    private readonly formatter: Formatter;\r\n\r\n    constructor() {\r\n        this.formatter = new Formatter();\r\n    }\r\n\r\n    public async compile(file: File): Promise<JSZip> {\r\n        const zip = new JSZip();\r\n\r\n        const xmlifiedFileMapping = this.xmlifyFile(file);\r\n\r\n        for (const key in xmlifiedFileMapping) {\r\n            if (!xmlifiedFileMapping[key]) {\r\n                continue;\r\n            }\r\n\r\n            const obj = xmlifiedFileMapping[key] as IXmlifyedFile | IXmlifyedFile[];\r\n\r\n            if (Array.isArray(obj)) {\r\n                for (const subFile of obj) {\r\n                    zip.file(subFile.path, subFile.data);\r\n                }\r\n            } else {\r\n                zip.file(obj.path, obj.data);\r\n            }\r\n        }\r\n\r\n        for (const data of file.Media.Array) {\r\n            const mediaData = data.stream;\r\n            zip.file(`word/media/${data.fileName}`, mediaData);\r\n        }\r\n\r\n        for (const header of file.Headers) {\r\n            for (const data of header.Media.Array) {\r\n                zip.file(`word/media/${data.fileName}`, data.stream);\r\n            }\r\n        }\r\n\r\n        for (const footer of file.Footers) {\r\n            for (const data of footer.Media.Array) {\r\n                zip.file(`word/media/${data.fileName}`, data.stream);\r\n            }\r\n        }\r\n\r\n        return zip;\r\n    }\r\n\r\n    private xmlifyFile(file: File): IXmlifyedFileMapping {\r\n        file.verifyUpdateFields();\r\n        return {\r\n            Document: {\r\n                data: xml(this.formatter.format(file.Document), true),\r\n                path: "word/document.xml",\r\n            },\r\n            Styles: {\r\n                data: xml(this.formatter.format(file.Styles)),\r\n                path: "word/styles.xml",\r\n            },\r\n            Properties: {\r\n                data: xml(this.formatter.format(file.CoreProperties), {\r\n                    declaration: {\r\n                        standalone: "yes",\r\n                        encoding: "UTF-8",\r\n                    },\r\n                }),\r\n                path: "docProps/core.xml",\r\n            },\r\n            Numbering: {\r\n                data: xml(this.formatter.format(file.Numbering)),\r\n                path: "word/numbering.xml",\r\n            },\r\n            Relationships: {\r\n                data: xml(this.formatter.format(file.DocumentRelationships)),\r\n                path: "word/_rels/document.xml.rels",\r\n            },\r\n            FileRelationships: {\r\n                data: xml(this.formatter.format(file.FileRelationships)),\r\n                path: "_rels/.rels",\r\n            },\r\n            Headers: file.Headers.map((headerWrapper, index) => ({\r\n                data: xml(this.formatter.format(headerWrapper.Header)),\r\n                path: `word/header${index + 1}.xml`,\r\n            })),\r\n            Footers: file.Footers.map((footerWrapper, index) => ({\r\n                data: xml(this.formatter.format(footerWrapper.Footer)),\r\n                path: `word/footer${index + 1}.xml`,\r\n            })),\r\n            HeaderRelationships: file.Headers.map((headerWrapper, index) => ({\r\n                data: xml(this.formatter.format(headerWrapper.Relationships)),\r\n                path: `word/_rels/header${index + 1}.xml.rels`,\r\n            })),\r\n            FooterRelationships: file.Footers.map((footerWrapper, index) => ({\r\n                data: xml(this.formatter.format(footerWrapper.Relationships)),\r\n                path: `word/_rels/footer${index + 1}.xml.rels`,\r\n            })),\r\n            ContentTypes: {\r\n                data: xml(this.formatter.format(file.ContentTypes)),\r\n                path: "[Content_Types].xml",\r\n            },\r\n            AppProperties: {\r\n                data: xml(this.formatter.format(file.AppProperties)),\r\n                path: "docProps/app.xml",\r\n            },\r\n            FootNotes: {\r\n                data: xml(this.formatter.format(file.FootNotes)),\r\n                path: "word/footnotes.xml",\r\n            },\r\n            Settings: {\r\n                data: xml(this.formatter.format(file.Settings)),\r\n                path: "word/settings.xml",\r\n            },\r\n        };\r\n    }\r\n\r\n    /* By default docx collapse empty tags. <a></a> -> <a/>. this function mimic it\r\n       so comparing (diff) original docx file and the library output is easier\r\n       Currently not used, so commenting out */\r\n    // private collapseEmptyTags(xmlData: string): string {\r\n    //     const regEx = /<(([^ <>]+)[^<>]*)><\\/\\2>/g;\r\n    //     const collapsed = xmlData.replace(regEx, "<$1/>");\r\n    //     return collapsed;\r\n    // }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s)),
          c = (a.s[0]++, a.b[0][0]++, this && (a.b[0][1]++, this.__awaiter) || (a.b[0][2]++, function (e, n, t, r) {
        return a.f[0]++, a.s[1]++, new (a.b[1][0]++, t || (a.b[1][1]++, t = Promise))(function (o, i) {
          function A(e) {
            a.f[2]++, a.s[2]++;

            try {
              a.s[3]++, l(r.next(e));
            } catch (e) {
              a.s[4]++, i(e);
            }
          }

          function s(e) {
            a.f[3]++, a.s[5]++;

            try {
              a.s[6]++, l(r.throw(e));
            } catch (e) {
              a.s[7]++, i(e);
            }
          }

          function l(e) {
            a.f[4]++, a.s[8]++, e.done ? (a.b[2][0]++, o(e.value)) : (a.b[2][1]++, new t(function (n) {
              a.f[5]++, a.s[9]++, n(e.value);
            }).then(A, s));
          }

          a.f[1]++, a.s[10]++, l((r = r.apply(e, (a.b[3][0]++, n || (a.b[3][1]++, [])))).next());
        });
      }));
      a.s[11]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var u = (a.s[12]++, t(107)),
          p = (a.s[13]++, t(335)),
          m = (a.s[14]++, t(337));
      a.s[43]++, n.Compiler =
      /*#__PURE__*/
      function () {
        function _class50() {
          _classCallCheck(this, _class50);

          a.f[6]++, a.s[15]++, this.formatter = new m.Formatter();
        }

        _createClass(_class50, [{
          key: "compile",
          value: function compile(e) {
            return a.f[7]++, a.s[16]++, c(this, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee4() {
              var n, t, _e11, _r3, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _e12, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _t9, _e13, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, _t10, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _e14, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _t11, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, _e15;

              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      a.f[8]++;
                      n = (a.s[17]++, new u()), t = (a.s[18]++, this.xmlifyFile(e));
                      a.s[19]++;
                      _context4.t0 = _regeneratorRuntime.keys(t);

                    case 4:
                      if ((_context4.t1 = _context4.t0()).done) {
                        _context4.next = 37;
                        break;
                      }

                      _e11 = _context4.t1.value;

                      if (!(a.s[20]++, !t[_e11])) {
                        _context4.next = 9;
                        break;
                      }

                      a.b[4][0]++, a.s[21]++;
                      return _context4.abrupt("continue", 4);

                    case 9:
                      a.b[4][1]++;
                      _r3 = (a.s[22]++, t[_e11]);

                      if (!(a.s[23]++, Array.isArray(_r3))) {
                        _context4.next = 34;
                        break;
                      }

                      a.b[5][0]++, a.s[24]++;
                      _iteratorNormalCompletion8 = true;
                      _didIteratorError8 = false;
                      _iteratorError8 = undefined;
                      _context4.prev = 16;

                      for (_iterator8 = _r3[Symbol.iterator](); !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        _e12 = _step8.value;
                        a.s[25]++, n.file(_e12.path, _e12.data);
                      }

                      _context4.next = 24;
                      break;

                    case 20:
                      _context4.prev = 20;
                      _context4.t2 = _context4["catch"](16);
                      _didIteratorError8 = true;
                      _iteratorError8 = _context4.t2;

                    case 24:
                      _context4.prev = 24;
                      _context4.prev = 25;

                      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                        _iterator8.return();
                      }

                    case 27:
                      _context4.prev = 27;

                      if (!_didIteratorError8) {
                        _context4.next = 30;
                        break;
                      }

                      throw _iteratorError8;

                    case 30:
                      return _context4.finish(27);

                    case 31:
                      return _context4.finish(24);

                    case 32:
                      _context4.next = 35;
                      break;

                    case 34:
                      a.b[5][1]++, a.s[26]++, n.file(_r3.path, _r3.data);

                    case 35:
                      _context4.next = 4;
                      break;

                    case 37:
                      a.s[27]++;
                      _iteratorNormalCompletion9 = true;
                      _didIteratorError9 = false;
                      _iteratorError9 = undefined;
                      _context4.prev = 41;

                      for (_iterator9 = e.Media.Array[Symbol.iterator](); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                        _t9 = _step9.value;
                        _e13 = (a.s[28]++, _t9.stream);
                        a.s[29]++, n.file("word/media/".concat(_t9.fileName), _e13);
                      }

                      _context4.next = 49;
                      break;

                    case 45:
                      _context4.prev = 45;
                      _context4.t3 = _context4["catch"](41);
                      _didIteratorError9 = true;
                      _iteratorError9 = _context4.t3;

                    case 49:
                      _context4.prev = 49;
                      _context4.prev = 50;

                      if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                        _iterator9.return();
                      }

                    case 52:
                      _context4.prev = 52;

                      if (!_didIteratorError9) {
                        _context4.next = 55;
                        break;
                      }

                      throw _iteratorError9;

                    case 55:
                      return _context4.finish(52);

                    case 56:
                      return _context4.finish(49);

                    case 57:
                      a.s[30]++;
                      _iteratorNormalCompletion10 = true;
                      _didIteratorError10 = false;
                      _iteratorError10 = undefined;
                      _context4.prev = 61;
                      _iterator10 = e.Headers[Symbol.iterator]();

                    case 63:
                      if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                        _context4.next = 88;
                        break;
                      }

                      _t10 = _step10.value;
                      a.s[31]++;
                      _iteratorNormalCompletion12 = true;
                      _didIteratorError12 = false;
                      _iteratorError12 = undefined;
                      _context4.prev = 69;

                      for (_iterator12 = _t10.Media.Array[Symbol.iterator](); !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                        _e14 = _step12.value;
                        a.s[32]++, n.file("word/media/".concat(_e14.fileName), _e14.stream);
                      }

                      _context4.next = 77;
                      break;

                    case 73:
                      _context4.prev = 73;
                      _context4.t4 = _context4["catch"](69);
                      _didIteratorError12 = true;
                      _iteratorError12 = _context4.t4;

                    case 77:
                      _context4.prev = 77;
                      _context4.prev = 78;

                      if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                        _iterator12.return();
                      }

                    case 80:
                      _context4.prev = 80;

                      if (!_didIteratorError12) {
                        _context4.next = 83;
                        break;
                      }

                      throw _iteratorError12;

                    case 83:
                      return _context4.finish(80);

                    case 84:
                      return _context4.finish(77);

                    case 85:
                      _iteratorNormalCompletion10 = true;
                      _context4.next = 63;
                      break;

                    case 88:
                      _context4.next = 94;
                      break;

                    case 90:
                      _context4.prev = 90;
                      _context4.t5 = _context4["catch"](61);
                      _didIteratorError10 = true;
                      _iteratorError10 = _context4.t5;

                    case 94:
                      _context4.prev = 94;
                      _context4.prev = 95;

                      if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                        _iterator10.return();
                      }

                    case 97:
                      _context4.prev = 97;

                      if (!_didIteratorError10) {
                        _context4.next = 100;
                        break;
                      }

                      throw _iteratorError10;

                    case 100:
                      return _context4.finish(97);

                    case 101:
                      return _context4.finish(94);

                    case 102:
                      a.s[33]++;
                      _iteratorNormalCompletion11 = true;
                      _didIteratorError11 = false;
                      _iteratorError11 = undefined;
                      _context4.prev = 106;
                      _iterator11 = e.Footers[Symbol.iterator]();

                    case 108:
                      if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                        _context4.next = 133;
                        break;
                      }

                      _t11 = _step11.value;
                      a.s[34]++;
                      _iteratorNormalCompletion13 = true;
                      _didIteratorError13 = false;
                      _iteratorError13 = undefined;
                      _context4.prev = 114;

                      for (_iterator13 = _t11.Media.Array[Symbol.iterator](); !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                        _e15 = _step13.value;
                        a.s[35]++, n.file("word/media/".concat(_e15.fileName), _e15.stream);
                      }

                      _context4.next = 122;
                      break;

                    case 118:
                      _context4.prev = 118;
                      _context4.t6 = _context4["catch"](114);
                      _didIteratorError13 = true;
                      _iteratorError13 = _context4.t6;

                    case 122:
                      _context4.prev = 122;
                      _context4.prev = 123;

                      if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
                        _iterator13.return();
                      }

                    case 125:
                      _context4.prev = 125;

                      if (!_didIteratorError13) {
                        _context4.next = 128;
                        break;
                      }

                      throw _iteratorError13;

                    case 128:
                      return _context4.finish(125);

                    case 129:
                      return _context4.finish(122);

                    case 130:
                      _iteratorNormalCompletion11 = true;
                      _context4.next = 108;
                      break;

                    case 133:
                      _context4.next = 139;
                      break;

                    case 135:
                      _context4.prev = 135;
                      _context4.t7 = _context4["catch"](106);
                      _didIteratorError11 = true;
                      _iteratorError11 = _context4.t7;

                    case 139:
                      _context4.prev = 139;
                      _context4.prev = 140;

                      if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                        _iterator11.return();
                      }

                    case 142:
                      _context4.prev = 142;

                      if (!_didIteratorError11) {
                        _context4.next = 145;
                        break;
                      }

                      throw _iteratorError11;

                    case 145:
                      return _context4.finish(142);

                    case 146:
                      return _context4.finish(139);

                    case 147:
                      return _context4.abrupt("return", (a.s[36]++, n));

                    case 148:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this, [[16, 20, 24, 32], [25,, 27, 31], [41, 45, 49, 57], [50,, 52, 56], [61, 90, 94, 102], [69, 73, 77, 85], [78,, 80, 84], [95,, 97, 101], [106, 135, 139, 147], [114, 118, 122, 130], [123,, 125, 129], [140,, 142, 146]]);
            }));
          }
        }, {
          key: "xmlifyFile",
          value: function xmlifyFile(e) {
            var _this317 = this;

            return a.f[9]++, a.s[37]++, e.verifyUpdateFields(), a.s[38]++, {
              Document: {
                data: p(this.formatter.format(e.Document), !0),
                path: "word/document.xml"
              },
              Styles: {
                data: p(this.formatter.format(e.Styles)),
                path: "word/styles.xml"
              },
              Properties: {
                data: p(this.formatter.format(e.CoreProperties), {
                  declaration: {
                    standalone: "yes",
                    encoding: "UTF-8"
                  }
                }),
                path: "docProps/core.xml"
              },
              Numbering: {
                data: p(this.formatter.format(e.Numbering)),
                path: "word/numbering.xml"
              },
              Relationships: {
                data: p(this.formatter.format(e.DocumentRelationships)),
                path: "word/_rels/document.xml.rels"
              },
              FileRelationships: {
                data: p(this.formatter.format(e.FileRelationships)),
                path: "_rels/.rels"
              },
              Headers: e.Headers.map(function (e, n) {
                return a.f[10]++, a.s[39]++, {
                  data: p(_this317.formatter.format(e.Header)),
                  path: "word/header".concat(n + 1, ".xml")
                };
              }),
              Footers: e.Footers.map(function (e, n) {
                return a.f[11]++, a.s[40]++, {
                  data: p(_this317.formatter.format(e.Footer)),
                  path: "word/footer".concat(n + 1, ".xml")
                };
              }),
              HeaderRelationships: e.Headers.map(function (e, n) {
                return a.f[12]++, a.s[41]++, {
                  data: p(_this317.formatter.format(e.Relationships)),
                  path: "word/_rels/header".concat(n + 1, ".xml.rels")
                };
              }),
              FooterRelationships: e.Footers.map(function (e, n) {
                return a.f[13]++, a.s[42]++, {
                  data: p(_this317.formatter.format(e.Relationships)),
                  path: "word/_rels/footer".concat(n + 1, ".xml.rels")
                };
              }),
              ContentTypes: {
                data: p(this.formatter.format(e.ContentTypes)),
                path: "[Content_Types].xml"
              },
              AppProperties: {
                data: p(this.formatter.format(e.AppProperties)),
                path: "docProps/app.xml"
              },
              FootNotes: {
                data: p(this.formatter.format(e.FootNotes)),
                path: "word/footnotes.xml"
              },
              Settings: {
                data: p(this.formatter.format(e.Settings)),
                path: "word/settings.xml"
              }
            };
          }
        }]);

        return _class50;
      }();
    }, function (e, n, t) {
      "use strict";

      var r = t(12),
          o = t(1),
          i = t(3),
          A = t(114),
          s = t(115),
          l = t(47),
          a = t(316),
          c = t(317),
          u = t(24),
          p = t(329),
          m = function m(e, n, t) {
        var r,
            A = o.getTypeOf(n),
            c = o.extend(t || {}, s);
        c.date = c.date || new Date(), null !== c.compression && (c.compression = c.compression.toUpperCase()), "string" == typeof c.unixPermissions && (c.unixPermissions = parseInt(c.unixPermissions, 8)), c.unixPermissions && 16384 & c.unixPermissions && (c.dir = !0), c.dosPermissions && 16 & c.dosPermissions && (c.dir = !0), c.dir && (e = d(e)), c.createFolders && (r = C(e)) && f.call(this, r, !0);
        var m = "string" === A && !1 === c.binary && !1 === c.base64;
        t && void 0 !== t.binary || (c.binary = !m), (n instanceof l && 0 === n.uncompressedSize || c.dir || !n || 0 === n.length) && (c.base64 = !1, c.binary = !0, n = "", c.compression = "STORE", A = "string");
        var h = null;
        h = n instanceof l || n instanceof i ? n : u.isNode && u.isStream(n) ? new p(e, n) : o.prepareContent(e, n, c.binary, c.optimizedBinaryString, c.base64);
        var x = new a(e, h, c);
        this.files[e] = x;
      },
          C = function C(e) {
        "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
        var n = e.lastIndexOf("/");
        return n > 0 ? e.substring(0, n) : "";
      },
          d = function d(e) {
        return "/" !== e.slice(-1) && (e += "/"), e;
      },
          f = function f(e, n) {
        return n = void 0 !== n ? n : s.createFolders, e = d(e), this.files[e] || m.call(this, e, null, {
          dir: !0,
          createFolders: n
        }), this.files[e];
      };

      function h(e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      }

      var x = {
        load: function load() {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        },
        forEach: function forEach(e) {
          var n, t, r;

          for (n in this.files) {
            this.files.hasOwnProperty(n) && (r = this.files[n], (t = n.slice(this.root.length, n.length)) && n.slice(0, this.root.length) === this.root && e(t, r));
          }
        },
        filter: function filter(e) {
          var n = [];
          return this.forEach(function (t, r) {
            e(t, r) && n.push(r);
          }), n;
        },
        file: function file(e, n, t) {
          if (1 === arguments.length) {
            if (h(e)) {
              var r = e;
              return this.filter(function (e, n) {
                return !n.dir && r.test(e);
              });
            }

            var o = this.files[this.root + e];
            return o && !o.dir ? o : null;
          }

          return e = this.root + e, m.call(this, e, n, t), this;
        },
        folder: function folder(e) {
          if (!e) return this;
          if (h(e)) return this.filter(function (n, t) {
            return t.dir && e.test(n);
          });
          var n = this.root + e,
              t = f.call(this, n),
              r = this.clone();
          return r.root = t.name, r;
        },
        remove: function remove(e) {
          e = this.root + e;
          var n = this.files[e];
          if (n || ("/" !== e.slice(-1) && (e += "/"), n = this.files[e]), n && !n.dir) delete this.files[e];else for (var t = this.filter(function (n, t) {
            return t.name.slice(0, e.length) === e;
          }), r = 0; r < t.length; r++) {
            delete this.files[t[r].name];
          }
          return this;
        },
        generate: function generate(e) {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        },
        generateInternalStream: function generateInternalStream(e) {
          var n,
              t = {};

          try {
            if ((t = o.extend(e || {}, {
              streamFiles: !1,
              compression: "STORE",
              compressionOptions: null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: "application/zip",
              encodeFileName: r.utf8encode
            })).type = t.type.toLowerCase(), t.compression = t.compression.toUpperCase(), "binarystring" === t.type && (t.type = "string"), !t.type) throw new Error("No output type specified.");
            o.checkSupport(t.type), "darwin" !== t.platform && "freebsd" !== t.platform && "linux" !== t.platform && "sunos" !== t.platform || (t.platform = "UNIX"), "win32" === t.platform && (t.platform = "DOS");
            var s = t.comment || this.comment || "";
            n = c.generateWorker(this, t, s);
          } catch (e) {
            (n = new i("error")).error(e);
          }

          return new A(n, t.type || "string", t.mimeType);
        },
        generateAsync: function generateAsync(e, n) {
          return this.generateInternalStream(e).accumulate(n);
        },
        generateNodeStream: function generateNodeStream(e, n) {
          return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(n);
        }
      };
      e.exports = x;
    }, function (e, n, t) {
      t(299), e.exports = t(110).setImmediate;
    }, function (e, n, t) {
      var r = t(300),
          o = t(308);
      r(r.G + r.B, {
        setImmediate: o.set,
        clearImmediate: o.clear
      });
    }, function (e, n, t) {
      var r = t(25),
          o = t(110),
          i = t(111),
          A = t(302),
          s = function s(e, n, t) {
        var l,
            a,
            c,
            u = e & s.F,
            p = e & s.G,
            m = e & s.S,
            C = e & s.P,
            d = e & s.B,
            f = e & s.W,
            h = p ? o : o[n] || (o[n] = {}),
            x = h.prototype,
            g = p ? r : m ? r[n] : (r[n] || {}).prototype;

        for (l in p && (t = n), t) {
          (a = !u && g && void 0 !== g[l]) && l in h || (c = a ? g[l] : t[l], h[l] = p && "function" != typeof g[l] ? t[l] : d && a ? i(c, r) : f && g[l] == c ? function (e) {
            var n = function n(_n8, t, r) {
              if (this instanceof e) {
                switch (arguments.length) {
                  case 0:
                    return new e();

                  case 1:
                    return new e(_n8);

                  case 2:
                    return new e(_n8, t);
                }

                return new e(_n8, t, r);
              }

              return e.apply(this, arguments);
            };

            return n.prototype = e.prototype, n;
          }(c) : C && "function" == typeof c ? i(Function.call, c) : c, C && ((h.virtual || (h.virtual = {}))[l] = c, e & s.R && x && !x[l] && A(x, l, c)));
        }
      };

      s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, e.exports = s;
    }, function (e, n) {
      e.exports = function (e) {
        if ("function" != typeof e) throw TypeError(e + " is not a function!");
        return e;
      };
    }, function (e, n, t) {
      var r = t(303),
          o = t(307);
      e.exports = t(46) ? function (e, n, t) {
        return r.f(e, n, o(1, t));
      } : function (e, n, t) {
        return e[n] = t, e;
      };
    }, function (e, n, t) {
      var r = t(304),
          o = t(305),
          i = t(306),
          A = Object.defineProperty;
      n.f = t(46) ? Object.defineProperty : function (e, n, t) {
        if (r(e), n = i(n, !0), r(t), o) try {
          return A(e, n, t);
        } catch (e) {}
        if ("get" in t || "set" in t) throw TypeError("Accessors not supported!");
        return "value" in t && (e[n] = t.value), e;
      };
    }, function (e, n, t) {
      var r = t(45);

      e.exports = function (e) {
        if (!r(e)) throw TypeError(e + " is not an object!");
        return e;
      };
    }, function (e, n, t) {
      e.exports = !t(46) && !t(112)(function () {
        return 7 != Object.defineProperty(t(113)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, n, t) {
      var r = t(45);

      e.exports = function (e, n) {
        if (!r(e)) return e;
        var t, o;
        if (n && "function" == typeof (t = e.toString) && !r(o = t.call(e))) return o;
        if ("function" == typeof (t = e.valueOf) && !r(o = t.call(e))) return o;
        if (!n && "function" == typeof (t = e.toString) && !r(o = t.call(e))) return o;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (e, n) {
      e.exports = function (e, n) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: n
        };
      };
    }, function (e, n, t) {
      var r,
          o,
          i,
          A = t(111),
          s = t(309),
          l = t(310),
          a = t(113),
          c = t(25),
          u = c.process,
          p = c.setImmediate,
          m = c.clearImmediate,
          C = c.MessageChannel,
          d = 0,
          f = {},
          h = function h() {
        var e = +this;

        if (f.hasOwnProperty(e)) {
          var n = f[e];
          delete f[e], n();
        }
      },
          x = function x(e) {
        h.call(e.data);
      };

      p && m || (p = function p(e) {
        for (var n = [], t = 1; arguments.length > t;) {
          n.push(arguments[t++]);
        }

        return f[++d] = function () {
          s("function" == typeof e ? e : Function(e), n);
        }, r(d), d;
      }, m = function m(e) {
        delete f[e];
      }, "process" == t(311)(u) ? r = function r(e) {
        u.nextTick(A(h, e, 1));
      } : C ? (i = (o = new C()).port2, o.port1.onmessage = x, r = A(i.postMessage, i, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (r = function r(e) {
        c.postMessage(e + "", "*");
      }, c.addEventListener("message", x, !1)) : r = "onreadystatechange" in a("script") ? function (e) {
        l.appendChild(a("script")).onreadystatechange = function () {
          l.removeChild(this), h.call(e);
        };
      } : function (e) {
        setTimeout(A(h, e, 1), 0);
      }), e.exports = {
        set: p,
        clear: m
      };
    }, function (e, n) {
      e.exports = function (e, n, t) {
        var r = void 0 === t;

        switch (n.length) {
          case 0:
            return r ? e() : e.call(t);

          case 1:
            return r ? e(n[0]) : e.call(t, n[0]);

          case 2:
            return r ? e(n[0], n[1]) : e.call(t, n[0], n[1]);

          case 3:
            return r ? e(n[0], n[1], n[2]) : e.call(t, n[0], n[1], n[2]);

          case 4:
            return r ? e(n[0], n[1], n[2], n[3]) : e.call(t, n[0], n[1], n[2], n[3]);
        }

        return e.apply(t, n);
      };
    }, function (e, n, t) {
      e.exports = t(25).document && document.documentElement;
    }, function (e, n) {
      var t = {}.toString;

      e.exports = function (e) {
        return t.call(e).slice(8, -1);
      };
    }, function (e, n, t) {
      "use strict";

      var r = t(313);

      function o() {}

      var i = {},
          A = ["REJECTED"],
          s = ["FULFILLED"],
          l = ["PENDING"];

      function a(e) {
        if ("function" != typeof e) throw new TypeError("resolver must be a function");
        this.state = l, this.queue = [], this.outcome = void 0, e !== o && m(this, e);
      }

      function c(e, n, t) {
        this.promise = e, "function" == typeof n && (this.onFulfilled = n, this.callFulfilled = this.otherCallFulfilled), "function" == typeof t && (this.onRejected = t, this.callRejected = this.otherCallRejected);
      }

      function u(e, n, t) {
        r(function () {
          var r;

          try {
            r = n(t);
          } catch (n) {
            return i.reject(e, n);
          }

          r === e ? i.reject(e, new TypeError("Cannot resolve promise with itself")) : i.resolve(e, r);
        });
      }

      function p(e) {
        var n = e && e.then;
        if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof n) return function () {
          n.apply(e, arguments);
        };
      }

      function m(e, n) {
        var t = !1;

        function r(n) {
          t || (t = !0, i.reject(e, n));
        }

        function o(n) {
          t || (t = !0, i.resolve(e, n));
        }

        var A = C(function () {
          n(o, r);
        });
        "error" === A.status && r(A.value);
      }

      function C(e, n) {
        var t = {};

        try {
          t.value = e(n), t.status = "success";
        } catch (e) {
          t.status = "error", t.value = e;
        }

        return t;
      }

      e.exports = a, a.prototype.catch = function (e) {
        return this.then(null, e);
      }, a.prototype.then = function (e, n) {
        if ("function" != typeof e && this.state === s || "function" != typeof n && this.state === A) return this;
        var t = new this.constructor(o);
        return this.state !== l ? u(t, this.state === s ? e : n, this.outcome) : this.queue.push(new c(t, e, n)), t;
      }, c.prototype.callFulfilled = function (e) {
        i.resolve(this.promise, e);
      }, c.prototype.otherCallFulfilled = function (e) {
        u(this.promise, this.onFulfilled, e);
      }, c.prototype.callRejected = function (e) {
        i.reject(this.promise, e);
      }, c.prototype.otherCallRejected = function (e) {
        u(this.promise, this.onRejected, e);
      }, i.resolve = function (e, n) {
        var t = C(p, n);
        if ("error" === t.status) return i.reject(e, t.value);
        var r = t.value;
        if (r) m(e, r);else {
          e.state = s, e.outcome = n;

          for (var o = -1, A = e.queue.length; ++o < A;) {
            e.queue[o].callFulfilled(n);
          }
        }
        return e;
      }, i.reject = function (e, n) {
        e.state = A, e.outcome = n;

        for (var t = -1, r = e.queue.length; ++t < r;) {
          e.queue[t].callRejected(n);
        }

        return e;
      }, a.resolve = function (e) {
        return e instanceof this ? e : i.resolve(new this(o), e);
      }, a.reject = function (e) {
        var n = new this(o);
        return i.reject(n, e);
      }, a.all = function (e) {
        var n = this;
        if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
        var t = e.length,
            r = !1;
        if (!t) return this.resolve([]);

        for (var A = new Array(t), s = 0, l = -1, a = new this(o); ++l < t;) {
          c(e[l], l);
        }

        return a;

        function c(e, o) {
          n.resolve(e).then(function (e) {
            A[o] = e, ++s !== t || r || (r = !0, i.resolve(a, A));
          }, function (e) {
            r || (r = !0, i.reject(a, e));
          });
        }
      }, a.race = function (e) {
        var n = this;
        if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
        var t = e.length,
            r = !1;
        if (!t) return this.resolve([]);

        for (var A, s = -1, l = new this(o); ++s < t;) {
          A = e[s], n.resolve(A).then(function (e) {
            r || (r = !0, i.resolve(l, e));
          }, function (e) {
            r || (r = !0, i.reject(l, e));
          });
        }

        return l;
      };
    }, function (e, n, t) {
      "use strict";

      (function (n) {
        var t,
            r,
            o = n.MutationObserver || n.WebKitMutationObserver;

        if (o) {
          var i = 0,
              A = new o(c),
              s = n.document.createTextNode("");
          A.observe(s, {
            characterData: !0
          }), t = function t() {
            s.data = i = ++i % 2;
          };
        } else if (n.setImmediate || void 0 === n.MessageChannel) t = "document" in n && "onreadystatechange" in n.document.createElement("script") ? function () {
          var e = n.document.createElement("script");
          e.onreadystatechange = function () {
            c(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
          }, n.document.documentElement.appendChild(e);
        } : function () {
          setTimeout(c, 0);
        };else {
          var l = new n.MessageChannel();
          l.port1.onmessage = c, t = function t() {
            l.port2.postMessage(0);
          };
        }

        var a = [];

        function c() {
          var e, n;
          r = !0;

          for (var t = a.length; t;) {
            for (n = a, a = [], e = -1; ++e < t;) {
              n[e]();
            }

            t = a.length;
          }

          r = !1;
        }

        e.exports = function (e) {
          1 !== a.push(e) || r || t();
        };
      }).call(n, t(8));
    }, function (e, n, t) {
      "use strict";

      var r = t(3),
          o = t(1);

      function i(e) {
        r.call(this, "ConvertWorker to " + e), this.destType = e;
      }

      o.inherits(i, r), i.prototype.processChunk = function (e) {
        this.push({
          data: o.transformTo(this.destType, e.data),
          meta: e.meta
        });
      }, e.exports = i;
    }, function (e, n, t) {
      "use strict";

      var r = t(108).Readable;

      function o(e, n, t) {
        r.call(this, n), this._helper = e;
        var o = this;
        e.on("data", function (e, n) {
          o.push(e) || o._helper.pause(), t && t(n);
        }).on("error", function (e) {
          o.emit("error", e);
        }).on("end", function () {
          o.push(null);
        });
      }

      t(1).inherits(o, r), o.prototype._read = function () {
        this._helper.resume();
      }, e.exports = o;
    }, function (e, n, t) {
      "use strict";

      var r = t(114),
          o = t(116),
          i = t(12),
          A = t(47),
          s = t(3),
          l = function l(e, n, t) {
        this.name = e, this.dir = t.dir, this.date = t.date, this.comment = t.comment, this.unixPermissions = t.unixPermissions, this.dosPermissions = t.dosPermissions, this._data = n, this._dataBinary = t.binary, this.options = {
          compression: t.compression,
          compressionOptions: t.compressionOptions
        };
      };

      l.prototype = {
        internalStream: function internalStream(e) {
          var n = null,
              t = "string";

          try {
            if (!e) throw new Error("No output type specified.");
            var o = "string" === (t = e.toLowerCase()) || "text" === t;
            "binarystring" !== t && "text" !== t || (t = "string"), n = this._decompressWorker();
            var A = !this._dataBinary;
            A && !o && (n = n.pipe(new i.Utf8EncodeWorker())), !A && o && (n = n.pipe(new i.Utf8DecodeWorker()));
          } catch (e) {
            (n = new s("error")).error(e);
          }

          return new r(n, t, "");
        },
        async: function async(e, n) {
          return this.internalStream(e).accumulate(n);
        },
        nodeStream: function nodeStream(e, n) {
          return this.internalStream(e || "nodebuffer").toNodejsStream(n);
        },
        _compressWorker: function _compressWorker(e, n) {
          if (this._data instanceof A && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();

          var t = this._decompressWorker();

          return this._dataBinary || (t = t.pipe(new i.Utf8EncodeWorker())), A.createWorkerFrom(t, e, n);
        },
        _decompressWorker: function _decompressWorker() {
          return this._data instanceof A ? this._data.getContentWorker() : this._data instanceof s ? this._data : new o(this._data);
        }
      };

      for (var a = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], c = function c() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, u = 0; u < a.length; u++) {
        l.prototype[a[u]] = c;
      }

      e.exports = l;
    }, function (e, n, t) {
      "use strict";

      var r = t(119),
          o = t(328);

      n.generateWorker = function (e, n, t) {
        var i = new o(n.streamFiles, t, n.platform, n.encodeFileName),
            A = 0;

        try {
          e.forEach(function (e, t) {
            A++;

            var o = function (e, n) {
              var t = e || n,
                  o = r[t];
              if (!o) throw new Error(t + " is not a valid compression method !");
              return o;
            }(t.options.compression, n.compression),
                s = t.options.compressionOptions || n.compressionOptions || {},
                l = t.dir,
                a = t.date;

            t._compressWorker(o, s).withStreamInfo("file", {
              name: e,
              dir: l,
              date: a,
              comment: t.comment || "",
              unixPermissions: t.unixPermissions,
              dosPermissions: t.dosPermissions
            }).pipe(i);
          }), i.entriesCount = A;
        } catch (e) {
          i.error(e);
        }

        return i;
      };
    }, function (e, n, t) {
      "use strict";

      var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array,
          o = t(319),
          i = t(1),
          A = t(3),
          s = r ? "uint8array" : "array";

      function l(e, n) {
        A.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = n, this.meta = {};
      }

      n.magic = "\b\0", i.inherits(l, A), l.prototype.processChunk = function (e) {
        this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(i.transformTo(s, e.data), !1);
      }, l.prototype.flush = function () {
        A.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
      }, l.prototype.cleanUp = function () {
        A.prototype.cleanUp.call(this), this._pako = null;
      }, l.prototype._createPako = function () {
        this._pako = new o[this._pakoAction]({
          raw: !0,
          level: this._pakoOptions.level || -1
        });
        var e = this;

        this._pako.onData = function (n) {
          e.push({
            data: n,
            meta: e.meta
          });
        };
      }, n.compressWorker = function (e) {
        return new l("Deflate", e);
      }, n.uncompressWorker = function () {
        return new l("Inflate", {});
      };
    }, function (e, n, t) {
      "use strict";

      var r = {};
      (0, t(7).assign)(r, t(320), t(323), t(124)), e.exports = r;
    }, function (e, n, t) {
      "use strict";

      var r = t(321),
          o = t(7),
          i = t(122),
          A = t(49),
          s = t(123),
          l = Object.prototype.toString,
          a = 0,
          c = -1,
          u = 0,
          p = 8;

      function m(e) {
        if (!(this instanceof m)) return new m(e);
        this.options = o.assign({
          level: c,
          method: p,
          chunkSize: 16384,
          windowBits: 15,
          memLevel: 8,
          strategy: u,
          to: ""
        }, e || {});
        var n = this.options;
        n.raw && n.windowBits > 0 ? n.windowBits = -n.windowBits : n.gzip && n.windowBits > 0 && n.windowBits < 16 && (n.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
        var t = r.deflateInit2(this.strm, n.level, n.method, n.windowBits, n.memLevel, n.strategy);
        if (t !== a) throw new Error(A[t]);

        if (n.header && r.deflateSetHeader(this.strm, n.header), n.dictionary) {
          var C;
          if (C = "string" == typeof n.dictionary ? i.string2buf(n.dictionary) : "[object ArrayBuffer]" === l.call(n.dictionary) ? new Uint8Array(n.dictionary) : n.dictionary, (t = r.deflateSetDictionary(this.strm, C)) !== a) throw new Error(A[t]);
          this._dict_set = !0;
        }
      }

      function C(e, n) {
        var t = new m(n);
        if (t.push(e, !0), t.err) throw t.msg || A[t.err];
        return t.result;
      }

      m.prototype.push = function (e, n) {
        var t,
            A,
            s = this.strm,
            c = this.options.chunkSize;
        if (this.ended) return !1;
        A = n === ~~n ? n : !0 === n ? 4 : 0, "string" == typeof e ? s.input = i.string2buf(e) : "[object ArrayBuffer]" === l.call(e) ? s.input = new Uint8Array(e) : s.input = e, s.next_in = 0, s.avail_in = s.input.length;

        do {
          if (0 === s.avail_out && (s.output = new o.Buf8(c), s.next_out = 0, s.avail_out = c), 1 !== (t = r.deflate(s, A)) && t !== a) return this.onEnd(t), this.ended = !0, !1;
          0 !== s.avail_out && (0 !== s.avail_in || 4 !== A && 2 !== A) || ("string" === this.options.to ? this.onData(i.buf2binstring(o.shrinkBuf(s.output, s.next_out))) : this.onData(o.shrinkBuf(s.output, s.next_out)));
        } while ((s.avail_in > 0 || 0 === s.avail_out) && 1 !== t);

        return 4 === A ? (t = r.deflateEnd(this.strm), this.onEnd(t), this.ended = !0, t === a) : 2 !== A || (this.onEnd(a), s.avail_out = 0, !0);
      }, m.prototype.onData = function (e) {
        this.chunks.push(e);
      }, m.prototype.onEnd = function (e) {
        e === a && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
      }, n.Deflate = m, n.deflate = C, n.deflateRaw = function (e, n) {
        return (n = n || {}).raw = !0, C(e, n);
      }, n.gzip = function (e, n) {
        return (n = n || {}).gzip = !0, C(e, n);
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o = t(7),
          i = t(322),
          A = t(120),
          s = t(121),
          l = t(49),
          a = 0,
          c = 1,
          u = 3,
          p = 4,
          m = 5,
          C = 0,
          d = 1,
          f = -2,
          h = -3,
          x = -5,
          g = -1,
          I = 1,
          b = 2,
          y = 3,
          E = 4,
          v = 0,
          w = 2,
          B = 8,
          _ = 9,
          D = 15,
          S = 8,
          M = 286,
          O = 30,
          k = 19,
          T = 2 * M + 1,
          P = 15,
          K = 3,
          Q = 258,
          U = Q + K + 1,
          R = 32,
          G = 42,
          Y = 69,
          F = 73,
          N = 91,
          j = 103,
          W = 113,
          L = 666,
          z = 1,
          X = 2,
          H = 3,
          q = 4,
          V = 3;

      function J(e, n) {
        return e.msg = l[n], n;
      }

      function Z(e) {
        return (e << 1) - (e > 4 ? 9 : 0);
      }

      function $(e) {
        for (var n = e.length; --n >= 0;) {
          e[n] = 0;
        }
      }

      function ee(e) {
        var n = e.state,
            t = n.pending;
        t > e.avail_out && (t = e.avail_out), 0 !== t && (o.arraySet(e.output, n.pending_buf, n.pending_out, t, e.next_out), e.next_out += t, n.pending_out += t, e.total_out += t, e.avail_out -= t, n.pending -= t, 0 === n.pending && (n.pending_out = 0));
      }

      function ne(e, n) {
        i._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, n), e.block_start = e.strstart, ee(e.strm);
      }

      function te(e, n) {
        e.pending_buf[e.pending++] = n;
      }

      function re(e, n) {
        e.pending_buf[e.pending++] = n >>> 8 & 255, e.pending_buf[e.pending++] = 255 & n;
      }

      function oe(e, n) {
        var t,
            r,
            o = e.max_chain_length,
            i = e.strstart,
            A = e.prev_length,
            s = e.nice_match,
            l = e.strstart > e.w_size - U ? e.strstart - (e.w_size - U) : 0,
            a = e.window,
            c = e.w_mask,
            u = e.prev,
            p = e.strstart + Q,
            m = a[i + A - 1],
            C = a[i + A];
        e.prev_length >= e.good_match && (o >>= 2), s > e.lookahead && (s = e.lookahead);

        do {
          if (a[(t = n) + A] === C && a[t + A - 1] === m && a[t] === a[i] && a[++t] === a[i + 1]) {
            i += 2, t++;

            do {} while (a[++i] === a[++t] && a[++i] === a[++t] && a[++i] === a[++t] && a[++i] === a[++t] && a[++i] === a[++t] && a[++i] === a[++t] && a[++i] === a[++t] && a[++i] === a[++t] && i < p);

            if (r = Q - (p - i), i = p - Q, r > A) {
              if (e.match_start = n, A = r, r >= s) break;
              m = a[i + A - 1], C = a[i + A];
            }
          }
        } while ((n = u[n & c]) > l && 0 != --o);

        return A <= e.lookahead ? A : e.lookahead;
      }

      function ie(e) {
        var n,
            t,
            r,
            i,
            l,
            a,
            c,
            u,
            p,
            m,
            C = e.w_size;

        do {
          if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= C + (C - U)) {
            o.arraySet(e.window, e.window, C, C, 0), e.match_start -= C, e.strstart -= C, e.block_start -= C, n = t = e.hash_size;

            do {
              r = e.head[--n], e.head[n] = r >= C ? r - C : 0;
            } while (--t);

            n = t = C;

            do {
              r = e.prev[--n], e.prev[n] = r >= C ? r - C : 0;
            } while (--t);

            i += C;
          }

          if (0 === e.strm.avail_in) break;
          if (a = e.strm, c = e.window, u = e.strstart + e.lookahead, p = i, m = void 0, (m = a.avail_in) > p && (m = p), t = 0 === m ? 0 : (a.avail_in -= m, o.arraySet(c, a.input, a.next_in, m, u), 1 === a.state.wrap ? a.adler = A(a.adler, c, m, u) : 2 === a.state.wrap && (a.adler = s(a.adler, c, m, u)), a.next_in += m, a.total_in += m, m), e.lookahead += t, e.lookahead + e.insert >= K) for (l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + K - 1]) & e.hash_mask, e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < K));) {
            ;
          }
        } while (e.lookahead < U && 0 !== e.strm.avail_in);
      }

      function Ae(e, n) {
        for (var t, r;;) {
          if (e.lookahead < U) {
            if (ie(e), e.lookahead < U && n === a) return z;
            if (0 === e.lookahead) break;
          }

          if (t = 0, e.lookahead >= K && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + K - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== t && e.strstart - t <= e.w_size - U && (e.match_length = oe(e, t)), e.match_length >= K) {
            if (r = i._tr_tally(e, e.strstart - e.match_start, e.match_length - K), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= K) {
              e.match_length--;

              do {
                e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + K - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
              } while (0 != --e.match_length);

              e.strstart++;
            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
          } else r = i._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
          if (r && (ne(e, !1), 0 === e.strm.avail_out)) return z;
        }

        return e.insert = e.strstart < K - 1 ? e.strstart : K - 1, n === p ? (ne(e, !0), 0 === e.strm.avail_out ? H : q) : e.last_lit && (ne(e, !1), 0 === e.strm.avail_out) ? z : X;
      }

      function se(e, n) {
        for (var t, r, o;;) {
          if (e.lookahead < U) {
            if (ie(e), e.lookahead < U && n === a) return z;
            if (0 === e.lookahead) break;
          }

          if (t = 0, e.lookahead >= K && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + K - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = K - 1, 0 !== t && e.prev_length < e.max_lazy_match && e.strstart - t <= e.w_size - U && (e.match_length = oe(e, t), e.match_length <= 5 && (e.strategy === I || e.match_length === K && e.strstart - e.match_start > 4096) && (e.match_length = K - 1)), e.prev_length >= K && e.match_length <= e.prev_length) {
            o = e.strstart + e.lookahead - K, r = i._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - K), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;

            do {
              ++e.strstart <= o && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + K - 1]) & e.hash_mask, t = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
            } while (0 != --e.prev_length);

            if (e.match_available = 0, e.match_length = K - 1, e.strstart++, r && (ne(e, !1), 0 === e.strm.avail_out)) return z;
          } else if (e.match_available) {
            if ((r = i._tr_tally(e, 0, e.window[e.strstart - 1])) && ne(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return z;
          } else e.match_available = 1, e.strstart++, e.lookahead--;
        }

        return e.match_available && (r = i._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < K - 1 ? e.strstart : K - 1, n === p ? (ne(e, !0), 0 === e.strm.avail_out ? H : q) : e.last_lit && (ne(e, !1), 0 === e.strm.avail_out) ? z : X;
      }

      function le(e, n, t, r, o) {
        this.good_length = e, this.max_lazy = n, this.nice_length = t, this.max_chain = r, this.func = o;
      }

      function ae() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = B, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new o.Buf16(2 * T), this.dyn_dtree = new o.Buf16(2 * (2 * O + 1)), this.bl_tree = new o.Buf16(2 * (2 * k + 1)), $(this.dyn_ltree), $(this.dyn_dtree), $(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new o.Buf16(P + 1), this.heap = new o.Buf16(2 * M + 1), $(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new o.Buf16(2 * M + 1), $(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }

      function ce(e) {
        var n;
        return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = w, (n = e.state).pending = 0, n.pending_out = 0, n.wrap < 0 && (n.wrap = -n.wrap), n.status = n.wrap ? G : W, e.adler = 2 === n.wrap ? 0 : 1, n.last_flush = a, i._tr_init(n), C) : J(e, f);
      }

      function ue(e) {
        var n,
            t = ce(e);
        return t === C && ((n = e.state).window_size = 2 * n.w_size, $(n.head), n.max_lazy_match = r[n.level].max_lazy, n.good_match = r[n.level].good_length, n.nice_match = r[n.level].nice_length, n.max_chain_length = r[n.level].max_chain, n.strstart = 0, n.block_start = 0, n.lookahead = 0, n.insert = 0, n.match_length = n.prev_length = K - 1, n.match_available = 0, n.ins_h = 0), t;
      }

      function pe(e, n, t, r, i, A) {
        if (!e) return f;
        var s = 1;
        if (n === g && (n = 6), r < 0 ? (s = 0, r = -r) : r > 15 && (s = 2, r -= 16), i < 1 || i > _ || t !== B || r < 8 || r > 15 || n < 0 || n > 9 || A < 0 || A > E) return J(e, f);
        8 === r && (r = 9);
        var l = new ae();
        return e.state = l, l.strm = e, l.wrap = s, l.gzhead = null, l.w_bits = r, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = i + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + K - 1) / K), l.window = new o.Buf8(2 * l.w_size), l.head = new o.Buf16(l.hash_size), l.prev = new o.Buf16(l.w_size), l.lit_bufsize = 1 << i + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new o.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = n, l.strategy = A, l.method = t, ue(e);
      }

      r = [new le(0, 0, 0, 0, function (e, n) {
        var t = 65535;

        for (t > e.pending_buf_size - 5 && (t = e.pending_buf_size - 5);;) {
          if (e.lookahead <= 1) {
            if (ie(e), 0 === e.lookahead && n === a) return z;
            if (0 === e.lookahead) break;
          }

          e.strstart += e.lookahead, e.lookahead = 0;
          var r = e.block_start + t;
          if ((0 === e.strstart || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, ne(e, !1), 0 === e.strm.avail_out)) return z;
          if (e.strstart - e.block_start >= e.w_size - U && (ne(e, !1), 0 === e.strm.avail_out)) return z;
        }

        return e.insert = 0, n === p ? (ne(e, !0), 0 === e.strm.avail_out ? H : q) : (e.strstart > e.block_start && (ne(e, !1), e.strm.avail_out), z);
      }), new le(4, 4, 8, 4, Ae), new le(4, 5, 16, 8, Ae), new le(4, 6, 32, 32, Ae), new le(4, 4, 16, 16, se), new le(8, 16, 32, 32, se), new le(8, 16, 128, 128, se), new le(8, 32, 128, 256, se), new le(32, 128, 258, 1024, se), new le(32, 258, 258, 4096, se)], n.deflateInit = function (e, n) {
        return pe(e, n, B, D, S, v);
      }, n.deflateInit2 = pe, n.deflateReset = ue, n.deflateResetKeep = ce, n.deflateSetHeader = function (e, n) {
        return e && e.state ? 2 !== e.state.wrap ? f : (e.state.gzhead = n, C) : f;
      }, n.deflate = function (e, n) {
        var t, o, A, l;
        if (!e || !e.state || n > m || n < 0) return e ? J(e, f) : f;
        if (o = e.state, !e.output || !e.input && 0 !== e.avail_in || o.status === L && n !== p) return J(e, 0 === e.avail_out ? x : f);
        if (o.strm = e, t = o.last_flush, o.last_flush = n, o.status === G) if (2 === o.wrap) e.adler = 0, te(o, 31), te(o, 139), te(o, 8), o.gzhead ? (te(o, (o.gzhead.text ? 1 : 0) + (o.gzhead.hcrc ? 2 : 0) + (o.gzhead.extra ? 4 : 0) + (o.gzhead.name ? 8 : 0) + (o.gzhead.comment ? 16 : 0)), te(o, 255 & o.gzhead.time), te(o, o.gzhead.time >> 8 & 255), te(o, o.gzhead.time >> 16 & 255), te(o, o.gzhead.time >> 24 & 255), te(o, 9 === o.level ? 2 : o.strategy >= b || o.level < 2 ? 4 : 0), te(o, 255 & o.gzhead.os), o.gzhead.extra && o.gzhead.extra.length && (te(o, 255 & o.gzhead.extra.length), te(o, o.gzhead.extra.length >> 8 & 255)), o.gzhead.hcrc && (e.adler = s(e.adler, o.pending_buf, o.pending, 0)), o.gzindex = 0, o.status = Y) : (te(o, 0), te(o, 0), te(o, 0), te(o, 0), te(o, 0), te(o, 9 === o.level ? 2 : o.strategy >= b || o.level < 2 ? 4 : 0), te(o, V), o.status = W);else {
          var h = B + (o.w_bits - 8 << 4) << 8;
          h |= (o.strategy >= b || o.level < 2 ? 0 : o.level < 6 ? 1 : 6 === o.level ? 2 : 3) << 6, 0 !== o.strstart && (h |= R), h += 31 - h % 31, o.status = W, re(o, h), 0 !== o.strstart && (re(o, e.adler >>> 16), re(o, 65535 & e.adler)), e.adler = 1;
        }
        if (o.status === Y) if (o.gzhead.extra) {
          for (A = o.pending; o.gzindex < (65535 & o.gzhead.extra.length) && (o.pending !== o.pending_buf_size || (o.gzhead.hcrc && o.pending > A && (e.adler = s(e.adler, o.pending_buf, o.pending - A, A)), ee(e), A = o.pending, o.pending !== o.pending_buf_size));) {
            te(o, 255 & o.gzhead.extra[o.gzindex]), o.gzindex++;
          }

          o.gzhead.hcrc && o.pending > A && (e.adler = s(e.adler, o.pending_buf, o.pending - A, A)), o.gzindex === o.gzhead.extra.length && (o.gzindex = 0, o.status = F);
        } else o.status = F;
        if (o.status === F) if (o.gzhead.name) {
          A = o.pending;

          do {
            if (o.pending === o.pending_buf_size && (o.gzhead.hcrc && o.pending > A && (e.adler = s(e.adler, o.pending_buf, o.pending - A, A)), ee(e), A = o.pending, o.pending === o.pending_buf_size)) {
              l = 1;
              break;
            }

            l = o.gzindex < o.gzhead.name.length ? 255 & o.gzhead.name.charCodeAt(o.gzindex++) : 0, te(o, l);
          } while (0 !== l);

          o.gzhead.hcrc && o.pending > A && (e.adler = s(e.adler, o.pending_buf, o.pending - A, A)), 0 === l && (o.gzindex = 0, o.status = N);
        } else o.status = N;
        if (o.status === N) if (o.gzhead.comment) {
          A = o.pending;

          do {
            if (o.pending === o.pending_buf_size && (o.gzhead.hcrc && o.pending > A && (e.adler = s(e.adler, o.pending_buf, o.pending - A, A)), ee(e), A = o.pending, o.pending === o.pending_buf_size)) {
              l = 1;
              break;
            }

            l = o.gzindex < o.gzhead.comment.length ? 255 & o.gzhead.comment.charCodeAt(o.gzindex++) : 0, te(o, l);
          } while (0 !== l);

          o.gzhead.hcrc && o.pending > A && (e.adler = s(e.adler, o.pending_buf, o.pending - A, A)), 0 === l && (o.status = j);
        } else o.status = j;

        if (o.status === j && (o.gzhead.hcrc ? (o.pending + 2 > o.pending_buf_size && ee(e), o.pending + 2 <= o.pending_buf_size && (te(o, 255 & e.adler), te(o, e.adler >> 8 & 255), e.adler = 0, o.status = W)) : o.status = W), 0 !== o.pending) {
          if (ee(e), 0 === e.avail_out) return o.last_flush = -1, C;
        } else if (0 === e.avail_in && Z(n) <= Z(t) && n !== p) return J(e, x);

        if (o.status === L && 0 !== e.avail_in) return J(e, x);

        if (0 !== e.avail_in || 0 !== o.lookahead || n !== a && o.status !== L) {
          var g = o.strategy === b ? function (e, n) {
            for (var t;;) {
              if (0 === e.lookahead && (ie(e), 0 === e.lookahead)) {
                if (n === a) return z;
                break;
              }

              if (e.match_length = 0, t = i._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, t && (ne(e, !1), 0 === e.strm.avail_out)) return z;
            }

            return e.insert = 0, n === p ? (ne(e, !0), 0 === e.strm.avail_out ? H : q) : e.last_lit && (ne(e, !1), 0 === e.strm.avail_out) ? z : X;
          }(o, n) : o.strategy === y ? function (e, n) {
            for (var t, r, o, A, s = e.window;;) {
              if (e.lookahead <= Q) {
                if (ie(e), e.lookahead <= Q && n === a) return z;
                if (0 === e.lookahead) break;
              }

              if (e.match_length = 0, e.lookahead >= K && e.strstart > 0 && (r = s[o = e.strstart - 1]) === s[++o] && r === s[++o] && r === s[++o]) {
                A = e.strstart + Q;

                do {} while (r === s[++o] && r === s[++o] && r === s[++o] && r === s[++o] && r === s[++o] && r === s[++o] && r === s[++o] && r === s[++o] && o < A);

                e.match_length = Q - (A - o), e.match_length > e.lookahead && (e.match_length = e.lookahead);
              }

              if (e.match_length >= K ? (t = i._tr_tally(e, 1, e.match_length - K), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (t = i._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), t && (ne(e, !1), 0 === e.strm.avail_out)) return z;
            }

            return e.insert = 0, n === p ? (ne(e, !0), 0 === e.strm.avail_out ? H : q) : e.last_lit && (ne(e, !1), 0 === e.strm.avail_out) ? z : X;
          }(o, n) : r[o.level].func(o, n);
          if (g !== H && g !== q || (o.status = L), g === z || g === H) return 0 === e.avail_out && (o.last_flush = -1), C;
          if (g === X && (n === c ? i._tr_align(o) : n !== m && (i._tr_stored_block(o, 0, 0, !1), n === u && ($(o.head), 0 === o.lookahead && (o.strstart = 0, o.block_start = 0, o.insert = 0))), ee(e), 0 === e.avail_out)) return o.last_flush = -1, C;
        }

        return n !== p ? C : o.wrap <= 0 ? d : (2 === o.wrap ? (te(o, 255 & e.adler), te(o, e.adler >> 8 & 255), te(o, e.adler >> 16 & 255), te(o, e.adler >> 24 & 255), te(o, 255 & e.total_in), te(o, e.total_in >> 8 & 255), te(o, e.total_in >> 16 & 255), te(o, e.total_in >> 24 & 255)) : (re(o, e.adler >>> 16), re(o, 65535 & e.adler)), ee(e), o.wrap > 0 && (o.wrap = -o.wrap), 0 !== o.pending ? C : d);
      }, n.deflateEnd = function (e) {
        var n;
        return e && e.state ? (n = e.state.status) !== G && n !== Y && n !== F && n !== N && n !== j && n !== W && n !== L ? J(e, f) : (e.state = null, n === W ? J(e, h) : C) : f;
      }, n.deflateSetDictionary = function (e, n) {
        var t,
            r,
            i,
            s,
            l,
            a,
            c,
            u,
            p = n.length;
        if (!e || !e.state) return f;
        if (2 === (s = (t = e.state).wrap) || 1 === s && t.status !== G || t.lookahead) return f;

        for (1 === s && (e.adler = A(e.adler, n, p, 0)), t.wrap = 0, p >= t.w_size && (0 === s && ($(t.head), t.strstart = 0, t.block_start = 0, t.insert = 0), u = new o.Buf8(t.w_size), o.arraySet(u, n, p - t.w_size, t.w_size, 0), n = u, p = t.w_size), l = e.avail_in, a = e.next_in, c = e.input, e.avail_in = p, e.next_in = 0, e.input = n, ie(t); t.lookahead >= K;) {
          r = t.strstart, i = t.lookahead - (K - 1);

          do {
            t.ins_h = (t.ins_h << t.hash_shift ^ t.window[r + K - 1]) & t.hash_mask, t.prev[r & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = r, r++;
          } while (--i);

          t.strstart = r, t.lookahead = K - 1, ie(t);
        }

        return t.strstart += t.lookahead, t.block_start = t.strstart, t.insert = t.lookahead, t.lookahead = 0, t.match_length = t.prev_length = K - 1, t.match_available = 0, e.next_in = a, e.input = c, e.avail_in = l, t.wrap = s, C;
      }, n.deflateInfo = "pako deflate (from Nodeca project)";
    }, function (e, n, t) {
      "use strict";

      var r = t(7),
          o = 4,
          i = 0,
          A = 1,
          s = 2;

      function l(e) {
        for (var n = e.length; --n >= 0;) {
          e[n] = 0;
        }
      }

      var a = 0,
          c = 1,
          u = 2,
          p = 29,
          m = 256,
          C = m + 1 + p,
          d = 30,
          f = 19,
          h = 2 * C + 1,
          x = 15,
          g = 16,
          I = 7,
          b = 256,
          y = 16,
          E = 17,
          v = 18,
          w = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
          B = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
          _ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
          D = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
          S = new Array(2 * (C + 2));
      l(S);
      var M = new Array(2 * d);
      l(M);
      var O = new Array(512);
      l(O);
      var k = new Array(256);
      l(k);
      var T = new Array(p);
      l(T);
      var P,
          K,
          Q,
          U = new Array(d);

      function R(e, n, t, r, o) {
        this.static_tree = e, this.extra_bits = n, this.extra_base = t, this.elems = r, this.max_length = o, this.has_stree = e && e.length;
      }

      function G(e, n) {
        this.dyn_tree = e, this.max_code = 0, this.stat_desc = n;
      }

      function Y(e) {
        return e < 256 ? O[e] : O[256 + (e >>> 7)];
      }

      function F(e, n) {
        e.pending_buf[e.pending++] = 255 & n, e.pending_buf[e.pending++] = n >>> 8 & 255;
      }

      function N(e, n, t) {
        e.bi_valid > g - t ? (e.bi_buf |= n << e.bi_valid & 65535, F(e, e.bi_buf), e.bi_buf = n >> g - e.bi_valid, e.bi_valid += t - g) : (e.bi_buf |= n << e.bi_valid & 65535, e.bi_valid += t);
      }

      function j(e, n, t) {
        N(e, t[2 * n], t[2 * n + 1]);
      }

      function W(e, n) {
        var t = 0;

        do {
          t |= 1 & e, e >>>= 1, t <<= 1;
        } while (--n > 0);

        return t >>> 1;
      }

      function L(e, n, t) {
        var r,
            o,
            i = new Array(x + 1),
            A = 0;

        for (r = 1; r <= x; r++) {
          i[r] = A = A + t[r - 1] << 1;
        }

        for (o = 0; o <= n; o++) {
          var s = e[2 * o + 1];
          0 !== s && (e[2 * o] = W(i[s]++, s));
        }
      }

      function z(e) {
        var n;

        for (n = 0; n < C; n++) {
          e.dyn_ltree[2 * n] = 0;
        }

        for (n = 0; n < d; n++) {
          e.dyn_dtree[2 * n] = 0;
        }

        for (n = 0; n < f; n++) {
          e.bl_tree[2 * n] = 0;
        }

        e.dyn_ltree[2 * b] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
      }

      function X(e) {
        e.bi_valid > 8 ? F(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
      }

      function H(e, n, t, r) {
        var o = 2 * n,
            i = 2 * t;
        return e[o] < e[i] || e[o] === e[i] && r[n] <= r[t];
      }

      function q(e, n, t) {
        for (var r = e.heap[t], o = t << 1; o <= e.heap_len && (o < e.heap_len && H(n, e.heap[o + 1], e.heap[o], e.depth) && o++, !H(n, r, e.heap[o], e.depth));) {
          e.heap[t] = e.heap[o], t = o, o <<= 1;
        }

        e.heap[t] = r;
      }

      function V(e, n, t) {
        var r,
            o,
            i,
            A,
            s = 0;
        if (0 !== e.last_lit) do {
          r = e.pending_buf[e.d_buf + 2 * s] << 8 | e.pending_buf[e.d_buf + 2 * s + 1], o = e.pending_buf[e.l_buf + s], s++, 0 === r ? j(e, o, n) : (j(e, (i = k[o]) + m + 1, n), 0 !== (A = w[i]) && N(e, o -= T[i], A), j(e, i = Y(--r), t), 0 !== (A = B[i]) && N(e, r -= U[i], A));
        } while (s < e.last_lit);
        j(e, b, n);
      }

      function J(e, n) {
        var t,
            r,
            o,
            i = n.dyn_tree,
            A = n.stat_desc.static_tree,
            s = n.stat_desc.has_stree,
            l = n.stat_desc.elems,
            a = -1;

        for (e.heap_len = 0, e.heap_max = h, t = 0; t < l; t++) {
          0 !== i[2 * t] ? (e.heap[++e.heap_len] = a = t, e.depth[t] = 0) : i[2 * t + 1] = 0;
        }

        for (; e.heap_len < 2;) {
          i[2 * (o = e.heap[++e.heap_len] = a < 2 ? ++a : 0)] = 1, e.depth[o] = 0, e.opt_len--, s && (e.static_len -= A[2 * o + 1]);
        }

        for (n.max_code = a, t = e.heap_len >> 1; t >= 1; t--) {
          q(e, i, t);
        }

        o = l;

        do {
          t = e.heap[1], e.heap[1] = e.heap[e.heap_len--], q(e, i, 1), r = e.heap[1], e.heap[--e.heap_max] = t, e.heap[--e.heap_max] = r, i[2 * o] = i[2 * t] + i[2 * r], e.depth[o] = (e.depth[t] >= e.depth[r] ? e.depth[t] : e.depth[r]) + 1, i[2 * t + 1] = i[2 * r + 1] = o, e.heap[1] = o++, q(e, i, 1);
        } while (e.heap_len >= 2);

        e.heap[--e.heap_max] = e.heap[1], function (e, n) {
          var t,
              r,
              o,
              i,
              A,
              s,
              l = n.dyn_tree,
              a = n.max_code,
              c = n.stat_desc.static_tree,
              u = n.stat_desc.has_stree,
              p = n.stat_desc.extra_bits,
              m = n.stat_desc.extra_base,
              C = n.stat_desc.max_length,
              d = 0;

          for (i = 0; i <= x; i++) {
            e.bl_count[i] = 0;
          }

          for (l[2 * e.heap[e.heap_max] + 1] = 0, t = e.heap_max + 1; t < h; t++) {
            (i = l[2 * l[2 * (r = e.heap[t]) + 1] + 1] + 1) > C && (i = C, d++), l[2 * r + 1] = i, r > a || (e.bl_count[i]++, A = 0, r >= m && (A = p[r - m]), s = l[2 * r], e.opt_len += s * (i + A), u && (e.static_len += s * (c[2 * r + 1] + A)));
          }

          if (0 !== d) {
            do {
              for (i = C - 1; 0 === e.bl_count[i];) {
                i--;
              }

              e.bl_count[i]--, e.bl_count[i + 1] += 2, e.bl_count[C]--, d -= 2;
            } while (d > 0);

            for (i = C; 0 !== i; i--) {
              for (r = e.bl_count[i]; 0 !== r;) {
                (o = e.heap[--t]) > a || (l[2 * o + 1] !== i && (e.opt_len += (i - l[2 * o + 1]) * l[2 * o], l[2 * o + 1] = i), r--);
              }
            }
          }
        }(e, n), L(i, a, e.bl_count);
      }

      function Z(e, n, t) {
        var r,
            o,
            i = -1,
            A = n[1],
            s = 0,
            l = 7,
            a = 4;

        for (0 === A && (l = 138, a = 3), n[2 * (t + 1) + 1] = 65535, r = 0; r <= t; r++) {
          o = A, A = n[2 * (r + 1) + 1], ++s < l && o === A || (s < a ? e.bl_tree[2 * o] += s : 0 !== o ? (o !== i && e.bl_tree[2 * o]++, e.bl_tree[2 * y]++) : s <= 10 ? e.bl_tree[2 * E]++ : e.bl_tree[2 * v]++, s = 0, i = o, 0 === A ? (l = 138, a = 3) : o === A ? (l = 6, a = 3) : (l = 7, a = 4));
        }
      }

      function $(e, n, t) {
        var r,
            o,
            i = -1,
            A = n[1],
            s = 0,
            l = 7,
            a = 4;

        for (0 === A && (l = 138, a = 3), r = 0; r <= t; r++) {
          if (o = A, A = n[2 * (r + 1) + 1], !(++s < l && o === A)) {
            if (s < a) do {
              j(e, o, e.bl_tree);
            } while (0 != --s);else 0 !== o ? (o !== i && (j(e, o, e.bl_tree), s--), j(e, y, e.bl_tree), N(e, s - 3, 2)) : s <= 10 ? (j(e, E, e.bl_tree), N(e, s - 3, 3)) : (j(e, v, e.bl_tree), N(e, s - 11, 7));
            s = 0, i = o, 0 === A ? (l = 138, a = 3) : o === A ? (l = 6, a = 3) : (l = 7, a = 4);
          }
        }
      }

      l(U);
      var ee = !1;

      function ne(e, n, t, o) {
        N(e, (a << 1) + (o ? 1 : 0), 3), function (e, n, t, o) {
          X(e), o && (F(e, t), F(e, ~t)), r.arraySet(e.pending_buf, e.window, n, t, e.pending), e.pending += t;
        }(e, n, t, !0);
      }

      n._tr_init = function (e) {
        ee || (function () {
          var e,
              n,
              t,
              r,
              o,
              i = new Array(x + 1);

          for (t = 0, r = 0; r < p - 1; r++) {
            for (T[r] = t, e = 0; e < 1 << w[r]; e++) {
              k[t++] = r;
            }
          }

          for (k[t - 1] = r, o = 0, r = 0; r < 16; r++) {
            for (U[r] = o, e = 0; e < 1 << B[r]; e++) {
              O[o++] = r;
            }
          }

          for (o >>= 7; r < d; r++) {
            for (U[r] = o << 7, e = 0; e < 1 << B[r] - 7; e++) {
              O[256 + o++] = r;
            }
          }

          for (n = 0; n <= x; n++) {
            i[n] = 0;
          }

          for (e = 0; e <= 143;) {
            S[2 * e + 1] = 8, e++, i[8]++;
          }

          for (; e <= 255;) {
            S[2 * e + 1] = 9, e++, i[9]++;
          }

          for (; e <= 279;) {
            S[2 * e + 1] = 7, e++, i[7]++;
          }

          for (; e <= 287;) {
            S[2 * e + 1] = 8, e++, i[8]++;
          }

          for (L(S, C + 1, i), e = 0; e < d; e++) {
            M[2 * e + 1] = 5, M[2 * e] = W(e, 5);
          }

          P = new R(S, w, m + 1, C, x), K = new R(M, B, 0, d, x), Q = new R(new Array(0), _, 0, f, I);
        }(), ee = !0), e.l_desc = new G(e.dyn_ltree, P), e.d_desc = new G(e.dyn_dtree, K), e.bl_desc = new G(e.bl_tree, Q), e.bi_buf = 0, e.bi_valid = 0, z(e);
      }, n._tr_stored_block = ne, n._tr_flush_block = function (e, n, t, r) {
        var l,
            a,
            p = 0;
        e.level > 0 ? (e.strm.data_type === s && (e.strm.data_type = function (e) {
          var n,
              t = 4093624447;

          for (n = 0; n <= 31; n++, t >>>= 1) {
            if (1 & t && 0 !== e.dyn_ltree[2 * n]) return i;
          }

          if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return A;

          for (n = 32; n < m; n++) {
            if (0 !== e.dyn_ltree[2 * n]) return A;
          }

          return i;
        }(e)), J(e, e.l_desc), J(e, e.d_desc), p = function (e) {
          var n;

          for (Z(e, e.dyn_ltree, e.l_desc.max_code), Z(e, e.dyn_dtree, e.d_desc.max_code), J(e, e.bl_desc), n = f - 1; n >= 3 && 0 === e.bl_tree[2 * D[n] + 1]; n--) {
            ;
          }

          return e.opt_len += 3 * (n + 1) + 5 + 5 + 4, n;
        }(e), l = e.opt_len + 3 + 7 >>> 3, (a = e.static_len + 3 + 7 >>> 3) <= l && (l = a)) : l = a = t + 5, t + 4 <= l && -1 !== n ? ne(e, n, t, r) : e.strategy === o || a === l ? (N(e, (c << 1) + (r ? 1 : 0), 3), V(e, S, M)) : (N(e, (u << 1) + (r ? 1 : 0), 3), function (e, n, t, r) {
          var o;

          for (N(e, n - 257, 5), N(e, t - 1, 5), N(e, r - 4, 4), o = 0; o < r; o++) {
            N(e, e.bl_tree[2 * D[o] + 1], 3);
          }

          $(e, e.dyn_ltree, n - 1), $(e, e.dyn_dtree, t - 1);
        }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, p + 1), V(e, e.dyn_ltree, e.dyn_dtree)), z(e), r && X(e);
      }, n._tr_tally = function (e, n, t) {
        return e.pending_buf[e.d_buf + 2 * e.last_lit] = n >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & n, e.pending_buf[e.l_buf + e.last_lit] = 255 & t, e.last_lit++, 0 === n ? e.dyn_ltree[2 * t]++ : (e.matches++, n--, e.dyn_ltree[2 * (k[t] + m + 1)]++, e.dyn_dtree[2 * Y(n)]++), e.last_lit === e.lit_bufsize - 1;
      }, n._tr_align = function (e) {
        N(e, c << 1, 3), j(e, b, S), function (e) {
          16 === e.bi_valid ? (F(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
        }(e);
      };
    }, function (e, n, t) {
      "use strict";

      var r = t(324),
          o = t(7),
          i = t(122),
          A = t(124),
          s = t(49),
          l = t(123),
          a = t(327),
          c = Object.prototype.toString;

      function u(e) {
        if (!(this instanceof u)) return new u(e);
        this.options = o.assign({
          chunkSize: 16384,
          windowBits: 0,
          to: ""
        }, e || {});
        var n = this.options;
        n.raw && n.windowBits >= 0 && n.windowBits < 16 && (n.windowBits = -n.windowBits, 0 === n.windowBits && (n.windowBits = -15)), !(n.windowBits >= 0 && n.windowBits < 16) || e && e.windowBits || (n.windowBits += 32), n.windowBits > 15 && n.windowBits < 48 && 0 == (15 & n.windowBits) && (n.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l(), this.strm.avail_out = 0;
        var t = r.inflateInit2(this.strm, n.windowBits);
        if (t !== A.Z_OK) throw new Error(s[t]);
        this.header = new a(), r.inflateGetHeader(this.strm, this.header);
      }

      function p(e, n) {
        var t = new u(n);
        if (t.push(e, !0), t.err) throw t.msg || s[t.err];
        return t.result;
      }

      u.prototype.push = function (e, n) {
        var t,
            s,
            l,
            a,
            u,
            p,
            m = this.strm,
            C = this.options.chunkSize,
            d = this.options.dictionary,
            f = !1;
        if (this.ended) return !1;
        s = n === ~~n ? n : !0 === n ? A.Z_FINISH : A.Z_NO_FLUSH, "string" == typeof e ? m.input = i.binstring2buf(e) : "[object ArrayBuffer]" === c.call(e) ? m.input = new Uint8Array(e) : m.input = e, m.next_in = 0, m.avail_in = m.input.length;

        do {
          if (0 === m.avail_out && (m.output = new o.Buf8(C), m.next_out = 0, m.avail_out = C), (t = r.inflate(m, A.Z_NO_FLUSH)) === A.Z_NEED_DICT && d && (p = "string" == typeof d ? i.string2buf(d) : "[object ArrayBuffer]" === c.call(d) ? new Uint8Array(d) : d, t = r.inflateSetDictionary(this.strm, p)), t === A.Z_BUF_ERROR && !0 === f && (t = A.Z_OK, f = !1), t !== A.Z_STREAM_END && t !== A.Z_OK) return this.onEnd(t), this.ended = !0, !1;
          m.next_out && (0 !== m.avail_out && t !== A.Z_STREAM_END && (0 !== m.avail_in || s !== A.Z_FINISH && s !== A.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = i.utf8border(m.output, m.next_out), a = m.next_out - l, u = i.buf2string(m.output, l), m.next_out = a, m.avail_out = C - a, a && o.arraySet(m.output, m.output, l, a, 0), this.onData(u)) : this.onData(o.shrinkBuf(m.output, m.next_out)))), 0 === m.avail_in && 0 === m.avail_out && (f = !0);
        } while ((m.avail_in > 0 || 0 === m.avail_out) && t !== A.Z_STREAM_END);

        return t === A.Z_STREAM_END && (s = A.Z_FINISH), s === A.Z_FINISH ? (t = r.inflateEnd(this.strm), this.onEnd(t), this.ended = !0, t === A.Z_OK) : s !== A.Z_SYNC_FLUSH || (this.onEnd(A.Z_OK), m.avail_out = 0, !0);
      }, u.prototype.onData = function (e) {
        this.chunks.push(e);
      }, u.prototype.onEnd = function (e) {
        e === A.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
      }, n.Inflate = u, n.inflate = p, n.inflateRaw = function (e, n) {
        return (n = n || {}).raw = !0, p(e, n);
      }, n.ungzip = p;
    }, function (e, n, t) {
      "use strict";

      var r = t(7),
          o = t(120),
          i = t(121),
          A = t(325),
          s = t(326),
          l = 0,
          a = 1,
          c = 2,
          u = 4,
          p = 5,
          m = 6,
          C = 0,
          d = 1,
          f = 2,
          h = -2,
          x = -3,
          g = -4,
          I = -5,
          b = 8,
          y = 1,
          E = 2,
          v = 3,
          w = 4,
          B = 5,
          _ = 6,
          D = 7,
          S = 8,
          M = 9,
          O = 10,
          k = 11,
          T = 12,
          P = 13,
          K = 14,
          Q = 15,
          U = 16,
          R = 17,
          G = 18,
          Y = 19,
          F = 20,
          N = 21,
          j = 22,
          W = 23,
          L = 24,
          z = 25,
          X = 26,
          H = 27,
          q = 28,
          V = 29,
          J = 30,
          Z = 31,
          $ = 32,
          ee = 852,
          ne = 592,
          te = 15;

      function re(e) {
        return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
      }

      function oe() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new r.Buf16(320), this.work = new r.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }

      function ie(e) {
        var n;
        return e && e.state ? (n = e.state, e.total_in = e.total_out = n.total = 0, e.msg = "", n.wrap && (e.adler = 1 & n.wrap), n.mode = y, n.last = 0, n.havedict = 0, n.dmax = 32768, n.head = null, n.hold = 0, n.bits = 0, n.lencode = n.lendyn = new r.Buf32(ee), n.distcode = n.distdyn = new r.Buf32(ne), n.sane = 1, n.back = -1, C) : h;
      }

      function Ae(e) {
        var n;
        return e && e.state ? ((n = e.state).wsize = 0, n.whave = 0, n.wnext = 0, ie(e)) : h;
      }

      function se(e, n) {
        var t, r;
        return e && e.state ? (r = e.state, n < 0 ? (t = 0, n = -n) : (t = 1 + (n >> 4), n < 48 && (n &= 15)), n && (n < 8 || n > 15) ? h : (null !== r.window && r.wbits !== n && (r.window = null), r.wrap = t, r.wbits = n, Ae(e))) : h;
      }

      function le(e, n) {
        var t, r;
        return e ? (r = new oe(), e.state = r, r.window = null, (t = se(e, n)) !== C && (e.state = null), t) : h;
      }

      var ae,
          ce,
          ue = !0;

      function pe(e) {
        if (ue) {
          var n;

          for (ae = new r.Buf32(512), ce = new r.Buf32(32), n = 0; n < 144;) {
            e.lens[n++] = 8;
          }

          for (; n < 256;) {
            e.lens[n++] = 9;
          }

          for (; n < 280;) {
            e.lens[n++] = 7;
          }

          for (; n < 288;) {
            e.lens[n++] = 8;
          }

          for (s(a, e.lens, 0, 288, ae, 0, e.work, {
            bits: 9
          }), n = 0; n < 32;) {
            e.lens[n++] = 5;
          }

          s(c, e.lens, 0, 32, ce, 0, e.work, {
            bits: 5
          }), ue = !1;
        }

        e.lencode = ae, e.lenbits = 9, e.distcode = ce, e.distbits = 5;
      }

      function me(e, n, t, o) {
        var i,
            A = e.state;
        return null === A.window && (A.wsize = 1 << A.wbits, A.wnext = 0, A.whave = 0, A.window = new r.Buf8(A.wsize)), o >= A.wsize ? (r.arraySet(A.window, n, t - A.wsize, A.wsize, 0), A.wnext = 0, A.whave = A.wsize) : ((i = A.wsize - A.wnext) > o && (i = o), r.arraySet(A.window, n, t - o, i, A.wnext), (o -= i) ? (r.arraySet(A.window, n, t - o, o, 0), A.wnext = o, A.whave = A.wsize) : (A.wnext += i, A.wnext === A.wsize && (A.wnext = 0), A.whave < A.wsize && (A.whave += i))), 0;
      }

      n.inflateReset = Ae, n.inflateReset2 = se, n.inflateResetKeep = ie, n.inflateInit = function (e) {
        return le(e, te);
      }, n.inflateInit2 = le, n.inflate = function (e, n) {
        var t,
            ee,
            ne,
            te,
            oe,
            ie,
            Ae,
            se,
            le,
            ae,
            ce,
            ue,
            Ce,
            de,
            fe,
            he,
            xe,
            ge,
            Ie,
            be,
            ye,
            Ee,
            ve,
            we,
            Be = 0,
            _e = new r.Buf8(4),
            De = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

        if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return h;
        (t = e.state).mode === T && (t.mode = P), oe = e.next_out, ne = e.output, Ae = e.avail_out, te = e.next_in, ee = e.input, ie = e.avail_in, se = t.hold, le = t.bits, ae = ie, ce = Ae, Ee = C;

        e: for (;;) {
          switch (t.mode) {
            case y:
              if (0 === t.wrap) {
                t.mode = P;
                break;
              }

              for (; le < 16;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              if (2 & t.wrap && 35615 === se) {
                t.check = 0, _e[0] = 255 & se, _e[1] = se >>> 8 & 255, t.check = i(t.check, _e, 2, 0), se = 0, le = 0, t.mode = E;
                break;
              }

              if (t.flags = 0, t.head && (t.head.done = !1), !(1 & t.wrap) || (((255 & se) << 8) + (se >> 8)) % 31) {
                e.msg = "incorrect header check", t.mode = J;
                break;
              }

              if ((15 & se) !== b) {
                e.msg = "unknown compression method", t.mode = J;
                break;
              }

              if (le -= 4, ye = 8 + (15 & (se >>>= 4)), 0 === t.wbits) t.wbits = ye;else if (ye > t.wbits) {
                e.msg = "invalid window size", t.mode = J;
                break;
              }
              t.dmax = 1 << ye, e.adler = t.check = 1, t.mode = 512 & se ? O : T, se = 0, le = 0;
              break;

            case E:
              for (; le < 16;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              if (t.flags = se, (255 & t.flags) !== b) {
                e.msg = "unknown compression method", t.mode = J;
                break;
              }

              if (57344 & t.flags) {
                e.msg = "unknown header flags set", t.mode = J;
                break;
              }

              t.head && (t.head.text = se >> 8 & 1), 512 & t.flags && (_e[0] = 255 & se, _e[1] = se >>> 8 & 255, t.check = i(t.check, _e, 2, 0)), se = 0, le = 0, t.mode = v;

            case v:
              for (; le < 32;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              t.head && (t.head.time = se), 512 & t.flags && (_e[0] = 255 & se, _e[1] = se >>> 8 & 255, _e[2] = se >>> 16 & 255, _e[3] = se >>> 24 & 255, t.check = i(t.check, _e, 4, 0)), se = 0, le = 0, t.mode = w;

            case w:
              for (; le < 16;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              t.head && (t.head.xflags = 255 & se, t.head.os = se >> 8), 512 & t.flags && (_e[0] = 255 & se, _e[1] = se >>> 8 & 255, t.check = i(t.check, _e, 2, 0)), se = 0, le = 0, t.mode = B;

            case B:
              if (1024 & t.flags) {
                for (; le < 16;) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                t.length = se, t.head && (t.head.extra_len = se), 512 & t.flags && (_e[0] = 255 & se, _e[1] = se >>> 8 & 255, t.check = i(t.check, _e, 2, 0)), se = 0, le = 0;
              } else t.head && (t.head.extra = null);

              t.mode = _;

            case _:
              if (1024 & t.flags && ((ue = t.length) > ie && (ue = ie), ue && (t.head && (ye = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Array(t.head.extra_len)), r.arraySet(t.head.extra, ee, te, ue, ye)), 512 & t.flags && (t.check = i(t.check, ee, ue, te)), ie -= ue, te += ue, t.length -= ue), t.length)) break e;
              t.length = 0, t.mode = D;

            case D:
              if (2048 & t.flags) {
                if (0 === ie) break e;
                ue = 0;

                do {
                  ye = ee[te + ue++], t.head && ye && t.length < 65536 && (t.head.name += String.fromCharCode(ye));
                } while (ye && ue < ie);

                if (512 & t.flags && (t.check = i(t.check, ee, ue, te)), ie -= ue, te += ue, ye) break e;
              } else t.head && (t.head.name = null);

              t.length = 0, t.mode = S;

            case S:
              if (4096 & t.flags) {
                if (0 === ie) break e;
                ue = 0;

                do {
                  ye = ee[te + ue++], t.head && ye && t.length < 65536 && (t.head.comment += String.fromCharCode(ye));
                } while (ye && ue < ie);

                if (512 & t.flags && (t.check = i(t.check, ee, ue, te)), ie -= ue, te += ue, ye) break e;
              } else t.head && (t.head.comment = null);

              t.mode = M;

            case M:
              if (512 & t.flags) {
                for (; le < 16;) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                if (se !== (65535 & t.check)) {
                  e.msg = "header crc mismatch", t.mode = J;
                  break;
                }

                se = 0, le = 0;
              }

              t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), e.adler = t.check = 0, t.mode = T;
              break;

            case O:
              for (; le < 32;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              e.adler = t.check = re(se), se = 0, le = 0, t.mode = k;

            case k:
              if (0 === t.havedict) return e.next_out = oe, e.avail_out = Ae, e.next_in = te, e.avail_in = ie, t.hold = se, t.bits = le, f;
              e.adler = t.check = 1, t.mode = T;

            case T:
              if (n === p || n === m) break e;

            case P:
              if (t.last) {
                se >>>= 7 & le, le -= 7 & le, t.mode = H;
                break;
              }

              for (; le < 3;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              switch (t.last = 1 & se, le -= 1, 3 & (se >>>= 1)) {
                case 0:
                  t.mode = K;
                  break;

                case 1:
                  if (pe(t), t.mode = F, n === m) {
                    se >>>= 2, le -= 2;
                    break e;
                  }

                  break;

                case 2:
                  t.mode = R;
                  break;

                case 3:
                  e.msg = "invalid block type", t.mode = J;
              }

              se >>>= 2, le -= 2;
              break;

            case K:
              for (se >>>= 7 & le, le -= 7 & le; le < 32;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              if ((65535 & se) != (se >>> 16 ^ 65535)) {
                e.msg = "invalid stored block lengths", t.mode = J;
                break;
              }

              if (t.length = 65535 & se, se = 0, le = 0, t.mode = Q, n === m) break e;

            case Q:
              t.mode = U;

            case U:
              if (ue = t.length) {
                if (ue > ie && (ue = ie), ue > Ae && (ue = Ae), 0 === ue) break e;
                r.arraySet(ne, ee, te, ue, oe), ie -= ue, te += ue, Ae -= ue, oe += ue, t.length -= ue;
                break;
              }

              t.mode = T;
              break;

            case R:
              for (; le < 14;) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              if (t.nlen = 257 + (31 & se), se >>>= 5, le -= 5, t.ndist = 1 + (31 & se), se >>>= 5, le -= 5, t.ncode = 4 + (15 & se), se >>>= 4, le -= 4, t.nlen > 286 || t.ndist > 30) {
                e.msg = "too many length or distance symbols", t.mode = J;
                break;
              }

              t.have = 0, t.mode = G;

            case G:
              for (; t.have < t.ncode;) {
                for (; le < 3;) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                t.lens[De[t.have++]] = 7 & se, se >>>= 3, le -= 3;
              }

              for (; t.have < 19;) {
                t.lens[De[t.have++]] = 0;
              }

              if (t.lencode = t.lendyn, t.lenbits = 7, ve = {
                bits: t.lenbits
              }, Ee = s(l, t.lens, 0, 19, t.lencode, 0, t.work, ve), t.lenbits = ve.bits, Ee) {
                e.msg = "invalid code lengths set", t.mode = J;
                break;
              }

              t.have = 0, t.mode = Y;

            case Y:
              for (; t.have < t.nlen + t.ndist;) {
                for (; he = (Be = t.lencode[se & (1 << t.lenbits) - 1]) >>> 16 & 255, xe = 65535 & Be, !((fe = Be >>> 24) <= le);) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                if (xe < 16) se >>>= fe, le -= fe, t.lens[t.have++] = xe;else {
                  if (16 === xe) {
                    for (we = fe + 2; le < we;) {
                      if (0 === ie) break e;
                      ie--, se += ee[te++] << le, le += 8;
                    }

                    if (se >>>= fe, le -= fe, 0 === t.have) {
                      e.msg = "invalid bit length repeat", t.mode = J;
                      break;
                    }

                    ye = t.lens[t.have - 1], ue = 3 + (3 & se), se >>>= 2, le -= 2;
                  } else if (17 === xe) {
                    for (we = fe + 3; le < we;) {
                      if (0 === ie) break e;
                      ie--, se += ee[te++] << le, le += 8;
                    }

                    le -= fe, ye = 0, ue = 3 + (7 & (se >>>= fe)), se >>>= 3, le -= 3;
                  } else {
                    for (we = fe + 7; le < we;) {
                      if (0 === ie) break e;
                      ie--, se += ee[te++] << le, le += 8;
                    }

                    le -= fe, ye = 0, ue = 11 + (127 & (se >>>= fe)), se >>>= 7, le -= 7;
                  }

                  if (t.have + ue > t.nlen + t.ndist) {
                    e.msg = "invalid bit length repeat", t.mode = J;
                    break;
                  }

                  for (; ue--;) {
                    t.lens[t.have++] = ye;
                  }
                }
              }

              if (t.mode === J) break;

              if (0 === t.lens[256]) {
                e.msg = "invalid code -- missing end-of-block", t.mode = J;
                break;
              }

              if (t.lenbits = 9, ve = {
                bits: t.lenbits
              }, Ee = s(a, t.lens, 0, t.nlen, t.lencode, 0, t.work, ve), t.lenbits = ve.bits, Ee) {
                e.msg = "invalid literal/lengths set", t.mode = J;
                break;
              }

              if (t.distbits = 6, t.distcode = t.distdyn, ve = {
                bits: t.distbits
              }, Ee = s(c, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, ve), t.distbits = ve.bits, Ee) {
                e.msg = "invalid distances set", t.mode = J;
                break;
              }

              if (t.mode = F, n === m) break e;

            case F:
              t.mode = N;

            case N:
              if (ie >= 6 && Ae >= 258) {
                e.next_out = oe, e.avail_out = Ae, e.next_in = te, e.avail_in = ie, t.hold = se, t.bits = le, A(e, ce), oe = e.next_out, ne = e.output, Ae = e.avail_out, te = e.next_in, ee = e.input, ie = e.avail_in, se = t.hold, le = t.bits, t.mode === T && (t.back = -1);
                break;
              }

              for (t.back = 0; he = (Be = t.lencode[se & (1 << t.lenbits) - 1]) >>> 16 & 255, xe = 65535 & Be, !((fe = Be >>> 24) <= le);) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              if (he && 0 == (240 & he)) {
                for (ge = fe, Ie = he, be = xe; he = (Be = t.lencode[be + ((se & (1 << ge + Ie) - 1) >> ge)]) >>> 16 & 255, xe = 65535 & Be, !(ge + (fe = Be >>> 24) <= le);) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                se >>>= ge, le -= ge, t.back += ge;
              }

              if (se >>>= fe, le -= fe, t.back += fe, t.length = xe, 0 === he) {
                t.mode = X;
                break;
              }

              if (32 & he) {
                t.back = -1, t.mode = T;
                break;
              }

              if (64 & he) {
                e.msg = "invalid literal/length code", t.mode = J;
                break;
              }

              t.extra = 15 & he, t.mode = j;

            case j:
              if (t.extra) {
                for (we = t.extra; le < we;) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                t.length += se & (1 << t.extra) - 1, se >>>= t.extra, le -= t.extra, t.back += t.extra;
              }

              t.was = t.length, t.mode = W;

            case W:
              for (; he = (Be = t.distcode[se & (1 << t.distbits) - 1]) >>> 16 & 255, xe = 65535 & Be, !((fe = Be >>> 24) <= le);) {
                if (0 === ie) break e;
                ie--, se += ee[te++] << le, le += 8;
              }

              if (0 == (240 & he)) {
                for (ge = fe, Ie = he, be = xe; he = (Be = t.distcode[be + ((se & (1 << ge + Ie) - 1) >> ge)]) >>> 16 & 255, xe = 65535 & Be, !(ge + (fe = Be >>> 24) <= le);) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                se >>>= ge, le -= ge, t.back += ge;
              }

              if (se >>>= fe, le -= fe, t.back += fe, 64 & he) {
                e.msg = "invalid distance code", t.mode = J;
                break;
              }

              t.offset = xe, t.extra = 15 & he, t.mode = L;

            case L:
              if (t.extra) {
                for (we = t.extra; le < we;) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                t.offset += se & (1 << t.extra) - 1, se >>>= t.extra, le -= t.extra, t.back += t.extra;
              }

              if (t.offset > t.dmax) {
                e.msg = "invalid distance too far back", t.mode = J;
                break;
              }

              t.mode = z;

            case z:
              if (0 === Ae) break e;

              if (ue = ce - Ae, t.offset > ue) {
                if ((ue = t.offset - ue) > t.whave && t.sane) {
                  e.msg = "invalid distance too far back", t.mode = J;
                  break;
                }

                ue > t.wnext ? (ue -= t.wnext, Ce = t.wsize - ue) : Ce = t.wnext - ue, ue > t.length && (ue = t.length), de = t.window;
              } else de = ne, Ce = oe - t.offset, ue = t.length;

              ue > Ae && (ue = Ae), Ae -= ue, t.length -= ue;

              do {
                ne[oe++] = de[Ce++];
              } while (--ue);

              0 === t.length && (t.mode = N);
              break;

            case X:
              if (0 === Ae) break e;
              ne[oe++] = t.length, Ae--, t.mode = N;
              break;

            case H:
              if (t.wrap) {
                for (; le < 32;) {
                  if (0 === ie) break e;
                  ie--, se |= ee[te++] << le, le += 8;
                }

                if (ce -= Ae, e.total_out += ce, t.total += ce, ce && (e.adler = t.check = t.flags ? i(t.check, ne, ce, oe - ce) : o(t.check, ne, ce, oe - ce)), ce = Ae, (t.flags ? se : re(se)) !== t.check) {
                  e.msg = "incorrect data check", t.mode = J;
                  break;
                }

                se = 0, le = 0;
              }

              t.mode = q;

            case q:
              if (t.wrap && t.flags) {
                for (; le < 32;) {
                  if (0 === ie) break e;
                  ie--, se += ee[te++] << le, le += 8;
                }

                if (se !== (4294967295 & t.total)) {
                  e.msg = "incorrect length check", t.mode = J;
                  break;
                }

                se = 0, le = 0;
              }

              t.mode = V;

            case V:
              Ee = d;
              break e;

            case J:
              Ee = x;
              break e;

            case Z:
              return g;

            case $:
            default:
              return h;
          }
        }

        return e.next_out = oe, e.avail_out = Ae, e.next_in = te, e.avail_in = ie, t.hold = se, t.bits = le, (t.wsize || ce !== e.avail_out && t.mode < J && (t.mode < H || n !== u)) && me(e, e.output, e.next_out, ce - e.avail_out) ? (t.mode = Z, g) : (ae -= e.avail_in, ce -= e.avail_out, e.total_in += ae, e.total_out += ce, t.total += ce, t.wrap && ce && (e.adler = t.check = t.flags ? i(t.check, ne, ce, e.next_out - ce) : o(t.check, ne, ce, e.next_out - ce)), e.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === T ? 128 : 0) + (t.mode === F || t.mode === Q ? 256 : 0), (0 === ae && 0 === ce || n === u) && Ee === C && (Ee = I), Ee);
      }, n.inflateEnd = function (e) {
        if (!e || !e.state) return h;
        var n = e.state;
        return n.window && (n.window = null), e.state = null, C;
      }, n.inflateGetHeader = function (e, n) {
        var t;
        return e && e.state ? 0 == (2 & (t = e.state).wrap) ? h : (t.head = n, n.done = !1, C) : h;
      }, n.inflateSetDictionary = function (e, n) {
        var t,
            r = n.length;
        return e && e.state ? 0 !== (t = e.state).wrap && t.mode !== k ? h : t.mode === k && o(1, n, r, 0) !== t.check ? x : me(e, n, r, r) ? (t.mode = Z, g) : (t.havedict = 1, C) : h;
      }, n.inflateInfo = "pako inflate (from Nodeca project)";
    }, function (e, n, t) {
      "use strict";

      e.exports = function (e, n) {
        var t, r, o, i, A, s, l, a, c, u, p, m, C, d, f, h, x, g, I, b, y, E, v, w, B;
        t = e.state, r = e.next_in, w = e.input, o = r + (e.avail_in - 5), i = e.next_out, B = e.output, A = i - (n - e.avail_out), s = i + (e.avail_out - 257), l = t.dmax, a = t.wsize, c = t.whave, u = t.wnext, p = t.window, m = t.hold, C = t.bits, d = t.lencode, f = t.distcode, h = (1 << t.lenbits) - 1, x = (1 << t.distbits) - 1;

        e: do {
          C < 15 && (m += w[r++] << C, C += 8, m += w[r++] << C, C += 8), g = d[m & h];

          n: for (;;) {
            if (m >>>= I = g >>> 24, C -= I, 0 == (I = g >>> 16 & 255)) B[i++] = 65535 & g;else {
              if (!(16 & I)) {
                if (0 == (64 & I)) {
                  g = d[(65535 & g) + (m & (1 << I) - 1)];
                  continue n;
                }

                if (32 & I) {
                  t.mode = 12;
                  break e;
                }

                e.msg = "invalid literal/length code", t.mode = 30;
                break e;
              }

              b = 65535 & g, (I &= 15) && (C < I && (m += w[r++] << C, C += 8), b += m & (1 << I) - 1, m >>>= I, C -= I), C < 15 && (m += w[r++] << C, C += 8, m += w[r++] << C, C += 8), g = f[m & x];

              t: for (;;) {
                if (m >>>= I = g >>> 24, C -= I, !(16 & (I = g >>> 16 & 255))) {
                  if (0 == (64 & I)) {
                    g = f[(65535 & g) + (m & (1 << I) - 1)];
                    continue t;
                  }

                  e.msg = "invalid distance code", t.mode = 30;
                  break e;
                }

                if (y = 65535 & g, C < (I &= 15) && (m += w[r++] << C, (C += 8) < I && (m += w[r++] << C, C += 8)), (y += m & (1 << I) - 1) > l) {
                  e.msg = "invalid distance too far back", t.mode = 30;
                  break e;
                }

                if (m >>>= I, C -= I, y > (I = i - A)) {
                  if ((I = y - I) > c && t.sane) {
                    e.msg = "invalid distance too far back", t.mode = 30;
                    break e;
                  }

                  if (E = 0, v = p, 0 === u) {
                    if (E += a - I, I < b) {
                      b -= I;

                      do {
                        B[i++] = p[E++];
                      } while (--I);

                      E = i - y, v = B;
                    }
                  } else if (u < I) {
                    if (E += a + u - I, (I -= u) < b) {
                      b -= I;

                      do {
                        B[i++] = p[E++];
                      } while (--I);

                      if (E = 0, u < b) {
                        b -= I = u;

                        do {
                          B[i++] = p[E++];
                        } while (--I);

                        E = i - y, v = B;
                      }
                    }
                  } else if (E += u - I, I < b) {
                    b -= I;

                    do {
                      B[i++] = p[E++];
                    } while (--I);

                    E = i - y, v = B;
                  }

                  for (; b > 2;) {
                    B[i++] = v[E++], B[i++] = v[E++], B[i++] = v[E++], b -= 3;
                  }

                  b && (B[i++] = v[E++], b > 1 && (B[i++] = v[E++]));
                } else {
                  E = i - y;

                  do {
                    B[i++] = B[E++], B[i++] = B[E++], B[i++] = B[E++], b -= 3;
                  } while (b > 2);

                  b && (B[i++] = B[E++], b > 1 && (B[i++] = B[E++]));
                }

                break;
              }
            }
            break;
          }
        } while (r < o && i < s);

        r -= b = C >> 3, m &= (1 << (C -= b << 3)) - 1, e.next_in = r, e.next_out = i, e.avail_in = r < o ? o - r + 5 : 5 - (r - o), e.avail_out = i < s ? s - i + 257 : 257 - (i - s), t.hold = m, t.bits = C;
      };
    }, function (e, n, t) {
      "use strict";

      var r = t(7),
          o = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
          i = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
          A = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
          s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

      e.exports = function (e, n, t, l, a, c, u, p) {
        var m,
            C,
            d,
            f,
            h,
            x,
            g,
            I,
            b,
            y = p.bits,
            E = 0,
            v = 0,
            w = 0,
            B = 0,
            _ = 0,
            D = 0,
            S = 0,
            M = 0,
            O = 0,
            k = 0,
            T = null,
            P = 0,
            K = new r.Buf16(16),
            Q = new r.Buf16(16),
            U = null,
            R = 0;

        for (E = 0; E <= 15; E++) {
          K[E] = 0;
        }

        for (v = 0; v < l; v++) {
          K[n[t + v]]++;
        }

        for (_ = y, B = 15; B >= 1 && 0 === K[B]; B--) {
          ;
        }

        if (_ > B && (_ = B), 0 === B) return a[c++] = 20971520, a[c++] = 20971520, p.bits = 1, 0;

        for (w = 1; w < B && 0 === K[w]; w++) {
          ;
        }

        for (_ < w && (_ = w), M = 1, E = 1; E <= 15; E++) {
          if (M <<= 1, (M -= K[E]) < 0) return -1;
        }

        if (M > 0 && (0 === e || 1 !== B)) return -1;

        for (Q[1] = 0, E = 1; E < 15; E++) {
          Q[E + 1] = Q[E] + K[E];
        }

        for (v = 0; v < l; v++) {
          0 !== n[t + v] && (u[Q[n[t + v]]++] = v);
        }

        if (0 === e ? (T = U = u, x = 19) : 1 === e ? (T = o, P -= 257, U = i, R -= 257, x = 256) : (T = A, U = s, x = -1), k = 0, v = 0, E = w, h = c, D = _, S = 0, d = -1, f = (O = 1 << _) - 1, 1 === e && O > 852 || 2 === e && O > 592) return 1;

        for (;;) {
          g = E - S, u[v] < x ? (I = 0, b = u[v]) : u[v] > x ? (I = U[R + u[v]], b = T[P + u[v]]) : (I = 96, b = 0), m = 1 << E - S, w = C = 1 << D;

          do {
            a[h + (k >> S) + (C -= m)] = g << 24 | I << 16 | b | 0;
          } while (0 !== C);

          for (m = 1 << E - 1; k & m;) {
            m >>= 1;
          }

          if (0 !== m ? (k &= m - 1, k += m) : k = 0, v++, 0 == --K[E]) {
            if (E === B) break;
            E = n[t + u[v]];
          }

          if (E > _ && (k & f) !== d) {
            for (0 === S && (S = _), h += w, M = 1 << (D = E - S); D + S < B && !((M -= K[D + S]) <= 0);) {
              D++, M <<= 1;
            }

            if (O += 1 << D, 1 === e && O > 852 || 2 === e && O > 592) return 1;
            a[d = k & f] = _ << 24 | D << 16 | h - c | 0;
          }
        }

        return 0 !== k && (a[h + k] = E - S << 24 | 64 << 16 | 0), p.bits = _, 0;
      };
    }, function (e, n, t) {
      "use strict";

      e.exports = function () {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = t(3),
          i = t(12),
          A = t(48),
          s = t(125),
          l = function l(e, n) {
        var t,
            r = "";

        for (t = 0; t < n; t++) {
          r += String.fromCharCode(255 & e), e >>>= 8;
        }

        return r;
      },
          a = function a(e, n, t, o, _a, c) {
        var u,
            p,
            m = e.file,
            C = e.compression,
            d = c !== i.utf8encode,
            f = r.transformTo("string", c(m.name)),
            h = r.transformTo("string", i.utf8encode(m.name)),
            x = m.comment,
            g = r.transformTo("string", c(x)),
            I = r.transformTo("string", i.utf8encode(x)),
            b = h.length !== m.name.length,
            y = I.length !== x.length,
            E = "",
            v = "",
            w = "",
            B = m.dir,
            _ = m.date,
            D = {
          crc32: 0,
          compressedSize: 0,
          uncompressedSize: 0
        };
        n && !t || (D.crc32 = e.crc32, D.compressedSize = e.compressedSize, D.uncompressedSize = e.uncompressedSize);
        var S = 0;
        n && (S |= 8), d || !b && !y || (S |= 2048);
        var M,
            O,
            k,
            T = 0,
            P = 0;
        B && (T |= 16), "UNIX" === _a ? (P = 798, T |= (M = m.unixPermissions, O = B, k = M, M || (k = O ? 16893 : 33204), (65535 & k) << 16)) : (P = 20, T |= 63 & (m.dosPermissions || 0)), u = _.getUTCHours(), u <<= 6, u |= _.getUTCMinutes(), u <<= 5, u |= _.getUTCSeconds() / 2, p = _.getUTCFullYear() - 1980, p <<= 4, p |= _.getUTCMonth() + 1, p <<= 5, p |= _.getUTCDate(), b && (v = l(1, 1) + l(A(f), 4) + h, E += "up" + l(v.length, 2) + v), y && (w = l(1, 1) + l(A(g), 4) + I, E += "uc" + l(w.length, 2) + w);
        var K = "";
        return K += "\n\0", K += l(S, 2), K += C.magic, K += l(u, 2), K += l(p, 2), K += l(D.crc32, 4), K += l(D.compressedSize, 4), K += l(D.uncompressedSize, 4), K += l(f.length, 2), K += l(E.length, 2), {
          fileRecord: s.LOCAL_FILE_HEADER + K + f + E,
          dirRecord: s.CENTRAL_FILE_HEADER + l(P, 2) + K + l(g.length, 2) + "\0\0\0\0" + l(T, 4) + l(o, 4) + f + E + g
        };
      },
          c = function c(e) {
        return s.DATA_DESCRIPTOR + l(e.crc32, 4) + l(e.compressedSize, 4) + l(e.uncompressedSize, 4);
      };

      function u(e, n, t, r) {
        o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = n, this.zipPlatform = t, this.encodeFileName = r, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }

      r.inherits(u, o), u.prototype.push = function (e) {
        var n = e.meta.percent || 0,
            t = this.entriesCount,
            r = this._sources.length;
        this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, o.prototype.push.call(this, {
          data: e.data,
          meta: {
            currentFile: this.currentFile,
            percent: t ? (n + 100 * (t - r - 1)) / t : 100
          }
        }));
      }, u.prototype.openedSource = function (e) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
        var n = this.streamFiles && !e.file.dir;

        if (n) {
          var t = a(e, n, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({
            data: t.fileRecord,
            meta: {
              percent: 0
            }
          });
        } else this.accumulate = !0;
      }, u.prototype.closedSource = function (e) {
        this.accumulate = !1;
        var n = this.streamFiles && !e.file.dir,
            t = a(e, n, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(t.dirRecord), n) this.push({
          data: c(e),
          meta: {
            percent: 100
          }
        });else for (this.push({
          data: t.fileRecord,
          meta: {
            percent: 0
          }
        }); this.contentBuffer.length;) {
          this.push(this.contentBuffer.shift());
        }
        this.currentFile = null;
      }, u.prototype.flush = function () {
        for (var e = this.bytesWritten, n = 0; n < this.dirRecords.length; n++) {
          this.push({
            data: this.dirRecords[n],
            meta: {
              percent: 100
            }
          });
        }

        var t = this.bytesWritten - e,
            o = function (e, n, t, o, i) {
          var A = r.transformTo("string", i(o));
          return s.CENTRAL_DIRECTORY_END + "\0\0\0\0" + l(e, 2) + l(e, 2) + l(n, 4) + l(t, 4) + l(A.length, 2) + A;
        }(this.dirRecords.length, t, e, this.zipComment, this.encodeFileName);

        this.push({
          data: o,
          meta: {
            percent: 100
          }
        });
      }, u.prototype.prepareNextSource = function () {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, u.prototype.registerPrevious = function (e) {
        this._sources.push(e);

        var n = this;
        return e.on("data", function (e) {
          n.processChunk(e);
        }), e.on("end", function () {
          n.closedSource(n.previous.streamInfo), n._sources.length ? n.prepareNextSource() : n.end();
        }), e.on("error", function (e) {
          n.error(e);
        }), this;
      }, u.prototype.resume = function () {
        return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, u.prototype.error = function (e) {
        var n = this._sources;
        if (!o.prototype.error.call(this, e)) return !1;

        for (var t = 0; t < n.length; t++) {
          try {
            n[t].error(e);
          } catch (e) {}
        }

        return !0;
      }, u.prototype.lock = function () {
        o.prototype.lock.call(this);

        for (var e = this._sources, n = 0; n < e.length; n++) {
          e[n].lock();
        }
      }, e.exports = u;
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = t(3);

      function i(e, n) {
        o.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(n);
      }

      r.inherits(i, o), i.prototype._bindStream = function (e) {
        var n = this;
        this._stream = e, e.pause(), e.on("data", function (e) {
          n.push({
            data: e,
            meta: {
              percent: 0
            }
          });
        }).on("error", function (e) {
          n.isPaused ? this.generatedError = e : n.error(e);
        }).on("end", function () {
          n.isPaused ? n._upstreamEnded = !0 : n.end();
        });
      }, i.prototype.pause = function () {
        return !!o.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, i.prototype.resume = function () {
        return !!o.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, e.exports = i;
    }, function (e, n, t) {
      "use strict";

      var r = t(1),
          o = t(17),
          i = t(12),
          A = (r = t(1), t(331)),
          s = t(118),
          l = t(24);

      function a(e) {
        return new o.Promise(function (n, t) {
          var r = e.decompressed.getContentWorker().pipe(new s());
          r.on("error", function (e) {
            t(e);
          }).on("end", function () {
            r.streamInfo.crc32 !== e.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : n();
          }).resume();
        });
      }

      e.exports = function (e, n) {
        var t = this;
        return n = r.extend(n || {}, {
          base64: !1,
          checkCRC32: !1,
          optimizedBinaryString: !1,
          createFolders: !1,
          decodeFileName: i.utf8decode
        }), l.isNode && l.isStream(e) ? o.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : r.prepareContent("the loaded zip file", e, !0, n.optimizedBinaryString, n.base64).then(function (e) {
          var t = new A(n);
          return t.load(e), t;
        }).then(function (e) {
          var t = [o.Promise.resolve(e)],
              r = e.files;
          if (n.checkCRC32) for (var i = 0; i < r.length; i++) {
            t.push(a(r[i]));
          }
          return o.Promise.all(t);
        }).then(function (e) {
          for (var r = e.shift(), o = r.files, i = 0; i < o.length; i++) {
            var A = o[i];
            t.file(A.fileNameStr, A.decompressed, {
              binary: !0,
              optimizedBinaryString: !0,
              date: A.date,
              dir: A.dir,
              comment: A.fileCommentStr.length ? A.fileCommentStr : null,
              unixPermissions: A.unixPermissions,
              dosPermissions: A.dosPermissions,
              createFolders: n.createFolders
            });
          }

          return r.zipComment.length && (t.comment = r.zipComment), t;
        });
      };
    }, function (e, n, t) {
      "use strict";

      var r = t(126),
          o = t(1),
          i = t(125),
          A = t(334),
          s = (t(12), t(6));

      function l(e) {
        this.files = [], this.loadOptions = e;
      }

      l.prototype = {
        checkSignature: function checkSignature(e) {
          if (!this.reader.readAndCheckSignature(e)) {
            this.reader.index -= 4;
            var n = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature (" + o.pretty(n) + ", expected " + o.pretty(e) + ")");
          }
        },
        isSignature: function isSignature(e, n) {
          var t = this.reader.index;
          this.reader.setIndex(e);
          var r = this.reader.readString(4) === n;
          return this.reader.setIndex(t), r;
        },
        readBlockEndOfCentral: function readBlockEndOfCentral() {
          this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
          var e = this.reader.readData(this.zipCommentLength),
              n = s.uint8array ? "uint8array" : "array",
              t = o.transformTo(n, e);
          this.zipComment = this.loadOptions.decodeFileName(t);
        },
        readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
          this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};

          for (var e, n, t, r = this.zip64EndOfCentralSize - 44; 0 < r;) {
            e = this.reader.readInt(2), n = this.reader.readInt(4), t = this.reader.readData(n), this.zip64ExtensibleData[e] = {
              id: e,
              length: n,
              value: t
            };
          }
        },
        readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
          if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), this.disksCount > 1) throw new Error("Multi-volumes zip are not supported");
        },
        readLocalFiles: function readLocalFiles() {
          var e, n;

          for (e = 0; e < this.files.length; e++) {
            n = this.files[e], this.reader.setIndex(n.localHeaderOffset), this.checkSignature(i.LOCAL_FILE_HEADER), n.readLocalPart(this.reader), n.handleUTF8(), n.processAttributes();
          }
        },
        readCentralDir: function readCentralDir() {
          var e;

          for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(i.CENTRAL_FILE_HEADER);) {
            (e = new A({
              zip64: this.zip64
            }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
          }

          if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
        },
        readEndOfCentral: function readEndOfCentral() {
          var e = this.reader.lastIndexOfSignature(i.CENTRAL_DIRECTORY_END);
          if (e < 0) throw this.isSignature(0, i.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
          this.reader.setIndex(e);
          var n = e;

          if (this.checkSignature(i.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === o.MAX_VALUE_16BITS || this.diskWithCentralDirStart === o.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === o.MAX_VALUE_16BITS || this.centralDirRecords === o.MAX_VALUE_16BITS || this.centralDirSize === o.MAX_VALUE_32BITS || this.centralDirOffset === o.MAX_VALUE_32BITS) {
            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(i.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            if (this.reader.setIndex(e), this.checkSignature(i.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, i.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(i.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(i.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
          }

          var t = this.centralDirOffset + this.centralDirSize;
          this.zip64 && (t += 20, t += 12 + this.zip64EndOfCentralSize);
          var r = n - t;
          if (r > 0) this.isSignature(n, i.CENTRAL_FILE_HEADER) || (this.reader.zero = r);else if (r < 0) throw new Error("Corrupted zip: missing " + Math.abs(r) + " bytes.");
        },
        prepareReader: function prepareReader(e) {
          this.reader = r(e);
        },
        load: function load(e) {
          this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
        }
      }, e.exports = l;
    }, function (e, n, t) {
      "use strict";

      var r = t(128);

      function o(e) {
        r.call(this, e);
      }

      t(1).inherits(o, r), o.prototype.byteAt = function (e) {
        return this.data.charCodeAt(this.zero + e);
      }, o.prototype.lastIndexOfSignature = function (e) {
        return this.data.lastIndexOf(e) - this.zero;
      }, o.prototype.readAndCheckSignature = function (e) {
        return e === this.readData(4);
      }, o.prototype.readData = function (e) {
        this.checkOffset(e);
        var n = this.data.slice(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, n;
      }, e.exports = o;
    }, function (e, n, t) {
      "use strict";

      var r = t(129);

      function o(e) {
        r.call(this, e);
      }

      t(1).inherits(o, r), o.prototype.readData = function (e) {
        this.checkOffset(e);
        var n = this.data.slice(this.zero + this.index, this.zero + this.index + e);
        return this.index += e, n;
      }, e.exports = o;
    }, function (e, n, t) {
      "use strict";

      var r = t(126),
          o = t(1),
          i = t(47),
          A = t(48),
          s = t(12),
          l = t(119),
          a = t(6);

      function c(e, n) {
        this.options = e, this.loadOptions = n;
      }

      c.prototype = {
        isEncrypted: function isEncrypted() {
          return 1 == (1 & this.bitFlag);
        },
        useUTF8: function useUTF8() {
          return 2048 == (2048 & this.bitFlag);
        },
        readLocalPart: function readLocalPart(e) {
          var n, t;
          if (e.skip(22), this.fileNameLength = e.readInt(2), t = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(t), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize === -1 || uncompressedSize === -1)");
          if (null === (n = function (e) {
            for (var n in l) {
              if (l.hasOwnProperty(n) && l[n].magic === e) return l[n];
            }

            return null;
          }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + o.pretty(this.compressionMethod) + " unknown (inner file : " + o.transformTo("string", this.fileName) + ")");
          this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, n, e.readData(this.compressedSize));
        },
        readCentralPart: function readCentralPart(e) {
          this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
          var n = e.readInt(2);
          if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
          e.skip(n), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
        },
        processAttributes: function processAttributes() {
          this.unixPermissions = null, this.dosPermissions = null;
          var e = this.versionMadeBy >> 8;
          this.dir = !!(16 & this.externalFileAttributes), 0 === e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 === e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
        },
        parseZIP64ExtraField: function parseZIP64ExtraField(e) {
          if (this.extraFields[1]) {
            var n = r(this.extraFields[1].value);
            this.uncompressedSize === o.MAX_VALUE_32BITS && (this.uncompressedSize = n.readInt(8)), this.compressedSize === o.MAX_VALUE_32BITS && (this.compressedSize = n.readInt(8)), this.localHeaderOffset === o.MAX_VALUE_32BITS && (this.localHeaderOffset = n.readInt(8)), this.diskNumberStart === o.MAX_VALUE_32BITS && (this.diskNumberStart = n.readInt(4));
          }
        },
        readExtraFields: function readExtraFields(e) {
          var n,
              t,
              r,
              o = e.index + this.extraFieldsLength;

          for (this.extraFields || (this.extraFields = {}); e.index < o;) {
            n = e.readInt(2), t = e.readInt(2), r = e.readData(t), this.extraFields[n] = {
              id: n,
              length: t,
              value: r
            };
          }
        },
        handleUTF8: function handleUTF8() {
          var e = a.uint8array ? "uint8array" : "array";
          if (this.useUTF8()) this.fileNameStr = s.utf8decode(this.fileName), this.fileCommentStr = s.utf8decode(this.fileComment);else {
            var n = this.findExtraFieldUnicodePath();
            if (null !== n) this.fileNameStr = n;else {
              var t = o.transformTo(e, this.fileName);
              this.fileNameStr = this.loadOptions.decodeFileName(t);
            }
            var r = this.findExtraFieldUnicodeComment();
            if (null !== r) this.fileCommentStr = r;else {
              var i = o.transformTo(e, this.fileComment);
              this.fileCommentStr = this.loadOptions.decodeFileName(i);
            }
          }
        },
        findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
          var e = this.extraFields[28789];

          if (e) {
            var n = r(e.value);
            return 1 !== n.readInt(1) ? null : A(this.fileName) !== n.readInt(4) ? null : s.utf8decode(n.readData(e.length - 5));
          }

          return null;
        },
        findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
          var e = this.extraFields[25461];

          if (e) {
            var n = r(e.value);
            return 1 !== n.readInt(1) ? null : A(this.fileComment) !== n.readInt(4) ? null : s.utf8decode(n.readData(e.length - 5));
          }

          return null;
        }
      }, e.exports = c;
    }, function (e, n, t) {
      (function (n) {
        var r = t(336),
            o = t(28).Stream,
            i = "    ";

        function A(e, n, t) {
          t = t || 0;
          var o,
              i,
              s = (o = n, new Array(t || 0).join(o || "")),
              l = e;
          if ("object" == typeof e && (l = e[i = Object.keys(e)[0]]) && l._elem) return l._elem.name = i, l._elem.icount = t, l._elem.indent = n, l._elem.indents = s, l._elem.interrupt = l, l._elem;
          var a,
              c = [],
              u = [];

          function p(e) {
            Object.keys(e).forEach(function (n) {
              c.push(function (e, n) {
                return e + '="' + r(n) + '"';
              }(n, e[n]));
            });
          }

          switch (typeof l) {
            case "object":
              if (null === l) break;
              l._attr && p(l._attr), l._cdata && u.push(("<![CDATA[" + l._cdata).replace(/\]\]>/g, "]]]]><![CDATA[>") + "]]>"), l.forEach && (a = !1, u.push(""), l.forEach(function (e) {
                "object" == typeof e ? "_attr" == Object.keys(e)[0] ? p(e._attr) : u.push(A(e, n, t + 1)) : (u.pop(), a = !0, u.push(r(e)));
              }), a || u.push(""));
              break;

            default:
              u.push(r(l));
          }

          return {
            name: i,
            interrupt: !1,
            attributes: c,
            content: u,
            icount: t,
            indents: s,
            indent: n
          };
        }

        function s(e, n, t) {
          if ("object" != typeof n) return e(!1, n);
          var r = n.interrupt ? 1 : n.content.length;

          function o() {
            for (; n.content.length;) {
              var o = n.content.shift();

              if (void 0 !== o) {
                if (i(o)) return;
                s(e, o);
              }
            }

            e(!1, (r > 1 ? n.indents : "") + (n.name ? "</" + n.name + ">" : "") + (n.indent && !t ? "\n" : "")), t && t();
          }

          function i(n) {
            return !!n.interrupt && (n.interrupt.append = e, n.interrupt.end = o, n.interrupt = !1, e(!0), !0);
          }

          if (e(!1, n.indents + (n.name ? "<" + n.name : "") + (n.attributes.length ? " " + n.attributes.join(" ") : "") + (r ? n.name ? ">" : "" : n.name ? "/>" : "") + (n.indent && r > 1 ? "\n" : "")), !r) return e(!1, n.indent ? "\n" : "");
          i(n) || o();
        }

        e.exports = function (e, t) {
          "object" != typeof t && (t = {
            indent: t
          });
          var r,
              l,
              a = t.stream ? new o() : null,
              c = "",
              u = !1,
              p = t.indent ? !0 === t.indent ? i : t.indent : "",
              m = !0;

          function C(e) {
            m ? n.nextTick(e) : e();
          }

          function d(e, n) {
            if (void 0 !== n && (c += n), e && !u && (a = a || new o(), u = !0), e && u) {
              var t = c;
              C(function () {
                a.emit("data", t);
              }), c = "";
            }
          }

          function f(e, n) {
            s(d, A(e, p, p ? 1 : 0), n);
          }

          function h() {
            if (a) {
              var e = c;
              C(function () {
                a.emit("data", e), a.emit("end"), a.readable = !1, a.emit("close");
              });
            }
          }

          return C(function () {
            m = !1;
          }), t.declaration && (r = t.declaration, l = {
            version: "1.0",
            encoding: r.encoding || "UTF-8"
          }, r.standalone && (l.standalone = r.standalone), f({
            "?xml": {
              _attr: l
            }
          }), c = c.replace("/>", "?>")), e && e.forEach ? e.forEach(function (n, t) {
            var r;
            t + 1 === e.length && (r = h), f(n, r);
          }) : f(e, h), a ? (a.readable = !0, a) : c;
        }, e.exports.element = e.exports.Element = function () {
          var e = {
            _elem: A(Array.prototype.slice.call(arguments)),
            push: function push(e) {
              if (!this.append) throw new Error("not assigned to a parent!");
              var n = this,
                  t = this._elem.indent;
              s(this.append, A(e, t, this._elem.icount + (t ? 1 : 0)), function () {
                n.append(!0);
              });
            },
            close: function close(e) {
              void 0 !== e && this.push(e), this.end && this.end();
            }
          };
          return e;
        };
      }).call(n, t(13));
    }, function (e, n) {
      var t = {
        "&": "&amp;",
        '"': "&quot;",
        "'": "&apos;",
        "<": "&lt;",
        ">": "&gt;"
      };

      e.exports = function (e) {
        return e && e.replace ? e.replace(/([&"<>'])/g, function (e, n) {
          return t[n];
        }) : e;
      };
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\formatter.ts", o = "99f2dc3369542f918eb81f5659b80e38d46facc0", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\export\\formatter.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 0
            },
            end: {
              line: 2,
              column: 62
            }
          },
          1: {
            start: {
              line: 5,
              column: 23
            },
            end: {
              line: 5,
              column: 41
            }
          },
          2: {
            start: {
              line: 6,
              column: 8
            },
            end: {
              line: 11,
              column: 9
            }
          },
          3: {
            start: {
              line: 7,
              column: 12
            },
            end: {
              line: 7,
              column: 26
            }
          },
          4: {
            start: {
              line: 10,
              column: 12
            },
            end: {
              line: 10,
              column: 65
            }
          },
          5: {
            start: {
              line: 14,
              column: 0
            },
            end: {
              line: 14,
              column: 30
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 4,
                column: 4
              },
              end: {
                line: 4,
                column: 5
              }
            },
            loc: {
              start: {
                line: 4,
                column: 18
              },
              end: {
                line: 12,
                column: 5
              }
            },
            line: 4
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 6,
                column: 8
              },
              end: {
                line: 11,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 6,
                column: 8
              },
              end: {
                line: 11,
                column: 9
              }
            }, {
              start: {
                line: 6,
                column: 8
              },
              end: {
                line: 11,
                column: 9
              }
            }],
            line: 6
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/export/formatter.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\export\\formatter.ts"],
          names: [],
          mappings: ";;AAEA;IACW,MAAM,CAAC,KAAuB;QACjC,MAAM,MAAM,GAAG,KAAK,CAAC,UAAU,EAAE,CAAC;QAElC,IAAI,MAAM,EAAE;YACR,OAAO,MAAM,CAAC;SACjB;aAAM;YACH,MAAM,KAAK,CAAC,uCAAuC,CAAC,CAAC;SACxD;IACL,CAAC;CACJ;AAVD,8BAUC",
          sourcesContent: ['import { BaseXmlComponent, IXmlableObject } from "file/xml-components";\r\n\r\nexport class Formatter {\r\n    public format(input: BaseXmlComponent): IXmlableObject {\r\n        const output = input.prepForXml();\r\n\r\n        if (output) {\r\n            return output;\r\n        } else {\r\n            throw Error("XMLComponent did not format correctly");\r\n        }\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[0]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[5]++, n.Formatter =
      /*#__PURE__*/
      function () {
        function _class51() {
          _classCallCheck(this, _class51);
        }

        _createClass(_class51, [{
          key: "format",
          value: function format(e) {
            a.f[0]++;
            var n = (a.s[1]++, e.prepForXml());
            if (a.s[2]++, n) return a.b[0][0]++, a.s[3]++, n;
            throw a.b[0][1]++, a.s[4]++, Error("XMLComponent did not format correctly");
          }
        }]);

        return _class51;
      }();
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\import-dotx\\index.ts", o = "29cc835114da21a4a4d2ff1b4f419c856a5131b6", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\import-dotx\\index.ts",
        statementMap: {
          0: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 3,
              column: 71
            }
          },
          1: {
            start: {
              line: 3,
              column: 21
            },
            end: {
              line: 3,
              column: 71
            }
          },
          2: {
            start: {
              line: 3,
              column: 53
            },
            end: {
              line: 3,
              column: 71
            }
          },
          3: {
            start: {
              line: 5,
              column: 0
            },
            end: {
              line: 5,
              column: 62
            }
          },
          4: {
            start: {
              line: 6,
              column: 0
            },
            end: {
              line: 6,
              column: 35
            }
          }
        },
        fnMap: {
          0: {
            name: "__export",
            decl: {
              start: {
                line: 2,
                column: 9
              },
              end: {
                line: 2,
                column: 17
              }
            },
            loc: {
              start: {
                line: 2,
                column: 21
              },
              end: {
                line: 4,
                column: 1
              }
            },
            line: 2
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }, {
              start: {
                line: 3,
                column: 21
              },
              end: {
                line: 3,
                column: 71
              }
            }],
            line: 3
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        f: {
          0: 0
        },
        b: {
          0: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/import-dotx/index.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\import-dotx\\index.ts"],
          names: [],
          mappings: ";;;;;AAAA,mCAA8B",
          sourcesContent: ['export * from "./import-dotx";\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s));
      a.s[3]++, Object.defineProperty(n, "__esModule", {
        value: !0
      }), a.s[4]++, function (e) {
        for (var t in a.f[0]++, a.s[0]++, e) {
          a.s[1]++, n.hasOwnProperty(t) ? a.b[0][1]++ : (a.b[0][0]++, a.s[2]++, n[t] = e[t]);
        }
      }(t(339));
    }, function (e, n, t) {
      "use strict";

      var r,
          o,
          i,
          A,
          s,
          l,
          a = (r = "C:\\Users\\Dolan\\Documents\\docx\\src\\import-dotx\\import-dotx.ts", o = "fe117fb9af1c980c5713bcae7a13211b4b2514fc", i = new (0, function () {}.constructor)("return this")(), s = {
        path: "C:\\Users\\Dolan\\Documents\\docx\\src\\import-dotx\\import-dotx.ts",
        statementMap: {
          0: {
            start: {
              line: 2,
              column: 16
            },
            end: {
              line: 9,
              column: 1
            }
          },
          1: {
            start: {
              line: 3,
              column: 4
            },
            end: {
              line: 8,
              column: 7
            }
          },
          2: {
            start: {
              line: 4,
              column: 36
            },
            end: {
              line: 4,
              column: 97
            }
          },
          3: {
            start: {
              line: 4,
              column: 42
            },
            end: {
              line: 4,
              column: 70
            }
          },
          4: {
            start: {
              line: 4,
              column: 85
            },
            end: {
              line: 4,
              column: 95
            }
          },
          5: {
            start: {
              line: 5,
              column: 35
            },
            end: {
              line: 5,
              column: 100
            }
          },
          6: {
            start: {
              line: 5,
              column: 41
            },
            end: {
              line: 5,
              column: 73
            }
          },
          7: {
            start: {
              line: 5,
              column: 88
            },
            end: {
              line: 5,
              column: 98
            }
          },
          8: {
            start: {
              line: 6,
              column: 32
            },
            end: {
              line: 6,
              column: 149
            }
          },
          9: {
            start: {
              line: 6,
              column: 97
            },
            end: {
              line: 6,
              column: 119
            }
          },
          10: {
            start: {
              line: 7,
              column: 8
            },
            end: {
              line: 7,
              column: 78
            }
          },
          11: {
            start: {
              line: 10,
              column: 0
            },
            end: {
              line: 10,
              column: 62
            }
          },
          12: {
            start: {
              line: 11,
              column: 14
            },
            end: {
              line: 11,
              column: 30
            }
          },
          13: {
            start: {
              line: 12,
              column: 17
            },
            end: {
              line: 12,
              column: 34
            }
          },
          14: {
            start: {
              line: 13,
              column: 25
            },
            end: {
              line: 13,
              column: 55
            }
          },
          15: {
            start: {
              line: 14,
              column: 25
            },
            end: {
              line: 14,
              column: 55
            }
          },
          16: {
            start: {
              line: 15,
              column: 25
            },
            end: {
              line: 15,
              column: 55
            }
          },
          17: {
            start: {
              line: 16,
              column: 16
            },
            end: {
              line: 16,
              column: 37
            }
          },
          18: {
            start: {
              line: 17,
              column: 34
            },
            end: {
              line: 17,
              column: 80
            }
          },
          19: {
            start: {
              line: 18,
              column: 21
            },
            end: {
              line: 23,
              column: 1
            }
          },
          20: {
            start: {
              line: 26,
              column: 8
            },
            end: {
              line: 26,
              column: 39
            }
          },
          21: {
            start: {
              line: 29,
              column: 8
            },
            end: {
              line: 92,
              column: 11
            }
          },
          22: {
            start: {
              line: 30,
              column: 31
            },
            end: {
              line: 30,
              column: 58
            }
          },
          23: {
            start: {
              line: 31,
              column: 34
            },
            end: {
              line: 31,
              column: 89
            }
          },
          24: {
            start: {
              line: 32,
              column: 34
            },
            end: {
              line: 32,
              column: 87
            }
          },
          25: {
            start: {
              line: 33,
              column: 27
            },
            end: {
              line: 33,
              column: 67
            }
          },
          26: {
            start: {
              line: 34,
              column: 36
            },
            end: {
              line: 34,
              column: 73
            }
          },
          27: {
            start: {
              line: 35,
              column: 33
            },
            end: {
              line: 35,
              column: 94
            }
          },
          28: {
            start: {
              line: 36,
              column: 39
            },
            end: {
              line: 36,
              column: 99
            }
          },
          29: {
            start: {
              line: 37,
              column: 40
            },
            end: {
              line: 37,
              column: 88
            }
          },
          30: {
            start: {
              line: 38,
              column: 42
            },
            end: {
              line: 38,
              column: 106
            }
          },
          31: {
            start: {
              line: 39,
              column: 26
            },
            end: {
              line: 39,
              column: 45
            }
          },
          32: {
            start: {
              line: 40,
              column: 28
            },
            end: {
              line: 40,
              column: 30
            }
          },
          33: {
            start: {
              line: 41,
              column: 12
            },
            end: {
              line: 61,
              column: 13
            }
          },
          34: {
            start: {
              line: 42,
              column: 41
            },
            end: {
              line: 42,
              column: 101
            }
          },
          35: {
            start: {
              line: 42,
              column: 77
            },
            end: {
              line: 42,
              column: 100
            }
          },
          36: {
            start: {
              line: 43,
              column: 16
            },
            end: {
              line: 45,
              column: 17
            }
          },
          37: {
            start: {
              line: 44,
              column: 20
            },
            end: {
              line: 44,
              column: 87
            }
          },
          38: {
            start: {
              line: 46,
              column: 32
            },
            end: {
              line: 46,
              column: 103
            }
          },
          39: {
            start: {
              line: 47,
              column: 31
            },
            end: {
              line: 47,
              column: 111
            }
          },
          40: {
            start: {
              line: 49,
              column: 16
            },
            end: {
              line: 53,
              column: 17
            }
          },
          41: {
            start: {
              line: 50,
              column: 20
            },
            end: {
              line: 52,
              column: 21
            }
          },
          42: {
            start: {
              line: 51,
              column: 24
            },
            end: {
              line: 51,
              column: 50
            }
          },
          43: {
            start: {
              line: 54,
              column: 16
            },
            end: {
              line: 56,
              column: 17
            }
          },
          44: {
            start: {
              line: 55,
              column: 20
            },
            end: {
              line: 55,
              column: 29
            }
          },
          45: {
            start: {
              line: 57,
              column: 37
            },
            end: {
              line: 57,
              column: 93
            }
          },
          46: {
            start: {
              line: 58,
              column: 31
            },
            end: {
              line: 58,
              column: 116
            }
          },
          47: {
            start: {
              line: 59,
              column: 16
            },
            end: {
              line: 59,
              column: 86
            }
          },
          48: {
            start: {
              line: 60,
              column: 16
            },
            end: {
              line: 60,
              column: 63
            }
          },
          49: {
            start: {
              line: 62,
              column: 28
            },
            end: {
              line: 62,
              column: 30
            }
          },
          50: {
            start: {
              line: 63,
              column: 12
            },
            end: {
              line: 83,
              column: 13
            }
          },
          51: {
            start: {
              line: 64,
              column: 41
            },
            end: {
              line: 64,
              column: 101
            }
          },
          52: {
            start: {
              line: 64,
              column: 77
            },
            end: {
              line: 64,
              column: 100
            }
          },
          53: {
            start: {
              line: 65,
              column: 16
            },
            end: {
              line: 67,
              column: 17
            }
          },
          54: {
            start: {
              line: 66,
              column: 20
            },
            end: {
              line: 66,
              column: 87
            }
          },
          55: {
            start: {
              line: 68,
              column: 32
            },
            end: {
              line: 68,
              column: 103
            }
          },
          56: {
            start: {
              line: 69,
              column: 31
            },
            end: {
              line: 69,
              column: 111
            }
          },
          57: {
            start: {
              line: 71,
              column: 16
            },
            end: {
              line: 75,
              column: 17
            }
          },
          58: {
            start: {
              line: 72,
              column: 20
            },
            end: {
              line: 74,
              column: 21
            }
          },
          59: {
            start: {
              line: 73,
              column: 24
            },
            end: {
              line: 73,
              column: 50
            }
          },
          60: {
            start: {
              line: 76,
              column: 16
            },
            end: {
              line: 78,
              column: 17
            }
          },
          61: {
            start: {
              line: 77,
              column: 20
            },
            end: {
              line: 77,
              column: 29
            }
          },
          62: {
            start: {
              line: 79,
              column: 37
            },
            end: {
              line: 79,
              column: 93
            }
          },
          63: {
            start: {
              line: 80,
              column: 31
            },
            end: {
              line: 80,
              column: 116
            }
          },
          64: {
            start: {
              line: 81,
              column: 16
            },
            end: {
              line: 81,
              column: 86
            }
          },
          65: {
            start: {
              line: 82,
              column: 16
            },
            end: {
              line: 82,
              column: 63
            }
          },
          66: {
            start: {
              line: 84,
              column: 37
            },
            end: {
              line: 90,
              column: 13
            }
          },
          67: {
            start: {
              line: 91,
              column: 12
            },
            end: {
              line: 91,
              column: 36
            }
          },
          68: {
            start: {
              line: 95,
              column: 8
            },
            end: {
              line: 111,
              column: 11
            }
          },
          69: {
            start: {
              line: 96,
              column: 42
            },
            end: {
              line: 96,
              column: 44
            }
          },
          70: {
            start: {
              line: 97,
              column: 38
            },
            end: {
              line: 97,
              column: 40
            }
          },
          71: {
            start: {
              line: 98,
              column: 28
            },
            end: {
              line: 98,
              column: 89
            }
          },
          72: {
            start: {
              line: 99,
              column: 12
            },
            end: {
              line: 103,
              column: 13
            }
          },
          73: {
            start: {
              line: 100,
              column: 31
            },
            end: {
              line: 100,
              column: 58
            }
          },
          74: {
            start: {
              line: 101,
              column: 16
            },
            end: {
              line: 101,
              column: 108
            }
          },
          75: {
            start: {
              line: 101,
              column: 88
            },
            end: {
              line: 101,
              column: 106
            }
          },
          76: {
            start: {
              line: 102,
              column: 16
            },
            end: {
              line: 102,
              column: 108
            }
          },
          77: {
            start: {
              line: 102,
              column: 84
            },
            end: {
              line: 102,
              column: 106
            }
          },
          78: {
            start: {
              line: 104,
              column: 12
            },
            end: {
              line: 107,
              column: 13
            }
          },
          79: {
            start: {
              line: 105,
              column: 31
            },
            end: {
              line: 105,
              column: 93
            }
          },
          80: {
            start: {
              line: 106,
              column: 16
            },
            end: {
              line: 106,
              column: 59
            }
          },
          81: {
            start: {
              line: 108,
              column: 12
            },
            end: {
              line: 110,
              column: 13
            }
          },
          82: {
            start: {
              line: 109,
              column: 16
            },
            end: {
              line: 109,
              column: 77
            }
          },
          83: {
            start: {
              line: 114,
              column: 23
            },
            end: {
              line: 114,
              column: 66
            }
          },
          84: {
            start: {
              line: 115,
              column: 33
            },
            end: {
              line: 117,
              column: 49
            }
          },
          85: {
            start: {
              line: 118,
              column: 30
            },
            end: {
              line: 129,
              column: 49
            }
          },
          86: {
            start: {
              line: 120,
              column: 12
            },
            end: {
              line: 122,
              column: 13
            }
          },
          87: {
            start: {
              line: 121,
              column: 16
            },
            end: {
              line: 121,
              column: 70
            }
          },
          88: {
            start: {
              line: 123,
              column: 12
            },
            end: {
              line: 127,
              column: 14
            }
          },
          89: {
            start: {
              line: 129,
              column: 30
            },
            end: {
              line: 129,
              column: 48
            }
          },
          90: {
            start: {
              line: 130,
              column: 8
            },
            end: {
              line: 130,
              column: 29
            }
          },
          91: {
            start: {
              line: 133,
              column: 23
            },
            end: {
              line: 133,
              column: 66
            }
          },
          92: {
            start: {
              line: 134,
              column: 28
            },
            end: {
              line: 134,
              column: 70
            }
          },
          93: {
            start: {
              line: 135,
              column: 28
            },
            end: {
              line: 135,
              column: 60
            }
          },
          94: {
            start: {
              line: 137,
              column: 8
            },
            end: {
              line: 145,
              column: 9
            }
          },
          95: {
            start: {
              line: 138,
              column: 12
            },
            end: {
              line: 138,
              column: 33
            }
          },
          96: {
            start: {
              line: 140,
              column: 13
            },
            end: {
              line: 145,
              column: 9
            }
          },
          97: {
            start: {
              line: 141,
              column: 12
            },
            end: {
              line: 141,
              column: 42
            }
          },
          98: {
            start: {
              line: 144,
              column: 12
            },
            end: {
              line: 144,
              column: 44
            }
          },
          99: {
            start: {
              line: 146,
              column: 24
            },
            end: {
              line: 154,
              column: 10
            }
          },
          100: {
            start: {
              line: 147,
              column: 12
            },
            end: {
              line: 149,
              column: 13
            }
          },
          101: {
            start: {
              line: 148,
              column: 16
            },
            end: {
              line: 148,
              column: 74
            }
          },
          102: {
            start: {
              line: 150,
              column: 12
            },
            end: {
              line: 153,
              column: 14
            }
          },
          103: {
            start: {
              line: 155,
              column: 28
            },
            end: {
              line: 155,
              column: 60
            }
          },
          104: {
            start: {
              line: 157,
              column: 8
            },
            end: {
              line: 165,
              column: 9
            }
          },
          105: {
            start: {
              line: 158,
              column: 12
            },
            end: {
              line: 158,
              column: 33
            }
          },
          106: {
            start: {
              line: 160,
              column: 13
            },
            end: {
              line: 165,
              column: 9
            }
          },
          107: {
            start: {
              line: 161,
              column: 12
            },
            end: {
              line: 161,
              column: 42
            }
          },
          108: {
            start: {
              line: 164,
              column: 12
            },
            end: {
              line: 164,
              column: 44
            }
          },
          109: {
            start: {
              line: 166,
              column: 24
            },
            end: {
              line: 174,
              column: 10
            }
          },
          110: {
            start: {
              line: 167,
              column: 12
            },
            end: {
              line: 169,
              column: 13
            }
          },
          111: {
            start: {
              line: 168,
              column: 16
            },
            end: {
              line: 168,
              column: 74
            }
          },
          112: {
            start: {
              line: 170,
              column: 12
            },
            end: {
              line: 173,
              column: 14
            }
          },
          113: {
            start: {
              line: 175,
              column: 8
            },
            end: {
              line: 175,
              column: 36
            }
          },
          114: {
            start: {
              line: 178,
              column: 23
            },
            end: {
              line: 178,
              column: 66
            }
          },
          115: {
            start: {
              line: 179,
              column: 28
            },
            end: {
              line: 179,
              column: 70
            }
          },
          116: {
            start: {
              line: 180,
              column: 8
            },
            end: {
              line: 180,
              column: 54
            }
          },
          117: {
            start: {
              line: 183,
              column: 22
            },
            end: {
              line: 183,
              column: 44
            }
          },
          118: {
            start: {
              line: 184,
              column: 8
            },
            end: {
              line: 186,
              column: 9
            }
          },
          119: {
            start: {
              line: 185,
              column: 12
            },
            end: {
              line: 185,
              column: 46
            }
          },
          120: {
            start: {
              line: 187,
              column: 8
            },
            end: {
              line: 187,
              column: 38
            }
          },
          121: {
            start: {
              line: 190,
              column: 0
            },
            end: {
              line: 190,
              column: 32
            }
          }
        },
        fnMap: {
          0: {
            name: "(anonymous_0)",
            decl: {
              start: {
                line: 2,
                column: 44
              },
              end: {
                line: 2,
                column: 45
              }
            },
            loc: {
              start: {
                line: 2,
                column: 89
              },
              end: {
                line: 9,
                column: 1
              }
            },
            line: 2
          },
          1: {
            name: "(anonymous_1)",
            decl: {
              start: {
                line: 3,
                column: 36
              },
              end: {
                line: 3,
                column: 37
              }
            },
            loc: {
              start: {
                line: 3,
                column: 63
              },
              end: {
                line: 8,
                column: 5
              }
            },
            line: 3
          },
          2: {
            name: "fulfilled",
            decl: {
              start: {
                line: 4,
                column: 17
              },
              end: {
                line: 4,
                column: 26
              }
            },
            loc: {
              start: {
                line: 4,
                column: 34
              },
              end: {
                line: 4,
                column: 99
              }
            },
            line: 4
          },
          3: {
            name: "rejected",
            decl: {
              start: {
                line: 5,
                column: 17
              },
              end: {
                line: 5,
                column: 25
              }
            },
            loc: {
              start: {
                line: 5,
                column: 33
              },
              end: {
                line: 5,
                column: 102
              }
            },
            line: 5
          },
          4: {
            name: "step",
            decl: {
              start: {
                line: 6,
                column: 17
              },
              end: {
                line: 6,
                column: 21
              }
            },
            loc: {
              start: {
                line: 6,
                column: 30
              },
              end: {
                line: 6,
                column: 151
              }
            },
            line: 6
          },
          5: {
            name: "(anonymous_5)",
            decl: {
              start: {
                line: 6,
                column: 76
              },
              end: {
                line: 6,
                column: 77
              }
            },
            loc: {
              start: {
                line: 6,
                column: 95
              },
              end: {
                line: 6,
                column: 121
              }
            },
            line: 6
          },
          6: {
            name: "(anonymous_6)",
            decl: {
              start: {
                line: 25,
                column: 4
              },
              end: {
                line: 25,
                column: 5
              }
            },
            loc: {
              start: {
                line: 25,
                column: 18
              },
              end: {
                line: 27,
                column: 5
              }
            },
            line: 25
          },
          7: {
            name: "(anonymous_7)",
            decl: {
              start: {
                line: 28,
                column: 4
              },
              end: {
                line: 28,
                column: 5
              }
            },
            loc: {
              start: {
                line: 28,
                column: 18
              },
              end: {
                line: 93,
                column: 5
              }
            },
            line: 28
          },
          8: {
            name: "(anonymous_8)",
            decl: {
              start: {
                line: 29,
                column: 47
              },
              end: {
                line: 29,
                column: 48
              }
            },
            loc: {
              start: {
                line: 29,
                column: 60
              },
              end: {
                line: 92,
                column: 9
              }
            },
            line: 29
          },
          9: {
            name: "(anonymous_9)",
            decl: {
              start: {
                line: 42,
                column: 68
              },
              end: {
                line: 42,
                column: 69
              }
            },
            loc: {
              start: {
                line: 42,
                column: 77
              },
              end: {
                line: 42,
                column: 100
              }
            },
            line: 42
          },
          10: {
            name: "(anonymous_10)",
            decl: {
              start: {
                line: 64,
                column: 68
              },
              end: {
                line: 64,
                column: 69
              }
            },
            loc: {
              start: {
                line: 64,
                column: 77
              },
              end: {
                line: 64,
                column: 100
              }
            },
            line: 64
          },
          11: {
            name: "(anonymous_11)",
            decl: {
              start: {
                line: 94,
                column: 4
              },
              end: {
                line: 94,
                column: 5
              }
            },
            loc: {
              start: {
                line: 94,
                column: 63
              },
              end: {
                line: 112,
                column: 5
              }
            },
            line: 94
          },
          12: {
            name: "(anonymous_12)",
            decl: {
              start: {
                line: 95,
                column: 47
              },
              end: {
                line: 95,
                column: 48
              }
            },
            loc: {
              start: {
                line: 95,
                column: 60
              },
              end: {
                line: 111,
                column: 9
              }
            },
            line: 95
          },
          13: {
            name: "(anonymous_13)",
            decl: {
              start: {
                line: 101,
                column: 81
              },
              end: {
                line: 101,
                column: 82
              }
            },
            loc: {
              start: {
                line: 101,
                column: 88
              },
              end: {
                line: 101,
                column: 106
              }
            },
            line: 101
          },
          14: {
            name: "(anonymous_14)",
            decl: {
              start: {
                line: 102,
                column: 77
              },
              end: {
                line: 102,
                column: 78
              }
            },
            loc: {
              start: {
                line: 102,
                column: 84
              },
              end: {
                line: 102,
                column: 106
              }
            },
            line: 102
          },
          15: {
            name: "(anonymous_15)",
            decl: {
              start: {
                line: 113,
                column: 4
              },
              end: {
                line: 113,
                column: 5
              }
            },
            loc: {
              start: {
                line: 113,
                column: 32
              },
              end: {
                line: 131,
                column: 5
              }
            },
            line: 113
          },
          16: {
            name: "(anonymous_16)",
            decl: {
              start: {
                line: 119,
                column: 17
              },
              end: {
                line: 119,
                column: 18
              }
            },
            loc: {
              start: {
                line: 119,
                column: 27
              },
              end: {
                line: 128,
                column: 9
              }
            },
            line: 119
          },
          17: {
            name: "(anonymous_17)",
            decl: {
              start: {
                line: 129,
                column: 20
              },
              end: {
                line: 129,
                column: 21
              }
            },
            loc: {
              start: {
                line: 129,
                column: 30
              },
              end: {
                line: 129,
                column: 48
              }
            },
            line: 129
          },
          18: {
            name: "(anonymous_18)",
            decl: {
              start: {
                line: 132,
                column: 4
              },
              end: {
                line: 132,
                column: 5
              }
            },
            loc: {
              start: {
                line: 132,
                column: 33
              },
              end: {
                line: 176,
                column: 5
              }
            },
            line: 132
          },
          19: {
            name: "(anonymous_19)",
            decl: {
              start: {
                line: 146,
                column: 44
              },
              end: {
                line: 146,
                column: 45
              }
            },
            loc: {
              start: {
                line: 146,
                column: 54
              },
              end: {
                line: 154,
                column: 9
              }
            },
            line: 146
          },
          20: {
            name: "(anonymous_20)",
            decl: {
              start: {
                line: 166,
                column: 44
              },
              end: {
                line: 166,
                column: 45
              }
            },
            loc: {
              start: {
                line: 166,
                column: 54
              },
              end: {
                line: 174,
                column: 9
              }
            },
            line: 166
          },
          21: {
            name: "(anonymous_21)",
            decl: {
              start: {
                line: 177,
                column: 4
              },
              end: {
                line: 177,
                column: 5
              }
            },
            loc: {
              start: {
                line: 177,
                column: 32
              },
              end: {
                line: 181,
                column: 5
              }
            },
            line: 177
          },
          22: {
            name: "(anonymous_22)",
            decl: {
              start: {
                line: 182,
                column: 4
              },
              end: {
                line: 182,
                column: 5
              }
            },
            loc: {
              start: {
                line: 182,
                column: 20
              },
              end: {
                line: 188,
                column: 5
              }
            },
            line: 182
          }
        },
        branchMap: {
          0: {
            loc: {
              start: {
                line: 2,
                column: 16
              },
              end: {
                line: 9,
                column: 1
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 2,
                column: 17
              },
              end: {
                line: 2,
                column: 21
              }
            }, {
              start: {
                line: 2,
                column: 25
              },
              end: {
                line: 2,
                column: 39
              }
            }, {
              start: {
                line: 2,
                column: 44
              },
              end: {
                line: 9,
                column: 1
              }
            }],
            line: 2
          },
          1: {
            loc: {
              start: {
                line: 3,
                column: 16
              },
              end: {
                line: 3,
                column: 34
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 3,
                column: 16
              },
              end: {
                line: 3,
                column: 17
              }
            }, {
              start: {
                line: 3,
                column: 22
              },
              end: {
                line: 3,
                column: 33
              }
            }],
            line: 3
          },
          2: {
            loc: {
              start: {
                line: 6,
                column: 32
              },
              end: {
                line: 6,
                column: 148
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 6,
                column: 46
              },
              end: {
                line: 6,
                column: 67
              }
            }, {
              start: {
                line: 6,
                column: 70
              },
              end: {
                line: 6,
                column: 148
              }
            }],
            line: 6
          },
          3: {
            loc: {
              start: {
                line: 7,
                column: 51
              },
              end: {
                line: 7,
                column: 67
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 7,
                column: 51
              },
              end: {
                line: 7,
                column: 61
              }
            }, {
              start: {
                line: 7,
                column: 65
              },
              end: {
                line: 7,
                column: 67
              }
            }],
            line: 7
          },
          4: {
            loc: {
              start: {
                line: 43,
                column: 16
              },
              end: {
                line: 45,
                column: 17
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 43,
                column: 16
              },
              end: {
                line: 45,
                column: 17
              }
            }, {
              start: {
                line: 43,
                column: 16
              },
              end: {
                line: 45,
                column: 17
              }
            }],
            line: 43
          },
          5: {
            loc: {
              start: {
                line: 43,
                column: 20
              },
              end: {
                line: 43,
                column: 66
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 43,
                column: 20
              },
              end: {
                line: 43,
                column: 45
              }
            }, {
              start: {
                line: 43,
                column: 49
              },
              end: {
                line: 43,
                column: 66
              }
            }],
            line: 43
          },
          6: {
            loc: {
              start: {
                line: 49,
                column: 37
              },
              end: {
                line: 49,
                column: 58
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 49,
                column: 37
              },
              end: {
                line: 49,
                column: 52
              }
            }, {
              start: {
                line: 49,
                column: 56
              },
              end: {
                line: 49,
                column: 58
              }
            }],
            line: 49
          },
          7: {
            loc: {
              start: {
                line: 50,
                column: 20
              },
              end: {
                line: 52,
                column: 21
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 50,
                column: 20
              },
              end: {
                line: 52,
                column: 21
              }
            }, {
              start: {
                line: 50,
                column: 20
              },
              end: {
                line: 52,
                column: 21
              }
            }],
            line: 50
          },
          8: {
            loc: {
              start: {
                line: 54,
                column: 16
              },
              end: {
                line: 56,
                column: 17
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 54,
                column: 16
              },
              end: {
                line: 56,
                column: 17
              }
            }, {
              start: {
                line: 54,
                column: 16
              },
              end: {
                line: 56,
                column: 17
              }
            }],
            line: 54
          },
          9: {
            loc: {
              start: {
                line: 65,
                column: 16
              },
              end: {
                line: 67,
                column: 17
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 65,
                column: 16
              },
              end: {
                line: 67,
                column: 17
              }
            }, {
              start: {
                line: 65,
                column: 16
              },
              end: {
                line: 67,
                column: 17
              }
            }],
            line: 65
          },
          10: {
            loc: {
              start: {
                line: 65,
                column: 20
              },
              end: {
                line: 65,
                column: 66
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 65,
                column: 20
              },
              end: {
                line: 65,
                column: 45
              }
            }, {
              start: {
                line: 65,
                column: 49
              },
              end: {
                line: 65,
                column: 66
              }
            }],
            line: 65
          },
          11: {
            loc: {
              start: {
                line: 71,
                column: 37
              },
              end: {
                line: 71,
                column: 58
              }
            },
            type: "binary-expr",
            locations: [{
              start: {
                line: 71,
                column: 37
              },
              end: {
                line: 71,
                column: 52
              }
            }, {
              start: {
                line: 71,
                column: 56
              },
              end: {
                line: 71,
                column: 58
              }
            }],
            line: 71
          },
          12: {
            loc: {
              start: {
                line: 72,
                column: 20
              },
              end: {
                line: 74,
                column: 21
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 72,
                column: 20
              },
              end: {
                line: 74,
                column: 21
              }
            }, {
              start: {
                line: 72,
                column: 20
              },
              end: {
                line: 74,
                column: 21
              }
            }],
            line: 72
          },
          13: {
            loc: {
              start: {
                line: 76,
                column: 16
              },
              end: {
                line: 78,
                column: 17
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 76,
                column: 16
              },
              end: {
                line: 78,
                column: 17
              }
            }, {
              start: {
                line: 76,
                column: 16
              },
              end: {
                line: 78,
                column: 17
              }
            }],
            line: 76
          },
          14: {
            loc: {
              start: {
                line: 99,
                column: 12
              },
              end: {
                line: 103,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 99,
                column: 12
              },
              end: {
                line: 103,
                column: 13
              }
            }, {
              start: {
                line: 99,
                column: 12
              },
              end: {
                line: 103,
                column: 13
              }
            }],
            line: 99
          },
          15: {
            loc: {
              start: {
                line: 115,
                column: 33
              },
              end: {
                line: 117,
                column: 49
              }
            },
            type: "cond-expr",
            locations: [{
              start: {
                line: 116,
                column: 14
              },
              end: {
                line: 116,
                column: 47
              }
            }, {
              start: {
                line: 117,
                column: 14
              },
              end: {
                line: 117,
                column: 49
              }
            }],
            line: 115
          },
          16: {
            loc: {
              start: {
                line: 120,
                column: 12
              },
              end: {
                line: 122,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 120,
                column: 12
              },
              end: {
                line: 122,
                column: 13
              }
            }, {
              start: {
                line: 120,
                column: 12
              },
              end: {
                line: 122,
                column: 13
              }
            }],
            line: 120
          },
          17: {
            loc: {
              start: {
                line: 137,
                column: 8
              },
              end: {
                line: 145,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 137,
                column: 8
              },
              end: {
                line: 145,
                column: 9
              }
            }, {
              start: {
                line: 137,
                column: 8
              },
              end: {
                line: 145,
                column: 9
              }
            }],
            line: 137
          },
          18: {
            loc: {
              start: {
                line: 140,
                column: 13
              },
              end: {
                line: 145,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 140,
                column: 13
              },
              end: {
                line: 145,
                column: 9
              }
            }, {
              start: {
                line: 140,
                column: 13
              },
              end: {
                line: 145,
                column: 9
              }
            }],
            line: 140
          },
          19: {
            loc: {
              start: {
                line: 147,
                column: 12
              },
              end: {
                line: 149,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 147,
                column: 12
              },
              end: {
                line: 149,
                column: 13
              }
            }, {
              start: {
                line: 147,
                column: 12
              },
              end: {
                line: 149,
                column: 13
              }
            }],
            line: 147
          },
          20: {
            loc: {
              start: {
                line: 157,
                column: 8
              },
              end: {
                line: 165,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 157,
                column: 8
              },
              end: {
                line: 165,
                column: 9
              }
            }, {
              start: {
                line: 157,
                column: 8
              },
              end: {
                line: 165,
                column: 9
              }
            }],
            line: 157
          },
          21: {
            loc: {
              start: {
                line: 160,
                column: 13
              },
              end: {
                line: 165,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 160,
                column: 13
              },
              end: {
                line: 165,
                column: 9
              }
            }, {
              start: {
                line: 160,
                column: 13
              },
              end: {
                line: 165,
                column: 9
              }
            }],
            line: 160
          },
          22: {
            loc: {
              start: {
                line: 167,
                column: 12
              },
              end: {
                line: 169,
                column: 13
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 167,
                column: 12
              },
              end: {
                line: 169,
                column: 13
              }
            }, {
              start: {
                line: 167,
                column: 12
              },
              end: {
                line: 169,
                column: 13
              }
            }],
            line: 167
          },
          23: {
            loc: {
              start: {
                line: 184,
                column: 8
              },
              end: {
                line: 186,
                column: 9
              }
            },
            type: "if",
            locations: [{
              start: {
                line: 184,
                column: 8
              },
              end: {
                line: 186,
                column: 9
              }
            }, {
              start: {
                line: 184,
                column: 8
              },
              end: {
                line: 186,
                column: 9
              }
            }],
            line: 184
          }
        },
        s: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
          39: 0,
          40: 0,
          41: 0,
          42: 0,
          43: 0,
          44: 0,
          45: 0,
          46: 0,
          47: 0,
          48: 0,
          49: 0,
          50: 0,
          51: 0,
          52: 0,
          53: 0,
          54: 0,
          55: 0,
          56: 0,
          57: 0,
          58: 0,
          59: 0,
          60: 0,
          61: 0,
          62: 0,
          63: 0,
          64: 0,
          65: 0,
          66: 0,
          67: 0,
          68: 0,
          69: 0,
          70: 0,
          71: 0,
          72: 0,
          73: 0,
          74: 0,
          75: 0,
          76: 0,
          77: 0,
          78: 0,
          79: 0,
          80: 0,
          81: 0,
          82: 0,
          83: 0,
          84: 0,
          85: 0,
          86: 0,
          87: 0,
          88: 0,
          89: 0,
          90: 0,
          91: 0,
          92: 0,
          93: 0,
          94: 0,
          95: 0,
          96: 0,
          97: 0,
          98: 0,
          99: 0,
          100: 0,
          101: 0,
          102: 0,
          103: 0,
          104: 0,
          105: 0,
          106: 0,
          107: 0,
          108: 0,
          109: 0,
          110: 0,
          111: 0,
          112: 0,
          113: 0,
          114: 0,
          115: 0,
          116: 0,
          117: 0,
          118: 0,
          119: 0,
          120: 0,
          121: 0
        },
        f: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0
        },
        b: {
          0: [0, 0, 0],
          1: [0, 0],
          2: [0, 0],
          3: [0, 0],
          4: [0, 0],
          5: [0, 0],
          6: [0, 0],
          7: [0, 0],
          8: [0, 0],
          9: [0, 0],
          10: [0, 0],
          11: [0, 0],
          12: [0, 0],
          13: [0, 0],
          14: [0, 0],
          15: [0, 0],
          16: [0, 0],
          17: [0, 0],
          18: [0, 0],
          19: [0, 0],
          20: [0, 0],
          21: [0, 0],
          22: [0, 0],
          23: [0, 0]
        },
        inputSourceMap: {
          version: 3,
          file: "C:/Users/Dolan/Documents/docx/src/import-dotx/import-dotx.ts",
          sourceRoot: "C:/Users/Dolan/Documents/docx/",
          sources: ["src\\import-dotx\\import-dotx.ts"],
          names: [],
          mappings: ";;;;;;;;;;AAAA,+BAA+B;AAC/B,mCAA4F;AAI5F,wDAAqE;AACrE,wDAAqE;AACrE,wDAAkF;AAElF,sCAAmC;AAEnC,iFAA4E;AAE5E,MAAM,YAAY,GAAG;IACjB,4EAA4E,EAAE,QAAQ;IACtF,4EAA4E,EAAE,QAAQ;IACtF,2EAA2E,EAAE,OAAO;IACpF,+EAA+E,EAAE,WAAW;CAC/F,CAAC;AAuBF;IAII;QACI,IAAI,CAAC,qBAAqB,GAAG,CAAC,CAAC;IACnC,CAAC;IAEY,OAAO,CAAC,IAAY;;YAC7B,MAAM,UAAU,GAAG,MAAM,KAAK,CAAC,SAAS,CAAC,IAAI,CAAC,CAAC;YAE/C,MAAM,aAAa,GAAG,MAAM,UAAU,CAAC,KAAK,CAAC,iBAAiB,CAAC,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC;YAC9E,MAAM,aAAa,GAAG,IAAI,+CAAqB,EAAE,CAAC;YAClD,MAAM,MAAM,GAAG,aAAa,CAAC,WAAW,CAAC,aAAa,CAAC,CAAC;YAExD,MAAM,eAAe,GAAG,UAAU,CAAC,KAAK,CAAC,mBAAmB,CAAC,CAAC;YAC9D,MAAM,YAAY,GAAkB,IAAI,CAAC,mBAAmB,CAAC,MAAM,eAAe,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC,CAAC;YAClG,MAAM,kBAAkB,GAAG,IAAI,CAAC,kBAAkB,CAAC,MAAM,eAAe,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC,CAAC;YAExF,MAAM,mBAAmB,GAAG,UAAU,CAAC,KAAK,CAAC,8BAA8B,CAAC,CAAC;YAC7E,MAAM,qBAAqB,GAA4B,IAAI,CAAC,kBAAkB,CAAC,MAAM,mBAAmB,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC,CAAC;YAExH,MAAM,KAAK,GAAG,IAAI,aAAK,EAAE,CAAC;YAE1B,MAAM,OAAO,GAAsB,EAAE,CAAC;YACtC,KAAK,MAAM,SAAS,IAAI,YAAY,CAAC,OAAO,EAAE;gBAC1C,MAAM,gBAAgB,GAAG,qBAAqB,CAAC,IAAI,CAAC,CAAC,GAAG,EAAE,EAAE,CAAC,GAAG,CAAC,EAAE,KAAK,SAAS,CAAC,EAAE,CAAC,CAAC;gBACtF,IAAI,gBAAgB,KAAK,IAAI,IAAI,CAAC,gBAAgB,EAAE;oBAChD,MAAM,IAAI,KAAK,CAAC,mCAAmC,SAAS,CAAC,EAAE,EAAE,CAAC,CAAC;iBACtE;gBAED,MAAM,OAAO,GAAG,MAAM,UAAU,CAAC,KAAK,CAAC,QAAQ,gBAAgB,CAAC,MAAM,EAAE,CAAC,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC;gBACxF,MAAM,MAAM,GAAG,eAAM,CAAC,OAAO,EAAE,EAAE,OAAO,EAAE,KAAK,EAAE,4BAA4B,EAAE,IAAI,EAAE,CAAe,CAAC;gBACrG,IAAI,gBAAwC,CAAC;gBAC7C,KAAK,MAAM,MAAM,IAAI,MAAM,CAAC,QAAQ,IAAI,EAAE,EAAE;oBACxC,IAAI,MAAM,CAAC,IAAI,KAAK,OAAO,EAAE;wBACzB,gBAAgB,GAAG,MAAM,CAAC;qBAC7B;iBACJ;gBACD,IAAI,gBAAgB,KAAK,SAAS,EAAE;oBAChC,SAAS;iBACZ;gBACD,MAAM,YAAY,GAAG,sCAAqB,CAAC,gBAAgB,CAAyB,CAAC;gBACrF,MAAM,MAAM,GAAG,IAAI,8BAAa,CAAC,KAAK,EAAE,IAAI,CAAC,qBAAqB,EAAE,EAAE,YAAY,CAAC,CAAC;gBACpF,MAAM,IAAI,CAAC,oBAAoB,CAAC,gBAAgB,EAAE,UAAU,EAAE,MAAM,CAAC,CAAC;gBACtE,OAAO,CAAC,IAAI,CAAC,EAAE,IAAI,EAAE,SAAS,CAAC,IAAI,EAAE,MAAM,EAAE,CAAC,CAAC;aAClD;YAED,MAAM,OAAO,GAAsB,EAAE,CAAC;YACtC,KAAK,MAAM,SAAS,IAAI,YAAY,CAAC,OAAO,EAAE;gBAC1C,MAAM,gBAAgB,GAAG,qBAAqB,CAAC,IAAI,CAAC,CAAC,GAAG,EAAE,EAAE,CAAC,GAAG,CAAC,EAAE,KAAK,SAAS,CAAC,EAAE,CAAC,CAAC;gBACtF,IAAI,gBAAgB,KAAK,IAAI,IAAI,CAAC,gBAAgB,EAAE;oBAChD,MAAM,IAAI,KAAK,CAAC,mCAAmC,SAAS,CAAC,EAAE,EAAE,CAAC,CAAC;iBACtE;gBACD,MAAM,OAAO,GAAG,MAAM,UAAU,CAAC,KAAK,CAAC,QAAQ,gBAAgB,CAAC,MAAM,EAAE,CAAC,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC;gBACxF,MAAM,MAAM,GAAG,eAAM,CAAC,OAAO,EAAE,EAAE,OAAO,EAAE,KAAK,EAAE,4BAA4B,EAAE,IAAI,EAAE,CAAe,CAAC;gBACrG,IAAI,gBAAwC,CAAC;gBAC7C,KAAK,MAAM,MAAM,IAAI,MAAM,CAAC,QAAQ,IAAI,EAAE,EAAE;oBACxC,IAAI,MAAM,CAAC,IAAI,KAAK,OAAO,EAAE;wBACzB,gBAAgB,GAAG,MAAM,CAAC;qBAC7B;iBACJ;gBACD,IAAI,gBAAgB,KAAK,SAAS,EAAE;oBAChC,SAAS;iBACZ;gBACD,MAAM,YAAY,GAAG,sCAAqB,CAAC,gBAAgB,CAAyB,CAAC;gBACrF,MAAM,MAAM,GAAG,IAAI,8BAAa,CAAC,KAAK,EAAE,IAAI,CAAC,qBAAqB,EAAE,EAAE,YAAY,CAAC,CAAC;gBACpF,MAAM,IAAI,CAAC,oBAAoB,CAAC,gBAAgB,EAAE,UAAU,EAAE,MAAM,CAAC,CAAC;gBACtE,OAAO,CAAC,IAAI,CAAC,EAAE,IAAI,EAAE,SAAS,CAAC,IAAI,EAAE,MAAM,EAAE,CAAC,CAAC;aAClD;YAED,MAAM,gBAAgB,GAAsB;gBACxC,OAAO;gBACP,OAAO;gBACP,qBAAqB,EAAE,IAAI,CAAC,qBAAqB;gBACjD,MAAM;gBACN,kBAAkB;aACrB,CAAC;YACF,OAAO,gBAAgB,CAAC;QAC5B,CAAC;KAAA;IAEY,oBAAoB,CAC7B,eAAsC,EACtC,UAAiB,EACjB,OAAsC;;YAEtC,IAAI,uBAAuB,GAA4B,EAAE,CAAC;YAC1D,IAAI,mBAAmB,GAA4B,EAAE,CAAC;YACtD,MAAM,OAAO,GAAG,UAAU,CAAC,KAAK,CAAC,cAAc,eAAe,CAAC,MAAM,OAAO,CAAC,CAAC;YAC9E,IAAI,OAAO,EAAE;gBACT,MAAM,MAAM,GAAG,MAAM,OAAO,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC;gBAC3C,uBAAuB,GAAG,IAAI,CAAC,kBAAkB,CAAC,MAAM,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC,CAAC,IAAI,KAAK,OAAO,CAAC,CAAC;gBAC5F,mBAAmB,GAAG,IAAI,CAAC,kBAAkB,CAAC,MAAM,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC,CAAC,IAAI,KAAK,WAAW,CAAC,CAAC;aAC/F;YACD,KAAK,MAAM,CAAC,IAAI,uBAAuB,EAAE;gBACrC,MAAM,MAAM,GAAG,MAAM,UAAU,CAAC,KAAK,CAAC,QAAQ,CAAC,CAAC,MAAM,EAAE,CAAC,CAAC,KAAK,CAAC,YAAY,CAAC,CAAC;gBAC9E,OAAO,CAAC,oBAAoB,CAAC,MAAM,EAAE,CAAC,CAAC,EAAE,CAAC,CAAC;aAC9C;YACD,KAAK,MAAM,CAAC,IAAI,mBAAmB,EAAE;gBACjC,OAAO,CAAC,wBAAwB,CAAC,CAAC,CAAC,MAAM,EAAE,CAAC,CAAC,EAAE,EAAE,UAAU,CAAC,CAAC;aAChE;QACL,CAAC;KAAA;IAEM,kBAAkB,CAAC,OAAe;QACrC,MAAM,MAAM,GAAG,eAAM,CAAC,OAAO,EAAE,EAAE,OAAO,EAAE,IAAI,EAAE,CAAsB,CAAC;QACvE,MAAM,gBAAgB,GAAG,KAAK,CAAC,OAAO,CAAC,MAAM,CAAC,aAAa,CAAC,YAAY,CAAC;YACrE,CAAC,CAAC,MAAM,CAAC,aAAa,CAAC,YAAY;YACnC,CAAC,CAAC,CAAC,MAAM,CAAC,aAAa,CAAC,YAAY,CAAC,CAAC;QAC1C,MAAM,aAAa,GAA4B,gBAAgB;aAC1D,GAAG,CAAC,CAAC,IAAuB,EAAE,EAAE;YAC7B,IAAI,IAAI,CAAC,WAAW,KAAK,SAAS,EAAE;gBAChC,MAAM,KAAK,CAAC,wCAAwC,CAAC,CAAC;aACzD;YACD,OAAO;gBACH,EAAE,EAAE,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,WAAW,CAAC,EAAY,CAAC;gBAClD,IAAI,EAAE,YAAY,CAAC,IAAI,CAAC,WAAW,CAAC,IAAc,CAAC;gBACnD,MAAM,EAAE,IAAI,CAAC,WAAW,CAAC,MAAgB;aAC5C,CAAC;QACN,CAAC,CAAC;aACD,MAAM,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,IAAI,KAAK,IAAI,CAAC,CAAC;QAC1C,OAAO,aAAa,CAAC;IACzB,CAAC;IAEM,mBAAmB,CAAC,OAAe;QACtC,MAAM,MAAM,GAAG,eAAM,CAAC,OAAO,EAAE,EAAE,OAAO,EAAE,IAAI,EAAE,CAAsB,CAAC;QACvE,MAAM,WAAW,GAAG,MAAM,CAAC,YAAY,CAAC,CAAC,QAAQ,CAAC,CAAC,UAAU,CAAC,CAAC;QAE/D,MAAM,WAAW,GAAsB,WAAW,CAAC,mBAAmB,CAAC,CAAC;QACxE,IAAI,eAAoC,CAAC;QACzC,IAAI,WAAW,KAAK,SAAS,EAAE;YAC3B,eAAe,GAAG,EAAE,CAAC;SACxB;aAAM,IAAI,KAAK,CAAC,OAAO,CAAC,WAAW,CAAC,EAAE;YACnC,eAAe,GAAG,WAAW,CAAC;SACjC;aAAM;YACH,eAAe,GAAG,CAAC,WAAW,CAAC,CAAC;SACnC;QACD,MAAM,OAAO,GAAG,eAAe,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE;YACzC,IAAI,IAAI,CAAC,WAAW,KAAK,SAAS,EAAE;gBAChC,MAAM,KAAK,CAAC,4CAA4C,CAAC,CAAC;aAC7D;YACD,OAAO;gBACH,IAAI,EAAE,IAAI,CAAC,WAAW,CAAC,QAAQ,CAAwB;gBACvD,EAAE,EAAE,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,WAAW,CAAC,MAAM,CAAW,CAAC;aAC1D,CAAC;QACN,CAAC,CAAC,CAAC;QAEH,MAAM,WAAW,GAAsB,WAAW,CAAC,mBAAmB,CAAC,CAAC;QACxE,IAAI,eAAoC,CAAC;QACzC,IAAI,WAAW,KAAK,SAAS,EAAE;YAC3B,eAAe,GAAG,EAAE,CAAC;SACxB;aAAM,IAAI,KAAK,CAAC,OAAO,CAAC,WAAW,CAAC,EAAE;YACnC,eAAe,GAAG,WAAW,CAAC;SACjC;aAAM;YACH,eAAe,GAAG,CAAC,WAAW,CAAC,CAAC;SACnC;QAED,MAAM,OAAO,GAAG,eAAe,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE;YACzC,IAAI,IAAI,CAAC,WAAW,KAAK,SAAS,EAAE;gBAChC,MAAM,KAAK,CAAC,4CAA4C,CAAC,CAAC;aAC7D;YACD,OAAO;gBACH,IAAI,EAAE,IAAI,CAAC,WAAW,CAAC,QAAQ,CAAwB;gBACvD,EAAE,EAAE,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,WAAW,CAAC,MAAM,CAAW,CAAC;aAC1D,CAAC;QACN,CAAC,CAAC,CAAC;QAEH,OAAO,EAAE,OAAO,EAAE,OAAO,EAAE,CAAC;IAChC,CAAC;IAEM,kBAAkB,CAAC,OAAe;QACrC,MAAM,MAAM,GAAG,eAAM,CAAC,OAAO,EAAE,EAAE,OAAO,EAAE,IAAI,EAAE,CAAsB,CAAC;QACvE,MAAM,WAAW,GAAG,MAAM,CAAC,YAAY,CAAC,CAAC,QAAQ,CAAC,CAAC,UAAU,CAAC,CAAC;QAC/D,OAAO,WAAW,CAAC,WAAW,CAAC,KAAK,SAAS,CAAC;IAClD,CAAC;IAEM,UAAU,CAAC,GAAW;QACzB,MAAM,KAAK,GAAG,YAAY,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC;QACrC,IAAI,KAAK,KAAK,IAAI,EAAE;YAChB,MAAM,IAAI,KAAK,CAAC,gBAAgB,CAAC,CAAC;SACrC;QACD,OAAO,QAAQ,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC;IAClC,CAAC;CACJ;AAtLD,gCAsLC",
          sourcesContent: ['import * as JSZip from "jszip";\r\nimport { Element as XMLElement, ElementCompact as XMLElementCompact, xml2js } from "xml-js";\r\n\r\nimport { FooterReferenceType } from "file/document/body/section-properties/footer-reference";\r\nimport { HeaderReferenceType } from "file/document/body/section-properties/header-reference";\r\nimport { FooterWrapper, IDocumentFooter } from "file/footer-wrapper";\r\nimport { HeaderWrapper, IDocumentHeader } from "file/header-wrapper";\r\nimport { convertToXmlComponent, ImportedXmlComponent } from "file/xml-components";\r\n\r\nimport { Media } from "file/media";\r\nimport { Styles } from "file/styles";\r\nimport { ExternalStylesFactory } from "file/styles/external-styles-factory";\r\n\r\nconst schemeToType = {\r\n    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header": "header",\r\n    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer": "footer",\r\n    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image": "image",\r\n    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink": "hyperlink",\r\n};\r\n\r\ninterface IDocumentRefs {\r\n    readonly headers: Array<{ readonly id: number; readonly type: HeaderReferenceType }>;\r\n    readonly footers: Array<{ readonly id: number; readonly type: FooterReferenceType }>;\r\n}\r\n\r\ninterface IRelationshipFileInfo {\r\n    readonly id: number;\r\n    readonly target: string;\r\n    readonly type: "header" | "footer" | "image" | "hyperlink";\r\n}\r\n\r\n// Document Template\r\n// https://fileinfo.com/extension/dotx\r\nexport interface IDocumentTemplate {\r\n    readonly currentRelationshipId: number;\r\n    readonly headers: IDocumentHeader[];\r\n    readonly footers: IDocumentFooter[];\r\n    readonly styles: Styles;\r\n    readonly titlePageIsDefined: boolean;\r\n}\r\n\r\nexport class ImportDotx {\r\n    // tslint:disable-next-line:readonly-keyword\r\n    private currentRelationshipId: number;\r\n\r\n    constructor() {\r\n        this.currentRelationshipId = 1;\r\n    }\r\n\r\n    public async extract(data: Buffer): Promise<IDocumentTemplate> {\r\n        const zipContent = await JSZip.loadAsync(data);\r\n\r\n        const stylesContent = await zipContent.files["word/styles.xml"].async("text");\r\n        const stylesFactory = new ExternalStylesFactory();\r\n        const styles = stylesFactory.newInstance(stylesContent);\r\n\r\n        const documentContent = zipContent.files["word/document.xml"];\r\n        const documentRefs: IDocumentRefs = this.extractDocumentRefs(await documentContent.async("text"));\r\n        const titlePageIsDefined = this.titlePageIsDefined(await documentContent.async("text"));\r\n\r\n        const relationshipContent = zipContent.files["word/_rels/document.xml.rels"];\r\n        const documentRelationships: IRelationshipFileInfo[] = this.findReferenceFiles(await relationshipContent.async("text"));\r\n\r\n        const media = new Media();\r\n\r\n        const headers: IDocumentHeader[] = [];\r\n        for (const headerRef of documentRefs.headers) {\r\n            const relationFileInfo = documentRelationships.find((rel) => rel.id === headerRef.id);\r\n            if (relationFileInfo === null || !relationFileInfo) {\r\n                throw new Error(`Can not find target file for id ${headerRef.id}`);\r\n            }\r\n\r\n            const xmlData = await zipContent.files[`word/${relationFileInfo.target}`].async("text");\r\n            const xmlObj = xml2js(xmlData, { compact: false, captureSpacesBetweenElements: true }) as XMLElement;\r\n            let headerXmlElement: XMLElement | undefined;\r\n            for (const xmlElm of xmlObj.elements || []) {\r\n                if (xmlElm.name === "w:hdr") {\r\n                    headerXmlElement = xmlElm;\r\n                }\r\n            }\r\n            if (headerXmlElement === undefined) {\r\n                continue;\r\n            }\r\n            const importedComp = convertToXmlComponent(headerXmlElement) as ImportedXmlComponent;\r\n            const header = new HeaderWrapper(media, this.currentRelationshipId++, importedComp);\r\n            await this.addRelationToWrapper(relationFileInfo, zipContent, header);\r\n            headers.push({ type: headerRef.type, header });\r\n        }\r\n\r\n        const footers: IDocumentFooter[] = [];\r\n        for (const footerRef of documentRefs.footers) {\r\n            const relationFileInfo = documentRelationships.find((rel) => rel.id === footerRef.id);\r\n            if (relationFileInfo === null || !relationFileInfo) {\r\n                throw new Error(`Can not find target file for id ${footerRef.id}`);\r\n            }\r\n            const xmlData = await zipContent.files[`word/${relationFileInfo.target}`].async("text");\r\n            const xmlObj = xml2js(xmlData, { compact: false, captureSpacesBetweenElements: true }) as XMLElement;\r\n            let footerXmlElement: XMLElement | undefined;\r\n            for (const xmlElm of xmlObj.elements || []) {\r\n                if (xmlElm.name === "w:ftr") {\r\n                    footerXmlElement = xmlElm;\r\n                }\r\n            }\r\n            if (footerXmlElement === undefined) {\r\n                continue;\r\n            }\r\n            const importedComp = convertToXmlComponent(footerXmlElement) as ImportedXmlComponent;\r\n            const footer = new FooterWrapper(media, this.currentRelationshipId++, importedComp);\r\n            await this.addRelationToWrapper(relationFileInfo, zipContent, footer);\r\n            footers.push({ type: footerRef.type, footer });\r\n        }\r\n\r\n        const templateDocument: IDocumentTemplate = {\r\n            headers,\r\n            footers,\r\n            currentRelationshipId: this.currentRelationshipId,\r\n            styles,\r\n            titlePageIsDefined,\r\n        };\r\n        return templateDocument;\r\n    }\r\n\r\n    public async addRelationToWrapper(\r\n        relationhipFile: IRelationshipFileInfo,\r\n        zipContent: JSZip,\r\n        wrapper: HeaderWrapper | FooterWrapper,\r\n    ): Promise<void> {\r\n        let wrapperImagesReferences: IRelationshipFileInfo[] = [];\r\n        let hyperLinkReferences: IRelationshipFileInfo[] = [];\r\n        const refFile = zipContent.files[`word/_rels/${relationhipFile.target}.rels`];\r\n        if (refFile) {\r\n            const xmlRef = await refFile.async("text");\r\n            wrapperImagesReferences = this.findReferenceFiles(xmlRef).filter((r) => r.type === "image");\r\n            hyperLinkReferences = this.findReferenceFiles(xmlRef).filter((r) => r.type === "hyperlink");\r\n        }\r\n        for (const r of wrapperImagesReferences) {\r\n            const buffer = await zipContent.files[`word/${r.target}`].async("nodebuffer");\r\n            wrapper.addImageRelationship(buffer, r.id);\r\n        }\r\n        for (const r of hyperLinkReferences) {\r\n            wrapper.addHyperlinkRelationship(r.target, r.id, "External");\r\n        }\r\n    }\r\n\r\n    public findReferenceFiles(xmlData: string): IRelationshipFileInfo[] {\r\n        const xmlObj = xml2js(xmlData, { compact: true }) as XMLElementCompact;\r\n        const relationXmlArray = Array.isArray(xmlObj.Relationships.Relationship)\r\n            ? xmlObj.Relationships.Relationship\r\n            : [xmlObj.Relationships.Relationship];\r\n        const relationships: IRelationshipFileInfo[] = relationXmlArray\r\n            .map((item: XMLElementCompact) => {\r\n                if (item._attributes === undefined) {\r\n                    throw Error("relationship element has no attributes");\r\n                }\r\n                return {\r\n                    id: this.parseRefId(item._attributes.Id as string),\r\n                    type: schemeToType[item._attributes.Type as string],\r\n                    target: item._attributes.Target as string,\r\n                };\r\n            })\r\n            .filter((item) => item.type !== null);\r\n        return relationships;\r\n    }\r\n\r\n    public extractDocumentRefs(xmlData: string): IDocumentRefs {\r\n        const xmlObj = xml2js(xmlData, { compact: true }) as XMLElementCompact;\r\n        const sectionProp = xmlObj["w:document"]["w:body"]["w:sectPr"];\r\n\r\n        const headerProps: XMLElementCompact = sectionProp["w:headerReference"];\r\n        let headersXmlArray: XMLElementCompact[];\r\n        if (headerProps === undefined) {\r\n            headersXmlArray = [];\r\n        } else if (Array.isArray(headerProps)) {\r\n            headersXmlArray = headerProps;\r\n        } else {\r\n            headersXmlArray = [headerProps];\r\n        }\r\n        const headers = headersXmlArray.map((item) => {\r\n            if (item._attributes === undefined) {\r\n                throw Error("header referecne element has no attributes");\r\n            }\r\n            return {\r\n                type: item._attributes["w:type"] as HeaderReferenceType,\r\n                id: this.parseRefId(item._attributes["r:id"] as string),\r\n            };\r\n        });\r\n\r\n        const footerProps: XMLElementCompact = sectionProp["w:footerReference"];\r\n        let footersXmlArray: XMLElementCompact[];\r\n        if (footerProps === undefined) {\r\n            footersXmlArray = [];\r\n        } else if (Array.isArray(footerProps)) {\r\n            footersXmlArray = footerProps;\r\n        } else {\r\n            footersXmlArray = [footerProps];\r\n        }\r\n\r\n        const footers = footersXmlArray.map((item) => {\r\n            if (item._attributes === undefined) {\r\n                throw Error("footer referecne element has no attributes");\r\n            }\r\n            return {\r\n                type: item._attributes["w:type"] as FooterReferenceType,\r\n                id: this.parseRefId(item._attributes["r:id"] as string),\r\n            };\r\n        });\r\n\r\n        return { headers, footers };\r\n    }\r\n\r\n    public titlePageIsDefined(xmlData: string): boolean {\r\n        const xmlObj = xml2js(xmlData, { compact: true }) as XMLElementCompact;\r\n        const sectionProp = xmlObj["w:document"]["w:body"]["w:sectPr"];\r\n        return sectionProp["w:titlePg"] !== undefined;\r\n    }\r\n\r\n    public parseRefId(str: string): number {\r\n        const match = /^rId(\\d+)$/.exec(str);\r\n        if (match === null) {\r\n            throw new Error("Invalid ref id");\r\n        }\r\n        return parseInt(match[1], 10);\r\n    }\r\n}\r\n']
        },
        _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
      }, (l = i[A = "__coverage__"] || (i[A] = {}))[r] && l[r].hash === o ? l[r] : (s.hash = o, l[r] = s)),
          c = (a.s[0]++, a.b[0][0]++, this && (a.b[0][1]++, this.__awaiter) || (a.b[0][2]++, function (e, n, t, r) {
        return a.f[0]++, a.s[1]++, new (a.b[1][0]++, t || (a.b[1][1]++, t = Promise))(function (o, i) {
          function A(e) {
            a.f[2]++, a.s[2]++;

            try {
              a.s[3]++, l(r.next(e));
            } catch (e) {
              a.s[4]++, i(e);
            }
          }

          function s(e) {
            a.f[3]++, a.s[5]++;

            try {
              a.s[6]++, l(r.throw(e));
            } catch (e) {
              a.s[7]++, i(e);
            }
          }

          function l(e) {
            a.f[4]++, a.s[8]++, e.done ? (a.b[2][0]++, o(e.value)) : (a.b[2][1]++, new t(function (n) {
              a.f[5]++, a.s[9]++, n(e.value);
            }).then(A, s));
          }

          a.f[1]++, a.s[10]++, l((r = r.apply(e, (a.b[3][0]++, n || (a.b[3][1]++, [])))).next());
        });
      }));
      a.s[11]++, Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var u = (a.s[12]++, t(107)),
          p = (a.s[13]++, t(27)),
          m = (a.s[14]++, t(99)),
          C = (a.s[15]++, t(101)),
          d = (a.s[16]++, t(0)),
          f = (a.s[17]++, t(16)),
          h = (a.s[18]++, t(105)),
          x = (a.s[19]++, {
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header": "header",
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer": "footer",
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image": "image",
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink": "hyperlink"
      });
      a.s[121]++, n.ImportDotx =
      /*#__PURE__*/
      function () {
        function _class52() {
          _classCallCheck(this, _class52);

          a.f[6]++, a.s[20]++, this.currentRelationshipId = 1;
        }

        _createClass(_class52, [{
          key: "extract",
          value: function extract(e) {
            return a.f[7]++, a.s[21]++, c(this, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee5() {
              var _this318 = this;

              var n, t, r, o, i, A, s, l, c, x, g, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _loop, _iterator14, _step14, _ret, I, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _loop2, _iterator15, _step15, _ret2, b;

              return _regeneratorRuntime.wrap(function _callee5$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      a.f[8]++;
                      a.s[22]++;
                      _context7.next = 4;
                      return u.loadAsync(e);

                    case 4:
                      n = _context7.sent;
                      a.s[23]++;
                      _context7.next = 8;
                      return n.files["word/styles.xml"].async("text");

                    case 8:
                      t = _context7.sent;
                      r = (a.s[24]++, new h.ExternalStylesFactory());
                      o = (a.s[25]++, r.newInstance(t));
                      i = (a.s[26]++, n.files["word/document.xml"]);
                      a.s[27]++;
                      _context7.t0 = this;
                      _context7.next = 16;
                      return i.async("text");

                    case 16:
                      _context7.t1 = _context7.sent;
                      A = _context7.t0.extractDocumentRefs.call(_context7.t0, _context7.t1);
                      a.s[28]++;
                      _context7.t2 = this;
                      _context7.next = 22;
                      return i.async("text");

                    case 22:
                      _context7.t3 = _context7.sent;
                      s = _context7.t2.titlePageIsDefined.call(_context7.t2, _context7.t3);
                      l = (a.s[29]++, n.files["word/_rels/document.xml.rels"]);
                      a.s[30]++;
                      _context7.t4 = this;
                      _context7.next = 29;
                      return l.async("text");

                    case 29:
                      _context7.t5 = _context7.sent;
                      c = _context7.t4.findReferenceFiles.call(_context7.t4, _context7.t5);
                      x = (a.s[31]++, new f.Media());
                      g = (a.s[32]++, []);
                      a.s[33]++;
                      _iteratorNormalCompletion14 = true;
                      _didIteratorError14 = false;
                      _iteratorError14 = undefined;
                      _context7.prev = 37;
                      _loop =
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _loop() {
                        var e, t, r, o, i, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, _e16, A, s;

                        return _regeneratorRuntime.wrap(function _loop$(_context5) {
                          while (1) {
                            switch (_context5.prev = _context5.next) {
                              case 0:
                                e = _step14.value;
                                t = (a.s[34]++, c.find(function (n) {
                                  return a.f[9]++, a.s[35]++, n.id === e.id;
                                }));

                                if (!(a.s[36]++, a.b[5][0]++, null === t || (a.b[5][1]++, !t))) {
                                  _context5.next = 4;
                                  break;
                                }

                                throw a.b[4][0]++, a.s[37]++, new Error("Can not find target file for id ".concat(e.id));

                              case 4:
                                a.b[4][1]++;
                                a.s[38]++;
                                _context5.next = 8;
                                return n.files["word/".concat(t.target)].async("text");

                              case 8:
                                r = _context5.sent;
                                o = (a.s[39]++, p.xml2js(r, {
                                  compact: !1,
                                  captureSpacesBetweenElements: !0
                                }));
                                i = void 0;
                                a.s[40]++;
                                _iteratorNormalCompletion16 = true;
                                _didIteratorError16 = false;
                                _iteratorError16 = undefined;
                                _context5.prev = 15;

                                for (_iterator16 = (a.b[6][0]++, o.elements || (a.b[6][1]++, []))[Symbol.iterator](); !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                                  _e16 = _step16.value;
                                  a.s[41]++, "w:hdr" === _e16.name ? (a.b[7][0]++, a.s[42]++, i = _e16) : a.b[7][1]++;
                                }

                                _context5.next = 23;
                                break;

                              case 19:
                                _context5.prev = 19;
                                _context5.t0 = _context5["catch"](15);
                                _didIteratorError16 = true;
                                _iteratorError16 = _context5.t0;

                              case 23:
                                _context5.prev = 23;
                                _context5.prev = 24;

                                if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                                  _iterator16.return();
                                }

                              case 26:
                                _context5.prev = 26;

                                if (!_didIteratorError16) {
                                  _context5.next = 29;
                                  break;
                                }

                                throw _iteratorError16;

                              case 29:
                                return _context5.finish(26);

                              case 30:
                                return _context5.finish(23);

                              case 31:
                                if (!(a.s[43]++, void 0 === i)) {
                                  _context5.next = 34;
                                  break;
                                }

                                a.b[8][0]++, a.s[44]++;
                                return _context5.abrupt("return", "continue");

                              case 34:
                                a.b[8][1]++;
                                A = (a.s[45]++, d.convertToXmlComponent(i)), s = (a.s[46]++, new C.HeaderWrapper(x, _this318.currentRelationshipId++, A));
                                a.s[47]++;
                                _context5.next = 39;
                                return _this318.addRelationToWrapper(t, n, s);

                              case 39:
                                a.s[48]++;
                                g.push({
                                  type: e.type,
                                  header: s
                                });

                              case 41:
                              case "end":
                                return _context5.stop();
                            }
                          }
                        }, _loop, null, [[15, 19, 23, 31], [24,, 26, 30]]);
                      });
                      _iterator14 = A.headers[Symbol.iterator]();

                    case 40:
                      if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                        _context7.next = 48;
                        break;
                      }

                      return _context7.delegateYield(_loop(), "t6", 42);

                    case 42:
                      _ret = _context7.t6;

                      if (!(_ret === "continue")) {
                        _context7.next = 45;
                        break;
                      }

                      return _context7.abrupt("continue", 45);

                    case 45:
                      _iteratorNormalCompletion14 = true;
                      _context7.next = 40;
                      break;

                    case 48:
                      _context7.next = 54;
                      break;

                    case 50:
                      _context7.prev = 50;
                      _context7.t7 = _context7["catch"](37);
                      _didIteratorError14 = true;
                      _iteratorError14 = _context7.t7;

                    case 54:
                      _context7.prev = 54;
                      _context7.prev = 55;

                      if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                        _iterator14.return();
                      }

                    case 57:
                      _context7.prev = 57;

                      if (!_didIteratorError14) {
                        _context7.next = 60;
                        break;
                      }

                      throw _iteratorError14;

                    case 60:
                      return _context7.finish(57);

                    case 61:
                      return _context7.finish(54);

                    case 62:
                      I = (a.s[49]++, []);
                      a.s[50]++;
                      _iteratorNormalCompletion15 = true;
                      _didIteratorError15 = false;
                      _iteratorError15 = undefined;
                      _context7.prev = 67;
                      _loop2 =
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _loop2() {
                        var e, t, r, o, i, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, _e17, A, s;

                        return _regeneratorRuntime.wrap(function _loop2$(_context6) {
                          while (1) {
                            switch (_context6.prev = _context6.next) {
                              case 0:
                                e = _step15.value;
                                t = (a.s[51]++, c.find(function (n) {
                                  return a.f[10]++, a.s[52]++, n.id === e.id;
                                }));

                                if (!(a.s[53]++, a.b[10][0]++, null === t || (a.b[10][1]++, !t))) {
                                  _context6.next = 4;
                                  break;
                                }

                                throw a.b[9][0]++, a.s[54]++, new Error("Can not find target file for id ".concat(e.id));

                              case 4:
                                a.b[9][1]++;
                                a.s[55]++;
                                _context6.next = 8;
                                return n.files["word/".concat(t.target)].async("text");

                              case 8:
                                r = _context6.sent;
                                o = (a.s[56]++, p.xml2js(r, {
                                  compact: !1,
                                  captureSpacesBetweenElements: !0
                                }));
                                i = void 0;
                                a.s[57]++;
                                _iteratorNormalCompletion17 = true;
                                _didIteratorError17 = false;
                                _iteratorError17 = undefined;
                                _context6.prev = 15;

                                for (_iterator17 = (a.b[11][0]++, o.elements || (a.b[11][1]++, []))[Symbol.iterator](); !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                                  _e17 = _step17.value;
                                  a.s[58]++, "w:ftr" === _e17.name ? (a.b[12][0]++, a.s[59]++, i = _e17) : a.b[12][1]++;
                                }

                                _context6.next = 23;
                                break;

                              case 19:
                                _context6.prev = 19;
                                _context6.t0 = _context6["catch"](15);
                                _didIteratorError17 = true;
                                _iteratorError17 = _context6.t0;

                              case 23:
                                _context6.prev = 23;
                                _context6.prev = 24;

                                if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
                                  _iterator17.return();
                                }

                              case 26:
                                _context6.prev = 26;

                                if (!_didIteratorError17) {
                                  _context6.next = 29;
                                  break;
                                }

                                throw _iteratorError17;

                              case 29:
                                return _context6.finish(26);

                              case 30:
                                return _context6.finish(23);

                              case 31:
                                if (!(a.s[60]++, void 0 === i)) {
                                  _context6.next = 34;
                                  break;
                                }

                                a.b[13][0]++, a.s[61]++;
                                return _context6.abrupt("return", "continue");

                              case 34:
                                a.b[13][1]++;
                                A = (a.s[62]++, d.convertToXmlComponent(i)), s = (a.s[63]++, new m.FooterWrapper(x, _this318.currentRelationshipId++, A));
                                a.s[64]++;
                                _context6.next = 39;
                                return _this318.addRelationToWrapper(t, n, s);

                              case 39:
                                a.s[65]++;
                                I.push({
                                  type: e.type,
                                  footer: s
                                });

                              case 41:
                              case "end":
                                return _context6.stop();
                            }
                          }
                        }, _loop2, null, [[15, 19, 23, 31], [24,, 26, 30]]);
                      });
                      _iterator15 = A.footers[Symbol.iterator]();

                    case 70:
                      if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
                        _context7.next = 78;
                        break;
                      }

                      return _context7.delegateYield(_loop2(), "t8", 72);

                    case 72:
                      _ret2 = _context7.t8;

                      if (!(_ret2 === "continue")) {
                        _context7.next = 75;
                        break;
                      }

                      return _context7.abrupt("continue", 75);

                    case 75:
                      _iteratorNormalCompletion15 = true;
                      _context7.next = 70;
                      break;

                    case 78:
                      _context7.next = 84;
                      break;

                    case 80:
                      _context7.prev = 80;
                      _context7.t9 = _context7["catch"](67);
                      _didIteratorError15 = true;
                      _iteratorError15 = _context7.t9;

                    case 84:
                      _context7.prev = 84;
                      _context7.prev = 85;

                      if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                        _iterator15.return();
                      }

                    case 87:
                      _context7.prev = 87;

                      if (!_didIteratorError15) {
                        _context7.next = 90;
                        break;
                      }

                      throw _iteratorError15;

                    case 90:
                      return _context7.finish(87);

                    case 91:
                      return _context7.finish(84);

                    case 92:
                      b = (a.s[66]++, {
                        headers: g,
                        footers: I,
                        currentRelationshipId: this.currentRelationshipId,
                        styles: o,
                        titlePageIsDefined: s
                      });
                      return _context7.abrupt("return", (a.s[67]++, b));

                    case 94:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee5, this, [[37, 50, 54, 62], [55,, 57, 61], [67, 80, 84, 92], [85,, 87, 91]]);
            }));
          }
        }, {
          key: "addRelationToWrapper",
          value: function addRelationToWrapper(e, n, t) {
            return a.f[11]++, a.s[68]++, c(this, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee6() {
              var r, o, i, _e18, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, _e19, _r4, _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, _e20;

              return _regeneratorRuntime.wrap(function _callee6$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      a.f[12]++;
                      r = (a.s[69]++, []), o = (a.s[70]++, []);
                      i = (a.s[71]++, n.files["word/_rels/".concat(e.target, ".rels")]);

                      if (!(a.s[72]++, i)) {
                        _context8.next = 12;
                        break;
                      }

                      a.b[14][0]++;
                      a.s[73]++;
                      _context8.next = 8;
                      return i.async("text");

                    case 8:
                      _e18 = _context8.sent;
                      a.s[74]++, r = this.findReferenceFiles(_e18).filter(function (e) {
                        return a.f[13]++, a.s[75]++, "image" === e.type;
                      }), a.s[76]++, o = this.findReferenceFiles(_e18).filter(function (e) {
                        return a.f[14]++, a.s[77]++, "hyperlink" === e.type;
                      });
                      _context8.next = 13;
                      break;

                    case 12:
                      a.b[14][1]++;

                    case 13:
                      a.s[78]++;
                      _iteratorNormalCompletion18 = true;
                      _didIteratorError18 = false;
                      _iteratorError18 = undefined;
                      _context8.prev = 17;
                      _iterator18 = r[Symbol.iterator]();

                    case 19:
                      if (_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done) {
                        _context8.next = 29;
                        break;
                      }

                      _e19 = _step18.value;
                      a.s[79]++;
                      _context8.next = 24;
                      return n.files["word/".concat(_e19.target)].async("nodebuffer");

                    case 24:
                      _r4 = _context8.sent;
                      a.s[80]++, t.addImageRelationship(_r4, _e19.id);

                    case 26:
                      _iteratorNormalCompletion18 = true;
                      _context8.next = 19;
                      break;

                    case 29:
                      _context8.next = 35;
                      break;

                    case 31:
                      _context8.prev = 31;
                      _context8.t0 = _context8["catch"](17);
                      _didIteratorError18 = true;
                      _iteratorError18 = _context8.t0;

                    case 35:
                      _context8.prev = 35;
                      _context8.prev = 36;

                      if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
                        _iterator18.return();
                      }

                    case 38:
                      _context8.prev = 38;

                      if (!_didIteratorError18) {
                        _context8.next = 41;
                        break;
                      }

                      throw _iteratorError18;

                    case 41:
                      return _context8.finish(38);

                    case 42:
                      return _context8.finish(35);

                    case 43:
                      a.s[81]++;
                      _iteratorNormalCompletion19 = true;
                      _didIteratorError19 = false;
                      _iteratorError19 = undefined;
                      _context8.prev = 47;

                      for (_iterator19 = o[Symbol.iterator](); !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                        _e20 = _step19.value;
                        a.s[82]++, t.addHyperlinkRelationship(_e20.target, _e20.id, "External");
                      }

                      _context8.next = 55;
                      break;

                    case 51:
                      _context8.prev = 51;
                      _context8.t1 = _context8["catch"](47);
                      _didIteratorError19 = true;
                      _iteratorError19 = _context8.t1;

                    case 55:
                      _context8.prev = 55;
                      _context8.prev = 56;

                      if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                        _iterator19.return();
                      }

                    case 58:
                      _context8.prev = 58;

                      if (!_didIteratorError19) {
                        _context8.next = 61;
                        break;
                      }

                      throw _iteratorError19;

                    case 61:
                      return _context8.finish(58);

                    case 62:
                      return _context8.finish(55);

                    case 63:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee6, this, [[17, 31, 35, 43], [36,, 38, 42], [47, 51, 55, 63], [56,, 58, 62]]);
            }));
          }
        }, {
          key: "findReferenceFiles",
          value: function findReferenceFiles(e) {
            var _this319 = this;

            a.f[15]++;
            var n = (a.s[83]++, p.xml2js(e, {
              compact: !0
            })),
                t = (a.s[84]++, Array.isArray(n.Relationships.Relationship) ? (a.b[15][0]++, n.Relationships.Relationship) : (a.b[15][1]++, [n.Relationships.Relationship])),
                r = (a.s[85]++, t.map(function (e) {
              if (a.f[16]++, a.s[86]++, void 0 === e._attributes) throw a.b[16][0]++, a.s[87]++, Error("relationship element has no attributes");
              return a.b[16][1]++, a.s[88]++, {
                id: _this319.parseRefId(e._attributes.Id),
                type: x[e._attributes.Type],
                target: e._attributes.Target
              };
            }).filter(function (e) {
              return a.f[17]++, a.s[89]++, null !== e.type;
            }));
            return a.s[90]++, r;
          }
        }, {
          key: "extractDocumentRefs",
          value: function extractDocumentRefs(e) {
            var _this320 = this;

            a.f[18]++;
            var n = (a.s[91]++, p.xml2js(e, {
              compact: !0
            })),
                t = (a.s[92]++, n["w:document"]["w:body"]["w:sectPr"]),
                r = (a.s[93]++, t["w:headerReference"]);
            var o;
            a.s[94]++, void 0 === r ? (a.b[17][0]++, a.s[95]++, o = []) : (a.b[17][1]++, a.s[96]++, Array.isArray(r) ? (a.b[18][0]++, a.s[97]++, o = r) : (a.b[18][1]++, a.s[98]++, o = [r]));
            var i = (a.s[99]++, o.map(function (e) {
              if (a.f[19]++, a.s[100]++, void 0 === e._attributes) throw a.b[19][0]++, a.s[101]++, Error("header referecne element has no attributes");
              return a.b[19][1]++, a.s[102]++, {
                type: e._attributes["w:type"],
                id: _this320.parseRefId(e._attributes["r:id"])
              };
            })),
                A = (a.s[103]++, t["w:footerReference"]);
            var s;
            a.s[104]++, void 0 === A ? (a.b[20][0]++, a.s[105]++, s = []) : (a.b[20][1]++, a.s[106]++, Array.isArray(A) ? (a.b[21][0]++, a.s[107]++, s = A) : (a.b[21][1]++, a.s[108]++, s = [A]));
            var l = (a.s[109]++, s.map(function (e) {
              if (a.f[20]++, a.s[110]++, void 0 === e._attributes) throw a.b[22][0]++, a.s[111]++, Error("footer referecne element has no attributes");
              return a.b[22][1]++, a.s[112]++, {
                type: e._attributes["w:type"],
                id: _this320.parseRefId(e._attributes["r:id"])
              };
            }));
            return a.s[113]++, {
              headers: i,
              footers: l
            };
          }
        }, {
          key: "titlePageIsDefined",
          value: function titlePageIsDefined(e) {
            a.f[21]++;
            var n = (a.s[114]++, p.xml2js(e, {
              compact: !0
            })),
                t = (a.s[115]++, n["w:document"]["w:body"]["w:sectPr"]);
            return a.s[116]++, void 0 !== t["w:titlePg"];
          }
        }, {
          key: "parseRefId",
          value: function parseRefId(e) {
            a.f[22]++;
            var n = (a.s[117]++, /^rId(\d+)$/.exec(e));
            if (a.s[118]++, null === n) throw a.b[23][0]++, a.s[119]++, new Error("Invalid ref id");
            return a.b[23][1]++, a.s[120]++, parseInt(n[1], 10);
          }
        }]);

        return _class52;
      }();
    }]);
  }, e.exports = r();
}, function (e, n, t) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;

  function A(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var n = {}, t = 0; t < 10; t++) {
        n["_" + String.fromCharCode(t)] = t;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, n) {
    for (var t, s, l = A(e), a = 1; a < arguments.length; a++) {
      for (var c in t = Object(arguments[a])) {
        o.call(t, c) && (l[c] = t[c]);
      }

      if (r) {
        s = r(t);

        for (var u = 0; u < s.length; u++) {
          i.call(t, s[u]) && (l[s[u]] = t[s[u]]);
        }
      }
    }

    return l;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(3),
      o = r.Map,
      i = r.OrderedSet,
      A = r.Record,
      s = i(),
      l = {
    style: s,
    entity: null
  },
      a = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.getStyle = function () {
      return this.get("style");
    }, n.prototype.getEntity = function () {
      return this.get("entity");
    }, n.prototype.hasStyle = function (e) {
      return this.getStyle().includes(e);
    }, n.applyStyle = function (e, t) {
      var r = e.set("style", e.getStyle().add(t));
      return n.create(r);
    }, n.removeStyle = function (e, t) {
      var r = e.set("style", e.getStyle().remove(t));
      return n.create(r);
    }, n.applyEntity = function (e, t) {
      var r = e.getEntity() === t ? e : e.set("entity", t);
      return n.create(r);
    }, n.create = function (e) {
      if (!e) return c;
      var t = o({
        style: s,
        entity: null
      }).merge(e),
          r = u.get(t);
      if (r) return r;
      var i = new n(t);
      return u = u.set(t, i), i;
    }, n;
  }(A(l)),
      c = new a(),
      u = o([[o(l), c]]);

  a.EMPTY = c, e.exports = a;
}, function (e, n, t) {
  "use strict";

  var r = Array.isArray,
      o = Object.keys,
      i = Object.prototype.hasOwnProperty,
      A = "undefined" != typeof Element;

  e.exports = function (e, n) {
    try {
      return function e(n, t) {
        if (n === t) return !0;

        if (n && t && "object" == typeof n && "object" == typeof t) {
          var s,
              l,
              a,
              c = r(n),
              u = r(t);

          if (c && u) {
            if ((l = n.length) != t.length) return !1;

            for (s = l; 0 != s--;) {
              if (!e(n[s], t[s])) return !1;
            }

            return !0;
          }

          if (c != u) return !1;
          var p = n instanceof Date,
              m = t instanceof Date;
          if (p != m) return !1;
          if (p && m) return n.getTime() == t.getTime();
          var C = n instanceof RegExp,
              d = t instanceof RegExp;
          if (C != d) return !1;
          if (C && d) return n.toString() == t.toString();
          var f = o(n);
          if ((l = f.length) !== o(t).length) return !1;

          for (s = l; 0 != s--;) {
            if (!i.call(t, f[s])) return !1;
          }

          if (A && n instanceof Element && t instanceof Element) return n === t;

          for (s = l; 0 != s--;) {
            if (!("_owner" === (a = f[s]) && n.$$typeof || e(n[a], t[a]))) return !1;
          }

          return !0;
        }

        return n != n && t != t;
      }(e, n);
    } catch (e) {
      if (e.message && e.message.match(/stack|recursion/i) || -2146828260 === e.number) return console.warn("Warning: react-fast-compare does not handle circular references.", e.name, e.message), !1;
      throw e;
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = t(19),
      o = t(3),
      i = t(38),
      A = o.List,
      s = o.Map,
      l = o.OrderedSet,
      a = o.Record,
      c = o.Repeat,
      u = l(),
      p = {
    parent: null,
    characterList: A(),
    data: s(),
    depth: 0,
    key: "",
    text: "",
    type: "unstyled",
    children: A(),
    prevSibling: null,
    nextSibling: null
  },
      m = function m(e, n) {
    return e.getStyle() === n.getStyle();
  },
      C = function C(e, n) {
    return e.getEntity() === n.getEntity();
  },
      d = function d(e) {
    if (!e) return e;
    var n = e.characterList,
        t = e.text;
    return t && !n && (e.characterList = A(c(r.EMPTY, t.length))), e;
  },
      f = function (e) {
    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : p;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.call(this, d(t)));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.getKey = function () {
      return this.get("key");
    }, n.prototype.getType = function () {
      return this.get("type");
    }, n.prototype.getText = function () {
      return this.get("text");
    }, n.prototype.getCharacterList = function () {
      return this.get("characterList");
    }, n.prototype.getLength = function () {
      return this.getText().length;
    }, n.prototype.getDepth = function () {
      return this.get("depth");
    }, n.prototype.getData = function () {
      return this.get("data");
    }, n.prototype.getInlineStyleAt = function (e) {
      var n = this.getCharacterList().get(e);
      return n ? n.getStyle() : u;
    }, n.prototype.getEntityAt = function (e) {
      var n = this.getCharacterList().get(e);
      return n ? n.getEntity() : null;
    }, n.prototype.getChildKeys = function () {
      return this.get("children");
    }, n.prototype.getParentKey = function () {
      return this.get("parent");
    }, n.prototype.getPrevSiblingKey = function () {
      return this.get("prevSibling");
    }, n.prototype.getNextSiblingKey = function () {
      return this.get("nextSibling");
    }, n.prototype.findStyleRanges = function (e, n) {
      i(this.getCharacterList(), m, e, n);
    }, n.prototype.findEntityRanges = function (e, n) {
      i(this.getCharacterList(), C, e, n);
    }, n;
  }(a(p));

  e.exports = f;
}, function (e, n, t) {
  var r = t(206);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    if (null != e) return e;
    throw new Error("Got unexpected null or undefined");
  };
}, function (e, n, t) {
  "use strict";

  var r = t(142),
      o = t(144),
      i = t(145),
      A = t(146);

  function s(e, n, t, r) {
    if (e === t) return !0;
    if (!t.startsWith(e)) return !1;
    var i = t.slice(e.length);
    return !!n && (i = r ? r(i) : i, o.contains(i, n));
  }

  function l(e) {
    return "Windows" === r.platformName ? e.replace(/^\s*NT/, "") : e;
  }

  var a = {
    isBrowser: function isBrowser(e) {
      return s(r.browserName, r.browserFullVersion, e);
    },
    isBrowserArchitecture: function isBrowserArchitecture(e) {
      return s(r.browserArchitecture, null, e);
    },
    isDevice: function isDevice(e) {
      return s(r.deviceName, null, e);
    },
    isEngine: function isEngine(e) {
      return s(r.engineName, r.engineVersion, e);
    },
    isPlatform: function isPlatform(e) {
      return s(r.platformName, r.platformFullVersion, e, l);
    },
    isPlatformArchitecture: function isPlatformArchitecture(e) {
      return s(r.platformArchitecture, null, e);
    }
  };
  e.exports = i(a, A);
}, function (e, n, t) {
  "use strict";

  var r = {},
      o = Math.pow(2, 24);

  e.exports = function () {
    for (var e = void 0; void 0 === e || r.hasOwnProperty(e) || !isNaN(+e);) {
      e = Math.floor(Math.random() * o).toString(32);
    }

    return r[e] = !0, e;
  };
}, function (e, n, t) {
  "use strict";

  (function (e, r) {
    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function i(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function A(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    function s(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {},
            r = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), r.forEach(function (n) {
          A(e, n, t[n]);
        });
      }

      return e;
    }

    function l(e, n) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, n) {
        var t = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var A, s = e[Symbol.iterator](); !(r = (A = s.next()).done) && (t.push(A.value), !n || t.length !== n); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (o) throw i;
          }
        }

        return t;
      }(e, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    t.d(n, "a", function () {
      return Te;
    }), t.d(n, "b", function () {
      return ke;
    });

    var a = function a() {},
        c = {},
        u = {},
        p = {
      mark: a,
      measure: a
    };

    try {
      "undefined" != typeof window && (c = window), "undefined" != typeof document && (u = document), "undefined" != typeof MutationObserver && MutationObserver, "undefined" != typeof performance && (p = performance);
    } catch (e) {}

    var m = (c.navigator || {}).userAgent,
        C = void 0 === m ? "" : m,
        d = c,
        f = u,
        h = p,
        x = (d.document, !!f.documentElement && !!f.head && "function" == typeof f.addEventListener && "function" == typeof f.createElement),
        g = (~C.indexOf("MSIE") || C.indexOf("Trident/"), "fa"),
        I = "svg-inline--fa",
        b = "data-fa-i2svg",
        y = (function () {
      try {} catch (e) {
        return !1;
      }
    }(), [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
        E = y.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
        v = {
      GROUP: "group",
      SWAP_OPACITY: "swap-opacity",
      PRIMARY: "primary",
      SECONDARY: "secondary"
    },
        w = (["xs", "sm", "lg", "fw", "ul", "li", "border", "pull-left", "pull-right", "spin", "pulse", "rotate-90", "rotate-180", "rotate-270", "flip-horizontal", "flip-vertical", "flip-both", "stack", "stack-1x", "stack-2x", "inverse", "layers", "layers-text", "layers-counter", v.GROUP, v.SWAP_OPACITY, v.PRIMARY, v.SECONDARY].concat(y.map(function (e) {
      return "".concat(e, "x");
    })).concat(E.map(function (e) {
      return "w-".concat(e);
    })), d.FontAwesomeConfig || {});

    if (f && "function" == typeof f.querySelector) {
      [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (e) {
        var n = l(e, 2),
            t = n[0],
            r = n[1],
            o = function (e) {
          return "" === e || "false" !== e && ("true" === e || e);
        }(function (e) {
          var n = f.querySelector("script[" + e + "]");
          if (n) return n.getAttribute(e);
        }(t));

        null != o && (w[r] = o);
      });
    }

    var B = s({}, {
      familyPrefix: g,
      replacementClass: I,
      autoReplaceSvg: !0,
      autoAddCss: !0,
      autoA11y: !0,
      searchPseudoElements: !1,
      observeMutations: !0,
      mutateApproach: "async",
      keepOriginalSource: !0,
      measurePerformance: !1,
      showMissingIcons: !0
    }, w);
    B.autoReplaceSvg || (B.observeMutations = !1);

    var _ = s({}, B);

    d.FontAwesomeConfig = _;
    var D = d || {};
    D.___FONT_AWESOME___ || (D.___FONT_AWESOME___ = {}), D.___FONT_AWESOME___.styles || (D.___FONT_AWESOME___.styles = {}), D.___FONT_AWESOME___.hooks || (D.___FONT_AWESOME___.hooks = {}), D.___FONT_AWESOME___.shims || (D.___FONT_AWESOME___.shims = []);
    var S = D.___FONT_AWESOME___,
        M = [];
    x && ((f.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(f.readyState) || f.addEventListener("DOMContentLoaded", function e() {
      f.removeEventListener("DOMContentLoaded", e), 1, M.map(function (e) {
        return e();
      });
    }));

    var O,
        k = "pending",
        T = "settled",
        P = "fulfilled",
        K = "rejected",
        Q = function Q() {},
        U = void 0 !== e && void 0 !== e.process && "function" == typeof e.process.emit,
        R = void 0 === r ? setTimeout : r,
        G = [];

    function Y() {
      for (var e = 0; e < G.length; e++) {
        G[e][0](G[e][1]);
      }

      G = [], O = !1;
    }

    function F(e, n) {
      G.push([e, n]), O || (O = !0, R(Y, 0));
    }

    function N(e) {
      var n = e.owner,
          t = n._state,
          r = n._data,
          o = e[t],
          i = e.then;

      if ("function" == typeof o) {
        t = P;

        try {
          r = o(r);
        } catch (e) {
          z(i, e);
        }
      }

      j(i, r) || (t === P && W(i, r), t === K && z(i, r));
    }

    function j(e, n) {
      var t;

      try {
        if (e === n) throw new TypeError("A promises callback cannot return that same promise.");

        if (n && ("function" == typeof n || "object" === o(n))) {
          var r = n.then;
          if ("function" == typeof r) return r.call(n, function (r) {
            t || (t = !0, n === r ? L(e, r) : W(e, r));
          }, function (n) {
            t || (t = !0, z(e, n));
          }), !0;
        }
      } catch (n) {
        return t || z(e, n), !0;
      }

      return !1;
    }

    function W(e, n) {
      e !== n && j(e, n) || L(e, n);
    }

    function L(e, n) {
      e._state === k && (e._state = T, e._data = n, F(H, e));
    }

    function z(e, n) {
      e._state === k && (e._state = T, e._data = n, F(q, e));
    }

    function X(e) {
      e._then = e._then.forEach(N);
    }

    function H(e) {
      e._state = P, X(e);
    }

    function q(n) {
      n._state = K, X(n), !n._handled && U && e.process.emit("unhandledRejection", n._data, n);
    }

    function V(n) {
      e.process.emit("rejectionHandled", n);
    }

    function J(e) {
      if ("function" != typeof e) throw new TypeError("Promise resolver " + e + " is not a function");
      if (this instanceof J == !1) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
      this._then = [], function (e, n) {
        function t(e) {
          z(n, e);
        }

        try {
          e(function (e) {
            W(n, e);
          }, t);
        } catch (e) {
          t(e);
        }
      }(e, this);
    }

    J.prototype = {
      constructor: J,
      _state: k,
      _then: null,
      _data: void 0,
      _handled: !1,
      then: function then(e, n) {
        var t = {
          owner: this,
          then: new this.constructor(Q),
          fulfilled: e,
          rejected: n
        };
        return !n && !e || this._handled || (this._handled = !0, this._state === K && U && F(V, this)), this._state === P || this._state === K ? F(N, t) : this._then.push(t), t.then;
      },
      catch: function _catch(e) {
        return this.then(null, e);
      }
    }, J.all = function (e) {
      if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.all().");
      return new J(function (n, t) {
        var r = [],
            o = 0;

        function i(e) {
          return o++, function (t) {
            r[e] = t, --o || n(r);
          };
        }

        for (var A, s = 0; s < e.length; s++) {
          (A = e[s]) && "function" == typeof A.then ? A.then(i(s), t) : r[s] = A;
        }

        o || n(r);
      });
    }, J.race = function (e) {
      if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.race().");
      return new J(function (n, t) {
        for (var r, o = 0; o < e.length; o++) {
          (r = e[o]) && "function" == typeof r.then ? r.then(n, t) : n(r);
        }
      });
    }, J.resolve = function (e) {
      return e && "object" === o(e) && e.constructor === J ? e : new J(function (n) {
        n(e);
      });
    }, J.reject = function (e) {
      return new J(function (n, t) {
        t(e);
      });
    };
    "function" == typeof Promise && Promise;
    var Z = {
      size: 16,
      x: 0,
      y: 0,
      rotate: 0,
      flipX: !1,
      flipY: !1
    };

    function $(e) {
      if (e && x) {
        var n = f.createElement("style");
        n.setAttribute("type", "text/css"), n.innerHTML = e;

        for (var t = f.head.childNodes, r = null, o = t.length - 1; o > -1; o--) {
          var i = t[o],
              A = (i.tagName || "").toUpperCase();
          ["STYLE", "LINK"].indexOf(A) > -1 && (r = i);
        }

        return f.head.insertBefore(n, r), e;
      }
    }

    var ee = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

    function ne() {
      for (var e = 12, n = ""; e-- > 0;) {
        n += ee[62 * Math.random() | 0];
      }

      return n;
    }

    function te(e) {
      return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function re(e) {
      return Object.keys(e || {}).reduce(function (n, t) {
        return n + "".concat(t, ": ").concat(e[t], ";");
      }, "");
    }

    function oe(e) {
      return e.size !== Z.size || e.x !== Z.x || e.y !== Z.y || e.rotate !== Z.rotate || e.flipX || e.flipY;
    }

    function ie(e) {
      var n = e.transform,
          t = e.containerWidth,
          r = e.iconWidth,
          o = {
        transform: "translate(".concat(t / 2, " 256)")
      },
          i = "translate(".concat(32 * n.x, ", ").concat(32 * n.y, ") "),
          A = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "),
          s = "rotate(".concat(n.rotate, " 0 0)");
      return {
        outer: o,
        inner: {
          transform: "".concat(i, " ").concat(A, " ").concat(s)
        },
        path: {
          transform: "translate(".concat(r / 2 * -1, " -256)")
        }
      };
    }

    var Ae = {
      x: 0,
      y: 0,
      width: "100%",
      height: "100%"
    };

    function se(e) {
      var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      return e.attributes && (e.attributes.fill || n) && (e.attributes.fill = "black"), e;
    }

    function le(e) {
      var n = e.icons,
          t = n.main,
          r = n.mask,
          o = e.prefix,
          i = e.iconName,
          A = e.transform,
          l = e.symbol,
          a = e.title,
          c = e.extra,
          u = e.watchable,
          p = void 0 !== u && u,
          m = r.found ? r : t,
          C = m.width,
          d = m.height,
          f = "fa-w-".concat(Math.ceil(C / d * 16)),
          h = [_.replacementClass, i ? "".concat(_.familyPrefix, "-").concat(i) : "", f].filter(function (e) {
        return -1 === c.classes.indexOf(e);
      }).concat(c.classes).join(" "),
          x = {
        children: [],
        attributes: s({}, c.attributes, {
          "data-prefix": o,
          "data-icon": i,
          class: h,
          role: c.attributes.role || "img",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 ".concat(C, " ").concat(d)
        })
      };
      p && (x.attributes[b] = ""), a && x.children.push({
        tag: "title",
        attributes: {
          id: x.attributes["aria-labelledby"] || "title-".concat(ne())
        },
        children: [a]
      });
      var g = s({}, x, {
        prefix: o,
        iconName: i,
        main: t,
        mask: r,
        transform: A,
        symbol: l,
        styles: c.styles
      }),
          I = r.found && t.found ? function (e) {
        var n,
            t = e.children,
            r = e.attributes,
            o = e.main,
            i = e.mask,
            A = e.transform,
            l = o.width,
            a = o.icon,
            c = i.width,
            u = i.icon,
            p = ie({
          transform: A,
          containerWidth: c,
          iconWidth: l
        }),
            m = {
          tag: "rect",
          attributes: s({}, Ae, {
            fill: "white"
          })
        },
            C = a.children ? {
          children: a.children.map(se)
        } : {},
            d = {
          tag: "g",
          attributes: s({}, p.inner),
          children: [se(s({
            tag: a.tag,
            attributes: s({}, a.attributes, p.path)
          }, C))]
        },
            f = {
          tag: "g",
          attributes: s({}, p.outer),
          children: [d]
        },
            h = "mask-".concat(ne()),
            x = "clip-".concat(ne()),
            g = {
          tag: "mask",
          attributes: s({}, Ae, {
            id: h,
            maskUnits: "userSpaceOnUse",
            maskContentUnits: "userSpaceOnUse"
          }),
          children: [m, f]
        },
            I = {
          tag: "defs",
          children: [{
            tag: "clipPath",
            attributes: {
              id: x
            },
            children: (n = u, "g" === n.tag ? n.children : [n])
          }, g]
        };
        return t.push(I, {
          tag: "rect",
          attributes: s({
            fill: "currentColor",
            "clip-path": "url(#".concat(x, ")"),
            mask: "url(#".concat(h, ")")
          }, Ae)
        }), {
          children: t,
          attributes: r
        };
      }(g) : function (e) {
        var n = e.children,
            t = e.attributes,
            r = e.main,
            o = e.transform,
            i = re(e.styles);

        if (i.length > 0 && (t.style = i), oe(o)) {
          var A = ie({
            transform: o,
            containerWidth: r.width,
            iconWidth: r.width
          });
          n.push({
            tag: "g",
            attributes: s({}, A.outer),
            children: [{
              tag: "g",
              attributes: s({}, A.inner),
              children: [{
                tag: r.icon.tag,
                children: r.icon.children,
                attributes: s({}, r.icon.attributes, A.path)
              }]
            }]
          });
        } else n.push(r.icon);

        return {
          children: n,
          attributes: t
        };
      }(g),
          y = I.children,
          E = I.attributes;
      return g.children = y, g.attributes = E, l ? function (e) {
        var n = e.prefix,
            t = e.iconName,
            r = e.children,
            o = e.attributes,
            i = e.symbol;
        return [{
          tag: "svg",
          attributes: {
            style: "display: none;"
          },
          children: [{
            tag: "symbol",
            attributes: s({}, o, {
              id: !0 === i ? "".concat(n, "-").concat(_.familyPrefix, "-").concat(t) : i
            }),
            children: r
          }]
        }];
      }(g) : function (e) {
        var n = e.children,
            t = e.main,
            r = e.mask,
            o = e.attributes,
            i = e.styles,
            A = e.transform;

        if (oe(A) && t.found && !r.found) {
          var l = {
            x: t.width / t.height / 2,
            y: .5
          };
          o.style = re(s({}, i, {
            "transform-origin": "".concat(l.x + A.x / 16, "em ").concat(l.y + A.y / 16, "em")
          }));
        }

        return [{
          tag: "svg",
          attributes: o,
          children: n
        }];
      }(g);
    }

    var ae = function ae() {},
        ce = (_.measurePerformance && h && h.mark && h.measure, function (e, n, t, r) {
      var o,
          i,
          A,
          s = Object.keys(e),
          l = s.length,
          a = void 0 !== r ? function (e, n) {
        return function (t, r, o, i) {
          return e.call(n, t, r, o, i);
        };
      }(n, r) : n;

      for (void 0 === t ? (o = 1, A = e[s[0]]) : (o = 0, A = t); o < l; o++) {
        A = a(A, e[i = s[o]], i, e);
      }

      return A;
    });

    function ue(e, n) {
      var t = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).skipHooks,
          r = void 0 !== t && t,
          o = Object.keys(n).reduce(function (e, t) {
        var r = n[t];
        return !!r.icon ? e[r.iconName] = r.icon : e[t] = r, e;
      }, {});
      "function" != typeof S.hooks.addPack || r ? S.styles[e] = s({}, S.styles[e] || {}, o) : S.hooks.addPack(e, o), "fas" === e && ue("fa", n);
    }

    var pe = S.styles,
        me = S.shims,
        Ce = function Ce() {
      var e = function e(_e21) {
        return ce(pe, function (n, t, r) {
          return n[r] = ce(t, _e21, {}), n;
        }, {});
      };

      e(function (e, n, t) {
        return n[3] && (e[n[3]] = t), e;
      }), e(function (e, n, t) {
        var r = n[2];
        return e[t] = t, r.forEach(function (n) {
          e[n] = t;
        }), e;
      });
      var n = "far" in pe;
      ce(me, function (e, t) {
        var r = t[0],
            o = t[1],
            i = t[2];
        return "far" !== o || n || (o = "fas"), e[r] = {
          prefix: o,
          iconName: i
        }, e;
      }, {});
    };

    Ce();
    S.styles;

    function de(e, n, t) {
      if (e && e[n] && e[n][t]) return {
        prefix: n,
        iconName: t,
        icon: e[n][t]
      };
    }

    function fe(e) {
      var n = e.tag,
          t = e.attributes,
          r = void 0 === t ? {} : t,
          o = e.children,
          i = void 0 === o ? [] : o;
      return "string" == typeof e ? te(e) : "<".concat(n, " ").concat(function (e) {
        return Object.keys(e || {}).reduce(function (n, t) {
          return n + "".concat(t, '="').concat(te(e[t]), '" ');
        }, "").trim();
      }(r), ">").concat(i.map(fe).join(""), "</").concat(n, ">");
    }

    var he = function he(e) {
      var n = {
        size: 16,
        x: 0,
        y: 0,
        flipX: !1,
        flipY: !1,
        rotate: 0
      };
      return e ? e.toLowerCase().split(" ").reduce(function (e, n) {
        var t = n.toLowerCase().split("-"),
            r = t[0],
            o = t.slice(1).join("-");
        if (r && "h" === o) return e.flipX = !0, e;
        if (r && "v" === o) return e.flipY = !0, e;
        if (o = parseFloat(o), isNaN(o)) return e;

        switch (r) {
          case "grow":
            e.size = e.size + o;
            break;

          case "shrink":
            e.size = e.size - o;
            break;

          case "left":
            e.x = e.x - o;
            break;

          case "right":
            e.x = e.x + o;
            break;

          case "up":
            e.y = e.y - o;
            break;

          case "down":
            e.y = e.y + o;
            break;

          case "rotate":
            e.rotate = e.rotate + o;
        }

        return e;
      }, n) : n;
    };

    function xe(e) {
      this.name = "MissingIcon", this.message = e || "Icon unavailable", this.stack = new Error().stack;
    }

    xe.prototype = Object.create(Error.prototype), xe.prototype.constructor = xe;
    var ge = {
      fill: "currentColor"
    },
        Ie = {
      attributeType: "XML",
      repeatCount: "indefinite",
      dur: "2s"
    },
        be = {
      tag: "path",
      attributes: s({}, ge, {
        d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
      })
    },
        ye = s({}, Ie, {
      attributeName: "opacity"
    });
    s({}, ge, {
      cx: "256",
      cy: "364",
      r: "28"
    }), s({}, Ie, {
      attributeName: "r",
      values: "28;14;28;28;14;28;"
    }), s({}, ye, {
      values: "1;0;1;1;0;1;"
    }), s({}, ge, {
      opacity: "1",
      d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
    }), s({}, ye, {
      values: "1;0;0;0;0;1;"
    }), s({}, ge, {
      opacity: "0",
      d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
    }), s({}, ye, {
      values: "0;0;1;1;0;0;"
    }), S.styles;

    function Ee(e) {
      var n = e[0],
          t = e[1],
          r = l(e.slice(4), 1)[0];
      return {
        found: !0,
        width: n,
        height: t,
        icon: Array.isArray(r) ? {
          tag: "g",
          attributes: {
            class: "".concat(_.familyPrefix, "-").concat(v.GROUP)
          },
          children: [{
            tag: "path",
            attributes: {
              class: "".concat(_.familyPrefix, "-").concat(v.SECONDARY),
              fill: "currentColor",
              d: r[0]
            }
          }, {
            tag: "path",
            attributes: {
              class: "".concat(_.familyPrefix, "-").concat(v.PRIMARY),
              fill: "currentColor",
              d: r[1]
            }
          }]
        } : {
          tag: "path",
          attributes: {
            fill: "currentColor",
            d: r
          }
        }
      };
    }

    S.styles;
    var ve = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';

    function we() {
      var e = g,
          n = I,
          t = _.familyPrefix,
          r = _.replacementClass,
          o = ve;

      if (t !== e || r !== n) {
        var i = new RegExp("\\.".concat(e, "\\-"), "g"),
            A = new RegExp("\\--".concat(e, "\\-"), "g"),
            s = new RegExp("\\.".concat(n), "g");
        o = o.replace(i, ".".concat(t, "-")).replace(A, "--".concat(t, "-")).replace(s, ".".concat(r));
      }

      return o;
    }

    function Be() {
      _.autoAddCss && !Oe && ($(we()), Oe = !0);
    }

    function _e(e, n) {
      return Object.defineProperty(e, "abstract", {
        get: n
      }), Object.defineProperty(e, "html", {
        get: function get() {
          return e.abstract.map(function (e) {
            return fe(e);
          });
        }
      }), Object.defineProperty(e, "node", {
        get: function get() {
          if (x) {
            var n = f.createElement("div");
            return n.innerHTML = e.html, n.children;
          }
        }
      }), e;
    }

    function De(e) {
      var n = e.prefix,
          t = void 0 === n ? "fa" : n,
          r = e.iconName;
      if (r) return de(Me.definitions, t, r) || de(S.styles, t, r);
    }

    var Se,
        Me = new (function () {
      function e() {
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.definitions = {};
      }

      var n, t, r;
      return n = e, (t = [{
        key: "add",
        value: function value() {
          for (var e = this, n = arguments.length, t = new Array(n), r = 0; r < n; r++) {
            t[r] = arguments[r];
          }

          var o = t.reduce(this._pullDefinitions, {});
          Object.keys(o).forEach(function (n) {
            e.definitions[n] = s({}, e.definitions[n] || {}, o[n]), ue(n, o[n]), Ce();
          });
        }
      }, {
        key: "reset",
        value: function value() {
          this.definitions = {};
        }
      }, {
        key: "_pullDefinitions",
        value: function value(e, n) {
          var t = n.prefix && n.iconName && n.icon ? {
            0: n
          } : n;
          return Object.keys(t).map(function (n) {
            var r = t[n],
                o = r.prefix,
                i = r.iconName,
                A = r.icon;
            e[o] || (e[o] = {}), e[o][i] = A;
          }), e;
        }
      }]) && i(n.prototype, t), r && i(n, r), e;
    }())(),
        Oe = !1,
        ke = {
      transform: function transform(e) {
        return he(e);
      }
    },
        Te = (Se = function Se(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          t = n.transform,
          r = void 0 === t ? Z : t,
          o = n.symbol,
          i = void 0 !== o && o,
          A = n.mask,
          l = void 0 === A ? null : A,
          a = n.title,
          c = void 0 === a ? null : a,
          u = n.classes,
          p = void 0 === u ? [] : u,
          m = n.attributes,
          C = void 0 === m ? {} : m,
          d = n.styles,
          f = void 0 === d ? {} : d;

      if (e) {
        var h = e.prefix,
            x = e.iconName,
            g = e.icon;
        return _e(s({
          type: "icon"
        }, e), function () {
          return Be(), _.autoA11y && (c ? C["aria-labelledby"] = "".concat(_.replacementClass, "-title-").concat(ne()) : (C["aria-hidden"] = "true", C.focusable = "false")), le({
            icons: {
              main: Ee(g),
              mask: l ? Ee(l.icon) : {
                found: !1,
                width: null,
                height: null,
                icon: {}
              }
            },
            prefix: h,
            iconName: x,
            transform: s({}, Z, r),
            symbol: i,
            title: c,
            extra: {
              attributes: C,
              styles: f,
              classes: p
            }
          });
        });
      }
    }, function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          t = (e || {}).icon ? e : De(e || {}),
          r = n.mask;
      return r && (r = (r || {}).icon ? r : De(r || {})), Se(t, s({}, n, {
        mask: r
      }));
    });
  }).call(this, t(12), t(56).setImmediate);
}, function (e, n, t) {
  "use strict";

  var r = t(120);
  e.exports = r;
}, function (e, n, t) {
  var r = t(227);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  "use strict";

  var r = t(19),
      o = t(3),
      i = t(38),
      A = o.List,
      s = o.Map,
      l = o.OrderedSet,
      a = o.Record,
      c = o.Repeat,
      u = l(),
      p = a({
    key: "",
    type: "unstyled",
    text: "",
    characterList: A(),
    depth: 0,
    data: s()
  }),
      m = function m(e) {
    if (!e) return e;
    var n = e.characterList,
        t = e.text;
    return t && !n && (e.characterList = A(c(r.EMPTY, t.length))), e;
  },
      C = function (e) {
    function n(t) {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.call(this, m(t)));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.getKey = function () {
      return this.get("key");
    }, n.prototype.getType = function () {
      return this.get("type");
    }, n.prototype.getText = function () {
      return this.get("text");
    }, n.prototype.getCharacterList = function () {
      return this.get("characterList");
    }, n.prototype.getLength = function () {
      return this.getText().length;
    }, n.prototype.getDepth = function () {
      return this.get("depth");
    }, n.prototype.getData = function () {
      return this.get("data");
    }, n.prototype.getInlineStyleAt = function (e) {
      var n = this.getCharacterList().get(e);
      return n ? n.getStyle() : u;
    }, n.prototype.getEntityAt = function (e) {
      var n = this.getCharacterList().get(e);
      return n ? n.getEntity() : null;
    }, n.prototype.findStyleRanges = function (e, n) {
      i(this.getCharacterList(), d, e, n);
    }, n.prototype.findEntityRanges = function (e, n) {
      i(this.getCharacterList(), f, e, n);
    }, n;
  }(p);

  function d(e, n) {
    return e.getStyle() === n.getStyle();
  }

  function f(e, n) {
    return e.getEntity() === n.getEntity();
  }

  e.exports = C;
}, function (e, n, t) {
  "use strict";

  var r = t(4),
      o = 55296,
      i = 56319,
      A = 56320,
      s = 57343,
      l = /[\uD800-\uDFFF]/;

  function a(e) {
    return o <= e && e <= s;
  }

  function c(e) {
    return l.test(e);
  }

  function u(e, n) {
    return 1 + a(e.charCodeAt(n));
  }

  function p(e, n, t) {
    if (n = n || 0, t = void 0 === t ? 1 / 0 : t || 0, !c(e)) return e.substr(n, t);
    var r = e.length;
    if (r <= 0 || n > r || t <= 0) return "";
    var o = 0;

    if (n > 0) {
      for (; n > 0 && o < r; n--) {
        o += u(e, o);
      }

      if (o >= r) return "";
    } else if (n < 0) {
      for (o = r; n < 0 && 0 < o; n++) {
        o -= u(e, o - 1);
      }

      o < 0 && (o = 0);
    }

    var i = r;
    if (t < r) for (i = o; t > 0 && i < r; t--) {
      i += u(e, i);
    }
    return e.substring(o, i);
  }

  var m = {
    getCodePoints: function getCodePoints(e) {
      for (var n = [], t = 0; t < e.length; t += u(e, t)) {
        n.push(e.codePointAt(t));
      }

      return n;
    },
    getUTF16Length: u,
    hasSurrogateUnit: c,
    isCodeUnitInSurrogateRange: a,
    isSurrogatePair: function isSurrogatePair(e, n) {
      if (0 <= n && n < e.length || r(!1), n + 1 === e.length) return !1;
      var t = e.charCodeAt(n),
          l = e.charCodeAt(n + 1);
      return o <= t && t <= i && A <= l && l <= s;
    },
    strlen: function strlen(e) {
      if (!c(e)) return e.length;

      for (var n = 0, t = 0; t < e.length; t += u(e, t)) {
        n++;
      }

      return n;
    },
    substring: function substring(e, n, t) {
      (n = n || 0) < 0 && (n = 0), (t = void 0 === t ? 1 / 0 : t || 0) < 0 && (t = 0);
      var r = Math.abs(t - n);
      return p(e, n = n < t ? n : t, r);
    },
    substr: p
  };
  e.exports = m;
}, function (e, n, t) {
  "use strict";

  var r = t(32);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, n, t, o, i, A) {
      if (A !== r) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }

    function n() {
      return e;
    }

    e.isRequired = e;
    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: n,
      element: e,
      elementType: e,
      instanceOf: n,
      node: e,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return t.PropTypes = t, t;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, n) {
  e.exports = function (e) {
    var n = "undefined" != typeof window && window.location;
    if (!n) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var t = n.protocol + "//" + n.host,
        r = t + n.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, n) {
      var o,
          i = n.trim().replace(/^"(.*)"$/, function (e, n) {
        return n;
      }).replace(/^'(.*)'$/, function (e, n) {
        return n;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? t + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.serialize = function () {
      return "Anchor: " + this.getAnchorKey() + ":" + this.getAnchorOffset() + ", Focus: " + this.getFocusKey() + ":" + this.getFocusOffset() + ", Is Backward: " + String(this.getIsBackward()) + ", Has Focus: " + String(this.getHasFocus());
    }, n.prototype.getAnchorKey = function () {
      return this.get("anchorKey");
    }, n.prototype.getAnchorOffset = function () {
      return this.get("anchorOffset");
    }, n.prototype.getFocusKey = function () {
      return this.get("focusKey");
    }, n.prototype.getFocusOffset = function () {
      return this.get("focusOffset");
    }, n.prototype.getIsBackward = function () {
      return this.get("isBackward");
    }, n.prototype.getHasFocus = function () {
      return this.get("hasFocus");
    }, n.prototype.hasEdgeWithin = function (e, n, t) {
      var r = this.getAnchorKey(),
          o = this.getFocusKey();

      if (r === o && r === e) {
        var i = this.getStartOffset();
        return n <= this.getEndOffset() && i <= t;
      }

      if (e !== r && e !== o) return !1;
      var A = e === r ? this.getAnchorOffset() : this.getFocusOffset();
      return n <= A && t >= A;
    }, n.prototype.isCollapsed = function () {
      return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
    }, n.prototype.getStartKey = function () {
      return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
    }, n.prototype.getStartOffset = function () {
      return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
    }, n.prototype.getEndKey = function () {
      return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
    }, n.prototype.getEndOffset = function () {
      return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
    }, n.createEmpty = function (e) {
      return new n({
        anchorKey: e,
        anchorOffset: 0,
        focusKey: e,
        focusOffset: 0,
        isBackward: !1,
        hasFocus: !1
      });
    }, n;
  }((0, t(3).Record)({
    anchorKey: "",
    anchorOffset: 0,
    focusKey: "",
    focusOffset: 0,
    isBackward: !1,
    hasFocus: !1
  }));

  e.exports = r;
}, function (e, n, t) {
  "use strict";

  function r(e) {
    return e.replace(/\//g, "-");
  }

  e.exports = function (e) {
    return "object" == typeof e ? Object.keys(e).filter(function (n) {
      return e[n];
    }).map(r).join(" ") : Array.prototype.map.call(arguments, r).join(" ");
  };
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(10);

  var o = function o(e, n) {
    return function (e) {
      var n = e[0].speaker,
          t = [],
          r = {
        words: [],
        text: "",
        speaker: ""
      };
      return e.forEach(function (e) {
        n === e.speaker ? (r.words.push(e), r.text += e.punct + " ", r.speaker = n) : (n = e.speaker, r.text = r.text.trim(), t.push(r), (r = {
          words: [],
          text: "",
          speaker: "U_UKN"
        }).words.push(e), r.text += e.punct + " ");
      }), t.push(r), t;
    }(function (e, n) {
      var t = [];
      return e.forEach(function (e) {
        var r,
            o = function (e, n) {
          var t = n.find(function (n) {
            var t = n.start + n.duration;
            return e.start >= n.start && e.end <= t;
          });
          return void 0 === t ? {
            "@type": "Segment",
            speaker: {
              "@id": "UKN",
              gender: "U"
            }
          } : t;
        }(e, n);

        e.speaker = (r = o.speaker).gender + "_" + r["@id"], t.push(e);
      }), t;
    }(e, n.segments));
  },
      i = function i(e) {
    var n,
        t = [],
        i = null;
    return void 0 === e.retval ? (n = e.words, void 0 !== e.segmentation && (i = e.segmentation)) : (n = e.retval.words, void 0 !== e.retval.segmentation && (i = e.retval.segmentation)), (null === i ? function (e) {
      var n = [],
          t = {
        words: [],
        text: []
      };
      return e.forEach(function (e) {
        /[.?!]/.test(e.punct) ? (t.words.push(e), t.text.push(e.punct), t.text = t.text.join(" "), n.push(t), t = {
          words: [],
          text: []
        }) : (t.words.push(e), t.text.push(e.punct));
      }), n;
    }(n) : o(n, i)).forEach(function (e, n) {
      if (void 0 !== e.words[0]) {
        var o = "TBC ".concat(n);
        null !== i && (o = e.speaker);
        var A = {
          text: e.text,
          type: "paragraph",
          data: {
            speaker: o,
            words: e.words,
            start: e.words[0].start
          },
          entityRanges: Object(r.a)(e.words, "punct")
        };
        t.push(A);
      }
    }), t;
  },
      A = function A(e) {
    var n = [];
    return function (e) {
      var n = [],
          t = {
        words: [],
        text: []
      };
      return e.forEach(function (e) {
        e.paragraph.forEach(function (e) {
          e.line.forEach(function (e) {
            var r = {
              text: e.text,
              start: e.startTime,
              end: e.endTime
            };
            /[.?!]/.test(e.text) ? (t.words.push(r), t.text.push(e.text), n.push(t), t = {
              words: [],
              text: []
            }) : (t.words.push(r), t.text.push(e.text));
          });
        });
      }), n;
    }(e.text).forEach(function (e, t) {
      var o = {
        text: e.text.join(" "),
        type: "paragraph",
        data: {
          speaker: "TBC ".concat(t),
          words: e.words,
          start: e.words[0].start
        },
        entityRanges: Object(r.a)(e.words, "text")
      };
      n.push(o);
    }), n;
  },
      s = function s(e, n) {
    for (var t in n) {
      var r = n[t],
          o = parseFloat(e);
      if (o >= r.start & o < r.end) return r.name;
    }

    return "UNK";
  },
      l = function l(e) {
    var n,
        t,
        o = [];
    return n = e.words, t = [], n.forEach(function (e) {
      /[.?!]/.test(e.name) ? (t[t.length - 1].name = t[t.length - 1].name + e.name, t[t.length - 1].duration = (parseFloat(t[t.length - 1].duration) + parseFloat(e.duration)).toString()) : t.push(e);
    }), function (e, n, t) {
      var r,
          o = [],
          i = {
        words: [],
        text: [],
        speaker: ""
      },
          A = s(e[0].start, n),
          l = !1;
      return e.forEach(function (e) {
        ((r = s(e.start, n)) !== A || i.words.length > t && l) && (i.speaker = A, o.push(i), A = r, i = {
          words: [],
          text: []
        }), i.words.push(e), i.text.push(e.punct), l = !!/[.?!]/.test(e.punct);
      }), i.speaker = A, o.push(i), o;
    }(t.map(function (e, n) {
      return {
        start: e.time,
        end: (parseFloat(e.time) + parseFloat(e.duration)).toString(),
        confidence: e.confidence,
        word: e.name.toLowerCase().replace(/[.?!]/g, ""),
        punct: e.name,
        index: n
      };
    }), e.speakers.map(function (e) {
      return {
        start: parseFloat(e.time),
        end: parseFloat(e.time) + parseFloat(e.duration),
        name: e.name
      };
    }), 150).forEach(function (e) {
      var n = e.words[0].start,
          t = {
        text: e.text.join(" "),
        type: "paragraph",
        data: {
          speaker: e.speaker,
          words: e.words,
          start: n
        },
        entityRanges: Object(r.a)(e.words, "punct")
      };
      o.push(t);
    }), o;
  },
      a = function a(e, n) {
    var t = parseFloat(e.start_time),
        r = parseFloat(e.end_time),
        o = n.find(function (e) {
      return t >= parseFloat(e.start_time) && r <= parseFloat(e.end_time);
    });
    return void 0 === o ? "UKN" : o.speaker_label.replace("spk_", "");
  },
      c = function c(e, n) {
    return function (e) {
      var n = [],
          t = "";
      return e.forEach(function (e) {
        e.speaker_label === t ? n[n.length - 1].words.push(e) : (t = e.speaker_label, n.push({
          speaker: e.speaker_label,
          words: [e]
        }));
      }), n;
    }(function (e, n) {
      return e.map(function (e) {
        return Object.assign(e, {
          speaker_label: a(e, n)
        });
      });
    }(e, n.segments));
  };

  function u(e, n) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      n && (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })), t.push.apply(t, r);
    }

    return t;
  }

  function p(e) {
    for (var n, t = 1; t < arguments.length; t++) {
      n = null == arguments[t] ? {} : arguments[t], t % 2 ? u(n, !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(n).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var C = function C(e) {
    return /punctuation/.test(e.type) ? Object.assign(e.alternatives[0], {
      confidence: 1
    }) : e.alternatives.reduce(function (e, n) {
      return parseFloat(e.confidence) > parseFloat(n.confidence) ? e : n;
    });
  },
      d = function d(e) {
    var n = C(e);
    return {
      start: parseFloat(e.start_time),
      end: parseFloat(e.end_time),
      text: n.content,
      confidence: parseFloat(n.confidence)
    };
  },
      f = function f(e) {
    var n = [];
    return e.map(function (t, r) {
      return "punctuation" === t.type ? (n.push(r - 1), function (e, n) {
        var t = e.alternatives[0].content;
        return p({}, n, {
          alternatives: n.alternatives.map(function (e) {
            return p({}, e, {
              content: e.content + (n = t, n.replace(/^\s/, ""))
            });
            var n;
          })
        });
      }(t, e[r - 1])) : t;
    }).filter(function (e, t) {
      return !n.includes(t);
    });
  },
      h = function h(e) {
    var n = [],
        t = e.results.items,
        o = e.results.speaker_labels,
        i = f(t);
    return (void 0 !== o ? function (e, n) {
      return c(e, n).map(function (e) {
        return {
          words: e.words.map(d),
          text: e.words.map(function (e) {
            return C(e).content;
          }),
          speaker: e.speaker
        };
      });
    }(i, o) : function (e) {
      var n = [],
          t = {
        words: [],
        text: []
      };
      return e.forEach(function (e) {
        var r = C(e).content,
            o = d(e);
        /[.?!]/.test(r) ? (t.words.push(o), t.text.push(r), n.push(t), t = {
          words: [],
          text: []
        }) : (t.words.push(o), t.text.push(r));
      }), n;
    }(i)).forEach(function (e, t) {
      var o = {
        text: e.text.join(" "),
        type: "paragraph",
        data: {
          speaker: e.speaker ? "Speaker ".concat(e.speaker) : "TBC ".concat(t),
          words: e.words,
          start: parseFloat(e.words[0].start)
        },
        entityRanges: Object(r.a)(e.words, "text")
      };
      n.push(o);
    }), n;
  },
      x = function x(e) {
    var n,
        t,
        o,
        i,
        A = (o = e.results[0].results, i = [], o.forEach(function (e) {
      i.push(e.alternatives[0].timestamps.map(function (e) {
        return {
          text: e[0],
          start: e[1],
          end: e[2]
        };
      }));
    }), i);
    return function (e) {
      var n = [];
      return e.forEach(function (e) {
        var t = {
          text: e.map(function (e) {
            return e.text;
          }).join(" "),
          type: "paragraph",
          data: {
            speaker: e[0].speaker,
            words: e,
            start: e[0].start
          },
          entityRanges: Object(r.a)(e, "text")
        };
        n.push(t);
      }), n;
    }((n = A, t = e.results[0].speaker_labels, n.map(function (e) {
      return e.map(function (e) {
        return e.speaker = function (e, n) {
          var t = n.find(function (n) {
            var t = n.from,
                r = n.to;
            return e.start === t && e.end === r;
          });
          return void 0 === t ? "UKN" : "S_".concat(t.speaker);
        }(e, t), e;
      });
    })));
  },
      g = t(48),
      I = function I(e) {
    var n = [],
        t = null,
        o = e.words;
    return e.paragraphs && (t = e.paragraphs), (t ? Object(g.default)(o, e.paragraphs) : function (e) {
      var n = [],
          t = {
        words: [],
        text: []
      };
      return e.forEach(function (e) {
        /[.?!]/.test(e.text) ? (t.words.push(e), t.text.push(e.text), t.text = t.text.join(" "), n.push(t), t = {
          words: [],
          text: []
        }) : (t.words.push(e), t.text.push(e.text));
      }), n;
    }(o)).forEach(function (e, o) {
      if (e.words[0]) {
        var i = "TBC ".concat(o);
        t && (i = e.speaker);
        var A = {
          text: e.text,
          type: "paragraph",
          data: {
            speaker: i,
            words: e.words,
            start: e.words[0].start
          },
          entityRanges: Object(r.a)(e.words, "text")
        };
        n.push(A);
      }
    }), n;
  },
      b = function b(e) {
    return e.reduce(function (e, n) {
      return e.concat(Array.isArray(n) ? b(n) : n);
    }, []);
  },
      y = function y(e) {
    var n = e.map(function (e) {
      return e.entityRanges;
    }),
        t = b(n),
        r = {};
    return t.forEach(function (e) {
      r[e.key] = {
        type: "WORD",
        mutability: "MUTABLE",
        data: e
      };
    }), r;
  },
      E = function E(e, n) {
    var t = parseFloat(e);
    return void 0 !== n && (t += parseFloat(n / 1e9)), t;
  },
      v = function v(e) {
    var n = [],
        t = {
      words: [],
      text: []
    };
    return e.forEach(function (e) {
      var r = function (e) {
        return 0 === e.alternatives.length ? e[0] : e.alternatives.reduce(function (e, n) {
          return parseFloat(e.confidence) > parseFloat(n.confidence) ? e : n;
        });
      }(e);

      t.text.push(r.transcript.trim()), r.words.forEach(function (e) {
        var n, o;
        t.words.push((n = e, o = r.confidence, {
          start: E(n.startTime.seconds, n.startTime.nanos),
          end: E(n.endTime.seconds, n.endTime.nanos),
          text: n.word,
          confidence: o
        }));
      }), n.push(t), t = {
        words: [],
        text: []
      };
    }), n;
  },
      w = function w(e) {
    var n = [];
    return v(e.results).forEach(function (e, t) {
      var o = {
        text: e.text.join(" "),
        type: "paragraph",
        data: {
          speaker: e.speaker ? "Speaker ".concat(e.speaker) : "TBC ".concat(t),
          words: e.words,
          start: parseFloat(e.words[0].start)
        },
        entityRanges: Object(r.a)(e.words, "text")
      };
      n.push(o);
    }), n;
  };

  t.d(n, "createEntityMap", function () {
    return y;
  });

  n.default = function (e, n) {
    var t;

    switch (n) {
      case "bbckaldi":
        return {
          blocks: t = i(e),
          entityMap: y(t)
        };

      case "autoedit2":
        return {
          blocks: t = A(e),
          entityMap: y(t)
        };

      case "speechmatics":
        return {
          blocks: t = l(e),
          entityMap: y(t)
        };

      case "ibm":
        return {
          blocks: t = x(e),
          entityMap: y(t)
        };

      case "draftjs":
        return e;

      case "amazontranscribe":
        return {
          blocks: t = h(e),
          entityMap: y(t)
        };

      case "digitalpaperedit":
        return {
          blocks: t = I(e),
          entityMap: y(t)
        };

      case "google-stt":
        return {
          blocks: t = w(e),
          entityMap: y(t)
        };

      default:
        console.error("Did not recognize the stt engine.");
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = t(3).OrderedMap,
      o = {
    createFromArray: function createFromArray(e) {
      return r(e.map(function (e) {
        return [e.getKey(), e];
      }));
    }
  };
  e.exports = o;
}, function (e, n, t) {
  "use strict";

  e.exports = function (e, n, t, r) {
    if (e.size) {
      var o = 0;
      e.reduce(function (e, i, A) {
        return n(e, i) || (t(e) && r(o, A), o = A), i;
      }), t(e.last()) && r(o, e.count());
    }
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    return "handled" === e || !0 === e;
  };
}, function (e, n) {
  e.exports = require("react-dom");
}, function (e, n, t) {
  "use strict";

  var r = t(16);

  e.exports = function (e, n, t) {
    var o = e.getSelection(),
        i = e.getCurrentContent(),
        A = o;

    if (o.isCollapsed()) {
      if ("forward" === t) {
        if (e.isSelectionAtEndOfContent()) return i;
      } else if (e.isSelectionAtStartOfContent()) return i;

      if ((A = n(e)) === o) return i;
    }

    return r.removeRange(i, A, t);
  };
}, function (e, n, t) {
  var r = t(73);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  var r = t(222);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  var r = t(225);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (function (e, n) {
    !function (e, t) {
      "use strict";

      if (!e.setImmediate) {
        var r,
            o,
            i,
            A,
            s,
            l = 1,
            a = {},
            c = !1,
            u = e.document,
            p = Object.getPrototypeOf && Object.getPrototypeOf(e);
        p = p && p.setTimeout ? p : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
          n.nextTick(function () {
            C(e);
          });
        } : !function () {
          if (e.postMessage && !e.importScripts) {
            var n = !0,
                t = e.onmessage;
            return e.onmessage = function () {
              n = !1;
            }, e.postMessage("", "*"), e.onmessage = t, n;
          }
        }() ? e.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (e) {
          C(e.data);
        }, r = function r(e) {
          i.port2.postMessage(e);
        }) : u && "onreadystatechange" in u.createElement("script") ? (o = u.documentElement, r = function r(e) {
          var n = u.createElement("script");
          n.onreadystatechange = function () {
            C(e), n.onreadystatechange = null, o.removeChild(n), n = null;
          }, o.appendChild(n);
        }) : r = function r(e) {
          setTimeout(C, 0, e);
        } : (A = "setImmediate$" + Math.random() + "$", s = function s(n) {
          n.source === e && "string" == typeof n.data && 0 === n.data.indexOf(A) && C(+n.data.slice(A.length));
        }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), r = function r(n) {
          e.postMessage(A + n, "*");
        }), p.setImmediate = function (e) {
          "function" != typeof e && (e = new Function("" + e));

          for (var n = new Array(arguments.length - 1), t = 0; t < n.length; t++) {
            n[t] = arguments[t + 1];
          }

          var o = {
            callback: e,
            args: n
          };
          return a[l] = o, r(l), l++;
        }, p.clearImmediate = m;
      }

      function m(e) {
        delete a[e];
      }

      function C(e) {
        if (c) setTimeout(C, 0, e);else {
          var n = a[e];

          if (n) {
            c = !0;

            try {
              !function (e) {
                var n = e.callback,
                    r = e.args;

                switch (r.length) {
                  case 0:
                    n();
                    break;

                  case 1:
                    n(r[0]);
                    break;

                  case 2:
                    n(r[0], r[1]);
                    break;

                  case 3:
                    n(r[0], r[1], r[2]);
                    break;

                  default:
                    n.apply(t, r);
                }
              }(n);
            } finally {
              m(e), c = !1;
            }
          }
        }
      }
    }("undefined" == typeof self ? void 0 === e ? this : e : self);
  }).call(this, t(12), t(46));
}, function (e, n) {
  var t,
      r,
      o = e.exports = {};

  function i() {
    throw new Error("setTimeout has not been defined");
  }

  function A() {
    throw new Error("clearTimeout has not been defined");
  }

  function s(e) {
    if (t === setTimeout) return setTimeout(e, 0);
    if ((t === i || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);

    try {
      return t(e, 0);
    } catch (n) {
      try {
        return t.call(null, e, 0);
      } catch (n) {
        return t.call(this, e, 0);
      }
    }
  }

  !function () {
    try {
      t = "function" == typeof setTimeout ? setTimeout : i;
    } catch (e) {
      t = i;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : A;
    } catch (e) {
      r = A;
    }
  }();
  var l,
      a = [],
      c = !1,
      u = -1;

  function p() {
    c && l && (c = !1, l.length ? a = l.concat(a) : u = -1, a.length && m());
  }

  function m() {
    if (!c) {
      var e = s(p);
      c = !0;

      for (var n = a.length; n;) {
        for (l = a, a = []; ++u < n;) {
          l && l[u].run();
        }

        u = -1, n = a.length;
      }

      l = null, c = !1, function (e) {
        if (r === clearTimeout) return clearTimeout(e);
        if ((r === A || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

        try {
          r(e);
        } catch (n) {
          try {
            return r.call(null, e);
          } catch (n) {
            return r.call(this, e);
          }
        }
      }(e);
    }
  }

  function C(e, n) {
    this.fun = e, this.array = n;
  }

  function d() {}

  o.nextTick = function (e) {
    var n = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var t = 1; t < arguments.length; t++) {
      n[t - 1] = arguments[t];
    }
    a.push(new C(e, n)), 1 !== a.length || c || s(m);
  }, C.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = d, o.addListener = d, o.once = d, o.off = d, o.removeListener = d, o.removeAllListeners = d, o.emit = d, o.prependListener = d, o.prependOnceListener = d, o.listeners = function (e) {
    return [];
  }, o.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, o.cwd = function () {
    return "/";
  }, o.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, o.umask = function () {
    return 0;
  };
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(42),
      l = t.n(s);

  function a(e) {
    return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function c(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function u(e, n) {
    return !n || "object" !== a(n) && "function" != typeof n ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : n;
  }

  function p(e) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function m(e, n) {
    return (m = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var C = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), u(this, p(n).apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && m(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        var e = this.props.options.map(function (e, n) {
          return o.a.createElement("option", {
            key: n,
            value: e.value
          }, e.label);
        });
        return o.a.createElement("select", {
          className: l.a.selectPlayerControl,
          name: this.props.name,
          value: this.props.currentValue,
          onChange: this.props.handleChange
        }, e);
      }
    }]) && c(t.prototype, r), i && c(t, i), n;
    var t, r, i;
  }(o.a.Component);

  C.propTypes = {
    options: A.a.array,
    name: A.a.string,
    currentValue: A.a.string,
    handleChange: A.a.func
  }, n.default = C;
}, function (e, n, t) {
  "use strict";

  t.r(n), n.default = function (e, n) {
    return function (e, n) {
      var t = [],
          r = "UKN",
          o = 0,
          i = 0,
          A = {
        words: [],
        text: "",
        speaker: ""
      };
      return e.forEach(function (e) {
        (r = function (e, n) {
          return n.find(function (n) {
            if (e.start >= n.start && e.end <= n.end) return n;
          });
        }(e, n)) && ((o = n.indexOf(r)) === i ? (A.words.push(e), A.text += e.text + " ", A.speaker = r.speaker) : (i = o, A.text.trim(), t.push(A), (A = {
          words: [],
          text: "",
          speaker: ""
        }).words.push(e), A.text += e.text + " ", A.speaker = r.speaker));
      }), t.push(A), t;
    }(e, n);
  };
}, function (e, n, t) {
  "use strict";

  t.r(n);

  var r = function r(e) {
    return e.blocks.map(function (e) {
      return "".concat(e.text);
    }).join("\n\n");
  },
      o = t(17),
      i = t(8),
      A = function A(e, n) {
    return function (e, n) {
      var t = new o.Document({
        creator: "Test",
        description: "Test Description",
        title: n
      }),
          r = new o.TextRun(n),
          A = new o.Paragraph();
      A.addRun(r), A.heading1().center(), t.addParagraph(A);
      var s = new o.Paragraph();
      t.addParagraph(s), e.blocks.forEach(function (e) {
        var n = new o.Paragraph(Object(i.shortTimecode)(e.data.words[0].start)),
            r = new o.TextRun(e.data.speaker).bold().tab(),
            A = new o.TextRun("").break();
        n.addRun(r), t.addParagraph(n);
        var s = new o.Paragraph(e.text);
        s.addRun(A), t.addParagraph(s);
      }), new o.Packer().toBlob(t).then(function (e) {
        var t = "".concat(n, ".docx"),
            r = document.createElement("a");
        return r.href = window.URL.createObjectURL(e), r.download = t, r.click(), e;
      });
    }(e, n);
  };

  var s = function s(e) {
    return e.blocks.map(function (e) {
      return "".concat(e.data.speaker, " \t [").concat(Object(i.shortTimecode)(e.data.start), "] \t ").concat(e.text);
    }).join("\n\n");
  },
      l = function l(e) {
    var n = {
      words: [],
      paragraphs: []
    };
    return e.blocks.forEach(function (e, t) {
      if (void 0 !== e.data.words) {
        var r = {
          id: t,
          start: e.data.words[0].start,
          end: e.data.words[e.data.words.length - 1].end,
          speaker: e.data.speaker
        };
        n.paragraphs.push(r);
        var o = e.data.words.map(function (e) {
          var n = {
            id: e.index,
            start: e.start,
            end: e.end,
            text: null
          };
          return e.text ? n.text = e.text : e.punct ? n.text = e.punct : e.word && (n.text = e.punct), n;
        });
        n.words = n.words.concat(o);
      }
    }), n;
  },
      a = t(74),
      c = t.n(a);

  var u = function u(e, n) {
    var t = null;
    void 0 !== n && (t = n);
    var r = {
      newline_boundaries: !0,
      html_boundaries: !1,
      sanitize: !1,
      allowed_tags: !1,
      abbreviations: t
    };
    return c.a.sentences(e, r).join("\n");
  };

  var p = function p(e) {
    return e.replace(/\n/g, "\n\n");
  };

  var m = function m(e) {
    return e.replace(/\n /g, "\n");
  };

  var C = function C(e, n) {
    return e.split("\n\n").map(function (e) {
      return function (e) {
        var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 35,
            t = 0;
        return e.map(function (e, r, o) {
          if ((t += e.length + 1) <= n) {
            if (void 0 !== o[r + 1]) {
              var i = o[r + 1].length;
              return t + i < n ? e : (t = 0, "".concat(e, "\n"));
            }

            return e;
          }

          return t = 0, "".concat(e, "\n");
        });
      }(e.split(" "), n);
    }).map(function (e) {
      return e.join(" ");
    }).map(function (e) {
      return m(e);
    }).join("\n\n");
  };

  var d = function d(e) {
    return e.map(function (e) {
      return e.replace(/^\s+/g, "");
    });
  };

  var f = function f(e) {
    var n = e.split("\n"),
        t = 0,
        r = n.map(function (e) {
      return "" === e ? e : 0 === t ? (t += 1, "." === e[e.length - 1][0] ? e + "\n\n" : e + "\n") : 1 === t ? (t = 0, e + "\n\n") : void 0;
    });
    return r = (r = (r = d(r)).filter(function (e) {
      return 0 !== e.length;
    })).join("").trim();
  };

  function h(e) {
    return (h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  var x = function x(e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 35,
        t = e;
    "object" === h(e) && (t = e.map(function (e) {
      return e.text;
    }).join(" "));
    var r = u(t),
        o = p(r),
        i = C(o, n);
    return f(i);
  },
      g = /&/g,
      I = /</g,
      b = />/g,
      y = function y(e) {
    return e.replace(g, "&amp;").replace(I, "&lt;").replace(b, "&gt;");
  },
      E = function E(e) {
    return new Date(1e3 * e.toFixed(3)).toISOString().substr(11, 12);
  },
      v = function v(e) {
    var n = '<?xml version="1.0" encoding="UTF-8" standalone="no" ?>\n    <tt xmlns="http://www.w3.org/ns/ttml"\n    xmlns:ttp="http://www.w3.org/ns/ttml#parameter"\n    ttp:timeBase="media"\n    xmlns:m608="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt#cea608"\n    xmlns:smpte="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt"\n    xmlns:ttm="http://www.w3.org/ns/ttml#metadata">\n    <head>\n    <metadata>\n    <smpte:information m608:captionService="F1C1CC" m608:channel="cc1"/>\n    </metadata>\n    <styling></styling>\n    <layout></layout>\n    </head>\n    <body><div>';
    return e.forEach(function (e) {
      n += '<p begin="'.concat(E(parseFloat(e.start)), '" end="').concat(E(parseFloat(e.end)), '">').concat(y(e.text).replace(/\n/g, "<br />"), "</p>\n");
    }), n += "</div>\n</body>\n</tt>";
  },
      w = t(75),
      B = t.n(w),
      _ = function _(e, n) {
    return B()(Math.round(e), n, !1).toString().replace(/^00/, "01");
  },
      D = function D(e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "en-GB",
        t = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 25,
        r = '<?xml version="1.0" encoding="UTF-8"?>\n        <tt\n          xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\n          xmlns="http://www.w3.org/ns/ttml"\n          xmlns:tt="http://www.w3.org/ns/ttml"\n          xmlns:tts="http://www.w3.org/ns/ttml#styling"\n          xmlns:ttp="http://www.w3.org/ns/ttml#parameter"\n          xml:lang="'.concat(n, '"\n          ttp:timeBase="smpte"\n          ttp:frameRate="').concat(t, '"\n          ttp:frameRateMultiplier="').concat(25 === t ? "1 1" : "999 1000", '"\n          ttp:dropMode="nonDrop"\n        >\n        <head>\n          <styling>\n            <style\n              xml:id="normal"\n              tts:fontFamily="sansSerif"\n              tts:fontWeight="normal"\n              tts:fontStyle="normal"\n              tts:color="white"\n              tts:fontSize="100%"\n            />\n          </styling>\n          <layout>\n            <region\n              xml:id="bottom"\n              tts:origin="0% 85%"\n              tts:extent="100% 15%"\n              tts:textAlign="center"\n              tts:displayAlign="after"\n            />\n          </layout>\n        </head>\n        <body style="normal" region="bottom">\n          <div begin="-01:00:00:00">');
    return e.forEach(function (e) {
      r += '<p begin="'.concat(_(parseFloat(e.start) * t, t), '" end="').concat(_(parseFloat(e.end) * t, t), '">').concat(y(e.text).replace(/\n/g, "<br />"), "</p>\n");
    }), r += "</div>\n</body>\n</tt>";
  },
      S = function S(e) {
    var n = '<?xml version="1.0" encoding="UTF-8"?>\n    <tt xmlns="http://www.w3.org/ns/ttml">\n    <head></head>\n    <body>\n    <div>';
    return e.forEach(function (e) {
      n += '<p begin="'.concat(E(parseFloat(e.start)), '" end="').concat(E(parseFloat(e.end)), '">').concat(y(e.text).replace(/\n/g, "<br />"), "</p>\n");
    }), n += "</div>\n</body>\n</tt>";
  },
      M = function M(e) {
    var n = "";
    return e.forEach(function (e, t) {
      n += "".concat(t + 1, "\n").concat(E(parseFloat(e.start)).replace(".", ","), " --\x3e ").concat(E(parseFloat(e.end)).replace(".", ","), "\n").concat(e.text.trim(), "\n\n");
    }), n;
  },
      O = function O(e) {
    var n = "WEBVTT\n\n";
    return e.forEach(function (e, t) {
      n += "".concat(t + 1, "\n").concat(E(parseFloat(e.start)), " --\x3e ").concat(E(parseFloat(e.end)), "\n").concat(e.text, "\n\n");
    }), n;
  };

  var k = function k(e) {
    var n = "N, In, Out, Text\n";
    return e.forEach(function (e, t) {
      n += "".concat(t + 1, ","), n += '"'.concat(e.start, '","').concat(e.end, '",'), n += '"'.concat(e.text.replace(/\n/g, "\r\n"), '"\n');
    }), n;
  };

  var T = function T(e) {
    var n = e.words,
        t = e.type,
        r = e.numberOfCharPerLine,
        o = function (e, n) {
      return function (e, n) {
        var t = 0,
            r = 0;
        return n.map(function (n) {
          r += n.trim().replace(/\n /g, "").replace(/\n/g, " ").split(" ").length;
          var o = {
            text: n.trim()
          };
          return o.start = e[t].start, o.end = e[r - 1].end, t = r, o;
        });
      }(e, function (e) {
        var n = e.split("\n\n");
        return n = n.map(function (e) {
          return e.trim();
        });
      }(x(e, n)));
    }(n, r);

    return "string" == typeof n ? x(n, r) : "premiere" === t ? v(o) : "ttml" === t ? S(o) : "itt" === t ? D(o) : "srt" === t ? M(o) : "vtt" === t ? O(o) : "json" === t ? o : "csv" === t ? k(o) : "pre-segment-txt" === t ? x(n, r) : "txt" === t ? x(n, r) : {
      ttml: S(o),
      premiere: v(o),
      itt: D(o),
      srt: M(o),
      vtt: O(o),
      json: o
    };
  };

  n.default = function (e, n, t) {
    switch (n) {
      case "draftjs":
        return {
          data: e,
          ext: "json"
        };

      case "txt":
        return {
          data: r(e),
          ext: "txt"
        };

      case "docx":
        return {
          data: A(e, t),
          ext: "docx"
        };

      case "txtspeakertimecodes":
        return {
          data: s(e),
          ext: "txt"
        };

      case "digitalpaperedit":
        return {
          data: l(e),
          ext: "json"
        };

      case "srt":
        var o = l(e).words;
        return {
          data: T({
            words: o,
            type: "srt",
            numberOfCharPerLine: 35
          }),
          ext: "srt"
        };

      case "premiereTTML":
        o = l(e).words;
        return {
          data: T({
            words: o,
            type: "premiere"
          }),
          ext: "ttml"
        };

      case "ttml":
        o = l(e).words;
        return {
          data: T({
            words: o,
            type: "ttml"
          }),
          ext: "ttml"
        };

      case "itt":
        o = l(e).words;
        return {
          data: T({
            words: o,
            type: "itt"
          }),
          ext: "itt"
        };

      case "csv":
        o = l(e).words;
        return {
          data: T({
            words: o,
            type: "csv"
          }),
          ext: "csv"
        };

      case "vtt":
        o = l(e).words;
        return {
          data: T({
            words: o,
            type: "vtt"
          }),
          ext: "vtt"
        };

      case "json-captions":
        o = l(e).words;
        return {
          data: T({
            words: o,
            type: "json"
          }),
          ext: "json"
        };

      case "pre-segment-txt":
        o = l(e).words;
        return {
          data: T({
            words: o,
            type: "pre-segment-txt"
          }),
          ext: "txt"
        };

      default:
        console.error("Did not recognise the export format");
    }
  };
}, function (e, n, t) {
  var r = t(118);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  "use strict";

  var r = t(84),
      o = t(85);

  e.exports = function (e, n) {
    var t = n.getStartKey(),
        i = n.getStartOffset(),
        A = n.getEndKey(),
        s = n.getEndOffset(),
        l = o(e, n).getBlockMap(),
        a = l.keySeq(),
        c = a.indexOf(t),
        u = a.indexOf(A) + 1;
    return r(l.slice(c, u).map(function (e, n) {
      var r = e.getText(),
          o = e.getCharacterList();
      return t === A ? e.merge({
        text: r.slice(i, s),
        characterList: o.slice(i, s)
      }) : n === t ? e.merge({
        text: r.slice(i),
        characterList: o.slice(i)
      }) : n === A ? e.merge({
        text: r.slice(0, s),
        characterList: o.slice(0, s)
      }) : e;
    }));
  };
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      o = t(89),
      i = t(3),
      A = t(4),
      s = (0, i.Map)(),
      l = 0;

  function a(e, n) {
    console.warn("WARNING: " + e + ' will be deprecated soon!\nPlease use "' + n + '" instead.');
  }

  var c = {
    getLastCreatedEntityKey: function getLastCreatedEntityKey() {
      return a("DraftEntity.getLastCreatedEntityKey", "contentState.getLastCreatedEntityKey"), c.__getLastCreatedEntityKey();
    },
    create: function create(e, n, t) {
      return a("DraftEntity.create", "contentState.createEntity"), c.__create(e, n, t);
    },
    add: function add(e) {
      return a("DraftEntity.add", "contentState.addEntity"), c.__add(e);
    },
    get: function get(e) {
      return a("DraftEntity.get", "contentState.getEntity"), c.__get(e);
    },
    mergeData: function mergeData(e, n) {
      return a("DraftEntity.mergeData", "contentState.mergeEntityData"), c.__mergeData(e, n);
    },
    replaceData: function replaceData(e, n) {
      return a("DraftEntity.replaceData", "contentState.replaceEntityData"), c.__replaceData(e, n);
    },
    __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
      return "" + l;
    },
    __create: function __create(e, n, t) {
      return c.__add(new o({
        type: e,
        mutability: n,
        data: t || {}
      }));
    },
    __add: function __add(e) {
      var n = "" + ++l;
      return s = s.set(n, e), n;
    },
    __get: function __get(e) {
      var n = s.get(e);
      return n || A(!1), n;
    },
    __mergeData: function __mergeData(e, n) {
      var t = c.__get(e),
          o = r({}, t.getData(), n),
          i = t.set("data", o);

      return s = s.set(e, i), i;
    },
    __replaceData: function __replaceData(e, n) {
      var t = c.__get(e).set("data", n);

      return s = s.set(e, t), t;
    }
  };
  e.exports = c;
}, function (e, n, t) {
  "use strict";

  var r = {
    encode: function encode(e, n, t) {
      return e + "-" + n + "-" + t;
    },
    decode: function decode(e) {
      var n = e.split("-"),
          t = n[0],
          r = n[1],
          o = n[2];
      return {
        blockKey: t,
        decoratorKey: parseInt(r, 10),
        leafKey: parseInt(o, 10)
      };
    }
  };
  e.exports = r;
}, function (e, n, t) {
  "use strict";

  e.exports.makeItArrayIfItsNot = function (e) {
    return "[object Array]" !== Object.prototype.toString.call(e) ? [e] : e;
  }, e.exports.findIntervalLeftBorderIndex = function (e, n) {
    if (e < n[0]) return 0;
    if (e > n[n.length - 1]) return n.length - 1;

    for (var t, r = 0, o = n.length - 1; o - r != 1;) {
      e >= n[t = r + Math.floor((o - r) / 2)] ? r = t : o = t;
    }

    return r;
  };
}, function (e, n, t) {
  var r = t(224);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (function (e) {
    var r = void 0 !== e && e || "undefined" != typeof self && self || window,
        o = Function.prototype.apply;

    function i(e, n) {
      this._id = e, this._clearFn = n;
    }

    n.setTimeout = function () {
      return new i(o.call(setTimeout, r, arguments), clearTimeout);
    }, n.setInterval = function () {
      return new i(o.call(setInterval, r, arguments), clearInterval);
    }, n.clearTimeout = n.clearInterval = function (e) {
      e && e.close();
    }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
      this._clearFn.call(r, this._id);
    }, n.enroll = function (e, n) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = n;
    }, n.unenroll = function (e) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
    }, n._unrefActive = n.active = function (e) {
      clearTimeout(e._idleTimeoutId);
      var n = e._idleTimeout;
      n >= 0 && (e._idleTimeoutId = setTimeout(function () {
        e._onTimeout && e._onTimeout();
      }, n));
    }, t(45), n.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, n.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(20),
      l = t.n(s),
      a = t(47),
      c = t(9),
      u = t.n(c);

  function p(e) {
    return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function m(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function C(e) {
    return (C = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function d(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function f(e, n) {
    return (f = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var h = function (e) {
    function n() {
      var e, t, r, o, i;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      for (var A = arguments.length, s = Array(A), a = 0; a < A; a++) {
        s[a] = arguments[a];
      }

      return t = function (e, n) {
        return !n || "object" !== p(n) && "function" != typeof n ? d(e) : n;
      }(this, (e = C(n)).call.apply(e, [this].concat(s))), r = d(t), i = function i(e) {
        return !l()(t.props, e);
      }, (o = "shouldComponentUpdate") in r ? Object.defineProperty(r, o, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[o] = i, t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && f(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("span", {
          className: u.a.playBackRate,
          title: "Playback rate: alt - & alt + "
        }, o.a.createElement(a.default, {
          options: this.props.playbackRateOptions,
          currentValue: this.props.playbackRate.toString(),
          name: "playbackRate",
          handleChange: this.props.handlePlayBackRateChange
        }));
      }
    }]) && m(t.prototype, r), i && m(t, i), n;
    var t, r, i;
  }(o.a.Component);

  h.propTypes = {
    playbackRateOptions: A.a.array,
    playbackRate: A.a.number,
    handlePlayBackRateChange: A.a.func
  }, n.default = h;
}, function (e, n, t) {
  var r = t(231);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(20),
      l = t.n(s),
      a = t(6),
      c = t(5),
      u = t(57),
      p = t(9),
      m = t.n(p);

  function C(e) {
    return (C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function d(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function f(e) {
    return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function h(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function x(e, n) {
    return (x = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function g(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var I = function (e) {
    function n() {
      var e, t;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      for (var r = arguments.length, o = Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      return t = function (e, n) {
        return !n || "object" !== C(n) && "function" != typeof n ? h(e) : n;
      }(this, (e = f(n)).call.apply(e, [this].concat(o))), g(h(t), "shouldComponentUpdate", function (e) {
        return !l()(t.props, e);
      }), g(h(t), "handleClick", function (e) {
        t.props.promptSetCurrentTime(e);
      }), t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && x(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("div", {
          className: m.a.timeBox
        }, o.a.createElement("span", {
          title: "Current time: alt t",
          className: m.a.currentTime,
          onClick: this.handleClick
        }, this.props.currentTime), o.a.createElement("span", {
          className: m.a.separator
        }, "|"), o.a.createElement("span", {
          title: "Clip duration",
          className: m.a.duration
        }, this.props.duration));
      }
    }]) && d(t.prototype, r), i && d(t, i), n;
    var t, r, i;
  }(o.a.Component);

  function b(e) {
    return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function y(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function E(e) {
    return (E = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function v(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function w(e, n) {
    return (w = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function B(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var _ = function (e) {
    function n() {
      var e, t;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      for (var r = arguments.length, o = Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      return t = function (e, n) {
        return !n || "object" !== b(n) && "function" != typeof n ? v(e) : n;
      }(this, (e = E(n)).call.apply(e, [this].concat(o))), B(v(t), "shouldComponentUpdate", function (e) {
        return !l()(t.props, e);
      }), B(v(t), "setIntervalHelperBackward", function () {
        t.interval = setInterval(function () {
          t.props.skipBackward();
        }, 300);
      }), B(v(t), "setIntervalHelperForward", function () {
        t.interval = setInterval(function () {
          t.props.skipForward();
        }, 300);
      }), B(v(t), "clearIntervalHelper", function () {
        clearInterval(t.interval);
      }), t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && w(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        var e = this,
            n = "pictureInPictureEnabled" in document ? o.a.createElement("button", {
          value: "Picture-in-picture",
          title: "Picture-in-picture",
          className: "".concat(m.a.playerButton, " ").concat(m.a.pip),
          onClick: this.props.pictureInPicture
        }, o.a.createElement(c.a, {
          icon: a.l
        })) : null;
        return o.a.createElement("div", {
          className: m.a.playerControls
        }, o.a.createElement(I, {
          promptSetCurrentTime: this.props.promptSetCurrentTime,
          currentTime: this.props.currentTime,
          duration: this.props.duration
        }), o.a.createElement("div", {
          className: m.a.btnsGroup
        }, o.a.createElement("button", {
          value: "seek backward by a set interval: alt r",
          title: "seek backward by a set interval: alt r",
          className: m.a.playerButton,
          onClick: this.props.rollback
        }, o.a.createElement(c.a, {
          icon: a.m
        })), o.a.createElement("button", {
          value: "seek backward: alt j",
          title: "seek backward: alt j",
          className: m.a.playerButton,
          onMouseDown: this.setIntervalHelperBackward,
          onMouseUp: this.clearIntervalHelper,
          onClick: function onClick() {
            e.props.skipBackward();
          }
        }, o.a.createElement(c.a, {
          icon: a.a
        })), o.a.createElement("button", {
          value: "Play/Pause: alt k",
          title: "Play/Pause: alt k",
          className: m.a.playerButton,
          onClick: this.props.playMedia
        }, this.props.isPlaying ? o.a.createElement(c.a, {
          icon: a.g
        }) : o.a.createElement(c.a, {
          icon: a.h
        })), o.a.createElement("button", {
          value: "seek forward: alt l",
          title: "seek forward: alt l",
          className: m.a.playerButton,
          onMouseDown: this.setIntervalHelperForward,
          onMouseUp: this.clearIntervalHelper,
          onClick: function onClick() {
            e.props.skipForward();
          }
        }, o.a.createElement(c.a, {
          icon: a.c
        }))), o.a.createElement("div", {
          className: m.a.btnsGroup
        }, o.a.createElement(u.default, {
          playbackRateOptions: this.props.playbackRateOptions,
          playbackRate: this.props.playbackRate,
          name: "playbackRate",
          handlePlayBackRateChange: this.props.setPlayBackRate
        }), n, o.a.createElement("button", {
          value: "Toggle Sound",
          title: "Toggle Sound",
          className: m.a.playerButton,
          onClick: this.props.handleMuteVolume
        }, this.props.isMute ? o.a.createElement(c.a, {
          icon: a.o
        }) : o.a.createElement(c.a, {
          icon: a.p
        }))));
      }
    }]) && y(t.prototype, r), i && y(t, i), n;
    var t, r, i;
  }(o.a.Component);

  _.propTypes = {
    playMedia: A.a.func,
    currentTime: A.a.string,
    timecodeOffset: A.a.string,
    promptSetCurrentTime: A.a.func,
    rollback: A.a.func,
    handleMuteVolume: A.a.func,
    duration: A.a.string,
    isPlaying: A.a.bool,
    isMute: A.a.bool,
    skipBackward: A.a.func,
    skipForward: A.a.func,
    playbackRate: A.a.number,
    playbackRateOptions: A.a.array,
    setPlayBackRate: A.a.func,
    pictureInPicture: A.a.func
  };
  n.default = _;
}, function (e, n, t) {
  "use strict";

  function r(e) {
    return function () {
      return e;
    };
  }

  var o = function o() {};

  o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
    return this;
  }, o.thatReturnsArgument = function (e) {
    return e;
  }, e.exports = o;
}, function (e, n, t) {
  "use strict";

  var r = t(37),
      o = t(19),
      i = t(29),
      A = t(21),
      s = t(52),
      l = t(27),
      a = t(3),
      c = t(34),
      u = t(25),
      p = t(62),
      m = a.List,
      C = a.Record,
      d = a.Repeat,
      f = l.draft_tree_data_support ? A : i,
      h = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.getEntityMap = function () {
      return s;
    }, n.prototype.getBlockMap = function () {
      return this.get("blockMap");
    }, n.prototype.getSelectionBefore = function () {
      return this.get("selectionBefore");
    }, n.prototype.getSelectionAfter = function () {
      return this.get("selectionAfter");
    }, n.prototype.getBlockForKey = function (e) {
      return this.getBlockMap().get(e);
    }, n.prototype.getKeyBefore = function (e) {
      return this.getBlockMap().reverse().keySeq().skipUntil(function (n) {
        return n === e;
      }).skip(1).first();
    }, n.prototype.getKeyAfter = function (e) {
      return this.getBlockMap().keySeq().skipUntil(function (n) {
        return n === e;
      }).skip(1).first();
    }, n.prototype.getBlockAfter = function (e) {
      return this.getBlockMap().skipUntil(function (n, t) {
        return t === e;
      }).skip(1).first();
    }, n.prototype.getBlockBefore = function (e) {
      return this.getBlockMap().reverse().skipUntil(function (n, t) {
        return t === e;
      }).skip(1).first();
    }, n.prototype.getBlocksAsArray = function () {
      return this.getBlockMap().toArray();
    }, n.prototype.getFirstBlock = function () {
      return this.getBlockMap().first();
    }, n.prototype.getLastBlock = function () {
      return this.getBlockMap().last();
    }, n.prototype.getPlainText = function (e) {
      return this.getBlockMap().map(function (e) {
        return e ? e.getText() : "";
      }).join(e || "\n");
    }, n.prototype.getLastCreatedEntityKey = function () {
      return s.__getLastCreatedEntityKey();
    }, n.prototype.hasText = function () {
      var e = this.getBlockMap();
      return e.size > 1 || e.first().getLength() > 0;
    }, n.prototype.createEntity = function (e, n, t) {
      return s.__create(e, n, t), this;
    }, n.prototype.mergeEntityData = function (e, n) {
      return s.__mergeData(e, n), this;
    }, n.prototype.replaceEntityData = function (e, n) {
      return s.__replaceData(e, n), this;
    }, n.prototype.addEntity = function (e) {
      return s.__add(e), this;
    }, n.prototype.getEntity = function (e) {
      return s.__get(e);
    }, n.createFromBlockArray = function (e, t) {
      var o = Array.isArray(e) ? e : e.contentBlocks,
          i = r.createFromArray(o),
          A = i.isEmpty() ? new c() : c.createEmpty(i.first().getKey());
      return new n({
        blockMap: i,
        entityMap: t || s,
        selectionBefore: A,
        selectionAfter: A
      });
    }, n.createFromText = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : /\r\n?|\n/g,
          r = e.split(t),
          i = r.map(function (e) {
        return e = p(e), new f({
          key: u(),
          text: e,
          type: "unstyled",
          characterList: m(d(o.EMPTY, e.length))
        });
      });
      return n.createFromBlockArray(i);
    }, n;
  }(C({
    entityMap: null,
    blockMap: null,
    selectionBefore: null,
    selectionAfter: null
  }));

  e.exports = h;
}, function (e, n, t) {
  "use strict";

  var r = new RegExp("\r", "g");

  e.exports = function (e) {
    return e.replace(r, "");
  };
}, function (e, n, t) {
  "use strict";

  var r = t(4),
      o = "LTR",
      i = "RTL",
      A = null;

  function s(e) {
    return e === o || e === i;
  }

  function l(e) {
    return s(e) || r(!1), e === o ? "ltr" : "rtl";
  }

  function a(e) {
    A = e;
  }

  var c = {
    NEUTRAL: "NEUTRAL",
    LTR: o,
    RTL: i,
    isStrong: s,
    getHTMLDir: l,
    getHTMLDirIfDifferent: function getHTMLDirIfDifferent(e, n) {
      return s(e) || r(!1), s(n) || r(!1), e === n ? null : l(e);
    },
    setGlobalDir: a,
    initGlobalDir: function initGlobalDir() {
      a(o);
    },
    getGlobalDir: function getGlobalDir() {
      return A || this.initGlobalDir(), A || r(!1), A;
    }
  };
  e.exports = c;
}, function (e, n, t) {
  "use strict";

  var r = t(3).Map,
      o = t(0),
      i = t(35),
      A = r({
    "header-one": {
      element: "h1"
    },
    "header-two": {
      element: "h2"
    },
    "header-three": {
      element: "h3"
    },
    "header-four": {
      element: "h4"
    },
    "header-five": {
      element: "h5"
    },
    "header-six": {
      element: "h6"
    },
    "unordered-list-item": {
      element: "li",
      wrapper: o.createElement("ul", {
        className: i("public/DraftStyleDefault/ul")
      })
    },
    "ordered-list-item": {
      element: "li",
      wrapper: o.createElement("ol", {
        className: i("public/DraftStyleDefault/ol")
      })
    },
    blockquote: {
      element: "blockquote"
    },
    atomic: {
      element: "figure"
    },
    "code-block": {
      element: "pre",
      wrapper: o.createElement("pre", {
        className: i("public/DraftStyleDefault/pre")
      })
    },
    unstyled: {
      element: "div",
      aliasedElements: ["p"]
    }
  });
  e.exports = A;
}, function (e, n, t) {
  "use strict";

  e.exports = {
    BACKSPACE: 8,
    TAB: 9,
    RETURN: 13,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46,
    COMMA: 188,
    PERIOD: 190,
    A: 65,
    Z: 90,
    ZERO: 48,
    NUMPAD_0: 96,
    NUMPAD_9: 105
  };
}, function (e, n, t) {
  "use strict";

  function r(e, n) {
    return n && "MUTABLE" === e.__get(n).getMutability() ? n : null;
  }

  e.exports = function (e, n) {
    var t;

    if (n.isCollapsed()) {
      var o = n.getAnchorKey(),
          i = n.getAnchorOffset();
      return i > 0 ? (t = e.getBlockForKey(o).getEntityAt(i - 1)) !== e.getBlockForKey(o).getEntityAt(i) ? null : r(e.getEntityMap(), t) : null;
    }

    var A = n.getStartKey(),
        s = n.getStartOffset(),
        l = e.getBlockForKey(A);
    return t = s === l.getLength() ? null : l.getEntityAt(s), r(e.getEntityMap(), t);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(149);

  e.exports = function e(n, t) {
    return !(!n || !t) && (n === t || !r(n) && (r(t) ? e(n, t.parentNode) : "contains" in n ? n.contains(t) : !!n.compareDocumentPosition && !!(16 & n.compareDocumentPosition(t))));
  };
}, function (e, n, t) {
  "use strict";

  function r(e, n) {
    var t = o.get(e, n);
    return "auto" === t || "scroll" === t;
  }

  var o = {
    get: t(151),
    getScrollParent: function getScrollParent(e) {
      if (!e) return null;

      for (var n = e.ownerDocument; e && e !== n.body;) {
        if (r(e, "overflow") || r(e, "overflowY") || r(e, "overflowX")) return e;
        e = e.parentNode;
      }

      return n.defaultView || n.parentWindow;
    }
  };
  e.exports = o;
}, function (e, n, t) {
  "use strict";

  var r = t(156),
      o = t(157);

  e.exports = function (e) {
    var n = r(e.ownerDocument || e.document);
    e.Window && e instanceof e.Window && (e = n);
    var t = o(e),
        i = e === n ? e.ownerDocument.documentElement : e,
        A = e.scrollWidth - i.clientWidth,
        s = e.scrollHeight - i.clientHeight;
    return t.x = Math.max(0, Math.min(t.x, A)), t.y = Math.max(0, Math.min(t.y, s)), t;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(97);

  e.exports = function (e) {
    for (var n = e; n && n !== document.documentElement;) {
      var t = r(n);
      if (null != t) return t;
      n = n.parentNode;
    }

    return null;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(24).isPlatform("Mac OS X"),
      o = {
    isCtrlKeyCommand: function isCtrlKeyCommand(e) {
      return !!e.ctrlKey && !e.altKey;
    },
    isOptionKeyCommand: function isOptionKeyCommand(e) {
      return r && e.altKey;
    },
    hasCommandModifier: function hasCommandModifier(e) {
      return r ? !!e.metaKey && !e.altKey : o.isCtrlKeyCommand(e);
    }
  };
  e.exports = o;
}, function (e, n, t) {
  "use strict";

  e.exports = function (e, n) {
    var t = e.getSelection(),
        r = e.getCurrentContent(),
        o = t.getStartKey(),
        i = t.getStartOffset(),
        A = o,
        s = 0;

    if (n > i) {
      var l = r.getKeyBefore(o);
      if (null == l) A = o;else A = l, s = r.getBlockForKey(l).getText().length;
    } else s = i - n;

    return t.merge({
      focusKey: A,
      focusOffset: s,
      isBackward: !0
    });
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._34fv5jYOgZKRoWiMw1LZ7y[name='playbackRate']{font-size:1em;-webkit-appearance:none;-moz-appearance:none;appearance:none;height:48px;width:97px;border-radius:0;background-image:url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEyNS4zMDQgMTI1LjMwNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTI1LjMwNCAxMjUuMzA0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CjxnPgoJPGc+CgkJPHBvbHlnb24gcG9pbnRzPSI2Mi42NTIsMTAzLjg5NSAwLDIxLjQwOSAxMjUuMzA0LDIxLjQwOSAgICIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=);background-repeat:no-repeat;background-position:85% center;color:white;border-color:transparent;padding-left:32px}@media (max-width: 768px){._34fv5jYOgZKRoWiMw1LZ7y[name='playbackRate']{width:100%}}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/media-player/src/Select.module.scss"],
    names: [],
    mappings: "AAAA,8CACE,aAAc,CACd,uBAAwB,CACxB,oBAAqB,CACrB,eAAgB,CAChB,WAAY,CACZ,UAAW,CACX,eAAgB,CAChB,q4BAAs4B,CACt4B,2BAA4B,CAC5B,8BAA+B,CAC/B,WAAY,CACZ,wBAAyB,CACzB,iBAAkB,CACnB,0BAIC,8CACE,UAAW,CACZ",
    file: "Select.module.scss",
    sourcesContent: [".selectPlayerControl[name='playbackRate'] {\n  font-size: 1em;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  height: 48px;\n  width: 97px;\n  border-radius: 0;\n  background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEyNS4zMDQgMTI1LjMwNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTI1LjMwNCAxMjUuMzA0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CjxnPgoJPGc+CgkJPHBvbHlnb24gcG9pbnRzPSI2Mi42NTIsMTAzLjg5NSAwLDIxLjQwOSAxMjUuMzA0LDIxLjQwOSAgICIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=);\n  background-repeat: no-repeat;\n  background-position: 85% center;\n  color: white;\n  border-color: transparent;\n  padding-left: 32px;\n}\n\n@media (max-width: 768px) {\n\n  .selectPlayerControl[name='playbackRate'] {\n    width: 100%;\n  }\n}\n"]
  }]), n.locals = {
    selectPlayerControl: "_34fv5jYOgZKRoWiMw1LZ7y"
  };
}, function (e, n, t) {
  var r = t(115),
      o = t(116),
      i = t(117),
      A = " @~@ ".trim(),
      s = new RegExp("\\S", ""),
      l = new RegExp("\\n+|[-#=_+*]{4,}", "g"),
      a = new RegExp("\\S+|\\n", "g");

  n.sentences = function (e, n) {
    if (!e || "string" != typeof e || !e.length) return [];
    if (!s.test(e)) return [];
    var t,
        c,
        u = {
      newline_boundaries: !1,
      html_boundaries: !1,
      html_boundaries_tags: ["p", "div", "ul", "ol"],
      sanitize: !1,
      allowed_tags: !1,
      preserve_whitespace: !1,
      abbreviations: null
    };
    if ("boolean" == typeof n) u.newline_boundaries = !0;else for (var p in n) {
      u[p] = n[p];
    }

    if (i.setAbbreviations(u.abbreviations), u.newline_boundaries && (e = e.replace(l, " @~@ ")), u.html_boundaries) {
      var m = "(<br\\s*\\/?>|<\\/(" + u.html_boundaries_tags.join("|") + ")>)",
          C = new RegExp(m, "g");
      e = e.replace(C, "$1 @~@ ");
    }

    (u.sanitize || u.allowed_tags) && (u.allowed_tags || (u.allowed_tags = [""]), e = r(e, {
      allowedTags: u.allowed_tags
    }));
    var d = 0,
        f = 0,
        h = [],
        x = [],
        g = [];
    if (!(t = u.preserve_whitespace ? (c = e.split(/(<br\s*\/?>|\S+|\n+)/)).filter(function (e, n) {
      return n % 2;
    }) : e.trim().match(a)) || !t.length) return [];

    for (var I = 0, b = t.length; I < b; I++) {
      if (d++, g.push(t[I]), ~t[I].indexOf(",") && (d = 0), i.isBoundaryChar(t[I]) || o.endsWithChar(t[I], "?!") || t[I] === A) (u.newline_boundaries || u.html_boundaries) && t[I] === A && g.pop(), x.push(g), d = 0, g = [];else if ((o.endsWithChar(t[I], '"') || o.endsWithChar(t[I], "”")) && (t[I] = t[I].slice(0, -1)), o.endsWithChar(t[I], ".")) {
        if (I + 1 < b) {
          if (2 === t[I].length && isNaN(t[I].charAt(0))) continue;
          if (i.isCommonAbbreviation(t[I])) continue;

          if (i.isSentenceStarter(t[I + 1])) {
            if (i.isTimeAbbreviation(t[I], t[I + 1])) continue;
            if (i.isNameAbbreviation(d, t.slice(I, 6))) continue;
            if (i.isNumber(t[I + 1]) && i.isCustomAbbreviation(t[I])) continue;
          } else {
            if (o.endsWith(t[I], "..")) continue;
            if (i.isDottedAbbreviation(t[I])) continue;
            if (i.isNameAbbreviation(d, t.slice(I, 5))) continue;
          }
        }

        x.push(g), g = [], d = 0;
      } else {
        if ((f = t[I].indexOf(".")) > -1) {
          if (i.isNumber(t[I], f)) continue;
          if (i.isDottedAbbreviation(t[I])) continue;
          if (i.isURL(t[I]) || i.isPhoneNr(t[I])) continue;
        }

        (h = i.isConcatenated(t[I])) && (g.pop(), g.push(h[0]), x.push(g), d = 0, (g = []).push(h[1]));
      }
    }

    return g.length && x.push(g), (x = x.filter(function (e) {
      return e.length > 0;
    })).slice(1).reduce(function (e, n) {
      var t = e[e.length - 1];
      return 1 === t.length && /^.{1,2}[.]$/.test(t[0]) && !/[.]/.test(n[0]) ? (e.pop(), e.push(t.concat(n)), e) : (e.push(n), e);
    }, [x[0]]).map(function (e, n) {
      if (u.preserve_whitespace && !u.newline_boundaries && !u.html_boundaries) {
        var t = 2 * e.length;
        return 0 === n && (t += 1), c.splice(0, t).join("");
      }

      return e.join(" ");
    });
  };
}, function (e, n, t) {
  var r, _o2;

  r = this, (_o2 = function o(e, n, t) {
    if (!(this instanceof _o2)) return new _o2(e, n, t);
    if (void 0 === n) this.frameRate = 29.97;else {
      if (!("number" == typeof n && n > 0)) throw new Error("Number expected as framerate");
      this.frameRate = n;
    }
    if (23.976 !== this.frameRate && 24 !== this.frameRate && 25 !== this.frameRate && 29.97 !== this.frameRate && 30 !== this.frameRate && 50 !== this.frameRate && 59.94 !== this.frameRate && 60 !== this.frameRate) throw new Error("Unsupported framerate");
    if (this.dropFrame = "boolean" == typeof t ? t : 29.97 === this.frameRate || 59.94 === this.frameRate, "number" == typeof e) this.frameCount = Math.round(e), this._frameCountToTimeCode();else if ("string" == typeof e) {
      var r = e.match("^([012]\\d):(\\d\\d):(\\d\\d)(:|;|\\.)(\\d\\d)$");
      if (!r) throw new Error("Timecode string expected as HH:MM:SS:FF or HH:MM:SS;FF");
      this.hours = parseInt(r[1]), this.minutes = parseInt(r[2]), this.seconds = parseInt(r[3]), "boolean" != typeof t && (this.dropFrame = ":" !== r[4]), this.frames = parseInt(r[5]), this._timeCodeToFrameCount();
    } else if ("object" == typeof e && e instanceof Date) {
      var i = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 0, 0, 0),
          A = 60 * i.getTimezoneOffset() * 1e3,
          s = 60 * e.getTimezoneOffset() * 1e3;
      this.frameCount = Math.round((e - i + (A - s)) * this.frameRate / 1e3), this._frameCountToTimeCode();
    } else if ("object" == typeof e && e.hours >= 0) this.hours = e.hours, this.minutes = e.minutes, this.seconds = e.seconds, this.frames = e.frames, this._timeCodeToFrameCount();else {
      if (void 0 !== e) throw new Error("Timecode() constructor expects a number, timecode string, or Date()");
      this.frameCount = 0;
    }
    return this._validate(e), this;
  }).prototype._validate = function (e) {
    if (this.dropFrame && 29.97 !== this.frameRate && 59.94 !== this.frameRate) throw new Error("Drop frame is only supported for 29.97 and 59.94 fps");
    if (this.hours > 23 || this.minutes > 59 || this.seconds > 59 || this.frames >= this.frameRate || this.dropFrame && 0 === this.seconds && this.minutes % 10 && this.frames < this.frameRate / 29.97 * 2) throw new Error("Invalid timecode" + JSON.stringify(e));
  }, _o2.prototype._frameCountToTimeCode = function () {
    var e = this.frameCount;

    if (this.dropFrame) {
      var n = 29.97 === this.frameRate ? 2 : 4,
          t = Math.floor(this.frameCount / (17982 * n / 2)),
          r = this.frameCount % (17982 * n / 2);
      r < n && (r += n), e += 9 * n * t + n * Math.floor((r - n) / (1798 * n / 2));
    }

    var o = Math.round(this.frameRate);
    this.frames = e % o, this.seconds = Math.floor(e / o) % 60, this.minutes = Math.floor(e / (60 * o)) % 60, this.hours = Math.floor(e / (3600 * o)) % 24;
  }, _o2.prototype._timeCodeToFrameCount = function () {
    if (this.frameCount = (3600 * this.hours + 60 * this.minutes + this.seconds) * Math.round(this.frameRate) + this.frames, this.dropFrame) {
      var e = 60 * this.hours + this.minutes,
          n = 29.97 === this.frameRate ? 2 : 4;
      this.frameCount -= n * (e - Math.floor(e / 10));
    }
  }, _o2.prototype.toString = function (e) {
    var n = this.frames,
        t = "";

    if ("string" == typeof e) {
      if ("field" !== e) throw new Error("Unsupported string format");
      this.frameRate <= 30 ? t = ".0" : (n = Math.floor(n / 2), t = ".".concat((this.frameCount % 2).toString()));
    }

    return "".concat(this.hours < 10 ? "0" : "", this.hours.toString(), ":", this.minutes < 10 ? "0" : "", this.minutes.toString(), ":", this.seconds < 10 ? "0" : "", this.seconds.toString(), this.dropFrame ? ";" : ":", n < 10 ? "0" : "", n.toString(), t);
  }, _o2.prototype.valueOf = function () {
    return this.frameCount;
  }, _o2.prototype.add = function (e, n, t) {
    if ("number" != typeof e) return e instanceof _o2 || (e = new _o2(e, this.frameRate, this.dropFrame)), this.add(e.frameCount, n, t);
    var r = this.frameCount + Math.round(e) * (n ? -1 : 1);
    if (r < 0 && t > 0 && (r = Math.round(86400 * this.frameRate) + r) / this.frameRate / 3600 > t) throw new Error("Rollover arithmetic exceeds max permitted");
    if (r < 0) throw new Error("Negative timecodes not supported");
    return this.frameCount = r, this.frameCount = this.frameCount % Math.round(86400 * this.frameRate), this._frameCountToTimeCode(), this;
  }, _o2.prototype.subtract = function (e, n) {
    return this.add(e, !0, n);
  }, _o2.prototype.toDate = function () {
    var e = this.frameCount / this.frameRate * 1e3,
        n = new Date();
    n.setHours(0), n.setMinutes(0), n.setSeconds(0), n.setMilliseconds(0);
    var t = new Date(n.valueOf() + e),
        r = 60 * n.getTimezoneOffset() * 1e3,
        o = 60 * t.getTimezoneOffset() * 1e3;
    return new Date(n.valueOf() + e + (o - r));
  }, "string" != typeof n.nodeName ? e.exports = _o2 : r && (r.Timecode = _o2);
}, function (e, n, t) {
  "use strict";

  e.exports.polynomial = t(214), e.exports.linear = t(215), e.exports.linearRegression = t(216), e.exports.step = t(217);
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(20),
      l = t.n(s),
      a = t(50),
      c = t.n(a);

  function u(e) {
    return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function p(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function m(e) {
    return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function C(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function d(e, n) {
    return (d = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function f(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var h = function (e) {
    function n() {
      var e, t;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      for (var r = arguments.length, o = Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      return t = function (e, n) {
        return !n || "object" !== u(n) && "function" != typeof n ? C(e) : n;
      }(this, (e = m(n)).call.apply(e, [this].concat(o))), f(C(t), "shouldComponentUpdate", function (e) {
        return !l()(t.props, e);
      }), f(C(t), "handleOnChange", function (e) {
        t.props.buttonClick(e);
      }), t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && d(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("div", {
          className: c.a.wrapper
        }, o.a.createElement("input", {
          type: "range",
          className: c.a.bar,
          onChange: this.handleOnChange,
          value: this.props.value,
          min: "0",
          max: this.props.max.toString()
        }));
      }
    }]) && p(t.prototype, r), i && p(t, i), n;
    var t, r, i;
  }(o.a.Component);

  h.propTypes = {
    value: A.a.string,
    max: A.a.string,
    buttonClick: A.a.func
  }, h.defaultProps = {
    value: "0",
    max: "0"
  }, n.default = h;
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._3Uxalc08gMtzZB4hnaX85U{margin-bottom:0.5em}._3Uxalc08gMtzZB4hnaX85U>*{display:inline-block}._3Uxalc08gMtzZB4hnaX85U>*:not(:last-child){margin-right:0.5em}.nfFU1U4XOLMdzg9dnbQE6{width:48px;height:48px;padding:0.5em;border:0;color:white;background:#282828;font-size:1em;cursor:pointer;margin-right:0.3rem;margin-top:0.3rem}.nfFU1U4XOLMdzg9dnbQE6:hover{background:#4a4a4a}._14YMQpt-PkIxcQSwXXLlvg{width:70px;border:0;color:white;font-size:1em;cursor:pointer;position:relative;margin-right:0.3rem}._14YMQpt-PkIxcQSwXXLlvg::before{content:'×';position:absolute;bottom:-2px;left:21px}._14YMQpt-PkIxcQSwXXLlvg>select{padding-top:0.5em;padding-bottom:0.5em;height:100%;outline:none;width:auto;width:100%;color:white;background-color:#282828;cursor:pointer}._14YMQpt-PkIxcQSwXXLlvg>select:hover{background-color:#4a4a4a}._2znM3G4aR2HBCH20g6mhGb{display:inline-block;text-align:center;line-height:48px;padding:0 1em;background-color:#282828}._2znM3G4aR2HBCH20g6mhGb .aH0YF-Y9zIHOtgN9PmNDJ{color:#E2A9A2;cursor:pointer;font-family:'Lucida Console', monospace}._2znM3G4aR2HBCH20g6mhGb ._1of7QGIwcp_3wqr89BYIJr{color:#767676;margin:0 1em}._2znM3G4aR2HBCH20g6mhGb ._2N6hqY-gxXwJ-2c8sRoL5i{color:white;font-family:'Lucida Console',  monospace}@media (max-width: 768px){._3Uxalc08gMtzZB4hnaX85U{display:grid;grid-template-rows:10% 3rem 3rem;grid-row-gap:5px;margin:0 0 0.5rem 0}._3Uxalc08gMtzZB4hnaX85U>*:not(:last-child){margin:0}._3Yzz5SC0aWv6XsLwxfjSEh{display:grid;grid-template-columns:repeat(4, 1fr);grid-column-gap:0.2em}.nfFU1U4XOLMdzg9dnbQE6{width:100%;height:48px;margin:0}._14YMQpt-PkIxcQSwXXLlvg{width:100%;grid-column:1 / span 2}._14YMQpt-PkIxcQSwXXLlvg::before{bottom:30%}._2znM3G4aR2HBCH20g6mhGb{background-color:transparent;align-self:start;padding:0}._2znM3G4aR2HBCH20g6mhGb .aH0YF-Y9zIHOtgN9PmNDJ{float:left;font-size:0.7em;line-height:1em}._2znM3G4aR2HBCH20g6mhGb ._1of7QGIwcp_3wqr89BYIJr{display:none}._2znM3G4aR2HBCH20g6mhGb ._2N6hqY-gxXwJ-2c8sRoL5i{color:white;font-size:0.7em;float:right;line-height:1em}._3jaqTgIQjj8Ae1CLtIF2e0{display:none}}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/media-player/src/PlayerControls/index.module.scss", "/Users/okunoe01/workspace/react-transcript-editor/packages/config/style-guide/colours.scss"],
    names: [],
    mappings: "AAEA,yBACE,mBAAoB,CACrB,2BAGC,oBAAqB,CACtB,4CAGC,kBAAmB,CACpB,uBAGC,UAAW,CACX,WAAY,CACZ,aAAc,CACd,QAAS,CACT,WAAY,CACZ,kBCnB0B,CDoB1B,aAAc,CACd,cAAe,CACf,mBAAoB,CACpB,iBAAkB,CAVpB,6BAaI,kBCzBqB,CD0BtB,yBAID,UAAW,CACX,QAAS,CACT,WAAY,CACZ,aAAc,CACd,cAAe,CACf,iBAAkB,CAClB,mBAAoB,CAPtB,iCAUI,WAAY,CACZ,iBAAkB,CAClB,WAAY,CACZ,SAAU,CAbd,gCAiBI,iBAAkB,CAClB,oBAAqB,CACrB,WAAY,CACZ,YAAa,CACb,UAAW,CACX,UAAW,CACX,WAAY,CACZ,wBCtDwB,CDuDxB,cAAe,CAzBnB,sCA4BM,wBCzDmB,CD0DpB,yBAKH,oBAAqB,CACrB,iBAAkB,CAClB,gBAAiB,CACjB,aAAc,CACd,wBCpE0B,CD+D5B,gDAQI,aCjEuB,CDkEvB,cAAe,CACf,uCAAwC,CAV5C,kDAcI,aC1EsB,CD2EtB,YAAa,CAfjB,kDAmBI,WAAY,CACZ,wCAAyC,CAC1C,0BAKD,yBACE,YAAa,CACb,gCAAiC,CACjC,gBAAiB,CACjB,mBAAoB,CACrB,4CAGC,QAAS,CACV,yBAGC,YAAa,CACb,oCAAqC,CACrC,qBAAsB,CACvB,uBAGC,UAAW,CACX,WAAY,CACZ,QAAS,CACV,yBAGC,UAAW,CACX,sBAAuB,CAFzB,iCAKI,UAAW,CACZ,yBAID,4BAA6B,CAC7B,gBAAiB,CACjB,SAAU,CAHZ,gDAMI,UAAW,CACX,eAAgB,CAChB,eAAgB,CARpB,kDAYI,YAAa,CAZjB,kDAgBI,WAAY,CACZ,eAAgB,CAChB,WAAY,CACZ,eAAgB,CACjB,yBAID,YAAa,CACd",
    file: "index.module.scss",
    sourcesContent: ["@import '../../../../config/style-guide/colours.scss';\n\n.playerControls {\n  margin-bottom: 0.5em;\n}\n\n.playerControls > * {\n  display: inline-block;\n}\n\n.playerControls > *:not(:last-child) {\n  margin-right: 0.5em;\n}\n\n.playerButton {\n  width: 48px;\n  height: 48px;\n  padding: 0.5em;\n  border: 0;\n  color: white;\n  background: $color-darkest-grey;\n  font-size: 1em;\n  cursor: pointer;\n  margin-right: 0.3rem;\n  margin-top: 0.3rem;\n\n  &:hover {\n    background: $color-dark-grey;\n  }\n}\n\n.playBackRate {\n  width: 70px;\n  border: 0;\n  color: white;\n  font-size: 1em;\n  cursor: pointer;\n  position: relative;\n  margin-right: 0.3rem;\n\n  &::before {\n    content: '×';\n    position: absolute;\n    bottom: -2px;\n    left: 21px;\n  }\n\n  & > select {\n    padding-top: 0.5em;\n    padding-bottom: 0.5em;\n    height: 100%;\n    outline: none;\n    width: auto;\n    width: 100%;\n    color: white;\n    background-color: $color-darkest-grey;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $color-dark-grey;\n    }\n  }\n}\n\n.timeBox {\n  display: inline-block;\n  text-align: center;\n  line-height: 48px;\n  padding: 0 1em;\n  background-color: $color-darkest-grey;\n\n  .currentTime {\n    color: $color-light-shilo;\n    cursor: pointer;\n    font-family: 'Lucida Console', monospace;\n  }\n\n  .separator {\n    color: $color-light-grey;\n    margin: 0 1em;\n  }\n\n  .duration {\n    color: white;\n    font-family: 'Lucida Console',  monospace;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .playerControls {\n    display: grid;\n    grid-template-rows: 10% 3rem 3rem;\n    grid-row-gap: 5px;\n    margin: 0 0 0.5rem 0;\n  }\n\n  .playerControls > *:not(:last-child) {\n    margin: 0;\n  }\n\n  .btnsGroup {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-column-gap: 0.2em;\n  }\n\n  .playerButton {\n    width: 100%;\n    height: 48px;\n    margin: 0;\n  }\n\n  .playBackRate {\n    width: 100%;\n    grid-column: 1 / span 2;\n\n    &::before {\n      bottom: 30%;\n    }\n  }\n\n  .timeBox {\n    background-color: transparent;\n    align-self: start;\n    padding: 0;\n\n    .currentTime {\n      float: left;\n      font-size: 0.7em;\n      line-height: 1em;\n    }\n\n    .separator {\n      display: none;\n    }\n\n    .duration {\n      color: white;\n      font-size: 0.7em;\n      float: right;\n      line-height: 1em;\n    }\n  }\n\n  .pip {\n    display: none;\n  }\n}\n", "$color-labs-red: #a0372d !default;\n$color-darkest-grey: #282828 !default;\n$color-dark-grey: #4a4a4a !default;\n$color-mid-grey: #696969 !default;\n$color-light-grey: #767676 !default;\n$color-lightest-grey: #f2f2f2 !default;\n$color-subt-green: #69e3c2 !default;\n$color-light-shilo: #E2A9A2 !default;\n"]
  }]), n.locals = {
    playerControls: "_3Uxalc08gMtzZB4hnaX85U",
    playerButton: "nfFU1U4XOLMdzg9dnbQE6",
    playBackRate: "_14YMQpt-PkIxcQSwXXLlvg",
    timeBox: "_2znM3G4aR2HBCH20g6mhGb",
    currentTime: "aH0YF-Y9zIHOtgN9PmNDJ",
    separator: "_1of7QGIwcp_3wqr89BYIJr",
    duration: "_2N6hqY-gxXwJ-2c8sRoL5i",
    btnsGroup: "_3Yzz5SC0aWv6XsLwxfjSEh",
    pip: "_3jaqTgIQjj8Ae1CLtIF2e0"
  };
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(114),
      l = t.n(s);

  function a(e) {
    return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function c(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function u(e) {
    return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function p(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function m(e, n) {
    return (m = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var C = function (e) {
    function n() {
      var e, t, r, o, i;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      for (var A = arguments.length, s = Array(A), l = 0; l < A; l++) {
        s[l] = arguments[l];
      }

      return t = function (e, n) {
        return !n || "object" !== a(n) && "function" != typeof n ? p(e) : n;
      }(this, (e = u(n)).call.apply(e, [this].concat(s))), r = p(t), i = function i() {
        if (null !== t.props.videoRef.current) return t.props.videoRef.current.paused ? t.props.videoRef.current.play() : t.props.videoRef.current.pause();
      }, (o = "handlePlayMedia") in r ? Object.defineProperty(r, o, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[o] = i, t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && m(e, n);
    }(n, e), t = n, (r = [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return e.previewIsDisplayed !== this.props.previewIsDisplayed || e.mediaUrl !== this.props.mediaUrl;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.previewIsDisplayed ? "inline" : "none";
        return o.a.createElement("video", {
          id: "video",
          playsInline: !0,
          src: this.props.mediaUrl,
          onTimeUpdate: this.props.onTimeUpdate,
          "data-testid": "media-player-id",
          onClick: this.handlePlayMedia,
          onLoadedData: this.props.onLoadedDataGetDuration,
          ref: this.props.videoRef,
          className: l.a.videoEl,
          preload: "auto",
          style: {
            display: e
          }
        });
      }
    }]) && c(t.prototype, r), i && c(t, i), n;
    var t, r, i;
  }(o.a.Component);

  C.propTypes = {
    mediaUrl: A.a.string,
    onTimeUpdate: A.a.func,
    onClick: A.a.func,
    videoRef: A.a.object.isRequired,
    onLoadedDataGetDuration: A.a.func,
    previewIsDisplayed: A.a.bool,
    previewViewWidth: A.a.string
  }, n.default = C;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(2),
      l = t(5),
      a = t(6),
      c = t(22),
      u = t.n(c);

  function p(e) {
    return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function m(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function C(e, n) {
    return !n || "object" !== p(n) && "function" != typeof n ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : n;
  }

  function d(e) {
    return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function f(e, n) {
    return (f = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var h = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), C(this, d(n).apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && f(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("span", {
          className: this.props.isEditable ? [u.a.speaker, u.a.speakerEditable].join(" ") : [u.a.speaker, u.a.speakerNotEditable].join(" "),
          title: this.props.name,
          onClick: this.props.isEditable ? this.props.handleOnClickEdit : null
        }, o.a.createElement("span", {
          className: u.a.EditLabel
        }, o.a.createElement(l.a, {
          icon: a.n
        })), this.props.name);
      }
    }]) && m(t.prototype, r), i && m(t, i), n;
    var t, r, i;
  }(r.PureComponent);

  h.propTypes = {
    name: A.a.string,
    handleOnClickEdit: A.a.func
  };
  var x = h,
      g = t(8);

  function I(e) {
    return (I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function b(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function y(e) {
    return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function E(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function v(e, n) {
    return (v = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function w(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var B = function B(e, n, t) {
    var r = Object(s.convertToRaw)(t);
    return r.blocks.forEach(function (t) {
      t.data.speaker === e && (t.data.speaker = n);
    }), Object(s.convertFromRaw)(r);
  },
      _ = function (e) {
    function n(e) {
      var t;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), t = function (e, n) {
        return !n || "object" !== I(n) && "function" != typeof n ? E(e) : n;
      }(this, y(n).call(this, e)), w(E(t), "shouldComponentUpdate", function (e, n) {
        return e.block.getText() !== t.props.block.getText() || e.blockProps.showSpeakers !== t.props.blockProps.showSpeakers || e.blockProps.showTimecodes !== t.props.blockProps.showTimecodes || e.blockProps.timecodeOffset !== t.props.blockProps.timecodeOffset || n.speaker !== t.state.speaker || e.blockProps.isEditable !== t.props.blockProps.isEditable || e.block.getData().get("speaker") !== t.state.speaker && (console.log("shouldComponentUpdate wrapper speaker", e.block.getData().get("speaker"), t.state.speaker), !0);
      }), w(E(t), "componentDidUpdate", function (e, n) {
        if (e.block.getData().get("speaker") !== n.speaker) return console.log("componentDidUpdate wrapper speaker", e.block.getData().get("speaker"), n.speaker), t.setState({
          speaker: e.block.getData().get("speaker")
        }), !0;
      }), w(E(t), "handleOnClickEdit", function () {
        var e = t.state.speaker,
            n = prompt("New Speaker Name?", t.state.speaker);

        if ("" !== n && null !== n) {
          t.setState({
            speaker: n
          });
          var r = confirm("Would you like to replace all occurrences of ".concat(e, " with ").concat(n, "?"));

          if (t.props.blockProps.handleAnalyticsEvents && t.props.blockProps.handleAnalyticsEvents({
            category: "WrapperBlock",
            action: "handleOnClickEdit",
            name: "newSpeakerName",
            value: n
          }), r) {
            var o = t.props.blockProps.editorState.getCurrentContent(),
                i = B(e, n, o);
            t.props.blockProps.setEditorNewContentStateSpeakersUpdate(i);
          } else {
            var A = t.props.block.getKey(),
                l = s.SelectionState.createEmpty(A),
                a = s.EditorState.acceptSelection(t.props.blockProps.editorState, l).getSelection(),
                c = s.Modifier.mergeBlockData(t.props.contentState, a, {
              speaker: n
            });
            t.props.blockProps.setEditorNewContentStateSpeakersUpdate(c);
          }
        }
      }), w(E(t), "handleTimecodeClick", function () {
        t.props.blockProps.onWordClick(t.state.start), t.props.blockProps.handleAnalyticsEvents && t.props.blockProps.handleAnalyticsEvents({
          category: "WrapperBlock",
          action: "handleTimecodeClick",
          name: "onWordClick",
          value: Object(g.secondsToTimecode)(t.state.start)
        });
      }), t.state = {
        speaker: "",
        start: 0,
        timecodeOffset: t.props.blockProps.timecodeOffset
      }, t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && v(e, n);
    }(n, e), t = n, (r = [{
      key: "componentDidMount",
      value: function value() {
        var e = this.props.block,
            n = e.getData().get("speaker"),
            t = e.getData().get("start");
        this.setState({
          speaker: n,
          start: t
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.state.start;
        this.props.blockProps.timecodeOffset && (e += this.props.blockProps.timecodeOffset);
        var n = o.a.createElement(x, {
          name: this.state.speaker,
          handleOnClickEdit: this.handleOnClickEdit,
          isEditable: this.props.blockProps.isEditable
        }),
            t = o.a.createElement("span", {
          className: u.a.time,
          onClick: this.handleTimecodeClick
        }, Object(g.shortTimecode)(e));
        return o.a.createElement("div", {
          className: u.a.WrapperBlock
        }, o.a.createElement("div", {
          className: [u.a.markers, u.a.unselectable].join(" "),
          contentEditable: !1
        }, this.props.blockProps.showSpeakers ? n : "", this.props.blockProps.showTimecodes ? t : ""), o.a.createElement("div", {
          className: u.a.text
        }, o.a.createElement(s.EditorBlock, this.props)));
      }
    }]) && b(t.prototype, r), i && b(t, i), n;
    var t, r, i;
  }(o.a.Component);

  function D(e) {
    return (D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function S(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function M(e) {
    return (M = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function O(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function k(e, n) {
    return (k = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function T(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var P = function (e) {
    function n() {
      var e, t;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      for (var r = arguments.length, o = Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      return t = function (e, n) {
        return !n || "object" !== D(n) && "function" != typeof n ? O(e) : n;
      }(this, (e = M(n)).call.apply(e, [this].concat(o))), T(O(t), "handleWordClick", function (e) {
        t.props.onWordClick(e);
      }), T(O(t), "renderBlockWithTimecodes", function () {
        return {
          component: _,
          editable: !0,
          props: {
            showSpeakers: t.props.showSpeakers,
            showTimecodes: t.props.showTimecodes,
            timecodeOffset: t.props.timecodeOffset,
            editorState: t.props.editorState,
            setEditorNewContentStateSpeakersUpdate: t.props.setEditorNewContentStateSpeakersUpdate,
            onWordClick: t.handleWordClick,
            handleAnalyticsEvents: t.props.handleAnalyticsEvents,
            isEditable: t.props.isEditable
          }
        };
      }), T(O(t), "handleOnChange", function (e) {
        t.props.onChange(e);
      }), t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && k(e, n);
    }(n, e), t = n, (r = [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return e.editorState !== this.props.editorState || e.isEditable !== this.props.isEditable;
      }
    }, {
      key: "render",
      value: function value() {
        return o.a.createElement(s.Editor, {
          editorState: this.props.editorState,
          onChange: this.handleOnChange,
          stripPastedStyles: !0,
          blockRendererFn: this.renderBlockWithTimecodes,
          handleKeyCommand: this.props.handleKeyCommand,
          keyBindingFn: this.props.customKeyBindingFn,
          spellCheck: this.props.spellCheck
        });
      }
    }]) && S(t.prototype, r), i && S(t, i), n;
    var t, r, i;
  }(o.a.Component);

  function K(e) {
    return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Q(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function U(e) {
    return (U = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function R(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function G(e, n) {
    return (G = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function Y(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var F = function (e) {
    function n() {
      var e, t;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      for (var r = arguments.length, o = Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      return t = function (e, n) {
        return !n || "object" !== K(n) && "function" != typeof n ? R(e) : n;
      }(this, (e = U(n)).call.apply(e, [this].concat(o))), Y(R(t), "generateConfidence", function (e) {
        return e.confidence ? .6 < e.confidence ? "high" : "low" : "high";
      }), Y(R(t), "generatePreviousTimes", function (e) {
        for (var n = "", t = 0; t < e.start; t++) {
          n += "".concat(t, " ");
        }

        if (0 < e.start % 1) {
          var r = Math.floor(e.start % 1 * 4) / 4;
          n += " ".concat(Math.floor(e.start) + r);
        }

        return n;
      }), t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && G(e, n);
    }(n, e), t = n, (r = [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return e.decoratedText !== this.props.decoratedText;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.entityKey ? this.props.contentState.getEntity(this.props.entityKey).getData() : {};
        return o.a.createElement("span", {
          "data-start": e.start,
          "data-end": e.end,
          "data-confidence": this.generateConfidence(e),
          "data-prev-times": this.generatePreviousTimes(e),
          "data-entity-key": e.key,
          className: "Word"
        }, this.props.children);
      }
    }]) && Q(t.prototype, r), i && Q(t, i), n;
    var t, r, i;
  }(r.Component);

  F.propTypes = {
    contentState: A.a.object,
    entityKey: A.a.string,
    children: A.a.array
  };
  var N = F,
      j = t(36),
      W = t(49),
      L = t(10),
      z = t(110),
      X = t(111),
      H = t.n(X),
      q = t(76),
      V = t.n(q);

  function J(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var n = 0, t = Array(e.length); n < e.length; n++) {
          t[n] = e[n];
        }

        return t;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function Z(e) {
    if (e) {
      var n = e.toLowerCase().trim().replace(/[^a-z|0-9|.]+/g, "");

      if (!isNaN(n)) {
        var t = n.replace(/\.$/, "");
        if ("" !== t) return Object(z.toWords)(t);
      }

      return n;
    }

    return e;
  }

  var $ = function $(e, n) {
    var t = e.map(function (e) {
      return Z(e.word);
    }),
        r = n.map(function (e) {
      return Z(e);
    }),
        o = [];
    return n.forEach(function () {
      o.push({});
    }), new H.a.SequenceMatcher(null, t, r).getOpcodes().forEach(function (t) {
      var r = t[0],
          i = t[1],
          A = t[2],
          s = t[3];

      if ("equal" === r) {
        var l = e.slice(i, A);
        o.splice.apply(o, [s, l.length].concat(J(l)));
      }

      o.forEach(function (e, t) {
        e.word = n[t];
      });
    }), function (e) {
      var n = function (e) {
        return e.map(function (n, t) {
          var r = n;

          if ("start" in n && 0 !== t) {
            var o = e[t - 1];
            "end" in o && (r = {
              start: o.end,
              end: n.end,
              word: n.word
            });
          }

          if ("end" in n && t !== e.length - 1) {
            var i = e[t + 1];
            "start" in i && (r = {
              end: i.start,
              start: n.start,
              word: n.word
            });
          }

          return r;
        });
      }(e),
          t = J(Array(n.length).keys()),
          r = [],
          o = [],
          i = [],
          A = [];

      n.forEach(function (e, n) {
        "start" in e && (r.push(n), i.push(e.start)), "end" in e && (o.push(n), A.push(e.end));
      });
      var s = V.a.linear(t, r, i),
          l = V.a.linear(t, o, A);
      return function (e) {
        return e.map(function (e, n, t) {
          if (0 != n) {
            var r = t[n - 1];
            return r.end > e.start && (e.start = r.end), e;
          }

          return e;
        });
      }(n.map(function (e, n) {
        return "start" in e || (e.start = s[n]), "end" in e || (e.end = l[n]), e;
      }));
    }(o);
  },
      ee = function ee(e, n) {
    var t = function (e) {
      var n = [];

      for (var t in e.blocks) {
        var r = e.blocks[t].text.match(/\S+/g) || [];
        n = n.concat(r);
      }

      return n;
    }(e),
        r = n.entityMap,
        o = [];

    for (var i in r) {
      o.push({
        start: parseFloat(r[i].data.start),
        end: parseFloat(r[i].data.end),
        word: r[i].data.text
      });
    }

    return function (e, n) {
      var t = [],
          r = 0;

      for (var o in e.blocks) {
        var i = e.blocks[o],
            A = (i.text.match(/\S+/g) || []).length,
            s = n.slice(r, r + A),
            l = i.data.speaker;
        l || (console.log("speaker", l, i), l = "U_UKN");
        var a = {
          text: s.map(function (e) {
            return e.punct;
          }).join(" "),
          type: "paragraph",
          data: {
            speaker: l,
            words: s,
            start: s[0].start
          },
          entityRanges: Object(L.a)(s, "punct")
        };
        t.push(a), r += A;
      }

      return {
        blocks: t,
        entityMap: Object(j.createEntityMap)(t)
      };
    }(e, $(o, t).map(function (e, n) {
      return t = e.start, r = e.end, o = 0, i = e.word, A = n, {
        start: t,
        end: r,
        confidence: o,
        word: i.toLowerCase().replace(/[.?!]/g, ""),
        punct: i,
        index: A
      };
      var t, r, o, i, A;
    }));
  },
      ne = t(112),
      te = t.n(ne);

  function re(e) {
    return (re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function oe(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function ie(e) {
    return (ie = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function Ae(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function se(e, n) {
    return (se = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function le(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var ae,
      ce = function (e) {
    function n(e) {
      var t;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), t = function (e, n) {
        return !n || "object" !== re(n) && "function" != typeof n ? Ae(e) : n;
      }(this, ie(n).call(this, e)), le(Ae(t), "shouldComponentUpdate", function (e, n) {
        return e !== t.props || n !== t.state;
      }), le(Ae(t), "onChange", function (e) {
        t.state.editorState.getCurrentContent() !== e.getCurrentContent() && (t.props.isPauseWhileTypingOn && t.props.isPlaying() && (t.props.playMedia(!1), clearTimeout(t.plauseWhileTypingTimeOut), t.plauseWhileTypingTimeOut = setTimeout(function () {
          this.props.playMedia(!0);
        }.bind(Ae(t)), 3e3)), void 0 !== t.saveTimer && clearTimeout(t.saveTimer), t.saveTimer = setTimeout(function () {
          t.setState(function () {
            return {
              editorState: e
            };
          }, function () {
            var e = t.getEditorContent(t.props.autoSaveContentType, t.props.title);
            t.props.handleAutoSaveChanges(e);
          });
        }, 1e3)), t.props.isEditable && t.setState({
          editorState: e
        });
      }), le(Ae(t), "handleDoubleClick", function (e) {
        for (var n = e.nativeEvent.target; !n.hasAttribute("data-start") && n.parentElement;) {
          n = n.parentElement;
        }

        if (n.hasAttribute("data-start")) {
          var r = parseFloat(n.getAttribute("data-start"));
          t.props.onWordClick(r);
        }
      }), le(Ae(t), "getWordCount", function (e) {
        var n = e.getCurrentContent().getPlainText("").replace(/(?:\r\n|\r|\n)/g, " ").trim().match(/\S+/g);
        return n ? n.length : 0;
      }), le(Ae(t), "setEditorContentState", function (e) {
        var n = Object(s.convertFromRaw)(e),
            r = s.EditorState.createWithContent(n, ue);
        void 0 !== t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TimedTextEditor",
          action: "setEditorContentState",
          name: "getWordCount",
          value: t.getWordCount(r)
        }), t.setState({
          editorState: r
        }, function () {
          t.forceRenderDecorator();
        });
      }), le(Ae(t), "forceRenderDecorator", function () {
        var e = t.state.editorState.getCurrentContent(),
            n = t.state.editorState.getDecorator(),
            r = s.EditorState.createWithContent(e, n),
            o = s.EditorState.push(r, e);
        t.setState({
          editorState: o
        });
      }), le(Ae(t), "setEditorNewContentState", function (e) {
        var n = t.state.editorState.getDecorator(),
            r = s.EditorState.createWithContent(e, n),
            o = s.EditorState.push(r, e);
        t.setState({
          editorState: o
        });
      }), le(Ae(t), "setEditorNewContentStateSpeakersUpdate", function (e) {
        var n = t.state.editorState.getDecorator(),
            r = s.EditorState.createWithContent(e, n),
            o = s.EditorState.push(r, e);
        t.setState(function () {
          return {
            editorState: o
          };
        }, function () {
          var e = t.props.autoSaveContentType,
              n = t.props.title,
              r = Object(W.default)(Object(s.convertToRaw)(o.getCurrentContent()), e, n);
          t.props.handleAutoSaveChanges(r);
        });
      }), le(Ae(t), "customKeyBindingFn", function (e) {
        return 13 === e.keyCode ? (console.log("customKeyBindingFn"), "split-paragraph") : !e.altKey || 32 !== e.keyCode && 32 !== e.keyCode && 75 !== e.keyCode && 76 !== e.keyCode && 74 !== e.keyCode && 187 !== e.keyCode && 189 !== e.keyCode && 82 !== e.keyCode && 84 !== e.keyCode ? Object(s.getDefaultKeyBinding)(e) : (e.preventDefault(), "keyboard-shortcuts");
      }), le(Ae(t), "handleKeyCommand", function (e) {
        return "split-paragraph" === e && t.splitParagraph(), "keyboard-shortcuts" === e ? "handled" : "not-handled";
      }), le(Ae(t), "splitParagraph", function () {
        var e = t.state.editorState.getSelection();

        if (e.isCollapsed()) {
          var n,
              r = t.state.editorState.getCurrentContent(),
              o = s.Modifier.splitBlock(r, e),
              i = s.EditorState.push(t.state.editorState, o, "split-block"),
              A = i.getSelection(),
              l = r.blockMap.get(o.selectionBefore.getStartKey()),
              a = l.getData().get("speaker"),
              c = !1,
              u = l.getEntityAt(e.getStartOffset());

          if (null === u) {
            var p = t.findClosestEntityKeyToSelectionPoint(e, l);
            if (u = p.entityKey, c = p.isEndOfParagraph, null === u) return "not-handled";
          }

          var m = r.getEntity(u).getData();
          n = c ? m.end : m.start;
          var C = s.Modifier.mergeBlockData(i.getCurrentContent(), A, {
            start: n,
            speaker: a
          });
          return t.setEditorNewContentState(C), "handled";
        }

        return "not-handled";
      }), le(Ae(t), "findClosestEntityKeyToSelectionPoint", function (e, n) {
        var t = null,
            r = !1,
            o = e.getStartOffset(),
            i = n.getLength(),
            A = i - o;

        if (0 === A) {
          r = !0;

          for (var s = i; 0 < s; s--) {
            if (null !== (t = n.getEntityAt(s))) return {
              entityKey: t,
              isEndOfParagraph: r
            };
          }
        } else for (var l = e.getStartOffset(), a = 0; a < A; a++) {
          if (l += a, null !== (t = n.getEntityAt(l))) return {
            entityKey: t,
            isEndOfParagraph: r
          };
        }

        return {
          entityKey: t,
          isEndOfParagraph: r
        };
      }), le(Ae(t), "getCurrentWord", function () {
        var e = {
          start: "NA",
          end: "NA"
        };

        if (t.props.transcriptData) {
          var n = t.state.editorState.getCurrentContent(),
              r = Object(s.convertToRaw)(n).entityMap;

          for (var o in r) {
            var i = r[o].data;
            i.start <= t.props.currentTime && i.end >= t.props.currentTime && (e.start = i.start, e.end = i.end);
          }
        }

        "NA" !== e.start && t.props.isScrollIntoViewOn && document.querySelector('span.Word[data-start="'.concat(e.start, '"]')).scrollIntoView({
          block: "nearest",
          inline: "center"
        });
        return e;
      }), le(Ae(t), "onWordClick", function (e) {
        t.props.onWordClick(e);
      }), t.state = {
        editorState: s.EditorState.createEmpty()
      }, t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && se(e, n);
    }(n, e), t = n, (r = [{
      key: "componentDidMount",
      value: function value() {
        this.loadData();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        (e.timecodeOffset !== this.props.timecodeOffset || e.showSpeakers !== this.props.showSpeakers || e.showTimecodes !== this.props.showTimecodes || e.isEditable !== this.props.isEditable) && this.forceRenderDecorator();
      }
    }, {
      key: "updateTimestampsForEditorState",
      value: function value() {
        var e = Object(s.convertToRaw)(this.state.editorState.getCurrentContent()),
            n = ee(e, this.state.originalState),
            t = Object(s.convertFromRaw)(n),
            r = s.EditorState.push(this.state.editorState, t),
            o = Object(s.convertToRaw)(t),
            i = this.state.editorState.getSelection();

        if (i.getHasFocus()) {
          for (var A = {}, l = 0; l < e.blocks.length; l++) {
            A[e.blocks[l].key] = o.blocks[l].key;
          }

          var a = i.merge({
            anchorOffset: i.getAnchorOffset(),
            anchorKey: A[i.getAnchorKey()],
            focusOffset: i.getFocusOffset(),
            focusKey: A[i.getFocusKey()]
          }),
              c = s.EditorState.forceSelection(r, a);
          return this.setState({
            editorState: c
          }), c;
        }

        return this.setState({
          editorState: r
        }), r;
      }
    }, {
      key: "loadData",
      value: function value() {
        if (null !== this.props.transcriptData) {
          var e = Object(j.default)(this.props.transcriptData, this.props.sttJsonType);
          this.setState({
            originalState: Object(s.convertToRaw)(Object(s.convertFromRaw)(e))
          }), this.setEditorContentState(e);
        }
      }
    }, {
      key: "getEditorContent",
      value: function value(e, n) {
        var t = this.updateTimestampsForEditorState();
        return Object(W.default)(Object(s.convertToRaw)(t.getCurrentContent()), e || "draftjs", n);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.getCurrentWord(),
            n = Math.round(4 * this.props.currentTime) / 4,
            t = o.a.createElement("section", {
          className: te.a.editor,
          onDoubleClick: this.handleDoubleClick
        }, o.a.createElement("style", {
          scoped: !0
        }, 'span.Word[data-start="'.concat(e.start, '"] { background-color: ').concat("#69e3c2", "; text-shadow: 0 0 0.01px black }"), 'span.Word[data-start="'.concat(e.start, '"]+span { background-color: ').concat("#69e3c2", " }"), 'span.Word[data-prev-times~="'.concat(Math.floor(n), '"] { color: ').concat("#767676", " }"), 'span.Word[data-prev-times~="'.concat(n, '"] { color: ').concat("#767676", " }"), 'span.Word[data-confidence="low"] { border-bottom: '.concat("1px dotted blue", " }")), o.a.createElement(P, {
          editorState: this.state.editorState,
          onChange: this.onChange,
          stripPastedStyles: !0,
          handleKeyCommand: this.handleKeyCommand,
          customKeyBindingFn: this.customKeyBindingFn,
          spellCheck: this.props.spellCheck,
          showSpeakers: this.props.showSpeakers,
          showTimecodes: this.props.showTimecodes,
          timecodeOffset: this.props.timecodeOffset,
          setEditorNewContentStateSpeakersUpdate: this.setEditorNewContentStateSpeakersUpdate,
          onWordClick: this.onWordClick,
          handleAnalyticsEvents: this.props.handleAnalyticsEvents,
          isEditable: this.props.isEditable
        }));
        return o.a.createElement("section", null, null === this.props.transcriptData ? null : t);
      }
    }]) && oe(t.prototype, r), i && oe(t, i), n;
    var t, r, i;
  }(o.a.Component),
      ue = new s.CompositeDecorator([{
    strategy: (ae = "MUTABLE", function (e, n, t) {
      e.findEntityRanges(function (e) {
        var n = e.getEntity();
        return null !== n && t.getEntity(n).getMutability() === ae;
      }, n);
    }),
    component: N
  }]);

  ce.propTypes = {
    transcriptData: A.a.object,
    mediaUrl: A.a.string,
    isEditable: A.a.bool,
    spellCheck: A.a.bool,
    onWordClick: A.a.func,
    sttJsonType: A.a.string,
    isPlaying: A.a.func,
    playMedia: A.a.func,
    currentTime: A.a.number,
    isScrollIntoViewOn: A.a.bool,
    isPauseWhileTypingOn: A.a.bool,
    timecodeOffset: A.a.number,
    handleAnalyticsEvents: A.a.func,
    showSpeakers: A.a.bool,
    showTimecodes: A.a.bool,
    fileName: A.a.string
  };
  n.default = ce;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(113),
      l = t(59),
      a = t(77);

  var c = function c(e) {
    return {
      "alt+k": {
        priority: 1,
        handler: function handler() {
          e.togglePlayMedia(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+k",
            name: "togglePlayMedia",
            value: "na"
          });
        },
        displayKeyCombination: "alt + k",
        label: "Play Media"
      },
      "alt+l": {
        priority: 1,
        handler: function handler() {
          e.skipForward(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+l",
            name: "skipForward",
            value: "na"
          });
        },
        displayKeyCombination: "alt + l",
        label: "Fast Forward"
      },
      "alt+j": {
        priority: 1,
        handler: function handler() {
          e.skipBackward(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+j",
            name: "skipBackward",
            value: "na"
          });
        },
        displayKeyCombination: "alt + j",
        label: "Rewind"
      },
      "alt+-": {
        priority: 1,
        handler: function handler() {
          e.decreasePlaybackRate(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+-",
            name: "decreasePlaybackRate",
            value: "na"
          });
        },
        displayKeyCombination: "alt + -",
        label: "Decrease Playback Speed"
      },
      "alt+=": {
        priority: 1,
        handler: function handler() {
          e.increasePlaybackRate(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+plus",
            name: "increasePlaybackRate",
            value: "na"
          });
        },
        displayKeyCombination: "alt + +",
        label: "Increase Playback Speed"
      },
      "alt+r": {
        priority: 1,
        handler: function handler() {
          e.rollBack(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+r",
            name: "rollBack",
            value: "na"
          });
        },
        displayKeyCombination: "alt + r",
        label: "Roll Back"
      },
      "alt+t": {
        priority: 1,
        handler: function handler() {
          e.promptSetCurrentTime(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+t",
            name: "promptSetCurrentTime",
            value: "na"
          });
        },
        displayKeyCombination: "alt + t",
        label: "set current time"
      }
    };
  },
      u = t(43),
      p = t.n(u),
      m = t(8),
      C = [{
    value: .2,
    label: "0.2"
  }, {
    value: .25,
    label: "0.25"
  }, {
    value: .5,
    label: "0.5"
  }, {
    value: .75,
    label: "0.75"
  }, {
    value: 1,
    label: "1"
  }, {
    value: 1.25,
    label: "1.25"
  }, {
    value: 1.5,
    label: "1.5"
  }, {
    value: 1.75,
    label: "1.75"
  }, {
    value: 2,
    label: "2"
  }, {
    value: 2.5,
    label: "2.5"
  }, {
    value: 3,
    label: "3"
  }, {
    value: 3.5,
    label: "3.5"
  }];

  function d(e) {
    return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function f(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var n = 0, t = Array(e.length); n < e.length; n++) {
          t[n] = e[n];
        }

        return t;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function h(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function x(e) {
    return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function g(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function I(e, n) {
    return (I = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function b(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var y = function (e) {
    function n(e) {
      var t;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), t = function (e, n) {
        return !n || "object" !== d(n) && "function" != typeof n ? g(e) : n;
      }(this, x(n).call(this, e)), b(g(t), "hot_keys", c(g(t))), b(g(t), "setCurrentTime", function (e) {
        if ("" !== e && null !== e) {
          var n = Object(m.timecodeToSeconds)(e),
              r = t.props.videoRef.current;
          4 === r.readyState && (r.currentTime = n, t.playMedia());
        }
      }), b(g(t), "promptSetCurrentTime", function () {
        var e = prompt("Jump to time - hh:mm:ss:ff hh:mm:ss mm:ss m:ss m.ss seconds");
        t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "promptSetCurrentTime",
          name: "userTimecodeValue",
          value: e
        }), null !== e && (e.includes(":") && (e = Object(m.timecodeToSeconds)(e)), 0 !== t.state.timecodeOffset && (e -= t.state.timecodeOffset), t.setCurrentTime(e));
      }), b(g(t), "setTimeCodeOffset", function (e) {
        if (t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "setTimeCodeOffset",
          name: "timecodeOffsetValue",
          value: e
        }), "" !== e && null !== e) {
          var n = e;
          e.includes(":") && (n = Object(m.timecodeToSeconds)(e), t.setState({
            timecodeOffset: n
          }));
        }
      }), b(g(t), "rollBack", function () {
        t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "rollBack",
          name: "rollBackValue",
          value: t.state.rollBackValueInSeconds
        });
        var e = t.props.videoRef.current.currentTime - t.state.rollBackValueInSeconds;
        t.setCurrentTime(e);
      }), b(g(t), "handlePlayBackRateChange", function (e) {
        t.setPlayBackRate(parseFloat(e.target.value));
      }), b(g(t), "setPlayBackRate", function (e) {
        .2 <= e && 3.5 >= e && t.setState({
          playbackRate: e
        }, function () {
          t.props.videoRef.current.playbackRate = e, t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
            category: "MediaPlayer",
            action: "setPlayBackRate",
            name: "playbackRateNewValue",
            value: e
          });
        });
      }), b(g(t), "decreasePlaybackRate", function () {
        var e = f(C).reverse().find(function (e) {
          return e.value < t.state.playbackRate;
        }),
            n = e ? e.value : .2;
        t.setPlayBackRate(n);
      }), b(g(t), "increasePlaybackRate", function () {
        var e = f(C).find(function (e) {
          return e.value > t.state.playbackRate;
        }),
            n = e ? e.value : 3.5;
        t.setPlayBackRate(n);
      }), b(g(t), "handleChangeReplayRollbackValue", function (e) {
        t.setState({
          rollBackValueInSeconds: e.target.value
        });
      }), b(g(t), "handleMuteVolume", function () {
        0 < t.props.videoRef.current.volume ? (t.props.videoRef.current.volume = 0, t.setState({
          isMute: !0
        })) : (t.props.videoRef.current.volume = 1, t.setState({
          isMute: !1
        }));
      }), b(g(t), "isPlaying", function () {
        return !t.props.videoRef.current.paused;
      }), b(g(t), "pauseMedia", function () {
        t.setState({
          isPlaying: !1
        }, function () {
          return t.props.videoRef.current.pause();
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "pauseMedia",
          name: "pauseMedia",
          value: Object(m.secondsToTimecode)(t.props.videoRef.current.currentTime)
        });
      }), b(g(t), "playMedia", function () {
        t.setState({
          isPlaying: !0
        }, function () {
          return t.props.videoRef.current.play();
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "playMedia",
          name: "playMedia",
          value: Object(m.secondsToTimecode)(t.props.videoRef.current.currentTime)
        });
      }), b(g(t), "togglePlayMedia", function () {
        t.state.isPlaying ? t.pauseMedia() : t.playMedia();
      }), b(g(t), "skipForward", function () {
        var e = +(t.props.videoRef.current.currentTime + 10).toFixed(1);
        t.setCurrentTime(e);
      }), b(g(t), "skipBackward", function () {
        var e = +(t.props.videoRef.current.currentTime - 10).toFixed(1);
        t.setCurrentTime(e);
      }), b(g(t), "handleProgressBarClick", function (e) {
        var n = e.target.value;
        t.setCurrentTime(n), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "handleProgressBarClick",
          name: "roundNewCurrentTime",
          value: n
        });
      }), b(g(t), "getMediaCurrentTime", function () {
        return Object(m.secondsToTimecode)(t.props.videoRef.current.currentTime + t.state.timecodeOffset);
      }), b(g(t), "handlePictureInPicture", function () {
        void 0 === document.pictureInPictureElement ? (alert("Picture in Picture not supported in this browser, try chrome."), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "handlePictureInPicture",
          name: "picture-in-picture-not-supported"
        })) : document.pictureInPictureElement ? (t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "handlePictureInPicture",
          name: "turning-picture-in-picture-off"
        }), document.exitPictureInPicture().catch(function (e) {
          console.error("Video failed to leave Picture-in-Picture mode", e), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
            category: "MediaPlayer",
            action: "handlePictureInPicture",
            name: "turning-picture-in-picture-off-error"
          });
        })) : (t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "MediaPlayer",
          action: "handlePictureInPicture",
          name: "turning-picture-in-picture-on"
        }), t.props.videoRef.current.requestPictureInPicture().catch(function (e) {
          console.error("Video failed to enter Picture-in-Picture mode", e), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
            category: "MediaPlayer",
            action: "handlePictureInPicture",
            name: "turning-picture-in-picture-on-error"
          });
        }));
      }), b(g(t), "getProgressBarMax", function () {
        return parseInt(t.props.videoRef.current.duration).toString();
      }), b(g(t), "getProgressBarValue", function () {
        return parseInt(t.props.videoRef.current.currentTime).toString();
      }), t.state = {
        playbackRate: 1,
        rollBackValueInSeconds: t.props.rollBackValueInSeconds,
        timecodeOffset: t.props.timecodeOffset,
        hotKeys: c(g(t)),
        isPlaying: !1,
        playbackRateOptions: C,
        previewIsDisplayed: !0,
        isMute: !1
      }, t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && I(e, n);
    }(n, e), t = n, i = [{
      key: "getDerivedStateFromProps",
      value: function value(e) {
        if (null !== e.timecodeOffset) {
          var n = e.timecodeOffset;
          return "string" == typeof n && n.includes(":") && !n.includes("NaN") && (n = Object(m.timecodeToSeconds)(e.timecodeOffset)), {
            timecodeOffset: n,
            rollBackValueInSeconds: e.rollBackValueInSeconds
          };
        }

        return null;
      }
    }], (r = [{
      key: "componentDidMount",
      value: function value() {
        this.props.hookSeek(this.setCurrentTime), this.props.hookPlayMedia(this.togglePlayMedia), this.props.hookIsPlaying(this.isPlaying);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e, n) {
        return e.rollBackValueInSeconds !== this.state.rollBackValueInSeconds || e.timecodeOffset !== this.state.timecodeOffset || e.currentTime !== this.props.currentTime || n.playbackRate !== this.state.playbackRate || e.mediaDuration !== this.props.mediaDuration || n.isMute !== this.state.isMute;
      }
    }, {
      key: "render",
      value: function value() {
        var e = o.a.createElement(a.default, {
          max: this.getProgressBarMax(),
          value: this.getProgressBarValue(),
          buttonClick: this.handleProgressBarClick
        }),
            n = o.a.createElement("div", {
          className: p.a.controlsSection
        }, this.props.title ? o.a.createElement("h2", {
          className: p.a.title,
          title: this.props.title
        }, this.props.title) : null, o.a.createElement(l.default, {
          playMedia: this.togglePlayMedia.bind(this),
          isPlaying: this.state.isPlaying,
          isMute: this.state.isMute,
          playbackRate: this.state.playbackRate,
          skipBackward: this.skipBackward.bind(this),
          skipForward: this.skipForward.bind(this),
          rollback: this.rollBack,
          currentTime: this.getMediaCurrentTime(),
          duration: this.props.mediaDuration,
          onSetCurrentTime: "",
          onSetTimecodeOffset: "",
          promptSetCurrentTime: this.promptSetCurrentTime.bind(this),
          setTimeCodeOffset: this.setTimeCodeOffset.bind(this),
          timecodeOffset: Object(m.secondsToTimecode)(this.state.timecodeOffset),
          handleMuteVolume: this.handleMuteVolume.bind(this),
          setPlayBackRate: this.handlePlayBackRateChange.bind(this),
          playbackRateOptions: this.state.playbackRateOptions,
          pictureInPicture: this.handlePictureInPicture
        }), this.props.mediaUrl ? e : null);
        return o.a.createElement("section", {
          className: p.a.topSection
        }, o.a.createElement("div", {
          className: p.a.playerSection
        }, this.props.mediaUrl ? n : null));
      }
    }]) && h(t.prototype, r), i && h(t, i), n;
    var t, r, i;
  }(o.a.Component);

  y.propTypes = {
    videoRef: A.a.object.isRequired,
    title: A.a.string,
    hookSeek: A.a.func,
    hookPlayMedia: A.a.func,
    hookIsPlaying: A.a.func,
    mediaUrl: A.a.string,
    hookOnTimeUpdate: A.a.func,
    rollBackValueInSeconds: A.a.number,
    timecodeOffset: A.a.number,
    handleAnalyticsEvents: A.a.func,
    mediaDuration: A.a.string
  };
  n.default = Object(s.hotkeys)(y);
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(5),
      l = t(6),
      a = t(55),
      c = t.n(a);

  function u(e) {
    return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function p(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function m(e, n) {
    return !n || "object" !== u(n) && "function" != typeof n ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : n;
  }

  function C(e) {
    return (C = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function d(e, n) {
    return (d = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var f = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), m(this, C(n).apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && d(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("div", {
          className: c.a.switchContainer
        }, o.a.createElement("label", {
          className: c.a.switch
        }, o.a.createElement("input", {
          type: "checkbox",
          defaultChecked: this.props.defaultValue,
          onChange: this.props.handleToggle
        }), o.a.createElement("span", {
          className: c.a.slider
        })));
      }
    }]) && p(t.prototype, r), i && p(t, i), n;
    var t, r, i;
  }(o.a.Component);

  f.propTypes = {
    handleToggle: A.a.func,
    label: A.a.string,
    defaultValue: A.a.bool
  };
  var h = f,
      x = t(44),
      g = t.n(x),
      I = t(8);

  function b(e) {
    return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function y(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function E(e) {
    return (E = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function v(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function w(e, n) {
    return (w = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function B(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var _ = function (e) {
    function n(e) {
      var t;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), t = function (e, n) {
        return !n || "object" !== b(n) && "function" != typeof n ? v(e) : n;
      }(this, E(n).call(this, e)), B(v(t), "handleChange", function (e) {
        t.setState({
          timecodeOffset: e.target.value
        });
      }), B(v(t), "resetTimecodeOffset", function () {
        void 0 !== t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TimecodeOffset",
          action: "resetTimecodeOffset",
          name: "resetTimecodeOffset",
          value: 0
        }), t.setState({
          timecodeOffset: Object(I.secondsToTimecode)(0)
        }, function () {
          t.props.handleSetTimecodeOffset(0);
        });
      }), B(v(t), "setTimecodeOffset", function () {
        void 0 !== t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TimecodeOffset",
          action: "setTimecodeOffset",
          name: "setTimecodeOffset",
          value: t.state.timecodeOffset
        });
        var e = t.state.timecodeOffset;
        "string" == typeof e && e.includes(":") && !e.includes("NaN") && (e = Object(I.timecodeToSeconds)(e)), t.props.handleSetTimecodeOffset(e);
      }), t.state = {
        timecodeOffset: Object(I.secondsToTimecode)(t.props.timecodeOffset)
      }, t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && w(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("div", {
          className: g.a.offsetContainer
        }, o.a.createElement("input", {
          className: g.a.inputBox,
          type: "text",
          value: this.state.timecodeOffset,
          onChange: this.handleChange,
          name: "lname"
        }), o.a.createElement("span", {
          className: g.a.button,
          onClick: this.resetTimecodeOffset
        }, o.a.createElement("u", null, "Reset")), o.a.createElement("span", null, " | "), o.a.createElement("span", {
          className: g.a.button,
          onClick: this.setTimecodeOffset
        }, o.a.createElement("u", null, "Save")));
      }
    }]) && y(t.prototype, r), i && y(t, i), n;
    var t, r, i;
  }(o.a.Component);

  _.propTypes = {
    handleSetTimecodeOffset: A.a.func,
    onChange: A.a.func,
    timecodeOffset: A.a.number,
    handleAnalyticsEvents: A.a.func
  };
  var D = _,
      S = t(11),
      M = t.n(S);

  function O(e) {
    return (O = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function k(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function T(e, n) {
    return !n || "object" !== O(n) && "function" != typeof n ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : n;
  }

  function P(e) {
    return (P = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function K(e, n) {
    return (K = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var Q = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), T(this, P(n).apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && K(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("div", {
          className: M.a.settings
        }, o.a.createElement("h2", {
          className: M.a.header
        }, "Settings Panel"), o.a.createElement("div", {
          className: M.a.closeButton,
          onClick: this.props.handleSettingsToggle
        }, o.a.createElement(s.a, {
          icon: l.q
        })), o.a.createElement("div", {
          className: M.a.controlsContainer
        }, o.a.createElement("section", {
          className: M.a.settingElement
        }, o.a.createElement("div", {
          className: M.a.label
        }, "Pause While Typing"), o.a.createElement(h, {
          defaultValue: this.props.defaultValuePauseWhileTyping,
          label: "Pause while typing",
          handleToggle: this.props.handlePauseWhileTyping
        })), o.a.createElement("section", {
          className: M.a.settingElement
        }, o.a.createElement("div", {
          className: M.a.label
        }, "Scroll Sync"), o.a.createElement(h, {
          defaultValue: this.props.defaultValueScrollSync,
          label: "ScrollSync",
          handleToggle: this.props.handleIsScrollIntoViewChange
        })), o.a.createElement("section", {
          className: M.a.settingElement
        }, o.a.createElement("div", {
          className: M.a.label
        }, "Rollback Interval (sec)"), o.a.createElement("input", {
          className: M.a.rollbackValue,
          type: "number",
          step: "1",
          max: "60",
          min: "1",
          value: this.props.defaultRollBackValueInSeconds,
          onChange: this.props.handleRollBackValueInSeconds,
          name: "lname"
        })), o.a.createElement("section", {
          className: M.a.settingElement
        }, o.a.createElement("div", {
          className: M.a.label
        }, "Show Timecodes"), o.a.createElement(h, {
          defaultValue: this.props.showTimecodes,
          label: "Hide Timecodes",
          handleToggle: this.props.handleShowTimecodes
        })), o.a.createElement("section", {
          className: M.a.settingElement
        }, o.a.createElement("div", {
          className: M.a.label
        }, "Show Speaker Labels"), o.a.createElement(h, {
          defaultValue: this.props.showSpeakers,
          label: "Hide Speaker Labels",
          handleToggle: this.props.handleShowSpeakers
        })), o.a.createElement("section", {
          className: M.a.settingElement
        }, o.a.createElement("div", {
          className: M.a.label
        }, "Display Preview"), o.a.createElement(h, {
          defaultValue: this.props.previewIsDisplayed,
          label: "Display Preview",
          handleToggle: this.props.handlePreviewIsDisplayed
        })), o.a.createElement("section", {
          className: M.a.settingElement
        }, o.a.createElement("div", {
          className: M.a.timecodeLabel
        }, "Timecode Offset ℹ"), o.a.createElement(D, {
          timecodeOffset: this.props.timecodeOffset,
          handleSetTimecodeOffset: this.props.handleSetTimecodeOffset,
          handleAnalyticsEvents: this.props.handleAnalyticsEvents
        }))));
      }
    }]) && k(t.prototype, r), i && k(t, i), n;
    var t, r, i;
  }(o.a.Component);

  Q.propTypes = {
    showTimecodes: A.a.bool,
    showSpeakers: A.a.bool,
    timecodeOffset: A.a.number,
    handleShowTimecodes: A.a.func,
    handleShowSpeakers: A.a.func,
    handleSetTimecodeOffset: A.a.func,
    handleSettingsToggle: A.a.func,
    handlePauseWhileTyping: A.a.func,
    handleIsScrollIntoViewChange: A.a.func,
    handleRollBackValueInSeconds: A.a.func,
    defaultValueScrollSync: A.a.bool,
    defaultValuePauseWhileTyping: A.a.bool,
    defaultRollBackValueInSeconds: A.a.number,
    previewIsDisplayed: A.a.bool,
    handlePreviewIsDisplayed: A.a.func,
    handleChangePreviewViewWidth: A.a.func,
    handleAnalyticsEvents: A.a.func
  };
  n.default = Q;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(6),
      l = t(5);

  var a = function a(e) {
    return {
      "alt+k": {
        priority: 1,
        handler: function handler() {
          e.togglePlayMedia(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+k",
            name: "togglePlayMedia",
            value: "na"
          });
        },
        displayKeyCombination: "alt + k",
        label: "Play Media"
      },
      "alt+l": {
        priority: 1,
        handler: function handler() {
          e.skipForward(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+l",
            name: "skipForward",
            value: "na"
          });
        },
        displayKeyCombination: "alt + l",
        label: "Fast Forward"
      },
      "alt+j": {
        priority: 1,
        handler: function handler() {
          e.skipBackward(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+j",
            name: "skipBackward",
            value: "na"
          });
        },
        displayKeyCombination: "alt + j",
        label: "Rewind"
      },
      "alt+-": {
        priority: 1,
        handler: function handler() {
          e.decreasePlaybackRate(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+-",
            name: "decreasePlaybackRate",
            value: "na"
          });
        },
        displayKeyCombination: "alt + -",
        label: "Decrease Playback Speed"
      },
      "alt+=": {
        priority: 1,
        handler: function handler() {
          e.increasePlaybackRate(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+plus",
            name: "increasePlaybackRate",
            value: "na"
          });
        },
        displayKeyCombination: "alt + +",
        label: "Increase Playback Speed"
      },
      "alt+r": {
        priority: 1,
        handler: function handler() {
          e.rollBack(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+r",
            name: "rollBack",
            value: "na"
          });
        },
        displayKeyCombination: "alt + r",
        label: "Roll Back"
      },
      "alt+t": {
        priority: 1,
        handler: function handler() {
          e.promptSetCurrentTime(), e.props.handleAnalyticsEvents({
            category: "defaultHotKeys",
            action: "alt+t",
            name: "promptSetCurrentTime",
            value: "na"
          });
        },
        displayKeyCombination: "alt + t",
        label: "set current time"
      }
    };
  },
      c = t(28),
      u = t.n(c);

  function p(e) {
    return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function m(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function C(e, n) {
    return !n || "object" !== p(n) && "function" != typeof n ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : n;
  }

  function d(e) {
    return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function f(e, n) {
    return (f = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  t.d(n, "getHotKeys", function () {
    return h;
  });

  var h = a,
      x = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), C(this, d(n).apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && f(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        var e = a(this),
            n = Object.keys(e).map(function (n) {
          var t = e[n];
          return o.a.createElement("li", {
            key: n,
            className: u.a.listItem
          }, o.a.createElement("div", {
            className: u.a.shortcut
          }, t.displayKeyCombination), o.a.createElement("div", {
            className: u.a.shortcutLabel
          }, t.label));
        });
        return o.a.createElement("div", {
          className: u.a.shortcuts
        }, o.a.createElement("h2", {
          className: u.a.header
        }, "Shortcuts"), o.a.createElement("div", {
          className: u.a.closeButton,
          onClick: this.props.handleShortcutsToggle
        }, o.a.createElement(l.a, {
          icon: s.q
        })), o.a.createElement("ul", {
          className: u.a.list
        }, n));
      }
    }]) && m(t.prototype, r), i && m(t, i), n;
    var t, r, i;
  }(o.a.Component);

  x.propTypes = {
    handleShortcutsToggle: A.a.func
  };
  n.default = x;
}, function (e, n, t) {
  "use strict";

  var r = t(21),
      o = t(3),
      i = t(25),
      A = o.OrderedMap;

  e.exports = function (e) {
    return e.first() instanceof r ? function (e) {
      var n = {},
          t = void 0;
      return A(e.withMutations(function (e) {
        e.forEach(function (r, o) {
          var A = r.getKey(),
              s = r.getNextSiblingKey(),
              l = r.getPrevSiblingKey(),
              a = r.getChildKeys(),
              c = r.getParentKey(),
              u = i();
          (n[A] = u, s) && (e.get(s) ? e.setIn([s, "prevSibling"], u) : e.setIn([A, "nextSibling"], null));
          l && (e.get(l) ? e.setIn([l, "nextSibling"], u) : e.setIn([A, "prevSibling"], null));

          if (c && e.get(c)) {
            var p = e.get(c).getChildKeys();
            e.setIn([c, "children"], p.set(p.indexOf(r.getKey()), u));
          } else e.setIn([A, "parent"], null), t && (e.setIn([t.getKey(), "nextSibling"], u), e.setIn([A, "prevSibling"], n[t.getKey()])), t = e.get(A);

          a.forEach(function (n) {
            e.get(n) ? e.setIn([n, "parent"], u) : e.setIn([A, "children"], r.getChildKeys().filter(function (e) {
              return e !== n;
            }));
          });
        });
      }).toArray().map(function (e) {
        return [n[e.getKey()], e.set("key", n[e.getKey()])];
      }));
    }(e) : function (e) {
      return A(e.toArray().map(function (e) {
        var n = i();
        return [n, e.set("key", n)];
      }));
    }(e);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(19),
      o = t(38),
      i = t(4);

  function A(e, n, t) {
    var A = n.getCharacterList(),
        s = t > 0 ? A.get(t - 1) : void 0,
        l = t < A.count() ? A.get(t) : void 0,
        a = s ? s.getEntity() : void 0,
        c = l ? l.getEntity() : void 0;

    if (c && c === a && "MUTABLE" !== e.__get(c).getMutability()) {
      for (var u, p = function (e, n, t) {
        var r;
        return o(e, function (e, n) {
          return e.getEntity() === n.getEntity();
        }, function (e) {
          return e.getEntity() === n;
        }, function (e, n) {
          e <= t && n >= t && (r = {
            start: e,
            end: n
          });
        }), "object" != typeof r && i(!1), r;
      }(A, c, t), m = p.start, C = p.end; m < C;) {
        u = A.get(m), A = A.set(m, r.applyEntity(u, null)), m++;
      }

      return n.set("characterList", A);
    }

    return n;
  }

  e.exports = function (e, n) {
    var t = e.getBlockMap(),
        r = e.getEntityMap(),
        o = {},
        i = n.getStartKey(),
        s = n.getStartOffset(),
        l = t.get(i),
        a = A(r, l, s);
    a !== l && (o[i] = a);
    var c = n.getEndKey(),
        u = n.getEndOffset(),
        p = t.get(c);
    i === c && (p = a);
    var m = A(r, p, u);
    return m !== p && (o[c] = m), Object.keys(o).length ? e.merge({
      blockMap: t.merge(o),
      selectionAfter: n
    }) : e.set("selectionAfter", n);
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e, n, t) {
    if (t === e.count()) n.forEach(function (n) {
      e = e.push(n);
    });else if (0 === t) n.reverse().forEach(function (n) {
      e = e.unshift(n);
    });else {
      var r = e.slice(0, t),
          o = e.slice(t);
      e = r.concat(n, o).toList();
    }
    return e;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(21);

  e.exports = function (e, n) {
    if (!(e instanceof r)) return null;
    var t = e.getNextSiblingKey();
    if (t) return t;
    var o = e.getParentKey();
    if (!o) return null;

    for (var i = n.get(o); i && !i.getNextSiblingKey();) {
      var A = i.getParentKey();
      i = A ? n.get(A) : null;
    }

    return i ? i.getNextSiblingKey() : null;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(3),
      o = t(60),
      i = t(38),
      A = r.List,
      s = r.Repeat,
      l = r.Record,
      a = o.thatReturnsTrue,
      c = l({
    start: null,
    end: null
  }),
      u = l({
    start: null,
    end: null,
    decoratorKey: null,
    leaves: null
  }),
      p = {
    generate: function generate(e, n, t) {
      var r = n.getLength();
      if (!r) return A.of(new u({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: A.of(new c({
          start: 0,
          end: 0
        }))
      }));
      var o = [],
          l = t ? t.getDecorations(n, e) : A(s(null, r)),
          p = n.getCharacterList();
      return i(l, C, a, function (e, n) {
        o.push(new u({
          start: e,
          end: n,
          decoratorKey: l.get(e),
          leaves: m(p.slice(e, n).toList(), e)
        }));
      }), A(o);
    },
    getFingerprint: function getFingerprint(e) {
      return e.map(function (e) {
        var n = e.get("decoratorKey");
        return (null !== n ? n + "." + (e.get("end") - e.get("start")) : "") + "." + e.get("leaves").size;
      }).join("-");
    }
  };

  function m(e, n) {
    var t = [],
        r = e.map(function (e) {
      return e.getStyle();
    }).toList();
    return i(r, C, a, function (e, r) {
      t.push(new c({
        start: e + n,
        end: r + n
      }));
    }), A(t);
  }

  function C(e, n) {
    return e === n;
  }

  e.exports = p;
}, function (e, n, t) {
  "use strict";

  var r = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.getType = function () {
      return this.get("type");
    }, n.prototype.getMutability = function () {
      return this.get("mutability");
    }, n.prototype.getData = function () {
      return this.get("data");
    }, n;
  }((0, t(3).Record)({
    type: "TOKEN",
    mutability: "IMMUTABLE",
    data: Object
  }));

  e.exports = r;
}, function (e, n, t) {
  "use strict";

  var r = t(63),
      o = t(4),
      i = "֐־׀׃׆׈-׏א-ת׫-ׯװ-ײ׳-״׵-׿߀-߉ߊ-ߪߴ-ߵߺ߻-߿ࠀ-ࠕࠚࠤࠨ࠮-࠯࠰-࠾࠿ࡀ-ࡘ࡜-࡝࡞࡟-࢟‏יִײַ-ﬨשׁ-זּ﬷טּ-לּ﬽מּ﬿נּ-סּ﭂ףּ-פּ﭅צּ-ﭏ",
      A = "؈؋؍؛؜؝؞-؟ؠ-ؿـف-ي٭ٮ-ٯٱ-ۓ۔ەۥ-ۦۮ-ۯۺ-ۼ۽-۾ۿ܀-܍܎܏ܐܒ-ܯ݋-݌ݍ-ޥޱ޲-޿ࢠ-ࢲࢳ-ࣣﭐ-ﮱ﮲-﯁﯂-﯒ﯓ-ﴽ﵀-﵏ﵐ-ﶏ﶐-﶑ﶒ-ﷇ﷈-﷏ﷰ-ﷻ﷼﷾-﷿ﹰ-ﹴ﹵ﹶ-ﻼ﻽-﻾",
      s = new RegExp("[" + "A-Za-zªµºÀ-ÖØ-öø-ƺƻƼ-ƿǀ-ǃǄ-ʓʔʕ-ʯʰ-ʸʻ-ˁː-ˑˠ-ˤˮͰ-ͳͶ-ͷͺͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁ҂Ҋ-ԯԱ-Ֆՙ՚-՟ա-և։ःऄ-हऻऽा-ीॉ-ौॎ-ॏॐक़-ॡ।-॥०-९॰ॱॲ-ঀং-ঃঅ-ঌএ-ঐও-নপ-রলশ-হঽা-ীে-ৈো-ৌৎৗড়-ঢ়য়-ৡ০-৯ৰ-ৱ৴-৹৺ਃਅ-ਊਏ-ਐਓ-ਨਪ-ਰਲ-ਲ਼ਵ-ਸ਼ਸ-ਹਾ-ੀਖ਼-ੜਫ਼੦-੯ੲ-ੴઃઅ-ઍએ-ઑઓ-નપ-રલ-ળવ-હઽા-ીૉો-ૌૐૠ-ૡ૦-૯૰ଂ-ଃଅ-ଌଏ-ଐଓ-ନପ-ରଲ-ଳଵ-ହଽାୀେ-ୈୋ-ୌୗଡ଼-ଢ଼ୟ-ୡ୦-୯୰ୱ୲-୷ஃஅ-ஊஎ-ஐஒ-கங-சஜஞ-டண-தந-பம-ஹா-ிு-ூெ-ைொ-ௌௐௗ௦-௯௰-௲ఁ-ఃఅ-ఌఎ-ఐఒ-నప-హఽు-ౄౘ-ౙౠ-ౡ౦-౯౿ಂ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽಾಿೀ-ೄೆೇ-ೈೊ-ೋೕ-ೖೞೠ-ೡ೦-೯ೱ-ೲം-ഃഅ-ഌഎ-ഐഒ-ഺഽാ-ീെ-ൈൊ-ൌൎൗൠ-ൡ൦-൯൰-൵൹ൺ-ൿං-ඃඅ-ඖක-නඳ-රලව-ෆා-ෑෘ-ෟ෦-෯ෲ-ෳ෴ก-ะา-ำเ-ๅๆ๏๐-๙๚-๛ກ-ຂຄງ-ຈຊຍດ-ທນ-ຟມ-ຣລວສ-ຫອ-ະາ-ຳຽເ-ໄໆ໐-໙ໜ-ໟༀ༁-༃༄-༒༓༔༕-༗༚-༟༠-༩༪-༳༴༶༸༾-༿ཀ-ཇཉ-ཬཿ྅ྈ-ྌ྾-࿅࿇-࿌࿎-࿏࿐-࿔࿕-࿘࿙-࿚က-ဪါ-ာေးျ-ြဿ၀-၉၊-၏ၐ-ၕၖ-ၗၚ-ၝၡၢ-ၤၥ-ၦၧ-ၭၮ-ၰၵ-ႁႃ-ႄႇ-ႌႎႏ႐-႙ႚ-ႜ႞-႟Ⴀ-ჅჇჍა-ჺ჻ჼჽ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፠-፨፩-፼ᎀ-ᎏᎠ-Ᏼᐁ-ᙬ᙭-᙮ᙯ-ᙿᚁ-ᚚᚠ-ᛪ᛫-᛭ᛮ-ᛰᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱ᜵-᜶ᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳាើ-ៅះ-ៈ។-៖ៗ៘-៚ៜ០-៩᠐-᠙ᠠ-ᡂᡃᡄ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᤣ-ᤦᤩ-ᤫᤰ-ᤱᤳ-ᤸ᥆-᥏ᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧀᧁ-ᧇᧈ-ᧉ᧐-᧙᧚ᨀ-ᨖᨙ-ᨚ᨞-᨟ᨠ-ᩔᩕᩗᩡᩣ-ᩤᩭ-ᩲ᪀-᪉᪐-᪙᪠-᪦ᪧ᪨-᪭ᬄᬅ-ᬳᬵᬻᬽ-ᭁᭃ-᭄ᭅ-ᭋ᭐-᭙᭚-᭠᭡-᭪᭴-᭼ᮂᮃ-ᮠᮡᮦ-ᮧ᮪ᮮ-ᮯ᮰-᮹ᮺ-ᯥᯧᯪ-ᯬᯮ᯲-᯳᯼-᯿ᰀ-ᰣᰤ-ᰫᰴ-ᰵ᰻-᰿᱀-᱉ᱍ-ᱏ᱐-᱙ᱚ-ᱷᱸ-ᱽ᱾-᱿᳀-᳇᳓᳡ᳩ-ᳬᳮ-ᳱᳲ-ᳳᳵ-ᳶᴀ-ᴫᴬ-ᵪᵫ-ᵷᵸᵹ-ᶚᶛ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‎ⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℵ-ℸℹℼ-ℿⅅ-ⅉⅎ⅏Ⅰ-ↂↃ-ↄↅ-ↈ⌶-⍺⎕⒜-ⓩ⚬⠀-⣿Ⰰ-Ⱞⰰ-ⱞⱠ-ⱻⱼ-ⱽⱾ-ⳤⳫ-ⳮⳲ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ⵰ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々〆〇〡-〩〮-〯〱-〵〸-〺〻〼ぁ-ゖゝ-ゞゟァ-ヺー-ヾヿㄅ-ㄭㄱ-ㆎ㆐-㆑㆒-㆕㆖-㆟ㆠ-ㆺㇰ-ㇿ㈀-㈜㈠-㈩㈪-㉇㉈-㉏㉠-㉻㉿㊀-㊉㊊-㊰㋀-㋋㋐-㋾㌀-㍶㍻-㏝㏠-㏾㐀-䶵一-鿌ꀀ-ꀔꀕꀖ-ꒌꓐ-ꓷꓸ-ꓽ꓾-꓿ꔀ-ꘋꘌꘐ-ꘟ꘠-꘩ꘪ-ꘫꙀ-ꙭꙮꚀ-ꚛꚜ-ꚝꚠ-ꛥꛦ-ꛯ꛲-꛷Ꜣ-ꝯꝰꝱ-ꞇ꞉-꞊Ꞌ-ꞎꞐ-ꞭꞰ-Ʇꟷꟸ-ꟹꟺꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꠣ-ꠤꠧ꠰-꠵꠶-꠷ꡀ-ꡳꢀ-ꢁꢂ-ꢳꢴ-ꣃ꣎-꣏꣐-꣙ꣲ-ꣷ꣸-꣺ꣻ꤀-꤉ꤊ-ꤥ꤮-꤯ꤰ-ꥆꥒ-꥓꥟ꥠ-ꥼꦃꦄ-ꦲꦴ-ꦵꦺ-ꦻꦽ-꧀꧁-꧍ꧏ꧐-꧙꧞-꧟ꧠ-ꧤꧦꧧ-ꧯ꧰-꧹ꧺ-ꧾꨀ-ꨨꨯ-ꨰꨳ-ꨴꩀ-ꩂꩄ-ꩋꩍ꩐-꩙꩜-꩟ꩠ-ꩯꩰꩱ-ꩶ꩷-꩹ꩺꩻꩽꩾ-ꪯꪱꪵ-ꪶꪹ-ꪽꫀꫂꫛ-ꫜꫝ꫞-꫟ꫠ-ꫪꫫꫮ-ꫯ꫰-꫱ꫲꫳ-ꫴꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚ꭛ꭜ-ꭟꭤ-ꭥꯀ-ꯢꯣ-ꯤꯦ-ꯧꯩ-ꯪ꯫꯬꯰-꯹가-힣ힰ-ퟆퟋ-ퟻ-豈-舘並-龎ﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚｦ-ｯｰｱ-ﾝﾞ-ﾟﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ" + i + A + "]"),
      l = new RegExp("[" + i + A + "]");

  function a(e) {
    var n = s.exec(e);
    return null == n ? null : n[0];
  }

  function c(e) {
    var n = a(e);
    return null == n ? r.NEUTRAL : l.exec(n) ? r.RTL : r.LTR;
  }

  function u(e, n) {
    if (n = n || r.NEUTRAL, !e.length) return n;
    var t = c(e);
    return t === r.NEUTRAL ? n : t;
  }

  function p(e, n) {
    return n || (n = r.getGlobalDir()), r.isStrong(n) || o(!1), u(e, n);
  }

  var m = {
    firstStrongChar: a,
    firstStrongCharDir: c,
    resolveBlockDir: u,
    getDirection: p,
    isDirectionLTR: function isDirectionLTR(e, n) {
      return p(e, n) === r.LTR;
    },
    isDirectionRTL: function isDirectionRTL(e, n) {
      return p(e, n) === r.RTL;
    }
  };
  e.exports = m;
}, function (e, n, t) {
  "use strict";

  e.exports = {
    BOLD: {
      fontWeight: "bold"
    },
    CODE: {
      fontFamily: "monospace",
      wordWrap: "break-word"
    },
    ITALIC: {
      fontStyle: "italic"
    },
    STRIKETHROUGH: {
      textDecoration: "line-through"
    },
    UNDERLINE: {
      textDecoration: "underline"
    }
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    var n = e.getSelection(),
        t = n.getAnchorKey(),
        r = e.getBlockTree(t),
        o = n.getStartOffset(),
        i = !1;
    return r.some(function (e) {
      return o === e.get("start") ? (i = !0, !0) : o < e.get("end") && e.get("leaves").some(function (e) {
        var n = e.get("start");
        return o === n && (i = !0, !0);
      });
    }), i;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  };

  var o = t(140),
      i = t(53),
      A = t(0),
      s = t(40),
      l = t(95),
      a = t(68),
      c = t(90),
      u = t(63),
      p = t(35),
      m = t(154),
      C = t(69),
      d = t(158),
      f = t(4),
      h = t(23),
      x = function x(e, n) {
    return e.getAnchorKey() === n || e.getFocusKey() === n;
  },
      g = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.shouldComponentUpdate = function (e) {
      return this.props.block !== e.block || this.props.tree !== e.tree || this.props.direction !== e.direction || x(e.selection, e.block.getKey()) && e.forceSelection;
    }, n.prototype.componentDidMount = function () {
      var e = this.props.selection,
          n = e.getEndKey();

      if (e.getHasFocus() && n === this.props.block.getKey()) {
        var t = s.findDOMNode(this),
            r = a.getScrollParent(t),
            o = C(r),
            i = void 0;

        if (r === window) {
          var A = m(t);
          (i = A.y + A.height - d().height) > 0 && window.scrollTo(o.x, o.y + i + 10);
        } else {
          t instanceof HTMLElement || f(!1), (i = t.offsetHeight + t.offsetTop - (r.offsetHeight + o.y)) > 0 && l.setTop(r, l.getTop(r) + i + 10);
        }
      }
    }, n.prototype._renderChildren = function () {
      var e = this,
          n = this.props.block,
          t = n.getKey(),
          s = n.getText(),
          l = this.props.tree.size - 1,
          a = x(this.props.selection, t);
      return this.props.tree.map(function (p, m) {
        var C = p.get("leaves"),
            d = C.size - 1,
            f = C.map(function (r, c) {
          var u = i.encode(t, m, c),
              p = r.get("start"),
              C = r.get("end");
          return A.createElement(o, {
            key: u,
            offsetKey: u,
            block: n,
            start: p,
            selection: a ? e.props.selection : null,
            forceSelection: e.props.forceSelection,
            text: s.slice(p, C),
            styleSet: n.getInlineStyleAt(p),
            customStyleMap: e.props.customStyleMap,
            customStyleFn: e.props.customStyleFn,
            isLast: m === l && c === d
          });
        }).toArray(),
            x = p.get("decoratorKey");
        if (null == x) return f;
        if (!e.props.decorator) return f;
        var g = h(e.props.decorator),
            I = g.getComponentForKey(x);
        if (!I) return f;
        var b = g.getPropsForKey(x),
            y = i.encode(t, m, 0),
            E = s.slice(C.first().get("start"), C.last().get("end")),
            v = u.getHTMLDirIfDifferent(c.getDirection(E), e.props.direction);
        return A.createElement(I, r({}, b, {
          contentState: e.props.contentState,
          decoratedText: E,
          dir: v,
          key: y,
          entityKey: n.getEntityAt(p.get("start")),
          offsetKey: y
        }), f);
      }).toArray();
    }, n.prototype.render = function () {
      var e = this.props,
          n = e.direction,
          t = e.offsetKey,
          r = p({
        "public/DraftStyleDefault/block": !0,
        "public/DraftStyleDefault/ltr": "LTR" === n,
        "public/DraftStyleDefault/rtl": "RTL" === n
      });
      return A.createElement("div", {
        "data-offset-key": t,
        className: r
      }, this._renderChildren());
    }, n;
  }(A.Component);

  e.exports = g;
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;

    try {
      return e.activeElement || e.body;
    } catch (n) {
      return e.body;
    }
  };
}, function (e, n, t) {
  "use strict";

  function r(e, n) {
    return !!n && (e === n.documentElement || e === n.body);
  }

  var o = {
    getTop: function getTop(e) {
      var n = e.ownerDocument;
      return r(e, n) ? n.body.scrollTop || n.documentElement.scrollTop : e.scrollTop;
    },
    setTop: function setTop(e, n) {
      var t = e.ownerDocument;
      r(e, t) ? t.body.scrollTop = t.documentElement.scrollTop = n : e.scrollTop = n;
    },
    getLeft: function getLeft(e) {
      var n = e.ownerDocument;
      return r(e, n) ? n.body.scrollLeft || n.documentElement.scrollLeft : e.scrollLeft;
    },
    setLeft: function setLeft(e, n) {
      var t = e.ownerDocument;
      r(e, t) ? t.body.scrollLeft = t.documentElement.scrollLeft = n : e.scrollLeft = n;
    }
  };
  e.exports = o;
}, function (e, n, t) {
  "use strict";

  var r = t(161),
      o = t(162),
      i = t(60),
      A = new RegExp("\r\n", "g"),
      s = {
    "text/rtf": 1,
    "text/html": 1
  };

  function l(e) {
    if ("file" == e.kind) return e.getAsFile();
  }

  var a = function () {
    function e(n) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.data = n, this.types = n.types ? o(n.types) : [];
    }

    return e.prototype.isRichText = function () {
      return !(!this.getHTML() || !this.getText()) || !this.isImage() && this.types.some(function (e) {
        return s[e];
      });
    }, e.prototype.getText = function () {
      var e;
      return this.data.getData && (this.types.length ? -1 != this.types.indexOf("text/plain") && (e = this.data.getData("text/plain")) : e = this.data.getData("Text")), e ? e.replace(A, "\n") : null;
    }, e.prototype.getHTML = function () {
      if (this.data.getData) {
        if (!this.types.length) return this.data.getData("Text");
        if (-1 != this.types.indexOf("text/html")) return this.data.getData("text/html");
      }
    }, e.prototype.isLink = function () {
      return this.types.some(function (e) {
        return -1 != e.indexOf("Url") || -1 != e.indexOf("text/uri-list") || e.indexOf("text/x-moz-url");
      });
    }, e.prototype.getLink = function () {
      return this.data.getData ? -1 != this.types.indexOf("text/x-moz-url") ? this.data.getData("text/x-moz-url").split("\n")[0] : -1 != this.types.indexOf("text/uri-list") ? this.data.getData("text/uri-list") : this.data.getData("url") : null;
    }, e.prototype.isImage = function () {
      var e = this.types.some(function (e) {
        return -1 != e.indexOf("application/x-moz-file");
      });
      if (e) return !0;

      for (var n = this.getFiles(), t = 0; t < n.length; t++) {
        var o = n[t].type;
        if (!r.isImage(o)) return !1;
      }

      return !0;
    }, e.prototype.getCount = function () {
      return this.data.hasOwnProperty("items") ? this.data.items.length : this.data.hasOwnProperty("mozItemCount") ? this.data.mozItemCount : this.data.files ? this.data.files.length : null;
    }, e.prototype.getFiles = function () {
      return this.data.items ? Array.prototype.slice.call(this.data.items).map(l).filter(i.thatReturnsArgument) : this.data.files ? Array.prototype.slice.call(this.data.files) : [];
    }, e.prototype.hasFiles = function () {
      return this.getFiles().length > 0;
    }, e;
  }();

  e.exports = a;
}, function (e, n, t) {
  "use strict";

  e.exports = function e(n) {
    if (n instanceof Element) {
      var t = n.getAttribute("data-offset-key");
      if (t) return t;

      for (var r = 0; r < n.childNodes.length; r++) {
        var o = e(n.childNodes[r]);
        if (o) return o;
      }
    }

    return null;
  };
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(4),
        o = /\.textClipping$/,
        i = {
      "text/plain": !0,
      "text/html": !0,
      "text/rtf": !0
    },
        A = 5e3;

    e.exports = function (e, t) {
      var s = 0,
          l = [];
      e.forEach(function (a) {
        !function (e, t) {
          if (!n.FileReader || e.type && !(e.type in i)) return void t("");

          if ("" === e.type) {
            var A = "";
            return o.test(e.name) && (A = e.name.replace(o, "")), void t(A);
          }

          var s = new FileReader();
          s.onload = function () {
            var e = s.result;
            "string" != typeof e && r(!1), t(e);
          }, s.onerror = function () {
            t("");
          }, s.readAsText(e);
        }(a, function (n) {
          s++, n && l.push(n.slice(0, A)), s == e.length && t(l.join("\r"));
        });
      });
    };
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  var r = t(53),
      o = t(23);

  e.exports = function (e, n, t, i, A) {
    var s = o(e.getSelection()),
        l = r.decode(n),
        a = l.blockKey,
        c = e.getBlockTree(a).getIn([l.decoratorKey, "leaves", l.leafKey]),
        u = r.decode(i),
        p = u.blockKey,
        m = e.getBlockTree(p).getIn([u.decoratorKey, "leaves", u.leafKey]),
        C = c.get("start"),
        d = m.get("start"),
        f = c ? C + t : null,
        h = m ? d + A : null;
    if (s.getAnchorKey() === a && s.getAnchorOffset() === f && s.getFocusKey() === p && s.getFocusOffset() === h) return s;
    var x = !1;

    if (a === p) {
      var g = c.get("end"),
          I = m.get("end");
      x = d === C && I === g ? A < t : d < C;
    } else {
      x = e.getCurrentContent().getBlockMap().keySeq().skipUntil(function (e) {
        return e === a || e === p;
      }).first() === p;
    }

    return s.merge({
      anchorKey: a,
      anchorOffset: f,
      focusKey: p,
      focusOffset: h,
      isBackward: x
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(51);

  e.exports = function (e) {
    var n = e.getSelection();
    return n.isCollapsed() ? null : r(e.getCurrentContent(), n);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(24),
      o = t(4);
  var i = r.isBrowser("Chrome") ? function (e) {
    for (var n = e.cloneRange(), t = [], r = e.endContainer; null != r; r = r.parentNode) {
      var i = r === e.commonAncestorContainer;
      i ? n.setStart(e.startContainer, e.startOffset) : n.setStart(n.endContainer, 0);
      var A,
          s = Array.from(n.getClientRects());
      if (t.push(s), i) return t.reverse(), (A = []).concat.apply(A, t);
      n.setEndBefore(r);
    }

    o(!1);
  } : function (e) {
    return Array.from(e.getClientRects());
  };
  e.exports = i;
}, function (e, n, t) {
  "use strict";

  var r = t(70),
      o = t(97),
      i = t(99),
      A = t(4),
      s = t(23);

  function l(e, n, t) {
    var i = n,
        l = r(i);

    if (null != l || e && (e === i || e.firstChild === i) || A(!1), e === i && ((i = i.firstChild) instanceof Element && "true" === i.getAttribute("data-contents") || A(!1), t > 0 && (t = i.childNodes.length)), 0 === t) {
      var c = null;
      if (null != l) c = l;else {
        var u = function (e) {
          for (; e.firstChild && (e.firstChild instanceof Element && "true" === e.firstChild.getAttribute("data-blocks") || o(e.firstChild));) {
            e = e.firstChild;
          }

          return e;
        }(i);

        c = s(o(u));
      }
      return {
        key: c,
        offset: 0
      };
    }

    var p = i.childNodes[t - 1],
        m = null,
        C = null;

    if (o(p)) {
      var d = function (e) {
        for (; e.lastChild && (e.lastChild instanceof Element && "true" === e.lastChild.getAttribute("data-blocks") || o(e.lastChild));) {
          e = e.lastChild;
        }

        return e;
      }(p);

      m = s(o(d)), C = a(d);
    } else m = s(l), C = a(p);

    return {
      key: m,
      offset: C
    };
  }

  function a(e) {
    var n = e.textContent;
    return "\n" === n ? 0 : n.length;
  }

  e.exports = function (e, n, t, o, A, a) {
    var c = t.nodeType === Node.TEXT_NODE,
        u = A.nodeType === Node.TEXT_NODE;
    if (c && u) return {
      selectionState: i(e, s(r(t)), o, s(r(A)), a),
      needsRecovery: !1
    };
    var p = null,
        m = null,
        C = !0;
    return c ? (p = {
      key: s(r(t)),
      offset: o
    }, m = l(n, A, a)) : u ? (m = {
      key: s(r(A)),
      offset: a
    }, p = l(n, t, o)) : (p = l(n, t, o), m = l(n, A, a), t === A && o === a && (C = !!t.firstChild && "BR" !== t.firstChild.nodeName)), {
      selectionState: i(e, p.key, p.offset, m.key, m.offset),
      needsRecovery: C
    };
  };
}, function (e, n, t) {
  "use strict";

  var r = "\\s|(?![_])" + t(179).getPunctuation(),
      o = new RegExp("^(?:" + r + ")*(?:['‘’]|(?!" + r + ").)*(?:(?!" + r + ").)"),
      i = new RegExp("(?:(?!" + r + ").)(?:['‘’]|(?!" + r + ").)*(?:" + r + ")*$");

  function A(e, n) {
    var t = n ? i.exec(e) : o.exec(e);
    return t ? t[0] : e;
  }

  var s = {
    getBackward: function getBackward(e) {
      return A(e, !0);
    },
    getForward: function getForward(e) {
      return A(e, !1);
    }
  };
  e.exports = s;
}, function (e, n, t) {
  "use strict";

  e.exports = function (e, n) {
    var t,
        r = e.getSelection(),
        o = r.getStartKey(),
        i = r.getStartOffset(),
        A = e.getCurrentContent(),
        s = o;
    return n > A.getBlockForKey(o).getText().length - i ? (s = A.getKeyAfter(o), t = 0) : t = i + n, r.merge({
      focusKey: s,
      focusOffset: t
    });
  };
}, function (e, n, t) {
  "use strict";

  var r,
      o = i || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      i = t(18);

  function A(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var s = t(19),
      l = t(29),
      a = t(21),
      c = t(64),
      u = t(52),
      p = t(27),
      m = t(3),
      C = t(3).Set,
      d = t(190),
      f = t(35),
      h = t(25),
      x = t(106),
      g = t(4),
      I = t(62),
      b = p.draft_tree_data_support,
      y = m.List,
      E = m.OrderedSet,
      v = new RegExp("\r", "g"),
      w = new RegExp("\n", "g"),
      B = new RegExp("&nbsp;", "g"),
      _ = new RegExp("&#13;?", "g"),
      D = new RegExp("&#8203;?", "g"),
      S = ["bold", "bolder", "500", "600", "700", "800", "900"],
      M = ["light", "lighter", "100", "200", "300", "400"],
      O = {
    b: "BOLD",
    code: "CODE",
    del: "STRIKETHROUGH",
    em: "ITALIC",
    i: "ITALIC",
    s: "STRIKETHROUGH",
    strike: "STRIKETHROUGH",
    strong: "BOLD",
    u: "UNDERLINE"
  },
      k = (A(r = {}, f("public/DraftStyleDefault/depth0"), 0), A(r, f("public/DraftStyleDefault/depth1"), 1), A(r, f("public/DraftStyleDefault/depth2"), 2), A(r, f("public/DraftStyleDefault/depth3"), 3), A(r, f("public/DraftStyleDefault/depth4"), 4), r),
      T = ["className", "href", "rel", "target", "title"],
      P = ["alt", "className", "height", "src", "width"],
      K = void 0,
      Q = {
    text: "",
    inlines: [],
    entities: [],
    blocks: []
  },
      U = {
    children: y(),
    depth: 0,
    key: "",
    type: ""
  },
      R = function R(e, n) {
    return "li" === e ? "ol" === n ? "ordered-list-item" : "unordered-list-item" : null;
  },
      G = function G(e, n, t) {
    var r = t.filter(function (n) {
      return n.element === e || n.wrapper === e || n.aliasedElements && n.aliasedElements.some(function (n) {
        return n === e;
      });
    }).keySeq().toSet().toArray().sort();

    switch (r.length) {
      case 0:
        return "unstyled";

      case 1:
        return r[0];

      default:
        return function (e, n, t) {
          for (var r = 0; r < t.length; r++) {
            var o = t[r](e, n);
            if (o) return o;
          }

          return null;
        }(e, n, [R]) || "unstyled";
    }
  },
      Y = function Y(e, n, t) {
    var r = e.text.slice(-1),
        o = n.text.slice(0, 1);

    if ("\r" !== r || "\r" !== o || t || (e.text = e.text.slice(0, -1), e.inlines.pop(), e.entities.pop(), e.blocks.pop()), "\r" === r) {
      if (" " === n.text || "\n" === n.text) return e;
      " " !== o && "\n" !== o || (n.text = n.text.slice(1), n.inlines.shift(), n.entities.shift());
    }

    return {
      text: e.text + n.text,
      inlines: e.inlines.concat(n.inlines),
      entities: e.entities.concat(n.entities),
      blocks: e.blocks.concat(n.blocks)
    };
  },
      F = function F(e) {
    e instanceof HTMLAnchorElement || g(!1);
    var n = e.protocol;
    return "http:" === n || "https:" === n || "mailto:" === n;
  },
      N = function N(e) {
    var n = new Array(1);
    return e && (n[0] = e), o({}, Q, {
      text: " ",
      inlines: [E()],
      entities: n
    });
  },
      j = function j() {
    return o({}, Q, {
      text: "\n",
      inlines: [E()],
      entities: new Array(1)
    });
  },
      W = function W() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return o({}, U, e);
  },
      L = function L(e, n) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
    return {
      text: "\r",
      inlines: [E()],
      entities: new Array(1),
      blocks: [W({
        parent: t,
        key: h(),
        type: e,
        depth: Math.max(0, Math.min(4, n))
      })]
    };
  },
      z = function e(n, t, r, i, A, s, l, a, c, p) {
    var m = K,
        C = t.nodeName.toLowerCase(),
        f = n,
        h = "unstyled",
        x = !1,
        g = A && G(A, i, a),
        I = o({}, Q),
        y = void 0;

    if ("#text" === C) {
      var E = t.textContent,
          v = E.trim();

      if (i && "" === v && t.parentElement) {
        var B = t.parentElement.nodeName.toLowerCase();
        if ("ol" === B || "ul" === B) return {
          chunk: o({}, Q),
          entityMap: n
        };
      }

      return "" === v && "pre" !== A ? {
        chunk: N(c),
        entityMap: n
      } : ("pre" !== A && (E = E.replace(w, " ")), K = C, {
        chunk: {
          text: E,
          inlines: Array(E.length).fill(r),
          entities: Array(E.length).fill(c),
          blocks: []
        },
        entityMap: n
      });
    }

    if (K = C, "br" === C) return "br" !== m || A && "unstyled" !== g ? {
      chunk: j(),
      entityMap: n
    } : {
      chunk: L("unstyled", l, p),
      entityMap: n
    };

    if ("img" === C && t instanceof HTMLImageElement && t.attributes.getNamedItem("src") && t.attributes.getNamedItem("src").value) {
      var _ = t,
          D = {};
      P.forEach(function (e) {
        var n = _.getAttribute(e);

        n && (D[e] = n);
      }), t.textContent = "📷", c = u.__create("IMAGE", "MUTABLE", D || {});
    }

    r = function (e, n, t) {
      var r = O[e];
      if (r) t = t.add(r).toOrderedSet();else if (n instanceof HTMLElement) {
        var o = n;
        t = t.withMutations(function (e) {
          var n = o.style.fontWeight,
              t = o.style.fontStyle,
              r = o.style.textDecoration;
          S.indexOf(n) >= 0 ? e.add("BOLD") : M.indexOf(n) >= 0 && e.remove("BOLD"), "italic" === t ? e.add("ITALIC") : "normal" === t && e.remove("ITALIC"), "underline" === r && e.add("UNDERLINE"), "line-through" === r && e.add("STRIKETHROUGH"), "none" === r && (e.remove("UNDERLINE"), e.remove("STRIKETHROUGH"));
        }).toOrderedSet();
      }
      return t;
    }(C, t, r), "ul" !== C && "ol" !== C || (i && (l += 1), i = C), !b && "li" === C && t instanceof HTMLElement && (l = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return Object.keys(k).some(function (t) {
        e.classList.contains(t) && (n = k[t]);
      }), n;
    }(t, l));
    var U = G(C, i, a),
        R = i && "li" === A && "li" === C,
        W = (!A || b) && -1 !== s.indexOf(C);
    (R || W) && (y = (I = L(U, l, p)).blocks[0].key, A = C, x = !b), R && (h = "ul" === i ? "unordered-list-item" : "ordered-list-item");
    var z = t.firstChild;
    null != z && (C = z.nodeName.toLowerCase());

    for (var X = null; z;) {
      z instanceof HTMLAnchorElement && z.href && F(z) ? function () {
        var e = z,
            n = {};
        T.forEach(function (t) {
          var r = e.getAttribute(t);
          r && (n[t] = r);
        }), n.url = new d(e.href).toString(), X = u.__create("LINK", "MUTABLE", n || {});
      }() : X = void 0;
      var H = e(f, z, r, i, A, s, l, a, X || c, b ? y : null),
          q = H.chunk;
      f = H.entityMap, I = Y(I, q, b);
      var V = z.nextSibling;
      !p && V && s.indexOf(C) >= 0 && A && (I = Y(I, j())), V && (C = V.nodeName.toLowerCase()), z = V;
    }

    return x && (I = Y(I, L(h, l, p))), {
      chunk: I,
      entityMap: f
    };
  },
      X = function X(e, n, t, r) {
    e = e.trim().replace(v, "").replace(B, " ").replace(_, "").replace(D, "");

    var i = function (e) {
      var n = e.get("unstyled").element,
          t = C([]);
      return e.forEach(function (e) {
        e.aliasedElements && e.aliasedElements.forEach(function (e) {
          t = t.add(e);
        }), t = t.add(e.element);
      }), t.filter(function (e) {
        return e && e !== n;
      }).toArray().sort();
    }(t),
        A = n(e);

    if (!A) return null;
    K = null;
    var s = function (e, n) {
      return n.some(function (n) {
        return -1 !== e.indexOf("<" + n);
      });
    }(e, i) ? i : ["div"],
        l = z(r, A, E(), "ul", null, s, -1, t),
        a = l.chunk,
        c = l.entityMap;
    return 0 === a.text.indexOf("\r") && (a = {
      text: a.text.slice(1),
      inlines: a.inlines.slice(1),
      entities: a.entities.slice(1),
      blocks: a.blocks
    }), "\r" === a.text.slice(-1) && (a.text = a.text.slice(0, -1), a.inlines = a.inlines.slice(0, -1), a.entities = a.entities.slice(0, -1), a.blocks.pop()), 0 === a.blocks.length && a.blocks.push(o({}, Q, {
      type: "unstyled",
      depth: 0
    })), a.text.split("\r").length === a.blocks.length + 1 && a.blocks.unshift({
      type: "unstyled",
      depth: 0
    }), {
      chunk: a,
      entityMap: c
    };
  },
      H = function H(e) {
    if (!e || !e.text || !Array.isArray(e.blocks)) return null;
    var n = 0,
        t = e.blocks,
        r = e.inlines,
        o = e.entities,
        i = b ? a : l;
    return e.text.split("\r").reduce(function (e, A, l) {
      A = I(A);
      var c = t[l],
          u = n + A.length,
          p = r.slice(n, u),
          m = o.slice(n, u),
          C = y(p.map(function (e, n) {
        var t = {
          style: e,
          entity: null
        };
        return m[n] && (t.entity = m[n]), s.create(t);
      }));
      n = u + 1;
      var d = c.depth,
          f = c.type,
          x = c.parent,
          g = c.key || h(),
          b = null;

      if (x) {
        var E = e.cacheRef[x],
            v = e.contentBlocks[E];

        if (v.getChildKeys().isEmpty() && v.getText()) {
          var w = v.getCharacterList(),
              B = v.getText();
          b = h();

          var _ = new a({
            key: b,
            text: B,
            characterList: w,
            parent: x,
            nextSibling: g
          });

          e.contentBlocks.push(_), v = v.withMutations(function (e) {
            e.set("characterList", y()).set("text", "").set("children", v.children.push(_.getKey()));
          });
        }

        e.contentBlocks[E] = v.set("children", v.children.push(g));
      }

      var D = new i({
        key: g,
        parent: x,
        type: f,
        depth: d,
        text: A,
        characterList: C,
        prevSibling: b || (0 === l || t[l - 1].parent !== x ? null : t[l - 1].key),
        nextSibling: l === t.length - 1 || t[l + 1].parent !== x ? null : t[l + 1].key
      });
      return e.contentBlocks.push(D), e.cacheRef[D.key] = l, e;
    }, {
      cacheRef: {},
      contentBlocks: []
    }).contentBlocks;
  };

  e.exports = function (e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : x,
        t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : c,
        r = X(e, n, t, u);
    if (null == r) return null;
    var o = r.chunk,
        i = r.entityMap,
        A = H(o);
    return {
      contentBlocks: A,
      entityMap: i
    };
  };
}, function (e, n, t) {
  "use strict";

  var r = t(24),
      o = t(4),
      i = r.isBrowser("IE <= 9");

  e.exports = function (e) {
    var n,
        t = null;
    return !i && document.implementation && document.implementation.createHTMLDocument && ((n = document.implementation.createHTMLDocument("foo")).documentElement || o(!1), n.documentElement.innerHTML = e, t = n.getElementsByTagName("body")[0]), t;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(16),
      o = t(7),
      i = (t(34), t(191)),
      A = t(23),
      s = {
    currentBlockContainsLink: function currentBlockContainsLink(e) {
      var n = e.getSelection(),
          t = e.getCurrentContent(),
          r = t.getEntityMap();
      return t.getBlockForKey(n.getAnchorKey()).getCharacterList().slice(n.getStartOffset(), n.getEndOffset()).some(function (e) {
        var n = e.getEntity();
        return !!n && "LINK" === r.__get(n).getType();
      });
    },
    getCurrentBlockType: function getCurrentBlockType(e) {
      var n = e.getSelection();
      return e.getCurrentContent().getBlockForKey(n.getStartKey()).getType();
    },
    getDataObjectForLinkURL: function getDataObjectForLinkURL(e) {
      return {
        url: e.toString()
      };
    },
    handleKeyCommand: function handleKeyCommand(e, n) {
      switch (n) {
        case "bold":
          return s.toggleInlineStyle(e, "BOLD");

        case "italic":
          return s.toggleInlineStyle(e, "ITALIC");

        case "underline":
          return s.toggleInlineStyle(e, "UNDERLINE");

        case "code":
          return s.toggleCode(e);

        case "backspace":
        case "backspace-word":
        case "backspace-to-start-of-line":
          return s.onBackspace(e);

        case "delete":
        case "delete-word":
        case "delete-to-end-of-block":
          return s.onDelete(e);

        default:
          return null;
      }
    },
    insertSoftNewline: function insertSoftNewline(e) {
      var n = r.insertText(e.getCurrentContent(), e.getSelection(), "\n", e.getCurrentInlineStyle(), null),
          t = o.push(e, n, "insert-characters");
      return o.forceSelection(t, n.getSelectionAfter());
    },
    onBackspace: function onBackspace(e) {
      var n = e.getSelection();
      if (!n.isCollapsed() || n.getAnchorOffset() || n.getFocusOffset()) return null;
      var t = e.getCurrentContent(),
          r = n.getStartKey(),
          i = t.getBlockBefore(r);

      if (i && "atomic" === i.getType()) {
        var A = t.getBlockMap().delete(i.getKey()),
            l = t.merge({
          blockMap: A,
          selectionAfter: n
        });
        if (l !== t) return o.push(e, l, "remove-range");
      }

      var a = s.tryToRemoveBlockStyle(e);
      return a ? o.push(e, a, "change-block-type") : null;
    },
    onDelete: function onDelete(e) {
      var n = e.getSelection();
      if (!n.isCollapsed()) return null;
      var t = e.getCurrentContent(),
          i = n.getStartKey(),
          A = t.getBlockForKey(i).getLength();
      if (n.getStartOffset() < A) return null;
      var s = t.getBlockAfter(i);
      if (!s || "atomic" !== s.getType()) return null;
      var l = n.merge({
        focusKey: s.getKey(),
        focusOffset: s.getLength()
      }),
          a = r.removeRange(t, l, "forward");
      return a !== t ? o.push(e, a, "remove-range") : null;
    },
    onTab: function onTab(e, n, t) {
      var r = n.getSelection(),
          A = r.getAnchorKey();
      if (A !== r.getFocusKey()) return n;
      var s = n.getCurrentContent(),
          l = s.getBlockForKey(A),
          a = l.getType();
      if ("unordered-list-item" !== a && "ordered-list-item" !== a) return n;
      e.preventDefault();
      var c = s.getBlockBefore(A);
      if (!c) return n;
      var u = c.getType();
      if ("unordered-list-item" !== u && "ordered-list-item" !== u) return n;
      var p = l.getDepth();
      if (!e.shiftKey && p === t) return n;
      t = Math.min(c.getDepth() + 1, t);
      var m = i(s, r, e.shiftKey ? -1 : 1, t);
      return o.push(n, m, "adjust-depth");
    },
    toggleBlockType: function toggleBlockType(e, n) {
      var t = e.getSelection(),
          i = t.getStartKey(),
          s = t.getEndKey(),
          l = e.getCurrentContent(),
          a = t;

      if (i !== s && 0 === t.getEndOffset()) {
        var c = A(l.getBlockBefore(s));
        s = c.getKey(), a = a.merge({
          anchorKey: i,
          anchorOffset: t.getStartOffset(),
          focusKey: s,
          focusOffset: c.getLength(),
          isBackward: !1
        });
      }

      if (l.getBlockMap().skipWhile(function (e, n) {
        return n !== i;
      }).reverse().skipWhile(function (e, n) {
        return n !== s;
      }).some(function (e) {
        return "atomic" === e.getType();
      })) return e;
      var u = l.getBlockForKey(i).getType() === n ? "unstyled" : n;
      return o.push(e, r.setBlockType(l, a, u), "change-block-type");
    },
    toggleCode: function toggleCode(e) {
      var n = e.getSelection(),
          t = n.getAnchorKey(),
          r = n.getFocusKey();
      return n.isCollapsed() || t !== r ? s.toggleBlockType(e, "code-block") : s.toggleInlineStyle(e, "CODE");
    },
    toggleInlineStyle: function toggleInlineStyle(e, n) {
      var t = e.getSelection(),
          i = e.getCurrentInlineStyle();
      if (t.isCollapsed()) return o.setInlineStyleOverride(e, i.has(n) ? i.remove(n) : i.add(n));
      var A,
          s = e.getCurrentContent();
      return A = i.has(n) ? r.removeInlineStyle(s, t, n) : r.applyInlineStyle(s, t, n), o.push(e, A, "change-inline-style");
    },
    toggleLink: function toggleLink(e, n, t) {
      var i = r.applyEntity(e.getCurrentContent(), n, t);
      return o.push(e, i, "apply-entity");
    },
    tryToRemoveBlockStyle: function tryToRemoveBlockStyle(e) {
      var n = e.getSelection(),
          t = n.getAnchorOffset();

      if (n.isCollapsed() && 0 === t) {
        var o = n.getAnchorKey(),
            i = e.getCurrentContent(),
            A = i.getBlockForKey(o),
            s = i.getFirstBlock();
        if (A.getLength() > 0 && A !== s) return null;
        var l = A.getType(),
            a = i.getBlockBefore(o);
        if ("code-block" === l && a && "code-block" === a.getType() && 0 !== a.getLength()) return null;
        if ("unstyled" !== l) return r.setBlockType(i, n, "unstyled");
      }

      return null;
    }
  };
  e.exports = s;
}, function (e, n, t) {
  "use strict";

  var r = t(71),
      o = t(65),
      i = t(24),
      A = i.isPlatform("Mac OS X"),
      s = i.isPlatform("Windows"),
      l = A && i.isBrowser("Firefox < 29"),
      a = r.hasCommandModifier,
      c = r.isCtrlKeyCommand;

  function u(e) {
    return A && e.altKey || c(e);
  }

  e.exports = function (e) {
    switch (e.keyCode) {
      case 66:
        return a(e) ? "bold" : null;

      case 68:
        return c(e) ? "delete" : null;

      case 72:
        return c(e) ? "backspace" : null;

      case 73:
        return a(e) ? "italic" : null;

      case 74:
        return a(e) ? "code" : null;

      case 75:
        return !s && c(e) ? "secondary-cut" : null;

      case 77:
      case 79:
        return c(e) ? "split-block" : null;

      case 84:
        return A && c(e) ? "transpose-characters" : null;

      case 85:
        return a(e) ? "underline" : null;

      case 87:
        return A && c(e) ? "backspace-word" : null;

      case 89:
        return c(e) ? s ? "redo" : "secondary-paste" : null;

      case 90:
        return function (e) {
          return a(e) ? e.shiftKey ? "redo" : "undo" : null;
        }(e) || null;

      case o.RETURN:
        return "split-block";

      case o.DELETE:
        return function (e) {
          return s && e.shiftKey ? null : u(e) ? "delete-word" : "delete";
        }(e);

      case o.BACKSPACE:
        return function (e) {
          return a(e) && A ? "backspace-to-start-of-line" : u(e) ? "backspace-word" : "backspace";
        }(e);

      case o.LEFT:
        return l && a(e) ? "move-selection-to-start-of-block" : null;

      case o.RIGHT:
        return l && a(e) ? "move-selection-to-end-of-block" : null;

      default:
        return null;
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = {
    stringify: function stringify(e) {
      return "_" + String(e);
    },
    unstringify: function unstringify(e) {
      return e.slice(1);
    }
  };
  e.exports = r;
}, function (e, n, t) {
  (function (t) {
    /*!
     * Number-To-Words util
     * @version v1.2.4
     * @link https://github.com/marlun78/number-to-words
     * @author Martin Eneqvist (https://github.com/marlun78)
     * @contributors Aleksey Pilyugin (https://github.com/pilyugin),Jeremiah Hall (https://github.com/jeremiahrhall),Adriano Melo (https://github.com/adrianomelo),dmrzn (https://github.com/dmrzn)
     * @license MIT
     */
    !function () {
      "use strict";

      "object" == typeof self && self.self === self && self || "object" == typeof t && t.global;
      var r = 9007199254740991;

      function o(e) {
        return !("number" != typeof e || e != e || e === 1 / 0 || e === -1 / 0);
      }

      function i(e) {
        return "number" == typeof e && Math.abs(e) <= r;
      }

      var A = /(hundred|thousand|(m|b|tr|quadr)illion)$/,
          s = /teen$/,
          l = /y$/,
          a = /(zero|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)$/,
          c = {
        zero: "zeroth",
        one: "first",
        two: "second",
        three: "third",
        four: "fourth",
        five: "fifth",
        six: "sixth",
        seven: "seventh",
        eight: "eighth",
        nine: "ninth",
        ten: "tenth",
        eleven: "eleventh",
        twelve: "twelfth"
      };

      function u(e) {
        return A.test(e) || s.test(e) ? e + "th" : l.test(e) ? e.replace(l, "ieth") : a.test(e) ? e.replace(a, p) : e;
      }

      function p(e, n) {
        return c[n];
      }

      var m = 10,
          C = 100,
          d = 1e3,
          f = 1e6,
          h = 1e9,
          x = 1e12,
          g = 1e15,
          I = 9007199254740992,
          b = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"],
          y = ["zero", "ten", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

      function E(e, n) {
        var t,
            r = parseInt(e, 10);
        if (!o(r)) throw new TypeError("Not a finite number: " + e + " (" + typeof e + ")");
        if (!i(r)) throw new RangeError("Input is not a safe number, it’s either too large or too small.");
        return t = function e(n) {
          var t,
              r,
              o = arguments[1];
          return 0 === n ? o ? o.join(" ").replace(/,$/, "") : "zero" : (o || (o = []), n < 0 && (o.push("minus"), n = Math.abs(n)), n < 20 ? (t = 0, r = b[n]) : n < C ? (t = n % m, r = y[Math.floor(n / m)], t && (r += "-" + b[t], t = 0)) : n < d ? (t = n % C, r = e(Math.floor(n / C)) + " hundred") : n < f ? (t = n % d, r = e(Math.floor(n / d)) + " thousand,") : n < h ? (t = n % f, r = e(Math.floor(n / f)) + " million,") : n < x ? (t = n % h, r = e(Math.floor(n / h)) + " billion,") : n < g ? (t = n % x, r = e(Math.floor(n / x)) + " trillion,") : n <= I && (t = n % g, r = e(Math.floor(n / g)) + " quadrillion,"), o.push(r), e(t, o));
        }(r), n ? u(t) : t;
      }

      var v = {
        toOrdinal: function toOrdinal(e) {
          var n = parseInt(e, 10);
          if (!o(n)) throw new TypeError("Not a finite number: " + e + " (" + typeof e + ")");
          if (!i(n)) throw new RangeError("Input is not a safe number, it’s either too large or too small.");
          var t = String(n),
              r = Math.abs(n % 100),
              A = 11 <= r && r <= 13,
              s = t.charAt(t.length - 1);
          return t + (A ? "th" : "1" === s ? "st" : "2" === s ? "nd" : "3" === s ? "rd" : "th");
        },
        toWords: E,
        toWordsOrdinal: function toWordsOrdinal(e) {
          return u(E(e));
        }
      };
      e.exports && (n = e.exports = v), n.numberToWords = v;
    }();
  }).call(this, t(12));
}, function (e, n, t) {
  e.exports = t(207);
}, function (e, n, t) {
  var r = t(218);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.hotkey_display = n.hotkeys = void 0;

  var r = function () {
    function e(e, n) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (n, t, r) {
      return t && e(n.prototype, t), r && e(n, r), n;
    };
  }(),
      o = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      i = l(t(0)),
      A = l(t(219)),
      s = l(t(220));

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e, n) {
    if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
  }

  function c(e, n) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !n || "object" != typeof n && "function" != typeof n ? e : n;
  }

  function u(e, n) {
    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
    e.prototype = Object.create(n && n.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
  }

  A.default.prototype.stopCallback = function () {
    return !1;
  };

  var p = {
    hot_key_property_name: "hot_keys"
  },
      m = {},
      C = function C(e) {
    s.default.forEach(e, function (e, n) {
      null == m[n] ? (m[n] = [e], A.default.bind(n, function (e) {
        return function (n, t) {
          var r = m[e],
              o = !0;
          return s.default.forEach(r, function (e) {
            var r = e.handler;
            o && (o = r(n, t));
          }), o;
        };
      }(n))) : (m[n].push(e), m[n] = s.default.sortBy(m[n], "priority").reverse());
    });
  },
      d = function d(e) {
    s.default.forEach(e, function (e, n) {
      s.default.remove(m[n], e), 0 === m[n].length && (m[n] = null, A.default.unbind(n));
    });
  },
      f = n.hotkeys = function (e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        t = o({}, p, n),
        A = function (n) {
      function A() {
        var e, n, t;
        a(this, A);

        for (var r = arguments.length, o = Array(r), i = 0; i < r; i++) {
          o[i] = arguments[i];
        }

        return n = t = c(this, (e = A.__proto__ || Object.getPrototypeOf(A)).call.apply(e, [this].concat(o))), t.getWrappedComponent = function () {
          return t.wrapped_component;
        }, t.on_ref_update = function (e) {
          t.wrapped_component = e;
        }, c(t, n);
      }

      return u(A, n), r(A, [{
        key: "componentDidMount",
        value: function value() {
          var n = this.wrapped_component[t.hot_key_property_name];
          null != n ? C(n) : console.warn("Component: " + e.displayName + " did not provide hotkey handlers");
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          var e = this.wrapped_component[t.hot_key_property_name];
          null != e && d(e);
        }
      }, {
        key: "render",
        value: function value() {
          return i.default.createElement(e, o({
            ref: this.on_ref_update
          }, this.props));
        }
      }]), A;
    }(i.default.PureComponent);

    return A;
  };

  n.default = f;

  n.hotkey_display = function (e) {
    return -1 !== window.navigator.appVersion.indexOf("Mac") ? e.replace("alt", "option").replace("meta", "⌘") : e;
  };
}, function (e, n, t) {
  var r = t(223);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(14)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n) {
  e.exports = function (e, n) {
    if (("string" == typeof e || e instanceof String) && "undefined" != typeof document) {
      var t = document.createElement("DIV");
      t.innerHTML = e, e = (t.textContent || "").trim();
    } else "object" == typeof e && e.textContent && (e = (e.textContent || "").trim());

    return e;
  };
}, function (e, n) {
  n.endsWithChar = function (e, n) {
    return n.length > 1 ? n.indexOf(e.slice(-1)) > -1 : e.slice(-1) === n;
  }, n.endsWith = function (e, n) {
    return e.slice(e.length - n.length) === n;
  };
}, function (e, n) {
  var t,
      r = ["al", "adj", "assn", "Ave", "BSc", "MSc", "Cell", "Ch", "Co", "cc", "Corp", "Dem", "Dept", "ed", "eg", "Eq", "Eqs", "est", "est", "etc", "Ex", "ext", "Fig", "fig", "Figs", "figs", "i.e", "ie", "Inc", "inc", "Jan", "Feb", "Mar", "Apr", "Jun", "Jul", "Aug", "Sep", "Sept", "Oct", "Nov", "Dec", "jr", "mi", "Miss", "Mrs", "Mr", "Ms", "Mol", "mt", "mts", "no", "Nos", "PhD", "MD", "BA", "MA", "MM", "pl", "pop", "pp", "Prof", "Dr", "pt", "Ref", "Refs", "Rep", "repr", "rev", "Sec", "Secs", "Sgt", "Col", "Gen", "Rep", "Sen", "Gov", "Lt", "Maj", "Capt", "St", "Sr", "sr", "Jr", "jr", "Rev", "Sun", "Mon", "Tu", "Tue", "Tues", "Wed", "Th", "Thu", "Thur", "Thurs", "Fri", "Sat", "trans", "Univ", "Viz", "Vol", "vs", "v"];

  n.setAbbreviations = function (e) {
    t = e || r;
  };

  var o = n.isCapitalized = function (e) {
    return /^[A-Z][a-z].*/.test(e) || i(e);
  };

  n.isSentenceStarter = function (e) {
    return o(e) || /``|"|'/.test(e.substring(0, 2));
  }, n.isCommonAbbreviation = function (e) {
    var n = e.replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, "");
    return ~t.indexOf(n);
  }, n.isTimeAbbreviation = function (e, n) {
    if (("a.m." === e || "p.m." === e) && "day" === n.replace(/\W+/g, "").slice(-3).toLowerCase()) return !0;
    return !1;
  }, n.isDottedAbbreviation = function (e) {
    var n = e.replace(/[\(\)\[\]\{\}]/g, "").match(/(.\.)*/);
    return n && n[0].length > 0;
  }, n.isCustomAbbreviation = function (e) {
    return e.length <= 3 || o(e);
  }, n.isNameAbbreviation = function (e, n) {
    return n.length > 0 && (!!(e < 5 && n[0].length < 6 && o(n[0])) || n.filter(function (e) {
      return /[A-Z]/.test(e.charAt(0));
    }).length >= 3);
  };

  var i = n.isNumber = function (e, n) {
    return n && (e = e.slice(n - 1, n + 2)), !isNaN(e);
  };

  n.isPhoneNr = function (e) {
    return e.match(/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/);
  }, n.isURL = function (e) {
    return e.match(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/);
  }, n.isConcatenated = function (e) {
    var n = 0;
    if (((n = e.indexOf(".")) > -1 || (n = e.indexOf("!")) > -1 || (n = e.indexOf("?")) > -1) && e.charAt(n + 1).match(/[a-zA-Z].*/)) return [e.slice(0, n), e.slice(n + 1)];
    return !1;
  }, n.isBoundaryChar = function (e) {
    return "." === e || "!" === e || "?" === e;
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._1Sqs7D5mukWn2nOcvTmkAt{width:100%;overflow-x:hidden;position:absolute;left:0;bottom:-16px}._3908VmKIi5jE0-hk6X3CPJ{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;cursor:pointer;width:100%;height:30px;margin:0}._3908VmKIi5jE0-hk6X3CPJ::-webkit-slider-runnable-track{height:10px;width:1440px;content:'';pointer-events:none;background:#a0372d}._3908VmKIi5jE0-hk6X3CPJ::-webkit-slider-thumb{-webkit-appearance:none;height:24px;width:16px;margin-top:-7px;background:#a0372d;box-shadow:1px 0 0 -7px #767676,1px 0 0 -7px #767676,2px 0 0 -7px #767676,3px 0 0 -7px #767676,4px 0 0 -7px #767676,5px 0 0 -7px #767676,6px 0 0 -7px #767676,7px 0 0 -7px #767676,8px 0 0 -7px #767676,9px 0 0 -7px #767676,10px 0 0 -7px #767676,11px 0 0 -7px #767676,12px 0 0 -7px #767676,13px 0 0 -7px #767676,14px 0 0 -7px #767676,15px 0 0 -7px #767676,16px 0 0 -7px #767676,17px 0 0 -7px #767676,18px 0 0 -7px #767676,19px 0 0 -7px #767676,20px 0 0 -7px #767676,21px 0 0 -7px #767676,22px 0 0 -7px #767676,23px 0 0 -7px #767676,24px 0 0 -7px #767676,25px 0 0 -7px #767676,26px 0 0 -7px #767676,27px 0 0 -7px #767676,28px 0 0 -7px #767676,29px 0 0 -7px #767676,30px 0 0 -7px #767676,31px 0 0 -7px #767676,32px 0 0 -7px #767676,33px 0 0 -7px #767676,34px 0 0 -7px #767676,35px 0 0 -7px #767676,36px 0 0 -7px #767676,37px 0 0 -7px #767676,38px 0 0 -7px #767676,39px 0 0 -7px #767676,40px 0 0 -7px #767676,41px 0 0 -7px #767676,42px 0 0 -7px #767676,43px 0 0 -7px #767676,44px 0 0 -7px #767676,45px 0 0 -7px #767676,46px 0 0 -7px #767676,47px 0 0 -7px #767676,48px 0 0 -7px #767676,49px 0 0 -7px #767676,50px 0 0 -7px #767676,51px 0 0 -7px #767676,52px 0 0 -7px #767676,53px 0 0 -7px #767676,54px 0 0 -7px #767676,55px 0 0 -7px #767676,56px 0 0 -7px #767676,57px 0 0 -7px #767676,58px 0 0 -7px #767676,59px 0 0 -7px #767676,60px 0 0 -7px #767676,61px 0 0 -7px #767676,62px 0 0 -7px #767676,63px 0 0 -7px #767676,64px 0 0 -7px #767676,65px 0 0 -7px #767676,66px 0 0 -7px #767676,67px 0 0 -7px #767676,68px 0 0 -7px #767676,69px 0 0 -7px #767676,70px 0 0 -7px #767676,71px 0 0 -7px #767676,72px 0 0 -7px #767676,73px 0 0 -7px #767676,74px 0 0 -7px #767676,75px 0 0 -7px #767676,76px 0 0 -7px #767676,77px 0 0 -7px #767676,78px 0 0 -7px #767676,79px 0 0 -7px #767676,80px 0 0 -7px #767676,81px 0 0 -7px #767676,82px 0 0 -7px #767676,83px 0 0 -7px #767676,84px 0 0 -7px #767676,85px 0 0 -7px #767676,86px 0 0 -7px #767676,87px 0 0 -7px #767676,88px 0 0 -7px #767676,89px 0 0 -7px #767676,90px 0 0 -7px #767676,91px 0 0 -7px #767676,92px 0 0 -7px #767676,93px 0 0 -7px #767676,94px 0 0 -7px #767676,95px 0 0 -7px #767676,96px 0 0 -7px #767676,97px 0 0 -7px #767676,98px 0 0 -7px #767676,99px 0 0 -7px #767676,100px 0 0 -7px #767676,101px 0 0 -7px #767676,102px 0 0 -7px #767676,103px 0 0 -7px #767676,104px 0 0 -7px #767676,105px 0 0 -7px #767676,106px 0 0 -7px #767676,107px 0 0 -7px #767676,108px 0 0 -7px #767676,109px 0 0 -7px #767676,110px 0 0 -7px #767676,111px 0 0 -7px #767676,112px 0 0 -7px #767676,113px 0 0 -7px #767676,114px 0 0 -7px #767676,115px 0 0 -7px #767676,116px 0 0 -7px #767676,117px 0 0 -7px #767676,118px 0 0 -7px #767676,119px 0 0 -7px #767676,120px 0 0 -7px #767676,121px 0 0 -7px #767676,122px 0 0 -7px #767676,123px 0 0 -7px #767676,124px 0 0 -7px #767676,125px 0 0 -7px #767676,126px 0 0 -7px #767676,127px 0 0 -7px #767676,128px 0 0 -7px #767676,129px 0 0 -7px #767676,130px 0 0 -7px #767676,131px 0 0 -7px #767676,132px 0 0 -7px #767676,133px 0 0 -7px #767676,134px 0 0 -7px #767676,135px 0 0 -7px #767676,136px 0 0 -7px #767676,137px 0 0 -7px #767676,138px 0 0 -7px #767676,139px 0 0 -7px #767676,140px 0 0 -7px #767676,141px 0 0 -7px #767676,142px 0 0 -7px #767676,143px 0 0 -7px #767676,144px 0 0 -7px #767676,145px 0 0 -7px #767676,146px 0 0 -7px #767676,147px 0 0 -7px #767676,148px 0 0 -7px #767676,149px 0 0 -7px #767676,150px 0 0 -7px #767676,151px 0 0 -7px #767676,152px 0 0 -7px #767676,153px 0 0 -7px #767676,154px 0 0 -7px #767676,155px 0 0 -7px #767676,156px 0 0 -7px #767676,157px 0 0 -7px #767676,158px 0 0 -7px #767676,159px 0 0 -7px #767676,160px 0 0 -7px #767676,161px 0 0 -7px #767676,162px 0 0 -7px #767676,163px 0 0 -7px #767676,164px 0 0 -7px #767676,165px 0 0 -7px #767676,166px 0 0 -7px #767676,167px 0 0 -7px #767676,168px 0 0 -7px #767676,169px 0 0 -7px #767676,170px 0 0 -7px #767676,171px 0 0 -7px #767676,172px 0 0 -7px #767676,173px 0 0 -7px #767676,174px 0 0 -7px #767676,175px 0 0 -7px #767676,176px 0 0 -7px #767676,177px 0 0 -7px #767676,178px 0 0 -7px #767676,179px 0 0 -7px #767676,180px 0 0 -7px #767676,181px 0 0 -7px #767676,182px 0 0 -7px #767676,183px 0 0 -7px #767676,184px 0 0 -7px #767676,185px 0 0 -7px #767676,186px 0 0 -7px #767676,187px 0 0 -7px #767676,188px 0 0 -7px #767676,189px 0 0 -7px #767676,190px 0 0 -7px #767676,191px 0 0 -7px #767676,192px 0 0 -7px #767676,193px 0 0 -7px #767676,194px 0 0 -7px #767676,195px 0 0 -7px #767676,196px 0 0 -7px #767676,197px 0 0 -7px #767676,198px 0 0 -7px #767676,199px 0 0 -7px #767676,200px 0 0 -7px #767676,201px 0 0 -7px #767676,202px 0 0 -7px #767676,203px 0 0 -7px #767676,204px 0 0 -7px #767676,205px 0 0 -7px #767676,206px 0 0 -7px #767676,207px 0 0 -7px #767676,208px 0 0 -7px #767676,209px 0 0 -7px #767676,210px 0 0 -7px #767676,211px 0 0 -7px #767676,212px 0 0 -7px #767676,213px 0 0 -7px #767676,214px 0 0 -7px #767676,215px 0 0 -7px #767676,216px 0 0 -7px #767676,217px 0 0 -7px #767676,218px 0 0 -7px #767676,219px 0 0 -7px #767676,220px 0 0 -7px #767676,221px 0 0 -7px #767676,222px 0 0 -7px #767676,223px 0 0 -7px #767676,224px 0 0 -7px #767676,225px 0 0 -7px #767676,226px 0 0 -7px #767676,227px 0 0 -7px #767676,228px 0 0 -7px #767676,229px 0 0 -7px #767676,230px 0 0 -7px #767676,231px 0 0 -7px #767676,232px 0 0 -7px #767676,233px 0 0 -7px #767676,234px 0 0 -7px #767676,235px 0 0 -7px #767676,236px 0 0 -7px #767676,237px 0 0 -7px #767676,238px 0 0 -7px #767676,239px 0 0 -7px #767676,240px 0 0 -7px #767676,241px 0 0 -7px #767676,242px 0 0 -7px #767676,243px 0 0 -7px #767676,244px 0 0 -7px #767676,245px 0 0 -7px #767676,246px 0 0 -7px #767676,247px 0 0 -7px #767676,248px 0 0 -7px #767676,249px 0 0 -7px #767676,250px 0 0 -7px #767676,251px 0 0 -7px #767676,252px 0 0 -7px #767676,253px 0 0 -7px #767676,254px 0 0 -7px #767676,255px 0 0 -7px #767676,256px 0 0 -7px #767676,257px 0 0 -7px #767676,258px 0 0 -7px #767676,259px 0 0 -7px #767676,260px 0 0 -7px #767676,261px 0 0 -7px #767676,262px 0 0 -7px #767676,263px 0 0 -7px #767676,264px 0 0 -7px #767676,265px 0 0 -7px #767676,266px 0 0 -7px #767676,267px 0 0 -7px #767676,268px 0 0 -7px #767676,269px 0 0 -7px #767676,270px 0 0 -7px #767676,271px 0 0 -7px #767676,272px 0 0 -7px #767676,273px 0 0 -7px #767676,274px 0 0 -7px #767676,275px 0 0 -7px #767676,276px 0 0 -7px #767676,277px 0 0 -7px #767676,278px 0 0 -7px #767676,279px 0 0 -7px #767676,280px 0 0 -7px #767676,281px 0 0 -7px #767676,282px 0 0 -7px #767676,283px 0 0 -7px #767676,284px 0 0 -7px #767676,285px 0 0 -7px #767676,286px 0 0 -7px #767676,287px 0 0 -7px #767676,288px 0 0 -7px #767676,289px 0 0 -7px #767676,290px 0 0 -7px #767676,291px 0 0 -7px #767676,292px 0 0 -7px #767676,293px 0 0 -7px #767676,294px 0 0 -7px #767676,295px 0 0 -7px #767676,296px 0 0 -7px #767676,297px 0 0 -7px #767676,298px 0 0 -7px #767676,299px 0 0 -7px #767676,300px 0 0 -7px #767676,301px 0 0 -7px #767676,302px 0 0 -7px #767676,303px 0 0 -7px #767676,304px 0 0 -7px #767676,305px 0 0 -7px #767676,306px 0 0 -7px #767676,307px 0 0 -7px #767676,308px 0 0 -7px #767676,309px 0 0 -7px #767676,310px 0 0 -7px #767676,311px 0 0 -7px #767676,312px 0 0 -7px #767676,313px 0 0 -7px #767676,314px 0 0 -7px #767676,315px 0 0 -7px #767676,316px 0 0 -7px #767676,317px 0 0 -7px #767676,318px 0 0 -7px #767676,319px 0 0 -7px #767676,320px 0 0 -7px #767676,321px 0 0 -7px #767676,322px 0 0 -7px #767676,323px 0 0 -7px #767676,324px 0 0 -7px #767676,325px 0 0 -7px #767676,326px 0 0 -7px #767676,327px 0 0 -7px #767676,328px 0 0 -7px #767676,329px 0 0 -7px #767676,330px 0 0 -7px #767676,331px 0 0 -7px #767676,332px 0 0 -7px #767676,333px 0 0 -7px #767676,334px 0 0 -7px #767676,335px 0 0 -7px #767676,336px 0 0 -7px #767676,337px 0 0 -7px #767676,338px 0 0 -7px #767676,339px 0 0 -7px #767676,340px 0 0 -7px #767676,341px 0 0 -7px #767676,342px 0 0 -7px #767676,343px 0 0 -7px #767676,344px 0 0 -7px #767676,345px 0 0 -7px #767676,346px 0 0 -7px #767676,347px 0 0 -7px #767676,348px 0 0 -7px #767676,349px 0 0 -7px #767676,350px 0 0 -7px #767676,351px 0 0 -7px #767676,352px 0 0 -7px #767676,353px 0 0 -7px #767676,354px 0 0 -7px #767676,355px 0 0 -7px #767676,356px 0 0 -7px #767676,357px 0 0 -7px #767676,358px 0 0 -7px #767676,359px 0 0 -7px #767676,360px 0 0 -7px #767676,361px 0 0 -7px #767676,362px 0 0 -7px #767676,363px 0 0 -7px #767676,364px 0 0 -7px #767676,365px 0 0 -7px #767676,366px 0 0 -7px #767676,367px 0 0 -7px #767676,368px 0 0 -7px #767676,369px 0 0 -7px #767676,370px 0 0 -7px #767676,371px 0 0 -7px #767676,372px 0 0 -7px #767676,373px 0 0 -7px #767676,374px 0 0 -7px #767676,375px 0 0 -7px #767676,376px 0 0 -7px #767676,377px 0 0 -7px #767676,378px 0 0 -7px #767676,379px 0 0 -7px #767676,380px 0 0 -7px #767676,381px 0 0 -7px #767676,382px 0 0 -7px #767676,383px 0 0 -7px #767676,384px 0 0 -7px #767676,385px 0 0 -7px #767676,386px 0 0 -7px #767676,387px 0 0 -7px #767676,388px 0 0 -7px #767676,389px 0 0 -7px #767676,390px 0 0 -7px #767676,391px 0 0 -7px #767676,392px 0 0 -7px #767676,393px 0 0 -7px #767676,394px 0 0 -7px #767676,395px 0 0 -7px #767676,396px 0 0 -7px #767676,397px 0 0 -7px #767676,398px 0 0 -7px #767676,399px 0 0 -7px #767676,400px 0 0 -7px #767676,401px 0 0 -7px #767676,402px 0 0 -7px #767676,403px 0 0 -7px #767676,404px 0 0 -7px #767676,405px 0 0 -7px #767676,406px 0 0 -7px #767676,407px 0 0 -7px #767676,408px 0 0 -7px #767676,409px 0 0 -7px #767676,410px 0 0 -7px #767676,411px 0 0 -7px #767676,412px 0 0 -7px #767676,413px 0 0 -7px #767676,414px 0 0 -7px #767676,415px 0 0 -7px #767676,416px 0 0 -7px #767676,417px 0 0 -7px #767676,418px 0 0 -7px #767676,419px 0 0 -7px #767676,420px 0 0 -7px #767676,421px 0 0 -7px #767676,422px 0 0 -7px #767676,423px 0 0 -7px #767676,424px 0 0 -7px #767676,425px 0 0 -7px #767676,426px 0 0 -7px #767676,427px 0 0 -7px #767676,428px 0 0 -7px #767676,429px 0 0 -7px #767676,430px 0 0 -7px #767676,431px 0 0 -7px #767676,432px 0 0 -7px #767676,433px 0 0 -7px #767676,434px 0 0 -7px #767676,435px 0 0 -7px #767676,436px 0 0 -7px #767676,437px 0 0 -7px #767676,438px 0 0 -7px #767676,439px 0 0 -7px #767676,440px 0 0 -7px #767676,441px 0 0 -7px #767676,442px 0 0 -7px #767676,443px 0 0 -7px #767676,444px 0 0 -7px #767676,445px 0 0 -7px #767676,446px 0 0 -7px #767676,447px 0 0 -7px #767676,448px 0 0 -7px #767676,449px 0 0 -7px #767676,450px 0 0 -7px #767676,451px 0 0 -7px #767676,452px 0 0 -7px #767676,453px 0 0 -7px #767676,454px 0 0 -7px #767676,455px 0 0 -7px #767676,456px 0 0 -7px #767676,457px 0 0 -7px #767676,458px 0 0 -7px #767676,459px 0 0 -7px #767676,460px 0 0 -7px #767676,461px 0 0 -7px #767676,462px 0 0 -7px #767676,463px 0 0 -7px #767676,464px 0 0 -7px #767676,465px 0 0 -7px #767676,466px 0 0 -7px #767676,467px 0 0 -7px #767676,468px 0 0 -7px #767676,469px 0 0 -7px #767676,470px 0 0 -7px #767676,471px 0 0 -7px #767676,472px 0 0 -7px #767676,473px 0 0 -7px #767676,474px 0 0 -7px #767676,475px 0 0 -7px #767676,476px 0 0 -7px #767676,477px 0 0 -7px #767676,478px 0 0 -7px #767676,479px 0 0 -7px #767676,480px 0 0 -7px #767676,481px 0 0 -7px #767676,482px 0 0 -7px #767676,483px 0 0 -7px #767676,484px 0 0 -7px #767676,485px 0 0 -7px #767676,486px 0 0 -7px #767676,487px 0 0 -7px #767676,488px 0 0 -7px #767676,489px 0 0 -7px #767676,490px 0 0 -7px #767676,491px 0 0 -7px #767676,492px 0 0 -7px #767676,493px 0 0 -7px #767676,494px 0 0 -7px #767676,495px 0 0 -7px #767676,496px 0 0 -7px #767676,497px 0 0 -7px #767676,498px 0 0 -7px #767676,499px 0 0 -7px #767676,500px 0 0 -7px #767676,501px 0 0 -7px #767676,502px 0 0 -7px #767676,503px 0 0 -7px #767676,504px 0 0 -7px #767676,505px 0 0 -7px #767676,506px 0 0 -7px #767676,507px 0 0 -7px #767676,508px 0 0 -7px #767676,509px 0 0 -7px #767676,510px 0 0 -7px #767676,511px 0 0 -7px #767676,512px 0 0 -7px #767676,513px 0 0 -7px #767676,514px 0 0 -7px #767676,515px 0 0 -7px #767676,516px 0 0 -7px #767676,517px 0 0 -7px #767676,518px 0 0 -7px #767676,519px 0 0 -7px #767676,520px 0 0 -7px #767676,521px 0 0 -7px #767676,522px 0 0 -7px #767676,523px 0 0 -7px #767676,524px 0 0 -7px #767676,525px 0 0 -7px #767676,526px 0 0 -7px #767676,527px 0 0 -7px #767676,528px 0 0 -7px #767676,529px 0 0 -7px #767676,530px 0 0 -7px #767676,531px 0 0 -7px #767676,532px 0 0 -7px #767676,533px 0 0 -7px #767676,534px 0 0 -7px #767676,535px 0 0 -7px #767676,536px 0 0 -7px #767676,537px 0 0 -7px #767676,538px 0 0 -7px #767676,539px 0 0 -7px #767676,540px 0 0 -7px #767676,541px 0 0 -7px #767676,542px 0 0 -7px #767676,543px 0 0 -7px #767676,544px 0 0 -7px #767676,545px 0 0 -7px #767676,546px 0 0 -7px #767676,547px 0 0 -7px #767676,548px 0 0 -7px #767676,549px 0 0 -7px #767676,550px 0 0 -7px #767676,551px 0 0 -7px #767676,552px 0 0 -7px #767676,553px 0 0 -7px #767676,554px 0 0 -7px #767676,555px 0 0 -7px #767676,556px 0 0 -7px #767676,557px 0 0 -7px #767676,558px 0 0 -7px #767676,559px 0 0 -7px #767676,560px 0 0 -7px #767676,561px 0 0 -7px #767676,562px 0 0 -7px #767676,563px 0 0 -7px #767676,564px 0 0 -7px #767676,565px 0 0 -7px #767676,566px 0 0 -7px #767676,567px 0 0 -7px #767676,568px 0 0 -7px #767676,569px 0 0 -7px #767676,570px 0 0 -7px #767676,571px 0 0 -7px #767676,572px 0 0 -7px #767676,573px 0 0 -7px #767676,574px 0 0 -7px #767676,575px 0 0 -7px #767676,576px 0 0 -7px #767676,577px 0 0 -7px #767676,578px 0 0 -7px #767676,579px 0 0 -7px #767676,580px 0 0 -7px #767676,581px 0 0 -7px #767676,582px 0 0 -7px #767676,583px 0 0 -7px #767676,584px 0 0 -7px #767676,585px 0 0 -7px #767676,586px 0 0 -7px #767676,587px 0 0 -7px #767676,588px 0 0 -7px #767676,589px 0 0 -7px #767676,590px 0 0 -7px #767676,591px 0 0 -7px #767676,592px 0 0 -7px #767676,593px 0 0 -7px #767676,594px 0 0 -7px #767676,595px 0 0 -7px #767676,596px 0 0 -7px #767676,597px 0 0 -7px #767676,598px 0 0 -7px #767676,599px 0 0 -7px #767676,600px 0 0 -7px #767676,601px 0 0 -7px #767676,602px 0 0 -7px #767676,603px 0 0 -7px #767676,604px 0 0 -7px #767676,605px 0 0 -7px #767676,606px 0 0 -7px #767676,607px 0 0 -7px #767676,608px 0 0 -7px #767676,609px 0 0 -7px #767676,610px 0 0 -7px #767676,611px 0 0 -7px #767676,612px 0 0 -7px #767676,613px 0 0 -7px #767676,614px 0 0 -7px #767676,615px 0 0 -7px #767676,616px 0 0 -7px #767676,617px 0 0 -7px #767676,618px 0 0 -7px #767676,619px 0 0 -7px #767676,620px 0 0 -7px #767676,621px 0 0 -7px #767676,622px 0 0 -7px #767676,623px 0 0 -7px #767676,624px 0 0 -7px #767676,625px 0 0 -7px #767676,626px 0 0 -7px #767676,627px 0 0 -7px #767676,628px 0 0 -7px #767676,629px 0 0 -7px #767676,630px 0 0 -7px #767676,631px 0 0 -7px #767676,632px 0 0 -7px #767676,633px 0 0 -7px #767676,634px 0 0 -7px #767676,635px 0 0 -7px #767676,636px 0 0 -7px #767676,637px 0 0 -7px #767676,638px 0 0 -7px #767676,639px 0 0 -7px #767676,640px 0 0 -7px #767676,641px 0 0 -7px #767676,642px 0 0 -7px #767676,643px 0 0 -7px #767676,644px 0 0 -7px #767676,645px 0 0 -7px #767676,646px 0 0 -7px #767676,647px 0 0 -7px #767676,648px 0 0 -7px #767676,649px 0 0 -7px #767676,650px 0 0 -7px #767676,651px 0 0 -7px #767676,652px 0 0 -7px #767676,653px 0 0 -7px #767676,654px 0 0 -7px #767676,655px 0 0 -7px #767676,656px 0 0 -7px #767676,657px 0 0 -7px #767676,658px 0 0 -7px #767676,659px 0 0 -7px #767676,660px 0 0 -7px #767676,661px 0 0 -7px #767676,662px 0 0 -7px #767676,663px 0 0 -7px #767676,664px 0 0 -7px #767676,665px 0 0 -7px #767676,666px 0 0 -7px #767676,667px 0 0 -7px #767676,668px 0 0 -7px #767676,669px 0 0 -7px #767676,670px 0 0 -7px #767676,671px 0 0 -7px #767676,672px 0 0 -7px #767676,673px 0 0 -7px #767676,674px 0 0 -7px #767676,675px 0 0 -7px #767676,676px 0 0 -7px #767676,677px 0 0 -7px #767676,678px 0 0 -7px #767676,679px 0 0 -7px #767676,680px 0 0 -7px #767676,681px 0 0 -7px #767676,682px 0 0 -7px #767676,683px 0 0 -7px #767676,684px 0 0 -7px #767676,685px 0 0 -7px #767676,686px 0 0 -7px #767676,687px 0 0 -7px #767676,688px 0 0 -7px #767676,689px 0 0 -7px #767676,690px 0 0 -7px #767676,691px 0 0 -7px #767676,692px 0 0 -7px #767676,693px 0 0 -7px #767676,694px 0 0 -7px #767676,695px 0 0 -7px #767676,696px 0 0 -7px #767676,697px 0 0 -7px #767676,698px 0 0 -7px #767676,699px 0 0 -7px #767676,700px 0 0 -7px #767676,701px 0 0 -7px #767676,702px 0 0 -7px #767676,703px 0 0 -7px #767676,704px 0 0 -7px #767676,705px 0 0 -7px #767676,706px 0 0 -7px #767676,707px 0 0 -7px #767676,708px 0 0 -7px #767676,709px 0 0 -7px #767676,710px 0 0 -7px #767676,711px 0 0 -7px #767676,712px 0 0 -7px #767676,713px 0 0 -7px #767676,714px 0 0 -7px #767676,715px 0 0 -7px #767676,716px 0 0 -7px #767676,717px 0 0 -7px #767676,718px 0 0 -7px #767676,719px 0 0 -7px #767676,720px 0 0 -7px #767676,721px 0 0 -7px #767676,722px 0 0 -7px #767676,723px 0 0 -7px #767676,724px 0 0 -7px #767676,725px 0 0 -7px #767676,726px 0 0 -7px #767676,727px 0 0 -7px #767676,728px 0 0 -7px #767676,729px 0 0 -7px #767676,730px 0 0 -7px #767676,731px 0 0 -7px #767676,732px 0 0 -7px #767676,733px 0 0 -7px #767676,734px 0 0 -7px #767676,735px 0 0 -7px #767676,736px 0 0 -7px #767676,737px 0 0 -7px #767676,738px 0 0 -7px #767676,739px 0 0 -7px #767676,740px 0 0 -7px #767676,741px 0 0 -7px #767676,742px 0 0 -7px #767676,743px 0 0 -7px #767676,744px 0 0 -7px #767676,745px 0 0 -7px #767676,746px 0 0 -7px #767676,747px 0 0 -7px #767676,748px 0 0 -7px #767676,749px 0 0 -7px #767676,750px 0 0 -7px #767676,751px 0 0 -7px #767676,752px 0 0 -7px #767676,753px 0 0 -7px #767676,754px 0 0 -7px #767676,755px 0 0 -7px #767676,756px 0 0 -7px #767676,757px 0 0 -7px #767676,758px 0 0 -7px #767676,759px 0 0 -7px #767676,760px 0 0 -7px #767676,761px 0 0 -7px #767676,762px 0 0 -7px #767676,763px 0 0 -7px #767676,764px 0 0 -7px #767676,765px 0 0 -7px #767676,766px 0 0 -7px #767676,767px 0 0 -7px #767676,768px 0 0 -7px #767676,769px 0 0 -7px #767676,770px 0 0 -7px #767676,771px 0 0 -7px #767676,772px 0 0 -7px #767676,773px 0 0 -7px #767676,774px 0 0 -7px #767676,775px 0 0 -7px #767676,776px 0 0 -7px #767676,777px 0 0 -7px #767676,778px 0 0 -7px #767676,779px 0 0 -7px #767676,780px 0 0 -7px #767676,781px 0 0 -7px #767676,782px 0 0 -7px #767676,783px 0 0 -7px #767676,784px 0 0 -7px #767676,785px 0 0 -7px #767676,786px 0 0 -7px #767676,787px 0 0 -7px #767676,788px 0 0 -7px #767676,789px 0 0 -7px #767676,790px 0 0 -7px #767676,791px 0 0 -7px #767676,792px 0 0 -7px #767676,793px 0 0 -7px #767676,794px 0 0 -7px #767676,795px 0 0 -7px #767676,796px 0 0 -7px #767676,797px 0 0 -7px #767676,798px 0 0 -7px #767676,799px 0 0 -7px #767676,800px 0 0 -7px #767676,801px 0 0 -7px #767676,802px 0 0 -7px #767676,803px 0 0 -7px #767676,804px 0 0 -7px #767676,805px 0 0 -7px #767676,806px 0 0 -7px #767676,807px 0 0 -7px #767676,808px 0 0 -7px #767676,809px 0 0 -7px #767676,810px 0 0 -7px #767676,811px 0 0 -7px #767676,812px 0 0 -7px #767676,813px 0 0 -7px #767676,814px 0 0 -7px #767676,815px 0 0 -7px #767676,816px 0 0 -7px #767676,817px 0 0 -7px #767676,818px 0 0 -7px #767676,819px 0 0 -7px #767676,820px 0 0 -7px #767676,821px 0 0 -7px #767676,822px 0 0 -7px #767676,823px 0 0 -7px #767676,824px 0 0 -7px #767676,825px 0 0 -7px #767676,826px 0 0 -7px #767676,827px 0 0 -7px #767676,828px 0 0 -7px #767676,829px 0 0 -7px #767676,830px 0 0 -7px #767676,831px 0 0 -7px #767676,832px 0 0 -7px #767676,833px 0 0 -7px #767676,834px 0 0 -7px #767676,835px 0 0 -7px #767676,836px 0 0 -7px #767676,837px 0 0 -7px #767676,838px 0 0 -7px #767676,839px 0 0 -7px #767676,840px 0 0 -7px #767676,841px 0 0 -7px #767676,842px 0 0 -7px #767676,843px 0 0 -7px #767676,844px 0 0 -7px #767676,845px 0 0 -7px #767676,846px 0 0 -7px #767676,847px 0 0 -7px #767676,848px 0 0 -7px #767676,849px 0 0 -7px #767676,850px 0 0 -7px #767676,851px 0 0 -7px #767676,852px 0 0 -7px #767676,853px 0 0 -7px #767676,854px 0 0 -7px #767676,855px 0 0 -7px #767676,856px 0 0 -7px #767676,857px 0 0 -7px #767676,858px 0 0 -7px #767676,859px 0 0 -7px #767676,860px 0 0 -7px #767676,861px 0 0 -7px #767676,862px 0 0 -7px #767676,863px 0 0 -7px #767676,864px 0 0 -7px #767676,865px 0 0 -7px #767676,866px 0 0 -7px #767676,867px 0 0 -7px #767676,868px 0 0 -7px #767676,869px 0 0 -7px #767676,870px 0 0 -7px #767676,871px 0 0 -7px #767676,872px 0 0 -7px #767676,873px 0 0 -7px #767676,874px 0 0 -7px #767676,875px 0 0 -7px #767676,876px 0 0 -7px #767676,877px 0 0 -7px #767676,878px 0 0 -7px #767676,879px 0 0 -7px #767676,880px 0 0 -7px #767676,881px 0 0 -7px #767676,882px 0 0 -7px #767676,883px 0 0 -7px #767676,884px 0 0 -7px #767676,885px 0 0 -7px #767676,886px 0 0 -7px #767676,887px 0 0 -7px #767676,888px 0 0 -7px #767676,889px 0 0 -7px #767676,890px 0 0 -7px #767676,891px 0 0 -7px #767676,892px 0 0 -7px #767676,893px 0 0 -7px #767676,894px 0 0 -7px #767676,895px 0 0 -7px #767676,896px 0 0 -7px #767676,897px 0 0 -7px #767676,898px 0 0 -7px #767676,899px 0 0 -7px #767676,900px 0 0 -7px #767676,901px 0 0 -7px #767676,902px 0 0 -7px #767676,903px 0 0 -7px #767676,904px 0 0 -7px #767676,905px 0 0 -7px #767676,906px 0 0 -7px #767676,907px 0 0 -7px #767676,908px 0 0 -7px #767676,909px 0 0 -7px #767676,910px 0 0 -7px #767676,911px 0 0 -7px #767676,912px 0 0 -7px #767676,913px 0 0 -7px #767676,914px 0 0 -7px #767676,915px 0 0 -7px #767676,916px 0 0 -7px #767676,917px 0 0 -7px #767676,918px 0 0 -7px #767676,919px 0 0 -7px #767676,920px 0 0 -7px #767676,921px 0 0 -7px #767676,922px 0 0 -7px #767676,923px 0 0 -7px #767676,924px 0 0 -7px #767676,925px 0 0 -7px #767676,926px 0 0 -7px #767676,927px 0 0 -7px #767676,928px 0 0 -7px #767676,929px 0 0 -7px #767676,930px 0 0 -7px #767676,931px 0 0 -7px #767676,932px 0 0 -7px #767676,933px 0 0 -7px #767676,934px 0 0 -7px #767676,935px 0 0 -7px #767676,936px 0 0 -7px #767676,937px 0 0 -7px #767676,938px 0 0 -7px #767676,939px 0 0 -7px #767676,940px 0 0 -7px #767676,941px 0 0 -7px #767676,942px 0 0 -7px #767676,943px 0 0 -7px #767676,944px 0 0 -7px #767676,945px 0 0 -7px #767676,946px 0 0 -7px #767676,947px 0 0 -7px #767676,948px 0 0 -7px #767676,949px 0 0 -7px #767676,950px 0 0 -7px #767676,951px 0 0 -7px #767676,952px 0 0 -7px #767676,953px 0 0 -7px #767676,954px 0 0 -7px #767676,955px 0 0 -7px #767676,956px 0 0 -7px #767676,957px 0 0 -7px #767676,958px 0 0 -7px #767676,959px 0 0 -7px #767676,960px 0 0 -7px #767676,961px 0 0 -7px #767676,962px 0 0 -7px #767676,963px 0 0 -7px #767676,964px 0 0 -7px #767676,965px 0 0 -7px #767676,966px 0 0 -7px #767676,967px 0 0 -7px #767676,968px 0 0 -7px #767676,969px 0 0 -7px #767676,970px 0 0 -7px #767676,971px 0 0 -7px #767676,972px 0 0 -7px #767676,973px 0 0 -7px #767676,974px 0 0 -7px #767676,975px 0 0 -7px #767676,976px 0 0 -7px #767676,977px 0 0 -7px #767676,978px 0 0 -7px #767676,979px 0 0 -7px #767676,980px 0 0 -7px #767676,981px 0 0 -7px #767676,982px 0 0 -7px #767676,983px 0 0 -7px #767676,984px 0 0 -7px #767676,985px 0 0 -7px #767676,986px 0 0 -7px #767676,987px 0 0 -7px #767676,988px 0 0 -7px #767676,989px 0 0 -7px #767676,990px 0 0 -7px #767676,991px 0 0 -7px #767676,992px 0 0 -7px #767676,993px 0 0 -7px #767676,994px 0 0 -7px #767676,995px 0 0 -7px #767676,996px 0 0 -7px #767676,997px 0 0 -7px #767676,998px 0 0 -7px #767676,999px 0 0 -7px #767676,1000px 0 0 -7px #767676,1001px 0 0 -7px #767676,1002px 0 0 -7px #767676,1003px 0 0 -7px #767676,1004px 0 0 -7px #767676,1005px 0 0 -7px #767676,1006px 0 0 -7px #767676,1007px 0 0 -7px #767676,1008px 0 0 -7px #767676,1009px 0 0 -7px #767676,1010px 0 0 -7px #767676,1011px 0 0 -7px #767676,1012px 0 0 -7px #767676,1013px 0 0 -7px #767676,1014px 0 0 -7px #767676,1015px 0 0 -7px #767676,1016px 0 0 -7px #767676,1017px 0 0 -7px #767676,1018px 0 0 -7px #767676,1019px 0 0 -7px #767676,1020px 0 0 -7px #767676,1021px 0 0 -7px #767676,1022px 0 0 -7px #767676,1023px 0 0 -7px #767676,1024px 0 0 -7px #767676,1025px 0 0 -7px #767676,1026px 0 0 -7px #767676,1027px 0 0 -7px #767676,1028px 0 0 -7px #767676,1029px 0 0 -7px #767676,1030px 0 0 -7px #767676,1031px 0 0 -7px #767676,1032px 0 0 -7px #767676,1033px 0 0 -7px #767676,1034px 0 0 -7px #767676,1035px 0 0 -7px #767676,1036px 0 0 -7px #767676,1037px 0 0 -7px #767676,1038px 0 0 -7px #767676,1039px 0 0 -7px #767676,1040px 0 0 -7px #767676,1041px 0 0 -7px #767676,1042px 0 0 -7px #767676,1043px 0 0 -7px #767676,1044px 0 0 -7px #767676,1045px 0 0 -7px #767676,1046px 0 0 -7px #767676,1047px 0 0 -7px #767676,1048px 0 0 -7px #767676,1049px 0 0 -7px #767676,1050px 0 0 -7px #767676,1051px 0 0 -7px #767676,1052px 0 0 -7px #767676,1053px 0 0 -7px #767676,1054px 0 0 -7px #767676,1055px 0 0 -7px #767676,1056px 0 0 -7px #767676,1057px 0 0 -7px #767676,1058px 0 0 -7px #767676,1059px 0 0 -7px #767676,1060px 0 0 -7px #767676,1061px 0 0 -7px #767676,1062px 0 0 -7px #767676,1063px 0 0 -7px #767676,1064px 0 0 -7px #767676,1065px 0 0 -7px #767676,1066px 0 0 -7px #767676,1067px 0 0 -7px #767676,1068px 0 0 -7px #767676,1069px 0 0 -7px #767676,1070px 0 0 -7px #767676,1071px 0 0 -7px #767676,1072px 0 0 -7px #767676,1073px 0 0 -7px #767676,1074px 0 0 -7px #767676,1075px 0 0 -7px #767676,1076px 0 0 -7px #767676,1077px 0 0 -7px #767676,1078px 0 0 -7px #767676,1079px 0 0 -7px #767676,1080px 0 0 -7px #767676,1081px 0 0 -7px #767676,1082px 0 0 -7px #767676,1083px 0 0 -7px #767676,1084px 0 0 -7px #767676,1085px 0 0 -7px #767676,1086px 0 0 -7px #767676,1087px 0 0 -7px #767676,1088px 0 0 -7px #767676,1089px 0 0 -7px #767676,1090px 0 0 -7px #767676,1091px 0 0 -7px #767676,1092px 0 0 -7px #767676,1093px 0 0 -7px #767676,1094px 0 0 -7px #767676,1095px 0 0 -7px #767676,1096px 0 0 -7px #767676,1097px 0 0 -7px #767676,1098px 0 0 -7px #767676,1099px 0 0 -7px #767676,1100px 0 0 -7px #767676,1101px 0 0 -7px #767676,1102px 0 0 -7px #767676,1103px 0 0 -7px #767676,1104px 0 0 -7px #767676,1105px 0 0 -7px #767676,1106px 0 0 -7px #767676,1107px 0 0 -7px #767676,1108px 0 0 -7px #767676,1109px 0 0 -7px #767676,1110px 0 0 -7px #767676,1111px 0 0 -7px #767676,1112px 0 0 -7px #767676,1113px 0 0 -7px #767676,1114px 0 0 -7px #767676,1115px 0 0 -7px #767676,1116px 0 0 -7px #767676,1117px 0 0 -7px #767676,1118px 0 0 -7px #767676,1119px 0 0 -7px #767676,1120px 0 0 -7px #767676,1121px 0 0 -7px #767676,1122px 0 0 -7px #767676,1123px 0 0 -7px #767676,1124px 0 0 -7px #767676,1125px 0 0 -7px #767676,1126px 0 0 -7px #767676,1127px 0 0 -7px #767676,1128px 0 0 -7px #767676,1129px 0 0 -7px #767676,1130px 0 0 -7px #767676,1131px 0 0 -7px #767676,1132px 0 0 -7px #767676,1133px 0 0 -7px #767676,1134px 0 0 -7px #767676,1135px 0 0 -7px #767676,1136px 0 0 -7px #767676,1137px 0 0 -7px #767676,1138px 0 0 -7px #767676,1139px 0 0 -7px #767676,1140px 0 0 -7px #767676,1141px 0 0 -7px #767676,1142px 0 0 -7px #767676,1143px 0 0 -7px #767676,1144px 0 0 -7px #767676,1145px 0 0 -7px #767676,1146px 0 0 -7px #767676,1147px 0 0 -7px #767676,1148px 0 0 -7px #767676,1149px 0 0 -7px #767676,1150px 0 0 -7px #767676,1151px 0 0 -7px #767676,1152px 0 0 -7px #767676,1153px 0 0 -7px #767676,1154px 0 0 -7px #767676,1155px 0 0 -7px #767676,1156px 0 0 -7px #767676,1157px 0 0 -7px #767676,1158px 0 0 -7px #767676,1159px 0 0 -7px #767676,1160px 0 0 -7px #767676,1161px 0 0 -7px #767676,1162px 0 0 -7px #767676,1163px 0 0 -7px #767676,1164px 0 0 -7px #767676,1165px 0 0 -7px #767676,1166px 0 0 -7px #767676,1167px 0 0 -7px #767676,1168px 0 0 -7px #767676,1169px 0 0 -7px #767676,1170px 0 0 -7px #767676,1171px 0 0 -7px #767676,1172px 0 0 -7px #767676,1173px 0 0 -7px #767676,1174px 0 0 -7px #767676,1175px 0 0 -7px #767676,1176px 0 0 -7px #767676,1177px 0 0 -7px #767676,1178px 0 0 -7px #767676,1179px 0 0 -7px #767676,1180px 0 0 -7px #767676,1181px 0 0 -7px #767676,1182px 0 0 -7px #767676,1183px 0 0 -7px #767676,1184px 0 0 -7px #767676,1185px 0 0 -7px #767676,1186px 0 0 -7px #767676,1187px 0 0 -7px #767676,1188px 0 0 -7px #767676,1189px 0 0 -7px #767676,1190px 0 0 -7px #767676,1191px 0 0 -7px #767676,1192px 0 0 -7px #767676,1193px 0 0 -7px #767676,1194px 0 0 -7px #767676,1195px 0 0 -7px #767676,1196px 0 0 -7px #767676,1197px 0 0 -7px #767676,1198px 0 0 -7px #767676,1199px 0 0 -7px #767676,1200px 0 0 -7px #767676,1201px 0 0 -7px #767676,1202px 0 0 -7px #767676,1203px 0 0 -7px #767676,1204px 0 0 -7px #767676,1205px 0 0 -7px #767676,1206px 0 0 -7px #767676,1207px 0 0 -7px #767676,1208px 0 0 -7px #767676,1209px 0 0 -7px #767676,1210px 0 0 -7px #767676,1211px 0 0 -7px #767676,1212px 0 0 -7px #767676,1213px 0 0 -7px #767676,1214px 0 0 -7px #767676,1215px 0 0 -7px #767676,1216px 0 0 -7px #767676,1217px 0 0 -7px #767676,1218px 0 0 -7px #767676,1219px 0 0 -7px #767676,1220px 0 0 -7px #767676,1221px 0 0 -7px #767676,1222px 0 0 -7px #767676,1223px 0 0 -7px #767676,1224px 0 0 -7px #767676,1225px 0 0 -7px #767676,1226px 0 0 -7px #767676,1227px 0 0 -7px #767676,1228px 0 0 -7px #767676,1229px 0 0 -7px #767676,1230px 0 0 -7px #767676,1231px 0 0 -7px #767676,1232px 0 0 -7px #767676,1233px 0 0 -7px #767676,1234px 0 0 -7px #767676,1235px 0 0 -7px #767676,1236px 0 0 -7px #767676,1237px 0 0 -7px #767676,1238px 0 0 -7px #767676,1239px 0 0 -7px #767676,1240px 0 0 -7px #767676,1241px 0 0 -7px #767676,1242px 0 0 -7px #767676,1243px 0 0 -7px #767676,1244px 0 0 -7px #767676,1245px 0 0 -7px #767676,1246px 0 0 -7px #767676,1247px 0 0 -7px #767676,1248px 0 0 -7px #767676,1249px 0 0 -7px #767676,1250px 0 0 -7px #767676,1251px 0 0 -7px #767676,1252px 0 0 -7px #767676,1253px 0 0 -7px #767676,1254px 0 0 -7px #767676,1255px 0 0 -7px #767676,1256px 0 0 -7px #767676,1257px 0 0 -7px #767676,1258px 0 0 -7px #767676,1259px 0 0 -7px #767676,1260px 0 0 -7px #767676,1261px 0 0 -7px #767676,1262px 0 0 -7px #767676,1263px 0 0 -7px #767676,1264px 0 0 -7px #767676,1265px 0 0 -7px #767676,1266px 0 0 -7px #767676,1267px 0 0 -7px #767676,1268px 0 0 -7px #767676,1269px 0 0 -7px #767676,1270px 0 0 -7px #767676,1271px 0 0 -7px #767676,1272px 0 0 -7px #767676,1273px 0 0 -7px #767676,1274px 0 0 -7px #767676,1275px 0 0 -7px #767676,1276px 0 0 -7px #767676,1277px 0 0 -7px #767676,1278px 0 0 -7px #767676,1279px 0 0 -7px #767676,1280px 0 0 -7px #767676,1281px 0 0 -7px #767676,1282px 0 0 -7px #767676,1283px 0 0 -7px #767676,1284px 0 0 -7px #767676,1285px 0 0 -7px #767676,1286px 0 0 -7px #767676,1287px 0 0 -7px #767676,1288px 0 0 -7px #767676,1289px 0 0 -7px #767676,1290px 0 0 -7px #767676,1291px 0 0 -7px #767676,1292px 0 0 -7px #767676,1293px 0 0 -7px #767676,1294px 0 0 -7px #767676,1295px 0 0 -7px #767676,1296px 0 0 -7px #767676,1297px 0 0 -7px #767676,1298px 0 0 -7px #767676,1299px 0 0 -7px #767676,1300px 0 0 -7px #767676,1301px 0 0 -7px #767676,1302px 0 0 -7px #767676,1303px 0 0 -7px #767676,1304px 0 0 -7px #767676,1305px 0 0 -7px #767676,1306px 0 0 -7px #767676,1307px 0 0 -7px #767676,1308px 0 0 -7px #767676,1309px 0 0 -7px #767676,1310px 0 0 -7px #767676,1311px 0 0 -7px #767676,1312px 0 0 -7px #767676,1313px 0 0 -7px #767676,1314px 0 0 -7px #767676,1315px 0 0 -7px #767676,1316px 0 0 -7px #767676,1317px 0 0 -7px #767676,1318px 0 0 -7px #767676,1319px 0 0 -7px #767676,1320px 0 0 -7px #767676,1321px 0 0 -7px #767676,1322px 0 0 -7px #767676,1323px 0 0 -7px #767676,1324px 0 0 -7px #767676,1325px 0 0 -7px #767676,1326px 0 0 -7px #767676,1327px 0 0 -7px #767676,1328px 0 0 -7px #767676,1329px 0 0 -7px #767676,1330px 0 0 -7px #767676,1331px 0 0 -7px #767676,1332px 0 0 -7px #767676,1333px 0 0 -7px #767676,1334px 0 0 -7px #767676,1335px 0 0 -7px #767676,1336px 0 0 -7px #767676,1337px 0 0 -7px #767676,1338px 0 0 -7px #767676,1339px 0 0 -7px #767676,1340px 0 0 -7px #767676,1341px 0 0 -7px #767676,1342px 0 0 -7px #767676,1343px 0 0 -7px #767676,1344px 0 0 -7px #767676,1345px 0 0 -7px #767676,1346px 0 0 -7px #767676,1347px 0 0 -7px #767676,1348px 0 0 -7px #767676,1349px 0 0 -7px #767676,1350px 0 0 -7px #767676,1351px 0 0 -7px #767676,1352px 0 0 -7px #767676,1353px 0 0 -7px #767676,1354px 0 0 -7px #767676,1355px 0 0 -7px #767676,1356px 0 0 -7px #767676,1357px 0 0 -7px #767676,1358px 0 0 -7px #767676,1359px 0 0 -7px #767676,1360px 0 0 -7px #767676,1361px 0 0 -7px #767676,1362px 0 0 -7px #767676,1363px 0 0 -7px #767676,1364px 0 0 -7px #767676,1365px 0 0 -7px #767676,1366px 0 0 -7px #767676,1367px 0 0 -7px #767676,1368px 0 0 -7px #767676,1369px 0 0 -7px #767676,1370px 0 0 -7px #767676,1371px 0 0 -7px #767676,1372px 0 0 -7px #767676,1373px 0 0 -7px #767676,1374px 0 0 -7px #767676,1375px 0 0 -7px #767676,1376px 0 0 -7px #767676,1377px 0 0 -7px #767676,1378px 0 0 -7px #767676,1379px 0 0 -7px #767676,1380px 0 0 -7px #767676,1381px 0 0 -7px #767676,1382px 0 0 -7px #767676,1383px 0 0 -7px #767676,1384px 0 0 -7px #767676,1385px 0 0 -7px #767676,1386px 0 0 -7px #767676,1387px 0 0 -7px #767676,1388px 0 0 -7px #767676,1389px 0 0 -7px #767676,1390px 0 0 -7px #767676,1391px 0 0 -7px #767676,1392px 0 0 -7px #767676,1393px 0 0 -7px #767676,1394px 0 0 -7px #767676,1395px 0 0 -7px #767676,1396px 0 0 -7px #767676,1397px 0 0 -7px #767676,1398px 0 0 -7px #767676,1399px 0 0 -7px #767676,1400px 0 0 -7px #767676,1401px 0 0 -7px #767676,1402px 0 0 -7px #767676,1403px 0 0 -7px #767676,1404px 0 0 -7px #767676,1405px 0 0 -7px #767676,1406px 0 0 -7px #767676,1407px 0 0 -7px #767676,1408px 0 0 -7px #767676,1409px 0 0 -7px #767676,1410px 0 0 -7px #767676,1411px 0 0 -7px #767676,1412px 0 0 -7px #767676,1413px 0 0 -7px #767676,1414px 0 0 -7px #767676,1415px 0 0 -7px #767676,1416px 0 0 -7px #767676,1417px 0 0 -7px #767676,1418px 0 0 -7px #767676,1419px 0 0 -7px #767676,1420px 0 0 -7px #767676,1421px 0 0 -7px #767676,1422px 0 0 -7px #767676,1423px 0 0 -7px #767676,1424px 0 0 -7px #767676,1425px 0 0 -7px #767676,1426px 0 0 -7px #767676,1427px 0 0 -7px #767676,1428px 0 0 -7px #767676,1429px 0 0 -7px #767676,1430px 0 0 -7px #767676,1431px 0 0 -7px #767676,1432px 0 0 -7px #767676,1433px 0 0 -7px #767676,1434px 0 0 -7px #767676,1435px 0 0 -7px #767676,1436px 0 0 -7px #767676,1437px 0 0 -7px #767676,1438px 0 0 -7px #767676,1439px 0 0 -7px #767676,1440px 0 0 -7px #767676}._3908VmKIi5jE0-hk6X3CPJ::-moz-range-track{height:10px;width:1440px;content:'';pointer-events:none;background:#a0372d}._3908VmKIi5jE0-hk6X3CPJ::-moz-range-thumb{-moz-appearance:none;height:24px;width:16px;margin-top:-7px;border:0;border-radius:0;background:#a0372d;box-shadow:1px 0 0 -7px #767676,1px 0 0 -7px #767676,2px 0 0 -7px #767676,3px 0 0 -7px #767676,4px 0 0 -7px #767676,5px 0 0 -7px #767676,6px 0 0 -7px #767676,7px 0 0 -7px #767676,8px 0 0 -7px #767676,9px 0 0 -7px #767676,10px 0 0 -7px #767676,11px 0 0 -7px #767676,12px 0 0 -7px #767676,13px 0 0 -7px #767676,14px 0 0 -7px #767676,15px 0 0 -7px #767676,16px 0 0 -7px #767676,17px 0 0 -7px #767676,18px 0 0 -7px #767676,19px 0 0 -7px #767676,20px 0 0 -7px #767676,21px 0 0 -7px #767676,22px 0 0 -7px #767676,23px 0 0 -7px #767676,24px 0 0 -7px #767676,25px 0 0 -7px #767676,26px 0 0 -7px #767676,27px 0 0 -7px #767676,28px 0 0 -7px #767676,29px 0 0 -7px #767676,30px 0 0 -7px #767676,31px 0 0 -7px #767676,32px 0 0 -7px #767676,33px 0 0 -7px #767676,34px 0 0 -7px #767676,35px 0 0 -7px #767676,36px 0 0 -7px #767676,37px 0 0 -7px #767676,38px 0 0 -7px #767676,39px 0 0 -7px #767676,40px 0 0 -7px #767676,41px 0 0 -7px #767676,42px 0 0 -7px #767676,43px 0 0 -7px #767676,44px 0 0 -7px #767676,45px 0 0 -7px #767676,46px 0 0 -7px #767676,47px 0 0 -7px #767676,48px 0 0 -7px #767676,49px 0 0 -7px #767676,50px 0 0 -7px #767676,51px 0 0 -7px #767676,52px 0 0 -7px #767676,53px 0 0 -7px #767676,54px 0 0 -7px #767676,55px 0 0 -7px #767676,56px 0 0 -7px #767676,57px 0 0 -7px #767676,58px 0 0 -7px #767676,59px 0 0 -7px #767676,60px 0 0 -7px #767676,61px 0 0 -7px #767676,62px 0 0 -7px #767676,63px 0 0 -7px #767676,64px 0 0 -7px #767676,65px 0 0 -7px #767676,66px 0 0 -7px #767676,67px 0 0 -7px #767676,68px 0 0 -7px #767676,69px 0 0 -7px #767676,70px 0 0 -7px #767676,71px 0 0 -7px #767676,72px 0 0 -7px #767676,73px 0 0 -7px #767676,74px 0 0 -7px #767676,75px 0 0 -7px #767676,76px 0 0 -7px #767676,77px 0 0 -7px #767676,78px 0 0 -7px #767676,79px 0 0 -7px #767676,80px 0 0 -7px #767676,81px 0 0 -7px #767676,82px 0 0 -7px #767676,83px 0 0 -7px #767676,84px 0 0 -7px #767676,85px 0 0 -7px #767676,86px 0 0 -7px #767676,87px 0 0 -7px #767676,88px 0 0 -7px #767676,89px 0 0 -7px #767676,90px 0 0 -7px #767676,91px 0 0 -7px #767676,92px 0 0 -7px #767676,93px 0 0 -7px #767676,94px 0 0 -7px #767676,95px 0 0 -7px #767676,96px 0 0 -7px #767676,97px 0 0 -7px #767676,98px 0 0 -7px #767676,99px 0 0 -7px #767676,100px 0 0 -7px #767676,101px 0 0 -7px #767676,102px 0 0 -7px #767676,103px 0 0 -7px #767676,104px 0 0 -7px #767676,105px 0 0 -7px #767676,106px 0 0 -7px #767676,107px 0 0 -7px #767676,108px 0 0 -7px #767676,109px 0 0 -7px #767676,110px 0 0 -7px #767676,111px 0 0 -7px #767676,112px 0 0 -7px #767676,113px 0 0 -7px #767676,114px 0 0 -7px #767676,115px 0 0 -7px #767676,116px 0 0 -7px #767676,117px 0 0 -7px #767676,118px 0 0 -7px #767676,119px 0 0 -7px #767676,120px 0 0 -7px #767676,121px 0 0 -7px #767676,122px 0 0 -7px #767676,123px 0 0 -7px #767676,124px 0 0 -7px #767676,125px 0 0 -7px #767676,126px 0 0 -7px #767676,127px 0 0 -7px #767676,128px 0 0 -7px #767676,129px 0 0 -7px #767676,130px 0 0 -7px #767676,131px 0 0 -7px #767676,132px 0 0 -7px #767676,133px 0 0 -7px #767676,134px 0 0 -7px #767676,135px 0 0 -7px #767676,136px 0 0 -7px #767676,137px 0 0 -7px #767676,138px 0 0 -7px #767676,139px 0 0 -7px #767676,140px 0 0 -7px #767676,141px 0 0 -7px #767676,142px 0 0 -7px #767676,143px 0 0 -7px #767676,144px 0 0 -7px #767676,145px 0 0 -7px #767676,146px 0 0 -7px #767676,147px 0 0 -7px #767676,148px 0 0 -7px #767676,149px 0 0 -7px #767676,150px 0 0 -7px #767676,151px 0 0 -7px #767676,152px 0 0 -7px #767676,153px 0 0 -7px #767676,154px 0 0 -7px #767676,155px 0 0 -7px #767676,156px 0 0 -7px #767676,157px 0 0 -7px #767676,158px 0 0 -7px #767676,159px 0 0 -7px #767676,160px 0 0 -7px #767676,161px 0 0 -7px #767676,162px 0 0 -7px #767676,163px 0 0 -7px #767676,164px 0 0 -7px #767676,165px 0 0 -7px #767676,166px 0 0 -7px #767676,167px 0 0 -7px #767676,168px 0 0 -7px #767676,169px 0 0 -7px #767676,170px 0 0 -7px #767676,171px 0 0 -7px #767676,172px 0 0 -7px #767676,173px 0 0 -7px #767676,174px 0 0 -7px #767676,175px 0 0 -7px #767676,176px 0 0 -7px #767676,177px 0 0 -7px #767676,178px 0 0 -7px #767676,179px 0 0 -7px #767676,180px 0 0 -7px #767676,181px 0 0 -7px #767676,182px 0 0 -7px #767676,183px 0 0 -7px #767676,184px 0 0 -7px #767676,185px 0 0 -7px #767676,186px 0 0 -7px #767676,187px 0 0 -7px #767676,188px 0 0 -7px #767676,189px 0 0 -7px #767676,190px 0 0 -7px #767676,191px 0 0 -7px #767676,192px 0 0 -7px #767676,193px 0 0 -7px #767676,194px 0 0 -7px #767676,195px 0 0 -7px #767676,196px 0 0 -7px #767676,197px 0 0 -7px #767676,198px 0 0 -7px #767676,199px 0 0 -7px #767676,200px 0 0 -7px #767676,201px 0 0 -7px #767676,202px 0 0 -7px #767676,203px 0 0 -7px #767676,204px 0 0 -7px #767676,205px 0 0 -7px #767676,206px 0 0 -7px #767676,207px 0 0 -7px #767676,208px 0 0 -7px #767676,209px 0 0 -7px #767676,210px 0 0 -7px #767676,211px 0 0 -7px #767676,212px 0 0 -7px #767676,213px 0 0 -7px #767676,214px 0 0 -7px #767676,215px 0 0 -7px #767676,216px 0 0 -7px #767676,217px 0 0 -7px #767676,218px 0 0 -7px #767676,219px 0 0 -7px #767676,220px 0 0 -7px #767676,221px 0 0 -7px #767676,222px 0 0 -7px #767676,223px 0 0 -7px #767676,224px 0 0 -7px #767676,225px 0 0 -7px #767676,226px 0 0 -7px #767676,227px 0 0 -7px #767676,228px 0 0 -7px #767676,229px 0 0 -7px #767676,230px 0 0 -7px #767676,231px 0 0 -7px #767676,232px 0 0 -7px #767676,233px 0 0 -7px #767676,234px 0 0 -7px #767676,235px 0 0 -7px #767676,236px 0 0 -7px #767676,237px 0 0 -7px #767676,238px 0 0 -7px #767676,239px 0 0 -7px #767676,240px 0 0 -7px #767676,241px 0 0 -7px #767676,242px 0 0 -7px #767676,243px 0 0 -7px #767676,244px 0 0 -7px #767676,245px 0 0 -7px #767676,246px 0 0 -7px #767676,247px 0 0 -7px #767676,248px 0 0 -7px #767676,249px 0 0 -7px #767676,250px 0 0 -7px #767676,251px 0 0 -7px #767676,252px 0 0 -7px #767676,253px 0 0 -7px #767676,254px 0 0 -7px #767676,255px 0 0 -7px #767676,256px 0 0 -7px #767676,257px 0 0 -7px #767676,258px 0 0 -7px #767676,259px 0 0 -7px #767676,260px 0 0 -7px #767676,261px 0 0 -7px #767676,262px 0 0 -7px #767676,263px 0 0 -7px #767676,264px 0 0 -7px #767676,265px 0 0 -7px #767676,266px 0 0 -7px #767676,267px 0 0 -7px #767676,268px 0 0 -7px #767676,269px 0 0 -7px #767676,270px 0 0 -7px #767676,271px 0 0 -7px #767676,272px 0 0 -7px #767676,273px 0 0 -7px #767676,274px 0 0 -7px #767676,275px 0 0 -7px #767676,276px 0 0 -7px #767676,277px 0 0 -7px #767676,278px 0 0 -7px #767676,279px 0 0 -7px #767676,280px 0 0 -7px #767676,281px 0 0 -7px #767676,282px 0 0 -7px #767676,283px 0 0 -7px #767676,284px 0 0 -7px #767676,285px 0 0 -7px #767676,286px 0 0 -7px #767676,287px 0 0 -7px #767676,288px 0 0 -7px #767676,289px 0 0 -7px #767676,290px 0 0 -7px #767676,291px 0 0 -7px #767676,292px 0 0 -7px #767676,293px 0 0 -7px #767676,294px 0 0 -7px #767676,295px 0 0 -7px #767676,296px 0 0 -7px #767676,297px 0 0 -7px #767676,298px 0 0 -7px #767676,299px 0 0 -7px #767676,300px 0 0 -7px #767676,301px 0 0 -7px #767676,302px 0 0 -7px #767676,303px 0 0 -7px #767676,304px 0 0 -7px #767676,305px 0 0 -7px #767676,306px 0 0 -7px #767676,307px 0 0 -7px #767676,308px 0 0 -7px #767676,309px 0 0 -7px #767676,310px 0 0 -7px #767676,311px 0 0 -7px #767676,312px 0 0 -7px #767676,313px 0 0 -7px #767676,314px 0 0 -7px #767676,315px 0 0 -7px #767676,316px 0 0 -7px #767676,317px 0 0 -7px #767676,318px 0 0 -7px #767676,319px 0 0 -7px #767676,320px 0 0 -7px #767676,321px 0 0 -7px #767676,322px 0 0 -7px #767676,323px 0 0 -7px #767676,324px 0 0 -7px #767676,325px 0 0 -7px #767676,326px 0 0 -7px #767676,327px 0 0 -7px #767676,328px 0 0 -7px #767676,329px 0 0 -7px #767676,330px 0 0 -7px #767676,331px 0 0 -7px #767676,332px 0 0 -7px #767676,333px 0 0 -7px #767676,334px 0 0 -7px #767676,335px 0 0 -7px #767676,336px 0 0 -7px #767676,337px 0 0 -7px #767676,338px 0 0 -7px #767676,339px 0 0 -7px #767676,340px 0 0 -7px #767676,341px 0 0 -7px #767676,342px 0 0 -7px #767676,343px 0 0 -7px #767676,344px 0 0 -7px #767676,345px 0 0 -7px #767676,346px 0 0 -7px #767676,347px 0 0 -7px #767676,348px 0 0 -7px #767676,349px 0 0 -7px #767676,350px 0 0 -7px #767676,351px 0 0 -7px #767676,352px 0 0 -7px #767676,353px 0 0 -7px #767676,354px 0 0 -7px #767676,355px 0 0 -7px #767676,356px 0 0 -7px #767676,357px 0 0 -7px #767676,358px 0 0 -7px #767676,359px 0 0 -7px #767676,360px 0 0 -7px #767676,361px 0 0 -7px #767676,362px 0 0 -7px #767676,363px 0 0 -7px #767676,364px 0 0 -7px #767676,365px 0 0 -7px #767676,366px 0 0 -7px #767676,367px 0 0 -7px #767676,368px 0 0 -7px #767676,369px 0 0 -7px #767676,370px 0 0 -7px #767676,371px 0 0 -7px #767676,372px 0 0 -7px #767676,373px 0 0 -7px #767676,374px 0 0 -7px #767676,375px 0 0 -7px #767676,376px 0 0 -7px #767676,377px 0 0 -7px #767676,378px 0 0 -7px #767676,379px 0 0 -7px #767676,380px 0 0 -7px #767676,381px 0 0 -7px #767676,382px 0 0 -7px #767676,383px 0 0 -7px #767676,384px 0 0 -7px #767676,385px 0 0 -7px #767676,386px 0 0 -7px #767676,387px 0 0 -7px #767676,388px 0 0 -7px #767676,389px 0 0 -7px #767676,390px 0 0 -7px #767676,391px 0 0 -7px #767676,392px 0 0 -7px #767676,393px 0 0 -7px #767676,394px 0 0 -7px #767676,395px 0 0 -7px #767676,396px 0 0 -7px #767676,397px 0 0 -7px #767676,398px 0 0 -7px #767676,399px 0 0 -7px #767676,400px 0 0 -7px #767676,401px 0 0 -7px #767676,402px 0 0 -7px #767676,403px 0 0 -7px #767676,404px 0 0 -7px #767676,405px 0 0 -7px #767676,406px 0 0 -7px #767676,407px 0 0 -7px #767676,408px 0 0 -7px #767676,409px 0 0 -7px #767676,410px 0 0 -7px #767676,411px 0 0 -7px #767676,412px 0 0 -7px #767676,413px 0 0 -7px #767676,414px 0 0 -7px #767676,415px 0 0 -7px #767676,416px 0 0 -7px #767676,417px 0 0 -7px #767676,418px 0 0 -7px #767676,419px 0 0 -7px #767676,420px 0 0 -7px #767676,421px 0 0 -7px #767676,422px 0 0 -7px #767676,423px 0 0 -7px #767676,424px 0 0 -7px #767676,425px 0 0 -7px #767676,426px 0 0 -7px #767676,427px 0 0 -7px #767676,428px 0 0 -7px #767676,429px 0 0 -7px #767676,430px 0 0 -7px #767676,431px 0 0 -7px #767676,432px 0 0 -7px #767676,433px 0 0 -7px #767676,434px 0 0 -7px #767676,435px 0 0 -7px #767676,436px 0 0 -7px #767676,437px 0 0 -7px #767676,438px 0 0 -7px #767676,439px 0 0 -7px #767676,440px 0 0 -7px #767676,441px 0 0 -7px #767676,442px 0 0 -7px #767676,443px 0 0 -7px #767676,444px 0 0 -7px #767676,445px 0 0 -7px #767676,446px 0 0 -7px #767676,447px 0 0 -7px #767676,448px 0 0 -7px #767676,449px 0 0 -7px #767676,450px 0 0 -7px #767676,451px 0 0 -7px #767676,452px 0 0 -7px #767676,453px 0 0 -7px #767676,454px 0 0 -7px #767676,455px 0 0 -7px #767676,456px 0 0 -7px #767676,457px 0 0 -7px #767676,458px 0 0 -7px #767676,459px 0 0 -7px #767676,460px 0 0 -7px #767676,461px 0 0 -7px #767676,462px 0 0 -7px #767676,463px 0 0 -7px #767676,464px 0 0 -7px #767676,465px 0 0 -7px #767676,466px 0 0 -7px #767676,467px 0 0 -7px #767676,468px 0 0 -7px #767676,469px 0 0 -7px #767676,470px 0 0 -7px #767676,471px 0 0 -7px #767676,472px 0 0 -7px #767676,473px 0 0 -7px #767676,474px 0 0 -7px #767676,475px 0 0 -7px #767676,476px 0 0 -7px #767676,477px 0 0 -7px #767676,478px 0 0 -7px #767676,479px 0 0 -7px #767676,480px 0 0 -7px #767676,481px 0 0 -7px #767676,482px 0 0 -7px #767676,483px 0 0 -7px #767676,484px 0 0 -7px #767676,485px 0 0 -7px #767676,486px 0 0 -7px #767676,487px 0 0 -7px #767676,488px 0 0 -7px #767676,489px 0 0 -7px #767676,490px 0 0 -7px #767676,491px 0 0 -7px #767676,492px 0 0 -7px #767676,493px 0 0 -7px #767676,494px 0 0 -7px #767676,495px 0 0 -7px #767676,496px 0 0 -7px #767676,497px 0 0 -7px #767676,498px 0 0 -7px #767676,499px 0 0 -7px #767676,500px 0 0 -7px #767676,501px 0 0 -7px #767676,502px 0 0 -7px #767676,503px 0 0 -7px #767676,504px 0 0 -7px #767676,505px 0 0 -7px #767676,506px 0 0 -7px #767676,507px 0 0 -7px #767676,508px 0 0 -7px #767676,509px 0 0 -7px #767676,510px 0 0 -7px #767676,511px 0 0 -7px #767676,512px 0 0 -7px #767676,513px 0 0 -7px #767676,514px 0 0 -7px #767676,515px 0 0 -7px #767676,516px 0 0 -7px #767676,517px 0 0 -7px #767676,518px 0 0 -7px #767676,519px 0 0 -7px #767676,520px 0 0 -7px #767676,521px 0 0 -7px #767676,522px 0 0 -7px #767676,523px 0 0 -7px #767676,524px 0 0 -7px #767676,525px 0 0 -7px #767676,526px 0 0 -7px #767676,527px 0 0 -7px #767676,528px 0 0 -7px #767676,529px 0 0 -7px #767676,530px 0 0 -7px #767676,531px 0 0 -7px #767676,532px 0 0 -7px #767676,533px 0 0 -7px #767676,534px 0 0 -7px #767676,535px 0 0 -7px #767676,536px 0 0 -7px #767676,537px 0 0 -7px #767676,538px 0 0 -7px #767676,539px 0 0 -7px #767676,540px 0 0 -7px #767676,541px 0 0 -7px #767676,542px 0 0 -7px #767676,543px 0 0 -7px #767676,544px 0 0 -7px #767676,545px 0 0 -7px #767676,546px 0 0 -7px #767676,547px 0 0 -7px #767676,548px 0 0 -7px #767676,549px 0 0 -7px #767676,550px 0 0 -7px #767676,551px 0 0 -7px #767676,552px 0 0 -7px #767676,553px 0 0 -7px #767676,554px 0 0 -7px #767676,555px 0 0 -7px #767676,556px 0 0 -7px #767676,557px 0 0 -7px #767676,558px 0 0 -7px #767676,559px 0 0 -7px #767676,560px 0 0 -7px #767676,561px 0 0 -7px #767676,562px 0 0 -7px #767676,563px 0 0 -7px #767676,564px 0 0 -7px #767676,565px 0 0 -7px #767676,566px 0 0 -7px #767676,567px 0 0 -7px #767676,568px 0 0 -7px #767676,569px 0 0 -7px #767676,570px 0 0 -7px #767676,571px 0 0 -7px #767676,572px 0 0 -7px #767676,573px 0 0 -7px #767676,574px 0 0 -7px #767676,575px 0 0 -7px #767676,576px 0 0 -7px #767676,577px 0 0 -7px #767676,578px 0 0 -7px #767676,579px 0 0 -7px #767676,580px 0 0 -7px #767676,581px 0 0 -7px #767676,582px 0 0 -7px #767676,583px 0 0 -7px #767676,584px 0 0 -7px #767676,585px 0 0 -7px #767676,586px 0 0 -7px #767676,587px 0 0 -7px #767676,588px 0 0 -7px #767676,589px 0 0 -7px #767676,590px 0 0 -7px #767676,591px 0 0 -7px #767676,592px 0 0 -7px #767676,593px 0 0 -7px #767676,594px 0 0 -7px #767676,595px 0 0 -7px #767676,596px 0 0 -7px #767676,597px 0 0 -7px #767676,598px 0 0 -7px #767676,599px 0 0 -7px #767676,600px 0 0 -7px #767676,601px 0 0 -7px #767676,602px 0 0 -7px #767676,603px 0 0 -7px #767676,604px 0 0 -7px #767676,605px 0 0 -7px #767676,606px 0 0 -7px #767676,607px 0 0 -7px #767676,608px 0 0 -7px #767676,609px 0 0 -7px #767676,610px 0 0 -7px #767676,611px 0 0 -7px #767676,612px 0 0 -7px #767676,613px 0 0 -7px #767676,614px 0 0 -7px #767676,615px 0 0 -7px #767676,616px 0 0 -7px #767676,617px 0 0 -7px #767676,618px 0 0 -7px #767676,619px 0 0 -7px #767676,620px 0 0 -7px #767676,621px 0 0 -7px #767676,622px 0 0 -7px #767676,623px 0 0 -7px #767676,624px 0 0 -7px #767676,625px 0 0 -7px #767676,626px 0 0 -7px #767676,627px 0 0 -7px #767676,628px 0 0 -7px #767676,629px 0 0 -7px #767676,630px 0 0 -7px #767676,631px 0 0 -7px #767676,632px 0 0 -7px #767676,633px 0 0 -7px #767676,634px 0 0 -7px #767676,635px 0 0 -7px #767676,636px 0 0 -7px #767676,637px 0 0 -7px #767676,638px 0 0 -7px #767676,639px 0 0 -7px #767676,640px 0 0 -7px #767676,641px 0 0 -7px #767676,642px 0 0 -7px #767676,643px 0 0 -7px #767676,644px 0 0 -7px #767676,645px 0 0 -7px #767676,646px 0 0 -7px #767676,647px 0 0 -7px #767676,648px 0 0 -7px #767676,649px 0 0 -7px #767676,650px 0 0 -7px #767676,651px 0 0 -7px #767676,652px 0 0 -7px #767676,653px 0 0 -7px #767676,654px 0 0 -7px #767676,655px 0 0 -7px #767676,656px 0 0 -7px #767676,657px 0 0 -7px #767676,658px 0 0 -7px #767676,659px 0 0 -7px #767676,660px 0 0 -7px #767676,661px 0 0 -7px #767676,662px 0 0 -7px #767676,663px 0 0 -7px #767676,664px 0 0 -7px #767676,665px 0 0 -7px #767676,666px 0 0 -7px #767676,667px 0 0 -7px #767676,668px 0 0 -7px #767676,669px 0 0 -7px #767676,670px 0 0 -7px #767676,671px 0 0 -7px #767676,672px 0 0 -7px #767676,673px 0 0 -7px #767676,674px 0 0 -7px #767676,675px 0 0 -7px #767676,676px 0 0 -7px #767676,677px 0 0 -7px #767676,678px 0 0 -7px #767676,679px 0 0 -7px #767676,680px 0 0 -7px #767676,681px 0 0 -7px #767676,682px 0 0 -7px #767676,683px 0 0 -7px #767676,684px 0 0 -7px #767676,685px 0 0 -7px #767676,686px 0 0 -7px #767676,687px 0 0 -7px #767676,688px 0 0 -7px #767676,689px 0 0 -7px #767676,690px 0 0 -7px #767676,691px 0 0 -7px #767676,692px 0 0 -7px #767676,693px 0 0 -7px #767676,694px 0 0 -7px #767676,695px 0 0 -7px #767676,696px 0 0 -7px #767676,697px 0 0 -7px #767676,698px 0 0 -7px #767676,699px 0 0 -7px #767676,700px 0 0 -7px #767676,701px 0 0 -7px #767676,702px 0 0 -7px #767676,703px 0 0 -7px #767676,704px 0 0 -7px #767676,705px 0 0 -7px #767676,706px 0 0 -7px #767676,707px 0 0 -7px #767676,708px 0 0 -7px #767676,709px 0 0 -7px #767676,710px 0 0 -7px #767676,711px 0 0 -7px #767676,712px 0 0 -7px #767676,713px 0 0 -7px #767676,714px 0 0 -7px #767676,715px 0 0 -7px #767676,716px 0 0 -7px #767676,717px 0 0 -7px #767676,718px 0 0 -7px #767676,719px 0 0 -7px #767676,720px 0 0 -7px #767676,721px 0 0 -7px #767676,722px 0 0 -7px #767676,723px 0 0 -7px #767676,724px 0 0 -7px #767676,725px 0 0 -7px #767676,726px 0 0 -7px #767676,727px 0 0 -7px #767676,728px 0 0 -7px #767676,729px 0 0 -7px #767676,730px 0 0 -7px #767676,731px 0 0 -7px #767676,732px 0 0 -7px #767676,733px 0 0 -7px #767676,734px 0 0 -7px #767676,735px 0 0 -7px #767676,736px 0 0 -7px #767676,737px 0 0 -7px #767676,738px 0 0 -7px #767676,739px 0 0 -7px #767676,740px 0 0 -7px #767676,741px 0 0 -7px #767676,742px 0 0 -7px #767676,743px 0 0 -7px #767676,744px 0 0 -7px #767676,745px 0 0 -7px #767676,746px 0 0 -7px #767676,747px 0 0 -7px #767676,748px 0 0 -7px #767676,749px 0 0 -7px #767676,750px 0 0 -7px #767676,751px 0 0 -7px #767676,752px 0 0 -7px #767676,753px 0 0 -7px #767676,754px 0 0 -7px #767676,755px 0 0 -7px #767676,756px 0 0 -7px #767676,757px 0 0 -7px #767676,758px 0 0 -7px #767676,759px 0 0 -7px #767676,760px 0 0 -7px #767676,761px 0 0 -7px #767676,762px 0 0 -7px #767676,763px 0 0 -7px #767676,764px 0 0 -7px #767676,765px 0 0 -7px #767676,766px 0 0 -7px #767676,767px 0 0 -7px #767676,768px 0 0 -7px #767676,769px 0 0 -7px #767676,770px 0 0 -7px #767676,771px 0 0 -7px #767676,772px 0 0 -7px #767676,773px 0 0 -7px #767676,774px 0 0 -7px #767676,775px 0 0 -7px #767676,776px 0 0 -7px #767676,777px 0 0 -7px #767676,778px 0 0 -7px #767676,779px 0 0 -7px #767676,780px 0 0 -7px #767676,781px 0 0 -7px #767676,782px 0 0 -7px #767676,783px 0 0 -7px #767676,784px 0 0 -7px #767676,785px 0 0 -7px #767676,786px 0 0 -7px #767676,787px 0 0 -7px #767676,788px 0 0 -7px #767676,789px 0 0 -7px #767676,790px 0 0 -7px #767676,791px 0 0 -7px #767676,792px 0 0 -7px #767676,793px 0 0 -7px #767676,794px 0 0 -7px #767676,795px 0 0 -7px #767676,796px 0 0 -7px #767676,797px 0 0 -7px #767676,798px 0 0 -7px #767676,799px 0 0 -7px #767676,800px 0 0 -7px #767676,801px 0 0 -7px #767676,802px 0 0 -7px #767676,803px 0 0 -7px #767676,804px 0 0 -7px #767676,805px 0 0 -7px #767676,806px 0 0 -7px #767676,807px 0 0 -7px #767676,808px 0 0 -7px #767676,809px 0 0 -7px #767676,810px 0 0 -7px #767676,811px 0 0 -7px #767676,812px 0 0 -7px #767676,813px 0 0 -7px #767676,814px 0 0 -7px #767676,815px 0 0 -7px #767676,816px 0 0 -7px #767676,817px 0 0 -7px #767676,818px 0 0 -7px #767676,819px 0 0 -7px #767676,820px 0 0 -7px #767676,821px 0 0 -7px #767676,822px 0 0 -7px #767676,823px 0 0 -7px #767676,824px 0 0 -7px #767676,825px 0 0 -7px #767676,826px 0 0 -7px #767676,827px 0 0 -7px #767676,828px 0 0 -7px #767676,829px 0 0 -7px #767676,830px 0 0 -7px #767676,831px 0 0 -7px #767676,832px 0 0 -7px #767676,833px 0 0 -7px #767676,834px 0 0 -7px #767676,835px 0 0 -7px #767676,836px 0 0 -7px #767676,837px 0 0 -7px #767676,838px 0 0 -7px #767676,839px 0 0 -7px #767676,840px 0 0 -7px #767676,841px 0 0 -7px #767676,842px 0 0 -7px #767676,843px 0 0 -7px #767676,844px 0 0 -7px #767676,845px 0 0 -7px #767676,846px 0 0 -7px #767676,847px 0 0 -7px #767676,848px 0 0 -7px #767676,849px 0 0 -7px #767676,850px 0 0 -7px #767676,851px 0 0 -7px #767676,852px 0 0 -7px #767676,853px 0 0 -7px #767676,854px 0 0 -7px #767676,855px 0 0 -7px #767676,856px 0 0 -7px #767676,857px 0 0 -7px #767676,858px 0 0 -7px #767676,859px 0 0 -7px #767676,860px 0 0 -7px #767676,861px 0 0 -7px #767676,862px 0 0 -7px #767676,863px 0 0 -7px #767676,864px 0 0 -7px #767676,865px 0 0 -7px #767676,866px 0 0 -7px #767676,867px 0 0 -7px #767676,868px 0 0 -7px #767676,869px 0 0 -7px #767676,870px 0 0 -7px #767676,871px 0 0 -7px #767676,872px 0 0 -7px #767676,873px 0 0 -7px #767676,874px 0 0 -7px #767676,875px 0 0 -7px #767676,876px 0 0 -7px #767676,877px 0 0 -7px #767676,878px 0 0 -7px #767676,879px 0 0 -7px #767676,880px 0 0 -7px #767676,881px 0 0 -7px #767676,882px 0 0 -7px #767676,883px 0 0 -7px #767676,884px 0 0 -7px #767676,885px 0 0 -7px #767676,886px 0 0 -7px #767676,887px 0 0 -7px #767676,888px 0 0 -7px #767676,889px 0 0 -7px #767676,890px 0 0 -7px #767676,891px 0 0 -7px #767676,892px 0 0 -7px #767676,893px 0 0 -7px #767676,894px 0 0 -7px #767676,895px 0 0 -7px #767676,896px 0 0 -7px #767676,897px 0 0 -7px #767676,898px 0 0 -7px #767676,899px 0 0 -7px #767676,900px 0 0 -7px #767676,901px 0 0 -7px #767676,902px 0 0 -7px #767676,903px 0 0 -7px #767676,904px 0 0 -7px #767676,905px 0 0 -7px #767676,906px 0 0 -7px #767676,907px 0 0 -7px #767676,908px 0 0 -7px #767676,909px 0 0 -7px #767676,910px 0 0 -7px #767676,911px 0 0 -7px #767676,912px 0 0 -7px #767676,913px 0 0 -7px #767676,914px 0 0 -7px #767676,915px 0 0 -7px #767676,916px 0 0 -7px #767676,917px 0 0 -7px #767676,918px 0 0 -7px #767676,919px 0 0 -7px #767676,920px 0 0 -7px #767676,921px 0 0 -7px #767676,922px 0 0 -7px #767676,923px 0 0 -7px #767676,924px 0 0 -7px #767676,925px 0 0 -7px #767676,926px 0 0 -7px #767676,927px 0 0 -7px #767676,928px 0 0 -7px #767676,929px 0 0 -7px #767676,930px 0 0 -7px #767676,931px 0 0 -7px #767676,932px 0 0 -7px #767676,933px 0 0 -7px #767676,934px 0 0 -7px #767676,935px 0 0 -7px #767676,936px 0 0 -7px #767676,937px 0 0 -7px #767676,938px 0 0 -7px #767676,939px 0 0 -7px #767676,940px 0 0 -7px #767676,941px 0 0 -7px #767676,942px 0 0 -7px #767676,943px 0 0 -7px #767676,944px 0 0 -7px #767676,945px 0 0 -7px #767676,946px 0 0 -7px #767676,947px 0 0 -7px #767676,948px 0 0 -7px #767676,949px 0 0 -7px #767676,950px 0 0 -7px #767676,951px 0 0 -7px #767676,952px 0 0 -7px #767676,953px 0 0 -7px #767676,954px 0 0 -7px #767676,955px 0 0 -7px #767676,956px 0 0 -7px #767676,957px 0 0 -7px #767676,958px 0 0 -7px #767676,959px 0 0 -7px #767676,960px 0 0 -7px #767676,961px 0 0 -7px #767676,962px 0 0 -7px #767676,963px 0 0 -7px #767676,964px 0 0 -7px #767676,965px 0 0 -7px #767676,966px 0 0 -7px #767676,967px 0 0 -7px #767676,968px 0 0 -7px #767676,969px 0 0 -7px #767676,970px 0 0 -7px #767676,971px 0 0 -7px #767676,972px 0 0 -7px #767676,973px 0 0 -7px #767676,974px 0 0 -7px #767676,975px 0 0 -7px #767676,976px 0 0 -7px #767676,977px 0 0 -7px #767676,978px 0 0 -7px #767676,979px 0 0 -7px #767676,980px 0 0 -7px #767676,981px 0 0 -7px #767676,982px 0 0 -7px #767676,983px 0 0 -7px #767676,984px 0 0 -7px #767676,985px 0 0 -7px #767676,986px 0 0 -7px #767676,987px 0 0 -7px #767676,988px 0 0 -7px #767676,989px 0 0 -7px #767676,990px 0 0 -7px #767676,991px 0 0 -7px #767676,992px 0 0 -7px #767676,993px 0 0 -7px #767676,994px 0 0 -7px #767676,995px 0 0 -7px #767676,996px 0 0 -7px #767676,997px 0 0 -7px #767676,998px 0 0 -7px #767676,999px 0 0 -7px #767676,1000px 0 0 -7px #767676,1001px 0 0 -7px #767676,1002px 0 0 -7px #767676,1003px 0 0 -7px #767676,1004px 0 0 -7px #767676,1005px 0 0 -7px #767676,1006px 0 0 -7px #767676,1007px 0 0 -7px #767676,1008px 0 0 -7px #767676,1009px 0 0 -7px #767676,1010px 0 0 -7px #767676,1011px 0 0 -7px #767676,1012px 0 0 -7px #767676,1013px 0 0 -7px #767676,1014px 0 0 -7px #767676,1015px 0 0 -7px #767676,1016px 0 0 -7px #767676,1017px 0 0 -7px #767676,1018px 0 0 -7px #767676,1019px 0 0 -7px #767676,1020px 0 0 -7px #767676,1021px 0 0 -7px #767676,1022px 0 0 -7px #767676,1023px 0 0 -7px #767676,1024px 0 0 -7px #767676,1025px 0 0 -7px #767676,1026px 0 0 -7px #767676,1027px 0 0 -7px #767676,1028px 0 0 -7px #767676,1029px 0 0 -7px #767676,1030px 0 0 -7px #767676,1031px 0 0 -7px #767676,1032px 0 0 -7px #767676,1033px 0 0 -7px #767676,1034px 0 0 -7px #767676,1035px 0 0 -7px #767676,1036px 0 0 -7px #767676,1037px 0 0 -7px #767676,1038px 0 0 -7px #767676,1039px 0 0 -7px #767676,1040px 0 0 -7px #767676,1041px 0 0 -7px #767676,1042px 0 0 -7px #767676,1043px 0 0 -7px #767676,1044px 0 0 -7px #767676,1045px 0 0 -7px #767676,1046px 0 0 -7px #767676,1047px 0 0 -7px #767676,1048px 0 0 -7px #767676,1049px 0 0 -7px #767676,1050px 0 0 -7px #767676,1051px 0 0 -7px #767676,1052px 0 0 -7px #767676,1053px 0 0 -7px #767676,1054px 0 0 -7px #767676,1055px 0 0 -7px #767676,1056px 0 0 -7px #767676,1057px 0 0 -7px #767676,1058px 0 0 -7px #767676,1059px 0 0 -7px #767676,1060px 0 0 -7px #767676,1061px 0 0 -7px #767676,1062px 0 0 -7px #767676,1063px 0 0 -7px #767676,1064px 0 0 -7px #767676,1065px 0 0 -7px #767676,1066px 0 0 -7px #767676,1067px 0 0 -7px #767676,1068px 0 0 -7px #767676,1069px 0 0 -7px #767676,1070px 0 0 -7px #767676,1071px 0 0 -7px #767676,1072px 0 0 -7px #767676,1073px 0 0 -7px #767676,1074px 0 0 -7px #767676,1075px 0 0 -7px #767676,1076px 0 0 -7px #767676,1077px 0 0 -7px #767676,1078px 0 0 -7px #767676,1079px 0 0 -7px #767676,1080px 0 0 -7px #767676,1081px 0 0 -7px #767676,1082px 0 0 -7px #767676,1083px 0 0 -7px #767676,1084px 0 0 -7px #767676,1085px 0 0 -7px #767676,1086px 0 0 -7px #767676,1087px 0 0 -7px #767676,1088px 0 0 -7px #767676,1089px 0 0 -7px #767676,1090px 0 0 -7px #767676,1091px 0 0 -7px #767676,1092px 0 0 -7px #767676,1093px 0 0 -7px #767676,1094px 0 0 -7px #767676,1095px 0 0 -7px #767676,1096px 0 0 -7px #767676,1097px 0 0 -7px #767676,1098px 0 0 -7px #767676,1099px 0 0 -7px #767676,1100px 0 0 -7px #767676,1101px 0 0 -7px #767676,1102px 0 0 -7px #767676,1103px 0 0 -7px #767676,1104px 0 0 -7px #767676,1105px 0 0 -7px #767676,1106px 0 0 -7px #767676,1107px 0 0 -7px #767676,1108px 0 0 -7px #767676,1109px 0 0 -7px #767676,1110px 0 0 -7px #767676,1111px 0 0 -7px #767676,1112px 0 0 -7px #767676,1113px 0 0 -7px #767676,1114px 0 0 -7px #767676,1115px 0 0 -7px #767676,1116px 0 0 -7px #767676,1117px 0 0 -7px #767676,1118px 0 0 -7px #767676,1119px 0 0 -7px #767676,1120px 0 0 -7px #767676,1121px 0 0 -7px #767676,1122px 0 0 -7px #767676,1123px 0 0 -7px #767676,1124px 0 0 -7px #767676,1125px 0 0 -7px #767676,1126px 0 0 -7px #767676,1127px 0 0 -7px #767676,1128px 0 0 -7px #767676,1129px 0 0 -7px #767676,1130px 0 0 -7px #767676,1131px 0 0 -7px #767676,1132px 0 0 -7px #767676,1133px 0 0 -7px #767676,1134px 0 0 -7px #767676,1135px 0 0 -7px #767676,1136px 0 0 -7px #767676,1137px 0 0 -7px #767676,1138px 0 0 -7px #767676,1139px 0 0 -7px #767676,1140px 0 0 -7px #767676,1141px 0 0 -7px #767676,1142px 0 0 -7px #767676,1143px 0 0 -7px #767676,1144px 0 0 -7px #767676,1145px 0 0 -7px #767676,1146px 0 0 -7px #767676,1147px 0 0 -7px #767676,1148px 0 0 -7px #767676,1149px 0 0 -7px #767676,1150px 0 0 -7px #767676,1151px 0 0 -7px #767676,1152px 0 0 -7px #767676,1153px 0 0 -7px #767676,1154px 0 0 -7px #767676,1155px 0 0 -7px #767676,1156px 0 0 -7px #767676,1157px 0 0 -7px #767676,1158px 0 0 -7px #767676,1159px 0 0 -7px #767676,1160px 0 0 -7px #767676,1161px 0 0 -7px #767676,1162px 0 0 -7px #767676,1163px 0 0 -7px #767676,1164px 0 0 -7px #767676,1165px 0 0 -7px #767676,1166px 0 0 -7px #767676,1167px 0 0 -7px #767676,1168px 0 0 -7px #767676,1169px 0 0 -7px #767676,1170px 0 0 -7px #767676,1171px 0 0 -7px #767676,1172px 0 0 -7px #767676,1173px 0 0 -7px #767676,1174px 0 0 -7px #767676,1175px 0 0 -7px #767676,1176px 0 0 -7px #767676,1177px 0 0 -7px #767676,1178px 0 0 -7px #767676,1179px 0 0 -7px #767676,1180px 0 0 -7px #767676,1181px 0 0 -7px #767676,1182px 0 0 -7px #767676,1183px 0 0 -7px #767676,1184px 0 0 -7px #767676,1185px 0 0 -7px #767676,1186px 0 0 -7px #767676,1187px 0 0 -7px #767676,1188px 0 0 -7px #767676,1189px 0 0 -7px #767676,1190px 0 0 -7px #767676,1191px 0 0 -7px #767676,1192px 0 0 -7px #767676,1193px 0 0 -7px #767676,1194px 0 0 -7px #767676,1195px 0 0 -7px #767676,1196px 0 0 -7px #767676,1197px 0 0 -7px #767676,1198px 0 0 -7px #767676,1199px 0 0 -7px #767676,1200px 0 0 -7px #767676,1201px 0 0 -7px #767676,1202px 0 0 -7px #767676,1203px 0 0 -7px #767676,1204px 0 0 -7px #767676,1205px 0 0 -7px #767676,1206px 0 0 -7px #767676,1207px 0 0 -7px #767676,1208px 0 0 -7px #767676,1209px 0 0 -7px #767676,1210px 0 0 -7px #767676,1211px 0 0 -7px #767676,1212px 0 0 -7px #767676,1213px 0 0 -7px #767676,1214px 0 0 -7px #767676,1215px 0 0 -7px #767676,1216px 0 0 -7px #767676,1217px 0 0 -7px #767676,1218px 0 0 -7px #767676,1219px 0 0 -7px #767676,1220px 0 0 -7px #767676,1221px 0 0 -7px #767676,1222px 0 0 -7px #767676,1223px 0 0 -7px #767676,1224px 0 0 -7px #767676,1225px 0 0 -7px #767676,1226px 0 0 -7px #767676,1227px 0 0 -7px #767676,1228px 0 0 -7px #767676,1229px 0 0 -7px #767676,1230px 0 0 -7px #767676,1231px 0 0 -7px #767676,1232px 0 0 -7px #767676,1233px 0 0 -7px #767676,1234px 0 0 -7px #767676,1235px 0 0 -7px #767676,1236px 0 0 -7px #767676,1237px 0 0 -7px #767676,1238px 0 0 -7px #767676,1239px 0 0 -7px #767676,1240px 0 0 -7px #767676,1241px 0 0 -7px #767676,1242px 0 0 -7px #767676,1243px 0 0 -7px #767676,1244px 0 0 -7px #767676,1245px 0 0 -7px #767676,1246px 0 0 -7px #767676,1247px 0 0 -7px #767676,1248px 0 0 -7px #767676,1249px 0 0 -7px #767676,1250px 0 0 -7px #767676,1251px 0 0 -7px #767676,1252px 0 0 -7px #767676,1253px 0 0 -7px #767676,1254px 0 0 -7px #767676,1255px 0 0 -7px #767676,1256px 0 0 -7px #767676,1257px 0 0 -7px #767676,1258px 0 0 -7px #767676,1259px 0 0 -7px #767676,1260px 0 0 -7px #767676,1261px 0 0 -7px #767676,1262px 0 0 -7px #767676,1263px 0 0 -7px #767676,1264px 0 0 -7px #767676,1265px 0 0 -7px #767676,1266px 0 0 -7px #767676,1267px 0 0 -7px #767676,1268px 0 0 -7px #767676,1269px 0 0 -7px #767676,1270px 0 0 -7px #767676,1271px 0 0 -7px #767676,1272px 0 0 -7px #767676,1273px 0 0 -7px #767676,1274px 0 0 -7px #767676,1275px 0 0 -7px #767676,1276px 0 0 -7px #767676,1277px 0 0 -7px #767676,1278px 0 0 -7px #767676,1279px 0 0 -7px #767676,1280px 0 0 -7px #767676,1281px 0 0 -7px #767676,1282px 0 0 -7px #767676,1283px 0 0 -7px #767676,1284px 0 0 -7px #767676,1285px 0 0 -7px #767676,1286px 0 0 -7px #767676,1287px 0 0 -7px #767676,1288px 0 0 -7px #767676,1289px 0 0 -7px #767676,1290px 0 0 -7px #767676,1291px 0 0 -7px #767676,1292px 0 0 -7px #767676,1293px 0 0 -7px #767676,1294px 0 0 -7px #767676,1295px 0 0 -7px #767676,1296px 0 0 -7px #767676,1297px 0 0 -7px #767676,1298px 0 0 -7px #767676,1299px 0 0 -7px #767676,1300px 0 0 -7px #767676,1301px 0 0 -7px #767676,1302px 0 0 -7px #767676,1303px 0 0 -7px #767676,1304px 0 0 -7px #767676,1305px 0 0 -7px #767676,1306px 0 0 -7px #767676,1307px 0 0 -7px #767676,1308px 0 0 -7px #767676,1309px 0 0 -7px #767676,1310px 0 0 -7px #767676,1311px 0 0 -7px #767676,1312px 0 0 -7px #767676,1313px 0 0 -7px #767676,1314px 0 0 -7px #767676,1315px 0 0 -7px #767676,1316px 0 0 -7px #767676,1317px 0 0 -7px #767676,1318px 0 0 -7px #767676,1319px 0 0 -7px #767676,1320px 0 0 -7px #767676,1321px 0 0 -7px #767676,1322px 0 0 -7px #767676,1323px 0 0 -7px #767676,1324px 0 0 -7px #767676,1325px 0 0 -7px #767676,1326px 0 0 -7px #767676,1327px 0 0 -7px #767676,1328px 0 0 -7px #767676,1329px 0 0 -7px #767676,1330px 0 0 -7px #767676,1331px 0 0 -7px #767676,1332px 0 0 -7px #767676,1333px 0 0 -7px #767676,1334px 0 0 -7px #767676,1335px 0 0 -7px #767676,1336px 0 0 -7px #767676,1337px 0 0 -7px #767676,1338px 0 0 -7px #767676,1339px 0 0 -7px #767676,1340px 0 0 -7px #767676,1341px 0 0 -7px #767676,1342px 0 0 -7px #767676,1343px 0 0 -7px #767676,1344px 0 0 -7px #767676,1345px 0 0 -7px #767676,1346px 0 0 -7px #767676,1347px 0 0 -7px #767676,1348px 0 0 -7px #767676,1349px 0 0 -7px #767676,1350px 0 0 -7px #767676,1351px 0 0 -7px #767676,1352px 0 0 -7px #767676,1353px 0 0 -7px #767676,1354px 0 0 -7px #767676,1355px 0 0 -7px #767676,1356px 0 0 -7px #767676,1357px 0 0 -7px #767676,1358px 0 0 -7px #767676,1359px 0 0 -7px #767676,1360px 0 0 -7px #767676,1361px 0 0 -7px #767676,1362px 0 0 -7px #767676,1363px 0 0 -7px #767676,1364px 0 0 -7px #767676,1365px 0 0 -7px #767676,1366px 0 0 -7px #767676,1367px 0 0 -7px #767676,1368px 0 0 -7px #767676,1369px 0 0 -7px #767676,1370px 0 0 -7px #767676,1371px 0 0 -7px #767676,1372px 0 0 -7px #767676,1373px 0 0 -7px #767676,1374px 0 0 -7px #767676,1375px 0 0 -7px #767676,1376px 0 0 -7px #767676,1377px 0 0 -7px #767676,1378px 0 0 -7px #767676,1379px 0 0 -7px #767676,1380px 0 0 -7px #767676,1381px 0 0 -7px #767676,1382px 0 0 -7px #767676,1383px 0 0 -7px #767676,1384px 0 0 -7px #767676,1385px 0 0 -7px #767676,1386px 0 0 -7px #767676,1387px 0 0 -7px #767676,1388px 0 0 -7px #767676,1389px 0 0 -7px #767676,1390px 0 0 -7px #767676,1391px 0 0 -7px #767676,1392px 0 0 -7px #767676,1393px 0 0 -7px #767676,1394px 0 0 -7px #767676,1395px 0 0 -7px #767676,1396px 0 0 -7px #767676,1397px 0 0 -7px #767676,1398px 0 0 -7px #767676,1399px 0 0 -7px #767676,1400px 0 0 -7px #767676,1401px 0 0 -7px #767676,1402px 0 0 -7px #767676,1403px 0 0 -7px #767676,1404px 0 0 -7px #767676,1405px 0 0 -7px #767676,1406px 0 0 -7px #767676,1407px 0 0 -7px #767676,1408px 0 0 -7px #767676,1409px 0 0 -7px #767676,1410px 0 0 -7px #767676,1411px 0 0 -7px #767676,1412px 0 0 -7px #767676,1413px 0 0 -7px #767676,1414px 0 0 -7px #767676,1415px 0 0 -7px #767676,1416px 0 0 -7px #767676,1417px 0 0 -7px #767676,1418px 0 0 -7px #767676,1419px 0 0 -7px #767676,1420px 0 0 -7px #767676,1421px 0 0 -7px #767676,1422px 0 0 -7px #767676,1423px 0 0 -7px #767676,1424px 0 0 -7px #767676,1425px 0 0 -7px #767676,1426px 0 0 -7px #767676,1427px 0 0 -7px #767676,1428px 0 0 -7px #767676,1429px 0 0 -7px #767676,1430px 0 0 -7px #767676,1431px 0 0 -7px #767676,1432px 0 0 -7px #767676,1433px 0 0 -7px #767676,1434px 0 0 -7px #767676,1435px 0 0 -7px #767676,1436px 0 0 -7px #767676,1437px 0 0 -7px #767676,1438px 0 0 -7px #767676,1439px 0 0 -7px #767676,1440px 0 0 -7px #767676}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/media-player/src/ProgressBar.module.scss", "/Users/okunoe01/workspace/react-transcript-editor/packages/config/style-guide/colours.scss"],
    names: [],
    mappings: "AA0BA,yBACE,UAAW,CACX,iBAAkB,CAClB,iBAAkB,CAClB,MAAO,CACP,YAAa,CACd,yBAGC,uBAAwB,CACxB,oBAAqB,CACrB,eAAgB,CAChB,eAAgB,CAChB,cAAe,CACf,UAAW,CACX,WAAY,CACZ,QAAS,CARX,wDAYI,WA1CgB,CA2ChB,YA5CU,CA6CV,UAAW,CACX,mBAAoB,CACpB,kBClDoB,CDkCxB,+CAoBI,uBAAwB,CACxB,WA/Ce,CAgDf,UAjDc,CAkDd,eA/CsB,CAgDtB,kBC1DoB,CD2DpB,4shCAvC4C,CAchD,2CA8BI,WA5DgB,CA6DhB,YA9DU,CA+DV,UAAW,CACX,mBAAoB,CACpB,kBCpEoB,CDkCxB,2CAsCI,oBAAqB,CACrB,WAjEe,CAkEf,UAnEc,CAoEd,eAjEsB,CAkEtB,QAAS,CACT,eAAgB,CAChB,kBC9EoB,CD+EpB,4shCA3D4C",
    file: "ProgressBar.module.scss",
    sourcesContent: ["@import '../../../config/style-guide/colours.scss';\n\n$slider-width-number: 1440;\n$slider-width: #{$slider-width-number}px;\n$slider-height: 10px;\n$background-slider: $color-light-grey;\n$bar-slider-filled: $color-labs-red;\n$thumb-width: 16px;\n$thumb-height: 24px;\n$shadow-size: -7px;\n$fit-thumb-in-slider: -7px;\n\n@function strip-units($number) {\n  @return $number / ($number * 0 + 1);\n}\n\n@function makelongshadow($color, $size) {\n  $val: 1px 0 0 $size $color;\n\n  @for $i from 1 through $slider-width-number {\n    $val: #{$val}, #{$i}px 0 0 $size #{$color};\n  }\n\n  @return $val;\n}\n\n.wrapper {\n  width: 100%;\n  overflow-x: hidden;\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n}\n\n.bar {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: none;\n  cursor: pointer;\n  width: 100%;\n  height: 30px;\n  margin: 0;\n\n  // Chrome\n  &::-webkit-slider-runnable-track {\n    height: $slider-height;\n    width: $slider-width;\n    content: '';\n    pointer-events: none;\n    background: $bar-slider-filled;\n  }\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    height: $thumb-height;\n    width: $thumb-width;\n    margin-top: $fit-thumb-in-slider;\n    background: $color-labs-red;\n    box-shadow: makelongshadow($color-light-grey, $shadow-size);\n  }\n\n  // Firefox\n  &::-moz-range-track {\n    height: $slider-height;\n    width: $slider-width;\n    content: '';\n    pointer-events: none;\n    background: $bar-slider-filled;\n  }\n\n  &::-moz-range-thumb {\n    -moz-appearance: none;\n    height: $thumb-height;\n    width: $thumb-width;\n    margin-top: $fit-thumb-in-slider;\n    border: 0;\n    border-radius: 0;\n    background: $color-labs-red;\n    box-shadow: makelongshadow($color-light-grey, $shadow-size);\n  }\n}\n", "$color-labs-red: #a0372d !default;\n$color-darkest-grey: #282828 !default;\n$color-dark-grey: #4a4a4a !default;\n$color-mid-grey: #696969 !default;\n$color-light-grey: #767676 !default;\n$color-lightest-grey: #f2f2f2 !default;\n$color-subt-green: #69e3c2 !default;\n$color-light-shilo: #E2A9A2 !default;\n"]
  }]), n.locals = {
    wrapper: "_1Sqs7D5mukWn2nOcvTmkAt",
    bar: "_3908VmKIi5jE0-hk6X3CPJ"
  };
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      o = t(37),
      i = t(19),
      A = t(29),
      s = t(21),
      l = t(27),
      a = t(16),
      c = t(7),
      u = t(3),
      p = (t(34), t(25)),
      m = t(134),
      C = l.draft_tree_data_support,
      d = C ? s : A,
      f = u.List,
      h = u.Repeat,
      x = {
    insertAtomicBlock: function insertAtomicBlock(e, n, t) {
      var A = e.getCurrentContent(),
          s = e.getSelection(),
          l = a.removeRange(A, s, "backward"),
          u = l.getSelectionAfter(),
          m = a.splitBlock(l, u),
          x = m.getSelectionAfter(),
          g = a.setBlockType(m, x, "atomic"),
          I = i.create({
        entity: n
      }),
          b = {
        key: p(),
        type: "atomic",
        text: t,
        characterList: f(h(I, t.length))
      },
          y = {
        key: p(),
        type: "unstyled"
      };
      C && (b = r({}, b, {
        nextSibling: y.key
      }), y = r({}, y, {
        prevSibling: b.key
      }));
      var E = [new d(b), new d(y)],
          v = o.createFromArray(E),
          w = a.replaceWithFragment(g, x, v),
          B = w.merge({
        selectionBefore: s,
        selectionAfter: w.getSelectionAfter().set("hasFocus", !0)
      });
      return c.push(e, B, "insert-fragment");
    },
    moveAtomicBlock: function moveAtomicBlock(e, n, t, r) {
      var o = e.getCurrentContent(),
          i = e.getSelection(),
          A = void 0;

      if ("before" === r || "after" === r) {
        var s = o.getBlockForKey("before" === r ? t.getStartKey() : t.getEndKey());
        A = m(o, n, s, r);
      } else {
        var l = a.removeRange(o, t, "backward"),
            u = l.getSelectionAfter(),
            p = l.getBlockForKey(u.getFocusKey());
        if (0 === u.getStartOffset()) A = m(l, n, p, "before");else if (u.getEndOffset() === p.getLength()) A = m(l, n, p, "after");else {
          var C = a.splitBlock(l, u),
              d = C.getSelectionAfter(),
              f = C.getBlockForKey(d.getFocusKey());
          A = m(C, n, f, "before");
        }
      }

      var h = A.merge({
        selectionBefore: i,
        selectionAfter: A.getSelectionAfter().set("hasFocus", !0)
      });
      return c.push(e, h, "move-block");
    }
  };

  e.exports = x;
}, function (e, n, t) {
  "use strict";

  e.exports = {
    draft_killswitch_allow_nontextnodes: !1,
    draft_segmented_entities_behavior: !1,
    draft_handlebeforeinput_composed_text: !1,
    draft_tree_data_support: !1
  };
}, function (e, n, t) {
  "use strict";

  var r = t(19),
      o = t(3).Map,
      i = {
    add: function add(e, n, t) {
      return A(e, n, t, !0);
    },
    remove: function remove(e, n, t) {
      return A(e, n, t, !1);
    }
  };

  function A(e, n, t, i) {
    var A = e.getBlockMap(),
        s = n.getStartKey(),
        l = n.getStartOffset(),
        a = n.getEndKey(),
        c = n.getEndOffset(),
        u = A.skipUntil(function (e, n) {
      return n === s;
    }).takeUntil(function (e, n) {
      return n === a;
    }).concat(o([[a, A.get(a)]])).map(function (e, n) {
      var o, A;
      s === a ? (o = l, A = c) : (o = n === s ? l : 0, A = n === a ? c : e.getLength());

      for (var u, p = e.getCharacterList(); o < A;) {
        u = p.get(o), p = p.set(o, i ? r.applyStyle(u, t) : r.removeStyle(u, t)), o++;
      }

      return e.set("characterList", p);
    });
    return e.merge({
      blockMap: A.merge(u),
      selectionBefore: n,
      selectionAfter: n
    });
  }

  e.exports = i;
}, function (e, n, t) {
  "use strict";

  var r = t(3),
      o = t(123);

  e.exports = function (e, n, t) {
    var i = e.getBlockMap(),
        A = n.getStartKey(),
        s = n.getStartOffset(),
        l = n.getEndKey(),
        a = n.getEndOffset(),
        c = i.skipUntil(function (e, n) {
      return n === A;
    }).takeUntil(function (e, n) {
      return n === l;
    }).toOrderedMap().merge(r.OrderedMap([[l, i.get(l)]])).map(function (e, n) {
      var r = n === A ? s : 0,
          i = n === l ? a : e.getLength();
      return o(e, r, i, t);
    });
    return e.merge({
      blockMap: i.merge(c),
      selectionBefore: n,
      selectionAfter: n
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(19);

  e.exports = function (e, n, t, o) {
    for (var i = e.getCharacterList(); n < t;) {
      i = i.set(n, r.applyEntity(i.get(n), o)), n++;
    }

    return e.set("characterList", i);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(125),
      o = t(126),
      i = t(4);

  function A(e, n, t, A, s, l, a) {
    var c = t.getStartOffset(),
        u = t.getEndOffset(),
        p = e.__get(s).getMutability(),
        m = a ? c : u;

    if ("MUTABLE" === p) return t;
    var C = o(n, s).filter(function (e) {
      return m <= e.end && m >= e.start;
    });
    1 != C.length && i(!1);
    var d = C[0];
    if ("IMMUTABLE" === p) return t.merge({
      anchorOffset: d.start,
      focusOffset: d.end,
      isBackward: !1
    });
    l || (a ? u = d.end : c = d.start);
    var f = r.getRemovalRange(c, u, n.getText().slice(d.start, d.end), d.start, A);
    return t.merge({
      anchorOffset: f.start,
      focusOffset: f.end,
      isBackward: !1
    });
  }

  e.exports = function (e, n, t, r, o) {
    var i = r.getStartOffset(),
        s = r.getEndOffset(),
        l = n.getEntityAt(i),
        a = t.getEntityAt(s - 1);
    if (!l && !a) return r;
    var c = r;
    if (l && l === a) c = A(e, n, c, o, l, !0, !0);else if (l && a) {
      var u = A(e, n, c, o, l, !1, !0),
          p = A(e, t, c, o, a, !1, !1);
      c = c.merge({
        anchorOffset: u.getAnchorOffset(),
        focusOffset: p.getFocusOffset(),
        isBackward: !1
      });
    } else if (l) {
      var m = A(e, n, c, o, l, !1, !0);
      c = c.merge({
        anchorOffset: m.getStartOffset(),
        isBackward: !1
      });
    } else if (a) {
      var C = A(e, t, c, o, a, !1, !1);
      c = c.merge({
        focusOffset: C.getEndOffset(),
        isBackward: !1
      });
    }
    return c;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = {
    getRemovalRange: function getRemovalRange(e, n, t, r, o) {
      var i = t.split(" ");
      i = i.map(function (e, n) {
        if ("forward" === o) {
          if (n > 0) return " " + e;
        } else if (n < i.length - 1) return e + " ";

        return e;
      });

      for (var A, s = r, l = null, a = null, c = 0; c < i.length; c++) {
        if (e < (A = s + i[c].length) && s < n) null !== l ? a = A : (l = s, a = A);else if (null !== l) break;
        s = A;
      }

      var u = r + t.length,
          p = l === r,
          m = a === u;
      return (!p && m || p && !m) && ("forward" === o ? a !== u && a++ : l !== r && l--), {
        start: l,
        end: a
      };
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = t(4);

  e.exports = function (e, n) {
    var t = [];
    return e.findEntityRanges(function (e) {
      return e.getEntity() === n;
    }, function (e, n) {
      t.push({
        start: e,
        end: n
      });
    }), t.length || r(!1), t;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(37),
      o = t(21),
      i = t(3),
      A = t(86),
      s = t(4),
      l = t(84),
      a = i.List,
      c = function c(e, n, t, i, A, s) {
    var l = t.first() instanceof o,
        c = [],
        u = i.size,
        p = t.get(A),
        m = i.first(),
        C = i.last(),
        d = C.getLength(),
        f = C.getKey(),
        h = l && (!p.getChildKeys().isEmpty() || !m.getChildKeys().isEmpty());
    t.forEach(function (e, n) {
      n === A ? (h ? c.push(e) : c.push(function (e, n, t) {
        var r = e.getText(),
            o = e.getCharacterList(),
            i = r.slice(0, n),
            A = o.slice(0, n),
            s = t.first();
        return e.merge({
          text: i + s.getText(),
          characterList: A.concat(s.getCharacterList()),
          type: i ? e.getType() : s.getType(),
          data: s.getData()
        });
      }(e, s, i)), i.slice(h ? 0 : 1, u - 1).forEach(function (e) {
        return c.push(e);
      }), c.push(function (e, n, t) {
        var r = e.getText(),
            o = e.getCharacterList(),
            i = r.length,
            A = r.slice(n, i),
            s = o.slice(n, i),
            l = t.last();
        return l.merge({
          text: l.getText() + A,
          characterList: l.getCharacterList().concat(s),
          data: l.getData()
        });
      }(e, s, i))) : c.push(e);
    });
    var x = r.createFromArray(c);
    return l && (x = function (e, n, t, r) {
      return e.withMutations(function (n) {
        var o = t.getKey(),
            i = r.getKey(),
            A = t.getNextSiblingKey(),
            s = t.getParentKey(),
            l = function (e, n) {
          var t = e.getKey(),
              r = e,
              o = [];

          for (n.get(t) && o.push(t); r && r.getNextSiblingKey();) {
            var i = r.getNextSiblingKey();
            if (!i) break;
            o.push(i), r = n.get(i);
          }

          return o;
        }(r, e),
            c = l[l.length - 1];

        if (n.get(i) ? (n.setIn([o, "nextSibling"], i), n.setIn([i, "prevSibling"], o)) : (n.setIn([o, "nextSibling"], r.getNextSiblingKey()), n.setIn([r.getNextSiblingKey(), "prevSibling"], o)), n.setIn([c, "nextSibling"], A), A && n.setIn([A, "prevSibling"], c), l.forEach(function (e) {
          return n.setIn([e, "parent"], s);
        }), s) {
          var u = e.get(s).getChildKeys(),
              p = u.indexOf(o) + 1,
              m = u.toArray();
          m.splice.apply(m, [p, 0].concat(l)), n.setIn([s, "children"], a(m));
        }
      });
    }(x, 0, p, m)), e.merge({
      blockMap: x,
      selectionBefore: n,
      selectionAfter: n.merge({
        anchorKey: f,
        anchorOffset: d,
        focusKey: f,
        focusOffset: d,
        isBackward: !1
      })
    });
  };

  e.exports = function (e, n, t) {
    n.isCollapsed() || s(!1);
    var r = e.getBlockMap(),
        i = l(t),
        a = n.getStartKey(),
        u = n.getStartOffset(),
        p = r.get(a);
    return p instanceof o && (p.getChildKeys().isEmpty() || s(!1)), 1 === i.size ? function (e, n, t, r, o, i) {
      var s = t.get(o),
          l = s.getText(),
          a = s.getCharacterList(),
          c = o,
          u = i + r.getText().length,
          p = s.merge({
        text: l.slice(0, i) + r.getText() + l.slice(i),
        characterList: A(a, r.getCharacterList(), i),
        data: r.getData()
      });
      return e.merge({
        blockMap: t.set(o, p),
        selectionBefore: n,
        selectionAfter: n.merge({
          anchorKey: c,
          anchorOffset: u,
          focusKey: c,
          focusOffset: u,
          isBackward: !1
        })
      });
    }(e, n, r, i.first(), a, u) : c(e, n, r, i, a, u);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(3),
      o = t(86),
      i = t(4),
      A = r.Repeat;

  e.exports = function (e, n, t, r) {
    n.isCollapsed() || i(!1);
    var s = t.length;
    if (!s) return e;
    var l = e.getBlockMap(),
        a = n.getStartKey(),
        c = n.getStartOffset(),
        u = l.get(a),
        p = u.getText(),
        m = u.merge({
      text: p.slice(0, c) + t + p.slice(c, u.getLength()),
      characterList: o(u.getCharacterList(), A(r, s).toList(), c)
    }),
        C = c + s;
    return e.merge({
      blockMap: l.set(a, m),
      selectionAfter: n.merge({
        anchorOffset: C,
        focusOffset: C
      })
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(3).Map;

  e.exports = function (e, n, t) {
    var o = n.getStartKey(),
        i = n.getEndKey(),
        A = e.getBlockMap(),
        s = A.toSeq().skipUntil(function (e, n) {
      return n === o;
    }).takeUntil(function (e, n) {
      return n === i;
    }).concat(r([[i, A.get(i)]])).map(t);
    return e.merge({
      blockMap: A.merge(s),
      selectionBefore: n,
      selectionAfter: n
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(21),
      o = t(3),
      i = t(87),
      A = (o.List, o.Map),
      s = function s(e, n, t) {
    if (e) {
      var r = n.get(e);
      r && n.set(e, t(r));
    }
  },
      l = function l(e, n) {
    var t = [];
    if (!e) return t;

    for (var r = n.get(e); r && r.getParentKey();) {
      var o = r.getParentKey();
      o && t.push(o), r = o ? n.get(o) : null;
    }

    return t;
  },
      a = function a(e, n, t) {
    if (!e) return null;

    for (var r = t.get(e.getKey()).getNextSiblingKey(); r && !n.get(r);) {
      r = t.get(r).getNextSiblingKey() || null;
    }

    return r;
  },
      c = function c(e, n, t) {
    if (!e) return null;

    for (var r = t.get(e.getKey()).getPrevSiblingKey(); r && !n.get(r);) {
      r = t.get(r).getPrevSiblingKey() || null;
    }

    return r;
  },
      u = function u(e, n, t, r) {
    return e.withMutations(function (e) {
      s(n.getKey(), e, function (t) {
        return t.merge({
          nextSibling: a(n, e, r),
          prevSibling: c(n, e, r)
        });
      }), s(t.getKey(), e, function (n) {
        return n.merge({
          nextSibling: a(t, e, r),
          prevSibling: c(t, e, r)
        });
      }), l(n.getKey(), r).forEach(function (n) {
        return s(n, e, function (n) {
          return n.merge({
            children: n.getChildKeys().filter(function (n) {
              return e.get(n);
            }),
            nextSibling: a(n, e, r),
            prevSibling: c(n, e, r)
          });
        });
      }), s(n.getNextSiblingKey(), e, function (e) {
        return e.merge({
          prevSibling: n.getPrevSiblingKey()
        });
      }), s(n.getPrevSiblingKey(), e, function (t) {
        return t.merge({
          nextSibling: a(n, e, r)
        });
      }), s(t.getNextSiblingKey(), e, function (n) {
        return n.merge({
          prevSibling: c(t, e, r)
        });
      }), s(t.getPrevSiblingKey(), e, function (e) {
        return e.merge({
          nextSibling: t.getNextSiblingKey()
        });
      }), l(t.getKey(), r).forEach(function (n) {
        s(n, e, function (n) {
          return n.merge({
            children: n.getChildKeys().filter(function (n) {
              return e.get(n);
            }),
            nextSibling: a(n, e, r),
            prevSibling: c(n, e, r)
          });
        });
      }), function (e, n) {
        var t = [];
        if (!e) return t;

        for (var r = i(e, n); r && n.get(r);) {
          var o = n.get(r);
          t.push(r), r = o.getParentKey() ? i(o, n) : null;
        }

        return t;
      }(t, r).forEach(function (n) {
        return s(n, e, function (n) {
          return n.merge({
            nextSibling: a(n, e, r),
            prevSibling: c(n, e, r)
          });
        });
      });
    });
  },
      p = function p(e, n, t) {
    if (0 === n) for (; n < t;) {
      e = e.shift(), n++;
    } else if (t === e.count()) for (; t > n;) {
      e = e.pop(), t--;
    } else {
      var r = e.slice(0, n),
          o = e.slice(t);
      e = r.concat(o).toList();
    }
    return e;
  };

  e.exports = function (e, n) {
    if (n.isCollapsed()) return e;
    var t = e.getBlockMap(),
        o = n.getStartKey(),
        s = n.getStartOffset(),
        a = n.getEndKey(),
        c = n.getEndOffset(),
        m = t.get(o),
        C = t.get(a),
        d = m instanceof r,
        f = [];

    if (d) {
      var h = C.getChildKeys(),
          x = l(a, t);
      C.getNextSiblingKey() && (f = f.concat(x)), h.isEmpty() || (f = f.concat(x.concat([a]))), f = f.concat(l(i(C, t), t));
    }

    var g = void 0;
    g = m === C ? p(m.getCharacterList(), s, c) : m.getCharacterList().slice(0, s).concat(C.getCharacterList().slice(c));
    var I = m.merge({
      text: m.getText().slice(0, s) + C.getText().slice(c),
      characterList: g
    }),
        b = t.toSeq().skipUntil(function (e, n) {
      return n === o;
    }).takeUntil(function (e, n) {
      return n === a;
    }).filter(function (e, n) {
      return -1 === f.indexOf(n);
    }).concat(A([[a, null]])).map(function (e, n) {
      return n === o ? I : null;
    }),
        y = t.merge(b).filter(function (e) {
      return !!e;
    });
    return d && (y = u(y, m, C, t)), e.merge({
      blockMap: y,
      selectionBefore: n,
      selectionAfter: n.merge({
        anchorKey: o,
        anchorOffset: s,
        focusKey: o,
        focusOffset: s,
        isBackward: !1
      })
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(21),
      o = t(3),
      i = t(25),
      A = t(4),
      s = o.List,
      l = o.Map,
      a = function a(e, n, t) {
    if (e) {
      var r = n.get(e);
      r && n.set(e, t(r));
    }
  };

  e.exports = function (e, n) {
    n.isCollapsed() || A(!1);
    var t = n.getAnchorKey(),
        o = n.getAnchorOffset(),
        c = e.getBlockMap(),
        u = c.get(t),
        p = u.getText(),
        m = u.getCharacterList(),
        C = i(),
        d = u instanceof r,
        f = u.merge({
      text: p.slice(0, o),
      characterList: m.slice(0, o)
    }),
        h = f.merge({
      key: C,
      text: p.slice(o),
      characterList: m.slice(o),
      data: l()
    }),
        x = c.toSeq().takeUntil(function (e) {
      return e === u;
    }),
        g = c.toSeq().skipUntil(function (e) {
      return e === u;
    }).rest(),
        I = x.concat([[t, f], [C, h]], g).toOrderedMap();
    return d && (u.getChildKeys().isEmpty() || A(!1), I = function (e, n, t) {
      return e.withMutations(function (e) {
        var r = n.getKey(),
            o = t.getKey();
        a(n.getParentKey(), e, function (e) {
          var n = e.getChildKeys(),
              t = n.indexOf(r) + 1,
              i = n.toArray();
          return i.splice(t, 0, o), e.merge({
            children: s(i)
          });
        }), a(n.getNextSiblingKey(), e, function (e) {
          return e.merge({
            prevSibling: o
          });
        }), a(r, e, function (e) {
          return e.merge({
            nextSibling: o
          });
        }), a(o, e, function (e) {
          return e.merge({
            prevSibling: r
          });
        });
      });
    }(I, f, h)), e.merge({
      blockMap: I,
      selectionBefore: n,
      selectionAfter: n.merge({
        anchorKey: C,
        anchorOffset: 0,
        focusKey: C,
        focusOffset: 0,
        isBackward: !1
      })
    });
  };
}, function (e, n, t) {
  "use strict";

  var r,
      o = t(3),
      i = t(133),
      A = t(23),
      s = o.OrderedMap,
      l = {
    getDirectionMap: function getDirectionMap(e, n) {
      r ? r.reset() : r = new i();
      var t = e.getBlockMap(),
          l = t.valueSeq().map(function (e) {
        return A(r).getDirection(e.getText());
      }),
          a = s(t.keySeq().zip(l));
      return null != n && o.is(n, a) ? n : a;
    }
  };
  e.exports = l;
}, function (e, n, t) {
  "use strict";

  var r = t(90),
      o = t(63),
      i = t(4),
      A = function () {
    function e(n) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), n ? o.isStrong(n) || i(!1) : n = o.getGlobalDir(), this._defaultDir = n, this.reset();
    }

    return e.prototype.reset = function () {
      this._lastDir = this._defaultDir;
    }, e.prototype.getDirection = function (e) {
      return this._lastDir = r.getDirection(e, this._lastDir), this._lastDir;
    }, e;
  }();

  e.exports = A;
}, function (e, n, t) {
  "use strict";

  var r = t(21),
      o = t(3),
      i = t(87),
      A = t(4),
      s = o.OrderedMap,
      l = o.List,
      a = function a(e, n, t) {
    if (e) {
      var r = n.get(e);
      r && n.set(e, t(r));
    }
  },
      c = function c(e, n, t, r, o) {
    if (!o) return e;
    var i = "after" === r,
        A = n.getKey(),
        s = t.getKey(),
        c = n.getParentKey(),
        u = n.getNextSiblingKey(),
        p = n.getPrevSiblingKey(),
        m = t.getParentKey(),
        C = i ? t.getNextSiblingKey() : s,
        d = i ? s : t.getPrevSiblingKey();
    return e.withMutations(function (e) {
      a(c, e, function (e) {
        var n = e.getChildKeys();
        return e.merge({
          children: n.delete(n.indexOf(A))
        });
      }), a(p, e, function (e) {
        return e.merge({
          nextSibling: u
        });
      }), a(u, e, function (e) {
        return e.merge({
          prevSibling: p
        });
      }), a(C, e, function (e) {
        return e.merge({
          prevSibling: A
        });
      }), a(d, e, function (e) {
        return e.merge({
          nextSibling: A
        });
      }), a(m, e, function (e) {
        var n = e.getChildKeys(),
            t = n.indexOf(s),
            r = i ? t + 1 : 0 !== t ? t - 1 : 0,
            o = n.toArray();
        return o.splice(r, 0, A), e.merge({
          children: l(o)
        });
      }), a(A, e, function (e) {
        return e.merge({
          nextSibling: C,
          prevSibling: d,
          parent: m
        });
      });
    });
  };

  e.exports = function (e, n, t, o) {
    "replace" === o && A(!1);
    var l = t.getKey(),
        a = n.getKey();
    a === l && A(!1);
    var u = e.getBlockMap(),
        p = n instanceof r,
        m = [n],
        C = u.delete(a);
    p && (m = [], C = u.withMutations(function (e) {
      var t = n.getNextSiblingKey(),
          r = i(n, e);
      e.toSeq().skipUntil(function (e) {
        return e.getKey() === a;
      }).takeWhile(function (e) {
        var n = e.getKey(),
            o = n === a,
            i = t && n !== t,
            A = !t && e.getParentKey() && (!r || n !== r);
        return !!(o || i || A);
      }).forEach(function (n) {
        m.push(n), e.delete(n.getKey());
      });
    }));
    var d = C.toSeq().takeUntil(function (e) {
      return e === t;
    }),
        f = C.toSeq().skipUntil(function (e) {
      return e === t;
    }).skip(1),
        h = m.map(function (e) {
      return [e.getKey(), e];
    }),
        x = s();

    if ("before" === o) {
      var g = e.getBlockBefore(l);
      g && g.getKey() === n.getKey() && A(!1), x = d.concat([].concat(h, [[l, t]]), f).toOrderedMap();
    } else if ("after" === o) {
      var I = e.getBlockAfter(l);
      I && I.getKey() === a && A(!1), x = d.concat([[l, t]].concat(h), f).toOrderedMap();
    }

    return e.merge({
      blockMap: c(x, n, t, o, p),
      selectionBefore: e.getSelectionAfter(),
      selectionAfter: e.getSelectionAfter().merge({
        anchorKey: a,
        focusKey: a
      })
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(3).List,
      o = function () {
    function e(n) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this._decorators = n.slice();
    }

    return e.prototype.getDecorations = function (e, n) {
      var t = Array(e.getText().length).fill(null);
      return this._decorators.forEach(function (r, o) {
        var i = 0;
        (0, r.strategy)(e, function (e, n) {
          (function (e, n, t) {
            for (var r = n; r < t; r++) {
              if (null != e[r]) return !1;
            }

            return !0;
          })(t, e, n) && (!function (e, n, t, r) {
            for (var o = n; o < t; o++) {
              e[o] = r;
            }
          }(t, e, n, o + "." + i), i++);
        }, n);
      }), r(t);
    }, e.prototype.getComponentForKey = function (e) {
      var n = parseInt(e.split(".")[0], 10);
      return this._decorators[n].component;
    }, e.prototype.getPropsForKey = function (e) {
      var n = parseInt(e.split(".")[0], 10);
      return this._decorators[n].props;
    }, e;
  }();

  e.exports = o;
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  };

  var o = t(64),
      i = t(91),
      A = t(137),
      s = t(138),
      l = t(160),
      a = t(163),
      c = t(195),
      u = t(7),
      p = t(0),
      m = t(40),
      C = t(95),
      d = t(68),
      f = t(24),
      h = t(35),
      x = t(60),
      g = t(25),
      I = t(108),
      b = t(69),
      y = t(4),
      E = t(23),
      v = f.isBrowser("IE"),
      w = !v,
      B = {
    edit: a,
    composite: A,
    drag: l,
    cut: null,
    render: null
  },
      _ = function (e) {
    function n(t) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      var r = function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.call(this, t));

      return r.focus = function (e) {
        var n = r.props.editorState,
            t = n.getSelection().getHasFocus(),
            o = m.findDOMNode(r.editor);

        if (o) {
          var i = d.getScrollParent(o),
              A = e || b(i),
              s = A.x,
              l = A.y;
          o instanceof HTMLElement || y(!1), o.focus(), i === window ? window.scrollTo(s, l) : C.setTop(i, l), t || r.update(u.forceSelection(n, n.getSelection()));
        }
      }, r.blur = function () {
        var e = m.findDOMNode(r.editor);
        e instanceof HTMLElement || y(!1), e.blur();
      }, r.setMode = function (e) {
        r._handler = B[e];
      }, r.exitCurrentMode = function () {
        r.setMode("edit");
      }, r.restoreEditorDOM = function (e) {
        r.setState({
          contentsKey: r.state.contentsKey + 1
        }, function () {
          r.focus(e);
        });
      }, r.setClipboard = function (e) {
        r._clipboard = e;
      }, r.getClipboard = function () {
        return r._clipboard;
      }, r.update = function (e) {
        r._latestEditorState = e, r.props.onChange(e);
      }, r.onDragEnter = function () {
        r._dragCount++;
      }, r.onDragLeave = function () {
        r._dragCount--, 0 === r._dragCount && r.exitCurrentMode();
      }, r._blockSelectEvents = !1, r._clipboard = null, r._handler = null, r._dragCount = 0, r._editorKey = t.editorKey || g(), r._placeholderAccessibilityID = "placeholder-" + r._editorKey, r._latestEditorState = t.editorState, r._latestCommittedEditorState = t.editorState, r._onBeforeInput = r._buildHandler("onBeforeInput"), r._onBlur = r._buildHandler("onBlur"), r._onCharacterData = r._buildHandler("onCharacterData"), r._onCompositionEnd = r._buildHandler("onCompositionEnd"), r._onCompositionStart = r._buildHandler("onCompositionStart"), r._onCopy = r._buildHandler("onCopy"), r._onCut = r._buildHandler("onCut"), r._onDragEnd = r._buildHandler("onDragEnd"), r._onDragOver = r._buildHandler("onDragOver"), r._onDragStart = r._buildHandler("onDragStart"), r._onDrop = r._buildHandler("onDrop"), r._onInput = r._buildHandler("onInput"), r._onFocus = r._buildHandler("onFocus"), r._onKeyDown = r._buildHandler("onKeyDown"), r._onKeyPress = r._buildHandler("onKeyPress"), r._onKeyUp = r._buildHandler("onKeyUp"), r._onMouseDown = r._buildHandler("onMouseDown"), r._onMouseUp = r._buildHandler("onMouseUp"), r._onPaste = r._buildHandler("onPaste"), r._onSelect = r._buildHandler("onSelect"), r.getEditorKey = function () {
        return r._editorKey;
      }, r.state = {
        contentsKey: 0
      }, r;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype._buildHandler = function (e) {
      var n = this;
      return function (t) {
        if (!n.props.readOnly) {
          var r = n._handler && n._handler[e];
          r && r(n, t);
        }
      };
    }, n.prototype._showPlaceholder = function () {
      return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
    }, n.prototype._renderPlaceholder = function () {
      if (this._showPlaceholder()) {
        var e = {
          text: E(this.props.placeholder),
          editorState: this.props.editorState,
          textAlignment: this.props.textAlignment,
          accessibilityID: this._placeholderAccessibilityID
        };
        return p.createElement(c, e);
      }

      return null;
    }, n.prototype.render = function () {
      var e = this,
          n = this.props,
          t = n.blockRenderMap,
          o = n.blockRendererFn,
          A = n.blockStyleFn,
          l = n.customStyleFn,
          a = n.customStyleMap,
          c = n.editorState,
          u = n.readOnly,
          m = n.textAlignment,
          C = n.textDirectionality,
          d = h({
        "DraftEditor/root": !0,
        "DraftEditor/alignLeft": "left" === m,
        "DraftEditor/alignRight": "right" === m,
        "DraftEditor/alignCenter": "center" === m
      }),
          f = this.props.role || "textbox",
          x = "combobox" === f ? !!this.props.ariaExpanded : null,
          g = {
        blockRenderMap: t,
        blockRendererFn: o,
        blockStyleFn: A,
        customStyleMap: r({}, i, a),
        customStyleFn: l,
        editorKey: this._editorKey,
        editorState: c,
        key: "contents" + this.state.contentsKey,
        textDirectionality: C
      };
      return p.createElement("div", {
        className: d
      }, this._renderPlaceholder(), p.createElement("div", {
        className: h("DraftEditor/editorContainer"),
        ref: function ref(n) {
          return e.editorContainer = n;
        }
      }, p.createElement("div", {
        "aria-activedescendant": u ? null : this.props.ariaActiveDescendantID,
        "aria-autocomplete": u ? null : this.props.ariaAutoComplete,
        "aria-controls": u ? null : this.props.ariaControls,
        "aria-describedby": this.props.ariaDescribedBy || this._placeholderAccessibilityID,
        "aria-expanded": u ? null : x,
        "aria-label": this.props.ariaLabel,
        "aria-labelledby": this.props.ariaLabelledBy,
        "aria-multiline": this.props.ariaMultiline,
        autoCapitalize: this.props.autoCapitalize,
        autoComplete: this.props.autoComplete,
        autoCorrect: this.props.autoCorrect,
        className: h({
          notranslate: !u,
          "public/DraftEditor/content": !0
        }),
        contentEditable: !u,
        "data-testid": this.props.webDriverTestID,
        onBeforeInput: this._onBeforeInput,
        onBlur: this._onBlur,
        onCompositionEnd: this._onCompositionEnd,
        onCompositionStart: this._onCompositionStart,
        onCopy: this._onCopy,
        onCut: this._onCut,
        onDragEnd: this._onDragEnd,
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onDragOver: this._onDragOver,
        onDragStart: this._onDragStart,
        onDrop: this._onDrop,
        onFocus: this._onFocus,
        onInput: this._onInput,
        onKeyDown: this._onKeyDown,
        onKeyPress: this._onKeyPress,
        onKeyUp: this._onKeyUp,
        onMouseUp: this._onMouseUp,
        onPaste: this._onPaste,
        onSelect: this._onSelect,
        ref: function ref(n) {
          return e.editor = n;
        },
        role: u ? null : f,
        spellCheck: w && this.props.spellCheck,
        style: {
          outline: "none",
          userSelect: "text",
          WebkitUserSelect: "text",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word"
        },
        suppressContentEditableWarning: !0,
        tabIndex: this.props.tabIndex
      }, p.createElement(s, g))));
    }, n.prototype.componentDidMount = function () {
      this.setMode("edit"), v && document.execCommand("AutoUrlDetect", !1, !1);
    }, n.prototype.componentWillUpdate = function (e) {
      this._blockSelectEvents = !0, this._latestEditorState = e.editorState;
    }, n.prototype.componentDidUpdate = function () {
      this._blockSelectEvents = !1, this._latestCommittedEditorState = this.props.editorState;
    }, n;
  }(p.Component);

  _.defaultProps = {
    blockRenderMap: o,
    blockRendererFn: x.thatReturnsNull,
    blockStyleFn: x.thatReturns(""),
    keyBindingFn: I,
    readOnly: !1,
    spellCheck: !1,
    stripPastedStyles: !1
  }, e.exports = _;
}, function (e, n, t) {
  "use strict";

  var r = t(27),
      o = t(16),
      i = t(7),
      A = t(65),
      s = t(66),
      l = t(39),
      a = t(92),
      c = !1,
      u = !1,
      p = "",
      m = {
    onBeforeInput: function onBeforeInput(e, n) {
      p = (p || "") + n.data;
    },
    onCompositionStart: function onCompositionStart(e) {
      u = !0;
    },
    onCompositionEnd: function onCompositionEnd(e) {
      c = !1, u = !1, setTimeout(function () {
        c || m.resolveComposition(e);
      }, 20);
    },
    onKeyDown: function onKeyDown(e, n) {
      if (!u) return m.resolveComposition(e), void e._onKeyDown(n);
      n.which !== A.RIGHT && n.which !== A.LEFT || n.preventDefault();
    },
    onKeyPress: function onKeyPress(e, n) {
      n.which === A.RETURN && n.preventDefault();
    },
    resolveComposition: function resolveComposition(e) {
      if (!u) {
        c = !0;
        var n = p;
        p = "";
        var t = i.set(e._latestEditorState, {
          inCompositionMode: !1
        }),
            A = t.getCurrentInlineStyle(),
            m = s(t.getCurrentContent(), t.getSelection()),
            C = !n || a(t) || A.size > 0 || null !== m;

        if (C && e.restoreEditorDOM(), e.exitCurrentMode(), n) {
          if (r.draft_handlebeforeinput_composed_text && e.props.handleBeforeInput && l(e.props.handleBeforeInput(n, t))) return;
          var d = o.replaceText(t.getCurrentContent(), t.getSelection(), n, A, m);
          e.update(i.push(t, d, "insert-characters"));
        } else C && e.update(i.set(t, {
          nativelyRenderedContent: null,
          forceSelection: !0
        }));
      }
    }
  };
  e.exports = m;
}, function (e, n, t) {
  "use strict";

  var r = t(139);
  e.exports = r;
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  };

  var o = t(93),
      i = t(53),
      A = (t(7), t(0)),
      s = t(35),
      l = t(159),
      a = t(23),
      c = function c(e, n, t, r) {
    return s({
      "public/DraftStyleDefault/unorderedListItem": "unordered-list-item" === e,
      "public/DraftStyleDefault/orderedListItem": "ordered-list-item" === e,
      "public/DraftStyleDefault/reset": t,
      "public/DraftStyleDefault/depth0": 0 === n,
      "public/DraftStyleDefault/depth1": 1 === n,
      "public/DraftStyleDefault/depth2": 2 === n,
      "public/DraftStyleDefault/depth3": 3 === n,
      "public/DraftStyleDefault/depth4": 4 === n,
      "public/DraftStyleDefault/listLTR": "LTR" === r,
      "public/DraftStyleDefault/listRTL": "RTL" === r
    });
  },
      u = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.shouldComponentUpdate = function (e) {
      var n = this.props.editorState,
          t = e.editorState;
      if (n.getDirectionMap() !== t.getDirectionMap()) return !0;
      if (n.getSelection().getHasFocus() !== t.getSelection().getHasFocus()) return !0;
      var r = t.getNativelyRenderedContent(),
          o = n.isInCompositionMode(),
          i = t.isInCompositionMode();
      if (n === t || null !== r && t.getCurrentContent() === r || o && i) return !1;
      var A = n.getCurrentContent(),
          s = t.getCurrentContent(),
          l = n.getDecorator(),
          a = t.getDecorator();
      return o !== i || A !== s || l !== a || t.mustForceSelection();
    }, n.prototype.render = function () {
      for (var e = this.props, n = e.blockRenderMap, t = e.blockRendererFn, s = e.blockStyleFn, u = e.customStyleMap, p = e.customStyleFn, m = e.editorState, C = e.editorKey, d = e.textDirectionality, f = m.getCurrentContent(), h = m.getSelection(), x = m.mustForceSelection(), g = m.getDecorator(), I = a(m.getDirectionMap()), b = f.getBlocksAsArray(), y = [], E = null, v = null, w = 0; w < b.length; w++) {
        var B = b[w],
            _ = B.getKey(),
            D = B.getType(),
            S = t(B),
            M = void 0,
            O = void 0,
            k = void 0;

        S && (M = S.component, O = S.props, k = S.editable);
        var T = d || I.get(_),
            P = i.encode(_, 0, 0),
            K = {
          contentState: f,
          block: B,
          blockProps: O,
          blockStyleFn: s,
          customStyleMap: u,
          customStyleFn: p,
          decorator: g,
          direction: T,
          forceSelection: x,
          key: _,
          offsetKey: P,
          selection: h,
          tree: m.getBlockTree(_)
        },
            Q = n.get(D) || n.get("unstyled"),
            U = Q.wrapper,
            R = Q.element || n.get("unstyled").element,
            G = B.getDepth(),
            Y = "";
        if (s && (Y = s(B)), "li" === R) Y = l(Y, c(D, G, v !== U || null === E || G > E, T));
        var F = M || o,
            N = {
          className: Y,
          "data-block": !0,
          "data-editor": C,
          "data-offset-key": P,
          key: _
        };
        void 0 !== k && (N = r({}, N, {
          contentEditable: k,
          suppressContentEditableWarning: !0
        }));
        var j = A.createElement(R, N, A.createElement(F, K));
        y.push({
          block: j,
          wrapperTemplate: U,
          key: _,
          offsetKey: P
        }), E = U ? B.getDepth() : null, v = U;
      }

      for (var W = [], L = 0; L < y.length;) {
        var z = y[L];

        if (z.wrapperTemplate) {
          var X = [];

          do {
            X.push(y[L].block), L++;
          } while (L < y.length && y[L].wrapperTemplate === z.wrapperTemplate);

          var H = A.cloneElement(z.wrapperTemplate, {
            key: z.key + "-wrap",
            "data-offset-key": z.offsetKey
          }, X);
          W.push(H);
        } else W.push(z.block), L++;
      }

      return A.createElement("div", {
        "data-contents": "true"
      }, W);
    }, n;
  }(A.Component);

  e.exports = u;
}, function (e, n, t) {
  "use strict";

  var r = t(18);

  var o = t(141),
      i = t(0),
      A = t(40),
      s = t(4),
      l = t(147),
      a = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype._setSelection = function () {
      var e = this.props.selection;

      if (null != e && e.getHasFocus()) {
        var n = this.props,
            t = n.block,
            r = n.start,
            o = n.text,
            i = t.getKey(),
            a = r + o.length;

        if (e.hasEdgeWithin(i, r, a)) {
          var c = A.findDOMNode(this);
          c || s(!1);
          var u = c.firstChild;
          u || s(!1);
          var p = void 0;
          u.nodeType === Node.TEXT_NODE ? p = u : "BR" === u.tagName ? p = c : (p = u.firstChild) || s(!1), l(e, p, i, r, a);
        }
      }
    }, n.prototype.shouldComponentUpdate = function (e) {
      var n = A.findDOMNode(this.leaf);
      return n || s(!1), n.textContent !== e.text || e.styleSet !== this.props.styleSet || e.forceSelection;
    }, n.prototype.componentDidUpdate = function () {
      this._setSelection();
    }, n.prototype.componentDidMount = function () {
      this._setSelection();
    }, n.prototype.render = function () {
      var e = this,
          n = this.props.block,
          t = this.props.text;
      t.endsWith("\n") && this.props.isLast && (t += "\n");
      var A = this.props,
          s = A.customStyleMap,
          l = A.customStyleFn,
          a = A.offsetKey,
          c = A.styleSet,
          u = c.reduce(function (e, n) {
        var t = {},
            o = s[n];
        return void 0 !== o && e.textDecoration !== o.textDecoration && (t.textDecoration = [e.textDecoration, o.textDecoration].join(" ").trim()), r(e, o, t);
      }, {});

      if (l) {
        var p = l(c, n);
        u = r(u, p);
      }

      return i.createElement("span", {
        "data-offset-key": a,
        ref: function ref(n) {
          return e.leaf = n;
        },
        style: u
      }, i.createElement(o, null, t));
    }, n;
  }(i.Component);

  e.exports = a;
}, function (e, n, t) {
  "use strict";

  var r = t(0),
      o = t(40),
      i = t(24),
      A = t(4),
      s = i.isBrowser("IE <= 11");

  var l = s ? r.createElement("span", {
    key: "A",
    "data-text": "true"
  }, "\n") : r.createElement("br", {
    key: "A",
    "data-text": "true"
  }),
      a = s ? r.createElement("span", {
    key: "B",
    "data-text": "true"
  }, "\n") : r.createElement("br", {
    key: "B",
    "data-text": "true"
  }),
      c = function (e) {
    function n(t) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      var r = function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.call(this, t));

      return r._forceFlag = !1, r;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.shouldComponentUpdate = function (e) {
      var n = o.findDOMNode(this),
          t = "" === e.children;
      return n instanceof Element || A(!1), t ? !function (e) {
        return s ? "\n" === e.textContent : "BR" === e.tagName;
      }(n) : n.textContent !== e.children;
    }, n.prototype.componentDidMount = function () {
      this._forceFlag = !this._forceFlag;
    }, n.prototype.componentDidUpdate = function () {
      this._forceFlag = !this._forceFlag;
    }, n.prototype.render = function () {
      return "" === this.props.children ? this._forceFlag ? l : a : r.createElement("span", {
        key: this._forceFlag ? "A" : "B",
        "data-text": "true"
      }, this.props.children);
    }, n;
  }(r.Component);

  e.exports = c;
}, function (e, n, t) {
  "use strict";

  var r = t(143),
      o = "Unknown",
      i = {
    "Mac OS": "Mac OS X"
  };

  var A,
      s = new r().getResult(),
      l = function (e) {
    if (!e) return {
      major: "",
      minor: ""
    };
    var n = e.split(".");
    return {
      major: n[0],
      minor: n[1]
    };
  }(s.browser.version),
      a = {
    browserArchitecture: s.cpu.architecture || o,
    browserFullVersion: s.browser.version || o,
    browserMinorVersion: l.minor || o,
    browserName: s.browser.name || o,
    browserVersion: s.browser.major || o,
    deviceName: s.device.model || o,
    engineName: s.engine.name || o,
    engineVersion: s.engine.version || o,
    platformArchitecture: s.cpu.architecture || o,
    platformName: (A = s.os.name, i[A] || A || o),
    platformVersion: s.os.version || o,
    platformFullVersion: s.os.version || o
  };

  e.exports = a;
}, function (e, n, t) {
  var r;
  /*!
   * UAParser.js v0.7.20
   * Lightweight JavaScript-based User-Agent string parser
   * https://github.com/faisalman/ua-parser-js
   *
   * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
   * Licensed under MIT License
   */

  !function (o, i) {
    "use strict";

    var A = "model",
        s = "name",
        l = "type",
        a = "vendor",
        c = "version",
        u = "mobile",
        p = "tablet",
        m = {
      extend: function extend(e, n) {
        var t = {};

        for (var r in e) {
          n[r] && n[r].length % 2 == 0 ? t[r] = n[r].concat(e[r]) : t[r] = e[r];
        }

        return t;
      },
      has: function has(e, n) {
        return "string" == typeof e && -1 !== n.toLowerCase().indexOf(e.toLowerCase());
      },
      lowerize: function lowerize(e) {
        return e.toLowerCase();
      },
      major: function major(e) {
        return "string" == typeof e ? e.replace(/[^\d\.]/g, "").split(".")[0] : void 0;
      },
      trim: function trim(e) {
        return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      }
    },
        C = {
      rgx: function rgx(e, n) {
        for (var t, r, o, i, A, s, l = 0; l < n.length && !A;) {
          var a = n[l],
              c = n[l + 1];

          for (t = r = 0; t < a.length && !A;) {
            if (A = a[t++].exec(e)) for (o = 0; o < c.length; o++) {
              s = A[++r], "object" == typeof (i = c[o]) && i.length > 0 ? 2 == i.length ? "function" == typeof i[1] ? this[i[0]] = i[1].call(this, s) : this[i[0]] = i[1] : 3 == i.length ? "function" != typeof i[1] || i[1].exec && i[1].test ? this[i[0]] = s ? s.replace(i[1], i[2]) : void 0 : this[i[0]] = s ? i[1].call(this, s, i[2]) : void 0 : 4 == i.length && (this[i[0]] = s ? i[3].call(this, s.replace(i[1], i[2])) : void 0) : this[i] = s || void 0;
            }
          }

          l += 2;
        }
      },
      str: function str(e, n) {
        for (var t in n) {
          if ("object" == typeof n[t] && n[t].length > 0) {
            for (var r = 0; r < n[t].length; r++) {
              if (m.has(n[t][r], e)) return "?" === t ? void 0 : t;
            }
          } else if (m.has(n[t], e)) return "?" === t ? void 0 : t;
        }

        return e;
      }
    },
        d = {
      browser: {
        oldsafari: {
          version: {
            "1.0": "/8",
            1.2: "/1",
            1.3: "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
          }
        }
      },
      device: {
        amazon: {
          model: {
            "Fire Phone": ["SD", "KF"]
          }
        },
        sprint: {
          model: {
            "Evo Shift 4G": "7373KT"
          },
          vendor: {
            HTC: "APA",
            Sprint: "Sprint"
          }
        }
      },
      os: {
        windows: {
          version: {
            ME: "4.90",
            "NT 3.11": "NT3.51",
            "NT 4.0": "NT4.0",
            2e3: "NT 5.0",
            XP: ["NT 5.1", "NT 5.2"],
            Vista: "NT 6.0",
            7: "NT 6.1",
            8: "NT 6.2",
            8.1: "NT 6.3",
            10: ["NT 6.4", "NT 10.0"],
            RT: "ARM"
          }
        }
      }
    },
        f = {
      browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [s, c], [/(opios)[\/\s]+([\w\.]+)/i], [[s, "Opera Mini"], c], [/\s(opr)\/([\w\.]+)/i], [[s, "Opera"], c], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]*)/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i], [s, c], [/(konqueror)\/([\w\.]+)/i], [[s, "Konqueror"], c], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[s, "IE"], c], [/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i], [[s, "Edge"], c], [/(yabrowser)\/([\w\.]+)/i], [[s, "Yandex"], c], [/(puffin)\/([\w\.]+)/i], [[s, "Puffin"], c], [/(focus)\/([\w\.]+)/i], [[s, "Firefox Focus"], c], [/(opt)\/([\w\.]+)/i], [[s, "Opera Touch"], c], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [[s, "UCBrowser"], c], [/(comodo_dragon)\/([\w\.]+)/i], [[s, /_/g, " "], c], [/(windowswechat qbcore)\/([\w\.]+)/i], [[s, "WeChat(Win) Desktop"], c], [/(micromessenger)\/([\w\.]+)/i], [[s, "WeChat"], c], [/(brave)\/([\w\.]+)/i], [[s, "Brave"], c], [/(qqbrowserlite)\/([\w\.]+)/i], [s, c], [/(QQ)\/([\d\.]+)/i], [s, c], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i], [s, c], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i], [s, c], [/(2345Explorer)[\/\s]?([\w\.]+)/i], [s, c], [/(MetaSr)[\/\s]?([\w\.]+)/i], [s], [/(LBBROWSER)/i], [s], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [c, [s, "MIUI Browser"]], [/;fbav\/([\w\.]+);/i], [c, [s, "Facebook"]], [/safari\s(line)\/([\w\.]+)/i, /android.+(line)\/([\w\.]+)\/iab/i], [s, c], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [c, [s, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[s, /(.+)/, "$1 WebView"], c], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[s, /(.+(?:g|us))(.+)/, "$1 $2"], c], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i], [c, [s, "Android Browser"]], [/(sailfishbrowser)\/([\w\.]+)/i], [[s, "Sailfish Browser"], c], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [s, c], [/(dolfin)\/([\w\.]+)/i], [[s, "Dolphin"], c], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[s, "Chrome"], c], [/(coast)\/([\w\.]+)/i], [[s, "Opera Coast"], c], [/fxios\/([\w\.-]+)/i], [c, [s, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [c, [s, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [c, s], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [[s, "GSA"], c], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [s, [c, C.str, d.browser.oldsafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [s, c], [/(navigator|netscape)\/([\w\.-]+)/i], [[s, "Netscape"], c], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [s, c]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [["architecture", "amd64"]], [/(ia32(?=;))/i], [["architecture", m.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [["architecture", "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [["architecture", "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [["architecture", /ower/, "", m.lowerize]], [/(sun4\w)[;\)]/i], [["architecture", "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [["architecture", m.lowerize]]],
      device: [[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i], [A, a, [l, p]], [/applecoremedia\/[\w\.]+ \((ipad)/], [A, [a, "Apple"], [l, p]], [/(apple\s{0,1}tv)/i], [[A, "Apple TV"], [a, "Apple"]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(hp).+(tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [a, A, [l, p]], [/(kf[A-z]+)\sbuild\/.+silk\//i], [A, [a, "Amazon"], [l, p]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i], [[A, C.str, d.device.amazon.model], [a, "Amazon"], [l, u]], [/android.+aft([bms])\sbuild/i], [A, [a, "Amazon"], [l, "smarttv"]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [A, a, [l, u]], [/\((ip[honed|\s\w*]+);/i], [A, [a, "Apple"], [l, u]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [a, A, [l, u]], [/\(bb10;\s(\w+)/i], [A, [a, "BlackBerry"], [l, u]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i], [A, [a, "Asus"], [l, p]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[a, "Sony"], [A, "Xperia Tablet"], [l, p]], [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [A, [a, "Sony"], [l, u]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [a, A, [l, "console"]], [/android.+;\s(shield)\sbuild/i], [A, [a, "Nvidia"], [l, "console"]], [/(playstation\s[34portablevi]+)/i], [A, [a, "Sony"], [l, "console"]], [/(sprint\s(\w+))/i], [[a, C.str, d.device.sprint.vendor], [A, C.str, d.device.sprint.model], [l, u]], [/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [a, [A, /_/g, " "], [l, u]], [/(nexus\s9)/i], [A, [a, "HTC"], [l, p]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i], [A, [a, "Huawei"], [l, u]], [/(microsoft);\s(lumia[\s\w]+)/i], [a, A, [l, u]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [A, [a, "Microsoft"], [l, "console"]], [/(kin\.[onetw]{3})/i], [[A, /\./g, " "], [a, "Microsoft"], [l, u]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [A, [a, "Motorola"], [l, u]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [A, [a, "Motorola"], [l, p]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[a, m.trim], [A, m.trim], [l, "smarttv"]], [/hbbtv.+maple;(\d+)/i], [[A, /^/, "SmartTV"], [a, "Samsung"], [l, "smarttv"]], [/\(dtv[\);].+(aquos)/i], [A, [a, "Sharp"], [l, "smarttv"]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[a, "Samsung"], A, [l, p]], [/smart-tv.+(samsung)/i], [a, [l, "smarttv"], A], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[a, "Samsung"], A, [l, u]], [/sie-(\w*)/i], [A, [a, "Siemens"], [l, u]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i], [[a, "Nokia"], A, [l, u]], [/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i], [A, [a, "Acer"], [l, p]], [/android.+([vl]k\-?\d{3})\s+build/i], [A, [a, "LG"], [l, p]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[a, "LG"], A, [l, p]], [/(lg) netcast\.tv/i], [a, A, [l, "smarttv"]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [A, [a, "LG"], [l, u]], [/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i], [a, A, [l, p]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [A, [a, "Lenovo"], [l, p]], [/(lenovo)[_\s-]?([\w-]+)/i], [a, A, [l, u]], [/linux;.+((jolla));/i], [a, A, [l, u]], [/((pebble))app\/[\d\.]+\s/i], [a, A, [l, "wearable"]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [a, A, [l, u]], [/crkey/i], [[A, "Chromecast"], [a, "Google"]], [/android.+;\s(glass)\s\d/i], [A, [a, "Google"], [l, "wearable"]], [/android.+;\s(pixel c)[\s)]/i], [A, [a, "Google"], [l, p]], [/android.+;\s(pixel( [23])?( xl)?)[\s)]/i], [A, [a, "Google"], [l, u]], [/android.+;\s(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i], [[A, /_/g, " "], [a, "Xiaomi"], [l, u]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i], [[A, /_/g, " "], [a, "Xiaomi"], [l, p]], [/android.+;\s(m[1-5]\snote)\sbuild/i], [A, [a, "Meizu"], [l, u]], [/(mz)-([\w-]{2,})/i], [[a, "Meizu"], A, [l, u]], [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})\s+build/i], [A, [a, "OnePlus"], [l, u]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i], [A, [a, "RCA"], [l, p]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i], [A, [a, "Dell"], [l, p]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i], [A, [a, "Verizon"], [l, p]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i], [[a, "Barnes & Noble"], A, [l, p]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i], [A, [a, "NuVision"], [l, p]], [/android.+;\s(k88)\sbuild/i], [A, [a, "ZTE"], [l, p]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i], [A, [a, "Swiss"], [l, u]], [/android.+[;\/]\s*(zur\d{3})\s+build/i], [A, [a, "Swiss"], [l, p]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i], [A, [a, "Zeki"], [l, p]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i], [[a, "Dragon Touch"], A, [l, p]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i], [A, [a, "Insignia"], [l, p]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i], [A, [a, "NextBook"], [l, p]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[a, "Voice"], A, [l, u]], [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i], [[a, "LvTel"], A, [l, u]], [/android.+;\s(PH-1)\s/i], [A, [a, "Essential"], [l, u]], [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i], [A, [a, "Envizen"], [l, p]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i], [a, A, [l, p]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i], [A, [a, "MachSpeed"], [l, p]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i], [a, A, [l, p]], [/android.+[;\/]\s*TU_(1491)\s+build/i], [A, [a, "Rotor"], [l, p]], [/android.+(KS(.+))\s+build/i], [A, [a, "Amazon"], [l, p]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i], [a, A, [l, p]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[l, m.lowerize], a, A], [/[\s\/\(](smart-?tv)[;\)]/i], [[l, "smarttv"]], [/(android[\w\.\s\-]{0,9});.+build/i], [A, [a, "Generic"]]],
      engine: [[/windows.+\sedge\/([\w\.]+)/i], [c, [s, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)/i], [[s, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [s, c], [/rv\:([\w\.]{1,9}).+(gecko)/i], [c, s]],
      os: [[/microsoft\s(windows)\s(vista|xp)/i], [s, c], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [s, [c, C.str, d.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[s, "Windows"], [c, C.str, d.os.windows.version]], [/\((bb)(10);/i], [[s, "BlackBerry"], c], [/(blackberry)\w*\/?([\w\.]*)/i, /(tizen)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i], [s, c], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i], [[s, "Symbian"], c], [/\((series40);/i], [s], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[s, "Firefox OS"], c], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i], [s, c], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[s, "Chromium OS"], c], [/(sunos)\s?([\w\.\d]*)/i], [[s, "Solaris"], c], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i], [s, c], [/(haiku)\s(\w+)/i], [s, c], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i], [[c, /_/g, "."], [s, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i], [[s, "Mac OS"], [c, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, /(unix)\s?([\w\.]*)/i], [s, c]]
    },
        h = function h(e, n) {
      if ("object" == typeof e && (n = e, e = void 0), !(this instanceof h)) return new h(e, n).getResult();
      var t = e || (o && o.navigator && o.navigator.userAgent ? o.navigator.userAgent : ""),
          r = n ? m.extend(f, n) : f;
      return this.getBrowser = function () {
        var e = {
          name: void 0,
          version: void 0
        };
        return C.rgx.call(e, t, r.browser), e.major = m.major(e.version), e;
      }, this.getCPU = function () {
        var e = {
          architecture: void 0
        };
        return C.rgx.call(e, t, r.cpu), e;
      }, this.getDevice = function () {
        var e = {
          vendor: void 0,
          model: void 0,
          type: void 0
        };
        return C.rgx.call(e, t, r.device), e;
      }, this.getEngine = function () {
        var e = {
          name: void 0,
          version: void 0
        };
        return C.rgx.call(e, t, r.engine), e;
      }, this.getOS = function () {
        var e = {
          name: void 0,
          version: void 0
        };
        return C.rgx.call(e, t, r.os), e;
      }, this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function () {
        return t;
      }, this.setUA = function (e) {
        return t = e, this;
      }, this;
    };

    h.VERSION = "0.7.20", h.BROWSER = {
      NAME: s,
      MAJOR: "major",
      VERSION: c
    }, h.CPU = {
      ARCHITECTURE: "architecture"
    }, h.DEVICE = {
      MODEL: A,
      VENDOR: a,
      TYPE: l,
      CONSOLE: "console",
      MOBILE: u,
      SMARTTV: "smarttv",
      TABLET: p,
      WEARABLE: "wearable",
      EMBEDDED: "embedded"
    }, h.ENGINE = {
      NAME: s,
      VERSION: c
    }, h.OS = {
      NAME: s,
      VERSION: c
    }, void 0 !== n ? (void 0 !== e && e.exports && (n = e.exports = h), n.UAParser = h) : void 0 === (r = function () {
      return h;
    }.call(n, t, n, e)) || (e.exports = r);
    var x = o && (o.jQuery || o.Zepto);

    if (void 0 !== x && !x.ua) {
      var g = new h();
      x.ua = g.getResult(), x.ua.get = function () {
        return g.getUA();
      }, x.ua.set = function (e) {
        g.setUA(e);
        var n = g.getResult();

        for (var t in n) {
          x.ua[t] = n[t];
        }
      };
    }
  }("object" == typeof window ? window : this);
}, function (e, n, t) {
  "use strict";

  var r = t(4),
      o = /\./,
      i = /\|\|/,
      A = /\s+\-\s+/,
      s = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/,
      l = /^(\d*)(.*)/;

  function a(e, n) {
    var t = e.split(i);
    return t.length > 1 ? t.some(function (e) {
      return I.contains(e, n);
    }) : function (e, n) {
      var t = e.split(A);
      if (t.length > 0 && t.length <= 2 || r(!1), 1 === t.length) return c(t[0], n);
      var o = t[0],
          i = t[1];
      return d(o) && d(i) || r(!1), c(">=" + o, n) && c("<=" + i, n);
    }(e = t[0].trim(), n);
  }

  function c(e, n) {
    if ("" === (e = e.trim())) return !0;
    var t,
        r = n.split(o),
        i = m(e),
        A = i.modifier,
        s = i.rangeComponents;

    switch (A) {
      case "<":
        return u(r, s);

      case "<=":
        return -1 === (t = g(r, s)) || 0 === t;

      case ">=":
        return p(r, s);

      case ">":
        return function (e, n) {
          return 1 === g(e, n);
        }(r, s);

      case "~":
      case "~>":
        return function (e, n) {
          var t = n.slice(),
              r = n.slice();
          r.length > 1 && r.pop();
          var o = r.length - 1,
              i = parseInt(r[o], 10);
          C(i) && (r[o] = i + 1 + "");
          return p(e, t) && u(e, r);
        }(r, s);

      default:
        return function (e, n) {
          return 0 === g(e, n);
        }(r, s);
    }
  }

  function u(e, n) {
    return -1 === g(e, n);
  }

  function p(e, n) {
    var t = g(e, n);
    return 1 === t || 0 === t;
  }

  function m(e) {
    var n = e.split(o),
        t = n[0].match(s);
    return t || r(!1), {
      modifier: t[1],
      rangeComponents: [t[2]].concat(n.slice(1))
    };
  }

  function C(e) {
    return !isNaN(e) && isFinite(e);
  }

  function d(e) {
    return !m(e).modifier;
  }

  function f(e, n) {
    for (var t = e.length; t < n; t++) {
      e[t] = "0";
    }
  }

  function h(e, n) {
    var t = e.match(l)[1],
        r = n.match(l)[1],
        o = parseInt(t, 10),
        i = parseInt(r, 10);
    return C(o) && C(i) && o !== i ? x(o, i) : x(e, n);
  }

  function x(e, n) {
    return typeof e != typeof n && r(!1), e > n ? 1 : e < n ? -1 : 0;
  }

  function g(e, n) {
    for (var t = function (e, n) {
      f(e = e.slice(), (n = n.slice()).length);

      for (var t = 0; t < n.length; t++) {
        var r = n[t].match(/^[x*]$/i);
        if (r && (n[t] = e[t] = "0", "*" === r[0] && t === n.length - 1)) for (var o = t; o < e.length; o++) {
          e[o] = "0";
        }
      }

      return f(n, e.length), [e, n];
    }(e, n), r = t[0], o = t[1], i = 0; i < o.length; i++) {
      var A = h(r[i], o[i]);
      if (A) return A;
    }

    return 0;
  }

  var I = {
    contains: function contains(e, n) {
      return a(e.trim(), n.trim());
    }
  };
  e.exports = I;
}, function (e, n, t) {
  "use strict";

  var r = Object.prototype.hasOwnProperty;

  e.exports = function (e, n, t) {
    if (!e) return null;
    var o = {};

    for (var i in e) {
      r.call(e, i) && (o[i] = n.call(t, e[i], i, e));
    }

    return o;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    var n = {};
    return function (t) {
      return n.hasOwnProperty(t) || (n[t] = e.call(this, t)), n[t];
    };
  };
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(148),
        o = t(67),
        i = t(94),
        A = t(4);

    function s(e, n) {
      if (!e) return "[empty]";

      var t = function e(n, t) {
        var r = void 0 !== t ? t(n) : [];

        if (n.nodeType === Node.TEXT_NODE) {
          var o = n.textContent.length;
          return document.createTextNode("[text " + o + (r.length ? " | " + r.join(", ") : "") + "]");
        }

        var i = n.cloneNode();
        1 === i.nodeType && r.length && i.setAttribute("data-labels", r.join(", "));
        var A = n.childNodes;

        for (var s = 0; s < A.length; s++) {
          i.appendChild(e(A[s], t));
        }

        return i;
      }(e, n);

      return t.nodeType === Node.TEXT_NODE ? t.textContent : (t instanceof Element || A(!1), t.outerHTML);
    }

    function l(e, n) {
      for (var t = e; t;) {
        if (t instanceof Element && t.hasAttribute("contenteditable")) return s(t, n);
        t = t.parentNode;
      }

      return "Could not find contentEditable parent of node";
    }

    function a(e) {
      return null === e.nodeValue ? e.childNodes.length : e.nodeValue.length;
    }

    function c(e, n, t, A) {
      var s = i();

      if (e.extend && o(s, n)) {
        t > a(n) && r.logSelectionStateFailure({
          anonymizedDom: l(n),
          extraParams: JSON.stringify({
            offset: t
          }),
          selectionState: JSON.stringify(A.toJS())
        });
        var c = n === e.focusNode;

        try {
          e.extend(n, t);
        } catch (o) {
          throw r.logSelectionStateFailure({
            anonymizedDom: l(n, function (n) {
              var t = [];
              return n === s && t.push("active element"), n === e.anchorNode && t.push("selection anchor node"), n === e.focusNode && t.push("selection focus node"), t;
            }),
            extraParams: JSON.stringify({
              activeElementName: s ? s.nodeName : null,
              nodeIsFocus: n === e.focusNode,
              nodeWasFocus: c,
              selectionRangeCount: e.rangeCount,
              selectionAnchorNodeName: e.anchorNode ? e.anchorNode.nodeName : null,
              selectionAnchorOffset: e.anchorOffset,
              selectionFocusNodeName: e.focusNode ? e.focusNode.nodeName : null,
              selectionFocusOffset: e.focusOffset,
              message: o ? "" + o : null,
              offset: t
            }, null, 2),
            selectionState: JSON.stringify(A.toJS(), null, 2)
          }), o;
        }
      } else {
        var u = e.getRangeAt(0);
        u.setEnd(n, t), e.addRange(u.cloneRange());
      }
    }

    function u(e, n, t, o) {
      var i = document.createRange();
      t > a(n) && r.logSelectionStateFailure({
        anonymizedDom: l(n),
        extraParams: JSON.stringify({
          offset: t
        }),
        selectionState: JSON.stringify(o.toJS())
      }), i.setStart(n, t), e.addRange(i);
    }

    e.exports = function (e, t, r, i, A) {
      if (o(document.documentElement, t)) {
        var s = n.getSelection(),
            l = e.getAnchorKey(),
            a = e.getAnchorOffset(),
            p = e.getFocusKey(),
            m = e.getFocusOffset(),
            C = e.getIsBackward();

        if (!s.extend && C) {
          var d = l,
              f = a;
          l = p, a = m, p = d, m = f, C = !1;
        }

        var h = l === r && i <= a && A >= a,
            x = p === r && i <= m && A >= m;
        if (h && x) return s.removeAllRanges(), u(s, t, a - i, e), void c(s, t, m - i, e);

        if (C) {
          if (x && (s.removeAllRanges(), u(s, t, m - i, e)), h) {
            var g = s.focusNode,
                I = s.focusOffset;
            s.removeAllRanges(), u(s, t, a - i, e), c(s, g, I, e);
          }
        } else h && (s.removeAllRanges(), u(s, t, a - i, e)), x && c(s, t, m - i, e);
      }
    };
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  e.exports = {
    logSelectionStateFailure: function logSelectionStateFailure() {
      return null;
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = t(150);

  e.exports = function (e) {
    return r(e) && 3 == e.nodeType;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    var n = (e ? e.ownerDocument || e : document).defaultView || window;
    return !(!e || !("function" == typeof n.Node ? e instanceof n.Node : "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName));
  };
}, function (e, n, t) {
  "use strict";

  var r = t(152),
      o = t(153);

  function i(e) {
    return null == e ? e : String(e);
  }

  e.exports = function (e, n) {
    var t = void 0;
    if (window.getComputedStyle && (t = window.getComputedStyle(e, null))) return i(t.getPropertyValue(o(n)));

    if (document.defaultView && document.defaultView.getComputedStyle) {
      if (t = document.defaultView.getComputedStyle(e, null)) return i(t.getPropertyValue(o(n)));
      if ("display" === n) return "none";
    }

    return e.currentStyle ? i("float" === n ? e.currentStyle.cssFloat || e.currentStyle.styleFloat : e.currentStyle[r(n)]) : i(e.style && e.style[r(n)]);
  };
}, function (e, n, t) {
  "use strict";

  var r = /-(.)/g;

  e.exports = function (e) {
    return e.replace(r, function (e, n) {
      return n.toUpperCase();
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = /([A-Z])/g;

  e.exports = function (e) {
    return e.replace(r, "-$1").toLowerCase();
  };
}, function (e, n, t) {
  "use strict";

  var r = t(155);

  e.exports = function (e) {
    var n = r(e);
    return {
      x: n.left,
      y: n.top,
      width: n.right - n.left,
      height: n.bottom - n.top
    };
  };
}, function (e, n, t) {
  "use strict";

  var r = t(67);

  e.exports = function (e) {
    var n = e.ownerDocument.documentElement;
    if (!("getBoundingClientRect" in e && r(n, e))) return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    var t = e.getBoundingClientRect();
    return {
      left: Math.round(t.left) - n.clientLeft,
      right: Math.round(t.right) - n.clientLeft,
      top: Math.round(t.top) - n.clientTop,
      bottom: Math.round(t.bottom) - n.clientTop
    };
  };
}, function (e, n, t) {
  "use strict";

  var r = "undefined" != typeof navigator && navigator.userAgent.indexOf("AppleWebKit") > -1;

  e.exports = function (e) {
    return (e = e || document).scrollingElement ? e.scrollingElement : r || "CSS1Compat" !== e.compatMode ? e.body : e.documentElement;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    return e.Window && e instanceof e.Window ? {
      x: e.pageXOffset || e.document.documentElement.scrollLeft,
      y: e.pageYOffset || e.document.documentElement.scrollTop
    } : {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  };
}, function (e, n, t) {
  "use strict";

  function r() {
    var e = void 0;
    return document.documentElement && (e = document.documentElement.clientWidth), !e && document.body && (e = document.body.clientWidth), e || 0;
  }

  function o() {
    var e = void 0;
    return document.documentElement && (e = document.documentElement.clientHeight), !e && document.body && (e = document.body.clientHeight), e || 0;
  }

  function i() {
    return {
      width: window.innerWidth || r(),
      height: window.innerHeight || o()
    };
  }

  i.withoutScrollbars = function () {
    return {
      width: r(),
      height: o()
    };
  }, e.exports = i;
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    e || (e = "");
    var n = void 0,
        t = arguments.length;
    if (t > 1) for (var r = 1; r < t; r++) {
      (n = arguments[r]) && (e = (e ? e + " " : "") + n);
    }
    return e;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(96),
      o = t(16),
      i = t(7),
      A = t(70),
      s = t(98),
      l = t(99),
      a = t(39),
      c = t(23);
  var u = {
    onDragEnd: function onDragEnd(e) {
      e.exitCurrentMode();
    },
    onDrop: function onDrop(e, n) {
      var t = new r(n.nativeEvent.dataTransfer),
          u = e._latestEditorState,
          m = function (e, n) {
        var t = null,
            r = null;

        if ("function" == typeof document.caretRangeFromPoint) {
          var o = document.caretRangeFromPoint(e.x, e.y);
          t = o.startContainer, r = o.startOffset;
        } else {
          if (!e.rangeParent) return null;
          t = e.rangeParent, r = e.rangeOffset;
        }

        t = c(t), r = c(r);
        var i = c(A(t));
        return l(n, i, r, i, r);
      }(n.nativeEvent, u);

      if (n.preventDefault(), e.exitCurrentMode(), null != m) {
        var C = t.getFiles();

        if (C.length > 0) {
          if (e.props.handleDroppedFiles && a(e.props.handleDroppedFiles(m, C))) return;
          s(C, function (n) {
            n && e.update(p(u, m, n));
          });
        } else {
          var d = e._internalDrag ? "internal" : "external";
          e.props.handleDrop && a(e.props.handleDrop(m, t, d)) || (e._internalDrag ? e.update(function (e, n) {
            var t = o.moveText(e.getCurrentContent(), e.getSelection(), n);
            return i.push(e, t, "insert-fragment");
          }(u, m)) : e.update(p(u, m, t.getText())));
        }
      }
    }
  };

  function p(e, n, t) {
    var r = o.insertText(e.getCurrentContent(), n, t, e.getCurrentInlineStyle());
    return i.push(e, r, "insert-fragment");
  }

  e.exports = u;
}, function (e, n, t) {
  "use strict";

  var r = {
    isImage: function isImage(e) {
      return "image" === o(e)[0];
    },
    isJpeg: function isJpeg(e) {
      var n = o(e);
      return r.isImage(e) && ("jpeg" === n[1] || "pjpeg" === n[1]);
    }
  };

  function o(e) {
    return e.split("/");
  }

  e.exports = r;
}, function (e, n, t) {
  "use strict";

  var r = t(4);

  e.exports = function (e) {
    return function (e) {
      return !!e && ("object" == typeof e || "function" == typeof e) && "length" in e && !("setInterval" in e) && "number" != typeof e.nodeType && (Array.isArray(e) || "callee" in e || "item" in e);
    }(e) ? Array.isArray(e) ? e.slice() : function (e) {
      var n = e.length;
      if ((Array.isArray(e) || "object" != typeof e && "function" != typeof e) && r(!1), "number" != typeof n && r(!1), 0 === n || n - 1 in e || r(!1), "function" == typeof e.callee && r(!1), e.hasOwnProperty) try {
        return Array.prototype.slice.call(e);
      } catch (e) {}

      for (var t = Array(n), o = 0; o < n; o++) {
        t[o] = e[o];
      }

      return t;
    }(e) : [e];
  };
}, function (e, n, t) {
  "use strict";

  var r = {
    onBeforeInput: t(164),
    onBlur: t(166),
    onCompositionStart: t(167),
    onCopy: t(168),
    onCut: t(169),
    onDragOver: t(170),
    onDragStart: t(171),
    onFocus: t(172),
    onInput: t(173),
    onKeyDown: t(174),
    onPaste: t(188),
    onSelect: t(193)
  };
  e.exports = r;
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(88),
        o = t(16),
        i = t(7),
        A = t(24),
        s = t(66),
        l = t(39),
        a = t(92),
        c = t(23),
        u = t(165),
        p = "'",
        m = "/",
        C = A.isBrowser("Firefox");

    function d(e, n, t, r) {
      var A = o.replaceText(e.getCurrentContent(), e.getSelection(), n, t, r);
      return i.push(e, A, "insert-characters");
    }

    e.exports = function (e, t) {
      void 0 !== e._pendingStateFromBeforeInput && (e.update(e._pendingStateFromBeforeInput), e._pendingStateFromBeforeInput = void 0);
      var o = e._latestEditorState,
          A = t.data;
      if (A) if (e.props.handleBeforeInput && l(e.props.handleBeforeInput(A, o))) t.preventDefault();else {
        var f = o.getSelection(),
            h = f.getStartOffset(),
            x = f.getEndOffset(),
            g = f.getAnchorKey();
        if (!f.isCollapsed()) return t.preventDefault(), void (A === o.getCurrentContent().getPlainText().slice(h, x) ? e.update(i.forceSelection(o, f.merge({
          focusOffset: x
        }))) : e.update(d(o, A, o.getCurrentInlineStyle(), s(o.getCurrentContent(), o.getSelection()))));
        var I,
            b = d(o, A, o.getCurrentInlineStyle(), s(o.getCurrentContent(), o.getSelection())),
            y = !1;

        if (y || (y = a(e._latestCommittedEditorState)), !y) {
          var E = n.getSelection();

          if (E.anchorNode && E.anchorNode.nodeType === Node.TEXT_NODE) {
            var v = E.anchorNode.parentNode;
            y = "SPAN" === v.nodeName && v.firstChild.nodeType === Node.TEXT_NODE && -1 !== v.firstChild.nodeValue.indexOf("\t");
          }
        }

        if (!y) y = r.getFingerprint(o.getBlockTree(g)) !== r.getFingerprint(b.getBlockTree(g));
        if (y || (I = A, y = C && (I == p || I == m)), y || (y = c(b.getDirectionMap()).get(g) !== c(o.getDirectionMap()).get(g)), y) return t.preventDefault(), void e.update(b);
        b = i.set(b, {
          nativelyRenderedContent: b.getCurrentContent()
        }), e._pendingStateFromBeforeInput = b, u(function () {
          void 0 !== e._pendingStateFromBeforeInput && (e.update(e._pendingStateFromBeforeInput), e._pendingStateFromBeforeInput = void 0);
        });
      }
    };
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  (function (n) {
    t(45), e.exports = n.setImmediate;
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(7),
        o = t(67),
        i = t(94);

    e.exports = function (e, t) {
      if (i() === document.body) {
        var A = n.getSelection(),
            s = e.editor;
        1 === A.rangeCount && o(s, A.anchorNode) && o(s, A.focusNode) && A.removeAllRanges();
      }

      var l = e._latestEditorState,
          a = l.getSelection();

      if (a.getHasFocus()) {
        var c = a.set("hasFocus", !1);
        e.props.onBlur && e.props.onBlur(t), e.update(r.acceptSelection(l, c));
      }
    };
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  var r = t(7);

  e.exports = function (e, n) {
    e.setMode("composite"), e.update(r.set(e._latestEditorState, {
      inCompositionMode: !0
    })), e._onCompositionStart(n);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(100);

  e.exports = function (e, n) {
    e._latestEditorState.getSelection().isCollapsed() ? n.preventDefault() : e.setClipboard(r(e._latestEditorState));
  };
}, function (e, n, t) {
  "use strict";

  var r = t(16),
      o = t(7),
      i = t(68),
      A = t(100),
      s = t(69);

  e.exports = function (e, n) {
    var t = e._latestEditorState,
        l = t.getSelection(),
        a = n.target,
        c = void 0;
    if (l.isCollapsed()) n.preventDefault();else {
      a instanceof Node && (c = s(i.getScrollParent(a)));
      var u = A(t);
      e.setClipboard(u), e.setMode("cut"), setTimeout(function () {
        e.restoreEditorDOM(c), e.exitCurrentMode(), e.update(function (e) {
          var n = r.removeRange(e.getCurrentContent(), e.getSelection(), "forward");
          return o.push(e, n, "remove-range");
        }(t));
      }, 0);
    }
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e, n) {
    e._internalDrag = !1, e.setMode("drag"), n.preventDefault();
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    e._internalDrag = !0, e.setMode("drag");
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7),
      o = t(24);

  e.exports = function (e, n) {
    var t = e._latestEditorState,
        i = t.getSelection();

    if (!i.getHasFocus()) {
      var A = i.set("hasFocus", !0);
      e.props.onFocus && e.props.onFocus(n), o.isBrowser("Chrome < 60.0.3081.0") ? e.update(r.forceSelection(t, A)) : e.update(r.acceptSelection(t, A));
    }
  };
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(27),
        o = t(16),
        i = t(53),
        A = t(7),
        s = t(24),
        l = t(70),
        a = t(23),
        c = s.isEngine("Gecko"),
        u = "\n\n";

    e.exports = function (e) {
      void 0 !== e._pendingStateFromBeforeInput && (e.update(e._pendingStateFromBeforeInput), e._pendingStateFromBeforeInput = void 0);
      var t = n.getSelection(),
          s = t.anchorNode,
          p = t.isCollapsed,
          m = s.nodeType !== Node.TEXT_NODE,
          C = s.nodeType !== Node.TEXT_NODE && s.nodeType !== Node.ELEMENT_NODE;

      if (r.draft_killswitch_allow_nontextnodes) {
        if (m) return;
      } else if (C) return;

      if (s.nodeType === Node.TEXT_NODE && (null !== s.previousSibling || null !== s.nextSibling)) {
        var d = s.parentNode;
        s.nodeValue = d.textContent;

        for (var f = d.firstChild; null !== f; f = f.nextSibling) {
          f !== s && d.removeChild(f);
        }
      }

      var h = s.textContent,
          x = e._latestEditorState,
          g = a(l(s)),
          I = i.decode(g),
          b = I.blockKey,
          y = I.decoratorKey,
          E = I.leafKey,
          v = x.getBlockTree(b).getIn([y, "leaves", E]),
          w = v.start,
          B = v.end,
          _ = x.getCurrentContent(),
          D = _.getBlockForKey(b),
          S = D.getText().slice(w, B);

      if (h.endsWith(u) && (h = h.slice(0, -1)), h !== S) {
        var M,
            O,
            k,
            T,
            P = x.getSelection(),
            K = P.merge({
          anchorOffset: w,
          focusOffset: B,
          isBackward: !1
        }),
            Q = D.getEntityAt(w),
            U = Q && _.getEntity(Q),
            R = "MUTABLE" === (U && U.getMutability()),
            G = R ? "spellcheck-change" : "apply-entity",
            Y = o.replaceText(_, K, h, D.getInlineStyleAt(w), R ? D.getEntityAt(w) : null);

        if (c) M = t.anchorOffset, O = t.focusOffset, T = (k = w + Math.min(M, O)) + Math.abs(M - O), M = k, O = T;else {
          var F = h.length - S.length;
          k = P.getStartOffset(), T = P.getEndOffset(), M = p ? T + F : k, O = T + F;
        }
        var N = Y.merge({
          selectionBefore: _.getSelectionAfter(),
          selectionAfter: P.merge({
            anchorOffset: M,
            focusOffset: O
          })
        });
        e.update(A.push(x, N, G));
      }
    };
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  var r = t(16),
      o = t(7),
      i = t(71),
      A = t(65),
      s = t(175),
      l = t(24),
      a = t(39),
      c = t(176),
      u = t(178),
      p = t(180),
      m = t(181),
      C = t(182),
      d = t(183),
      f = t(184),
      h = t(185),
      x = t(186),
      g = t(187),
      I = i.isOptionKeyCommand,
      b = l.isBrowser("Chrome");

  e.exports = function (e, n) {
    var t = n.which,
        i = e._latestEditorState;

    switch (t) {
      case A.RETURN:
        if (n.preventDefault(), e.props.handleReturn && a(e.props.handleReturn(n, i))) return;
        break;

      case A.ESC:
        return n.preventDefault(), void (e.props.onEscape && e.props.onEscape(n));

      case A.TAB:
        return void (e.props.onTab && e.props.onTab(n));

      case A.UP:
        return void (e.props.onUpArrow && e.props.onUpArrow(n));

      case A.RIGHT:
        return void (e.props.onRightArrow && e.props.onRightArrow(n));

      case A.DOWN:
        return void (e.props.onDownArrow && e.props.onDownArrow(n));

      case A.LEFT:
        return void (e.props.onLeftArrow && e.props.onLeftArrow(n));

      case A.SPACE:
        if (b && I(n)) {
          n.preventDefault();
          var l = r.replaceText(i.getCurrentContent(), i.getSelection(), " ");
          return void e.update(o.push(i, l, "insert-characters"));
        }

    }

    var y = e.props.keyBindingFn(n);
    if (y) if ("undo" !== y) {
      if (n.preventDefault(), !e.props.handleKeyCommand || !a(e.props.handleKeyCommand(y, i))) {
        var E = function (e, n) {
          switch (e) {
            case "redo":
              return o.redo(n);

            case "delete":
              return h(n);

            case "delete-word":
              return p(n);

            case "backspace":
              return f(n);

            case "backspace-word":
              return u(n);

            case "backspace-to-start-of-line":
              return c(n);

            case "split-block":
              return m(n);

            case "transpose-characters":
              return x(n);

            case "move-selection-to-start-of-block":
              return d(n);

            case "move-selection-to-end-of-block":
              return C(n);

            case "secondary-cut":
              return s.cut(n);

            case "secondary-paste":
              return s.paste(n);

            default:
              return n;
          }
        }(y, i);

        E !== i && e.update(E);
      }
    } else g(n, i, e.update);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(16),
      o = t(7),
      i = t(51),
      A = t(23),
      s = null,
      l = {
    cut: function cut(e) {
      var n = e.getCurrentContent(),
          t = e.getSelection(),
          l = null;

      if (t.isCollapsed()) {
        var a = t.getAnchorKey(),
            c = n.getBlockForKey(a).getLength();
        if (c === t.getAnchorOffset()) return e;
        l = t.set("focusOffset", c);
      } else l = t;

      l = A(l), s = i(n, l);
      var u = r.removeRange(n, l, "forward");
      return u === n ? e : o.push(e, u, "remove-range");
    },
    paste: function paste(e) {
      if (!s) return e;
      var n = r.replaceWithFragment(e.getCurrentContent(), e.getSelection(), s);
      return o.push(e, n, "insert-fragment");
    }
  };
  e.exports = l;
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(7),
        o = t(177),
        i = t(102),
        A = t(72),
        s = t(41);

    e.exports = function (e) {
      var t = s(e, function (e) {
        var t = e.getSelection();
        if (t.isCollapsed() && 0 === t.getAnchorOffset()) return A(e, 1);
        var r = n.getSelection().getRangeAt(0);
        return r = o(r), i(e, null, r.endContainer, r.endOffset, r.startContainer, r.startOffset).selectionState;
      }, "backward");
      return t === e.getCurrentContent() ? e : r.push(e, t, "remove-range");
    };
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  var r = t(30),
      o = t(101),
      i = t(4);

  function A(e, n) {
    for (var t = 1 / 0, r = 1 / 0, o = -1 / 0, i = -1 / 0, A = 0; A < e.length; A++) {
      var s = e[A];
      0 !== s.width && 1 !== s.width && (t = Math.min(t, s.top), r = Math.min(r, s.bottom), o = Math.max(o, s.top), i = Math.max(i, s.bottom));
    }

    return o <= r && o - t < n && i - r < n;
  }

  function s(e) {
    switch (e.nodeType) {
      case Node.DOCUMENT_TYPE_NODE:
        return 0;

      case Node.TEXT_NODE:
      case Node.PROCESSING_INSTRUCTION_NODE:
      case Node.COMMENT_NODE:
        return e.length;

      default:
        return e.childNodes.length;
    }
  }

  e.exports = function (e) {
    e.collapsed || i(!1);
    var n = (e = e.cloneRange()).startContainer;
    1 !== n.nodeType && (n = n.parentNode);

    var t = function (e) {
      var n = getComputedStyle(e),
          t = document.createElement("div");
      t.style.fontFamily = n.fontFamily, t.style.fontSize = n.fontSize, t.style.fontStyle = n.fontStyle, t.style.fontWeight = n.fontWeight, t.style.lineHeight = n.lineHeight, t.style.position = "absolute", t.textContent = "M";
      var r = document.body;
      r || i(!1), r.appendChild(t);
      var o = t.getBoundingClientRect();
      return r.removeChild(t), o.height;
    }(n),
        l = e.endContainer,
        a = e.endOffset;

    for (e.setStart(e.startContainer, 0); A(o(e), t) && (l = e.startContainer, a = e.startOffset, l.parentNode || i(!1), e.setStartBefore(l), 1 !== l.nodeType || "inline" === getComputedStyle(l).display);) {
      ;
    }

    for (var c = l, u = a - 1;;) {
      for (var p = c.nodeValue, m = u; m >= 0; m--) {
        if (!(null != p && m > 0 && r.isSurrogatePair(p, m - 1))) {
          if (e.setStart(c, m), !A(o(e), t)) break;
          l = c, a = m;
        }
      }

      if (-1 === m || 0 === c.childNodes.length) break;
      u = s(c = c.childNodes[m]);
    }

    return e.setStart(l, a), e;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(103),
      o = t(7),
      i = t(72),
      A = t(41);

  e.exports = function (e) {
    var n = A(e, function (e) {
      var n = e.getSelection(),
          t = n.getStartOffset();
      if (0 === t) return i(e, 1);
      var o = n.getStartKey(),
          A = e.getCurrentContent().getBlockForKey(o).getText().slice(0, t),
          s = r.getBackward(A);
      return i(e, s.length || 1);
    }, "backward");
    return n === e.getCurrentContent() ? e : o.push(e, n, "remove-range");
  };
}, function (e, n, t) {
  "use strict";

  e.exports = {
    getPunctuation: function getPunctuation() {
      return "[.,+*?$|#{}()'\\^\\-\\[\\]\\\\\\/!@%\"~=<>_:;・、。〈-】〔-〟：-？！-／［-｀｛-･⸮؟٪-٬؛،؍﴾﴿᠁।၊။‐-‧‰-⁞¡-±´-¸º»¿]";
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = t(103),
      o = t(7),
      i = t(104),
      A = t(41);

  e.exports = function (e) {
    var n = A(e, function (e) {
      var n = e.getSelection(),
          t = n.getStartOffset(),
          o = n.getStartKey(),
          A = e.getCurrentContent().getBlockForKey(o).getText().slice(t),
          s = r.getForward(A);
      return i(e, s.length || 1);
    }, "forward");
    return n === e.getCurrentContent() ? e : o.push(e, n, "remove-range");
  };
}, function (e, n, t) {
  "use strict";

  var r = t(16),
      o = t(7);

  e.exports = function (e) {
    var n = r.splitBlock(e.getCurrentContent(), e.getSelection());
    return o.push(e, n, "split-block");
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7);

  e.exports = function (e) {
    var n = e.getSelection(),
        t = n.getEndKey(),
        o = e.getCurrentContent().getBlockForKey(t).getLength();
    return r.set(e, {
      selection: n.merge({
        anchorKey: t,
        anchorOffset: o,
        focusKey: t,
        focusOffset: o,
        isBackward: !1
      }),
      forceSelection: !0
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7);

  e.exports = function (e) {
    var n = e.getSelection(),
        t = n.getStartKey();
    return r.set(e, {
      selection: n.merge({
        anchorKey: t,
        anchorOffset: 0,
        focusKey: t,
        focusOffset: 0,
        isBackward: !1
      }),
      forceSelection: !0
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7),
      o = t(30),
      i = t(72),
      A = t(41);

  e.exports = function (e) {
    var n = A(e, function (e) {
      var n = e.getSelection(),
          t = e.getCurrentContent(),
          r = n.getAnchorKey(),
          A = n.getAnchorOffset(),
          s = t.getBlockForKey(r).getText()[A - 1];
      return i(e, s ? o.getUTF16Length(s, 0) : 1);
    }, "backward");
    if (n === e.getCurrentContent()) return e;
    var t = e.getSelection();
    return r.push(e, n.set("selectionBefore", t), t.isCollapsed() ? "backspace-character" : "remove-range");
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7),
      o = t(30),
      i = t(104),
      A = t(41);

  e.exports = function (e) {
    var n = A(e, function (e) {
      var n = e.getSelection(),
          t = e.getCurrentContent(),
          r = n.getAnchorKey(),
          A = n.getAnchorOffset(),
          s = t.getBlockForKey(r).getText()[A];
      return i(e, s ? o.getUTF16Length(s, 0) : 1);
    }, "forward");
    if (n === e.getCurrentContent()) return e;
    var t = e.getSelection();
    return r.push(e, n.set("selectionBefore", t), t.isCollapsed() ? "delete-character" : "remove-range");
  };
}, function (e, n, t) {
  "use strict";

  var r = t(16),
      o = t(7),
      i = t(51);

  e.exports = function (e) {
    var n = e.getSelection();
    if (!n.isCollapsed()) return e;
    var t = n.getAnchorOffset();
    if (0 === t) return e;
    var A,
        s,
        l = n.getAnchorKey(),
        a = e.getCurrentContent(),
        c = a.getBlockForKey(l).getLength();
    if (c <= 1) return e;
    t === c ? (A = n.set("anchorOffset", t - 1), s = n) : s = (A = n.set("focusOffset", t + 1)).set("anchorOffset", t + 1);
    var u = i(a, A),
        p = r.removeRange(a, A, "backward"),
        m = p.getSelectionAfter(),
        C = m.getAnchorOffset() - 1,
        d = m.merge({
      anchorOffset: C,
      focusOffset: C
    }),
        f = r.replaceWithFragment(p, d, u),
        h = o.push(e, f, "insert-fragment");
    return o.acceptSelection(h, s);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7);

  e.exports = function (e, n, t) {
    var o = r.undo(n);
    if ("spellcheck-change" !== n.getLastChangeType()) e.preventDefault(), n.getNativelyRenderedContent() ? (t(r.set(n, {
      nativelyRenderedContent: null
    })), setTimeout(function () {
      t(o);
    }, 0)) : t(o);else {
      var i = o.getCurrentContent();
      t(r.set(o, {
        nativelyRenderedContent: i
      }));
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = t(37),
      o = t(19),
      i = t(96),
      A = t(16),
      s = t(189),
      l = t(7),
      a = t(107),
      c = t(66),
      u = t(98),
      p = t(39),
      m = t(192);

  function C(e, n, t) {
    var r = A.replaceWithFragment(e.getCurrentContent(), e.getSelection(), n);
    return l.push(e, r.set("entityMap", t), "insert-fragment");
  }

  e.exports = function (e, n) {
    n.preventDefault();
    var t = new i(n.clipboardData);

    if (!t.isRichText()) {
      var d = t.getFiles(),
          f = t.getText();

      if (d.length > 0) {
        if (e.props.handlePastedFiles && p(e.props.handlePastedFiles(d))) return;
        return void u(d, function (n) {
          if (n = n || f) {
            var t = e._latestEditorState,
                i = m(n),
                u = o.create({
              style: t.getCurrentInlineStyle(),
              entity: c(t.getCurrentContent(), t.getSelection())
            }),
                p = a.getCurrentBlockType(t),
                C = s.processText(i, u, p),
                d = r.createFromArray(C),
                h = A.replaceWithFragment(t.getCurrentContent(), t.getSelection(), d);
            e.update(l.push(t, h, "insert-fragment"));
          }
        });
      }
    }

    var h = [],
        x = t.getText(),
        g = t.getHTML(),
        I = e._latestEditorState;

    if (!e.props.handlePastedText || !p(e.props.handlePastedText(x, g, I))) {
      if (x && (h = m(x)), !e.props.stripPastedStyles) {
        var b = e.getClipboard();

        if (t.isRichText() && b) {
          if (-1 !== g.indexOf(e.getEditorKey()) || 1 === h.length && 1 === b.size && b.first().getText() === x) return void e.update(C(e._latestEditorState, b));
        } else if (b && t.types.includes("com.apple.webarchive") && !t.types.includes("text/html") && function (e, n) {
          return e.length === n.size && n.valueSeq().every(function (n, t) {
            return n.getText() === e[t];
          });
        }(h, b)) return void e.update(C(e._latestEditorState, b));

        if (g) {
          var y = s.processHTML(g, e.props.blockRenderMap);

          if (y) {
            var E = y.contentBlocks,
                v = y.entityMap;

            if (E) {
              var w = r.createFromArray(E);
              return void e.update(C(e._latestEditorState, w, v));
            }
          }
        }

        e.setClipboard(null);
      }

      if (h.length) {
        var B = o.create({
          style: I.getCurrentInlineStyle(),
          entity: c(I.getCurrentContent(), I.getSelection())
        }),
            _ = a.getCurrentBlockType(I),
            D = s.processText(h, B, _),
            S = r.createFromArray(D);

        e.update(C(e._latestEditorState, S));
      }
    }
  };
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      o = (t(19), t(29)),
      i = t(21),
      A = t(27),
      s = t(3),
      l = t(105),
      a = t(25),
      c = t(106),
      u = t(62),
      p = s.List,
      m = s.Repeat,
      C = A.draft_tree_data_support,
      d = C ? i : o,
      f = {
    processHTML: function processHTML(e, n) {
      return l(e, c, n);
    },
    processText: function processText(e, n, t) {
      return e.reduce(function (e, o, i) {
        o = u(o);
        var A = a(),
            s = {
          key: A,
          type: t,
          text: o,
          characterList: p(m(n, o.length))
        };

        if (C && 0 !== i) {
          var l = i - 1,
              c = e[l] = e[l].merge({
            nextSibling: A
          });
          s = r({}, s, {
            prevSibling: c.getKey()
          });
        }

        return e.push(new d(s)), e;
      }, []);
    }
  };

  e.exports = f;
}, function (e, n, t) {
  "use strict";

  var r = function () {
    function e(n) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this._uri = n;
    }

    return e.prototype.toString = function () {
      return this._uri;
    }, e;
  }();

  e.exports = r;
}, function (e, n, t) {
  "use strict";

  e.exports = function (e, n, t, r) {
    var o = n.getStartKey(),
        i = n.getEndKey(),
        A = e.getBlockMap(),
        s = A.toSeq().skipUntil(function (e, n) {
      return n === o;
    }).takeUntil(function (e, n) {
      return n === i;
    }).concat([[i, A.get(i)]]).map(function (e) {
      var n = e.getDepth() + t;
      return n = Math.max(0, Math.min(n, r)), e.set("depth", n);
    });
    return A = A.merge(s), e.merge({
      blockMap: A,
      selectionBefore: n,
      selectionAfter: n
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = /\r\n?|\n/g;

  e.exports = function (e) {
    return e.split(r);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7),
      o = t(40),
      i = t(194),
      A = t(4);

  e.exports = function (e) {
    if (!e._blockSelectEvents && e._latestEditorState === e.props.editorState) {
      var n = e.props.editorState,
          t = o.findDOMNode(e.editorContainer);
      t || A(!1), t.firstChild instanceof HTMLElement || A(!1);
      var s = i(n, t.firstChild),
          l = s.selectionState;
      l !== n.getSelection() && (n = s.needsRecovery ? r.forceSelection(n, l) : r.acceptSelection(n, l), e.update(n));
    }
  };
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(102);

    e.exports = function (e, t) {
      var o = n.getSelection();
      return 0 === o.rangeCount ? {
        selectionState: e.getSelection().set("hasFocus", !1),
        needsRecovery: !1
      } : r(e, t, o.anchorNode, o.anchorOffset, o.focusNode, o.focusOffset);
    };
  }).call(this, t(12));
}, function (e, n, t) {
  "use strict";

  var r = t(0),
      o = t(35),
      i = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.shouldComponentUpdate = function (e) {
      return this.props.text !== e.text || this.props.editorState.getSelection().getHasFocus() !== e.editorState.getSelection().getHasFocus();
    }, n.prototype.render = function () {
      var e = this.props.editorState.getSelection().getHasFocus(),
          n = o({
        "public/DraftEditorPlaceholder/root": !0,
        "public/DraftEditorPlaceholder/hasFocus": e
      });
      return r.createElement("div", {
        className: n
      }, r.createElement("div", {
        className: o("public/DraftEditorPlaceholder/inner"),
        id: this.props.accessibilityID,
        style: {
          whiteSpace: "pre-wrap"
        }
      }, this.props.text));
    }, n;
  }(r.Component);

  e.exports = i;
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      o = t(29),
      i = t(21),
      A = t(109),
      s = t(197),
      l = t(198),
      a = t(4),
      c = function c(e, n) {
    return {
      key: e.getKey(),
      text: e.getText(),
      type: e.getType(),
      depth: e.getDepth(),
      inlineStyleRanges: l(e),
      entityRanges: s(e, n),
      data: e.getData().toObject()
    };
  },
      u = function u(e, n) {
    var t = n.entityMap,
        s = [],
        l = {},
        u = {},
        p = 0;
    return e.getBlockMap().forEach(function (e) {
      e.findEntityRanges(function (e) {
        return null !== e.getEntity();
      }, function (n) {
        var r = e.getEntityAt(n),
            o = A.stringify(r);
        u[o] || (u[o] = r, t[o] = "" + p, p++);
      }), function (e, n, t, A) {
        if (e instanceof o) t.push(c(e, n));else {
          e instanceof i || a(!1);
          var s = e.getParentKey(),
              l = A[e.getKey()] = r({}, c(e, n), {
            children: []
          });
          s ? A[s].children.push(l) : t.push(l);
        }
      }(e, t, s, l);
    }), {
      blocks: s,
      entityMap: t
    };
  };

  e.exports = function (e) {
    var n = {
      entityMap: {},
      blocks: []
    };
    return n = function (e, n) {
      var t = n.blocks,
          r = n.entityMap,
          o = {};
      return Object.keys(r).forEach(function (n, t) {
        var r = e.getEntity(A.unstringify(n));
        o[t] = {
          type: r.getType(),
          mutability: r.getMutability(),
          data: r.getData()
        };
      }), {
        blocks: t,
        entityMap: o
      };
    }(e, n = u(e, n));
  };
}, function (e, n, t) {
  "use strict";

  var r = t(109),
      o = t(30).strlen;

  e.exports = function (e, n) {
    var t = [];
    return e.findEntityRanges(function (e) {
      return !!e.getEntity();
    }, function (i, A) {
      var s = e.getText(),
          l = e.getEntityAt(i);
      t.push({
        offset: o(s.slice(0, i)),
        length: o(s.slice(i, A)),
        key: Number(n[r.stringify(l)])
      });
    }), t;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(30),
      o = t(38),
      i = function i(e, n) {
    return e === n;
  },
      A = function A(e) {
    return !!e;
  },
      s = [];

  e.exports = function (e) {
    var n = e.getCharacterList().map(function (e) {
      return e.getStyle();
    }).toList(),
        t = n.flatten().toSet().map(function (t) {
      return function (e, n, t) {
        var s = [],
            l = n.map(function (e) {
          return e.has(t);
        }).toList();
        return o(l, i, A, function (n, o) {
          var i = e.getText();
          s.push({
            offset: r.strlen(i.slice(0, n)),
            length: r.strlen(i.slice(n, o)),
            style: t
          });
        }), s;
      }(e, n, t);
    });
    return Array.prototype.concat.apply(s, t.toJS());
  };
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      o = t(29),
      i = t(21),
      A = t(61),
      s = t(52),
      l = t(27),
      a = t(200),
      c = t(3),
      u = t(34),
      p = t(201),
      m = t(202),
      C = t(203),
      d = t(25),
      f = t(4),
      h = l.draft_tree_data_support,
      x = c.List,
      g = c.Map,
      I = c.OrderedMap,
      b = function b(e, n) {
    var t = e.key,
        r = e.type,
        o = e.data;
    return {
      text: e.text,
      depth: e.depth || 0,
      type: r || "unstyled",
      key: t || d(),
      data: g(o),
      characterList: y(e, n)
    };
  },
      y = function y(e, n) {
    var t = e.text,
        o = e.entityRanges,
        i = e.inlineStyleRanges,
        A = o || [];
    return p(C(t, i || []), m(t, A.filter(function (e) {
      return n.hasOwnProperty(e.key);
    }).map(function (e) {
      return r({}, e, {
        key: n[e.key]
      });
    })));
  },
      E = function E(e) {
    return r({}, e, {
      key: e.key || d()
    });
  },
      v = function v(e, n, t) {
    var o = n.map(function (e) {
      return r({}, e, {
        parentRef: t
      });
    });
    return e.concat(o.reverse());
  },
      w = function w(e, n) {
    var t = Array.isArray(e.blocks[0].children),
        A = h && !t ? a.fromRawStateToRawTreeState(e).blocks : e.blocks;
    return h ? function (e, n) {
      return e.map(E).reduce(function (t, o, A) {
        Array.isArray(o.children) || f(!1);
        var s = o.children.map(E),
            l = new i(r({}, b(o, n), {
          prevSibling: 0 === A ? null : e[A - 1].key,
          nextSibling: A === e.length - 1 ? null : e[A + 1].key,
          children: x(s.map(function (e) {
            return e.key;
          }))
        }));
        t = t.set(l.getKey(), l);

        for (var a = v([], s, l); a.length > 0;) {
          var c = a.pop(),
              u = c.parentRef,
              p = u.getChildKeys(),
              m = p.indexOf(c.key),
              C = Array.isArray(c.children);

          if (!C) {
            C || f(!1);
            break;
          }

          var d = c.children.map(E),
              h = new i(r({}, b(c, n), {
            parent: u.getKey(),
            children: x(d.map(function (e) {
              return e.key;
            })),
            prevSibling: 0 === m ? null : p.get(m - 1),
            nextSibling: m === p.size - 1 ? null : p.get(m + 1)
          }));
          t = t.set(h.getKey(), h), a = v(a, d, h);
        }

        return t;
      }, I());
    }(A, n) : function (e, n) {
      return I(e.map(function (e) {
        var t = new o(b(e, n));
        return [t.getKey(), t];
      }));
    }(t ? a.fromRawTreeStateToRawState(e).blocks : A, n);
  };

  e.exports = function (e) {
    Array.isArray(e.blocks) || f(!1);

    var n = function (e) {
      var n = e.entityMap,
          t = {};
      return Object.keys(n).forEach(function (e) {
        var r = n[e],
            o = r.type,
            i = r.mutability,
            A = r.data;
        t[e] = s.__create(o, i, A || {});
      }), t;
    }(e),
        t = w(e, n),
        r = t.isEmpty() ? new u() : u.createEmpty(t.first().getKey());

    return new A({
      blockMap: t,
      entityMap: n,
      selectionBefore: r,
      selectionAfter: r
    });
  };
}, function (e, n, t) {
  "use strict";

  var r = t(18) || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      o = t(4),
      i = function i(e) {
    if (!e || !e.type) return !1;
    var n = e.type;
    return "unordered-list-item" === n || "ordered-list-item" === n;
  },
      A = {
    fromRawTreeStateToRawState: function fromRawTreeStateToRawState(e) {
      var n = e.blocks,
          t = [];
      return Array.isArray(n) || o(!1), Array.isArray(n) && n.length ? (function (e, n) {
        for (var t = [].concat(e).reverse(); t.length;) {
          var r = t.pop();
          n(r);
          var i = r.children;
          Array.isArray(i) || o(!1), t = t.concat([].concat(i.reverse()));
        }
      }(n, function (e) {
        var n = r({}, e);
        i(e) && (n.depth = n.depth || 0, function (e) {
          Array.isArray(e.children) && (e.children = e.children.map(function (n) {
            return n.type === e.type ? r({}, n, {
              depth: (e.depth || 0) + 1
            }) : n;
          }));
        }(e)), delete n.children, t.push(n);
      }), e.blocks = t, r({}, e, {
        blocks: t
      })) : e;
    },
    fromRawStateToRawTreeState: function fromRawStateToRawTreeState(e) {
      var n = {},
          t = [];
      return e.blocks.forEach(function (e) {
        var A = i(e),
            s = e.depth || 0,
            l = r({}, e, {
          children: []
        });
        if (!A) return n = {}, void t.push(l);

        if (n[s] = l, s > 0) {
          var a = n[s - 1];
          return a || o(!1), void a.children.push(l);
        }

        t.push(l);
      }), r({}, e, {
        blocks: t
      });
    }
  };

  e.exports = A;
}, function (e, n, t) {
  "use strict";

  var r = t(19),
      o = t(3).List;

  e.exports = function (e, n) {
    var t = e.map(function (e, t) {
      var o = n[t];
      return r.create({
        style: e,
        entity: o
      });
    });
    return o(t);
  };
}, function (e, n, t) {
  "use strict";

  var r = t(30).substr;

  e.exports = function (e, n) {
    var t = Array(e.length).fill(null);
    return n && n.forEach(function (n) {
      for (var o = r(e, 0, n.offset).length, i = o + r(e, n.offset, n.length).length, A = o; A < i; A++) {
        t[A] = n.key;
      }
    }), t;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(3).OrderedSet,
      o = t(30).substr,
      i = r();

  e.exports = function (e, n) {
    var t = Array(e.length).fill(i);
    return n && n.forEach(function (n) {
      for (var r = o(e, 0, n.offset).length, i = r + o(e, n.offset, n.length).length; r < i;) {
        t[r] = t[r].add(n.style), r++;
      }
    }), t;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(205);

  e.exports = function (e) {
    var n = e.getSelection();
    if (!n.rangeCount) return null;
    var t = n.getRangeAt(0),
        o = r(t),
        i = o.top,
        A = o.right,
        s = o.bottom,
        l = o.left;
    return 0 === i && 0 === A && 0 === s && 0 === l ? null : o;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(101);

  e.exports = function (e) {
    var n = r(e),
        t = 0,
        o = 0,
        i = 0,
        A = 0;

    if (n.length) {
      if (n.length > 1 && 0 === n[0].width) {
        var s = n[1];
        t = s.top, o = s.right, i = s.bottom, A = s.left;
      } else {
        var l = n[0];
        t = l.top, o = l.right, i = l.bottom, A = l.left;
      }

      for (var a = 1; a < n.length; a++) {
        var c = n[a];
        0 !== c.height && 0 !== c.width && (t = Math.min(t, c.top), o = Math.max(o, c.right), i = Math.max(i, c.bottom), A = Math.min(A, c.left));
      }
    }

    return {
      top: t,
      right: o,
      bottom: i,
      left: A,
      width: o - A,
      height: i - t
    };
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._3sCjpCshJssfQdy70fZbe3{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}@media (min-width: 768px){._1z93WMKhmx9r9e9ig0ORDx{display:grid;grid-template-columns:2fr 1fr}._2dj7lLhKodhCIwOY7vYre_{margin-bottom:1em;overflow:hidden;display:grid;grid-template-columns:[col-speaker] minmax(200px, 18%) [col-text] minmax(50%, 81%);grid-column-gap:1%;justify-content:center;align-content:center}._220-uL8BKPBdx715-H9VvM{color:dimgray;font-weight:bold;text-transform:uppercase;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;justify-self:start;max-width:100%;text-align:left}._3QPtbUi5LjfOSFZE2FUVpO{font-size:1em;float:right;clear:right}}._3ilX_gAaqiNrGprh5xN6cW{font-weight:lighter;cursor:pointer;justify-self:start}._3ilX_gAaqiNrGprh5xN6cW:hover{text-decoration:underline}._3PR-2Wx_MlvQFzlzRF6O7p{cursor:pointer}._1z51XqZ5utHrbLOYM1hTVT{cursor:no-drop}._35Ozy_qre-nCukN05RvZP1{margin-right:0.5em}@media (max-width: 768px){._1z93WMKhmx9r9e9ig0ORDx{width:100%;font-size:0.8em;line-height:1.2em;margin-bottom:0.5em}._2dj7lLhKodhCIwOY7vYre_{width:100%;margin-bottom:1em;line-height:1.2em;overflow:hidden}._220-uL8BKPBdx715-H9VvM{padding-right:2em;vertical-align:middle;color:dimgray;font-weight:bold;text-transform:uppercase;text-align:right;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-align:left}._3QPtbUi5LjfOSFZE2FUVpO{width:100%;font-size:1em;float:left}}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/timed-text-editor/WrapperBlock.module.css", "/Users/okunoe01/workspace/react-transcript-editor/packages/config/style-guide/colours.scss"],
    names: [],
    mappings: "AASC,yBACC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAiB,CAClB,0BAKC,yBACE,YAAa,CACb,6BAA8B,CAC/B,yBAGC,iBAAkB,CAClB,eAAgB,CAChB,YAAa,CACb,kFAGC,CACD,kBAAmB,CACnB,sBAAuB,CACvB,oBAAqB,CACtB,yBAGC,aCnCoB,CDoCpB,gBAAiB,CACjB,wBAAyB,CACzB,sBAAuB,CACvB,eAAgB,CAChB,kBAAmB,CACnB,kBAAmB,CACnB,cAAe,CACf,eAAgB,CACjB,yBAGC,aAAc,CACd,WAAY,CACZ,WAAY,CACb,CAIH,yBACE,mBAAoB,CACpB,cAAe,CACf,kBAAmB,CACpB,+BAGC,yBAA0B,CAG3B,yBAGC,cAAe,CAChB,yBAGC,cAAe,CAChB,yBAGC,kBAAmB,CACpB,0BAMC,yBACE,UAAW,CACX,eAAgB,CAChB,iBAAkB,CAClB,mBAAoB,CACrB,yBAGC,UAAW,CACX,iBAAkB,CAClB,iBAAkB,CAClB,eAAgB,CACjB,yBAGC,iBAAkB,CAClB,qBAAsB,CACtB,aCnGoB,CDoGpB,gBAAiB,CACjB,wBAAyB,CACzB,gBAAiB,CACjB,sBAAuB,CACvB,eAAgB,CAChB,kBAAmB,CACnB,eAAgB,CACjB,yBAGC,UAAW,CACX,aAAc,CACd,UAAW,CAGZ",
    file: "WrapperBlock.module.css",
    sourcesContent: ["@import '../../config/style-guide/colours.scss';\n\n/* https://developer.mozilla.org/en-US/docs/Web/CSS/user-select\nTODO: only working in Chrome, not working in Firefox, and Safari - OSX\nif selecting text, not showing selection\nCommented out because it means cannot select speakers and timecode anymore\nwhich is the intended default behavior but needs to come with export\nfunctionality to export as plain text, word etc.. otherwise user won't be able\nto get text out of component with timecodes and speaker names in the interim */\n .unselectable {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Desktop size */\n@media (min-width: 768px) {\n\n  .markers {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n  }\n\n  .WrapperBlock {\n    margin-bottom: 1em;\n    overflow: hidden;\n    display: grid;\n    grid-template-columns: [col-speaker] minmax(200px, 18%) [col-text] minmax(\n      50%,\n      81%\n    );\n    grid-column-gap: 1%;\n    justify-content: center;\n    align-content: center;\n  }\n\n  .speaker {\n    color: $color-mid-grey;\n    font-weight: bold;\n    text-transform: uppercase;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    justify-self: start;\n    max-width: 100%;\n    text-align: left;\n  }\n\n  .text {\n    font-size: 1em;\n    float: right;\n    clear: right;\n  }\n}\n\n\n.time {\n  font-weight: lighter;\n  cursor: pointer;\n  justify-self: start;\n}\n\n.time:hover {\n  text-decoration: underline;\n\n  /* color: blue; */\n}\n\n.speakerEditable {\n  cursor: pointer;\n}\n\n.speakerNotEditable {\n  cursor: no-drop;\n}\n\n.EditLabel {\n  margin-right: 0.5em;\n}\n\n\n/* Mobile devices */\n@media (max-width: 768px) {\n\n  .markers {\n    width: 100%;\n    font-size: 0.8em;\n    line-height: 1.2em;\n    margin-bottom: 0.5em;\n  }\n\n  .WrapperBlock {\n    width: 100%;\n    margin-bottom: 1em;\n    line-height: 1.2em;\n    overflow: hidden;\n  }\n\n  .speaker {\n    padding-right: 2em;\n    vertical-align: middle;\n    color: $color-mid-grey;\n    font-weight: bold;\n    text-transform: uppercase;\n    text-align: right;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    text-align: left;\n  }\n\n  .text {\n    width: 100%;\n    font-size: 1em;\n    float: left;\n\n    /* clear: right; */\n  }\n}\n", "$color-labs-red: #a0372d !default;\n$color-darkest-grey: #282828 !default;\n$color-dark-grey: #4a4a4a !default;\n$color-mid-grey: #696969 !default;\n$color-light-grey: #767676 !default;\n$color-lightest-grey: #f2f2f2 !default;\n$color-subt-green: #69e3c2 !default;\n$color-light-shilo: #E2A9A2 !default;\n"]
  }]), n.locals = {
    unselectable: "_3sCjpCshJssfQdy70fZbe3",
    markers: "_1z93WMKhmx9r9e9ig0ORDx",
    WrapperBlock: "_2dj7lLhKodhCIwOY7vYre_",
    speaker: "_220-uL8BKPBdx715-H9VvM",
    text: "_3QPtbUi5LjfOSFZE2FUVpO",
    time: "_3ilX_gAaqiNrGprh5xN6cW",
    speakerEditable: "_3PR-2Wx_MlvQFzlzRF6O7p",
    speakerNotEditable: "_1z51XqZ5utHrbLOYM1hTVT",
    EditLabel: "_35Ozy_qre-nCukN05RvZP1"
  };
}, function (e, n, t) {
  (function () {
    var e,
        r,
        o,
        i,
        A,
        s,
        l,
        a,
        c,
        u,
        p,
        m,
        C,
        d,
        f,
        h,
        x,
        g,
        I,
        b,
        y,
        E = [].indexOf || function (e) {
      for (var n = 0, t = this.length; n < t; n++) {
        if (n in this && this[n] === e) return n;
      }

      return -1;
    };

    a = Math.floor, u = Math.max, p = Math.min, r = t(208), s = t(210), x = function x(e, n) {
      return n ? 2 * e / n : 1;
    }, h = function h(e, n) {
      var t, r, o, i, A, s;

      for (A = [e.length, n.length], t = i = 0, s = p(r = A[0], o = A[1]); 0 <= s ? i < s : i > s; t = 0 <= s ? ++i : --i) {
        if (e[t] < n[t]) return -1;
        if (e[t] > n[t]) return 1;
      }

      return r - o;
    }, y = function y(e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, f = function f(e) {
      var n, t;

      for (n = 0, t = e.length; n < t; n++) {
        if (e[n]) return !0;
      }

      return !1;
    }, A = function () {
      function e(e, n, t, r) {
        this.isjunk = e, null == n && (n = ""), null == t && (t = ""), this.autojunk = null == r || r, this.a = this.b = null, this.setSeqs(n, t);
      }

      return e.name = "SequenceMatcher", e.prototype.setSeqs = function (e, n) {
        return this.setSeq1(e), this.setSeq2(n);
      }, e.prototype.setSeq1 = function (e) {
        if (e !== this.a) return this.a = e, this.matchingBlocks = this.opcodes = null;
      }, e.prototype.setSeq2 = function (e) {
        if (e !== this.b) return this.b = e, this.matchingBlocks = this.opcodes = null, this.fullbcount = null, this._chainB();
      }, e.prototype._chainB = function () {
        var e, n, t, r, o, i, A, s, l, c, u, p, m, C;

        for (e = this.b, this.b2j = n = {}, r = c = 0, p = e.length; c < p; r = ++c) {
          t = e[r], (y(n, t) ? n[t] : n[t] = []).push(r);
        }

        if (i = {}, o = this.isjunk) for (u = 0, m = (C = Object.keys(n)).length; u < m; u++) {
          o(t = C[u]) && (i[t] = !0, delete n[t]);
        }
        if (l = {}, A = e.length, this.autojunk && A >= 200) for (t in s = a(A / 100) + 1, n) {
          n[t].length > s && (l[t] = !0, delete n[t]);
        }
        return this.isbjunk = function (e) {
          return y(i, e);
        }, this.isbpopular = function (e) {
          return y(l, e);
        };
      }, e.prototype.findLongestMatch = function (e, n, t, r) {
        var o, i, A, s, l, a, c, u, p, m, C, d, f, h, x, g, I, b, E, v, w;

        for (o = (g = [this.a, this.b, this.b2j, this.isbjunk])[0], i = g[1], A = g[2], u = g[3], s = (I = [e, t, 0])[0], l = I[1], a = I[2], m = {}, c = f = e; e <= n ? f < n : f > n; c = e <= n ? ++f : --f) {
          for (d = {}, h = 0, x = (b = y(A, o[c]) ? A[o[c]] : []).length; h < x; h++) {
            if (!((p = b[h]) < t)) {
              if (p >= r) break;
              (C = d[p] = (m[p - 1] || 0) + 1) > a && (s = (E = [c - C + 1, p - C + 1, C])[0], l = E[1], a = E[2]);
            }
          }

          m = d;
        }

        for (; s > e && l > t && !u(i[l - 1]) && o[s - 1] === i[l - 1];) {
          s = (v = [s - 1, l - 1, a + 1])[0], l = v[1], a = v[2];
        }

        for (; s + a < n && l + a < r && !u(i[l + a]) && o[s + a] === i[l + a];) {
          a++;
        }

        for (; s > e && l > t && u(i[l - 1]) && o[s - 1] === i[l - 1];) {
          s = (w = [s - 1, l - 1, a + 1])[0], l = w[1], a = w[2];
        }

        for (; s + a < n && l + a < r && u(i[l + a]) && o[s + a] === i[l + a];) {
          a++;
        }

        return [s, l, a];
      }, e.prototype.getMatchingBlocks = function () {
        var e, n, t, r, o, i, A, s, l, a, c, u, p, m, C, d, f, x, g, I, b, y, E, v, w, B;
        if (this.matchingBlocks) return this.matchingBlocks;

        for (x = [[0, m = (y = [this.a.length, this.b.length])[0], 0, C = y[1]]], d = []; x.length;) {
          n = (E = x.pop())[0], e = E[1], r = E[2], t = E[3], o = (v = g = this.findLongestMatch(n, e, r, t))[0], s = v[1], (c = v[2]) && (d.push(g), n < o && r < s && x.push([n, o, r, s]), o + c < e && s + c < t && x.push([o + c, e, s + c, t]));
        }

        for (d.sort(h), i = l = u = 0, f = [], I = 0, b = d.length; I < b; I++) {
          A = (w = d[I])[0], a = w[1], p = w[2], i + u === A && l + u === a ? u += p : (u && f.push([i, l, u]), i = (B = [A, a, p])[0], l = B[1], u = B[2]);
        }

        return u && f.push([i, l, u]), f.push([m, C, 0]), this.matchingBlocks = f;
      }, e.prototype.getOpcodes = function () {
        var e, n, t, r, o, i, A, s, l, a, c, u;
        if (this.opcodes) return this.opcodes;

        for (r = o = 0, this.opcodes = n = [], s = 0, l = (a = this.getMatchingBlocks()).length; s < l; s++) {
          e = (c = a[s])[0], t = c[1], i = c[2], A = "", r < e && o < t ? A = "replace" : r < e ? A = "delete" : o < t && (A = "insert"), A && n.push([A, r, e, o, t]), r = (u = [e + i, t + i])[0], o = u[1], i && n.push(["equal", e, r, t, o]);
        }

        return n;
      }, e.prototype.getGroupedOpcodes = function (e) {
        var n, t, r, o, i, A, s, l, a, c, m, C, d, f, h;

        for (null == e && (e = 3), (n = this.getOpcodes()).length || (n = [["equal", 0, 1, 0, 1]]), "equal" === n[0][0] && (a = (C = n[0])[0], o = C[1], i = C[2], A = C[3], s = C[4], n[0] = [a, u(o, i - e), i, u(A, s - e), s]), "equal" === n[n.length - 1][0] && (a = (d = n[n.length - 1])[0], o = d[1], i = d[2], A = d[3], s = d[4], n[n.length - 1] = [a, o, p(i, o + e), A, p(s, A + e)]), l = e + e, r = [], t = [], c = 0, m = n.length; c < m; c++) {
          a = (f = n[c])[0], o = f[1], i = f[2], A = f[3], s = f[4], "equal" === a && i - o > l && (t.push([a, o, p(i, o + e), A, p(s, A + e)]), r.push(t), t = [], o = (h = [u(o, i - e), u(A, s - e)])[0], A = h[1]), t.push([a, o, i, A, s]);
        }

        return !t.length || 1 === t.length && "equal" === t[0][0] || r.push(t), r;
      }, e.prototype.ratio = function () {
        var e, n, t, r;

        for (e = 0, n = 0, t = (r = this.getMatchingBlocks()).length; n < t; n++) {
          e += r[n][2];
        }

        return x(e, this.a.length + this.b.length);
      }, e.prototype.quickRatio = function () {
        var e, n, t, r, o, i, A, s, l, a, c;
        if (!this.fullbcount) for (this.fullbcount = t = {}, i = 0, s = (a = this.b).length; i < s; i++) {
          t[n = a[i]] = (t[n] || 0) + 1;
        }

        for (t = this.fullbcount, e = {}, r = 0, A = 0, l = (c = this.a).length; A < l; A++) {
          n = c[A], o = y(e, n) ? e[n] : t[n] || 0, e[n] = o - 1, o > 0 && r++;
        }

        return x(r, this.a.length + this.b.length);
      }, e.prototype.realQuickRatio = function () {
        var e, n, t;
        return t = [this.a.length, this.b.length], x(p(e = t[0], n = t[1]), e + n);
      }, e;
    }(), c = function c(e, n, t, o) {
      var i, s, l, a, c, u, p, m, C;
      if (null == t && (t = 3), null == o && (o = .6), !(t > 0)) throw new Error("n must be > 0: (" + t + ")");
      if (!(0 <= o && o <= 1)) throw new Error("cutoff must be in [0.0, 1.0]: (" + o + ")");

      for (i = [], (s = new A()).setSeq2(e), a = 0, u = n.length; a < u; a++) {
        l = n[a], s.setSeq1(l), s.realQuickRatio() >= o && s.quickRatio() >= o && s.ratio() >= o && i.push([s.ratio(), l]);
      }

      for (C = [], c = 0, p = (i = r.nlargest(i, t, h)).length; c < p; c++) {
        (m = i[c])[0], l = m[1], C.push(l);
      }

      return C;
    }, g = function g(e, n) {
      var t, r, o;

      for (t = (o = [0, e.length])[0], r = o[1]; t < r && e[t] === n;) {
        t++;
      }

      return t;
    }, e = function () {
      function e(e, n) {
        this.linejunk = e, this.charjunk = n;
      }

      return e.name = "Differ", e.prototype.compare = function (e, n) {
        var t, r, o, i, s, l, a, c, u, p, m, C, d, f;

        for (a = [], u = 0, m = (d = new A(this.linejunk, e, n).getOpcodes()).length; u < m; u++) {
          switch (c = (f = d[u])[0], r = f[1], t = f[2], i = f[3], o = f[4], c) {
            case "replace":
              s = this._fancyReplace(e, r, t, n, i, o);
              break;

            case "delete":
              s = this._dump("-", e, r, t);
              break;

            case "insert":
              s = this._dump("+", n, i, o);
              break;

            case "equal":
              s = this._dump(" ", e, r, t);
              break;

            default:
              throw new Error("unknow tag (" + c + ")");
          }

          for (p = 0, C = s.length; p < C; p++) {
            l = s[p], a.push(l);
          }
        }

        return a;
      }, e.prototype._dump = function (e, n, t, r) {
        var o, i, A;

        for (A = [], o = i = t; t <= r ? i < r : i > r; o = t <= r ? ++i : --i) {
          A.push(e + " " + n[o]);
        }

        return A;
      }, e.prototype._plainReplace = function (e, n, t, r, o, i) {
        var A, l, a, c, u, p, m, C, d, f;

        for (s(n < t && o < i), i - o < t - n ? (A = this._dump("+", r, o, i), u = this._dump("-", e, n, t)) : (A = this._dump("-", e, n, t), u = this._dump("+", r, o, i)), c = [], p = 0, C = (f = [A, u]).length; p < C; p++) {
          for (m = 0, d = (l = f[p]).length; m < d; m++) {
            a = l[m], c.push(a);
          }
        }

        return c;
      }, e.prototype._fancyReplace = function (e, n, t, r, o, i) {
        var s, l, a, c, u, p, m, C, d, f, h, x, g, I, b, y, E, v, w, B, _, D, S, M, O, k, T, P, K, Q, U, R, G, Y, F, N, j, W, L, z, X, H, q, V, J, Z, $, ee;

        for (m = (N = [.74, .75])[0], I = N[1], g = new A(this.charjunk), b = (j = [null, null])[0], y = j[1], D = [], v = M = o; o <= i ? M < i : M > i; v = o <= i ? ++M : --M) {
          for (f = r[v], g.setSeq2(f), E = O = n; n <= t ? O < t : O > t; E = n <= t ? ++O : --O) {
            (l = e[E]) !== f ? (g.setSeq1(l), g.realQuickRatio() > m && g.quickRatio() > m && g.ratio() > m && (m = (H = [g.ratio(), E, v])[0], C = H[1], d = H[2])) : null === b && (b = (X = [E, v])[0], y = X[1]);
          }
        }

        if (m < I) {
          if (null === b) {
            for (k = 0, P = (q = this._plainReplace(e, n, t, r, o, i)).length; k < P; k++) {
              _ = q[k], D.push(_);
            }

            return D;
          }

          C = (V = [b, y, 1])[0], d = V[1], m = V[2];
        } else b = null;

        for (T = 0, K = (J = this._fancyHelper(e, n, C, r, o, d)).length; T < K; T++) {
          _ = J[T], D.push(_);
        }

        if (s = (Z = [e[C], r[d]])[0], p = Z[1], null === b) {
          for (u = x = "", g.setSeqs(s, p), G = 0, Q = ($ = g.getOpcodes()).length; G < Q; G++) {
            switch (S = (ee = $[G])[0], a = ee[1], c = ee[2], h = ee[3], w = (W = [c - a, ee[4] - h])[0], B = W[1], S) {
              case "replace":
                u += Array(w + 1).join("^"), x += Array(B + 1).join("^");
                break;

              case "delete":
                u += Array(w + 1).join("-");
                break;

              case "insert":
                x += Array(B + 1).join("+");
                break;

              case "equal":
                u += Array(w + 1).join(" "), x += Array(B + 1).join(" ");
                break;

              default:
                throw new Error("unknow tag (" + S + ")");
            }
          }

          for (Y = 0, U = (L = this._qformat(s, p, u, x)).length; Y < U; Y++) {
            _ = L[Y], D.push(_);
          }
        } else D.push("  " + s);

        for (F = 0, R = (z = this._fancyHelper(e, C + 1, t, r, d + 1, i)).length; F < R; F++) {
          _ = z[F], D.push(_);
        }

        return D;
      }, e.prototype._fancyHelper = function (e, n, t, r, o, i) {
        var A;
        return A = [], n < t ? A = o < i ? this._fancyReplace(e, n, t, r, o, i) : this._dump("-", e, n, t) : o < i && (A = this._dump("+", r, o, i)), A;
      }, e.prototype._qformat = function (e, n, t, r) {
        var o, i;
        return i = [], o = p(g(e, "\t"), g(n, "\t")), o = p(o, g(t.slice(0, o), " ")), o = p(o, g(r.slice(0, o), " ")), t = t.slice(o).replace(/\s+$/, ""), r = r.slice(o).replace(/\s+$/, ""), i.push("- " + e), t.length && i.push("? " + Array(o + 1).join("\t") + t + "\n"), i.push("+ " + n), r.length && i.push("? " + Array(o + 1).join("\t") + r + "\n"), i;
      }, e;
    }(), i = function i(e, n) {
      return null == n && (n = /^\s*#?\s*$/), n.test(e);
    }, o = function o(e, n) {
      return null == n && (n = " \t"), E.call(n, e) >= 0;
    }, b = function b(e, n) {
      var t, r;
      return t = e + 1, 1 === (r = n - e) ? "" + t : (r || t--, t + "," + r);
    }, d = function d(e, n, t) {
      var r, o, i, s, l, a, c, u, p, m, C, d, f, h, x, g, I, y, E, v, w, B, _, D, S, M, O, k, T, P, K, Q, U, R, G, Y, F;

      for (null == (l = (K = null != t ? t : {}).fromfile) && (l = ""), null == (E = K.tofile) && (E = ""), null == (a = K.fromfiledate) && (a = ""), null == (v = K.tofiledate) && (v = ""), null == K.n && 3, null == (x = K.lineterm) && (x = "\n"), h = [], g = !1, w = 0, S = (Q = new A(null, e, n).getGroupedOpcodes()).length; w < S; w++) {
        for (c = Q[w], g || (g = !0, s = a ? "\t" + a : "", y = v ? "\t" + v : "", h.push("--- " + l + s + x), h.push("+++ " + E + y + x)), d = (U = [c[0], c[c.length - 1]])[1], r = b((i = U[0])[1], d[2]), o = b(i[3], d[4]), h.push("@@ -" + r + " +" + o + " @@" + x), B = 0, M = c.length; B < M; B++) {
          if (I = (R = c[B])[0], u = R[1], p = R[2], m = R[3], C = R[4], "equal" !== I) {
            if ("replace" === I || "delete" === I) for (D = 0, k = (Y = e.slice(u, p)).length; D < k; D++) {
              f = Y[D], h.push("-" + f);
            }
            if ("replace" === I || "insert" === I) for (P = 0, T = (F = n.slice(m, C)).length; P < T; P++) {
              f = F[P], h.push("+" + f);
            }
          } else for (_ = 0, O = (G = e.slice(u, p)).length; _ < O; _++) {
            f = G[_], h.push(" " + f);
          }
        }
      }

      return h;
    }, I = function I(e, n) {
      var t, r;
      return t = e + 1, (r = n - e) || t--, r <= 1 ? "" + t : t + "," + (t + r - 1);
    }, l = function l(e, n, t) {
      var r, o, i, s, l, a, c, u, p, m, C, d, h, x, g, b, y, E, v, w, B, _, D, S, M, O, k, T, P, K, Q, U, R, G, Y, F, N, j;

      for (null == (l = (U = null != t ? t : {}).fromfile) && (l = ""), null == (w = U.tofile) && (w = ""), null == (a = U.fromfiledate) && (a = ""), null == (B = U.tofiledate) && (B = ""), null == U.n && 3, null == (g = U.lineterm) && (g = "\n"), b = {
        insert: "+ ",
        delete: "- ",
        replace: "! ",
        equal: "  "
      }, y = !1, x = [], _ = 0, O = (R = new A(null, e, n).getGroupedOpcodes()).length; _ < O; _++) {
        if (c = R[_], !y) {
          if (y = !0, s = a ? "\t" + a : "", v = B ? "\t" + B : "", x.push("*** " + l + s + g), x.push("--- " + w + v + g), i = (G = [c[0], c[c.length - 1]])[0], d = G[1], x.push("***************" + g), r = I(i[1], d[2]), x.push("*** " + r + " ****" + g), f(function () {
            var e, n, t, r;

            for (r = [], e = 0, n = c.length; e < n; e++) {
              t = c[e], E = t[0], t[1], t[2], t[3], t[4], r.push("replace" === E || "delete" === E);
            }

            return r;
          }())) for (D = 0, k = c.length; D < k; D++) {
            if (Y = c[D], E = Y[0], u = Y[1], p = Y[2], Y[3], Y[4], "insert" !== E) for (S = 0, T = (F = e.slice(u, p)).length; S < T; S++) {
              h = F[S], x.push(b[E] + h);
            }
          }
          if (o = I(i[3], d[4]), x.push("--- " + o + " ----" + g), f(function () {
            var e, n, t, r;

            for (r = [], e = 0, n = c.length; e < n; e++) {
              t = c[e], E = t[0], t[1], t[2], t[3], t[4], r.push("replace" === E || "insert" === E);
            }

            return r;
          }())) for (M = 0, P = c.length; M < P; M++) {
            if (N = c[M], E = N[0], N[1], N[2], m = N[3], C = N[4], "delete" !== E) for (Q = 0, K = (j = n.slice(m, C)).length; Q < K; Q++) {
              h = j[Q], x.push(b[E] + h);
            }
          }
        }
      }

      return x;
    }, m = function m(n, t, r, i) {
      return null == i && (i = o), new e(r, i).compare(n, t);
    }, C = function C(e, n) {
      var t, r, o, i, A, s, l;
      if (!(i = {
        1: "- ",
        2: "+ "
      }[n])) throw new Error("unknow delta choice (must be 1 or 2): " + n);

      for (o = ["  ", i], r = [], A = 0, s = e.length; A < s; A++) {
        l = (t = e[A]).slice(0, 2), E.call(o, l) >= 0 && r.push(t.slice(2));
      }

      return r;
    }, n._arrayCmp = h, n.SequenceMatcher = A, n.getCloseMatches = c, n._countLeading = g, n.Differ = e, n.IS_LINE_JUNK = i, n.IS_CHARACTER_JUNK = o, n._formatRangeUnified = b, n.unifiedDiff = d, n._formatRangeContext = I, n.contextDiff = l, n.ndiff = m, n.restore = C;
  }).call(this);
}, function (e, n, t) {
  e.exports = t(209);
}, function (e, n, t) {
  var r, o, i;
  (function () {
    var t, A, s, l, a, c, u, p, m, C, d, f, h, x, g;
    s = Math.floor, C = Math.min, A = function A(e, n) {
      return e < n ? -1 : e > n ? 1 : 0;
    }, m = function m(e, n, t, r, o) {
      var i;
      if (null == t && (t = 0), null == o && (o = A), t < 0) throw new Error("lo must be non-negative");

      for (null == r && (r = e.length); t < r;) {
        o(n, e[i = s((t + r) / 2)]) < 0 ? r = i : t = i + 1;
      }

      return [].splice.apply(e, [t, t - t].concat(n)), n;
    }, c = function c(e, n, t) {
      return null == t && (t = A), e.push(n), x(e, 0, e.length - 1, t);
    }, a = function a(e, n) {
      var t, r;
      return null == n && (n = A), t = e.pop(), e.length ? (r = e[0], e[0] = t, g(e, 0, n)) : r = t, r;
    }, p = function p(e, n, t) {
      var r;
      return null == t && (t = A), r = e[0], e[0] = n, g(e, 0, t), r;
    }, u = function u(e, n, t) {
      var r;
      return null == t && (t = A), e.length && t(e[0], n) < 0 && (n = (r = [e[0], n])[0], e[0] = r[1], g(e, 0, t)), n;
    }, l = function l(e, n) {
      var t, r, o, i, l, a;

      for (null == n && (n = A), l = [], r = 0, o = (i = function () {
        a = [];

        for (var n = 0, t = s(e.length / 2); 0 <= t ? n < t : n > t; 0 <= t ? n++ : n--) {
          a.push(n);
        }

        return a;
      }.apply(this).reverse()).length; r < o; r++) {
        t = i[r], l.push(g(e, t, n));
      }

      return l;
    }, h = function h(e, n, t) {
      var r;
      if (null == t && (t = A), -1 !== (r = e.indexOf(n))) return x(e, 0, r, t), g(e, r, t);
    }, d = function d(e, n, t) {
      var r, o, i, s, a;
      if (null == t && (t = A), !(o = e.slice(0, n)).length) return o;

      for (l(o, t), i = 0, s = (a = e.slice(n)).length; i < s; i++) {
        r = a[i], u(o, r, t);
      }

      return o.sort(t).reverse();
    }, f = function f(e, n, t) {
      var r, o, i, s, c, u, p, d, f;

      if (null == t && (t = A), 10 * n <= e.length) {
        if (!(i = e.slice(0, n).sort(t)).length) return i;

        for (o = i[i.length - 1], s = 0, u = (p = e.slice(n)).length; s < u; s++) {
          t(r = p[s], o) < 0 && (m(i, r, 0, null, t), i.pop(), o = i[i.length - 1]);
        }

        return i;
      }

      for (l(e, t), f = [], c = 0, d = C(n, e.length); 0 <= d ? c < d : c > d; 0 <= d ? ++c : --c) {
        f.push(a(e, t));
      }

      return f;
    }, x = function x(e, n, t, r) {
      var o, i, s;

      for (null == r && (r = A), o = e[t]; t > n && r(o, i = e[s = t - 1 >> 1]) < 0;) {
        e[t] = i, t = s;
      }

      return e[t] = o;
    }, g = function g(e, n, t) {
      var r, o, i, s, l;

      for (null == t && (t = A), o = e.length, l = n, i = e[n], r = 2 * n + 1; r < o;) {
        (s = r + 1) < o && !(t(e[r], e[s]) < 0) && (r = s), e[n] = e[r], r = 2 * (n = r) + 1;
      }

      return e[n] = i, x(e, l, n, t);
    }, t = function () {
      function e(e) {
        this.cmp = null != e ? e : A, this.nodes = [];
      }

      return e.push = c, e.pop = a, e.replace = p, e.pushpop = u, e.heapify = l, e.updateItem = h, e.nlargest = d, e.nsmallest = f, e.prototype.push = function (e) {
        return c(this.nodes, e, this.cmp);
      }, e.prototype.pop = function () {
        return a(this.nodes, this.cmp);
      }, e.prototype.peek = function () {
        return this.nodes[0];
      }, e.prototype.contains = function (e) {
        return -1 !== this.nodes.indexOf(e);
      }, e.prototype.replace = function (e) {
        return p(this.nodes, e, this.cmp);
      }, e.prototype.pushpop = function (e) {
        return u(this.nodes, e, this.cmp);
      }, e.prototype.heapify = function () {
        return l(this.nodes, this.cmp);
      }, e.prototype.updateItem = function (e) {
        return h(this.nodes, e, this.cmp);
      }, e.prototype.clear = function () {
        return this.nodes = [];
      }, e.prototype.empty = function () {
        return 0 === this.nodes.length;
      }, e.prototype.size = function () {
        return this.nodes.length;
      }, e.prototype.clone = function () {
        var n;
        return (n = new e()).nodes = this.nodes.slice(0), n;
      }, e.prototype.toArray = function () {
        return this.nodes.slice(0);
      }, e.prototype.insert = e.prototype.push, e.prototype.top = e.prototype.peek, e.prototype.front = e.prototype.peek, e.prototype.has = e.prototype.contains, e.prototype.copy = e.prototype.clone, e;
    }(), o = [], void 0 === (i = "function" == typeof (r = function r() {
      return t;
    }) ? r.apply(n, o) : r) || (e.exports = i);
  }).call(this);
}, function (e, n, t) {
  "use strict";

  (function (n) {
    var r = t(18);
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */

    function o(e, n) {
      if (e === n) return 0;

      for (var t = e.length, r = n.length, o = 0, i = Math.min(t, r); o < i; ++o) {
        if (e[o] !== n[o]) {
          t = e[o], r = n[o];
          break;
        }
      }

      return t < r ? -1 : r < t ? 1 : 0;
    }

    function i(e) {
      return n.Buffer && "function" == typeof n.Buffer.isBuffer ? n.Buffer.isBuffer(e) : !(null == e || !e._isBuffer);
    }

    var A = t(211),
        s = Object.prototype.hasOwnProperty,
        l = Array.prototype.slice,
        a = "foo" === function () {}.name;

    function c(e) {
      return Object.prototype.toString.call(e);
    }

    function u(e) {
      return !i(e) && "function" == typeof n.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : !!e && (e instanceof DataView || !!(e.buffer && e.buffer instanceof ArrayBuffer)));
    }

    var p = e.exports = x,
        m = /\s*function\s+([^\(\s]*)\s*/;

    function C(e) {
      if (A.isFunction(e)) {
        if (a) return e.name;
        var n = e.toString().match(m);
        return n && n[1];
      }
    }

    function d(e, n) {
      return "string" == typeof e ? e.length < n ? e : e.slice(0, n) : e;
    }

    function f(e) {
      if (a || !A.isFunction(e)) return A.inspect(e);
      var n = C(e);
      return "[Function" + (n ? ": " + n : "") + "]";
    }

    function h(e, n, t, r, o) {
      throw new p.AssertionError({
        message: t,
        actual: e,
        expected: n,
        operator: r,
        stackStartFunction: o
      });
    }

    function x(e, n) {
      e || h(e, !0, n, "==", p.ok);
    }

    function g(e, n, t, r) {
      if (e === n) return !0;
      if (i(e) && i(n)) return 0 === o(e, n);
      if (A.isDate(e) && A.isDate(n)) return e.getTime() === n.getTime();
      if (A.isRegExp(e) && A.isRegExp(n)) return e.source === n.source && e.global === n.global && e.multiline === n.multiline && e.lastIndex === n.lastIndex && e.ignoreCase === n.ignoreCase;

      if (null !== e && "object" == typeof e || null !== n && "object" == typeof n) {
        if (u(e) && u(n) && c(e) === c(n) && !(e instanceof Float32Array || e instanceof Float64Array)) return 0 === o(new Uint8Array(e.buffer), new Uint8Array(n.buffer));
        if (i(e) !== i(n)) return !1;
        var s = (r = r || {
          actual: [],
          expected: []
        }).actual.indexOf(e);
        return -1 !== s && s === r.expected.indexOf(n) || (r.actual.push(e), r.expected.push(n), function (e, n, t, r) {
          if (null == e || null == n) return !1;
          if (A.isPrimitive(e) || A.isPrimitive(n)) return e === n;
          if (t && Object.getPrototypeOf(e) !== Object.getPrototypeOf(n)) return !1;
          var o = I(e),
              i = I(n);
          if (o && !i || !o && i) return !1;
          if (o) return e = l.call(e), n = l.call(n), g(e, n, t);
          var s,
              a,
              c = E(e),
              u = E(n);
          if (c.length !== u.length) return !1;

          for (c.sort(), u.sort(), a = c.length - 1; a >= 0; a--) {
            if (c[a] !== u[a]) return !1;
          }

          for (a = c.length - 1; a >= 0; a--) {
            if (s = c[a], !g(e[s], n[s], t, r)) return !1;
          }

          return !0;
        }(e, n, t, r));
      }

      return t ? e === n : e == n;
    }

    function I(e) {
      return "[object Arguments]" == Object.prototype.toString.call(e);
    }

    function b(e, n) {
      if (!e || !n) return !1;
      if ("[object RegExp]" == Object.prototype.toString.call(n)) return n.test(e);

      try {
        if (e instanceof n) return !0;
      } catch (e) {}

      return !Error.isPrototypeOf(n) && !0 === n.call({}, e);
    }

    function y(e, n, t, r) {
      var o;
      if ("function" != typeof n) throw new TypeError('"block" argument must be a function');
      "string" == typeof t && (r = t, t = null), o = function (e) {
        var n;

        try {
          e();
        } catch (e) {
          n = e;
        }

        return n;
      }(n), r = (t && t.name ? " (" + t.name + ")." : ".") + (r ? " " + r : "."), e && !o && h(o, t, "Missing expected exception" + r);
      var i = "string" == typeof r,
          s = !e && o && !t;
      if ((!e && A.isError(o) && i && b(o, t) || s) && h(o, t, "Got unwanted exception" + r), e && o && t && !b(o, t) || !e && o) throw o;
    }

    p.AssertionError = function (e) {
      this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = function (e) {
        return d(f(e.actual), 128) + " " + e.operator + " " + d(f(e.expected), 128);
      }(this), this.generatedMessage = !0);
      var n = e.stackStartFunction || h;
      if (Error.captureStackTrace) Error.captureStackTrace(this, n);else {
        var t = new Error();

        if (t.stack) {
          var r = t.stack,
              o = C(n),
              i = r.indexOf("\n" + o);

          if (i >= 0) {
            var A = r.indexOf("\n", i + 1);
            r = r.substring(A + 1);
          }

          this.stack = r;
        }
      }
    }, A.inherits(p.AssertionError, Error), p.fail = h, p.ok = x, p.equal = function (e, n, t) {
      e != n && h(e, n, t, "==", p.equal);
    }, p.notEqual = function (e, n, t) {
      e == n && h(e, n, t, "!=", p.notEqual);
    }, p.deepEqual = function (e, n, t) {
      g(e, n, !1) || h(e, n, t, "deepEqual", p.deepEqual);
    }, p.deepStrictEqual = function (e, n, t) {
      g(e, n, !0) || h(e, n, t, "deepStrictEqual", p.deepStrictEqual);
    }, p.notDeepEqual = function (e, n, t) {
      g(e, n, !1) && h(e, n, t, "notDeepEqual", p.notDeepEqual);
    }, p.notDeepStrictEqual = function e(n, t, r) {
      g(n, t, !0) && h(n, t, r, "notDeepStrictEqual", e);
    }, p.strictEqual = function (e, n, t) {
      e !== n && h(e, n, t, "===", p.strictEqual);
    }, p.notStrictEqual = function (e, n, t) {
      e === n && h(e, n, t, "!==", p.notStrictEqual);
    }, p.throws = function (e, n, t) {
      y(!0, e, n, t);
    }, p.doesNotThrow = function (e, n, t) {
      y(!1, e, n, t);
    }, p.ifError = function (e) {
      if (e) throw e;
    }, p.strict = r(function e(n, t) {
      n || h(n, !0, t, "==", e);
    }, p, {
      equal: p.strictEqual,
      deepEqual: p.deepStrictEqual,
      notEqual: p.notStrictEqual,
      notDeepEqual: p.notDeepStrictEqual
    }), p.strict.strict = p.strict;

    var E = Object.keys || function (e) {
      var n = [];

      for (var t in e) {
        s.call(e, t) && n.push(t);
      }

      return n;
    };
  }).call(this, t(12));
}, function (e, n, t) {
  (function (e) {
    var r = Object.getOwnPropertyDescriptors || function (e) {
      for (var n = Object.keys(e), t = {}, r = 0; r < n.length; r++) {
        t[n[r]] = Object.getOwnPropertyDescriptor(e, n[r]);
      }

      return t;
    },
        o = /%[sdj%]/g;

    n.format = function (e) {
      if (!h(e)) {
        for (var n = [], t = 0; t < arguments.length; t++) {
          n.push(s(arguments[t]));
        }

        return n.join(" ");
      }

      t = 1;

      for (var r = arguments, i = r.length, A = String(e).replace(o, function (e) {
        if ("%%" === e) return "%";
        if (t >= i) return e;

        switch (e) {
          case "%s":
            return String(r[t++]);

          case "%d":
            return Number(r[t++]);

          case "%j":
            try {
              return JSON.stringify(r[t++]);
            } catch (e) {
              return "[Circular]";
            }

          default:
            return e;
        }
      }), l = r[t]; t < i; l = r[++t]) {
        d(l) || !I(l) ? A += " " + l : A += " " + s(l);
      }

      return A;
    }, n.deprecate = function (t, r) {
      if (void 0 !== e && !0 === e.noDeprecation) return t;
      if (void 0 === e) return function () {
        return n.deprecate(t, r).apply(this, arguments);
      };
      var o = !1;
      return function () {
        if (!o) {
          if (e.throwDeprecation) throw new Error(r);
          e.traceDeprecation ? console.trace(r) : console.error(r), o = !0;
        }

        return t.apply(this, arguments);
      };
    };
    var i,
        A = {};

    function s(e, t) {
      var r = {
        seen: [],
        stylize: a
      };
      return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), C(t) ? r.showHidden = t : t && n._extend(r, t), x(r.showHidden) && (r.showHidden = !1), x(r.depth) && (r.depth = 2), x(r.colors) && (r.colors = !1), x(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = l), c(r, e, r.depth);
    }

    function l(e, n) {
      var t = s.styles[n];
      return t ? "[" + s.colors[t][0] + "m" + e + "[" + s.colors[t][1] + "m" : e;
    }

    function a(e, n) {
      return e;
    }

    function c(e, t, r) {
      if (e.customInspect && t && E(t.inspect) && t.inspect !== n.inspect && (!t.constructor || t.constructor.prototype !== t)) {
        var o = t.inspect(r, e);
        return h(o) || (o = c(e, o, r)), o;
      }

      var i = function (e, n) {
        if (x(n)) return e.stylize("undefined", "undefined");

        if (h(n)) {
          var t = "'" + JSON.stringify(n).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return e.stylize(t, "string");
        }

        if (f(n)) return e.stylize("" + n, "number");
        if (C(n)) return e.stylize("" + n, "boolean");
        if (d(n)) return e.stylize("null", "null");
      }(e, t);

      if (i) return i;

      var A = Object.keys(t),
          s = function (e) {
        var n = {};
        return e.forEach(function (e, t) {
          n[e] = !0;
        }), n;
      }(A);

      if (e.showHidden && (A = Object.getOwnPropertyNames(t)), y(t) && (A.indexOf("message") >= 0 || A.indexOf("description") >= 0)) return u(t);

      if (0 === A.length) {
        if (E(t)) {
          var l = t.name ? ": " + t.name : "";
          return e.stylize("[Function" + l + "]", "special");
        }

        if (g(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
        if (b(t)) return e.stylize(Date.prototype.toString.call(t), "date");
        if (y(t)) return u(t);
      }

      var a,
          I = "",
          v = !1,
          w = ["{", "}"];
      (m(t) && (v = !0, w = ["[", "]"]), E(t)) && (I = " [Function" + (t.name ? ": " + t.name : "") + "]");
      return g(t) && (I = " " + RegExp.prototype.toString.call(t)), b(t) && (I = " " + Date.prototype.toUTCString.call(t)), y(t) && (I = " " + u(t)), 0 !== A.length || v && 0 != t.length ? r < 0 ? g(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), a = v ? function (e, n, t, r, o) {
        for (var i = [], A = 0, s = n.length; A < s; ++A) {
          D(n, String(A)) ? i.push(p(e, n, t, r, String(A), !0)) : i.push("");
        }

        return o.forEach(function (o) {
          o.match(/^\d+$/) || i.push(p(e, n, t, r, o, !0));
        }), i;
      }(e, t, r, s, A) : A.map(function (n) {
        return p(e, t, r, s, n, v);
      }), e.seen.pop(), function (e, n, t) {
        if (e.reduce(function (e, n) {
          return n.indexOf("\n") >= 0 && 0, e + n.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60) return t[0] + ("" === n ? "" : n + "\n ") + " " + e.join(",\n  ") + " " + t[1];
        return t[0] + n + " " + e.join(", ") + " " + t[1];
      }(a, I, w)) : w[0] + I + w[1];
    }

    function u(e) {
      return "[" + Error.prototype.toString.call(e) + "]";
    }

    function p(e, n, t, r, o, i) {
      var A, s, l;

      if ((l = Object.getOwnPropertyDescriptor(n, o) || {
        value: n[o]
      }).get ? s = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (s = e.stylize("[Setter]", "special")), D(r, o) || (A = "[" + o + "]"), s || (e.seen.indexOf(l.value) < 0 ? (s = d(t) ? c(e, l.value, null) : c(e, l.value, t - 1)).indexOf("\n") > -1 && (s = i ? s.split("\n").map(function (e) {
        return "  " + e;
      }).join("\n").substr(2) : "\n" + s.split("\n").map(function (e) {
        return "   " + e;
      }).join("\n")) : s = e.stylize("[Circular]", "special")), x(A)) {
        if (i && o.match(/^\d+$/)) return s;
        (A = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (A = A.substr(1, A.length - 2), A = e.stylize(A, "name")) : (A = A.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), A = e.stylize(A, "string"));
      }

      return A + ": " + s;
    }

    function m(e) {
      return Array.isArray(e);
    }

    function C(e) {
      return "boolean" == typeof e;
    }

    function d(e) {
      return null === e;
    }

    function f(e) {
      return "number" == typeof e;
    }

    function h(e) {
      return "string" == typeof e;
    }

    function x(e) {
      return void 0 === e;
    }

    function g(e) {
      return I(e) && "[object RegExp]" === v(e);
    }

    function I(e) {
      return "object" == typeof e && null !== e;
    }

    function b(e) {
      return I(e) && "[object Date]" === v(e);
    }

    function y(e) {
      return I(e) && ("[object Error]" === v(e) || e instanceof Error);
    }

    function E(e) {
      return "function" == typeof e;
    }

    function v(e) {
      return Object.prototype.toString.call(e);
    }

    function w(e) {
      return e < 10 ? "0" + e.toString(10) : e.toString(10);
    }

    n.debuglog = function (t) {
      if (x(i) && (i = e.env.NODE_DEBUG || ""), t = t.toUpperCase(), !A[t]) if (new RegExp("\\b" + t + "\\b", "i").test(i)) {
        var r = e.pid;

        A[t] = function () {
          var e = n.format.apply(n, arguments);
          console.error("%s %d: %s", t, r, e);
        };
      } else A[t] = function () {};
      return A[t];
    }, n.inspect = s, s.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, s.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      regexp: "red"
    }, n.isArray = m, n.isBoolean = C, n.isNull = d, n.isNullOrUndefined = function (e) {
      return null == e;
    }, n.isNumber = f, n.isString = h, n.isSymbol = function (e) {
      return "symbol" == typeof e;
    }, n.isUndefined = x, n.isRegExp = g, n.isObject = I, n.isDate = b, n.isError = y, n.isFunction = E, n.isPrimitive = function (e) {
      return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
    }, n.isBuffer = t(212);
    var B = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    function _() {
      var e = new Date(),
          n = [w(e.getHours()), w(e.getMinutes()), w(e.getSeconds())].join(":");
      return [e.getDate(), B[e.getMonth()], n].join(" ");
    }

    function D(e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }

    n.log = function () {
      console.log("%s - %s", _(), n.format.apply(n, arguments));
    }, n.inherits = t(213), n._extend = function (e, n) {
      if (!n || !I(n)) return e;

      for (var t = Object.keys(n), r = t.length; r--;) {
        e[t[r]] = n[t[r]];
      }

      return e;
    };
    var S = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

    function M(e, n) {
      if (!e) {
        var t = new Error("Promise was rejected with a falsy value");
        t.reason = e, e = t;
      }

      return n(e);
    }

    n.promisify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

      if (S && e[S]) {
        var n;
        if ("function" != typeof (n = e[S])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(n, S, {
          value: n,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), n;
      }

      function n() {
        for (var n, t, r = new Promise(function (e, r) {
          n = e, t = r;
        }), o = [], i = 0; i < arguments.length; i++) {
          o.push(arguments[i]);
        }

        o.push(function (e, r) {
          e ? t(e) : n(r);
        });

        try {
          e.apply(this, o);
        } catch (e) {
          t(e);
        }

        return r;
      }

      return Object.setPrototypeOf(n, Object.getPrototypeOf(e)), S && Object.defineProperty(n, S, {
        value: n,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(n, r(e));
    }, n.promisify.custom = S, n.callbackify = function (n) {
      if ("function" != typeof n) throw new TypeError('The "original" argument must be of type Function');

      function t() {
        for (var t = [], r = 0; r < arguments.length; r++) {
          t.push(arguments[r]);
        }

        var o = t.pop();
        if ("function" != typeof o) throw new TypeError("The last argument must be of type Function");

        var i = this,
            A = function A() {
          return o.apply(i, arguments);
        };

        n.apply(this, t).then(function (n) {
          e.nextTick(A, null, n);
        }, function (n) {
          e.nextTick(M, n, A);
        });
      }

      return Object.setPrototypeOf(t, Object.getPrototypeOf(n)), Object.defineProperties(t, r(n)), t;
    };
  }).call(this, t(46));
}, function (e, n) {
  e.exports = function (e) {
    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
  };
}, function (e, n) {
  "function" == typeof Object.create ? e.exports = function (e, n) {
    e.super_ = n, e.prototype = Object.create(n.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  } : e.exports = function (e, n) {
    e.super_ = n;

    var t = function t() {};

    t.prototype = n.prototype, e.prototype = new t(), e.prototype.constructor = e;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(54);

  e.exports = function (e, n, t) {
    var o = [];
    return (e = r.makeItArrayIfItsNot(e)).forEach(function (e) {
      o.push(function (e, n, t) {
        for (var r = [t], o = 1; o < n.length; o++) {
          r.push([]);

          for (var i = 1; i <= o; i++) {
            r[i][o] = ((e - n[o - i]) * r[i - 1][o] - (e - n[o]) * r[i - 1][o - 1]) / (n[o] - n[o - i]);
          }
        }

        return r[i - 1][o - 1];
      }(e, n, t));
    }), o;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(54);

  e.exports = function (e, n, t) {
    var o = [];
    return (e = r.makeItArrayIfItsNot(e)).forEach(function (e) {
      var i,
          A,
          s,
          l,
          a,
          c,
          u = r.findIntervalLeftBorderIndex(e, n);
      u == n.length - 1 && u--, o.push((i = e, A = n[u], s = t[u], l = n[u + 1], a = t[u + 1], (c = (a - s) / (l - A)) * i + (-c * A + s)));
    }), o;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = function (e, n) {
    for (var t = {}, o = e, i = n, A = i.length, s = 0, l = 0, a = 0, c = 0, u = 0, p = 0; p < i.length; p++) {
      s += o[p], l += i[p], a += o[p] * i[p], c += o[p] * o[p], u += i[p] * i[p];
    }

    return t.slope = (A * a - s * l) / (A * c - s * s), t.intercept = (l - t.slope * s) / A, t.rSquared = Math.pow((A * a - s * l) / Math.sqrt((A * c - s * s) * (A * u - l * l)), 2), t.evaluate = function (e) {
      var n = r.makeItArrayIfItsNot(e),
          t = [],
          o = this;
      return n.forEach(function (e) {
        t.push(o.slope * e + o.intercept);
      }), t;
    }, t;
  };

  var r = t(54);
}, function (e, n, t) {
  "use strict";

  var r = t(54);

  e.exports = function (e, n, t) {
    return r.makeItArrayIfItsNot(e).map(function (e) {
      return t[r.findIntervalLeftBorderIndex(e, n)];
    });
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._3PjWW14H5jv-J1Gj9a4qOz{background:#f9f9f9}._33b8lH3CQYlYUnfqLJ7uHy .public-DraftEditor-content{max-height:75vh;overflow:auto;padding:8px 16px;background-color:white}@media (max-width: 768px){._33b8lH3CQYlYUnfqLJ7uHy .public-DraftEditor-content{margin:0 auto}}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/timed-text-editor/index.module.css"],
    names: [],
    mappings: "AAEA,yBACE,kBAAmB,CACpB,qDAQC,eAAgB,CAChB,aAAc,CACd,gBAAiB,CACjB,sBAAuB,CACxB,0BAKC,qDACE,aAAc,CACf",
    file: "index.module.css",
    sourcesContent: ["@import '../../config/style-guide/colours.scss';\n\n.DraftEditor-root {\n  background: #f9f9f9;\n}\n\n/*\nGiving the editor a oveflow\nhttps://github.com/facebook/draft-js/issues/528\n*/\n\n.editor :global(.public-DraftEditor-content) {\n  max-height: 75vh;\n  overflow: auto;\n  padding: 8px 16px;\n  background-color: white;\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n\n  .editor :global(.public-DraftEditor-content) {\n    margin: 0 auto;\n  }\n}\n"]
  }]), n.locals = {
    "DraftEditor-root": "_3PjWW14H5jv-J1Gj9a4qOz",
    editor: "_33b8lH3CQYlYUnfqLJ7uHy"
  };
}, function (e, n, t) {
  var r;
  !function (o, i, A) {
    for (var s, l = {
      8: "backspace",
      9: "tab",
      13: "enter",
      16: "shift",
      17: "ctrl",
      18: "alt",
      20: "capslock",
      27: "esc",
      32: "space",
      33: "pageup",
      34: "pagedown",
      35: "end",
      36: "home",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      45: "ins",
      46: "del",
      91: "meta",
      93: "meta",
      224: "meta"
    }, a = {
      106: "*",
      107: "+",
      109: "-",
      110: ".",
      111: "/",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'"
    }, c = {
      "~": "`",
      "!": "1",
      "@": "2",
      "#": "3",
      $: "4",
      "%": "5",
      "^": "6",
      "&": "7",
      "*": "8",
      "(": "9",
      ")": "0",
      _: "-",
      "+": "=",
      ":": ";",
      '"': "'",
      "<": ",",
      ">": ".",
      "?": "/",
      "|": "\\"
    }, u = {
      option: "alt",
      command: "meta",
      return: "enter",
      escape: "esc",
      plus: "+",
      mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
    }, p = 1; p < 20; ++p) {
      l[111 + p] = "f" + p;
    }

    for (p = 0; p <= 9; ++p) {
      l[p + 96] = p;
    }

    function m(e, n, t) {
      e.addEventListener ? e.addEventListener(n, t, !1) : e.attachEvent("on" + n, t);
    }

    function C(e) {
      if ("keypress" == e.type) {
        var n = String.fromCharCode(e.which);
        return e.shiftKey || (n = n.toLowerCase()), n;
      }

      return l[e.which] ? l[e.which] : a[e.which] ? a[e.which] : String.fromCharCode(e.which).toLowerCase();
    }

    function d(e) {
      return "shift" == e || "ctrl" == e || "alt" == e || "meta" == e;
    }

    function f(e, n, t) {
      return t || (t = function () {
        if (!s) for (var e in s = {}, l) {
          e > 95 && e < 112 || l.hasOwnProperty(e) && (s[l[e]] = e);
        }
        return s;
      }()[e] ? "keydown" : "keypress"), "keypress" == t && n.length && (t = "keydown"), t;
    }

    function h(e, n) {
      var t,
          r,
          o,
          i = [];

      for (t = function (e) {
        return "+" === e ? ["+"] : (e = e.replace(/\+{2}/g, "+plus")).split("+");
      }(e), o = 0; o < t.length; ++o) {
        r = t[o], u[r] && (r = u[r]), n && "keypress" != n && c[r] && (r = c[r], i.push("shift")), d(r) && i.push(r);
      }

      return {
        key: r,
        modifiers: i,
        action: n = f(r, i, n)
      };
    }

    function x(e) {
      var n = this;
      if (e = e || i, !(n instanceof x)) return new x(e);
      n.target = e, n._callbacks = {}, n._directMap = {};
      var t,
          r = {},
          o = !1,
          A = !1,
          s = !1;

      function l(e) {
        e = e || {};
        var n,
            t = !1;

        for (n in r) {
          e[n] ? t = !0 : r[n] = 0;
        }

        t || (s = !1);
      }

      function a(e, t, o, i, A, s) {
        var l,
            a,
            c,
            u,
            p = [],
            m = o.type;
        if (!n._callbacks[e]) return [];

        for ("keyup" == m && d(e) && (t = [e]), l = 0; l < n._callbacks[e].length; ++l) {
          if (a = n._callbacks[e][l], (i || !a.seq || r[a.seq] == a.level) && m == a.action && ("keypress" == m && !o.metaKey && !o.ctrlKey || (c = t, u = a.modifiers, c.sort().join(",") === u.sort().join(",")))) {
            var C = !i && a.combo == A,
                f = i && a.seq == i && a.level == s;
            (C || f) && n._callbacks[e].splice(l, 1), p.push(a);
          }
        }

        return p;
      }

      function c(e, t, r, o) {
        n.stopCallback(t, t.target || t.srcElement, r, o) || !1 === e(t, r) && (function (e) {
          e.preventDefault ? e.preventDefault() : e.returnValue = !1;
        }(t), function (e) {
          e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0;
        }(t));
      }

      function u(e) {
        "number" != typeof e.which && (e.which = e.keyCode);
        var t = C(e);
        t && ("keyup" != e.type || o !== t ? n.handleKey(t, function (e) {
          var n = [];
          return e.shiftKey && n.push("shift"), e.altKey && n.push("alt"), e.ctrlKey && n.push("ctrl"), e.metaKey && n.push("meta"), n;
        }(e), e) : o = !1);
      }

      function p(e, n, i, A) {
        function a(n) {
          return function () {
            s = n, ++r[e], clearTimeout(t), t = setTimeout(l, 1e3);
          };
        }

        function u(n) {
          c(i, n, e), "keyup" !== A && (o = C(n)), setTimeout(l, 10);
        }

        r[e] = 0;

        for (var p = 0; p < n.length; ++p) {
          var m = p + 1 === n.length ? u : a(A || h(n[p + 1]).action);
          f(n[p], m, A, e, p);
        }
      }

      function f(e, t, r, o, i) {
        n._directMap[e + ":" + r] = t;
        var A,
            s = (e = e.replace(/\s+/g, " ")).split(" ");
        s.length > 1 ? p(e, s, t, r) : (A = h(e, r), n._callbacks[A.key] = n._callbacks[A.key] || [], a(A.key, A.modifiers, {
          type: A.action
        }, o, e, i), n._callbacks[A.key][o ? "unshift" : "push"]({
          callback: t,
          modifiers: A.modifiers,
          action: A.action,
          seq: o,
          level: i,
          combo: e
        }));
      }

      n._handleKey = function (e, n, t) {
        var r,
            o = a(e, n, t),
            i = {},
            u = 0,
            p = !1;

        for (r = 0; r < o.length; ++r) {
          o[r].seq && (u = Math.max(u, o[r].level));
        }

        for (r = 0; r < o.length; ++r) {
          if (o[r].seq) {
            if (o[r].level != u) continue;
            p = !0, i[o[r].seq] = 1, c(o[r].callback, t, o[r].combo, o[r].seq);
          } else p || c(o[r].callback, t, o[r].combo);
        }

        var m = "keypress" == t.type && A;
        t.type != s || d(e) || m || l(i), A = p && "keydown" == t.type;
      }, n._bindMultiple = function (e, n, t) {
        for (var r = 0; r < e.length; ++r) {
          f(e[r], n, t);
        }
      }, m(e, "keypress", u), m(e, "keydown", u), m(e, "keyup", u);
    }

    x.prototype.bind = function (e, n, t) {
      return e = e instanceof Array ? e : [e], this._bindMultiple.call(this, e, n, t), this;
    }, x.prototype.unbind = function (e, n) {
      return this.bind.call(this, e, function () {}, n);
    }, x.prototype.trigger = function (e, n) {
      return this._directMap[e + ":" + n] && this._directMap[e + ":" + n]({}, e), this;
    }, x.prototype.reset = function () {
      return this._callbacks = {}, this._directMap = {}, this;
    }, x.prototype.stopCallback = function (e, n) {
      return !((" " + n.className + " ").indexOf(" mousetrap ") > -1) && !function e(n, t) {
        return n !== i && (n === t || e(n.parentNode, t));
      }(n, this.target) && ("INPUT" == n.tagName || "SELECT" == n.tagName || "TEXTAREA" == n.tagName || n.isContentEditable);
    }, x.prototype.handleKey = function () {
      var e = this;
      return e._handleKey.apply(e, arguments);
    }, x.init = function () {
      var e = x(i);

      for (var n in e) {
        "_" !== n.charAt(0) && (x[n] = function (n) {
          return function () {
            return e[n].apply(e, arguments);
          };
        }(n));
      }
    }, x.init(), o.Mousetrap = x, e.exports && (e.exports = x), void 0 === (r = function () {
      return x;
    }.call(n, t, n, e)) || (e.exports = r);
  }(window, document);
}, function (e, n, t) {
  (function (e, r) {
    var o;
    /**
     * @license
     * Lodash <https://lodash.com/>
     * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */

    (function () {
      var i,
          A = 200,
          s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",
          l = "Expected a function",
          a = "__lodash_hash_undefined__",
          c = 500,
          u = "__lodash_placeholder__",
          p = 1,
          m = 2,
          C = 4,
          d = 1,
          f = 2,
          h = 1,
          x = 2,
          g = 4,
          I = 8,
          b = 16,
          y = 32,
          E = 64,
          v = 128,
          w = 256,
          B = 512,
          _ = 30,
          D = "...",
          S = 800,
          M = 16,
          O = 1,
          k = 2,
          T = 1 / 0,
          P = 9007199254740991,
          K = 17976931348623157e292,
          Q = NaN,
          U = 4294967295,
          R = U - 1,
          G = U >>> 1,
          Y = [["ary", v], ["bind", h], ["bindKey", x], ["curry", I], ["curryRight", b], ["flip", B], ["partial", y], ["partialRight", E], ["rearg", w]],
          F = "[object Arguments]",
          N = "[object Array]",
          j = "[object AsyncFunction]",
          W = "[object Boolean]",
          L = "[object Date]",
          z = "[object DOMException]",
          X = "[object Error]",
          H = "[object Function]",
          q = "[object GeneratorFunction]",
          V = "[object Map]",
          J = "[object Number]",
          Z = "[object Null]",
          $ = "[object Object]",
          ee = "[object Proxy]",
          ne = "[object RegExp]",
          te = "[object Set]",
          re = "[object String]",
          oe = "[object Symbol]",
          ie = "[object Undefined]",
          Ae = "[object WeakMap]",
          se = "[object WeakSet]",
          le = "[object ArrayBuffer]",
          ae = "[object DataView]",
          ce = "[object Float32Array]",
          ue = "[object Float64Array]",
          pe = "[object Int8Array]",
          me = "[object Int16Array]",
          Ce = "[object Int32Array]",
          de = "[object Uint8Array]",
          fe = "[object Uint8ClampedArray]",
          he = "[object Uint16Array]",
          xe = "[object Uint32Array]",
          ge = /\b__p \+= '';/g,
          Ie = /\b(__p \+=) '' \+/g,
          be = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
          ye = /&(?:amp|lt|gt|quot|#39);/g,
          Ee = /[&<>"']/g,
          ve = RegExp(ye.source),
          we = RegExp(Ee.source),
          Be = /<%-([\s\S]+?)%>/g,
          _e = /<%([\s\S]+?)%>/g,
          De = /<%=([\s\S]+?)%>/g,
          Se = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          Me = /^\w*$/,
          Oe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          ke = /[\\^$.*+?()[\]{}|]/g,
          Te = RegExp(ke.source),
          Pe = /^\s+|\s+$/g,
          Ke = /^\s+/,
          Qe = /\s+$/,
          Ue = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
          Re = /\{\n\/\* \[wrapped with (.+)\] \*/,
          Ge = /,? & /,
          Ye = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
          Fe = /\\(\\)?/g,
          Ne = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
          je = /\w*$/,
          We = /^[-+]0x[0-9a-f]+$/i,
          Le = /^0b[01]+$/i,
          ze = /^\[object .+?Constructor\]$/,
          Xe = /^0o[0-7]+$/i,
          He = /^(?:0|[1-9]\d*)$/,
          qe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
          Ve = /($^)/,
          Je = /['\n\r\u2028\u2029\\]/g,
          Ze = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
          $e = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
          en = "[\\ud800-\\udfff]",
          nn = "[" + $e + "]",
          tn = "[" + Ze + "]",
          rn = "\\d+",
          on = "[\\u2700-\\u27bf]",
          An = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
          sn = "[^\\ud800-\\udfff" + $e + rn + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
          ln = "\\ud83c[\\udffb-\\udfff]",
          an = "[^\\ud800-\\udfff]",
          cn = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          un = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          pn = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
          mn = "(?:" + An + "|" + sn + ")",
          Cn = "(?:" + pn + "|" + sn + ")",
          dn = "(?:" + tn + "|" + ln + ")" + "?",
          fn = "[\\ufe0e\\ufe0f]?" + dn + ("(?:\\u200d(?:" + [an, cn, un].join("|") + ")[\\ufe0e\\ufe0f]?" + dn + ")*"),
          hn = "(?:" + [on, cn, un].join("|") + ")" + fn,
          xn = "(?:" + [an + tn + "?", tn, cn, un, en].join("|") + ")",
          gn = RegExp("['’]", "g"),
          In = RegExp(tn, "g"),
          bn = RegExp(ln + "(?=" + ln + ")|" + xn + fn, "g"),
          yn = RegExp([pn + "?" + An + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [nn, pn, "$"].join("|") + ")", Cn + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [nn, pn + mn, "$"].join("|") + ")", pn + "?" + mn + "+(?:['’](?:d|ll|m|re|s|t|ve))?", pn + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rn, hn].join("|"), "g"),
          En = RegExp("[\\u200d\\ud800-\\udfff" + Ze + "\\ufe0e\\ufe0f]"),
          vn = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
          wn = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
          Bn = -1,
          _n = {};
      _n[ce] = _n[ue] = _n[pe] = _n[me] = _n[Ce] = _n[de] = _n[fe] = _n[he] = _n[xe] = !0, _n[F] = _n[N] = _n[le] = _n[W] = _n[ae] = _n[L] = _n[X] = _n[H] = _n[V] = _n[J] = _n[$] = _n[ne] = _n[te] = _n[re] = _n[Ae] = !1;
      var Dn = {};
      Dn[F] = Dn[N] = Dn[le] = Dn[ae] = Dn[W] = Dn[L] = Dn[ce] = Dn[ue] = Dn[pe] = Dn[me] = Dn[Ce] = Dn[V] = Dn[J] = Dn[$] = Dn[ne] = Dn[te] = Dn[re] = Dn[oe] = Dn[de] = Dn[fe] = Dn[he] = Dn[xe] = !0, Dn[X] = Dn[H] = Dn[Ae] = !1;

      var Sn = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      },
          Mn = parseFloat,
          On = parseInt,
          kn = "object" == typeof e && e && e.Object === Object && e,
          Tn = "object" == typeof self && self && self.Object === Object && self,
          Pn = kn || Tn || Function("return this")(),
          Kn = n && !n.nodeType && n,
          Qn = Kn && "object" == typeof r && r && !r.nodeType && r,
          Un = Qn && Qn.exports === Kn,
          Rn = Un && kn.process,
          Gn = function () {
        try {
          var e = Qn && Qn.require && Qn.require("util").types;

          return e || Rn && Rn.binding && Rn.binding("util");
        } catch (e) {}
      }(),
          Yn = Gn && Gn.isArrayBuffer,
          Fn = Gn && Gn.isDate,
          Nn = Gn && Gn.isMap,
          jn = Gn && Gn.isRegExp,
          Wn = Gn && Gn.isSet,
          Ln = Gn && Gn.isTypedArray;

      function zn(e, n, t) {
        switch (t.length) {
          case 0:
            return e.call(n);

          case 1:
            return e.call(n, t[0]);

          case 2:
            return e.call(n, t[0], t[1]);

          case 3:
            return e.call(n, t[0], t[1], t[2]);
        }

        return e.apply(n, t);
      }

      function Xn(e, n, t, r) {
        for (var o = -1, i = null == e ? 0 : e.length; ++o < i;) {
          var A = e[o];
          n(r, A, t(A), e);
        }

        return r;
      }

      function Hn(e, n) {
        for (var t = -1, r = null == e ? 0 : e.length; ++t < r && !1 !== n(e[t], t, e);) {
          ;
        }

        return e;
      }

      function qn(e, n) {
        for (var t = null == e ? 0 : e.length; t-- && !1 !== n(e[t], t, e);) {
          ;
        }

        return e;
      }

      function Vn(e, n) {
        for (var t = -1, r = null == e ? 0 : e.length; ++t < r;) {
          if (!n(e[t], t, e)) return !1;
        }

        return !0;
      }

      function Jn(e, n) {
        for (var t = -1, r = null == e ? 0 : e.length, o = 0, i = []; ++t < r;) {
          var A = e[t];
          n(A, t, e) && (i[o++] = A);
        }

        return i;
      }

      function Zn(e, n) {
        return !!(null == e ? 0 : e.length) && lt(e, n, 0) > -1;
      }

      function $n(e, n, t) {
        for (var r = -1, o = null == e ? 0 : e.length; ++r < o;) {
          if (t(n, e[r])) return !0;
        }

        return !1;
      }

      function et(e, n) {
        for (var t = -1, r = null == e ? 0 : e.length, o = Array(r); ++t < r;) {
          o[t] = n(e[t], t, e);
        }

        return o;
      }

      function nt(e, n) {
        for (var t = -1, r = n.length, o = e.length; ++t < r;) {
          e[o + t] = n[t];
        }

        return e;
      }

      function tt(e, n, t, r) {
        var o = -1,
            i = null == e ? 0 : e.length;

        for (r && i && (t = e[++o]); ++o < i;) {
          t = n(t, e[o], o, e);
        }

        return t;
      }

      function rt(e, n, t, r) {
        var o = null == e ? 0 : e.length;

        for (r && o && (t = e[--o]); o--;) {
          t = n(t, e[o], o, e);
        }

        return t;
      }

      function ot(e, n) {
        for (var t = -1, r = null == e ? 0 : e.length; ++t < r;) {
          if (n(e[t], t, e)) return !0;
        }

        return !1;
      }

      var it = pt("length");

      function At(e, n, t) {
        var r;
        return t(e, function (e, t, o) {
          if (n(e, t, o)) return r = t, !1;
        }), r;
      }

      function st(e, n, t, r) {
        for (var o = e.length, i = t + (r ? 1 : -1); r ? i-- : ++i < o;) {
          if (n(e[i], i, e)) return i;
        }

        return -1;
      }

      function lt(e, n, t) {
        return n == n ? function (e, n, t) {
          var r = t - 1,
              o = e.length;

          for (; ++r < o;) {
            if (e[r] === n) return r;
          }

          return -1;
        }(e, n, t) : st(e, ct, t);
      }

      function at(e, n, t, r) {
        for (var o = t - 1, i = e.length; ++o < i;) {
          if (r(e[o], n)) return o;
        }

        return -1;
      }

      function ct(e) {
        return e != e;
      }

      function ut(e, n) {
        var t = null == e ? 0 : e.length;
        return t ? dt(e, n) / t : Q;
      }

      function pt(e) {
        return function (n) {
          return null == n ? i : n[e];
        };
      }

      function mt(e) {
        return function (n) {
          return null == e ? i : e[n];
        };
      }

      function Ct(e, n, t, r, o) {
        return o(e, function (e, o, i) {
          t = r ? (r = !1, e) : n(t, e, o, i);
        }), t;
      }

      function dt(e, n) {
        for (var t, r = -1, o = e.length; ++r < o;) {
          var A = n(e[r]);
          A !== i && (t = t === i ? A : t + A);
        }

        return t;
      }

      function ft(e, n) {
        for (var t = -1, r = Array(e); ++t < e;) {
          r[t] = n(t);
        }

        return r;
      }

      function ht(e) {
        return function (n) {
          return e(n);
        };
      }

      function xt(e, n) {
        return et(n, function (n) {
          return e[n];
        });
      }

      function gt(e, n) {
        return e.has(n);
      }

      function It(e, n) {
        for (var t = -1, r = e.length; ++t < r && lt(n, e[t], 0) > -1;) {
          ;
        }

        return t;
      }

      function bt(e, n) {
        for (var t = e.length; t-- && lt(n, e[t], 0) > -1;) {
          ;
        }

        return t;
      }

      var yt = mt({
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      }),
          Et = mt({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      });

      function vt(e) {
        return "\\" + Sn[e];
      }

      function wt(e) {
        return En.test(e);
      }

      function Bt(e) {
        var n = -1,
            t = Array(e.size);
        return e.forEach(function (e, r) {
          t[++n] = [r, e];
        }), t;
      }

      function _t(e, n) {
        return function (t) {
          return e(n(t));
        };
      }

      function Dt(e, n) {
        for (var t = -1, r = e.length, o = 0, i = []; ++t < r;) {
          var A = e[t];
          A !== n && A !== u || (e[t] = u, i[o++] = t);
        }

        return i;
      }

      function St(e) {
        var n = -1,
            t = Array(e.size);
        return e.forEach(function (e) {
          t[++n] = e;
        }), t;
      }

      function Mt(e) {
        var n = -1,
            t = Array(e.size);
        return e.forEach(function (e) {
          t[++n] = [e, e];
        }), t;
      }

      function Ot(e) {
        return wt(e) ? function (e) {
          var n = bn.lastIndex = 0;

          for (; bn.test(e);) {
            ++n;
          }

          return n;
        }(e) : it(e);
      }

      function kt(e) {
        return wt(e) ? function (e) {
          return e.match(bn) || [];
        }(e) : function (e) {
          return e.split("");
        }(e);
      }

      var Tt = mt({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      });

      var Pt = function e(n) {
        var t,
            r = (n = null == n ? Pn : Pt.defaults(Pn.Object(), n, Pt.pick(Pn, wn))).Array,
            o = n.Date,
            Ze = n.Error,
            $e = n.Function,
            en = n.Math,
            nn = n.Object,
            tn = n.RegExp,
            rn = n.String,
            on = n.TypeError,
            An = r.prototype,
            sn = $e.prototype,
            ln = nn.prototype,
            an = n["__core-js_shared__"],
            cn = sn.toString,
            un = ln.hasOwnProperty,
            pn = 0,
            mn = (t = /[^.]+$/.exec(an && an.keys && an.keys.IE_PROTO || "")) ? "Symbol(src)_1." + t : "",
            Cn = ln.toString,
            dn = cn.call(nn),
            fn = Pn._,
            hn = tn("^" + cn.call(un).replace(ke, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
            xn = Un ? n.Buffer : i,
            bn = n.Symbol,
            En = n.Uint8Array,
            Sn = xn ? xn.allocUnsafe : i,
            kn = _t(nn.getPrototypeOf, nn),
            Tn = nn.create,
            Kn = ln.propertyIsEnumerable,
            Qn = An.splice,
            Rn = bn ? bn.isConcatSpreadable : i,
            Gn = bn ? bn.iterator : i,
            it = bn ? bn.toStringTag : i,
            mt = function () {
          try {
            var e = Gi(nn, "defineProperty");
            return e({}, "", {}), e;
          } catch (e) {}
        }(),
            Kt = n.clearTimeout !== Pn.clearTimeout && n.clearTimeout,
            Qt = o && o.now !== Pn.Date.now && o.now,
            Ut = n.setTimeout !== Pn.setTimeout && n.setTimeout,
            Rt = en.ceil,
            Gt = en.floor,
            Yt = nn.getOwnPropertySymbols,
            Ft = xn ? xn.isBuffer : i,
            Nt = n.isFinite,
            jt = An.join,
            Wt = _t(nn.keys, nn),
            Lt = en.max,
            zt = en.min,
            Xt = o.now,
            Ht = n.parseInt,
            qt = en.random,
            Vt = An.reverse,
            Jt = Gi(n, "DataView"),
            Zt = Gi(n, "Map"),
            $t = Gi(n, "Promise"),
            er = Gi(n, "Set"),
            nr = Gi(n, "WeakMap"),
            tr = Gi(nn, "create"),
            rr = nr && new nr(),
            or = {},
            ir = uA(Jt),
            Ar = uA(Zt),
            sr = uA($t),
            lr = uA(er),
            ar = uA(nr),
            cr = bn ? bn.prototype : i,
            ur = cr ? cr.valueOf : i,
            pr = cr ? cr.toString : i;

        function mr(e) {
          if (Ds(e) && !hs(e) && !(e instanceof hr)) {
            if (e instanceof fr) return e;
            if (un.call(e, "__wrapped__")) return pA(e);
          }

          return new fr(e);
        }

        var Cr = function () {
          function e() {}

          return function (n) {
            if (!_s(n)) return {};
            if (Tn) return Tn(n);
            e.prototype = n;
            var t = new e();
            return e.prototype = i, t;
          };
        }();

        function dr() {}

        function fr(e, n) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = i;
        }

        function hr(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = U, this.__views__ = [];
        }

        function xr(e) {
          var n = -1,
              t = null == e ? 0 : e.length;

          for (this.clear(); ++n < t;) {
            var r = e[n];
            this.set(r[0], r[1]);
          }
        }

        function gr(e) {
          var n = -1,
              t = null == e ? 0 : e.length;

          for (this.clear(); ++n < t;) {
            var r = e[n];
            this.set(r[0], r[1]);
          }
        }

        function Ir(e) {
          var n = -1,
              t = null == e ? 0 : e.length;

          for (this.clear(); ++n < t;) {
            var r = e[n];
            this.set(r[0], r[1]);
          }
        }

        function br(e) {
          var n = -1,
              t = null == e ? 0 : e.length;

          for (this.__data__ = new Ir(); ++n < t;) {
            this.add(e[n]);
          }
        }

        function yr(e) {
          var n = this.__data__ = new gr(e);
          this.size = n.size;
        }

        function Er(e, n) {
          var t = hs(e),
              r = !t && fs(e),
              o = !t && !r && bs(e),
              i = !t && !r && !o && Qs(e),
              A = t || r || o || i,
              s = A ? ft(e.length, rn) : [],
              l = s.length;

          for (var a in e) {
            !n && !un.call(e, a) || A && ("length" == a || o && ("offset" == a || "parent" == a) || i && ("buffer" == a || "byteLength" == a || "byteOffset" == a) || zi(a, l)) || s.push(a);
          }

          return s;
        }

        function vr(e) {
          var n = e.length;
          return n ? e[yo(0, n - 1)] : i;
        }

        function wr(e, n) {
          return lA(ri(e), Pr(n, 0, e.length));
        }

        function Br(e) {
          return lA(ri(e));
        }

        function _r(e, n, t) {
          (t === i || ms(e[n], t)) && (t !== i || n in e) || kr(e, n, t);
        }

        function Dr(e, n, t) {
          var r = e[n];
          un.call(e, n) && ms(r, t) && (t !== i || n in e) || kr(e, n, t);
        }

        function Sr(e, n) {
          for (var t = e.length; t--;) {
            if (ms(e[t][0], n)) return t;
          }

          return -1;
        }

        function Mr(e, n, t, r) {
          return Gr(e, function (e, o, i) {
            n(r, e, t(e), i);
          }), r;
        }

        function Or(e, n) {
          return e && oi(n, ol(n), e);
        }

        function kr(e, n, t) {
          "__proto__" == n && mt ? mt(e, n, {
            configurable: !0,
            enumerable: !0,
            value: t,
            writable: !0
          }) : e[n] = t;
        }

        function Tr(e, n) {
          for (var t = -1, o = n.length, A = r(o), s = null == e; ++t < o;) {
            A[t] = s ? i : $s(e, n[t]);
          }

          return A;
        }

        function Pr(e, n, t) {
          return e == e && (t !== i && (e = e <= t ? e : t), n !== i && (e = e >= n ? e : n)), e;
        }

        function Kr(e, n, t, r, o, A) {
          var s,
              l = n & p,
              a = n & m,
              c = n & C;
          if (t && (s = o ? t(e, r, o, A) : t(e)), s !== i) return s;
          if (!_s(e)) return e;
          var u = hs(e);

          if (u) {
            if (s = function (e) {
              var n = e.length,
                  t = new e.constructor(n);
              n && "string" == typeof e[0] && un.call(e, "index") && (t.index = e.index, t.input = e.input);
              return t;
            }(e), !l) return ri(e, s);
          } else {
            var d = Ni(e),
                f = d == H || d == q;
            if (bs(e)) return Jo(e, l);

            if (d == $ || d == F || f && !o) {
              if (s = a || f ? {} : Wi(e), !l) return a ? function (e, n) {
                return oi(e, Fi(e), n);
              }(e, function (e, n) {
                return e && oi(n, il(n), e);
              }(s, e)) : function (e, n) {
                return oi(e, Yi(e), n);
              }(e, Or(s, e));
            } else {
              if (!Dn[d]) return o ? e : {};

              s = function (e, n, t) {
                var r = e.constructor;

                switch (n) {
                  case le:
                    return Zo(e);

                  case W:
                  case L:
                    return new r(+e);

                  case ae:
                    return function (e, n) {
                      var t = n ? Zo(e.buffer) : e.buffer;
                      return new e.constructor(t, e.byteOffset, e.byteLength);
                    }(e, t);

                  case ce:
                  case ue:
                  case pe:
                  case me:
                  case Ce:
                  case de:
                  case fe:
                  case he:
                  case xe:
                    return $o(e, t);

                  case V:
                    return new r();

                  case J:
                  case re:
                    return new r(e);

                  case ne:
                    return function (e) {
                      var n = new e.constructor(e.source, je.exec(e));
                      return n.lastIndex = e.lastIndex, n;
                    }(e);

                  case te:
                    return new r();

                  case oe:
                    return o = e, ur ? nn(ur.call(o)) : {};
                }

                var o;
              }(e, d, l);
            }
          }

          A || (A = new yr());
          var h = A.get(e);
          if (h) return h;
          A.set(e, s), Ts(e) ? e.forEach(function (r) {
            s.add(Kr(r, n, t, r, e, A));
          }) : Ss(e) && e.forEach(function (r, o) {
            s.set(o, Kr(r, n, t, o, e, A));
          });
          var x = u ? i : (c ? a ? ki : Oi : a ? il : ol)(e);
          return Hn(x || e, function (r, o) {
            x && (r = e[o = r]), Dr(s, o, Kr(r, n, t, o, e, A));
          }), s;
        }

        function Qr(e, n, t) {
          var r = t.length;
          if (null == e) return !r;

          for (e = nn(e); r--;) {
            var o = t[r],
                A = n[o],
                s = e[o];
            if (s === i && !(o in e) || !A(s)) return !1;
          }

          return !0;
        }

        function Ur(e, n, t) {
          if ("function" != typeof e) throw new on(l);
          return oA(function () {
            e.apply(i, t);
          }, n);
        }

        function Rr(e, n, t, r) {
          var o = -1,
              i = Zn,
              s = !0,
              l = e.length,
              a = [],
              c = n.length;
          if (!l) return a;
          t && (n = et(n, ht(t))), r ? (i = $n, s = !1) : n.length >= A && (i = gt, s = !1, n = new br(n));

          e: for (; ++o < l;) {
            var u = e[o],
                p = null == t ? u : t(u);

            if (u = r || 0 !== u ? u : 0, s && p == p) {
              for (var m = c; m--;) {
                if (n[m] === p) continue e;
              }

              a.push(u);
            } else i(n, p, r) || a.push(u);
          }

          return a;
        }

        mr.templateSettings = {
          escape: Be,
          evaluate: _e,
          interpolate: De,
          variable: "",
          imports: {
            _: mr
          }
        }, mr.prototype = dr.prototype, mr.prototype.constructor = mr, fr.prototype = Cr(dr.prototype), fr.prototype.constructor = fr, hr.prototype = Cr(dr.prototype), hr.prototype.constructor = hr, xr.prototype.clear = function () {
          this.__data__ = tr ? tr(null) : {}, this.size = 0;
        }, xr.prototype.delete = function (e) {
          var n = this.has(e) && delete this.__data__[e];
          return this.size -= n ? 1 : 0, n;
        }, xr.prototype.get = function (e) {
          var n = this.__data__;

          if (tr) {
            var t = n[e];
            return t === a ? i : t;
          }

          return un.call(n, e) ? n[e] : i;
        }, xr.prototype.has = function (e) {
          var n = this.__data__;
          return tr ? n[e] !== i : un.call(n, e);
        }, xr.prototype.set = function (e, n) {
          var t = this.__data__;
          return this.size += this.has(e) ? 0 : 1, t[e] = tr && n === i ? a : n, this;
        }, gr.prototype.clear = function () {
          this.__data__ = [], this.size = 0;
        }, gr.prototype.delete = function (e) {
          var n = this.__data__,
              t = Sr(n, e);
          return !(t < 0) && (t == n.length - 1 ? n.pop() : Qn.call(n, t, 1), --this.size, !0);
        }, gr.prototype.get = function (e) {
          var n = this.__data__,
              t = Sr(n, e);
          return t < 0 ? i : n[t][1];
        }, gr.prototype.has = function (e) {
          return Sr(this.__data__, e) > -1;
        }, gr.prototype.set = function (e, n) {
          var t = this.__data__,
              r = Sr(t, e);
          return r < 0 ? (++this.size, t.push([e, n])) : t[r][1] = n, this;
        }, Ir.prototype.clear = function () {
          this.size = 0, this.__data__ = {
            hash: new xr(),
            map: new (Zt || gr)(),
            string: new xr()
          };
        }, Ir.prototype.delete = function (e) {
          var n = Ui(this, e).delete(e);
          return this.size -= n ? 1 : 0, n;
        }, Ir.prototype.get = function (e) {
          return Ui(this, e).get(e);
        }, Ir.prototype.has = function (e) {
          return Ui(this, e).has(e);
        }, Ir.prototype.set = function (e, n) {
          var t = Ui(this, e),
              r = t.size;
          return t.set(e, n), this.size += t.size == r ? 0 : 1, this;
        }, br.prototype.add = br.prototype.push = function (e) {
          return this.__data__.set(e, a), this;
        }, br.prototype.has = function (e) {
          return this.__data__.has(e);
        }, yr.prototype.clear = function () {
          this.__data__ = new gr(), this.size = 0;
        }, yr.prototype.delete = function (e) {
          var n = this.__data__,
              t = n.delete(e);
          return this.size = n.size, t;
        }, yr.prototype.get = function (e) {
          return this.__data__.get(e);
        }, yr.prototype.has = function (e) {
          return this.__data__.has(e);
        }, yr.prototype.set = function (e, n) {
          var t = this.__data__;

          if (t instanceof gr) {
            var r = t.__data__;
            if (!Zt || r.length < A - 1) return r.push([e, n]), this.size = ++t.size, this;
            t = this.__data__ = new Ir(r);
          }

          return t.set(e, n), this.size = t.size, this;
        };
        var Gr = si(Xr),
            Yr = si(Hr, !0);

        function Fr(e, n) {
          var t = !0;
          return Gr(e, function (e, r, o) {
            return t = !!n(e, r, o);
          }), t;
        }

        function Nr(e, n, t) {
          for (var r = -1, o = e.length; ++r < o;) {
            var A = e[r],
                s = n(A);
            if (null != s && (l === i ? s == s && !Ks(s) : t(s, l))) var l = s,
                a = A;
          }

          return a;
        }

        function jr(e, n) {
          var t = [];
          return Gr(e, function (e, r, o) {
            n(e, r, o) && t.push(e);
          }), t;
        }

        function Wr(e, n, t, r, o) {
          var i = -1,
              A = e.length;

          for (t || (t = Li), o || (o = []); ++i < A;) {
            var s = e[i];
            n > 0 && t(s) ? n > 1 ? Wr(s, n - 1, t, r, o) : nt(o, s) : r || (o[o.length] = s);
          }

          return o;
        }

        var Lr = li(),
            zr = li(!0);

        function Xr(e, n) {
          return e && Lr(e, n, ol);
        }

        function Hr(e, n) {
          return e && zr(e, n, ol);
        }

        function qr(e, n) {
          return Jn(n, function (n) {
            return vs(e[n]);
          });
        }

        function Vr(e, n) {
          for (var t = 0, r = (n = Xo(n, e)).length; null != e && t < r;) {
            e = e[cA(n[t++])];
          }

          return t && t == r ? e : i;
        }

        function Jr(e, n, t) {
          var r = n(e);
          return hs(e) ? r : nt(r, t(e));
        }

        function Zr(e) {
          return null == e ? e === i ? ie : Z : it && it in nn(e) ? function (e) {
            var n = un.call(e, it),
                t = e[it];

            try {
              e[it] = i;
              var r = !0;
            } catch (e) {}

            var o = Cn.call(e);
            r && (n ? e[it] = t : delete e[it]);
            return o;
          }(e) : function (e) {
            return Cn.call(e);
          }(e);
        }

        function $r(e, n) {
          return e > n;
        }

        function eo(e, n) {
          return null != e && un.call(e, n);
        }

        function no(e, n) {
          return null != e && n in nn(e);
        }

        function to(e, n, t) {
          for (var o = t ? $n : Zn, A = e[0].length, s = e.length, l = s, a = r(s), c = 1 / 0, u = []; l--;) {
            var p = e[l];
            l && n && (p = et(p, ht(n))), c = zt(p.length, c), a[l] = !t && (n || A >= 120 && p.length >= 120) ? new br(l && p) : i;
          }

          p = e[0];
          var m = -1,
              C = a[0];

          e: for (; ++m < A && u.length < c;) {
            var d = p[m],
                f = n ? n(d) : d;

            if (d = t || 0 !== d ? d : 0, !(C ? gt(C, f) : o(u, f, t))) {
              for (l = s; --l;) {
                var h = a[l];
                if (!(h ? gt(h, f) : o(e[l], f, t))) continue e;
              }

              C && C.push(f), u.push(d);
            }
          }

          return u;
        }

        function ro(e, n, t) {
          var r = null == (e = nA(e, n = Xo(n, e))) ? e : e[cA(EA(n))];
          return null == r ? i : zn(r, e, t);
        }

        function oo(e) {
          return Ds(e) && Zr(e) == F;
        }

        function io(e, n, t, r, o) {
          return e === n || (null == e || null == n || !Ds(e) && !Ds(n) ? e != e && n != n : function (e, n, t, r, o, A) {
            var s = hs(e),
                l = hs(n),
                a = s ? N : Ni(e),
                c = l ? N : Ni(n),
                u = (a = a == F ? $ : a) == $,
                p = (c = c == F ? $ : c) == $,
                m = a == c;

            if (m && bs(e)) {
              if (!bs(n)) return !1;
              s = !0, u = !1;
            }

            if (m && !u) return A || (A = new yr()), s || Qs(e) ? Si(e, n, t, r, o, A) : function (e, n, t, r, o, i, A) {
              switch (t) {
                case ae:
                  if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset) return !1;
                  e = e.buffer, n = n.buffer;

                case le:
                  return !(e.byteLength != n.byteLength || !i(new En(e), new En(n)));

                case W:
                case L:
                case J:
                  return ms(+e, +n);

                case X:
                  return e.name == n.name && e.message == n.message;

                case ne:
                case re:
                  return e == n + "";

                case V:
                  var s = Bt;

                case te:
                  var l = r & d;
                  if (s || (s = St), e.size != n.size && !l) return !1;
                  var a = A.get(e);
                  if (a) return a == n;
                  r |= f, A.set(e, n);
                  var c = Si(s(e), s(n), r, o, i, A);
                  return A.delete(e), c;

                case oe:
                  if (ur) return ur.call(e) == ur.call(n);
              }

              return !1;
            }(e, n, a, t, r, o, A);

            if (!(t & d)) {
              var C = u && un.call(e, "__wrapped__"),
                  h = p && un.call(n, "__wrapped__");

              if (C || h) {
                var x = C ? e.value() : e,
                    g = h ? n.value() : n;
                return A || (A = new yr()), o(x, g, t, r, A);
              }
            }

            if (!m) return !1;
            return A || (A = new yr()), function (e, n, t, r, o, A) {
              var s = t & d,
                  l = Oi(e),
                  a = l.length,
                  c = Oi(n).length;
              if (a != c && !s) return !1;
              var u = a;

              for (; u--;) {
                var p = l[u];
                if (!(s ? p in n : un.call(n, p))) return !1;
              }

              var m = A.get(e);
              if (m && A.get(n)) return m == n;
              var C = !0;
              A.set(e, n), A.set(n, e);
              var f = s;

              for (; ++u < a;) {
                p = l[u];
                var h = e[p],
                    x = n[p];
                if (r) var g = s ? r(x, h, p, n, e, A) : r(h, x, p, e, n, A);

                if (!(g === i ? h === x || o(h, x, t, r, A) : g)) {
                  C = !1;
                  break;
                }

                f || (f = "constructor" == p);
              }

              if (C && !f) {
                var I = e.constructor,
                    b = n.constructor;
                I != b && "constructor" in e && "constructor" in n && !("function" == typeof I && I instanceof I && "function" == typeof b && b instanceof b) && (C = !1);
              }

              return A.delete(e), A.delete(n), C;
            }(e, n, t, r, o, A);
          }(e, n, t, r, io, o));
        }

        function Ao(e, n, t, r) {
          var o = t.length,
              A = o,
              s = !r;
          if (null == e) return !A;

          for (e = nn(e); o--;) {
            var l = t[o];
            if (s && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
          }

          for (; ++o < A;) {
            var a = (l = t[o])[0],
                c = e[a],
                u = l[1];

            if (s && l[2]) {
              if (c === i && !(a in e)) return !1;
            } else {
              var p = new yr();
              if (r) var m = r(c, u, a, e, n, p);
              if (!(m === i ? io(u, c, d | f, r, p) : m)) return !1;
            }
          }

          return !0;
        }

        function so(e) {
          return !(!_s(e) || (n = e, mn && mn in n)) && (vs(e) ? hn : ze).test(uA(e));
          var n;
        }

        function lo(e) {
          return "function" == typeof e ? e : null == e ? Ml : "object" == typeof e ? hs(e) ? Co(e[0], e[1]) : mo(e) : Gl(e);
        }

        function ao(e) {
          if (!Ji(e)) return Wt(e);
          var n = [];

          for (var t in nn(e)) {
            un.call(e, t) && "constructor" != t && n.push(t);
          }

          return n;
        }

        function co(e) {
          if (!_s(e)) return function (e) {
            var n = [];
            if (null != e) for (var t in nn(e)) {
              n.push(t);
            }
            return n;
          }(e);
          var n = Ji(e),
              t = [];

          for (var r in e) {
            ("constructor" != r || !n && un.call(e, r)) && t.push(r);
          }

          return t;
        }

        function uo(e, n) {
          return e < n;
        }

        function po(e, n) {
          var t = -1,
              o = gs(e) ? r(e.length) : [];
          return Gr(e, function (e, r, i) {
            o[++t] = n(e, r, i);
          }), o;
        }

        function mo(e) {
          var n = Ri(e);
          return 1 == n.length && n[0][2] ? $i(n[0][0], n[0][1]) : function (t) {
            return t === e || Ao(t, e, n);
          };
        }

        function Co(e, n) {
          return Hi(e) && Zi(n) ? $i(cA(e), n) : function (t) {
            var r = $s(t, e);
            return r === i && r === n ? el(t, e) : io(n, r, d | f);
          };
        }

        function fo(e, n, t, r, o) {
          e !== n && Lr(n, function (A, s) {
            if (o || (o = new yr()), _s(A)) !function (e, n, t, r, o, A, s) {
              var l = tA(e, t),
                  a = tA(n, t),
                  c = s.get(a);
              if (c) return void _r(e, t, c);
              var u = A ? A(l, a, t + "", e, n, s) : i,
                  p = u === i;

              if (p) {
                var m = hs(a),
                    C = !m && bs(a),
                    d = !m && !C && Qs(a);
                u = a, m || C || d ? hs(l) ? u = l : Is(l) ? u = ri(l) : C ? (p = !1, u = Jo(a, !0)) : d ? (p = !1, u = $o(a, !0)) : u = [] : Os(a) || fs(a) ? (u = l, fs(l) ? u = Ws(l) : _s(l) && !vs(l) || (u = Wi(a))) : p = !1;
              }

              p && (s.set(a, u), o(u, a, r, A, s), s.delete(a));

              _r(e, t, u);
            }(e, n, s, t, fo, r, o);else {
              var l = r ? r(tA(e, s), A, s + "", e, n, o) : i;
              l === i && (l = A), _r(e, s, l);
            }
          }, il);
        }

        function ho(e, n) {
          var t = e.length;
          if (t) return zi(n += n < 0 ? t : 0, t) ? e[n] : i;
        }

        function xo(e, n, t) {
          var r = -1;
          return n = et(n.length ? n : [Ml], ht(Qi())), function (e, n) {
            var t = e.length;

            for (e.sort(n); t--;) {
              e[t] = e[t].value;
            }

            return e;
          }(po(e, function (e, t, o) {
            return {
              criteria: et(n, function (n) {
                return n(e);
              }),
              index: ++r,
              value: e
            };
          }), function (e, n) {
            return function (e, n, t) {
              var r = -1,
                  o = e.criteria,
                  i = n.criteria,
                  A = o.length,
                  s = t.length;

              for (; ++r < A;) {
                var l = ei(o[r], i[r]);

                if (l) {
                  if (r >= s) return l;
                  var a = t[r];
                  return l * ("desc" == a ? -1 : 1);
                }
              }

              return e.index - n.index;
            }(e, n, t);
          });
        }

        function go(e, n, t) {
          for (var r = -1, o = n.length, i = {}; ++r < o;) {
            var A = n[r],
                s = Vr(e, A);
            t(s, A) && _o(i, Xo(A, e), s);
          }

          return i;
        }

        function Io(e, n, t, r) {
          var o = r ? at : lt,
              i = -1,
              A = n.length,
              s = e;

          for (e === n && (n = ri(n)), t && (s = et(e, ht(t))); ++i < A;) {
            for (var l = 0, a = n[i], c = t ? t(a) : a; (l = o(s, c, l, r)) > -1;) {
              s !== e && Qn.call(s, l, 1), Qn.call(e, l, 1);
            }
          }

          return e;
        }

        function bo(e, n) {
          for (var t = e ? n.length : 0, r = t - 1; t--;) {
            var o = n[t];

            if (t == r || o !== i) {
              var i = o;
              zi(o) ? Qn.call(e, o, 1) : Go(e, o);
            }
          }

          return e;
        }

        function yo(e, n) {
          return e + Gt(qt() * (n - e + 1));
        }

        function Eo(e, n) {
          var t = "";
          if (!e || n < 1 || n > P) return t;

          do {
            n % 2 && (t += e), (n = Gt(n / 2)) && (e += e);
          } while (n);

          return t;
        }

        function vo(e, n) {
          return iA(eA(e, n, Ml), e + "");
        }

        function wo(e) {
          return vr(ml(e));
        }

        function Bo(e, n) {
          var t = ml(e);
          return lA(t, Pr(n, 0, t.length));
        }

        function _o(e, n, t, r) {
          if (!_s(e)) return e;

          for (var o = -1, A = (n = Xo(n, e)).length, s = A - 1, l = e; null != l && ++o < A;) {
            var a = cA(n[o]),
                c = t;

            if (o != s) {
              var u = l[a];
              (c = r ? r(u, a, l) : i) === i && (c = _s(u) ? u : zi(n[o + 1]) ? [] : {});
            }

            Dr(l, a, c), l = l[a];
          }

          return e;
        }

        var Do = rr ? function (e, n) {
          return rr.set(e, n), e;
        } : Ml,
            So = mt ? function (e, n) {
          return mt(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: _l(n),
            writable: !0
          });
        } : Ml;

        function Mo(e) {
          return lA(ml(e));
        }

        function Oo(e, n, t) {
          var o = -1,
              i = e.length;
          n < 0 && (n = -n > i ? 0 : i + n), (t = t > i ? i : t) < 0 && (t += i), i = n > t ? 0 : t - n >>> 0, n >>>= 0;

          for (var A = r(i); ++o < i;) {
            A[o] = e[o + n];
          }

          return A;
        }

        function ko(e, n) {
          var t;
          return Gr(e, function (e, r, o) {
            return !(t = n(e, r, o));
          }), !!t;
        }

        function To(e, n, t) {
          var r = 0,
              o = null == e ? r : e.length;

          if ("number" == typeof n && n == n && o <= G) {
            for (; r < o;) {
              var i = r + o >>> 1,
                  A = e[i];
              null !== A && !Ks(A) && (t ? A <= n : A < n) ? r = i + 1 : o = i;
            }

            return o;
          }

          return Po(e, n, Ml, t);
        }

        function Po(e, n, t, r) {
          n = t(n);

          for (var o = 0, A = null == e ? 0 : e.length, s = n != n, l = null === n, a = Ks(n), c = n === i; o < A;) {
            var u = Gt((o + A) / 2),
                p = t(e[u]),
                m = p !== i,
                C = null === p,
                d = p == p,
                f = Ks(p);
            if (s) var h = r || d;else h = c ? d && (r || m) : l ? d && m && (r || !C) : a ? d && m && !C && (r || !f) : !C && !f && (r ? p <= n : p < n);
            h ? o = u + 1 : A = u;
          }

          return zt(A, R);
        }

        function Ko(e, n) {
          for (var t = -1, r = e.length, o = 0, i = []; ++t < r;) {
            var A = e[t],
                s = n ? n(A) : A;

            if (!t || !ms(s, l)) {
              var l = s;
              i[o++] = 0 === A ? 0 : A;
            }
          }

          return i;
        }

        function Qo(e) {
          return "number" == typeof e ? e : Ks(e) ? Q : +e;
        }

        function Uo(e) {
          if ("string" == typeof e) return e;
          if (hs(e)) return et(e, Uo) + "";
          if (Ks(e)) return pr ? pr.call(e) : "";
          var n = e + "";
          return "0" == n && 1 / e == -T ? "-0" : n;
        }

        function Ro(e, n, t) {
          var r = -1,
              o = Zn,
              i = e.length,
              s = !0,
              l = [],
              a = l;
          if (t) s = !1, o = $n;else if (i >= A) {
            var c = n ? null : Ei(e);
            if (c) return St(c);
            s = !1, o = gt, a = new br();
          } else a = n ? [] : l;

          e: for (; ++r < i;) {
            var u = e[r],
                p = n ? n(u) : u;

            if (u = t || 0 !== u ? u : 0, s && p == p) {
              for (var m = a.length; m--;) {
                if (a[m] === p) continue e;
              }

              n && a.push(p), l.push(u);
            } else o(a, p, t) || (a !== l && a.push(p), l.push(u));
          }

          return l;
        }

        function Go(e, n) {
          return null == (e = nA(e, n = Xo(n, e))) || delete e[cA(EA(n))];
        }

        function Yo(e, n, t, r) {
          return _o(e, n, t(Vr(e, n)), r);
        }

        function Fo(e, n, t, r) {
          for (var o = e.length, i = r ? o : -1; (r ? i-- : ++i < o) && n(e[i], i, e);) {
            ;
          }

          return t ? Oo(e, r ? 0 : i, r ? i + 1 : o) : Oo(e, r ? i + 1 : 0, r ? o : i);
        }

        function No(e, n) {
          var t = e;
          return t instanceof hr && (t = t.value()), tt(n, function (e, n) {
            return n.func.apply(n.thisArg, nt([e], n.args));
          }, t);
        }

        function jo(e, n, t) {
          var o = e.length;
          if (o < 2) return o ? Ro(e[0]) : [];

          for (var i = -1, A = r(o); ++i < o;) {
            for (var s = e[i], l = -1; ++l < o;) {
              l != i && (A[i] = Rr(A[i] || s, e[l], n, t));
            }
          }

          return Ro(Wr(A, 1), n, t);
        }

        function Wo(e, n, t) {
          for (var r = -1, o = e.length, A = n.length, s = {}; ++r < o;) {
            var l = r < A ? n[r] : i;
            t(s, e[r], l);
          }

          return s;
        }

        function Lo(e) {
          return Is(e) ? e : [];
        }

        function zo(e) {
          return "function" == typeof e ? e : Ml;
        }

        function Xo(e, n) {
          return hs(e) ? e : Hi(e, n) ? [e] : aA(Ls(e));
        }

        var Ho = vo;

        function qo(e, n, t) {
          var r = e.length;
          return t = t === i ? r : t, !n && t >= r ? e : Oo(e, n, t);
        }

        var Vo = Kt || function (e) {
          return Pn.clearTimeout(e);
        };

        function Jo(e, n) {
          if (n) return e.slice();
          var t = e.length,
              r = Sn ? Sn(t) : new e.constructor(t);
          return e.copy(r), r;
        }

        function Zo(e) {
          var n = new e.constructor(e.byteLength);
          return new En(n).set(new En(e)), n;
        }

        function $o(e, n) {
          var t = n ? Zo(e.buffer) : e.buffer;
          return new e.constructor(t, e.byteOffset, e.length);
        }

        function ei(e, n) {
          if (e !== n) {
            var t = e !== i,
                r = null === e,
                o = e == e,
                A = Ks(e),
                s = n !== i,
                l = null === n,
                a = n == n,
                c = Ks(n);
            if (!l && !c && !A && e > n || A && s && a && !l && !c || r && s && a || !t && a || !o) return 1;
            if (!r && !A && !c && e < n || c && t && o && !r && !A || l && t && o || !s && o || !a) return -1;
          }

          return 0;
        }

        function ni(e, n, t, o) {
          for (var i = -1, A = e.length, s = t.length, l = -1, a = n.length, c = Lt(A - s, 0), u = r(a + c), p = !o; ++l < a;) {
            u[l] = n[l];
          }

          for (; ++i < s;) {
            (p || i < A) && (u[t[i]] = e[i]);
          }

          for (; c--;) {
            u[l++] = e[i++];
          }

          return u;
        }

        function ti(e, n, t, o) {
          for (var i = -1, A = e.length, s = -1, l = t.length, a = -1, c = n.length, u = Lt(A - l, 0), p = r(u + c), m = !o; ++i < u;) {
            p[i] = e[i];
          }

          for (var C = i; ++a < c;) {
            p[C + a] = n[a];
          }

          for (; ++s < l;) {
            (m || i < A) && (p[C + t[s]] = e[i++]);
          }

          return p;
        }

        function ri(e, n) {
          var t = -1,
              o = e.length;

          for (n || (n = r(o)); ++t < o;) {
            n[t] = e[t];
          }

          return n;
        }

        function oi(e, n, t, r) {
          var o = !t;
          t || (t = {});

          for (var A = -1, s = n.length; ++A < s;) {
            var l = n[A],
                a = r ? r(t[l], e[l], l, t, e) : i;
            a === i && (a = e[l]), o ? kr(t, l, a) : Dr(t, l, a);
          }

          return t;
        }

        function ii(e, n) {
          return function (t, r) {
            var o = hs(t) ? Xn : Mr,
                i = n ? n() : {};
            return o(t, e, Qi(r, 2), i);
          };
        }

        function Ai(e) {
          return vo(function (n, t) {
            var r = -1,
                o = t.length,
                A = o > 1 ? t[o - 1] : i,
                s = o > 2 ? t[2] : i;

            for (A = e.length > 3 && "function" == typeof A ? (o--, A) : i, s && Xi(t[0], t[1], s) && (A = o < 3 ? i : A, o = 1), n = nn(n); ++r < o;) {
              var l = t[r];
              l && e(n, l, r, A);
            }

            return n;
          });
        }

        function si(e, n) {
          return function (t, r) {
            if (null == t) return t;
            if (!gs(t)) return e(t, r);

            for (var o = t.length, i = n ? o : -1, A = nn(t); (n ? i-- : ++i < o) && !1 !== r(A[i], i, A);) {
              ;
            }

            return t;
          };
        }

        function li(e) {
          return function (n, t, r) {
            for (var o = -1, i = nn(n), A = r(n), s = A.length; s--;) {
              var l = A[e ? s : ++o];
              if (!1 === t(i[l], l, i)) break;
            }

            return n;
          };
        }

        function ai(e) {
          return function (n) {
            var t = wt(n = Ls(n)) ? kt(n) : i,
                r = t ? t[0] : n.charAt(0),
                o = t ? qo(t, 1).join("") : n.slice(1);
            return r[e]() + o;
          };
        }

        function ci(e) {
          return function (n) {
            return tt(vl(fl(n).replace(gn, "")), e, "");
          };
        }

        function ui(e) {
          return function () {
            var n = arguments;

            switch (n.length) {
              case 0:
                return new e();

              case 1:
                return new e(n[0]);

              case 2:
                return new e(n[0], n[1]);

              case 3:
                return new e(n[0], n[1], n[2]);

              case 4:
                return new e(n[0], n[1], n[2], n[3]);

              case 5:
                return new e(n[0], n[1], n[2], n[3], n[4]);

              case 6:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5]);

              case 7:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }

            var t = Cr(e.prototype),
                r = e.apply(t, n);
            return _s(r) ? r : t;
          };
        }

        function pi(e) {
          return function (n, t, r) {
            var o = nn(n);

            if (!gs(n)) {
              var A = Qi(t, 3);
              n = ol(n), t = function t(e) {
                return A(o[e], e, o);
              };
            }

            var s = e(n, t, r);
            return s > -1 ? o[A ? n[s] : s] : i;
          };
        }

        function mi(e) {
          return Mi(function (n) {
            var t = n.length,
                r = t,
                o = fr.prototype.thru;

            for (e && n.reverse(); r--;) {
              var A = n[r];
              if ("function" != typeof A) throw new on(l);
              if (o && !s && "wrapper" == Pi(A)) var s = new fr([], !0);
            }

            for (r = s ? r : t; ++r < t;) {
              var a = Pi(A = n[r]),
                  c = "wrapper" == a ? Ti(A) : i;
              s = c && qi(c[0]) && c[1] == (v | I | y | w) && !c[4].length && 1 == c[9] ? s[Pi(c[0])].apply(s, c[3]) : 1 == A.length && qi(A) ? s[a]() : s.thru(A);
            }

            return function () {
              var e = arguments,
                  r = e[0];
              if (s && 1 == e.length && hs(r)) return s.plant(r).value();

              for (var o = 0, i = t ? n[o].apply(this, e) : r; ++o < t;) {
                i = n[o].call(this, i);
              }

              return i;
            };
          });
        }

        function Ci(e, n, t, o, A, s, l, a, c, u) {
          var p = n & v,
              m = n & h,
              C = n & x,
              d = n & (I | b),
              f = n & B,
              g = C ? i : ui(e);
          return function h() {
            for (var x = arguments.length, I = r(x), b = x; b--;) {
              I[b] = arguments[b];
            }

            if (d) var y = Ki(h),
                E = function (e, n) {
              for (var t = e.length, r = 0; t--;) {
                e[t] === n && ++r;
              }

              return r;
            }(I, y);

            if (o && (I = ni(I, o, A, d)), s && (I = ti(I, s, l, d)), x -= E, d && x < u) {
              var v = Dt(I, y);
              return bi(e, n, Ci, h.placeholder, t, I, v, a, c, u - x);
            }

            var w = m ? t : this,
                B = C ? w[e] : e;
            return x = I.length, a ? I = function (e, n) {
              var t = e.length,
                  r = zt(n.length, t),
                  o = ri(e);

              for (; r--;) {
                var A = n[r];
                e[r] = zi(A, t) ? o[A] : i;
              }

              return e;
            }(I, a) : f && x > 1 && I.reverse(), p && c < x && (I.length = c), this && this !== Pn && this instanceof h && (B = g || ui(B)), B.apply(w, I);
          };
        }

        function di(e, n) {
          return function (t, r) {
            return function (e, n, t, r) {
              return Xr(e, function (e, o, i) {
                n(r, t(e), o, i);
              }), r;
            }(t, e, n(r), {});
          };
        }

        function fi(e, n) {
          return function (t, r) {
            var o;
            if (t === i && r === i) return n;

            if (t !== i && (o = t), r !== i) {
              if (o === i) return r;
              "string" == typeof t || "string" == typeof r ? (t = Uo(t), r = Uo(r)) : (t = Qo(t), r = Qo(r)), o = e(t, r);
            }

            return o;
          };
        }

        function hi(e) {
          return Mi(function (n) {
            return n = et(n, ht(Qi())), vo(function (t) {
              var r = this;
              return e(n, function (e) {
                return zn(e, r, t);
              });
            });
          });
        }

        function xi(e, n) {
          var t = (n = n === i ? " " : Uo(n)).length;
          if (t < 2) return t ? Eo(n, e) : n;
          var r = Eo(n, Rt(e / Ot(n)));
          return wt(n) ? qo(kt(r), 0, e).join("") : r.slice(0, e);
        }

        function gi(e) {
          return function (n, t, o) {
            return o && "number" != typeof o && Xi(n, t, o) && (t = o = i), n = Ys(n), t === i ? (t = n, n = 0) : t = Ys(t), function (e, n, t, o) {
              for (var i = -1, A = Lt(Rt((n - e) / (t || 1)), 0), s = r(A); A--;) {
                s[o ? A : ++i] = e, e += t;
              }

              return s;
            }(n, t, o = o === i ? n < t ? 1 : -1 : Ys(o), e);
          };
        }

        function Ii(e) {
          return function (n, t) {
            return "string" == typeof n && "string" == typeof t || (n = js(n), t = js(t)), e(n, t);
          };
        }

        function bi(e, n, t, r, o, A, s, l, a, c) {
          var u = n & I;
          n |= u ? y : E, (n &= ~(u ? E : y)) & g || (n &= ~(h | x));
          var p = [e, n, o, u ? A : i, u ? s : i, u ? i : A, u ? i : s, l, a, c],
              m = t.apply(i, p);
          return qi(e) && rA(m, p), m.placeholder = r, AA(m, e, n);
        }

        function yi(e) {
          var n = en[e];
          return function (e, t) {
            if (e = js(e), (t = null == t ? 0 : zt(Fs(t), 292)) && Nt(e)) {
              var r = (Ls(e) + "e").split("e");
              return +((r = (Ls(n(r[0] + "e" + (+r[1] + t))) + "e").split("e"))[0] + "e" + (+r[1] - t));
            }

            return n(e);
          };
        }

        var Ei = er && 1 / St(new er([, -0]))[1] == T ? function (e) {
          return new er(e);
        } : Kl;

        function vi(e) {
          return function (n) {
            var t = Ni(n);
            return t == V ? Bt(n) : t == te ? Mt(n) : function (e, n) {
              return et(n, function (n) {
                return [n, e[n]];
              });
            }(n, e(n));
          };
        }

        function wi(e, n, t, o, A, s, a, c) {
          var p = n & x;
          if (!p && "function" != typeof e) throw new on(l);
          var m = o ? o.length : 0;

          if (m || (n &= ~(y | E), o = A = i), a = a === i ? a : Lt(Fs(a), 0), c = c === i ? c : Fs(c), m -= A ? A.length : 0, n & E) {
            var C = o,
                d = A;
            o = A = i;
          }

          var f = p ? i : Ti(e),
              B = [e, n, t, o, A, C, d, s, a, c];
          if (f && function (e, n) {
            var t = e[1],
                r = n[1],
                o = t | r,
                i = o < (h | x | v),
                A = r == v && t == I || r == v && t == w && e[7].length <= n[8] || r == (v | w) && n[7].length <= n[8] && t == I;
            if (!i && !A) return e;
            r & h && (e[2] = n[2], o |= t & h ? 0 : g);
            var s = n[3];

            if (s) {
              var l = e[3];
              e[3] = l ? ni(l, s, n[4]) : s, e[4] = l ? Dt(e[3], u) : n[4];
            }

            (s = n[5]) && (l = e[5], e[5] = l ? ti(l, s, n[6]) : s, e[6] = l ? Dt(e[5], u) : n[6]);
            (s = n[7]) && (e[7] = s);
            r & v && (e[8] = null == e[8] ? n[8] : zt(e[8], n[8]));
            null == e[9] && (e[9] = n[9]);
            e[0] = n[0], e[1] = o;
          }(B, f), e = B[0], n = B[1], t = B[2], o = B[3], A = B[4], !(c = B[9] = B[9] === i ? p ? 0 : e.length : Lt(B[9] - m, 0)) && n & (I | b) && (n &= ~(I | b)), n && n != h) _ = n == I || n == b ? function (e, n, t) {
            var o = ui(e);
            return function A() {
              for (var s = arguments.length, l = r(s), a = s, c = Ki(A); a--;) {
                l[a] = arguments[a];
              }

              var u = s < 3 && l[0] !== c && l[s - 1] !== c ? [] : Dt(l, c);
              return (s -= u.length) < t ? bi(e, n, Ci, A.placeholder, i, l, u, i, i, t - s) : zn(this && this !== Pn && this instanceof A ? o : e, this, l);
            };
          }(e, n, c) : n != y && n != (h | y) || A.length ? Ci.apply(i, B) : function (e, n, t, o) {
            var i = n & h,
                A = ui(e);
            return function n() {
              for (var s = -1, l = arguments.length, a = -1, c = o.length, u = r(c + l), p = this && this !== Pn && this instanceof n ? A : e; ++a < c;) {
                u[a] = o[a];
              }

              for (; l--;) {
                u[a++] = arguments[++s];
              }

              return zn(p, i ? t : this, u);
            };
          }(e, n, t, o);else var _ = function (e, n, t) {
            var r = n & h,
                o = ui(e);
            return function n() {
              return (this && this !== Pn && this instanceof n ? o : e).apply(r ? t : this, arguments);
            };
          }(e, n, t);
          return AA((f ? Do : rA)(_, B), e, n);
        }

        function Bi(e, n, t, r) {
          return e === i || ms(e, ln[t]) && !un.call(r, t) ? n : e;
        }

        function _i(e, n, t, r, o, A) {
          return _s(e) && _s(n) && (A.set(n, e), fo(e, n, i, _i, A), A.delete(n)), e;
        }

        function Di(e) {
          return Os(e) ? i : e;
        }

        function Si(e, n, t, r, o, A) {
          var s = t & d,
              l = e.length,
              a = n.length;
          if (l != a && !(s && a > l)) return !1;
          var c = A.get(e);
          if (c && A.get(n)) return c == n;
          var u = -1,
              p = !0,
              m = t & f ? new br() : i;

          for (A.set(e, n), A.set(n, e); ++u < l;) {
            var C = e[u],
                h = n[u];
            if (r) var x = s ? r(h, C, u, n, e, A) : r(C, h, u, e, n, A);

            if (x !== i) {
              if (x) continue;
              p = !1;
              break;
            }

            if (m) {
              if (!ot(n, function (e, n) {
                if (!gt(m, n) && (C === e || o(C, e, t, r, A))) return m.push(n);
              })) {
                p = !1;
                break;
              }
            } else if (C !== h && !o(C, h, t, r, A)) {
              p = !1;
              break;
            }
          }

          return A.delete(e), A.delete(n), p;
        }

        function Mi(e) {
          return iA(eA(e, i, xA), e + "");
        }

        function Oi(e) {
          return Jr(e, ol, Yi);
        }

        function ki(e) {
          return Jr(e, il, Fi);
        }

        var Ti = rr ? function (e) {
          return rr.get(e);
        } : Kl;

        function Pi(e) {
          for (var n = e.name + "", t = or[n], r = un.call(or, n) ? t.length : 0; r--;) {
            var o = t[r],
                i = o.func;
            if (null == i || i == e) return o.name;
          }

          return n;
        }

        function Ki(e) {
          return (un.call(mr, "placeholder") ? mr : e).placeholder;
        }

        function Qi() {
          var e = mr.iteratee || Ol;
          return e = e === Ol ? lo : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }

        function Ui(e, n) {
          var t,
              r,
              o = e.__data__;
          return ("string" == (r = typeof (t = n)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== t : null === t) ? o["string" == typeof n ? "string" : "hash"] : o.map;
        }

        function Ri(e) {
          for (var n = ol(e), t = n.length; t--;) {
            var r = n[t],
                o = e[r];
            n[t] = [r, o, Zi(o)];
          }

          return n;
        }

        function Gi(e, n) {
          var t = function (e, n) {
            return null == e ? i : e[n];
          }(e, n);

          return so(t) ? t : i;
        }

        var Yi = Yt ? function (e) {
          return null == e ? [] : (e = nn(e), Jn(Yt(e), function (n) {
            return Kn.call(e, n);
          }));
        } : Nl,
            Fi = Yt ? function (e) {
          for (var n = []; e;) {
            nt(n, Yi(e)), e = kn(e);
          }

          return n;
        } : Nl,
            Ni = Zr;

        function ji(e, n, t) {
          for (var r = -1, o = (n = Xo(n, e)).length, i = !1; ++r < o;) {
            var A = cA(n[r]);
            if (!(i = null != e && t(e, A))) break;
            e = e[A];
          }

          return i || ++r != o ? i : !!(o = null == e ? 0 : e.length) && Bs(o) && zi(A, o) && (hs(e) || fs(e));
        }

        function Wi(e) {
          return "function" != typeof e.constructor || Ji(e) ? {} : Cr(kn(e));
        }

        function Li(e) {
          return hs(e) || fs(e) || !!(Rn && e && e[Rn]);
        }

        function zi(e, n) {
          var t = typeof e;
          return !!(n = null == n ? P : n) && ("number" == t || "symbol" != t && He.test(e)) && e > -1 && e % 1 == 0 && e < n;
        }

        function Xi(e, n, t) {
          if (!_s(t)) return !1;
          var r = typeof n;
          return !!("number" == r ? gs(t) && zi(n, t.length) : "string" == r && n in t) && ms(t[n], e);
        }

        function Hi(e, n) {
          if (hs(e)) return !1;
          var t = typeof e;
          return !("number" != t && "symbol" != t && "boolean" != t && null != e && !Ks(e)) || Me.test(e) || !Se.test(e) || null != n && e in nn(n);
        }

        function qi(e) {
          var n = Pi(e),
              t = mr[n];
          if ("function" != typeof t || !(n in hr.prototype)) return !1;
          if (e === t) return !0;
          var r = Ti(t);
          return !!r && e === r[0];
        }

        (Jt && Ni(new Jt(new ArrayBuffer(1))) != ae || Zt && Ni(new Zt()) != V || $t && "[object Promise]" != Ni($t.resolve()) || er && Ni(new er()) != te || nr && Ni(new nr()) != Ae) && (Ni = function Ni(e) {
          var n = Zr(e),
              t = n == $ ? e.constructor : i,
              r = t ? uA(t) : "";
          if (r) switch (r) {
            case ir:
              return ae;

            case Ar:
              return V;

            case sr:
              return "[object Promise]";

            case lr:
              return te;

            case ar:
              return Ae;
          }
          return n;
        });
        var Vi = an ? vs : jl;

        function Ji(e) {
          var n = e && e.constructor;
          return e === ("function" == typeof n && n.prototype || ln);
        }

        function Zi(e) {
          return e == e && !_s(e);
        }

        function $i(e, n) {
          return function (t) {
            return null != t && t[e] === n && (n !== i || e in nn(t));
          };
        }

        function eA(e, n, t) {
          return n = Lt(n === i ? e.length - 1 : n, 0), function () {
            for (var o = arguments, i = -1, A = Lt(o.length - n, 0), s = r(A); ++i < A;) {
              s[i] = o[n + i];
            }

            i = -1;

            for (var l = r(n + 1); ++i < n;) {
              l[i] = o[i];
            }

            return l[n] = t(s), zn(e, this, l);
          };
        }

        function nA(e, n) {
          return n.length < 2 ? e : Vr(e, Oo(n, 0, -1));
        }

        function tA(e, n) {
          if (("constructor" !== n || "function" != typeof e[n]) && "__proto__" != n) return e[n];
        }

        var rA = sA(Do),
            oA = Ut || function (e, n) {
          return Pn.setTimeout(e, n);
        },
            iA = sA(So);

        function AA(e, n, t) {
          var r = n + "";
          return iA(e, function (e, n) {
            var t = n.length;
            if (!t) return e;
            var r = t - 1;
            return n[r] = (t > 1 ? "& " : "") + n[r], n = n.join(t > 2 ? ", " : " "), e.replace(Ue, "{\n/* [wrapped with " + n + "] */\n");
          }(r, function (e, n) {
            return Hn(Y, function (t) {
              var r = "_." + t[0];
              n & t[1] && !Zn(e, r) && e.push(r);
            }), e.sort();
          }(function (e) {
            var n = e.match(Re);
            return n ? n[1].split(Ge) : [];
          }(r), t)));
        }

        function sA(e) {
          var n = 0,
              t = 0;
          return function () {
            var r = Xt(),
                o = M - (r - t);

            if (t = r, o > 0) {
              if (++n >= S) return arguments[0];
            } else n = 0;

            return e.apply(i, arguments);
          };
        }

        function lA(e, n) {
          var t = -1,
              r = e.length,
              o = r - 1;

          for (n = n === i ? r : n; ++t < n;) {
            var A = yo(t, o),
                s = e[A];
            e[A] = e[t], e[t] = s;
          }

          return e.length = n, e;
        }

        var aA = function (e) {
          var n = ss(e, function (e) {
            return t.size === c && t.clear(), e;
          }),
              t = n.cache;
          return n;
        }(function (e) {
          var n = [];
          return 46 === e.charCodeAt(0) && n.push(""), e.replace(Oe, function (e, t, r, o) {
            n.push(r ? o.replace(Fe, "$1") : t || e);
          }), n;
        });

        function cA(e) {
          if ("string" == typeof e || Ks(e)) return e;
          var n = e + "";
          return "0" == n && 1 / e == -T ? "-0" : n;
        }

        function uA(e) {
          if (null != e) {
            try {
              return cn.call(e);
            } catch (e) {}

            try {
              return e + "";
            } catch (e) {}
          }

          return "";
        }

        function pA(e) {
          if (e instanceof hr) return e.clone();
          var n = new fr(e.__wrapped__, e.__chain__);
          return n.__actions__ = ri(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
        }

        var mA = vo(function (e, n) {
          return Is(e) ? Rr(e, Wr(n, 1, Is, !0)) : [];
        }),
            CA = vo(function (e, n) {
          var t = EA(n);
          return Is(t) && (t = i), Is(e) ? Rr(e, Wr(n, 1, Is, !0), Qi(t, 2)) : [];
        }),
            dA = vo(function (e, n) {
          var t = EA(n);
          return Is(t) && (t = i), Is(e) ? Rr(e, Wr(n, 1, Is, !0), i, t) : [];
        });

        function fA(e, n, t) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var o = null == t ? 0 : Fs(t);
          return o < 0 && (o = Lt(r + o, 0)), st(e, Qi(n, 3), o);
        }

        function hA(e, n, t) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var o = r - 1;
          return t !== i && (o = Fs(t), o = t < 0 ? Lt(r + o, 0) : zt(o, r - 1)), st(e, Qi(n, 3), o, !0);
        }

        function xA(e) {
          return (null == e ? 0 : e.length) ? Wr(e, 1) : [];
        }

        function gA(e) {
          return e && e.length ? e[0] : i;
        }

        var IA = vo(function (e) {
          var n = et(e, Lo);
          return n.length && n[0] === e[0] ? to(n) : [];
        }),
            bA = vo(function (e) {
          var n = EA(e),
              t = et(e, Lo);
          return n === EA(t) ? n = i : t.pop(), t.length && t[0] === e[0] ? to(t, Qi(n, 2)) : [];
        }),
            yA = vo(function (e) {
          var n = EA(e),
              t = et(e, Lo);
          return (n = "function" == typeof n ? n : i) && t.pop(), t.length && t[0] === e[0] ? to(t, i, n) : [];
        });

        function EA(e) {
          var n = null == e ? 0 : e.length;
          return n ? e[n - 1] : i;
        }

        var vA = vo(wA);

        function wA(e, n) {
          return e && e.length && n && n.length ? Io(e, n) : e;
        }

        var BA = Mi(function (e, n) {
          var t = null == e ? 0 : e.length,
              r = Tr(e, n);
          return bo(e, et(n, function (e) {
            return zi(e, t) ? +e : e;
          }).sort(ei)), r;
        });

        function _A(e) {
          return null == e ? e : Vt.call(e);
        }

        var DA = vo(function (e) {
          return Ro(Wr(e, 1, Is, !0));
        }),
            SA = vo(function (e) {
          var n = EA(e);
          return Is(n) && (n = i), Ro(Wr(e, 1, Is, !0), Qi(n, 2));
        }),
            MA = vo(function (e) {
          var n = EA(e);
          return n = "function" == typeof n ? n : i, Ro(Wr(e, 1, Is, !0), i, n);
        });

        function OA(e) {
          if (!e || !e.length) return [];
          var n = 0;
          return e = Jn(e, function (e) {
            if (Is(e)) return n = Lt(e.length, n), !0;
          }), ft(n, function (n) {
            return et(e, pt(n));
          });
        }

        function kA(e, n) {
          if (!e || !e.length) return [];
          var t = OA(e);
          return null == n ? t : et(t, function (e) {
            return zn(n, i, e);
          });
        }

        var TA = vo(function (e, n) {
          return Is(e) ? Rr(e, n) : [];
        }),
            PA = vo(function (e) {
          return jo(Jn(e, Is));
        }),
            KA = vo(function (e) {
          var n = EA(e);
          return Is(n) && (n = i), jo(Jn(e, Is), Qi(n, 2));
        }),
            QA = vo(function (e) {
          var n = EA(e);
          return n = "function" == typeof n ? n : i, jo(Jn(e, Is), i, n);
        }),
            UA = vo(OA);
        var RA = vo(function (e) {
          var n = e.length,
              t = n > 1 ? e[n - 1] : i;
          return t = "function" == typeof t ? (e.pop(), t) : i, kA(e, t);
        });

        function GA(e) {
          var n = mr(e);
          return n.__chain__ = !0, n;
        }

        function YA(e, n) {
          return n(e);
        }

        var FA = Mi(function (e) {
          var n = e.length,
              t = n ? e[0] : 0,
              r = this.__wrapped__,
              o = function o(n) {
            return Tr(n, e);
          };

          return !(n > 1 || this.__actions__.length) && r instanceof hr && zi(t) ? ((r = r.slice(t, +t + (n ? 1 : 0))).__actions__.push({
            func: YA,
            args: [o],
            thisArg: i
          }), new fr(r, this.__chain__).thru(function (e) {
            return n && !e.length && e.push(i), e;
          })) : this.thru(o);
        });
        var NA = ii(function (e, n, t) {
          un.call(e, t) ? ++e[t] : kr(e, t, 1);
        });
        var jA = pi(fA),
            WA = pi(hA);

        function LA(e, n) {
          return (hs(e) ? Hn : Gr)(e, Qi(n, 3));
        }

        function zA(e, n) {
          return (hs(e) ? qn : Yr)(e, Qi(n, 3));
        }

        var XA = ii(function (e, n, t) {
          un.call(e, t) ? e[t].push(n) : kr(e, t, [n]);
        });
        var HA = vo(function (e, n, t) {
          var o = -1,
              i = "function" == typeof n,
              A = gs(e) ? r(e.length) : [];
          return Gr(e, function (e) {
            A[++o] = i ? zn(n, e, t) : ro(e, n, t);
          }), A;
        }),
            qA = ii(function (e, n, t) {
          kr(e, t, n);
        });

        function VA(e, n) {
          return (hs(e) ? et : po)(e, Qi(n, 3));
        }

        var JA = ii(function (e, n, t) {
          e[t ? 0 : 1].push(n);
        }, function () {
          return [[], []];
        });

        var ZA = vo(function (e, n) {
          if (null == e) return [];
          var t = n.length;
          return t > 1 && Xi(e, n[0], n[1]) ? n = [] : t > 2 && Xi(n[0], n[1], n[2]) && (n = [n[0]]), xo(e, Wr(n, 1), []);
        }),
            $A = Qt || function () {
          return Pn.Date.now();
        };

        function es(e, n, t) {
          return n = t ? i : n, n = e && null == n ? e.length : n, wi(e, v, i, i, i, i, n);
        }

        function ns(e, n) {
          var t;
          if ("function" != typeof n) throw new on(l);
          return e = Fs(e), function () {
            return --e > 0 && (t = n.apply(this, arguments)), e <= 1 && (n = i), t;
          };
        }

        var ts = vo(function (e, n, t) {
          var r = h;

          if (t.length) {
            var o = Dt(t, Ki(ts));
            r |= y;
          }

          return wi(e, r, n, t, o);
        }),
            rs = vo(function (e, n, t) {
          var r = h | x;

          if (t.length) {
            var o = Dt(t, Ki(rs));
            r |= y;
          }

          return wi(n, r, e, t, o);
        });

        function os(e, n, t) {
          var r,
              o,
              A,
              s,
              a,
              c,
              u = 0,
              p = !1,
              m = !1,
              C = !0;
          if ("function" != typeof e) throw new on(l);

          function d(n) {
            var t = r,
                A = o;
            return r = o = i, u = n, s = e.apply(A, t);
          }

          function f(e) {
            var t = e - c;
            return c === i || t >= n || t < 0 || m && e - u >= A;
          }

          function h() {
            var e = $A();
            if (f(e)) return x(e);
            a = oA(h, function (e) {
              var t = n - (e - c);
              return m ? zt(t, A - (e - u)) : t;
            }(e));
          }

          function x(e) {
            return a = i, C && r ? d(e) : (r = o = i, s);
          }

          function g() {
            var e = $A(),
                t = f(e);

            if (r = arguments, o = this, c = e, t) {
              if (a === i) return function (e) {
                return u = e, a = oA(h, n), p ? d(e) : s;
              }(c);
              if (m) return Vo(a), a = oA(h, n), d(c);
            }

            return a === i && (a = oA(h, n)), s;
          }

          return n = js(n) || 0, _s(t) && (p = !!t.leading, A = (m = "maxWait" in t) ? Lt(js(t.maxWait) || 0, n) : A, C = "trailing" in t ? !!t.trailing : C), g.cancel = function () {
            a !== i && Vo(a), u = 0, r = c = o = a = i;
          }, g.flush = function () {
            return a === i ? s : x($A());
          }, g;
        }

        var is = vo(function (e, n) {
          return Ur(e, 1, n);
        }),
            As = vo(function (e, n, t) {
          return Ur(e, js(n) || 0, t);
        });

        function ss(e, n) {
          if ("function" != typeof e || null != n && "function" != typeof n) throw new on(l);

          var t = function t() {
            var r = arguments,
                o = n ? n.apply(this, r) : r[0],
                i = t.cache;
            if (i.has(o)) return i.get(o);
            var A = e.apply(this, r);
            return t.cache = i.set(o, A) || i, A;
          };

          return t.cache = new (ss.Cache || Ir)(), t;
        }

        function ls(e) {
          if ("function" != typeof e) throw new on(l);
          return function () {
            var n = arguments;

            switch (n.length) {
              case 0:
                return !e.call(this);

              case 1:
                return !e.call(this, n[0]);

              case 2:
                return !e.call(this, n[0], n[1]);

              case 3:
                return !e.call(this, n[0], n[1], n[2]);
            }

            return !e.apply(this, n);
          };
        }

        ss.Cache = Ir;
        var as = Ho(function (e, n) {
          var t = (n = 1 == n.length && hs(n[0]) ? et(n[0], ht(Qi())) : et(Wr(n, 1), ht(Qi()))).length;
          return vo(function (r) {
            for (var o = -1, i = zt(r.length, t); ++o < i;) {
              r[o] = n[o].call(this, r[o]);
            }

            return zn(e, this, r);
          });
        }),
            cs = vo(function (e, n) {
          var t = Dt(n, Ki(cs));
          return wi(e, y, i, n, t);
        }),
            us = vo(function (e, n) {
          var t = Dt(n, Ki(us));
          return wi(e, E, i, n, t);
        }),
            ps = Mi(function (e, n) {
          return wi(e, w, i, i, i, n);
        });

        function ms(e, n) {
          return e === n || e != e && n != n;
        }

        var Cs = Ii($r),
            ds = Ii(function (e, n) {
          return e >= n;
        }),
            fs = oo(function () {
          return arguments;
        }()) ? oo : function (e) {
          return Ds(e) && un.call(e, "callee") && !Kn.call(e, "callee");
        },
            hs = r.isArray,
            xs = Yn ? ht(Yn) : function (e) {
          return Ds(e) && Zr(e) == le;
        };

        function gs(e) {
          return null != e && Bs(e.length) && !vs(e);
        }

        function Is(e) {
          return Ds(e) && gs(e);
        }

        var bs = Ft || jl,
            ys = Fn ? ht(Fn) : function (e) {
          return Ds(e) && Zr(e) == L;
        };

        function Es(e) {
          if (!Ds(e)) return !1;
          var n = Zr(e);
          return n == X || n == z || "string" == typeof e.message && "string" == typeof e.name && !Os(e);
        }

        function vs(e) {
          if (!_s(e)) return !1;
          var n = Zr(e);
          return n == H || n == q || n == j || n == ee;
        }

        function ws(e) {
          return "number" == typeof e && e == Fs(e);
        }

        function Bs(e) {
          return "number" == typeof e && e > -1 && e % 1 == 0 && e <= P;
        }

        function _s(e) {
          var n = typeof e;
          return null != e && ("object" == n || "function" == n);
        }

        function Ds(e) {
          return null != e && "object" == typeof e;
        }

        var Ss = Nn ? ht(Nn) : function (e) {
          return Ds(e) && Ni(e) == V;
        };

        function Ms(e) {
          return "number" == typeof e || Ds(e) && Zr(e) == J;
        }

        function Os(e) {
          if (!Ds(e) || Zr(e) != $) return !1;
          var n = kn(e);
          if (null === n) return !0;
          var t = un.call(n, "constructor") && n.constructor;
          return "function" == typeof t && t instanceof t && cn.call(t) == dn;
        }

        var ks = jn ? ht(jn) : function (e) {
          return Ds(e) && Zr(e) == ne;
        };
        var Ts = Wn ? ht(Wn) : function (e) {
          return Ds(e) && Ni(e) == te;
        };

        function Ps(e) {
          return "string" == typeof e || !hs(e) && Ds(e) && Zr(e) == re;
        }

        function Ks(e) {
          return "symbol" == typeof e || Ds(e) && Zr(e) == oe;
        }

        var Qs = Ln ? ht(Ln) : function (e) {
          return Ds(e) && Bs(e.length) && !!_n[Zr(e)];
        };
        var Us = Ii(uo),
            Rs = Ii(function (e, n) {
          return e <= n;
        });

        function Gs(e) {
          if (!e) return [];
          if (gs(e)) return Ps(e) ? kt(e) : ri(e);
          if (Gn && e[Gn]) return function (e) {
            for (var n, t = []; !(n = e.next()).done;) {
              t.push(n.value);
            }

            return t;
          }(e[Gn]());
          var n = Ni(e);
          return (n == V ? Bt : n == te ? St : ml)(e);
        }

        function Ys(e) {
          return e ? (e = js(e)) === T || e === -T ? (e < 0 ? -1 : 1) * K : e == e ? e : 0 : 0 === e ? e : 0;
        }

        function Fs(e) {
          var n = Ys(e),
              t = n % 1;
          return n == n ? t ? n - t : n : 0;
        }

        function Ns(e) {
          return e ? Pr(Fs(e), 0, U) : 0;
        }

        function js(e) {
          if ("number" == typeof e) return e;
          if (Ks(e)) return Q;

          if (_s(e)) {
            var n = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = _s(n) ? n + "" : n;
          }

          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(Pe, "");
          var t = Le.test(e);
          return t || Xe.test(e) ? On(e.slice(2), t ? 2 : 8) : We.test(e) ? Q : +e;
        }

        function Ws(e) {
          return oi(e, il(e));
        }

        function Ls(e) {
          return null == e ? "" : Uo(e);
        }

        var zs = Ai(function (e, n) {
          if (Ji(n) || gs(n)) oi(n, ol(n), e);else for (var t in n) {
            un.call(n, t) && Dr(e, t, n[t]);
          }
        }),
            Xs = Ai(function (e, n) {
          oi(n, il(n), e);
        }),
            Hs = Ai(function (e, n, t, r) {
          oi(n, il(n), e, r);
        }),
            qs = Ai(function (e, n, t, r) {
          oi(n, ol(n), e, r);
        }),
            Vs = Mi(Tr);
        var Js = vo(function (e, n) {
          e = nn(e);
          var t = -1,
              r = n.length,
              o = r > 2 ? n[2] : i;

          for (o && Xi(n[0], n[1], o) && (r = 1); ++t < r;) {
            for (var A = n[t], s = il(A), l = -1, a = s.length; ++l < a;) {
              var c = s[l],
                  u = e[c];
              (u === i || ms(u, ln[c]) && !un.call(e, c)) && (e[c] = A[c]);
            }
          }

          return e;
        }),
            Zs = vo(function (e) {
          return e.push(i, _i), zn(sl, i, e);
        });

        function $s(e, n, t) {
          var r = null == e ? i : Vr(e, n);
          return r === i ? t : r;
        }

        function el(e, n) {
          return null != e && ji(e, n, no);
        }

        var nl = di(function (e, n, t) {
          null != n && "function" != typeof n.toString && (n = Cn.call(n)), e[n] = t;
        }, _l(Ml)),
            tl = di(function (e, n, t) {
          null != n && "function" != typeof n.toString && (n = Cn.call(n)), un.call(e, n) ? e[n].push(t) : e[n] = [t];
        }, Qi),
            rl = vo(ro);

        function ol(e) {
          return gs(e) ? Er(e) : ao(e);
        }

        function il(e) {
          return gs(e) ? Er(e, !0) : co(e);
        }

        var Al = Ai(function (e, n, t) {
          fo(e, n, t);
        }),
            sl = Ai(function (e, n, t, r) {
          fo(e, n, t, r);
        }),
            ll = Mi(function (e, n) {
          var t = {};
          if (null == e) return t;
          var r = !1;
          n = et(n, function (n) {
            return n = Xo(n, e), r || (r = n.length > 1), n;
          }), oi(e, ki(e), t), r && (t = Kr(t, p | m | C, Di));

          for (var o = n.length; o--;) {
            Go(t, n[o]);
          }

          return t;
        });
        var al = Mi(function (e, n) {
          return null == e ? {} : function (e, n) {
            return go(e, n, function (n, t) {
              return el(e, t);
            });
          }(e, n);
        });

        function cl(e, n) {
          if (null == e) return {};
          var t = et(ki(e), function (e) {
            return [e];
          });
          return n = Qi(n), go(e, t, function (e, t) {
            return n(e, t[0]);
          });
        }

        var ul = vi(ol),
            pl = vi(il);

        function ml(e) {
          return null == e ? [] : xt(e, ol(e));
        }

        var Cl = ci(function (e, n, t) {
          return n = n.toLowerCase(), e + (t ? dl(n) : n);
        });

        function dl(e) {
          return El(Ls(e).toLowerCase());
        }

        function fl(e) {
          return (e = Ls(e)) && e.replace(qe, yt).replace(In, "");
        }

        var hl = ci(function (e, n, t) {
          return e + (t ? "-" : "") + n.toLowerCase();
        }),
            xl = ci(function (e, n, t) {
          return e + (t ? " " : "") + n.toLowerCase();
        }),
            gl = ai("toLowerCase");
        var Il = ci(function (e, n, t) {
          return e + (t ? "_" : "") + n.toLowerCase();
        });
        var bl = ci(function (e, n, t) {
          return e + (t ? " " : "") + El(n);
        });
        var yl = ci(function (e, n, t) {
          return e + (t ? " " : "") + n.toUpperCase();
        }),
            El = ai("toUpperCase");

        function vl(e, n, t) {
          return e = Ls(e), (n = t ? i : n) === i ? function (e) {
            return vn.test(e);
          }(e) ? function (e) {
            return e.match(yn) || [];
          }(e) : function (e) {
            return e.match(Ye) || [];
          }(e) : e.match(n) || [];
        }

        var wl = vo(function (e, n) {
          try {
            return zn(e, i, n);
          } catch (e) {
            return Es(e) ? e : new Ze(e);
          }
        }),
            Bl = Mi(function (e, n) {
          return Hn(n, function (n) {
            n = cA(n), kr(e, n, ts(e[n], e));
          }), e;
        });

        function _l(e) {
          return function () {
            return e;
          };
        }

        var Dl = mi(),
            Sl = mi(!0);

        function Ml(e) {
          return e;
        }

        function Ol(e) {
          return lo("function" == typeof e ? e : Kr(e, p));
        }

        var kl = vo(function (e, n) {
          return function (t) {
            return ro(t, e, n);
          };
        }),
            Tl = vo(function (e, n) {
          return function (t) {
            return ro(e, t, n);
          };
        });

        function Pl(e, n, t) {
          var r = ol(n),
              o = qr(n, r);
          null != t || _s(n) && (o.length || !r.length) || (t = n, n = e, e = this, o = qr(n, ol(n)));
          var i = !(_s(t) && "chain" in t && !t.chain),
              A = vs(e);
          return Hn(o, function (t) {
            var r = n[t];
            e[t] = r, A && (e.prototype[t] = function () {
              var n = this.__chain__;

              if (i || n) {
                var t = e(this.__wrapped__),
                    o = t.__actions__ = ri(this.__actions__);
                return o.push({
                  func: r,
                  args: arguments,
                  thisArg: e
                }), t.__chain__ = n, t;
              }

              return r.apply(e, nt([this.value()], arguments));
            });
          }), e;
        }

        function Kl() {}

        var Ql = hi(et),
            Ul = hi(Vn),
            Rl = hi(ot);

        function Gl(e) {
          return Hi(e) ? pt(cA(e)) : function (e) {
            return function (n) {
              return Vr(n, e);
            };
          }(e);
        }

        var Yl = gi(),
            Fl = gi(!0);

        function Nl() {
          return [];
        }

        function jl() {
          return !1;
        }

        var Wl = fi(function (e, n) {
          return e + n;
        }, 0),
            Ll = yi("ceil"),
            zl = fi(function (e, n) {
          return e / n;
        }, 1),
            Xl = yi("floor");
        var Hl,
            ql = fi(function (e, n) {
          return e * n;
        }, 1),
            Vl = yi("round"),
            Jl = fi(function (e, n) {
          return e - n;
        }, 0);
        return mr.after = function (e, n) {
          if ("function" != typeof n) throw new on(l);
          return e = Fs(e), function () {
            if (--e < 1) return n.apply(this, arguments);
          };
        }, mr.ary = es, mr.assign = zs, mr.assignIn = Xs, mr.assignInWith = Hs, mr.assignWith = qs, mr.at = Vs, mr.before = ns, mr.bind = ts, mr.bindAll = Bl, mr.bindKey = rs, mr.castArray = function () {
          if (!arguments.length) return [];
          var e = arguments[0];
          return hs(e) ? e : [e];
        }, mr.chain = GA, mr.chunk = function (e, n, t) {
          n = (t ? Xi(e, n, t) : n === i) ? 1 : Lt(Fs(n), 0);
          var o = null == e ? 0 : e.length;
          if (!o || n < 1) return [];

          for (var A = 0, s = 0, l = r(Rt(o / n)); A < o;) {
            l[s++] = Oo(e, A, A += n);
          }

          return l;
        }, mr.compact = function (e) {
          for (var n = -1, t = null == e ? 0 : e.length, r = 0, o = []; ++n < t;) {
            var i = e[n];
            i && (o[r++] = i);
          }

          return o;
        }, mr.concat = function () {
          var e = arguments.length;
          if (!e) return [];

          for (var n = r(e - 1), t = arguments[0], o = e; o--;) {
            n[o - 1] = arguments[o];
          }

          return nt(hs(t) ? ri(t) : [t], Wr(n, 1));
        }, mr.cond = function (e) {
          var n = null == e ? 0 : e.length,
              t = Qi();
          return e = n ? et(e, function (e) {
            if ("function" != typeof e[1]) throw new on(l);
            return [t(e[0]), e[1]];
          }) : [], vo(function (t) {
            for (var r = -1; ++r < n;) {
              var o = e[r];
              if (zn(o[0], this, t)) return zn(o[1], this, t);
            }
          });
        }, mr.conforms = function (e) {
          return function (e) {
            var n = ol(e);
            return function (t) {
              return Qr(t, e, n);
            };
          }(Kr(e, p));
        }, mr.constant = _l, mr.countBy = NA, mr.create = function (e, n) {
          var t = Cr(e);
          return null == n ? t : Or(t, n);
        }, mr.curry = function e(n, t, r) {
          var o = wi(n, I, i, i, i, i, i, t = r ? i : t);
          return o.placeholder = e.placeholder, o;
        }, mr.curryRight = function e(n, t, r) {
          var o = wi(n, b, i, i, i, i, i, t = r ? i : t);
          return o.placeholder = e.placeholder, o;
        }, mr.debounce = os, mr.defaults = Js, mr.defaultsDeep = Zs, mr.defer = is, mr.delay = As, mr.difference = mA, mr.differenceBy = CA, mr.differenceWith = dA, mr.drop = function (e, n, t) {
          var r = null == e ? 0 : e.length;
          return r ? Oo(e, (n = t || n === i ? 1 : Fs(n)) < 0 ? 0 : n, r) : [];
        }, mr.dropRight = function (e, n, t) {
          var r = null == e ? 0 : e.length;
          return r ? Oo(e, 0, (n = r - (n = t || n === i ? 1 : Fs(n))) < 0 ? 0 : n) : [];
        }, mr.dropRightWhile = function (e, n) {
          return e && e.length ? Fo(e, Qi(n, 3), !0, !0) : [];
        }, mr.dropWhile = function (e, n) {
          return e && e.length ? Fo(e, Qi(n, 3), !0) : [];
        }, mr.fill = function (e, n, t, r) {
          var o = null == e ? 0 : e.length;
          return o ? (t && "number" != typeof t && Xi(e, n, t) && (t = 0, r = o), function (e, n, t, r) {
            var o = e.length;

            for ((t = Fs(t)) < 0 && (t = -t > o ? 0 : o + t), (r = r === i || r > o ? o : Fs(r)) < 0 && (r += o), r = t > r ? 0 : Ns(r); t < r;) {
              e[t++] = n;
            }

            return e;
          }(e, n, t, r)) : [];
        }, mr.filter = function (e, n) {
          return (hs(e) ? Jn : jr)(e, Qi(n, 3));
        }, mr.flatMap = function (e, n) {
          return Wr(VA(e, n), 1);
        }, mr.flatMapDeep = function (e, n) {
          return Wr(VA(e, n), T);
        }, mr.flatMapDepth = function (e, n, t) {
          return t = t === i ? 1 : Fs(t), Wr(VA(e, n), t);
        }, mr.flatten = xA, mr.flattenDeep = function (e) {
          return (null == e ? 0 : e.length) ? Wr(e, T) : [];
        }, mr.flattenDepth = function (e, n) {
          return (null == e ? 0 : e.length) ? Wr(e, n = n === i ? 1 : Fs(n)) : [];
        }, mr.flip = function (e) {
          return wi(e, B);
        }, mr.flow = Dl, mr.flowRight = Sl, mr.fromPairs = function (e) {
          for (var n = -1, t = null == e ? 0 : e.length, r = {}; ++n < t;) {
            var o = e[n];
            r[o[0]] = o[1];
          }

          return r;
        }, mr.functions = function (e) {
          return null == e ? [] : qr(e, ol(e));
        }, mr.functionsIn = function (e) {
          return null == e ? [] : qr(e, il(e));
        }, mr.groupBy = XA, mr.initial = function (e) {
          return (null == e ? 0 : e.length) ? Oo(e, 0, -1) : [];
        }, mr.intersection = IA, mr.intersectionBy = bA, mr.intersectionWith = yA, mr.invert = nl, mr.invertBy = tl, mr.invokeMap = HA, mr.iteratee = Ol, mr.keyBy = qA, mr.keys = ol, mr.keysIn = il, mr.map = VA, mr.mapKeys = function (e, n) {
          var t = {};
          return n = Qi(n, 3), Xr(e, function (e, r, o) {
            kr(t, n(e, r, o), e);
          }), t;
        }, mr.mapValues = function (e, n) {
          var t = {};
          return n = Qi(n, 3), Xr(e, function (e, r, o) {
            kr(t, r, n(e, r, o));
          }), t;
        }, mr.matches = function (e) {
          return mo(Kr(e, p));
        }, mr.matchesProperty = function (e, n) {
          return Co(e, Kr(n, p));
        }, mr.memoize = ss, mr.merge = Al, mr.mergeWith = sl, mr.method = kl, mr.methodOf = Tl, mr.mixin = Pl, mr.negate = ls, mr.nthArg = function (e) {
          return e = Fs(e), vo(function (n) {
            return ho(n, e);
          });
        }, mr.omit = ll, mr.omitBy = function (e, n) {
          return cl(e, ls(Qi(n)));
        }, mr.once = function (e) {
          return ns(2, e);
        }, mr.orderBy = function (e, n, t, r) {
          return null == e ? [] : (hs(n) || (n = null == n ? [] : [n]), hs(t = r ? i : t) || (t = null == t ? [] : [t]), xo(e, n, t));
        }, mr.over = Ql, mr.overArgs = as, mr.overEvery = Ul, mr.overSome = Rl, mr.partial = cs, mr.partialRight = us, mr.partition = JA, mr.pick = al, mr.pickBy = cl, mr.property = Gl, mr.propertyOf = function (e) {
          return function (n) {
            return null == e ? i : Vr(e, n);
          };
        }, mr.pull = vA, mr.pullAll = wA, mr.pullAllBy = function (e, n, t) {
          return e && e.length && n && n.length ? Io(e, n, Qi(t, 2)) : e;
        }, mr.pullAllWith = function (e, n, t) {
          return e && e.length && n && n.length ? Io(e, n, i, t) : e;
        }, mr.pullAt = BA, mr.range = Yl, mr.rangeRight = Fl, mr.rearg = ps, mr.reject = function (e, n) {
          return (hs(e) ? Jn : jr)(e, ls(Qi(n, 3)));
        }, mr.remove = function (e, n) {
          var t = [];
          if (!e || !e.length) return t;
          var r = -1,
              o = [],
              i = e.length;

          for (n = Qi(n, 3); ++r < i;) {
            var A = e[r];
            n(A, r, e) && (t.push(A), o.push(r));
          }

          return bo(e, o), t;
        }, mr.rest = function (e, n) {
          if ("function" != typeof e) throw new on(l);
          return vo(e, n = n === i ? n : Fs(n));
        }, mr.reverse = _A, mr.sampleSize = function (e, n, t) {
          return n = (t ? Xi(e, n, t) : n === i) ? 1 : Fs(n), (hs(e) ? wr : Bo)(e, n);
        }, mr.set = function (e, n, t) {
          return null == e ? e : _o(e, n, t);
        }, mr.setWith = function (e, n, t, r) {
          return r = "function" == typeof r ? r : i, null == e ? e : _o(e, n, t, r);
        }, mr.shuffle = function (e) {
          return (hs(e) ? Br : Mo)(e);
        }, mr.slice = function (e, n, t) {
          var r = null == e ? 0 : e.length;
          return r ? (t && "number" != typeof t && Xi(e, n, t) ? (n = 0, t = r) : (n = null == n ? 0 : Fs(n), t = t === i ? r : Fs(t)), Oo(e, n, t)) : [];
        }, mr.sortBy = ZA, mr.sortedUniq = function (e) {
          return e && e.length ? Ko(e) : [];
        }, mr.sortedUniqBy = function (e, n) {
          return e && e.length ? Ko(e, Qi(n, 2)) : [];
        }, mr.split = function (e, n, t) {
          return t && "number" != typeof t && Xi(e, n, t) && (n = t = i), (t = t === i ? U : t >>> 0) ? (e = Ls(e)) && ("string" == typeof n || null != n && !ks(n)) && !(n = Uo(n)) && wt(e) ? qo(kt(e), 0, t) : e.split(n, t) : [];
        }, mr.spread = function (e, n) {
          if ("function" != typeof e) throw new on(l);
          return n = null == n ? 0 : Lt(Fs(n), 0), vo(function (t) {
            var r = t[n],
                o = qo(t, 0, n);
            return r && nt(o, r), zn(e, this, o);
          });
        }, mr.tail = function (e) {
          var n = null == e ? 0 : e.length;
          return n ? Oo(e, 1, n) : [];
        }, mr.take = function (e, n, t) {
          return e && e.length ? Oo(e, 0, (n = t || n === i ? 1 : Fs(n)) < 0 ? 0 : n) : [];
        }, mr.takeRight = function (e, n, t) {
          var r = null == e ? 0 : e.length;
          return r ? Oo(e, (n = r - (n = t || n === i ? 1 : Fs(n))) < 0 ? 0 : n, r) : [];
        }, mr.takeRightWhile = function (e, n) {
          return e && e.length ? Fo(e, Qi(n, 3), !1, !0) : [];
        }, mr.takeWhile = function (e, n) {
          return e && e.length ? Fo(e, Qi(n, 3)) : [];
        }, mr.tap = function (e, n) {
          return n(e), e;
        }, mr.throttle = function (e, n, t) {
          var r = !0,
              o = !0;
          if ("function" != typeof e) throw new on(l);
          return _s(t) && (r = "leading" in t ? !!t.leading : r, o = "trailing" in t ? !!t.trailing : o), os(e, n, {
            leading: r,
            maxWait: n,
            trailing: o
          });
        }, mr.thru = YA, mr.toArray = Gs, mr.toPairs = ul, mr.toPairsIn = pl, mr.toPath = function (e) {
          return hs(e) ? et(e, cA) : Ks(e) ? [e] : ri(aA(Ls(e)));
        }, mr.toPlainObject = Ws, mr.transform = function (e, n, t) {
          var r = hs(e),
              o = r || bs(e) || Qs(e);

          if (n = Qi(n, 4), null == t) {
            var i = e && e.constructor;
            t = o ? r ? new i() : [] : _s(e) && vs(i) ? Cr(kn(e)) : {};
          }

          return (o ? Hn : Xr)(e, function (e, r, o) {
            return n(t, e, r, o);
          }), t;
        }, mr.unary = function (e) {
          return es(e, 1);
        }, mr.union = DA, mr.unionBy = SA, mr.unionWith = MA, mr.uniq = function (e) {
          return e && e.length ? Ro(e) : [];
        }, mr.uniqBy = function (e, n) {
          return e && e.length ? Ro(e, Qi(n, 2)) : [];
        }, mr.uniqWith = function (e, n) {
          return n = "function" == typeof n ? n : i, e && e.length ? Ro(e, i, n) : [];
        }, mr.unset = function (e, n) {
          return null == e || Go(e, n);
        }, mr.unzip = OA, mr.unzipWith = kA, mr.update = function (e, n, t) {
          return null == e ? e : Yo(e, n, zo(t));
        }, mr.updateWith = function (e, n, t, r) {
          return r = "function" == typeof r ? r : i, null == e ? e : Yo(e, n, zo(t), r);
        }, mr.values = ml, mr.valuesIn = function (e) {
          return null == e ? [] : xt(e, il(e));
        }, mr.without = TA, mr.words = vl, mr.wrap = function (e, n) {
          return cs(zo(n), e);
        }, mr.xor = PA, mr.xorBy = KA, mr.xorWith = QA, mr.zip = UA, mr.zipObject = function (e, n) {
          return Wo(e || [], n || [], Dr);
        }, mr.zipObjectDeep = function (e, n) {
          return Wo(e || [], n || [], _o);
        }, mr.zipWith = RA, mr.entries = ul, mr.entriesIn = pl, mr.extend = Xs, mr.extendWith = Hs, Pl(mr, mr), mr.add = Wl, mr.attempt = wl, mr.camelCase = Cl, mr.capitalize = dl, mr.ceil = Ll, mr.clamp = function (e, n, t) {
          return t === i && (t = n, n = i), t !== i && (t = (t = js(t)) == t ? t : 0), n !== i && (n = (n = js(n)) == n ? n : 0), Pr(js(e), n, t);
        }, mr.clone = function (e) {
          return Kr(e, C);
        }, mr.cloneDeep = function (e) {
          return Kr(e, p | C);
        }, mr.cloneDeepWith = function (e, n) {
          return Kr(e, p | C, n = "function" == typeof n ? n : i);
        }, mr.cloneWith = function (e, n) {
          return Kr(e, C, n = "function" == typeof n ? n : i);
        }, mr.conformsTo = function (e, n) {
          return null == n || Qr(e, n, ol(n));
        }, mr.deburr = fl, mr.defaultTo = function (e, n) {
          return null == e || e != e ? n : e;
        }, mr.divide = zl, mr.endsWith = function (e, n, t) {
          e = Ls(e), n = Uo(n);
          var r = e.length,
              o = t = t === i ? r : Pr(Fs(t), 0, r);
          return (t -= n.length) >= 0 && e.slice(t, o) == n;
        }, mr.eq = ms, mr.escape = function (e) {
          return (e = Ls(e)) && we.test(e) ? e.replace(Ee, Et) : e;
        }, mr.escapeRegExp = function (e) {
          return (e = Ls(e)) && Te.test(e) ? e.replace(ke, "\\$&") : e;
        }, mr.every = function (e, n, t) {
          var r = hs(e) ? Vn : Fr;
          return t && Xi(e, n, t) && (n = i), r(e, Qi(n, 3));
        }, mr.find = jA, mr.findIndex = fA, mr.findKey = function (e, n) {
          return At(e, Qi(n, 3), Xr);
        }, mr.findLast = WA, mr.findLastIndex = hA, mr.findLastKey = function (e, n) {
          return At(e, Qi(n, 3), Hr);
        }, mr.floor = Xl, mr.forEach = LA, mr.forEachRight = zA, mr.forIn = function (e, n) {
          return null == e ? e : Lr(e, Qi(n, 3), il);
        }, mr.forInRight = function (e, n) {
          return null == e ? e : zr(e, Qi(n, 3), il);
        }, mr.forOwn = function (e, n) {
          return e && Xr(e, Qi(n, 3));
        }, mr.forOwnRight = function (e, n) {
          return e && Hr(e, Qi(n, 3));
        }, mr.get = $s, mr.gt = Cs, mr.gte = ds, mr.has = function (e, n) {
          return null != e && ji(e, n, eo);
        }, mr.hasIn = el, mr.head = gA, mr.identity = Ml, mr.includes = function (e, n, t, r) {
          e = gs(e) ? e : ml(e), t = t && !r ? Fs(t) : 0;
          var o = e.length;
          return t < 0 && (t = Lt(o + t, 0)), Ps(e) ? t <= o && e.indexOf(n, t) > -1 : !!o && lt(e, n, t) > -1;
        }, mr.indexOf = function (e, n, t) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var o = null == t ? 0 : Fs(t);
          return o < 0 && (o = Lt(r + o, 0)), lt(e, n, o);
        }, mr.inRange = function (e, n, t) {
          return n = Ys(n), t === i ? (t = n, n = 0) : t = Ys(t), function (e, n, t) {
            return e >= zt(n, t) && e < Lt(n, t);
          }(e = js(e), n, t);
        }, mr.invoke = rl, mr.isArguments = fs, mr.isArray = hs, mr.isArrayBuffer = xs, mr.isArrayLike = gs, mr.isArrayLikeObject = Is, mr.isBoolean = function (e) {
          return !0 === e || !1 === e || Ds(e) && Zr(e) == W;
        }, mr.isBuffer = bs, mr.isDate = ys, mr.isElement = function (e) {
          return Ds(e) && 1 === e.nodeType && !Os(e);
        }, mr.isEmpty = function (e) {
          if (null == e) return !0;
          if (gs(e) && (hs(e) || "string" == typeof e || "function" == typeof e.splice || bs(e) || Qs(e) || fs(e))) return !e.length;
          var n = Ni(e);
          if (n == V || n == te) return !e.size;
          if (Ji(e)) return !ao(e).length;

          for (var t in e) {
            if (un.call(e, t)) return !1;
          }

          return !0;
        }, mr.isEqual = function (e, n) {
          return io(e, n);
        }, mr.isEqualWith = function (e, n, t) {
          var r = (t = "function" == typeof t ? t : i) ? t(e, n) : i;
          return r === i ? io(e, n, i, t) : !!r;
        }, mr.isError = Es, mr.isFinite = function (e) {
          return "number" == typeof e && Nt(e);
        }, mr.isFunction = vs, mr.isInteger = ws, mr.isLength = Bs, mr.isMap = Ss, mr.isMatch = function (e, n) {
          return e === n || Ao(e, n, Ri(n));
        }, mr.isMatchWith = function (e, n, t) {
          return t = "function" == typeof t ? t : i, Ao(e, n, Ri(n), t);
        }, mr.isNaN = function (e) {
          return Ms(e) && e != +e;
        }, mr.isNative = function (e) {
          if (Vi(e)) throw new Ze(s);
          return so(e);
        }, mr.isNil = function (e) {
          return null == e;
        }, mr.isNull = function (e) {
          return null === e;
        }, mr.isNumber = Ms, mr.isObject = _s, mr.isObjectLike = Ds, mr.isPlainObject = Os, mr.isRegExp = ks, mr.isSafeInteger = function (e) {
          return ws(e) && e >= -P && e <= P;
        }, mr.isSet = Ts, mr.isString = Ps, mr.isSymbol = Ks, mr.isTypedArray = Qs, mr.isUndefined = function (e) {
          return e === i;
        }, mr.isWeakMap = function (e) {
          return Ds(e) && Ni(e) == Ae;
        }, mr.isWeakSet = function (e) {
          return Ds(e) && Zr(e) == se;
        }, mr.join = function (e, n) {
          return null == e ? "" : jt.call(e, n);
        }, mr.kebabCase = hl, mr.last = EA, mr.lastIndexOf = function (e, n, t) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var o = r;
          return t !== i && (o = (o = Fs(t)) < 0 ? Lt(r + o, 0) : zt(o, r - 1)), n == n ? function (e, n, t) {
            for (var r = t + 1; r--;) {
              if (e[r] === n) return r;
            }

            return r;
          }(e, n, o) : st(e, ct, o, !0);
        }, mr.lowerCase = xl, mr.lowerFirst = gl, mr.lt = Us, mr.lte = Rs, mr.max = function (e) {
          return e && e.length ? Nr(e, Ml, $r) : i;
        }, mr.maxBy = function (e, n) {
          return e && e.length ? Nr(e, Qi(n, 2), $r) : i;
        }, mr.mean = function (e) {
          return ut(e, Ml);
        }, mr.meanBy = function (e, n) {
          return ut(e, Qi(n, 2));
        }, mr.min = function (e) {
          return e && e.length ? Nr(e, Ml, uo) : i;
        }, mr.minBy = function (e, n) {
          return e && e.length ? Nr(e, Qi(n, 2), uo) : i;
        }, mr.stubArray = Nl, mr.stubFalse = jl, mr.stubObject = function () {
          return {};
        }, mr.stubString = function () {
          return "";
        }, mr.stubTrue = function () {
          return !0;
        }, mr.multiply = ql, mr.nth = function (e, n) {
          return e && e.length ? ho(e, Fs(n)) : i;
        }, mr.noConflict = function () {
          return Pn._ === this && (Pn._ = fn), this;
        }, mr.noop = Kl, mr.now = $A, mr.pad = function (e, n, t) {
          e = Ls(e);
          var r = (n = Fs(n)) ? Ot(e) : 0;
          if (!n || r >= n) return e;
          var o = (n - r) / 2;
          return xi(Gt(o), t) + e + xi(Rt(o), t);
        }, mr.padEnd = function (e, n, t) {
          e = Ls(e);
          var r = (n = Fs(n)) ? Ot(e) : 0;
          return n && r < n ? e + xi(n - r, t) : e;
        }, mr.padStart = function (e, n, t) {
          e = Ls(e);
          var r = (n = Fs(n)) ? Ot(e) : 0;
          return n && r < n ? xi(n - r, t) + e : e;
        }, mr.parseInt = function (e, n, t) {
          return t || null == n ? n = 0 : n && (n = +n), Ht(Ls(e).replace(Ke, ""), n || 0);
        }, mr.random = function (e, n, t) {
          if (t && "boolean" != typeof t && Xi(e, n, t) && (n = t = i), t === i && ("boolean" == typeof n ? (t = n, n = i) : "boolean" == typeof e && (t = e, e = i)), e === i && n === i ? (e = 0, n = 1) : (e = Ys(e), n === i ? (n = e, e = 0) : n = Ys(n)), e > n) {
            var r = e;
            e = n, n = r;
          }

          if (t || e % 1 || n % 1) {
            var o = qt();
            return zt(e + o * (n - e + Mn("1e-" + ((o + "").length - 1))), n);
          }

          return yo(e, n);
        }, mr.reduce = function (e, n, t) {
          var r = hs(e) ? tt : Ct,
              o = arguments.length < 3;
          return r(e, Qi(n, 4), t, o, Gr);
        }, mr.reduceRight = function (e, n, t) {
          var r = hs(e) ? rt : Ct,
              o = arguments.length < 3;
          return r(e, Qi(n, 4), t, o, Yr);
        }, mr.repeat = function (e, n, t) {
          return n = (t ? Xi(e, n, t) : n === i) ? 1 : Fs(n), Eo(Ls(e), n);
        }, mr.replace = function () {
          var e = arguments,
              n = Ls(e[0]);
          return e.length < 3 ? n : n.replace(e[1], e[2]);
        }, mr.result = function (e, n, t) {
          var r = -1,
              o = (n = Xo(n, e)).length;

          for (o || (o = 1, e = i); ++r < o;) {
            var A = null == e ? i : e[cA(n[r])];
            A === i && (r = o, A = t), e = vs(A) ? A.call(e) : A;
          }

          return e;
        }, mr.round = Vl, mr.runInContext = e, mr.sample = function (e) {
          return (hs(e) ? vr : wo)(e);
        }, mr.size = function (e) {
          if (null == e) return 0;
          if (gs(e)) return Ps(e) ? Ot(e) : e.length;
          var n = Ni(e);
          return n == V || n == te ? e.size : ao(e).length;
        }, mr.snakeCase = Il, mr.some = function (e, n, t) {
          var r = hs(e) ? ot : ko;
          return t && Xi(e, n, t) && (n = i), r(e, Qi(n, 3));
        }, mr.sortedIndex = function (e, n) {
          return To(e, n);
        }, mr.sortedIndexBy = function (e, n, t) {
          return Po(e, n, Qi(t, 2));
        }, mr.sortedIndexOf = function (e, n) {
          var t = null == e ? 0 : e.length;

          if (t) {
            var r = To(e, n);
            if (r < t && ms(e[r], n)) return r;
          }

          return -1;
        }, mr.sortedLastIndex = function (e, n) {
          return To(e, n, !0);
        }, mr.sortedLastIndexBy = function (e, n, t) {
          return Po(e, n, Qi(t, 2), !0);
        }, mr.sortedLastIndexOf = function (e, n) {
          if (null == e ? 0 : e.length) {
            var t = To(e, n, !0) - 1;
            if (ms(e[t], n)) return t;
          }

          return -1;
        }, mr.startCase = bl, mr.startsWith = function (e, n, t) {
          return e = Ls(e), t = null == t ? 0 : Pr(Fs(t), 0, e.length), n = Uo(n), e.slice(t, t + n.length) == n;
        }, mr.subtract = Jl, mr.sum = function (e) {
          return e && e.length ? dt(e, Ml) : 0;
        }, mr.sumBy = function (e, n) {
          return e && e.length ? dt(e, Qi(n, 2)) : 0;
        }, mr.template = function (e, n, t) {
          var r = mr.templateSettings;
          t && Xi(e, n, t) && (n = i), e = Ls(e), n = Hs({}, n, r, Bi);
          var o,
              A,
              s = Hs({}, n.imports, r.imports, Bi),
              l = ol(s),
              a = xt(s, l),
              c = 0,
              u = n.interpolate || Ve,
              p = "__p += '",
              m = tn((n.escape || Ve).source + "|" + u.source + "|" + (u === De ? Ne : Ve).source + "|" + (n.evaluate || Ve).source + "|$", "g"),
              C = "//# sourceURL=" + (un.call(n, "sourceURL") ? (n.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++Bn + "]") + "\n";
          e.replace(m, function (n, t, r, i, s, l) {
            return r || (r = i), p += e.slice(c, l).replace(Je, vt), t && (o = !0, p += "' +\n__e(" + t + ") +\n'"), s && (A = !0, p += "';\n" + s + ";\n__p += '"), r && (p += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), c = l + n.length, n;
          }), p += "';\n";
          var d = un.call(n, "variable") && n.variable;
          d || (p = "with (obj) {\n" + p + "\n}\n"), p = (A ? p.replace(ge, "") : p).replace(Ie, "$1").replace(be, "$1;"), p = "function(" + (d || "obj") + ") {\n" + (d ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (o ? ", __e = _.escape" : "") + (A ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + p + "return __p\n}";
          var f = wl(function () {
            return $e(l, C + "return " + p).apply(i, a);
          });
          if (f.source = p, Es(f)) throw f;
          return f;
        }, mr.times = function (e, n) {
          if ((e = Fs(e)) < 1 || e > P) return [];
          var t = U,
              r = zt(e, U);
          n = Qi(n), e -= U;

          for (var o = ft(r, n); ++t < e;) {
            n(t);
          }

          return o;
        }, mr.toFinite = Ys, mr.toInteger = Fs, mr.toLength = Ns, mr.toLower = function (e) {
          return Ls(e).toLowerCase();
        }, mr.toNumber = js, mr.toSafeInteger = function (e) {
          return e ? Pr(Fs(e), -P, P) : 0 === e ? e : 0;
        }, mr.toString = Ls, mr.toUpper = function (e) {
          return Ls(e).toUpperCase();
        }, mr.trim = function (e, n, t) {
          if ((e = Ls(e)) && (t || n === i)) return e.replace(Pe, "");
          if (!e || !(n = Uo(n))) return e;
          var r = kt(e),
              o = kt(n);
          return qo(r, It(r, o), bt(r, o) + 1).join("");
        }, mr.trimEnd = function (e, n, t) {
          if ((e = Ls(e)) && (t || n === i)) return e.replace(Qe, "");
          if (!e || !(n = Uo(n))) return e;
          var r = kt(e);
          return qo(r, 0, bt(r, kt(n)) + 1).join("");
        }, mr.trimStart = function (e, n, t) {
          if ((e = Ls(e)) && (t || n === i)) return e.replace(Ke, "");
          if (!e || !(n = Uo(n))) return e;
          var r = kt(e);
          return qo(r, It(r, kt(n))).join("");
        }, mr.truncate = function (e, n) {
          var t = _,
              r = D;

          if (_s(n)) {
            var o = "separator" in n ? n.separator : o;
            t = "length" in n ? Fs(n.length) : t, r = "omission" in n ? Uo(n.omission) : r;
          }

          var A = (e = Ls(e)).length;

          if (wt(e)) {
            var s = kt(e);
            A = s.length;
          }

          if (t >= A) return e;
          var l = t - Ot(r);
          if (l < 1) return r;
          var a = s ? qo(s, 0, l).join("") : e.slice(0, l);
          if (o === i) return a + r;

          if (s && (l += a.length - l), ks(o)) {
            if (e.slice(l).search(o)) {
              var c,
                  u = a;

              for (o.global || (o = tn(o.source, Ls(je.exec(o)) + "g")), o.lastIndex = 0; c = o.exec(u);) {
                var p = c.index;
              }

              a = a.slice(0, p === i ? l : p);
            }
          } else if (e.indexOf(Uo(o), l) != l) {
            var m = a.lastIndexOf(o);
            m > -1 && (a = a.slice(0, m));
          }

          return a + r;
        }, mr.unescape = function (e) {
          return (e = Ls(e)) && ve.test(e) ? e.replace(ye, Tt) : e;
        }, mr.uniqueId = function (e) {
          var n = ++pn;
          return Ls(e) + n;
        }, mr.upperCase = yl, mr.upperFirst = El, mr.each = LA, mr.eachRight = zA, mr.first = gA, Pl(mr, (Hl = {}, Xr(mr, function (e, n) {
          un.call(mr.prototype, n) || (Hl[n] = e);
        }), Hl), {
          chain: !1
        }), mr.VERSION = "4.17.15", Hn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
          mr[e].placeholder = mr;
        }), Hn(["drop", "take"], function (e, n) {
          hr.prototype[e] = function (t) {
            t = t === i ? 1 : Lt(Fs(t), 0);
            var r = this.__filtered__ && !n ? new hr(this) : this.clone();
            return r.__filtered__ ? r.__takeCount__ = zt(t, r.__takeCount__) : r.__views__.push({
              size: zt(t, U),
              type: e + (r.__dir__ < 0 ? "Right" : "")
            }), r;
          }, hr.prototype[e + "Right"] = function (n) {
            return this.reverse()[e](n).reverse();
          };
        }), Hn(["filter", "map", "takeWhile"], function (e, n) {
          var t = n + 1,
              r = t == O || 3 == t;

          hr.prototype[e] = function (e) {
            var n = this.clone();
            return n.__iteratees__.push({
              iteratee: Qi(e, 3),
              type: t
            }), n.__filtered__ = n.__filtered__ || r, n;
          };
        }), Hn(["head", "last"], function (e, n) {
          var t = "take" + (n ? "Right" : "");

          hr.prototype[e] = function () {
            return this[t](1).value()[0];
          };
        }), Hn(["initial", "tail"], function (e, n) {
          var t = "drop" + (n ? "" : "Right");

          hr.prototype[e] = function () {
            return this.__filtered__ ? new hr(this) : this[t](1);
          };
        }), hr.prototype.compact = function () {
          return this.filter(Ml);
        }, hr.prototype.find = function (e) {
          return this.filter(e).head();
        }, hr.prototype.findLast = function (e) {
          return this.reverse().find(e);
        }, hr.prototype.invokeMap = vo(function (e, n) {
          return "function" == typeof e ? new hr(this) : this.map(function (t) {
            return ro(t, e, n);
          });
        }), hr.prototype.reject = function (e) {
          return this.filter(ls(Qi(e)));
        }, hr.prototype.slice = function (e, n) {
          e = Fs(e);
          var t = this;
          return t.__filtered__ && (e > 0 || n < 0) ? new hr(t) : (e < 0 ? t = t.takeRight(-e) : e && (t = t.drop(e)), n !== i && (t = (n = Fs(n)) < 0 ? t.dropRight(-n) : t.take(n - e)), t);
        }, hr.prototype.takeRightWhile = function (e) {
          return this.reverse().takeWhile(e).reverse();
        }, hr.prototype.toArray = function () {
          return this.take(U);
        }, Xr(hr.prototype, function (e, n) {
          var t = /^(?:filter|find|map|reject)|While$/.test(n),
              r = /^(?:head|last)$/.test(n),
              o = mr[r ? "take" + ("last" == n ? "Right" : "") : n],
              A = r || /^find/.test(n);
          o && (mr.prototype[n] = function () {
            var n = this.__wrapped__,
                s = r ? [1] : arguments,
                l = n instanceof hr,
                a = s[0],
                c = l || hs(n),
                u = function u(e) {
              var n = o.apply(mr, nt([e], s));
              return r && p ? n[0] : n;
            };

            c && t && "function" == typeof a && 1 != a.length && (l = c = !1);
            var p = this.__chain__,
                m = !!this.__actions__.length,
                C = A && !p,
                d = l && !m;

            if (!A && c) {
              n = d ? n : new hr(this);
              var f = e.apply(n, s);
              return f.__actions__.push({
                func: YA,
                args: [u],
                thisArg: i
              }), new fr(f, p);
            }

            return C && d ? e.apply(this, s) : (f = this.thru(u), C ? r ? f.value()[0] : f.value() : f);
          });
        }), Hn(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
          var n = An[e],
              t = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
              r = /^(?:pop|shift)$/.test(e);

          mr.prototype[e] = function () {
            var e = arguments;

            if (r && !this.__chain__) {
              var o = this.value();
              return n.apply(hs(o) ? o : [], e);
            }

            return this[t](function (t) {
              return n.apply(hs(t) ? t : [], e);
            });
          };
        }), Xr(hr.prototype, function (e, n) {
          var t = mr[n];

          if (t) {
            var r = t.name + "";
            un.call(or, r) || (or[r] = []), or[r].push({
              name: n,
              func: t
            });
          }
        }), or[Ci(i, x).name] = [{
          name: "wrapper",
          func: i
        }], hr.prototype.clone = function () {
          var e = new hr(this.__wrapped__);
          return e.__actions__ = ri(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = ri(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = ri(this.__views__), e;
        }, hr.prototype.reverse = function () {
          if (this.__filtered__) {
            var e = new hr(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else (e = this.clone()).__dir__ *= -1;

          return e;
        }, hr.prototype.value = function () {
          var e = this.__wrapped__.value(),
              n = this.__dir__,
              t = hs(e),
              r = n < 0,
              o = t ? e.length : 0,
              i = function (e, n, t) {
            var r = -1,
                o = t.length;

            for (; ++r < o;) {
              var i = t[r],
                  A = i.size;

              switch (i.type) {
                case "drop":
                  e += A;
                  break;

                case "dropRight":
                  n -= A;
                  break;

                case "take":
                  n = zt(n, e + A);
                  break;

                case "takeRight":
                  e = Lt(e, n - A);
              }
            }

            return {
              start: e,
              end: n
            };
          }(0, o, this.__views__),
              A = i.start,
              s = i.end,
              l = s - A,
              a = r ? s : A - 1,
              c = this.__iteratees__,
              u = c.length,
              p = 0,
              m = zt(l, this.__takeCount__);

          if (!t || !r && o == l && m == l) return No(e, this.__actions__);
          var C = [];

          e: for (; l-- && p < m;) {
            for (var d = -1, f = e[a += n]; ++d < u;) {
              var h = c[d],
                  x = h.iteratee,
                  g = h.type,
                  I = x(f);
              if (g == k) f = I;else if (!I) {
                if (g == O) continue e;
                break e;
              }
            }

            C[p++] = f;
          }

          return C;
        }, mr.prototype.at = FA, mr.prototype.chain = function () {
          return GA(this);
        }, mr.prototype.commit = function () {
          return new fr(this.value(), this.__chain__);
        }, mr.prototype.next = function () {
          this.__values__ === i && (this.__values__ = Gs(this.value()));
          var e = this.__index__ >= this.__values__.length;
          return {
            done: e,
            value: e ? i : this.__values__[this.__index__++]
          };
        }, mr.prototype.plant = function (e) {
          for (var n, t = this; t instanceof dr;) {
            var r = pA(t);
            r.__index__ = 0, r.__values__ = i, n ? o.__wrapped__ = r : n = r;
            var o = r;
            t = t.__wrapped__;
          }

          return o.__wrapped__ = e, n;
        }, mr.prototype.reverse = function () {
          var e = this.__wrapped__;

          if (e instanceof hr) {
            var n = e;
            return this.__actions__.length && (n = new hr(this)), (n = n.reverse()).__actions__.push({
              func: YA,
              args: [_A],
              thisArg: i
            }), new fr(n, this.__chain__);
          }

          return this.thru(_A);
        }, mr.prototype.toJSON = mr.prototype.valueOf = mr.prototype.value = function () {
          return No(this.__wrapped__, this.__actions__);
        }, mr.prototype.first = mr.prototype.head, Gn && (mr.prototype[Gn] = function () {
          return this;
        }), mr;
      }();

      Pn._ = Pt, (o = function () {
        return Pt;
      }.call(n, t, n, r)) === i || (r.exports = o);
    }).call(this);
  }).call(this, t(12), t(221)(e));
}, function (e, n) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function get() {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function get() {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, ".Mxao5fiyLJbGe--JJtVvN{background:black}.iiNP-9nhZWHSzo4pmQLjk{display:inline-flex;align-items:flex-start;width:100%}._27_v6Y9PMZDRN5D7dnzm0d{text-align:center;width:100%;margin:auto;padding:1em;position:relative}.I-rcBeRSMpuXgw8WBTYGV{color:white;line-height:1.2em;width:60%;margin-top:0;margin-bottom:0.5em;font-size:1.2em;overflow:hidden;display:inline-block;white-space:nowrap;text-overflow:ellipsis}@media (max-width: 768px){.I-rcBeRSMpuXgw8WBTYGV{text-align:center;padding-top:1em;white-space:normal}}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/media-player/index.module.scss"],
    names: [],
    mappings: "AAAA,uBACE,gBAAiB,CAClB,uBAGC,mBAAoB,CACpB,sBAAuB,CACvB,UAAW,CACZ,yBAGC,iBAAkB,CAClB,UAAW,CACX,WAAY,CACZ,WAAY,CACZ,iBAAkB,CAGnB,uBAGC,WAAY,CACZ,iBAAkB,CAClB,SAAU,CACV,YAAa,CACb,mBAAoB,CACpB,eAAgB,CAChB,eAAgB,CAChB,oBAAqB,CACrB,kBAAmB,CACnB,sBAAuB,CACxB,0BAIC,uBACE,iBAAkB,CAClB,eAAgB,CAChB,kBAAmB,CACpB",
    file: "index.module.scss",
    sourcesContent: [".topSection {\n  background: black;\n}\n\n.playerSection {\n  display: inline-flex;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.controlsSection {\n  text-align: center;\n  width: 100%;\n  margin: auto;\n  padding: 1em;\n  position: relative;\n  // overflow-x: auto;\n  // overflow-y: auto;\n}\n\n.title {\n  color: white;\n  line-height: 1.2em;\n  width: 60%;\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  font-size: 1.2em;\n  overflow: hidden;\n  display: inline-block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 768px) {\n\n  .title {\n    text-align: center;\n    padding-top: 1em;\n    white-space: normal;\n  }\n}\n"]
  }]), n.locals = {
    topSection: "Mxao5fiyLJbGe--JJtVvN",
    playerSection: "iiNP-9nhZWHSzo4pmQLjk",
    controlsSection: "_27_v6Y9PMZDRN5D7dnzm0d",
    title: "I-rcBeRSMpuXgw8WBTYGV"
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._24N77mDGihC8lEw-gSsC6r{cursor:pointer}@media (min-width: 768px){._24N77mDGihC8lEw-gSsC6r{max-width:100%}}@media (max-width: 767px){._24N77mDGihC8lEw-gSsC6r{max-width:100%}}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/video-player/index.module.css"],
    names: [],
    mappings: "AAAA,yBACE,cAAe,CAChB,0BAKC,yBACE,cAAe,CAChB,CAIH,0BAEE,yBACE,cAAe,CAChB",
    file: "index.module.css",
    sourcesContent: [".videoEl {\n  cursor: pointer;\n}\n\n/* Desktop size */\n@media (min-width: 768px) {\n\n  .videoEl {\n    max-width: 100%;\n  }\n}\n\n/* Mobile devices - excluding ipad*/\n@media (max-width: 767px) {\n\n  .videoEl {\n    max-width: 100%;\n  }\n}"]
  }]), n.locals = {
    videoEl: "_24N77mDGihC8lEw-gSsC6r"
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._2-P6QQvz0q7t4vMg5cIO6c{display:inline-block;position:relative;width:48px;display:inline-block;vertical-align:middle;margin-right:1em}._2WP1leuv4W5kNYP7UQDlkW{position:relative;display:inline-block;width:48px;height:28px}._2WP1leuv4W5kNYP7UQDlkW input{opacity:0;width:0;height:0}._2QDovDj-z5vJ3frE_1kn3B{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;-webkit-transition:0.4s;transition:0.4s}._2QDovDj-z5vJ3frE_1kn3B:before{position:absolute;content:'';height:20px;width:20px;left:4px;bottom:4px;background-color:white;-webkit-transition:0.4s;transition:0.4s}input:checked+._2QDovDj-z5vJ3frE_1kn3B{background-color:#a0372d}input:focus+._2QDovDj-z5vJ3frE_1kn3B{box-shadow:0 0 1px #a0372d}input:checked+._2QDovDj-z5vJ3frE_1kn3B:before{-webkit-transform:translateX(20px);-ms-transform:translateX(20px);transform:translateX(20px)}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/settings/Toggle/index.module.css", "/Users/okunoe01/workspace/react-transcript-editor/packages/config/style-guide/colours.scss"],
    names: [],
    mappings: "AAEA,yBACE,oBAAqB,CACrB,iBAAkB,CAClB,UAAW,CACX,oBAAqB,CACrB,qBAAsB,CACtB,gBAAiB,CAClB,yBAGC,iBAAkB,CAClB,oBAAqB,CACrB,UAAW,CACX,WAAY,CACb,+BAGC,SAAU,CACV,OAAQ,CACR,QAAS,CACV,yBAGC,iBAAkB,CAClB,cAAe,CACf,KAAM,CACN,MAAO,CACP,OAAQ,CACR,QAAS,CACT,qBAAsB,CACtB,uBAAwB,CACxB,eAAgB,CACjB,gCAGC,iBAAkB,CAClB,UAAW,CACX,WAAY,CACZ,UAAW,CACX,QAAS,CACT,UAAW,CACX,sBAAuB,CACvB,uBAAwB,CACxB,eAAgB,CACjB,uCAGC,wBCjDsB,CDkDvB,qCAGC,0BCrDsB,CDsDvB,8CAGC,kCAAmC,CACnC,8BAA+B,CAC/B,0BAA2B",
    file: "index.module.css",
    sourcesContent: ["@import '../../../config/style-guide/colours.scss';\n\n.switchContainer {\n  display: inline-block;\n  position: relative;\n  width: 48px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 1em;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 28px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: '';\n  height: 20px;\n  width: 20px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: $color-labs-red;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px $color-labs-red;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(20px);\n  -ms-transform: translateX(20px);\n  transform: translateX(20px);\n}\n", "$color-labs-red: #a0372d !default;\n$color-darkest-grey: #282828 !default;\n$color-dark-grey: #4a4a4a !default;\n$color-mid-grey: #696969 !default;\n$color-light-grey: #767676 !default;\n$color-lightest-grey: #f2f2f2 !default;\n$color-subt-green: #69e3c2 !default;\n$color-light-shilo: #E2A9A2 !default;\n"]
  }]), n.locals = {
    switchContainer: "_2-P6QQvz0q7t4vMg5cIO6c",
    switch: "_2WP1leuv4W5kNYP7UQDlkW",
    slider: "_2QDovDj-z5vJ3frE_1kn3B"
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._3v2Jpfelf2BQwv2rwSQ9H4{display:inline-block}._1yZJUMpXRbrtQjcJlQmDM7{height:2em;width:96px;box-sizing:border-box;border:none;text-align:center;font-weight:bold;margin-right:16px;vertical-align:middle}._2S-_LOJWPdwwh1bZgSffh0{font-weight:lighter;font-size:0.8em;cursor:pointer}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/settings/TimecodeOffset/index.module.css"],
    names: [],
    mappings: "AAAA,yBACE,oBAAqB,CACtB,yBAGC,UAAW,CACX,UAAW,CACX,qBAAsB,CACtB,WAAY,CACZ,iBAAkB,CAClB,gBAAiB,CACjB,iBAAkB,CAClB,qBAAsB,CACvB,yBAGC,mBAAoB,CACpB,eAAgB,CAChB,cAAe",
    file: "index.module.css",
    sourcesContent: [".offsetContainer {\n  display: inline-block;\n}\n\n.inputBox {\n  height: 2em;\n  width: 96px;\n  box-sizing: border-box;\n  border: none;\n  text-align: center;\n  font-weight: bold;\n  margin-right: 16px;\n  vertical-align: middle;\n}\n\n.button {\n  font-weight: lighter;\n  font-size: 0.8em;\n  cursor: pointer;\n}\n"]
  }]), n.locals = {
    offsetContainer: "_3v2Jpfelf2BQwv2rwSQ9H4",
    inputBox: "_1yZJUMpXRbrtQjcJlQmDM7",
    button: "_2S-_LOJWPdwwh1bZgSffh0"
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, ".JdHo9EaV61lkPYVOnY9Tr{position:absolute;left:0;right:0;margin:0 auto;width:30%;min-width:300px;min-height:300px;text-align:center;vertical-align:middle;color:white;background:#4a4a4a;padding:1em;font-weight:lighter;z-index:2}._3oFivHVg381f86Dvq_VKeL{margin-top:0;margin-bottom:1em}._2tvYaCv7psYHm_P5wedE4r{position:absolute;top:0;right:0;padding:1em;cursor:pointer}.fIfMHUdGQjz3vMdIEi8Jv{display:flex;flex-direction:column;align-content:flex-start;align-items:center;margin:0 auto}.RR5OSS1kiw_iws7Cl06lo{text-align:left;align-self:auto;margin-bottom:0.5em}._3g3SAU451awMxG-h9hkJB{display:inline-block;min-width:200px;width:200px}._3_RdkO-v0sVmSoXjTWPLAM{height:2em;width:48px;box-sizing:border-box;border:none;text-align:center;font-weight:bold;margin-right:16px;vertical-align:middle}._1jFCVDNuZCVANMQ1tPvi2L{display:block;text-align:center}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/settings/index.module.css"],
    names: [],
    mappings: "AAAA,uBACE,iBAAkB,CAClB,MAAO,CACP,OAAQ,CACR,aAAc,CACd,SAAU,CACV,eAAgB,CAChB,gBAAiB,CACjB,iBAAkB,CAClB,qBAAsB,CACtB,WAAY,CACZ,kBAAmB,CACnB,WAAY,CACZ,mBAAoB,CACpB,SAAU,CACX,yBAGC,YAAa,CACb,iBAAkB,CACnB,yBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,WAAY,CACZ,cAAe,CAChB,uBAGC,YAAa,CACb,qBAAsB,CACtB,wBAAyB,CACzB,kBAAmB,CACnB,aAAc,CACf,uBAGC,eAAgB,CAChB,eAAgB,CAChB,mBAAoB,CACrB,wBAGC,oBAAqB,CACrB,eAAgB,CAChB,WAAY,CACb,yBAGC,UAAW,CACX,UAAW,CACX,qBAAsB,CACtB,WAAY,CACZ,iBAAkB,CAClB,gBAAiB,CACjB,iBAAkB,CAClB,qBAAsB,CACvB,yBAGC,aAAc,CACd,iBAAkB",
    file: "index.module.css",
    sourcesContent: [".settings {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 30%;\n  min-width: 300px;\n  min-height: 300px;\n  text-align: center;\n  vertical-align: middle;\n  color: white;\n  background: #4a4a4a;\n  padding: 1em;\n  font-weight: lighter;\n  z-index: 2;\n}\n\n.header {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\n\n.closeButton {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 1em;\n  cursor: pointer;\n}\n\n.controlsContainer {\n  display: flex;\n  flex-direction: column;\n  align-content: flex-start;\n  align-items: center;\n  margin: 0 auto;\n}\n\n.settingElement {\n  text-align: left;\n  align-self: auto;\n  margin-bottom: 0.5em;\n}\n\n.label {\n  display: inline-block;\n  min-width: 200px;\n  width: 200px;\n}\n\n.rollbackValue {\n  height: 2em;\n  width: 48px;\n  box-sizing: border-box;\n  border: none;\n  text-align: center;\n  font-weight: bold;\n  margin-right: 16px;\n  vertical-align: middle;\n}\n\n.timecodeLabel {\n  display: block;\n  text-align: center;\n}\n"]
  }]), n.locals = {
    settings: "JdHo9EaV61lkPYVOnY9Tr",
    header: "_3oFivHVg381f86Dvq_VKeL",
    closeButton: "_2tvYaCv7psYHm_P5wedE4r",
    controlsContainer: "fIfMHUdGQjz3vMdIEi8Jv",
    settingElement: "RR5OSS1kiw_iws7Cl06lo",
    label: "_3g3SAU451awMxG-h9hkJB",
    rollbackValue: "_3_RdkO-v0sVmSoXjTWPLAM",
    timecodeLabel: "_1jFCVDNuZCVANMQ1tPvi2L"
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._3vz4i9xSEAUQCef4V49RqJ{font-size:0.85em;padding:1em;margin:0 auto;height:auto;vertical-align:middle;color:black;background:#f2f2f2;z-index:2;position:absolute;top:0;right:0}.XKXO62F3z7twaGOQau4AA{margin-top:0;margin-bottom:1em;text-align:center}._38JlPnDM81pTOO6XyC_2d{position:absolute;top:0;right:0;padding:1em;cursor:pointer;z-index:3}._3hIDqyJI9sseBtlYSXKcjQ{list-style:none;padding:1em;margin:0 auto}.CxEhL3Nl4a1OgiWFaRSwU{margin:0 auto;margin-bottom:0.5em}._3w39IqtcTpY5o5oh4Ohe5u{display:inline-block;width:6em;background:#a0372d;font-weight:lighter;color:white;padding:0 0;border-radius:1em;text-align:center;margin-right:1em}._2adwK9rVdwW2MXgO_2B02B{display:inline-block;text-align:left}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/keyboard-shortcuts/index.module.css", "/Users/okunoe01/workspace/react-transcript-editor/packages/config/style-guide/colours.scss"],
    names: [],
    mappings: "AAEA,yBACE,gBAAiB,CACjB,WAAY,CACZ,aAAc,CACd,WAAY,CACZ,qBAAsB,CACtB,WAAY,CACZ,kBCJ2B,CDK3B,SAAU,CACV,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACT,uBAGC,YAAa,CACb,iBAAkB,CAClB,iBAAkB,CACnB,wBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,WAAY,CACZ,cAAe,CACf,SAAU,CACX,yBAGC,eAAgB,CAChB,WAAY,CACZ,aAAc,CACf,uBAGC,aAAc,CACd,mBAAoB,CACrB,yBAGC,oBAAqB,CACrB,SAAU,CACV,kBC7CsB,CD8CtB,mBAAoB,CACpB,WAAY,CACZ,WAAY,CACZ,iBAAkB,CAClB,iBAAkB,CAClB,gBAAiB,CAClB,yBAGC,oBAAqB,CACrB,eAAgB",
    file: "index.module.css",
    sourcesContent: ["@import '../../config/style-guide/colours.scss';\n\n.shortcuts {\n  font-size: 0.85em;\n  padding: 1em;\n  margin: 0 auto;\n  height: auto;\n  vertical-align: middle;\n  color: black;\n  background: $color-lightest-grey;\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.header {\n  margin-top: 0;\n  margin-bottom: 1em;\n  text-align: center;\n}\n\n.closeButton {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 1em;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.list {\n  list-style: none;\n  padding: 1em;\n  margin: 0 auto;\n}\n\n.listItem {\n  margin: 0 auto;\n  margin-bottom: 0.5em;\n}\n\n.shortcut {\n  display: inline-block;\n  width: 6em;\n  background: $color-labs-red;\n  font-weight: lighter;\n  color: white;\n  padding: 0 0;\n  border-radius: 1em;\n  text-align: center;\n  margin-right: 1em;\n}\n\n.shortcutLabel {\n  display: inline-block;\n  text-align: left;\n}\n", "$color-labs-red: #a0372d !default;\n$color-darkest-grey: #282828 !default;\n$color-dark-grey: #4a4a4a !default;\n$color-mid-grey: #696969 !default;\n$color-light-grey: #767676 !default;\n$color-lightest-grey: #f2f2f2 !default;\n$color-subt-green: #69e3c2 !default;\n$color-light-shilo: #E2A9A2 !default;\n"]
  }]), n.locals = {
    shortcuts: "_3vz4i9xSEAUQCef4V49RqJ",
    header: "XKXO62F3z7twaGOQau4AA",
    closeButton: "_38JlPnDM81pTOO6XyC_2d",
    list: "_3hIDqyJI9sseBtlYSXKcjQ",
    listItem: "CxEhL3Nl4a1OgiWFaRSwU",
    shortcut: "_3w39IqtcTpY5o5oh4Ohe5u",
    shortcutLabel: "_2adwK9rVdwW2MXgO_2B02B"
  };
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      A = t.n(i),
      s = t(80),
      l = t(81),
      a = t(79),
      c = t(82),
      u = t(83),
      p = t(8),
      m = t(6),
      C = t(5),
      d = t(15),
      f = t.n(d);

  function h(e) {
    return (h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function x(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function g(e, n) {
    return !n || "object" !== h(n) && "function" != typeof n ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : n;
  }

  function I(e) {
    return (I = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function b(e, n) {
    return (b = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var y = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), g(this, I(n).apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && b(e, n);
    }(n, e), t = n, (r = [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return e !== this.props;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props;
        return o.a.createElement(o.a.Fragment, null, o.a.createElement("header", {
          className: f.a.header
        }, e.showSettings ? e.settings : null, e.showShortcuts ? e.shortcuts : null, e.showExportOptions ? e.exportOptions : null, e.tooltip), o.a.createElement("nav", {
          className: f.a.nav
        }, null === e.mediaUrl ? null : e.mediaControls), o.a.createElement("div", {
          className: f.a.settingsContainer
        }, o.a.createElement("button", {
          className: f.a.settingsButton,
          title: "Settings",
          onClick: e.handleSettingsToggle
        }, o.a.createElement(C.a, {
          icon: m.b
        })), o.a.createElement("button", {
          className: "".concat(f.a.settingsButton, " ").concat(f.a.keyboardShortcutsButon),
          title: "view shortcuts",
          onClick: e.handleShortcutsToggle
        }, o.a.createElement(C.a, {
          icon: m.e
        })), o.a.createElement("button", {
          className: "".concat(f.a.settingsButton),
          title: "Export",
          onClick: e.handleExportToggle
        }, o.a.createElement(C.a, {
          icon: m.k
        }))));
      }
    }]) && x(t.prototype, r), i && x(t, i), n;
    var t, r, i;
  }(o.a.Component),
      E = t(58),
      v = t.n(E);

  function w(e) {
    return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function B(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  function _(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function D(e, n) {
    return !n || "object" !== w(n) && "function" != typeof n ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : n;
  }

  function S(e) {
    return (S = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function M(e, n) {
    return (M = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var O = function (e) {
    function n() {
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), D(this, S(n).apply(this, arguments));
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && M(e, n);
    }(n, e), t = n, (r = [{
      key: "render",
      value: function value() {
        var e = this,
            n = this.props.exportOptionsList.map(function (n, t) {
          var r;
          return o.a.createElement(o.a.Fragment, null, o.a.createElement("button", (B(r = {
            key: n.label + t,
            title: n.label,
            className: v.a.playerButton
          }, "key", n.value), B(r, "onClick", e.props.handleExportOptionsChange), B(r, "value", n.value), r), n.label), o.a.createElement("br", null));
        });
        return o.a.createElement("div", {
          className: v.a.settings
        }, o.a.createElement("h2", {
          className: v.a.header
        }, "Export Options"), o.a.createElement("div", {
          className: v.a.closeButton,
          onClick: this.props.handleExportToggle
        }, o.a.createElement(C.a, {
          icon: m.q
        })), o.a.createElement("div", {
          className: v.a.controlsContainer
        }, n));
      }
    }]) && _(t.prototype, r), i && _(t, i), n;
    var t, r, i;
  }(o.a.Component);

  O.propTypes = {
    handleExportToggle: A.a.func
  };
  var k = O,
      T = t(229),
      P = t.n(T);

  var K = function () {
    function e(e) {
      this.isSpeedy = void 0 === e.speedy || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
    }

    var n = e.prototype;
    return n.insert = function (e) {
      if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
        var n,
            t = function (e) {
          var n = document.createElement("style");
          return n.setAttribute("data-emotion", e.key), void 0 !== e.nonce && n.setAttribute("nonce", e.nonce), n.appendChild(document.createTextNode("")), n;
        }(this);

        n = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(t, n), this.tags.push(t);
      }

      var r = this.tags[this.tags.length - 1];

      if (this.isSpeedy) {
        var o = function (e) {
          if (e.sheet) return e.sheet;

          for (var n = 0; n < document.styleSheets.length; n++) {
            if (document.styleSheets[n].ownerNode === e) return document.styleSheets[n];
          }
        }(r);

        try {
          var i = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
          o.insertRule(e, i ? 0 : o.cssRules.length);
        } catch (e) {
          0;
        }
      } else r.appendChild(document.createTextNode(e));

      this.ctr++;
    }, n.flush = function () {
      this.tags.forEach(function (e) {
        return e.parentNode.removeChild(e);
      }), this.tags = [], this.ctr = 0;
    }, e;
  }();

  var Q = function Q(e) {
    function n(e, n, r) {
      var o = n.trim().split(C);
      n = o;
      var i = o.length,
          A = e.length;

      switch (A) {
        case 0:
        case 1:
          var s = 0;

          for (e = 0 === A ? "" : e[0] + " "; s < i; ++s) {
            n[s] = t(e, n[s], r).trim();
          }

          break;

        default:
          var l = s = 0;

          for (n = []; s < i; ++s) {
            for (var a = 0; a < A; ++a) {
              n[l++] = t(e[a] + " ", o[s], r).trim();
            }
          }

      }

      return n;
    }

    function t(e, n, t) {
      var r = n.charCodeAt(0);

      switch (33 > r && (r = (n = n.trim()).charCodeAt(0)), r) {
        case 38:
          return n.replace(d, "$1" + e.trim());

        case 58:
          return e.trim() + n.replace(d, "$1" + e.trim());

        default:
          if (0 < 1 * t && 0 < n.indexOf("\f")) return n.replace(d, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
      }

      return e + n;
    }

    function r(e, n, t, i) {
      var A = e + ";",
          s = 2 * n + 3 * t + 4 * i;

      if (944 === s) {
        e = A.indexOf(":", 9) + 1;
        var l = A.substring(e, A.length - 1).trim();
        return l = A.substring(0, e).trim() + l + ";", 1 === S || 2 === S && o(l, 1) ? "-webkit-" + l + l : l;
      }

      if (0 === S || 2 === S && !o(A, 1)) return A;

      switch (s) {
        case 1015:
          return 97 === A.charCodeAt(10) ? "-webkit-" + A + A : A;

        case 951:
          return 116 === A.charCodeAt(3) ? "-webkit-" + A + A : A;

        case 963:
          return 110 === A.charCodeAt(5) ? "-webkit-" + A + A : A;

        case 1009:
          if (100 !== A.charCodeAt(4)) break;

        case 969:
        case 942:
          return "-webkit-" + A + A;

        case 978:
          return "-webkit-" + A + "-moz-" + A + A;

        case 1019:
        case 983:
          return "-webkit-" + A + "-moz-" + A + "-ms-" + A + A;

        case 883:
          if (45 === A.charCodeAt(8)) return "-webkit-" + A + A;
          if (0 < A.indexOf("image-set(", 11)) return A.replace(w, "$1-webkit-$2") + A;
          break;

        case 932:
          if (45 === A.charCodeAt(4)) switch (A.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + A.replace("-grow", "") + "-webkit-" + A + "-ms-" + A.replace("grow", "positive") + A;

            case 115:
              return "-webkit-" + A + "-ms-" + A.replace("shrink", "negative") + A;

            case 98:
              return "-webkit-" + A + "-ms-" + A.replace("basis", "preferred-size") + A;
          }
          return "-webkit-" + A + "-ms-" + A + A;

        case 964:
          return "-webkit-" + A + "-ms-flex-" + A + A;

        case 1023:
          if (99 !== A.charCodeAt(8)) break;
          return "-webkit-box-pack" + (l = A.substring(A.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + A + "-ms-flex-pack" + l + A;

        case 1005:
          return p.test(A) ? A.replace(u, ":-webkit-") + A.replace(u, ":-moz-") + A : A;

        case 1e3:
          switch (n = (l = A.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(n)) {
            case 226:
              l = A.replace(g, "tb");
              break;

            case 232:
              l = A.replace(g, "tb-rl");
              break;

            case 220:
              l = A.replace(g, "lr");
              break;

            default:
              return A;
          }

          return "-webkit-" + A + "-ms-" + l + A;

        case 1017:
          if (-1 === A.indexOf("sticky", 9)) break;

        case 975:
          switch (n = (A = e).length - 10, s = (l = (33 === A.charCodeAt(n) ? A.substring(0, n) : A).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))) {
            case 203:
              if (111 > l.charCodeAt(8)) break;

            case 115:
              A = A.replace(l, "-webkit-" + l) + ";" + A;
              break;

            case 207:
            case 102:
              A = A.replace(l, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + A.replace(l, "-webkit-" + l) + ";" + A.replace(l, "-ms-" + l + "box") + ";" + A;
          }

          return A + ";";

        case 938:
          if (45 === A.charCodeAt(5)) switch (A.charCodeAt(6)) {
            case 105:
              return l = A.replace("-items", ""), "-webkit-" + A + "-webkit-box-" + l + "-ms-flex-" + l + A;

            case 115:
              return "-webkit-" + A + "-ms-flex-item-" + A.replace(y, "") + A;

            default:
              return "-webkit-" + A + "-ms-flex-line-pack" + A.replace("align-content", "").replace(y, "") + A;
          }
          break;

        case 973:
        case 989:
          if (45 !== A.charCodeAt(3) || 122 === A.charCodeAt(4)) break;

        case 931:
        case 953:
          if (!0 === v.test(e)) return 115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? r(e.replace("stretch", "fill-available"), n, t, i).replace(":fill-available", ":stretch") : A.replace(l, "-webkit-" + l) + A.replace(l, "-moz-" + l.replace("fill-", "")) + A;
          break;

        case 962:
          if (A = "-webkit-" + A + (102 === A.charCodeAt(5) ? "-ms-" + A : "") + A, 211 === t + i && 105 === A.charCodeAt(13) && 0 < A.indexOf("transform", 10)) return A.substring(0, A.indexOf(";", 27) + 1).replace(m, "$1-webkit-$2") + A;
      }

      return A;
    }

    function o(e, n) {
      var t = e.indexOf(1 === n ? ":" : "{"),
          r = e.substring(0, 3 !== n ? t : 10);
      return t = e.substring(t + 1, e.length - 1), T(2 !== n ? r : r.replace(E, "$1"), t, n);
    }

    function i(e, n) {
      var t = r(n, n.charCodeAt(0), n.charCodeAt(1), n.charCodeAt(2));
      return t !== n + ";" ? t.replace(b, " or ($1)").substring(4) : "(" + n + ")";
    }

    function A(e, n, t, r, o, i, A, s, a, c) {
      for (var u, p = 0, m = n; p < k; ++p) {
        switch (u = O[p].call(l, e, m, t, r, o, i, A, s, a, c)) {
          case void 0:
          case !1:
          case !0:
          case null:
            break;

          default:
            m = u;
        }
      }

      if (m !== n) return m;
    }

    function s(e) {
      return void 0 !== (e = e.prefix) && (T = null, e ? "function" != typeof e ? S = 1 : (S = 2, T = e) : S = 0), s;
    }

    function l(e, t) {
      var s = e;

      if (33 > s.charCodeAt(0) && (s = s.trim()), s = [s], 0 < k) {
        var l = A(-1, t, s, s, _, B, 0, 0, 0, 0);
        void 0 !== l && "string" == typeof l && (t = l);
      }

      var u = function e(t, s, l, u, p) {
        for (var m, C, d, g, b, y = 0, E = 0, v = 0, w = 0, O = 0, T = 0, K = d = m = 0, Q = 0, U = 0, R = 0, G = 0, Y = l.length, F = Y - 1, N = "", j = "", W = "", L = ""; Q < Y;) {
          if (C = l.charCodeAt(Q), Q === F && 0 !== E + w + v + y && (0 !== E && (C = 47 === E ? 10 : 47), w = v = y = 0, Y++, F++), 0 === E + w + v + y) {
            if (Q === F && (0 < U && (N = N.replace(c, "")), 0 < N.trim().length)) {
              switch (C) {
                case 32:
                case 9:
                case 59:
                case 13:
                case 10:
                  break;

                default:
                  N += l.charAt(Q);
              }

              C = 59;
            }

            switch (C) {
              case 123:
                for (m = (N = N.trim()).charCodeAt(0), d = 1, G = ++Q; Q < Y;) {
                  switch (C = l.charCodeAt(Q)) {
                    case 123:
                      d++;
                      break;

                    case 125:
                      d--;
                      break;

                    case 47:
                      switch (C = l.charCodeAt(Q + 1)) {
                        case 42:
                        case 47:
                          e: {
                            for (K = Q + 1; K < F; ++K) {
                              switch (l.charCodeAt(K)) {
                                case 47:
                                  if (42 === C && 42 === l.charCodeAt(K - 1) && Q + 2 !== K) {
                                    Q = K + 1;
                                    break e;
                                  }

                                  break;

                                case 10:
                                  if (47 === C) {
                                    Q = K + 1;
                                    break e;
                                  }

                              }
                            }

                            Q = K;
                          }

                      }

                      break;

                    case 91:
                      C++;

                    case 40:
                      C++;

                    case 34:
                    case 39:
                      for (; Q++ < F && l.charCodeAt(Q) !== C;) {
                        ;
                      }

                  }

                  if (0 === d) break;
                  Q++;
                }

                switch (d = l.substring(G, Q), 0 === m && (m = (N = N.replace(a, "").trim()).charCodeAt(0)), m) {
                  case 64:
                    switch (0 < U && (N = N.replace(c, "")), C = N.charCodeAt(1)) {
                      case 100:
                      case 109:
                      case 115:
                      case 45:
                        U = s;
                        break;

                      default:
                        U = M;
                    }

                    if (G = (d = e(s, U, d, C, p + 1)).length, 0 < k && (b = A(3, d, U = n(M, N, R), s, _, B, G, C, p, u), N = U.join(""), void 0 !== b && 0 === (G = (d = b.trim()).length) && (C = 0, d = "")), 0 < G) switch (C) {
                      case 115:
                        N = N.replace(I, i);

                      case 100:
                      case 109:
                      case 45:
                        d = N + "{" + d + "}";
                        break;

                      case 107:
                        d = (N = N.replace(f, "$1 $2")) + "{" + d + "}", d = 1 === S || 2 === S && o("@" + d, 3) ? "@-webkit-" + d + "@" + d : "@" + d;
                        break;

                      default:
                        d = N + d, 112 === u && (j += d, d = "");
                    } else d = "";
                    break;

                  default:
                    d = e(s, n(s, N, R), d, u, p + 1);
                }

                W += d, d = R = U = K = m = 0, N = "", C = l.charCodeAt(++Q);
                break;

              case 125:
              case 59:
                if (1 < (G = (N = (0 < U ? N.replace(c, "") : N).trim()).length)) switch (0 === K && (m = N.charCodeAt(0), 45 === m || 96 < m && 123 > m) && (G = (N = N.replace(" ", ":")).length), 0 < k && void 0 !== (b = A(1, N, s, t, _, B, j.length, u, p, u)) && 0 === (G = (N = b.trim()).length) && (N = "\0\0"), m = N.charCodeAt(0), C = N.charCodeAt(1), m) {
                  case 0:
                    break;

                  case 64:
                    if (105 === C || 99 === C) {
                      L += N + l.charAt(Q);
                      break;
                    }

                  default:
                    58 !== N.charCodeAt(G - 1) && (j += r(N, m, C, N.charCodeAt(2)));
                }
                R = U = K = m = 0, N = "", C = l.charCodeAt(++Q);
            }
          }

          switch (C) {
            case 13:
            case 10:
              47 === E ? E = 0 : 0 === 1 + m && 107 !== u && 0 < N.length && (U = 1, N += "\0"), 0 < k * P && A(0, N, s, t, _, B, j.length, u, p, u), B = 1, _++;
              break;

            case 59:
            case 125:
              if (0 === E + w + v + y) {
                B++;
                break;
              }

            default:
              switch (B++, g = l.charAt(Q), C) {
                case 9:
                case 32:
                  if (0 === w + y + E) switch (O) {
                    case 44:
                    case 58:
                    case 9:
                    case 32:
                      g = "";
                      break;

                    default:
                      32 !== C && (g = " ");
                  }
                  break;

                case 0:
                  g = "\\0";
                  break;

                case 12:
                  g = "\\f";
                  break;

                case 11:
                  g = "\\v";
                  break;

                case 38:
                  0 === w + E + y && (U = R = 1, g = "\f" + g);
                  break;

                case 108:
                  if (0 === w + E + y + D && 0 < K) switch (Q - K) {
                    case 2:
                      112 === O && 58 === l.charCodeAt(Q - 3) && (D = O);

                    case 8:
                      111 === T && (D = T);
                  }
                  break;

                case 58:
                  0 === w + E + y && (K = Q);
                  break;

                case 44:
                  0 === E + v + w + y && (U = 1, g += "\r");
                  break;

                case 34:
                case 39:
                  0 === E && (w = w === C ? 0 : 0 === w ? C : w);
                  break;

                case 91:
                  0 === w + E + v && y++;
                  break;

                case 93:
                  0 === w + E + v && y--;
                  break;

                case 41:
                  0 === w + E + y && v--;
                  break;

                case 40:
                  if (0 === w + E + y) {
                    if (0 === m) switch (2 * O + 3 * T) {
                      case 533:
                        break;

                      default:
                        m = 1;
                    }
                    v++;
                  }

                  break;

                case 64:
                  0 === E + v + w + y + K + d && (d = 1);
                  break;

                case 42:
                case 47:
                  if (!(0 < w + y + v)) switch (E) {
                    case 0:
                      switch (2 * C + 3 * l.charCodeAt(Q + 1)) {
                        case 235:
                          E = 47;
                          break;

                        case 220:
                          G = Q, E = 42;
                      }

                      break;

                    case 42:
                      47 === C && 42 === O && G + 2 !== Q && (33 === l.charCodeAt(G + 2) && (j += l.substring(G, Q + 1)), g = "", E = 0);
                  }
              }

              0 === E && (N += g);
          }

          T = O, O = C, Q++;
        }

        if (0 < (G = j.length)) {
          if (U = s, 0 < k && void 0 !== (b = A(2, j, U, t, _, B, G, u, p, u)) && 0 === (j = b).length) return L + j + W;

          if (j = U.join(",") + "{" + j + "}", 0 != S * D) {
            switch (2 !== S || o(j, 2) || (D = 0), D) {
              case 111:
                j = j.replace(x, ":-moz-$1") + j;
                break;

              case 112:
                j = j.replace(h, "::-webkit-input-$1") + j.replace(h, "::-moz-$1") + j.replace(h, ":-ms-input-$1") + j;
            }

            D = 0;
          }
        }

        return L + j + W;
      }(M, s, t, 0, 0);

      return 0 < k && void 0 !== (l = A(-2, u, s, s, _, B, u.length, 0, 0, 0)) && (u = l), "", D = 0, B = _ = 1, u;
    }

    var a = /^\0+/g,
        c = /[\0\r\f]/g,
        u = /: */g,
        p = /zoo|gra/,
        m = /([,: ])(transform)/g,
        C = /,\r+?/g,
        d = /([\t\r\n ])*\f?&/g,
        f = /@(k\w+)\s*(\S*)\s*/,
        h = /::(place)/g,
        x = /:(read-only)/g,
        g = /[svh]\w+-[tblr]{2}/,
        I = /\(\s*(.*)\s*\)/g,
        b = /([\s\S]*?);/g,
        y = /-self|flex-/g,
        E = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
        v = /stretch|:\s*\w+\-(?:conte|avail)/,
        w = /([^-])(image-set\()/,
        B = 1,
        _ = 1,
        D = 0,
        S = 1,
        M = [],
        O = [],
        k = 0,
        T = null,
        P = 0;
    return l.use = function e(n) {
      switch (n) {
        case void 0:
        case null:
          k = O.length = 0;
          break;

        default:
          if ("function" == typeof n) O[k++] = n;else if ("object" == typeof n) for (var t = 0, r = n.length; t < r; ++t) {
            e(n[t]);
          } else P = 0 | !!n;
      }

      return e;
    }, l.set = s, void 0 !== e && s(e), l;
  };

  function U(e) {
    e && R.current.insert(e + "}");
  }

  var R = {
    current: null
  },
      G = function G(e, n, t, r, o, i, A, s, l, a) {
    switch (e) {
      case 1:
        switch (n.charCodeAt(0)) {
          case 64:
            return R.current.insert(n + ";"), "";

          case 108:
            if (98 === n.charCodeAt(2)) return "";
        }

        break;

      case 2:
        if (0 === s) return n + "/*|*/";
        break;

      case 3:
        switch (s) {
          case 102:
          case 112:
            return R.current.insert(t[0] + n), "";

          default:
            return n + (0 === a ? "/*|*/" : "");
        }

      case -2:
        n.split("/*|*/}").forEach(U);
    }
  },
      Y = function Y(e) {
    void 0 === e && (e = {});
    var n,
        t = e.key || "css";
    void 0 !== e.prefix && (n = {
      prefix: e.prefix
    });
    var r = new Q(n);
    var o,
        i = {};
    o = e.container || document.head;
    var A,
        s = document.querySelectorAll("style[data-emotion-" + t + "]");
    Array.prototype.forEach.call(s, function (e) {
      e.getAttribute("data-emotion-" + t).split(" ").forEach(function (e) {
        i[e] = !0;
      }), e.parentNode !== o && o.appendChild(e);
    }), r.use(e.stylisPlugins)(G), A = function A(e, n, t, o) {
      var i = n.name;
      R.current = t, r(e, n.styles), o && (l.inserted[i] = !0);
    };
    var l = {
      key: t,
      sheet: new K({
        key: t,
        container: o,
        nonce: e.nonce,
        speedy: e.speedy
      }),
      nonce: e.nonce,
      inserted: i,
      registered: {},
      insert: A
    };
    return l;
  };

  function F(e, n, t) {
    var r = "";
    return t.split(" ").forEach(function (t) {
      void 0 !== e[t] ? n.push(e[t]) : r += t + " ";
    }), r;
  }

  var N = function N(e, n, t) {
    var r = e.key + "-" + n.name;

    if (!1 === t && void 0 === e.registered[r] && (e.registered[r] = n.styles), void 0 === e.inserted[n.name]) {
      var o = n;

      do {
        e.insert("." + r, o, e.sheet, !0);
        o = o.next;
      } while (void 0 !== o);
    }
  };

  var j = function j(e) {
    for (var n, t = e.length, r = t ^ t, o = 0; t >= 4;) {
      n = 1540483477 * (65535 & (n = 255 & e.charCodeAt(o) | (255 & e.charCodeAt(++o)) << 8 | (255 & e.charCodeAt(++o)) << 16 | (255 & e.charCodeAt(++o)) << 24)) + ((1540483477 * (n >>> 16) & 65535) << 16), r = 1540483477 * (65535 & r) + ((1540483477 * (r >>> 16) & 65535) << 16) ^ (n = 1540483477 * (65535 & (n ^= n >>> 24)) + ((1540483477 * (n >>> 16) & 65535) << 16)), t -= 4, ++o;
    }

    switch (t) {
      case 3:
        r ^= (255 & e.charCodeAt(o + 2)) << 16;

      case 2:
        r ^= (255 & e.charCodeAt(o + 1)) << 8;

      case 1:
        r = 1540483477 * (65535 & (r ^= 255 & e.charCodeAt(o))) + ((1540483477 * (r >>> 16) & 65535) << 16);
    }

    return r = 1540483477 * (65535 & (r ^= r >>> 13)) + ((1540483477 * (r >>> 16) & 65535) << 16), ((r ^= r >>> 15) >>> 0).toString(36);
  },
      W = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  var L = /[A-Z]|^ms/g,
      z = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
      X = function X(e) {
    return 45 === e.charCodeAt(1);
  },
      H = function (e) {
    var n = {};
    return function (t) {
      return void 0 === n[t] && (n[t] = e(t)), n[t];
    };
  }(function (e) {
    return X(e) ? e : e.replace(L, "-$&").toLowerCase();
  }),
      q = function q(e, n) {
    if (null == n || "boolean" == typeof n) return "";

    switch (e) {
      case "animation":
      case "animationName":
        if ("string" == typeof n) return n.replace(z, function (e, n, t) {
          return J = {
            name: n,
            styles: t,
            next: J
          }, n;
        });
    }

    return 1 === W[e] || X(e) || "number" != typeof n || 0 === n ? n : n + "px";
  };

  function V(e, n, t, r) {
    if (null == t) return "";
    if (void 0 !== t.__emotion_styles) return t;

    switch (typeof t) {
      case "boolean":
        return "";

      case "object":
        if (1 === t.anim) return J = {
          name: t.name,
          styles: t.styles,
          next: J
        }, t.name;

        if (void 0 !== t.styles) {
          var o = t.next;
          if (void 0 !== o) for (; void 0 !== o;) {
            J = {
              name: o.name,
              styles: o.styles,
              next: J
            }, o = o.next;
          }
          return t.styles;
        }

        return function (e, n, t) {
          var r = "";
          if (Array.isArray(t)) for (var o = 0; o < t.length; o++) {
            r += V(e, n, t[o], !1);
          } else for (var i in t) {
            var A = t[i];
            if ("object" != typeof A) null != n && void 0 !== n[A] ? r += i + "{" + n[A] + "}" : r += H(i) + ":" + q(i, A) + ";";else if (!Array.isArray(A) || "string" != typeof A[0] || null != n && void 0 !== n[A[0]]) {
              var s = V(e, n, A, !1);

              switch (i) {
                case "animation":
                case "animationName":
                  r += H(i) + ":" + s + ";";
                  break;

                default:
                  r += i + "{" + s + "}";
              }
            } else for (var l = 0; l < A.length; l++) {
              r += H(i) + ":" + q(i, A[l]) + ";";
            }
          }
          return r;
        }(e, n, t);

      case "function":
        if (void 0 !== e) {
          var i = J,
              A = t(e);
          return J = i, V(e, n, A, r);
        }

      default:
        if (null == n) return t;
        var s = n[t];
        return void 0 === s || r ? t : s;
    }
  }

  var J,
      Z = /label:\s*([^\s;\n{]+)\s*;/g;

  var $ = function $(e, n, t) {
    if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
    var r = !0,
        o = "";
    J = void 0;
    var i = e[0];
    null == i || void 0 === i.raw ? (r = !1, o += V(t, n, i, !1)) : o += i[0];

    for (var A = 1; A < e.length; A++) {
      o += V(t, n, e[A], 46 === o.charCodeAt(o.length - 1)), r && (o += i[A]);
    }

    Z.lastIndex = 0;

    for (var s, l = ""; null !== (s = Z.exec(o));) {
      l += "-" + s[1];
    }

    return {
      name: j(o) + l,
      styles: o,
      next: J
    };
  };

  var ee = function ee() {
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
      n[t] = arguments[t];
    }

    return $(n);
  },
      ne = Object(r.createContext)("undefined" != typeof HTMLElement ? Y() : null),
      te = Object(r.createContext)({}),
      re = (ne.Provider, function (e) {
    return Object(r.forwardRef)(function (n, t) {
      return Object(r.createElement)(ne.Consumer, null, function (r) {
        return e(n, r, t);
      });
    });
  }),
      oe = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__",
      ie = Object.prototype.hasOwnProperty,
      Ae = function Ae(e, n, t, o) {
    var i = null === t ? n.css : n.css(t);
    "string" == typeof i && void 0 !== e.registered[i] && (i = e.registered[i]);
    var A = n[oe],
        s = [i],
        l = "";
    void 0 !== n.className && (l = F(e.registered, s, n.className));
    var a = $(s);
    N(e, a, "string" == typeof A);
    l += e.key + "-" + a.name;
    var c = {};

    for (var u in n) {
      ie.call(n, u) && "css" !== u && u !== oe && (c[u] = n[u]);
    }

    return c.ref = o, c.className = l, Object(r.createElement)(A, c);
  },
      se = re(function (e, n, t) {
    return "function" == typeof e.css ? Object(r.createElement)(te.Consumer, null, function (r) {
      return Ae(n, e, r, t);
    }) : Ae(n, e, null, t);
  });

  var le = function le(e, n) {
    var t = arguments;
    if (null == n || !ie.call(n, "css")) return r.createElement.apply(void 0, t);
    var o = t.length,
        i = new Array(o);
    i[0] = se;
    var A = {};

    for (var s in n) {
      ie.call(n, s) && (A[s] = n[s]);
    }

    A[oe] = e, i[1] = A;

    for (var l = 2; l < o; l++) {
      i[l] = t[l];
    }

    return r.createElement.apply(null, i);
  },
      ae = (r.Component, function e(n) {
    for (var t = n.length, r = 0, o = ""; r < t; r++) {
      var i = n[r];

      if (null != i) {
        var A = void 0;

        switch (typeof i) {
          case "boolean":
            break;

          case "object":
            if (Array.isArray(i)) A = e(i);else for (var s in A = "", i) {
              i[s] && s && (A && (A += " "), A += s);
            }
            break;

          default:
            A = i;
        }

        A && (o && (o += " "), o += A);
      }
    }

    return o;
  });

  function ce(e, n, t) {
    var r = [],
        o = F(e, r, t);
    return r.length < 2 ? t : o + n(r);
  }

  re(function (e, n) {
    return Object(r.createElement)(te.Consumer, null, function (t) {
      var r = function r() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        var o = $(t, n.registered);
        return N(n, o, !1), n.key + "-" + o.name;
      },
          o = {
        css: r,
        cx: function cx() {
          for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++) {
            t[o] = arguments[o];
          }

          return ce(n.registered, r, ae(t));
        },
        theme: t
      },
          i = e.children(o);

      return !0, i;
    });
  });

  var ue = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      pe = he(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  background: ", ";\n"], ["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n  background: ", ";\n"]),
      me = he(["\n  ", ";\n  transform: translateX(-50%) translateY(50%) rotateZ(45deg);\n  bottom: 100%;\n  left: 50%;\n  border-left: 1px solid ", ";\n  border-top: 1px solid ", ";\n"], ["\n  ", ";\n  transform: translateX(-50%) translateY(50%) rotateZ(45deg);\n  bottom: 100%;\n  left: 50%;\n  border-left: 1px solid ", ";\n  border-top: 1px solid ", ";\n"]),
      Ce = he(["\n  ", ";\n  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);\n  top: 100%;\n  left: 50%;\n  border-right: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  ", ";\n  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);\n  top: 100%;\n  left: 50%;\n  border-right: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"]),
      de = he(["\n  ", ";\n  transform: translateX(50%) translateY(-50%) rotateZ(45deg);\n  right: 100%;\n  top: 50%;\n  border-left: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  ", ";\n  transform: translateX(50%) translateY(-50%) rotateZ(45deg);\n  right: 100%;\n  top: 50%;\n  border-left: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"]),
      fe = he(["\n  ", ";\n  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);\n  left: 100%;\n  top: 50%;\n  border-right: 1px solid ", ";\n  border-top: 1px solid ", ";\n"], ["\n  ", ";\n  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);\n  left: 100%;\n  top: 50%;\n  border-right: 1px solid ", ";\n  border-top: 1px solid ", ";\n"]);

  function he(e, n) {
    return e.raw = n, e;
  }

  var xe = function xe(e) {
    return ee(pe, e.width, e.width, e.background);
  },
      ge = function ge(e) {
    return ee(me, xe(e), e.border, e.border);
  },
      Ie = function Ie(e) {
    return ee(Ce, xe(e), e.border, e.border);
  },
      be = function be(e) {
    return ee(de, xe(e), e.border, e.border);
  },
      ye = function ye(e) {
    return ee(fe, xe(e), e.border, e.border);
  },
      Ee = function Ee(e) {
    var n = e.fn,
        t = function (e, n) {
      var t = {};

      for (var r in e) {
        n.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }

      return t;
    }(e, ["fn"]);

    return le("div", {
      css: n(t)
    });
  };

  Ee.propTypes = {};

  var ve = {
    left: function left(e) {
      return Ee(ue({
        fn: ye
      }, e));
    },
    top: function top(e) {
      return Ee(ue({
        fn: Ie
      }, e));
    },
    right: function right(e) {
      return Ee(ue({
        fn: be
      }, e));
    },
    bottom: function bottom(e) {
      return Ee(ue({
        fn: ge
      }, e));
    }
  },
      we = function we(e) {
    var n = e.background,
        t = e.border,
        r = e.placement,
        o = e.width;
    return o > 0 && le(ve[r] || ve.top, {
      background: n,
      border: t,
      width: o
    });
  };

  we.propTypes = {};

  var Be = we,
      _e = A.a.oneOf(["linear", "ease", "ease-in", "ease-out", "ease-in-out"]),
      De = /^cubic-bezier\((-?((\d*\.\d+)|\d+),){3}(-?(\d*\.\d+)|\d+)\)$/,
      Se = (A.a.oneOfType([_e, function (e, n, t) {
    if (!De.test(e[n])) return new Error("Invalid prop `" + n + "` supplied to `" + t + "`. Validation failed.");
  }]), Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }),
      Me = Re(["\n  0% {\n      opacity: 0;\n  }\n  100% {\n      opacity: 1;\n  }\n"], ["\n  0% {\n      opacity: 0;\n  }\n  100% {\n      opacity: 1;\n  }\n"]),
      Oe = Re(["\n  animation: ", "ms ", " 0s 1 ", ";\n"], ["\n  animation: ", "ms ", " 0s 1 ", ";\n"]),
      ke = Re(["\n  position: absolute;\n  ", ";\n  ", ";\n"], ["\n  position: absolute;\n  ", ";\n  ", ";\n"]),
      Te = Re(["\n  ", ";\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: ", "px;\n"], ["\n  ", ";\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: ", "px;\n"]),
      Pe = Re(["\n  ", ";\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: ", "px;\n"], ["\n  ", ";\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: ", "px;\n"]),
      Ke = Re(["\n  ", ";\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-right: ", "px;\n"], ["\n  ", ";\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-right: ", "px;\n"]),
      Qe = Re(["\n  ", ";\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-left: ", "px;\n"], ["\n  ", ";\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-left: ", "px;\n"]);

  function Ue(e, n) {
    var t = {};

    for (var r in e) {
      n.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }

    return t;
  }

  function Re(e, n) {
    return e.raw = n, e;
  }

  var Ge = function () {
    var e = ee.apply(void 0, arguments),
        n = "animation-" + e.name;
    return {
      name: n,
      styles: "@keyframes " + n + "{" + e.styles + "}",
      anim: 1,
      toString: function toString() {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  }(Me),
      Ye = function Ye(e) {
    return ee(ke, e.fadeDuration && e.fadeDuration > 0 && function (e) {
      return ee(Oe, e.fadeDuration, e.fadeEasing, Ge);
    }(e), e.zIndex && "z-index: " + e.zIndex + ";");
  },
      Fe = function Fe(e) {
    return ee(Te, Ye(e), e.offset);
  },
      Ne = function Ne(e) {
    return ee(Pe, Ye(e), e.offset);
  },
      je = function je(e) {
    return ee(Ke, Ye(e), e.offset);
  },
      We = function We(e) {
    return ee(Qe, Ye(e), e.offset);
  },
      Le = function Le(e) {
    var n = e.fn,
        t = e.children,
        r = Ue(e, ["fn", "children"]);
    return le("div", {
      css: n(r)
    }, t);
  };

  Le.propTypes = {};

  var ze = {
    left: function left(e) {
      var n = e.children,
          t = Ue(e, ["children"]);
      return Le(Se({
        fn: je,
        children: n
      }, t));
    },
    top: function top(e) {
      var n = e.children,
          t = Ue(e, ["children"]);
      return Le(Se({
        fn: Fe,
        children: n
      }, t));
    },
    right: function right(e) {
      var n = e.children,
          t = Ue(e, ["children"]);
      return Le(Se({
        fn: We,
        children: n
      }, t));
    },
    bottom: function bottom(e) {
      var n = e.children,
          t = Ue(e, ["children"]);
      return Le(Se({
        fn: Ne,
        children: n
      }, t));
    }
  },
      Xe = function Xe(e) {
    var n = e.children,
        t = e.offset,
        r = e.open,
        o = e.placement,
        i = e.zIndex,
        A = e.fadeDuration,
        s = e.fadeEasing;
    return r && le(ze[o] || ze.top, {
      offset: t,
      zIndex: i,
      fadeDuration: A,
      fadeEasing: s
    }, n);
  };

  Xe.propTypes = {};
  var He,
      qe = Xe,
      Ve = ((He = ["\n      color: ", ";\n      background: ", ";\n      border-radius: ", ";\n      border: 1px solid ", ";\n      padding: ", ";\n      font-size: ", ";\n      font-family: ", ";\n    "]).raw = ["\n      color: ", ";\n      background: ", ";\n      border-radius: ", ";\n      border: 1px solid ", ";\n      padding: ", ";\n      font-size: ", ";\n      font-family: ", ";\n    "], He);

  var Je = function Je(e) {
    return le("div", {
      css: ee(Ve, e.color ? e.color : "inherit", e.background ? e.background : "inherit", e.radius ? e.radius + "px" : 0, e.border, e.padding ? e.padding + "px" : 0, e.fontSize, e.fontFamily)
    }, e.children);
  };

  Je.propTypes = {};

  var Ze = Je,
      $e = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  },
      en = tn(["\n  position: relative;\n  display: inline-block;\n"], ["\n  position: relative;\n  display: inline-block;\n"]),
      nn = tn(["\n          ", ";\n          ", "\n        "], ["\n          ", ";\n          ", "\n        "]);

  function tn(e, n) {
    return e.raw = n, e;
  }

  var rn = ee(en),
      on = function (e) {
    function n() {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n);

      var t = function (e, n) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !n || "object" != typeof n && "function" != typeof n ? e : n;
      }(this, e.call(this));

      return t.state = {
        open: !1
      }, t.handleMouseEnter = t.handleMouseEnter.bind(t), t.handleMouseLeave = t.handleMouseLeave.bind(t), t.handleTouch = t.handleTouch.bind(t), t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function, not " + typeof n);
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), n && (Object.setPrototypeOf ? Object.setPrototypeOf(e, n) : e.__proto__ = n);
    }(n, e), n.prototype.handleMouseEnter = function () {
      this.setState({
        open: !0
      });
    }, n.prototype.handleMouseLeave = function () {
      this.setState({
        open: !1
      });
    }, n.prototype.handleTouch = function () {
      var e = this.state.open;
      this.setState({
        open: !e
      });
    }, n.prototype.render = function () {
      var e = this.state.open,
          n = this.props,
          t = n.arrow,
          r = n.background,
          o = n.border,
          i = n.children,
          A = n.color,
          s = n.content,
          l = n.customCss,
          a = n.fadeDuration,
          c = n.fadeEasing,
          u = n.fixed,
          p = n.fontFamily,
          m = n.fontSize,
          C = n.offset,
          d = n.padding,
          f = n.placement,
          h = n.radius,
          x = n.zIndex,
          g = function (e, n) {
        var t = {};

        for (var r in e) {
          n.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }

        return t;
      }(n, ["arrow", "background", "border", "children", "color", "content", "customCss", "fadeDuration", "fadeEasing", "fixed", "fontFamily", "fontSize", "offset", "padding", "placement", "radius", "zIndex"]),
          I = null != i,
          b = le(qe, {
        open: !(I && !u) || e,
        placement: f,
        offset: C + t,
        zIndex: x,
        fadeEasing: c,
        fadeDuration: a
      }, le(Ze, {
        background: r,
        border: o,
        color: A,
        radius: h,
        fontFamily: p,
        fontSize: m,
        padding: d
      }, le(Be, {
        width: t,
        background: r,
        border: o,
        color: A,
        placement: f
      }), s));

      return I ? le("div", $e({
        onMouseEnter: u ? void 0 : this.handleMouseEnter,
        onMouseLeave: u ? void 0 : this.handleMouseLeave,
        onTouchEnd: u ? void 0 : this.handleTouch,
        css: ee(nn, rn, l)
      }, g), i, b) : le("div", $e({
        css: ee(nn, rn, l)
      }, g), b);
    }, n;
  }(o.a.Component);

  on.propTypes = {}, on.defaultProps = {
    arrow: 8,
    background: "#000",
    border: "#000",
    children: null,
    color: "#fff",
    fadeDuration: 0,
    fadeEasing: "linear",
    fixed: !1,
    fontFamily: "inherit",
    fontSize: "inherit",
    offset: 0,
    padding: 16,
    placement: "top",
    radius: 0,
    zIndex: 1
  }, on.displayName = "Tooltip.Wrapper", qe.displayName = "Tooltip", Ze.displayName = "Tooltip.Bubble", Be.displayName = "Tooltip.Arrow";
  var An = on,
      sn = o.a.createElement("div", {
    className: f.a.helpMessage
  }, o.a.createElement("span", null, o.a.createElement(C.a, {
    className: f.a.icon,
    icon: m.f
  }), "Double click on a word or timestamp to jump to that point in the video."), o.a.createElement("span", null, o.a.createElement(C.a, {
    className: f.a.icon,
    icon: m.d
  }), "Start typing to edit text."), o.a.createElement("span", null, o.a.createElement(C.a, {
    className: f.a.icon,
    icon: m.n
  }), "You can add and change names of speakers in your transcript."), o.a.createElement("span", null, o.a.createElement(C.a, {
    className: f.a.icon,
    icon: m.e
  }), "Use keyboard shortcuts for quick control."), o.a.createElement("span", null, o.a.createElement(C.a, {
    className: f.a.icon,
    icon: m.j
  }), "Save & export to get a copy to your desktop.")),
      ln = o.a.createElement(An, {
    className: f.a.help,
    content: sn,
    fadeDuration: 250,
    fadeEasing: "ease-in",
    placement: "bottom",
    radius: 5,
    border: "#ffffff",
    background: "#f2f2f2",
    color: "#000000"
  }, o.a.createElement(C.a, {
    className: f.a.icon,
    icon: m.i
  }), "How does this work?");

  function an(e) {
    return (an = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function cn(e, n) {
    for (var t, r = 0; r < n.length; r++) {
      (t = n[r]).enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
    }
  }

  function un(e) {
    return (un = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function pn(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function mn(e, n) {
    return (mn = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function Cn(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  var dn = [{
    value: "txt",
    label: "Text file"
  }, {
    value: "txtspeakertimecodes",
    label: "Text file - with Speakers and Timecodes"
  }, {
    value: "docx",
    label: "MS Word"
  }, {
    value: "srt",
    label: "Srt - Captions"
  }, {
    value: "ttml",
    label: "TTML - Captions"
  }, {
    value: "premiereTTML",
    label: "TTML for Adobe Premiere - Captions"
  }, {
    value: "itt",
    label: "iTT - Captions"
  }, {
    value: "csv",
    label: "CSV - Captions"
  }, {
    value: "vtt",
    label: "VTT - Captions"
  }, {
    value: "pre-segment-txt",
    label: "Pre segmented txt - Captions"
  }, {
    value: "json-captions",
    label: "Json - Captions"
  }, {
    value: "draftjs",
    label: "Draft Js - json"
  }, {
    value: "digitalpaperedit",
    label: "Digital Paper Edit - Json"
  }],
      fn = function (e) {
    function n(e) {
      var t;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), t = function (e, n) {
        return !n || "object" !== an(n) && "function" != typeof n ? pn(e) : n;
      }(this, un(n).call(this, e)), Cn(pn(t), "shouldComponentUpdate", function (e, n) {
        return e.mediaUrl !== t.props.mediaUrl || n !== t.state;
      }), Cn(pn(t), "componentDidMount", function () {
        t.updateDimensions(), window.addEventListener("resize", t.updateDimensions);
      }), Cn(pn(t), "updateDimensions", function () {
        var e = {
          display: "grid",
          gridTemplateColumns: "1fr 3fr",
          gridColumnGap: "1em"
        },
            n = null;
        "audio" === t.props.mediaType && (console.log("this.props.mediaType", t.props.mediaType), e = null, n = {
          display: "none"
        }), 767 >= Math.max(document.documentElement.clientWidth, window.innerWidth || 0) && (e = null), t.setState({
          gridDisplay: e,
          displayMedia: n
        });
      }), Cn(pn(t), "handleWordClick", function (e) {
        t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TranscriptEditor",
          action: "doubleClickOnWord",
          name: "startTime",
          value: Object(p.secondsToTimecode)(e)
        }), t.setCurrentTime(e);
      }), Cn(pn(t), "handleTimeUpdate", function (e) {
        var n = e.target.currentTime;
        t.setState({
          currentTime: n
        });
      }), Cn(pn(t), "handlePlayMedia", function (e) {
        t.playMedia(e);
      }), Cn(pn(t), "handleIsPlaying", function () {
        return t.isPlaying();
      }), Cn(pn(t), "handleIsScrollIntoViewChange", function (e) {
        var n = e.target.checked;
        t.setState({
          isScrollIntoViewOn: n
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TranscriptEditor",
          action: "handleIsScrollIntoViewChange",
          name: "isScrollIntoViewOn",
          value: n
        });
      }), Cn(pn(t), "handlePauseWhileTyping", function (e) {
        var n = e.target.checked;
        t.setState({
          isPauseWhileTypingOn: n
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TranscriptEditor",
          action: "handlePauseWhileTyping",
          name: "isPauseWhileTypingOn",
          value: n
        });
      }), Cn(pn(t), "handleRollBackValueInSeconds", function (e) {
        var n = e.target.value;
        t.setState({
          rollBackValueInSeconds: n
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TranscriptEditor",
          action: "handleRollBackValueInSeconds",
          name: "rollBackValueInSeconds",
          value: n
        });
      }), Cn(pn(t), "handleSetTimecodeOffset", function (e) {
        t.setState({
          timecodeOffset: e
        }, function () {
          t.timedTextEditorRef.current.forceUpdate();
        });
      }), Cn(pn(t), "handleShowTimecodes", function (e) {
        var n = e.target.checked;
        t.setState({
          showTimecodes: n
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TranscriptEditor",
          action: "handleShowTimecodes",
          name: "showTimecodes",
          value: n
        });
      }), Cn(pn(t), "handleShowSpeakers", function (e) {
        var n = e.target.checked;
        t.setState({
          showSpeakers: n
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TranscriptEditor",
          action: "handleShowSpeakers",
          name: "showSpeakers",
          value: n
        });
      }), Cn(pn(t), "handleSettingsToggle", function () {
        t.setState(function (e) {
          return {
            showSettings: !e.showSettings
          };
        }, function () {
          t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
            category: "TranscriptEditor",
            action: "handleSettingsToggle",
            name: "showSettings",
            value: !t.state.showSettings
          });
        });
      }), Cn(pn(t), "handleShortcutsToggle", function () {
        t.setState(function (e) {
          return {
            showShortcuts: !e.showShortcuts
          };
        }, function () {
          t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
            category: "TranscriptEditor",
            action: "handleShortcutsToggle",
            name: "showShortcuts",
            value: !t.state.showShortcuts
          });
        });
      }), Cn(pn(t), "handleExportToggle", function () {
        console.log("handleExportToggle", t.state.showExportOptions), t.setState(function (e) {
          return {
            showExportOptions: !e.showExportOptions
          };
        }, function () {
          t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
            category: "TranscriptEditor",
            action: "handleExportToggle",
            name: "showExportOptions",
            value: !t.state.showExportOptions
          });
        });
      }), Cn(pn(t), "handleExportOptionsChange", function (e) {
        var n = e.target.value;

        if (console.log(n), "instructions" !== n) {
          var r = t.props.title ? t.props.title : t.props.mediaUrl,
              o = t.getEditorContent(n),
              i = o.data,
              A = o.ext,
              s = i;
          "json" === A && (s = JSON.stringify(i, null, 2)), "docx" !== A && t.download(s, "".concat(r, ".").concat(A)), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
            category: "TranscriptEditor",
            action: "handleExportOptionsChange",
            name: "exportFile",
            value: n
          });
        }
      }), Cn(pn(t), "download", function (e, n, t) {
        var r = document.createElement("a"),
            o = new Blob([e], {
          type: t || "application/octet-stream"
        });
        r.href = window.URL.createObjectURL(o), r.download = n, document.body.appendChild(r), r.click(), document.body.removeChild(r);
      }), Cn(pn(t), "getEditorContent", function (e) {
        var n = t.props.title ? t.props.title : "";
        return t.timedTextEditorRef.current.getEditorContent(e, n);
      }), Cn(pn(t), "handlePreviewIsDisplayed", function () {
        t.setState({
          previewIsDisplayed: !t.state.previewIsDisplayed
        });
      }), Cn(pn(t), "onLoadedDataGetDuration", function (e) {
        var n = e.target.duration,
            r = n + t.state.timecodeOffset,
            o = Object(p.secondsToTimecode)(r);
        t.setState({
          mediaDuration: o
        }), t.props.handleAnalyticsEvents && t.props.handleAnalyticsEvents({
          category: "TranscriptEditor",
          action: "onLoadedDataGetDuration",
          name: "durationInSeconds-WithoutOffset",
          value: Object(p.secondsToTimecode)(n)
        });
      }), Cn(pn(t), "handleChangePreviewViewWidth", function (e) {
        var n = e.target.value;
        t.setState({
          previewViewWidth: n
        });
      }), Cn(pn(t), "handleAutoSaveChanges", function (e) {
        t.props.handleAutoSaveChanges && t.props.handleAutoSaveChanges(e);
      }), t.videoRef = o.a.createRef(), t.state = {
        currentTime: 0,
        transcriptData: null,
        isScrollIntoViewOn: !1,
        showSettings: !1,
        showShortcuts: !1,
        showExportOptions: !1,
        isPauseWhileTypingOn: !0,
        rollBackValueInSeconds: 15,
        timecodeOffset: 0,
        showTimecodes: !0,
        showSpeakers: !0,
        previewIsDisplayed: !0,
        mediaDuration: "00:00:00:00",
        gridDisplay: null
      }, t.timedTextEditorRef = o.a.createRef(), t;
    }

    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && mn(e, n);
    }(n, e), t = n, i = [{
      key: "getDerivedStateFromProps",
      value: function value(e) {
        return null === e.transcriptData ? null : {
          transcriptData: e.transcriptData
        };
      }
    }], (r = [{
      key: "render",
      value: function value() {
        var e = this,
            n = o.a.createElement(a.default, {
          mediaUrl: this.props.mediaUrl,
          onTimeUpdate: this.handleTimeUpdate,
          videoRef: this.videoRef,
          previewIsDisplayed: this.state.previewIsDisplayed,
          onLoadedDataGetDuration: this.onLoadedDataGetDuration
        }),
            t = o.a.createElement(l.default, {
          title: this.props.title ? this.props.title : "",
          mediaDuration: this.state.mediaDuration,
          currentTime: this.state.currentTime,
          hookSeek: function hookSeek(n) {
            return e.setCurrentTime = n;
          },
          hookPlayMedia: function hookPlayMedia(n) {
            return e.playMedia = n;
          },
          hookIsPlaying: function hookIsPlaying(n) {
            return e.isPlaying = n;
          },
          rollBackValueInSeconds: this.state.rollBackValueInSeconds,
          timecodeOffset: this.state.timecodeOffset,
          mediaUrl: this.props.mediaUrl,
          handleAnalyticsEvents: this.props.handleAnalyticsEvents,
          videoRef: this.videoRef
        }),
            r = o.a.createElement(c.default, {
          handleSettingsToggle: this.handleSettingsToggle,
          defaultValuePauseWhileTyping: this.state.isPauseWhileTypingOn,
          defaultValueScrollSync: this.state.isScrollIntoViewOn,
          defaultRollBackValueInSeconds: this.state.rollBackValueInSeconds,
          timecodeOffset: this.state.timecodeOffset,
          showTimecodes: this.state.showTimecodes,
          showSpeakers: this.state.showSpeakers,
          handlePauseWhileTyping: this.handlePauseWhileTyping,
          handleIsScrollIntoViewChange: this.handleIsScrollIntoViewChange,
          handleRollBackValueInSeconds: this.handleRollBackValueInSeconds,
          handleSetTimecodeOffset: this.handleSetTimecodeOffset,
          handleShowTimecodes: this.handleShowTimecodes,
          handleShowSpeakers: this.handleShowSpeakers,
          handleAnalyticsEvents: this.props.handleAnalyticsEvents,
          previewIsDisplayed: this.state.previewIsDisplayed,
          handlePreviewIsDisplayed: this.handlePreviewIsDisplayed,
          handleChangePreviewViewWidth: this.handleChangePreviewViewWidth
        }),
            i = o.a.createElement(k, {
          exportOptionsList: dn,
          handleExportOptionsChange: this.handleExportOptionsChange,
          handleExportToggle: this.handleExportToggle
        }),
            A = o.a.createElement(u.default, {
          handleShortcutsToggle: this.handleShortcutsToggle
        }),
            p = "draftjs";
        this.props.autoSaveContentType ? p = this.props.autoSaveContentType : this.props.sttJsonType && (p = this.props.sttJsonType);
        var m = o.a.createElement(s.default, {
          fileName: this.props.fileName,
          transcriptData: this.state.transcriptData,
          timecodeOffset: this.state.timecodeOffset,
          onWordClick: this.handleWordClick,
          playMedia: this.handlePlayMedia,
          isPlaying: this.handleIsPlaying,
          currentTime: this.state.currentTime,
          isEditable: this.props.isEditable,
          spellCheck: this.props.spellCheck,
          sttJsonType: this.props.sttJsonType,
          mediaUrl: this.props.mediaUrl,
          isScrollIntoViewOn: this.state.isScrollIntoViewOn,
          isPauseWhileTypingOn: this.state.isPauseWhileTypingOn,
          showTimecodes: this.state.showTimecodes,
          showSpeakers: this.state.showSpeakers,
          ref: this.timedTextEditorRef,
          handleAnalyticsEvents: this.props.handleAnalyticsEvents,
          handleAutoSaveChanges: this.handleAutoSaveChanges,
          autoSaveContentType: p,
          title: this.props.title ? this.props.title : Date.now()
        }),
            C = o.a.createElement(y, {
          showSettings: this.state.showSettings,
          showShortcuts: this.state.showShortcuts,
          showExportOptions: this.state.showExportOptions,
          settings: r,
          shortcuts: A,
          exportOptions: i,
          tooltip: ln,
          mediaUrl: this.props.mediaUrl,
          mediaControls: this.videoRef.current ? t : null,
          handleSettingsToggle: this.handleSettingsToggle,
          handleShortcutsToggle: this.handleShortcutsToggle,
          handleExportToggle: this.handleExportToggle
        });
        return o.a.createElement("div", {
          className: f.a.container
        }, this.props.mediaUrl ? C : null, o.a.createElement("div", {
          className: f.a.grid
        }, o.a.createElement("section", {
          className: f.a.row,
          style: this.state.gridDisplay
        }, o.a.createElement("aside", {
          className: f.a.aside,
          style: this.state.displayMedia
        }, this.props.mediaUrl ? n : null), o.a.createElement("main", {
          className: "audio" === this.props.mediaType ? f.a.mainWithAudiio : f.a.main
        }, this.props.mediaUrl && this.props.transcriptData ? m : null))));
      }
    }]) && cn(t.prototype, r), i && cn(t, i), n;
    var t, r, i;
  }(o.a.Component);

  fn.propTypes = {
    onClick: A.a.func,
    title: A.a.string,
    mediaUrl: A.a.string,
    isEditable: A.a.bool,
    spellCheck: A.a.bool,
    sttJsonType: A.a.string,
    handleAnalyticsEvents: A.a.func,
    fileName: A.a.string,
    transcriptData: A.a.object,
    mediaType: A.a.string
  };
  n.default = fn;
}, function (e, n) {
  e.exports = function (e, n) {
    e.prototype = Object.create(n.prototype), e.prototype.constructor = e, e.__proto__ = n;
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._1rnNwJ3gDENvv5BbIobNPA{background-color:#f1f1f1;position:relative}._1M8Fi31DLCYTQ-eTYBvALk{margin-top:1em;margin-bottom:1em;box-shadow:0 0 10px #ccc}._1wBdlkjwjUq3OoOKYC2k66{margin-top:1em;margin-bottom:1em;box-shadow:0 0 10px #ccc}video{margin-top:1em;display:block;box-shadow:0 0 10px #ccc}.ZhZivtjbFgycw7x9pM2lu{text-align:center;cursor:pointer;float:right;padding-right:2.5em;margin:0.5em 0;color:white;display:block;font-weight:lighter;margin-top:0.5em;margin-right:6em}.OLXrt5ObeCJOWIrwZYzVA{min-width:240px;text-align:left}.cVSrMNMWrIW6695xL9Vnw{line-height:1em;margin-left:0.5em;background:#282828;display:inline-block;border:0;color:white;font-size:1em;cursor:pointer;text-align:center;width:2em;height:2em}.cVSrMNMWrIW6695xL9Vnw:hover{background:#4a4a4a}.wo2Pzxw3LwWClU9kDjN0P{color:#a0372d;margin-right:0.5em}.OLXrt5ObeCJOWIrwZYzVA span{display:block;font-weight:lighter;margin-top:1em}@media (min-width: 1020px){._1hLdgpjrf79DcL29WZYASD{margin-left:auto}._1wBdlkjwjUq3OoOKYC2k66{margin-right:20%;margin-left:20%}._2ONWma4Cs1G8opurFXOGst{position:absolute;top:0;right:0;padding:0}}@media (max-width: 768px){.ZhZivtjbFgycw7x9pM2lu{display:none}}@media (min-width: 769px) and (max-width: 1020px){._2OWYgBCz7WfdwIyhNGt_eF{margin-top:1em;margin-left:1em;margin-right:1em}._34a7DD64cC4O3ltXETdjhg{display:grid;grid-column-gap:1em}._2ONWma4Cs1G8opurFXOGst{position:absolute;top:0;right:0;padding:0}._1wBdlkjwjUq3OoOKYC2k66{margin-top:1em;margin-right:0px;margin-left:0px}}@media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait){._1hLdgpjrf79DcL29WZYASD{margin-left:auto}._1M8Fi31DLCYTQ-eTYBvALk{margin-top:1em;margin-right:auto}._1wBdlkjwjUq3OoOKYC2k66{margin-top:1em;margin-left:0;margin-right:0;box-shadow:0 0 10px #ccc}._2ONWma4Cs1G8opurFXOGst{position:absolute;top:0;right:0;padding:0}}@media all and (device-height: 768px) and (device-width: 1024px) and (orientation: landscape){._1hLdgpjrf79DcL29WZYASD{margin-left:auto}._1M8Fi31DLCYTQ-eTYBvALk{margin-right:auto}._1wBdlkjwjUq3OoOKYC2k66{margin-left:0;margin-right:0}._2ONWma4Cs1G8opurFXOGst{position:absolute;top:0;right:0;padding:0}}@media (max-width: 767px){._34a7DD64cC4O3ltXETdjhg{display:block}._1M8Fi31DLCYTQ-eTYBvALk{width:100%;margin-top:0.5em}._1hLdgpjrf79DcL29WZYASD{margin-top:0px}._1wBdlkjwjUq3OoOKYC2k66{margin-left:0;margin-right:0}._2ONWma4Cs1G8opurFXOGst{position:absolute;top:0;right:0;padding:0}.FD_ZvSmPzp4Oj97XwqvIh{display:none}}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/transcript-editor/index.module.css", "/Users/okunoe01/workspace/react-transcript-editor/packages/config/style-guide/colours.scss"],
    names: [],
    mappings: "AAEA,yBACE,wBAAyB,CACzB,iBAAkB,CACnB,yBAGC,cAAe,CACf,iBAAkB,CAClB,wBAAyB,CAC1B,yBAGC,cAAe,CACf,iBAAkB,CAClB,wBAAyB,CAC1B,MAGC,cAAe,CACf,aAAc,CACd,wBAAyB,CAC1B,uBAGC,iBAAkB,CAClB,cAAe,CACf,WAAY,CACZ,mBAAoB,CACpB,cAAe,CACf,WAAY,CACZ,aAAc,CACd,mBAAoB,CACpB,gBAAiB,CACjB,gBAAiB,CAClB,uBAGC,eAAgB,CAChB,eAAgB,CACjB,uBAGC,eAAgB,CAChB,iBAAkB,CAClB,kBC7C0B,CD8C1B,oBAAqB,CACrB,QAAS,CACT,WAAY,CACZ,aAAc,CACd,cAAe,CACf,iBAAkB,CAClB,SAAU,CACV,UAAW,CAXb,6BAcI,kBCvDqB,CDwDtB,uBAKD,aC/DsB,CDgEtB,kBAAmB,CACpB,4BAGC,aAAc,CACd,mBAAoB,CACpB,cAAe,CAChB,2BAGC,yBACE,gBAAiB,CAClB,yBAEC,gBAAiB,CACjB,eAAgB,CACjB,yBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,SAAU,CACX,CAGH,0BACE,uBACE,YAAa,CACd,CAKH,kDAGE,yBACE,cAAe,CACf,eAAgB,CAChB,gBAAiB,CAClB,yBAGC,YAAa,CAEb,mBAAoB,CACrB,yBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,SAAU,CACX,yBAGC,cAAe,CACf,gBAAiB,CACjB,eAAgB,CACjB,CAIH,6FAEE,yBACE,gBAAiB,CAClB,yBAGC,cAAe,CACf,iBAAkB,CACnB,yBAGC,cAAe,CACf,aAAc,CACd,cAAe,CACf,wBAAyB,CAC1B,yBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,SAAU,CACX,CAGH,8FAEE,yBACE,gBAAiB,CAClB,yBAGC,iBAAkB,CACnB,yBAGC,aAAc,CACd,cAAe,CAChB,yBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,SAAU,CACX,CAIH,0BACE,yBACA,aAAc,CACb,yBAEC,UAAW,CACX,gBAAiB,CAClB,yBAGC,cAAe,CAChB,yBAGC,aAAc,CACd,cAAe,CAChB,yBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,SAAU,CACX,uBAGC,YAAa,CACd",
    file: "index.module.css",
    sourcesContent: ["@import '../../config/style-guide/colours.scss';\n\n.container {\n  background-color: #f1f1f1;\n  position: relative;\n}\n\n.main {\n  margin-top: 1em;\n  margin-bottom: 1em;\n  box-shadow: 0 0 10px #ccc; \n}\n\n.mainWithAudiio{\n  margin-top: 1em;\n  margin-bottom: 1em;\n  box-shadow: 0 0 10px #ccc;\n}\n\nvideo{\n  margin-top: 1em;\n  display: block;\n  box-shadow: 0 0 10px #ccc; \n}\n\n.help {\n  text-align: center;\n  cursor: pointer;\n  float: right;\n  padding-right: 2.5em;\n  margin: 0.5em 0;\n  color: white;\n  display: block;\n  font-weight: lighter;\n  margin-top: 0.5em;\n  margin-right: 6em;\n}\n\n.helpMessage {\n  min-width: 240px;\n  text-align: left;\n}\n\n.settingsButton {\n  line-height: 1em;\n  margin-left: 0.5em;\n  background: $color-darkest-grey;\n  display: inline-block;\n  border: 0;\n  color: white;\n  font-size: 1em;\n  cursor: pointer;\n  text-align: center;\n  width: 2em;\n  height: 2em;\n\n  &:hover {\n    background: $color-dark-grey;\n  }\n}\n\n\n.icon {\n  color: $color-labs-red;\n  margin-right: 0.5em;\n}\n\n.helpMessage span {\n  display: block;\n  font-weight: lighter;\n  margin-top: 1em;\n}\n\n@media (min-width: 1020px) {\n  .aside {\n    margin-left: auto;\n  }\n  .mainWithAudiio{\n    margin-right: 20%;\n    margin-left: 20%;\n  }\n\n  .settingsContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .help {\n    display: none;\n  }\n}\n\n\n/* Desktop size */\n@media  (min-width: 769px) and (max-width: 1020px){\n\n  \n  .grid {\n    margin-top: 1em;\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .row {\n    display: grid;\n    /* grid-template-columns: 1fr 3fr; */\n    grid-column-gap: 1em;\n  }\n\n  .settingsContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0;\n  }\n\n  .mainWithAudiio{\n    margin-top: 1em;\n    margin-right: 0px;\n    margin-left: 0px;\n  }\n}\n\n/* Ipad */\n@media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n\n  .aside {\n    margin-left: auto;\n  }\n\n  .main {\n    margin-top: 1em;\n    margin-right: auto;\n  }\n\n  .mainWithAudiio{\n    margin-top: 1em;\n    margin-left: 0;\n    margin-right: 0;\n    box-shadow: 0 0 10px #ccc;\n  }\n\n  .settingsContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0;\n  }\n}\n\n@media all and (device-height: 768px) and (device-width: 1024px) and (orientation: landscape) {\n\n  .aside {\n    margin-left: auto;\n  }\n\n  .main {\n    margin-right: auto;\n  }\n\n  .mainWithAudiio{\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .settingsContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0;\n  }\n}\n\n/* Mobile devices - excluding ipad*/\n@media (max-width: 767px) {\n  .row {\n  display: block;\n  }\n  .main {\n    width: 100%;\n    margin-top: 0.5em;\n  }\n\n  .aside{\n    margin-top: 0px;\n  }\n\n  .mainWithAudiio{\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .settingsContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0;\n  }\n\n  .keyboardShortcutsButon {\n    display: none;\n  }\n}\n", "$color-labs-red: #a0372d !default;\n$color-darkest-grey: #282828 !default;\n$color-dark-grey: #4a4a4a !default;\n$color-mid-grey: #696969 !default;\n$color-light-grey: #767676 !default;\n$color-lightest-grey: #f2f2f2 !default;\n$color-subt-green: #69e3c2 !default;\n$color-light-shilo: #E2A9A2 !default;\n"]
  }]), n.locals = {
    container: "_1rnNwJ3gDENvv5BbIobNPA",
    main: "_1M8Fi31DLCYTQ-eTYBvALk",
    mainWithAudiio: "_1wBdlkjwjUq3OoOKYC2k66",
    help: "ZhZivtjbFgycw7x9pM2lu",
    helpMessage: "OLXrt5ObeCJOWIrwZYzVA",
    settingsButton: "cVSrMNMWrIW6695xL9Vnw",
    icon: "wo2Pzxw3LwWClU9kDjN0P",
    aside: "_1hLdgpjrf79DcL29WZYASD",
    settingsContainer: "_2ONWma4Cs1G8opurFXOGst",
    grid: "_2OWYgBCz7WfdwIyhNGt_eF",
    row: "_34a7DD64cC4O3ltXETdjhg",
    keyboardShortcutsButon: "FD_ZvSmPzp4Oj97XwqvIh"
  };
}, function (e, n, t) {
  (n = e.exports = t(13)(!0)).push([e.i, "._2PvVLOqZB3wEpL05MoyZML{position:absolute;left:0;right:0;margin:0 auto;width:30%;min-width:300px;min-height:300px;text-align:center;vertical-align:middle;color:white;background:#4a4a4a;padding:1em;font-weight:lighter;z-index:2}.DqIEUTxEFL2T2Asj_nQ-Z{margin-top:0;margin-bottom:1em}.vps04F3b3tzShNK2lV7oJ{position:absolute;top:0;right:0;padding:1em;cursor:pointer}._3dy1VzAIyEU_oi4E8B54B9{display:flex;flex-direction:column;align-content:flex-start;align-items:center;margin:0 auto}._2hPYWzXWg4pyU3oYfVstyb{text-align:left;align-self:auto;margin-bottom:0.5em}.O1RoPSDsOVgprndjHo6ks{display:inline-block;min-width:200px;width:200px}.zy5tyz6I6SCOhwJ01YdFn{height:2em;width:48px;box-sizing:border-box;border:none;text-align:center;font-weight:bold;margin-right:16px;vertical-align:middle}._32hTCbY5WbqYXFJ4OFuVJm{display:block;text-align:center}._2L7J8eX3MHY_WLOjXYVGJY{width:48px;height:48px;padding:0.5em;border:0;color:white;background:#282828;font-size:1em;cursor:pointer;margin-right:0.3rem;margin-top:0.3rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._2L7J8eX3MHY_WLOjXYVGJY{width:100%;height:48px;margin:0}._2L7J8eX3MHY_WLOjXYVGJY:hover{background-color:gray}\n", "", {
    version: 3,
    sources: ["/Users/okunoe01/workspace/react-transcript-editor/packages/components/transcript-editor/src/index.module.css", "/Users/okunoe01/workspace/react-transcript-editor/packages/config/style-guide/colours.scss"],
    names: [],
    mappings: "AAEA,yBACI,iBAAkB,CAClB,MAAO,CACP,OAAQ,CACR,aAAc,CACd,SAAU,CACV,eAAgB,CAChB,gBAAiB,CACjB,iBAAkB,CAClB,qBAAsB,CACtB,WAAY,CACZ,kBAAmB,CACnB,WAAY,CACZ,mBAAoB,CACpB,SAAU,CACX,uBAGC,YAAa,CACb,iBAAkB,CACnB,uBAGC,iBAAkB,CAClB,KAAM,CACN,OAAQ,CACR,WAAY,CACZ,cAAe,CAChB,yBAGC,YAAa,CACb,qBAAsB,CACtB,wBAAyB,CACzB,kBAAmB,CACnB,aAAc,CACf,yBAGC,eAAgB,CAChB,eAAgB,CAChB,mBAAoB,CACrB,uBAGC,oBAAqB,CACrB,eAAgB,CAChB,WAAY,CACb,uBAGC,UAAW,CACX,UAAW,CACX,qBAAsB,CACtB,WAAY,CACZ,iBAAkB,CAClB,gBAAiB,CACjB,iBAAkB,CAClB,qBAAsB,CACvB,yBAGC,aAAc,CACd,iBAAkB,CACnB,yBAID,UAAW,CACX,WAAY,CACZ,aAAc,CACd,QAAS,CACT,WAAY,CACZ,kBC1E0B,CD2E1B,aAAc,CACd,cAAe,CACf,mBAAoB,CACpB,iBAAkB,CAClB,kBAAmB,CACnB,eAAgB,CAChB,sBAAuB,CACxB,yBAGC,UAAW,CACX,WAAY,CACZ,QAAS,CACV,+BAIC,qBAAsB",
    file: "index.module.css",
    sourcesContent: ["@import '../../../config/style-guide/colours.scss';\n\n.settings {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 30%;\n    min-width: 300px;\n    min-height: 300px;\n    text-align: center;\n    vertical-align: middle;\n    color: white;\n    background: #4a4a4a;\n    padding: 1em;\n    font-weight: lighter;\n    z-index: 2;\n  }\n\n  .header {\n    margin-top: 0;\n    margin-bottom: 1em;\n  }\n\n  .closeButton {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 1em;\n    cursor: pointer;\n  }\n\n  .controlsContainer {\n    display: flex;\n    flex-direction: column;\n    align-content: flex-start;\n    align-items: center;\n    margin: 0 auto;\n  }\n\n  .settingElement {\n    text-align: left;\n    align-self: auto;\n    margin-bottom: 0.5em;\n  }\n\n  .label {\n    display: inline-block;\n    min-width: 200px;\n    width: 200px;\n  }\n\n  .rollbackValue {\n    height: 2em;\n    width: 48px;\n    box-sizing: border-box;\n    border: none;\n    text-align: center;\n    font-weight: bold;\n    margin-right: 16px;\n    vertical-align: middle;\n  }\n\n  .timecodeLabel {\n    display: block;\n    text-align: center;\n  }\n\n\n.playerButton {\n  width: 48px;\n  height: 48px;\n  padding: 0.5em;\n  border: 0;\n  color: white;\n  background: $color-darkest-grey;\n  font-size: 1em;\n  cursor: pointer;\n  margin-right: 0.3rem;\n  margin-top: 0.3rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.playerButton {\n  width: 100%;\n  height: 48px;\n  margin: 0;\n}\n\n\n.playerButton:hover {\n  background-color: gray;\n}\n", "$color-labs-red: #a0372d !default;\n$color-darkest-grey: #282828 !default;\n$color-dark-grey: #4a4a4a !default;\n$color-mid-grey: #696969 !default;\n$color-light-grey: #767676 !default;\n$color-lightest-grey: #f2f2f2 !default;\n$color-subt-green: #69e3c2 !default;\n$color-light-shilo: #E2A9A2 !default;\n"]
  }]), n.locals = {
    settings: "_2PvVLOqZB3wEpL05MoyZML",
    header: "DqIEUTxEFL2T2Asj_nQ-Z",
    closeButton: "vps04F3b3tzShNK2lV7oJ",
    controlsContainer: "_3dy1VzAIyEU_oi4E8B54B9",
    settingElement: "_2hPYWzXWg4pyU3oYfVstyb",
    label: "O1RoPSDsOVgprndjHo6ks",
    rollbackValue: "zy5tyz6I6SCOhwJ01YdFn",
    timecodeLabel: "_32hTCbY5WbqYXFJ4OFuVJm",
    playerButton: "_2L7J8eX3MHY_WLOjXYVGJY"
  };
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(228);
  t.d(n, "TranscriptEditor", function () {
    return r.default;
  });
  var o = t(80);
  t.d(n, "TimedTextEditor", function () {
    return o.default;
  });
  var i = t(82);
  t.d(n, "Settings", function () {
    return i.default;
  });
  var A = t(83);
  t.d(n, "KeyboardShortcuts", function () {
    return A.default;
  });
  var s = t(79);
  t.d(n, "VideoPlayer", function () {
    return s.default;
  });
  var l = t(81);
  t.d(n, "MediaPlayer", function () {
    return l.default;
  });
  var a = t(59);
  t.d(n, "PlayerControls", function () {
    return a.default;
  });
  var c = t(48);
  t.d(n, "groupWordsInParagraphsBySpeakersDPE", function () {
    return c.default;
  });
  var u = t(8);
  t.d(n, "secondsToTimecode", function () {
    return u.secondsToTimecode;
  }), t.d(n, "timecodeToSeconds", function () {
    return u.timecodeToSeconds;
  }), t.d(n, "shortTimecode", function () {
    return u.shortTimecode;
  });
  var p = t(49);
  t.d(n, "exportAdapter", function () {
    return p.default;
  });
  var m = t(36);
  t.d(n, "sttJsonAdapter", function () {
    return m.default;
  }), n.default = r.default;
}]);